"use strict";
"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// ../../node_modules/mapbox-gl/dist/mapbox-gl.js
var require_mapbox_gl = __commonJS({
  "../../node_modules/mapbox-gl/dist/mapbox-gl.js"(exports, module2) {
    "use strict";
    (function(global2, factory) {
      typeof exports === "object" && typeof module2 !== "undefined" ? module2.exports = factory() : typeof define === "function" && define.amd ? define(factory) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, global2.mapboxgl = factory());
    })(exports, function() {
      "use strict";
      var shared, worker, mapboxgl2;
      function define2(_, chunk) {
        if (!shared) {
          shared = chunk;
        } else if (!worker) {
          worker = chunk;
        } else {
          var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";
          var sharedChunk = {};
          shared(sharedChunk);
          mapboxgl2 = chunk(sharedChunk);
          if (typeof window !== "undefined" && window && window.URL && window.URL.createObjectURL) {
            mapboxgl2.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], { type: "text/javascript" }));
          }
        }
      }
      define2(["exports"], function(t) {
        var e = "3.6.0";
        let r;
        const n = { API_URL: "https://api.mapbox.com", get API_URL_REGEX() {
          if (null == r) {
            const t2 = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
            try {
              r = null != process.env.API_URL_REGEX ? new RegExp(process.env.API_URL_REGEX) : t2;
            } catch (e2) {
              r = t2;
            }
          }
          return r;
        }, get API_TILEJSON_REGEX() {
          return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i;
        }, get API_SPRITE_REGEX() {
          return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i;
        }, get API_FONTS_REGEX() {
          return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i;
        }, get API_STYLE_REGEX() {
          return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i;
        }, get API_CDN_URL_REGEX() {
          return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i;
        }, get EVENTS_URL() {
          if (!n.API_URL)
            return null;
          try {
            const t2 = new URL(n.API_URL);
            return "api.mapbox.cn" === t2.hostname ? "https://events.mapbox.cn/events/v2" : "api.mapbox.com" === t2.hostname ? "https://events.mapbox.com/events/v2" : null;
          } catch (t2) {
            return null;
          }
        }, SESSION_PATH: "/map-sessions/v1", FEEDBACK_URL: "https://apps.mapbox.com/feedback", TILE_URL_VERSION: "v4", RASTER_URL_PREFIX: "raster/v1", RASTERARRAYS_URL_PREFIX: "rasterarrays/v1", REQUIRE_ACCESS_TOKEN: true, ACCESS_TOKEN: null, DEFAULT_STYLE: "mapbox://styles/mapbox/standard", MAX_PARALLEL_IMAGE_REQUESTS: 16, DRACO_URL: "https://api.mapbox.com/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm", MESHOPT_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_base_v0.20.wasm", MESHOPT_SIMD_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_simd_v0.20.wasm", GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf", TILES3D_URL_PREFIX: "3dtiles/v1" };
        function i(t2) {
          return n.API_URL_REGEX.test(t2);
        }
        function s(t2) {
          return 0 === t2.indexOf("mapbox:");
        }
        function a(t2) {
          return n.API_CDN_URL_REGEX.test(t2);
        }
        function o(t2) {
          return n.API_SPRITE_REGEX.test(t2);
        }
        function l(t2) {
          return n.API_STYLE_REGEX.test(t2) && !o(t2);
        }
        const u = { create: "create", load: "load", fullLoad: "fullLoad" }, c = { mark(t2) {
          performance.mark(t2);
        }, measure(t2, e2, r2) {
          performance.measure(t2, e2, r2);
        } };
        function h(t2) {
          const e2 = t2.name.split("?")[0];
          return a(e2) && e2.includes("mapbox-gl.js") ? "javascript" : a(e2) && e2.includes("mapbox-gl.css") ? "css" : function(t3) {
            return n.API_FONTS_REGEX.test(t3);
          }(e2) ? "fontRange" : o(e2) ? "sprite" : l(e2) ? "style" : function(t3) {
            return n.API_TILEJSON_REGEX.test(t3);
          }(e2) ? "tilejson" : "other";
        }
        function p(t2) {
          return t2 && t2.__esModule && Object.prototype.hasOwnProperty.call(t2, "default") ? t2.default : t2;
        }
        var f = {}, d = {};
        Object.defineProperty(d, "__esModule", { value: true }), d.setMatrixArrayType = function(t2) {
          d.ARRAY_TYPE = y = t2;
        }, d.toRadian = function(t2) {
          return t2 * x;
        }, d.equals = function(t2, e2) {
          return Math.abs(t2 - e2) <= m * Math.max(1, Math.abs(t2), Math.abs(e2));
        }, d.RANDOM = d.ARRAY_TYPE = d.EPSILON = void 0;
        var m = 1e-6;
        d.EPSILON = m;
        var y = "undefined" != typeof Float32Array ? Float32Array : Array;
        d.ARRAY_TYPE = y;
        var g = Math.random;
        d.RANDOM = g;
        var x = Math.PI / 180;
        Math.hypot || (Math.hypot = function() {
          for (var t2 = 0, e2 = arguments.length; e2--; )
            t2 += arguments[e2] * arguments[e2];
          return Math.sqrt(t2);
        });
        var b = {};
        function v(t2) {
          return v = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
            return typeof t3;
          } : function(t3) {
            return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
          }, v(t2);
        }
        Object.defineProperty(b, "__esModule", { value: true }), b.create = function() {
          var t2 = new _.ARRAY_TYPE(4);
          return _.ARRAY_TYPE != Float32Array && (t2[1] = 0, t2[2] = 0), t2[0] = 1, t2[3] = 1, t2;
        }, b.clone = function(t2) {
          var e2 = new _.ARRAY_TYPE(4);
          return e2[0] = t2[0], e2[1] = t2[1], e2[2] = t2[2], e2[3] = t2[3], e2;
        }, b.copy = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[3], t2;
        }, b.identity = function(t2) {
          return t2[0] = 1, t2[1] = 0, t2[2] = 0, t2[3] = 1, t2;
        }, b.fromValues = function(t2, e2, r2, n2) {
          var i2 = new _.ARRAY_TYPE(4);
          return i2[0] = t2, i2[1] = e2, i2[2] = r2, i2[3] = n2, i2;
        }, b.set = function(t2, e2, r2, n2, i2) {
          return t2[0] = e2, t2[1] = r2, t2[2] = n2, t2[3] = i2, t2;
        }, b.transpose = function(t2, e2) {
          if (t2 === e2) {
            var r2 = e2[1];
            t2[1] = e2[2], t2[2] = r2;
          } else
            t2[0] = e2[0], t2[1] = e2[2], t2[2] = e2[1], t2[3] = e2[3];
          return t2;
        }, b.invert = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = r2 * s2 - i2 * n2;
          return a2 ? (t2[0] = s2 * (a2 = 1 / a2), t2[1] = -n2 * a2, t2[2] = -i2 * a2, t2[3] = r2 * a2, t2) : null;
        }, b.adjoint = function(t2, e2) {
          var r2 = e2[0];
          return t2[0] = e2[3], t2[1] = -e2[1], t2[2] = -e2[2], t2[3] = r2, t2;
        }, b.determinant = function(t2) {
          return t2[0] * t2[3] - t2[2] * t2[1];
        }, b.multiply = M, b.rotate = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = Math.sin(r2), l2 = Math.cos(r2);
          return t2[0] = n2 * l2 + s2 * o2, t2[1] = i2 * l2 + a2 * o2, t2[2] = n2 * -o2 + s2 * l2, t2[3] = i2 * -o2 + a2 * l2, t2;
        }, b.scale = function(t2, e2, r2) {
          var n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = r2[0], o2 = r2[1];
          return t2[0] = e2[0] * a2, t2[1] = n2 * a2, t2[2] = i2 * o2, t2[3] = s2 * o2, t2;
        }, b.fromRotation = function(t2, e2) {
          var r2 = Math.sin(e2), n2 = Math.cos(e2);
          return t2[0] = n2, t2[1] = r2, t2[2] = -r2, t2[3] = n2, t2;
        }, b.fromScaling = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = 0, t2[2] = 0, t2[3] = e2[1], t2;
        }, b.str = function(t2) {
          return "mat2(" + t2[0] + ", " + t2[1] + ", " + t2[2] + ", " + t2[3] + ")";
        }, b.frob = function(t2) {
          return Math.hypot(t2[0], t2[1], t2[2], t2[3]);
        }, b.LDU = function(t2, e2, r2, n2) {
          return t2[2] = n2[2] / n2[0], r2[0] = n2[0], r2[1] = n2[1], r2[3] = n2[3] - t2[2] * r2[1], [t2, e2, r2];
        }, b.add = function(t2, e2, r2) {
          return t2[0] = e2[0] + r2[0], t2[1] = e2[1] + r2[1], t2[2] = e2[2] + r2[2], t2[3] = e2[3] + r2[3], t2;
        }, b.subtract = A, b.exactEquals = function(t2, e2) {
          return t2[0] === e2[0] && t2[1] === e2[1] && t2[2] === e2[2] && t2[3] === e2[3];
        }, b.equals = function(t2, e2) {
          var r2 = t2[0], n2 = t2[1], i2 = t2[2], s2 = t2[3], a2 = e2[0], o2 = e2[1], l2 = e2[2], u2 = e2[3];
          return Math.abs(r2 - a2) <= _.EPSILON * Math.max(1, Math.abs(r2), Math.abs(a2)) && Math.abs(n2 - o2) <= _.EPSILON * Math.max(1, Math.abs(n2), Math.abs(o2)) && Math.abs(i2 - l2) <= _.EPSILON * Math.max(1, Math.abs(i2), Math.abs(l2)) && Math.abs(s2 - u2) <= _.EPSILON * Math.max(1, Math.abs(s2), Math.abs(u2));
        }, b.multiplyScalar = function(t2, e2, r2) {
          return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2[2] = e2[2] * r2, t2[3] = e2[3] * r2, t2;
        }, b.multiplyScalarAndAdd = function(t2, e2, r2, n2) {
          return t2[0] = e2[0] + r2[0] * n2, t2[1] = e2[1] + r2[1] * n2, t2[2] = e2[2] + r2[2] * n2, t2[3] = e2[3] + r2[3] * n2, t2;
        }, b.sub = b.mul = void 0;
        var _ = function(t2, e2) {
          if (t2 && t2.__esModule)
            return t2;
          if (null === t2 || "object" !== v(t2) && "function" != typeof t2)
            return { default: t2 };
          var r2 = w(void 0);
          if (r2 && r2.has(t2))
            return r2.get(t2);
          var n2 = {}, i2 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s2 in t2)
            if ("default" !== s2 && Object.prototype.hasOwnProperty.call(t2, s2)) {
              var a2 = i2 ? Object.getOwnPropertyDescriptor(t2, s2) : null;
              a2 && (a2.get || a2.set) ? Object.defineProperty(n2, s2, a2) : n2[s2] = t2[s2];
            }
          return n2.default = t2, r2 && r2.set(t2, n2), n2;
        }(d);
        function w(t2) {
          if ("function" != typeof WeakMap)
            return null;
          var e2 = /* @__PURE__ */ new WeakMap(), r2 = /* @__PURE__ */ new WeakMap();
          return (w = function(t3) {
            return t3 ? r2 : e2;
          })(t2);
        }
        function M(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = r2[0], l2 = r2[1], u2 = r2[2], c2 = r2[3];
          return t2[0] = n2 * o2 + s2 * l2, t2[1] = i2 * o2 + a2 * l2, t2[2] = n2 * u2 + s2 * c2, t2[3] = i2 * u2 + a2 * c2, t2;
        }
        function A(t2, e2, r2) {
          return t2[0] = e2[0] - r2[0], t2[1] = e2[1] - r2[1], t2[2] = e2[2] - r2[2], t2[3] = e2[3] - r2[3], t2;
        }
        b.mul = M, b.sub = A;
        var S = {};
        function I(t2) {
          return I = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
            return typeof t3;
          } : function(t3) {
            return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
          }, I(t2);
        }
        Object.defineProperty(S, "__esModule", { value: true }), S.create = function() {
          var t2 = new T.ARRAY_TYPE(6);
          return T.ARRAY_TYPE != Float32Array && (t2[1] = 0, t2[2] = 0, t2[4] = 0, t2[5] = 0), t2[0] = 1, t2[3] = 1, t2;
        }, S.clone = function(t2) {
          var e2 = new T.ARRAY_TYPE(6);
          return e2[0] = t2[0], e2[1] = t2[1], e2[2] = t2[2], e2[3] = t2[3], e2[4] = t2[4], e2[5] = t2[5], e2;
        }, S.copy = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[3], t2[4] = e2[4], t2[5] = e2[5], t2;
        }, S.identity = function(t2) {
          return t2[0] = 1, t2[1] = 0, t2[2] = 0, t2[3] = 1, t2[4] = 0, t2[5] = 0, t2;
        }, S.fromValues = function(t2, e2, r2, n2, i2, s2) {
          var a2 = new T.ARRAY_TYPE(6);
          return a2[0] = t2, a2[1] = e2, a2[2] = r2, a2[3] = n2, a2[4] = i2, a2[5] = s2, a2;
        }, S.set = function(t2, e2, r2, n2, i2, s2, a2) {
          return t2[0] = e2, t2[1] = r2, t2[2] = n2, t2[3] = i2, t2[4] = s2, t2[5] = a2, t2;
        }, S.invert = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = e2[4], o2 = e2[5], l2 = r2 * s2 - n2 * i2;
          return l2 ? (t2[0] = s2 * (l2 = 1 / l2), t2[1] = -n2 * l2, t2[2] = -i2 * l2, t2[3] = r2 * l2, t2[4] = (i2 * o2 - s2 * a2) * l2, t2[5] = (n2 * a2 - r2 * o2) * l2, t2) : null;
        }, S.determinant = function(t2) {
          return t2[0] * t2[3] - t2[1] * t2[2];
        }, S.multiply = P, S.rotate = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = Math.sin(r2), c2 = Math.cos(r2);
          return t2[0] = n2 * c2 + s2 * u2, t2[1] = i2 * c2 + a2 * u2, t2[2] = n2 * -u2 + s2 * c2, t2[3] = i2 * -u2 + a2 * c2, t2[4] = o2, t2[5] = l2, t2;
        }, S.scale = function(t2, e2, r2) {
          var n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = e2[4], o2 = e2[5], l2 = r2[0], u2 = r2[1];
          return t2[0] = e2[0] * l2, t2[1] = n2 * l2, t2[2] = i2 * u2, t2[3] = s2 * u2, t2[4] = a2, t2[5] = o2, t2;
        }, S.translate = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = r2[0], c2 = r2[1];
          return t2[0] = n2, t2[1] = i2, t2[2] = s2, t2[3] = a2, t2[4] = n2 * u2 + s2 * c2 + o2, t2[5] = i2 * u2 + a2 * c2 + l2, t2;
        }, S.fromRotation = function(t2, e2) {
          var r2 = Math.sin(e2), n2 = Math.cos(e2);
          return t2[0] = n2, t2[1] = r2, t2[2] = -r2, t2[3] = n2, t2[4] = 0, t2[5] = 0, t2;
        }, S.fromScaling = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = 0, t2[2] = 0, t2[3] = e2[1], t2[4] = 0, t2[5] = 0, t2;
        }, S.fromTranslation = function(t2, e2) {
          return t2[0] = 1, t2[1] = 0, t2[2] = 0, t2[3] = 1, t2[4] = e2[0], t2[5] = e2[1], t2;
        }, S.str = function(t2) {
          return "mat2d(" + t2[0] + ", " + t2[1] + ", " + t2[2] + ", " + t2[3] + ", " + t2[4] + ", " + t2[5] + ")";
        }, S.frob = function(t2) {
          return Math.hypot(t2[0], t2[1], t2[2], t2[3], t2[4], t2[5], 1);
        }, S.add = function(t2, e2, r2) {
          return t2[0] = e2[0] + r2[0], t2[1] = e2[1] + r2[1], t2[2] = e2[2] + r2[2], t2[3] = e2[3] + r2[3], t2[4] = e2[4] + r2[4], t2[5] = e2[5] + r2[5], t2;
        }, S.subtract = z, S.multiplyScalar = function(t2, e2, r2) {
          return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2[2] = e2[2] * r2, t2[3] = e2[3] * r2, t2[4] = e2[4] * r2, t2[5] = e2[5] * r2, t2;
        }, S.multiplyScalarAndAdd = function(t2, e2, r2, n2) {
          return t2[0] = e2[0] + r2[0] * n2, t2[1] = e2[1] + r2[1] * n2, t2[2] = e2[2] + r2[2] * n2, t2[3] = e2[3] + r2[3] * n2, t2[4] = e2[4] + r2[4] * n2, t2[5] = e2[5] + r2[5] * n2, t2;
        }, S.exactEquals = function(t2, e2) {
          return t2[0] === e2[0] && t2[1] === e2[1] && t2[2] === e2[2] && t2[3] === e2[3] && t2[4] === e2[4] && t2[5] === e2[5];
        }, S.equals = function(t2, e2) {
          var r2 = t2[0], n2 = t2[1], i2 = t2[2], s2 = t2[3], a2 = t2[4], o2 = t2[5], l2 = e2[0], u2 = e2[1], c2 = e2[2], h2 = e2[3], p2 = e2[4], f2 = e2[5];
          return Math.abs(r2 - l2) <= T.EPSILON * Math.max(1, Math.abs(r2), Math.abs(l2)) && Math.abs(n2 - u2) <= T.EPSILON * Math.max(1, Math.abs(n2), Math.abs(u2)) && Math.abs(i2 - c2) <= T.EPSILON * Math.max(1, Math.abs(i2), Math.abs(c2)) && Math.abs(s2 - h2) <= T.EPSILON * Math.max(1, Math.abs(s2), Math.abs(h2)) && Math.abs(a2 - p2) <= T.EPSILON * Math.max(1, Math.abs(a2), Math.abs(p2)) && Math.abs(o2 - f2) <= T.EPSILON * Math.max(1, Math.abs(o2), Math.abs(f2));
        }, S.sub = S.mul = void 0;
        var T = function(t2, e2) {
          if (t2 && t2.__esModule)
            return t2;
          if (null === t2 || "object" !== I(t2) && "function" != typeof t2)
            return { default: t2 };
          var r2 = k(void 0);
          if (r2 && r2.has(t2))
            return r2.get(t2);
          var n2 = {}, i2 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s2 in t2)
            if ("default" !== s2 && Object.prototype.hasOwnProperty.call(t2, s2)) {
              var a2 = i2 ? Object.getOwnPropertyDescriptor(t2, s2) : null;
              a2 && (a2.get || a2.set) ? Object.defineProperty(n2, s2, a2) : n2[s2] = t2[s2];
            }
          return n2.default = t2, r2 && r2.set(t2, n2), n2;
        }(d);
        function k(t2) {
          if ("function" != typeof WeakMap)
            return null;
          var e2 = /* @__PURE__ */ new WeakMap(), r2 = /* @__PURE__ */ new WeakMap();
          return (k = function(t3) {
            return t3 ? r2 : e2;
          })(t2);
        }
        function P(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = r2[0], c2 = r2[1], h2 = r2[2], p2 = r2[3], f2 = r2[4], d2 = r2[5];
          return t2[0] = n2 * u2 + s2 * c2, t2[1] = i2 * u2 + a2 * c2, t2[2] = n2 * h2 + s2 * p2, t2[3] = i2 * h2 + a2 * p2, t2[4] = n2 * f2 + s2 * d2 + o2, t2[5] = i2 * f2 + a2 * d2 + l2, t2;
        }
        function z(t2, e2, r2) {
          return t2[0] = e2[0] - r2[0], t2[1] = e2[1] - r2[1], t2[2] = e2[2] - r2[2], t2[3] = e2[3] - r2[3], t2[4] = e2[4] - r2[4], t2[5] = e2[5] - r2[5], t2;
        }
        S.mul = P, S.sub = z;
        var E = {};
        function B(t2) {
          return B = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
            return typeof t3;
          } : function(t3) {
            return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
          }, B(t2);
        }
        Object.defineProperty(E, "__esModule", { value: true }), E.create = function() {
          var t2 = new D.ARRAY_TYPE(9);
          return D.ARRAY_TYPE != Float32Array && (t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[5] = 0, t2[6] = 0, t2[7] = 0), t2[0] = 1, t2[4] = 1, t2[8] = 1, t2;
        }, E.fromMat4 = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[4], t2[4] = e2[5], t2[5] = e2[6], t2[6] = e2[8], t2[7] = e2[9], t2[8] = e2[10], t2;
        }, E.clone = function(t2) {
          var e2 = new D.ARRAY_TYPE(9);
          return e2[0] = t2[0], e2[1] = t2[1], e2[2] = t2[2], e2[3] = t2[3], e2[4] = t2[4], e2[5] = t2[5], e2[6] = t2[6], e2[7] = t2[7], e2[8] = t2[8], e2;
        }, E.copy = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[3], t2[4] = e2[4], t2[5] = e2[5], t2[6] = e2[6], t2[7] = e2[7], t2[8] = e2[8], t2;
        }, E.fromValues = function(t2, e2, r2, n2, i2, s2, a2, o2, l2) {
          var u2 = new D.ARRAY_TYPE(9);
          return u2[0] = t2, u2[1] = e2, u2[2] = r2, u2[3] = n2, u2[4] = i2, u2[5] = s2, u2[6] = a2, u2[7] = o2, u2[8] = l2, u2;
        }, E.set = function(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2) {
          return t2[0] = e2, t2[1] = r2, t2[2] = n2, t2[3] = i2, t2[4] = s2, t2[5] = a2, t2[6] = o2, t2[7] = l2, t2[8] = u2, t2;
        }, E.identity = function(t2) {
          return t2[0] = 1, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 1, t2[5] = 0, t2[6] = 0, t2[7] = 0, t2[8] = 1, t2;
        }, E.transpose = function(t2, e2) {
          if (t2 === e2) {
            var r2 = e2[1], n2 = e2[2], i2 = e2[5];
            t2[1] = e2[3], t2[2] = e2[6], t2[3] = r2, t2[5] = e2[7], t2[6] = n2, t2[7] = i2;
          } else
            t2[0] = e2[0], t2[1] = e2[3], t2[2] = e2[6], t2[3] = e2[1], t2[4] = e2[4], t2[5] = e2[7], t2[6] = e2[2], t2[7] = e2[5], t2[8] = e2[8];
          return t2;
        }, E.invert = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = e2[4], o2 = e2[5], l2 = e2[6], u2 = e2[7], c2 = e2[8], h2 = c2 * a2 - o2 * u2, p2 = -c2 * s2 + o2 * l2, f2 = u2 * s2 - a2 * l2, d2 = r2 * h2 + n2 * p2 + i2 * f2;
          return d2 ? (t2[0] = h2 * (d2 = 1 / d2), t2[1] = (-c2 * n2 + i2 * u2) * d2, t2[2] = (o2 * n2 - i2 * a2) * d2, t2[3] = p2 * d2, t2[4] = (c2 * r2 - i2 * l2) * d2, t2[5] = (-o2 * r2 + i2 * s2) * d2, t2[6] = f2 * d2, t2[7] = (-u2 * r2 + n2 * l2) * d2, t2[8] = (a2 * r2 - n2 * s2) * d2, t2) : null;
        }, E.adjoint = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = e2[4], o2 = e2[5], l2 = e2[6], u2 = e2[7], c2 = e2[8];
          return t2[0] = a2 * c2 - o2 * u2, t2[1] = i2 * u2 - n2 * c2, t2[2] = n2 * o2 - i2 * a2, t2[3] = o2 * l2 - s2 * c2, t2[4] = r2 * c2 - i2 * l2, t2[5] = i2 * s2 - r2 * o2, t2[6] = s2 * u2 - a2 * l2, t2[7] = n2 * l2 - r2 * u2, t2[8] = r2 * a2 - n2 * s2, t2;
        }, E.determinant = function(t2) {
          var e2 = t2[3], r2 = t2[4], n2 = t2[5], i2 = t2[6], s2 = t2[7], a2 = t2[8];
          return t2[0] * (a2 * r2 - n2 * s2) + t2[1] * (-a2 * e2 + n2 * i2) + t2[2] * (s2 * e2 - r2 * i2);
        }, E.multiply = C, E.translate = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = e2[8], p2 = r2[0], f2 = r2[1];
          return t2[0] = n2, t2[1] = i2, t2[2] = s2, t2[3] = a2, t2[4] = o2, t2[5] = l2, t2[6] = p2 * n2 + f2 * a2 + u2, t2[7] = p2 * i2 + f2 * o2 + c2, t2[8] = p2 * s2 + f2 * l2 + h2, t2;
        }, E.rotate = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = e2[8], p2 = Math.sin(r2), f2 = Math.cos(r2);
          return t2[0] = f2 * n2 + p2 * a2, t2[1] = f2 * i2 + p2 * o2, t2[2] = f2 * s2 + p2 * l2, t2[3] = f2 * a2 - p2 * n2, t2[4] = f2 * o2 - p2 * i2, t2[5] = f2 * l2 - p2 * s2, t2[6] = u2, t2[7] = c2, t2[8] = h2, t2;
        }, E.scale = function(t2, e2, r2) {
          var n2 = r2[0], i2 = r2[1];
          return t2[0] = n2 * e2[0], t2[1] = n2 * e2[1], t2[2] = n2 * e2[2], t2[3] = i2 * e2[3], t2[4] = i2 * e2[4], t2[5] = i2 * e2[5], t2[6] = e2[6], t2[7] = e2[7], t2[8] = e2[8], t2;
        }, E.fromTranslation = function(t2, e2) {
          return t2[0] = 1, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 1, t2[5] = 0, t2[6] = e2[0], t2[7] = e2[1], t2[8] = 1, t2;
        }, E.fromRotation = function(t2, e2) {
          var r2 = Math.sin(e2), n2 = Math.cos(e2);
          return t2[0] = n2, t2[1] = r2, t2[2] = 0, t2[3] = -r2, t2[4] = n2, t2[5] = 0, t2[6] = 0, t2[7] = 0, t2[8] = 1, t2;
        }, E.fromScaling = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = e2[1], t2[5] = 0, t2[6] = 0, t2[7] = 0, t2[8] = 1, t2;
        }, E.fromMat2d = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = e2[1], t2[2] = 0, t2[3] = e2[2], t2[4] = e2[3], t2[5] = 0, t2[6] = e2[4], t2[7] = e2[5], t2[8] = 1, t2;
        }, E.fromQuat = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = r2 + r2, o2 = n2 + n2, l2 = i2 + i2, u2 = r2 * a2, c2 = n2 * a2, h2 = n2 * o2, p2 = i2 * a2, f2 = i2 * o2, d2 = i2 * l2, m2 = s2 * a2, y2 = s2 * o2, g2 = s2 * l2;
          return t2[0] = 1 - h2 - d2, t2[3] = c2 - g2, t2[6] = p2 + y2, t2[1] = c2 + g2, t2[4] = 1 - u2 - d2, t2[7] = f2 - m2, t2[2] = p2 - y2, t2[5] = f2 + m2, t2[8] = 1 - u2 - h2, t2;
        }, E.normalFromMat4 = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = e2[4], o2 = e2[5], l2 = e2[6], u2 = e2[7], c2 = e2[8], h2 = e2[9], p2 = e2[10], f2 = e2[11], d2 = e2[12], m2 = e2[13], y2 = e2[14], g2 = e2[15], x2 = r2 * o2 - n2 * a2, b2 = r2 * l2 - i2 * a2, v2 = r2 * u2 - s2 * a2, _2 = n2 * l2 - i2 * o2, w2 = n2 * u2 - s2 * o2, M2 = i2 * u2 - s2 * l2, A2 = c2 * m2 - h2 * d2, S2 = c2 * y2 - p2 * d2, I2 = c2 * g2 - f2 * d2, T2 = h2 * y2 - p2 * m2, k2 = h2 * g2 - f2 * m2, P2 = p2 * g2 - f2 * y2, z2 = x2 * P2 - b2 * k2 + v2 * T2 + _2 * I2 - w2 * S2 + M2 * A2;
          return z2 ? (t2[0] = (o2 * P2 - l2 * k2 + u2 * T2) * (z2 = 1 / z2), t2[1] = (l2 * I2 - a2 * P2 - u2 * S2) * z2, t2[2] = (a2 * k2 - o2 * I2 + u2 * A2) * z2, t2[3] = (i2 * k2 - n2 * P2 - s2 * T2) * z2, t2[4] = (r2 * P2 - i2 * I2 + s2 * S2) * z2, t2[5] = (n2 * I2 - r2 * k2 - s2 * A2) * z2, t2[6] = (m2 * M2 - y2 * w2 + g2 * _2) * z2, t2[7] = (y2 * v2 - d2 * M2 - g2 * b2) * z2, t2[8] = (d2 * w2 - m2 * v2 + g2 * x2) * z2, t2) : null;
        }, E.projection = function(t2, e2, r2) {
          return t2[0] = 2 / e2, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = -2 / r2, t2[5] = 0, t2[6] = -1, t2[7] = 1, t2[8] = 1, t2;
        }, E.str = function(t2) {
          return "mat3(" + t2[0] + ", " + t2[1] + ", " + t2[2] + ", " + t2[3] + ", " + t2[4] + ", " + t2[5] + ", " + t2[6] + ", " + t2[7] + ", " + t2[8] + ")";
        }, E.frob = function(t2) {
          return Math.hypot(t2[0], t2[1], t2[2], t2[3], t2[4], t2[5], t2[6], t2[7], t2[8]);
        }, E.add = function(t2, e2, r2) {
          return t2[0] = e2[0] + r2[0], t2[1] = e2[1] + r2[1], t2[2] = e2[2] + r2[2], t2[3] = e2[3] + r2[3], t2[4] = e2[4] + r2[4], t2[5] = e2[5] + r2[5], t2[6] = e2[6] + r2[6], t2[7] = e2[7] + r2[7], t2[8] = e2[8] + r2[8], t2;
        }, E.subtract = L, E.multiplyScalar = function(t2, e2, r2) {
          return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2[2] = e2[2] * r2, t2[3] = e2[3] * r2, t2[4] = e2[4] * r2, t2[5] = e2[5] * r2, t2[6] = e2[6] * r2, t2[7] = e2[7] * r2, t2[8] = e2[8] * r2, t2;
        }, E.multiplyScalarAndAdd = function(t2, e2, r2, n2) {
          return t2[0] = e2[0] + r2[0] * n2, t2[1] = e2[1] + r2[1] * n2, t2[2] = e2[2] + r2[2] * n2, t2[3] = e2[3] + r2[3] * n2, t2[4] = e2[4] + r2[4] * n2, t2[5] = e2[5] + r2[5] * n2, t2[6] = e2[6] + r2[6] * n2, t2[7] = e2[7] + r2[7] * n2, t2[8] = e2[8] + r2[8] * n2, t2;
        }, E.exactEquals = function(t2, e2) {
          return t2[0] === e2[0] && t2[1] === e2[1] && t2[2] === e2[2] && t2[3] === e2[3] && t2[4] === e2[4] && t2[5] === e2[5] && t2[6] === e2[6] && t2[7] === e2[7] && t2[8] === e2[8];
        }, E.equals = function(t2, e2) {
          var r2 = t2[0], n2 = t2[1], i2 = t2[2], s2 = t2[3], a2 = t2[4], o2 = t2[5], l2 = t2[6], u2 = t2[7], c2 = t2[8], h2 = e2[0], p2 = e2[1], f2 = e2[2], d2 = e2[3], m2 = e2[4], y2 = e2[5], g2 = e2[6], x2 = e2[7], b2 = e2[8];
          return Math.abs(r2 - h2) <= D.EPSILON * Math.max(1, Math.abs(r2), Math.abs(h2)) && Math.abs(n2 - p2) <= D.EPSILON * Math.max(1, Math.abs(n2), Math.abs(p2)) && Math.abs(i2 - f2) <= D.EPSILON * Math.max(1, Math.abs(i2), Math.abs(f2)) && Math.abs(s2 - d2) <= D.EPSILON * Math.max(1, Math.abs(s2), Math.abs(d2)) && Math.abs(a2 - m2) <= D.EPSILON * Math.max(1, Math.abs(a2), Math.abs(m2)) && Math.abs(o2 - y2) <= D.EPSILON * Math.max(1, Math.abs(o2), Math.abs(y2)) && Math.abs(l2 - g2) <= D.EPSILON * Math.max(1, Math.abs(l2), Math.abs(g2)) && Math.abs(u2 - x2) <= D.EPSILON * Math.max(1, Math.abs(u2), Math.abs(x2)) && Math.abs(c2 - b2) <= D.EPSILON * Math.max(1, Math.abs(c2), Math.abs(b2));
        }, E.sub = E.mul = void 0;
        var D = function(t2, e2) {
          if (t2 && t2.__esModule)
            return t2;
          if (null === t2 || "object" !== B(t2) && "function" != typeof t2)
            return { default: t2 };
          var r2 = R(void 0);
          if (r2 && r2.has(t2))
            return r2.get(t2);
          var n2 = {}, i2 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s2 in t2)
            if ("default" !== s2 && Object.prototype.hasOwnProperty.call(t2, s2)) {
              var a2 = i2 ? Object.getOwnPropertyDescriptor(t2, s2) : null;
              a2 && (a2.get || a2.set) ? Object.defineProperty(n2, s2, a2) : n2[s2] = t2[s2];
            }
          return n2.default = t2, r2 && r2.set(t2, n2), n2;
        }(d);
        function R(t2) {
          if ("function" != typeof WeakMap)
            return null;
          var e2 = /* @__PURE__ */ new WeakMap(), r2 = /* @__PURE__ */ new WeakMap();
          return (R = function(t3) {
            return t3 ? r2 : e2;
          })(t2);
        }
        function C(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = e2[8], p2 = r2[0], f2 = r2[1], d2 = r2[2], m2 = r2[3], y2 = r2[4], g2 = r2[5], x2 = r2[6], b2 = r2[7], v2 = r2[8];
          return t2[0] = p2 * n2 + f2 * a2 + d2 * u2, t2[1] = p2 * i2 + f2 * o2 + d2 * c2, t2[2] = p2 * s2 + f2 * l2 + d2 * h2, t2[3] = m2 * n2 + y2 * a2 + g2 * u2, t2[4] = m2 * i2 + y2 * o2 + g2 * c2, t2[5] = m2 * s2 + y2 * l2 + g2 * h2, t2[6] = x2 * n2 + b2 * a2 + v2 * u2, t2[7] = x2 * i2 + b2 * o2 + v2 * c2, t2[8] = x2 * s2 + b2 * l2 + v2 * h2, t2;
        }
        function L(t2, e2, r2) {
          return t2[0] = e2[0] - r2[0], t2[1] = e2[1] - r2[1], t2[2] = e2[2] - r2[2], t2[3] = e2[3] - r2[3], t2[4] = e2[4] - r2[4], t2[5] = e2[5] - r2[5], t2[6] = e2[6] - r2[6], t2[7] = e2[7] - r2[7], t2[8] = e2[8] - r2[8], t2;
        }
        E.mul = C, E.sub = L;
        var V = {};
        function F(t2) {
          return F = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
            return typeof t3;
          } : function(t3) {
            return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
          }, F(t2);
        }
        Object.defineProperty(V, "__esModule", { value: true }), V.create = function() {
          var t2 = new O.ARRAY_TYPE(16);
          return O.ARRAY_TYPE != Float32Array && (t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0), t2[0] = 1, t2[5] = 1, t2[10] = 1, t2[15] = 1, t2;
        }, V.clone = function(t2) {
          var e2 = new O.ARRAY_TYPE(16);
          return e2[0] = t2[0], e2[1] = t2[1], e2[2] = t2[2], e2[3] = t2[3], e2[4] = t2[4], e2[5] = t2[5], e2[6] = t2[6], e2[7] = t2[7], e2[8] = t2[8], e2[9] = t2[9], e2[10] = t2[10], e2[11] = t2[11], e2[12] = t2[12], e2[13] = t2[13], e2[14] = t2[14], e2[15] = t2[15], e2;
        }, V.copy = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[3], t2[4] = e2[4], t2[5] = e2[5], t2[6] = e2[6], t2[7] = e2[7], t2[8] = e2[8], t2[9] = e2[9], t2[10] = e2[10], t2[11] = e2[11], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15], t2;
        }, V.fromValues = function(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2) {
          var y2 = new O.ARRAY_TYPE(16);
          return y2[0] = t2, y2[1] = e2, y2[2] = r2, y2[3] = n2, y2[4] = i2, y2[5] = s2, y2[6] = a2, y2[7] = o2, y2[8] = l2, y2[9] = u2, y2[10] = c2, y2[11] = h2, y2[12] = p2, y2[13] = f2, y2[14] = d2, y2[15] = m2, y2;
        }, V.set = function(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2, y2) {
          return t2[0] = e2, t2[1] = r2, t2[2] = n2, t2[3] = i2, t2[4] = s2, t2[5] = a2, t2[6] = o2, t2[7] = l2, t2[8] = u2, t2[9] = c2, t2[10] = h2, t2[11] = p2, t2[12] = f2, t2[13] = d2, t2[14] = m2, t2[15] = y2, t2;
        }, V.identity = j, V.transpose = function(t2, e2) {
          if (t2 === e2) {
            var r2 = e2[1], n2 = e2[2], i2 = e2[3], s2 = e2[6], a2 = e2[7], o2 = e2[11];
            t2[1] = e2[4], t2[2] = e2[8], t2[3] = e2[12], t2[4] = r2, t2[6] = e2[9], t2[7] = e2[13], t2[8] = n2, t2[9] = s2, t2[11] = e2[14], t2[12] = i2, t2[13] = a2, t2[14] = o2;
          } else
            t2[0] = e2[0], t2[1] = e2[4], t2[2] = e2[8], t2[3] = e2[12], t2[4] = e2[1], t2[5] = e2[5], t2[6] = e2[9], t2[7] = e2[13], t2[8] = e2[2], t2[9] = e2[6], t2[10] = e2[10], t2[11] = e2[14], t2[12] = e2[3], t2[13] = e2[7], t2[14] = e2[11], t2[15] = e2[15];
          return t2;
        }, V.invert = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = e2[4], o2 = e2[5], l2 = e2[6], u2 = e2[7], c2 = e2[8], h2 = e2[9], p2 = e2[10], f2 = e2[11], d2 = e2[12], m2 = e2[13], y2 = e2[14], g2 = e2[15], x2 = r2 * o2 - n2 * a2, b2 = r2 * l2 - i2 * a2, v2 = r2 * u2 - s2 * a2, _2 = n2 * l2 - i2 * o2, w2 = n2 * u2 - s2 * o2, M2 = i2 * u2 - s2 * l2, A2 = c2 * m2 - h2 * d2, S2 = c2 * y2 - p2 * d2, I2 = c2 * g2 - f2 * d2, T2 = h2 * y2 - p2 * m2, k2 = h2 * g2 - f2 * m2, P2 = p2 * g2 - f2 * y2, z2 = x2 * P2 - b2 * k2 + v2 * T2 + _2 * I2 - w2 * S2 + M2 * A2;
          return z2 ? (t2[0] = (o2 * P2 - l2 * k2 + u2 * T2) * (z2 = 1 / z2), t2[1] = (i2 * k2 - n2 * P2 - s2 * T2) * z2, t2[2] = (m2 * M2 - y2 * w2 + g2 * _2) * z2, t2[3] = (p2 * w2 - h2 * M2 - f2 * _2) * z2, t2[4] = (l2 * I2 - a2 * P2 - u2 * S2) * z2, t2[5] = (r2 * P2 - i2 * I2 + s2 * S2) * z2, t2[6] = (y2 * v2 - d2 * M2 - g2 * b2) * z2, t2[7] = (c2 * M2 - p2 * v2 + f2 * b2) * z2, t2[8] = (a2 * k2 - o2 * I2 + u2 * A2) * z2, t2[9] = (n2 * I2 - r2 * k2 - s2 * A2) * z2, t2[10] = (d2 * w2 - m2 * v2 + g2 * x2) * z2, t2[11] = (h2 * v2 - c2 * w2 - f2 * x2) * z2, t2[12] = (o2 * S2 - a2 * T2 - l2 * A2) * z2, t2[13] = (r2 * T2 - n2 * S2 + i2 * A2) * z2, t2[14] = (m2 * b2 - d2 * _2 - y2 * x2) * z2, t2[15] = (c2 * _2 - h2 * b2 + p2 * x2) * z2, t2) : null;
        }, V.adjoint = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = e2[4], o2 = e2[5], l2 = e2[6], u2 = e2[7], c2 = e2[8], h2 = e2[9], p2 = e2[10], f2 = e2[11], d2 = e2[12], m2 = e2[13], y2 = e2[14], g2 = e2[15];
          return t2[0] = o2 * (p2 * g2 - f2 * y2) - h2 * (l2 * g2 - u2 * y2) + m2 * (l2 * f2 - u2 * p2), t2[1] = -(n2 * (p2 * g2 - f2 * y2) - h2 * (i2 * g2 - s2 * y2) + m2 * (i2 * f2 - s2 * p2)), t2[2] = n2 * (l2 * g2 - u2 * y2) - o2 * (i2 * g2 - s2 * y2) + m2 * (i2 * u2 - s2 * l2), t2[3] = -(n2 * (l2 * f2 - u2 * p2) - o2 * (i2 * f2 - s2 * p2) + h2 * (i2 * u2 - s2 * l2)), t2[4] = -(a2 * (p2 * g2 - f2 * y2) - c2 * (l2 * g2 - u2 * y2) + d2 * (l2 * f2 - u2 * p2)), t2[5] = r2 * (p2 * g2 - f2 * y2) - c2 * (i2 * g2 - s2 * y2) + d2 * (i2 * f2 - s2 * p2), t2[6] = -(r2 * (l2 * g2 - u2 * y2) - a2 * (i2 * g2 - s2 * y2) + d2 * (i2 * u2 - s2 * l2)), t2[7] = r2 * (l2 * f2 - u2 * p2) - a2 * (i2 * f2 - s2 * p2) + c2 * (i2 * u2 - s2 * l2), t2[8] = a2 * (h2 * g2 - f2 * m2) - c2 * (o2 * g2 - u2 * m2) + d2 * (o2 * f2 - u2 * h2), t2[9] = -(r2 * (h2 * g2 - f2 * m2) - c2 * (n2 * g2 - s2 * m2) + d2 * (n2 * f2 - s2 * h2)), t2[10] = r2 * (o2 * g2 - u2 * m2) - a2 * (n2 * g2 - s2 * m2) + d2 * (n2 * u2 - s2 * o2), t2[11] = -(r2 * (o2 * f2 - u2 * h2) - a2 * (n2 * f2 - s2 * h2) + c2 * (n2 * u2 - s2 * o2)), t2[12] = -(a2 * (h2 * y2 - p2 * m2) - c2 * (o2 * y2 - l2 * m2) + d2 * (o2 * p2 - l2 * h2)), t2[13] = r2 * (h2 * y2 - p2 * m2) - c2 * (n2 * y2 - i2 * m2) + d2 * (n2 * p2 - i2 * h2), t2[14] = -(r2 * (o2 * y2 - l2 * m2) - a2 * (n2 * y2 - i2 * m2) + d2 * (n2 * l2 - i2 * o2)), t2[15] = r2 * (o2 * p2 - l2 * h2) - a2 * (n2 * p2 - i2 * h2) + c2 * (n2 * l2 - i2 * o2), t2;
        }, V.determinant = function(t2) {
          var e2 = t2[0], r2 = t2[1], n2 = t2[2], i2 = t2[3], s2 = t2[4], a2 = t2[5], o2 = t2[6], l2 = t2[7], u2 = t2[8], c2 = t2[9], h2 = t2[10], p2 = t2[11], f2 = t2[12], d2 = t2[13], m2 = t2[14], y2 = t2[15];
          return (e2 * a2 - r2 * s2) * (h2 * y2 - p2 * m2) - (e2 * o2 - n2 * s2) * (c2 * y2 - p2 * d2) + (e2 * l2 - i2 * s2) * (c2 * m2 - h2 * d2) + (r2 * o2 - n2 * a2) * (u2 * y2 - p2 * f2) - (r2 * l2 - i2 * a2) * (u2 * m2 - h2 * f2) + (n2 * l2 - i2 * o2) * (u2 * d2 - c2 * f2);
        }, V.multiply = N, V.translate = function(t2, e2, r2) {
          var n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2 = r2[0], y2 = r2[1], g2 = r2[2];
          return e2 === t2 ? (t2[12] = e2[0] * m2 + e2[4] * y2 + e2[8] * g2 + e2[12], t2[13] = e2[1] * m2 + e2[5] * y2 + e2[9] * g2 + e2[13], t2[14] = e2[2] * m2 + e2[6] * y2 + e2[10] * g2 + e2[14], t2[15] = e2[3] * m2 + e2[7] * y2 + e2[11] * g2 + e2[15]) : (i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = e2[8], p2 = e2[9], f2 = e2[10], d2 = e2[11], t2[0] = n2 = e2[0], t2[1] = i2, t2[2] = s2, t2[3] = a2, t2[4] = o2, t2[5] = l2, t2[6] = u2, t2[7] = c2, t2[8] = h2, t2[9] = p2, t2[10] = f2, t2[11] = d2, t2[12] = n2 * m2 + o2 * y2 + h2 * g2 + e2[12], t2[13] = i2 * m2 + l2 * y2 + p2 * g2 + e2[13], t2[14] = s2 * m2 + u2 * y2 + f2 * g2 + e2[14], t2[15] = a2 * m2 + c2 * y2 + d2 * g2 + e2[15]), t2;
        }, V.scale = function(t2, e2, r2) {
          var n2 = r2[0], i2 = r2[1], s2 = r2[2];
          return t2[0] = e2[0] * n2, t2[1] = e2[1] * n2, t2[2] = e2[2] * n2, t2[3] = e2[3] * n2, t2[4] = e2[4] * i2, t2[5] = e2[5] * i2, t2[6] = e2[6] * i2, t2[7] = e2[7] * i2, t2[8] = e2[8] * s2, t2[9] = e2[9] * s2, t2[10] = e2[10] * s2, t2[11] = e2[11] * s2, t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15], t2;
        }, V.rotate = function(t2, e2, r2, n2) {
          var i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2, y2, g2, x2, b2, v2, _2, w2, M2, A2, S2, I2, T2, k2 = n2[0], P2 = n2[1], z2 = n2[2], E2 = Math.hypot(k2, P2, z2);
          return E2 < O.EPSILON ? null : (k2 *= E2 = 1 / E2, P2 *= E2, z2 *= E2, i2 = Math.sin(r2), s2 = Math.cos(r2), l2 = e2[1], u2 = e2[2], c2 = e2[3], p2 = e2[5], f2 = e2[6], d2 = e2[7], y2 = e2[9], g2 = e2[10], x2 = e2[11], b2 = k2 * k2 * (a2 = 1 - s2) + s2, w2 = k2 * P2 * a2 - z2 * i2, M2 = P2 * P2 * a2 + s2, A2 = z2 * P2 * a2 + k2 * i2, S2 = k2 * z2 * a2 + P2 * i2, I2 = P2 * z2 * a2 - k2 * i2, T2 = z2 * z2 * a2 + s2, t2[0] = (o2 = e2[0]) * b2 + (h2 = e2[4]) * (v2 = P2 * k2 * a2 + z2 * i2) + (m2 = e2[8]) * (_2 = z2 * k2 * a2 - P2 * i2), t2[1] = l2 * b2 + p2 * v2 + y2 * _2, t2[2] = u2 * b2 + f2 * v2 + g2 * _2, t2[3] = c2 * b2 + d2 * v2 + x2 * _2, t2[4] = o2 * w2 + h2 * M2 + m2 * A2, t2[5] = l2 * w2 + p2 * M2 + y2 * A2, t2[6] = u2 * w2 + f2 * M2 + g2 * A2, t2[7] = c2 * w2 + d2 * M2 + x2 * A2, t2[8] = o2 * S2 + h2 * I2 + m2 * T2, t2[9] = l2 * S2 + p2 * I2 + y2 * T2, t2[10] = u2 * S2 + f2 * I2 + g2 * T2, t2[11] = c2 * S2 + d2 * I2 + x2 * T2, e2 !== t2 && (t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15]), t2);
        }, V.rotateX = function(t2, e2, r2) {
          var n2 = Math.sin(r2), i2 = Math.cos(r2), s2 = e2[4], a2 = e2[5], o2 = e2[6], l2 = e2[7], u2 = e2[8], c2 = e2[9], h2 = e2[10], p2 = e2[11];
          return e2 !== t2 && (t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[3], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15]), t2[4] = s2 * i2 + u2 * n2, t2[5] = a2 * i2 + c2 * n2, t2[6] = o2 * i2 + h2 * n2, t2[7] = l2 * i2 + p2 * n2, t2[8] = u2 * i2 - s2 * n2, t2[9] = c2 * i2 - a2 * n2, t2[10] = h2 * i2 - o2 * n2, t2[11] = p2 * i2 - l2 * n2, t2;
        }, V.rotateY = function(t2, e2, r2) {
          var n2 = Math.sin(r2), i2 = Math.cos(r2), s2 = e2[0], a2 = e2[1], o2 = e2[2], l2 = e2[3], u2 = e2[8], c2 = e2[9], h2 = e2[10], p2 = e2[11];
          return e2 !== t2 && (t2[4] = e2[4], t2[5] = e2[5], t2[6] = e2[6], t2[7] = e2[7], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15]), t2[0] = s2 * i2 - u2 * n2, t2[1] = a2 * i2 - c2 * n2, t2[2] = o2 * i2 - h2 * n2, t2[3] = l2 * i2 - p2 * n2, t2[8] = s2 * n2 + u2 * i2, t2[9] = a2 * n2 + c2 * i2, t2[10] = o2 * n2 + h2 * i2, t2[11] = l2 * n2 + p2 * i2, t2;
        }, V.rotateZ = function(t2, e2, r2) {
          var n2 = Math.sin(r2), i2 = Math.cos(r2), s2 = e2[0], a2 = e2[1], o2 = e2[2], l2 = e2[3], u2 = e2[4], c2 = e2[5], h2 = e2[6], p2 = e2[7];
          return e2 !== t2 && (t2[8] = e2[8], t2[9] = e2[9], t2[10] = e2[10], t2[11] = e2[11], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15]), t2[0] = s2 * i2 + u2 * n2, t2[1] = a2 * i2 + c2 * n2, t2[2] = o2 * i2 + h2 * n2, t2[3] = l2 * i2 + p2 * n2, t2[4] = u2 * i2 - s2 * n2, t2[5] = c2 * i2 - a2 * n2, t2[6] = h2 * i2 - o2 * n2, t2[7] = p2 * i2 - l2 * n2, t2;
        }, V.fromTranslation = function(t2, e2) {
          return t2[0] = 1, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = 1, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = 1, t2[11] = 0, t2[12] = e2[0], t2[13] = e2[1], t2[14] = e2[2], t2[15] = 1, t2;
        }, V.fromScaling = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = e2[1], t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = e2[2], t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
        }, V.fromRotation = function(t2, e2, r2) {
          var n2, i2, s2, a2 = r2[0], o2 = r2[1], l2 = r2[2], u2 = Math.hypot(a2, o2, l2);
          return u2 < O.EPSILON ? null : (a2 *= u2 = 1 / u2, o2 *= u2, l2 *= u2, n2 = Math.sin(e2), i2 = Math.cos(e2), t2[0] = a2 * a2 * (s2 = 1 - i2) + i2, t2[1] = o2 * a2 * s2 + l2 * n2, t2[2] = l2 * a2 * s2 - o2 * n2, t2[3] = 0, t2[4] = a2 * o2 * s2 - l2 * n2, t2[5] = o2 * o2 * s2 + i2, t2[6] = l2 * o2 * s2 + a2 * n2, t2[7] = 0, t2[8] = a2 * l2 * s2 + o2 * n2, t2[9] = o2 * l2 * s2 - a2 * n2, t2[10] = l2 * l2 * s2 + i2, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2);
        }, V.fromXRotation = function(t2, e2) {
          var r2 = Math.sin(e2), n2 = Math.cos(e2);
          return t2[0] = 1, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = n2, t2[6] = r2, t2[7] = 0, t2[8] = 0, t2[9] = -r2, t2[10] = n2, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
        }, V.fromYRotation = function(t2, e2) {
          var r2 = Math.sin(e2), n2 = Math.cos(e2);
          return t2[0] = n2, t2[1] = 0, t2[2] = -r2, t2[3] = 0, t2[4] = 0, t2[5] = 1, t2[6] = 0, t2[7] = 0, t2[8] = r2, t2[9] = 0, t2[10] = n2, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
        }, V.fromZRotation = function(t2, e2) {
          var r2 = Math.sin(e2), n2 = Math.cos(e2);
          return t2[0] = n2, t2[1] = r2, t2[2] = 0, t2[3] = 0, t2[4] = -r2, t2[5] = n2, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = 1, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
        }, V.fromRotationTranslation = $, V.fromQuat2 = function(t2, e2) {
          var r2 = new O.ARRAY_TYPE(3), n2 = -e2[0], i2 = -e2[1], s2 = -e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = n2 * n2 + i2 * i2 + s2 * s2 + a2 * a2;
          return h2 > 0 ? (r2[0] = 2 * (o2 * a2 + c2 * n2 + l2 * s2 - u2 * i2) / h2, r2[1] = 2 * (l2 * a2 + c2 * i2 + u2 * n2 - o2 * s2) / h2, r2[2] = 2 * (u2 * a2 + c2 * s2 + o2 * i2 - l2 * n2) / h2) : (r2[0] = 2 * (o2 * a2 + c2 * n2 + l2 * s2 - u2 * i2), r2[1] = 2 * (l2 * a2 + c2 * i2 + u2 * n2 - o2 * s2), r2[2] = 2 * (u2 * a2 + c2 * s2 + o2 * i2 - l2 * n2)), $(t2, e2, r2), t2;
        }, V.getTranslation = function(t2, e2) {
          return t2[0] = e2[12], t2[1] = e2[13], t2[2] = e2[14], t2;
        }, V.getScaling = q, V.getRotation = function(t2, e2) {
          var r2 = new O.ARRAY_TYPE(3);
          q(r2, e2);
          var n2 = 1 / r2[0], i2 = 1 / r2[1], s2 = 1 / r2[2], a2 = e2[0] * n2, o2 = e2[1] * i2, l2 = e2[2] * s2, u2 = e2[4] * n2, c2 = e2[5] * i2, h2 = e2[6] * s2, p2 = e2[8] * n2, f2 = e2[9] * i2, d2 = e2[10] * s2, m2 = a2 + c2 + d2, y2 = 0;
          return m2 > 0 ? (y2 = 2 * Math.sqrt(m2 + 1), t2[3] = 0.25 * y2, t2[0] = (h2 - f2) / y2, t2[1] = (p2 - l2) / y2, t2[2] = (o2 - u2) / y2) : a2 > c2 && a2 > d2 ? (y2 = 2 * Math.sqrt(1 + a2 - c2 - d2), t2[3] = (h2 - f2) / y2, t2[0] = 0.25 * y2, t2[1] = (o2 + u2) / y2, t2[2] = (p2 + l2) / y2) : c2 > d2 ? (y2 = 2 * Math.sqrt(1 + c2 - a2 - d2), t2[3] = (p2 - l2) / y2, t2[0] = (o2 + u2) / y2, t2[1] = 0.25 * y2, t2[2] = (h2 + f2) / y2) : (y2 = 2 * Math.sqrt(1 + d2 - a2 - c2), t2[3] = (o2 - u2) / y2, t2[0] = (p2 + l2) / y2, t2[1] = (h2 + f2) / y2, t2[2] = 0.25 * y2), t2;
        }, V.fromRotationTranslationScale = function(t2, e2, r2, n2) {
          var i2 = e2[0], s2 = e2[1], a2 = e2[2], o2 = e2[3], l2 = i2 + i2, u2 = s2 + s2, c2 = a2 + a2, h2 = i2 * l2, p2 = i2 * u2, f2 = i2 * c2, d2 = s2 * u2, m2 = s2 * c2, y2 = a2 * c2, g2 = o2 * l2, x2 = o2 * u2, b2 = o2 * c2, v2 = n2[0], _2 = n2[1], w2 = n2[2];
          return t2[0] = (1 - (d2 + y2)) * v2, t2[1] = (p2 + b2) * v2, t2[2] = (f2 - x2) * v2, t2[3] = 0, t2[4] = (p2 - b2) * _2, t2[5] = (1 - (h2 + y2)) * _2, t2[6] = (m2 + g2) * _2, t2[7] = 0, t2[8] = (f2 + x2) * w2, t2[9] = (m2 - g2) * w2, t2[10] = (1 - (h2 + d2)) * w2, t2[11] = 0, t2[12] = r2[0], t2[13] = r2[1], t2[14] = r2[2], t2[15] = 1, t2;
        }, V.fromRotationTranslationScaleOrigin = function(t2, e2, r2, n2, i2) {
          var s2 = e2[0], a2 = e2[1], o2 = e2[2], l2 = e2[3], u2 = s2 + s2, c2 = a2 + a2, h2 = o2 + o2, p2 = s2 * u2, f2 = s2 * c2, d2 = s2 * h2, m2 = a2 * c2, y2 = a2 * h2, g2 = o2 * h2, x2 = l2 * u2, b2 = l2 * c2, v2 = l2 * h2, _2 = n2[0], w2 = n2[1], M2 = n2[2], A2 = i2[0], S2 = i2[1], I2 = i2[2], T2 = (1 - (m2 + g2)) * _2, k2 = (f2 + v2) * _2, P2 = (d2 - b2) * _2, z2 = (f2 - v2) * w2, E2 = (1 - (p2 + g2)) * w2, B2 = (y2 + x2) * w2, D2 = (d2 + b2) * M2, R2 = (y2 - x2) * M2, C2 = (1 - (p2 + m2)) * M2;
          return t2[0] = T2, t2[1] = k2, t2[2] = P2, t2[3] = 0, t2[4] = z2, t2[5] = E2, t2[6] = B2, t2[7] = 0, t2[8] = D2, t2[9] = R2, t2[10] = C2, t2[11] = 0, t2[12] = r2[0] + A2 - (T2 * A2 + z2 * S2 + D2 * I2), t2[13] = r2[1] + S2 - (k2 * A2 + E2 * S2 + R2 * I2), t2[14] = r2[2] + I2 - (P2 * A2 + B2 * S2 + C2 * I2), t2[15] = 1, t2;
        }, V.fromQuat = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = r2 + r2, o2 = n2 + n2, l2 = i2 + i2, u2 = r2 * a2, c2 = n2 * a2, h2 = n2 * o2, p2 = i2 * a2, f2 = i2 * o2, d2 = i2 * l2, m2 = s2 * a2, y2 = s2 * o2, g2 = s2 * l2;
          return t2[0] = 1 - h2 - d2, t2[1] = c2 + g2, t2[2] = p2 - y2, t2[3] = 0, t2[4] = c2 - g2, t2[5] = 1 - u2 - d2, t2[6] = f2 + m2, t2[7] = 0, t2[8] = p2 + y2, t2[9] = f2 - m2, t2[10] = 1 - u2 - h2, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
        }, V.frustum = function(t2, e2, r2, n2, i2, s2, a2) {
          var o2 = 1 / (r2 - e2), l2 = 1 / (i2 - n2), u2 = 1 / (s2 - a2);
          return t2[0] = 2 * s2 * o2, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = 2 * s2 * l2, t2[6] = 0, t2[7] = 0, t2[8] = (r2 + e2) * o2, t2[9] = (i2 + n2) * l2, t2[10] = (a2 + s2) * u2, t2[11] = -1, t2[12] = 0, t2[13] = 0, t2[14] = a2 * s2 * 2 * u2, t2[15] = 0, t2;
        }, V.perspectiveNO = G, V.perspectiveZO = function(t2, e2, r2, n2, i2) {
          var s2, a2 = 1 / Math.tan(e2 / 2);
          return t2[0] = a2 / r2, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = a2, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[11] = -1, t2[12] = 0, t2[13] = 0, t2[15] = 0, null != i2 && i2 !== 1 / 0 ? (t2[10] = i2 * (s2 = 1 / (n2 - i2)), t2[14] = i2 * n2 * s2) : (t2[10] = -1, t2[14] = -n2), t2;
        }, V.perspectiveFromFieldOfView = function(t2, e2, r2, n2) {
          var i2 = Math.tan(e2.upDegrees * Math.PI / 180), s2 = Math.tan(e2.downDegrees * Math.PI / 180), a2 = Math.tan(e2.leftDegrees * Math.PI / 180), o2 = Math.tan(e2.rightDegrees * Math.PI / 180), l2 = 2 / (a2 + o2), u2 = 2 / (i2 + s2);
          return t2[0] = l2, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = u2, t2[6] = 0, t2[7] = 0, t2[8] = -(a2 - o2) * l2 * 0.5, t2[9] = (i2 - s2) * u2 * 0.5, t2[10] = n2 / (r2 - n2), t2[11] = -1, t2[12] = 0, t2[13] = 0, t2[14] = n2 * r2 / (r2 - n2), t2[15] = 0, t2;
        }, V.orthoNO = X, V.orthoZO = function(t2, e2, r2, n2, i2, s2, a2) {
          var o2 = 1 / (e2 - r2), l2 = 1 / (n2 - i2), u2 = 1 / (s2 - a2);
          return t2[0] = -2 * o2, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = -2 * l2, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = u2, t2[11] = 0, t2[12] = (e2 + r2) * o2, t2[13] = (i2 + n2) * l2, t2[14] = s2 * u2, t2[15] = 1, t2;
        }, V.lookAt = function(t2, e2, r2, n2) {
          var i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2 = e2[0], m2 = e2[1], y2 = e2[2], g2 = n2[0], x2 = n2[1], b2 = n2[2], v2 = r2[0], _2 = r2[1], w2 = r2[2];
          return Math.abs(d2 - v2) < O.EPSILON && Math.abs(m2 - _2) < O.EPSILON && Math.abs(y2 - w2) < O.EPSILON ? j(t2) : (c2 = d2 - v2, h2 = m2 - _2, p2 = y2 - w2, i2 = x2 * (p2 *= f2 = 1 / Math.hypot(c2, h2, p2)) - b2 * (h2 *= f2), s2 = b2 * (c2 *= f2) - g2 * p2, a2 = g2 * h2 - x2 * c2, (f2 = Math.hypot(i2, s2, a2)) ? (i2 *= f2 = 1 / f2, s2 *= f2, a2 *= f2) : (i2 = 0, s2 = 0, a2 = 0), o2 = h2 * a2 - p2 * s2, l2 = p2 * i2 - c2 * a2, u2 = c2 * s2 - h2 * i2, (f2 = Math.hypot(o2, l2, u2)) ? (o2 *= f2 = 1 / f2, l2 *= f2, u2 *= f2) : (o2 = 0, l2 = 0, u2 = 0), t2[0] = i2, t2[1] = o2, t2[2] = c2, t2[3] = 0, t2[4] = s2, t2[5] = l2, t2[6] = h2, t2[7] = 0, t2[8] = a2, t2[9] = u2, t2[10] = p2, t2[11] = 0, t2[12] = -(i2 * d2 + s2 * m2 + a2 * y2), t2[13] = -(o2 * d2 + l2 * m2 + u2 * y2), t2[14] = -(c2 * d2 + h2 * m2 + p2 * y2), t2[15] = 1, t2);
        }, V.targetTo = function(t2, e2, r2, n2) {
          var i2 = e2[0], s2 = e2[1], a2 = e2[2], o2 = n2[0], l2 = n2[1], u2 = n2[2], c2 = i2 - r2[0], h2 = s2 - r2[1], p2 = a2 - r2[2], f2 = c2 * c2 + h2 * h2 + p2 * p2;
          f2 > 0 && (c2 *= f2 = 1 / Math.sqrt(f2), h2 *= f2, p2 *= f2);
          var d2 = l2 * p2 - u2 * h2, m2 = u2 * c2 - o2 * p2, y2 = o2 * h2 - l2 * c2;
          return (f2 = d2 * d2 + m2 * m2 + y2 * y2) > 0 && (d2 *= f2 = 1 / Math.sqrt(f2), m2 *= f2, y2 *= f2), t2[0] = d2, t2[1] = m2, t2[2] = y2, t2[3] = 0, t2[4] = h2 * y2 - p2 * m2, t2[5] = p2 * d2 - c2 * y2, t2[6] = c2 * m2 - h2 * d2, t2[7] = 0, t2[8] = c2, t2[9] = h2, t2[10] = p2, t2[11] = 0, t2[12] = i2, t2[13] = s2, t2[14] = a2, t2[15] = 1, t2;
        }, V.str = function(t2) {
          return "mat4(" + t2[0] + ", " + t2[1] + ", " + t2[2] + ", " + t2[3] + ", " + t2[4] + ", " + t2[5] + ", " + t2[6] + ", " + t2[7] + ", " + t2[8] + ", " + t2[9] + ", " + t2[10] + ", " + t2[11] + ", " + t2[12] + ", " + t2[13] + ", " + t2[14] + ", " + t2[15] + ")";
        }, V.frob = function(t2) {
          return Math.hypot(t2[0], t2[1], t2[2], t2[3], t2[4], t2[5], t2[6], t2[7], t2[8], t2[9], t2[10], t2[11], t2[12], t2[13], t2[14], t2[15]);
        }, V.add = function(t2, e2, r2) {
          return t2[0] = e2[0] + r2[0], t2[1] = e2[1] + r2[1], t2[2] = e2[2] + r2[2], t2[3] = e2[3] + r2[3], t2[4] = e2[4] + r2[4], t2[5] = e2[5] + r2[5], t2[6] = e2[6] + r2[6], t2[7] = e2[7] + r2[7], t2[8] = e2[8] + r2[8], t2[9] = e2[9] + r2[9], t2[10] = e2[10] + r2[10], t2[11] = e2[11] + r2[11], t2[12] = e2[12] + r2[12], t2[13] = e2[13] + r2[13], t2[14] = e2[14] + r2[14], t2[15] = e2[15] + r2[15], t2;
        }, V.subtract = Y, V.multiplyScalar = function(t2, e2, r2) {
          return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2[2] = e2[2] * r2, t2[3] = e2[3] * r2, t2[4] = e2[4] * r2, t2[5] = e2[5] * r2, t2[6] = e2[6] * r2, t2[7] = e2[7] * r2, t2[8] = e2[8] * r2, t2[9] = e2[9] * r2, t2[10] = e2[10] * r2, t2[11] = e2[11] * r2, t2[12] = e2[12] * r2, t2[13] = e2[13] * r2, t2[14] = e2[14] * r2, t2[15] = e2[15] * r2, t2;
        }, V.multiplyScalarAndAdd = function(t2, e2, r2, n2) {
          return t2[0] = e2[0] + r2[0] * n2, t2[1] = e2[1] + r2[1] * n2, t2[2] = e2[2] + r2[2] * n2, t2[3] = e2[3] + r2[3] * n2, t2[4] = e2[4] + r2[4] * n2, t2[5] = e2[5] + r2[5] * n2, t2[6] = e2[6] + r2[6] * n2, t2[7] = e2[7] + r2[7] * n2, t2[8] = e2[8] + r2[8] * n2, t2[9] = e2[9] + r2[9] * n2, t2[10] = e2[10] + r2[10] * n2, t2[11] = e2[11] + r2[11] * n2, t2[12] = e2[12] + r2[12] * n2, t2[13] = e2[13] + r2[13] * n2, t2[14] = e2[14] + r2[14] * n2, t2[15] = e2[15] + r2[15] * n2, t2;
        }, V.exactEquals = function(t2, e2) {
          return t2[0] === e2[0] && t2[1] === e2[1] && t2[2] === e2[2] && t2[3] === e2[3] && t2[4] === e2[4] && t2[5] === e2[5] && t2[6] === e2[6] && t2[7] === e2[7] && t2[8] === e2[8] && t2[9] === e2[9] && t2[10] === e2[10] && t2[11] === e2[11] && t2[12] === e2[12] && t2[13] === e2[13] && t2[14] === e2[14] && t2[15] === e2[15];
        }, V.equals = function(t2, e2) {
          var r2 = t2[0], n2 = t2[1], i2 = t2[2], s2 = t2[3], a2 = t2[4], o2 = t2[5], l2 = t2[6], u2 = t2[7], c2 = t2[8], h2 = t2[9], p2 = t2[10], f2 = t2[11], d2 = t2[12], m2 = t2[13], y2 = t2[14], g2 = t2[15], x2 = e2[0], b2 = e2[1], v2 = e2[2], _2 = e2[3], w2 = e2[4], M2 = e2[5], A2 = e2[6], S2 = e2[7], I2 = e2[8], T2 = e2[9], k2 = e2[10], P2 = e2[11], z2 = e2[12], E2 = e2[13], B2 = e2[14], D2 = e2[15];
          return Math.abs(r2 - x2) <= O.EPSILON * Math.max(1, Math.abs(r2), Math.abs(x2)) && Math.abs(n2 - b2) <= O.EPSILON * Math.max(1, Math.abs(n2), Math.abs(b2)) && Math.abs(i2 - v2) <= O.EPSILON * Math.max(1, Math.abs(i2), Math.abs(v2)) && Math.abs(s2 - _2) <= O.EPSILON * Math.max(1, Math.abs(s2), Math.abs(_2)) && Math.abs(a2 - w2) <= O.EPSILON * Math.max(1, Math.abs(a2), Math.abs(w2)) && Math.abs(o2 - M2) <= O.EPSILON * Math.max(1, Math.abs(o2), Math.abs(M2)) && Math.abs(l2 - A2) <= O.EPSILON * Math.max(1, Math.abs(l2), Math.abs(A2)) && Math.abs(u2 - S2) <= O.EPSILON * Math.max(1, Math.abs(u2), Math.abs(S2)) && Math.abs(c2 - I2) <= O.EPSILON * Math.max(1, Math.abs(c2), Math.abs(I2)) && Math.abs(h2 - T2) <= O.EPSILON * Math.max(1, Math.abs(h2), Math.abs(T2)) && Math.abs(p2 - k2) <= O.EPSILON * Math.max(1, Math.abs(p2), Math.abs(k2)) && Math.abs(f2 - P2) <= O.EPSILON * Math.max(1, Math.abs(f2), Math.abs(P2)) && Math.abs(d2 - z2) <= O.EPSILON * Math.max(1, Math.abs(d2), Math.abs(z2)) && Math.abs(m2 - E2) <= O.EPSILON * Math.max(1, Math.abs(m2), Math.abs(E2)) && Math.abs(y2 - B2) <= O.EPSILON * Math.max(1, Math.abs(y2), Math.abs(B2)) && Math.abs(g2 - D2) <= O.EPSILON * Math.max(1, Math.abs(g2), Math.abs(D2));
        }, V.sub = V.mul = V.ortho = V.perspective = void 0;
        var O = function(t2, e2) {
          if (t2 && t2.__esModule)
            return t2;
          if (null === t2 || "object" !== F(t2) && "function" != typeof t2)
            return { default: t2 };
          var r2 = U(void 0);
          if (r2 && r2.has(t2))
            return r2.get(t2);
          var n2 = {}, i2 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s2 in t2)
            if ("default" !== s2 && Object.prototype.hasOwnProperty.call(t2, s2)) {
              var a2 = i2 ? Object.getOwnPropertyDescriptor(t2, s2) : null;
              a2 && (a2.get || a2.set) ? Object.defineProperty(n2, s2, a2) : n2[s2] = t2[s2];
            }
          return n2.default = t2, r2 && r2.set(t2, n2), n2;
        }(d);
        function U(t2) {
          if ("function" != typeof WeakMap)
            return null;
          var e2 = /* @__PURE__ */ new WeakMap(), r2 = /* @__PURE__ */ new WeakMap();
          return (U = function(t3) {
            return t3 ? r2 : e2;
          })(t2);
        }
        function j(t2) {
          return t2[0] = 1, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = 1, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = 1, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
        }
        function N(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = e2[8], p2 = e2[9], f2 = e2[10], d2 = e2[11], m2 = e2[12], y2 = e2[13], g2 = e2[14], x2 = e2[15], b2 = r2[0], v2 = r2[1], _2 = r2[2], w2 = r2[3];
          return t2[0] = b2 * n2 + v2 * o2 + _2 * h2 + w2 * m2, t2[1] = b2 * i2 + v2 * l2 + _2 * p2 + w2 * y2, t2[2] = b2 * s2 + v2 * u2 + _2 * f2 + w2 * g2, t2[3] = b2 * a2 + v2 * c2 + _2 * d2 + w2 * x2, t2[4] = (b2 = r2[4]) * n2 + (v2 = r2[5]) * o2 + (_2 = r2[6]) * h2 + (w2 = r2[7]) * m2, t2[5] = b2 * i2 + v2 * l2 + _2 * p2 + w2 * y2, t2[6] = b2 * s2 + v2 * u2 + _2 * f2 + w2 * g2, t2[7] = b2 * a2 + v2 * c2 + _2 * d2 + w2 * x2, t2[8] = (b2 = r2[8]) * n2 + (v2 = r2[9]) * o2 + (_2 = r2[10]) * h2 + (w2 = r2[11]) * m2, t2[9] = b2 * i2 + v2 * l2 + _2 * p2 + w2 * y2, t2[10] = b2 * s2 + v2 * u2 + _2 * f2 + w2 * g2, t2[11] = b2 * a2 + v2 * c2 + _2 * d2 + w2 * x2, t2[12] = (b2 = r2[12]) * n2 + (v2 = r2[13]) * o2 + (_2 = r2[14]) * h2 + (w2 = r2[15]) * m2, t2[13] = b2 * i2 + v2 * l2 + _2 * p2 + w2 * y2, t2[14] = b2 * s2 + v2 * u2 + _2 * f2 + w2 * g2, t2[15] = b2 * a2 + v2 * c2 + _2 * d2 + w2 * x2, t2;
        }
        function $(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = n2 + n2, l2 = i2 + i2, u2 = s2 + s2, c2 = n2 * o2, h2 = n2 * l2, p2 = n2 * u2, f2 = i2 * l2, d2 = i2 * u2, m2 = s2 * u2, y2 = a2 * o2, g2 = a2 * l2, x2 = a2 * u2;
          return t2[0] = 1 - (f2 + m2), t2[1] = h2 + x2, t2[2] = p2 - g2, t2[3] = 0, t2[4] = h2 - x2, t2[5] = 1 - (c2 + m2), t2[6] = d2 + y2, t2[7] = 0, t2[8] = p2 + g2, t2[9] = d2 - y2, t2[10] = 1 - (c2 + f2), t2[11] = 0, t2[12] = r2[0], t2[13] = r2[1], t2[14] = r2[2], t2[15] = 1, t2;
        }
        function q(t2, e2) {
          var r2 = e2[4], n2 = e2[5], i2 = e2[6], s2 = e2[8], a2 = e2[9], o2 = e2[10];
          return t2[0] = Math.hypot(e2[0], e2[1], e2[2]), t2[1] = Math.hypot(r2, n2, i2), t2[2] = Math.hypot(s2, a2, o2), t2;
        }
        function G(t2, e2, r2, n2, i2) {
          var s2, a2 = 1 / Math.tan(e2 / 2);
          return t2[0] = a2 / r2, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = a2, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[11] = -1, t2[12] = 0, t2[13] = 0, t2[15] = 0, null != i2 && i2 !== 1 / 0 ? (t2[10] = (i2 + n2) * (s2 = 1 / (n2 - i2)), t2[14] = 2 * i2 * n2 * s2) : (t2[10] = -1, t2[14] = -2 * n2), t2;
        }
        function X(t2, e2, r2, n2, i2, s2, a2) {
          var o2 = 1 / (e2 - r2), l2 = 1 / (n2 - i2), u2 = 1 / (s2 - a2);
          return t2[0] = -2 * o2, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = -2 * l2, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = 2 * u2, t2[11] = 0, t2[12] = (e2 + r2) * o2, t2[13] = (i2 + n2) * l2, t2[14] = (a2 + s2) * u2, t2[15] = 1, t2;
        }
        function Y(t2, e2, r2) {
          return t2[0] = e2[0] - r2[0], t2[1] = e2[1] - r2[1], t2[2] = e2[2] - r2[2], t2[3] = e2[3] - r2[3], t2[4] = e2[4] - r2[4], t2[5] = e2[5] - r2[5], t2[6] = e2[6] - r2[6], t2[7] = e2[7] - r2[7], t2[8] = e2[8] - r2[8], t2[9] = e2[9] - r2[9], t2[10] = e2[10] - r2[10], t2[11] = e2[11] - r2[11], t2[12] = e2[12] - r2[12], t2[13] = e2[13] - r2[13], t2[14] = e2[14] - r2[14], t2[15] = e2[15] - r2[15], t2;
        }
        V.perspective = G, V.ortho = X, V.mul = N, V.sub = Y;
        var Z = {}, H = {};
        function K(t2) {
          return K = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
            return typeof t3;
          } : function(t3) {
            return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
          }, K(t2);
        }
        Object.defineProperty(H, "__esModule", { value: true }), H.create = Q, H.clone = function(t2) {
          var e2 = new W.ARRAY_TYPE(3);
          return e2[0] = t2[0], e2[1] = t2[1], e2[2] = t2[2], e2;
        }, H.length = tt, H.fromValues = function(t2, e2, r2) {
          var n2 = new W.ARRAY_TYPE(3);
          return n2[0] = t2, n2[1] = e2, n2[2] = r2, n2;
        }, H.copy = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2;
        }, H.set = function(t2, e2, r2, n2) {
          return t2[0] = e2, t2[1] = r2, t2[2] = n2, t2;
        }, H.add = function(t2, e2, r2) {
          return t2[0] = e2[0] + r2[0], t2[1] = e2[1] + r2[1], t2[2] = e2[2] + r2[2], t2;
        }, H.subtract = et, H.multiply = rt, H.divide = nt, H.ceil = function(t2, e2) {
          return t2[0] = Math.ceil(e2[0]), t2[1] = Math.ceil(e2[1]), t2[2] = Math.ceil(e2[2]), t2;
        }, H.floor = function(t2, e2) {
          return t2[0] = Math.floor(e2[0]), t2[1] = Math.floor(e2[1]), t2[2] = Math.floor(e2[2]), t2;
        }, H.min = function(t2, e2, r2) {
          return t2[0] = Math.min(e2[0], r2[0]), t2[1] = Math.min(e2[1], r2[1]), t2[2] = Math.min(e2[2], r2[2]), t2;
        }, H.max = function(t2, e2, r2) {
          return t2[0] = Math.max(e2[0], r2[0]), t2[1] = Math.max(e2[1], r2[1]), t2[2] = Math.max(e2[2], r2[2]), t2;
        }, H.round = function(t2, e2) {
          return t2[0] = Math.round(e2[0]), t2[1] = Math.round(e2[1]), t2[2] = Math.round(e2[2]), t2;
        }, H.scale = function(t2, e2, r2) {
          return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2[2] = e2[2] * r2, t2;
        }, H.scaleAndAdd = function(t2, e2, r2, n2) {
          return t2[0] = e2[0] + r2[0] * n2, t2[1] = e2[1] + r2[1] * n2, t2[2] = e2[2] + r2[2] * n2, t2;
        }, H.distance = it, H.squaredDistance = st, H.squaredLength = at, H.negate = function(t2, e2) {
          return t2[0] = -e2[0], t2[1] = -e2[1], t2[2] = -e2[2], t2;
        }, H.inverse = function(t2, e2) {
          return t2[0] = 1 / e2[0], t2[1] = 1 / e2[1], t2[2] = 1 / e2[2], t2;
        }, H.normalize = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = r2 * r2 + n2 * n2 + i2 * i2;
          return s2 > 0 && (s2 = 1 / Math.sqrt(s2)), t2[0] = e2[0] * s2, t2[1] = e2[1] * s2, t2[2] = e2[2] * s2, t2;
        }, H.dot = ot, H.cross = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = r2[0], o2 = r2[1], l2 = r2[2];
          return t2[0] = i2 * l2 - s2 * o2, t2[1] = s2 * a2 - n2 * l2, t2[2] = n2 * o2 - i2 * a2, t2;
        }, H.lerp = function(t2, e2, r2, n2) {
          var i2 = e2[0], s2 = e2[1], a2 = e2[2];
          return t2[0] = i2 + n2 * (r2[0] - i2), t2[1] = s2 + n2 * (r2[1] - s2), t2[2] = a2 + n2 * (r2[2] - a2), t2;
        }, H.hermite = function(t2, e2, r2, n2, i2, s2) {
          var a2 = s2 * s2, o2 = a2 * (2 * s2 - 3) + 1, l2 = a2 * (s2 - 2) + s2, u2 = a2 * (s2 - 1), c2 = a2 * (3 - 2 * s2);
          return t2[0] = e2[0] * o2 + r2[0] * l2 + n2[0] * u2 + i2[0] * c2, t2[1] = e2[1] * o2 + r2[1] * l2 + n2[1] * u2 + i2[1] * c2, t2[2] = e2[2] * o2 + r2[2] * l2 + n2[2] * u2 + i2[2] * c2, t2;
        }, H.bezier = function(t2, e2, r2, n2, i2, s2) {
          var a2 = 1 - s2, o2 = a2 * a2, l2 = s2 * s2, u2 = o2 * a2, c2 = 3 * s2 * o2, h2 = 3 * l2 * a2, p2 = l2 * s2;
          return t2[0] = e2[0] * u2 + r2[0] * c2 + n2[0] * h2 + i2[0] * p2, t2[1] = e2[1] * u2 + r2[1] * c2 + n2[1] * h2 + i2[1] * p2, t2[2] = e2[2] * u2 + r2[2] * c2 + n2[2] * h2 + i2[2] * p2, t2;
        }, H.random = function(t2, e2) {
          e2 = e2 || 1;
          var r2 = 2 * W.RANDOM() * Math.PI, n2 = 2 * W.RANDOM() - 1, i2 = Math.sqrt(1 - n2 * n2) * e2;
          return t2[0] = Math.cos(r2) * i2, t2[1] = Math.sin(r2) * i2, t2[2] = n2 * e2, t2;
        }, H.transformMat4 = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = r2[3] * n2 + r2[7] * i2 + r2[11] * s2 + r2[15];
          return t2[0] = (r2[0] * n2 + r2[4] * i2 + r2[8] * s2 + r2[12]) / (a2 = a2 || 1), t2[1] = (r2[1] * n2 + r2[5] * i2 + r2[9] * s2 + r2[13]) / a2, t2[2] = (r2[2] * n2 + r2[6] * i2 + r2[10] * s2 + r2[14]) / a2, t2;
        }, H.transformMat3 = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2];
          return t2[0] = n2 * r2[0] + i2 * r2[3] + s2 * r2[6], t2[1] = n2 * r2[1] + i2 * r2[4] + s2 * r2[7], t2[2] = n2 * r2[2] + i2 * r2[5] + s2 * r2[8], t2;
        }, H.transformQuat = function(t2, e2, r2) {
          var n2 = r2[0], i2 = r2[1], s2 = r2[2], a2 = e2[0], o2 = e2[1], l2 = e2[2], u2 = i2 * l2 - s2 * o2, c2 = s2 * a2 - n2 * l2, h2 = n2 * o2 - i2 * a2, p2 = i2 * h2 - s2 * c2, f2 = s2 * u2 - n2 * h2, d2 = n2 * c2 - i2 * u2, m2 = 2 * r2[3];
          return c2 *= m2, h2 *= m2, f2 *= 2, d2 *= 2, t2[0] = a2 + (u2 *= m2) + (p2 *= 2), t2[1] = o2 + c2 + f2, t2[2] = l2 + h2 + d2, t2;
        }, H.rotateX = function(t2, e2, r2, n2) {
          var i2 = [], s2 = [];
          return i2[0] = e2[0] - r2[0], i2[1] = e2[1] - r2[1], i2[2] = e2[2] - r2[2], s2[0] = i2[0], s2[1] = i2[1] * Math.cos(n2) - i2[2] * Math.sin(n2), s2[2] = i2[1] * Math.sin(n2) + i2[2] * Math.cos(n2), t2[0] = s2[0] + r2[0], t2[1] = s2[1] + r2[1], t2[2] = s2[2] + r2[2], t2;
        }, H.rotateY = function(t2, e2, r2, n2) {
          var i2 = [], s2 = [];
          return i2[0] = e2[0] - r2[0], i2[1] = e2[1] - r2[1], i2[2] = e2[2] - r2[2], s2[0] = i2[2] * Math.sin(n2) + i2[0] * Math.cos(n2), s2[1] = i2[1], s2[2] = i2[2] * Math.cos(n2) - i2[0] * Math.sin(n2), t2[0] = s2[0] + r2[0], t2[1] = s2[1] + r2[1], t2[2] = s2[2] + r2[2], t2;
        }, H.rotateZ = function(t2, e2, r2, n2) {
          var i2 = [], s2 = [];
          return i2[0] = e2[0] - r2[0], i2[1] = e2[1] - r2[1], i2[2] = e2[2] - r2[2], s2[0] = i2[0] * Math.cos(n2) - i2[1] * Math.sin(n2), s2[1] = i2[0] * Math.sin(n2) + i2[1] * Math.cos(n2), s2[2] = i2[2], t2[0] = s2[0] + r2[0], t2[1] = s2[1] + r2[1], t2[2] = s2[2] + r2[2], t2;
        }, H.angle = function(t2, e2) {
          var r2 = t2[0], n2 = t2[1], i2 = t2[2], s2 = e2[0], a2 = e2[1], o2 = e2[2], l2 = Math.sqrt(r2 * r2 + n2 * n2 + i2 * i2) * Math.sqrt(s2 * s2 + a2 * a2 + o2 * o2), u2 = l2 && ot(t2, e2) / l2;
          return Math.acos(Math.min(Math.max(u2, -1), 1));
        }, H.zero = function(t2) {
          return t2[0] = 0, t2[1] = 0, t2[2] = 0, t2;
        }, H.str = function(t2) {
          return "vec3(" + t2[0] + ", " + t2[1] + ", " + t2[2] + ")";
        }, H.exactEquals = function(t2, e2) {
          return t2[0] === e2[0] && t2[1] === e2[1] && t2[2] === e2[2];
        }, H.equals = function(t2, e2) {
          var r2 = t2[0], n2 = t2[1], i2 = t2[2], s2 = e2[0], a2 = e2[1], o2 = e2[2];
          return Math.abs(r2 - s2) <= W.EPSILON * Math.max(1, Math.abs(r2), Math.abs(s2)) && Math.abs(n2 - a2) <= W.EPSILON * Math.max(1, Math.abs(n2), Math.abs(a2)) && Math.abs(i2 - o2) <= W.EPSILON * Math.max(1, Math.abs(i2), Math.abs(o2));
        }, H.forEach = H.sqrLen = H.len = H.sqrDist = H.dist = H.div = H.mul = H.sub = void 0;
        var W = function(t2, e2) {
          if (t2 && t2.__esModule)
            return t2;
          if (null === t2 || "object" !== K(t2) && "function" != typeof t2)
            return { default: t2 };
          var r2 = J(void 0);
          if (r2 && r2.has(t2))
            return r2.get(t2);
          var n2 = {}, i2 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s2 in t2)
            if ("default" !== s2 && Object.prototype.hasOwnProperty.call(t2, s2)) {
              var a2 = i2 ? Object.getOwnPropertyDescriptor(t2, s2) : null;
              a2 && (a2.get || a2.set) ? Object.defineProperty(n2, s2, a2) : n2[s2] = t2[s2];
            }
          return n2.default = t2, r2 && r2.set(t2, n2), n2;
        }(d);
        function J(t2) {
          if ("function" != typeof WeakMap)
            return null;
          var e2 = /* @__PURE__ */ new WeakMap(), r2 = /* @__PURE__ */ new WeakMap();
          return (J = function(t3) {
            return t3 ? r2 : e2;
          })(t2);
        }
        function Q() {
          var t2 = new W.ARRAY_TYPE(3);
          return W.ARRAY_TYPE != Float32Array && (t2[0] = 0, t2[1] = 0, t2[2] = 0), t2;
        }
        function tt(t2) {
          return Math.hypot(t2[0], t2[1], t2[2]);
        }
        function et(t2, e2, r2) {
          return t2[0] = e2[0] - r2[0], t2[1] = e2[1] - r2[1], t2[2] = e2[2] - r2[2], t2;
        }
        function rt(t2, e2, r2) {
          return t2[0] = e2[0] * r2[0], t2[1] = e2[1] * r2[1], t2[2] = e2[2] * r2[2], t2;
        }
        function nt(t2, e2, r2) {
          return t2[0] = e2[0] / r2[0], t2[1] = e2[1] / r2[1], t2[2] = e2[2] / r2[2], t2;
        }
        function it(t2, e2) {
          return Math.hypot(e2[0] - t2[0], e2[1] - t2[1], e2[2] - t2[2]);
        }
        function st(t2, e2) {
          var r2 = e2[0] - t2[0], n2 = e2[1] - t2[1], i2 = e2[2] - t2[2];
          return r2 * r2 + n2 * n2 + i2 * i2;
        }
        function at(t2) {
          var e2 = t2[0], r2 = t2[1], n2 = t2[2];
          return e2 * e2 + r2 * r2 + n2 * n2;
        }
        function ot(t2, e2) {
          return t2[0] * e2[0] + t2[1] * e2[1] + t2[2] * e2[2];
        }
        H.sub = et, H.mul = rt, H.div = nt, H.dist = it, H.sqrDist = st, H.len = tt, H.sqrLen = at;
        var lt, ut = (lt = Q(), function(t2, e2, r2, n2, i2, s2) {
          var a2, o2;
          for (e2 || (e2 = 3), r2 || (r2 = 0), o2 = n2 ? Math.min(n2 * e2 + r2, t2.length) : t2.length, a2 = r2; a2 < o2; a2 += e2)
            lt[0] = t2[a2], lt[1] = t2[a2 + 1], lt[2] = t2[a2 + 2], i2(lt, lt, s2), t2[a2] = lt[0], t2[a2 + 1] = lt[1], t2[a2 + 2] = lt[2];
          return t2;
        });
        H.forEach = ut;
        var ct = {};
        function ht(t2) {
          return ht = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
            return typeof t3;
          } : function(t3) {
            return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
          }, ht(t2);
        }
        Object.defineProperty(ct, "__esModule", { value: true }), ct.create = dt, ct.clone = function(t2) {
          var e2 = new pt.ARRAY_TYPE(4);
          return e2[0] = t2[0], e2[1] = t2[1], e2[2] = t2[2], e2[3] = t2[3], e2;
        }, ct.fromValues = function(t2, e2, r2, n2) {
          var i2 = new pt.ARRAY_TYPE(4);
          return i2[0] = t2, i2[1] = e2, i2[2] = r2, i2[3] = n2, i2;
        }, ct.copy = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[3], t2;
        }, ct.set = function(t2, e2, r2, n2, i2) {
          return t2[0] = e2, t2[1] = r2, t2[2] = n2, t2[3] = i2, t2;
        }, ct.add = function(t2, e2, r2) {
          return t2[0] = e2[0] + r2[0], t2[1] = e2[1] + r2[1], t2[2] = e2[2] + r2[2], t2[3] = e2[3] + r2[3], t2;
        }, ct.subtract = mt, ct.multiply = yt, ct.divide = gt, ct.ceil = function(t2, e2) {
          return t2[0] = Math.ceil(e2[0]), t2[1] = Math.ceil(e2[1]), t2[2] = Math.ceil(e2[2]), t2[3] = Math.ceil(e2[3]), t2;
        }, ct.floor = function(t2, e2) {
          return t2[0] = Math.floor(e2[0]), t2[1] = Math.floor(e2[1]), t2[2] = Math.floor(e2[2]), t2[3] = Math.floor(e2[3]), t2;
        }, ct.min = function(t2, e2, r2) {
          return t2[0] = Math.min(e2[0], r2[0]), t2[1] = Math.min(e2[1], r2[1]), t2[2] = Math.min(e2[2], r2[2]), t2[3] = Math.min(e2[3], r2[3]), t2;
        }, ct.max = function(t2, e2, r2) {
          return t2[0] = Math.max(e2[0], r2[0]), t2[1] = Math.max(e2[1], r2[1]), t2[2] = Math.max(e2[2], r2[2]), t2[3] = Math.max(e2[3], r2[3]), t2;
        }, ct.round = function(t2, e2) {
          return t2[0] = Math.round(e2[0]), t2[1] = Math.round(e2[1]), t2[2] = Math.round(e2[2]), t2[3] = Math.round(e2[3]), t2;
        }, ct.scale = function(t2, e2, r2) {
          return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2[2] = e2[2] * r2, t2[3] = e2[3] * r2, t2;
        }, ct.scaleAndAdd = function(t2, e2, r2, n2) {
          return t2[0] = e2[0] + r2[0] * n2, t2[1] = e2[1] + r2[1] * n2, t2[2] = e2[2] + r2[2] * n2, t2[3] = e2[3] + r2[3] * n2, t2;
        }, ct.distance = xt, ct.squaredDistance = bt, ct.length = vt, ct.squaredLength = _t, ct.negate = function(t2, e2) {
          return t2[0] = -e2[0], t2[1] = -e2[1], t2[2] = -e2[2], t2[3] = -e2[3], t2;
        }, ct.inverse = function(t2, e2) {
          return t2[0] = 1 / e2[0], t2[1] = 1 / e2[1], t2[2] = 1 / e2[2], t2[3] = 1 / e2[3], t2;
        }, ct.normalize = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = r2 * r2 + n2 * n2 + i2 * i2 + s2 * s2;
          return a2 > 0 && (a2 = 1 / Math.sqrt(a2)), t2[0] = r2 * a2, t2[1] = n2 * a2, t2[2] = i2 * a2, t2[3] = s2 * a2, t2;
        }, ct.dot = function(t2, e2) {
          return t2[0] * e2[0] + t2[1] * e2[1] + t2[2] * e2[2] + t2[3] * e2[3];
        }, ct.cross = function(t2, e2, r2, n2) {
          var i2 = r2[0] * n2[1] - r2[1] * n2[0], s2 = r2[0] * n2[2] - r2[2] * n2[0], a2 = r2[0] * n2[3] - r2[3] * n2[0], o2 = r2[1] * n2[2] - r2[2] * n2[1], l2 = r2[1] * n2[3] - r2[3] * n2[1], u2 = r2[2] * n2[3] - r2[3] * n2[2], c2 = e2[0], h2 = e2[1], p2 = e2[2], f2 = e2[3];
          return t2[0] = h2 * u2 - p2 * l2 + f2 * o2, t2[1] = -c2 * u2 + p2 * a2 - f2 * s2, t2[2] = c2 * l2 - h2 * a2 + f2 * i2, t2[3] = -c2 * o2 + h2 * s2 - p2 * i2, t2;
        }, ct.lerp = function(t2, e2, r2, n2) {
          var i2 = e2[0], s2 = e2[1], a2 = e2[2], o2 = e2[3];
          return t2[0] = i2 + n2 * (r2[0] - i2), t2[1] = s2 + n2 * (r2[1] - s2), t2[2] = a2 + n2 * (r2[2] - a2), t2[3] = o2 + n2 * (r2[3] - o2), t2;
        }, ct.random = function(t2, e2) {
          var r2, n2, i2, s2, a2, o2;
          e2 = e2 || 1;
          do {
            a2 = (r2 = 2 * pt.RANDOM() - 1) * r2 + (n2 = 2 * pt.RANDOM() - 1) * n2;
          } while (a2 >= 1);
          do {
            o2 = (i2 = 2 * pt.RANDOM() - 1) * i2 + (s2 = 2 * pt.RANDOM() - 1) * s2;
          } while (o2 >= 1);
          var l2 = Math.sqrt((1 - a2) / o2);
          return t2[0] = e2 * r2, t2[1] = e2 * n2, t2[2] = e2 * i2 * l2, t2[3] = e2 * s2 * l2, t2;
        }, ct.transformMat4 = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3];
          return t2[0] = r2[0] * n2 + r2[4] * i2 + r2[8] * s2 + r2[12] * a2, t2[1] = r2[1] * n2 + r2[5] * i2 + r2[9] * s2 + r2[13] * a2, t2[2] = r2[2] * n2 + r2[6] * i2 + r2[10] * s2 + r2[14] * a2, t2[3] = r2[3] * n2 + r2[7] * i2 + r2[11] * s2 + r2[15] * a2, t2;
        }, ct.transformQuat = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = r2[0], o2 = r2[1], l2 = r2[2], u2 = r2[3], c2 = u2 * n2 + o2 * s2 - l2 * i2, h2 = u2 * i2 + l2 * n2 - a2 * s2, p2 = u2 * s2 + a2 * i2 - o2 * n2, f2 = -a2 * n2 - o2 * i2 - l2 * s2;
          return t2[0] = c2 * u2 + f2 * -a2 + h2 * -l2 - p2 * -o2, t2[1] = h2 * u2 + f2 * -o2 + p2 * -a2 - c2 * -l2, t2[2] = p2 * u2 + f2 * -l2 + c2 * -o2 - h2 * -a2, t2[3] = e2[3], t2;
        }, ct.zero = function(t2) {
          return t2[0] = 0, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2;
        }, ct.str = function(t2) {
          return "vec4(" + t2[0] + ", " + t2[1] + ", " + t2[2] + ", " + t2[3] + ")";
        }, ct.exactEquals = function(t2, e2) {
          return t2[0] === e2[0] && t2[1] === e2[1] && t2[2] === e2[2] && t2[3] === e2[3];
        }, ct.equals = function(t2, e2) {
          var r2 = t2[0], n2 = t2[1], i2 = t2[2], s2 = t2[3], a2 = e2[0], o2 = e2[1], l2 = e2[2], u2 = e2[3];
          return Math.abs(r2 - a2) <= pt.EPSILON * Math.max(1, Math.abs(r2), Math.abs(a2)) && Math.abs(n2 - o2) <= pt.EPSILON * Math.max(1, Math.abs(n2), Math.abs(o2)) && Math.abs(i2 - l2) <= pt.EPSILON * Math.max(1, Math.abs(i2), Math.abs(l2)) && Math.abs(s2 - u2) <= pt.EPSILON * Math.max(1, Math.abs(s2), Math.abs(u2));
        }, ct.forEach = ct.sqrLen = ct.len = ct.sqrDist = ct.dist = ct.div = ct.mul = ct.sub = void 0;
        var pt = function(t2, e2) {
          if (t2 && t2.__esModule)
            return t2;
          if (null === t2 || "object" !== ht(t2) && "function" != typeof t2)
            return { default: t2 };
          var r2 = ft(void 0);
          if (r2 && r2.has(t2))
            return r2.get(t2);
          var n2 = {}, i2 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s2 in t2)
            if ("default" !== s2 && Object.prototype.hasOwnProperty.call(t2, s2)) {
              var a2 = i2 ? Object.getOwnPropertyDescriptor(t2, s2) : null;
              a2 && (a2.get || a2.set) ? Object.defineProperty(n2, s2, a2) : n2[s2] = t2[s2];
            }
          return n2.default = t2, r2 && r2.set(t2, n2), n2;
        }(d);
        function ft(t2) {
          if ("function" != typeof WeakMap)
            return null;
          var e2 = /* @__PURE__ */ new WeakMap(), r2 = /* @__PURE__ */ new WeakMap();
          return (ft = function(t3) {
            return t3 ? r2 : e2;
          })(t2);
        }
        function dt() {
          var t2 = new pt.ARRAY_TYPE(4);
          return pt.ARRAY_TYPE != Float32Array && (t2[0] = 0, t2[1] = 0, t2[2] = 0, t2[3] = 0), t2;
        }
        function mt(t2, e2, r2) {
          return t2[0] = e2[0] - r2[0], t2[1] = e2[1] - r2[1], t2[2] = e2[2] - r2[2], t2[3] = e2[3] - r2[3], t2;
        }
        function yt(t2, e2, r2) {
          return t2[0] = e2[0] * r2[0], t2[1] = e2[1] * r2[1], t2[2] = e2[2] * r2[2], t2[3] = e2[3] * r2[3], t2;
        }
        function gt(t2, e2, r2) {
          return t2[0] = e2[0] / r2[0], t2[1] = e2[1] / r2[1], t2[2] = e2[2] / r2[2], t2[3] = e2[3] / r2[3], t2;
        }
        function xt(t2, e2) {
          return Math.hypot(e2[0] - t2[0], e2[1] - t2[1], e2[2] - t2[2], e2[3] - t2[3]);
        }
        function bt(t2, e2) {
          var r2 = e2[0] - t2[0], n2 = e2[1] - t2[1], i2 = e2[2] - t2[2], s2 = e2[3] - t2[3];
          return r2 * r2 + n2 * n2 + i2 * i2 + s2 * s2;
        }
        function vt(t2) {
          return Math.hypot(t2[0], t2[1], t2[2], t2[3]);
        }
        function _t(t2) {
          var e2 = t2[0], r2 = t2[1], n2 = t2[2], i2 = t2[3];
          return e2 * e2 + r2 * r2 + n2 * n2 + i2 * i2;
        }
        ct.sub = mt, ct.mul = yt, ct.div = gt, ct.dist = xt, ct.sqrDist = bt, ct.len = vt, ct.sqrLen = _t;
        var wt = function() {
          var t2 = dt();
          return function(e2, r2, n2, i2, s2, a2) {
            var o2, l2;
            for (r2 || (r2 = 4), n2 || (n2 = 0), l2 = i2 ? Math.min(i2 * r2 + n2, e2.length) : e2.length, o2 = n2; o2 < l2; o2 += r2)
              t2[0] = e2[o2], t2[1] = e2[o2 + 1], t2[2] = e2[o2 + 2], t2[3] = e2[o2 + 3], s2(t2, t2, a2), e2[o2] = t2[0], e2[o2 + 1] = t2[1], e2[o2 + 2] = t2[2], e2[o2 + 3] = t2[3];
            return e2;
          };
        }();
        function Mt(t2) {
          return Mt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
            return typeof t3;
          } : function(t3) {
            return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
          }, Mt(t2);
        }
        ct.forEach = wt, Object.defineProperty(Z, "__esModule", { value: true }), Z.create = zt, Z.identity = function(t2) {
          return t2[0] = 0, t2[1] = 0, t2[2] = 0, t2[3] = 1, t2;
        }, Z.setAxisAngle = Et, Z.getAxisAngle = function(t2, e2) {
          var r2 = 2 * Math.acos(e2[3]), n2 = Math.sin(r2 / 2);
          return n2 > At.EPSILON ? (t2[0] = e2[0] / n2, t2[1] = e2[1] / n2, t2[2] = e2[2] / n2) : (t2[0] = 1, t2[1] = 0, t2[2] = 0), r2;
        }, Z.getAngle = function(t2, e2) {
          var r2 = Ft(t2, e2);
          return Math.acos(2 * r2 * r2 - 1);
        }, Z.multiply = Bt, Z.rotateX = function(t2, e2, r2) {
          r2 *= 0.5;
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = Math.sin(r2), l2 = Math.cos(r2);
          return t2[0] = n2 * l2 + a2 * o2, t2[1] = i2 * l2 + s2 * o2, t2[2] = s2 * l2 - i2 * o2, t2[3] = a2 * l2 - n2 * o2, t2;
        }, Z.rotateY = function(t2, e2, r2) {
          r2 *= 0.5;
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = Math.sin(r2), l2 = Math.cos(r2);
          return t2[0] = n2 * l2 - s2 * o2, t2[1] = i2 * l2 + a2 * o2, t2[2] = s2 * l2 + n2 * o2, t2[3] = a2 * l2 - i2 * o2, t2;
        }, Z.rotateZ = function(t2, e2, r2) {
          r2 *= 0.5;
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = Math.sin(r2), l2 = Math.cos(r2);
          return t2[0] = n2 * l2 + i2 * o2, t2[1] = i2 * l2 - n2 * o2, t2[2] = s2 * l2 + a2 * o2, t2[3] = a2 * l2 - s2 * o2, t2;
        }, Z.calculateW = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2];
          return t2[0] = r2, t2[1] = n2, t2[2] = i2, t2[3] = Math.sqrt(Math.abs(1 - r2 * r2 - n2 * n2 - i2 * i2)), t2;
        }, Z.exp = Dt, Z.ln = Rt, Z.pow = function(t2, e2, r2) {
          return Rt(t2, e2), Vt(t2, t2, r2), Dt(t2, t2), t2;
        }, Z.slerp = Ct, Z.random = function(t2) {
          var e2 = At.RANDOM(), r2 = At.RANDOM(), n2 = At.RANDOM(), i2 = Math.sqrt(1 - e2), s2 = Math.sqrt(e2);
          return t2[0] = i2 * Math.sin(2 * Math.PI * r2), t2[1] = i2 * Math.cos(2 * Math.PI * r2), t2[2] = s2 * Math.sin(2 * Math.PI * n2), t2[3] = s2 * Math.cos(2 * Math.PI * n2), t2;
        }, Z.invert = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = r2 * r2 + n2 * n2 + i2 * i2 + s2 * s2, o2 = a2 ? 1 / a2 : 0;
          return t2[0] = -r2 * o2, t2[1] = -n2 * o2, t2[2] = -i2 * o2, t2[3] = s2 * o2, t2;
        }, Z.conjugate = function(t2, e2) {
          return t2[0] = -e2[0], t2[1] = -e2[1], t2[2] = -e2[2], t2[3] = e2[3], t2;
        }, Z.fromMat3 = Lt, Z.fromEuler = function(t2, e2, r2, n2) {
          var i2 = 0.5 * Math.PI / 180;
          e2 *= i2, r2 *= i2, n2 *= i2;
          var s2 = Math.sin(e2), a2 = Math.cos(e2), o2 = Math.sin(r2), l2 = Math.cos(r2), u2 = Math.sin(n2), c2 = Math.cos(n2);
          return t2[0] = s2 * l2 * c2 - a2 * o2 * u2, t2[1] = a2 * o2 * c2 + s2 * l2 * u2, t2[2] = a2 * l2 * u2 - s2 * o2 * c2, t2[3] = a2 * l2 * c2 + s2 * o2 * u2, t2;
        }, Z.str = function(t2) {
          return "quat(" + t2[0] + ", " + t2[1] + ", " + t2[2] + ", " + t2[3] + ")";
        }, Z.setAxes = Z.sqlerp = Z.rotationTo = Z.equals = Z.exactEquals = Z.normalize = Z.sqrLen = Z.squaredLength = Z.len = Z.length = Z.lerp = Z.dot = Z.scale = Z.mul = Z.add = Z.set = Z.copy = Z.fromValues = Z.clone = void 0;
        var At = Pt(d), St = Pt(E), It = Pt(H), Tt = Pt(ct);
        function kt(t2) {
          if ("function" != typeof WeakMap)
            return null;
          var e2 = /* @__PURE__ */ new WeakMap(), r2 = /* @__PURE__ */ new WeakMap();
          return (kt = function(t3) {
            return t3 ? r2 : e2;
          })(t2);
        }
        function Pt(t2, e2) {
          if (t2 && t2.__esModule)
            return t2;
          if (null === t2 || "object" !== Mt(t2) && "function" != typeof t2)
            return { default: t2 };
          var r2 = kt(e2);
          if (r2 && r2.has(t2))
            return r2.get(t2);
          var n2 = {}, i2 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s2 in t2)
            if ("default" !== s2 && Object.prototype.hasOwnProperty.call(t2, s2)) {
              var a2 = i2 ? Object.getOwnPropertyDescriptor(t2, s2) : null;
              a2 && (a2.get || a2.set) ? Object.defineProperty(n2, s2, a2) : n2[s2] = t2[s2];
            }
          return n2.default = t2, r2 && r2.set(t2, n2), n2;
        }
        function zt() {
          var t2 = new At.ARRAY_TYPE(4);
          return At.ARRAY_TYPE != Float32Array && (t2[0] = 0, t2[1] = 0, t2[2] = 0), t2[3] = 1, t2;
        }
        function Et(t2, e2, r2) {
          r2 *= 0.5;
          var n2 = Math.sin(r2);
          return t2[0] = n2 * e2[0], t2[1] = n2 * e2[1], t2[2] = n2 * e2[2], t2[3] = Math.cos(r2), t2;
        }
        function Bt(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = r2[0], l2 = r2[1], u2 = r2[2], c2 = r2[3];
          return t2[0] = n2 * c2 + a2 * o2 + i2 * u2 - s2 * l2, t2[1] = i2 * c2 + a2 * l2 + s2 * o2 - n2 * u2, t2[2] = s2 * c2 + a2 * u2 + n2 * l2 - i2 * o2, t2[3] = a2 * c2 - n2 * o2 - i2 * l2 - s2 * u2, t2;
        }
        function Dt(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = Math.sqrt(r2 * r2 + n2 * n2 + i2 * i2), o2 = Math.exp(s2), l2 = a2 > 0 ? o2 * Math.sin(a2) / a2 : 0;
          return t2[0] = r2 * l2, t2[1] = n2 * l2, t2[2] = i2 * l2, t2[3] = o2 * Math.cos(a2), t2;
        }
        function Rt(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], a2 = Math.sqrt(r2 * r2 + n2 * n2 + i2 * i2), o2 = a2 > 0 ? Math.atan2(a2, s2) / a2 : 0;
          return t2[0] = r2 * o2, t2[1] = n2 * o2, t2[2] = i2 * o2, t2[3] = 0.5 * Math.log(r2 * r2 + n2 * n2 + i2 * i2 + s2 * s2), t2;
        }
        function Ct(t2, e2, r2, n2) {
          var i2, s2, a2, o2, l2, u2 = e2[0], c2 = e2[1], h2 = e2[2], p2 = e2[3], f2 = r2[0], d2 = r2[1], m2 = r2[2], y2 = r2[3];
          return (s2 = u2 * f2 + c2 * d2 + h2 * m2 + p2 * y2) < 0 && (s2 = -s2, f2 = -f2, d2 = -d2, m2 = -m2, y2 = -y2), 1 - s2 > At.EPSILON ? (i2 = Math.acos(s2), a2 = Math.sin(i2), o2 = Math.sin((1 - n2) * i2) / a2, l2 = Math.sin(n2 * i2) / a2) : (o2 = 1 - n2, l2 = n2), t2[0] = o2 * u2 + l2 * f2, t2[1] = o2 * c2 + l2 * d2, t2[2] = o2 * h2 + l2 * m2, t2[3] = o2 * p2 + l2 * y2, t2;
        }
        function Lt(t2, e2) {
          var r2, n2 = e2[0] + e2[4] + e2[8];
          if (n2 > 0)
            r2 = Math.sqrt(n2 + 1), t2[3] = 0.5 * r2, t2[0] = (e2[5] - e2[7]) * (r2 = 0.5 / r2), t2[1] = (e2[6] - e2[2]) * r2, t2[2] = (e2[1] - e2[3]) * r2;
          else {
            var i2 = 0;
            e2[4] > e2[0] && (i2 = 1), e2[8] > e2[3 * i2 + i2] && (i2 = 2);
            var s2 = (i2 + 1) % 3, a2 = (i2 + 2) % 3;
            r2 = Math.sqrt(e2[3 * i2 + i2] - e2[3 * s2 + s2] - e2[3 * a2 + a2] + 1), t2[i2] = 0.5 * r2, t2[3] = (e2[3 * s2 + a2] - e2[3 * a2 + s2]) * (r2 = 0.5 / r2), t2[s2] = (e2[3 * s2 + i2] + e2[3 * i2 + s2]) * r2, t2[a2] = (e2[3 * a2 + i2] + e2[3 * i2 + a2]) * r2;
          }
          return t2;
        }
        Z.clone = Tt.clone, Z.fromValues = Tt.fromValues, Z.copy = Tt.copy, Z.set = Tt.set, Z.add = Tt.add, Z.mul = Bt;
        var Vt = Tt.scale;
        Z.scale = Vt;
        var Ft = Tt.dot;
        Z.dot = Ft, Z.lerp = Tt.lerp;
        var Ot = Tt.length;
        Z.length = Ot, Z.len = Ot;
        var Ut = Tt.squaredLength;
        Z.squaredLength = Ut, Z.sqrLen = Ut;
        var jt = Tt.normalize;
        Z.normalize = jt, Z.exactEquals = Tt.exactEquals, Z.equals = Tt.equals;
        var Nt, $t, qt, Gt = (Nt = It.create(), $t = It.fromValues(1, 0, 0), qt = It.fromValues(0, 1, 0), function(t2, e2, r2) {
          var n2 = It.dot(e2, r2);
          return n2 < -0.999999 ? (It.cross(Nt, $t, e2), It.len(Nt) < 1e-6 && It.cross(Nt, qt, e2), It.normalize(Nt, Nt), Et(t2, Nt, Math.PI), t2) : n2 > 0.999999 ? (t2[0] = 0, t2[1] = 0, t2[2] = 0, t2[3] = 1, t2) : (It.cross(Nt, e2, r2), t2[0] = Nt[0], t2[1] = Nt[1], t2[2] = Nt[2], t2[3] = 1 + n2, jt(t2, t2));
        });
        Z.rotationTo = Gt;
        var Xt, Yt, Zt = (Xt = zt(), Yt = zt(), function(t2, e2, r2, n2, i2, s2) {
          return Ct(Xt, e2, i2, s2), Ct(Yt, r2, n2, s2), Ct(t2, Xt, Yt, 2 * s2 * (1 - s2)), t2;
        });
        Z.sqlerp = Zt;
        var Ht, Kt = (Ht = St.create(), function(t2, e2, r2, n2) {
          return Ht[0] = r2[0], Ht[3] = r2[1], Ht[6] = r2[2], Ht[1] = n2[0], Ht[4] = n2[1], Ht[7] = n2[2], Ht[2] = -e2[0], Ht[5] = -e2[1], Ht[8] = -e2[2], jt(t2, Lt(t2, Ht));
        });
        Z.setAxes = Kt;
        var Wt = {};
        function Jt(t2) {
          return Jt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
            return typeof t3;
          } : function(t3) {
            return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
          }, Jt(t2);
        }
        Object.defineProperty(Wt, "__esModule", { value: true }), Wt.create = function() {
          var t2 = new Qt.ARRAY_TYPE(8);
          return Qt.ARRAY_TYPE != Float32Array && (t2[0] = 0, t2[1] = 0, t2[2] = 0, t2[4] = 0, t2[5] = 0, t2[6] = 0, t2[7] = 0), t2[3] = 1, t2;
        }, Wt.clone = function(t2) {
          var e2 = new Qt.ARRAY_TYPE(8);
          return e2[0] = t2[0], e2[1] = t2[1], e2[2] = t2[2], e2[3] = t2[3], e2[4] = t2[4], e2[5] = t2[5], e2[6] = t2[6], e2[7] = t2[7], e2;
        }, Wt.fromValues = function(t2, e2, r2, n2, i2, s2, a2, o2) {
          var l2 = new Qt.ARRAY_TYPE(8);
          return l2[0] = t2, l2[1] = e2, l2[2] = r2, l2[3] = n2, l2[4] = i2, l2[5] = s2, l2[6] = a2, l2[7] = o2, l2;
        }, Wt.fromRotationTranslationValues = function(t2, e2, r2, n2, i2, s2, a2) {
          var o2 = new Qt.ARRAY_TYPE(8);
          o2[0] = t2, o2[1] = e2, o2[2] = r2, o2[3] = n2;
          var l2 = 0.5 * i2, u2 = 0.5 * s2, c2 = 0.5 * a2;
          return o2[4] = l2 * n2 + u2 * r2 - c2 * e2, o2[5] = u2 * n2 + c2 * t2 - l2 * r2, o2[6] = c2 * n2 + l2 * e2 - u2 * t2, o2[7] = -l2 * t2 - u2 * e2 - c2 * r2, o2;
        }, Wt.fromRotationTranslation = ie, Wt.fromTranslation = function(t2, e2) {
          return t2[0] = 0, t2[1] = 0, t2[2] = 0, t2[3] = 1, t2[4] = 0.5 * e2[0], t2[5] = 0.5 * e2[1], t2[6] = 0.5 * e2[2], t2[7] = 0, t2;
        }, Wt.fromRotation = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[3], t2[4] = 0, t2[5] = 0, t2[6] = 0, t2[7] = 0, t2;
        }, Wt.fromMat4 = function(t2, e2) {
          var r2 = te.create();
          ee.getRotation(r2, e2);
          var n2 = new Qt.ARRAY_TYPE(3);
          return ee.getTranslation(n2, e2), ie(t2, r2, n2), t2;
        }, Wt.copy = se, Wt.identity = function(t2) {
          return t2[0] = 0, t2[1] = 0, t2[2] = 0, t2[3] = 1, t2[4] = 0, t2[5] = 0, t2[6] = 0, t2[7] = 0, t2;
        }, Wt.set = function(t2, e2, r2, n2, i2, s2, a2, o2, l2) {
          return t2[0] = e2, t2[1] = r2, t2[2] = n2, t2[3] = i2, t2[4] = s2, t2[5] = a2, t2[6] = o2, t2[7] = l2, t2;
        }, Wt.getDual = function(t2, e2) {
          return t2[0] = e2[4], t2[1] = e2[5], t2[2] = e2[6], t2[3] = e2[7], t2;
        }, Wt.setDual = function(t2, e2) {
          return t2[4] = e2[0], t2[5] = e2[1], t2[6] = e2[2], t2[7] = e2[3], t2;
        }, Wt.getTranslation = function(t2, e2) {
          var r2 = e2[4], n2 = e2[5], i2 = e2[6], s2 = e2[7], a2 = -e2[0], o2 = -e2[1], l2 = -e2[2], u2 = e2[3];
          return t2[0] = 2 * (r2 * u2 + s2 * a2 + n2 * l2 - i2 * o2), t2[1] = 2 * (n2 * u2 + s2 * o2 + i2 * a2 - r2 * l2), t2[2] = 2 * (i2 * u2 + s2 * l2 + r2 * o2 - n2 * a2), t2;
        }, Wt.translate = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = 0.5 * r2[0], l2 = 0.5 * r2[1], u2 = 0.5 * r2[2], c2 = e2[4], h2 = e2[5], p2 = e2[6], f2 = e2[7];
          return t2[0] = n2, t2[1] = i2, t2[2] = s2, t2[3] = a2, t2[4] = a2 * o2 + i2 * u2 - s2 * l2 + c2, t2[5] = a2 * l2 + s2 * o2 - n2 * u2 + h2, t2[6] = a2 * u2 + n2 * l2 - i2 * o2 + p2, t2[7] = -n2 * o2 - i2 * l2 - s2 * u2 + f2, t2;
        }, Wt.rotateX = function(t2, e2, r2) {
          var n2 = -e2[0], i2 = -e2[1], s2 = -e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = o2 * a2 + c2 * n2 + l2 * s2 - u2 * i2, p2 = l2 * a2 + c2 * i2 + u2 * n2 - o2 * s2, f2 = u2 * a2 + c2 * s2 + o2 * i2 - l2 * n2, d2 = c2 * a2 - o2 * n2 - l2 * i2 - u2 * s2;
          return te.rotateX(t2, e2, r2), t2[4] = h2 * (a2 = t2[3]) + d2 * (n2 = t2[0]) + p2 * (s2 = t2[2]) - f2 * (i2 = t2[1]), t2[5] = p2 * a2 + d2 * i2 + f2 * n2 - h2 * s2, t2[6] = f2 * a2 + d2 * s2 + h2 * i2 - p2 * n2, t2[7] = d2 * a2 - h2 * n2 - p2 * i2 - f2 * s2, t2;
        }, Wt.rotateY = function(t2, e2, r2) {
          var n2 = -e2[0], i2 = -e2[1], s2 = -e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = o2 * a2 + c2 * n2 + l2 * s2 - u2 * i2, p2 = l2 * a2 + c2 * i2 + u2 * n2 - o2 * s2, f2 = u2 * a2 + c2 * s2 + o2 * i2 - l2 * n2, d2 = c2 * a2 - o2 * n2 - l2 * i2 - u2 * s2;
          return te.rotateY(t2, e2, r2), t2[4] = h2 * (a2 = t2[3]) + d2 * (n2 = t2[0]) + p2 * (s2 = t2[2]) - f2 * (i2 = t2[1]), t2[5] = p2 * a2 + d2 * i2 + f2 * n2 - h2 * s2, t2[6] = f2 * a2 + d2 * s2 + h2 * i2 - p2 * n2, t2[7] = d2 * a2 - h2 * n2 - p2 * i2 - f2 * s2, t2;
        }, Wt.rotateZ = function(t2, e2, r2) {
          var n2 = -e2[0], i2 = -e2[1], s2 = -e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = o2 * a2 + c2 * n2 + l2 * s2 - u2 * i2, p2 = l2 * a2 + c2 * i2 + u2 * n2 - o2 * s2, f2 = u2 * a2 + c2 * s2 + o2 * i2 - l2 * n2, d2 = c2 * a2 - o2 * n2 - l2 * i2 - u2 * s2;
          return te.rotateZ(t2, e2, r2), t2[4] = h2 * (a2 = t2[3]) + d2 * (n2 = t2[0]) + p2 * (s2 = t2[2]) - f2 * (i2 = t2[1]), t2[5] = p2 * a2 + d2 * i2 + f2 * n2 - h2 * s2, t2[6] = f2 * a2 + d2 * s2 + h2 * i2 - p2 * n2, t2[7] = d2 * a2 - h2 * n2 - p2 * i2 - f2 * s2, t2;
        }, Wt.rotateByQuatAppend = function(t2, e2, r2) {
          var n2 = r2[0], i2 = r2[1], s2 = r2[2], a2 = r2[3], o2 = e2[0], l2 = e2[1], u2 = e2[2], c2 = e2[3];
          return t2[0] = o2 * a2 + c2 * n2 + l2 * s2 - u2 * i2, t2[1] = l2 * a2 + c2 * i2 + u2 * n2 - o2 * s2, t2[2] = u2 * a2 + c2 * s2 + o2 * i2 - l2 * n2, t2[3] = c2 * a2 - o2 * n2 - l2 * i2 - u2 * s2, t2[4] = (o2 = e2[4]) * a2 + (c2 = e2[7]) * n2 + (l2 = e2[5]) * s2 - (u2 = e2[6]) * i2, t2[5] = l2 * a2 + c2 * i2 + u2 * n2 - o2 * s2, t2[6] = u2 * a2 + c2 * s2 + o2 * i2 - l2 * n2, t2[7] = c2 * a2 - o2 * n2 - l2 * i2 - u2 * s2, t2;
        }, Wt.rotateByQuatPrepend = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = r2[0], l2 = r2[1], u2 = r2[2], c2 = r2[3];
          return t2[0] = n2 * c2 + a2 * o2 + i2 * u2 - s2 * l2, t2[1] = i2 * c2 + a2 * l2 + s2 * o2 - n2 * u2, t2[2] = s2 * c2 + a2 * u2 + n2 * l2 - i2 * o2, t2[3] = a2 * c2 - n2 * o2 - i2 * l2 - s2 * u2, t2[4] = n2 * (c2 = r2[7]) + a2 * (o2 = r2[4]) + i2 * (u2 = r2[6]) - s2 * (l2 = r2[5]), t2[5] = i2 * c2 + a2 * l2 + s2 * o2 - n2 * u2, t2[6] = s2 * c2 + a2 * u2 + n2 * l2 - i2 * o2, t2[7] = a2 * c2 - n2 * o2 - i2 * l2 - s2 * u2, t2;
        }, Wt.rotateAroundAxis = function(t2, e2, r2, n2) {
          if (Math.abs(n2) < Qt.EPSILON)
            return se(t2, e2);
          var i2 = Math.hypot(r2[0], r2[1], r2[2]);
          n2 *= 0.5;
          var s2 = Math.sin(n2), a2 = s2 * r2[0] / i2, o2 = s2 * r2[1] / i2, l2 = s2 * r2[2] / i2, u2 = Math.cos(n2), c2 = e2[0], h2 = e2[1], p2 = e2[2], f2 = e2[3];
          t2[0] = c2 * u2 + f2 * a2 + h2 * l2 - p2 * o2, t2[1] = h2 * u2 + f2 * o2 + p2 * a2 - c2 * l2, t2[2] = p2 * u2 + f2 * l2 + c2 * o2 - h2 * a2, t2[3] = f2 * u2 - c2 * a2 - h2 * o2 - p2 * l2;
          var d2 = e2[4], m2 = e2[5], y2 = e2[6], g2 = e2[7];
          return t2[4] = d2 * u2 + g2 * a2 + m2 * l2 - y2 * o2, t2[5] = m2 * u2 + g2 * o2 + y2 * a2 - d2 * l2, t2[6] = y2 * u2 + g2 * l2 + d2 * o2 - m2 * a2, t2[7] = g2 * u2 - d2 * a2 - m2 * o2 - y2 * l2, t2;
        }, Wt.add = function(t2, e2, r2) {
          return t2[0] = e2[0] + r2[0], t2[1] = e2[1] + r2[1], t2[2] = e2[2] + r2[2], t2[3] = e2[3] + r2[3], t2[4] = e2[4] + r2[4], t2[5] = e2[5] + r2[5], t2[6] = e2[6] + r2[6], t2[7] = e2[7] + r2[7], t2;
        }, Wt.multiply = ae, Wt.scale = function(t2, e2, r2) {
          return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2[2] = e2[2] * r2, t2[3] = e2[3] * r2, t2[4] = e2[4] * r2, t2[5] = e2[5] * r2, t2[6] = e2[6] * r2, t2[7] = e2[7] * r2, t2;
        }, Wt.lerp = function(t2, e2, r2, n2) {
          var i2 = 1 - n2;
          return oe(e2, r2) < 0 && (n2 = -n2), t2[0] = e2[0] * i2 + r2[0] * n2, t2[1] = e2[1] * i2 + r2[1] * n2, t2[2] = e2[2] * i2 + r2[2] * n2, t2[3] = e2[3] * i2 + r2[3] * n2, t2[4] = e2[4] * i2 + r2[4] * n2, t2[5] = e2[5] * i2 + r2[5] * n2, t2[6] = e2[6] * i2 + r2[6] * n2, t2[7] = e2[7] * i2 + r2[7] * n2, t2;
        }, Wt.invert = function(t2, e2) {
          var r2 = ue(e2);
          return t2[0] = -e2[0] / r2, t2[1] = -e2[1] / r2, t2[2] = -e2[2] / r2, t2[3] = e2[3] / r2, t2[4] = -e2[4] / r2, t2[5] = -e2[5] / r2, t2[6] = -e2[6] / r2, t2[7] = e2[7] / r2, t2;
        }, Wt.conjugate = function(t2, e2) {
          return t2[0] = -e2[0], t2[1] = -e2[1], t2[2] = -e2[2], t2[3] = e2[3], t2[4] = -e2[4], t2[5] = -e2[5], t2[6] = -e2[6], t2[7] = e2[7], t2;
        }, Wt.normalize = function(t2, e2) {
          var r2 = ue(e2);
          if (r2 > 0) {
            r2 = Math.sqrt(r2);
            var n2 = e2[0] / r2, i2 = e2[1] / r2, s2 = e2[2] / r2, a2 = e2[3] / r2, o2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = n2 * o2 + i2 * l2 + s2 * u2 + a2 * c2;
            t2[0] = n2, t2[1] = i2, t2[2] = s2, t2[3] = a2, t2[4] = (o2 - n2 * h2) / r2, t2[5] = (l2 - i2 * h2) / r2, t2[6] = (u2 - s2 * h2) / r2, t2[7] = (c2 - a2 * h2) / r2;
          }
          return t2;
        }, Wt.str = function(t2) {
          return "quat2(" + t2[0] + ", " + t2[1] + ", " + t2[2] + ", " + t2[3] + ", " + t2[4] + ", " + t2[5] + ", " + t2[6] + ", " + t2[7] + ")";
        }, Wt.exactEquals = function(t2, e2) {
          return t2[0] === e2[0] && t2[1] === e2[1] && t2[2] === e2[2] && t2[3] === e2[3] && t2[4] === e2[4] && t2[5] === e2[5] && t2[6] === e2[6] && t2[7] === e2[7];
        }, Wt.equals = function(t2, e2) {
          var r2 = t2[0], n2 = t2[1], i2 = t2[2], s2 = t2[3], a2 = t2[4], o2 = t2[5], l2 = t2[6], u2 = t2[7], c2 = e2[0], h2 = e2[1], p2 = e2[2], f2 = e2[3], d2 = e2[4], m2 = e2[5], y2 = e2[6], g2 = e2[7];
          return Math.abs(r2 - c2) <= Qt.EPSILON * Math.max(1, Math.abs(r2), Math.abs(c2)) && Math.abs(n2 - h2) <= Qt.EPSILON * Math.max(1, Math.abs(n2), Math.abs(h2)) && Math.abs(i2 - p2) <= Qt.EPSILON * Math.max(1, Math.abs(i2), Math.abs(p2)) && Math.abs(s2 - f2) <= Qt.EPSILON * Math.max(1, Math.abs(s2), Math.abs(f2)) && Math.abs(a2 - d2) <= Qt.EPSILON * Math.max(1, Math.abs(a2), Math.abs(d2)) && Math.abs(o2 - m2) <= Qt.EPSILON * Math.max(1, Math.abs(o2), Math.abs(m2)) && Math.abs(l2 - y2) <= Qt.EPSILON * Math.max(1, Math.abs(l2), Math.abs(y2)) && Math.abs(u2 - g2) <= Qt.EPSILON * Math.max(1, Math.abs(u2), Math.abs(g2));
        }, Wt.sqrLen = Wt.squaredLength = Wt.len = Wt.length = Wt.dot = Wt.mul = Wt.setReal = Wt.getReal = void 0;
        var Qt = ne(d), te = ne(Z), ee = ne(V);
        function re(t2) {
          if ("function" != typeof WeakMap)
            return null;
          var e2 = /* @__PURE__ */ new WeakMap(), r2 = /* @__PURE__ */ new WeakMap();
          return (re = function(t3) {
            return t3 ? r2 : e2;
          })(t2);
        }
        function ne(t2, e2) {
          if (t2 && t2.__esModule)
            return t2;
          if (null === t2 || "object" !== Jt(t2) && "function" != typeof t2)
            return { default: t2 };
          var r2 = re(e2);
          if (r2 && r2.has(t2))
            return r2.get(t2);
          var n2 = {}, i2 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s2 in t2)
            if ("default" !== s2 && Object.prototype.hasOwnProperty.call(t2, s2)) {
              var a2 = i2 ? Object.getOwnPropertyDescriptor(t2, s2) : null;
              a2 && (a2.get || a2.set) ? Object.defineProperty(n2, s2, a2) : n2[s2] = t2[s2];
            }
          return n2.default = t2, r2 && r2.set(t2, n2), n2;
        }
        function ie(t2, e2, r2) {
          var n2 = 0.5 * r2[0], i2 = 0.5 * r2[1], s2 = 0.5 * r2[2], a2 = e2[0], o2 = e2[1], l2 = e2[2], u2 = e2[3];
          return t2[0] = a2, t2[1] = o2, t2[2] = l2, t2[3] = u2, t2[4] = n2 * u2 + i2 * l2 - s2 * o2, t2[5] = i2 * u2 + s2 * a2 - n2 * l2, t2[6] = s2 * u2 + n2 * o2 - i2 * a2, t2[7] = -n2 * a2 - i2 * o2 - s2 * l2, t2;
        }
        function se(t2, e2) {
          return t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[3], t2[4] = e2[4], t2[5] = e2[5], t2[6] = e2[6], t2[7] = e2[7], t2;
        }
        function ae(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], a2 = e2[3], o2 = r2[4], l2 = r2[5], u2 = r2[6], c2 = r2[7], h2 = e2[4], p2 = e2[5], f2 = e2[6], d2 = e2[7], m2 = r2[0], y2 = r2[1], g2 = r2[2], x2 = r2[3];
          return t2[0] = n2 * x2 + a2 * m2 + i2 * g2 - s2 * y2, t2[1] = i2 * x2 + a2 * y2 + s2 * m2 - n2 * g2, t2[2] = s2 * x2 + a2 * g2 + n2 * y2 - i2 * m2, t2[3] = a2 * x2 - n2 * m2 - i2 * y2 - s2 * g2, t2[4] = n2 * c2 + a2 * o2 + i2 * u2 - s2 * l2 + h2 * x2 + d2 * m2 + p2 * g2 - f2 * y2, t2[5] = i2 * c2 + a2 * l2 + s2 * o2 - n2 * u2 + p2 * x2 + d2 * y2 + f2 * m2 - h2 * g2, t2[6] = s2 * c2 + a2 * u2 + n2 * l2 - i2 * o2 + f2 * x2 + d2 * g2 + h2 * y2 - p2 * m2, t2[7] = a2 * c2 - n2 * o2 - i2 * l2 - s2 * u2 + d2 * x2 - h2 * m2 - p2 * y2 - f2 * g2, t2;
        }
        Wt.getReal = te.copy, Wt.setReal = te.copy, Wt.mul = ae;
        var oe = te.dot;
        Wt.dot = oe;
        var le = te.length;
        Wt.length = le, Wt.len = le;
        var ue = te.squaredLength;
        Wt.squaredLength = ue, Wt.sqrLen = ue;
        var ce = {};
        function he(t2) {
          return he = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
            return typeof t3;
          } : function(t3) {
            return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
          }, he(t2);
        }
        Object.defineProperty(ce, "__esModule", { value: true }), ce.create = de, ce.clone = function(t2) {
          var e2 = new pe.ARRAY_TYPE(2);
          return e2[0] = t2[0], e2[1] = t2[1], e2;
        }, ce.fromValues = function(t2, e2) {
          var r2 = new pe.ARRAY_TYPE(2);
          return r2[0] = t2, r2[1] = e2, r2;
        }, ce.copy = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = e2[1], t2;
        }, ce.set = function(t2, e2, r2) {
          return t2[0] = e2, t2[1] = r2, t2;
        }, ce.add = function(t2, e2, r2) {
          return t2[0] = e2[0] + r2[0], t2[1] = e2[1] + r2[1], t2;
        }, ce.subtract = me, ce.multiply = ye, ce.divide = ge, ce.ceil = function(t2, e2) {
          return t2[0] = Math.ceil(e2[0]), t2[1] = Math.ceil(e2[1]), t2;
        }, ce.floor = function(t2, e2) {
          return t2[0] = Math.floor(e2[0]), t2[1] = Math.floor(e2[1]), t2;
        }, ce.min = function(t2, e2, r2) {
          return t2[0] = Math.min(e2[0], r2[0]), t2[1] = Math.min(e2[1], r2[1]), t2;
        }, ce.max = function(t2, e2, r2) {
          return t2[0] = Math.max(e2[0], r2[0]), t2[1] = Math.max(e2[1], r2[1]), t2;
        }, ce.round = function(t2, e2) {
          return t2[0] = Math.round(e2[0]), t2[1] = Math.round(e2[1]), t2;
        }, ce.scale = function(t2, e2, r2) {
          return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2;
        }, ce.scaleAndAdd = function(t2, e2, r2, n2) {
          return t2[0] = e2[0] + r2[0] * n2, t2[1] = e2[1] + r2[1] * n2, t2;
        }, ce.distance = xe, ce.squaredDistance = be, ce.length = ve, ce.squaredLength = _e, ce.negate = function(t2, e2) {
          return t2[0] = -e2[0], t2[1] = -e2[1], t2;
        }, ce.inverse = function(t2, e2) {
          return t2[0] = 1 / e2[0], t2[1] = 1 / e2[1], t2;
        }, ce.normalize = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = r2 * r2 + n2 * n2;
          return i2 > 0 && (i2 = 1 / Math.sqrt(i2)), t2[0] = e2[0] * i2, t2[1] = e2[1] * i2, t2;
        }, ce.dot = function(t2, e2) {
          return t2[0] * e2[0] + t2[1] * e2[1];
        }, ce.cross = function(t2, e2, r2) {
          var n2 = e2[0] * r2[1] - e2[1] * r2[0];
          return t2[0] = t2[1] = 0, t2[2] = n2, t2;
        }, ce.lerp = function(t2, e2, r2, n2) {
          var i2 = e2[0], s2 = e2[1];
          return t2[0] = i2 + n2 * (r2[0] - i2), t2[1] = s2 + n2 * (r2[1] - s2), t2;
        }, ce.random = function(t2, e2) {
          e2 = e2 || 1;
          var r2 = 2 * pe.RANDOM() * Math.PI;
          return t2[0] = Math.cos(r2) * e2, t2[1] = Math.sin(r2) * e2, t2;
        }, ce.transformMat2 = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1];
          return t2[0] = r2[0] * n2 + r2[2] * i2, t2[1] = r2[1] * n2 + r2[3] * i2, t2;
        }, ce.transformMat2d = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1];
          return t2[0] = r2[0] * n2 + r2[2] * i2 + r2[4], t2[1] = r2[1] * n2 + r2[3] * i2 + r2[5], t2;
        }, ce.transformMat3 = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1];
          return t2[0] = r2[0] * n2 + r2[3] * i2 + r2[6], t2[1] = r2[1] * n2 + r2[4] * i2 + r2[7], t2;
        }, ce.transformMat4 = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1];
          return t2[0] = r2[0] * n2 + r2[4] * i2 + r2[12], t2[1] = r2[1] * n2 + r2[5] * i2 + r2[13], t2;
        }, ce.rotate = function(t2, e2, r2, n2) {
          var i2 = e2[0] - r2[0], s2 = e2[1] - r2[1], a2 = Math.sin(n2), o2 = Math.cos(n2);
          return t2[0] = i2 * o2 - s2 * a2 + r2[0], t2[1] = i2 * a2 + s2 * o2 + r2[1], t2;
        }, ce.angle = function(t2, e2) {
          var r2 = t2[0], n2 = t2[1], i2 = e2[0], s2 = e2[1], a2 = Math.sqrt(r2 * r2 + n2 * n2) * Math.sqrt(i2 * i2 + s2 * s2);
          return Math.acos(Math.min(Math.max(a2 && (r2 * i2 + n2 * s2) / a2, -1), 1));
        }, ce.zero = function(t2) {
          return t2[0] = 0, t2[1] = 0, t2;
        }, ce.str = function(t2) {
          return "vec2(" + t2[0] + ", " + t2[1] + ")";
        }, ce.exactEquals = function(t2, e2) {
          return t2[0] === e2[0] && t2[1] === e2[1];
        }, ce.equals = function(t2, e2) {
          var r2 = t2[0], n2 = t2[1], i2 = e2[0], s2 = e2[1];
          return Math.abs(r2 - i2) <= pe.EPSILON * Math.max(1, Math.abs(r2), Math.abs(i2)) && Math.abs(n2 - s2) <= pe.EPSILON * Math.max(1, Math.abs(n2), Math.abs(s2));
        }, ce.forEach = ce.sqrLen = ce.sqrDist = ce.dist = ce.div = ce.mul = ce.sub = ce.len = void 0;
        var pe = function(t2, e2) {
          if (t2 && t2.__esModule)
            return t2;
          if (null === t2 || "object" !== he(t2) && "function" != typeof t2)
            return { default: t2 };
          var r2 = fe(void 0);
          if (r2 && r2.has(t2))
            return r2.get(t2);
          var n2 = {}, i2 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s2 in t2)
            if ("default" !== s2 && Object.prototype.hasOwnProperty.call(t2, s2)) {
              var a2 = i2 ? Object.getOwnPropertyDescriptor(t2, s2) : null;
              a2 && (a2.get || a2.set) ? Object.defineProperty(n2, s2, a2) : n2[s2] = t2[s2];
            }
          return n2.default = t2, r2 && r2.set(t2, n2), n2;
        }(d);
        function fe(t2) {
          if ("function" != typeof WeakMap)
            return null;
          var e2 = /* @__PURE__ */ new WeakMap(), r2 = /* @__PURE__ */ new WeakMap();
          return (fe = function(t3) {
            return t3 ? r2 : e2;
          })(t2);
        }
        function de() {
          var t2 = new pe.ARRAY_TYPE(2);
          return pe.ARRAY_TYPE != Float32Array && (t2[0] = 0, t2[1] = 0), t2;
        }
        function me(t2, e2, r2) {
          return t2[0] = e2[0] - r2[0], t2[1] = e2[1] - r2[1], t2;
        }
        function ye(t2, e2, r2) {
          return t2[0] = e2[0] * r2[0], t2[1] = e2[1] * r2[1], t2;
        }
        function ge(t2, e2, r2) {
          return t2[0] = e2[0] / r2[0], t2[1] = e2[1] / r2[1], t2;
        }
        function xe(t2, e2) {
          return Math.hypot(e2[0] - t2[0], e2[1] - t2[1]);
        }
        function be(t2, e2) {
          var r2 = e2[0] - t2[0], n2 = e2[1] - t2[1];
          return r2 * r2 + n2 * n2;
        }
        function ve(t2) {
          return Math.hypot(t2[0], t2[1]);
        }
        function _e(t2) {
          var e2 = t2[0], r2 = t2[1];
          return e2 * e2 + r2 * r2;
        }
        ce.len = ve, ce.sub = me, ce.mul = ye, ce.div = ge, ce.dist = xe, ce.sqrDist = be, ce.sqrLen = _e;
        var we = function() {
          var t2 = de();
          return function(e2, r2, n2, i2, s2, a2) {
            var o2, l2;
            for (r2 || (r2 = 2), n2 || (n2 = 0), l2 = i2 ? Math.min(i2 * r2 + n2, e2.length) : e2.length, o2 = n2; o2 < l2; o2 += r2)
              t2[0] = e2[o2], t2[1] = e2[o2 + 1], s2(t2, t2, a2), e2[o2] = t2[0], e2[o2 + 1] = t2[1];
            return e2;
          };
        }();
        function Me(t2) {
          return Me = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
            return typeof t3;
          } : function(t3) {
            return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
          }, Me(t2);
        }
        ce.forEach = we, Object.defineProperty(f, "__esModule", { value: true }), t.aB = f.vec4 = t.$ = f.vec3 = f.vec2 = f.quat2 = t.aw = f.quat = t.ae = f.mat4 = t.bE = f.mat3 = f.mat2d = t.aD = f.mat2 = f.glMatrix = void 0;
        var Ae = Ce(d);
        f.glMatrix = Ae;
        var Se = Ce(b);
        t.aD = f.mat2 = Se;
        var Ie = Ce(S);
        f.mat2d = Ie;
        var Te = Ce(E);
        t.bE = f.mat3 = Te;
        var ke = Ce(V);
        t.ae = f.mat4 = ke;
        var Pe = Ce(Z);
        t.aw = f.quat = Pe;
        var ze = Ce(Wt);
        f.quat2 = ze;
        var Ee = Ce(ce);
        f.vec2 = Ee;
        var Be = Ce(H);
        t.$ = f.vec3 = Be;
        var De = Ce(ct);
        function Re(t2) {
          if ("function" != typeof WeakMap)
            return null;
          var e2 = /* @__PURE__ */ new WeakMap(), r2 = /* @__PURE__ */ new WeakMap();
          return (Re = function(t3) {
            return t3 ? r2 : e2;
          })(t2);
        }
        function Ce(t2, e2) {
          if (t2 && t2.__esModule)
            return t2;
          if (null === t2 || "object" !== Me(t2) && "function" != typeof t2)
            return { default: t2 };
          var r2 = Re(e2);
          if (r2 && r2.has(t2))
            return r2.get(t2);
          var n2 = {}, i2 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s2 in t2)
            if ("default" !== s2 && Object.prototype.hasOwnProperty.call(t2, s2)) {
              var a2 = i2 ? Object.getOwnPropertyDescriptor(t2, s2) : null;
              a2 && (a2.get || a2.set) ? Object.defineProperty(n2, s2, a2) : n2[s2] = t2[s2];
            }
          return n2.default = t2, r2 && r2.set(t2, n2), n2;
        }
        t.aB = f.vec4 = De;
        var Le = Ve;
        function Ve(t2, e2, r2, n2) {
          this.cx = 3 * t2, this.bx = 3 * (r2 - t2) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e2, this.by = 3 * (n2 - e2) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t2, this.p1y = e2, this.p2x = r2, this.p2y = n2;
        }
        Ve.prototype = { sampleCurveX: function(t2) {
          return ((this.ax * t2 + this.bx) * t2 + this.cx) * t2;
        }, sampleCurveY: function(t2) {
          return ((this.ay * t2 + this.by) * t2 + this.cy) * t2;
        }, sampleCurveDerivativeX: function(t2) {
          return (3 * this.ax * t2 + 2 * this.bx) * t2 + this.cx;
        }, solveCurveX: function(t2, e2) {
          if (void 0 === e2 && (e2 = 1e-6), t2 < 0)
            return 0;
          if (t2 > 1)
            return 1;
          for (var r2 = t2, n2 = 0; n2 < 8; n2++) {
            var i2 = this.sampleCurveX(r2) - t2;
            if (Math.abs(i2) < e2)
              return r2;
            var s2 = this.sampleCurveDerivativeX(r2);
            if (Math.abs(s2) < 1e-6)
              break;
            r2 -= i2 / s2;
          }
          var a2 = 0, o2 = 1;
          for (r2 = t2, n2 = 0; n2 < 20 && (i2 = this.sampleCurveX(r2), !(Math.abs(i2 - t2) < e2)); n2++)
            t2 > i2 ? a2 = r2 : o2 = r2, r2 = 0.5 * (o2 - a2) + a2;
          return r2;
        }, solve: function(t2, e2) {
          return this.sampleCurveY(this.solveCurveX(t2, e2));
        } };
        var Fe = p(Le), Oe = Ue;
        function Ue(t2, e2) {
          this.x = t2, this.y = e2;
        }
        Ue.prototype = { clone: function() {
          return new Ue(this.x, this.y);
        }, add: function(t2) {
          return this.clone()._add(t2);
        }, sub: function(t2) {
          return this.clone()._sub(t2);
        }, multByPoint: function(t2) {
          return this.clone()._multByPoint(t2);
        }, divByPoint: function(t2) {
          return this.clone()._divByPoint(t2);
        }, mult: function(t2) {
          return this.clone()._mult(t2);
        }, div: function(t2) {
          return this.clone()._div(t2);
        }, rotate: function(t2) {
          return this.clone()._rotate(t2);
        }, rotateAround: function(t2, e2) {
          return this.clone()._rotateAround(t2, e2);
        }, matMult: function(t2) {
          return this.clone()._matMult(t2);
        }, unit: function() {
          return this.clone()._unit();
        }, perp: function() {
          return this.clone()._perp();
        }, round: function() {
          return this.clone()._round();
        }, mag: function() {
          return Math.sqrt(this.x * this.x + this.y * this.y);
        }, equals: function(t2) {
          return this.x === t2.x && this.y === t2.y;
        }, dist: function(t2) {
          return Math.sqrt(this.distSqr(t2));
        }, distSqr: function(t2) {
          var e2 = t2.x - this.x, r2 = t2.y - this.y;
          return e2 * e2 + r2 * r2;
        }, angle: function() {
          return Math.atan2(this.y, this.x);
        }, angleTo: function(t2) {
          return Math.atan2(this.y - t2.y, this.x - t2.x);
        }, angleWith: function(t2) {
          return this.angleWithSep(t2.x, t2.y);
        }, angleWithSep: function(t2, e2) {
          return Math.atan2(this.x * e2 - this.y * t2, this.x * t2 + this.y * e2);
        }, _matMult: function(t2) {
          var e2 = t2[2] * this.x + t2[3] * this.y;
          return this.x = t2[0] * this.x + t2[1] * this.y, this.y = e2, this;
        }, _add: function(t2) {
          return this.x += t2.x, this.y += t2.y, this;
        }, _sub: function(t2) {
          return this.x -= t2.x, this.y -= t2.y, this;
        }, _mult: function(t2) {
          return this.x *= t2, this.y *= t2, this;
        }, _div: function(t2) {
          return this.x /= t2, this.y /= t2, this;
        }, _multByPoint: function(t2) {
          return this.x *= t2.x, this.y *= t2.y, this;
        }, _divByPoint: function(t2) {
          return this.x /= t2.x, this.y /= t2.y, this;
        }, _unit: function() {
          return this._div(this.mag()), this;
        }, _perp: function() {
          var t2 = this.y;
          return this.y = this.x, this.x = -t2, this;
        }, _rotate: function(t2) {
          var e2 = Math.cos(t2), r2 = Math.sin(t2), n2 = r2 * this.x + e2 * this.y;
          return this.x = e2 * this.x - r2 * this.y, this.y = n2, this;
        }, _rotateAround: function(t2, e2) {
          var r2 = Math.cos(t2), n2 = Math.sin(t2), i2 = e2.y + n2 * (this.x - e2.x) + r2 * (this.y - e2.y);
          return this.x = e2.x + r2 * (this.x - e2.x) - n2 * (this.y - e2.y), this.y = i2, this;
        }, _round: function() {
          return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
        } }, Ue.convert = function(t2) {
          return t2 instanceof Ue ? t2 : Array.isArray(t2) ? new Ue(t2[0], t2[1]) : t2;
        };
        var je = p(Oe);
        function Ne(t2, e2) {
          if (Array.isArray(t2)) {
            if (!Array.isArray(e2) || t2.length !== e2.length)
              return false;
            for (let r2 = 0; r2 < t2.length; r2++)
              if (!Ne(t2[r2], e2[r2]))
                return false;
            return true;
          }
          if ("object" == typeof t2 && null !== t2 && null !== e2) {
            if ("object" != typeof e2)
              return false;
            if (Object.keys(t2).length !== Object.keys(e2).length)
              return false;
            for (const r2 in t2)
              if (!Ne(t2[r2], e2[r2]))
                return false;
            return true;
          }
          return t2 === e2;
        }
        const $e = Math.PI / 180, qe = 180 / Math.PI;
        function Ge(t2) {
          return t2 * $e;
        }
        function Xe(t2) {
          return t2 * qe;
        }
        const Ye = [[0, 0], [1, 0], [1, 1], [0, 1]];
        function Ze(t2) {
          if (t2 <= 0)
            return 0;
          if (t2 >= 1)
            return 1;
          const e2 = t2 * t2, r2 = e2 * t2;
          return 4 * (t2 < 0.5 ? r2 : 3 * (t2 - e2) + r2 - 0.75);
        }
        function He(t2, e2, r2, n2) {
          const i2 = new Fe(t2, e2, r2, n2);
          return function(t3) {
            return i2.solve(t3);
          };
        }
        const Ke = He(0.25, 0.1, 0.25, 1);
        function We(t2, e2, r2) {
          return Math.min(r2, Math.max(e2, t2));
        }
        function Je(t2, e2, r2) {
          return (r2 = We((r2 - t2) / (e2 - t2), 0, 1)) * r2 * (3 - 2 * r2);
        }
        function Qe(t2, e2, r2) {
          const n2 = r2 - e2, i2 = ((t2 - e2) % n2 + n2) % n2 + e2;
          return i2 === e2 ? r2 : i2;
        }
        function tr(t2, e2, r2) {
          if (!t2.length)
            return r2(null, []);
          let n2 = t2.length;
          const i2 = new Array(t2.length);
          let s2 = null;
          t2.forEach((t3, a2) => {
            e2(t3, (t4, e3) => {
              t4 && (s2 = t4), i2[a2] = e3, 0 == --n2 && r2(s2, i2);
            });
          });
        }
        function er(t2) {
          const e2 = [];
          for (const r2 in t2)
            e2.push(t2[r2]);
          return e2;
        }
        function rr(t2, ...e2) {
          for (const r2 of e2)
            for (const e3 in r2)
              t2[e3] = r2[e3];
          return t2;
        }
        let nr = 1;
        function ir() {
          return nr++;
        }
        function sr() {
          return function t2(e2) {
            return e2 ? (e2 ^ Math.random() * (16 >> e2 / 4)).toString(16) : ([1e7] + -[1e3] + -4e3 + -8e3 + -1e11).replace(/[018]/g, t2);
          }();
        }
        function ar(t2) {
          return t2 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t2) / Math.LN2));
        }
        function or(t2) {
          return !!t2 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t2);
        }
        function lr(t2, e2) {
          t2.forEach((t3) => {
            e2[t3] && (e2[t3] = e2[t3].bind(e2));
          });
        }
        function ur(t2, e2) {
          return -1 !== t2.indexOf(e2, t2.length - e2.length);
        }
        function cr(t2, e2, r2) {
          const n2 = {};
          for (const r3 in t2)
            n2[r3] = e2.call(this, t2[r3], r3, t2);
          return n2;
        }
        function hr(t2, e2, r2) {
          const n2 = {};
          for (const r3 in t2)
            e2.call(this, t2[r3], r3, t2) && (n2[r3] = t2[r3]);
          return n2;
        }
        function pr(t2) {
          return Array.isArray(t2) ? t2.map(pr) : "object" == typeof t2 && t2 ? cr(t2, pr) : t2;
        }
        const fr = {};
        function dr(t2) {
          fr[t2] || ("undefined" != typeof console && console.warn(t2), fr[t2] = true);
        }
        function mr(t2, e2, r2) {
          return (r2.y - t2.y) * (e2.x - t2.x) > (e2.y - t2.y) * (r2.x - t2.x);
        }
        function yr(t2) {
          let e2 = 0;
          for (let r2, n2, i2 = 0, s2 = t2.length, a2 = s2 - 1; i2 < s2; a2 = i2++)
            r2 = t2[i2], n2 = t2[a2], e2 += (n2.x - r2.x) * (r2.y + n2.y);
          return e2;
        }
        function gr([t2, e2, r2]) {
          const n2 = Ge(e2 + 90), i2 = Ge(r2);
          return { x: t2 * Math.cos(n2) * Math.sin(i2), y: t2 * Math.sin(n2) * Math.sin(i2), z: t2 * Math.cos(i2), azimuthal: e2, polar: r2 };
        }
        function xr() {
          return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
        }
        function br(t2) {
          const e2 = {};
          if (t2.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t3, r2, n2, i2) => {
            const s2 = n2 || i2;
            return e2[r2] = !s2 || s2.toLowerCase(), "";
          }), e2["max-age"]) {
            const t3 = parseInt(e2["max-age"], 10);
            isNaN(t3) ? delete e2["max-age"] : e2["max-age"] = t3;
          }
          return e2;
        }
        let vr, _r, wr, Mr, Ar, Sr, Ir = null;
        function Tr(t2) {
          try {
            const e2 = self[t2];
            return e2.setItem("_mapbox_test_", 1), e2.removeItem("_mapbox_test_"), true;
          } catch (t3) {
            return false;
          }
        }
        function kr(t2, e2) {
          return [t2[4 * e2], t2[4 * e2 + 1], t2[4 * e2 + 2], t2[4 * e2 + 3]];
        }
        function Pr(t2, e2, r2, n2) {
          for (; e2 < r2; ) {
            const i2 = e2 + r2 >> 1;
            t2[i2] < n2 ? e2 = i2 + 1 : r2 = i2;
          }
          return e2;
        }
        function zr(t2, e2, r2, n2) {
          for (; e2 < r2; ) {
            const i2 = e2 + r2 >> 1;
            t2[i2] <= n2 ? e2 = i2 + 1 : r2 = i2;
          }
          return e2;
        }
        function Er(t2) {
          return t2 > 0 ? 1 / (1.001 - t2) : 1 + t2;
        }
        function Br(t2) {
          return t2 > 0 ? 1 - 1 / (1.001 - t2) : -t2;
        }
        function Dr() {
          return null == vr && (vr = self.OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof self.createImageBitmap), vr;
        }
        const Rr = { now: () => void 0 !== Mr ? Mr : performance.now(), setNow(t2) {
          Mr = t2;
        }, restoreNow() {
          Mr = void 0;
        }, frame(t2) {
          const e2 = requestAnimationFrame(t2);
          return { cancel: () => cancelAnimationFrame(e2) };
        }, getImageData(t2, e2 = 0) {
          const { width: r2, height: n2 } = t2;
          Ar || (Ar = document.createElement("canvas"));
          const i2 = Ar.getContext("2d", { willReadFrequently: true });
          if (!i2)
            throw new Error("failed to create canvas 2d context");
          return (r2 > Ar.width || n2 > Ar.height) && (Ar.width = r2, Ar.height = n2), i2.clearRect(-e2, -e2, r2 + 2 * e2, n2 + 2 * e2), i2.drawImage(t2, 0, 0, r2, n2), i2.getImageData(-e2, -e2, r2 + 2 * e2, n2 + 2 * e2);
        }, resolveURL: (t2) => (_r || (_r = document.createElement("a")), _r.href = t2, _r.href), get devicePixelRatio() {
          return window.devicePixelRatio;
        }, get prefersReducedMotion() {
          return !!window.matchMedia && (null == wr && (wr = window.matchMedia("(prefers-reduced-motion: reduce)")), wr.matches);
        }, hasCanvasFingerprintNoise() {
          if (void 0 !== Sr)
            return Sr;
          if (!Dr())
            return Sr = false, false;
          const t2 = new OffscreenCanvas(85, 1), e2 = t2.getContext("2d", { willReadFrequently: true });
          let r2 = 0;
          for (let n3 = 0; n3 < t2.width; ++n3)
            e2.fillStyle = `rgba(${r2++},${r2++},${r2++}, 255)`, e2.fillRect(n3, 0, 1, 1);
          const n2 = e2.getImageData(0, 0, t2.width, t2.height);
          r2 = 0;
          for (let t3 = 0; t3 < n2.data.length; ++t3)
            if (t3 % 4 != 3 && r2++ !== n2.data[t3])
              return Sr = true, true;
          return Sr = false, false;
        } };
        function Cr(t2, e2) {
          const r2 = t2.indexOf("?");
          if (r2 < 0)
            return `${t2}?${new URLSearchParams(e2).toString()}`;
          const n2 = new URLSearchParams(t2.slice(r2));
          for (const t3 in e2)
            n2.set(t3, e2[t3]);
          return `${t2.slice(0, r2)}?${n2.toString()}`;
        }
        function Lr(t2, e2 = { persistentParams: [] }) {
          const r2 = t2.indexOf("?");
          if (r2 < 0)
            return t2;
          const n2 = new URLSearchParams(), i2 = new URLSearchParams(t2.slice(r2));
          for (const t3 of e2.persistentParams) {
            const e3 = i2.get(t3);
            e3 && n2.set(t3, e3);
          }
          const s2 = n2.toString();
          return `${t2.slice(0, r2)}${s2.length > 0 ? `?${s2}` : ""}`;
        }
        const Vr = "mapbox-tiles";
        let Fr = 500, Or = 50;
        const Ur = ["language", "worldview", "jobid"];
        let jr, Nr;
        function $r() {
          try {
            return caches;
          } catch (t2) {
          }
        }
        function qr() {
          const t2 = $r();
          t2 && !jr && (jr = t2.open(Vr));
        }
        let Gr = 1 / 0;
        const Xr = { supported: false, testSupport: function(t2) {
          !Hr && Zr && (Kr ? Jr(t2) : Yr = t2);
        } };
        let Yr, Zr, Hr = false, Kr = false;
        const Wr = "undefined" != typeof self ? self : {};
        function Jr(t2) {
          const e2 = t2.createTexture();
          t2.bindTexture(t2.TEXTURE_2D, e2);
          try {
            if (t2.texImage2D(t2.TEXTURE_2D, 0, t2.RGBA, t2.RGBA, t2.UNSIGNED_BYTE, Zr), t2.isContextLost())
              return;
            Xr.supported = true;
          } catch (t3) {
          }
          t2.deleteTexture(e2), Hr = true;
        }
        Wr.document && (Zr = Wr.document.createElement("img"), Zr.onload = function() {
          Yr && Jr(Yr), Yr = null, Kr = true;
        }, Zr.onerror = function() {
          Hr = true, Yr = null;
        }, Zr.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
        const Qr = { Unknown: "Unknown", Style: "Style", Source: "Source", Tile: "Tile", Glyphs: "Glyphs", SpriteImage: "SpriteImage", SpriteJSON: "SpriteJSON", Image: "Image", Model: "Model" };
        "function" == typeof Object.freeze && Object.freeze(Qr);
        class tn extends Error {
          constructor(t2, e2, r2) {
            401 === e2 && i(r2) && (t2 += ": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"), super(t2), this.status = e2, this.url = r2;
          }
          toString() {
            return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
          }
        }
        const en = xr() ? () => self.worker && self.worker.referrer : () => ("blob:" === location.protocol ? parent : self).location.href;
        const rn = function(t2, e2) {
          if (!(/^file:/.test(r2 = t2.url) || /^file:/.test(en()) && !/^\w+:/.test(r2))) {
            if (self.fetch && self.Request && self.AbortController && Request.prototype.hasOwnProperty("signal"))
              return function(t3, e3) {
                const r3 = new AbortController(), n2 = new Request(t3.url, { method: t3.method || "GET", body: t3.body, credentials: t3.credentials, headers: t3.headers, referrer: en(), referrerPolicy: t3.referrerPolicy, signal: r3.signal });
                let s2 = false, a2 = false;
                const o2 = (l2 = n2.url).indexOf("sku=") > 0 && i(l2);
                var l2;
                "json" === t3.type && n2.headers.set("Accept", "application/json");
                const u2 = (r4, i2, s3) => {
                  if (a2)
                    return;
                  if (r4 && "SecurityError" !== r4.message && dr(r4.toString()), i2 && s3)
                    return c2(i2);
                  const l3 = Date.now();
                  fetch(n2).then((r5) => {
                    if (r5.ok) {
                      const t4 = o2 ? r5.clone() : null;
                      return c2(r5, t4, l3);
                    }
                    return e3(new tn(r5.statusText, r5.status, t3.url));
                  }).catch((r5) => {
                    "AbortError" !== r5.name && e3(new Error(`${r5.message} ${t3.url}`));
                  });
                }, c2 = (r4, i2, o3) => {
                  ("arrayBuffer" === t3.type ? r4.arrayBuffer() : "json" === t3.type ? r4.json() : r4.text()).then((t4) => {
                    a2 || (i2 && o3 && function(t5, e4, r5) {
                      if (qr(), !jr)
                        return;
                      const n3 = br(e4.headers.get("Cache-Control") || "");
                      if (n3["no-store"])
                        return;
                      const i3 = { status: e4.status, statusText: e4.statusText, headers: new Headers() };
                      e4.headers.forEach((t6, e5) => i3.headers.set(e5, t6)), n3["max-age"] && i3.headers.set("Expires", new Date(r5 + 1e3 * n3["max-age"]).toUTCString());
                      const s3 = i3.headers.get("Expires");
                      if (!s3)
                        return;
                      if (new Date(s3).getTime() - r5 < 42e4)
                        return;
                      let a3 = Lr(t5.url, { persistentParams: Ur });
                      if (206 === e4.status) {
                        const e5 = t5.headers.get("Range");
                        if (!e5)
                          return;
                        i3.status = 200, a3 = Cr(a3, { range: e5 });
                      }
                      !function(t6, e5) {
                        if (void 0 === Nr)
                          try {
                            new Response(new ReadableStream()), Nr = true;
                          } catch (t7) {
                            Nr = false;
                          }
                        Nr ? e5(t6.body) : t6.blob().then(e5);
                      }(e4, (t6) => {
                        const r6 = new Response(200 !== (n4 = e4.status) && 404 !== n4 && [101, 103, 204, 205, 304].includes(n4) ? null : t6, i3);
                        var n4;
                        qr(), jr && jr.then((t7) => t7.put(a3, r6)).catch((t7) => dr(t7.message));
                      });
                    }(n2, i2, o3), s2 = true, e3(null, t4, r4.headers.get("Cache-Control"), r4.headers.get("Expires")));
                  }).catch((t4) => {
                    a2 || e3(new Error(t4.message));
                  });
                };
                return o2 ? function(t4, e4) {
                  if (qr(), !jr)
                    return e4(null);
                  jr.then((r4) => {
                    let n3 = Lr(t4.url, { persistentParams: Ur });
                    const i2 = t4.headers.get("Range");
                    i2 && (n3 = Cr(n3, { range: i2 })), r4.match(n3).then((t5) => {
                      const i3 = function(t6) {
                        if (!t6)
                          return false;
                        const e5 = new Date(t6.headers.get("Expires") || 0), r5 = br(t6.headers.get("Cache-Control") || "");
                        return e5 > Date.now() && !r5["no-cache"];
                      }(t5);
                      r4.delete(n3), i3 && r4.put(n3, t5.clone()), e4(null, t5, i3);
                    }).catch(e4);
                  }).catch(e4);
                }(n2, u2) : u2(null, null), { cancel: () => {
                  a2 = true, s2 || r3.abort();
                } };
              }(t2, e2);
            if (xr() && self.worker && self.worker.actor)
              return self.worker.actor.send("getResource", t2, e2, void 0, true);
          }
          var r2;
          return function(t3, e3) {
            const r3 = new XMLHttpRequest();
            r3.open(t3.method || "GET", t3.url, true), "arrayBuffer" === t3.type && (r3.responseType = "arraybuffer");
            for (const e4 in t3.headers)
              r3.setRequestHeader(e4, t3.headers[e4]);
            return "json" === t3.type && (r3.responseType = "text", r3.setRequestHeader("Accept", "application/json")), r3.withCredentials = "include" === t3.credentials, r3.onerror = () => {
              e3(new Error(r3.statusText));
            }, r3.onload = () => {
              if ((r3.status >= 200 && r3.status < 300 || 0 === r3.status) && null !== r3.response) {
                let n2 = r3.response;
                if ("json" === t3.type)
                  try {
                    n2 = JSON.parse(r3.response);
                  } catch (t4) {
                    return e3(t4);
                  }
                e3(null, n2, r3.getResponseHeader("Cache-Control"), r3.getResponseHeader("Expires"));
              } else
                e3(new tn(r3.statusText, r3.status, t3.url));
            }, r3.send(t3.body), { cancel: () => r3.abort() };
          }(t2, e2);
        }, nn = function(t2, e2) {
          return rn(rr(t2, { type: "arrayBuffer" }), e2);
        };
        function sn(t2) {
          const e2 = document.createElement("a");
          return e2.href = t2, e2.protocol === location.protocol && e2.host === location.host;
        }
        const an = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        let on, ln;
        on = [], ln = 0;
        const un = function(t2, e2) {
          if (Xr.supported && (t2.headers || (t2.headers = {}), t2.headers.accept = "image/webp,*/*"), ln >= n.MAX_PARALLEL_IMAGE_REQUESTS) {
            const r3 = { requestParameters: t2, callback: e2, cancelled: false, cancel() {
              this.cancelled = true;
            } };
            return on.push(r3), r3;
          }
          ln++;
          let r2 = false;
          const i2 = () => {
            if (!r2)
              for (r2 = true, ln--; on.length && ln < n.MAX_PARALLEL_IMAGE_REQUESTS; ) {
                const t3 = on.shift(), { requestParameters: e3, callback: r3, cancelled: n2 } = t3;
                n2 || (t3.cancel = un(e3, r3).cancel);
              }
          }, s2 = nn(t2, (t3, r3, n2, s3) => {
            i2(), t3 ? e2(t3) : r3 && (self.createImageBitmap ? function(t4, e3) {
              const r4 = new Blob([new Uint8Array(t4)], { type: "image/png" });
              createImageBitmap(r4).then((t5) => {
                e3(null, t5);
              }).catch((t5) => {
                e3(new Error(`Could not load image because of ${t5.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
              });
            }(r3, (t4, r4) => e2(t4, r4, n2, s3)) : function(t4, e3) {
              const r4 = new Image();
              r4.onload = () => {
                e3(null, r4), URL.revokeObjectURL(r4.src), r4.onload = null, requestAnimationFrame(() => {
                  r4.src = an;
                });
              }, r4.onerror = () => e3(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
              const n3 = new Blob([new Uint8Array(t4)], { type: "image/png" });
              r4.src = t4.byteLength ? URL.createObjectURL(n3) : an;
            }(r3, (t4, r4) => e2(t4, r4, n2, s3)));
          });
          return { cancel: () => {
            s2.cancel(), i2();
          } };
        }, cn = "01", hn = "NO_ACCESS_TOKEN", pn = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function fn(t2) {
          const e2 = t2.match(pn);
          if (!e2)
            throw new Error("Unable to parse URL object");
          return { protocol: e2[1], authority: e2[2], path: e2[3] || "/", params: e2[4] ? e2[4].split("&") : [] };
        }
        function dn(t2) {
          const e2 = t2.params.length ? `?${t2.params.join("&")}` : "";
          return `${t2.protocol}://${t2.authority}${t2.path}${e2}`;
        }
        const mn = "mapbox.eventData";
        function yn(t2) {
          if (!t2)
            return null;
          const e2 = t2.split(".");
          if (!e2 || 3 !== e2.length)
            return null;
          try {
            return JSON.parse(decodeURIComponent(atob(e2[1]).split("").map((t3) => "%" + ("00" + t3.charCodeAt(0).toString(16)).slice(-2)).join("")));
          } catch (t3) {
            return null;
          }
        }
        class gn {
          constructor(t2) {
            this.type = t2, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
          }
          getStorageKey(t2) {
            const e2 = yn(n.ACCESS_TOKEN);
            let r2 = "";
            return r2 = e2 && e2.u ? btoa(encodeURIComponent(e2.u).replace(/%([0-9A-F]{2})/g, (t3, e3) => String.fromCharCode(Number("0x" + e3)))) : n.ACCESS_TOKEN || "", t2 ? `${mn}.${t2}:${r2}` : `${mn}:${r2}`;
          }
          fetchEventData() {
            const t2 = Tr("localStorage"), e2 = this.getStorageKey(), r2 = this.getStorageKey("uuid");
            if (t2)
              try {
                const t3 = localStorage.getItem(e2);
                t3 && (this.eventData = JSON.parse(t3));
                const n2 = localStorage.getItem(r2);
                n2 && (this.anonId = n2);
              } catch (t3) {
                dr("Unable to read from LocalStorage");
              }
          }
          saveEventData() {
            const t2 = Tr("localStorage"), e2 = this.getStorageKey(), r2 = this.getStorageKey("uuid"), n2 = this.anonId;
            if (t2 && n2)
              try {
                localStorage.setItem(r2, n2), Object.keys(this.eventData).length >= 1 && localStorage.setItem(e2, JSON.stringify(this.eventData));
              } catch (t3) {
                dr("Unable to write to LocalStorage");
              }
          }
          processRequests(t2) {
          }
          postEvent(t2, e2, r2, i2) {
            if (!n.EVENTS_URL)
              return;
            const s2 = fn(n.EVENTS_URL);
            s2.params.push(`access_token=${i2 || n.ACCESS_TOKEN || ""}`);
            const a2 = { event: this.type, created: new Date(t2).toISOString() }, o2 = e2 ? rr(a2, e2) : a2, l2 = { url: dn(s2), headers: { "Content-Type": "text/plain" }, body: JSON.stringify([o2]) };
            this.pendingRequest = function(t3, e3) {
              return rn(rr(t3, { method: "POST" }), e3);
            }(l2, (t3) => {
              this.pendingRequest = null, r2(t3), this.saveEventData(), this.processRequests(i2);
            });
          }
          queueRequest(t2, e2) {
            this.queue.push(t2), this.processRequests(e2);
          }
        }
        const xn = new class extends gn {
          constructor(t2) {
            super("appUserTurnstile"), this._customAccessToken = t2;
          }
          postTurnstileEvent(t2, e2) {
            n.EVENTS_URL && n.ACCESS_TOKEN && Array.isArray(t2) && t2.some((t3) => s(t3) || i(t3)) && this.queueRequest(Date.now(), e2);
          }
          processRequests(t2) {
            if (this.pendingRequest || 0 === this.queue.length)
              return;
            this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
            const r2 = yn(n.ACCESS_TOKEN), i2 = r2 ? r2.u : n.ACCESS_TOKEN;
            let s2 = i2 !== this.eventData.tokenU;
            or(this.anonId) || (this.anonId = sr(), s2 = true);
            const a2 = this.queue.shift();
            if (this.eventData.lastSuccess) {
              const t3 = new Date(this.eventData.lastSuccess), e2 = new Date(a2), r3 = (a2 - this.eventData.lastSuccess) / 864e5;
              s2 = s2 || r3 >= 1 || r3 < -1 || t3.getDate() !== e2.getDate();
            } else
              s2 = true;
            s2 ? this.postEvent(a2, { sdkIdentifier: "mapbox-gl-js", sdkVersion: e, skuId: cn, "enabled.telemetry": false, userId: this.anonId }, (t3) => {
              t3 || (this.eventData.lastSuccess = a2, this.eventData.tokenU = i2);
            }, t2) : this.processRequests();
          }
        }(), bn = xn.postTurnstileEvent.bind(xn), vn = new class extends gn {
          constructor() {
            super("map.load"), this.success = {}, this.skuToken = "";
          }
          postMapLoadEvent(t2, e2, r2, i2) {
            this.skuToken = e2, this.errorCb = i2, n.EVENTS_URL && (r2 || n.ACCESS_TOKEN ? this.queueRequest({ id: t2, timestamp: Date.now() }, r2) : this.errorCb(new Error(hn)));
          }
          processRequests(t2) {
            if (this.pendingRequest || 0 === this.queue.length)
              return;
            const { id: r2, timestamp: n2 } = this.queue.shift();
            r2 && this.success[r2] || (this.anonId || this.fetchEventData(), or(this.anonId) || (this.anonId = sr()), this.postEvent(n2, { sdkIdentifier: "mapbox-gl-js", sdkVersion: e, skuId: cn, skuToken: this.skuToken, userId: this.anonId }, (t3) => {
              t3 ? this.errorCb(t3) : r2 && (this.success[r2] = true);
            }, t2));
          }
          remove() {
            this.errorCb = null;
          }
        }(), _n = vn.postMapLoadEvent.bind(vn), wn = new class extends gn {
          constructor() {
            super("style.load"), this.eventIdPerMapInstanceMap = /* @__PURE__ */ new Map(), this.mapInstanceIdMap = /* @__PURE__ */ new WeakMap();
          }
          getMapInstanceId(t2) {
            let e2 = this.mapInstanceIdMap.get(t2);
            return e2 || (e2 = sr(), this.mapInstanceIdMap.set(t2, e2)), e2;
          }
          getEventId(t2) {
            const e2 = this.eventIdPerMapInstanceMap.get(t2) || 0;
            return this.eventIdPerMapInstanceMap.set(t2, e2 + 1), e2;
          }
          postStyleLoadEvent(t2, e2) {
            const { map: r2, style: i2, importedStyles: s2 } = e2;
            if (!n.EVENTS_URL || !t2 && !n.ACCESS_TOKEN)
              return;
            const a2 = this.getMapInstanceId(r2), o2 = { mapInstanceId: a2, eventId: this.getEventId(a2), style: i2 };
            s2.length && (o2.importedStyles = s2), this.queueRequest({ timestamp: Date.now(), payload: o2 }, t2);
          }
          processRequests(t2) {
            if (this.pendingRequest || 0 === this.queue.length)
              return;
            const { timestamp: e2, payload: r2 } = this.queue.shift();
            this.postEvent(e2, r2, () => {
            }, t2);
          }
        }(), Mn = wn.postStyleLoadEvent.bind(wn), An = new class extends gn {
          constructor() {
            super("gljs.performance");
          }
          postPerformanceEvent(t2, e2) {
            n.EVENTS_URL && (t2 || n.ACCESS_TOKEN) && this.queueRequest({ timestamp: Date.now(), performanceData: e2 }, t2);
          }
          processRequests(t2) {
            if (this.pendingRequest || 0 === this.queue.length)
              return;
            const { timestamp: r2, performanceData: n2 } = this.queue.shift(), i2 = function(t3) {
              const r3 = performance.getEntriesByType("resource"), n3 = performance.getEntriesByType("mark"), i3 = function(t4) {
                const e2 = {};
                if (t4) {
                  for (const r4 in t4)
                    if ("other" !== r4)
                      for (const n4 of t4[r4]) {
                        const t5 = `${r4}ResolveRangeMin`, i4 = `${r4}ResolveRangeMax`, s3 = `${r4}RequestCount`, a3 = `${r4}RequestCachedCount`;
                        e2[t5] = Math.min(e2[t5] || 1 / 0, n4.startTime), e2[i4] = Math.max(e2[i4] || -1 / 0, n4.responseEnd);
                        const o3 = (t6) => {
                          void 0 === e2[t6] && (e2[t6] = 0), ++e2[t6];
                        };
                        void 0 !== n4.transferSize && 0 === n4.transferSize && o3(a3), o3(s3);
                      }
                }
                return e2;
              }(function(t4, e2) {
                const r4 = {};
                if (t4)
                  for (const n4 of t4) {
                    const t5 = e2(n4);
                    void 0 === r4[t5] && (r4[t5] = []), r4[t5].push(n4);
                  }
                return r4;
              }(r3, h)), s2 = window.devicePixelRatio, a2 = navigator.connection || navigator.mozConnection || navigator.webkitConnection, o2 = a2 ? a2.effectiveType : void 0, c2 = { counters: [], metadata: [], attributes: [] }, p2 = (t4, e2, r4) => {
                null != r4 && t4.push({ name: e2, value: r4.toString() });
              };
              for (const t4 in i3)
                p2(c2.counters, t4, i3[t4]);
              if (t3.interactionRange[0] !== 1 / 0 && t3.interactionRange[1] !== -1 / 0 && (p2(c2.counters, "interactionRangeMin", t3.interactionRange[0]), p2(c2.counters, "interactionRangeMax", t3.interactionRange[1])), n3)
                for (const t4 of Object.keys(u)) {
                  const e2 = u[t4], r4 = n3.find((t5) => t5.name === e2);
                  r4 && p2(c2.counters, e2, r4.startTime);
                }
              return p2(c2.counters, "visibilityHidden", t3.visibilityHidden), p2(c2.attributes, "style", function(t4) {
                if (t4)
                  for (const e2 of t4) {
                    const t5 = e2.name.split("?")[0];
                    if (l(t5)) {
                      const e3 = t5.split("/").slice(-2);
                      if (2 === e3.length)
                        return `mapbox://styles/${e3[0]}/${e3[1]}`;
                    }
                  }
              }(r3)), p2(c2.attributes, "terrainEnabled", t3.terrainEnabled ? "true" : "false"), p2(c2.attributes, "fogEnabled", t3.fogEnabled ? "true" : "false"), p2(c2.attributes, "projection", t3.projection), p2(c2.attributes, "zoom", t3.zoom), p2(c2.metadata, "devicePixelRatio", s2), p2(c2.metadata, "connectionEffectiveType", o2), p2(c2.metadata, "navigatorUserAgent", navigator.userAgent), p2(c2.metadata, "screenWidth", window.screen.width), p2(c2.metadata, "screenHeight", window.screen.height), p2(c2.metadata, "windowWidth", window.innerWidth), p2(c2.metadata, "windowHeight", window.innerHeight), p2(c2.metadata, "mapWidth", t3.width / s2), p2(c2.metadata, "mapHeight", t3.height / s2), p2(c2.metadata, "webglRenderer", t3.renderer), p2(c2.metadata, "webglVendor", t3.vendor), p2(c2.metadata, "sdkVersion", e), p2(c2.metadata, "sdkIdentifier", "mapbox-gl-js"), c2;
            }(n2);
            for (const t3 of i2.metadata)
              ;
            for (const t3 of i2.counters)
              ;
            for (const t3 of i2.attributes)
              ;
            this.postEvent(r2, i2, () => {
            }, t2);
          }
        }(), Sn = An.postPerformanceEvent.bind(An), In = new class extends gn {
          constructor() {
            super("map.auth"), this.success = {}, this.skuToken = "";
          }
          getSession(t2, e2, r2, i2) {
            if (!n.API_URL || !n.SESSION_PATH)
              return;
            const s2 = fn(n.API_URL + n.SESSION_PATH);
            s2.params.push(`sku=${e2 || ""}`), s2.params.push(`access_token=${i2 || n.ACCESS_TOKEN || ""}`);
            const a2 = { url: dn(s2), headers: { "Content-Type": "text/plain" } };
            this.pendingRequest = function(t3, e3) {
              return rn(rr(t3, { method: "GET" }), e3);
            }(a2, (t3) => {
              this.pendingRequest = null, r2(t3), this.saveEventData(), this.processRequests(i2);
            });
          }
          getSessionAPI(t2, e2, r2, i2) {
            this.skuToken = e2, this.errorCb = i2, n.SESSION_PATH && n.API_URL && (r2 || n.ACCESS_TOKEN ? this.queueRequest({ id: t2, timestamp: Date.now() }, r2) : this.errorCb(new Error(hn)));
          }
          processRequests(t2) {
            if (this.pendingRequest || 0 === this.queue.length)
              return;
            const { id: e2, timestamp: r2 } = this.queue.shift();
            e2 && this.success[e2] || this.getSession(r2, this.skuToken, (t3) => {
              t3 ? this.errorCb(t3) : e2 && (this.success[e2] = true);
            }, t2);
          }
          remove() {
            this.errorCb = null;
          }
        }(), Tn = In.getSessionAPI.bind(In), kn = /* @__PURE__ */ new Set();
        var Pn = { exports: {} }, zn = { exports: function(t2, e2) {
          var r2, n2, i2, s2, a2, o2, l2, u2;
          for (n2 = t2.length - (r2 = 3 & t2.length), i2 = e2, a2 = 3432918353, o2 = 461845907, u2 = 0; u2 < n2; )
            l2 = 255 & t2.charCodeAt(u2) | (255 & t2.charCodeAt(++u2)) << 8 | (255 & t2.charCodeAt(++u2)) << 16 | (255 & t2.charCodeAt(++u2)) << 24, ++u2, i2 = 27492 + (65535 & (s2 = 5 * (65535 & (i2 = (i2 ^= l2 = (65535 & (l2 = (l2 = (65535 & l2) * a2 + (((l2 >>> 16) * a2 & 65535) << 16) & 4294967295) << 15 | l2 >>> 17)) * o2 + (((l2 >>> 16) * o2 & 65535) << 16) & 4294967295) << 13 | i2 >>> 19)) + ((5 * (i2 >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s2 >>> 16) & 65535) << 16);
          switch (l2 = 0, r2) {
            case 3:
              l2 ^= (255 & t2.charCodeAt(u2 + 2)) << 16;
            case 2:
              l2 ^= (255 & t2.charCodeAt(u2 + 1)) << 8;
            case 1:
              i2 ^= l2 = (65535 & (l2 = (l2 = (65535 & (l2 ^= 255 & t2.charCodeAt(u2))) * a2 + (((l2 >>> 16) * a2 & 65535) << 16) & 4294967295) << 15 | l2 >>> 17)) * o2 + (((l2 >>> 16) * o2 & 65535) << 16) & 4294967295;
          }
          return i2 ^= t2.length, i2 = 2246822507 * (65535 & (i2 ^= i2 >>> 16)) + ((2246822507 * (i2 >>> 16) & 65535) << 16) & 4294967295, i2 = 3266489909 * (65535 & (i2 ^= i2 >>> 13)) + ((3266489909 * (i2 >>> 16) & 65535) << 16) & 4294967295, (i2 ^= i2 >>> 16) >>> 0;
        } }, En = { exports: ({}, function(t2, e2) {
          for (var r2, n2 = t2.length, i2 = e2 ^ n2, s2 = 0; n2 >= 4; )
            r2 = 1540483477 * (65535 & (r2 = 255 & t2.charCodeAt(s2) | (255 & t2.charCodeAt(++s2)) << 8 | (255 & t2.charCodeAt(++s2)) << 16 | (255 & t2.charCodeAt(++s2)) << 24)) + ((1540483477 * (r2 >>> 16) & 65535) << 16), i2 = 1540483477 * (65535 & i2) + ((1540483477 * (i2 >>> 16) & 65535) << 16) ^ (r2 = 1540483477 * (65535 & (r2 ^= r2 >>> 24)) + ((1540483477 * (r2 >>> 16) & 65535) << 16)), n2 -= 4, ++s2;
          switch (n2) {
            case 3:
              i2 ^= (255 & t2.charCodeAt(s2 + 2)) << 16;
            case 2:
              i2 ^= (255 & t2.charCodeAt(s2 + 1)) << 8;
            case 1:
              i2 = 1540483477 * (65535 & (i2 ^= 255 & t2.charCodeAt(s2))) + ((1540483477 * (i2 >>> 16) & 65535) << 16);
          }
          return i2 = 1540483477 * (65535 & (i2 ^= i2 >>> 13)) + ((1540483477 * (i2 >>> 16) & 65535) << 16), (i2 ^= i2 >>> 15) >>> 0;
        }) }, Bn = zn.exports, Dn = En.exports;
        Pn.exports = Bn, Pn.exports.murmur3 = Bn, Pn.exports.murmur2 = Dn;
        var Rn = p(Pn.exports);
        class Cn {
          constructor(t2, ...e2) {
            rr(this, e2[0] || {}), this.type = t2;
          }
        }
        class Ln extends Cn {
          constructor(t2, e2 = {}) {
            super("error", rr({ error: t2 }, e2));
          }
        }
        function Vn(t2, e2, r2) {
          r2[t2] && -1 !== r2[t2].indexOf(e2) || (r2[t2] = r2[t2] || [], r2[t2].push(e2));
        }
        function Fn(t2, e2, r2) {
          if (r2 && r2[t2]) {
            const n2 = r2[t2].indexOf(e2);
            -1 !== n2 && r2[t2].splice(n2, 1);
          }
        }
        class On {
          on(t2, e2) {
            return this._listeners = this._listeners || {}, Vn(t2, e2, this._listeners), this;
          }
          off(t2, e2) {
            return Fn(t2, e2, this._listeners), Fn(t2, e2, this._oneTimeListeners), this;
          }
          once(t2, e2) {
            return e2 ? (this._oneTimeListeners = this._oneTimeListeners || {}, Vn(t2, e2, this._oneTimeListeners), this) : new Promise((e3) => this.once(t2, e3));
          }
          fire(t2, e2) {
            const r2 = "string" == typeof t2 ? new Cn(t2, e2) : t2, n2 = r2.type;
            if (this.listens(n2)) {
              r2.target = this;
              const t3 = this._listeners && this._listeners[n2] ? this._listeners[n2].slice() : [];
              for (const e4 of t3)
                e4.call(this, r2);
              const e3 = this._oneTimeListeners && this._oneTimeListeners[n2] ? this._oneTimeListeners[n2].slice() : [];
              for (const t4 of e3)
                Fn(n2, t4, this._oneTimeListeners), t4.call(this, r2);
              const i2 = this._eventedParent;
              i2 && (rr(r2, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i2.fire(r2));
            } else
              r2 instanceof Ln && console.error(r2.error);
            return this;
          }
          listens(t2) {
            return !!(this._listeners && this._listeners[t2] && this._listeners[t2].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t2] && this._oneTimeListeners[t2].length > 0 || this._eventedParent && this._eventedParent.listens(t2));
          }
          setEventedParent(t2, e2) {
            return this._eventedParent = t2, this._eventedParentData = e2, this;
          }
        }
        t.G = void 0;
        var Un = { transparent: [0, 0, 0, 0], aliceblue: [240, 248, 255, 1], antiquewhite: [250, 235, 215, 1], aqua: [0, 255, 255, 1], aquamarine: [127, 255, 212, 1], azure: [240, 255, 255, 1], beige: [245, 245, 220, 1], bisque: [255, 228, 196, 1], black: [0, 0, 0, 1], blanchedalmond: [255, 235, 205, 1], blue: [0, 0, 255, 1], blueviolet: [138, 43, 226, 1], brown: [165, 42, 42, 1], burlywood: [222, 184, 135, 1], cadetblue: [95, 158, 160, 1], chartreuse: [127, 255, 0, 1], chocolate: [210, 105, 30, 1], coral: [255, 127, 80, 1], cornflowerblue: [100, 149, 237, 1], cornsilk: [255, 248, 220, 1], crimson: [220, 20, 60, 1], cyan: [0, 255, 255, 1], darkblue: [0, 0, 139, 1], darkcyan: [0, 139, 139, 1], darkgoldenrod: [184, 134, 11, 1], darkgray: [169, 169, 169, 1], darkgreen: [0, 100, 0, 1], darkgrey: [169, 169, 169, 1], darkkhaki: [189, 183, 107, 1], darkmagenta: [139, 0, 139, 1], darkolivegreen: [85, 107, 47, 1], darkorange: [255, 140, 0, 1], darkorchid: [153, 50, 204, 1], darkred: [139, 0, 0, 1], darksalmon: [233, 150, 122, 1], darkseagreen: [143, 188, 143, 1], darkslateblue: [72, 61, 139, 1], darkslategray: [47, 79, 79, 1], darkslategrey: [47, 79, 79, 1], darkturquoise: [0, 206, 209, 1], darkviolet: [148, 0, 211, 1], deeppink: [255, 20, 147, 1], deepskyblue: [0, 191, 255, 1], dimgray: [105, 105, 105, 1], dimgrey: [105, 105, 105, 1], dodgerblue: [30, 144, 255, 1], firebrick: [178, 34, 34, 1], floralwhite: [255, 250, 240, 1], forestgreen: [34, 139, 34, 1], fuchsia: [255, 0, 255, 1], gainsboro: [220, 220, 220, 1], ghostwhite: [248, 248, 255, 1], gold: [255, 215, 0, 1], goldenrod: [218, 165, 32, 1], gray: [128, 128, 128, 1], green: [0, 128, 0, 1], greenyellow: [173, 255, 47, 1], grey: [128, 128, 128, 1], honeydew: [240, 255, 240, 1], hotpink: [255, 105, 180, 1], indianred: [205, 92, 92, 1], indigo: [75, 0, 130, 1], ivory: [255, 255, 240, 1], khaki: [240, 230, 140, 1], lavender: [230, 230, 250, 1], lavenderblush: [255, 240, 245, 1], lawngreen: [124, 252, 0, 1], lemonchiffon: [255, 250, 205, 1], lightblue: [173, 216, 230, 1], lightcoral: [240, 128, 128, 1], lightcyan: [224, 255, 255, 1], lightgoldenrodyellow: [250, 250, 210, 1], lightgray: [211, 211, 211, 1], lightgreen: [144, 238, 144, 1], lightgrey: [211, 211, 211, 1], lightpink: [255, 182, 193, 1], lightsalmon: [255, 160, 122, 1], lightseagreen: [32, 178, 170, 1], lightskyblue: [135, 206, 250, 1], lightslategray: [119, 136, 153, 1], lightslategrey: [119, 136, 153, 1], lightsteelblue: [176, 196, 222, 1], lightyellow: [255, 255, 224, 1], lime: [0, 255, 0, 1], limegreen: [50, 205, 50, 1], linen: [250, 240, 230, 1], magenta: [255, 0, 255, 1], maroon: [128, 0, 0, 1], mediumaquamarine: [102, 205, 170, 1], mediumblue: [0, 0, 205, 1], mediumorchid: [186, 85, 211, 1], mediumpurple: [147, 112, 219, 1], mediumseagreen: [60, 179, 113, 1], mediumslateblue: [123, 104, 238, 1], mediumspringgreen: [0, 250, 154, 1], mediumturquoise: [72, 209, 204, 1], mediumvioletred: [199, 21, 133, 1], midnightblue: [25, 25, 112, 1], mintcream: [245, 255, 250, 1], mistyrose: [255, 228, 225, 1], moccasin: [255, 228, 181, 1], navajowhite: [255, 222, 173, 1], navy: [0, 0, 128, 1], oldlace: [253, 245, 230, 1], olive: [128, 128, 0, 1], olivedrab: [107, 142, 35, 1], orange: [255, 165, 0, 1], orangered: [255, 69, 0, 1], orchid: [218, 112, 214, 1], palegoldenrod: [238, 232, 170, 1], palegreen: [152, 251, 152, 1], paleturquoise: [175, 238, 238, 1], palevioletred: [219, 112, 147, 1], papayawhip: [255, 239, 213, 1], peachpuff: [255, 218, 185, 1], peru: [205, 133, 63, 1], pink: [255, 192, 203, 1], plum: [221, 160, 221, 1], powderblue: [176, 224, 230, 1], purple: [128, 0, 128, 1], rebeccapurple: [102, 51, 153, 1], red: [255, 0, 0, 1], rosybrown: [188, 143, 143, 1], royalblue: [65, 105, 225, 1], saddlebrown: [139, 69, 19, 1], salmon: [250, 128, 114, 1], sandybrown: [244, 164, 96, 1], seagreen: [46, 139, 87, 1], seashell: [255, 245, 238, 1], sienna: [160, 82, 45, 1], silver: [192, 192, 192, 1], skyblue: [135, 206, 235, 1], slateblue: [106, 90, 205, 1], slategray: [112, 128, 144, 1], slategrey: [112, 128, 144, 1], snow: [255, 250, 250, 1], springgreen: [0, 255, 127, 1], steelblue: [70, 130, 180, 1], tan: [210, 180, 140, 1], teal: [0, 128, 128, 1], thistle: [216, 191, 216, 1], tomato: [255, 99, 71, 1], turquoise: [64, 224, 208, 1], violet: [238, 130, 238, 1], wheat: [245, 222, 179, 1], white: [255, 255, 255, 1], whitesmoke: [245, 245, 245, 1], yellow: [255, 255, 0, 1], yellowgreen: [154, 205, 50, 1] };
        function jn(t2) {
          return (t2 = Math.round(t2)) < 0 ? 0 : t2 > 255 ? 255 : t2;
        }
        function Nn(t2) {
          return jn("%" === t2[t2.length - 1] ? parseFloat(t2) / 100 * 255 : parseInt(t2));
        }
        function $n(t2) {
          return (e2 = "%" === t2[t2.length - 1] ? parseFloat(t2) / 100 : parseFloat(t2)) < 0 ? 0 : e2 > 1 ? 1 : e2;
          var e2;
        }
        function qn(t2, e2, r2) {
          return r2 < 0 ? r2 += 1 : r2 > 1 && (r2 -= 1), 6 * r2 < 1 ? t2 + (e2 - t2) * r2 * 6 : 2 * r2 < 1 ? e2 : 3 * r2 < 2 ? t2 + (e2 - t2) * (2 / 3 - r2) * 6 : t2;
        }
        try {
          t.G = {}.parseCSSColor = function(t2) {
            var e2, r2 = t2.replace(/ /g, "").toLowerCase();
            if (r2 in Un)
              return Un[r2].slice();
            if ("#" === r2[0])
              return 4 === r2.length ? (e2 = parseInt(r2.substr(1), 16)) >= 0 && e2 <= 4095 ? [(3840 & e2) >> 4 | (3840 & e2) >> 8, 240 & e2 | (240 & e2) >> 4, 15 & e2 | (15 & e2) << 4, 1] : null : 7 === r2.length && (e2 = parseInt(r2.substr(1), 16)) >= 0 && e2 <= 16777215 ? [(16711680 & e2) >> 16, (65280 & e2) >> 8, 255 & e2, 1] : null;
            var n2 = r2.indexOf("("), i2 = r2.indexOf(")");
            if (-1 !== n2 && i2 + 1 === r2.length) {
              var s2 = r2.substr(0, n2), a2 = r2.substr(n2 + 1, i2 - (n2 + 1)).split(","), o2 = 1;
              switch (s2) {
                case "rgba":
                  if (4 !== a2.length)
                    return null;
                  o2 = $n(a2.pop());
                case "rgb":
                  return 3 !== a2.length ? null : [Nn(a2[0]), Nn(a2[1]), Nn(a2[2]), o2];
                case "hsla":
                  if (4 !== a2.length)
                    return null;
                  o2 = $n(a2.pop());
                case "hsl":
                  if (3 !== a2.length)
                    return null;
                  var l2 = (parseFloat(a2[0]) % 360 + 360) % 360 / 360, u2 = $n(a2[1]), c2 = $n(a2[2]), h2 = c2 <= 0.5 ? c2 * (u2 + 1) : c2 + u2 - c2 * u2, p2 = 2 * c2 - h2;
                  return [jn(255 * qn(p2, h2, l2 + 1 / 3)), jn(255 * qn(p2, h2, l2)), jn(255 * qn(p2, h2, l2 - 1 / 3)), o2];
                default:
                  return null;
              }
            }
            return null;
          };
        } catch (t2) {
        }
        class Gn {
          constructor(t2, e2, r2, n2 = 1) {
            this.r = t2, this.g = e2, this.b = r2, this.a = n2;
          }
          static parse(e2) {
            if (!e2)
              return;
            if (e2 instanceof Gn)
              return e2;
            if ("string" != typeof e2)
              return;
            const r2 = t.G(e2);
            return r2 ? new Gn(r2[0] / 255 * r2[3], r2[1] / 255 * r2[3], r2[2] / 255 * r2[3], r2[3]) : void 0;
          }
          toString() {
            const [t2, e2, r2, n2] = 0 === this.a ? [0, 0, 0, 0] : [255 * this.r / this.a, 255 * this.g / this.a, 255 * this.b / this.a, this.a];
            return `rgba(${Math.round(t2)},${Math.round(e2)},${Math.round(r2)},${n2})`;
          }
          toRenderColor(t2) {
            const { r: e2, g: r2, b: n2, a: i2 } = this;
            return new Xn(t2, e2, r2, n2, i2);
          }
        }
        class Xn {
          constructor(t2, e2, r2, n2, i2) {
            if (t2) {
              const s2 = t2.image.height, a2 = s2 * s2;
              e2 = 0 === i2 ? 0 : e2 / i2 * (s2 - 1), r2 = 0 === i2 ? 0 : r2 / i2 * (s2 - 1), n2 = 0 === i2 ? 0 : n2 / i2 * (s2 - 1);
              const o2 = Math.floor(e2), l2 = Math.floor(r2), u2 = Math.floor(n2), c2 = Math.ceil(e2), h2 = Math.ceil(r2), p2 = Math.ceil(n2), f2 = e2 - o2, d2 = r2 - l2, m2 = n2 - u2, y2 = t2.image.data, g2 = 4 * (o2 + l2 * a2 + u2 * s2), x2 = 4 * (o2 + l2 * a2 + p2 * s2), b2 = 4 * (o2 + h2 * a2 + u2 * s2), v2 = 4 * (o2 + h2 * a2 + p2 * s2), _2 = 4 * (c2 + l2 * a2 + u2 * s2), w2 = 4 * (c2 + l2 * a2 + p2 * s2), M2 = 4 * (c2 + h2 * a2 + u2 * s2), A2 = 4 * (c2 + h2 * a2 + p2 * s2);
              if (g2 < 0 || A2 >= y2.length)
                throw new Error("out of range");
              this.r = Yn(Yn(Yn(y2[g2], y2[x2], m2), Yn(y2[b2], y2[v2], m2), d2), Yn(Yn(y2[_2], y2[w2], m2), Yn(y2[M2], y2[A2], m2), d2), f2) / 255 * i2, this.g = Yn(Yn(Yn(y2[g2 + 1], y2[x2 + 1], m2), Yn(y2[b2 + 1], y2[v2 + 1], m2), d2), Yn(Yn(y2[_2 + 1], y2[w2 + 1], m2), Yn(y2[M2 + 1], y2[A2 + 1], m2), d2), f2) / 255 * i2, this.b = Yn(Yn(Yn(y2[g2 + 2], y2[x2 + 2], m2), Yn(y2[b2 + 2], y2[v2 + 2], m2), d2), Yn(Yn(y2[_2 + 2], y2[w2 + 2], m2), Yn(y2[M2 + 2], y2[A2 + 2], m2), d2), f2) / 255 * i2, this.a = i2;
            } else
              this.r = e2, this.g = r2, this.b = n2, this.a = i2;
          }
          toArray() {
            const { r: t2, g: e2, b: r2, a: n2 } = this;
            return 0 === n2 ? [0, 0, 0, 0] : [255 * t2 / n2, 255 * e2 / n2, 255 * r2 / n2, n2];
          }
          toArray01() {
            const { r: t2, g: e2, b: r2, a: n2 } = this;
            return 0 === n2 ? [0, 0, 0, 0] : [t2 / n2, e2 / n2, r2 / n2, n2];
          }
          toArray01Scaled(t2) {
            const { r: e2, g: r2, b: n2, a: i2 } = this;
            return 0 === i2 ? [0, 0, 0] : [e2 / i2 * t2, r2 / i2 * t2, n2 / i2 * t2];
          }
          toArray01PremultipliedAlpha() {
            const { r: t2, g: e2, b: r2, a: n2 } = this;
            return [t2, e2, r2, n2];
          }
          toArray01Linear() {
            const { r: t2, g: e2, b: r2, a: n2 } = this;
            return 0 === n2 ? [0, 0, 0, 0] : [Math.pow(t2 / n2, 2.2), Math.pow(e2 / n2, 2.2), Math.pow(r2 / n2, 2.2), n2];
          }
        }
        function Yn(t2, e2, r2) {
          return t2 * (1 - r2) + e2 * r2;
        }
        function Zn(t2, e2, r2) {
          return t2.map((t3, n2) => Yn(t3, e2[n2], r2));
        }
        Gn.black = new Gn(0, 0, 0, 1), Gn.white = new Gn(1, 1, 1, 1), Gn.transparent = new Gn(0, 0, 0, 0), Gn.red = new Gn(1, 0, 0, 1), Gn.blue = new Gn(0, 0, 1, 1);
        var Hn = Object.freeze({ __proto__: null, array: Zn, color: function(t2, e2, r2) {
          return new Gn(Yn(t2.r, e2.r, r2), Yn(t2.g, e2.g, r2), Yn(t2.b, e2.b, r2), Yn(t2.a, e2.a, r2));
        }, number: Yn });
        function Kn(t2, ...e2) {
          for (const r2 of e2)
            for (const e3 in r2)
              t2[e3] = r2[e3];
          return t2;
        }
        class Wn extends Error {
          constructor(t2, e2) {
            super(e2), this.message = e2, this.key = t2;
          }
        }
        class Jn {
          constructor(t2, e2 = []) {
            this.parent = t2, this.bindings = {};
            for (const [t3, r2] of e2)
              this.bindings[t3] = r2;
          }
          concat(t2) {
            return new Jn(this, t2);
          }
          get(t2) {
            if (this.bindings[t2])
              return this.bindings[t2];
            if (this.parent)
              return this.parent.get(t2);
            throw new Error(`${t2} not found in scope.`);
          }
          has(t2) {
            return !!this.bindings[t2] || !!this.parent && this.parent.has(t2);
          }
        }
        const Qn = { kind: "null" }, ti = { kind: "number" }, ei = { kind: "string" }, ri = { kind: "boolean" }, ni = { kind: "color" }, ii = { kind: "object" }, si = { kind: "value" }, ai = { kind: "collator" }, oi = { kind: "formatted" }, li = { kind: "resolvedImage" };
        function ui(t2, e2) {
          return { kind: "array", itemType: t2, N: e2 };
        }
        function ci(t2) {
          if ("array" === t2.kind) {
            const e2 = ci(t2.itemType);
            return "number" == typeof t2.N ? `array<${e2}, ${t2.N}>` : "value" === t2.itemType.kind ? "array" : `array<${e2}>`;
          }
          return t2.kind;
        }
        const hi = [Qn, ti, ei, ri, ni, oi, ii, ui(si), li];
        function pi(t2, e2) {
          if ("error" === e2.kind)
            return null;
          if ("array" === t2.kind) {
            if ("array" === e2.kind && (0 === e2.N && "value" === e2.itemType.kind || !pi(t2.itemType, e2.itemType)) && ("number" != typeof t2.N || t2.N === e2.N))
              return null;
          } else {
            if (t2.kind === e2.kind)
              return null;
            if ("value" === t2.kind) {
              for (const t3 of hi)
                if (!pi(t3, e2))
                  return null;
            }
          }
          return `Expected ${ci(t2)} but found ${ci(e2)} instead.`;
        }
        function fi(t2, e2) {
          return e2.some((e3) => e3.kind === t2.kind);
        }
        function di(t2, e2) {
          return e2.some((e3) => "null" === e3 ? null === t2 : "array" === e3 ? Array.isArray(t2) : "object" === e3 ? t2 && !Array.isArray(t2) && "object" == typeof t2 : e3 === typeof t2);
        }
        class mi {
          constructor(t2, e2, r2) {
            this.sensitivity = t2 ? e2 ? "variant" : "case" : e2 ? "accent" : "base", this.locale = r2, this.collator = new Intl.Collator(this.locale ? this.locale : [], { sensitivity: this.sensitivity, usage: "search" });
          }
          compare(t2, e2) {
            return this.collator.compare(t2, e2);
          }
          resolvedLocale() {
            return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
          }
        }
        class yi {
          constructor(t2, e2, r2, n2, i2) {
            this.text = t2.normalize ? t2.normalize() : t2, this.image = e2, this.scale = r2, this.fontStack = n2, this.textColor = i2;
          }
        }
        class gi {
          constructor(t2) {
            this.sections = t2;
          }
          static fromString(t2) {
            return new gi([new yi(t2, null, null, null, null)]);
          }
          isEmpty() {
            return 0 === this.sections.length || !this.sections.some((t2) => 0 !== t2.text.length || t2.image && 0 !== t2.image.namePrimary.length);
          }
          static factory(t2) {
            return t2 instanceof gi ? t2 : gi.fromString(t2);
          }
          toString() {
            return 0 === this.sections.length ? "" : this.sections.map((t2) => t2.text).join("");
          }
          serialize() {
            const t2 = ["format"];
            for (const e2 of this.sections) {
              if (e2.image) {
                t2.push(["image", e2.image.namePrimary]);
                continue;
              }
              t2.push(e2.text);
              const r2 = {};
              e2.fontStack && (r2["text-font"] = ["literal", e2.fontStack.split(",")]), e2.scale && (r2["font-scale"] = e2.scale), e2.textColor && (r2["text-color"] = ["rgba"].concat(e2.textColor.toRenderColor(null).toArray())), t2.push(r2);
            }
            return t2;
          }
        }
        class xi {
          constructor(t2) {
            this.namePrimary = t2.namePrimary, t2.nameSecondary && (this.nameSecondary = t2.nameSecondary), this.available = t2.available;
          }
          toString() {
            return this.nameSecondary ? `[${this.namePrimary},${this.nameSecondary}]` : this.namePrimary;
          }
          static fromString(t2, e2) {
            return t2 ? new xi({ namePrimary: t2, nameSecondary: e2, available: false }) : null;
          }
          serialize() {
            return this.nameSecondary ? ["image", this.namePrimary, this.nameSecondary] : ["image", this.namePrimary];
          }
        }
        function bi(t2, e2, r2, n2) {
          return "number" == typeof t2 && t2 >= 0 && t2 <= 255 && "number" == typeof e2 && e2 >= 0 && e2 <= 255 && "number" == typeof r2 && r2 >= 0 && r2 <= 255 ? void 0 === n2 || "number" == typeof n2 && n2 >= 0 && n2 <= 1 ? null : `Invalid rgba value [${[t2, e2, r2, n2].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n2 ? [t2, e2, r2, n2] : [t2, e2, r2]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function vi(t2) {
          if (null === t2)
            return true;
          if ("string" == typeof t2)
            return true;
          if ("boolean" == typeof t2)
            return true;
          if ("number" == typeof t2)
            return true;
          if (t2 instanceof Gn)
            return true;
          if (t2 instanceof mi)
            return true;
          if (t2 instanceof gi)
            return true;
          if (t2 instanceof xi)
            return true;
          if (Array.isArray(t2)) {
            for (const e2 of t2)
              if (!vi(e2))
                return false;
            return true;
          }
          if ("object" == typeof t2) {
            for (const e2 in t2)
              if (!vi(t2[e2]))
                return false;
            return true;
          }
          return false;
        }
        function _i(t2) {
          if (null === t2)
            return Qn;
          if ("string" == typeof t2)
            return ei;
          if ("boolean" == typeof t2)
            return ri;
          if ("number" == typeof t2)
            return ti;
          if (t2 instanceof Gn)
            return ni;
          if (t2 instanceof mi)
            return ai;
          if (t2 instanceof gi)
            return oi;
          if (t2 instanceof xi)
            return li;
          if (Array.isArray(t2)) {
            const e2 = t2.length;
            let r2;
            for (const e3 of t2) {
              const t3 = _i(e3);
              if (r2) {
                if (r2 === t3)
                  continue;
                r2 = si;
                break;
              }
              r2 = t3;
            }
            return ui(r2 || si, e2);
          }
          return ii;
        }
        function wi(t2) {
          const e2 = typeof t2;
          return null === t2 ? "" : "string" === e2 || "number" === e2 || "boolean" === e2 ? String(t2) : t2 instanceof Gn || t2 instanceof gi || t2 instanceof xi ? t2.toString() : JSON.stringify(t2);
        }
        class Mi {
          constructor(t2, e2) {
            this.type = t2, this.value = e2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length)
              return e2.error(`'literal' expression requires exactly one argument, but found ${t2.length - 1} instead.`);
            if (!vi(t2[1]))
              return e2.error("invalid value");
            const r2 = t2[1];
            let n2 = _i(r2);
            const i2 = e2.expectedType;
            return "array" !== n2.kind || 0 !== n2.N || !i2 || "array" !== i2.kind || "number" == typeof i2.N && 0 !== i2.N || (n2 = i2), new Mi(n2, r2);
          }
          evaluate() {
            return this.value;
          }
          eachChild() {
          }
          outputDefined() {
            return true;
          }
          serialize() {
            return "array" === this.type.kind || "object" === this.type.kind ? ["literal", this.value] : this.value instanceof Gn ? ["rgba"].concat(this.value.toRenderColor(null).toArray()) : this.value instanceof gi ? this.value.serialize() : this.value;
          }
        }
        class Ai {
          constructor(t2) {
            this.name = "ExpressionEvaluationError", this.message = t2;
          }
          toJSON() {
            return this.message;
          }
        }
        const Si = { string: ei, number: ti, boolean: ri, object: ii };
        class Ii {
          constructor(t2, e2) {
            this.type = t2, this.args = e2;
          }
          static parse(t2, e2) {
            if (t2.length < 2)
              return e2.error("Expected at least one argument.");
            let r2, n2 = 1;
            const i2 = t2[0];
            if ("array" === i2) {
              let i3, s3;
              if (t2.length > 2) {
                const r3 = t2[1];
                if ("string" != typeof r3 || !(r3 in Si) || "object" === r3)
                  return e2.error('The item type argument of "array" must be one of string, number, boolean', 1);
                i3 = Si[r3], n2++;
              } else
                i3 = si;
              if (t2.length > 3) {
                if (null !== t2[2] && ("number" != typeof t2[2] || t2[2] < 0 || t2[2] !== Math.floor(t2[2])))
                  return e2.error('The length argument to "array" must be a positive integer literal', 2);
                s3 = t2[2], n2++;
              }
              r2 = ui(i3, s3);
            } else
              r2 = Si[i2];
            const s2 = [];
            for (; n2 < t2.length; n2++) {
              const r3 = e2.parse(t2[n2], n2, si);
              if (!r3)
                return null;
              s2.push(r3);
            }
            return new Ii(r2, s2);
          }
          evaluate(t2) {
            for (let e2 = 0; e2 < this.args.length; e2++) {
              const r2 = this.args[e2].evaluate(t2);
              if (!pi(this.type, _i(r2)))
                return r2;
              if (e2 === this.args.length - 1)
                throw new Ai(`The expression ${JSON.stringify(this.args[e2].serialize())} evaluated to ${ci(_i(r2))} but was expected to be of type ${ci(this.type)}.`);
            }
            return null;
          }
          eachChild(t2) {
            this.args.forEach(t2);
          }
          outputDefined() {
            return this.args.every((t2) => t2.outputDefined());
          }
          serialize() {
            const t2 = this.type, e2 = [t2.kind];
            if ("array" === t2.kind) {
              const r2 = t2.itemType;
              if ("string" === r2.kind || "number" === r2.kind || "boolean" === r2.kind) {
                e2.push(r2.kind);
                const n2 = t2.N;
                ("number" == typeof n2 || this.args.length > 1) && e2.push(n2);
              }
            }
            return e2.concat(this.args.map((t3) => t3.serialize()));
          }
        }
        class Ti {
          constructor(t2) {
            this.type = oi, this.sections = t2;
          }
          static parse(t2, e2) {
            if (t2.length < 2)
              return e2.error("Expected at least one argument.");
            const r2 = t2[1];
            if (!Array.isArray(r2) && "object" == typeof r2)
              return e2.error("First argument must be an image or text section.");
            const n2 = [];
            let i2 = false;
            for (let r3 = 1; r3 <= t2.length - 1; ++r3) {
              const s2 = t2[r3];
              if (i2 && "object" == typeof s2 && !Array.isArray(s2)) {
                i2 = false;
                let t3 = null;
                if (s2["font-scale"] && (t3 = e2.parse(s2["font-scale"], 1, ti), !t3))
                  return null;
                let r4 = null;
                if (s2["text-font"] && (r4 = e2.parse(s2["text-font"], 1, ui(ei)), !r4))
                  return null;
                let a2 = null;
                if (s2["text-color"] && (a2 = e2.parse(s2["text-color"], 1, ni), !a2))
                  return null;
                const o2 = n2[n2.length - 1];
                o2.scale = t3, o2.font = r4, o2.textColor = a2;
              } else {
                const s3 = e2.parse(t2[r3], 1, si);
                if (!s3)
                  return null;
                const a2 = s3.type.kind;
                if ("string" !== a2 && "value" !== a2 && "null" !== a2 && "resolvedImage" !== a2)
                  return e2.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                i2 = true, n2.push({ content: s3, scale: null, font: null, textColor: null });
              }
            }
            return new Ti(n2);
          }
          evaluate(t2) {
            return new gi(this.sections.map((e2) => {
              const r2 = e2.content.evaluate(t2);
              return _i(r2) === li ? new yi("", r2, null, null, null) : new yi(wi(r2), null, e2.scale ? e2.scale.evaluate(t2) : null, e2.font ? e2.font.evaluate(t2).join(",") : null, e2.textColor ? e2.textColor.evaluate(t2) : null);
            }));
          }
          eachChild(t2) {
            for (const e2 of this.sections)
              t2(e2.content), e2.scale && t2(e2.scale), e2.font && t2(e2.font), e2.textColor && t2(e2.textColor);
          }
          outputDefined() {
            return false;
          }
          serialize() {
            const t2 = ["format"];
            for (const e2 of this.sections) {
              t2.push(e2.content.serialize());
              const r2 = {};
              e2.scale && (r2["font-scale"] = e2.scale.serialize()), e2.font && (r2["text-font"] = e2.font.serialize()), e2.textColor && (r2["text-color"] = e2.textColor.serialize()), t2.push(r2);
            }
            return t2;
          }
        }
        class ki {
          constructor(t2, e2) {
            this.type = li, this.inputPrimary = t2, this.inputSecondary = e2;
          }
          static parse(t2, e2) {
            if (t2.length < 2)
              return e2.error("Expected two or more arguments.");
            const r2 = e2.parse(t2[1], 1, ei);
            if (!r2)
              return e2.error("No image name provided.");
            if (2 === t2.length)
              return new ki(r2);
            const n2 = e2.parse(t2[2], 1, ei);
            return n2 ? new ki(r2, n2) : e2.error("Secondary image variant is not a string.");
          }
          evaluate(t2) {
            const e2 = xi.fromString(this.inputPrimary.evaluate(t2), this.inputSecondary ? this.inputSecondary.evaluate(t2) : void 0);
            return e2 && t2.availableImages && (e2.available = t2.availableImages.indexOf(e2.namePrimary) > -1, e2.nameSecondary && e2.available && t2.availableImages && (e2.available = t2.availableImages.indexOf(e2.nameSecondary) > -1)), e2;
          }
          eachChild(t2) {
            t2(this.inputPrimary), this.inputSecondary && t2(this.inputSecondary);
          }
          outputDefined() {
            return false;
          }
          serialize() {
            return this.inputSecondary ? ["image", this.inputPrimary.serialize(), this.inputSecondary.serialize()] : ["image", this.inputPrimary.serialize()];
          }
        }
        function Pi(t2) {
          return t2 instanceof Number ? "number" : t2 instanceof String ? "string" : t2 instanceof Boolean ? "boolean" : Array.isArray(t2) ? "array" : null === t2 ? "null" : typeof t2;
        }
        const zi = { "to-boolean": ri, "to-color": ni, "to-number": ti, "to-string": ei };
        class Ei {
          constructor(t2, e2) {
            this.type = t2, this.args = e2;
          }
          static parse(t2, e2) {
            if (t2.length < 2)
              return e2.error("Expected at least one argument.");
            const r2 = t2[0], n2 = [];
            let i2 = Qn;
            if ("to-array" === r2) {
              if (!Array.isArray(t2[1]))
                return null;
              const r3 = t2[1].length;
              if (e2.expectedType) {
                if ("array" !== e2.expectedType.kind)
                  return e2.error(`Expected ${e2.expectedType.kind} but found array.`);
                i2 = ui(e2.expectedType.itemType, r3);
              } else {
                if (!(r3 > 0 && vi(t2[1][0])))
                  return null;
                i2 = ui(_i(t2[1][0]), r3);
              }
              for (let s2 = 0; s2 < r3; s2++) {
                const r4 = t2[1][s2];
                let a2;
                if ("array" === Pi(r4))
                  a2 = e2.parse(r4, void 0, i2.itemType);
                else {
                  const t3 = Pi(r4);
                  if (t3 !== i2.itemType.kind)
                    return e2.error(`Expected ${i2.itemType.kind} but found ${t3}.`);
                  a2 = e2.registry.literal.parse(["literal", void 0 === r4 ? null : r4], e2);
                }
                if (!a2)
                  return null;
                n2.push(a2);
              }
            } else {
              if (("to-boolean" === r2 || "to-string" === r2) && 2 !== t2.length)
                return e2.error("Expected one argument.");
              i2 = zi[r2];
              for (let r3 = 1; r3 < t2.length; r3++) {
                const i3 = e2.parse(t2[r3], r3, si);
                if (!i3)
                  return null;
                n2.push(i3);
              }
            }
            return new Ei(i2, n2);
          }
          evaluate(t2) {
            if ("boolean" === this.type.kind)
              return Boolean(this.args[0].evaluate(t2));
            if ("color" === this.type.kind) {
              let e2, r2;
              for (const n2 of this.args) {
                if (e2 = n2.evaluate(t2), r2 = null, e2 instanceof Gn)
                  return e2;
                if ("string" == typeof e2) {
                  const r3 = t2.parseColor(e2);
                  if (r3)
                    return r3;
                } else if (Array.isArray(e2) && (r2 = e2.length < 3 || e2.length > 4 ? `Invalid rbga value ${JSON.stringify(e2)}: expected an array containing either three or four numeric values.` : bi(e2[0], e2[1], e2[2], e2[3]), !r2))
                  return new Gn(e2[0] / 255, e2[1] / 255, e2[2] / 255, e2[3]);
              }
              throw new Ai(r2 || `Could not parse color from value '${"string" == typeof e2 ? e2 : String(JSON.stringify(e2))}'`);
            }
            if ("number" === this.type.kind) {
              let e2 = null;
              for (const r2 of this.args) {
                if (e2 = r2.evaluate(t2), null === e2)
                  return 0;
                const n2 = Number(e2);
                if (!isNaN(n2))
                  return n2;
              }
              throw new Ai(`Could not convert ${JSON.stringify(e2)} to number.`);
            }
            return "formatted" === this.type.kind ? gi.fromString(wi(this.args[0].evaluate(t2))) : "resolvedImage" === this.type.kind ? xi.fromString(wi(this.args[0].evaluate(t2))) : "array" === this.type.kind ? this.args.map((e2) => e2.evaluate(t2)) : wi(this.args[0].evaluate(t2));
          }
          eachChild(t2) {
            this.args.forEach(t2);
          }
          outputDefined() {
            return this.args.every((t2) => t2.outputDefined());
          }
          serialize() {
            if ("formatted" === this.type.kind)
              return new Ti([{ content: this.args[0], scale: null, font: null, textColor: null }]).serialize();
            if ("resolvedImage" === this.type.kind)
              return new ki(this.args[0]).serialize();
            const t2 = "array" === this.type.kind ? [] : [`to-${this.type.kind}`];
            return this.eachChild((e2) => {
              t2.push(e2.serialize());
            }), t2;
          }
        }
        const Bi = ["Unknown", "Point", "LineString", "Polygon"];
        class Di {
          constructor(t2, e2) {
            this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.scope = t2, this.options = e2;
          }
          id() {
            return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
          }
          geometryType() {
            return this.feature ? "number" == typeof this.feature.type ? Bi[this.feature.type] : this.feature.type : null;
          }
          geometry() {
            return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
          }
          canonicalID() {
            return this.canonical;
          }
          properties() {
            return this.feature && this.feature.properties || {};
          }
          measureLight(t2) {
            return this.globals.brightness || 0;
          }
          distanceFromCenter() {
            if (this.featureTileCoord && this.featureDistanceData) {
              const t2 = this.featureDistanceData.center, e2 = this.featureDistanceData.scale, { x: r2, y: n2 } = this.featureTileCoord;
              return this.featureDistanceData.bearing[0] * (r2 * e2 - t2[0]) + this.featureDistanceData.bearing[1] * (n2 * e2 - t2[1]);
            }
            return 0;
          }
          parseColor(t2) {
            let e2 = this._parseColorCache[t2];
            return e2 || (e2 = this._parseColorCache[t2] = Gn.parse(t2)), e2;
          }
          getConfig(t2) {
            return this.options ? this.options.get(t2) : null;
          }
        }
        class Ri {
          constructor(t2, e2, r2, n2, i2) {
            this.name = t2, this.type = e2, this._evaluate = r2, this.args = n2, this._overloadIndex = i2;
          }
          evaluate(t2) {
            if (!this._evaluate) {
              const t3 = Ri.definitions[this.name];
              this._evaluate = Array.isArray(t3) ? t3[2] : t3.overloads[this._overloadIndex][1];
            }
            return this._evaluate(t2, this.args);
          }
          eachChild(t2) {
            this.args.forEach(t2);
          }
          outputDefined() {
            return false;
          }
          serialize() {
            return [this.name].concat(this.args.map((t2) => t2.serialize()));
          }
          static parse(t2, e2) {
            const r2 = t2[0], n2 = Ri.definitions[r2];
            if (!n2)
              return e2.error(`Unknown expression "${r2}". If you wanted a literal array, use ["literal", [...]].`, 0);
            const i2 = Array.isArray(n2) ? n2[0] : n2.type, s2 = Array.isArray(n2) ? [[n2[1], n2[2]]] : n2.overloads, a2 = [];
            let o2 = null, l2 = -1;
            for (const [n3, u2] of s2) {
              if (Array.isArray(n3) && n3.length !== t2.length - 1)
                continue;
              a2.push(n3), l2++, o2 = new ta(e2.registry, e2.path, null, e2.scope, void 0, e2._scope, e2.options);
              const s3 = [];
              let c2 = false;
              for (let e3 = 1; e3 < t2.length; e3++) {
                const r3 = t2[e3], i3 = Array.isArray(n3) ? n3[e3 - 1] : n3.type, a3 = o2.parse(r3, 1 + s3.length, i3);
                if (!a3) {
                  c2 = true;
                  break;
                }
                s3.push(a3);
              }
              if (!c2)
                if (Array.isArray(n3) && n3.length !== s3.length)
                  o2.error(`Expected ${n3.length} arguments, but found ${s3.length} instead.`);
                else {
                  for (let t3 = 0; t3 < s3.length; t3++) {
                    const e3 = Array.isArray(n3) ? n3[t3] : n3.type, r3 = s3[t3];
                    o2.concat(t3 + 1).checkSubtype(e3, r3.type);
                  }
                  if (0 === o2.errors.length)
                    return new Ri(r2, i2, u2, s3, l2);
                }
            }
            if (1 === a2.length)
              e2.errors.push(...o2.errors);
            else {
              const r3 = (a2.length ? a2 : s2.map(([t3]) => t3)).map(Ci).join(" | "), n3 = [];
              for (let r4 = 1; r4 < t2.length; r4++) {
                const i3 = e2.parse(t2[r4], 1 + n3.length);
                if (!i3)
                  return null;
                n3.push(ci(i3.type));
              }
              e2.error(`Expected arguments of type ${r3}, but found (${n3.join(", ")}) instead.`);
            }
            return null;
          }
          static register(t2, e2) {
            Ri.definitions = e2;
            for (const r2 in e2)
              t2[r2] = Ri;
          }
        }
        function Ci(t2) {
          return Array.isArray(t2) ? `(${t2.map(ci).join(", ")})` : `(${ci(t2.type)}...)`;
        }
        class Li {
          constructor(t2, e2, r2) {
            this.type = ai, this.locale = r2, this.caseSensitive = t2, this.diacriticSensitive = e2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length)
              return e2.error("Expected one argument.");
            const r2 = t2[1];
            if ("object" != typeof r2 || Array.isArray(r2))
              return e2.error("Collator options argument must be an object.");
            const n2 = e2.parse(void 0 !== r2["case-sensitive"] && r2["case-sensitive"], 1, ri);
            if (!n2)
              return null;
            const i2 = e2.parse(void 0 !== r2["diacritic-sensitive"] && r2["diacritic-sensitive"], 1, ri);
            if (!i2)
              return null;
            let s2 = null;
            return r2.locale && (s2 = e2.parse(r2.locale, 1, ei), !s2) ? null : new Li(n2, i2, s2);
          }
          evaluate(t2) {
            return new mi(this.caseSensitive.evaluate(t2), this.diacriticSensitive.evaluate(t2), this.locale ? this.locale.evaluate(t2) : null);
          }
          eachChild(t2) {
            t2(this.caseSensitive), t2(this.diacriticSensitive), this.locale && t2(this.locale);
          }
          outputDefined() {
            return false;
          }
          serialize() {
            const t2 = {};
            return t2["case-sensitive"] = this.caseSensitive.serialize(), t2["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t2.locale = this.locale.serialize()), ["collator", t2];
          }
        }
        function Vi(t2, e2, r2 = 0, n2 = t2.length - 1, i2 = Oi) {
          for (; n2 > r2; ) {
            if (n2 - r2 > 600) {
              const s3 = n2 - r2 + 1, a3 = e2 - r2 + 1, o3 = Math.log(s3), l2 = 0.5 * Math.exp(2 * o3 / 3), u2 = 0.5 * Math.sqrt(o3 * l2 * (s3 - l2) / s3) * (a3 - s3 / 2 < 0 ? -1 : 1);
              Vi(t2, e2, Math.max(r2, Math.floor(e2 - a3 * l2 / s3 + u2)), Math.min(n2, Math.floor(e2 + (s3 - a3) * l2 / s3 + u2)), i2);
            }
            const s2 = t2[e2];
            let a2 = r2, o2 = n2;
            for (Fi(t2, r2, e2), i2(t2[n2], s2) > 0 && Fi(t2, r2, n2); a2 < o2; ) {
              for (Fi(t2, a2, o2), a2++, o2--; i2(t2[a2], s2) < 0; )
                a2++;
              for (; i2(t2[o2], s2) > 0; )
                o2--;
            }
            0 === i2(t2[r2], s2) ? Fi(t2, r2, o2) : (o2++, Fi(t2, o2, n2)), o2 <= e2 && (r2 = o2 + 1), e2 <= o2 && (n2 = o2 - 1);
          }
        }
        function Fi(t2, e2, r2) {
          const n2 = t2[e2];
          t2[e2] = t2[r2], t2[r2] = n2;
        }
        function Oi(t2, e2) {
          return t2 < e2 ? -1 : t2 > e2 ? 1 : 0;
        }
        function Ui(t2) {
          let e2 = 0;
          for (let r2, n2, i2 = 0, s2 = t2.length, a2 = s2 - 1; i2 < s2; a2 = i2++)
            r2 = t2[i2], n2 = t2[a2], e2 += (n2.x - r2.x) * (r2.y + n2.y);
          return e2;
        }
        function ji(t2, e2) {
          t2[0] = Math.min(t2[0], e2[0]), t2[1] = Math.min(t2[1], e2[1]), t2[2] = Math.max(t2[2], e2[0]), t2[3] = Math.max(t2[3], e2[1]);
        }
        function Ni(t2, e2) {
          return !(t2[0] <= e2[0] || t2[2] >= e2[2] || t2[1] <= e2[1] || t2[3] >= e2[3]);
        }
        function $i(t2, e2, r2) {
          const n2 = t2[0] - e2[0], i2 = t2[1] - e2[1], s2 = t2[0] - r2[0], a2 = t2[1] - r2[1];
          return n2 * a2 - s2 * i2 == 0 && n2 * s2 <= 0 && i2 * a2 <= 0;
        }
        function qi(t2, e2, r2 = false) {
          let n2 = false;
          for (let o2 = 0, l2 = e2.length; o2 < l2; o2++) {
            const l3 = e2[o2];
            for (let e3 = 0, o3 = l3.length, u2 = o3 - 1; e3 < o3; u2 = e3++) {
              const o4 = l3[u2], c2 = l3[e3];
              if ($i(t2, o4, c2))
                return r2;
              (s2 = o4)[1] > (i2 = t2)[1] != (a2 = c2)[1] > i2[1] && i2[0] < (a2[0] - s2[0]) * (i2[1] - s2[1]) / (a2[1] - s2[1]) + s2[0] && (n2 = !n2);
            }
          }
          var i2, s2, a2;
          return n2;
        }
        function Gi(t2, e2, r2, n2) {
          const i2 = n2[0] - r2[0], s2 = n2[1] - r2[1], a2 = (t2[0] - r2[0]) * s2 - i2 * (t2[1] - r2[1]), o2 = (e2[0] - r2[0]) * s2 - i2 * (e2[1] - r2[1]);
          return a2 > 0 && o2 < 0 || a2 < 0 && o2 > 0;
        }
        function Xi(t2, e2, r2, n2) {
          return 0 != (i2 = [n2[0] - r2[0], n2[1] - r2[1]])[0] * (s2 = [e2[0] - t2[0], e2[1] - t2[1]])[1] - i2[1] * s2[0] && !(!Gi(t2, e2, r2, n2) || !Gi(r2, n2, t2, e2));
          var i2, s2;
        }
        const Yi = 8192;
        function Zi(t2, e2) {
          const r2 = (180 + t2[0]) / 360, n2 = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t2[1] * Math.PI / 360))) / 360, i2 = Math.pow(2, e2.z);
          return [Math.round(r2 * i2 * Yi), Math.round(n2 * i2 * Yi)];
        }
        function Hi(t2, e2) {
          for (let r2 = 0; r2 < e2.length; r2++)
            if (qi(t2, e2[r2]))
              return true;
          return false;
        }
        function Ki(t2, e2, r2) {
          for (const n2 of r2)
            for (let r3 = 0, i2 = n2.length, s2 = i2 - 1; r3 < i2; s2 = r3++)
              if (Xi(t2, e2, n2[s2], n2[r3]))
                return true;
          return false;
        }
        function Wi(t2, e2) {
          for (let r2 = 0; r2 < t2.length; ++r2)
            if (!qi(t2[r2], e2))
              return false;
          for (let r2 = 0; r2 < t2.length - 1; ++r2)
            if (Ki(t2[r2], t2[r2 + 1], e2))
              return false;
          return true;
        }
        function Ji(t2, e2) {
          for (let r2 = 0; r2 < e2.length; r2++)
            if (Wi(t2, e2[r2]))
              return true;
          return false;
        }
        function Qi(t2, e2, r2) {
          const n2 = [];
          for (let i2 = 0; i2 < t2.length; i2++) {
            const s2 = [];
            for (let n3 = 0; n3 < t2[i2].length; n3++) {
              const a2 = Zi(t2[i2][n3], r2);
              ji(e2, a2), s2.push(a2);
            }
            n2.push(s2);
          }
          return n2;
        }
        function ts(t2, e2, r2) {
          const n2 = [];
          for (let i2 = 0; i2 < t2.length; i2++) {
            const s2 = Qi(t2[i2], e2, r2);
            n2.push(s2);
          }
          return n2;
        }
        function es(t2, e2, r2, n2) {
          if (t2[0] < r2[0] || t2[0] > r2[2]) {
            const e3 = 0.5 * n2;
            let i2 = t2[0] - r2[0] > e3 ? -n2 : r2[0] - t2[0] > e3 ? n2 : 0;
            0 === i2 && (i2 = t2[0] - r2[2] > e3 ? -n2 : r2[2] - t2[0] > e3 ? n2 : 0), t2[0] += i2;
          }
          ji(e2, t2);
        }
        function rs(t2, e2, r2, n2) {
          const i2 = Math.pow(2, n2.z) * Yi, s2 = [n2.x * Yi, n2.y * Yi], a2 = [];
          if (!t2)
            return a2;
          for (const n3 of t2)
            for (const t3 of n3) {
              const n4 = [t3.x + s2[0], t3.y + s2[1]];
              es(n4, e2, r2, i2), a2.push(n4);
            }
          return a2;
        }
        function ns(t2, e2, r2, n2) {
          const i2 = Math.pow(2, n2.z) * Yi, s2 = [n2.x * Yi, n2.y * Yi], a2 = [];
          if (!t2)
            return a2;
          for (const r3 of t2) {
            const t3 = [];
            for (const n3 of r3) {
              const r4 = [n3.x + s2[0], n3.y + s2[1]];
              ji(e2, r4), t3.push(r4);
            }
            a2.push(t3);
          }
          if (e2[2] - e2[0] <= i2 / 2) {
            (o2 = e2)[0] = o2[1] = 1 / 0, o2[2] = o2[3] = -1 / 0;
            for (const t3 of a2)
              for (const n3 of t3)
                es(n3, e2, r2, i2);
          }
          var o2;
          return a2;
        }
        class is {
          constructor(t2, e2) {
            this.type = ri, this.geojson = t2, this.geometries = e2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length)
              return e2.error(`'within' expression requires exactly one argument, but found ${t2.length - 1} instead.`);
            if (vi(t2[1])) {
              const e3 = t2[1];
              if ("FeatureCollection" === e3.type)
                for (let t3 = 0; t3 < e3.features.length; ++t3) {
                  const r2 = e3.features[t3].geometry.type;
                  if ("Polygon" === r2 || "MultiPolygon" === r2)
                    return new is(e3, e3.features[t3].geometry);
                }
              else if ("Feature" === e3.type) {
                const t3 = e3.geometry.type;
                if ("Polygon" === t3 || "MultiPolygon" === t3)
                  return new is(e3, e3.geometry);
              } else if ("Polygon" === e3.type || "MultiPolygon" === e3.type)
                return new is(e3, e3);
            }
            return e2.error("'within' expression requires valid geojson object that contains polygon geometry type.");
          }
          evaluate(t2) {
            if (null != t2.geometry() && null != t2.canonicalID()) {
              if ("Point" === t2.geometryType())
                return function(t3, e2) {
                  const r2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], n2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], i2 = t3.canonicalID();
                  if (!i2)
                    return false;
                  if ("Polygon" === e2.type) {
                    const s2 = Qi(e2.coordinates, n2, i2), a2 = rs(t3.geometry(), r2, n2, i2);
                    if (!Ni(r2, n2))
                      return false;
                    for (const t4 of a2)
                      if (!qi(t4, s2))
                        return false;
                  }
                  if ("MultiPolygon" === e2.type) {
                    const s2 = ts(e2.coordinates, n2, i2), a2 = rs(t3.geometry(), r2, n2, i2);
                    if (!Ni(r2, n2))
                      return false;
                    for (const t4 of a2)
                      if (!Hi(t4, s2))
                        return false;
                  }
                  return true;
                }(t2, this.geometries);
              if ("LineString" === t2.geometryType())
                return function(t3, e2) {
                  const r2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], n2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], i2 = t3.canonicalID();
                  if (!i2)
                    return false;
                  if ("Polygon" === e2.type) {
                    const s2 = Qi(e2.coordinates, n2, i2), a2 = ns(t3.geometry(), r2, n2, i2);
                    if (!Ni(r2, n2))
                      return false;
                    for (const t4 of a2)
                      if (!Wi(t4, s2))
                        return false;
                  }
                  if ("MultiPolygon" === e2.type) {
                    const s2 = ts(e2.coordinates, n2, i2), a2 = ns(t3.geometry(), r2, n2, i2);
                    if (!Ni(r2, n2))
                      return false;
                    for (const t4 of a2)
                      if (!Ji(t4, s2))
                        return false;
                  }
                  return true;
                }(t2, this.geometries);
            }
            return false;
          }
          eachChild() {
          }
          outputDefined() {
            return true;
          }
          serialize() {
            return ["within", this.geojson];
          }
        }
        const ss = { kilometers: 1, miles: 1e3 / 1609.344, nauticalmiles: 1e3 / 1852, meters: 1e3, metres: 1e3, yards: 1e3 / 0.9144, feet: 1e3 / 0.3048, inches: 1e3 / 0.0254 }, as = 1 / 298.257223563, os = as * (2 - as), ls = Math.PI / 180;
        class us {
          static fromTile(t2, e2, r2) {
            const n2 = Math.PI * (1 - 2 * (t2 + 0.5) / Math.pow(2, e2)), i2 = Math.atan(0.5 * (Math.exp(n2) - Math.exp(-n2))) / ls;
            return new us(i2, r2);
          }
          static get units() {
            return ss;
          }
          constructor(t2, e2) {
            if (void 0 === t2)
              throw new Error("No latitude given.");
            if (e2 && !ss[e2])
              throw new Error(`Unknown unit ${e2}. Use one of: ${Object.keys(ss).join(", ")}`);
            const r2 = 6378.137 * ls * (e2 ? ss[e2] : 1), n2 = Math.cos(t2 * ls), i2 = 1 / (1 - os * (1 - n2 * n2)), s2 = Math.sqrt(i2);
            this.kx = r2 * s2 * n2, this.ky = r2 * s2 * i2 * (1 - os);
          }
          distance(t2, e2) {
            const r2 = ps(t2[0] - e2[0]) * this.kx, n2 = (t2[1] - e2[1]) * this.ky;
            return Math.sqrt(r2 * r2 + n2 * n2);
          }
          bearing(t2, e2) {
            const r2 = ps(e2[0] - t2[0]) * this.kx;
            return Math.atan2(r2, (e2[1] - t2[1]) * this.ky) / ls;
          }
          destination(t2, e2, r2) {
            const n2 = r2 * ls;
            return this.offset(t2, Math.sin(n2) * e2, Math.cos(n2) * e2);
          }
          offset(t2, e2, r2) {
            return [t2[0] + e2 / this.kx, t2[1] + r2 / this.ky];
          }
          lineDistance(t2) {
            let e2 = 0;
            for (let r2 = 0; r2 < t2.length - 1; r2++)
              e2 += this.distance(t2[r2], t2[r2 + 1]);
            return e2;
          }
          area(t2) {
            let e2 = 0;
            for (let r2 = 0; r2 < t2.length; r2++) {
              const n2 = t2[r2];
              for (let t3 = 0, i2 = n2.length, s2 = i2 - 1; t3 < i2; s2 = t3++)
                e2 += ps(n2[t3][0] - n2[s2][0]) * (n2[t3][1] + n2[s2][1]) * (r2 ? -1 : 1);
            }
            return Math.abs(e2) / 2 * this.kx * this.ky;
          }
          along(t2, e2) {
            let r2 = 0;
            if (e2 <= 0)
              return t2[0];
            for (let n2 = 0; n2 < t2.length - 1; n2++) {
              const i2 = t2[n2], s2 = t2[n2 + 1], a2 = this.distance(i2, s2);
              if (r2 += a2, r2 > e2)
                return hs(i2, s2, (e2 - (r2 - a2)) / a2);
            }
            return t2[t2.length - 1];
          }
          pointToSegmentDistance(t2, e2, r2) {
            let [n2, i2] = e2, s2 = ps(r2[0] - n2) * this.kx, a2 = (r2[1] - i2) * this.ky;
            if (0 !== s2 || 0 !== a2) {
              const e3 = (ps(t2[0] - n2) * this.kx * s2 + (t2[1] - i2) * this.ky * a2) / (s2 * s2 + a2 * a2);
              e3 > 1 ? (n2 = r2[0], i2 = r2[1]) : e3 > 0 && (n2 += s2 / this.kx * e3, i2 += a2 / this.ky * e3);
            }
            return s2 = ps(t2[0] - n2) * this.kx, a2 = (t2[1] - i2) * this.ky, Math.sqrt(s2 * s2 + a2 * a2);
          }
          pointOnLine(t2, e2) {
            let r2 = 1 / 0, n2 = t2[0][0], i2 = t2[0][1], s2 = 0, a2 = 0;
            for (let o2 = 0; o2 < t2.length - 1; o2++) {
              let l2 = t2[o2][0], u2 = t2[o2][1], c2 = ps(t2[o2 + 1][0] - l2) * this.kx, h2 = (t2[o2 + 1][1] - u2) * this.ky, p2 = 0;
              0 === c2 && 0 === h2 || (p2 = (ps(e2[0] - l2) * this.kx * c2 + (e2[1] - u2) * this.ky * h2) / (c2 * c2 + h2 * h2), p2 > 1 ? (l2 = t2[o2 + 1][0], u2 = t2[o2 + 1][1]) : p2 > 0 && (l2 += c2 / this.kx * p2, u2 += h2 / this.ky * p2)), c2 = ps(e2[0] - l2) * this.kx, h2 = (e2[1] - u2) * this.ky;
              const f2 = c2 * c2 + h2 * h2;
              f2 < r2 && (r2 = f2, n2 = l2, i2 = u2, s2 = o2, a2 = p2);
            }
            return { point: [n2, i2], index: s2, t: Math.max(0, Math.min(1, a2)) };
          }
          lineSlice(t2, e2, r2) {
            let n2 = this.pointOnLine(r2, t2), i2 = this.pointOnLine(r2, e2);
            if (n2.index > i2.index || n2.index === i2.index && n2.t > i2.t) {
              const t3 = n2;
              n2 = i2, i2 = t3;
            }
            const s2 = [n2.point], a2 = n2.index + 1, o2 = i2.index;
            !cs(r2[a2], s2[0]) && a2 <= o2 && s2.push(r2[a2]);
            for (let t3 = a2 + 1; t3 <= o2; t3++)
              s2.push(r2[t3]);
            return cs(r2[o2], i2.point) || s2.push(i2.point), s2;
          }
          lineSliceAlong(t2, e2, r2) {
            let n2 = 0;
            const i2 = [];
            for (let s2 = 0; s2 < r2.length - 1; s2++) {
              const a2 = r2[s2], o2 = r2[s2 + 1], l2 = this.distance(a2, o2);
              if (n2 += l2, n2 > t2 && 0 === i2.length && i2.push(hs(a2, o2, (t2 - (n2 - l2)) / l2)), n2 >= e2)
                return i2.push(hs(a2, o2, (e2 - (n2 - l2)) / l2)), i2;
              n2 > t2 && i2.push(o2);
            }
            return i2;
          }
          bufferPoint(t2, e2) {
            const r2 = e2 / this.ky, n2 = e2 / this.kx;
            return [t2[0] - n2, t2[1] - r2, t2[0] + n2, t2[1] + r2];
          }
          bufferBBox(t2, e2) {
            const r2 = e2 / this.ky, n2 = e2 / this.kx;
            return [t2[0] - n2, t2[1] - r2, t2[2] + n2, t2[3] + r2];
          }
          insideBBox(t2, e2) {
            return ps(t2[0] - e2[0]) >= 0 && ps(t2[0] - e2[2]) <= 0 && t2[1] >= e2[1] && t2[1] <= e2[3];
          }
        }
        function cs(t2, e2) {
          return t2[0] === e2[0] && t2[1] === e2[1];
        }
        function hs(t2, e2, r2) {
          const n2 = ps(e2[0] - t2[0]);
          return [t2[0] + n2 * r2, t2[1] + (e2[1] - t2[1]) * r2];
        }
        function ps(t2) {
          for (; t2 < -180; )
            t2 += 360;
          for (; t2 > 180; )
            t2 -= 360;
          return t2;
        }
        class fs {
          constructor(t2 = [], e2 = (t3, e3) => t3 < e3 ? -1 : t3 > e3 ? 1 : 0) {
            if (this.data = t2, this.length = this.data.length, this.compare = e2, this.length > 0)
              for (let t3 = (this.length >> 1) - 1; t3 >= 0; t3--)
                this._down(t3);
          }
          push(t2) {
            this.data.push(t2), this._up(this.length++);
          }
          pop() {
            if (0 === this.length)
              return;
            const t2 = this.data[0], e2 = this.data.pop();
            return --this.length > 0 && (this.data[0] = e2, this._down(0)), t2;
          }
          peek() {
            return this.data[0];
          }
          _up(t2) {
            const { data: e2, compare: r2 } = this, n2 = e2[t2];
            for (; t2 > 0; ) {
              const i2 = t2 - 1 >> 1, s2 = e2[i2];
              if (r2(n2, s2) >= 0)
                break;
              e2[t2] = s2, t2 = i2;
            }
            e2[t2] = n2;
          }
          _down(t2) {
            const { data: e2, compare: r2 } = this, n2 = this.length >> 1, i2 = e2[t2];
            for (; t2 < n2; ) {
              let n3 = 1 + (t2 << 1);
              const s2 = n3 + 1;
              if (s2 < this.length && r2(e2[s2], e2[n3]) < 0 && (n3 = s2), r2(e2[n3], i2) >= 0)
                break;
              e2[t2] = e2[n3], t2 = n3;
            }
            e2[t2] = i2;
          }
        }
        var ds = 8192;
        function ms(t2, e2) {
          return e2.dist - t2.dist;
        }
        const ys = 100, gs = 50;
        function xs(t2) {
          const e2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
          if (e2.length !== t2.length)
            return false;
          for (let r2 = 0; r2 < e2.length; r2++)
            if (e2[r2] !== t2[r2])
              return false;
          return true;
        }
        function bs(t2) {
          return t2[1] - t2[0] + 1;
        }
        function vs(t2, e2) {
          const r2 = t2[1] >= t2[0] && t2[1] < e2;
          return r2 || console.warn("Distance Expression: Index is out of range"), r2;
        }
        function _s(t2, e2) {
          if (t2[0] > t2[1])
            return [null, null];
          const r2 = bs(t2);
          if (e2) {
            if (2 === r2)
              return [t2, null];
            const e3 = Math.floor(r2 / 2);
            return [[t2[0], t2[0] + e3], [t2[0] + e3, t2[1]]];
          }
          {
            if (1 === r2)
              return [t2, null];
            const e3 = Math.floor(r2 / 2) - 1;
            return [[t2[0], t2[0] + e3], [t2[0] + e3 + 1, t2[1]]];
          }
        }
        function ws(t2, e2) {
          const r2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
          if (!vs(e2, t2.length))
            return r2;
          for (let n2 = e2[0]; n2 <= e2[1]; ++n2)
            ji(r2, t2[n2]);
          return r2;
        }
        function Ms(t2) {
          const e2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
          for (let r2 = 0; r2 < t2.length; ++r2)
            for (let n2 = 0; n2 < t2[r2].length; ++n2)
              ji(e2, t2[r2][n2]);
          return e2;
        }
        function As(t2, e2, r2) {
          if (xs(t2) || xs(e2))
            return NaN;
          let n2 = 0, i2 = 0;
          return t2[2] < e2[0] && (n2 = e2[0] - t2[2]), t2[0] > e2[2] && (n2 = t2[0] - e2[2]), t2[1] > e2[3] && (i2 = t2[1] - e2[3]), t2[3] < e2[1] && (i2 = e2[1] - t2[3]), r2.distance([0, 0], [n2, i2]);
        }
        function Ss(t2) {
          return 360 * t2 - 180;
        }
        function Is(t2) {
          return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t2) * Math.PI / 180)) - 90;
        }
        function Ts(t2, e2) {
          const r2 = Math.pow(2, e2.z), n2 = (t2.y / ds + e2.y) / r2;
          return [Ss((t2.x / ds + e2.x) / r2), Is(n2)];
        }
        function ks(t2, e2) {
          const r2 = [];
          for (let n2 = 0; n2 < t2.length; ++n2)
            r2.push(Ts(t2[n2], e2));
          return r2;
        }
        function Ps(t2, e2, r2) {
          const n2 = r2.pointOnLine(e2, t2).point;
          return r2.distance(t2, n2);
        }
        function zs(t2, e2, r2, n2, i2) {
          const s2 = r2.slice(n2[0], n2[1] + 1);
          let a2 = 1 / 0;
          for (let r3 = e2[0]; r3 <= e2[1]; ++r3)
            if (0 === (a2 = Math.min(a2, Ps(t2[r3], s2, i2))))
              return 0;
          return a2;
        }
        function Es(t2, e2, r2, n2, i2) {
          const s2 = Math.min(i2.pointToSegmentDistance(t2, r2, n2), i2.pointToSegmentDistance(e2, r2, n2)), a2 = Math.min(i2.pointToSegmentDistance(r2, t2, e2), i2.pointToSegmentDistance(n2, t2, e2));
          return Math.min(s2, a2);
        }
        function Bs(t2, e2, r2, n2, i2) {
          if (!vs(e2, t2.length) || !vs(n2, r2.length))
            return NaN;
          let s2 = 1 / 0;
          for (let a2 = e2[0]; a2 < e2[1]; ++a2)
            for (let e3 = n2[0]; e3 < n2[1]; ++e3) {
              if (Xi(t2[a2], t2[a2 + 1], r2[e3], r2[e3 + 1]))
                return 0;
              s2 = Math.min(s2, Es(t2[a2], t2[a2 + 1], r2[e3], r2[e3 + 1], i2));
            }
          return s2;
        }
        function Ds(t2, e2, r2, n2, i2) {
          if (!vs(e2, t2.length) || !vs(n2, r2.length))
            return NaN;
          let s2 = 1 / 0;
          for (let a2 = e2[0]; a2 <= e2[1]; ++a2)
            for (let e3 = n2[0]; e3 <= n2[1]; ++e3)
              if (0 === (s2 = Math.min(s2, i2.distance(t2[a2], r2[e3]))))
                return s2;
          return s2;
        }
        function Rs(t2, e2, r2) {
          if (qi(t2, e2, true))
            return 0;
          let n2 = 1 / 0;
          for (const i2 of e2) {
            const e3 = i2.length;
            if (e3 < 2)
              return console.warn("Distance Expression: Invalid polygon!"), NaN;
            if (i2[0] !== i2[e3 - 1] && 0 === (n2 = Math.min(n2, r2.pointToSegmentDistance(t2, i2[e3 - 1], i2[0]))))
              return n2;
            if (0 === (n2 = Math.min(n2, Ps(t2, i2, r2))))
              return n2;
          }
          return n2;
        }
        function Cs(t2, e2, r2, n2) {
          if (!vs(e2, t2.length))
            return NaN;
          for (let n3 = e2[0]; n3 <= e2[1]; ++n3)
            if (qi(t2[n3], r2, true))
              return 0;
          let i2 = 1 / 0;
          for (let s2 = e2[0]; s2 < e2[1]; ++s2)
            for (const e3 of r2)
              for (let r3 = 0, a2 = e3.length, o2 = a2 - 1; r3 < a2; o2 = r3++) {
                if (Xi(t2[s2], t2[s2 + 1], e3[o2], e3[r3]))
                  return 0;
                i2 = Math.min(i2, Es(t2[s2], t2[s2 + 1], e3[o2], e3[r3], n2));
              }
          return i2;
        }
        function Ls(t2, e2) {
          for (const r2 of t2)
            for (let t3 = 0; t3 <= r2.length - 1; ++t3)
              if (qi(r2[t3], e2, true))
                return true;
          return false;
        }
        function Vs(t2, e2, r2, n2 = 1 / 0) {
          const i2 = Ms(t2), s2 = Ms(e2);
          if (n2 !== 1 / 0 && As(i2, s2, r2) >= n2)
            return n2;
          if (Ni(i2, s2)) {
            if (Ls(t2, e2))
              return 0;
          } else if (Ls(e2, t2))
            return 0;
          let a2 = n2;
          for (const n3 of t2)
            for (let t3 = 0, i3 = n3.length, s3 = i3 - 1; t3 < i3; s3 = t3++)
              for (const i4 of e2)
                for (let e3 = 0, o2 = i4.length, l2 = o2 - 1; e3 < o2; l2 = e3++) {
                  if (Xi(n3[s3], n3[t3], i4[l2], i4[e3]))
                    return 0;
                  a2 = Math.min(a2, Es(n3[s3], n3[t3], i4[l2], i4[e3], r2));
                }
          return a2;
        }
        function Fs(t2, e2, r2, n2, i2, s2, a2) {
          if (null === s2 || null === a2)
            return;
          const o2 = As(ws(n2, s2), ws(i2, a2), r2);
          o2 < e2 && t2.push({ dist: o2, range1: s2, range2: a2 });
        }
        function Os(t2, e2, r2, n2, i2 = 1 / 0) {
          let s2 = Math.min(n2.distance(t2[0], r2[0][0]), i2);
          if (0 === s2)
            return s2;
          const a2 = new fs([{ dist: 0, range1: [0, t2.length - 1], range2: [0, 0] }], ms), o2 = e2 ? gs : ys, l2 = Ms(r2);
          for (; a2.length; ) {
            const i3 = a2.pop();
            if (i3.dist >= s2)
              continue;
            const u2 = i3.range1;
            if (bs(u2) <= o2) {
              if (!vs(u2, t2.length))
                return NaN;
              if (e2) {
                const e3 = Cs(t2, u2, r2, n2);
                if (0 === (s2 = Math.min(s2, e3)))
                  return s2;
              } else
                for (let e3 = u2[0]; e3 <= u2[1]; ++e3) {
                  const i4 = Rs(t2[e3], r2, n2);
                  if (0 === (s2 = Math.min(s2, i4)))
                    return s2;
                }
            } else {
              const r3 = _s(u2, e2);
              if (null !== r3[0]) {
                const e3 = As(ws(t2, r3[0]), l2, n2);
                e3 < s2 && a2.push({ dist: e3, range1: r3[0], range2: [0, 0] });
              }
              if (null !== r3[1]) {
                const e3 = As(ws(t2, r3[1]), l2, n2);
                e3 < s2 && a2.push({ dist: e3, range1: r3[1], range2: [0, 0] });
              }
            }
          }
          return s2;
        }
        function Us(t2, e2, r2, n2, i2, s2 = 1 / 0) {
          let a2 = Math.min(s2, i2.distance(t2[0], r2[0]));
          if (0 === a2)
            return a2;
          const o2 = new fs([{ dist: 0, range1: [0, t2.length - 1], range2: [0, r2.length - 1] }], ms), l2 = e2 ? gs : ys, u2 = n2 ? gs : ys;
          for (; o2.length; ) {
            const s3 = o2.pop();
            if (s3.dist >= a2)
              continue;
            const c2 = s3.range1, h2 = s3.range2;
            if (bs(c2) <= l2 && bs(h2) <= u2) {
              if (!vs(c2, t2.length) || !vs(h2, r2.length))
                return NaN;
              if (e2 && n2 ? a2 = Math.min(a2, Bs(t2, c2, r2, h2, i2)) : e2 || n2 ? e2 && !n2 ? a2 = Math.min(a2, zs(r2, h2, t2, c2, i2)) : !e2 && n2 && (a2 = Math.min(a2, zs(t2, c2, r2, h2, i2))) : a2 = Math.min(a2, Ds(t2, c2, r2, h2, i2)), 0 === a2)
                return a2;
            } else {
              const s4 = _s(c2, e2), l3 = _s(h2, n2);
              Fs(o2, a2, i2, t2, r2, s4[0], l3[0]), Fs(o2, a2, i2, t2, r2, s4[0], l3[1]), Fs(o2, a2, i2, t2, r2, s4[1], l3[0]), Fs(o2, a2, i2, t2, r2, s4[1], l3[1]);
            }
          }
          return a2;
        }
        function js(t2, e2, r2, n2, i2 = 1 / 0) {
          let s2 = i2;
          const a2 = ws(t2, [0, t2.length - 1]);
          for (const i3 of r2)
            if (!(s2 !== 1 / 0 && As(a2, ws(i3, [0, i3.length - 1]), n2) >= s2) && (s2 = Math.min(s2, Us(t2, e2, i3, true, n2, s2)), 0 === s2))
              return s2;
          return s2;
        }
        function Ns(t2, e2, r2, n2, i2 = 1 / 0) {
          let s2 = i2;
          const a2 = ws(t2, [0, t2.length - 1]);
          for (const i3 of r2) {
            if (s2 !== 1 / 0 && As(a2, Ms(i3), n2) >= s2)
              continue;
            const r3 = Os(t2, e2, i3, n2, s2);
            if (isNaN(r3))
              return r3;
            if (0 === (s2 = Math.min(s2, r3)))
              return s2;
          }
          return s2;
        }
        function $s(t2) {
          return "Point" === t2 || "MultiPoint" === t2 || "LineString" === t2 || "MultiLineString" === t2 || "Polygon" === t2 || "MultiPolygon" === t2;
        }
        class qs {
          constructor(t2, e2) {
            this.type = ti, this.geojson = t2, this.geometries = e2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length)
              return e2.error(`'distance' expression requires either one argument, but found ' ${t2.length - 1} instead.`);
            if (vi(t2[1])) {
              const e3 = t2[1];
              if ("FeatureCollection" === e3.type) {
                for (let t3 = 0; t3 < e3.features.length; ++t3)
                  if ($s(e3.features[t3].geometry.type))
                    return new qs(e3, e3.features[t3].geometry);
              } else if ("Feature" === e3.type) {
                if ($s(e3.geometry.type))
                  return new qs(e3, e3.geometry);
              } else if ($s(e3.type))
                return new qs(e3, e3);
            }
            return e2.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].");
          }
          evaluate(t2) {
            const e2 = t2.geometry(), r2 = t2.canonicalID();
            if (null != e2 && null != r2) {
              if ("Point" === t2.geometryType())
                return function(t3, e3, r3) {
                  const n2 = [];
                  for (const r4 of t3)
                    for (const t4 of r4)
                      n2.push(Ts(t4, e3));
                  const i2 = new us(n2[0][1], "meters");
                  return "Point" === r3.type || "MultiPoint" === r3.type || "LineString" === r3.type ? Us(n2, false, "Point" === r3.type ? [r3.coordinates] : r3.coordinates, "LineString" === r3.type, i2) : "MultiLineString" === r3.type ? js(n2, false, r3.coordinates, i2) : "Polygon" === r3.type || "MultiPolygon" === r3.type ? Ns(n2, false, "Polygon" === r3.type ? [r3.coordinates] : r3.coordinates, i2) : null;
                }(e2, r2, this.geometries);
              if ("LineString" === t2.geometryType())
                return function(t3, e3, r3) {
                  const n2 = [];
                  for (const r4 of t3) {
                    const t4 = [];
                    for (const n3 of r4)
                      t4.push(Ts(n3, e3));
                    n2.push(t4);
                  }
                  const i2 = new us(n2[0][0][1], "meters");
                  if ("Point" === r3.type || "MultiPoint" === r3.type || "LineString" === r3.type)
                    return js("Point" === r3.type ? [r3.coordinates] : r3.coordinates, "LineString" === r3.type, n2, i2);
                  if ("MultiLineString" === r3.type) {
                    let t4 = 1 / 0;
                    for (let e4 = 0; e4 < r3.coordinates.length; e4++) {
                      const s2 = js(r3.coordinates[e4], true, n2, i2, t4);
                      if (isNaN(s2))
                        return s2;
                      if (0 === (t4 = Math.min(t4, s2)))
                        return t4;
                    }
                    return t4;
                  }
                  if ("Polygon" === r3.type || "MultiPolygon" === r3.type) {
                    let t4 = 1 / 0;
                    for (let e4 = 0; e4 < n2.length; e4++) {
                      const s2 = Ns(n2[e4], true, "Polygon" === r3.type ? [r3.coordinates] : r3.coordinates, i2, t4);
                      if (isNaN(s2))
                        return s2;
                      if (0 === (t4 = Math.min(t4, s2)))
                        return t4;
                    }
                    return t4;
                  }
                  return null;
                }(e2, r2, this.geometries);
              if ("Polygon" === t2.geometryType())
                return function(t3, e3, r3) {
                  const n2 = [];
                  for (const r4 of function(t4, e4) {
                    const r5 = t4.length;
                    if (r5 <= 1)
                      return [t4];
                    const n3 = [];
                    let i3, s2;
                    for (let e5 = 0; e5 < r5; e5++) {
                      const r6 = Ui(t4[e5]);
                      0 !== r6 && (t4[e5].area = Math.abs(r6), void 0 === s2 && (s2 = r6 < 0), s2 === r6 < 0 ? (i3 && n3.push(i3), i3 = [t4[e5]]) : i3.push(t4[e5]));
                    }
                    return i3 && n3.push(i3), n3;
                  }(t3)) {
                    const t4 = [];
                    for (let n3 = 0; n3 < r4.length; ++n3)
                      t4.push(ks(r4[n3], e3));
                    n2.push(t4);
                  }
                  const i2 = new us(n2[0][0][0][1], "meters");
                  if ("Point" === r3.type || "MultiPoint" === r3.type || "LineString" === r3.type)
                    return Ns("Point" === r3.type ? [r3.coordinates] : r3.coordinates, "LineString" === r3.type, n2, i2);
                  if ("MultiLineString" === r3.type) {
                    let t4 = 1 / 0;
                    for (let e4 = 0; e4 < r3.coordinates.length; e4++) {
                      const s2 = Ns(r3.coordinates[e4], true, n2, i2, t4);
                      if (isNaN(s2))
                        return s2;
                      if (0 === (t4 = Math.min(t4, s2)))
                        return t4;
                    }
                    return t4;
                  }
                  return "Polygon" === r3.type || "MultiPolygon" === r3.type ? function(t4, e4, r4) {
                    let n3 = 1 / 0;
                    for (const i3 of t4)
                      for (const t5 of e4) {
                        const e5 = Vs(i3, t5, r4, n3);
                        if (isNaN(e5))
                          return e5;
                        if (0 === (n3 = Math.min(n3, e5)))
                          return n3;
                      }
                    return n3;
                  }("Polygon" === r3.type ? [r3.coordinates] : r3.coordinates, n2, i2) : null;
                }(e2, r2, this.geometries);
              console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries.");
            } else
              console.warn("Distance Expression: requirs valid feature and canonical information.");
            return null;
          }
          eachChild() {
          }
          outputDefined() {
            return true;
          }
          serialize() {
            return ["distance", this.geojson];
          }
        }
        function Gs(t2, e2) {
          switch (t2) {
            case "string":
              return wi(e2);
            case "number":
              return +e2;
            case "boolean":
              return !!e2;
            case "color":
              return Gn.parse(e2);
            case "formatted":
              return gi.fromString(wi(e2));
            case "resolvedImage":
              return xi.fromString(wi(e2));
          }
          return e2;
        }
        function Xs(t2, e2, r2, n2) {
          return void 0 !== n2 && (t2 = n2 * Math.round(t2 / n2)), void 0 !== e2 && t2 < e2 && (t2 = e2), void 0 !== r2 && t2 > r2 && (t2 = r2), t2;
        }
        class Ys {
          constructor(t2, e2, r2) {
            this.type = t2, this.key = e2, this.scope = r2;
          }
          static parse(t2, e2) {
            let r2 = e2.expectedType;
            if (null == r2 && (r2 = si), t2.length < 2 || t2.length > 3)
              return e2.error("Invalid number of arguments for 'config' expression.");
            const n2 = e2.parse(t2[1], 1);
            if (!(n2 instanceof Mi))
              return e2.error("Key name of 'config' expression must be a string literal.");
            if (t2.length >= 3) {
              const i2 = e2.parse(t2[2], 2);
              return i2 instanceof Mi ? new Ys(r2, wi(n2.value), wi(i2.value)) : e2.error("Scope of 'config' expression must be a string literal.");
            }
            return new Ys(r2, wi(n2.value));
          }
          evaluate(t2) {
            const e2 = [this.key, this.scope, t2.scope].filter(Boolean).join(""), r2 = t2.getConfig(e2);
            if (!r2)
              return null;
            const { type: n2, value: i2, values: s2, minValue: a2, maxValue: o2, stepValue: l2 } = r2, u2 = r2.default.evaluate(t2);
            let c2 = u2;
            if (i2) {
              const e3 = t2.scope;
              t2.scope = (e3 || "").split("").slice(1).join(""), c2 = i2.evaluate(t2), t2.scope = e3;
            }
            return n2 && (c2 = Gs(n2, c2)), void 0 === c2 || void 0 === a2 && void 0 === o2 && void 0 === l2 || ("number" == typeof c2 ? c2 = Xs(c2, a2, o2, l2) : Array.isArray(c2) && (c2 = c2.map((t3) => "number" == typeof t3 ? Xs(t3, a2, o2, l2) : t3))), void 0 !== i2 && void 0 !== c2 && s2 && !s2.includes(c2) && (c2 = u2, n2 && (c2 = Gs(n2, c2))), (n2 && n2 !== this.type || void 0 !== c2 && _i(c2) !== this.type) && (c2 = Gs(this.type.kind, c2)), c2;
          }
          eachChild() {
          }
          outputDefined() {
            return false;
          }
          serialize() {
            const t2 = ["config", this.key];
            return this.scope && t2.concat(this.key), t2;
          }
        }
        function Zs(t2) {
          if (t2 instanceof Ri) {
            if ("get" === t2.name && 1 === t2.args.length)
              return false;
            if ("feature-state" === t2.name)
              return false;
            if ("has" === t2.name && 1 === t2.args.length)
              return false;
            if ("properties" === t2.name || "geometry-type" === t2.name || "id" === t2.name)
              return false;
            if (/^filter-/.test(t2.name))
              return false;
          }
          if (t2 instanceof is)
            return false;
          if (t2 instanceof qs)
            return false;
          let e2 = true;
          return t2.eachChild((t3) => {
            e2 && !Zs(t3) && (e2 = false);
          }), e2;
        }
        function Hs(t2) {
          if (t2 instanceof Ri && "feature-state" === t2.name)
            return false;
          let e2 = true;
          return t2.eachChild((t3) => {
            e2 && !Hs(t3) && (e2 = false);
          }), e2;
        }
        function Ks(t2) {
          if (t2 instanceof Ys)
            return /* @__PURE__ */ new Set([t2.key]);
          let e2 = /* @__PURE__ */ new Set();
          return t2.eachChild((t3) => {
            e2 = /* @__PURE__ */ new Set([...e2, ...Ks(t3)]);
          }), e2;
        }
        function Ws(t2, e2) {
          if (t2 instanceof Ri && e2.indexOf(t2.name) >= 0)
            return false;
          let r2 = true;
          return t2.eachChild((t3) => {
            r2 && !Ws(t3, e2) && (r2 = false);
          }), r2;
        }
        class Js {
          constructor(t2, e2) {
            this.type = e2.type, this.name = t2, this.boundExpression = e2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length || "string" != typeof t2[1])
              return e2.error("'var' expression requires exactly one string literal argument.");
            const r2 = t2[1];
            return e2.scope.has(r2) ? new Js(r2, e2.scope.get(r2)) : e2.error(`Unknown variable "${r2}". Make sure "${r2}" has been bound in an enclosing "let" expression before using it.`, 1);
          }
          evaluate(t2) {
            return this.boundExpression.evaluate(t2);
          }
          eachChild() {
          }
          outputDefined() {
            return false;
          }
          serialize() {
            return ["var", this.name];
          }
        }
        class Qs {
          constructor(t2, e2 = [], r2, n2 = new Jn(), i2 = [], s2, a2) {
            this.registry = t2, this.path = e2, this.key = e2.map((t3) => `[${t3}]`).join(""), this.scope = n2, this.errors = i2, this.expectedType = r2, this._scope = s2, this.options = a2;
          }
          parse(t2, e2, r2, n2, i2 = {}) {
            return e2 || r2 ? this.concat(e2, r2, n2)._parse(t2, i2) : this._parse(t2, i2);
          }
          _parse(t2, e2) {
            function r2(t3, e3, r3) {
              return "assert" === r3 ? new Ii(e3, [t3]) : "coerce" === r3 ? new Ei(e3, [t3]) : t3;
            }
            if (null !== t2 && "string" != typeof t2 && "boolean" != typeof t2 && "number" != typeof t2 || (t2 = ["literal", t2]), Array.isArray(t2)) {
              if (0 === t2.length)
                return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
              const n2 = "string" == typeof t2[0] ? this.registry[t2[0]] : void 0;
              if (n2) {
                let i2 = n2.parse(t2, this);
                if (!i2)
                  return null;
                if (this.expectedType) {
                  const t3 = this.expectedType, n3 = i2.type;
                  if ("string" !== t3.kind && "number" !== t3.kind && "boolean" !== t3.kind && "object" !== t3.kind && "array" !== t3.kind || "value" !== n3.kind)
                    if ("color" !== t3.kind && "formatted" !== t3.kind && "resolvedImage" !== t3.kind || "value" !== n3.kind && "string" !== n3.kind) {
                      if (this.checkSubtype(t3, n3))
                        return null;
                    } else
                      i2 = r2(i2, t3, e2.typeAnnotation || "coerce");
                  else
                    i2 = r2(i2, t3, e2.typeAnnotation || "assert");
                }
                if (!(i2 instanceof Mi) && "resolvedImage" !== i2.type.kind && ea(i2)) {
                  const t3 = new Di(this._scope, this.options);
                  try {
                    i2 = new Mi(i2.type, i2.evaluate(t3));
                  } catch (t4) {
                    return this.error(t4.message), null;
                  }
                }
                return i2;
              }
              return Ei.parse(["to-array", t2], this);
            }
            return this.error(void 0 === t2 ? "'undefined' value invalid. Use null instead." : "object" == typeof t2 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t2} instead.`);
          }
          concat(t2, e2, r2) {
            const n2 = "number" == typeof t2 ? this.path.concat(t2) : this.path, i2 = r2 ? this.scope.concat(r2) : this.scope;
            return new Qs(this.registry, n2, e2 || null, i2, this.errors, this._scope, this.options);
          }
          error(t2, ...e2) {
            const r2 = `${this.key}${e2.map((t3) => `[${t3}]`).join("")}`;
            this.errors.push(new Wn(r2, t2));
          }
          checkSubtype(t2, e2) {
            const r2 = pi(t2, e2);
            return r2 && this.error(r2), r2;
          }
        }
        var ta = Qs;
        function ea(t2) {
          if (t2 instanceof Js)
            return ea(t2.boundExpression);
          if (t2 instanceof Ri && "error" === t2.name)
            return false;
          if (t2 instanceof Li)
            return false;
          if (t2 instanceof is)
            return false;
          if (t2 instanceof qs)
            return false;
          if (t2 instanceof Ys)
            return false;
          const e2 = t2 instanceof Ei || t2 instanceof Ii;
          let r2 = true;
          return t2.eachChild((t3) => {
            r2 = e2 ? r2 && ea(t3) : r2 && t3 instanceof Mi;
          }), !!r2 && Zs(t2) && Ws(t2, ["zoom", "heatmap-density", "line-progress", "raster-value", "sky-radial-progress", "accumulated", "is-supported-script", "pitch", "distance-from-center", "measure-light", "raster-particle-speed"]);
        }
        function ra(t2, e2) {
          const r2 = t2.length - 1;
          let n2, i2, s2 = 0, a2 = r2, o2 = 0;
          for (; s2 <= a2; )
            if (o2 = Math.floor((s2 + a2) / 2), n2 = t2[o2], i2 = t2[o2 + 1], n2 <= e2) {
              if (o2 === r2 || e2 < i2)
                return o2;
              s2 = o2 + 1;
            } else {
              if (!(n2 > e2))
                throw new Ai("Input is not a number.");
              a2 = o2 - 1;
            }
          return 0;
        }
        class na {
          constructor(t2, e2, r2) {
            this.type = t2, this.input = e2, this.labels = [], this.outputs = [];
            for (const [t3, e3] of r2)
              this.labels.push(t3), this.outputs.push(e3);
          }
          static parse(t2, e2) {
            if (t2.length - 1 < 4)
              return e2.error(`Expected at least 4 arguments, but found only ${t2.length - 1}.`);
            if ((t2.length - 1) % 2 != 0)
              return e2.error("Expected an even number of arguments.");
            const r2 = e2.parse(t2[1], 1, ti);
            if (!r2)
              return null;
            const n2 = [];
            let i2 = null;
            e2.expectedType && "value" !== e2.expectedType.kind && (i2 = e2.expectedType);
            for (let r3 = 1; r3 < t2.length; r3 += 2) {
              const s2 = 1 === r3 ? -1 / 0 : t2[r3], a2 = t2[r3 + 1], o2 = r3, l2 = r3 + 1;
              if ("number" != typeof s2)
                return e2.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o2);
              if (n2.length && n2[n2.length - 1][0] >= s2)
                return e2.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o2);
              const u2 = e2.parse(a2, l2, i2);
              if (!u2)
                return null;
              i2 = i2 || u2.type, n2.push([s2, u2]);
            }
            return new na(i2, r2, n2);
          }
          evaluate(t2) {
            const e2 = this.labels, r2 = this.outputs;
            if (1 === e2.length)
              return r2[0].evaluate(t2);
            const n2 = this.input.evaluate(t2);
            if (n2 <= e2[0])
              return r2[0].evaluate(t2);
            const i2 = e2.length;
            return n2 >= e2[i2 - 1] ? r2[i2 - 1].evaluate(t2) : r2[ra(e2, n2)].evaluate(t2);
          }
          eachChild(t2) {
            t2(this.input);
            for (const e2 of this.outputs)
              t2(e2);
          }
          outputDefined() {
            return this.outputs.every((t2) => t2.outputDefined());
          }
          serialize() {
            const t2 = ["step", this.input.serialize()];
            for (let e2 = 0; e2 < this.labels.length; e2++)
              e2 > 0 && t2.push(this.labels[e2]), t2.push(this.outputs[e2].serialize());
            return t2;
          }
        }
        const ia = 0.95047, sa = 1.08883, aa = 4 / 29, oa = 6 / 29, la = 3 * oa * oa, ua = oa * oa * oa, ca = Math.PI / 180, ha = 180 / Math.PI;
        function pa(t2) {
          return t2 > ua ? Math.pow(t2, 1 / 3) : t2 / la + aa;
        }
        function fa(t2) {
          return t2 > oa ? t2 * t2 * t2 : la * (t2 - aa);
        }
        function da(t2) {
          return 255 * (t2 <= 31308e-7 ? 12.92 * t2 : 1.055 * Math.pow(t2, 1 / 2.4) - 0.055);
        }
        function ma(t2) {
          return (t2 /= 255) <= 0.04045 ? t2 / 12.92 : Math.pow((t2 + 0.055) / 1.055, 2.4);
        }
        function ya(t2) {
          const e2 = ma(t2.r), r2 = ma(t2.g), n2 = ma(t2.b), i2 = pa((0.4124564 * e2 + 0.3575761 * r2 + 0.1804375 * n2) / ia), s2 = pa((0.2126729 * e2 + 0.7151522 * r2 + 0.072175 * n2) / 1);
          return { l: 116 * s2 - 16, a: 500 * (i2 - s2), b: 200 * (s2 - pa((0.0193339 * e2 + 0.119192 * r2 + 0.9503041 * n2) / sa)), alpha: t2.a };
        }
        function ga(t2) {
          let e2 = (t2.l + 16) / 116, r2 = isNaN(t2.a) ? e2 : e2 + t2.a / 500, n2 = isNaN(t2.b) ? e2 : e2 - t2.b / 200;
          return e2 = 1 * fa(e2), r2 = ia * fa(r2), n2 = sa * fa(n2), new Gn(da(3.2404542 * r2 - 1.5371385 * e2 - 0.4985314 * n2), da(-0.969266 * r2 + 1.8760108 * e2 + 0.041556 * n2), da(0.0556434 * r2 - 0.2040259 * e2 + 1.0572252 * n2), t2.alpha);
        }
        function xa(t2, e2, r2) {
          const n2 = e2 - t2;
          return t2 + r2 * (n2 > 180 || n2 < -180 ? n2 - 360 * Math.round(n2 / 360) : n2);
        }
        const ba = { forward: ya, reverse: ga, interpolate: function(t2, e2, r2) {
          return { l: Yn(t2.l, e2.l, r2), a: Yn(t2.a, e2.a, r2), b: Yn(t2.b, e2.b, r2), alpha: Yn(t2.alpha, e2.alpha, r2) };
        } }, va = { forward: function(t2) {
          const { l: e2, a: r2, b: n2 } = ya(t2), i2 = Math.atan2(n2, r2) * ha;
          return { h: i2 < 0 ? i2 + 360 : i2, c: Math.sqrt(r2 * r2 + n2 * n2), l: e2, alpha: t2.a };
        }, reverse: function(t2) {
          const e2 = t2.h * ca, r2 = t2.c;
          return ga({ l: t2.l, a: Math.cos(e2) * r2, b: Math.sin(e2) * r2, alpha: t2.alpha });
        }, interpolate: function(t2, e2, r2) {
          return { h: xa(t2.h, e2.h, r2), c: Yn(t2.c, e2.c, r2), l: Yn(t2.l, e2.l, r2), alpha: Yn(t2.alpha, e2.alpha, r2) };
        } };
        var _a = Object.freeze({ __proto__: null, hcl: va, lab: ba });
        class wa {
          constructor(t2, e2, r2, n2, i2) {
            this.type = t2, this.operator = e2, this.interpolation = r2, this.input = n2, this.labels = [], this.outputs = [];
            for (const [t3, e3] of i2)
              this.labels.push(t3), this.outputs.push(e3);
          }
          static interpolationFactor(t2, e2, r2, n2) {
            let i2 = 0;
            if ("exponential" === t2.name)
              i2 = Ma(e2, t2.base, r2, n2);
            else if ("linear" === t2.name)
              i2 = Ma(e2, 1, r2, n2);
            else if ("cubic-bezier" === t2.name) {
              const s2 = t2.controlPoints;
              i2 = new Fe(s2[0], s2[1], s2[2], s2[3]).solve(Ma(e2, 1, r2, n2));
            }
            return i2;
          }
          static parse(t2, e2) {
            let [r2, n2, i2, ...s2] = t2;
            if (!Array.isArray(n2) || 0 === n2.length)
              return e2.error("Expected an interpolation type expression.", 1);
            if ("linear" === n2[0])
              n2 = { name: "linear" };
            else if ("exponential" === n2[0]) {
              const t3 = n2[1];
              if ("number" != typeof t3)
                return e2.error("Exponential interpolation requires a numeric base.", 1, 1);
              n2 = { name: "exponential", base: t3 };
            } else {
              if ("cubic-bezier" !== n2[0])
                return e2.error(`Unknown interpolation type ${String(n2[0])}`, 1, 0);
              {
                const t3 = n2.slice(1);
                if (4 !== t3.length || t3.some((t4) => "number" != typeof t4 || t4 < 0 || t4 > 1))
                  return e2.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                n2 = { name: "cubic-bezier", controlPoints: t3 };
              }
            }
            if (t2.length - 1 < 4)
              return e2.error(`Expected at least 4 arguments, but found only ${t2.length - 1}.`);
            if ((t2.length - 1) % 2 != 0)
              return e2.error("Expected an even number of arguments.");
            if (i2 = e2.parse(i2, 2, ti), !i2)
              return null;
            const a2 = [];
            let o2 = null;
            "interpolate-hcl" === r2 || "interpolate-lab" === r2 ? o2 = ni : e2.expectedType && "value" !== e2.expectedType.kind && (o2 = e2.expectedType);
            for (let t3 = 0; t3 < s2.length; t3 += 2) {
              const r3 = s2[t3], n3 = s2[t3 + 1], i3 = t3 + 3, l2 = t3 + 4;
              if ("number" != typeof r3)
                return e2.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i3);
              if (a2.length && a2[a2.length - 1][0] >= r3)
                return e2.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i3);
              const u2 = e2.parse(n3, l2, o2);
              if (!u2)
                return null;
              o2 = o2 || u2.type, a2.push([r3, u2]);
            }
            return "number" === o2.kind || "color" === o2.kind || "array" === o2.kind && "number" === o2.itemType.kind && "number" == typeof o2.N ? new wa(o2, r2, n2, i2, a2) : e2.error(`Type ${ci(o2)} is not interpolatable.`);
          }
          evaluate(t2) {
            const e2 = this.labels, r2 = this.outputs;
            if (1 === e2.length)
              return r2[0].evaluate(t2);
            const n2 = this.input.evaluate(t2);
            if (n2 <= e2[0])
              return r2[0].evaluate(t2);
            const i2 = e2.length;
            if (n2 >= e2[i2 - 1])
              return r2[i2 - 1].evaluate(t2);
            const s2 = ra(e2, n2), a2 = wa.interpolationFactor(this.interpolation, n2, e2[s2], e2[s2 + 1]), o2 = r2[s2].evaluate(t2), l2 = r2[s2 + 1].evaluate(t2);
            return "interpolate" === this.operator ? Hn[this.type.kind.toLowerCase()](o2, l2, a2) : "interpolate-hcl" === this.operator ? va.reverse(va.interpolate(va.forward(o2), va.forward(l2), a2)) : ba.reverse(ba.interpolate(ba.forward(o2), ba.forward(l2), a2));
          }
          eachChild(t2) {
            t2(this.input);
            for (const e2 of this.outputs)
              t2(e2);
          }
          outputDefined() {
            return this.outputs.every((t2) => t2.outputDefined());
          }
          serialize() {
            let t2;
            t2 = "linear" === this.interpolation.name ? ["linear"] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? ["linear"] : ["exponential", this.interpolation.base] : ["cubic-bezier"].concat(this.interpolation.controlPoints);
            const e2 = [this.operator, t2, this.input.serialize()];
            for (let t3 = 0; t3 < this.labels.length; t3++)
              e2.push(this.labels[t3], this.outputs[t3].serialize());
            return e2;
          }
        }
        function Ma(t2, e2, r2, n2) {
          const i2 = n2 - r2, s2 = t2 - r2;
          return 0 === i2 ? 0 : 1 === e2 ? s2 / i2 : (Math.pow(e2, s2) - 1) / (Math.pow(e2, i2) - 1);
        }
        class Aa {
          constructor(t2, e2) {
            this.type = t2, this.args = e2;
          }
          static parse(t2, e2) {
            if (t2.length < 2)
              return e2.error("Expectected at least one argument.");
            let r2 = null;
            const n2 = e2.expectedType;
            n2 && "value" !== n2.kind && (r2 = n2);
            const i2 = [];
            for (const n3 of t2.slice(1)) {
              const t3 = e2.parse(n3, 1 + i2.length, r2, void 0, { typeAnnotation: "omit" });
              if (!t3)
                return null;
              r2 = r2 || t3.type, i2.push(t3);
            }
            const s2 = n2 && i2.some((t3) => pi(n2, t3.type));
            return new Aa(s2 ? si : r2, i2);
          }
          evaluate(t2) {
            let e2, r2 = null, n2 = 0;
            for (const i2 of this.args) {
              if (n2++, r2 = i2.evaluate(t2), r2 && r2 instanceof xi && !r2.available && (e2 || (e2 = r2), r2 = null, n2 === this.args.length))
                return e2;
              if (null !== r2)
                break;
            }
            return r2;
          }
          eachChild(t2) {
            this.args.forEach(t2);
          }
          outputDefined() {
            return this.args.every((t2) => t2.outputDefined());
          }
          serialize() {
            const t2 = ["coalesce"];
            return this.eachChild((e2) => {
              t2.push(e2.serialize());
            }), t2;
          }
        }
        class Sa {
          constructor(t2, e2) {
            this.type = e2.type, this.bindings = [].concat(t2), this.result = e2;
          }
          evaluate(t2) {
            return this.result.evaluate(t2);
          }
          eachChild(t2) {
            for (const e2 of this.bindings)
              t2(e2[1]);
            t2(this.result);
          }
          static parse(t2, e2) {
            if (t2.length < 4)
              return e2.error(`Expected at least 3 arguments, but found ${t2.length - 1} instead.`);
            const r2 = [];
            for (let n3 = 1; n3 < t2.length - 1; n3 += 2) {
              const i2 = t2[n3];
              if ("string" != typeof i2)
                return e2.error(`Expected string, but found ${typeof i2} instead.`, n3);
              if (/[^a-zA-Z0-9_]/.test(i2))
                return e2.error("Variable names must contain only alphanumeric characters or '_'.", n3);
              const s2 = e2.parse(t2[n3 + 1], n3 + 1);
              if (!s2)
                return null;
              r2.push([i2, s2]);
            }
            const n2 = e2.parse(t2[t2.length - 1], t2.length - 1, e2.expectedType, r2);
            return n2 ? new Sa(r2, n2) : null;
          }
          outputDefined() {
            return this.result.outputDefined();
          }
          serialize() {
            const t2 = ["let"];
            for (const [e2, r2] of this.bindings)
              t2.push(e2, r2.serialize());
            return t2.push(this.result.serialize()), t2;
          }
        }
        class Ia {
          constructor(t2, e2, r2) {
            this.type = t2, this.index = e2, this.input = r2;
          }
          static parse(t2, e2) {
            if (3 !== t2.length)
              return e2.error(`Expected 2 arguments, but found ${t2.length - 1} instead.`);
            const r2 = e2.parse(t2[1], 1, ti), n2 = e2.parse(t2[2], 2, ui(e2.expectedType || si));
            return r2 && n2 ? new Ia(n2.type.itemType, r2, n2) : null;
          }
          evaluate(t2) {
            const e2 = this.index.evaluate(t2), r2 = this.input.evaluate(t2);
            if (e2 < 0)
              throw new Ai(`Array index out of bounds: ${e2} < 0.`);
            if (e2 >= r2.length)
              throw new Ai(`Array index out of bounds: ${e2} > ${r2.length - 1}.`);
            if (e2 !== Math.floor(e2))
              throw new Ai(`Array index must be an integer, but found ${e2} instead.`);
            return r2[e2];
          }
          eachChild(t2) {
            t2(this.index), t2(this.input);
          }
          outputDefined() {
            return false;
          }
          serialize() {
            return ["at", this.index.serialize(), this.input.serialize()];
          }
        }
        class Ta {
          constructor(t2, e2) {
            this.type = ri, this.needle = t2, this.haystack = e2;
          }
          static parse(t2, e2) {
            if (3 !== t2.length)
              return e2.error(`Expected 2 arguments, but found ${t2.length - 1} instead.`);
            const r2 = e2.parse(t2[1], 1, si), n2 = e2.parse(t2[2], 2, si);
            return r2 && n2 ? fi(r2.type, [ri, ei, ti, Qn, si]) ? new Ta(r2, n2) : e2.error(`Expected first argument to be of type boolean, string, number or null, but found ${ci(r2.type)} instead`) : null;
          }
          evaluate(t2) {
            const e2 = this.needle.evaluate(t2), r2 = this.haystack.evaluate(t2);
            if (null == r2)
              return false;
            if (!di(e2, ["boolean", "string", "number", "null"]))
              throw new Ai(`Expected first argument to be of type boolean, string, number or null, but found ${ci(_i(e2))} instead.`);
            if (!di(r2, ["string", "array"]))
              throw new Ai(`Expected second argument to be of type array or string, but found ${ci(_i(r2))} instead.`);
            return r2.indexOf(e2) >= 0;
          }
          eachChild(t2) {
            t2(this.needle), t2(this.haystack);
          }
          outputDefined() {
            return true;
          }
          serialize() {
            return ["in", this.needle.serialize(), this.haystack.serialize()];
          }
        }
        class ka {
          constructor(t2, e2, r2) {
            this.type = ti, this.needle = t2, this.haystack = e2, this.fromIndex = r2;
          }
          static parse(t2, e2) {
            if (t2.length <= 2 || t2.length >= 5)
              return e2.error(`Expected 3 or 4 arguments, but found ${t2.length - 1} instead.`);
            const r2 = e2.parse(t2[1], 1, si), n2 = e2.parse(t2[2], 2, si);
            if (!r2 || !n2)
              return null;
            if (!fi(r2.type, [ri, ei, ti, Qn, si]))
              return e2.error(`Expected first argument to be of type boolean, string, number or null, but found ${ci(r2.type)} instead`);
            if (4 === t2.length) {
              const i2 = e2.parse(t2[3], 3, ti);
              return i2 ? new ka(r2, n2, i2) : null;
            }
            return new ka(r2, n2);
          }
          evaluate(t2) {
            const e2 = this.needle.evaluate(t2), r2 = this.haystack.evaluate(t2);
            if (!di(e2, ["boolean", "string", "number", "null"]))
              throw new Ai(`Expected first argument to be of type boolean, string, number or null, but found ${ci(_i(e2))} instead.`);
            if (!di(r2, ["string", "array"]))
              throw new Ai(`Expected second argument to be of type array or string, but found ${ci(_i(r2))} instead.`);
            if (this.fromIndex) {
              const n2 = this.fromIndex.evaluate(t2);
              return r2.indexOf(e2, n2);
            }
            return r2.indexOf(e2);
          }
          eachChild(t2) {
            t2(this.needle), t2(this.haystack), this.fromIndex && t2(this.fromIndex);
          }
          outputDefined() {
            return false;
          }
          serialize() {
            if (null != this.fromIndex && void 0 !== this.fromIndex) {
              const t2 = this.fromIndex.serialize();
              return ["index-of", this.needle.serialize(), this.haystack.serialize(), t2];
            }
            return ["index-of", this.needle.serialize(), this.haystack.serialize()];
          }
        }
        class Pa {
          constructor(t2, e2, r2, n2, i2, s2) {
            this.inputType = t2, this.type = e2, this.input = r2, this.cases = n2, this.outputs = i2, this.otherwise = s2;
          }
          static parse(t2, e2) {
            if (t2.length < 5)
              return e2.error(`Expected at least 4 arguments, but found only ${t2.length - 1}.`);
            if (t2.length % 2 != 1)
              return e2.error("Expected an even number of arguments.");
            let r2, n2;
            e2.expectedType && "value" !== e2.expectedType.kind && (n2 = e2.expectedType);
            const i2 = {}, s2 = [];
            for (let a3 = 2; a3 < t2.length - 1; a3 += 2) {
              let o3 = t2[a3];
              const l2 = t2[a3 + 1];
              Array.isArray(o3) || (o3 = [o3]);
              const u2 = e2.concat(a3);
              if (0 === o3.length)
                return u2.error("Expected at least one branch label.");
              for (const t3 of o3) {
                if ("number" != typeof t3 && "string" != typeof t3)
                  return u2.error("Branch labels must be numbers or strings.");
                if ("number" == typeof t3 && Math.abs(t3) > Number.MAX_SAFE_INTEGER)
                  return u2.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                if ("number" == typeof t3 && Math.floor(t3) !== t3)
                  return u2.error("Numeric branch labels must be integer values.");
                if (r2) {
                  if (u2.checkSubtype(r2, _i(t3)))
                    return null;
                } else
                  r2 = _i(t3);
                if (void 0 !== i2[String(t3)])
                  return u2.error("Branch labels must be unique.");
                i2[String(t3)] = s2.length;
              }
              const c2 = e2.parse(l2, a3, n2);
              if (!c2)
                return null;
              n2 = n2 || c2.type, s2.push(c2);
            }
            const a2 = e2.parse(t2[1], 1, si);
            if (!a2)
              return null;
            const o2 = e2.parse(t2[t2.length - 1], t2.length - 1, n2);
            return o2 ? "value" !== a2.type.kind && e2.concat(1).checkSubtype(r2, a2.type) ? null : new Pa(r2, n2, a2, i2, s2, o2) : null;
          }
          evaluate(t2) {
            const e2 = this.input.evaluate(t2);
            return (_i(e2) === this.inputType && this.outputs[this.cases[e2]] || this.otherwise).evaluate(t2);
          }
          eachChild(t2) {
            t2(this.input), this.outputs.forEach(t2), t2(this.otherwise);
          }
          outputDefined() {
            return this.outputs.every((t2) => t2.outputDefined()) && this.otherwise.outputDefined();
          }
          serialize() {
            const t2 = ["match", this.input.serialize()], e2 = Object.keys(this.cases).sort(), r2 = [], n2 = {};
            for (const t3 of e2) {
              const e3 = n2[this.cases[t3]];
              void 0 === e3 ? (n2[this.cases[t3]] = r2.length, r2.push([this.cases[t3], [t3]])) : r2[e3][1].push(t3);
            }
            const i2 = (t3) => "number" === this.inputType.kind ? Number(t3) : t3;
            for (const [e3, n3] of r2)
              t2.push(1 === n3.length ? i2(n3[0]) : n3.map(i2)), t2.push(this.outputs[e3].serialize());
            return t2.push(this.otherwise.serialize()), t2;
          }
        }
        class za {
          constructor(t2, e2, r2) {
            this.type = t2, this.branches = e2, this.otherwise = r2;
          }
          static parse(t2, e2) {
            if (t2.length < 4)
              return e2.error(`Expected at least 3 arguments, but found only ${t2.length - 1}.`);
            if (t2.length % 2 != 0)
              return e2.error("Expected an odd number of arguments.");
            let r2;
            e2.expectedType && "value" !== e2.expectedType.kind && (r2 = e2.expectedType);
            const n2 = [];
            for (let i3 = 1; i3 < t2.length - 1; i3 += 2) {
              const s2 = e2.parse(t2[i3], i3, ri);
              if (!s2)
                return null;
              const a2 = e2.parse(t2[i3 + 1], i3 + 1, r2);
              if (!a2)
                return null;
              n2.push([s2, a2]), r2 = r2 || a2.type;
            }
            const i2 = e2.parse(t2[t2.length - 1], t2.length - 1, r2);
            return i2 ? new za(r2, n2, i2) : null;
          }
          evaluate(t2) {
            for (const [e2, r2] of this.branches)
              if (e2.evaluate(t2))
                return r2.evaluate(t2);
            return this.otherwise.evaluate(t2);
          }
          eachChild(t2) {
            for (const [e2, r2] of this.branches)
              t2(e2), t2(r2);
            t2(this.otherwise);
          }
          outputDefined() {
            return this.branches.every(([t2, e2]) => e2.outputDefined()) && this.otherwise.outputDefined();
          }
          serialize() {
            const t2 = ["case"];
            return this.eachChild((e2) => {
              t2.push(e2.serialize());
            }), t2;
          }
        }
        class Ea {
          constructor(t2, e2, r2, n2) {
            this.type = t2, this.input = e2, this.beginIndex = r2, this.endIndex = n2;
          }
          static parse(t2, e2) {
            if (t2.length <= 2 || t2.length >= 5)
              return e2.error(`Expected 3 or 4 arguments, but found ${t2.length - 1} instead.`);
            const r2 = e2.parse(t2[1], 1, si), n2 = e2.parse(t2[2], 2, ti);
            if (!r2 || !n2)
              return null;
            if (!fi(r2.type, [ui(si), ei, si]))
              return e2.error(`Expected first argument to be of type array or string, but found ${ci(r2.type)} instead`);
            if (4 === t2.length) {
              const i2 = e2.parse(t2[3], 3, ti);
              return i2 ? new Ea(r2.type, r2, n2, i2) : null;
            }
            return new Ea(r2.type, r2, n2);
          }
          evaluate(t2) {
            const e2 = this.input.evaluate(t2), r2 = this.beginIndex.evaluate(t2);
            if (!di(e2, ["string", "array"]))
              throw new Ai(`Expected first argument to be of type array or string, but found ${ci(_i(e2))} instead.`);
            if (this.endIndex) {
              const n2 = this.endIndex.evaluate(t2);
              return e2.slice(r2, n2);
            }
            return e2.slice(r2);
          }
          eachChild(t2) {
            t2(this.input), t2(this.beginIndex), this.endIndex && t2(this.endIndex);
          }
          outputDefined() {
            return false;
          }
          serialize() {
            if (null != this.endIndex && void 0 !== this.endIndex) {
              const t2 = this.endIndex.serialize();
              return ["slice", this.input.serialize(), this.beginIndex.serialize(), t2];
            }
            return ["slice", this.input.serialize(), this.beginIndex.serialize()];
          }
        }
        function Ba(t2, e2) {
          return "==" === t2 || "!=" === t2 ? "boolean" === e2.kind || "string" === e2.kind || "number" === e2.kind || "null" === e2.kind || "value" === e2.kind : "string" === e2.kind || "number" === e2.kind || "value" === e2.kind;
        }
        function Da(t2, e2, r2, n2) {
          return 0 === n2.compare(e2, r2);
        }
        function Ra(t2, e2, r2) {
          const n2 = "==" !== t2 && "!=" !== t2;
          return class i2 {
            constructor(t3, e3, r3) {
              this.type = ri, this.lhs = t3, this.rhs = e3, this.collator = r3, this.hasUntypedArgument = "value" === t3.type.kind || "value" === e3.type.kind;
            }
            static parse(t3, e3) {
              if (3 !== t3.length && 4 !== t3.length)
                return e3.error("Expected two or three arguments.");
              const r3 = t3[0];
              let s2 = e3.parse(t3[1], 1, si);
              if (!s2)
                return null;
              if (!Ba(r3, s2.type))
                return e3.concat(1).error(`"${r3}" comparisons are not supported for type '${ci(s2.type)}'.`);
              let a2 = e3.parse(t3[2], 2, si);
              if (!a2)
                return null;
              if (!Ba(r3, a2.type))
                return e3.concat(2).error(`"${r3}" comparisons are not supported for type '${ci(a2.type)}'.`);
              if (s2.type.kind !== a2.type.kind && "value" !== s2.type.kind && "value" !== a2.type.kind)
                return e3.error(`Cannot compare types '${ci(s2.type)}' and '${ci(a2.type)}'.`);
              n2 && ("value" === s2.type.kind && "value" !== a2.type.kind ? s2 = new Ii(a2.type, [s2]) : "value" !== s2.type.kind && "value" === a2.type.kind && (a2 = new Ii(s2.type, [a2])));
              let o2 = null;
              if (4 === t3.length) {
                if ("string" !== s2.type.kind && "string" !== a2.type.kind && "value" !== s2.type.kind && "value" !== a2.type.kind)
                  return e3.error("Cannot use collator to compare non-string types.");
                if (o2 = e3.parse(t3[3], 3, ai), !o2)
                  return null;
              }
              return new i2(s2, a2, o2);
            }
            evaluate(i3) {
              const s2 = this.lhs.evaluate(i3), a2 = this.rhs.evaluate(i3);
              if (n2 && this.hasUntypedArgument) {
                const e3 = _i(s2), r3 = _i(a2);
                if (e3.kind !== r3.kind || "string" !== e3.kind && "number" !== e3.kind)
                  throw new Ai(`Expected arguments for "${t2}" to be (string, string) or (number, number), but found (${e3.kind}, ${r3.kind}) instead.`);
              }
              if (this.collator && !n2 && this.hasUntypedArgument) {
                const t3 = _i(s2), r3 = _i(a2);
                if ("string" !== t3.kind || "string" !== r3.kind)
                  return e2(i3, s2, a2);
              }
              return this.collator ? r2(i3, s2, a2, this.collator.evaluate(i3)) : e2(i3, s2, a2);
            }
            eachChild(t3) {
              t3(this.lhs), t3(this.rhs), this.collator && t3(this.collator);
            }
            outputDefined() {
              return true;
            }
            serialize() {
              const e3 = [t2];
              return this.eachChild((t3) => {
                e3.push(t3.serialize());
              }), e3;
            }
          };
        }
        const Ca = Ra("==", function(t2, e2, r2) {
          return e2 === r2;
        }, Da), La = Ra("!=", function(t2, e2, r2) {
          return e2 !== r2;
        }, function(t2, e2, r2, n2) {
          return !Da(0, e2, r2, n2);
        }), Va = Ra("<", function(t2, e2, r2) {
          return e2 < r2;
        }, function(t2, e2, r2, n2) {
          return n2.compare(e2, r2) < 0;
        }), Fa = Ra(">", function(t2, e2, r2) {
          return e2 > r2;
        }, function(t2, e2, r2, n2) {
          return n2.compare(e2, r2) > 0;
        }), Oa = Ra("<=", function(t2, e2, r2) {
          return e2 <= r2;
        }, function(t2, e2, r2, n2) {
          return n2.compare(e2, r2) <= 0;
        }), Ua = Ra(">=", function(t2, e2, r2) {
          return e2 >= r2;
        }, function(t2, e2, r2, n2) {
          return n2.compare(e2, r2) >= 0;
        });
        class ja {
          constructor(t2, e2, r2, n2, i2, s2) {
            this.type = ei, this.number = t2, this.locale = e2, this.currency = r2, this.unit = n2, this.minFractionDigits = i2, this.maxFractionDigits = s2;
          }
          static parse(t2, e2) {
            if (3 !== t2.length)
              return e2.error("Expected two arguments.");
            const r2 = e2.parse(t2[1], 1, ti);
            if (!r2)
              return null;
            const n2 = t2[2];
            if ("object" != typeof n2 || Array.isArray(n2))
              return e2.error("NumberFormat options argument must be an object.");
            let i2 = null;
            if (n2.locale && (i2 = e2.parse(n2.locale, 1, ei), !i2))
              return null;
            let s2 = null;
            if (n2.currency && (s2 = e2.parse(n2.currency, 1, ei), !s2))
              return null;
            let a2 = null;
            if (n2.unit && (a2 = e2.parse(n2.unit, 1, ei), !a2))
              return null;
            let o2 = null;
            if (n2["min-fraction-digits"] && (o2 = e2.parse(n2["min-fraction-digits"], 1, ti), !o2))
              return null;
            let l2 = null;
            return n2["max-fraction-digits"] && (l2 = e2.parse(n2["max-fraction-digits"], 1, ti), !l2) ? null : new ja(r2, i2, s2, a2, o2, l2);
          }
          evaluate(t2) {
            return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t2) : [], { style: (this.currency ? "currency" : this.unit && "unit") || "decimal", currency: this.currency ? this.currency.evaluate(t2) : void 0, unit: this.unit ? this.unit.evaluate(t2) : void 0, minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t2) : void 0, maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t2) : void 0 }).format(this.number.evaluate(t2));
          }
          eachChild(t2) {
            t2(this.number), this.locale && t2(this.locale), this.currency && t2(this.currency), this.unit && t2(this.unit), this.minFractionDigits && t2(this.minFractionDigits), this.maxFractionDigits && t2(this.maxFractionDigits);
          }
          outputDefined() {
            return false;
          }
          serialize() {
            const t2 = {};
            return this.locale && (t2.locale = this.locale.serialize()), this.currency && (t2.currency = this.currency.serialize()), this.unit && (t2.unit = this.unit.serialize()), this.minFractionDigits && (t2["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t2["max-fraction-digits"] = this.maxFractionDigits.serialize()), ["number-format", this.number.serialize(), t2];
          }
        }
        class Na {
          constructor(t2) {
            this.type = ti, this.input = t2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length)
              return e2.error(`Expected 1 argument, but found ${t2.length - 1} instead.`);
            const r2 = e2.parse(t2[1], 1);
            return r2 ? "array" !== r2.type.kind && "string" !== r2.type.kind && "value" !== r2.type.kind ? e2.error(`Expected argument of type string or array, but found ${ci(r2.type)} instead.`) : new Na(r2) : null;
          }
          evaluate(t2) {
            const e2 = this.input.evaluate(t2);
            if ("string" == typeof e2)
              return e2.length;
            if (Array.isArray(e2))
              return e2.length;
            throw new Ai(`Expected value to be of type string or array, but found ${ci(_i(e2))} instead.`);
          }
          eachChild(t2) {
            t2(this.input);
          }
          outputDefined() {
            return false;
          }
          serialize() {
            const t2 = ["length"];
            return this.eachChild((e2) => {
              t2.push(e2.serialize());
            }), t2;
          }
        }
        function $a(t2) {
          return function() {
            t2 = 1831565813 + (t2 |= 0) | 0;
            let e2 = Math.imul(t2 ^ t2 >>> 15, 1 | t2);
            return e2 = e2 + Math.imul(e2 ^ e2 >>> 7, 61 | e2) ^ e2, ((e2 ^ e2 >>> 14) >>> 0) / 4294967296;
          };
        }
        const qa = { "==": Ca, "!=": La, ">": Fa, "<": Va, ">=": Ua, "<=": Oa, array: Ii, at: Ia, boolean: Ii, case: za, coalesce: Aa, collator: Li, format: Ti, image: ki, in: Ta, "index-of": ka, interpolate: wa, "interpolate-hcl": wa, "interpolate-lab": wa, length: Na, let: Sa, literal: Mi, match: Pa, number: Ii, "number-format": ja, object: Ii, slice: Ea, step: na, string: Ii, "to-boolean": Ei, "to-color": Ei, "to-number": Ei, "to-string": Ei, var: Js, within: is, distance: qs, config: Ys };
        function Ga(t2, [e2, r2, n2, i2]) {
          e2 = e2.evaluate(t2), r2 = r2.evaluate(t2), n2 = n2.evaluate(t2);
          const s2 = i2 ? i2.evaluate(t2) : 1, a2 = bi(e2, r2, n2, s2);
          if (a2)
            throw new Ai(a2);
          return new Gn(e2 / 255 * s2, r2 / 255 * s2, n2 / 255 * s2, s2);
        }
        function Xa(t2, [e2, r2, n2, i2]) {
          e2 = e2.evaluate(t2), r2 = r2.evaluate(t2), n2 = n2.evaluate(t2);
          const s2 = i2 ? i2.evaluate(t2) : 1, a2 = function(t3, e3, r3, n3) {
            return "number" == typeof t3 && t3 >= 0 && t3 <= 360 ? "number" == typeof e3 && e3 >= 0 && e3 <= 100 && "number" == typeof r3 && r3 >= 0 && r3 <= 100 ? void 0 === n3 || "number" == typeof n3 && n3 >= 0 && n3 <= 1 ? null : `Invalid hsla value [${[t3, e3, r3, n3].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid hsla value [${("number" == typeof n3 ? [t3, e3, r3, n3] : [t3, e3, r3]).join(", ")}]: 's', and 'l' must be between 0 and 100.` : `Invalid hsla value [${("number" == typeof n3 ? [t3, e3, r3, n3] : [t3, e3, r3]).join(", ")}]: 'h' must be between 0 and 360.`;
          }(e2, r2, n2, s2);
          if (a2)
            throw new Ai(a2);
          const o2 = `hsla(${e2}, ${r2}%, ${n2}%, ${s2})`, l2 = Gn.parse(o2);
          if (!l2)
            throw new Ai(`Failed to parse HSLA color: ${o2}`);
          return l2;
        }
        function Ya(t2, e2) {
          return t2 in e2;
        }
        function Za(t2, e2) {
          const r2 = e2[t2];
          return void 0 === r2 ? null : r2;
        }
        function Ha(t2) {
          return { type: t2 };
        }
        function Ka(t2) {
          return { result: "success", value: t2 };
        }
        function Wa(t2) {
          return { result: "error", value: t2 };
        }
        function Ja(t2, e2) {
          return !!t2 && !!t2.parameters && t2.parameters.indexOf(e2) > -1;
        }
        function Qa(t2) {
          return "data-driven" === t2["property-type"];
        }
        function to(t2) {
          return Ja(t2.expression, "measure-light");
        }
        function eo(t2) {
          return Ja(t2.expression, "zoom");
        }
        function ro(t2) {
          return !!t2.expression && t2.expression.interpolated;
        }
        function no(t2) {
          return "object" == typeof t2 && null !== t2 && !Array.isArray(t2);
        }
        function io(t2) {
          return t2;
        }
        function so(t2, e2) {
          const r2 = "color" === e2.type, n2 = t2.stops && "object" == typeof t2.stops[0][0], i2 = n2 || !(n2 || void 0 !== t2.property), s2 = t2.type || (ro(e2) ? "exponential" : "interval");
          if (r2 && ((t2 = Kn({}, t2)).stops && (t2.stops = t2.stops.map((t3) => [t3[0], Gn.parse(t3[1])])), t2.default = Gn.parse(t2.default ? t2.default : e2.default)), t2.colorSpace && "rgb" !== t2.colorSpace && !_a[t2.colorSpace])
            throw new Error(`Unknown color space: ${t2.colorSpace}`);
          let a2, o2, l2;
          if ("exponential" === s2)
            a2 = uo;
          else if ("interval" === s2)
            a2 = lo;
          else if ("categorical" === s2) {
            a2 = oo, o2 = /* @__PURE__ */ Object.create(null);
            for (const e3 of t2.stops)
              o2[e3[0]] = e3[1];
            l2 = typeof t2.stops[0][0];
          } else {
            if ("identity" !== s2)
              throw new Error(`Unknown function type "${s2}"`);
            a2 = co;
          }
          if (n2) {
            const r3 = {}, n3 = [];
            for (let e3 = 0; e3 < t2.stops.length; e3++) {
              const i4 = t2.stops[e3], s4 = i4[0].zoom;
              void 0 === r3[s4] && (r3[s4] = { zoom: s4, type: t2.type, property: t2.property, default: t2.default, stops: [] }, n3.push(s4)), r3[s4].stops.push([i4[0].value, i4[1]]);
            }
            const i3 = [];
            for (const t3 of n3)
              i3.push([r3[t3].zoom, so(r3[t3], e2)]);
            const s3 = { name: "linear" };
            return { kind: "composite", interpolationType: s3, interpolationFactor: wa.interpolationFactor.bind(void 0, s3), zoomStops: i3.map((t3) => t3[0]), evaluate: ({ zoom: r4 }, n4) => uo({ stops: i3, base: t2.base }, e2, r4).evaluate(r4, n4) };
          }
          if (i2) {
            const r3 = "exponential" === s2 ? { name: "exponential", base: void 0 !== t2.base ? t2.base : 1 } : null;
            return { kind: "camera", interpolationType: r3, interpolationFactor: wa.interpolationFactor.bind(void 0, r3), zoomStops: t2.stops.map((t3) => t3[0]), evaluate: ({ zoom: r4 }) => a2(t2, e2, r4, o2, l2) };
          }
          return { kind: "source", evaluate(r3, n3) {
            const i3 = n3 && n3.properties ? n3.properties[t2.property] : void 0;
            return void 0 === i3 ? ao(t2.default, e2.default) : a2(t2, e2, i3, o2, l2);
          } };
        }
        function ao(t2, e2, r2) {
          return void 0 !== t2 ? t2 : void 0 !== e2 ? e2 : void 0 !== r2 ? r2 : void 0;
        }
        function oo(t2, e2, r2, n2, i2) {
          return ao(typeof r2 === i2 ? n2[r2] : void 0, t2.default, e2.default);
        }
        function lo(t2, e2, r2) {
          if ("number" !== Pi(r2))
            return ao(t2.default, e2.default);
          const n2 = t2.stops.length;
          if (1 === n2)
            return t2.stops[0][1];
          if (r2 <= t2.stops[0][0])
            return t2.stops[0][1];
          if (r2 >= t2.stops[n2 - 1][0])
            return t2.stops[n2 - 1][1];
          const i2 = ra(t2.stops.map((t3) => t3[0]), r2);
          return t2.stops[i2][1];
        }
        function uo(t2, e2, r2) {
          const n2 = void 0 !== t2.base ? t2.base : 1;
          if ("number" !== Pi(r2))
            return ao(t2.default, e2.default);
          const i2 = t2.stops.length;
          if (1 === i2)
            return t2.stops[0][1];
          if (r2 <= t2.stops[0][0])
            return t2.stops[0][1];
          if (r2 >= t2.stops[i2 - 1][0])
            return t2.stops[i2 - 1][1];
          const s2 = ra(t2.stops.map((t3) => t3[0]), r2), a2 = function(t3, e3, r3, n3) {
            const i3 = n3 - r3, s3 = t3 - r3;
            return 0 === i3 ? 0 : 1 === e3 ? s3 / i3 : (Math.pow(e3, s3) - 1) / (Math.pow(e3, i3) - 1);
          }(r2, n2, t2.stops[s2][0], t2.stops[s2 + 1][0]), o2 = t2.stops[s2][1], l2 = t2.stops[s2 + 1][1];
          let u2 = Hn[e2.type] || io;
          if (t2.colorSpace && "rgb" !== t2.colorSpace) {
            const e3 = _a[t2.colorSpace];
            u2 = (t3, r3) => e3.reverse(e3.interpolate(e3.forward(t3), e3.forward(r3), a2));
          }
          return "function" == typeof o2.evaluate ? { evaluate(...t3) {
            const e3 = o2.evaluate.apply(void 0, t3), r3 = l2.evaluate.apply(void 0, t3);
            if (void 0 !== e3 && void 0 !== r3)
              return u2(e3, r3, a2);
          } } : u2(o2, l2, a2);
        }
        function co(t2, e2, r2) {
          return "color" === e2.type ? r2 = Gn.parse(r2) : "formatted" === e2.type ? r2 = gi.fromString(r2.toString()) : "resolvedImage" === e2.type ? r2 = xi.fromString(r2.toString()) : Pi(r2) === e2.type || "enum" === e2.type && e2.values[r2] || (r2 = void 0), ao(r2, t2.default, e2.default);
        }
        Ri.register(qa, { error: [{ kind: "error" }, [ei], (t2, [e2]) => {
          throw new Ai(e2.evaluate(t2));
        }], typeof: [ei, [si], (t2, [e2]) => ci(_i(e2.evaluate(t2)))], "to-rgba": [ui(ti, 4), [ni], (t2, [e2]) => e2.evaluate(t2).toRenderColor(null).toArray()], rgb: [ni, [ti, ti, ti], Ga], rgba: [ni, [ti, ti, ti, ti], Ga], hsl: [ni, [ti, ti, ti], Xa], hsla: [ni, [ti, ti, ti, ti], Xa], has: { type: ri, overloads: [[[ei], (t2, [e2]) => Ya(e2.evaluate(t2), t2.properties())], [[ei, ii], (t2, [e2, r2]) => Ya(e2.evaluate(t2), r2.evaluate(t2))]] }, get: { type: si, overloads: [[[ei], (t2, [e2]) => Za(e2.evaluate(t2), t2.properties())], [[ei, ii], (t2, [e2, r2]) => Za(e2.evaluate(t2), r2.evaluate(t2))]] }, "feature-state": [si, [ei], (t2, [e2]) => Za(e2.evaluate(t2), t2.featureState || {})], properties: [ii, [], (t2) => t2.properties()], "geometry-type": [ei, [], (t2) => t2.geometryType()], id: [si, [], (t2) => t2.id()], zoom: [ti, [], (t2) => t2.globals.zoom], pitch: [ti, [], (t2) => t2.globals.pitch || 0], "distance-from-center": [ti, [], (t2) => t2.distanceFromCenter()], "measure-light": [ti, [ei], (t2, [e2]) => t2.measureLight(e2.evaluate(t2))], "heatmap-density": [ti, [], (t2) => t2.globals.heatmapDensity || 0], "line-progress": [ti, [], (t2) => t2.globals.lineProgress || 0], "raster-value": [ti, [], (t2) => t2.globals.rasterValue || 0], "raster-particle-speed": [ti, [], (t2) => t2.globals.rasterParticleSpeed || 0], "sky-radial-progress": [ti, [], (t2) => t2.globals.skyRadialProgress || 0], accumulated: [si, [], (t2) => void 0 === t2.globals.accumulated ? null : t2.globals.accumulated], "+": [ti, Ha(ti), (t2, e2) => {
          let r2 = 0;
          for (const n2 of e2)
            r2 += n2.evaluate(t2);
          return r2;
        }], "*": [ti, Ha(ti), (t2, e2) => {
          let r2 = 1;
          for (const n2 of e2)
            r2 *= n2.evaluate(t2);
          return r2;
        }], "-": { type: ti, overloads: [[[ti, ti], (t2, [e2, r2]) => e2.evaluate(t2) - r2.evaluate(t2)], [[ti], (t2, [e2]) => -e2.evaluate(t2)]] }, "/": [ti, [ti, ti], (t2, [e2, r2]) => e2.evaluate(t2) / r2.evaluate(t2)], "%": [ti, [ti, ti], (t2, [e2, r2]) => e2.evaluate(t2) % r2.evaluate(t2)], ln2: [ti, [], () => Math.LN2], pi: [ti, [], () => Math.PI], e: [ti, [], () => Math.E], "^": [ti, [ti, ti], (t2, [e2, r2]) => Math.pow(e2.evaluate(t2), r2.evaluate(t2))], sqrt: [ti, [ti], (t2, [e2]) => Math.sqrt(e2.evaluate(t2))], log10: [ti, [ti], (t2, [e2]) => Math.log(e2.evaluate(t2)) / Math.LN10], ln: [ti, [ti], (t2, [e2]) => Math.log(e2.evaluate(t2))], log2: [ti, [ti], (t2, [e2]) => Math.log(e2.evaluate(t2)) / Math.LN2], sin: [ti, [ti], (t2, [e2]) => Math.sin(e2.evaluate(t2))], cos: [ti, [ti], (t2, [e2]) => Math.cos(e2.evaluate(t2))], tan: [ti, [ti], (t2, [e2]) => Math.tan(e2.evaluate(t2))], asin: [ti, [ti], (t2, [e2]) => Math.asin(e2.evaluate(t2))], acos: [ti, [ti], (t2, [e2]) => Math.acos(e2.evaluate(t2))], atan: [ti, [ti], (t2, [e2]) => Math.atan(e2.evaluate(t2))], min: [ti, Ha(ti), (t2, e2) => Math.min(...e2.map((e3) => e3.evaluate(t2)))], max: [ti, Ha(ti), (t2, e2) => Math.max(...e2.map((e3) => e3.evaluate(t2)))], abs: [ti, [ti], (t2, [e2]) => Math.abs(e2.evaluate(t2))], round: [ti, [ti], (t2, [e2]) => {
          const r2 = e2.evaluate(t2);
          return r2 < 0 ? -Math.round(-r2) : Math.round(r2);
        }], floor: [ti, [ti], (t2, [e2]) => Math.floor(e2.evaluate(t2))], ceil: [ti, [ti], (t2, [e2]) => Math.ceil(e2.evaluate(t2))], "filter-==": [ri, [ei, si], (t2, [e2, r2]) => t2.properties()[e2.value] === r2.value], "filter-id-==": [ri, [si], (t2, [e2]) => t2.id() === e2.value], "filter-type-==": [ri, [ei], (t2, [e2]) => t2.geometryType() === e2.value], "filter-<": [ri, [ei, si], (t2, [e2, r2]) => {
          const n2 = t2.properties()[e2.value], i2 = r2.value;
          return typeof n2 == typeof i2 && n2 < i2;
        }], "filter-id-<": [ri, [si], (t2, [e2]) => {
          const r2 = t2.id(), n2 = e2.value;
          return typeof r2 == typeof n2 && r2 < n2;
        }], "filter->": [ri, [ei, si], (t2, [e2, r2]) => {
          const n2 = t2.properties()[e2.value], i2 = r2.value;
          return typeof n2 == typeof i2 && n2 > i2;
        }], "filter-id->": [ri, [si], (t2, [e2]) => {
          const r2 = t2.id(), n2 = e2.value;
          return typeof r2 == typeof n2 && r2 > n2;
        }], "filter-<=": [ri, [ei, si], (t2, [e2, r2]) => {
          const n2 = t2.properties()[e2.value], i2 = r2.value;
          return typeof n2 == typeof i2 && n2 <= i2;
        }], "filter-id-<=": [ri, [si], (t2, [e2]) => {
          const r2 = t2.id(), n2 = e2.value;
          return typeof r2 == typeof n2 && r2 <= n2;
        }], "filter->=": [ri, [ei, si], (t2, [e2, r2]) => {
          const n2 = t2.properties()[e2.value], i2 = r2.value;
          return typeof n2 == typeof i2 && n2 >= i2;
        }], "filter-id->=": [ri, [si], (t2, [e2]) => {
          const r2 = t2.id(), n2 = e2.value;
          return typeof r2 == typeof n2 && r2 >= n2;
        }], "filter-has": [ri, [si], (t2, [e2]) => e2.value in t2.properties()], "filter-has-id": [ri, [], (t2) => null !== t2.id() && void 0 !== t2.id()], "filter-type-in": [ri, [ui(ei)], (t2, [e2]) => e2.value.indexOf(t2.geometryType()) >= 0], "filter-id-in": [ri, [ui(si)], (t2, [e2]) => e2.value.indexOf(t2.id()) >= 0], "filter-in-small": [ri, [ei, ui(si)], (t2, [e2, r2]) => r2.value.indexOf(t2.properties()[e2.value]) >= 0], "filter-in-large": [ri, [ei, ui(si)], (t2, [e2, r2]) => function(t3, e3, r3, n2) {
          for (; r3 <= n2; ) {
            const i2 = r3 + n2 >> 1;
            if (e3[i2] === t3)
              return true;
            e3[i2] > t3 ? n2 = i2 - 1 : r3 = i2 + 1;
          }
          return false;
        }(t2.properties()[e2.value], r2.value, 0, r2.value.length - 1)], all: { type: ri, overloads: [[[ri, ri], (t2, [e2, r2]) => e2.evaluate(t2) && r2.evaluate(t2)], [Ha(ri), (t2, e2) => {
          for (const r2 of e2)
            if (!r2.evaluate(t2))
              return false;
          return true;
        }]] }, any: { type: ri, overloads: [[[ri, ri], (t2, [e2, r2]) => e2.evaluate(t2) || r2.evaluate(t2)], [Ha(ri), (t2, e2) => {
          for (const r2 of e2)
            if (r2.evaluate(t2))
              return true;
          return false;
        }]] }, "!": [ri, [ri], (t2, [e2]) => !e2.evaluate(t2)], "is-supported-script": [ri, [ei], (t2, [e2]) => {
          const r2 = t2.globals && t2.globals.isSupportedScript;
          return !r2 || r2(e2.evaluate(t2));
        }], upcase: [ei, [ei], (t2, [e2]) => e2.evaluate(t2).toUpperCase()], downcase: [ei, [ei], (t2, [e2]) => e2.evaluate(t2).toLowerCase()], concat: [ei, Ha(si), (t2, e2) => e2.map((e3) => wi(e3.evaluate(t2))).join("")], "resolved-locale": [ei, [ai], (t2, [e2]) => e2.evaluate(t2).resolvedLocale()], random: [ti, [ti, ti, si], (t2, e2) => {
          const [r2, n2, i2] = e2.map((e3) => e3.evaluate(t2));
          if (r2 > n2)
            return r2;
          if (r2 === n2)
            return r2;
          let s2;
          if ("string" == typeof i2)
            s2 = function(t3) {
              let e3 = 0;
              if (0 === t3.length)
                return e3;
              for (let r3 = 0; r3 < t3.length; r3++)
                e3 = (e3 << 5) - e3 + t3.charCodeAt(r3), e3 |= 0;
              return e3;
            }(i2);
          else {
            if ("number" != typeof i2)
              throw new Ai(`Invalid seed input: ${i2}`);
            s2 = i2;
          }
          return r2 + $a(s2)() * (n2 - r2);
        }] });
        class ho {
          constructor(t2, e2, r2, n2) {
            this.expression = t2, this._warningHistory = {}, this._evaluator = new Di(r2, n2), this._defaultValue = e2 ? function(t3) {
              return "color" === t3.type && (no(t3.default) || Array.isArray(t3.default)) ? new Gn(0, 0, 0, 0) : "color" === t3.type ? Gn.parse(t3.default) || null : void 0 === t3.default ? null : t3.default;
            }(e2) : null, this._enumValues = e2 && "enum" === e2.type ? e2.values : null;
          }
          evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2, a2, o2) {
            return this._evaluator.globals = t2, this._evaluator.feature = e2, this._evaluator.featureState = r2, this._evaluator.canonical = n2 || null, this._evaluator.availableImages = i2 || null, this._evaluator.formattedSection = s2, this._evaluator.featureTileCoord = a2 || null, this._evaluator.featureDistanceData = o2 || null, this.expression.evaluate(this._evaluator);
          }
          evaluate(t2, e2, r2, n2, i2, s2, a2, o2) {
            this._evaluator.globals = t2, this._evaluator.feature = e2 || null, this._evaluator.featureState = r2 || null, this._evaluator.canonical = n2 || null, this._evaluator.availableImages = i2 || null, this._evaluator.formattedSection = s2 || null, this._evaluator.featureTileCoord = a2 || null, this._evaluator.featureDistanceData = o2 || null;
            try {
              const t3 = this.expression.evaluate(this._evaluator);
              if (null == t3 || "number" == typeof t3 && t3 != t3)
                return this._defaultValue;
              if (this._enumValues && !(t3 in this._enumValues))
                throw new Ai(`Expected value to be one of ${Object.keys(this._enumValues).map((t4) => JSON.stringify(t4)).join(", ")}, but found ${JSON.stringify(t3)} instead.`);
              return t3;
            } catch (t3) {
              return this._warningHistory[t3.message] || (this._warningHistory[t3.message] = true, "undefined" != typeof console && console.warn(`Failed to evaluate expression "${JSON.stringify(this.expression.serialize())}". ${t3.message}`)), this._defaultValue;
            }
          }
        }
        function po(t2) {
          return Array.isArray(t2) && t2.length > 0 && "string" == typeof t2[0] && t2[0] in qa;
        }
        function fo(t2, e2, r2, n2) {
          const i2 = new ta(qa, [], e2 ? function(t3) {
            const e3 = { color: ni, string: ei, number: ti, enum: ei, boolean: ri, formatted: oi, resolvedImage: li };
            return "array" === t3.type ? ui(e3[t3.value] || si, t3.length) : e3[t3.type];
          }(e2) : void 0, void 0, void 0, r2, n2), s2 = i2.parse(t2, void 0, void 0, void 0, e2 && "string" === e2.type ? { typeAnnotation: "coerce" } : void 0);
          return s2 ? Ka(new ho(s2, e2, r2, n2)) : Wa(i2.errors);
        }
        class mo {
          constructor(t2, e2, r2) {
            this.kind = t2, this._styleExpression = e2, this.isLightConstant = r2, this.isStateDependent = "constant" !== t2 && !Hs(e2.expression), this.configDependencies = Ks(e2.expression);
          }
          evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2) {
            return this._styleExpression.evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2);
          }
          evaluate(t2, e2, r2, n2, i2, s2) {
            return this._styleExpression.evaluate(t2, e2, r2, n2, i2, s2);
          }
        }
        class yo {
          constructor(t2, e2, r2, n2, i2) {
            this.kind = t2, this.zoomStops = r2, this._styleExpression = e2, this.isStateDependent = "camera" !== t2 && !Hs(e2.expression), this.isLightConstant = i2, this.configDependencies = Ks(e2.expression), this.interpolationType = n2;
          }
          evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2) {
            return this._styleExpression.evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2);
          }
          evaluate(t2, e2, r2, n2, i2, s2) {
            return this._styleExpression.evaluate(t2, e2, r2, n2, i2, s2);
          }
          interpolationFactor(t2, e2, r2) {
            return this.interpolationType ? wa.interpolationFactor(this.interpolationType, t2, e2, r2) : 0;
          }
        }
        function go(t2, e2, r2, n2) {
          if ("error" === (t2 = fo(t2, e2, r2, n2)).result)
            return t2;
          const i2 = t2.value.expression, s2 = Zs(i2);
          if (!s2 && !Qa(e2))
            return Wa([new Wn("", "data expressions not supported")]);
          const a2 = Ws(i2, ["zoom", "pitch", "distance-from-center"]);
          if (!a2 && !eo(e2))
            return Wa([new Wn("", "zoom expressions not supported")]);
          const o2 = Ws(i2, ["measure-light"]);
          if (!o2 && !to(e2))
            return Wa([new Wn("", "measure-light expression not supported")]);
          const l2 = e2.expression && e2.expression.relaxZoomRestriction, u2 = bo(i2);
          return u2 || a2 || l2 ? u2 instanceof Wn ? Wa([u2]) : u2 instanceof wa && !ro(e2) ? Wa([new Wn("", '"interpolate" expressions cannot be used with this property')]) : Ka(u2 ? new yo(s2 ? "camera" : "composite", t2.value, u2.labels, u2 instanceof wa ? u2.interpolation : void 0, o2) : new mo(s2 ? "constant" : "source", t2.value, o2)) : Wa([new Wn("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')]);
        }
        class xo {
          constructor(t2, e2) {
            this._parameters = t2, this._specification = e2, Kn(this, so(this._parameters, this._specification));
          }
          static deserialize(t2) {
            return new xo(t2._parameters, t2._specification);
          }
          static serialize(t2) {
            return { _parameters: t2._parameters, _specification: t2._specification };
          }
        }
        function bo(t2) {
          let e2 = null;
          if (t2 instanceof Sa)
            e2 = bo(t2.result);
          else if (t2 instanceof Aa) {
            for (const r2 of t2.args)
              if (e2 = bo(r2), e2)
                break;
          } else
            (t2 instanceof na || t2 instanceof wa) && t2.input instanceof Ri && "zoom" === t2.input.name && (e2 = t2);
          return e2 instanceof Wn || t2.eachChild((t3) => {
            const r2 = bo(t3);
            r2 instanceof Wn ? e2 = r2 : e2 && r2 && e2 !== r2 && (e2 = new Wn("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
          }), e2;
        }
        var vo = wo, _o = 3;
        function wo(t2, e2, r2) {
          var n2 = this.cells = [];
          if (t2 instanceof ArrayBuffer) {
            this.arrayBuffer = t2;
            var i2 = new Int32Array(this.arrayBuffer);
            t2 = i2[0], this.d = (e2 = i2[1]) + 2 * (r2 = i2[2]);
            for (var s2 = 0; s2 < this.d * this.d; s2++) {
              var a2 = i2[_o + s2], o2 = i2[_o + s2 + 1];
              n2.push(a2 === o2 ? null : i2.subarray(a2, o2));
            }
            var l2 = i2[_o + n2.length + 1];
            this.keys = i2.subarray(i2[_o + n2.length], l2), this.bboxes = i2.subarray(l2), this.insert = this._insertReadonly;
          } else {
            this.d = e2 + 2 * r2;
            for (var u2 = 0; u2 < this.d * this.d; u2++)
              n2.push([]);
            this.keys = [], this.bboxes = [];
          }
          this.n = e2, this.extent = t2, this.padding = r2, this.scale = e2 / t2, this.uid = 0;
          var c2 = r2 / e2 * t2;
          this.min = -c2, this.max = t2 + c2;
        }
        wo.prototype.insert = function(t2, e2, r2, n2, i2) {
          this._forEachCell(e2, r2, n2, i2, this._insertCell, this.uid++), this.keys.push(t2), this.bboxes.push(e2), this.bboxes.push(r2), this.bboxes.push(n2), this.bboxes.push(i2);
        }, wo.prototype._insertReadonly = function() {
          throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
        }, wo.prototype._insertCell = function(t2, e2, r2, n2, i2, s2) {
          this.cells[i2].push(s2);
        }, wo.prototype.query = function(t2, e2, r2, n2, i2) {
          var s2 = this.min, a2 = this.max;
          if (t2 <= s2 && e2 <= s2 && a2 <= r2 && a2 <= n2 && !i2)
            return Array.prototype.slice.call(this.keys);
          var o2 = [];
          return this._forEachCell(t2, e2, r2, n2, this._queryCell, o2, {}, i2), o2;
        }, wo.prototype._queryCell = function(t2, e2, r2, n2, i2, s2, a2, o2) {
          var l2 = this.cells[i2];
          if (null !== l2)
            for (var u2 = this.keys, c2 = this.bboxes, h2 = 0; h2 < l2.length; h2++) {
              var p2 = l2[h2];
              if (void 0 === a2[p2]) {
                var f2 = 4 * p2;
                (o2 ? o2(c2[f2 + 0], c2[f2 + 1], c2[f2 + 2], c2[f2 + 3]) : t2 <= c2[f2 + 2] && e2 <= c2[f2 + 3] && r2 >= c2[f2 + 0] && n2 >= c2[f2 + 1]) ? (a2[p2] = true, s2.push(u2[p2])) : a2[p2] = false;
              }
            }
        }, wo.prototype._forEachCell = function(t2, e2, r2, n2, i2, s2, a2, o2) {
          for (var l2 = this._convertToCellCoord(t2), u2 = this._convertToCellCoord(e2), c2 = this._convertToCellCoord(r2), h2 = this._convertToCellCoord(n2), p2 = l2; p2 <= c2; p2++)
            for (var f2 = u2; f2 <= h2; f2++) {
              var d2 = this.d * f2 + p2;
              if ((!o2 || o2(this._convertFromCellCoord(p2), this._convertFromCellCoord(f2), this._convertFromCellCoord(p2 + 1), this._convertFromCellCoord(f2 + 1))) && i2.call(this, t2, e2, r2, n2, d2, s2, a2, o2))
                return;
            }
        }, wo.prototype._convertFromCellCoord = function(t2) {
          return (t2 - this.padding) / this.scale;
        }, wo.prototype._convertToCellCoord = function(t2) {
          return Math.max(0, Math.min(this.d - 1, Math.floor(t2 * this.scale) + this.padding));
        }, wo.prototype.toArrayBuffer = function() {
          if (this.arrayBuffer)
            return this.arrayBuffer;
          for (var t2 = this.cells, e2 = _o + this.cells.length + 1 + 1, r2 = 0, n2 = 0; n2 < this.cells.length; n2++)
            r2 += this.cells[n2].length;
          var i2 = new Int32Array(e2 + r2 + this.keys.length + this.bboxes.length);
          i2[0] = this.extent, i2[1] = this.n, i2[2] = this.padding;
          for (var s2 = e2, a2 = 0; a2 < t2.length; a2++) {
            var o2 = t2[a2];
            i2[_o + a2] = s2, i2.set(o2, s2), s2 += o2.length;
          }
          return i2[_o + t2.length] = s2, i2.set(this.keys, s2), i2[_o + t2.length + 1] = s2 += this.keys.length, i2.set(this.bboxes, s2), s2 += this.bboxes.length, i2.buffer;
        };
        var Mo = p(vo);
        const Ao = {};
        function So(t2, e2, r2 = {}) {
          Object.defineProperty(t2, "_classRegistryKey", { value: e2, writable: false }), Ao[e2] = { klass: t2, omit: r2.omit || [] };
        }
        So(Object, "Object"), Mo.serialize = function(t2, e2) {
          const r2 = t2.toArrayBuffer();
          return e2 && e2.add(r2), { buffer: r2 };
        }, Mo.deserialize = function(t2) {
          return new Mo(t2.buffer);
        }, Object.defineProperty(Mo, "name", { value: "Grid" }), So(Mo, "Grid"), So(Gn, "Color"), So(Error, "Error"), So(gi, "Formatted"), So(yi, "FormattedSection"), So(tn, "AJAXError"), So(xi, "ResolvedImage"), So(xo, "StylePropertyFunction"), So(ho, "StyleExpression", { omit: ["_evaluator"] }), So(yo, "ZoomDependentExpression"), So(mo, "ZoomConstantExpression"), So(Ri, "CompoundExpression", { omit: ["_evaluate"] });
        for (const t2 in qa)
          Ao[qa[t2]._classRegistryKey] || So(qa[t2], `Expression${t2}`);
        function Io(t2) {
          return t2 && "undefined" != typeof ArrayBuffer && (t2 instanceof ArrayBuffer || t2.constructor && "ArrayBuffer" === t2.constructor.name);
        }
        function To(t2) {
          return self.ImageBitmap && t2 instanceof ImageBitmap;
        }
        function ko(t2, e2) {
          if (null == t2 || "boolean" == typeof t2 || "number" == typeof t2 || "string" == typeof t2 || t2 instanceof Boolean || t2 instanceof Number || t2 instanceof String || t2 instanceof Date || t2 instanceof RegExp)
            return t2;
          if (Io(t2) || To(t2))
            return e2 && e2.add(t2), t2;
          if (ArrayBuffer.isView(t2)) {
            const r2 = t2;
            return e2 && e2.add(r2.buffer), r2;
          }
          if (t2 instanceof ImageData)
            return e2 && e2.add(t2.data.buffer), t2;
          if (Array.isArray(t2)) {
            const r2 = [];
            for (const n2 of t2)
              r2.push(ko(n2, e2));
            return r2;
          }
          if (t2 instanceof Map) {
            const e3 = { $name: "Map" };
            for (const [r2, n2] of t2.entries())
              e3[r2] = ko(n2);
            return e3;
          }
          if (t2 instanceof Set) {
            const e3 = { $name: "Set" };
            let r2 = 0;
            for (const n2 of t2.values())
              e3[++r2] = ko(n2);
            return e3;
          }
          if ("object" == typeof t2) {
            const r2 = t2.constructor, n2 = r2._classRegistryKey;
            if (!n2)
              throw new Error(`can't serialize object of unregistered class ${n2}`);
            const i2 = r2.serialize ? r2.serialize(t2, e2) : {};
            if (!r2.serialize) {
              for (const r3 in t2)
                t2.hasOwnProperty(r3) && (Ao[n2].omit.indexOf(r3) >= 0 || (i2[r3] = ko(t2[r3], e2)));
              t2 instanceof Error && (i2.message = t2.message);
            }
            if (i2.$name)
              throw new Error("$name property is reserved for worker serialization logic.");
            return "Object" !== n2 && (i2.$name = n2), i2;
          }
          throw new Error("can't serialize object of type " + typeof t2);
        }
        function Po(t2) {
          if (null == t2 || "boolean" == typeof t2 || "number" == typeof t2 || "string" == typeof t2 || t2 instanceof Boolean || t2 instanceof Number || t2 instanceof String || t2 instanceof Date || t2 instanceof RegExp || Io(t2) || To(t2) || ArrayBuffer.isView(t2) || t2 instanceof ImageData)
            return t2;
          if (Array.isArray(t2))
            return t2.map(Po);
          if ("object" == typeof t2) {
            const e2 = t2.$name || "Object";
            if ("Map" === e2) {
              const e3 = /* @__PURE__ */ new Map();
              for (const r3 of Object.keys(t2))
                "$name" !== r3 && e3.set(r3, Po(t2[r3]));
              return e3;
            }
            if ("Set" === e2) {
              const e3 = /* @__PURE__ */ new Set();
              for (const r3 of Object.keys(t2))
                "$name" !== r3 && e3.add(Po(t2[r3]));
              return e3;
            }
            const { klass: r2 } = Ao[e2];
            if (!r2)
              throw new Error(`can't deserialize unregistered class ${e2}`);
            if (r2.deserialize)
              return r2.deserialize(t2);
            const n2 = Object.create(r2.prototype);
            for (const e3 of Object.keys(t2))
              "$name" !== e3 && (n2[e3] = Po(t2[e3]));
            return n2;
          }
          throw new Error("can't deserialize object of type " + typeof t2);
        }
        const zo = { "Latin-1 Supplement": (t2) => t2 >= 128 && t2 <= 255, Arabic: (t2) => t2 >= 1536 && t2 <= 1791, "Arabic Supplement": (t2) => t2 >= 1872 && t2 <= 1919, "Arabic Extended-A": (t2) => t2 >= 2208 && t2 <= 2303, "Hangul Jamo": (t2) => t2 >= 4352 && t2 <= 4607, "Unified Canadian Aboriginal Syllabics": (t2) => t2 >= 5120 && t2 <= 5759, Khmer: (t2) => t2 >= 6016 && t2 <= 6143, "Unified Canadian Aboriginal Syllabics Extended": (t2) => t2 >= 6320 && t2 <= 6399, "General Punctuation": (t2) => t2 >= 8192 && t2 <= 8303, "Letterlike Symbols": (t2) => t2 >= 8448 && t2 <= 8527, "Number Forms": (t2) => t2 >= 8528 && t2 <= 8591, "Miscellaneous Technical": (t2) => t2 >= 8960 && t2 <= 9215, "Control Pictures": (t2) => t2 >= 9216 && t2 <= 9279, "Optical Character Recognition": (t2) => t2 >= 9280 && t2 <= 9311, "Enclosed Alphanumerics": (t2) => t2 >= 9312 && t2 <= 9471, "Geometric Shapes": (t2) => t2 >= 9632 && t2 <= 9727, "Miscellaneous Symbols": (t2) => t2 >= 9728 && t2 <= 9983, "Miscellaneous Symbols and Arrows": (t2) => t2 >= 11008 && t2 <= 11263, "CJK Radicals Supplement": (t2) => t2 >= 11904 && t2 <= 12031, "Kangxi Radicals": (t2) => t2 >= 12032 && t2 <= 12255, "Ideographic Description Characters": (t2) => t2 >= 12272 && t2 <= 12287, "CJK Symbols and Punctuation": (t2) => t2 >= 12288 && t2 <= 12351, Hiragana: (t2) => t2 >= 12352 && t2 <= 12447, Katakana: (t2) => t2 >= 12448 && t2 <= 12543, Bopomofo: (t2) => t2 >= 12544 && t2 <= 12591, "Hangul Compatibility Jamo": (t2) => t2 >= 12592 && t2 <= 12687, Kanbun: (t2) => t2 >= 12688 && t2 <= 12703, "Bopomofo Extended": (t2) => t2 >= 12704 && t2 <= 12735, "CJK Strokes": (t2) => t2 >= 12736 && t2 <= 12783, "Katakana Phonetic Extensions": (t2) => t2 >= 12784 && t2 <= 12799, "Enclosed CJK Letters and Months": (t2) => t2 >= 12800 && t2 <= 13055, "CJK Compatibility": (t2) => t2 >= 13056 && t2 <= 13311, "CJK Unified Ideographs Extension A": (t2) => t2 >= 13312 && t2 <= 19903, "Yijing Hexagram Symbols": (t2) => t2 >= 19904 && t2 <= 19967, "CJK Unified Ideographs": (t2) => t2 >= 19968 && t2 <= 40959, "Yi Syllables": (t2) => t2 >= 40960 && t2 <= 42127, "Yi Radicals": (t2) => t2 >= 42128 && t2 <= 42191, "Hangul Jamo Extended-A": (t2) => t2 >= 43360 && t2 <= 43391, "Hangul Syllables": (t2) => t2 >= 44032 && t2 <= 55215, "Hangul Jamo Extended-B": (t2) => t2 >= 55216 && t2 <= 55295, "Private Use Area": (t2) => t2 >= 57344 && t2 <= 63743, "CJK Compatibility Ideographs": (t2) => t2 >= 63744 && t2 <= 64255, "Arabic Presentation Forms-A": (t2) => t2 >= 64336 && t2 <= 65023, "Vertical Forms": (t2) => t2 >= 65040 && t2 <= 65055, "CJK Compatibility Forms": (t2) => t2 >= 65072 && t2 <= 65103, "Small Form Variants": (t2) => t2 >= 65104 && t2 <= 65135, "Arabic Presentation Forms-B": (t2) => t2 >= 65136 && t2 <= 65279, "Halfwidth and Fullwidth Forms": (t2) => t2 >= 65280 && t2 <= 65519, "CJK Unified Ideographs Extension B": (t2) => t2 >= 131072 && t2 <= 173791 };
        function Eo(t2) {
          for (const e2 of t2)
            if (Ro(e2.charCodeAt(0)))
              return true;
          return false;
        }
        function Bo(t2) {
          for (const e2 of t2)
            if (!Do(e2.charCodeAt(0)))
              return false;
          return true;
        }
        function Do(t2) {
          return !(zo.Arabic(t2) || zo["Arabic Supplement"](t2) || zo["Arabic Extended-A"](t2) || zo["Arabic Presentation Forms-A"](t2) || zo["Arabic Presentation Forms-B"](t2));
        }
        function Ro(t2) {
          return !(746 !== t2 && 747 !== t2 && (t2 < 4352 || !(zo["Bopomofo Extended"](t2) || zo.Bopomofo(t2) || zo["CJK Compatibility Forms"](t2) && !(t2 >= 65097 && t2 <= 65103) || zo["CJK Compatibility Ideographs"](t2) || zo["CJK Compatibility"](t2) || zo["CJK Radicals Supplement"](t2) || zo["CJK Strokes"](t2) || !(!zo["CJK Symbols and Punctuation"](t2) || t2 >= 12296 && t2 <= 12305 || t2 >= 12308 && t2 <= 12319 || 12336 === t2) || zo["CJK Unified Ideographs Extension A"](t2) || zo["CJK Unified Ideographs"](t2) || zo["Enclosed CJK Letters and Months"](t2) || zo["Hangul Compatibility Jamo"](t2) || zo["Hangul Jamo Extended-A"](t2) || zo["Hangul Jamo Extended-B"](t2) || zo["Hangul Jamo"](t2) || zo["Hangul Syllables"](t2) || zo.Hiragana(t2) || zo["Ideographic Description Characters"](t2) || zo.Kanbun(t2) || zo["Kangxi Radicals"](t2) || zo["Katakana Phonetic Extensions"](t2) || zo.Katakana(t2) && 12540 !== t2 || !(!zo["Halfwidth and Fullwidth Forms"](t2) || 65288 === t2 || 65289 === t2 || 65293 === t2 || t2 >= 65306 && t2 <= 65310 || 65339 === t2 || 65341 === t2 || 65343 === t2 || t2 >= 65371 && t2 <= 65503 || 65507 === t2 || t2 >= 65512 && t2 <= 65519) || !(!zo["Small Form Variants"](t2) || t2 >= 65112 && t2 <= 65118 || t2 >= 65123 && t2 <= 65126) || zo["Unified Canadian Aboriginal Syllabics"](t2) || zo["Unified Canadian Aboriginal Syllabics Extended"](t2) || zo["Vertical Forms"](t2) || zo["Yijing Hexagram Symbols"](t2) || zo["Yi Syllables"](t2) || zo["Yi Radicals"](t2))));
        }
        function Co(t2) {
          return !(Ro(t2) || function(t3) {
            return !!(zo["Latin-1 Supplement"](t3) && (167 === t3 || 169 === t3 || 174 === t3 || 177 === t3 || 188 === t3 || 189 === t3 || 190 === t3 || 215 === t3 || 247 === t3) || zo["General Punctuation"](t3) && (8214 === t3 || 8224 === t3 || 8225 === t3 || 8240 === t3 || 8241 === t3 || 8251 === t3 || 8252 === t3 || 8258 === t3 || 8263 === t3 || 8264 === t3 || 8265 === t3 || 8273 === t3) || zo["Letterlike Symbols"](t3) || zo["Number Forms"](t3) || zo["Miscellaneous Technical"](t3) && (t3 >= 8960 && t3 <= 8967 || t3 >= 8972 && t3 <= 8991 || t3 >= 8996 && t3 <= 9e3 || 9003 === t3 || t3 >= 9085 && t3 <= 9114 || t3 >= 9150 && t3 <= 9165 || 9167 === t3 || t3 >= 9169 && t3 <= 9179 || t3 >= 9186 && t3 <= 9215) || zo["Control Pictures"](t3) && 9251 !== t3 || zo["Optical Character Recognition"](t3) || zo["Enclosed Alphanumerics"](t3) || zo["Geometric Shapes"](t3) || zo["Miscellaneous Symbols"](t3) && !(t3 >= 9754 && t3 <= 9759) || zo["Miscellaneous Symbols and Arrows"](t3) && (t3 >= 11026 && t3 <= 11055 || t3 >= 11088 && t3 <= 11097 || t3 >= 11192 && t3 <= 11243) || zo["CJK Symbols and Punctuation"](t3) || zo.Katakana(t3) || zo["Private Use Area"](t3) || zo["CJK Compatibility Forms"](t3) || zo["Small Form Variants"](t3) || zo["Halfwidth and Fullwidth Forms"](t3) || 8734 === t3 || 8756 === t3 || 8757 === t3 || t3 >= 9984 && t3 <= 10087 || t3 >= 10102 && t3 <= 10131 || 65532 === t3 || 65533 === t3);
          }(t2));
        }
        function Lo(t2) {
          return t2 >= 1424 && t2 <= 2303 || zo["Arabic Presentation Forms-A"](t2) || zo["Arabic Presentation Forms-B"](t2);
        }
        function Vo(t2, e2) {
          return !(!e2 && Lo(t2) || t2 >= 2304 && t2 <= 3583 || t2 >= 3840 && t2 <= 4255 || zo.Khmer(t2));
        }
        function Fo(t2) {
          for (const e2 of t2)
            if (Lo(e2.charCodeAt(0)))
              return true;
          return false;
        }
        const Oo = "deferred", Uo = "loading", jo = "loaded";
        let No = null, $o = "unavailable", qo = null;
        const Go = function(t2) {
          t2 && "string" == typeof t2 && t2.indexOf("NetworkError") > -1 && ($o = "error"), No && No(t2);
        };
        function Xo() {
          Yo.fire(new Cn("pluginStateChange", { pluginStatus: $o, pluginURL: qo }));
        }
        const Yo = new On(), Zo = function() {
          return $o;
        }, Ho = function() {
          if ($o !== Oo || !qo)
            throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
          $o = Uo, Xo(), qo && nn({ url: qo }, (t2) => {
            t2 ? Go(t2) : ($o = jo, Xo());
          });
        }, Ko = { applyArabicShaping: null, processBidirectionalText: null, processStyledBidirectionalText: null, isLoaded: () => $o === jo || null != Ko.applyArabicShaping, isLoading: () => $o === Uo, setState(t2) {
          $o = t2.pluginStatus, qo = t2.pluginURL;
        }, isParsed: () => null != Ko.applyArabicShaping && null != Ko.processBidirectionalText && null != Ko.processStyledBidirectionalText, getPluginURL: () => qo };
        class Wo {
          constructor(t2, e2) {
            this.zoom = t2, e2 ? (this.now = e2.now, this.fadeDuration = e2.fadeDuration, this.transition = e2.transition, this.pitch = e2.pitch, this.brightness = e2.brightness) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
          }
          isSupportedScript(t2) {
            return function(t3, e2) {
              for (const r2 of t3)
                if (!Vo(r2.charCodeAt(0), e2))
                  return false;
              return true;
            }(t2, Ko.isLoaded());
          }
        }
        class Jo {
          constructor(t2, e2, r2, n2) {
            this.property = t2, this.value = e2, this.expression = function(t3, e3, r3, n3) {
              if (no(t3))
                return new xo(t3, e3);
              if (po(t3) || Array.isArray(t3) && t3.length > 0) {
                const i2 = go(t3, e3, r3, n3);
                if ("error" === i2.result)
                  throw new Error(i2.value.map((t4) => `${t4.key}: ${t4.message}`).join(", "));
                return i2.value;
              }
              {
                let r4 = t3;
                return "string" == typeof t3 && "color" === e3.type && (r4 = Gn.parse(t3)), { kind: "constant", configDependencies: /* @__PURE__ */ new Set(), evaluate: () => r4 };
              }
            }(void 0 === e2 ? t2.specification.default : e2, t2.specification, r2, n2);
          }
          isDataDriven() {
            return "source" === this.expression.kind || "composite" === this.expression.kind;
          }
          possiblyEvaluate(t2, e2, r2) {
            return this.property.possiblyEvaluate(this, t2, e2, r2);
          }
        }
        class Qo {
          constructor(t2, e2, r2) {
            this.property = t2, this.value = new Jo(t2, void 0, e2, r2);
          }
          transitioned(t2, e2) {
            return new el(this.property, this.value, e2, rr({}, t2.transition, this.transition), t2.now);
          }
          untransitioned() {
            return new el(this.property, this.value, null, {}, 0);
          }
        }
        class tl {
          constructor(t2, e2, r2) {
            this._properties = t2, this._values = Object.create(t2.defaultTransitionablePropertyValues), this._scope = e2, this._options = r2, this.configDependencies = /* @__PURE__ */ new Set();
          }
          getValue(t2) {
            return pr(this._values[t2].value.value);
          }
          setValue(t2, e2) {
            this._values.hasOwnProperty(t2) || (this._values[t2] = new Qo(this._values[t2].property, this._scope, this._options)), this._values[t2].value = new Jo(this._values[t2].property, null === e2 ? void 0 : pr(e2), this._scope, this._options), this._values[t2].value.expression.configDependencies && (this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._values[t2].value.expression.configDependencies]));
          }
          setTransitionOrValue(t2, e2) {
            e2 && (this._options = e2);
            const r2 = this._properties.properties;
            if (t2)
              for (const e3 in t2) {
                const n2 = t2[e3];
                if (ur(e3, "-transition")) {
                  const t3 = e3.slice(0, -11);
                  r2[t3] && this.setTransition(t3, n2);
                } else
                  r2.hasOwnProperty(e3) && this.setValue(e3, n2);
              }
          }
          getTransition(t2) {
            return pr(this._values[t2].transition);
          }
          setTransition(t2, e2) {
            this._values.hasOwnProperty(t2) || (this._values[t2] = new Qo(this._values[t2].property)), this._values[t2].transition = pr(e2) || void 0;
          }
          serialize() {
            const t2 = {};
            for (const e2 of Object.keys(this._values)) {
              const r2 = this.getValue(e2);
              void 0 !== r2 && (t2[e2] = r2);
              const n2 = this.getTransition(e2);
              void 0 !== n2 && (t2[`${e2}-transition`] = n2);
            }
            return t2;
          }
          transitioned(t2, e2) {
            const r2 = new rl(this._properties);
            for (const n2 of Object.keys(this._values))
              r2._values[n2] = this._values[n2].transitioned(t2, e2._values[n2]);
            return r2;
          }
          untransitioned() {
            const t2 = new rl(this._properties);
            for (const e2 of Object.keys(this._values))
              t2._values[e2] = this._values[e2].untransitioned();
            return t2;
          }
        }
        class el {
          constructor(t2, e2, r2, n2, i2) {
            const s2 = n2.delay || 0, a2 = n2.duration || 0;
            i2 = i2 || 0, this.property = t2, this.value = e2, this.begin = i2 + s2, this.end = this.begin + a2, t2.specification.transition && (n2.delay || n2.duration) && (this.prior = r2);
          }
          possiblyEvaluate(t2, e2, r2) {
            const n2 = t2.now || 0, i2 = this.value.possiblyEvaluate(t2, e2, r2), s2 = this.prior;
            if (s2) {
              if (n2 > this.end)
                return this.prior = null, i2;
              if (this.value.isDataDriven())
                return this.prior = null, i2;
              if (n2 < this.begin)
                return s2.possiblyEvaluate(t2, e2, r2);
              {
                const a2 = (n2 - this.begin) / (this.end - this.begin);
                return this.property.interpolate(s2.possiblyEvaluate(t2, e2, r2), i2, Ze(a2));
              }
            }
            return i2;
          }
        }
        class rl {
          constructor(t2) {
            this._properties = t2, this._values = Object.create(t2.defaultTransitioningPropertyValues);
          }
          possiblyEvaluate(t2, e2, r2) {
            const n2 = new sl(this._properties);
            for (const i2 of Object.keys(this._values))
              n2._values[i2] = this._values[i2].possiblyEvaluate(t2, e2, r2);
            return n2;
          }
          hasTransition() {
            for (const t2 of Object.keys(this._values))
              if (this._values[t2].prior)
                return true;
            return false;
          }
        }
        class nl {
          constructor(t2, e2, r2) {
            this._properties = t2, this._values = Object.create(t2.defaultPropertyValues), this._scope = e2, this._options = r2, this.configDependencies = /* @__PURE__ */ new Set();
          }
          getValue(t2) {
            return pr(this._values[t2].value);
          }
          setValue(t2, e2) {
            this._values[t2] = new Jo(this._values[t2].property, null === e2 ? void 0 : pr(e2), this._scope, this._options), this._values[t2].expression.configDependencies && (this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._values[t2].expression.configDependencies]));
          }
          serialize() {
            const t2 = {};
            for (const e2 of Object.keys(this._values)) {
              const r2 = this.getValue(e2);
              void 0 !== r2 && (t2[e2] = r2);
            }
            return t2;
          }
          possiblyEvaluate(t2, e2, r2) {
            const n2 = new sl(this._properties);
            for (const i2 of Object.keys(this._values))
              n2._values[i2] = this._values[i2].possiblyEvaluate(t2, e2, r2);
            return n2;
          }
        }
        class il {
          constructor(t2, e2, r2) {
            this.property = t2, this.value = e2, this.parameters = r2;
          }
          isConstant() {
            return "constant" === this.value.kind;
          }
          constantOr(t2) {
            return "constant" === this.value.kind ? this.value.value : t2;
          }
          evaluate(t2, e2, r2, n2) {
            return this.property.evaluate(this.value, this.parameters, t2, e2, r2, n2);
          }
        }
        class sl {
          constructor(t2) {
            this._properties = t2, this._values = Object.create(t2.defaultPossiblyEvaluatedValues);
          }
          get(t2) {
            return this._values[t2];
          }
        }
        class al {
          constructor(t2) {
            this.specification = t2;
          }
          possiblyEvaluate(t2, e2) {
            return t2.expression.evaluate(e2);
          }
          interpolate(t2, e2, r2) {
            const n2 = Hn[this.specification.type];
            return n2 ? n2(t2, e2, r2) : t2;
          }
        }
        class ol {
          constructor(t2, e2) {
            this.specification = t2, this.overrides = e2;
          }
          possiblyEvaluate(t2, e2, r2, n2) {
            return new il(this, "constant" === t2.expression.kind || "camera" === t2.expression.kind ? { kind: "constant", value: t2.expression.evaluate(e2, null, {}, r2, n2) } : t2.expression, e2);
          }
          interpolate(t2, e2, r2) {
            if ("constant" !== t2.value.kind || "constant" !== e2.value.kind)
              return t2;
            if (void 0 === t2.value.value || void 0 === e2.value.value)
              return new il(this, { kind: "constant", value: void 0 }, t2.parameters);
            const n2 = Hn[this.specification.type];
            return n2 ? new il(this, { kind: "constant", value: n2(t2.value.value, e2.value.value, r2) }, t2.parameters) : t2;
          }
          evaluate(t2, e2, r2, n2, i2, s2) {
            return "constant" === t2.kind ? t2.value : t2.evaluate(e2, r2, n2, i2, s2);
          }
        }
        class ll {
          constructor(t2) {
            this.specification = t2;
          }
          possiblyEvaluate(t2, e2, r2, n2) {
            return !!t2.expression.evaluate(e2, null, {}, r2, n2);
          }
          interpolate() {
            return false;
          }
        }
        class ul {
          constructor(t2) {
            this.properties = t2, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
            const e2 = new Wo(0, {});
            for (const r2 in t2) {
              const n2 = t2[r2];
              n2.specification.overridable && this.overridableProperties.push(r2);
              const i2 = this.defaultPropertyValues[r2] = new Jo(n2, void 0), s2 = this.defaultTransitionablePropertyValues[r2] = new Qo(n2);
              this.defaultTransitioningPropertyValues[r2] = s2.untransitioned(), this.defaultPossiblyEvaluatedValues[r2] = i2.possiblyEvaluate(e2);
            }
          }
        }
        So(ol, "DataDrivenProperty"), So(al, "DataConstantProperty"), So(ll, "ColorRampProperty");
        var cl = JSON.parse('{"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"required":false,"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"camera":{"type":"camera"},"color-theme":{"type":"colorTheme"},"imports":{"type":"array","value":"import"},"schema":{"type":"schema"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"required":true,"type":"array","value":"layer"},"models":{"type":"models"}},"model":{"type":"string","required":true},"import":{"id":{"type":"string","required":true},"url":{"type":"string","required":true},"config":{"type":"config"},"data":{"type":"$root"}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"default":{"type":"*","property-type":"data-constant","expression":{},"required":true},"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1}},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"values":{"type":"array","value":"*"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"id":{"type":"string","required":true},"properties":{"type":"properties"},"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"cast-shadows":{"type":"boolean","default":false,"expression":{},"property-type":"data-constant"},"shadow-intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_ambient":{"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":1,"mapbox":1},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"experimental":true,"type":{"required":true,"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"},"dynamic":{"type":"boolean","default":false}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":1}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":1}},"url":{"required":false,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_model":{"type":{"required":true,"type":"enum","values":{"model":1,"batched-model":1}},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"raster-particle":{"experimental":true},"hillshade":{},"model":{"experimental":true},"background":{},"sky":{},"slot":{},"clip":{"experimental":true}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_clip","layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_raster-particle","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_model":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"model-id":{"type":"string","default":"","property-type":"data-driven","expression":{"parameters":["zoom","feature"]}}},"layout_clip":{"clip-layer-types":{"type":"array","value":"enum","values":{"model":1,"symbol":1},"default":[],"expression":{},"property-type":"data-constant","experimental":true},"clip-layer-scope":{"type":"array","value":"string","default":[],"expression":{},"property-type":"data-constant","experimental":true}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"fill-extrusion-edge-radius":{"type":"number","experimental":true,"private":true,"default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"constant"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":1,"round":1,"square":1},"default":"butt","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":1,"round":1,"miter":1,"none":1},"default":"miter","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-z-offset":{"type":"number","experimental":true,"expression":{"parameters":["zoom","feature","line-progress"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":1,"line":1,"line-center":1},"default":"point","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":1,"viewport-y":1,"source":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-size":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{"type":"enum","values":{"none":1,"width":1,"height":1,"both":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":1,"left":1,"center":1,"right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-transform":{"type":"enum","values":{"none":1,"uppercase":1,"lowercase":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster-particle":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":1,"exponential":1,"interval":1,"categorical":1},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":1,"lab":1,"hcl":1},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"high-color":{"type":"color","property-type":"data-constant","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"space-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"horizon-blend":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"star-intensity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"camera":{"camera-projection":{"type":"enum","values":{"perspective":1,"orthographic":1},"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"default":"perspective","property-type":"data-constant"}},"colorTheme":{"data":{"type":"string","property-type":"data-constant","expression":{}}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1},"default":"mercator","required":true},"center":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-180,-90],"maximum":[180,90]},"parallels":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-90,-90],"maximum":[90,90]}},"terrain":{"source":{"type":"string","required":true},"exaggeration":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_raster-particle","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-ambient-occlusion-intensity":{"property-type":"data-constant","type":"number","private":true,"default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"property-type":"data-constant","type":"number","private":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-wall-radius":{"property-type":"data-constant","type":"number","experimental":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-radius":{"property-type":"data-constant","type":"number","experimental":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-attenuation":{"property-type":"data-constant","type":"number","experimental":true,"default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-flood-light-color":{"property-type":"data-constant","type":"color","experimental":true,"default":"#ffffff","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-intensity":{"property-type":"data-constant","type":"number","experimental":true,"default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-wall-radius":{"property-type":"data-driven","type":"number","experimental":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-radius":{"property-type":"data-driven","type":"number","experimental":true,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-attenuation":{"property-type":"data-constant","type":"number","experimental":true,"default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-vertical-scale":{"property-type":"data-constant","type":"number","experimental":true,"default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-rounded-roof":{"property-type":"data-constant","type":"boolean","default":true,"experimental":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"fill-extrusion-line-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-line-alignment":{"type":"enum","values":{"inside":1,"outside":1,"center":1},"default":"center","property-type":"data-constant"}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-gradient":{"type":"color","expression":{"interpolated":true,"parameters":["line-progress"]},"property-type":"color-ramp"},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"property-type":"constant"},"line-trim-fade-range":{"type":"array","value":"number","experimental":true,"length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-trim-color":{"type":"color","experimental":true,"default":"transparent","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-border-width":{"type":"number","private":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-border-color":{"type":"color","private":true,"default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true,"property-type":"data-constant"}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"expression":{"interpolated":true,"parameters":["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-driven"},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-image-cross-fade":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"transition":true},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","transition":true,"overridable":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-color-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-value"]},"property-type":"color-ramp"},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color-range":{"type":"array","length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-resampling":{"type":"enum","values":{"linear":1,"nearest":1},"default":"linear","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"raster-array-band":{"type":"string","required":false,"experimental":true,"property-type":"data-constant"},"raster-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_raster-particle":{"raster-particle-array-band":{"type":"string","required":false,"property-type":"data-constant"},"raster-particle-count":{"type":"number","default":512,"minimum":1,"property-type":"data-constant"},"raster-particle-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-particle-speed"]},"property-type":"color-ramp"},"raster-particle-max-speed":{"type":"number","default":1,"minimum":1,"property-type":"data-constant"},"raster-particle-speed-factor":{"type":"number","default":0.2,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-particle-fade-opacity-factor":{"type":"number","default":0.98,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-particle-reset-rate-factor":{"type":"number","default":0.8,"minimum":0,"maximum":1,"property-type":"data-constant"},"raster-particle-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-accent-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_background":{"background-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":1,"atmosphere":1},"default":"atmosphere","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100,"property-type":"data-constant"},"sky-gradient-center":{"type":"array","value":"number","default":[0,0],"length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"expression":{"interpolated":true,"parameters":["sky-radial-progress"]},"property-type":"color-ramp"},"sky-atmosphere-halo-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-atmosphere-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"model-rotation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-scale":{"type":"array","value":"number","length":3,"default":[1,1,1],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-translation":{"type":"array","value":"number","length":3,"default":[0,0,0],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-color":{"type":"color","default":"#ffffff","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":true},"model-color-mix-intensity":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-type":{"type":"enum","values":{"common-3d":1,"location-indicator":1},"default":"common-3d","property-type":"data-constant"},"model-cast-shadows":{"type":"boolean","default":true,"property-type":"data-constant"},"model-receive-shadows":{"type":"boolean","default":true,"property-type":"data-constant"},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant","transition":true},"model-emissive-strength":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state"]},"transition":true},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"model-front-cutoff":{"type":"array","private":true,"value":"number","property-type":"data-constant","expression":{"interpolated":true,"parameters":["zoom"]},"length":3,"default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1]}},"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"property-type":{"data-driven":{"type":"property-type"},"color-ramp":{"type":"property-type"},"data-constant":{"type":"property-type"},"constant":{"type":"property-type"}},"promoteId":{"*":{"type":"string"}}}');
        function hl(t2) {
          return t2 instanceof Number || t2 instanceof String || t2 instanceof Boolean ? t2.valueOf() : t2;
        }
        function pl(t2) {
          if (Array.isArray(t2))
            return t2.map(pl);
          if (t2 instanceof Object && !(t2 instanceof Number || t2 instanceof String || t2 instanceof Boolean)) {
            const e2 = {};
            for (const r2 in t2)
              e2[r2] = pl(t2[r2]);
            return e2;
          }
          return hl(t2);
        }
        function fl(t2) {
          if (true === t2 || false === t2)
            return true;
          if (!Array.isArray(t2) || 0 === t2.length)
            return false;
          switch (t2[0]) {
            case "has":
              return t2.length >= 2 && "$id" !== t2[1] && "$type" !== t2[1];
            case "in":
              return t2.length >= 3 && ("string" != typeof t2[1] || Array.isArray(t2[2]));
            case "!in":
            case "!has":
            case "none":
              return false;
            case "==":
            case "!=":
            case ">":
            case ">=":
            case "<":
            case "<=":
              return 3 !== t2.length || Array.isArray(t2[1]) || Array.isArray(t2[2]);
            case "any":
            case "all":
              for (const e2 of t2.slice(1))
                if (!fl(e2) && "boolean" != typeof e2)
                  return false;
              return true;
            default:
              return true;
          }
        }
        function dl(t2, e2 = "fill") {
          if (null == t2)
            return { filter: () => true, needGeometry: false, needFeature: false };
          fl(t2) || (t2 = _l(t2));
          const r2 = t2;
          let n2 = true;
          try {
            n2 = function(t3) {
              if (!gl(t3))
                return t3;
              let e3 = pl(t3);
              return yl(e3), e3 = ml(e3), e3;
            }(r2);
          } catch (t3) {
            console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.
This is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md
and paste the contents of this message in the report.
Thank you!
Filter Expression:
${JSON.stringify(r2, null, 2)}
        `);
          }
          const i2 = cl[`filter_${e2}`], s2 = fo(n2, i2);
          let a2 = null;
          if ("error" === s2.result)
            throw new Error(s2.value.map((t3) => `${t3.key}: ${t3.message}`).join(", "));
          a2 = (t3, e3, r3) => s2.value.evaluate(t3, e3, {}, r3);
          let o2 = null, l2 = null;
          if (n2 !== r2) {
            const t3 = fo(r2, i2);
            if ("error" === t3.result)
              throw new Error(t3.value.map((t4) => `${t4.key}: ${t4.message}`).join(", "));
            o2 = (e3, r3, n3, i3, s3) => t3.value.evaluate(e3, r3, {}, n3, void 0, void 0, i3, s3), l2 = !Zs(t3.value.expression);
          }
          return { filter: a2, dynamicFilter: o2 || void 0, needGeometry: vl(n2), needFeature: !!l2 };
        }
        function ml(t2) {
          if (!Array.isArray(t2))
            return t2;
          const e2 = function(t3) {
            if (xl.has(t3[0])) {
              for (let e3 = 1; e3 < t3.length; e3++)
                if (gl(t3[e3]))
                  return true;
            }
            return t3;
          }(t2);
          return true === e2 ? e2 : e2.map((t3) => ml(t3));
        }
        function yl(t2) {
          let e2 = false;
          const r2 = [];
          if ("case" === t2[0]) {
            for (let n2 = 1; n2 < t2.length - 1; n2 += 2)
              e2 = e2 || gl(t2[n2]), r2.push(t2[n2 + 1]);
            r2.push(t2[t2.length - 1]);
          } else if ("match" === t2[0]) {
            e2 = e2 || gl(t2[1]);
            for (let e3 = 2; e3 < t2.length - 1; e3 += 2)
              r2.push(t2[e3 + 1]);
            r2.push(t2[t2.length - 1]);
          } else if ("step" === t2[0]) {
            e2 = e2 || gl(t2[1]);
            for (let e3 = 1; e3 < t2.length - 1; e3 += 2)
              r2.push(t2[e3 + 1]);
          }
          e2 && (t2.length = 0, t2.push("any", ...r2));
          for (let e3 = 1; e3 < t2.length; e3++)
            yl(t2[e3]);
        }
        function gl(t2) {
          if (!Array.isArray(t2))
            return false;
          if ("pitch" === (e2 = t2[0]) || "distance-from-center" === e2)
            return true;
          var e2;
          for (let e3 = 1; e3 < t2.length; e3++)
            if (gl(t2[e3]))
              return true;
          return false;
        }
        const xl = /* @__PURE__ */ new Set(["in", "==", "!=", ">", ">=", "<", "<=", "to-boolean"]);
        function bl(t2, e2) {
          return t2 < e2 ? -1 : t2 > e2 ? 1 : 0;
        }
        function vl(t2) {
          if (!Array.isArray(t2))
            return false;
          if ("within" === t2[0] || "distance" === t2[0])
            return true;
          for (let e2 = 1; e2 < t2.length; e2++)
            if (vl(t2[e2]))
              return true;
          return false;
        }
        function _l(t2) {
          if (!t2)
            return true;
          const e2 = t2[0];
          return t2.length <= 1 ? "any" !== e2 : "==" === e2 ? wl(t2[1], t2[2], "==") : "!=" === e2 ? Sl(wl(t2[1], t2[2], "==")) : "<" === e2 || ">" === e2 || "<=" === e2 || ">=" === e2 ? wl(t2[1], t2[2], e2) : "any" === e2 ? (r2 = t2.slice(1), ["any"].concat(r2.map(_l))) : "all" === e2 ? ["all"].concat(t2.slice(1).map(_l)) : "none" === e2 ? ["all"].concat(t2.slice(1).map(_l).map(Sl)) : "in" === e2 ? Ml(t2[1], t2.slice(2)) : "!in" === e2 ? Sl(Ml(t2[1], t2.slice(2))) : "has" === e2 ? Al(t2[1]) : "!has" !== e2 || Sl(Al(t2[1]));
          var r2;
        }
        function wl(t2, e2, r2) {
          switch (t2) {
            case "$type":
              return [`filter-type-${r2}`, e2];
            case "$id":
              return [`filter-id-${r2}`, e2];
            default:
              return [`filter-${r2}`, t2, e2];
          }
        }
        function Ml(t2, e2) {
          if (0 === e2.length)
            return false;
          switch (t2) {
            case "$type":
              return ["filter-type-in", ["literal", e2]];
            case "$id":
              return ["filter-id-in", ["literal", e2]];
            default:
              return e2.length > 200 && !e2.some((t3) => typeof t3 != typeof e2[0]) ? ["filter-in-large", t2, ["literal", e2.sort(bl)]] : ["filter-in-small", t2, ["literal", e2]];
          }
        }
        function Al(t2) {
          switch (t2) {
            case "$type":
              return true;
            case "$id":
              return ["filter-has-id"];
            default:
              return ["filter-has", t2];
          }
        }
        function Sl(t2) {
          return ["!", t2];
        }
        const Il = "";
        function Tl(t2, e2) {
          return e2 ? `${t2}${Il}${e2}` : t2;
        }
        const kl = "-transition", Pl = /* @__PURE__ */ new Set(["fill", "line", "background", "hillshade", "raster"]);
        class zl extends On {
          constructor(t2, e2, r2, n2, i2) {
            if (super(), this.id = t2.id, this.fqid = Tl(this.id, r2), this.type = t2.type, this.scope = r2, this.lut = n2, this.options = i2, this._featureFilter = { filter: () => true, needGeometry: false, needFeature: false }, this._filterCompiled = false, this.configDependencies = /* @__PURE__ */ new Set(), "custom" !== t2.type && (this.metadata = t2.metadata, this.minzoom = t2.minzoom, this.maxzoom = t2.maxzoom, "background" !== t2.type && "sky" !== t2.type && "slot" !== t2.type && (this.source = t2.source, this.sourceLayer = t2["source-layer"], this.filter = t2.filter), t2.slot && (this.slot = t2.slot), e2.layout && (this._unevaluatedLayout = new nl(e2.layout, this.scope, i2), this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._unevaluatedLayout.configDependencies])), e2.paint)) {
              this._transitionablePaint = new tl(e2.paint, this.scope, i2);
              for (const e3 in t2.paint)
                this.setPaintProperty(e3, t2.paint[e3]);
              for (const e3 in t2.layout)
                this.setLayoutProperty(e3, t2.layout[e3]);
              this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._transitionablePaint.configDependencies]), this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new sl(e2.paint);
            }
          }
          onAdd(t2) {
          }
          onRemove(t2) {
          }
          isDraped(t2) {
            return Pl.has(this.type);
          }
          getLayoutProperty(t2) {
            return "visibility" === t2 ? this.visibility : this._unevaluatedLayout.getValue(t2);
          }
          setLayoutProperty(t2, e2) {
            if ("custom" === this.type && "visibility" === t2)
              return void (this.visibility = e2);
            const r2 = this._unevaluatedLayout;
            r2._properties.properties[t2] && (r2.setValue(t2, e2), this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...r2.configDependencies]), "visibility" === t2 && this.possiblyEvaluateVisibility());
          }
          possiblyEvaluateVisibility() {
            this.visibility = this._unevaluatedLayout._values.visibility.possiblyEvaluate({ zoom: 0 });
          }
          getPaintProperty(t2) {
            return ur(t2, kl) ? this._transitionablePaint.getTransition(t2.slice(0, -11)) : this._transitionablePaint.getValue(t2);
          }
          setPaintProperty(t2, e2) {
            const r2 = this._transitionablePaint, n2 = r2._properties.properties;
            if (ur(t2, kl)) {
              const i3 = t2.slice(0, -11);
              return n2[i3] && r2.setTransition(i3, e2 || void 0), false;
            }
            if (!n2[t2])
              return false;
            const i2 = r2._values[t2], s2 = i2.value.isDataDriven(), a2 = i2.value;
            r2.setValue(t2, e2), this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...r2.configDependencies]), this._handleSpecialPaintPropertyUpdate(t2);
            const o2 = r2._values[t2].value, l2 = o2.isDataDriven(), u2 = ur(t2, "pattern") || "line-dasharray" === t2;
            return l2 || s2 || u2 || this._handleOverridablePaintPropertyUpdate(t2, a2, o2);
          }
          _handleSpecialPaintPropertyUpdate(t2) {
          }
          getProgramIds() {
            return null;
          }
          getDefaultProgramParams(t2, e2, r2) {
            return null;
          }
          _handleOverridablePaintPropertyUpdate(t2, e2, r2) {
            return false;
          }
          isHidden(t2) {
            return !!(this.minzoom && t2 < this.minzoom) || !!(this.maxzoom && t2 >= this.maxzoom) || "none" === this.visibility;
          }
          updateTransitions(t2) {
            this._transitioningPaint = this._transitionablePaint.transitioned(t2, this._transitioningPaint);
          }
          hasTransition() {
            return this._transitioningPaint.hasTransition();
          }
          recalculate(t2, e2) {
            this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t2, void 0, e2)), this.paint = this._transitioningPaint.possiblyEvaluate(t2, void 0, e2);
          }
          serialize() {
            return hr({ id: this.id, type: this.type, slot: this.slot, source: this.source, "source-layer": this.sourceLayer, metadata: this.metadata, minzoom: this.minzoom, maxzoom: this.maxzoom, filter: this.filter, layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(), paint: this._transitionablePaint && this._transitionablePaint.serialize() }, (t2, e2) => !(void 0 === t2 || "layout" === e2 && !Object.keys(t2).length || "paint" === e2 && !Object.keys(t2).length));
          }
          is3D() {
            return false;
          }
          isSky() {
            return false;
          }
          isTileClipped() {
            return false;
          }
          hasOffscreenPass() {
            return false;
          }
          hasShadowPass() {
            return false;
          }
          canCastShadows() {
            return false;
          }
          hasLightBeamPass() {
            return false;
          }
          cutoffRange() {
            return 0;
          }
          tileCoverLift() {
            return 0;
          }
          resize() {
          }
          isStateDependent() {
            for (const t2 in this.paint._values) {
              const e2 = this.paint.get(t2);
              if (e2 instanceof il && Qa(e2.property.specification) && ("source" === e2.value.kind || "composite" === e2.value.kind) && e2.value.isStateDependent)
                return true;
            }
            return false;
          }
          compileFilter() {
            this._filterCompiled || (this._featureFilter = dl(this.filter), this._filterCompiled = true);
          }
          invalidateCompiledFilter() {
            this._filterCompiled = false;
          }
          dynamicFilter() {
            return this._featureFilter.dynamicFilter;
          }
          dynamicFilterNeedsFeature() {
            return this._featureFilter.needFeature;
          }
          getLayerRenderingStats() {
            return this._stats;
          }
          resetLayerRenderingStats(t2) {
            this._stats && ("shadow" === t2.renderPass ? this._stats.numRenderedVerticesInShadowPass = 0 : this._stats.numRenderedVerticesInTransparentPass = 0);
          }
          queryRadius(t2) {
          }
          queryIntersectsFeature(t2, e2, r2, n2, i2, s2, a2, o2, l2) {
          }
          queryIntersectsMatchingFeature(t2, e2, r2, n2) {
          }
        }
        const El = { Int8: Int8Array, Uint8: Uint8Array, Int16: Int16Array, Uint16: Uint16Array, Int32: Int32Array, Uint32: Uint32Array, Float32: Float32Array };
        class Bl {
          constructor(t2, e2) {
            this._structArray = t2, this._pos1 = e2 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
          }
        }
        class Dl {
          constructor() {
            this.isTransferred = false, this.capacity = -1, this.resize(0);
          }
          static serialize(t2, e2) {
            return t2._trim(), e2 && (t2.isTransferred = true, e2.add(t2.arrayBuffer)), { length: t2.length, arrayBuffer: t2.arrayBuffer };
          }
          static deserialize(t2) {
            const e2 = Object.create(this.prototype);
            return e2.arrayBuffer = t2.arrayBuffer, e2.length = t2.length, e2.capacity = t2.arrayBuffer.byteLength / e2.bytesPerElement, e2._refreshViews(), e2;
          }
          _trim() {
            this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
          }
          clear() {
            this.length = 0;
          }
          resize(t2) {
            this.reserve(t2), this.length = t2;
          }
          reserve(t2) {
            if (t2 > this.capacity) {
              this.capacity = Math.max(t2, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
              const e2 = this.uint8;
              this._refreshViews(), e2 && this.uint8.set(e2);
            }
          }
          _refreshViews() {
            throw new Error("StructArray#_refreshViews() must be implemented by each concrete StructArray layout");
          }
          emplace(...t2) {
            throw new Error("StructArray#emplace() must be implemented by each concrete StructArray layout");
          }
          emplaceBack(...t2) {
            throw new Error("StructArray#emplaceBack() must be implemented by each concrete StructArray layout");
          }
          destroy() {
            this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
          }
        }
        function Rl(t2, e2 = 1) {
          let r2 = 0, n2 = 0;
          return { members: t2.map((t3) => {
            const i2 = El[t3.type].BYTES_PER_ELEMENT, s2 = r2 = Cl(r2, Math.max(e2, i2)), a2 = t3.components || 1;
            return n2 = Math.max(n2, i2), r2 += i2 * a2, { name: t3.name, type: t3.type, components: a2, offset: s2 };
          }), size: Cl(r2, Math.max(n2, e2)), alignment: e2 };
        }
        function Cl(t2, e2) {
          return Math.ceil(t2 / e2) * e2;
        }
        class Ll extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2) {
            const r2 = this.length;
            return this.resize(r2 + 1), this.emplace(r2, t2, e2);
          }
          emplace(t2, e2, r2) {
            const n2 = 2 * t2;
            return this.int16[n2 + 0] = e2, this.int16[n2 + 1] = r2, t2;
          }
        }
        Ll.prototype.bytesPerElement = 4, So(Ll, "StructArrayLayout2i4");
        class Vl extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2) {
            const n2 = this.length;
            return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
          }
          emplace(t2, e2, r2, n2) {
            const i2 = 3 * t2;
            return this.int16[i2 + 0] = e2, this.int16[i2 + 1] = r2, this.int16[i2 + 2] = n2, t2;
          }
        }
        Vl.prototype.bytesPerElement = 6, So(Vl, "StructArrayLayout3i6");
        class Fl extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2) {
            const i2 = this.length;
            return this.resize(i2 + 1), this.emplace(i2, t2, e2, r2, n2);
          }
          emplace(t2, e2, r2, n2, i2) {
            const s2 = 4 * t2;
            return this.int16[s2 + 0] = e2, this.int16[s2 + 1] = r2, this.int16[s2 + 2] = n2, this.int16[s2 + 3] = i2, t2;
          }
        }
        Fl.prototype.bytesPerElement = 8, So(Fl, "StructArrayLayout4i8");
        class Ol extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2) {
            const s2 = this.length;
            return this.resize(s2 + 1), this.emplace(s2, t2, e2, r2, n2, i2);
          }
          emplace(t2, e2, r2, n2, i2, s2) {
            const a2 = 5 * t2;
            return this.int16[a2 + 0] = e2, this.int16[a2 + 1] = r2, this.int16[a2 + 2] = n2, this.int16[a2 + 3] = i2, this.int16[a2 + 4] = s2, t2;
          }
        }
        Ol.prototype.bytesPerElement = 10, So(Ol, "StructArrayLayout5i10");
        class Ul extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, a2) {
            const o2 = this.length;
            return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i2, s2, a2);
          }
          emplace(t2, e2, r2, n2, i2, s2, a2, o2) {
            const l2 = 6 * t2, u2 = 12 * t2, c2 = 3 * t2;
            return this.int16[l2 + 0] = e2, this.int16[l2 + 1] = r2, this.uint8[u2 + 4] = n2, this.uint8[u2 + 5] = i2, this.uint8[u2 + 6] = s2, this.uint8[u2 + 7] = a2, this.float32[c2 + 2] = o2, t2;
          }
        }
        Ul.prototype.bytesPerElement = 12, So(Ul, "StructArrayLayout2i4ub1f12");
        class jl extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2) {
            const i2 = this.length;
            return this.resize(i2 + 1), this.emplace(i2, t2, e2, r2, n2);
          }
          emplace(t2, e2, r2, n2, i2) {
            const s2 = 4 * t2;
            return this.float32[s2 + 0] = e2, this.float32[s2 + 1] = r2, this.float32[s2 + 2] = n2, this.float32[s2 + 3] = i2, t2;
          }
        }
        jl.prototype.bytesPerElement = 16, So(jl, "StructArrayLayout4f16");
        class Nl extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2) {
            const n2 = this.length;
            return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
          }
          emplace(t2, e2, r2, n2) {
            const i2 = 3 * t2;
            return this.float32[i2 + 0] = e2, this.float32[i2 + 1] = r2, this.float32[i2 + 2] = n2, t2;
          }
        }
        Nl.prototype.bytesPerElement = 12, So(Nl, "StructArrayLayout3f12");
        class $l extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2) {
            const s2 = this.length;
            return this.resize(s2 + 1), this.emplace(s2, t2, e2, r2, n2, i2);
          }
          emplace(t2, e2, r2, n2, i2, s2) {
            const a2 = 6 * t2, o2 = 3 * t2;
            return this.uint16[a2 + 0] = e2, this.uint16[a2 + 1] = r2, this.uint16[a2 + 2] = n2, this.uint16[a2 + 3] = i2, this.float32[o2 + 2] = s2, t2;
          }
        }
        $l.prototype.bytesPerElement = 12, So($l, "StructArrayLayout4ui1f12");
        class ql extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2) {
            const i2 = this.length;
            return this.resize(i2 + 1), this.emplace(i2, t2, e2, r2, n2);
          }
          emplace(t2, e2, r2, n2, i2) {
            const s2 = 4 * t2;
            return this.uint16[s2 + 0] = e2, this.uint16[s2 + 1] = r2, this.uint16[s2 + 2] = n2, this.uint16[s2 + 3] = i2, t2;
          }
        }
        ql.prototype.bytesPerElement = 8, So(ql, "StructArrayLayout4ui8");
        class Gl extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2) {
            const a2 = this.length;
            return this.resize(a2 + 1), this.emplace(a2, t2, e2, r2, n2, i2, s2);
          }
          emplace(t2, e2, r2, n2, i2, s2, a2) {
            const o2 = 6 * t2;
            return this.int16[o2 + 0] = e2, this.int16[o2 + 1] = r2, this.int16[o2 + 2] = n2, this.int16[o2 + 3] = i2, this.int16[o2 + 4] = s2, this.int16[o2 + 5] = a2, t2;
          }
        }
        Gl.prototype.bytesPerElement = 12, So(Gl, "StructArrayLayout6i12");
        class Xl extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2) {
            const p2 = this.length;
            return this.resize(p2 + 1), this.emplace(p2, t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2);
          }
          emplace(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2) {
            const f2 = 12 * t2;
            return this.int16[f2 + 0] = e2, this.int16[f2 + 1] = r2, this.int16[f2 + 2] = n2, this.int16[f2 + 3] = i2, this.uint16[f2 + 4] = s2, this.uint16[f2 + 5] = a2, this.uint16[f2 + 6] = o2, this.uint16[f2 + 7] = l2, this.int16[f2 + 8] = u2, this.int16[f2 + 9] = c2, this.int16[f2 + 10] = h2, this.int16[f2 + 11] = p2, t2;
          }
        }
        Xl.prototype.bytesPerElement = 24, So(Xl, "StructArrayLayout4i4ui4i24");
        class Yl extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2) {
            const a2 = this.length;
            return this.resize(a2 + 1), this.emplace(a2, t2, e2, r2, n2, i2, s2);
          }
          emplace(t2, e2, r2, n2, i2, s2, a2) {
            const o2 = 10 * t2, l2 = 5 * t2;
            return this.int16[o2 + 0] = e2, this.int16[o2 + 1] = r2, this.int16[o2 + 2] = n2, this.float32[l2 + 2] = i2, this.float32[l2 + 3] = s2, this.float32[l2 + 4] = a2, t2;
          }
        }
        Yl.prototype.bytesPerElement = 20, So(Yl, "StructArrayLayout3i3f20");
        class Zl extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
          }
          emplaceBack(t2) {
            const e2 = this.length;
            return this.resize(e2 + 1), this.emplace(e2, t2);
          }
          emplace(t2, e2) {
            return this.uint32[1 * t2 + 0] = e2, t2;
          }
        }
        Zl.prototype.bytesPerElement = 4, So(Zl, "StructArrayLayout1ul4");
        class Hl extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2) {
            const r2 = this.length;
            return this.resize(r2 + 1), this.emplace(r2, t2, e2);
          }
          emplace(t2, e2, r2) {
            const n2 = 2 * t2;
            return this.uint16[n2 + 0] = e2, this.uint16[n2 + 1] = r2, t2;
          }
        }
        Hl.prototype.bytesPerElement = 4, So(Hl, "StructArrayLayout2ui4");
        class Kl extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2) {
            const f2 = this.length;
            return this.resize(f2 + 1), this.emplace(f2, t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2);
          }
          emplace(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2) {
            const d2 = 20 * t2, m2 = 10 * t2;
            return this.int16[d2 + 0] = e2, this.int16[d2 + 1] = r2, this.int16[d2 + 2] = n2, this.int16[d2 + 3] = i2, this.int16[d2 + 4] = s2, this.float32[m2 + 3] = a2, this.float32[m2 + 4] = o2, this.float32[m2 + 5] = l2, this.float32[m2 + 6] = u2, this.int16[d2 + 14] = c2, this.uint32[m2 + 8] = h2, this.uint16[d2 + 18] = p2, this.uint16[d2 + 19] = f2, t2;
          }
        }
        Kl.prototype.bytesPerElement = 40, So(Kl, "StructArrayLayout5i4f1i1ul2ui40");
        class Wl extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, a2) {
            const o2 = this.length;
            return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i2, s2, a2);
          }
          emplace(t2, e2, r2, n2, i2, s2, a2, o2) {
            const l2 = 8 * t2;
            return this.int16[l2 + 0] = e2, this.int16[l2 + 1] = r2, this.int16[l2 + 2] = n2, this.int16[l2 + 4] = i2, this.int16[l2 + 5] = s2, this.int16[l2 + 6] = a2, this.int16[l2 + 7] = o2, t2;
          }
        }
        Wl.prototype.bytesPerElement = 16, So(Wl, "StructArrayLayout3i2i2i16");
        class Jl extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2) {
            const s2 = this.length;
            return this.resize(s2 + 1), this.emplace(s2, t2, e2, r2, n2, i2);
          }
          emplace(t2, e2, r2, n2, i2, s2) {
            const a2 = 4 * t2, o2 = 8 * t2;
            return this.float32[a2 + 0] = e2, this.float32[a2 + 1] = r2, this.float32[a2 + 2] = n2, this.int16[o2 + 6] = i2, this.int16[o2 + 7] = s2, t2;
          }
        }
        Jl.prototype.bytesPerElement = 16, So(Jl, "StructArrayLayout2f1f2i16");
        class Ql extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2) {
            const i2 = this.length;
            return this.resize(i2 + 1), this.emplace(i2, t2, e2, r2, n2);
          }
          emplace(t2, e2, r2, n2, i2) {
            const s2 = 12 * t2, a2 = 3 * t2;
            return this.uint8[s2 + 0] = e2, this.uint8[s2 + 1] = r2, this.float32[a2 + 1] = n2, this.float32[a2 + 2] = i2, t2;
          }
        }
        Ql.prototype.bytesPerElement = 12, So(Ql, "StructArrayLayout2ub2f12");
        class tu extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2) {
            const n2 = this.length;
            return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
          }
          emplace(t2, e2, r2, n2) {
            const i2 = 3 * t2;
            return this.uint16[i2 + 0] = e2, this.uint16[i2 + 1] = r2, this.uint16[i2 + 2] = n2, t2;
          }
        }
        tu.prototype.bytesPerElement = 6, So(tu, "StructArrayLayout3ui6");
        class eu extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2, y2, g2, x2, b2, v2) {
            const _2 = this.length;
            return this.resize(_2 + 1), this.emplace(_2, t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2, y2, g2, x2, b2, v2);
          }
          emplace(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2, y2, g2, x2, b2, v2, _2) {
            const w2 = 30 * t2, M2 = 15 * t2, A2 = 60 * t2;
            return this.int16[w2 + 0] = e2, this.int16[w2 + 1] = r2, this.int16[w2 + 2] = n2, this.float32[M2 + 2] = i2, this.float32[M2 + 3] = s2, this.uint16[w2 + 8] = a2, this.uint16[w2 + 9] = o2, this.uint32[M2 + 5] = l2, this.uint32[M2 + 6] = u2, this.uint32[M2 + 7] = c2, this.uint16[w2 + 16] = h2, this.uint16[w2 + 17] = p2, this.uint16[w2 + 18] = f2, this.float32[M2 + 10] = d2, this.float32[M2 + 11] = m2, this.uint8[A2 + 48] = y2, this.uint8[A2 + 49] = g2, this.uint8[A2 + 50] = x2, this.uint32[M2 + 13] = b2, this.int16[w2 + 28] = v2, this.uint8[A2 + 58] = _2, t2;
          }
        }
        eu.prototype.bytesPerElement = 60, So(eu, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
        class ru extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2, y2, g2, x2, b2, v2, _2, w2, M2, A2, S2, I2, T2, k2, P2, z2, E2) {
            const B2 = this.length;
            return this.resize(B2 + 1), this.emplace(B2, t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2, y2, g2, x2, b2, v2, _2, w2, M2, A2, S2, I2, T2, k2, P2, z2, E2);
          }
          emplace(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2, y2, g2, x2, b2, v2, _2, w2, M2, A2, S2, I2, T2, k2, P2, z2, E2, B2) {
            const D2 = 20 * t2, R2 = 40 * t2, C2 = 80 * t2;
            return this.float32[D2 + 0] = e2, this.float32[D2 + 1] = r2, this.int16[R2 + 4] = n2, this.int16[R2 + 5] = i2, this.int16[R2 + 6] = s2, this.int16[R2 + 7] = a2, this.int16[R2 + 8] = o2, this.int16[R2 + 9] = l2, this.int16[R2 + 10] = u2, this.int16[R2 + 11] = c2, this.int16[R2 + 12] = h2, this.uint16[R2 + 13] = p2, this.uint16[R2 + 14] = f2, this.uint16[R2 + 15] = d2, this.uint16[R2 + 16] = m2, this.uint16[R2 + 17] = y2, this.uint16[R2 + 18] = g2, this.uint16[R2 + 19] = x2, this.uint16[R2 + 20] = b2, this.uint16[R2 + 21] = v2, this.uint16[R2 + 22] = _2, this.uint16[R2 + 23] = w2, this.uint16[R2 + 24] = M2, this.uint16[R2 + 25] = A2, this.uint16[R2 + 26] = S2, this.uint16[R2 + 27] = I2, this.uint32[D2 + 14] = T2, this.float32[D2 + 15] = k2, this.float32[D2 + 16] = P2, this.float32[D2 + 17] = z2, this.float32[D2 + 18] = E2, this.uint8[C2 + 76] = B2, t2;
          }
        }
        ru.prototype.bytesPerElement = 80, So(ru, "StructArrayLayout2f9i15ui1ul4f1ub80");
        class nu extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2) {
            const e2 = this.length;
            return this.resize(e2 + 1), this.emplace(e2, t2);
          }
          emplace(t2, e2) {
            return this.float32[1 * t2 + 0] = e2, t2;
          }
        }
        nu.prototype.bytesPerElement = 4, So(nu, "StructArrayLayout1f4");
        class iu extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2) {
            const s2 = this.length;
            return this.resize(s2 + 1), this.emplace(s2, t2, e2, r2, n2, i2);
          }
          emplace(t2, e2, r2, n2, i2, s2) {
            const a2 = 5 * t2;
            return this.float32[a2 + 0] = e2, this.float32[a2 + 1] = r2, this.float32[a2 + 2] = n2, this.float32[a2 + 3] = i2, this.float32[a2 + 4] = s2, t2;
          }
        }
        iu.prototype.bytesPerElement = 20, So(iu, "StructArrayLayout5f20");
        class su extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, a2) {
            const o2 = this.length;
            return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i2, s2, a2);
          }
          emplace(t2, e2, r2, n2, i2, s2, a2, o2) {
            const l2 = 7 * t2;
            return this.float32[l2 + 0] = e2, this.float32[l2 + 1] = r2, this.float32[l2 + 2] = n2, this.float32[l2 + 3] = i2, this.float32[l2 + 4] = s2, this.float32[l2 + 5] = a2, this.float32[l2 + 6] = o2, t2;
          }
        }
        su.prototype.bytesPerElement = 28, So(su, "StructArrayLayout7f28");
        class au extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2) {
            const i2 = this.length;
            return this.resize(i2 + 1), this.emplace(i2, t2, e2, r2, n2);
          }
          emplace(t2, e2, r2, n2, i2) {
            const s2 = 6 * t2;
            return this.uint32[3 * t2 + 0] = e2, this.uint16[s2 + 2] = r2, this.uint16[s2 + 3] = n2, this.uint16[s2 + 4] = i2, t2;
          }
        }
        au.prototype.bytesPerElement = 12, So(au, "StructArrayLayout1ul3ui12");
        class ou extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2) {
            const e2 = this.length;
            return this.resize(e2 + 1), this.emplace(e2, t2);
          }
          emplace(t2, e2) {
            return this.uint16[1 * t2 + 0] = e2, t2;
          }
        }
        ou.prototype.bytesPerElement = 2, So(ou, "StructArrayLayout1ui2");
        class lu extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2) {
            const r2 = this.length;
            return this.resize(r2 + 1), this.emplace(r2, t2, e2);
          }
          emplace(t2, e2, r2) {
            const n2 = 2 * t2;
            return this.float32[n2 + 0] = e2, this.float32[n2 + 1] = r2, t2;
          }
        }
        lu.prototype.bytesPerElement = 8, So(lu, "StructArrayLayout2f8");
        class uu extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2) {
            const y2 = this.length;
            return this.resize(y2 + 1), this.emplace(y2, t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2);
          }
          emplace(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2, y2) {
            const g2 = 16 * t2;
            return this.float32[g2 + 0] = e2, this.float32[g2 + 1] = r2, this.float32[g2 + 2] = n2, this.float32[g2 + 3] = i2, this.float32[g2 + 4] = s2, this.float32[g2 + 5] = a2, this.float32[g2 + 6] = o2, this.float32[g2 + 7] = l2, this.float32[g2 + 8] = u2, this.float32[g2 + 9] = c2, this.float32[g2 + 10] = h2, this.float32[g2 + 11] = p2, this.float32[g2 + 12] = f2, this.float32[g2 + 13] = d2, this.float32[g2 + 14] = m2, this.float32[g2 + 15] = y2, t2;
          }
        }
        uu.prototype.bytesPerElement = 64, So(uu, "StructArrayLayout16f64");
        class cu extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, a2) {
            const o2 = this.length;
            return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i2, s2, a2);
          }
          emplace(t2, e2, r2, n2, i2, s2, a2, o2) {
            const l2 = 10 * t2, u2 = 5 * t2;
            return this.uint16[l2 + 0] = e2, this.uint16[l2 + 1] = r2, this.uint16[l2 + 2] = n2, this.uint16[l2 + 3] = i2, this.float32[u2 + 2] = s2, this.float32[u2 + 3] = a2, this.float32[u2 + 4] = o2, t2;
          }
        }
        cu.prototype.bytesPerElement = 20, So(cu, "StructArrayLayout4ui3f20");
        class hu extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2) {
            const e2 = this.length;
            return this.resize(e2 + 1), this.emplace(e2, t2);
          }
          emplace(t2, e2) {
            return this.int16[1 * t2 + 0] = e2, t2;
          }
        }
        hu.prototype.bytesPerElement = 2, So(hu, "StructArrayLayout1i2");
        class pu extends Dl {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer);
          }
          emplaceBack(t2) {
            const e2 = this.length;
            return this.resize(e2 + 1), this.emplace(e2, t2);
          }
          emplace(t2, e2) {
            return this.uint8[1 * t2 + 0] = e2, t2;
          }
        }
        pu.prototype.bytesPerElement = 1, So(pu, "StructArrayLayout1ub1");
        class fu extends Bl {
          get projectedAnchorX() {
            return this._structArray.int16[this._pos2 + 0];
          }
          get projectedAnchorY() {
            return this._structArray.int16[this._pos2 + 1];
          }
          get projectedAnchorZ() {
            return this._structArray.int16[this._pos2 + 2];
          }
          get tileAnchorX() {
            return this._structArray.int16[this._pos2 + 3];
          }
          get tileAnchorY() {
            return this._structArray.int16[this._pos2 + 4];
          }
          get x1() {
            return this._structArray.float32[this._pos4 + 3];
          }
          get y1() {
            return this._structArray.float32[this._pos4 + 4];
          }
          get x2() {
            return this._structArray.float32[this._pos4 + 5];
          }
          get y2() {
            return this._structArray.float32[this._pos4 + 6];
          }
          get padding() {
            return this._structArray.int16[this._pos2 + 14];
          }
          get featureIndex() {
            return this._structArray.uint32[this._pos4 + 8];
          }
          get sourceLayerIndex() {
            return this._structArray.uint16[this._pos2 + 18];
          }
          get bucketIndex() {
            return this._structArray.uint16[this._pos2 + 19];
          }
        }
        fu.prototype.size = 40;
        class du extends Kl {
          get(t2) {
            return new fu(this, t2);
          }
        }
        So(du, "CollisionBoxArray");
        class mu extends Bl {
          get projectedAnchorX() {
            return this._structArray.int16[this._pos2 + 0];
          }
          get projectedAnchorY() {
            return this._structArray.int16[this._pos2 + 1];
          }
          get projectedAnchorZ() {
            return this._structArray.int16[this._pos2 + 2];
          }
          get tileAnchorX() {
            return this._structArray.float32[this._pos4 + 2];
          }
          get tileAnchorY() {
            return this._structArray.float32[this._pos4 + 3];
          }
          get glyphStartIndex() {
            return this._structArray.uint16[this._pos2 + 8];
          }
          get numGlyphs() {
            return this._structArray.uint16[this._pos2 + 9];
          }
          get vertexStartIndex() {
            return this._structArray.uint32[this._pos4 + 5];
          }
          get lineStartIndex() {
            return this._structArray.uint32[this._pos4 + 6];
          }
          get lineLength() {
            return this._structArray.uint32[this._pos4 + 7];
          }
          get segment() {
            return this._structArray.uint16[this._pos2 + 16];
          }
          get lowerSize() {
            return this._structArray.uint16[this._pos2 + 17];
          }
          get upperSize() {
            return this._structArray.uint16[this._pos2 + 18];
          }
          get lineOffsetX() {
            return this._structArray.float32[this._pos4 + 10];
          }
          get lineOffsetY() {
            return this._structArray.float32[this._pos4 + 11];
          }
          get writingMode() {
            return this._structArray.uint8[this._pos1 + 48];
          }
          get placedOrientation() {
            return this._structArray.uint8[this._pos1 + 49];
          }
          set placedOrientation(t2) {
            this._structArray.uint8[this._pos1 + 49] = t2;
          }
          get hidden() {
            return this._structArray.uint8[this._pos1 + 50];
          }
          set hidden(t2) {
            this._structArray.uint8[this._pos1 + 50] = t2;
          }
          get crossTileID() {
            return this._structArray.uint32[this._pos4 + 13];
          }
          set crossTileID(t2) {
            this._structArray.uint32[this._pos4 + 13] = t2;
          }
          get associatedIconIndex() {
            return this._structArray.int16[this._pos2 + 28];
          }
          get flipState() {
            return this._structArray.uint8[this._pos1 + 58];
          }
          set flipState(t2) {
            this._structArray.uint8[this._pos1 + 58] = t2;
          }
        }
        mu.prototype.size = 60;
        class yu extends eu {
          get(t2) {
            return new mu(this, t2);
          }
        }
        So(yu, "PlacedSymbolArray");
        class gu extends Bl {
          get tileAnchorX() {
            return this._structArray.float32[this._pos4 + 0];
          }
          get tileAnchorY() {
            return this._structArray.float32[this._pos4 + 1];
          }
          get projectedAnchorX() {
            return this._structArray.int16[this._pos2 + 4];
          }
          get projectedAnchorY() {
            return this._structArray.int16[this._pos2 + 5];
          }
          get projectedAnchorZ() {
            return this._structArray.int16[this._pos2 + 6];
          }
          get rightJustifiedTextSymbolIndex() {
            return this._structArray.int16[this._pos2 + 7];
          }
          get centerJustifiedTextSymbolIndex() {
            return this._structArray.int16[this._pos2 + 8];
          }
          get leftJustifiedTextSymbolIndex() {
            return this._structArray.int16[this._pos2 + 9];
          }
          get verticalPlacedTextSymbolIndex() {
            return this._structArray.int16[this._pos2 + 10];
          }
          get placedIconSymbolIndex() {
            return this._structArray.int16[this._pos2 + 11];
          }
          get verticalPlacedIconSymbolIndex() {
            return this._structArray.int16[this._pos2 + 12];
          }
          get key() {
            return this._structArray.uint16[this._pos2 + 13];
          }
          get textBoxStartIndex() {
            return this._structArray.uint16[this._pos2 + 14];
          }
          get textBoxEndIndex() {
            return this._structArray.uint16[this._pos2 + 15];
          }
          get verticalTextBoxStartIndex() {
            return this._structArray.uint16[this._pos2 + 16];
          }
          get verticalTextBoxEndIndex() {
            return this._structArray.uint16[this._pos2 + 17];
          }
          get iconBoxStartIndex() {
            return this._structArray.uint16[this._pos2 + 18];
          }
          get iconBoxEndIndex() {
            return this._structArray.uint16[this._pos2 + 19];
          }
          get verticalIconBoxStartIndex() {
            return this._structArray.uint16[this._pos2 + 20];
          }
          get verticalIconBoxEndIndex() {
            return this._structArray.uint16[this._pos2 + 21];
          }
          get featureIndex() {
            return this._structArray.uint16[this._pos2 + 22];
          }
          get numHorizontalGlyphVertices() {
            return this._structArray.uint16[this._pos2 + 23];
          }
          get numVerticalGlyphVertices() {
            return this._structArray.uint16[this._pos2 + 24];
          }
          get numIconVertices() {
            return this._structArray.uint16[this._pos2 + 25];
          }
          get numVerticalIconVertices() {
            return this._structArray.uint16[this._pos2 + 26];
          }
          get useRuntimeCollisionCircles() {
            return this._structArray.uint16[this._pos2 + 27];
          }
          get crossTileID() {
            return this._structArray.uint32[this._pos4 + 14];
          }
          set crossTileID(t2) {
            this._structArray.uint32[this._pos4 + 14] = t2;
          }
          get textOffset0() {
            return this._structArray.float32[this._pos4 + 15];
          }
          get textOffset1() {
            return this._structArray.float32[this._pos4 + 16];
          }
          get collisionCircleDiameter() {
            return this._structArray.float32[this._pos4 + 17];
          }
          get zOffset() {
            return this._structArray.float32[this._pos4 + 18];
          }
          set zOffset(t2) {
            this._structArray.float32[this._pos4 + 18] = t2;
          }
          get hasIconTextFit() {
            return this._structArray.uint8[this._pos1 + 76];
          }
        }
        gu.prototype.size = 80;
        class xu extends ru {
          get(t2) {
            return new gu(this, t2);
          }
        }
        So(xu, "SymbolInstanceArray");
        class bu extends nu {
          getoffsetX(t2) {
            return this.float32[1 * t2 + 0];
          }
        }
        So(bu, "GlyphOffsetArray");
        class vu extends Ll {
          getx(t2) {
            return this.int16[2 * t2 + 0];
          }
          gety(t2) {
            return this.int16[2 * t2 + 1];
          }
        }
        So(vu, "SymbolLineVertexArray");
        class _u extends Bl {
          get featureIndex() {
            return this._structArray.uint32[this._pos4 + 0];
          }
          get sourceLayerIndex() {
            return this._structArray.uint16[this._pos2 + 2];
          }
          get bucketIndex() {
            return this._structArray.uint16[this._pos2 + 3];
          }
          get layoutVertexArrayOffset() {
            return this._structArray.uint16[this._pos2 + 4];
          }
        }
        _u.prototype.size = 12;
        class wu extends au {
          get(t2) {
            return new _u(this, t2);
          }
        }
        So(wu, "FeatureIndexArray");
        class Mu extends Hl {
          geta_centroid_pos0(t2) {
            return this.uint16[2 * t2 + 0];
          }
          geta_centroid_pos1(t2) {
            return this.uint16[2 * t2 + 1];
          }
        }
        So(Mu, "FillExtrusionCentroidArray");
        class Au extends Bl {
          get a_join_normal_inside_polygon0() {
            return this._structArray.int16[this._pos2 + 0];
          }
          get a_join_normal_inside_polygon1() {
            return this._structArray.int16[this._pos2 + 1];
          }
          get a_join_normal_inside_polygon2() {
            return this._structArray.int16[this._pos2 + 2];
          }
          get a_join_normal_inside_polygon3() {
            return this._structArray.int16[this._pos2 + 3];
          }
        }
        Au.prototype.size = 8;
        class Su extends Fl {
          get(t2) {
            return new Au(this, t2);
          }
        }
        So(Su, "FillExtrusionWallArray");
        const Iu = Rl([{ name: "a_pos", components: 2, type: "Int16" }], 4), Tu = Rl([{ name: "a_pos_3", components: 3, type: "Int16" }, { name: "a_pos_normal_3", components: 3, type: "Int16" }]);
        class ku {
          constructor(t2 = []) {
            this.segments = t2;
          }
          _prepareSegment(t2, e2, r2, n2) {
            let i2 = this.segments[this.segments.length - 1];
            return t2 > ku.MAX_VERTEX_ARRAY_LENGTH && dr(`Max vertices per segment is ${ku.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t2}`), (!i2 || i2.vertexLength + t2 > ku.MAX_VERTEX_ARRAY_LENGTH || i2.sortKey !== n2) && (i2 = { vertexOffset: e2, primitiveOffset: r2, vertexLength: 0, primitiveLength: 0 }, void 0 !== n2 && (i2.sortKey = n2), this.segments.push(i2)), i2;
          }
          prepareSegment(t2, e2, r2, n2) {
            return this._prepareSegment(t2, e2.length, r2.length, n2);
          }
          get() {
            return this.segments;
          }
          destroy() {
            for (const t2 of this.segments)
              for (const e2 in t2.vaos)
                t2.vaos[e2].destroy();
          }
          static simpleSegment(t2, e2, r2, n2) {
            return new ku([{ vertexOffset: t2, primitiveOffset: e2, vertexLength: r2, primitiveLength: n2, vaos: {}, sortKey: 0 }]);
          }
        }
        function Pu(t2, e2) {
          return 256 * (t2 = We(Math.floor(t2), 0, 255)) + We(Math.floor(e2), 0, 255);
        }
        ku.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, So(ku, "SegmentVector");
        const zu = Rl([{ name: "a_pattern", components: 4, type: "Uint16" }, { name: "a_pixel_ratio", components: 1, type: "Float32" }]), Eu = Rl([{ name: "a_dash", components: 4, type: "Uint16" }]);
        class Bu {
          constructor() {
            this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = false;
          }
          add(t2, e2, r2, n2) {
            this.ids.push(Du(t2)), this.positions.push(e2, r2, n2);
          }
          eachPosition(t2, e2) {
            const r2 = Du(t2);
            let n2 = 0, i2 = this.ids.length - 1;
            for (; n2 < i2; ) {
              const t3 = n2 + i2 >> 1;
              this.ids[t3] >= r2 ? i2 = t3 : n2 = t3 + 1;
            }
            for (; this.ids[n2] === r2; )
              e2(this.positions[3 * n2], this.positions[3 * n2 + 1], this.positions[3 * n2 + 2]), n2++;
          }
          static serialize(t2, e2) {
            const r2 = new Float64Array(t2.ids), n2 = new Uint32Array(t2.positions);
            return Ru(r2, n2, 0, r2.length - 1), e2 && (e2.add(r2.buffer), e2.add(n2.buffer)), { ids: r2, positions: n2 };
          }
          static deserialize(t2) {
            const e2 = new Bu();
            let r2;
            e2.ids = t2.ids, e2.positions = t2.positions;
            for (const t3 of e2.ids)
              t3 !== r2 && e2.uniqueIds.push(t3), r2 = t3;
            return e2.indexed = true, e2;
          }
        }
        function Du(t2) {
          const e2 = +t2;
          return !isNaN(e2) && Number.MIN_SAFE_INTEGER <= e2 && e2 <= Number.MAX_SAFE_INTEGER ? e2 : Rn(String(t2));
        }
        function Ru(t2, e2, r2, n2) {
          for (; r2 < n2; ) {
            const i2 = t2[r2 + n2 >> 1];
            let s2 = r2 - 1, a2 = n2 + 1;
            for (; ; ) {
              do {
                s2++;
              } while (t2[s2] < i2);
              do {
                a2--;
              } while (t2[a2] > i2);
              if (s2 >= a2)
                break;
              Cu(t2, s2, a2), Cu(e2, 3 * s2, 3 * a2), Cu(e2, 3 * s2 + 1, 3 * a2 + 1), Cu(e2, 3 * s2 + 2, 3 * a2 + 2);
            }
            a2 - r2 < n2 - a2 ? (Ru(t2, e2, r2, a2), r2 = a2 + 1) : (Ru(t2, e2, a2 + 1, n2), n2 = a2);
          }
        }
        function Cu(t2, e2, r2) {
          const n2 = t2[e2];
          t2[e2] = t2[r2], t2[r2] = n2;
        }
        So(Bu, "FeaturePositionMap");
        class Lu {
          constructor(t2) {
            this.gl = t2.gl, this.initialized = false;
          }
          fetchUniformLocation(t2, e2) {
            return this.location || this.initialized || (this.location = this.gl.getUniformLocation(t2, e2), this.initialized = true), !!this.location;
          }
          set(t2, e2, r2) {
            throw new Error("Uniform#set() must be implemented by each concrete Uniform");
          }
        }
        class Vu extends Lu {
          constructor(t2) {
            super(t2), this.current = 0;
          }
          set(t2, e2, r2) {
            this.fetchUniformLocation(t2, e2) && this.current !== r2 && (this.current = r2, this.gl.uniform1i(this.location, r2));
          }
        }
        class Fu extends Lu {
          constructor(t2) {
            super(t2), this.current = 0;
          }
          set(t2, e2, r2) {
            this.fetchUniformLocation(t2, e2) && this.current !== r2 && (this.current = r2, this.gl.uniform1f(this.location, r2));
          }
        }
        class Ou extends Lu {
          constructor(t2) {
            super(t2), this.current = [0, 0];
          }
          set(t2, e2, r2) {
            this.fetchUniformLocation(t2, e2) && (r2[0] === this.current[0] && r2[1] === this.current[1] || (this.current = r2, this.gl.uniform2f(this.location, r2[0], r2[1])));
          }
        }
        class Uu extends Lu {
          constructor(t2) {
            super(t2), this.current = [0, 0, 0];
          }
          set(t2, e2, r2) {
            this.fetchUniformLocation(t2, e2) && (r2[0] === this.current[0] && r2[1] === this.current[1] && r2[2] === this.current[2] || (this.current = r2, this.gl.uniform3f(this.location, r2[0], r2[1], r2[2])));
          }
        }
        class ju extends Lu {
          constructor(t2) {
            super(t2), this.current = [0, 0, 0, 0];
          }
          set(t2, e2, r2) {
            this.fetchUniformLocation(t2, e2) && (r2[0] === this.current[0] && r2[1] === this.current[1] && r2[2] === this.current[2] && r2[3] === this.current[3] || (this.current = r2, this.gl.uniform4f(this.location, r2[0], r2[1], r2[2], r2[3])));
          }
        }
        class Nu extends Lu {
          constructor(t2) {
            super(t2), this.current = Gn.transparent.toRenderColor(null);
          }
          set(t2, e2, r2) {
            this.fetchUniformLocation(t2, e2) && (r2.r === this.current.r && r2.g === this.current.g && r2.b === this.current.b && r2.a === this.current.a || (this.current = r2, this.gl.uniform4f(this.location, r2.r, r2.g, r2.b, r2.a)));
          }
        }
        const $u = new Float32Array(16);
        class qu extends Lu {
          constructor(t2) {
            super(t2), this.current = $u;
          }
          set(t2, e2, r2) {
            if (this.fetchUniformLocation(t2, e2)) {
              if (r2[12] !== this.current[12] || r2[0] !== this.current[0])
                return this.current = r2, void this.gl.uniformMatrix4fv(this.location, false, r2);
              for (let t3 = 1; t3 < 16; t3++)
                if (r2[t3] !== this.current[t3]) {
                  this.current = r2, this.gl.uniformMatrix4fv(this.location, false, r2);
                  break;
                }
            }
          }
        }
        const Gu = new Float32Array(9), Xu = new Float32Array(4);
        class Yu extends Lu {
          constructor(t2) {
            super(t2), this.current = Xu;
          }
          set(t2, e2, r2) {
            if (this.fetchUniformLocation(t2, e2)) {
              for (let t3 = 0; t3 < 4; t3++)
                if (r2[t3] !== this.current[t3]) {
                  this.current = r2, this.gl.uniformMatrix2fv(this.location, false, r2);
                  break;
                }
            }
          }
        }
        function Zu(t2) {
          return [Pu(255 * t2.r, 255 * t2.g), Pu(255 * t2.b, 255 * t2.a)];
        }
        class Hu {
          constructor(t2, e2, r2, n2) {
            this.value = t2, this.uniformNames = e2.map((t3) => `u_${t3}`), this.type = r2, this.context = n2;
          }
          setUniform(t2, e2, r2, n2, i2) {
            const s2 = n2.constantOr(this.value);
            e2.set(t2, i2, s2 instanceof Gn ? s2.toRenderColor(this.context.lut) : s2);
          }
          getBinding(t2, e2) {
            return "color" === this.type ? new Nu(t2) : new Fu(t2);
          }
        }
        class Ku {
          constructor(t2, e2) {
            this.uniformNames = e2.map((t3) => `u_${t3}`), this.pattern = null, this.pixelRatio = 1;
          }
          setConstantPatternPositions(t2) {
            this.pixelRatio = t2.pixelRatio || 1, this.pattern = t2.tl.concat(t2.br);
          }
          setUniform(t2, e2, r2, n2, i2) {
            const s2 = "u_pattern" === i2 || "u_dash" === i2 ? this.pattern : "u_pixel_ratio" === i2 ? this.pixelRatio : null;
            s2 && e2.set(t2, i2, s2);
          }
          getBinding(t2, e2) {
            return "u_pattern" === e2 || "u_dash" === e2 ? new ju(t2) : new Fu(t2);
          }
        }
        class Wu {
          constructor(t2, e2, r2, n2) {
            this.expression = t2, this.type = r2, this.maxValue = 0, this.paintVertexAttributes = e2.map((t3) => ({ name: `a_${t3}`, type: "Float32", components: "color" === r2 ? 2 : 1, offset: 0 })), this.paintVertexArray = new n2();
          }
          populatePaintArray(t2, e2, r2, n2, i2, s2, a2) {
            const o2 = this.paintVertexArray.length, l2 = this.expression.evaluate(new Wo(0, { brightness: s2 }), e2, {}, i2, n2, a2);
            this.paintVertexArray.resize(t2), this._setPaintValue(o2, t2, l2, this.context);
          }
          updatePaintArray(t2, e2, r2, n2, i2, s2, a2) {
            const o2 = this.expression.evaluate({ zoom: 0, brightness: a2 }, r2, n2, void 0, i2);
            this._setPaintValue(t2, e2, o2, this.context);
          }
          _setPaintValue(t2, e2, r2, n2) {
            if ("color" === this.type) {
              const i2 = Zu(r2.toRenderColor(n2.lut));
              for (let r3 = t2; r3 < e2; r3++)
                this.paintVertexArray.emplace(r3, i2[0], i2[1]);
            } else {
              for (let n3 = t2; n3 < e2; n3++)
                this.paintVertexArray.emplace(n3, r2);
              this.maxValue = Math.max(this.maxValue, Math.abs(r2));
            }
          }
          upload(t2) {
            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t2.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
          }
          destroy() {
            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
          }
        }
        class Ju {
          constructor(t2, e2, r2, n2, i2, s2) {
            this.expression = t2, this.uniformNames = e2.map((t3) => `u_${t3}_t`), this.type = r2, this.useIntegerZoom = n2, this.context = i2, this.maxValue = 0, this.paintVertexAttributes = e2.map((t3) => ({ name: `a_${t3}`, type: "Float32", components: "color" === r2 ? 4 : 2, offset: 0 })), this.paintVertexArray = new s2();
          }
          populatePaintArray(t2, e2, r2, n2, i2, s2, a2) {
            const o2 = this.expression.evaluate(new Wo(this.context.zoom, { brightness: s2 }), e2, {}, i2, n2, a2), l2 = this.expression.evaluate(new Wo(this.context.zoom + 1, { brightness: s2 }), e2, {}, i2, n2, a2), u2 = this.paintVertexArray.length;
            this.paintVertexArray.resize(t2), this._setPaintValue(u2, t2, o2, l2, this.context);
          }
          updatePaintArray(t2, e2, r2, n2, i2, s2, a2) {
            const o2 = this.expression.evaluate({ zoom: this.context.zoom, brightness: a2 }, r2, n2, void 0, i2), l2 = this.expression.evaluate({ zoom: this.context.zoom + 1, brightness: a2 }, r2, n2, void 0, i2);
            this._setPaintValue(t2, e2, o2, l2, this.context);
          }
          _setPaintValue(t2, e2, r2, n2, i2) {
            if ("color" === this.type) {
              const n3 = Zu(r2.toRenderColor(i2.lut)), s2 = Zu(r2.toRenderColor(i2.lut));
              for (let r3 = t2; r3 < e2; r3++)
                this.paintVertexArray.emplace(r3, n3[0], n3[1], s2[0], s2[1]);
            } else {
              for (let i3 = t2; i3 < e2; i3++)
                this.paintVertexArray.emplace(i3, r2, n2);
              this.maxValue = Math.max(this.maxValue, Math.abs(r2), Math.abs(n2));
            }
          }
          upload(t2) {
            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t2.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
          }
          destroy() {
            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
          }
          setUniform(t2, e2, r2, n2, i2) {
            const s2 = this.useIntegerZoom ? Math.floor(r2.zoom) : r2.zoom, a2 = We(this.expression.interpolationFactor(s2, this.context.zoom, this.context.zoom + 1), 0, 1);
            e2.set(t2, i2, a2);
          }
          getBinding(t2, e2) {
            return new Fu(t2);
          }
        }
        class Qu {
          constructor(t2, e2, r2, n2, i2) {
            this.expression = t2, this.layerId = i2, this.paintVertexAttributes = ("array" === r2 ? Eu : zu).members;
            for (let t3 = 0; t3 < e2.length; ++t3)
              ;
            this.paintVertexArray = new n2();
          }
          populatePaintArray(t2, e2, r2, n2) {
            const i2 = this.paintVertexArray.length;
            this.paintVertexArray.resize(t2), this._setPaintValues(i2, t2, e2.patterns && e2.patterns[this.layerId], r2);
          }
          updatePaintArray(t2, e2, r2, n2, i2, s2, a2) {
            this._setPaintValues(t2, e2, r2.patterns && r2.patterns[this.layerId], s2);
          }
          _setPaintValues(t2, e2, r2, n2) {
            if (!n2 || !r2)
              return;
            const i2 = n2[r2];
            if (!i2)
              return;
            const { tl: s2, br: a2, pixelRatio: o2 } = i2;
            for (let r3 = t2; r3 < e2; r3++)
              this.paintVertexArray.emplace(r3, s2[0], s2[1], a2[0], a2[1], o2);
          }
          upload(t2) {
            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = t2.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
          }
          destroy() {
            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
          }
        }
        class tc {
          constructor(t2, e2, r2 = () => true) {
            this.binders = {}, this._buffers = [], this.context = e2;
            const n2 = [];
            for (const i2 in t2.paint._values) {
              const s2 = t2.paint.get(i2);
              if (!r2(i2))
                continue;
              if (!(s2 instanceof il && Qa(s2.property.specification)))
                continue;
              const a2 = nc(i2, t2.type), o2 = s2.value, l2 = s2.property.specification.type, u2 = !!s2.property.useIntegerZoom, c2 = "line-dasharray" === i2 || i2.endsWith("pattern"), h2 = "line-dasharray" === i2 && "constant" !== t2.layout.get("line-cap").value.kind;
              if ("constant" !== o2.kind || h2)
                if ("source" === o2.kind || h2 || c2) {
                  const e3 = ac(i2, l2, "source");
                  this.binders[i2] = c2 ? new Qu(o2, a2, l2, e3, t2.id) : new Wu(o2, a2, l2, e3), n2.push(`/a_${i2}`);
                } else {
                  const t3 = ac(i2, l2, "composite");
                  this.binders[i2] = new Ju(o2, a2, l2, u2, e2, t3), n2.push(`/z_${i2}`);
                }
              else
                this.binders[i2] = c2 ? new Ku(o2.value, a2) : new Hu(o2.value, a2, l2, e2), n2.push(`/u_${i2}`);
            }
            this.cacheKey = n2.sort().join("");
          }
          getMaxValue(t2) {
            const e2 = this.binders[t2];
            return e2 instanceof Wu || e2 instanceof Ju ? e2.maxValue : 0;
          }
          populatePaintArrays(t2, e2, r2, n2, i2, s2, a2) {
            for (const o2 in this.binders) {
              const l2 = this.binders[o2];
              l2.context = this.context, (l2 instanceof Wu || l2 instanceof Ju || l2 instanceof Qu) && l2.populatePaintArray(t2, e2, r2, n2, i2, s2, a2);
            }
          }
          setConstantPatternPositions(t2) {
            for (const e2 in this.binders) {
              const r2 = this.binders[e2];
              r2 instanceof Ku && r2.setConstantPatternPositions(t2);
            }
          }
          updatePaintArrays(t2, e2, r2, n2, i2, s2, a2, o2) {
            let l2 = false;
            const u2 = Object.keys(t2), c2 = 0 !== u2.length, h2 = c2 ? u2 : e2.uniqueIds;
            this.context.lut = i2.lut;
            for (const u3 in this.binders) {
              const p2 = this.binders[u3];
              if (p2.context = this.context, (p2 instanceof Wu || p2 instanceof Ju || p2 instanceof Qu) && (true === p2.expression.isStateDependent || false === p2.expression.isLightConstant)) {
                const f2 = i2.paint.get(u3);
                p2.expression = f2.value;
                for (const r3 of h2) {
                  const i3 = t2[r3.toString()];
                  e2.eachPosition(r3, (t3, e3, r4) => {
                    const l3 = n2.feature(t3);
                    p2.updatePaintArray(e3, r4, l3, i3, s2, a2, o2);
                  });
                }
                if (!c2)
                  for (const e3 of r2.uniqueIds) {
                    const i3 = t2[e3.toString()];
                    r2.eachPosition(e3, (t3, e4, r3) => {
                      const l3 = n2.feature(t3);
                      p2.updatePaintArray(e4, r3, l3, i3, s2, a2, o2);
                    });
                  }
                l2 = true;
              }
            }
            return l2;
          }
          defines() {
            const t2 = [];
            for (const e2 in this.binders) {
              const r2 = this.binders[e2];
              (r2 instanceof Hu || r2 instanceof Ku) && t2.push(...r2.uniformNames.map((t3) => `#define HAS_UNIFORM_${t3}`));
            }
            return t2;
          }
          getBinderAttributes() {
            const t2 = [];
            for (const e2 in this.binders) {
              const r2 = this.binders[e2];
              if (r2 instanceof Wu || r2 instanceof Ju || r2 instanceof Qu)
                for (let e3 = 0; e3 < r2.paintVertexAttributes.length; e3++)
                  t2.push(r2.paintVertexAttributes[e3].name);
            }
            return t2;
          }
          getBinderUniforms() {
            const t2 = [];
            for (const e2 in this.binders) {
              const r2 = this.binders[e2];
              if (r2 instanceof Hu || r2 instanceof Ku || r2 instanceof Ju)
                for (const e3 of r2.uniformNames)
                  t2.push(e3);
            }
            return t2;
          }
          getPaintVertexBuffers() {
            return this._buffers;
          }
          getUniforms(t2) {
            const e2 = [];
            for (const r2 in this.binders) {
              const n2 = this.binders[r2];
              if (n2 instanceof Hu || n2 instanceof Ku || n2 instanceof Ju)
                for (const i2 of n2.uniformNames)
                  e2.push({ name: i2, property: r2, binding: n2.getBinding(t2, i2) });
            }
            return e2;
          }
          setUniforms(t2, e2, r2, n2, i2) {
            for (const { name: e3, property: s2, binding: a2 } of r2)
              this.binders[s2].setUniform(t2, a2, i2, n2.get(s2), e3);
          }
          updatePaintBuffers() {
            this._buffers = [];
            for (const t2 in this.binders) {
              const e2 = this.binders[t2];
              (e2 instanceof Wu || e2 instanceof Ju || e2 instanceof Qu) && e2.paintVertexBuffer && this._buffers.push(e2.paintVertexBuffer);
            }
          }
          upload(t2) {
            for (const e2 in this.binders) {
              const r2 = this.binders[e2];
              (r2 instanceof Wu || r2 instanceof Ju || r2 instanceof Qu) && r2.upload(t2);
            }
            this.updatePaintBuffers();
          }
          destroy() {
            for (const t2 in this.binders) {
              const e2 = this.binders[t2];
              (e2 instanceof Wu || e2 instanceof Ju || e2 instanceof Qu) && e2.destroy();
            }
          }
        }
        class ec {
          constructor(t2, e2, r2 = () => true) {
            this.programConfigurations = {};
            for (const n2 of t2)
              this.programConfigurations[n2.id] = new tc(n2, e2, r2);
            this.needsUpload = false, this._featureMap = new Bu(), this._featureMapWithoutIds = new Bu(), this._bufferOffset = 0, this._idlessCounter = 0;
          }
          populatePaintArrays(t2, e2, r2, n2, i2, s2, a2, o2) {
            for (const r3 in this.programConfigurations)
              this.programConfigurations[r3].populatePaintArrays(t2, e2, n2, i2, s2, a2, o2);
            void 0 !== e2.id ? this._featureMap.add(e2.id, r2, this._bufferOffset, t2) : (this._featureMapWithoutIds.add(this._idlessCounter, r2, this._bufferOffset, t2), this._idlessCounter += 1), this._bufferOffset = t2, this.needsUpload = true;
          }
          updatePaintArrays(t2, e2, r2, n2, i2, s2) {
            for (const a2 of r2)
              this.needsUpload = this.programConfigurations[a2.id].updatePaintArrays(t2, this._featureMap, this._featureMapWithoutIds, e2, a2, n2, i2, s2 || 0) || this.needsUpload;
          }
          get(t2) {
            return this.programConfigurations[t2];
          }
          upload(t2) {
            if (this.needsUpload) {
              for (const e2 in this.programConfigurations)
                this.programConfigurations[e2].upload(t2);
              this.needsUpload = false;
            }
          }
          destroy() {
            for (const t2 in this.programConfigurations)
              this.programConfigurations[t2].destroy();
          }
        }
        const rc = { "text-opacity": ["opacity"], "icon-opacity": ["opacity"], "text-occlusion-opacity": ["occlusion_opacity"], "icon-occlusion-opacity": ["occlusion_opacity"], "text-color": ["fill_color"], "icon-color": ["fill_color"], "text-emissive-strength": ["emissive_strength"], "icon-emissive-strength": ["emissive_strength"], "text-halo-color": ["halo_color"], "icon-halo-color": ["halo_color"], "text-halo-blur": ["halo_blur"], "icon-halo-blur": ["halo_blur"], "text-halo-width": ["halo_width"], "icon-halo-width": ["halo_width"], "line-gap-width": ["gapwidth"], "line-pattern": ["pattern", "pixel_ratio"], "fill-pattern": ["pattern", "pixel_ratio"], "fill-extrusion-pattern": ["pattern", "pixel_ratio"], "line-dasharray": ["dash"] };
        function nc(t2, e2) {
          return rc[t2] || [t2.replace(`${e2}-`, "").replace(/-/g, "_")];
        }
        const ic = { "line-pattern": { source: $l, composite: $l }, "fill-pattern": { source: $l, composite: $l }, "fill-extrusion-pattern": { source: $l, composite: $l }, "line-dasharray": { source: ql, composite: ql } }, sc = { color: { source: lu, composite: jl }, number: { source: nu, composite: lu } };
        function ac(t2, e2, r2) {
          const n2 = ic[t2];
          return n2 && n2[r2] || sc[e2][r2];
        }
        So(Hu, "ConstantBinder"), So(Ku, "PatternConstantBinder"), So(Wu, "SourceExpressionBinder"), So(Qu, "PatternCompositeBinder"), So(Ju, "CompositeExpressionBinder"), So(tc, "ProgramConfiguration", { omit: ["_buffers"] }), So(ec, "ProgramConfigurationSet");
        const oc = ds / Math.PI / 2, lc = 5, uc = 6, cc = 16383, hc = 64, pc = [hc, 32, 16], fc = -oc, dc = oc;
        function mc(t2, e2, r2, n2 = oc) {
          return r2 = Ge(r2), [t2 * Math.sin(r2) * n2, -e2 * n2, t2 * Math.cos(r2) * n2];
        }
        function yc(t2, e2, r2) {
          return mc(Math.cos(Ge(t2)), Math.sin(Ge(t2)), e2, r2);
        }
        const gc = 63710088e-1, xc = 2 * Math.PI * gc;
        class bc {
          constructor(t2, e2) {
            if (isNaN(t2) || isNaN(e2))
              throw new Error(`Invalid LngLat object: (${t2}, ${e2})`);
            if (this.lng = +t2, this.lat = +e2, this.lat > 90 || this.lat < -90)
              throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
          }
          wrap() {
            return new bc(Qe(this.lng, -180, 180), this.lat);
          }
          toArray() {
            return [this.lng, this.lat];
          }
          toString() {
            return `LngLat(${this.lng}, ${this.lat})`;
          }
          distanceTo(t2) {
            const e2 = Math.PI / 180, r2 = this.lat * e2, n2 = t2.lat * e2, i2 = Math.sin(r2) * Math.sin(n2) + Math.cos(r2) * Math.cos(n2) * Math.cos((t2.lng - this.lng) * e2);
            return gc * Math.acos(Math.min(i2, 1));
          }
          toBounds(t2 = 0) {
            const e2 = 360 * t2 / 40075017, r2 = e2 / Math.cos(Math.PI / 180 * this.lat);
            return new vc({ lng: this.lng - r2, lat: this.lat - e2 }, { lng: this.lng + r2, lat: this.lat + e2 });
          }
          toEcef(t2) {
            return yc(this.lat, this.lng, oc + t2 * oc / gc);
          }
          static convert(t2) {
            if (t2 instanceof bc)
              return t2;
            if (Array.isArray(t2) && (2 === t2.length || 3 === t2.length))
              return new bc(Number(t2[0]), Number(t2[1]));
            if (!Array.isArray(t2) && "object" == typeof t2 && null !== t2)
              return new bc(Number("lng" in t2 ? t2.lng : t2.lon), Number(t2.lat));
            throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
          }
        }
        class vc {
          constructor(t2, e2) {
            if (t2)
              if (e2)
                this.setSouthWest(t2).setNorthEast(e2);
              else if (4 === t2.length) {
                const e3 = t2;
                this.setSouthWest([e3[0], e3[1]]).setNorthEast([e3[2], e3[3]]);
              } else {
                const e3 = t2;
                this.setSouthWest(e3[0]).setNorthEast(e3[1]);
              }
          }
          setNorthEast(t2) {
            return this._ne = t2 instanceof bc ? new bc(t2.lng, t2.lat) : bc.convert(t2), this;
          }
          setSouthWest(t2) {
            return this._sw = t2 instanceof bc ? new bc(t2.lng, t2.lat) : bc.convert(t2), this;
          }
          extend(t2) {
            const e2 = this._sw, r2 = this._ne;
            let n2, i2;
            if (t2 instanceof bc)
              n2 = t2, i2 = t2;
            else {
              if (!(t2 instanceof vc))
                return Array.isArray(t2) ? 4 === t2.length || t2.every(Array.isArray) ? this.extend(vc.convert(t2)) : this.extend(bc.convert(t2)) : "object" == typeof t2 && null !== t2 && t2.hasOwnProperty("lat") && (t2.hasOwnProperty("lon") || t2.hasOwnProperty("lng")) ? this.extend(bc.convert(t2)) : this;
              if (n2 = t2._sw, i2 = t2._ne, !n2 || !i2)
                return this;
            }
            return e2 || r2 ? (e2.lng = Math.min(n2.lng, e2.lng), e2.lat = Math.min(n2.lat, e2.lat), r2.lng = Math.max(i2.lng, r2.lng), r2.lat = Math.max(i2.lat, r2.lat)) : (this._sw = new bc(n2.lng, n2.lat), this._ne = new bc(i2.lng, i2.lat)), this;
          }
          getCenter() {
            return new bc((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
          }
          getSouthWest() {
            return this._sw;
          }
          getNorthEast() {
            return this._ne;
          }
          getNorthWest() {
            return new bc(this.getWest(), this.getNorth());
          }
          getSouthEast() {
            return new bc(this.getEast(), this.getSouth());
          }
          getWest() {
            return this._sw.lng;
          }
          getSouth() {
            return this._sw.lat;
          }
          getEast() {
            return this._ne.lng;
          }
          getNorth() {
            return this._ne.lat;
          }
          toArray() {
            return [this._sw.toArray(), this._ne.toArray()];
          }
          toString() {
            return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
          }
          isEmpty() {
            return !(this._sw && this._ne);
          }
          contains(t2) {
            const { lng: e2, lat: r2 } = bc.convert(t2);
            let n2 = this._sw.lng <= e2 && e2 <= this._ne.lng;
            return this._sw.lng > this._ne.lng && (n2 = this._sw.lng >= e2 && e2 >= this._ne.lng), this._sw.lat <= r2 && r2 <= this._ne.lat && n2;
          }
          static convert(t2) {
            return !t2 || t2 instanceof vc ? t2 : new vc(t2);
          }
        }
        var _c = {};
        !function(t2, e2) {
          !function(t3) {
            function e3(t4, e4, n2) {
              var i2 = r2(256 * t4, 256 * (e4 = Math.pow(2, n2) - e4 - 1), n2), s2 = r2(256 * (t4 + 1), 256 * (e4 + 1), n2);
              return i2[0] + "," + i2[1] + "," + s2[0] + "," + s2[1];
            }
            function r2(t4, e4, r3) {
              var n2 = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r3);
              return [t4 * n2 - 2 * Math.PI * 6378137 / 2, e4 * n2 - 2 * Math.PI * 6378137 / 2];
            }
            t3.getURL = function(t4, r3, n2, i2, s2, a2) {
              return a2 = a2 || {}, t4 + "?" + ["bbox=" + e3(n2, i2, s2), "format=" + (a2.format || "image/png"), "service=" + (a2.service || "WMS"), "version=" + (a2.version || "1.1.1"), "request=" + (a2.request || "GetMap"), "srs=" + (a2.srs || "EPSG:3857"), "width=" + (a2.width || 256), "height=" + (a2.height || 256), "layers=" + r3].join("&");
            }, t3.getTileBBox = e3, t3.getMercCoords = r2, Object.defineProperty(t3, "__esModule", { value: true });
          }(e2);
        }(0, _c);
        var wc = _c;
        class Mc {
          constructor(t2, e2, r2) {
            this.z = t2, this.x = e2, this.y = r2, this.key = Ic(0, t2, t2, e2, r2);
          }
          equals(t2) {
            return this.z === t2.z && this.x === t2.x && this.y === t2.y;
          }
          url(t2, e2) {
            const r2 = wc.getTileBBox(this.x, this.y, this.z), n2 = function(t3, e3, r3) {
              let n3, i2 = "";
              for (let s2 = t3; s2 > 0; s2--)
                n3 = 1 << s2 - 1, i2 += (e3 & n3 ? 1 : 0) + (r3 & n3 ? 2 : 0);
              return i2;
            }(this.z, this.x, this.y);
            return t2[(this.x + this.y) % t2.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === e2 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n2).replace("{bbox-epsg-3857}", r2);
          }
          toString() {
            return `${this.z}/${this.x}/${this.y}`;
          }
        }
        class Ac {
          constructor(t2, e2) {
            this.wrap = t2, this.canonical = e2, this.key = Ic(t2, e2.z, e2.z, e2.x, e2.y);
          }
        }
        class Sc {
          constructor(t2, e2, r2, n2, i2) {
            this.overscaledZ = t2, this.wrap = e2, this.canonical = new Mc(r2, +n2, +i2), this.key = 0 === e2 && t2 === r2 ? this.canonical.key : Ic(e2, t2, r2, n2, i2);
          }
          equals(t2) {
            return this.overscaledZ === t2.overscaledZ && this.wrap === t2.wrap && this.canonical.equals(t2.canonical);
          }
          scaledTo(t2) {
            const e2 = this.canonical.z - t2;
            return t2 > this.canonical.z ? new Sc(t2, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Sc(t2, this.wrap, t2, this.canonical.x >> e2, this.canonical.y >> e2);
          }
          calculateScaledKey(t2, e2 = true) {
            if (this.overscaledZ === t2 && e2)
              return this.key;
            if (t2 > this.canonical.z)
              return Ic(this.wrap * +e2, t2, this.canonical.z, this.canonical.x, this.canonical.y);
            {
              const r2 = this.canonical.z - t2;
              return Ic(this.wrap * +e2, t2, t2, this.canonical.x >> r2, this.canonical.y >> r2);
            }
          }
          isChildOf(t2) {
            if (t2.wrap !== this.wrap)
              return false;
            const e2 = this.canonical.z - t2.canonical.z;
            return 0 === t2.overscaledZ || t2.overscaledZ < this.overscaledZ && t2.canonical.z < this.canonical.z && t2.canonical.x === this.canonical.x >> e2 && t2.canonical.y === this.canonical.y >> e2;
          }
          children(t2) {
            if (this.overscaledZ >= t2)
              return [new Sc(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)];
            const e2 = this.canonical.z + 1, r2 = 2 * this.canonical.x, n2 = 2 * this.canonical.y;
            return [new Sc(e2, this.wrap, e2, r2, n2), new Sc(e2, this.wrap, e2, r2 + 1, n2), new Sc(e2, this.wrap, e2, r2, n2 + 1), new Sc(e2, this.wrap, e2, r2 + 1, n2 + 1)];
          }
          isLessThan(t2) {
            return this.wrap < t2.wrap || !(this.wrap > t2.wrap) && (this.overscaledZ < t2.overscaledZ || !(this.overscaledZ > t2.overscaledZ) && (this.canonical.x < t2.canonical.x || !(this.canonical.x > t2.canonical.x) && this.canonical.y < t2.canonical.y));
          }
          wrapped() {
            return new Sc(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
          }
          unwrapTo(t2) {
            return new Sc(this.overscaledZ, t2, this.canonical.z, this.canonical.x, this.canonical.y);
          }
          overscaleFactor() {
            return Math.pow(2, this.overscaledZ - this.canonical.z);
          }
          toUnwrapped() {
            return new Ac(this.wrap, this.canonical);
          }
          toString() {
            return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
          }
        }
        function Ic(t2, e2, r2, n2, i2) {
          const s2 = 1 << Math.min(r2, 22);
          let a2 = s2 * (i2 % s2) + n2 % s2;
          return t2 && r2 < 22 && (a2 += s2 * s2 * ((t2 < 0 ? -2 * t2 - 1 : 2 * t2) % (1 << 2 * (22 - r2)))), 16 * (32 * a2 + r2) + (e2 - r2);
        }
        const Tc = [(t2) => {
          let e2 = t2.canonical.x - 1, r2 = t2.wrap;
          return e2 < 0 && (e2 = (1 << t2.canonical.z) - 1, r2--), new Sc(t2.overscaledZ, r2, t2.canonical.z, e2, t2.canonical.y);
        }, (t2) => {
          let e2 = t2.canonical.x + 1, r2 = t2.wrap;
          return e2 === 1 << t2.canonical.z && (e2 = 0, r2++), new Sc(t2.overscaledZ, r2, t2.canonical.z, e2, t2.canonical.y);
        }, (t2) => new Sc(t2.overscaledZ, t2.wrap, t2.canonical.z, t2.canonical.x, (0 === t2.canonical.y ? 1 << t2.canonical.z : t2.canonical.y) - 1), (t2) => new Sc(t2.overscaledZ, t2.wrap, t2.canonical.z, t2.canonical.x, t2.canonical.y === (1 << t2.canonical.z) - 1 ? 0 : t2.canonical.y + 1)];
        So(Mc, "CanonicalTileID"), So(Sc, "OverscaledTileID", { omit: ["projMatrix", "expandedProjMatrix"] });
        const kc = 0, Pc = 25.5;
        function zc(t2) {
          return xc * Math.cos(t2 * Math.PI / 180);
        }
        function Ec(t2) {
          return (180 + t2) / 360;
        }
        function Bc(t2) {
          return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t2 * Math.PI / 360))) / 360;
        }
        function Dc(t2, e2) {
          return t2 / zc(e2);
        }
        function Rc(t2) {
          return 360 * t2 - 180;
        }
        function Cc(t2) {
          return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t2) * Math.PI / 180)) - 90;
        }
        function Lc(t2, e2) {
          return t2 * zc(Cc(e2));
        }
        const Vc = 85.051129;
        function Fc(t2) {
          return Math.cos(Ge(We(t2, -Vc, Vc)));
        }
        function Oc(t2, e2) {
          const r2 = We(e2, kc, Pc), n2 = Math.pow(2, r2);
          return Fc(t2) * xc / (512 * n2);
        }
        function Uc(t2) {
          return 1 / Math.cos(t2 * Math.PI / 180);
        }
        function jc(t2, e2 = 0) {
          const r2 = Math.exp(Math.PI * (1 - (t2.y + e2 / ds) / (1 << t2.z) * 2));
          return 80150034 * r2 / (r2 * r2 + 1) / ds / (1 << t2.z);
        }
        class Nc {
          constructor(t2, e2, r2 = 0) {
            this.x = +t2, this.y = +e2, this.z = +r2;
          }
          static fromLngLat(t2, e2 = 0) {
            const r2 = bc.convert(t2);
            return new Nc(Ec(r2.lng), Bc(r2.lat), Dc(e2, r2.lat));
          }
          toLngLat() {
            return new bc(Rc(this.x), Cc(this.y));
          }
          toAltitude() {
            return Lc(this.z, this.y);
          }
          meterInMercatorCoordinateUnits() {
            return 1 / xc * Uc(Cc(this.y));
          }
        }
        function $c(t2, e2, r2, n2, i2, s2, a2, o2, l2) {
          const u2 = (e2 + n2) / 2, c2 = (r2 + i2) / 2, h2 = new je(u2, c2);
          o2(h2), function(t3, e3, r3, n3, i3, s3) {
            const a3 = r3 - i3, o3 = n3 - s3;
            return Math.abs((n3 - e3) * a3 - (r3 - t3) * o3) / Math.hypot(a3, o3);
          }(h2.x, h2.y, s2.x, s2.y, a2.x, a2.y) >= l2 ? ($c(t2, e2, r2, u2, c2, s2, h2, o2, l2), $c(t2, u2, c2, n2, i2, h2, a2, o2, l2)) : t2.push(a2);
        }
        function qc(t2, e2, r2) {
          let n2 = t2[0], i2 = n2.x, s2 = n2.y;
          e2(n2);
          const a2 = [n2];
          for (let o2 = 1; o2 < t2.length; o2++) {
            const l2 = t2[o2], { x: u2, y: c2 } = l2;
            e2(l2), $c(a2, i2, s2, u2, c2, n2, l2, e2, r2), i2 = u2, s2 = c2, n2 = l2;
          }
          return a2;
        }
        function Gc(t2, e2, r2, n2) {
          if (n2(e2, r2)) {
            const i2 = e2.add(r2)._mult(0.5);
            Gc(t2, e2, i2, n2), Gc(t2, i2, r2, n2);
          } else
            t2.push(r2);
        }
        function Xc(t2, e2) {
          let r2 = t2[0];
          const n2 = [r2];
          for (let i2 = 1; i2 < t2.length; i2++) {
            const s2 = t2[i2];
            Gc(n2, r2, s2, e2), r2 = s2;
          }
          return n2;
        }
        const Yc = Math.pow(2, 14) - 1, Zc = -Yc - 1;
        function Hc(t2, e2) {
          const r2 = Math.round(t2.x * e2), n2 = Math.round(t2.y * e2);
          return t2.x = We(r2, Zc, Yc), t2.y = We(n2, Zc, Yc), (r2 < t2.x || r2 > t2.x + 1 || n2 < t2.y || n2 > t2.y + 1) && dr("Geometry exceeds allowed extent, reduce your vector tile buffer size"), t2;
        }
        function Kc(t2, e2, r2) {
          const n2 = t2.loadGeometry(), i2 = t2.extent, s2 = ds / i2;
          if (e2 && r2 && r2.projection.isReprojectedInTileSpace) {
            const s3 = 1 << e2.z, { scale: a2, x: o2, y: l2, projection: u2 } = r2, c2 = (t3) => {
              const r3 = Rc((e2.x + t3.x / i2) / s3), n3 = Cc((e2.y + t3.y / i2) / s3), c3 = u2.project(r3, n3);
              t3.x = (c3.x * a2 - o2) * i2, t3.y = (c3.y * a2 - l2) * i2;
            };
            for (let e3 = 0; e3 < n2.length; e3++)
              if (1 !== t2.type)
                n2[e3] = qc(n2[e3], c2, 1);
              else {
                const t3 = [];
                for (const r3 of n2[e3])
                  r3.x < 0 || r3.x >= i2 || r3.y < 0 || r3.y >= i2 || (c2(r3), t3.push(r3));
                n2[e3] = t3;
              }
          }
          for (const t3 of n2)
            for (const e3 of t3)
              Hc(e3, s2);
          return n2;
        }
        function Wc(t2, e2) {
          return { type: t2.type, id: t2.id, properties: t2.properties, geometry: e2 ? Kc(t2) : [] };
        }
        function Jc(t2, e2, r2, n2, i2) {
          t2.emplaceBack(2 * e2 + (n2 + 1) / 2, 2 * r2 + (i2 + 1) / 2);
        }
        function Qc(t2, e2, r2) {
          const n2 = 16384;
          t2.emplaceBack(e2.x, e2.y, e2.z, r2[0] * n2, r2[1] * n2, r2[2] * n2);
        }
        class th {
          constructor(t2) {
            this.zoom = t2.zoom, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.fqid), this.index = t2.index, this.hasPattern = false, this.projection = t2.projection, this.layoutVertexArray = new Ll(), this.indexArray = new tu(), this.segments = new ku(), this.programConfigurations = new ec(t2.layers, { zoom: t2.zoom, lut: t2.lut }), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id);
          }
          updateFootprints(t2, e2) {
          }
          populate(t2, e2, r2, n2) {
            const i2 = this.layers[0], s2 = [];
            let a2 = null;
            "circle" === i2.type && (a2 = i2.layout.get("circle-sort-key"));
            for (const { feature: e3, id: i3, index: o3, sourceLayerIndex: l2 } of t2) {
              const t3 = this.layers[0]._featureFilter.needGeometry, u2 = Wc(e3, t3);
              if (!this.layers[0]._featureFilter.filter(new Wo(this.zoom), u2, r2))
                continue;
              const c2 = a2 ? a2.evaluate(u2, {}, r2) : void 0, h2 = { id: i3, properties: e3.properties, type: e3.type, sourceLayerIndex: l2, index: o3, geometry: t3 ? u2.geometry : Kc(e3, r2, n2), patterns: {}, sortKey: c2 };
              s2.push(h2);
            }
            a2 && s2.sort((t3, e3) => t3.sortKey - e3.sortKey);
            let o2 = null;
            "globe" === n2.projection.name && (this.globeExtVertexArray = new Gl(), o2 = n2.projection);
            for (const n3 of s2) {
              const { geometry: i3, index: s3, sourceLayerIndex: a3 } = n3, l2 = t2[s3].feature;
              this.addFeature(n3, i3, s3, e2.availableImages, r2, o2, e2.brightness), e2.featureIndex.insert(l2, i3, s3, a3, this.index);
            }
          }
          update(t2, e2, r2, n2, i2) {
            const s2 = 0 !== Object.keys(t2).length;
            s2 && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(t2, e2, s2 ? this.stateDependentLayers : this.layers, r2, n2, i2);
          }
          isEmpty() {
            return 0 === this.layoutVertexArray.length;
          }
          uploadPending() {
            return !this.uploaded || this.programConfigurations.needsUpload;
          }
          upload(t2) {
            this.uploaded || (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, Iu.members), this.indexBuffer = t2.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = t2.createVertexBuffer(this.globeExtVertexArray, Tu.members))), this.programConfigurations.upload(t2), this.uploaded = true;
          }
          destroy() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy());
          }
          addFeature(t2, e2, r2, n2, i2, s2, a2) {
            for (const r3 of e2)
              for (const e3 of r3) {
                const r4 = e3.x, n3 = e3.y;
                if (r4 < 0 || r4 >= ds || n3 < 0 || n3 >= ds)
                  continue;
                if (s2) {
                  const t3 = s2.projectTilePoint(r4, n3, i2), e4 = s2.upVector(i2, r4, n3), a4 = this.globeExtVertexArray;
                  Qc(a4, t3, e4), Qc(a4, t3, e4), Qc(a4, t3, e4), Qc(a4, t3, e4);
                }
                const a3 = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t2.sortKey), o2 = a3.vertexLength;
                Jc(this.layoutVertexArray, r4, n3, -1, -1), Jc(this.layoutVertexArray, r4, n3, 1, -1), Jc(this.layoutVertexArray, r4, n3, 1, 1), Jc(this.layoutVertexArray, r4, n3, -1, 1), this.indexArray.emplaceBack(o2, o2 + 1, o2 + 2), this.indexArray.emplaceBack(o2, o2 + 2, o2 + 3), a3.vertexLength += 4, a3.primitiveLength += 2;
              }
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, {}, n2, i2, a2);
          }
        }
        function eh(t2, e2) {
          for (let r2 = 0; r2 < t2.length; r2++)
            if (ch(e2, t2[r2]))
              return true;
          for (let r2 = 0; r2 < e2.length; r2++)
            if (ch(t2, e2[r2]))
              return true;
          return !!sh(t2, e2);
        }
        function rh(t2, e2, r2) {
          return !!ch(t2, e2) || !!oh(e2, t2, r2);
        }
        function nh(t2, e2) {
          if (1 === t2.length)
            return uh(e2, t2[0]);
          for (let r2 = 0; r2 < e2.length; r2++) {
            const n2 = e2[r2];
            for (let e3 = 0; e3 < n2.length; e3++)
              if (ch(t2, n2[e3]))
                return true;
          }
          for (let r2 = 0; r2 < t2.length; r2++)
            if (uh(e2, t2[r2]))
              return true;
          for (let r2 = 0; r2 < e2.length; r2++)
            if (sh(t2, e2[r2]))
              return true;
          return false;
        }
        function ih(t2, e2, r2) {
          if (t2.length > 1) {
            if (sh(t2, e2))
              return true;
            for (let n2 = 0; n2 < e2.length; n2++)
              if (oh(e2[n2], t2, r2))
                return true;
          }
          for (let n2 = 0; n2 < t2.length; n2++)
            if (oh(t2[n2], e2, r2))
              return true;
          return false;
        }
        function sh(t2, e2) {
          if (0 === t2.length || 0 === e2.length)
            return false;
          for (let r2 = 0; r2 < t2.length - 1; r2++) {
            const n2 = t2[r2], i2 = t2[r2 + 1];
            for (let t3 = 0; t3 < e2.length - 1; t3++)
              if (ah(n2, i2, e2[t3], e2[t3 + 1]))
                return true;
          }
          return false;
        }
        function ah(t2, e2, r2, n2) {
          return mr(t2, r2, n2) !== mr(e2, r2, n2) && mr(t2, e2, r2) !== mr(t2, e2, n2);
        }
        function oh(t2, e2, r2) {
          const n2 = r2 * r2;
          if (1 === e2.length)
            return t2.distSqr(e2[0]) < n2;
          for (let r3 = 1; r3 < e2.length; r3++)
            if (lh(t2, e2[r3 - 1], e2[r3]) < n2)
              return true;
          return false;
        }
        function lh(t2, e2, r2) {
          const n2 = e2.distSqr(r2);
          if (0 === n2)
            return t2.distSqr(e2);
          const i2 = ((t2.x - e2.x) * (r2.x - e2.x) + (t2.y - e2.y) * (r2.y - e2.y)) / n2;
          return t2.distSqr(i2 < 0 ? e2 : i2 > 1 ? r2 : r2.sub(e2)._mult(i2)._add(e2));
        }
        function uh(t2, e2) {
          let r2, n2, i2, s2 = false;
          for (let a2 = 0; a2 < t2.length; a2++) {
            r2 = t2[a2];
            for (let t3 = 0, a3 = r2.length - 1; t3 < r2.length; a3 = t3++)
              n2 = r2[t3], i2 = r2[a3], n2.y > e2.y != i2.y > e2.y && e2.x < (i2.x - n2.x) * (e2.y - n2.y) / (i2.y - n2.y) + n2.x && (s2 = !s2);
          }
          return s2;
        }
        function ch(t2, e2) {
          let r2 = false;
          for (let n2 = 0, i2 = t2.length - 1; n2 < t2.length; i2 = n2++) {
            const s2 = t2[n2], a2 = t2[i2];
            s2.y > e2.y != a2.y > e2.y && e2.x < (a2.x - s2.x) * (e2.y - s2.y) / (a2.y - s2.y) + s2.x && (r2 = !r2);
          }
          return r2;
        }
        function hh(t2, e2, r2, n2, i2) {
          for (const s3 of t2)
            if (e2 <= s3.x && r2 <= s3.y && n2 >= s3.x && i2 >= s3.y)
              return true;
          const s2 = [new je(e2, r2), new je(e2, i2), new je(n2, i2), new je(n2, r2)];
          if (t2.length > 2) {
            for (const e3 of s2)
              if (ch(t2, e3))
                return true;
          }
          for (let e3 = 0; e3 < t2.length - 1; e3++)
            if (ph(t2[e3], t2[e3 + 1], s2))
              return true;
          return false;
        }
        function ph(t2, e2, r2) {
          const n2 = r2[0], i2 = r2[2];
          if (t2.x < n2.x && e2.x < n2.x || t2.x > i2.x && e2.x > i2.x || t2.y < n2.y && e2.y < n2.y || t2.y > i2.y && e2.y > i2.y)
            return false;
          const s2 = mr(t2, e2, r2[0]);
          return s2 !== mr(t2, e2, r2[1]) || s2 !== mr(t2, e2, r2[2]) || s2 !== mr(t2, e2, r2[3]);
        }
        function fh(t2, e2, r2, n2, i2, s2) {
          let a2 = e2.y - t2.y, o2 = t2.x - e2.x;
          if (s2 = s2 || 0) {
            const t3 = a2 * a2 + o2 * o2;
            if (0 === t3)
              return true;
            const e3 = Math.sqrt(t3);
            a2 /= e3, o2 /= e3;
          }
          return !((r2.x - t2.x) * a2 + (r2.y - t2.y) * o2 - s2 < 0 || (n2.x - t2.x) * a2 + (n2.y - t2.y) * o2 - s2 < 0 || (i2.x - t2.x) * a2 + (i2.y - t2.y) * o2 - s2 < 0);
        }
        function dh(t2, e2, r2, n2, i2, s2, a2) {
          return !(fh(t2, e2, n2, i2, s2, a2) || fh(e2, r2, n2, i2, s2, a2) || fh(r2, t2, n2, i2, s2, a2) || fh(n2, i2, t2, e2, r2, a2) || fh(i2, s2, t2, e2, r2, a2) || fh(s2, n2, t2, e2, r2, a2));
        }
        function mh(t2, e2, r2) {
          const n2 = e2.paint.get(t2).value;
          return "constant" === n2.kind ? n2.value : r2.programConfigurations.get(e2.id).getMaxValue(t2);
        }
        function yh(t2) {
          return Math.sqrt(t2[0] * t2[0] + t2[1] * t2[1]);
        }
        function gh(t2, e2, r2, n2, i2) {
          if (!e2[0] && !e2[1])
            return t2;
          const s2 = je.convert(e2)._mult(i2);
          "viewport" === r2 && s2._rotate(-n2);
          const a2 = [];
          for (let e3 = 0; e3 < t2.length; e3++)
            a2.push(t2[e3].sub(s2));
          return a2;
        }
        function xh(t2, e2, r2, n2) {
          const i2 = je.convert(t2)._mult(n2);
          return "viewport" === e2 && i2._rotate(-r2), i2;
        }
        let bh, vh;
        So(th, "CircleBucket", { omit: ["layers"] });
        class _h {
          constructor(t2, e2) {
            this.pos = t2, this.dir = e2;
          }
          intersectsPlane(e2, r2, n2) {
            const i2 = t.$.dot(r2, this.dir);
            if (Math.abs(i2) < 1e-6)
              return false;
            const s2 = ((e2[0] - this.pos[0]) * r2[0] + (e2[1] - this.pos[1]) * r2[1] + (e2[2] - this.pos[2]) * r2[2]) / i2;
            return n2[0] = this.pos[0] + this.dir[0] * s2, n2[1] = this.pos[1] + this.dir[1] * s2, n2[2] = this.pos[2] + this.dir[2] * s2, true;
          }
          closestPointOnSphere(e2, r2, n2) {
            if (t.$.equals(this.pos, e2) || 0 === r2)
              return n2[0] = n2[1] = n2[2] = 0, false;
            const [i2, s2, a2] = this.dir, o2 = this.pos[0] - e2[0], l2 = this.pos[1] - e2[1], u2 = this.pos[2] - e2[2], c2 = i2 * i2 + s2 * s2 + a2 * a2, h2 = 2 * (o2 * i2 + l2 * s2 + u2 * a2), p2 = h2 * h2 - 4 * c2 * (o2 * o2 + l2 * l2 + u2 * u2 - r2 * r2);
            if (p2 < 0) {
              const t2 = Math.max(-h2 / 2, 0), e3 = o2 + i2 * t2, c3 = l2 + s2 * t2, p3 = u2 + a2 * t2, f2 = Math.hypot(e3, c3, p3);
              return n2[0] = e3 * r2 / f2, n2[1] = c3 * r2 / f2, n2[2] = p3 * r2 / f2, false;
            }
            {
              const t2 = (-h2 - Math.sqrt(p2)) / (2 * c2);
              if (t2 < 0) {
                const t3 = Math.hypot(o2, l2, u2);
                return n2[0] = o2 * r2 / t3, n2[1] = l2 * r2 / t3, n2[2] = u2 * r2 / t3, false;
              }
              return n2[0] = o2 + i2 * t2, n2[1] = l2 + s2 * t2, n2[2] = u2 + a2 * t2, true;
            }
          }
        }
        class wh {
          constructor(t2, e2, r2, n2, i2) {
            this.TL = t2, this.TR = e2, this.BR = r2, this.BL = n2, this.horizon = i2;
          }
          static fromInvProjectionMatrix(e2, r2, n2) {
            const i2 = [-1, 1, 1], s2 = [1, 1, 1], a2 = [1, -1, 1], o2 = [-1, -1, 1], l2 = t.$.transformMat4(i2, i2, e2), u2 = t.$.transformMat4(s2, s2, e2), c2 = t.$.transformMat4(a2, a2, e2), h2 = t.$.transformMat4(o2, o2, e2);
            return new wh(l2, u2, c2, h2, r2 / n2);
          }
        }
        function Mh(e2, r2, n2) {
          let i2 = 1 / 0, s2 = -1 / 0;
          const a2 = [];
          for (const o2 of e2) {
            t.$.sub(a2, o2, r2);
            const e3 = t.$.dot(a2, n2);
            i2 = Math.min(i2, e3), s2 = Math.max(s2, e3);
          }
          return [i2, s2];
        }
        function Ah(e2, r2) {
          let n2 = true;
          for (let i2 = 0; i2 < e2.planes.length; i2++) {
            const s2 = e2.planes[i2];
            let a2 = 0;
            for (let e3 = 0; e3 < r2.length; e3++)
              a2 += t.$.dot(s2, r2[e3]) + s2[3] >= 0;
            if (0 === a2)
              return 0;
            a2 !== r2.length && (n2 = false);
          }
          return n2 ? 2 : 1;
        }
        function Sh(t2, e2) {
          for (const r2 of t2.projections) {
            const n2 = Mh(e2, t2.points[0], r2.axis);
            if (r2.projection[1] < n2[0] || r2.projection[0] > n2[1])
              return 0;
          }
          return 1;
        }
        function Ih(e2, r2) {
          let n2 = 0;
          const i2 = [0, 0, 0, 0];
          for (let s2 = 0; s2 < e2.length; s2++)
            i2[0] = e2[s2][0], i2[1] = e2[s2][1], i2[2] = e2[s2][2], i2[3] = 1, t.aB.dot(i2, r2) >= 0 && n2++;
          return n2;
        }
        class Th {
          constructor(e2, r2) {
            this.points = e2 || new Array(8).fill([0, 0, 0]), this.planes = r2 || new Array(6).fill([0, 0, 0, 0]), this.bounds = kh.fromPoints(this.points), this.projections = [], this.frustumEdges = [t.$.sub([], this.points[2], this.points[3]), t.$.sub([], this.points[0], this.points[3]), t.$.sub([], this.points[4], this.points[0]), t.$.sub([], this.points[5], this.points[1]), t.$.sub([], this.points[6], this.points[2]), t.$.sub([], this.points[7], this.points[3])];
            for (const t2 of this.frustumEdges) {
              const e3 = [0, -t2[2], t2[1]], r3 = [t2[2], 0, -t2[0]];
              this.projections.push({ axis: e3, projection: Mh(this.points, this.points[0], e3) }), this.projections.push({ axis: r3, projection: Mh(this.points, this.points[0], r3) });
            }
          }
          static fromInvProjectionMatrix(e2, r2, n2, i2) {
            const s2 = Math.pow(2, n2), a2 = [[-1, 1, -1, 1], [1, 1, -1, 1], [1, -1, -1, 1], [-1, -1, -1, 1], [-1, 1, 1, 1], [1, 1, 1, 1], [1, -1, 1, 1], [-1, -1, 1, 1]].map((n3) => {
              const a3 = t.aB.transformMat4([], n3, e2), o3 = 1 / a3[3] / r2 * s2;
              return t.aB.mul(a3, a3, [o3, o3, i2 ? 1 / a3[3] : o3, o3]);
            }), o2 = [[0, 1, 2], [6, 5, 4], [0, 3, 7], [2, 1, 5], [3, 2, 6], [0, 4, 5]].map((e3) => {
              const r3 = t.$.sub([], a2[e3[0]], a2[e3[1]]), n3 = t.$.sub([], a2[e3[2]], a2[e3[1]]), i3 = t.$.normalize([], t.$.cross([], r3, n3)), s3 = -t.$.dot(i3, a2[e3[1]]);
              return i3.concat(s3);
            }), l2 = [];
            for (let t2 = 0; t2 < a2.length; t2++)
              l2.push([a2[t2][0], a2[t2][1], a2[t2][2]]);
            return new Th(l2, o2);
          }
          intersectsPrecise(e2, r2, n2) {
            for (let t2 = 0; t2 < r2.length; t2++)
              if (!Ih(e2, r2[t2]))
                return 0;
            for (let t2 = 0; t2 < this.planes.length; t2++)
              if (!Ih(e2, this.planes[t2]))
                return 0;
            for (const r3 of n2)
              for (const n3 of this.frustumEdges) {
                const i2 = t.$.cross([], r3, n3), s2 = t.$.length(i2);
                if (0 === s2)
                  continue;
                t.$.scale(i2, i2, 1 / s2);
                const a2 = Mh(this.points, this.points[0], i2), o2 = Mh(e2, this.points[0], i2);
                if (a2[0] > o2[1] || o2[0] > a2[1])
                  return 0;
              }
            return 1;
          }
          containsPoint(e2) {
            for (const r2 of this.planes) {
              const n2 = r2[3];
              if (t.$.dot([r2[0], r2[1], r2[2]], e2) + n2 < 0)
                return false;
            }
            return true;
          }
        }
        class kh {
          static fromPoints(e2) {
            const r2 = [1 / 0, 1 / 0, 1 / 0], n2 = [-1 / 0, -1 / 0, -1 / 0];
            for (const i2 of e2)
              t.$.min(r2, r2, i2), t.$.max(n2, n2, i2);
            return new kh(r2, n2);
          }
          static fromTileIdAndHeight(t2, e2, r2) {
            const n2 = 1 << t2.canonical.z, i2 = t2.canonical.x, s2 = t2.canonical.y;
            return new kh([i2 / n2, s2 / n2, e2], [(i2 + 1) / n2, (s2 + 1) / n2, r2]);
          }
          static applyTransform(e2, r2) {
            const n2 = e2.getCorners();
            for (let e3 = 0; e3 < n2.length; ++e3)
              t.$.transformMat4(n2[e3], n2[e3], r2);
            return kh.fromPoints(n2);
          }
          static applyTransformFast(t2, e2) {
            const r2 = [e2[12], e2[13], e2[14]], n2 = [...r2];
            for (let i2 = 0; i2 < 3; i2++)
              for (let s2 = 0; s2 < 3; s2++) {
                const a2 = e2[4 * s2 + i2], o2 = a2 * t2.min[s2], l2 = a2 * t2.max[s2];
                r2[i2] += Math.min(o2, l2), n2[i2] += Math.max(o2, l2);
              }
            return new kh(r2, n2);
          }
          static projectAabbCorners(e2, r2) {
            const n2 = e2.getCorners();
            for (let e3 = 0; e3 < n2.length; ++e3)
              t.$.transformMat4(n2[e3], n2[e3], r2);
            return n2;
          }
          constructor(e2, r2) {
            this.min = e2, this.max = r2, this.center = t.$.scale([], t.$.add([], this.min, this.max), 0.5);
          }
          quadrant(e2) {
            const r2 = [e2 % 2 == 0, e2 < 2], n2 = t.$.clone(this.min), i2 = t.$.clone(this.max);
            for (let t2 = 0; t2 < r2.length; t2++)
              n2[t2] = r2[t2] ? this.min[t2] : this.center[t2], i2[t2] = r2[t2] ? this.center[t2] : this.max[t2];
            return i2[2] = this.max[2], new kh(n2, i2);
          }
          distanceX(t2) {
            return Math.max(Math.min(this.max[0], t2[0]), this.min[0]) - t2[0];
          }
          distanceY(t2) {
            return Math.max(Math.min(this.max[1], t2[1]), this.min[1]) - t2[1];
          }
          distanceZ(t2) {
            return Math.max(Math.min(this.max[2], t2[2]), this.min[2]) - t2[2];
          }
          getCorners() {
            const t2 = this.min, e2 = this.max;
            return [[t2[0], t2[1], t2[2]], [e2[0], t2[1], t2[2]], [e2[0], e2[1], t2[2]], [t2[0], e2[1], t2[2]], [t2[0], t2[1], e2[2]], [e2[0], t2[1], e2[2]], [e2[0], e2[1], e2[2]], [t2[0], e2[1], e2[2]]];
          }
          intersects(t2) {
            return this.intersectsAabb(t2.bounds) ? Ah(t2, this.getCorners()) : 0;
          }
          intersectsFlat(t2) {
            return this.intersectsAabb(t2.bounds) ? Ah(t2, [[this.min[0], this.min[1], 0], [this.max[0], this.min[1], 0], [this.max[0], this.max[1], 0], [this.min[0], this.max[1], 0]]) : 0;
          }
          intersectsPrecise(t2, e2) {
            return e2 || this.intersects(t2) ? Sh(t2, this.getCorners()) : 0;
          }
          intersectsPreciseFlat(t2, e2) {
            return e2 || this.intersectsFlat(t2) ? Sh(t2, [[this.min[0], this.min[1], 0], [this.max[0], this.min[1], 0], [this.max[0], this.max[1], 0], [this.min[0], this.max[1], 0]]) : 0;
          }
          intersectsAabb(t2) {
            for (let e2 = 0; e2 < 3; ++e2)
              if (this.min[e2] > t2.max[e2] || t2.min[e2] > this.max[e2])
                return false;
            return true;
          }
          intersectsAabbXY(t2) {
            return !(this.min[0] > t2.max[0] || t2.min[0] > this.max[0] || this.min[1] > t2.max[1] || t2.min[1] > this.max[1]);
          }
          encapsulate(t2) {
            for (let e2 = 0; e2 < 3; e2++)
              this.min[e2] = Math.min(this.min[e2], t2.min[e2]), this.max[e2] = Math.max(this.max[e2], t2.max[e2]);
          }
          encapsulatePoint(t2) {
            for (let e2 = 0; e2 < 3; e2++)
              this.min[e2] = Math.min(this.min[e2], t2[e2]), this.max[e2] = Math.max(this.max[e2], t2[e2]);
          }
          closestPoint(t2) {
            return [Math.max(Math.min(this.max[0], t2[0]), this.min[0]), Math.max(Math.min(this.max[1], t2[1]), this.min[1]), Math.max(Math.min(this.max[2], t2[2]), this.min[2])];
          }
        }
        So(kh, "Aabb");
        const Ph = Rl([{ type: "Float32", name: "a_globe_pos", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }]), { members: zh } = Ph, Eh = Rl([{ name: "a_pos_3", components: 3, type: "Int16" }]);
        var Bh = Rl([{ name: "a_pos", type: "Int16", components: 2 }]);
        function Dh(t2) {
          return t2 * oc / gc;
        }
        const Rh = [new kh([fc, fc, fc], [dc, dc, dc]), new kh([fc, fc, fc], [0, 0, dc]), new kh([0, fc, fc], [dc, 0, dc]), new kh([fc, 0, fc], [0, dc, dc]), new kh([0, 0, fc], [dc, dc, dc])];
        function Ch(e2, r2, n2, i2 = true) {
          const s2 = t.$.scale([], e2._camera.position, e2.worldSize), a2 = [r2, n2, 1, 1];
          t.aB.transformMat4(a2, a2, e2.pixelMatrixInverse), t.aB.scale(a2, a2, 1 / a2[3]);
          const o2 = t.$.sub([], a2, s2), l2 = t.$.normalize([], o2), u2 = e2.globeMatrix, c2 = [u2[12], u2[13], u2[14]], h2 = t.$.sub([], c2, s2), p2 = t.$.length(h2), f2 = t.$.normalize([], h2), d2 = e2.worldSize / (2 * Math.PI), m2 = t.$.dot(f2, l2), y2 = Math.asin(d2 / p2);
          if (y2 < Math.acos(m2)) {
            if (!i2)
              return null;
            const e3 = [], r3 = [];
            t.$.scale(e3, l2, p2 / m2), t.$.normalize(r3, t.$.sub(r3, e3, h2)), t.$.normalize(l2, t.$.add(l2, h2, t.$.scale(l2, r3, Math.tan(y2) * p2)));
          }
          const g2 = [];
          new _h(s2, l2).closestPointOnSphere(c2, d2, g2);
          const x2 = t.$.normalize([], kr(u2, 0)), b2 = t.$.normalize([], kr(u2, 1)), v2 = t.$.normalize([], kr(u2, 2)), _2 = t.$.dot(x2, g2), w2 = t.$.dot(b2, g2), M2 = t.$.dot(v2, g2), A2 = Xe(Math.asin(-w2 / d2));
          let S2 = Xe(Math.atan2(_2, M2));
          S2 = e2.center.lng + function(t2, e3) {
            const r3 = (e3 - t2 + 180) % 360 - 180;
            return r3 < -180 ? r3 + 360 : r3;
          }(e2.center.lng, S2);
          const I2 = Ec(S2), T2 = We(Bc(A2), 0, 1);
          return new Nc(I2, T2);
        }
        class Lh {
          constructor(e2, r2, n2) {
            this.a = t.$.sub([], e2, n2), this.b = t.$.sub([], r2, n2), this.center = n2;
            const i2 = t.$.normalize([], this.a), s2 = t.$.normalize([], this.b);
            this.angle = Math.acos(t.$.dot(i2, s2));
          }
        }
        function Vh(t2, e2) {
          if (0 === t2.angle)
            return null;
          let r2;
          return r2 = 0 === t2.a[e2] ? 1 / t2.angle * 0.5 * Math.PI : 1 / t2.angle * Math.atan(t2.b[e2] / t2.a[e2] / Math.sin(t2.angle) - 1 / Math.tan(t2.angle)), r2 < 0 || r2 > 1 ? null : function(t3, e3, r3, n2) {
            const i2 = Math.sin(r3);
            return t3 * (Math.sin((1 - n2) * r3) / i2) + e3 * (Math.sin(n2 * r3) / i2);
          }(t2.a[e2], t2.b[e2], t2.angle, We(r2, 0, 1)) + t2.center[e2];
        }
        function Fh(t2) {
          if (t2.z <= 1)
            return Rh[t2.z + 2 * t2.y + t2.x];
          const e2 = qh($h(t2));
          return kh.fromPoints(e2);
        }
        function Oh(e2, r2, n2) {
          return t.$.scale(e2, e2, 1 - n2), t.$.scaleAndAdd(e2, e2, r2, n2);
        }
        function Uh(e2, r2) {
          const n2 = Qh(r2.zoom);
          if (0 === n2)
            return Fh(e2);
          const i2 = $h(e2), s2 = qh(i2), a2 = Ec(i2.getWest()) * r2.worldSize, o2 = Ec(i2.getEast()) * r2.worldSize, l2 = Bc(i2.getNorth()) * r2.worldSize, u2 = Bc(i2.getSouth()) * r2.worldSize, c2 = [a2, l2, 0], h2 = [o2, l2, 0], p2 = [a2, u2, 0], f2 = [o2, u2, 0], d2 = t.ae.invert([], r2.globeMatrix);
          return t.$.transformMat4(c2, c2, d2), t.$.transformMat4(h2, h2, d2), t.$.transformMat4(p2, p2, d2), t.$.transformMat4(f2, f2, d2), s2[0] = Oh(s2[0], p2, n2), s2[1] = Oh(s2[1], f2, n2), s2[2] = Oh(s2[2], h2, n2), s2[3] = Oh(s2[3], c2, n2), kh.fromPoints(s2);
        }
        function jh(e2, r2, n2) {
          for (const i2 of e2)
            t.$.transformMat4(i2, i2, r2), t.$.scale(i2, i2, n2);
        }
        function Nh(e2, r2, n2, i2) {
          const s2 = r2 / e2.worldSize, a2 = e2.globeMatrix;
          if (n2.z <= 1) {
            const t2 = Fh(n2).getCorners();
            return jh(t2, a2, s2), kh.fromPoints(t2);
          }
          const o2 = $h(n2, i2), l2 = qh(o2, oc + Dh(e2._tileCoverLift));
          jh(l2, a2, s2);
          const u2 = Number.MAX_VALUE, c2 = [-u2, -u2, -u2], h2 = [u2, u2, u2];
          if (o2.contains(e2.center)) {
            for (const e3 of l2)
              t.$.min(h2, h2, e3), t.$.max(c2, c2, e3);
            c2[2] = 0;
            const r3 = e2.point, n3 = [r3.x * s2, r3.y * s2, 0];
            return t.$.min(h2, h2, n3), t.$.max(c2, c2, n3), new kh(h2, c2);
          }
          if (e2._tileCoverLift > 0) {
            for (const e3 of l2)
              t.$.min(h2, h2, e3), t.$.max(c2, c2, e3);
            return new kh(h2, c2);
          }
          const p2 = [a2[12] * s2, a2[13] * s2, a2[14] * s2], f2 = o2.getCenter(), d2 = We(e2.center.lat, -Vc, Vc), m2 = We(f2.lat, -Vc, Vc), y2 = Ec(e2.center.lng), g2 = Bc(d2);
          let x2 = y2 - Ec(f2.lng);
          const b2 = g2 - Bc(m2);
          x2 > 0.5 ? x2 -= 1 : x2 < -0.5 && (x2 += 1);
          let v2 = 0;
          if (Math.abs(x2) > Math.abs(b2))
            v2 = x2 >= 0 ? 1 : 3;
          else {
            v2 = b2 >= 0 ? 0 : 2;
            const e3 = [a2[4] * s2, a2[5] * s2, a2[6] * s2], r3 = -Math.sin(Ge(b2 >= 0 ? o2.getSouth() : o2.getNorth())) * oc;
            t.$.scaleAndAdd(p2, p2, e3, r3);
          }
          const _2 = l2[v2], w2 = l2[(v2 + 1) % 4], M2 = new Lh(_2, w2, p2), A2 = [Vh(M2, 0) || _2[0], Vh(M2, 1) || _2[1], Vh(M2, 2) || _2[2]], S2 = Qh(e2.zoom);
          if (S2 > 0) {
            const i3 = function({ x: t2, y: e3, z: r3 }, n3, i4, s4, a3) {
              const o3 = 1 / (1 << r3);
              let l3 = t2 * o3, u3 = l3 + o3, c3 = e3 * o3, h3 = c3 + o3, p3 = 0;
              const f3 = (l3 + u3) / 2 - s4;
              return f3 > 0.5 ? p3 = -1 : f3 < -0.5 && (p3 = 1), l3 = ((l3 + p3) * n3 - (s4 *= n3)) * i4 + s4, u3 = ((u3 + p3) * n3 - s4) * i4 + s4, c3 = (c3 * n3 - (a3 *= n3)) * i4 + a3, h3 = (h3 * n3 - a3) * i4 + a3, [[l3, h3, 0], [u3, h3, 0], [u3, c3, 0], [l3, c3, 0]];
            }(n2, r2, e2._pixelsPerMercatorPixel, y2, g2);
            for (let t2 = 0; t2 < l2.length; t2++)
              Oh(l2[t2], i3[t2], S2);
            const s3 = t.$.add([], i3[v2], i3[(v2 + 1) % 4]);
            t.$.scale(s3, s3, 0.5), Oh(A2, s3, S2);
          }
          for (const e3 of l2)
            t.$.min(h2, h2, e3), t.$.max(c2, c2, e3);
          return h2[2] = Math.min(_2[2], w2[2]), t.$.min(h2, h2, A2), t.$.max(c2, c2, A2), new kh(h2, c2);
        }
        function $h({ x: t2, y: e2, z: r2 }, n2 = false) {
          const i2 = 1 / (1 << r2), s2 = new bc(Rc(t2 * i2), e2 === (1 << r2) - 1 && n2 ? -90 : Cc((e2 + 1) * i2)), a2 = new bc(Rc((t2 + 1) * i2), 0 === e2 && n2 ? 90 : Cc(e2 * i2));
          return new vc(s2, a2);
        }
        function qh(t2, e2 = oc) {
          const r2 = Ge(t2.getNorth()), n2 = Ge(t2.getSouth()), i2 = Math.cos(r2), s2 = Math.cos(n2), a2 = Math.sin(r2), o2 = Math.sin(n2), l2 = t2.getWest(), u2 = t2.getEast();
          return [mc(s2, o2, l2, e2), mc(s2, o2, u2, e2), mc(i2, a2, u2, e2), mc(i2, a2, l2, e2)];
        }
        function Gh(t2, e2, r2, n2) {
          const i2 = 1 << r2.z, s2 = (t2 / ds + r2.x) / i2;
          return yc(Cc((e2 / ds + r2.y) / i2), Rc(s2), n2);
        }
        function Xh({ min: t2, max: e2 }) {
          return cc / Math.max(e2[0] - t2[0], e2[1] - t2[1], e2[2] - t2[2]);
        }
        const Yh = new Float64Array(16);
        function Zh(e2) {
          const r2 = Xh(e2), n2 = t.ae.fromScaling(Yh, [r2, r2, r2]);
          return t.ae.translate(n2, n2, t.$.negate([], e2.min));
        }
        function Hh(e2) {
          const r2 = t.ae.fromTranslation(Yh, e2.min), n2 = 1 / Xh(e2);
          return t.ae.scale(r2, r2, [n2, n2, n2]);
        }
        function Kh(t2) {
          const e2 = ds / (2 * Math.PI);
          return t2 / (2 * Math.PI) / e2;
        }
        function Wh(t2, e2) {
          return ds / (512 * Math.pow(2, t2)) * Xh(Fh(e2));
        }
        function Jh(e2, r2, n2, i2, s2) {
          const a2 = Kh(n2), o2 = [e2, r2, -n2 / (2 * Math.PI)], l2 = t.ae.identity(new Float64Array(16));
          return t.ae.translate(l2, l2, o2), t.ae.scale(l2, l2, [a2, a2, a2]), t.ae.rotateX(l2, l2, Ge(-s2)), t.ae.rotateY(l2, l2, Ge(-i2)), l2;
        }
        function Qh(t2) {
          return Je(lc, uc, t2);
        }
        function tp(e2, r2) {
          const n2 = yc(r2.lat, r2.lng), i2 = function(e3) {
            const r3 = yc(e3._center.lat, e3._center.lng), n3 = t.$.fromValues(0, 1, 0);
            let i3 = t.$.cross([], n3, r3);
            const s3 = t.ae.fromRotation([], -e3.angle, r3);
            i3 = t.$.transformMat4(i3, i3, s3), t.ae.fromRotation(s3, -e3._pitch, i3);
            const a2 = t.$.normalize([], r3);
            return t.$.scale(a2, a2, Dh(e3.cameraToCenterDistance / e3.pixelsPerMeter)), t.$.transformMat4(a2, a2, s3), t.$.add([], r3, a2);
          }(e2), s2 = t.$.subtract([], i2, n2);
          return t.$.angle(s2, n2);
        }
        function ep(t2, e2) {
          return tp(t2, e2) > Math.PI / 2 * 1.01;
        }
        const rp = Ge(85), np = Math.cos(rp), ip = Math.sin(rp), sp = t.ae.create(), ap = (t2) => {
          const e2 = [];
          return "map" === t2.paint.get("circle-pitch-alignment") && e2.push("PITCH_WITH_MAP"), "map" === t2.paint.get("circle-pitch-scale") && e2.push("SCALE_WITH_MAP"), e2;
        };
        function op(e2, r2, n2, i2, s2, a2, o2, l2, u2) {
          if (a2 && e2.queryGeometry.isAboveHorizon)
            return false;
          a2 && (u2 *= e2.pixelToTileUnitsFactor);
          const c2 = e2.tileID.canonical, h2 = n2.projection.upVectorScale(c2, n2.center.lat, n2.worldSize).metersToTile;
          for (const p2 of r2)
            for (const r3 of p2) {
              const p3 = r3.add(l2), f2 = s2 && n2.elevation ? n2.elevation.exaggeration() * s2.getElevationAt(p3.x, p3.y, true) : 0, d2 = n2.projection.projectTilePoint(p3.x, p3.y, c2);
              if (f2 > 0) {
                const t2 = n2.projection.upVector(c2, p3.x, p3.y);
                d2.x += t2[0] * h2 * f2, d2.y += t2[1] * h2 * f2, d2.z += t2[2] * h2 * f2;
              }
              const m2 = a2 ? p3 : lp(d2.x, d2.y, d2.z, i2), y2 = a2 ? e2.tilespaceRays.map((t2) => hp(t2, f2)) : e2.queryGeometry.screenGeometry, g2 = t.aB.transformMat4([], [d2.x, d2.y, d2.z, 1], i2);
              if (!o2 && a2 ? u2 *= g2[3] / n2.cameraToCenterDistance : o2 && !a2 && (u2 *= n2.cameraToCenterDistance / g2[3]), a2) {
                const t2 = Cc((r3.y / ds + c2.y) / (1 << c2.z));
                u2 /= n2.projection.pixelsPerMeter(t2, 1) / Dc(1, t2);
              }
              if (rh(y2, m2, u2))
                return true;
            }
          return false;
        }
        function lp(e2, r2, n2, i2) {
          const s2 = t.aB.transformMat4([], [e2, r2, n2, 1], i2);
          return new je(s2[0] / s2[3], s2[1] / s2[3]);
        }
        const up = t.$.fromValues(0, 0, 0), cp = t.$.fromValues(0, 0, 1);
        function hp(e2, r2) {
          const n2 = t.$.create();
          return up[2] = r2, e2.intersectsPlane(up, cp, n2), new je(n2[0], n2[1]);
        }
        class pp extends th {
        }
        function fp(t2, { width: e2, height: r2 }, n2, i2) {
          if (i2) {
            if (i2 instanceof Uint8ClampedArray)
              i2 = new Uint8Array(i2.buffer);
            else if (i2.length !== e2 * r2 * n2)
              throw new RangeError("mismatched image size");
          } else
            i2 = new Uint8Array(e2 * r2 * n2);
          return t2.width = e2, t2.height = r2, t2.data = i2, t2;
        }
        function dp(t2, e2, r2) {
          const { width: n2, height: i2 } = e2;
          n2 === t2.width && i2 === t2.height || (mp(t2, e2, { x: 0, y: 0 }, { x: 0, y: 0 }, { width: Math.min(t2.width, n2), height: Math.min(t2.height, i2) }, r2, null), t2.width = n2, t2.height = i2, t2.data = e2.data);
        }
        function mp(t2, e2, r2, n2, i2, s2, a2, o2) {
          if (0 === i2.width || 0 === i2.height)
            return e2;
          if (i2.width > t2.width || i2.height > t2.height || r2.x > t2.width - i2.width || r2.y > t2.height - i2.height)
            throw new RangeError("out of range source coordinates for image copy");
          if (i2.width > e2.width || i2.height > e2.height || n2.x > e2.width - i2.width || n2.y > e2.height - i2.height)
            throw new RangeError("out of range destination coordinates for image copy");
          const l2 = t2.data, u2 = e2.data, c2 = 4 === s2 && o2;
          for (let o3 = 0; o3 < i2.height; o3++) {
            const h2 = ((r2.y + o3) * t2.width + r2.x) * s2, p2 = ((n2.y + o3) * e2.width + n2.x) * s2;
            if (c2)
              for (let t3 = 0; t3 < i2.width; t3++) {
                const e3 = h2 + t3 * s2 + 3, r3 = p2 + t3 * s2;
                u2[r3 + 0] = 255, u2[r3 + 1] = 255, u2[r3 + 2] = 255, u2[r3 + 3] = l2[e3];
              }
            else if (a2)
              for (let t3 = 0; t3 < i2.width; t3++) {
                const e3 = h2 + t3 * s2, r3 = p2 + t3 * s2, n3 = l2[e3 + 3], i3 = new Gn(l2[e3 + 0] / 255 * n3, l2[e3 + 1] / 255 * n3, l2[e3 + 2] / 255 * n3, n3).toRenderColor(a2).toArray();
                u2[r3 + 0] = i3[0], u2[r3 + 1] = i3[1], u2[r3 + 2] = i3[2], u2[r3 + 3] = i3[3];
              }
            else
              for (let t3 = 0; t3 < i2.width * s2; t3++)
                u2[p2 + t3] = l2[h2 + t3];
          }
          return e2;
        }
        So(pp, "HeatmapBucket", { omit: ["layers"] });
        class yp {
          constructor(t2, e2) {
            fp(this, t2, 1, e2);
          }
          resize(t2) {
            dp(this, new yp(t2), 1);
          }
          clone() {
            return new yp({ width: this.width, height: this.height }, new Uint8Array(this.data));
          }
          static copy(t2, e2, r2, n2, i2) {
            mp(t2, e2, r2, n2, i2, 1, null);
          }
        }
        class gp {
          constructor(t2, e2) {
            fp(this, t2, 4, e2);
          }
          resize(t2) {
            dp(this, new gp(t2), 4);
          }
          replace(t2, e2) {
            e2 ? this.data.set(t2) : this.data = t2 instanceof Uint8ClampedArray ? new Uint8Array(t2.buffer) : t2;
          }
          clone() {
            return new gp({ width: this.width, height: this.height }, new Uint8Array(this.data));
          }
          static copy(t2, e2, r2, n2, i2, s2, a2) {
            mp(t2, e2, r2, n2, i2, 4, s2, a2);
          }
        }
        class xp {
          constructor(t2, e2) {
            this.width = t2.width, this.height = t2.height, this.data = e2 instanceof Uint8Array ? new Float32Array(e2.buffer) : e2;
          }
        }
        let bp, vp, _p, wp;
        function Mp(t2) {
          const e2 = {}, r2 = t2.resolution || 256, n2 = t2.clips ? t2.clips.length : 1, i2 = t2.image || new gp({ width: r2, height: n2 }), s2 = (r3, n3, s3) => {
            e2[t2.evaluationKey] = s3;
            const a2 = t2.expression.evaluate(e2);
            a2 && (i2.data[r3 + n3 + 0] = Math.floor(255 * a2.r / a2.a), i2.data[r3 + n3 + 1] = Math.floor(255 * a2.g / a2.a), i2.data[r3 + n3 + 2] = Math.floor(255 * a2.b / a2.a), i2.data[r3 + n3 + 3] = Math.floor(255 * a2.a));
          };
          if (t2.clips)
            for (let e3 = 0, i3 = 0; e3 < n2; ++e3, i3 += 4 * r2)
              for (let n3 = 0, a2 = 0; n3 < r2; n3++, a2 += 4) {
                const o2 = n3 / (r2 - 1), { start: l2, end: u2 } = t2.clips[e3];
                s2(i3, a2, l2 * (1 - o2) + u2 * o2);
              }
          else
            for (let t3 = 0, e3 = 0; t3 < r2; t3++, e3 += 4)
              s2(0, e3, t3 / (r2 - 1));
          return i2;
        }
        So(yp, "AlphaImage"), So(gp, "RGBAImage");
        const Ap = Rl([{ name: "a_pos", components: 2, type: "Int16" }], 4), { members: Sp } = Ap;
        function Ip(t2, e2, r2 = 2) {
          const n2 = e2 && e2.length, i2 = n2 ? e2[0] * r2 : t2.length;
          let s2 = Tp(t2, 0, i2, r2, true);
          const a2 = [];
          if (!s2 || s2.next === s2.prev)
            return a2;
          let o2, l2, u2;
          if (n2 && (s2 = function(t3, e3, r3, n3) {
            const i3 = [];
            for (let r4 = 0, s3 = e3.length; r4 < s3; r4++) {
              const a3 = Tp(t3, e3[r4] * n3, r4 < s3 - 1 ? e3[r4 + 1] * n3 : t3.length, n3, false);
              a3 === a3.next && (a3.steiner = true), i3.push(Fp(a3));
            }
            i3.sort(Rp);
            for (let t4 = 0; t4 < i3.length; t4++)
              r3 = Cp(i3[t4], r3);
            return r3;
          }(t2, e2, s2, r2)), t2.length > 80 * r2) {
            o2 = 1 / 0, l2 = 1 / 0;
            let e3 = -1 / 0, n3 = -1 / 0;
            for (let s3 = r2; s3 < i2; s3 += r2) {
              const r3 = t2[s3], i3 = t2[s3 + 1];
              r3 < o2 && (o2 = r3), i3 < l2 && (l2 = i3), r3 > e3 && (e3 = r3), i3 > n3 && (n3 = i3);
            }
            u2 = Math.max(e3 - o2, n3 - l2), u2 = 0 !== u2 ? 32767 / u2 : 0;
          }
          return Pp(s2, a2, r2, o2, l2, u2, 0), a2;
        }
        function Tp(t2, e2, r2, n2, i2) {
          let s2;
          if (i2 === function(t3, e3, r3, n3) {
            let i3 = 0;
            for (let s3 = e3, a2 = r3 - n3; s3 < r3; s3 += n3)
              i3 += (t3[a2] - t3[s3]) * (t3[s3 + 1] + t3[a2 + 1]), a2 = s3;
            return i3;
          }(t2, e2, r2, n2) > 0)
            for (let i3 = e2; i3 < r2; i3 += n2)
              s2 = Zp(i3 / n2 | 0, t2[i3], t2[i3 + 1], s2);
          else
            for (let i3 = r2 - n2; i3 >= e2; i3 -= n2)
              s2 = Zp(i3 / n2 | 0, t2[i3], t2[i3 + 1], s2);
          return s2 && Np(s2, s2.next) && (Hp(s2), s2 = s2.next), s2;
        }
        function kp(t2, e2) {
          if (!t2)
            return t2;
          e2 || (e2 = t2);
          let r2, n2 = t2;
          do {
            if (r2 = false, n2.steiner || !Np(n2, n2.next) && 0 !== jp(n2.prev, n2, n2.next))
              n2 = n2.next;
            else {
              if (Hp(n2), n2 = e2 = n2.prev, n2 === n2.next)
                break;
              r2 = true;
            }
          } while (r2 || n2 !== e2);
          return e2;
        }
        function Pp(t2, e2, r2, n2, i2, s2, a2) {
          if (!t2)
            return;
          !a2 && s2 && function(t3, e3, r3, n3) {
            let i3 = t3;
            do {
              0 === i3.z && (i3.z = Vp(i3.x, i3.y, e3, r3, n3)), i3.prevZ = i3.prev, i3.nextZ = i3.next, i3 = i3.next;
            } while (i3 !== t3);
            i3.prevZ.nextZ = null, i3.prevZ = null, function(t4) {
              let e4, r4 = 1;
              do {
                let n4, i4 = t4;
                t4 = null;
                let s3 = null;
                for (e4 = 0; i4; ) {
                  e4++;
                  let a3 = i4, o3 = 0;
                  for (let t5 = 0; t5 < r4 && (o3++, a3 = a3.nextZ, a3); t5++)
                    ;
                  let l2 = r4;
                  for (; o3 > 0 || l2 > 0 && a3; )
                    0 !== o3 && (0 === l2 || !a3 || i4.z <= a3.z) ? (n4 = i4, i4 = i4.nextZ, o3--) : (n4 = a3, a3 = a3.nextZ, l2--), s3 ? s3.nextZ = n4 : t4 = n4, n4.prevZ = s3, s3 = n4;
                  i4 = a3;
                }
                s3.nextZ = null, r4 *= 2;
              } while (e4 > 1);
            }(i3);
          }(t2, n2, i2, s2);
          let o2 = t2;
          for (; t2.prev !== t2.next; ) {
            const l2 = t2.prev, u2 = t2.next;
            if (s2 ? Ep(t2, n2, i2, s2) : zp(t2))
              e2.push(l2.i, t2.i, u2.i), Hp(t2), t2 = u2.next, o2 = u2.next;
            else if ((t2 = u2) === o2) {
              a2 ? 1 === a2 ? Pp(t2 = Bp(kp(t2), e2), e2, r2, n2, i2, s2, 2) : 2 === a2 && Dp(t2, e2, r2, n2, i2, s2) : Pp(kp(t2), e2, r2, n2, i2, s2, 1);
              break;
            }
          }
        }
        function zp(t2) {
          const e2 = t2.prev, r2 = t2, n2 = t2.next;
          if (jp(e2, r2, n2) >= 0)
            return false;
          const i2 = e2.x, s2 = r2.x, a2 = n2.x, o2 = e2.y, l2 = r2.y, u2 = n2.y, c2 = i2 < s2 ? i2 < a2 ? i2 : a2 : s2 < a2 ? s2 : a2, h2 = o2 < l2 ? o2 < u2 ? o2 : u2 : l2 < u2 ? l2 : u2, p2 = i2 > s2 ? i2 > a2 ? i2 : a2 : s2 > a2 ? s2 : a2, f2 = o2 > l2 ? o2 > u2 ? o2 : u2 : l2 > u2 ? l2 : u2;
          let d2 = n2.next;
          for (; d2 !== e2; ) {
            if (d2.x >= c2 && d2.x <= p2 && d2.y >= h2 && d2.y <= f2 && Op(i2, o2, s2, l2, a2, u2, d2.x, d2.y) && jp(d2.prev, d2, d2.next) >= 0)
              return false;
            d2 = d2.next;
          }
          return true;
        }
        function Ep(t2, e2, r2, n2) {
          const i2 = t2.prev, s2 = t2, a2 = t2.next;
          if (jp(i2, s2, a2) >= 0)
            return false;
          const o2 = i2.x, l2 = s2.x, u2 = a2.x, c2 = i2.y, h2 = s2.y, p2 = a2.y, f2 = o2 < l2 ? o2 < u2 ? o2 : u2 : l2 < u2 ? l2 : u2, d2 = c2 < h2 ? c2 < p2 ? c2 : p2 : h2 < p2 ? h2 : p2, m2 = o2 > l2 ? o2 > u2 ? o2 : u2 : l2 > u2 ? l2 : u2, y2 = c2 > h2 ? c2 > p2 ? c2 : p2 : h2 > p2 ? h2 : p2, g2 = Vp(f2, d2, e2, r2, n2), x2 = Vp(m2, y2, e2, r2, n2);
          let b2 = t2.prevZ, v2 = t2.nextZ;
          for (; b2 && b2.z >= g2 && v2 && v2.z <= x2; ) {
            if (b2.x >= f2 && b2.x <= m2 && b2.y >= d2 && b2.y <= y2 && b2 !== i2 && b2 !== a2 && Op(o2, c2, l2, h2, u2, p2, b2.x, b2.y) && jp(b2.prev, b2, b2.next) >= 0)
              return false;
            if (b2 = b2.prevZ, v2.x >= f2 && v2.x <= m2 && v2.y >= d2 && v2.y <= y2 && v2 !== i2 && v2 !== a2 && Op(o2, c2, l2, h2, u2, p2, v2.x, v2.y) && jp(v2.prev, v2, v2.next) >= 0)
              return false;
            v2 = v2.nextZ;
          }
          for (; b2 && b2.z >= g2; ) {
            if (b2.x >= f2 && b2.x <= m2 && b2.y >= d2 && b2.y <= y2 && b2 !== i2 && b2 !== a2 && Op(o2, c2, l2, h2, u2, p2, b2.x, b2.y) && jp(b2.prev, b2, b2.next) >= 0)
              return false;
            b2 = b2.prevZ;
          }
          for (; v2 && v2.z <= x2; ) {
            if (v2.x >= f2 && v2.x <= m2 && v2.y >= d2 && v2.y <= y2 && v2 !== i2 && v2 !== a2 && Op(o2, c2, l2, h2, u2, p2, v2.x, v2.y) && jp(v2.prev, v2, v2.next) >= 0)
              return false;
            v2 = v2.nextZ;
          }
          return true;
        }
        function Bp(t2, e2) {
          let r2 = t2;
          do {
            const n2 = r2.prev, i2 = r2.next.next;
            !Np(n2, i2) && $p(n2, r2, r2.next, i2) && Xp(n2, i2) && Xp(i2, n2) && (e2.push(n2.i, r2.i, i2.i), Hp(r2), Hp(r2.next), r2 = t2 = i2), r2 = r2.next;
          } while (r2 !== t2);
          return kp(r2);
        }
        function Dp(t2, e2, r2, n2, i2, s2) {
          let a2 = t2;
          do {
            let t3 = a2.next.next;
            for (; t3 !== a2.prev; ) {
              if (a2.i !== t3.i && Up(a2, t3)) {
                let o2 = Yp(a2, t3);
                return a2 = kp(a2, a2.next), o2 = kp(o2, o2.next), Pp(a2, e2, r2, n2, i2, s2, 0), void Pp(o2, e2, r2, n2, i2, s2, 0);
              }
              t3 = t3.next;
            }
            a2 = a2.next;
          } while (a2 !== t2);
        }
        function Rp(t2, e2) {
          return t2.x - e2.x;
        }
        function Cp(t2, e2) {
          const r2 = function(t3, e3) {
            let r3 = e3;
            const n3 = t3.x, i2 = t3.y;
            let s2, a2 = -1 / 0;
            do {
              if (i2 <= r3.y && i2 >= r3.next.y && r3.next.y !== r3.y) {
                const t4 = r3.x + (i2 - r3.y) * (r3.next.x - r3.x) / (r3.next.y - r3.y);
                if (t4 <= n3 && t4 > a2 && (a2 = t4, s2 = r3.x < r3.next.x ? r3 : r3.next, t4 === n3))
                  return s2;
              }
              r3 = r3.next;
            } while (r3 !== e3);
            if (!s2)
              return null;
            const o2 = s2, l2 = s2.x, u2 = s2.y;
            let c2 = 1 / 0;
            r3 = s2;
            do {
              if (n3 >= r3.x && r3.x >= l2 && n3 !== r3.x && Op(i2 < u2 ? n3 : a2, i2, l2, u2, i2 < u2 ? a2 : n3, i2, r3.x, r3.y)) {
                const e4 = Math.abs(i2 - r3.y) / (n3 - r3.x);
                Xp(r3, t3) && (e4 < c2 || e4 === c2 && (r3.x > s2.x || r3.x === s2.x && Lp(s2, r3))) && (s2 = r3, c2 = e4);
              }
              r3 = r3.next;
            } while (r3 !== o2);
            return s2;
          }(t2, e2);
          if (!r2)
            return e2;
          const n2 = Yp(r2, t2);
          return kp(n2, n2.next), kp(r2, r2.next);
        }
        function Lp(t2, e2) {
          return jp(t2.prev, t2, e2.prev) < 0 && jp(e2.next, t2, t2.next) < 0;
        }
        function Vp(t2, e2, r2, n2, i2) {
          return (t2 = 1431655765 & ((t2 = 858993459 & ((t2 = 252645135 & ((t2 = 16711935 & ((t2 = (t2 - r2) * i2 | 0) | t2 << 8)) | t2 << 4)) | t2 << 2)) | t2 << 1)) | (e2 = 1431655765 & ((e2 = 858993459 & ((e2 = 252645135 & ((e2 = 16711935 & ((e2 = (e2 - n2) * i2 | 0) | e2 << 8)) | e2 << 4)) | e2 << 2)) | e2 << 1)) << 1;
        }
        function Fp(t2) {
          let e2 = t2, r2 = t2;
          do {
            (e2.x < r2.x || e2.x === r2.x && e2.y < r2.y) && (r2 = e2), e2 = e2.next;
          } while (e2 !== t2);
          return r2;
        }
        function Op(t2, e2, r2, n2, i2, s2, a2, o2) {
          return (i2 - a2) * (e2 - o2) >= (t2 - a2) * (s2 - o2) && (t2 - a2) * (n2 - o2) >= (r2 - a2) * (e2 - o2) && (r2 - a2) * (s2 - o2) >= (i2 - a2) * (n2 - o2);
        }
        function Up(t2, e2) {
          return t2.next.i !== e2.i && t2.prev.i !== e2.i && !function(t3, e3) {
            let r2 = t3;
            do {
              if (r2.i !== t3.i && r2.next.i !== t3.i && r2.i !== e3.i && r2.next.i !== e3.i && $p(r2, r2.next, t3, e3))
                return true;
              r2 = r2.next;
            } while (r2 !== t3);
            return false;
          }(t2, e2) && (Xp(t2, e2) && Xp(e2, t2) && function(t3, e3) {
            let r2 = t3, n2 = false;
            const i2 = (t3.x + e3.x) / 2, s2 = (t3.y + e3.y) / 2;
            do {
              r2.y > s2 != r2.next.y > s2 && r2.next.y !== r2.y && i2 < (r2.next.x - r2.x) * (s2 - r2.y) / (r2.next.y - r2.y) + r2.x && (n2 = !n2), r2 = r2.next;
            } while (r2 !== t3);
            return n2;
          }(t2, e2) && (jp(t2.prev, t2, e2.prev) || jp(t2, e2.prev, e2)) || Np(t2, e2) && jp(t2.prev, t2, t2.next) > 0 && jp(e2.prev, e2, e2.next) > 0);
        }
        function jp(t2, e2, r2) {
          return (e2.y - t2.y) * (r2.x - e2.x) - (e2.x - t2.x) * (r2.y - e2.y);
        }
        function Np(t2, e2) {
          return t2.x === e2.x && t2.y === e2.y;
        }
        function $p(t2, e2, r2, n2) {
          const i2 = Gp(jp(t2, e2, r2)), s2 = Gp(jp(t2, e2, n2)), a2 = Gp(jp(r2, n2, t2)), o2 = Gp(jp(r2, n2, e2));
          return i2 !== s2 && a2 !== o2 || !(0 !== i2 || !qp(t2, r2, e2)) || !(0 !== s2 || !qp(t2, n2, e2)) || !(0 !== a2 || !qp(r2, t2, n2)) || !(0 !== o2 || !qp(r2, e2, n2));
        }
        function qp(t2, e2, r2) {
          return e2.x <= Math.max(t2.x, r2.x) && e2.x >= Math.min(t2.x, r2.x) && e2.y <= Math.max(t2.y, r2.y) && e2.y >= Math.min(t2.y, r2.y);
        }
        function Gp(t2) {
          return t2 > 0 ? 1 : t2 < 0 ? -1 : 0;
        }
        function Xp(t2, e2) {
          return jp(t2.prev, t2, t2.next) < 0 ? jp(t2, e2, t2.next) >= 0 && jp(t2, t2.prev, e2) >= 0 : jp(t2, e2, t2.prev) < 0 || jp(t2, t2.next, e2) < 0;
        }
        function Yp(t2, e2) {
          const r2 = Kp(t2.i, t2.x, t2.y), n2 = Kp(e2.i, e2.x, e2.y), i2 = t2.next, s2 = e2.prev;
          return t2.next = e2, e2.prev = t2, r2.next = i2, i2.prev = r2, n2.next = r2, r2.prev = n2, s2.next = n2, n2.prev = s2, n2;
        }
        function Zp(t2, e2, r2, n2) {
          const i2 = Kp(t2, e2, r2);
          return n2 ? (i2.next = n2.next, i2.prev = n2, n2.next.prev = i2, n2.next = i2) : (i2.prev = i2, i2.next = i2), i2;
        }
        function Hp(t2) {
          t2.next.prev = t2.prev, t2.prev.next = t2.next, t2.prevZ && (t2.prevZ.nextZ = t2.nextZ), t2.nextZ && (t2.nextZ.prevZ = t2.prevZ);
        }
        function Kp(t2, e2, r2) {
          return { i: t2, x: e2, y: r2, prev: null, next: null, z: 0, prevZ: null, nextZ: null, steiner: false };
        }
        function Wp(t2, e2) {
          const r2 = t2.length;
          if (r2 <= 1)
            return [t2];
          const n2 = [];
          let i2, s2;
          for (let e3 = 0; e3 < r2; e3++) {
            const r3 = yr(t2[e3]);
            0 !== r3 && (t2[e3].area = Math.abs(r3), void 0 === s2 && (s2 = r3 < 0), s2 === r3 < 0 ? (i2 && n2.push(i2), i2 = [t2[e3]]) : i2.push(t2[e3]));
          }
          if (i2 && n2.push(i2), e2 > 1)
            for (let t3 = 0; t3 < n2.length; t3++)
              n2[t3].length <= e2 || (Vi(n2[t3], e2, 1, n2[t3].length - 1, Jp), n2[t3] = n2[t3].slice(0, e2));
          return n2;
        }
        function Jp(t2, e2) {
          return e2.area - t2.area;
        }
        function Qp(t2, e2, r2) {
          const n2 = r2.patternDependencies;
          let i2 = false;
          for (const r3 of e2) {
            const e3 = r3.paint.get(`${t2}-pattern`);
            e3.isConstant() || (i2 = true);
            const s2 = e3.constantOr(null);
            s2 && (i2 = true, n2[s2] = true);
          }
          return i2;
        }
        function tf(t2, e2, r2, n2, i2) {
          const s2 = i2.patternDependencies;
          for (const a2 of e2) {
            const e3 = a2.paint.get(`${t2}-pattern`).value;
            if ("constant" !== e3.kind) {
              let t3 = e3.evaluate({ zoom: n2 }, r2, {}, i2.availableImages);
              t3 = t3 && t3.name ? t3.name : t3, s2[t3] = true, r2.patterns[a2.id] = t3;
            }
          }
          return r2;
        }
        class ef {
          constructor(t2) {
            this.zoom = t2.zoom, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.fqid), this.index = t2.index, this.hasPattern = false, this.patternFeatures = [], this.layoutVertexArray = new Ll(), this.indexArray = new tu(), this.indexArray2 = new Hl(), this.programConfigurations = new ec(t2.layers, { zoom: t2.zoom, lut: t2.lut }), this.segments = new ku(), this.segments2 = new ku(), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.projection = t2.projection;
          }
          updateFootprints(t2, e2) {
          }
          populate(t2, e2, r2, n2) {
            this.hasPattern = Qp("fill", this.layers, e2);
            const i2 = this.layers[0].layout.get("fill-sort-key"), s2 = [];
            for (const { feature: a2, id: o2, index: l2, sourceLayerIndex: u2 } of t2) {
              const t3 = this.layers[0]._featureFilter.needGeometry, c2 = Wc(a2, t3);
              if (!this.layers[0]._featureFilter.filter(new Wo(this.zoom), c2, r2))
                continue;
              const h2 = i2 ? i2.evaluate(c2, {}, r2, e2.availableImages) : void 0, p2 = { id: o2, properties: a2.properties, type: a2.type, sourceLayerIndex: u2, index: l2, geometry: t3 ? c2.geometry : Kc(a2, r2, n2), patterns: {}, sortKey: h2 };
              s2.push(p2);
            }
            i2 && s2.sort((t3, e3) => t3.sortKey - e3.sortKey);
            for (const n3 of s2) {
              const { geometry: i3, index: s3, sourceLayerIndex: a2 } = n3;
              if (this.hasPattern) {
                const t3 = tf("fill", this.layers, n3, this.zoom, e2);
                this.patternFeatures.push(t3);
              } else
                this.addFeature(n3, i3, s3, r2, {}, e2.availableImages, e2.brightness);
              e2.featureIndex.insert(t2[s3].feature, i3, s3, a2, this.index);
            }
          }
          update(t2, e2, r2, n2, i2) {
            const s2 = 0 !== Object.keys(t2).length;
            s2 && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(t2, e2, s2 ? this.stateDependentLayers : this.layers, r2, n2, i2);
          }
          addFeatures(t2, e2, r2, n2, i2, s2) {
            for (const t3 of this.patternFeatures)
              this.addFeature(t3, t3.geometry, t3.index, e2, r2, n2, s2);
          }
          isEmpty() {
            return 0 === this.layoutVertexArray.length;
          }
          uploadPending() {
            return !this.uploaded || this.programConfigurations.needsUpload;
          }
          upload(t2) {
            this.uploaded || (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, Sp), this.indexBuffer = t2.createIndexBuffer(this.indexArray), this.indexBuffer2 = t2.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t2), this.uploaded = true;
          }
          destroy() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
          }
          addFeature(t2, e2, r2, n2, i2, s2 = [], a2) {
            for (const t3 of Wp(e2, 500)) {
              let e3 = 0;
              for (const r4 of t3)
                e3 += r4.length;
              const r3 = this.segments.prepareSegment(e3, this.layoutVertexArray, this.indexArray), n3 = r3.vertexLength, i3 = [], s3 = [];
              for (const e4 of t3) {
                if (0 === e4.length)
                  continue;
                e4 !== t3[0] && s3.push(i3.length / 2);
                const r4 = this.segments2.prepareSegment(e4.length, this.layoutVertexArray, this.indexArray2), n4 = r4.vertexLength;
                this.layoutVertexArray.emplaceBack(e4[0].x, e4[0].y), this.indexArray2.emplaceBack(n4 + e4.length - 1, n4), i3.push(e4[0].x), i3.push(e4[0].y);
                for (let t4 = 1; t4 < e4.length; t4++)
                  this.layoutVertexArray.emplaceBack(e4[t4].x, e4[t4].y), this.indexArray2.emplaceBack(n4 + t4 - 1, n4 + t4), i3.push(e4[t4].x), i3.push(e4[t4].y);
                r4.vertexLength += e4.length, r4.primitiveLength += e4.length;
              }
              const a3 = Ip(i3, s3);
              for (let t4 = 0; t4 < a3.length; t4 += 3)
                this.indexArray.emplaceBack(n3 + a3[t4], n3 + a3[t4 + 1], n3 + a3[t4 + 2]);
              r3.vertexLength += e3, r3.primitiveLength += a3.length / 3;
            }
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, i2, s2, n2, a2);
          }
        }
        let rf, nf, sf, af;
        So(ef, "FillBucket", { omit: ["layers", "patternFeatures"] });
        class of {
          constructor(t2, e2, r2, n2) {
            if (this.triangleCount = e2.length / 3, this.min = new je(0, 0), this.max = new je(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cells = [], this.payload = [], 0 === this.triangleCount || 0 === t2.length)
              return;
            const [i2, s2] = [t2[0].clone(), t2[0].clone()];
            for (let e3 = 1; e3 < t2.length; ++e3) {
              const r3 = t2[e3];
              i2.x = Math.min(i2.x, r3.x), i2.y = Math.min(i2.y, r3.y), s2.x = Math.max(s2.x, r3.x), s2.y = Math.max(s2.y, r3.y);
            }
            if (n2) {
              const t3 = Math.ceil(Math.max(s2.x - i2.x, s2.y - i2.y) / n2);
              r2 = Math.max(r2, t3);
            }
            if (0 === r2)
              return;
            this.min = i2, this.max = s2;
            const a2 = this.max.sub(this.min);
            a2.x = Math.max(a2.x, 1), a2.y = Math.max(a2.y, 1);
            const o2 = Math.max(a2.x, a2.y) / r2;
            this.cellsX = Math.max(1, Math.ceil(a2.x / o2)), this.cellsY = Math.max(1, Math.ceil(a2.y / o2)), this.xScale = 1 / o2, this.yScale = 1 / o2;
            const l2 = [];
            for (let r3 = 0; r3 < this.triangleCount; r3++) {
              const n3 = t2[e2[3 * r3 + 0]].sub(this.min), i3 = t2[e2[3 * r3 + 1]].sub(this.min), s3 = t2[e2[3 * r3 + 2]].sub(this.min), a3 = lf(Math.floor(Math.min(n3.x, i3.x, s3.x)), this.xScale, this.cellsX), u3 = lf(Math.floor(Math.max(n3.x, i3.x, s3.x)), this.xScale, this.cellsX), c2 = lf(Math.floor(Math.min(n3.y, i3.y, s3.y)), this.yScale, this.cellsY), h2 = lf(Math.floor(Math.max(n3.y, i3.y, s3.y)), this.yScale, this.cellsY), p2 = new je(0, 0), f2 = new je(0, 0), d2 = new je(0, 0), m2 = new je(0, 0);
              for (let t3 = c2; t3 <= h2; ++t3) {
                p2.y = f2.y = t3 * o2, d2.y = m2.y = (t3 + 1) * o2;
                for (let e3 = a3; e3 <= u3; ++e3)
                  p2.x = d2.x = e3 * o2, f2.x = m2.x = (e3 + 1) * o2, (dh(n3, i3, s3, p2, f2, m2) || dh(n3, i3, s3, p2, m2, d2)) && l2.push({ cellIdx: t3 * this.cellsX + e3, triIdx: r3 });
              }
            }
            if (0 === l2.length)
              return;
            l2.sort((t3, e3) => t3.cellIdx - e3.cellIdx || t3.triIdx - e3.triIdx);
            let u2 = 0;
            for (; u2 < l2.length; ) {
              const t3 = l2[u2].cellIdx, e3 = { start: this.payload.length, len: 0 };
              for (; u2 < l2.length && l2[u2].cellIdx === t3; )
                ++e3.len, this.payload.push(l2[u2++].triIdx);
              this.cells[t3] = e3;
            }
          }
          _lazyInitLookup() {
            this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8))), this.lookup.fill(0);
          }
          queryPoint(t2, e2) {
            if (0 === this.triangleCount || 0 === this.cells.length)
              return;
            if (t2.x > this.max.x || this.min.x > t2.x || t2.y > this.max.y || this.min.y > t2.y)
              return;
            const r2 = lf(t2.x - this.min.x, this.xScale, this.cellsX), n2 = lf(t2.y - this.min.y, this.yScale, this.cellsY), i2 = this.cells[n2 * this.cellsX + r2];
            if (i2) {
              this._lazyInitLookup();
              for (let t3 = 0; t3 < i2.len; t3++) {
                const r3 = this.payload[i2.start + t3], n3 = Math.floor(r3 / 8), s2 = 1 << r3 % 8;
                if (!(this.lookup[n3] & s2) && (this.lookup[n3] |= s2, e2.push(r3), e2.length === this.triangleCount))
                  return;
              }
            }
          }
          query(t2, e2, r2) {
            if (0 === this.triangleCount || 0 === this.cells.length)
              return;
            if (t2.x > this.max.x || this.min.x > e2.x)
              return;
            if (t2.y > this.max.y || this.min.y > e2.y)
              return;
            this._lazyInitLookup();
            const n2 = lf(t2.x - this.min.x, this.xScale, this.cellsX), i2 = lf(e2.x - this.min.x, this.xScale, this.cellsX), s2 = lf(t2.y - this.min.y, this.yScale, this.cellsY), a2 = lf(e2.y - this.min.y, this.yScale, this.cellsY);
            for (let t3 = s2; t3 <= a2; t3++)
              for (let e3 = n2; e3 <= i2; e3++) {
                const n3 = this.cells[t3 * this.cellsX + e3];
                if (n3)
                  for (let t4 = 0; t4 < n3.len; t4++) {
                    const e4 = this.payload[n3.start + t4], i3 = Math.floor(e4 / 8), s3 = 1 << e4 % 8;
                    if (!(this.lookup[i3] & s3) && (this.lookup[i3] |= s3, r2.push(e4), r2.length === this.triangleCount))
                      return;
                  }
              }
          }
        }
        function lf(t2, e2, r2) {
          return Math.max(0, Math.min(r2 - 1, Math.floor(t2 * e2)));
        }
        So(of, "TriangleGridIndex");
        class uf {
          constructor(t2) {
            this.zoom = t2.zoom, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.fqid), this.index = t2.index, this.hasPattern = false, this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.footprints = [];
          }
          updateFootprints(t2, e2) {
            for (const r2 of this.footprints)
              e2.push({ footprint: r2, id: t2 });
          }
          populate(t2, e2, r2, n2) {
            const i2 = [];
            for (const { feature: e3, id: s2, index: a2, sourceLayerIndex: o2 } of t2) {
              const t3 = this.layers[0]._featureFilter.needGeometry, l2 = Wc(e3, t3);
              if (!this.layers[0]._featureFilter.filter(new Wo(this.zoom), l2, r2))
                continue;
              const u2 = { id: s2, properties: e3.properties, type: e3.type, sourceLayerIndex: o2, index: a2, geometry: t3 ? l2.geometry : Kc(e3, r2, n2), patterns: {} };
              i2.push(u2);
            }
            for (const n3 of i2) {
              const { geometry: i3, index: s2, sourceLayerIndex: a2 } = n3;
              this.addFeature(n3, i3, s2, r2, {}, e2.availableImages, e2.brightness), e2.featureIndex.insert(t2[s2].feature, i3, s2, a2, this.index);
            }
          }
          isEmpty() {
            return 0 === this.footprints.length;
          }
          uploadPending() {
            return false;
          }
          upload(t2) {
          }
          update(t2, e2, r2, n2, i2) {
          }
          destroy() {
          }
          addFeature(t2, e2, r2, n2, i2, s2 = [], a2) {
            for (const t3 of Wp(e2, 2)) {
              const e3 = [], r3 = [], n3 = [], i3 = new je(1 / 0, 1 / 0), s3 = new je(-1 / 0, -1 / 0);
              for (const a4 of t3)
                if (0 !== a4.length) {
                  a4 !== t3[0] && n3.push(r3.length / 2);
                  for (let t4 = 0; t4 < a4.length; t4++)
                    r3.push(a4[t4].x), r3.push(a4[t4].y), e3.push(a4[t4]), i3.x = Math.min(i3.x, a4[t4].x), i3.y = Math.min(i3.y, a4[t4].y), s3.x = Math.max(s3.x, a4[t4].x), s3.y = Math.max(s3.y, a4[t4].y);
                }
              const a3 = Ip(r3, n3), o2 = new of(e3, a3, 8, 256);
              this.footprints.push({ vertices: e3, indices: a3, grid: o2, min: i3, max: s3 });
            }
          }
        }
        So(uf, "ClipBucket", { omit: ["layers"] });
        const cf = Rl([{ name: "a_pos_normal_ed", components: 4, type: "Int16" }]), hf = Rl([{ name: "a_pos_end", components: 4, type: "Int16" }, { name: "a_angular_offset_factor", components: 1, type: "Int16" }]), pf = Rl([{ name: "a_centroid_pos", components: 2, type: "Uint16" }]), ff = Rl([{ name: "a_join_normal_inside_polygon", components: 4, type: "Int16" }]), df = Rl([{ name: "a_hidden_by_landmark", components: 1, type: "Uint8" }]), mf = Rl([{ name: "a_pos_3", components: 3, type: "Int16" }, { name: "a_pos_normal_3", components: 3, type: "Int16" }]), { members: yf } = cf;
        var gf = {}, xf = Oe, bf = vf;
        function vf(t2, e2, r2, n2, i2) {
          this.properties = {}, this.extent = r2, this.type = 0, this._pbf = t2, this._geometry = -1, this._keys = n2, this._values = i2, t2.readFields(_f, this, e2);
        }
        function _f(t2, e2, r2) {
          1 == t2 ? e2.id = r2.readVarint() : 2 == t2 ? function(t3, e3) {
            for (var r3 = t3.readVarint() + t3.pos; t3.pos < r3; ) {
              var n2 = e3._keys[t3.readVarint()], i2 = e3._values[t3.readVarint()];
              e3.properties[n2] = i2;
            }
          }(r2, e2) : 3 == t2 ? e2.type = r2.readVarint() : 4 == t2 && (e2._geometry = r2.pos);
        }
        function wf(t2) {
          for (var e2, r2, n2 = 0, i2 = 0, s2 = t2.length, a2 = s2 - 1; i2 < s2; a2 = i2++)
            n2 += ((r2 = t2[a2]).x - (e2 = t2[i2]).x) * (e2.y + r2.y);
          return n2;
        }
        vf.types = ["Unknown", "Point", "LineString", "Polygon"], vf.prototype.loadGeometry = function() {
          var t2 = this._pbf;
          t2.pos = this._geometry;
          for (var e2, r2 = t2.readVarint() + t2.pos, n2 = 1, i2 = 0, s2 = 0, a2 = 0, o2 = []; t2.pos < r2; ) {
            if (i2 <= 0) {
              var l2 = t2.readVarint();
              n2 = 7 & l2, i2 = l2 >> 3;
            }
            if (i2--, 1 === n2 || 2 === n2)
              s2 += t2.readSVarint(), a2 += t2.readSVarint(), 1 === n2 && (e2 && o2.push(e2), e2 = []), e2.push(new xf(s2, a2));
            else {
              if (7 !== n2)
                throw new Error("unknown command " + n2);
              e2 && e2.push(e2[0].clone());
            }
          }
          return e2 && o2.push(e2), o2;
        }, vf.prototype.bbox = function() {
          var t2 = this._pbf;
          t2.pos = this._geometry;
          for (var e2 = t2.readVarint() + t2.pos, r2 = 1, n2 = 0, i2 = 0, s2 = 0, a2 = 1 / 0, o2 = -1 / 0, l2 = 1 / 0, u2 = -1 / 0; t2.pos < e2; ) {
            if (n2 <= 0) {
              var c2 = t2.readVarint();
              r2 = 7 & c2, n2 = c2 >> 3;
            }
            if (n2--, 1 === r2 || 2 === r2)
              (i2 += t2.readSVarint()) < a2 && (a2 = i2), i2 > o2 && (o2 = i2), (s2 += t2.readSVarint()) < l2 && (l2 = s2), s2 > u2 && (u2 = s2);
            else if (7 !== r2)
              throw new Error("unknown command " + r2);
          }
          return [a2, l2, o2, u2];
        }, vf.prototype.toGeoJSON = function(t2, e2, r2) {
          var n2, i2, s2 = this.extent * Math.pow(2, r2), a2 = this.extent * t2, o2 = this.extent * e2, l2 = this.loadGeometry(), u2 = vf.types[this.type];
          function c2(t3) {
            for (var e3 = 0; e3 < t3.length; e3++) {
              var r3 = t3[e3];
              t3[e3] = [360 * (r3.x + a2) / s2 - 180, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r3.y + o2) / s2) * Math.PI / 180)) - 90];
            }
          }
          switch (this.type) {
            case 1:
              var h2 = [];
              for (n2 = 0; n2 < l2.length; n2++)
                h2[n2] = l2[n2][0];
              c2(l2 = h2);
              break;
            case 2:
              for (n2 = 0; n2 < l2.length; n2++)
                c2(l2[n2]);
              break;
            case 3:
              for (l2 = function(t3) {
                var e3 = t3.length;
                if (e3 <= 1)
                  return [t3];
                for (var r3, n3, i3 = [], s3 = 0; s3 < e3; s3++) {
                  var a3 = wf(t3[s3]);
                  0 !== a3 && (void 0 === n3 && (n3 = a3 < 0), n3 === a3 < 0 ? (r3 && i3.push(r3), r3 = [t3[s3]]) : r3.push(t3[s3]));
                }
                return r3 && i3.push(r3), i3;
              }(l2), n2 = 0; n2 < l2.length; n2++)
                for (i2 = 0; i2 < l2[n2].length; i2++)
                  c2(l2[n2][i2]);
          }
          1 === l2.length ? l2 = l2[0] : u2 = "Multi" + u2;
          var p2 = { type: "Feature", geometry: { type: u2, coordinates: l2 }, properties: this.properties };
          return "id" in this && (p2.id = this.id), p2;
        };
        var Mf = bf, Af = Sf;
        function Sf(t2, e2) {
          this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t2, this._keys = [], this._values = [], this._features = [], t2.readFields(If, this, e2), this.length = this._features.length;
        }
        function If(t2, e2, r2) {
          15 === t2 ? e2.version = r2.readVarint() : 1 === t2 ? e2.name = r2.readString() : 5 === t2 ? e2.extent = r2.readVarint() : 2 === t2 ? e2._features.push(r2.pos) : 3 === t2 ? e2._keys.push(r2.readString()) : 4 === t2 && e2._values.push(function(t3) {
            for (var e3 = null, r3 = t3.readVarint() + t3.pos; t3.pos < r3; ) {
              var n2 = t3.readVarint() >> 3;
              e3 = 1 === n2 ? t3.readString() : 2 === n2 ? t3.readFloat() : 3 === n2 ? t3.readDouble() : 4 === n2 ? t3.readVarint64() : 5 === n2 ? t3.readVarint() : 6 === n2 ? t3.readSVarint() : 7 === n2 ? t3.readBoolean() : null;
            }
            return e3;
          }(r2));
        }
        Sf.prototype.feature = function(t2) {
          if (t2 < 0 || t2 >= this._features.length)
            throw new Error("feature index out of bounds");
          this._pbf.pos = this._features[t2];
          var e2 = this._pbf.readVarint() + this._pbf.pos;
          return new Mf(this._pbf, e2, this.extent, this._keys, this._values);
        };
        var Tf = Af;
        function kf(t2, e2, r2) {
          if (3 === t2) {
            var n2 = new Tf(r2, r2.readVarint() + r2.pos);
            n2.length && (e2[n2.name] = n2);
          }
        }
        var Pf = gf.VectorTile = function(t2, e2) {
          this.layers = t2.readFields(kf, {}, e2);
        }, zf = gf.VectorTileFeature = bf;
        gf.VectorTileLayer = Af;
        class Ef extends je {
          constructor(t2, e2, r2) {
            super(t2, e2), this.z = r2;
          }
        }
        class Bf extends Ef {
          constructor(t2, e2, r2, n2) {
            super(t2, e2, r2), this.w = n2;
          }
        }
        function Df(t2, e2, r2, n2) {
          const i2 = [], s2 = 0 === n2 ? (t3, e3, r3, n3, i3, s3) => {
            t3.push(new je(s3, r3 + (s3 - e3) / (n3 - e3) * (i3 - r3)));
          } : (t3, e3, r3, n3, i3, s3) => {
            t3.push(new je(e3 + (s3 - r3) / (i3 - r3) * (n3 - e3), s3));
          };
          for (const a2 of t2) {
            const t3 = [];
            for (const i3 of a2) {
              if (i3.length <= 2)
                continue;
              const a3 = [];
              for (let t4 = 0; t4 < i3.length - 1; t4++) {
                const o3 = i3[t4].x, l3 = i3[t4].y, u2 = i3[t4 + 1].x, c2 = i3[t4 + 1].y, h2 = 0 === n2 ? o3 : l3, p2 = 0 === n2 ? u2 : c2;
                h2 < e2 ? p2 > e2 && s2(a3, o3, l3, u2, c2, e2) : h2 > r2 ? p2 < r2 && s2(a3, o3, l3, u2, c2, r2) : a3.push(i3[t4]), p2 < e2 && h2 >= e2 && s2(a3, o3, l3, u2, c2, e2), p2 > r2 && h2 <= r2 && s2(a3, o3, l3, u2, c2, r2);
              }
              let o2 = i3[i3.length - 1];
              const l2 = 0 === n2 ? o2.x : o2.y;
              l2 >= e2 && l2 <= r2 && a3.push(o2), a3.length && (o2 = a3[a3.length - 1], a3[0].x === o2.x && a3[0].y === o2.y || a3.push(a3[0]), t3.push(a3));
            }
            t3.length && i2.push(t3);
          }
          return i2;
        }
        function Rf(t2, e2, r2, n2) {
          const i2 = "x" === r2 ? "y" : "x", s2 = (n2 - t2[r2]) / (e2[r2] - t2[r2]);
          t2[i2] = t2[i2] + (e2[i2] - t2[i2]) * s2, t2[r2] = n2, t2.hasOwnProperty("z") && (t2.z = Yn(t2.z, e2.z, s2)), t2.hasOwnProperty("w") && (t2.w = Yn(t2.w, e2.w, s2));
        }
        function Cf(t2, e2, r2, n2) {
          const i2 = r2, s2 = n2;
          for (const r3 of ["x", "y"]) {
            let n3 = t2, a2 = e2;
            n3[r3] >= a2[r3] && (n3 = e2, a2 = t2), n3[r3] < i2 && a2[r3] > i2 && Rf(n3, a2, r3, i2), n3[r3] < s2 && a2[r3] > s2 && Rf(a2, n3, r3, s2);
          }
        }
        const Lf = Number.MAX_SAFE_INTEGER;
        function Vf(t2, e2, r2, n2) {
          return t2.order < e2 || t2.order === Lf || !(t2.clipMask & r2) || function(t3, e3) {
            return 0 !== e3.length && void 0 === e3.find((e4) => e4 === t3);
          }(n2, t2.clipScope);
        }
        function Ff(t2, e2) {
          return t2.x - e2.x || t2.y - e2.y;
        }
        function Of(t2, e2) {
          return 0 === Ff(t2.min, e2.min) && 0 === Ff(t2.max, e2.max);
        }
        function Uf(t2, e2) {
          return !(t2.min.x > e2.max.x || t2.max.x < e2.min.x || t2.min.y > e2.max.y || t2.max.y < e2.min.y);
        }
        function jf(t2, e2) {
          if (t2.length !== e2.length)
            return false;
          for (let r2 = 0; r2 < t2.length; r2++)
            if (t2[r2].sourceId !== e2[r2].sourceId || !Of(t2[r2], e2[r2]) || t2[r2].order !== e2[r2].order || t2[r2].clipMask !== e2[r2].clipMask || !Ne(t2[r2].clipScope, e2[r2].clipScope))
              return false;
          return true;
        }
        function Nf(t2, e2, r2) {
          const n2 = 1 / ds, i2 = 1 / (1 << r2.canonical.z), s2 = (e2.x * n2 + r2.canonical.x) * i2 + r2.wrap, a2 = (e2.y * n2 + r2.canonical.y) * i2;
          return { min: new je((t2.x * n2 + r2.canonical.x) * i2 + r2.wrap, (t2.y * n2 + r2.canonical.y) * i2), max: new je(s2, a2) };
        }
        function $f(t2, e2, r2) {
          const n2 = 1 << r2.canonical.z, i2 = ((e2.x - r2.wrap) * n2 - r2.canonical.x) * ds, s2 = (e2.y * n2 - r2.canonical.y) * ds;
          return { min: new je(((t2.x - r2.wrap) * n2 - r2.canonical.x) * ds, (t2.y * n2 - r2.canonical.y) * ds), max: new je(i2, s2) };
        }
        function qf(t2, e2, r2, n2, i2, s2, a2) {
          const o2 = t2.indices, l2 = t2.vertices, u2 = [];
          for (let c2 = n2; c2 < n2 + i2; c2 += 3) {
            const n3 = e2[r2[c2 + 0] + s2], i3 = e2[r2[c2 + 1] + s2], h2 = e2[r2[c2 + 2] + s2], p2 = Math.min(n3.x, i3.x, h2.x), f2 = Math.max(n3.x, i3.x, h2.x), d2 = Math.min(n3.y, i3.y, h2.y), m2 = Math.max(n3.y, i3.y, h2.y);
            u2.length = 0, t2.grid.query(new je(p2, d2), new je(f2, m2), u2);
            for (let t3 = 0; t3 < u2.length; t3++) {
              const e3 = u2[t3];
              if (dh(l2[o2[3 * e3 + 0]], l2[o2[3 * e3 + 1]], l2[o2[3 * e3 + 2]], n3, i3, h2, a2))
                return true;
            }
          }
          return false;
        }
        function Gf(t2, e2, r2, n2) {
          if (!t2 || !r2)
            return false;
          let i2 = t2.vertices;
          if (!e2.canonical.equals(n2.canonical) || e2.wrap !== n2.wrap) {
            if (r2.vertices.length < t2.vertices.length)
              return Gf(r2, n2, t2, e2);
            const s2 = e2.canonical, a2 = n2.canonical, o2 = Math.pow(2, a2.z - s2.z);
            i2 = t2.vertices.map((t3) => new je((t3.x + s2.x * ds) * o2 - a2.x * ds, (t3.y + s2.y * ds) * o2 - a2.y * ds));
          }
          return qf(r2, i2, t2.indices, 0, t2.indices.length, 0, 0);
        }
        function Xf(t2, e2, r2, n2) {
          const i2 = Math.pow(2, n2.z - r2.z);
          return new je((t2 + r2.x * ds) * i2 - n2.x * ds, (e2 + r2.y * ds) * i2 - n2.y * ds);
        }
        function Yf(t2, e2) {
          const r2 = [];
          e2.footprint.grid.queryPoint(t2, r2);
          const n2 = e2.footprint.indices, i2 = e2.footprint.vertices;
          for (let e3 = 0; e3 < r2.length; e3++) {
            const s2 = r2[e3];
            if (ch([i2[n2[3 * s2 + 0]], i2[n2[3 * s2 + 1]], i2[n2[3 * s2 + 2]]], t2))
              return true;
          }
          return false;
        }
        class Zf {
          constructor(t2) {
            this.size = t2, this.minimums = [], this.maximums = [], this.leaves = [];
          }
          getElevation(t2, e2) {
            const r2 = this.toIdx(t2, e2);
            return { min: this.minimums[r2], max: this.maximums[r2] };
          }
          isLeaf(t2, e2) {
            return this.leaves[this.toIdx(t2, e2)];
          }
          toIdx(t2, e2) {
            return e2 * this.size + t2;
          }
        }
        function Hf(t2, e2, r2, n2) {
          let i2 = 0, s2 = Number.MAX_VALUE;
          for (let a2 = 0; a2 < 3; a2++)
            if (Math.abs(n2[a2]) < 1e-15) {
              if (r2[a2] < t2[a2] || r2[a2] > e2[a2])
                return null;
            } else {
              const o2 = 1 / n2[a2];
              let l2 = (t2[a2] - r2[a2]) * o2, u2 = (e2[a2] - r2[a2]) * o2;
              if (l2 > u2) {
                const t3 = l2;
                l2 = u2, u2 = t3;
              }
              if (l2 > i2 && (i2 = l2), u2 < s2 && (s2 = u2), i2 > s2)
                return null;
            }
          return i2;
        }
        function Kf(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2) {
          const h2 = n2 - t2, p2 = i2 - e2, f2 = s2 - r2, d2 = a2 - t2, m2 = o2 - e2, y2 = l2 - r2, g2 = c2[1] * y2 - c2[2] * m2, x2 = c2[2] * d2 - c2[0] * y2, b2 = c2[0] * m2 - c2[1] * d2, v2 = h2 * g2 + p2 * x2 + f2 * b2;
          if (Math.abs(v2) < 1e-15)
            return null;
          const _2 = 1 / v2, w2 = u2[0] - t2, M2 = u2[1] - e2, A2 = u2[2] - r2, S2 = (w2 * g2 + M2 * x2 + A2 * b2) * _2;
          if (S2 < 0 || S2 > 1)
            return null;
          const I2 = M2 * f2 - A2 * p2, T2 = A2 * h2 - w2 * f2, k2 = w2 * p2 - M2 * h2, P2 = (c2[0] * I2 + c2[1] * T2 + c2[2] * k2) * _2;
          return P2 < 0 || S2 + P2 > 1 ? null : (d2 * I2 + m2 * T2 + y2 * k2) * _2;
        }
        function Wf(t2, e2, r2) {
          return (t2 - e2) / (r2 - e2);
        }
        function Jf(t2, e2, r2, n2, i2, s2, a2, o2, l2) {
          const u2 = 1 << r2, c2 = s2 - n2, h2 = a2 - i2, p2 = (t2 + 1) / u2 * c2 + n2, f2 = (e2 + 0) / u2 * h2 + i2, d2 = (e2 + 1) / u2 * h2 + i2;
          o2[0] = (t2 + 0) / u2 * c2 + n2, o2[1] = f2, l2[0] = p2, l2[1] = d2;
        }
        class Qf {
          constructor(t2) {
            if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = t2, this._siblingOffset = [[0, 0], [1, 0], [0, 1], [1, 1]], !this.dem)
              return;
            const e2 = function(t3) {
              const e3 = Math.ceil(Math.log2(t3.dim / 8)), r3 = [];
              let n3 = Math.ceil(Math.pow(2, e3));
              const i2 = 1 / n3, s2 = (t4, e4, r4, n4, i3) => {
                const s3 = n4 ? 1 : 0, a3 = (t4 + 1) * r4 - s3, o3 = e4 * r4, l2 = (e4 + 1) * r4 - s3;
                i3[0] = t4 * r4, i3[1] = o3, i3[2] = a3, i3[3] = l2;
              };
              let a2 = new Zf(n3);
              const o2 = [];
              for (let e4 = 0; e4 < n3 * n3; e4++) {
                s2(e4 % n3, Math.floor(e4 / n3), i2, false, o2);
                const r4 = ed(o2[0], o2[1], t3), l2 = ed(o2[2], o2[1], t3), u2 = ed(o2[2], o2[3], t3), c2 = ed(o2[0], o2[3], t3);
                a2.minimums.push(Math.min(r4, l2, u2, c2)), a2.maximums.push(Math.max(r4, l2, u2, c2)), a2.leaves.push(1);
              }
              for (r3.push(a2), n3 /= 2; n3 >= 1; n3 /= 2) {
                const t4 = r3[r3.length - 1];
                a2 = new Zf(n3);
                for (let e4 = 0; e4 < n3 * n3; e4++) {
                  s2(e4 % n3, Math.floor(e4 / n3), 2, true, o2);
                  const r4 = t4.getElevation(o2[0], o2[1]), i3 = t4.getElevation(o2[2], o2[1]), l2 = t4.getElevation(o2[2], o2[3]), u2 = t4.getElevation(o2[0], o2[3]), c2 = t4.isLeaf(o2[0], o2[1]), h2 = t4.isLeaf(o2[2], o2[1]), p2 = t4.isLeaf(o2[2], o2[3]), f2 = t4.isLeaf(o2[0], o2[3]), d2 = Math.min(r4.min, i3.min, l2.min, u2.min), m2 = Math.max(r4.max, i3.max, l2.max, u2.max), y2 = c2 && h2 && p2 && f2;
                  a2.maximums.push(m2), a2.minimums.push(d2), a2.leaves.push(m2 - d2 <= 5 && y2 ? 1 : 0);
                }
                r3.push(a2);
              }
              return r3;
            }(this.dem), r2 = e2.length - 1, n2 = e2[r2];
            this._addNode(n2.minimums[0], n2.maximums[0], n2.leaves[0]), this._construct(e2, 0, 0, r2, 0);
          }
          raycastRoot(t2, e2, r2, n2, i2, s2, a2 = 1) {
            return Hf([t2, e2, -100], [r2, n2, this.maximums[0] * a2], i2, s2);
          }
          raycast(e2, r2, n2, i2, s2, a2, o2 = 1) {
            if (!this.nodeCount)
              return null;
            const l2 = this.raycastRoot(e2, r2, n2, i2, s2, a2, o2);
            if (null == l2)
              return null;
            const u2 = [], c2 = [], h2 = [], p2 = [], f2 = [{ idx: 0, t: l2, nodex: 0, nodey: 0, depth: 0 }];
            for (; f2.length > 0; ) {
              const { idx: l3, t: d2, nodex: m2, nodey: y2, depth: g2 } = f2.pop();
              if (this.leaves[l3]) {
                Jf(m2, y2, g2, e2, r2, n2, i2, h2, p2);
                const l4 = 1 << g2, u3 = (m2 + 0) / l4, c3 = (m2 + 1) / l4, f3 = (y2 + 0) / l4, x3 = (y2 + 1) / l4, b2 = ed(u3, f3, this.dem) * o2, v2 = ed(c3, f3, this.dem) * o2, _2 = ed(c3, x3, this.dem) * o2, w2 = ed(u3, x3, this.dem) * o2, M2 = Kf(h2[0], h2[1], b2, p2[0], h2[1], v2, p2[0], p2[1], _2, s2, a2), A2 = Kf(p2[0], p2[1], _2, h2[0], p2[1], w2, h2[0], h2[1], b2, s2, a2), S2 = Math.min(null !== M2 ? M2 : Number.MAX_VALUE, null !== A2 ? A2 : Number.MAX_VALUE);
                if (S2 !== Number.MAX_VALUE)
                  return S2;
                {
                  const e3 = t.$.scaleAndAdd([], s2, a2, d2);
                  if (td(b2, v2, w2, _2, Wf(e3[0], h2[0], p2[0]), Wf(e3[1], h2[1], p2[1])) >= e3[2])
                    return d2;
                }
                continue;
              }
              let x2 = 0;
              for (let t2 = 0; t2 < this._siblingOffset.length; t2++) {
                Jf((m2 << 1) + this._siblingOffset[t2][0], (y2 << 1) + this._siblingOffset[t2][1], g2 + 1, e2, r2, n2, i2, h2, p2), h2[2] = -100, p2[2] = this.maximums[this.childOffsets[l3] + t2] * o2;
                const f3 = Hf(h2, p2, s2, a2);
                if (null != f3) {
                  const e3 = f3;
                  u2[t2] = e3;
                  let r3 = false;
                  for (let n3 = 0; n3 < x2 && !r3; n3++)
                    e3 >= u2[c2[n3]] && (c2.splice(n3, 0, t2), r3 = true);
                  r3 || (c2[x2] = t2), x2++;
                }
              }
              for (let t2 = 0; t2 < x2; t2++) {
                const e3 = c2[t2];
                f2.push({ idx: this.childOffsets[l3] + e3, t: u2[e3], nodex: (m2 << 1) + this._siblingOffset[e3][0], nodey: (y2 << 1) + this._siblingOffset[e3][1], depth: g2 + 1 });
              }
            }
            return null;
          }
          _addNode(t2, e2, r2) {
            return this.minimums.push(t2), this.maximums.push(e2), this.leaves.push(r2), this.childOffsets.push(0), this.nodeCount++;
          }
          _construct(t2, e2, r2, n2, i2) {
            if (1 === t2[n2].isLeaf(e2, r2))
              return;
            this.childOffsets[i2] || (this.childOffsets[i2] = this.nodeCount);
            const s2 = n2 - 1, a2 = t2[s2];
            let o2 = 0, l2 = 0;
            for (let t3 = 0; t3 < this._siblingOffset.length; t3++) {
              const n3 = 2 * e2 + this._siblingOffset[t3][0], i3 = 2 * r2 + this._siblingOffset[t3][1], s3 = a2.getElevation(n3, i3), u2 = a2.isLeaf(n3, i3), c2 = this._addNode(s3.min, s3.max, u2);
              u2 && (o2 |= 1 << t3), l2 || (l2 = c2);
            }
            for (let n3 = 0; n3 < this._siblingOffset.length; n3++)
              o2 & 1 << n3 || this._construct(t2, 2 * e2 + this._siblingOffset[n3][0], 2 * r2 + this._siblingOffset[n3][1], s2, l2 + n3);
          }
        }
        function td(t2, e2, r2, n2, i2, s2) {
          return Yn(Yn(t2, r2, s2), Yn(e2, n2, s2), i2);
        }
        function ed(t2, e2, r2) {
          const n2 = r2.dim, i2 = We(t2 * n2 - 0.5, 0, n2 - 1), s2 = We(e2 * n2 - 0.5, 0, n2 - 1), a2 = Math.floor(i2), o2 = Math.floor(s2), l2 = Math.min(a2 + 1, n2 - 1), u2 = Math.min(o2 + 1, n2 - 1);
          return td(r2.get(a2, o2), r2.get(l2, o2), r2.get(a2, u2), r2.get(l2, u2), i2 - a2, s2 - o2);
        }
        const rd = { mapbox: [6553.6, 25.6, 0.1, 1e4], terrarium: [256, 1, 1 / 256, 32768] };
        function nd(t2, e2, r2) {
          return (256 * t2 * 256 + 256 * e2 + r2) / 10 - 1e4;
        }
        function id(t2, e2, r2) {
          return 256 * t2 + e2 + r2 / 256 - 32768;
        }
        class sd {
          get tree() {
            return this._tree || this._buildQuadTree(), this._tree;
          }
          constructor(t2, e2, r2, n2 = false) {
            if (this.uid = t2, e2.height !== e2.width)
              throw new RangeError("DEM tiles must be square");
            if (r2 && "mapbox" !== r2 && "terrarium" !== r2)
              return dr(`"${r2}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
            this.stride = e2.height;
            const i2 = this.dim = e2.height - 2, s2 = new Uint32Array(e2.data.buffer);
            if (this.pixels = new Uint8Array(e2.data.buffer), this.floatView = new Float32Array(e2.data.buffer), this.borderReady = n2, this._modifiedForSources = {}, !n2) {
              for (let t3 = 0; t3 < i2; t3++)
                s2[this._idx(-1, t3)] = s2[this._idx(0, t3)], s2[this._idx(i2, t3)] = s2[this._idx(i2 - 1, t3)], s2[this._idx(t3, -1)] = s2[this._idx(t3, 0)], s2[this._idx(t3, i2)] = s2[this._idx(t3, i2 - 1)];
              s2[this._idx(-1, -1)] = s2[this._idx(0, 0)], s2[this._idx(i2, -1)] = s2[this._idx(i2 - 1, 0)], s2[this._idx(-1, i2)] = s2[this._idx(0, i2 - 1)], s2[this._idx(i2, i2)] = s2[this._idx(i2 - 1, i2 - 1)];
            }
            const a2 = "terrarium" === r2 ? id : nd;
            for (let t3 = 0; t3 < s2.length; ++t3) {
              const e3 = 4 * t3;
              this.floatView[t3] = a2(this.pixels[e3], this.pixels[e3 + 1], this.pixels[e3 + 2]);
            }
            this._timestamp = Rr.now();
          }
          _buildQuadTree() {
            this._tree = new Qf(this);
          }
          get(t2, e2, r2 = false) {
            r2 && (t2 = We(t2, -1, this.dim), e2 = We(e2, -1, this.dim));
            const n2 = this._idx(t2, e2);
            return this.floatView[n2];
          }
          set(t2, e2, r2) {
            const n2 = this._idx(t2, e2), i2 = this.floatView[n2];
            return this.floatView[n2] = r2, r2 - i2;
          }
          static getUnpackVector(t2) {
            return rd[t2];
          }
          _idx(t2, e2) {
            if (t2 < -1 || t2 >= this.dim + 1 || e2 < -1 || e2 >= this.dim + 1)
              throw new RangeError("out of range source coordinates for DEM data");
            return (e2 + 1) * this.stride + (t2 + 1);
          }
          static pack(t2, e2) {
            const r2 = [0, 0, 0, 0], n2 = sd.getUnpackVector(e2);
            let i2 = Math.floor((t2 + n2[3]) / n2[2]);
            return r2[2] = i2 % 256, i2 = Math.floor(i2 / 256), r2[1] = i2 % 256, i2 = Math.floor(i2 / 256), r2[0] = i2, r2;
          }
          getPixels() {
            return new xp({ width: this.stride, height: this.stride }, this.pixels);
          }
          backfillBorder(t2, e2, r2) {
            if (this.dim !== t2.dim)
              throw new Error("dem dimension mismatch");
            let n2 = e2 * this.dim, i2 = e2 * this.dim + this.dim, s2 = r2 * this.dim, a2 = r2 * this.dim + this.dim;
            switch (e2) {
              case -1:
                n2 = i2 - 1;
                break;
              case 1:
                i2 = n2 + 1;
            }
            switch (r2) {
              case -1:
                s2 = a2 - 1;
                break;
              case 1:
                a2 = s2 + 1;
            }
            const o2 = -e2 * this.dim, l2 = -r2 * this.dim;
            for (let e3 = s2; e3 < a2; e3++)
              for (let r3 = n2; r3 < i2; r3++) {
                const n3 = 4 * this._idx(r3, e3), i3 = 4 * this._idx(r3 + o2, e3 + l2);
                this.pixels[n3 + 0] = t2.pixels[i3 + 0], this.pixels[n3 + 1] = t2.pixels[i3 + 1], this.pixels[n3 + 2] = t2.pixels[i3 + 2], this.pixels[n3 + 3] = t2.pixels[i3 + 3];
              }
          }
          onDeserialize() {
            this._tree && (this._tree.dem = this);
          }
        }
        So(sd, "DEMData"), So(Qf, "DemMinMaxQuadTree", { omit: ["dem"] });
        class ad {
          constructor(t2, e2, r2) {
            this._demTile = t2, this._dem = this._demTile.dem, this._scale = e2, this._offset = r2;
          }
          static create(t2, e2, r2) {
            const n2 = r2 || t2.findDEMTileFor(e2);
            if (!n2 || !n2.dem)
              return;
            const i2 = n2.dem, s2 = n2.tileID, a2 = 1 << e2.canonical.z - s2.canonical.z;
            return new ad(n2, i2.dim / ds / a2, [(e2.canonical.x / a2 - s2.canonical.x) * i2.dim, (e2.canonical.y / a2 - s2.canonical.y) * i2.dim]);
          }
          tileCoordToPixel(t2, e2) {
            const r2 = e2 * this._scale + this._offset[1], n2 = Math.floor(t2 * this._scale + this._offset[0]), i2 = Math.floor(r2);
            return new je(n2, i2);
          }
          getElevationAt(t2, e2, r2, n2) {
            const i2 = t2 * this._scale + this._offset[0], s2 = e2 * this._scale + this._offset[1], a2 = Math.floor(i2), o2 = Math.floor(s2), l2 = this._dem;
            return n2 = !!n2, r2 ? Yn(Yn(l2.get(a2, o2, n2), l2.get(a2, o2 + 1, n2), s2 - o2), Yn(l2.get(a2 + 1, o2, n2), l2.get(a2 + 1, o2 + 1, n2), s2 - o2), i2 - a2) : l2.get(a2, o2, n2);
          }
          getElevationAtPixel(t2, e2, r2) {
            return this._dem.get(t2, e2, !!r2);
          }
          getMeterToDEM(t2) {
            return (1 << this._demTile.tileID.canonical.z) * Dc(1, t2) * this._dem.stride;
          }
        }
        const od = { None: 0, Model: 1, Symbol: 2, FillExtrusion: 4, All: 7 }, ld = zf.types, ud = ["fill-extrusion-base", "fill-extrusion-height", "fill-extrusion-color", "fill-extrusion-pattern", "fill-extrusion-flood-light-wall-radius", "fill-extrusion-line-width", "fill-extrusion-line-alignment"], cd = ["fill-extrusion-flood-light-ground-radius"], hd = Math.pow(2, 13), pd = Math.pow(2, 15) - 1, fd = new je(0, 1), dd = 2147483648;
        function md(t2, e2, r2, n2, i2, s2, a2, o2) {
          t2.emplaceBack((e2 << 1) + a2, (r2 << 1) + s2, (Math.floor(n2 * hd) << 1) + i2, Math.round(o2));
        }
        function yd(t2, e2, r2, n2) {
          t2.emplaceBack(e2.x * ds, e2.y * ds, r2 ? 0 : 1, n2 ? 1 : 0);
        }
        function gd(t2, e2, r2, n2, i2, s2) {
          t2.emplaceBack(e2.x, e2.y, (r2.x << 1) + n2, (r2.y << 1) + i2, s2);
        }
        function xd(t2, e2, r2) {
          const n2 = 16384;
          t2.emplaceBack(e2.x, e2.y, e2.z, r2[0] * n2, r2[1] * n2, r2[2] * n2);
        }
        class bd {
          constructor() {
            this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
          }
        }
        class vd {
          constructor() {
            this.centroidXY = new je(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new je(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new je(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0;
          }
          span() {
            return new je(this.max.x - this.min.x, this.max.y - this.min.y);
          }
        }
        class _d {
          constructor() {
            this.acc = new je(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
          }
          startRing(t2, e2) {
            t2.min.x === Number.MAX_VALUE && (t2.min.x = t2.max.x = e2.x, t2.min.y = t2.max.y = e2.y);
          }
          appendEdge(t2, e2, r2) {
            this.accCount++, this.acc._add(e2);
            let n2 = !!this.borders;
            e2.x < t2.min.x ? (t2.min.x = e2.x, n2 = true) : e2.x > t2.max.x && (t2.max.x = e2.x, n2 = true), e2.y < t2.min.y ? (t2.min.y = e2.y, n2 = true) : e2.y > t2.max.y && (t2.max.y = e2.y, n2 = true), ((0 === e2.x || e2.x === ds) && e2.x === r2.x) != ((0 === e2.y || e2.y === ds) && e2.y === r2.y) && this.processBorderOverlap(e2, r2), n2 && this.checkBorderIntersection(e2, r2);
          }
          checkBorderIntersection(t2, e2) {
            e2.x < 0 != t2.x < 0 && this.addBorderIntersection(0, Yn(e2.y, t2.y, (0 - e2.x) / (t2.x - e2.x))), e2.x > ds != t2.x > ds && this.addBorderIntersection(1, Yn(e2.y, t2.y, (ds - e2.x) / (t2.x - e2.x))), e2.y < 0 != t2.y < 0 && this.addBorderIntersection(2, Yn(e2.x, t2.x, (0 - e2.y) / (t2.y - e2.y))), e2.y > ds != t2.y > ds && this.addBorderIntersection(3, Yn(e2.x, t2.x, (ds - e2.y) / (t2.y - e2.y)));
          }
          addBorderIntersection(t2, e2) {
            this.borders || (this.borders = [[Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE]]);
            const r2 = this.borders[t2];
            e2 < r2[0] && (r2[0] = e2), e2 > r2[1] && (r2[1] = e2);
          }
          processBorderOverlap(t2, e2) {
            if (t2.x === e2.x) {
              if (t2.y === e2.y)
                return;
              const r2 = 0 === t2.x ? 0 : 1;
              this.addBorderIntersection(r2, e2.y), this.addBorderIntersection(r2, t2.y);
            } else {
              const r2 = 0 === t2.y ? 2 : 3;
              this.addBorderIntersection(r2, e2.x), this.addBorderIntersection(r2, t2.x);
            }
          }
          centroid() {
            return 0 === this.accCount ? new je(0, 0) : new je(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
          }
          intersectsCount() {
            return this.borders ? this.borders.reduce((t2, e2) => t2 + +(e2[0] !== Number.MAX_VALUE), 0) : 0;
          }
        }
        function wd(t2, e2) {
          const r2 = t2.add(e2)._unit(), n2 = We(t2.x * r2.x + t2.y * r2.y, -1, 1);
          var i2, s2, a2;
          return i2 = Math.acos(n2), Math.min(4, Math.max(-4, Math.tan(i2))) / 4 * pd * ((s2 = t2).x * (a2 = e2).y - s2.y * a2.x < 0 ? -1 : 1);
        }
        const Md = [(t2) => t2.x < 0, (t2) => t2.x > ds, (t2) => t2.y < 0, (t2) => t2.y > ds];
        function Ad(t2, e2, r2, n2) {
          const i2 = [4];
          if (0 === n2)
            return i2;
          r2._mult(n2);
          const s2 = t2.sub(r2), a2 = e2.sub(r2), o2 = [t2, e2, s2, a2];
          for (let t3 = 0; t3 < 4; t3++)
            for (const e3 of o2)
              if (Md[t3](e3)) {
                i2.push(t3);
                break;
              }
          return i2;
        }
        class Sd {
          constructor(t2) {
            this.vertexArray = new Ol(), this.indexArray = new tu(), this.programConfigurations = new ec(t2.layers, { zoom: t2.zoom, lut: t2.lut }, (t3) => cd.includes(t3)), this._segments = new ku(), this.hiddenByLandmarkVertexArray = new pu(), this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [0, 0, 0, 0, 0], this.regionSegments = {}, this.regionSegments[4] = new ku();
          }
          getDefaultSegment() {
            return this.regionSegments[4];
          }
          hasData() {
            return 0 !== this.vertexArray.length;
          }
          addData(t2, e2, r2, n2 = false) {
            const i2 = t2.length;
            if (i2 > 2) {
              let s2 = Math.max(0, this._segments.get().length - 1);
              const a2 = this._segments._prepareSegment(4 * i2, this.vertexArray.length, 2 * this._segmentToGroundQuads[s2].length);
              let o2;
              s2 !== this._segments.get().length - 1 && (s2++, this._segmentToGroundQuads[s2] = [], this._segmentToRegionTriCounts[s2] = [0, 0, 0, 0, 0]);
              {
                const e3 = t2[0], r3 = t2[1];
                o2 = wd(e3.sub(t2[i2 - 1])._perp()._unit(), r3.sub(e3)._perp()._unit());
              }
              for (let l2 = 0; l2 < i2; l2++) {
                const u2 = l2 === i2 - 1 ? 0 : l2 + 1, c2 = t2[l2], h2 = t2[u2], p2 = t2[u2 === i2 - 1 ? 0 : u2 + 1], f2 = h2.sub(c2)._perp()._unit(), d2 = wd(f2, p2.sub(h2)._perp()._unit()), m2 = o2, y2 = d2;
                if (zd(c2, h2, e2) || n2 && Ed(c2, e2) && Ed(h2, e2)) {
                  o2 = d2;
                  continue;
                }
                const g2 = a2.vertexLength;
                gd(this.vertexArray, c2, h2, 1, 1, m2), gd(this.vertexArray, c2, h2, 1, 0, m2), gd(this.vertexArray, c2, h2, 0, 1, y2), gd(this.vertexArray, c2, h2, 0, 0, y2), a2.vertexLength += 4;
                const x2 = Ad(c2, h2, f2, r2);
                for (const t3 of x2)
                  this._segmentToGroundQuads[s2].push({ id: g2, region: t3 }), this._segmentToRegionTriCounts[s2][t3] += 2, a2.primitiveLength += 2;
                o2 = d2;
              }
            }
          }
          prepareBorderSegments() {
            if (!this.hasData())
              return;
            const t2 = this._segments.get(), e2 = t2.length;
            for (let t3 = 0; t3 < e2; t3++)
              this._segmentToGroundQuads[t3].sort((t4, e3) => t4.region - e3.region);
            for (let r2 = 0; r2 < e2; r2++) {
              const e3 = this._segmentToGroundQuads[r2], n2 = t2[r2], i2 = this._segmentToRegionTriCounts[r2];
              i2.reduce((t3, e4) => t3 + e4, 0);
              let s2 = 0;
              for (let t3 = 0; t3 <= 4; t3++) {
                const e4 = i2[t3];
                if (0 !== e4) {
                  let r3 = this.regionSegments[t3];
                  r3 || (r3 = this.regionSegments[t3] = new ku());
                  const i3 = { vertexOffset: n2.vertexOffset, primitiveOffset: n2.primitiveOffset + s2, vertexLength: n2.vertexLength, primitiveLength: e4 };
                  r3.get().push(i3);
                }
                s2 += e4;
              }
              for (let t3 = 0; t3 < e3.length; t3++) {
                const r3 = e3[t3].id;
                this.indexArray.emplaceBack(r3, r3 + 1, r3 + 3), this.indexArray.emplaceBack(r3, r3 + 3, r3 + 2);
              }
            }
            this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
          }
          addPaintPropertiesData(t2, e2, r2, n2, i2, s2) {
            this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, t2, e2, r2, n2, i2, s2);
          }
          upload(t2) {
            this.hasData() && (this.vertexBuffer = t2.createVertexBuffer(this.vertexArray, hf.members), this.indexBuffer = t2.createIndexBuffer(this.indexArray));
          }
          uploadPaintProperties(t2) {
            this.hasData() && this.programConfigurations.upload(t2);
          }
          update(t2, e2, r2, n2, i2, s2) {
            this.hasData() && this.programConfigurations.updatePaintArrays(t2, e2, r2, n2, i2, s2);
          }
          updateHiddenByLandmark(t2) {
            if (!this.hasData())
              return;
            const e2 = t2.groundVertexCount + t2.groundVertexArrayOffset;
            if (0 === t2.groundVertexCount)
              return;
            const r2 = t2.flags & dd ? 1 : 0;
            for (let n2 = t2.groundVertexArrayOffset; n2 < e2; ++n2)
              this.hiddenByLandmarkVertexArray.emplace(n2, r2);
            this._needsHiddenByLandmarkUpdate = true;
          }
          uploadHiddenByLandmark(t2) {
            this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = t2.createVertexBuffer(this.hiddenByLandmarkVertexArray, df.members, true) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = false);
          }
          destroy() {
            if (this.vertexBuffer) {
              this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
              for (let t2 = 0; t2 <= 4; t2++) {
                const e2 = this.regionSegments[t2];
                e2 && e2.destroy();
              }
            }
          }
        }
        class Id {
          constructor(t2) {
            this.zoom = t2.zoom, this.canonical = t2.canonical, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.fqid), this.index = t2.index, this.hasPattern = false, this.edgeRadius = 0, this.projection = t2.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = [], this.footprintIndices = new tu(), this.footprintVertices = new Ll(), this.footprintSegments = [], this.layoutVertexArray = new Fl(), this.centroidVertexArray = new Mu(), this.wallVertexArray = new Su(), this.indexArray = new tu(), this.programConfigurations = new ec(t2.layers, { zoom: t2.zoom, lut: t2.lut }, (t3) => ud.includes(t3)), this.segments = new ku(), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.groundEffect = new Sd(t2), this.maxHeight = 0, this.partLookup = {}, this.triangleSubSegments = [], this.polygonSegments = [];
          }
          updateFootprints(t2, e2) {
          }
          populate(t2, e2, r2, n2) {
            this.features = [], this.hasPattern = Qp("fill-extrusion", this.layers, e2), this.featuresOnBorder = [], this.borderFeatureIndices = [[], [], [], []], this.borderDoneWithNeighborZ = [-1, -1, -1, -1], this.tileToMeter = jc(r2), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter, this.wallMode = 0 !== this.layers[0].paint.get("fill-extrusion-line-width").constantOr(1);
            for (const { feature: i2, id: s2, index: a2, sourceLayerIndex: o2 } of t2) {
              const t3 = this.layers[0]._featureFilter.needGeometry, l2 = Wc(i2, t3);
              if (!this.layers[0]._featureFilter.filter(new Wo(this.zoom), l2, r2))
                continue;
              const u2 = { id: s2, sourceLayerIndex: o2, index: a2, geometry: t3 ? l2.geometry : Kc(i2, r2, n2), properties: i2.properties, type: i2.type, patterns: {} }, c2 = this.layoutVertexArray.length;
              if (this.hasPattern)
                this.features.push(tf("fill-extrusion", this.layers, u2, this.zoom, e2));
              else if (this.wallMode)
                for (const t4 of u2.geometry)
                  this.addFeature(u2, [t4], a2, r2, {}, e2.availableImages, n2, e2.brightness);
              else
                this.addFeature(u2, u2.geometry, a2, r2, {}, e2.availableImages, n2, e2.brightness);
              e2.featureIndex.insert(i2, u2.geometry, a2, o2, this.index, c2);
            }
            this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
          }
          addFeatures(t2, e2, r2, n2, i2, s2) {
            for (const t3 of this.features) {
              const { geometry: a2 } = t3;
              if (this.wallMode)
                for (const o2 of a2)
                  this.addFeature(t3, [o2], t3.index, e2, r2, n2, i2, s2);
              else
                this.addFeature(t3, a2, t3.index, e2, r2, n2, i2, s2);
            }
            this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles();
          }
          update(t2, e2, r2, n2, i2) {
            const s2 = 0 !== Object.keys(t2).length;
            if (s2 && !this.stateDependentLayers.length)
              return;
            const a2 = s2 ? this.stateDependentLayers : this.layers;
            this.programConfigurations.updatePaintArrays(t2, e2, a2, r2, n2, i2), this.groundEffect.update(t2, e2, a2, r2, n2, i2);
          }
          isEmpty() {
            return 0 === this.layoutVertexArray.length;
          }
          uploadPending() {
            return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
          }
          upload(t2) {
            this.uploaded || (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, yf), this.indexBuffer = t2.createIndexBuffer(this.indexArray), this.wallVertexBuffer = t2.createVertexBuffer(this.wallVertexArray, ff.members), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = t2.createVertexBuffer(this.layoutVertexExtArray, mf.members, true)), this.groundEffect.upload(t2)), this.groundEffect.uploadPaintProperties(t2), this.programConfigurations.upload(t2), this.uploaded = true;
          }
          uploadCentroid(t2) {
            this.groundEffect.uploadHiddenByLandmark(t2), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = t2.createVertexBuffer(this.centroidVertexArray, pf.members, true) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = false);
          }
          destroy() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
          }
          addFeature(t2, e2, r2, n2, i2, s2, a2, o2) {
            const l2 = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(t2, {}) / this.tileToMeter, u2 = [new je(0, 0), new je(ds, ds)], c2 = a2.projection, h2 = "globe" === c2.name, p2 = this.wallMode || "Polygon" === ld[t2.type], f2 = new _d();
            f2.centroidDataIndex = this.centroidData.length;
            const d2 = new vd(), m2 = this.layers[0].paint.get("fill-extrusion-base").evaluate(t2, {}, n2) <= 0, y2 = this.layers[0].paint.get("fill-extrusion-height").evaluate(t2, {}, n2);
            let g2;
            if (d2.height = y2, d2.vertexArrayOffset = this.layoutVertexArray.length, d2.groundVertexArrayOffset = this.groundEffect.vertexArray.length, h2 && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new Gl()), this.wallMode) {
              if (h2)
                return void dr("Non zero fill-extrusion-line-width is not yet supported on globe.");
              if (1 !== e2.length)
                return;
              g2 = function(t3) {
                const e3 = t3[0].x === t3[t3.length - 1].x && t3[0].y === t3[t3.length - 1].y, r3 = function(t4) {
                  let e4 = 0;
                  const r4 = t4.length;
                  for (let n4 = 0; n4 < r4; n4++)
                    e4 += (t4[(n4 + 1) % r4].x - t4[n4].x) * (t4[(n4 + 1) % r4].y + t4[n4].y);
                  return e4 >= 0;
                }(t3);
                r3 || (t3 = t3.reverse());
                const n3 = { isPolygon: e3, geometry: [], joinNormals: [] }, i3 = [], s3 = [], a3 = [];
                let o3 = t3.length;
                if (o3 < (e3 ? 3 : 2))
                  return n3;
                for (; o3 >= 2 && t3[o3 - 1].equals(t3[o3 - 2]); )
                  o3--;
                let l3, u3, c3, h3, p3, f3 = 0;
                for (; f3 < o3 - 1 && t3[f3].equals(t3[f3 + 1]); )
                  f3++;
                e3 && (l3 = t3[o3 - 2], p3 = t3[f3].sub(l3)._unit()._perp());
                for (let r4 = f3; r4 < o3; r4++) {
                  if (c3 = r4 === o3 - 1 ? e3 ? t3[f3 + 1] : void 0 : t3[r4 + 1], c3 && t3[r4].equals(c3))
                    continue;
                  p3 && (h3 = p3), l3 && (u3 = l3), l3 = t3[r4], p3 = c3 ? c3.sub(l3)._unit()._perp() : h3, h3 = h3 || p3;
                  const n4 = h3.add(p3);
                  0 === n4.x && 0 === n4.y || n4._unit();
                  const d3 = n4.x * p3.x + n4.y * p3.y, m3 = 0 !== d3 ? 1 / d3 : 1 / 0, y3 = h3.x * p3.y - h3.y * p3.x > 0;
                  let g3 = "miter";
                  "miter" === g3 && m3 > 2 && (g3 = "bevel");
                  const x3 = (t4, e4, r5, n5) => {
                    const o4 = new je(t4.x, t4.y), l4 = new je(t4.x, t4.y);
                    o4.x -= e4.x * n5, o4.y -= e4.y * n5, l4.x -= e4.x * Math.max(r5, 1), l4.y -= e4.y * Math.max(r5, 1), a3.push(e4), i3.push(o4), s3.push(l4);
                  };
                  if ("miter" === g3)
                    n4._mult(m3), x3(l3, n4, 1, 0);
                  else {
                    const t4 = -Math.sqrt(m3 * m3 - 1), e4 = y3 ? t4 : 0, r5 = y3 ? 0 : t4;
                    u3 && x3(l3, h3, e4, r5), c3 && x3(l3, p3, e4, r5);
                  }
                }
                return n3.geometry = [...i3, ...s3.reverse(), i3[0]], n3.joinNormals = [...a3, ...a3.reverse(), a3[a3.length - 1]], n3;
              }(e2[0]), e2 = [g2.geometry];
            }
            const x2 = (t3, e3) => t3 < (e3.length - 1) / 2 || t3 === e3.length - 1, b2 = this.wallMode ? [e2] : Wp(e2, 500);
            for (let t3 = b2.length - 1; t3 >= 0; t3--) {
              const e3 = b2[t3];
              (0 === e3.length || (v2 = e3[0]).every((t4) => t4.x <= 0) || v2.every((t4) => t4.x >= ds) || v2.every((t4) => t4.y <= 0) || v2.every((t4) => t4.y >= ds)) && b2.splice(t3, 1);
            }
            var v2;
            let _2;
            if (h2)
              _2 = Cd(b2, u2, n2);
            else {
              _2 = [];
              for (const t3 of b2)
                _2.push({ polygon: t3, bounds: u2 });
            }
            const w2 = p2 ? this.edgeRadius : 0, M2 = w2 > 0 && this.zoom < 17, A2 = (t3, e3) => {
              if (0 === t3.length)
                return false;
              const r3 = t3[t3.length - 1];
              return e3.x === r3.x && e3.y === r3.y;
            };
            for (const { polygon: t3, bounds: e3 } of _2) {
              let r3 = 0, i3 = 0;
              for (const e4 of t3)
                p2 && !e4[0].equals(e4[e4.length - 1]) && e4.push(e4[0]), i3 += p2 ? e4.length - 1 : e4.length;
              const s3 = this.segments.prepareSegment((p2 ? 5 : 4) * i3, this.layoutVertexArray, this.indexArray);
              d2.footprintSegIdx < 0 && (d2.footprintSegIdx = this.footprintSegments.length), d2.polygonSegIdx < 0 && (d2.polygonSegIdx = this.polygonSegments.length);
              const a3 = { triangleArrayOffset: this.indexArray.length, triangleCount: 0, triangleSegIdx: this.segments.segments.length - 1 }, o3 = new bd();
              if (o3.vertexOffset = this.footprintVertices.length, o3.indexOffset = 3 * this.footprintIndices.length, o3.ringIndices = [], p2) {
                const i4 = [], a4 = [];
                r3 = s3.vertexLength;
                for (let r4 = 0; r4 < t3.length; r4++) {
                  const u4 = t3[r4];
                  u4.length && 0 !== r4 && a4.push(i4.length / 2);
                  const p3 = [];
                  let f3, d3;
                  f3 = u4[1].sub(u4[0])._perp()._unit(), o3.ringIndices.push(u4.length - 1);
                  for (let t4 = 1; t4 < u4.length; t4++) {
                    const e4 = u4[t4], r5 = u4[t4 === u4.length - 1 ? 1 : t4 + 1], a5 = e4.clone();
                    if (w2) {
                      d3 = r5.sub(e4)._perp()._unit();
                      const t5 = f3.add(d3)._unit(), n3 = w2 * Math.min(4, 1 / (f3.x * t5.x + f3.y * t5.y));
                      a5.x += n3 * t5.x, a5.y += n3 * t5.y, a5.x = Math.round(a5.x), a5.y = Math.round(a5.y), f3 = d3;
                    }
                    if (!m2 || 0 !== w2 && !M2 || A2(p3, a5) || p3.push(a5), md(this.layoutVertexArray, a5.x, a5.y, 0, 0, 1, 1, 0), this.wallMode) {
                      const e5 = x2(t4, u4);
                      yd(this.wallVertexArray, g2.joinNormals[t4], e5, g2.isPolygon);
                    }
                    s3.vertexLength++, this.footprintVertices.emplaceBack(e4.x, e4.y), i4.push(e4.x, e4.y), h2 && xd(this.layoutVertexExtArray, c2.projectTilePoint(a5.x, a5.y, n2), c2.upVector(n2, a5.x, a5.y));
                  }
                  m2 && (0 === w2 || M2) && (0 !== p3.length && A2(p3, p3[0]) && p3.pop(), this.groundEffect.addData(p3, e3, l2));
                }
                const u3 = Ip(i4, a4);
                for (let t4 = 0; t4 < u3.length; t4 += 3)
                  this.footprintIndices.emplaceBack(o3.vertexOffset + u3[t4 + 0], o3.vertexOffset + u3[t4 + 1], o3.vertexOffset + u3[t4 + 2]), this.indexArray.emplaceBack(r3 + u3[t4], r3 + u3[t4 + 2], r3 + u3[t4 + 1]), s3.primitiveLength++;
                o3.indexCount += u3.length, o3.vertexCount += this.footprintVertices.length - o3.vertexOffset;
              }
              for (let i4 = 0; i4 < t3.length; i4++) {
                const a4 = t3[i4];
                f2.startRing(d2, a4[0]);
                let o4 = a4.length > 4 && Bd(a4[a4.length - 2], a4[0], a4[1]), u3 = w2 ? kd(a4[a4.length - 2], a4[0], a4[1], w2) : 0;
                const y3 = [];
                let b3, v3, _3;
                v3 = a4[1].sub(a4[0])._perp()._unit();
                let M3 = true;
                for (let t4 = 1, i5 = 0; t4 < a4.length; t4++) {
                  let l3 = a4[t4 - 1], p3 = a4[t4];
                  const S2 = a4[t4 === a4.length - 1 ? 1 : t4 + 1];
                  if (f2.appendEdge(d2, p3, l3), zd(p3, l3, e3)) {
                    w2 && (v3 = S2.sub(p3)._perp()._unit(), M3 = !M3);
                    continue;
                  }
                  const I2 = p3.sub(l3)._perp(), T2 = I2.x / (Math.abs(I2.x) + Math.abs(I2.y)), k2 = I2.y > 0 ? 1 : 0, P2 = l3.dist(p3);
                  if (i5 + P2 > 32768 && (i5 = 0), w2) {
                    _3 = S2.sub(p3)._perp()._unit();
                    let t5 = Pd(l3, p3, S2, Td(v3, _3), w2);
                    isNaN(t5) && (t5 = 0);
                    const e4 = p3.sub(l3)._unit();
                    l3 = l3.add(e4.mult(u3))._round(), p3 = p3.add(e4.mult(-t5))._round(), u3 = t5, v3 = _3, m2 && this.zoom >= 17 && (A2(y3, l3) || y3.push(l3), A2(y3, p3) || y3.push(p3));
                  }
                  const z2 = s3.vertexLength, E2 = a4.length > 4 && Bd(l3, p3, S2);
                  let B2 = Dd(i5, o4, M3);
                  if (md(this.layoutVertexArray, l3.x, l3.y, T2, k2, 0, 0, B2), md(this.layoutVertexArray, l3.x, l3.y, T2, k2, 0, 1, B2), this.wallMode) {
                    const e4 = x2(t4 - 1, a4), r4 = g2.joinNormals[t4 - 1];
                    yd(this.wallVertexArray, r4, !e4, g2.isPolygon), yd(this.wallVertexArray, r4, !e4, g2.isPolygon);
                  }
                  if (i5 += P2, B2 = Dd(i5, E2, !M3), o4 = E2, md(this.layoutVertexArray, p3.x, p3.y, T2, k2, 0, 0, B2), md(this.layoutVertexArray, p3.x, p3.y, T2, k2, 0, 1, B2), this.wallMode) {
                    const e4 = x2(t4, a4), r4 = g2.joinNormals[t4];
                    yd(this.wallVertexArray, r4, !e4, g2.isPolygon), yd(this.wallVertexArray, r4, !e4, g2.isPolygon);
                  }
                  if (s3.vertexLength += 4, this.indexArray.emplaceBack(z2 + 0, z2 + 1, z2 + 2), this.indexArray.emplaceBack(z2 + 1, z2 + 3, z2 + 2), s3.primitiveLength += 2, w2) {
                    const n3 = r3 + (1 === t4 ? a4.length - 2 : t4 - 2), i6 = 1 === t4 ? r3 : n3 + 1;
                    if (this.indexArray.emplaceBack(z2 + 1, n3, z2 + 3), this.indexArray.emplaceBack(n3, i6, z2 + 3), s3.primitiveLength += 2, void 0 === b3 && (b3 = z2), !zd(S2, a4[t4], e3)) {
                      const e4 = t4 === a4.length - 1 ? b3 : s3.vertexLength;
                      this.indexArray.emplaceBack(z2 + 2, z2 + 3, e4), this.indexArray.emplaceBack(z2 + 3, e4 + 1, e4), this.indexArray.emplaceBack(z2 + 3, i6, e4 + 1), s3.primitiveLength += 3;
                    }
                    M3 = !M3;
                  }
                  if (h2) {
                    const t5 = this.layoutVertexExtArray, e4 = c2.projectTilePoint(l3.x, l3.y, n2), r4 = c2.projectTilePoint(p3.x, p3.y, n2), i6 = c2.upVector(n2, l3.x, l3.y), s4 = c2.upVector(n2, p3.x, p3.y);
                    xd(t5, e4, i6), xd(t5, e4, i6), xd(t5, r4, s4), xd(t5, r4, s4);
                  }
                }
                p2 && (r3 += a4.length - 1), m2 && w2 && this.zoom >= 17 && (0 !== y3.length && A2(y3, y3[0]) && y3.pop(), this.groundEffect.addData(y3, e3, l2, w2 > 0));
              }
              this.footprintSegments.push(o3), a3.triangleCount = this.indexArray.length - a3.triangleArrayOffset, this.polygonSegments.push(a3), ++d2.footprintSegLen, ++d2.polygonSegLen;
            }
            if (d2.vertexCount = this.layoutVertexArray.length - d2.vertexArrayOffset, d2.groundVertexCount = this.groundEffect.vertexArray.length - d2.groundVertexArrayOffset, 0 !== d2.vertexCount) {
              if (d2.centroidXY = f2.borders ? fd : this.encodeCentroid(f2, d2), this.centroidData.push(d2), f2.borders) {
                this.featuresOnBorder.push(f2);
                const t3 = this.featuresOnBorder.length - 1;
                for (let e3 = 0; e3 < f2.borders.length; e3++)
                  f2.borders[e3][0] !== Number.MAX_VALUE && this.borderFeatureIndices[e3].push(t3);
              }
              this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, i2, s2, n2, o2), this.groundEffect.addPaintPropertiesData(t2, r2, i2, s2, n2, o2), this.maxHeight = Math.max(this.maxHeight, y2);
            }
          }
          sortBorders() {
            for (let t2 = 0; t2 < this.borderFeatureIndices.length; t2++)
              this.borderFeatureIndices[t2].sort((e2, r2) => this.featuresOnBorder[e2].borders[t2][0] - this.featuresOnBorder[r2].borders[t2][0]);
          }
          splitToSubtiles() {
            const t2 = [];
            for (let e3 = 0; e3 < this.centroidData.length; e3++) {
              const r3 = this.centroidData[e3], n3 = +(r3.min.y + r3.max.y > ds), i3 = 2 * n3 + (+(r3.min.x + r3.max.x > ds) ^ n3);
              for (let n4 = 0; n4 < r3.polygonSegLen; n4++) {
                const s3 = r3.polygonSegIdx + n4;
                t2.push({ centroidIdx: e3, subtile: i3, polygonSegmentIdx: s3, triangleSegmentIdx: this.polygonSegments[s3].triangleSegIdx });
              }
            }
            const e2 = new tu();
            t2.sort((t3, e3) => t3.triangleSegmentIdx === e3.triangleSegmentIdx ? t3.subtile - e3.subtile : t3.triangleSegmentIdx - e3.triangleSegmentIdx);
            let r2 = 0, n2 = 0, i2 = 0;
            for (const e3 of t2) {
              if (e3.triangleSegmentIdx !== r2)
                break;
              i2++;
            }
            const s2 = t2.length;
            for (; n2 !== t2.length; ) {
              r2 = t2[n2].triangleSegmentIdx;
              let a2 = 0, o2 = n2, l2 = n2;
              for (let e3 = o2; e3 < i2 && t2[e3].subtile === a2; e3++)
                l2++;
              for (; o2 !== i2; ) {
                const n3 = t2[o2];
                a2 = n3.subtile;
                const s3 = this.centroidData[n3.centroidIdx].min.clone(), u2 = this.centroidData[n3.centroidIdx].max.clone(), c2 = { vertexOffset: this.segments.segments[r2].vertexOffset, primitiveOffset: e2.length, vertexLength: this.segments.segments[r2].vertexLength, primitiveLength: 0, sortKey: void 0, vaos: {} };
                for (let r3 = o2; r3 < l2; r3++) {
                  const n4 = t2[r3], i3 = this.polygonSegments[n4.polygonSegmentIdx], a3 = this.centroidData[n4.centroidIdx].min, o3 = this.centroidData[n4.centroidIdx].max, l3 = this.indexArray.uint16;
                  for (let t3 = i3.triangleArrayOffset; t3 < i3.triangleArrayOffset + i3.triangleCount; t3++)
                    e2.emplaceBack(l3[3 * t3], l3[3 * t3 + 1], l3[3 * t3 + 2]);
                  c2.primitiveLength += i3.triangleCount, s3.x = Math.min(s3.x, a3.x), s3.y = Math.min(s3.y, a3.y), u2.x = Math.max(u2.x, o3.x), u2.y = Math.max(u2.y, o3.y);
                }
                c2.primitiveLength > 0 && this.triangleSubSegments.push({ segment: c2, min: s3, max: u2 }), o2 = l2;
                for (let e3 = o2; e3 < i2 && t2[e3].subtile === t2[o2].subtile; e3++)
                  l2++;
              }
              n2 = i2;
              for (let e3 = n2; e3 < s2 && t2[e3].triangleSegmentIdx === t2[n2].triangleSegmentIdx; e3++)
                i2++;
            }
            e2._trim(), this.indexArray = e2;
          }
          getVisibleSegments(t2, e2, r2) {
            const n2 = new ku();
            if (this.wallMode) {
              for (const t3 of this.triangleSubSegments)
                n2.segments.push(t3.segment);
              return n2;
            }
            let i2 = 0, s2 = 0;
            const a2 = 1 << t2.canonical.z;
            if (e2) {
              const r3 = e2.getMinMaxForTile(t2);
              r3 && (i2 = r3.min, s2 = r3.max);
            }
            s2 += this.maxHeight;
            const o2 = t2.toUnwrapped();
            let l2;
            const u2 = [o2.canonical.x / a2 + o2.wrap, o2.canonical.y / a2], c2 = [(o2.canonical.x + 1) / a2 + o2.wrap, (o2.canonical.y + 1) / a2], h2 = (t3, e3, r3) => [t3[0] * (1 - r3[0]) + e3[0] * r3[0], t3[1] * (1 - r3[1]) + e3[1] * r3[1]], p2 = [], f2 = [];
            for (const t3 of this.triangleSubSegments) {
              p2[0] = t3.min.x / ds, p2[1] = t3.min.y / ds, f2[0] = t3.max.x / ds, f2[1] = t3.max.y / ds;
              const e3 = h2(u2, c2, p2), a3 = h2(u2, c2, f2);
              if (0 === new kh([e3[0], e3[1], i2], [a3[0], a3[1], s2]).intersectsPrecise(r2)) {
                l2 && (n2.segments.push(l2), l2 = void 0);
                continue;
              }
              const o3 = t3.segment;
              l2 && l2.vertexOffset !== o3.vertexOffset && (n2.segments.push(l2), l2 = void 0), l2 ? (l2.vertexLength += o3.vertexLength, l2.primitiveLength += o3.primitiveLength) : l2 = { vertexOffset: o3.vertexOffset, primitiveLength: o3.primitiveLength, vertexLength: o3.vertexLength, primitiveOffset: o3.primitiveOffset, sortKey: void 0, vaos: {} };
            }
            return l2 && n2.segments.push(l2), n2;
          }
          encodeCentroid(t2, e2) {
            const r2 = t2.centroid(), n2 = e2.span(), i2 = Math.min(7, Math.round(n2.x * this.tileToMeter / 10)), s2 = Math.min(7, Math.round(n2.y * this.tileToMeter / 10));
            return new je(We(r2.x, 1, ds - 1) << 3 | i2, We(r2.y, 1, ds - 1) << 3 | s2);
          }
          encodeBorderCentroid(t2) {
            if (!t2.borders)
              return new je(0, 0);
            const e2 = t2.borders, r2 = Number.MAX_VALUE;
            if (e2[0][0] !== r2 || e2[1][0] !== r2) {
              const t3 = e2[0][0] !== r2 ? 0 : 1;
              return new je(6 | (e2[0][0] !== r2 ? 0 : 65528), (e2[t3][0] + e2[t3][1]) / 2 << 3 | 6);
            }
            {
              const t3 = e2[2][0] !== r2 ? 2 : 3;
              return new je((e2[t3][0] + e2[t3][1]) / 2 << 3 | 6, 6 | (e2[2][0] !== r2 ? 0 : 65528));
            }
          }
          showCentroid(t2) {
            const e2 = this.centroidData[t2.centroidDataIndex];
            e2.flags &= dd, e2.centroidXY.x = 0, e2.centroidXY.y = 0, this.writeCentroidToBuffer(e2);
          }
          writeCentroidToBuffer(t2) {
            this.groundEffect.updateHiddenByLandmark(t2);
            const e2 = t2.vertexArrayOffset, r2 = t2.vertexCount + t2.vertexArrayOffset, n2 = t2.flags & dd ? fd : t2.centroidXY, i2 = this.centroidVertexArray.geta_centroid_pos0(e2);
            if (this.centroidVertexArray.geta_centroid_pos1(e2) !== n2.y || i2 !== n2.x) {
              for (let t3 = e2; t3 < r2; ++t3)
                this.centroidVertexArray.emplace(t3, n2.x, n2.y);
              this.needsCentroidUpdate = true;
            }
          }
          createCentroidsBuffer() {
            this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
            for (const t2 of this.centroidData)
              this.writeCentroidToBuffer(t2);
          }
          updateReplacement(t2, e2, r2) {
            if (e2.updateTime === this.replacementUpdateTime)
              return;
            this.replacementUpdateTime = e2.updateTime;
            const n2 = e2.getReplacementRegionsForTile(t2.toUnwrapped());
            if (jf(this.activeReplacements, n2))
              return;
            if (this.activeReplacements = n2, 0 === this.centroidVertexArray.length)
              this.createCentroidsBuffer();
            else
              for (const t3 of this.centroidData)
                t3.flags &= 2147483647;
            const i2 = [];
            for (const e3 of this.activeReplacements) {
              if (e3.order < r2)
                continue;
              const n3 = Math.pow(2, e3.footprintTileId.canonical.z - t2.canonical.z);
              for (const r3 of this.centroidData)
                if (!(r3.flags & dd || e3.min.x > r3.max.x || r3.min.x > e3.max.x || e3.min.y > r3.max.y || r3.min.y > e3.max.y))
                  for (let s2 = 0; s2 < r3.footprintSegLen; s2++) {
                    const a2 = this.footprintSegments[r3.footprintSegIdx + s2];
                    if (i2.length = 0, Ld(this.footprintVertices, a2.vertexOffset, a2.vertexCount, e3.footprintTileId.canonical, t2.canonical, i2), qf(e3.footprint, i2, this.footprintIndices.uint16, a2.indexOffset, a2.indexCount, -a2.vertexOffset, -n3)) {
                      r3.flags |= dd;
                      break;
                    }
                  }
            }
            for (const t3 of this.centroidData)
              this.writeCentroidToBuffer(t3);
            this.borderDoneWithNeighborZ = [-1, -1, -1, -1];
          }
          footprintContainsPoint(t2, e2, r2) {
            let n2 = false;
            for (let i2 = 0; i2 < r2.footprintSegLen; i2++) {
              const s2 = this.footprintSegments[r2.footprintSegIdx + i2];
              let a2 = 0;
              for (const r3 of s2.ringIndices) {
                for (let i3 = a2, o2 = r3 + a2 - 1; i3 < r3 + a2; o2 = i3++) {
                  const r4 = this.footprintVertices.int16[2 * (i3 + s2.vertexOffset) + 0], a3 = this.footprintVertices.int16[2 * (i3 + s2.vertexOffset) + 1], l2 = this.footprintVertices.int16[2 * (o2 + s2.vertexOffset) + 1];
                  a3 > e2 != l2 > e2 && t2 < (this.footprintVertices.int16[2 * (o2 + s2.vertexOffset) + 0] - r4) * (e2 - a3) / (l2 - a3) + r4 && (n2 = !n2);
                }
                a2 = r3;
              }
            }
            return n2;
          }
          getHeightAtTileCoord(t2, e2) {
            let r2 = Number.NEGATIVE_INFINITY, n2 = true;
            const i2 = 4 * (t2 + ds) * ds + (e2 + ds);
            if (this.partLookup.hasOwnProperty(i2)) {
              const t3 = this.partLookup[i2];
              return t3 ? { height: t3.height, hidden: !!(t3.flags & dd) } : void 0;
            }
            for (const s2 of this.centroidData)
              t2 > s2.max.x || s2.min.x > t2 || e2 > s2.max.y || s2.min.y > e2 || this.footprintContainsPoint(t2, e2, s2) && s2 && s2.height > r2 && (r2 = s2.height, this.partLookup[i2] = s2, n2 = !!(s2.flags & dd));
            if (r2 !== Number.NEGATIVE_INFINITY)
              return { height: r2, hidden: n2 };
            this.partLookup[i2] = void 0;
          }
        }
        function Td(t2, e2) {
          const r2 = t2.add(e2)._unit();
          return t2.x * r2.x + t2.y * r2.y;
        }
        function kd(t2, e2, r2, n2) {
          const i2 = e2.sub(t2)._perp()._unit(), s2 = r2.sub(e2)._perp()._unit();
          return Pd(t2, e2, r2, Td(i2, s2), n2);
        }
        function Pd(t2, e2, r2, n2, i2) {
          const s2 = Math.sqrt(1 - n2 * n2);
          return Math.min(t2.dist(e2) / 3, e2.dist(r2) / 3, i2 * s2 / n2);
        }
        function zd(t2, e2, r2) {
          return t2.x < r2[0].x && e2.x < r2[0].x || t2.x > r2[1].x && e2.x > r2[1].x || t2.y < r2[0].y && e2.y < r2[0].y || t2.y > r2[1].y && e2.y > r2[1].y;
        }
        function Ed(t2, e2) {
          return t2.x < e2[0].x || t2.x > e2[1].x || t2.y < e2[0].y || t2.y > e2[1].y;
        }
        function Bd(t2, e2, r2) {
          if (t2.x < 0 || t2.x >= ds || e2.x < 0 || e2.x >= ds || r2.x < 0 || r2.x >= ds)
            return false;
          const n2 = r2.sub(e2), i2 = n2.perp(), s2 = t2.sub(e2);
          return (n2.x * s2.x + n2.y * s2.y) / Math.sqrt((n2.x * n2.x + n2.y * n2.y) * (s2.x * s2.x + s2.y * s2.y)) > -0.866 && i2.x * s2.x + i2.y * s2.y < 0;
        }
        function Dd(t2, e2, r2) {
          const n2 = e2 ? 2 | t2 : -3 & t2;
          return r2 ? 1 | n2 : -2 & n2;
        }
        function Rd() {
          const t2 = Math.PI / 32, e2 = Math.tan(t2), r2 = gc;
          return r2 * Math.sqrt(1 + 2 * e2 * e2) - r2;
        }
        function Cd(t2, e2, r2) {
          const n2 = 1 << r2.z, i2 = Rc(r2.x / n2), s2 = Rc((r2.x + 1) / n2), a2 = Cc(r2.y / n2), o2 = Cc((r2.y + 1) / n2);
          return function(t3, e3, r3, n3, i3 = 0, s3) {
            const a3 = [];
            if (!t3.length || !r3 || !n3)
              return a3;
            const o3 = (t4, e4) => {
              for (const r4 of t4)
                a3.push({ polygon: r4, bounds: e4 });
            }, l2 = Math.ceil(Math.log2(r3)), u2 = Math.ceil(Math.log2(n3)), c2 = l2 - u2, h2 = [];
            for (let t4 = 0; t4 < Math.abs(c2); t4++)
              h2.push(c2 > 0 ? 0 : 1);
            for (let t4 = 0; t4 < Math.min(l2, u2); t4++)
              h2.push(0), h2.push(1);
            let p2 = t3;
            if (p2 = Df(p2, e3[0].y - i3, e3[1].y + i3, 1), p2 = Df(p2, e3[0].x - i3, e3[1].x + i3, 0), !p2.length)
              return a3;
            const f2 = [];
            for (h2.length ? f2.push({ polygons: p2, bounds: e3, depth: 0 }) : o3(p2, e3); f2.length; ) {
              const t4 = f2.pop(), e4 = t4.depth, r4 = h2[e4], n4 = t4.bounds[0], a4 = t4.bounds[1], l3 = 0 === r4 ? n4.x : n4.y, u3 = 0 === r4 ? a4.x : a4.y, c3 = s3 ? s3(r4, l3, u3) : 0.5 * (l3 + u3), p3 = Df(t4.polygons, l3 - i3, c3 + i3, r4), d2 = Df(t4.polygons, c3 - i3, u3 + i3, r4);
              if (p3.length) {
                const t5 = [n4, new je(0 === r4 ? c3 : a4.x, 1 === r4 ? c3 : a4.y)];
                h2.length > e4 + 1 ? f2.push({ polygons: p3, bounds: t5, depth: e4 + 1 }) : o3(p3, t5);
              }
              if (d2.length) {
                const t5 = [new je(0 === r4 ? c3 : n4.x, 1 === r4 ? c3 : n4.y), a4];
                h2.length > e4 + 1 ? f2.push({ polygons: d2, bounds: t5, depth: e4 + 1 }) : o3(d2, t5);
              }
            }
            return a3;
          }(t2, e2, Math.ceil((s2 - i2) / 11.25), Math.ceil((a2 - o2) / 11.25), 1, (t3, e3, i3) => {
            if (0 === t3)
              return 0.5 * (e3 + i3);
            {
              const t4 = Cc((r2.y + e3 / ds) / n2);
              return (Bc(0.5 * (Cc((r2.y + i3 / ds) / n2) + t4)) * n2 - r2.y) * ds;
            }
          });
        }
        function Ld(t2, e2, r2, n2, i2, s2) {
          const a2 = Math.pow(2, n2.z - i2.z);
          for (let o2 = 0; o2 < r2; o2++) {
            let r3 = t2.int16[2 * (o2 + e2) + 0], l2 = t2.int16[2 * (o2 + e2) + 1];
            r3 = (r3 + i2.x * ds) * a2 - n2.x * ds, l2 = (l2 + i2.y * ds) * a2 - n2.y * ds, s2.push(new je(r3, l2));
          }
        }
        let Vd, Fd;
        function Od(t2, e2) {
          return t2.x * e2.x + t2.y * e2.y;
        }
        function Ud(t2, e2) {
          if (1 === t2.length) {
            let r2 = 0;
            const n2 = e2[r2++];
            let i2;
            for (; !i2 || n2.equals(i2); )
              if (i2 = e2[r2++], !i2)
                return 1 / 0;
            for (; r2 < e2.length; r2++) {
              const s2 = e2[r2], a2 = t2[0], o2 = i2.sub(n2), l2 = s2.sub(n2), u2 = a2.sub(n2), c2 = Od(o2, o2), h2 = Od(o2, l2), p2 = Od(l2, l2), f2 = Od(u2, o2), d2 = Od(u2, l2), m2 = c2 * p2 - h2 * h2, y2 = (p2 * f2 - h2 * d2) / m2, g2 = (c2 * d2 - h2 * f2) / m2, x2 = n2.z * (1 - y2 - g2) + i2.z * y2 + s2.z * g2;
              if (isFinite(x2))
                return x2;
            }
            return 1 / 0;
          }
          {
            let t3 = 1 / 0;
            for (const r2 of e2)
              t3 = Math.min(t3, r2.z);
            return t3;
          }
        }
        function jd(t2, e2, r2, n2, i2, s2, a2, o2) {
          const l2 = a2 * i2.getElevationAt(t2, e2, true, true), u2 = 0 !== s2[0], c2 = u2 ? 0 === s2[1] ? a2 * (s2[0] / 7 - 450) : a2 * function(t3, e3, r3) {
            const n3 = Math.floor(e3[0] / 8), i3 = Math.floor(e3[1] / 8), s3 = 10 * (e3[0] - 8 * n3), a3 = 10 * (e3[1] - 8 * i3), o3 = t3.getElevationAt(n3, i3, true, true), l3 = t3.getMeterToDEM(r3), u3 = Math.floor(0.5 * (s3 * l3 - 1)), c3 = Math.floor(0.5 * (a3 * l3 - 1)), h2 = t3.tileCoordToPixel(n3, i3), p2 = 2 * u3 + 1, f2 = 2 * c3 + 1, d2 = function(t4, e4, r4, n4, i4) {
              return [t4.getElevationAtPixel(e4, r4, true), t4.getElevationAtPixel(e4 + i4, r4, true), t4.getElevationAtPixel(e4, r4 + i4, true), t4.getElevationAtPixel(e4 + n4, r4 + i4, true)];
            }(t3, h2.x - u3, h2.y - c3, p2, f2), m2 = Math.abs(d2[0] - d2[1]), y2 = Math.abs(d2[2] - d2[3]), g2 = Math.abs(d2[0] - d2[2]) + Math.abs(d2[1] - d2[3]), x2 = Math.min(0.25, 0.5 * l3 * (m2 + y2) / p2), b2 = Math.min(0.25, 0.5 * l3 * g2 / f2);
            return o3 + Math.max(x2 * s3, b2 * a3);
          }(i2, s2, o2) : l2;
          return { base: l2 + (0 === r2) ? -1 : r2, top: u2 ? Math.max(c2 + n2, l2 + r2 + 2) : l2 + n2 };
        }
        So(Id, "FillExtrusionBucket", { omit: ["layers", "features"] }), So(vd, "PartData"), So(bd, "FootprintSegment"), So(_d, "BorderCentroidData"), So(Sd, "GroundEffect");
        const Nd = Rl([{ name: "a_pos_normal", components: 2, type: "Int16" }, { name: "a_data", components: 4, type: "Uint8" }, { name: "a_linesofar", components: 1, type: "Float32" }], 4), { members: $d } = Nd, qd = Rl([{ name: "a_packed", components: 4, type: "Float32" }]), { members: Gd } = qd, Xd = Rl([{ name: "a_pattern_data", components: 3, type: "Float32" }]), { members: Yd } = Xd, Zd = Rl([{ name: "a_pos_offset", components: 4, type: "Int16" }, { name: "a_tex_size", components: 4, type: "Uint16" }, { name: "a_pixeloffset", components: 4, type: "Int16" }], 4), Hd = Rl([{ name: "a_globe_anchor", components: 3, type: "Int16" }, { name: "a_globe_normal", components: 3, type: "Float32" }], 4), Kd = Rl([{ name: "a_projected_pos", components: 4, type: "Float32" }], 4);
        Rl([{ name: "a_fade_opacity", components: 1, type: "Uint32" }], 4);
        const Wd = Rl([{ name: "a_z_offset", components: 1, type: "Float32" }], 4), Jd = Rl([{ name: "a_texb", components: 2, type: "Uint16" }]), Qd = Rl([{ name: "a_placed", components: 2, type: "Uint8" }, { name: "a_shift", components: 2, type: "Float32" }]), tm = Rl([{ name: "a_size_scale", components: 1, type: "Float32" }, { name: "a_padding", components: 2, type: "Float32" }, { name: "a_z_offset", components: 1, type: "Float32" }]);
        Rl([{ type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Int16", name: "tileAnchorX" }, { type: "Int16", name: "tileAnchorY" }, { type: "Float32", name: "x1" }, { type: "Float32", name: "y1" }, { type: "Float32", name: "x2" }, { type: "Float32", name: "y2" }, { type: "Int16", name: "padding" }, { type: "Uint32", name: "featureIndex" }, { type: "Uint16", name: "sourceLayerIndex" }, { type: "Uint16", name: "bucketIndex" }]);
        const em = Rl([{ name: "a_pos", components: 3, type: "Int16" }, { name: "a_anchor_pos", components: 2, type: "Int16" }, { name: "a_extrude", components: 2, type: "Int16" }], 4), rm = Rl([{ name: "a_pos_2f", components: 2, type: "Float32" }, { name: "a_radius", components: 1, type: "Float32" }, { name: "a_flags", components: 2, type: "Int16" }], 4);
        Rl([{ name: "triangle", components: 3, type: "Uint16" }]), Rl([{ type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Float32", name: "tileAnchorX" }, { type: "Float32", name: "tileAnchorY" }, { type: "Uint16", name: "glyphStartIndex" }, { type: "Uint16", name: "numGlyphs" }, { type: "Uint32", name: "vertexStartIndex" }, { type: "Uint32", name: "lineStartIndex" }, { type: "Uint32", name: "lineLength" }, { type: "Uint16", name: "segment" }, { type: "Uint16", name: "lowerSize" }, { type: "Uint16", name: "upperSize" }, { type: "Float32", name: "lineOffsetX" }, { type: "Float32", name: "lineOffsetY" }, { type: "Uint8", name: "writingMode" }, { type: "Uint8", name: "placedOrientation" }, { type: "Uint8", name: "hidden" }, { type: "Uint32", name: "crossTileID" }, { type: "Int16", name: "associatedIconIndex" }, { type: "Uint8", name: "flipState" }]), Rl([{ type: "Float32", name: "tileAnchorX" }, { type: "Float32", name: "tileAnchorY" }, { type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Int16", name: "rightJustifiedTextSymbolIndex" }, { type: "Int16", name: "centerJustifiedTextSymbolIndex" }, { type: "Int16", name: "leftJustifiedTextSymbolIndex" }, { type: "Int16", name: "verticalPlacedTextSymbolIndex" }, { type: "Int16", name: "placedIconSymbolIndex" }, { type: "Int16", name: "verticalPlacedIconSymbolIndex" }, { type: "Uint16", name: "key" }, { type: "Uint16", name: "textBoxStartIndex" }, { type: "Uint16", name: "textBoxEndIndex" }, { type: "Uint16", name: "verticalTextBoxStartIndex" }, { type: "Uint16", name: "verticalTextBoxEndIndex" }, { type: "Uint16", name: "iconBoxStartIndex" }, { type: "Uint16", name: "iconBoxEndIndex" }, { type: "Uint16", name: "verticalIconBoxStartIndex" }, { type: "Uint16", name: "verticalIconBoxEndIndex" }, { type: "Uint16", name: "featureIndex" }, { type: "Uint16", name: "numHorizontalGlyphVertices" }, { type: "Uint16", name: "numVerticalGlyphVertices" }, { type: "Uint16", name: "numIconVertices" }, { type: "Uint16", name: "numVerticalIconVertices" }, { type: "Uint16", name: "useRuntimeCollisionCircles" }, { type: "Uint32", name: "crossTileID" }, { type: "Float32", components: 2, name: "textOffset" }, { type: "Float32", name: "collisionCircleDiameter" }, { type: "Float32", name: "zOffset" }, { type: "Uint8", name: "hasIconTextFit" }]), Rl([{ type: "Float32", name: "offsetX" }]), Rl([{ type: "Int16", name: "x" }, { type: "Int16", name: "y" }]);
        class nm {
          constructor(t2, e2) {
            this.width = t2, this.height = e2, this.nextRow = 0, this.image = new yp({ width: t2, height: e2 }), this.positions = {}, this.uploaded = false;
          }
          getDash(t2, e2) {
            const r2 = this.getKey(t2, e2);
            return this.positions[r2];
          }
          trim() {
            const t2 = this.width, e2 = this.height = ar(this.nextRow);
            this.image.resize({ width: t2, height: e2 });
          }
          getKey(t2, e2) {
            return t2.join(",") + e2;
          }
          getDashRanges(t2, e2, r2) {
            const n2 = [];
            let i2 = t2.length % 2 == 1 ? -t2[t2.length - 1] * r2 : 0, s2 = t2[0] * r2, a2 = true;
            n2.push({ left: i2, right: s2, isDash: a2, zeroLength: 0 === t2[0] });
            let o2 = t2[0];
            for (let e3 = 1; e3 < t2.length; e3++) {
              a2 = !a2;
              const l2 = t2[e3];
              i2 = o2 * r2, o2 += l2, s2 = o2 * r2, n2.push({ left: i2, right: s2, isDash: a2, zeroLength: 0 === l2 });
            }
            return n2;
          }
          addRoundDash(t2, e2, r2) {
            const n2 = e2 / 2;
            for (let e3 = -r2; e3 <= r2; e3++) {
              const i2 = this.width * (this.nextRow + r2 + e3);
              let s2 = 0, a2 = t2[s2];
              for (let o2 = 0; o2 < this.width; o2++) {
                o2 / a2.right > 1 && (a2 = t2[++s2]);
                const l2 = Math.abs(o2 - a2.left), u2 = Math.abs(o2 - a2.right), c2 = Math.min(l2, u2);
                let h2;
                const p2 = e3 / r2 * (n2 + 1);
                if (a2.isDash) {
                  const t3 = n2 - Math.abs(p2);
                  h2 = Math.sqrt(c2 * c2 + t3 * t3);
                } else
                  h2 = n2 - Math.sqrt(c2 * c2 + p2 * p2);
                this.image.data[i2 + o2] = Math.max(0, Math.min(255, h2 + 128));
              }
            }
          }
          addRegularDash(t2, e2) {
            for (let e3 = t2.length - 1; e3 >= 0; --e3) {
              const r3 = t2[e3], n3 = t2[e3 + 1];
              r3.zeroLength ? t2.splice(e3, 1) : n3 && n3.isDash === r3.isDash && (n3.left = r3.left, t2.splice(e3, 1));
            }
            const r2 = t2[0], n2 = t2[t2.length - 1];
            r2.isDash === n2.isDash && (r2.left = n2.left - this.width, n2.right = r2.right + this.width);
            const i2 = this.width * this.nextRow;
            let s2 = 0, a2 = t2[s2];
            for (let r3 = 0; r3 < this.width; r3++) {
              r3 / a2.right > 1 && (a2 = t2[++s2]);
              const n3 = Math.abs(r3 - a2.left), o2 = Math.abs(r3 - a2.right), l2 = Math.min(n3, o2);
              this.image.data[i2 + r3] = Math.max(0, Math.min(255, (a2.isDash ? l2 : -l2) + e2 + 128));
            }
          }
          addDash(t2, e2) {
            const r2 = this.getKey(t2, e2);
            if (this.positions[r2])
              return this.positions[r2];
            const n2 = "round" === e2, i2 = n2 ? 7 : 0, s2 = 2 * i2 + 1;
            if (this.nextRow + s2 > this.height)
              return dr("LineAtlas out of space"), null;
            0 === t2.length && t2.push(1);
            let a2 = 0;
            for (let e3 = 0; e3 < t2.length; e3++)
              t2[e3] < 0 && (dr("Negative value is found in line dasharray, replacing values with 0"), t2[e3] = 0), a2 += t2[e3];
            if (0 !== a2) {
              const r3 = this.width / a2, s3 = this.getDashRanges(t2, this.width, r3);
              n2 ? this.addRoundDash(s3, r3, i2) : this.addRegularDash(s3, "square" === e2 ? 0.5 * r3 : 0);
            }
            const o2 = this.nextRow + i2;
            this.nextRow += s2;
            const l2 = { tl: [o2, i2], br: [a2, 0] };
            return this.positions[r2] = l2, l2;
          }
        }
        So(nm, "LineAtlas");
        const im = zf.types, sm = Math.cos(Math.PI / 180 * 37.5), am = Math.cos(Math.PI / 180 * 5);
        class om {
          constructor(t2) {
            this.zoom = t2.zoom, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.fqid), this.index = t2.index, this.projection = t2.projection, this.hasPattern = false, this.hasZOffset = false, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t3) => {
              this.gradients[t3.id] = {};
            }), this.layoutVertexArray = new Ul(), this.layoutVertexArray2 = new jl(), this.patternVertexArray = new Nl(), this.indexArray = new tu(), this.programConfigurations = new ec(t2.layers, { zoom: t2.zoom, lut: t2.lut }), this.segments = new ku(), this.maxLineLength = 0, this.zOffsetVertexArray = new nu(), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.tessellationStep = t2.tessellationStep ? t2.tessellationStep : ds / 64;
          }
          updateFootprints(t2, e2) {
          }
          populate(t2, e2, r2, n2) {
            this.hasPattern = Qp("line", this.layers, e2);
            const i2 = this.layers[0].layout.get("line-sort-key"), s2 = this.layers[0].layout.get("line-z-offset");
            this.hasZOffset = !s2.isConstant() || !!s2.constantOr(0);
            const a2 = [];
            for (const { feature: e3, id: s3, index: o3, sourceLayerIndex: l3 } of t2) {
              const t3 = this.layers[0]._featureFilter.needGeometry, u3 = Wc(e3, t3);
              if (!this.layers[0]._featureFilter.filter(new Wo(this.zoom), u3, r2))
                continue;
              const c2 = i2 ? i2.evaluate(u3, {}, r2) : void 0, h2 = { id: s3, properties: e3.properties, type: e3.type, sourceLayerIndex: l3, index: o3, geometry: t3 ? u3.geometry : Kc(e3, r2, n2), patterns: {}, sortKey: c2 };
              a2.push(h2);
            }
            i2 && a2.sort((t3, e3) => t3.sortKey - e3.sortKey);
            const { lineAtlas: o2, featureIndex: l2 } = e2, u2 = this.addConstantDashes(o2);
            for (const n3 of a2) {
              const { geometry: i3, index: s3, sourceLayerIndex: a3 } = n3;
              if (u2 && this.addFeatureDashes(n3, o2), this.hasPattern) {
                const t3 = tf("line", this.layers, n3, this.zoom, e2);
                this.patternFeatures.push(t3);
              } else
                this.addFeature(n3, i3, s3, r2, o2.positions, e2.availableImages, e2.brightness);
              l2.insert(t2[s3].feature, i3, s3, a3, this.index);
            }
          }
          addConstantDashes(t2) {
            let e2 = false;
            for (const r2 of this.layers) {
              const n2 = r2.paint.get("line-dasharray").value, i2 = r2.layout.get("line-cap").value;
              if ("constant" !== n2.kind || "constant" !== i2.kind)
                e2 = true;
              else {
                const e3 = i2.value, r3 = n2.value;
                if (!r3)
                  continue;
                t2.addDash(r3, e3);
              }
            }
            return e2;
          }
          addFeatureDashes(t2, e2) {
            const r2 = this.zoom;
            for (const n2 of this.layers) {
              const i2 = n2.paint.get("line-dasharray").value, s2 = n2.layout.get("line-cap").value;
              if ("constant" === i2.kind && "constant" === s2.kind)
                continue;
              let a2, o2;
              if ("constant" === i2.kind) {
                if (a2 = i2.value, !a2)
                  continue;
              } else
                a2 = i2.evaluate({ zoom: r2 }, t2);
              o2 = "constant" === s2.kind ? s2.value : s2.evaluate({ zoom: r2 }, t2), e2.addDash(a2, o2), t2.patterns[n2.id] = e2.getKey(a2, o2);
            }
          }
          update(t2, e2, r2, n2, i2) {
            const s2 = 0 !== Object.keys(t2).length;
            s2 && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(t2, e2, s2 ? this.stateDependentLayers : this.layers, r2, n2, i2);
          }
          addFeatures(t2, e2, r2, n2, i2, s2) {
            for (const t3 of this.patternFeatures)
              this.addFeature(t3, t3.geometry, t3.index, e2, r2, n2, s2);
          }
          isEmpty() {
            return 0 === this.layoutVertexArray.length;
          }
          uploadPending() {
            return !this.uploaded || this.programConfigurations.needsUpload;
          }
          upload(t2) {
            this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t2.createVertexBuffer(this.layoutVertexArray2, Gd)), 0 !== this.patternVertexArray.length && (this.patternVertexBuffer = t2.createVertexBuffer(this.patternVertexArray, Yd)), !this.zOffsetVertexBuffer && this.zOffsetVertexArray.length > 0 && (this.zOffsetVertexBuffer = t2.createVertexBuffer(this.zOffsetVertexArray, Wd.members, true)), this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, $d), this.indexBuffer = t2.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t2), this.uploaded = true;
          }
          destroy() {
            this.layoutVertexBuffer && (this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
          }
          lineFeatureClips(t2) {
            if (t2.properties && t2.properties.hasOwnProperty("mapbox_clip_start") && t2.properties.hasOwnProperty("mapbox_clip_end"))
              return { start: +t2.properties.mapbox_clip_start, end: +t2.properties.mapbox_clip_end };
          }
          addFeature(t2, e2, r2, n2, i2, s2, a2) {
            const o2 = this.layers[0].layout, l2 = o2.get("line-join").evaluate(t2, {}), u2 = o2.get("line-cap").evaluate(t2, {}), c2 = o2.get("line-miter-limit"), h2 = o2.get("line-round-limit");
            this.lineClips = this.lineFeatureClips(t2);
            for (const r3 of e2)
              this.addLine(r3, t2, n2, l2, u2, c2, h2);
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, i2, s2, n2, a2);
          }
          addLine(t2, e2, r2, n2, i2, s2, a2) {
            this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineSoFar = 0, this.currentVertex = void 0;
            const o2 = { zoom: this.zoom, lineProgress: void 0 }, l2 = this.layers[0].layout, u2 = "none" === n2;
            if (this.patternJoinNone = this.hasPattern && u2, this.segmentStart = 0, this.segmentStartf32 = 0, this.segmentPoints = [], this.lineClips) {
              this.lineClipsArray.push(this.lineClips);
              for (let e3 = 0; e3 < t2.length - 1; e3++)
                this.totalDistance += t2[e3].dist(t2[e3 + 1]);
              this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
            }
            const c2 = "Polygon" === im[e2.type];
            let h2 = t2.length;
            for (; h2 >= 2 && t2[h2 - 1].equals(t2[h2 - 2]); )
              h2--;
            let p2 = 0;
            for (; p2 < h2 - 1 && t2[p2].equals(t2[p2 + 1]); )
              p2++;
            if (h2 < (c2 ? 3 : 2))
              return;
            "bevel" === n2 && (s2 = 1.05);
            const f2 = this.overscaling <= 16 ? 15 * ds / (512 * this.overscaling) : 0, d2 = this.segments.prepareSegment(10 * h2, this.layoutVertexArray, this.indexArray);
            let m2, y2, g2, x2, b2, v2;
            this.e1 = this.e2 = -1, c2 && (m2 = t2[h2 - 2], b2 = t2[p2].sub(m2)._unit()._perp());
            for (let r3 = p2; r3 < h2; r3++) {
              if (g2 = r3 === h2 - 1 ? c2 ? t2[p2 + 1] : void 0 : t2[r3 + 1], g2 && t2[r3].equals(g2))
                continue;
              if (b2 && (x2 = b2), m2 && (y2 = m2), m2 = t2[r3], this.hasZOffset) {
                const t3 = l2.get("line-z-offset").value;
                if ("constant" === t3.kind)
                  v2 = t3.value;
                else {
                  if (this.lineClips) {
                    const t4 = this.totalDistance / (this.lineClips.end - this.lineClips.start);
                    o2.lineProgress = (t4 * this.lineClips.start + this.distance + (y2 ? y2.dist(m2) : 0)) / t4;
                  } else
                    dr(`line-z-offset evaluation for ${this.layerIds[0]} requires enabling 'lineMetrics' for the source.`), o2.lineProgress = 0;
                  v2 = t3.evaluate(o2, e2);
                }
                v2 = v2 || 0;
              }
              b2 = g2 ? g2.sub(m2)._unit()._perp() : x2, x2 = x2 || b2;
              const _2 = y2 && g2;
              let w2 = _2 ? n2 : c2 || u2 ? "butt" : i2;
              const M2 = x2.x * b2.x + x2.y * b2.y;
              if (u2) {
                const t3 = function(t4) {
                  if (t4.patternJoinNone) {
                    const e3 = t4.segmentPoints.length / 2, r4 = t4.lineSoFar - t4.segmentStart;
                    for (let n3 = 0; n3 < e3; ++n3) {
                      const e4 = t4.segmentPoints[2 * n3 + 1], i3 = Math.round(t4.segmentPoints[2 * n3]) + 0.5 + 0.25 * e4;
                      t4.patternVertexArray.emplaceBack(i3, r4, t4.segmentStart), t4.patternVertexArray.emplaceBack(i3, r4, t4.segmentStart);
                    }
                    t4.segmentPoints.length = 0;
                  }
                  t4.e1 = t4.e2 = -1;
                };
                if (_2 && M2 < am) {
                  this.updateDistance(y2, m2), this.addCurrentVertex(m2, x2, 1, 1, d2, v2), t3(this), this.addCurrentVertex(m2, b2, -1, -1, d2, v2);
                  continue;
                }
                if (y2) {
                  if (!g2) {
                    this.updateDistance(y2, m2), this.addCurrentVertex(m2, x2, 1, 1, d2, v2), t3(this);
                    continue;
                  }
                  w2 = "miter";
                }
              }
              let A2 = x2.add(b2);
              0 === A2.x && 0 === A2.y || A2._unit();
              const S2 = A2.x * b2.x + A2.y * b2.y, I2 = 0 !== S2 ? 1 / S2 : 1 / 0, T2 = 2 * Math.sqrt(2 - 2 * S2), k2 = S2 < sm && y2 && g2, P2 = x2.x * b2.y - x2.y * b2.x > 0;
              if (k2 && r3 > p2) {
                const t3 = m2.dist(y2);
                if (t3 > 2 * f2) {
                  const e3 = m2.sub(m2.sub(y2)._mult(f2 / t3)._round());
                  this.updateDistance(y2, e3), this.addCurrentVertex(e3, x2, 0, 0, d2, v2), y2 = e3;
                }
              }
              if (_2 && "round" === w2 && (I2 < a2 ? w2 = "miter" : I2 <= 2 && (w2 = "fakeround")), "miter" === w2 && I2 > s2 && (w2 = "bevel"), "bevel" === w2 && (I2 > 2 && (w2 = "flipbevel"), I2 < s2 && (w2 = "miter")), y2 && this.updateDistance(y2, m2), "miter" === w2)
                A2._mult(I2), this.addCurrentVertex(m2, A2, 0, 0, d2, v2);
              else if ("flipbevel" === w2) {
                if (I2 > 100)
                  A2 = b2.mult(-1);
                else {
                  const t3 = I2 * x2.add(b2).mag() / x2.sub(b2).mag();
                  A2._perp()._mult(t3 * (P2 ? -1 : 1));
                }
                this.addCurrentVertex(m2, A2, 0, 0, d2, v2), this.addCurrentVertex(m2, A2.mult(-1), 0, 0, d2, v2);
              } else if ("bevel" === w2 || "fakeround" === w2) {
                const t3 = -Math.sqrt(I2 * I2 - 1), e3 = P2 ? t3 : 0, r4 = P2 ? 0 : t3;
                if (y2 && this.addCurrentVertex(m2, x2, e3, r4, d2, v2), "fakeround" === w2) {
                  const t4 = Math.round(180 * T2 / Math.PI / 20);
                  for (let e4 = 1; e4 < t4; e4++) {
                    let r5 = e4 / t4;
                    if (0.5 !== r5) {
                      const t5 = r5 - 0.5;
                      r5 += r5 * t5 * (r5 - 1) * ((1.0904 + M2 * (M2 * (3.55645 - 1.43519 * M2) - 3.2452)) * t5 * t5 + (0.848013 + M2 * (0.215638 * M2 - 1.06021)));
                    }
                    const n3 = b2.sub(x2)._mult(r5)._add(x2)._unit()._mult(P2 ? -1 : 1);
                    this.addHalfVertex(m2, n3.x, n3.y, false, P2, 0, d2, v2);
                  }
                }
                g2 && this.addCurrentVertex(m2, b2, -e3, -r4, d2, v2);
              } else
                "butt" === w2 ? this.addCurrentVertex(m2, A2, 0, 0, d2, v2) : "square" === w2 ? (y2 || this.addCurrentVertex(m2, A2, -1, -1, d2, v2), this.addCurrentVertex(m2, A2, 0, 0, d2, v2), y2 && this.addCurrentVertex(m2, A2, 1, 1, d2, v2)) : "round" === w2 && (y2 && (this.addCurrentVertex(m2, x2, 0, 0, d2, v2), this.addCurrentVertex(m2, x2, 1, 1, d2, v2, true)), g2 && (this.addCurrentVertex(m2, b2, -1, -1, d2, v2, true), this.addCurrentVertex(m2, b2, 0, 0, d2, v2)));
              if (k2 && r3 < h2 - 1) {
                const t3 = m2.dist(g2);
                if (t3 > 2 * f2) {
                  const e3 = m2.add(g2.sub(m2)._mult(f2 / t3)._round());
                  this.updateDistance(m2, e3), this.addCurrentVertex(e3, b2, 0, 0, d2, v2), m2 = e3;
                }
              }
            }
          }
          addVerticesTo(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2) {
            const c2 = (e2.w - t2.w) / this.tessellationStep | 0;
            if (c2 > 1) {
              this.lineSoFar = t2.w;
              const h2 = (e2.x - t2.x) / c2, p2 = (e2.y - t2.y) / c2, f2 = (e2.z - t2.z) / c2, d2 = (e2.w - t2.w) / c2;
              for (let e3 = 1; e3 < c2; ++e3)
                t2.x += h2, t2.y += p2, t2.z += f2, this.lineSoFar += d2, this.addHalfVertex(t2, r2, n2, u2, false, a2, l2, t2.z), this.addHalfVertex(t2, i2, s2, u2, true, -o2, l2, t2.z);
            }
            this.lineSoFar = e2.w, this.addHalfVertex(e2, r2, n2, u2, false, a2, l2, e2.z), this.addHalfVertex(e2, i2, s2, u2, true, -o2, l2, e2.z);
          }
          addCurrentVertex(t2, e2, r2, n2, i2, s2, a2 = false) {
            const o2 = e2.x + e2.y * r2, l2 = e2.y - e2.x * r2, u2 = e2.y * n2 - e2.x, c2 = -e2.y - e2.x * n2;
            if (null != s2) {
              const e3 = -10, h2 = ds + 10, p2 = s2, f2 = new Bf(t2.x, t2.y, p2, this.lineSoFar), d2 = lm(t2, e3, h2), m2 = this.lineSoFar;
              if (this.currentVertex)
                if (d2) {
                  const s3 = this.currentVertexIsOutside, f3 = this.currentVertex, d3 = new Bf(t2.x, t2.y, p2, this.lineSoFar);
                  Cf(f3, d3, e3, h2), lm(d3, e3, h2) || (s3 && (this.e1 = this.e2 = -1, this.lineSoFar = f3.w, this.addHalfVertex(f3, o2, l2, a2, false, r2, i2, f3.z), this.addHalfVertex(f3, u2, c2, a2, true, -n2, i2, f3.z)), this.addVerticesTo(f3, d3, o2, l2, u2, c2, r2, n2, i2, a2));
                } else {
                  const t3 = this.currentVertex;
                  this.currentVertexIsOutside && (Cf(t3, f2, e3, h2), this.e1 = this.e2 = -1, this.lineSoFar = t3.w, this.addHalfVertex(t3, o2, l2, a2, false, r2, i2, t3.z), this.addHalfVertex(t3, u2, c2, a2, true, -n2, i2, t3.z)), this.addVerticesTo(t3, f2, o2, l2, u2, c2, r2, n2, i2, a2);
                }
              else
                d2 || (this.addHalfVertex(t2, o2, l2, a2, false, r2, i2, s2), this.addHalfVertex(t2, u2, c2, a2, true, -n2, i2, s2));
              this.currentVertex = f2, this.currentVertexIsOutside = d2, this.lineSoFar = m2;
            } else
              this.addHalfVertex(t2, o2, l2, a2, false, r2, i2, s2), this.addHalfVertex(t2, u2, c2, a2, true, -n2, i2, s2);
          }
          addHalfVertex({ x: t2, y: e2 }, r2, n2, i2, s2, a2, o2, l2) {
            this.patternJoinNone && (0 === this.segmentPoints.length && (this.segmentStart = this.lineSoFar, this.segmentStartf32 = Math.fround(this.lineSoFar)), s2 || this.segmentPoints.push(this.lineSoFar - this.segmentStart, a2)), this.layoutVertexArray.emplaceBack((t2 << 1) + (i2 ? 1 : 0), (e2 << 1) + (s2 ? 1 : 0), Math.round(63 * r2) + 128, Math.round(63 * n2) + 128, 1 + (0 === a2 ? 0 : a2 < 0 ? -1 : 1), 0, this.lineSoFar - this.segmentStartf32), this.lineClips && this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, this.lineClips.start, this.lineClips.end);
            const u2 = o2.vertexLength++;
            this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u2), o2.primitiveLength++), s2 ? this.e2 = u2 : this.e1 = u2, null != l2 && this.zOffsetVertexArray.emplaceBack(l2);
          }
          updateScaledDistance() {
            if (this.lineClips) {
              const t2 = this.totalDistance / (this.lineClips.end - this.lineClips.start);
              this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = t2 * this.lineClips.start + this.distance;
            } else
              this.lineSoFar = this.distance;
          }
          updateDistance(t2, e2) {
            this.distance += t2.dist(e2), this.updateScaledDistance();
          }
        }
        function lm(t2, e2, r2) {
          return t2.x < e2 || t2.x > r2 || t2.y < e2 || t2.y > r2;
        }
        let um, cm;
        function hm(t2, e2, r2) {
          return e2 * (ds / (t2.tileSize * Math.pow(2, r2 - t2.tileID.overscaledZ)));
        }
        function pm(t2, e2) {
          return 1 / hm(t2, 1, e2.tileZoom);
        }
        function fm(t2, e2, r2, n2) {
          return t2.translatePosMatrix(n2 || e2.tileID.projMatrix, e2, r2.paint.get("line-translate"), r2.paint.get("line-translate-anchor"));
        }
        So(om, "LineBucket", { omit: ["layers", "patternFeatures", "currentVertex", "currentVertexIsOutside"] });
        const dm = (t2) => {
          const e2 = [];
          mm(t2) && e2.push("RENDER_LINE_DASH"), t2.paint.get("line-gradient") && e2.push("RENDER_LINE_GRADIENT");
          const r2 = t2.paint.get("line-trim-offset");
          0 === r2[0] && 0 === r2[1] || e2.push("RENDER_LINE_TRIM_OFFSET"), 0 !== t2.paint.get("line-border-width").constantOr(1) && e2.push("RENDER_LINE_BORDER");
          const n2 = "none" === t2.layout.get("line-join").constantOr("miter"), i2 = !!t2.paint.get("line-pattern").constantOr(1);
          return n2 && i2 && e2.push("LINE_JOIN_NONE"), e2;
        };
        function mm(t2) {
          const e2 = t2.paint.get("line-dasharray").value;
          return e2.value || "constant" !== e2.kind;
        }
        class ym {
          constructor(t2) {
            this._stringToNumber = {}, this._numberToString = [];
            for (let e2 = 0; e2 < t2.length; e2++) {
              const r2 = t2[e2];
              this._stringToNumber[r2] = e2, this._numberToString[e2] = r2;
            }
          }
          encode(t2) {
            return this._stringToNumber[t2];
          }
          decode(t2) {
            return this._numberToString[t2];
          }
        }
        var gm = {
          /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
          read: function(t2, e2, r2, n2, i2) {
            var s2, a2, o2 = 8 * i2 - n2 - 1, l2 = (1 << o2) - 1, u2 = l2 >> 1, c2 = -7, h2 = r2 ? i2 - 1 : 0, p2 = r2 ? -1 : 1, f2 = t2[e2 + h2];
            for (h2 += p2, s2 = f2 & (1 << -c2) - 1, f2 >>= -c2, c2 += o2; c2 > 0; s2 = 256 * s2 + t2[e2 + h2], h2 += p2, c2 -= 8)
              ;
            for (a2 = s2 & (1 << -c2) - 1, s2 >>= -c2, c2 += n2; c2 > 0; a2 = 256 * a2 + t2[e2 + h2], h2 += p2, c2 -= 8)
              ;
            if (0 === s2)
              s2 = 1 - u2;
            else {
              if (s2 === l2)
                return a2 ? NaN : 1 / 0 * (f2 ? -1 : 1);
              a2 += Math.pow(2, n2), s2 -= u2;
            }
            return (f2 ? -1 : 1) * a2 * Math.pow(2, s2 - n2);
          },
          write: function(t2, e2, r2, n2, i2, s2) {
            var a2, o2, l2, u2 = 8 * s2 - i2 - 1, c2 = (1 << u2) - 1, h2 = c2 >> 1, p2 = 23 === i2 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f2 = n2 ? 0 : s2 - 1, d2 = n2 ? 1 : -1, m2 = e2 < 0 || 0 === e2 && 1 / e2 < 0 ? 1 : 0;
            for (e2 = Math.abs(e2), isNaN(e2) || e2 === 1 / 0 ? (o2 = isNaN(e2) ? 1 : 0, a2 = c2) : (a2 = Math.floor(Math.log(e2) / Math.LN2), e2 * (l2 = Math.pow(2, -a2)) < 1 && (a2--, l2 *= 2), (e2 += a2 + h2 >= 1 ? p2 / l2 : p2 * Math.pow(2, 1 - h2)) * l2 >= 2 && (a2++, l2 /= 2), a2 + h2 >= c2 ? (o2 = 0, a2 = c2) : a2 + h2 >= 1 ? (o2 = (e2 * l2 - 1) * Math.pow(2, i2), a2 += h2) : (o2 = e2 * Math.pow(2, h2 - 1) * Math.pow(2, i2), a2 = 0)); i2 >= 8; t2[r2 + f2] = 255 & o2, f2 += d2, o2 /= 256, i2 -= 8)
              ;
            for (a2 = a2 << i2 | o2, u2 += i2; u2 > 0; t2[r2 + f2] = 255 & a2, f2 += d2, a2 /= 256, u2 -= 8)
              ;
            t2[r2 + f2 - d2] |= 128 * m2;
          }
        }, xm = vm, bm = gm;
        function vm(t2) {
          this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t2) ? t2 : new Uint8Array(t2 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        vm.Varint = 0, vm.Fixed64 = 1, vm.Bytes = 2, vm.Fixed32 = 5;
        var _m = 4294967296, wm = 1 / _m, Mm = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
        function Am(t2) {
          return t2.type === vm.Bytes ? t2.readVarint() + t2.pos : t2.pos + 1;
        }
        function Sm(t2, e2, r2) {
          return r2 ? 4294967296 * e2 + (t2 >>> 0) : 4294967296 * (e2 >>> 0) + (t2 >>> 0);
        }
        function Im(t2, e2, r2) {
          var n2 = e2 <= 16383 ? 1 : e2 <= 2097151 ? 2 : e2 <= 268435455 ? 3 : Math.floor(Math.log(e2) / (7 * Math.LN2));
          r2.realloc(n2);
          for (var i2 = r2.pos - 1; i2 >= t2; i2--)
            r2.buf[i2 + n2] = r2.buf[i2];
        }
        function Tm(t2, e2) {
          for (var r2 = 0; r2 < t2.length; r2++)
            e2.writeVarint(t2[r2]);
        }
        function km(t2, e2) {
          for (var r2 = 0; r2 < t2.length; r2++)
            e2.writeSVarint(t2[r2]);
        }
        function Pm(t2, e2) {
          for (var r2 = 0; r2 < t2.length; r2++)
            e2.writeFloat(t2[r2]);
        }
        function zm(t2, e2) {
          for (var r2 = 0; r2 < t2.length; r2++)
            e2.writeDouble(t2[r2]);
        }
        function Em(t2, e2) {
          for (var r2 = 0; r2 < t2.length; r2++)
            e2.writeBoolean(t2[r2]);
        }
        function Bm(t2, e2) {
          for (var r2 = 0; r2 < t2.length; r2++)
            e2.writeFixed32(t2[r2]);
        }
        function Dm(t2, e2) {
          for (var r2 = 0; r2 < t2.length; r2++)
            e2.writeSFixed32(t2[r2]);
        }
        function Rm(t2, e2) {
          for (var r2 = 0; r2 < t2.length; r2++)
            e2.writeFixed64(t2[r2]);
        }
        function Cm(t2, e2) {
          for (var r2 = 0; r2 < t2.length; r2++)
            e2.writeSFixed64(t2[r2]);
        }
        function Lm(t2, e2) {
          return (t2[e2] | t2[e2 + 1] << 8 | t2[e2 + 2] << 16) + 16777216 * t2[e2 + 3];
        }
        function Vm(t2, e2, r2) {
          t2[r2] = e2, t2[r2 + 1] = e2 >>> 8, t2[r2 + 2] = e2 >>> 16, t2[r2 + 3] = e2 >>> 24;
        }
        function Fm(t2, e2) {
          return (t2[e2] | t2[e2 + 1] << 8 | t2[e2 + 2] << 16) + (t2[e2 + 3] << 24);
        }
        vm.prototype = { destroy: function() {
          this.buf = null;
        }, readFields: function(t2, e2, r2) {
          for (r2 = r2 || this.length; this.pos < r2; ) {
            var n2 = this.readVarint(), i2 = n2 >> 3, s2 = this.pos;
            this.type = 7 & n2, t2(i2, e2, this), this.pos === s2 && this.skip(n2);
          }
          return e2;
        }, readMessage: function(t2, e2) {
          return this.readFields(t2, e2, this.readVarint() + this.pos);
        }, readFixed32: function() {
          var t2 = Lm(this.buf, this.pos);
          return this.pos += 4, t2;
        }, readSFixed32: function() {
          var t2 = Fm(this.buf, this.pos);
          return this.pos += 4, t2;
        }, readFixed64: function() {
          var t2 = Lm(this.buf, this.pos) + Lm(this.buf, this.pos + 4) * _m;
          return this.pos += 8, t2;
        }, readSFixed64: function() {
          var t2 = Lm(this.buf, this.pos) + Fm(this.buf, this.pos + 4) * _m;
          return this.pos += 8, t2;
        }, readFloat: function() {
          var t2 = bm.read(this.buf, this.pos, true, 23, 4);
          return this.pos += 4, t2;
        }, readDouble: function() {
          var t2 = bm.read(this.buf, this.pos, true, 52, 8);
          return this.pos += 8, t2;
        }, readVarint: function(t2) {
          var e2, r2, n2 = this.buf;
          return e2 = 127 & (r2 = n2[this.pos++]), r2 < 128 ? e2 : (e2 |= (127 & (r2 = n2[this.pos++])) << 7, r2 < 128 ? e2 : (e2 |= (127 & (r2 = n2[this.pos++])) << 14, r2 < 128 ? e2 : (e2 |= (127 & (r2 = n2[this.pos++])) << 21, r2 < 128 ? e2 : function(t3, e3, r3) {
            var n3, i2, s2 = r3.buf;
            if (n3 = (112 & (i2 = s2[r3.pos++])) >> 4, i2 < 128)
              return Sm(t3, n3, e3);
            if (n3 |= (127 & (i2 = s2[r3.pos++])) << 3, i2 < 128)
              return Sm(t3, n3, e3);
            if (n3 |= (127 & (i2 = s2[r3.pos++])) << 10, i2 < 128)
              return Sm(t3, n3, e3);
            if (n3 |= (127 & (i2 = s2[r3.pos++])) << 17, i2 < 128)
              return Sm(t3, n3, e3);
            if (n3 |= (127 & (i2 = s2[r3.pos++])) << 24, i2 < 128)
              return Sm(t3, n3, e3);
            if (n3 |= (1 & (i2 = s2[r3.pos++])) << 31, i2 < 128)
              return Sm(t3, n3, e3);
            throw new Error("Expected varint not more than 10 bytes");
          }(e2 |= (15 & (r2 = n2[this.pos])) << 28, t2, this))));
        }, readVarint64: function() {
          return this.readVarint(true);
        }, readSVarint: function() {
          var t2 = this.readVarint();
          return t2 % 2 == 1 ? (t2 + 1) / -2 : t2 / 2;
        }, readBoolean: function() {
          return Boolean(this.readVarint());
        }, readString: function() {
          var t2 = this.readVarint() + this.pos, e2 = this.pos;
          return this.pos = t2, t2 - e2 >= 12 && Mm ? function(t3, e3, r2) {
            return Mm.decode(t3.subarray(e3, r2));
          }(this.buf, e2, t2) : function(t3, e3, r2) {
            for (var n2 = "", i2 = e3; i2 < r2; ) {
              var s2, a2, o2, l2 = t3[i2], u2 = null, c2 = l2 > 239 ? 4 : l2 > 223 ? 3 : l2 > 191 ? 2 : 1;
              if (i2 + c2 > r2)
                break;
              1 === c2 ? l2 < 128 && (u2 = l2) : 2 === c2 ? 128 == (192 & (s2 = t3[i2 + 1])) && (u2 = (31 & l2) << 6 | 63 & s2) <= 127 && (u2 = null) : 3 === c2 ? (a2 = t3[i2 + 2], 128 == (192 & (s2 = t3[i2 + 1])) && 128 == (192 & a2) && ((u2 = (15 & l2) << 12 | (63 & s2) << 6 | 63 & a2) <= 2047 || u2 >= 55296 && u2 <= 57343) && (u2 = null)) : 4 === c2 && (a2 = t3[i2 + 2], o2 = t3[i2 + 3], 128 == (192 & (s2 = t3[i2 + 1])) && 128 == (192 & a2) && 128 == (192 & o2) && ((u2 = (15 & l2) << 18 | (63 & s2) << 12 | (63 & a2) << 6 | 63 & o2) <= 65535 || u2 >= 1114112) && (u2 = null)), null === u2 ? (u2 = 65533, c2 = 1) : u2 > 65535 && (u2 -= 65536, n2 += String.fromCharCode(u2 >>> 10 & 1023 | 55296), u2 = 56320 | 1023 & u2), n2 += String.fromCharCode(u2), i2 += c2;
            }
            return n2;
          }(this.buf, e2, t2);
        }, readBytes: function() {
          var t2 = this.readVarint() + this.pos, e2 = this.buf.subarray(this.pos, t2);
          return this.pos = t2, e2;
        }, readPackedVarint: function(t2, e2) {
          if (this.type !== vm.Bytes)
            return t2.push(this.readVarint(e2));
          var r2 = Am(this);
          for (t2 = t2 || []; this.pos < r2; )
            t2.push(this.readVarint(e2));
          return t2;
        }, readPackedSVarint: function(t2) {
          if (this.type !== vm.Bytes)
            return t2.push(this.readSVarint());
          var e2 = Am(this);
          for (t2 = t2 || []; this.pos < e2; )
            t2.push(this.readSVarint());
          return t2;
        }, readPackedBoolean: function(t2) {
          if (this.type !== vm.Bytes)
            return t2.push(this.readBoolean());
          var e2 = Am(this);
          for (t2 = t2 || []; this.pos < e2; )
            t2.push(this.readBoolean());
          return t2;
        }, readPackedFloat: function(t2) {
          if (this.type !== vm.Bytes)
            return t2.push(this.readFloat());
          var e2 = Am(this);
          for (t2 = t2 || []; this.pos < e2; )
            t2.push(this.readFloat());
          return t2;
        }, readPackedDouble: function(t2) {
          if (this.type !== vm.Bytes)
            return t2.push(this.readDouble());
          var e2 = Am(this);
          for (t2 = t2 || []; this.pos < e2; )
            t2.push(this.readDouble());
          return t2;
        }, readPackedFixed32: function(t2) {
          if (this.type !== vm.Bytes)
            return t2.push(this.readFixed32());
          var e2 = Am(this);
          for (t2 = t2 || []; this.pos < e2; )
            t2.push(this.readFixed32());
          return t2;
        }, readPackedSFixed32: function(t2) {
          if (this.type !== vm.Bytes)
            return t2.push(this.readSFixed32());
          var e2 = Am(this);
          for (t2 = t2 || []; this.pos < e2; )
            t2.push(this.readSFixed32());
          return t2;
        }, readPackedFixed64: function(t2) {
          if (this.type !== vm.Bytes)
            return t2.push(this.readFixed64());
          var e2 = Am(this);
          for (t2 = t2 || []; this.pos < e2; )
            t2.push(this.readFixed64());
          return t2;
        }, readPackedSFixed64: function(t2) {
          if (this.type !== vm.Bytes)
            return t2.push(this.readSFixed64());
          var e2 = Am(this);
          for (t2 = t2 || []; this.pos < e2; )
            t2.push(this.readSFixed64());
          return t2;
        }, skip: function(t2) {
          var e2 = 7 & t2;
          if (e2 === vm.Varint)
            for (; this.buf[this.pos++] > 127; )
              ;
          else if (e2 === vm.Bytes)
            this.pos = this.readVarint() + this.pos;
          else if (e2 === vm.Fixed32)
            this.pos += 4;
          else {
            if (e2 !== vm.Fixed64)
              throw new Error("Unimplemented type: " + e2);
            this.pos += 8;
          }
        }, writeTag: function(t2, e2) {
          this.writeVarint(t2 << 3 | e2);
        }, realloc: function(t2) {
          for (var e2 = this.length || 16; e2 < this.pos + t2; )
            e2 *= 2;
          if (e2 !== this.length) {
            var r2 = new Uint8Array(e2);
            r2.set(this.buf), this.buf = r2, this.length = e2;
          }
        }, finish: function() {
          return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
        }, writeFixed32: function(t2) {
          this.realloc(4), Vm(this.buf, t2, this.pos), this.pos += 4;
        }, writeSFixed32: function(t2) {
          this.realloc(4), Vm(this.buf, t2, this.pos), this.pos += 4;
        }, writeFixed64: function(t2) {
          this.realloc(8), Vm(this.buf, -1 & t2, this.pos), Vm(this.buf, Math.floor(t2 * wm), this.pos + 4), this.pos += 8;
        }, writeSFixed64: function(t2) {
          this.realloc(8), Vm(this.buf, -1 & t2, this.pos), Vm(this.buf, Math.floor(t2 * wm), this.pos + 4), this.pos += 8;
        }, writeVarint: function(t2) {
          (t2 = +t2 || 0) > 268435455 || t2 < 0 ? function(t3, e2) {
            var r2, n2;
            if (t3 >= 0 ? (r2 = t3 % 4294967296 | 0, n2 = t3 / 4294967296 | 0) : (n2 = ~(-t3 / 4294967296), 4294967295 ^ (r2 = ~(-t3 % 4294967296)) ? r2 = r2 + 1 | 0 : (r2 = 0, n2 = n2 + 1 | 0)), t3 >= 18446744073709552e3 || t3 < -18446744073709552e3)
              throw new Error("Given varint doesn't fit into 10 bytes");
            e2.realloc(10), function(t4, e3, r3) {
              r3.buf[r3.pos++] = 127 & t4 | 128, t4 >>>= 7, r3.buf[r3.pos++] = 127 & t4 | 128, t4 >>>= 7, r3.buf[r3.pos++] = 127 & t4 | 128, t4 >>>= 7, r3.buf[r3.pos++] = 127 & t4 | 128, r3.buf[r3.pos] = 127 & (t4 >>>= 7);
            }(r2, 0, e2), function(t4, e3) {
              var r3 = (7 & t4) << 4;
              e3.buf[e3.pos++] |= r3 | ((t4 >>>= 3) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4 | ((t4 >>>= 7) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4 | ((t4 >>>= 7) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4 | ((t4 >>>= 7) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4 | ((t4 >>>= 7) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4)))));
            }(n2, e2);
          }(t2, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t2 | (t2 > 127 ? 128 : 0), t2 <= 127 || (this.buf[this.pos++] = 127 & (t2 >>>= 7) | (t2 > 127 ? 128 : 0), t2 <= 127 || (this.buf[this.pos++] = 127 & (t2 >>>= 7) | (t2 > 127 ? 128 : 0), t2 <= 127 || (this.buf[this.pos++] = t2 >>> 7 & 127))));
        }, writeSVarint: function(t2) {
          this.writeVarint(t2 < 0 ? 2 * -t2 - 1 : 2 * t2);
        }, writeBoolean: function(t2) {
          this.writeVarint(Boolean(t2));
        }, writeString: function(t2) {
          t2 = String(t2), this.realloc(4 * t2.length), this.pos++;
          var e2 = this.pos;
          this.pos = function(t3, e3, r3) {
            for (var n2, i2, s2 = 0; s2 < e3.length; s2++) {
              if ((n2 = e3.charCodeAt(s2)) > 55295 && n2 < 57344) {
                if (!i2) {
                  n2 > 56319 || s2 + 1 === e3.length ? (t3[r3++] = 239, t3[r3++] = 191, t3[r3++] = 189) : i2 = n2;
                  continue;
                }
                if (n2 < 56320) {
                  t3[r3++] = 239, t3[r3++] = 191, t3[r3++] = 189, i2 = n2;
                  continue;
                }
                n2 = i2 - 55296 << 10 | n2 - 56320 | 65536, i2 = null;
              } else
                i2 && (t3[r3++] = 239, t3[r3++] = 191, t3[r3++] = 189, i2 = null);
              n2 < 128 ? t3[r3++] = n2 : (n2 < 2048 ? t3[r3++] = n2 >> 6 | 192 : (n2 < 65536 ? t3[r3++] = n2 >> 12 | 224 : (t3[r3++] = n2 >> 18 | 240, t3[r3++] = n2 >> 12 & 63 | 128), t3[r3++] = n2 >> 6 & 63 | 128), t3[r3++] = 63 & n2 | 128);
            }
            return r3;
          }(this.buf, t2, this.pos);
          var r2 = this.pos - e2;
          r2 >= 128 && Im(e2, r2, this), this.pos = e2 - 1, this.writeVarint(r2), this.pos += r2;
        }, writeFloat: function(t2) {
          this.realloc(4), bm.write(this.buf, t2, this.pos, true, 23, 4), this.pos += 4;
        }, writeDouble: function(t2) {
          this.realloc(8), bm.write(this.buf, t2, this.pos, true, 52, 8), this.pos += 8;
        }, writeBytes: function(t2) {
          var e2 = t2.length;
          this.writeVarint(e2), this.realloc(e2);
          for (var r2 = 0; r2 < e2; r2++)
            this.buf[this.pos++] = t2[r2];
        }, writeRawMessage: function(t2, e2) {
          this.pos++;
          var r2 = this.pos;
          t2(e2, this);
          var n2 = this.pos - r2;
          n2 >= 128 && Im(r2, n2, this), this.pos = r2 - 1, this.writeVarint(n2), this.pos += n2;
        }, writeMessage: function(t2, e2, r2) {
          this.writeTag(t2, vm.Bytes), this.writeRawMessage(e2, r2);
        }, writePackedVarint: function(t2, e2) {
          e2.length && this.writeMessage(t2, Tm, e2);
        }, writePackedSVarint: function(t2, e2) {
          e2.length && this.writeMessage(t2, km, e2);
        }, writePackedBoolean: function(t2, e2) {
          e2.length && this.writeMessage(t2, Em, e2);
        }, writePackedFloat: function(t2, e2) {
          e2.length && this.writeMessage(t2, Pm, e2);
        }, writePackedDouble: function(t2, e2) {
          e2.length && this.writeMessage(t2, zm, e2);
        }, writePackedFixed32: function(t2, e2) {
          e2.length && this.writeMessage(t2, Bm, e2);
        }, writePackedSFixed32: function(t2, e2) {
          e2.length && this.writeMessage(t2, Dm, e2);
        }, writePackedFixed64: function(t2, e2) {
          e2.length && this.writeMessage(t2, Rm, e2);
        }, writePackedSFixed64: function(t2, e2) {
          e2.length && this.writeMessage(t2, Cm, e2);
        }, writeBytesField: function(t2, e2) {
          this.writeTag(t2, vm.Bytes), this.writeBytes(e2);
        }, writeFixed32Field: function(t2, e2) {
          this.writeTag(t2, vm.Fixed32), this.writeFixed32(e2);
        }, writeSFixed32Field: function(t2, e2) {
          this.writeTag(t2, vm.Fixed32), this.writeSFixed32(e2);
        }, writeFixed64Field: function(t2, e2) {
          this.writeTag(t2, vm.Fixed64), this.writeFixed64(e2);
        }, writeSFixed64Field: function(t2, e2) {
          this.writeTag(t2, vm.Fixed64), this.writeSFixed64(e2);
        }, writeVarintField: function(t2, e2) {
          this.writeTag(t2, vm.Varint), this.writeVarint(e2);
        }, writeSVarintField: function(t2, e2) {
          this.writeTag(t2, vm.Varint), this.writeSVarint(e2);
        }, writeStringField: function(t2, e2) {
          this.writeTag(t2, vm.Bytes), this.writeString(e2);
        }, writeFloatField: function(t2, e2) {
          this.writeTag(t2, vm.Fixed32), this.writeFloat(e2);
        }, writeDoubleField: function(t2, e2) {
          this.writeTag(t2, vm.Fixed64), this.writeDouble(e2);
        }, writeBooleanField: function(t2, e2) {
          this.writeVarintField(t2, Boolean(e2));
        } };
        var Om = p(xm);
        const Um = ["id", "tile", "layer", "source", "sourceLayer", "state"];
        class jm {
          constructor(t2, e2, r2, n2, i2) {
            this.type = "Feature", this._vectorTileFeature = t2, this._z = e2, this._x = r2, this._y = n2, this.properties = t2.properties, this.id = i2;
          }
          get geometry() {
            return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
          }
          set geometry(t2) {
            this._geometry = t2;
          }
          toJSON() {
            const t2 = { type: "Feature", state: void 0, geometry: this.geometry, properties: this.properties };
            for (const e2 of Um)
              void 0 !== this[e2] && (t2[e2] = this[e2]);
            return t2;
          }
        }
        class Nm {
          constructor() {
            this.state = {}, this.stateChanges = {}, this.deletedStates = {};
          }
          updateState(t2, e2, r2) {
            const n2 = String(e2);
            if (this.stateChanges[t2] = this.stateChanges[t2] || {}, this.stateChanges[t2][n2] = this.stateChanges[t2][n2] || {}, rr(this.stateChanges[t2][n2], r2), null === this.deletedStates[t2]) {
              this.deletedStates[t2] = {};
              for (const e3 in this.state[t2])
                e3 !== n2 && (this.deletedStates[t2][e3] = null);
            } else if (this.deletedStates[t2] && null === this.deletedStates[t2][n2]) {
              this.deletedStates[t2][n2] = {};
              for (const e3 in this.state[t2][n2])
                r2[e3] || (this.deletedStates[t2][n2][e3] = null);
            } else
              for (const e3 in r2)
                this.deletedStates[t2] && this.deletedStates[t2][n2] && null === this.deletedStates[t2][n2][e3] && delete this.deletedStates[t2][n2][e3];
          }
          removeFeatureState(t2, e2, r2) {
            if (null === this.deletedStates[t2])
              return;
            const n2 = String(e2);
            if (this.deletedStates[t2] = this.deletedStates[t2] || {}, r2 && void 0 !== e2)
              null !== this.deletedStates[t2][n2] && (this.deletedStates[t2][n2] = this.deletedStates[t2][n2] || {}, this.deletedStates[t2][n2][r2] = null);
            else if (void 0 !== e2)
              if (this.stateChanges[t2] && this.stateChanges[t2][n2])
                for (r2 in this.deletedStates[t2][n2] = {}, this.stateChanges[t2][n2])
                  this.deletedStates[t2][n2][r2] = null;
              else
                this.deletedStates[t2][n2] = null;
            else
              this.deletedStates[t2] = null;
          }
          getState(t2, e2) {
            const r2 = String(e2), n2 = rr({}, (this.state[t2] || {})[r2], (this.stateChanges[t2] || {})[r2]);
            if (null === this.deletedStates[t2])
              return {};
            if (this.deletedStates[t2]) {
              const r3 = this.deletedStates[t2][e2];
              if (null === r3)
                return {};
              for (const t3 in r3)
                delete n2[t3];
            }
            return n2;
          }
          initializeTileState(t2, e2) {
            t2.setFeatureState(this.state, e2);
          }
          coalesceChanges(t2, e2) {
            const r2 = {};
            for (const t3 in this.stateChanges) {
              this.state[t3] = this.state[t3] || {};
              const e3 = {};
              for (const r3 in this.stateChanges[t3])
                this.state[t3][r3] || (this.state[t3][r3] = {}), rr(this.state[t3][r3], this.stateChanges[t3][r3]), e3[r3] = this.state[t3][r3];
              r2[t3] = e3;
            }
            for (const t3 in this.deletedStates) {
              this.state[t3] = this.state[t3] || {};
              const e3 = {};
              if (null === this.deletedStates[t3])
                for (const r3 in this.state[t3])
                  e3[r3] = {}, this.state[t3][r3] = {};
              else
                for (const r3 in this.deletedStates[t3]) {
                  if (null === this.deletedStates[t3][r3])
                    this.state[t3][r3] = {};
                  else if (this.state[t3][r3])
                    for (const e4 of Object.keys(this.deletedStates[t3][r3]))
                      delete this.state[t3][r3][e4];
                  e3[r3] = this.state[t3][r3];
                }
              r2[t3] = r2[t3] || {}, rr(r2[t3], e3);
            }
            if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(r2).length)
              for (const n2 in t2)
                t2[n2].setFeatureState(r2, e2);
          }
        }
        class $m {
          constructor(t2, e2) {
            this.tileID = t2, this.x = t2.canonical.x, this.y = t2.canonical.y, this.z = t2.canonical.z, this.grid = new Mo(ds, 16, 0), this.featureIndexArray = new wu(), this.promoteId = e2, this.is3DTile = false;
          }
          insert(t2, e2, r2, n2, i2, s2 = 0, a2 = 0) {
            const o2 = this.featureIndexArray.length;
            this.featureIndexArray.emplaceBack(r2, n2, i2, s2);
            const l2 = this.grid;
            for (let t3 = 0; t3 < e2.length; t3++) {
              const r3 = e2[t3], n3 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
              for (let t4 = 0; t4 < r3.length; t4++) {
                const e3 = r3[t4];
                n3[0] = Math.min(n3[0], e3.x), n3[1] = Math.min(n3[1], e3.y), n3[2] = Math.max(n3[2], e3.x), n3[3] = Math.max(n3[3], e3.y);
              }
              0 !== a2 && (n3[0] -= a2, n3[1] -= a2, n3[2] += a2, n3[3] += a2), n3[0] < ds && n3[1] < ds && n3[2] >= 0 && n3[3] >= 0 && l2.insert(o2, n3[0], n3[1], n3[2], n3[3]);
            }
          }
          loadVTLayers() {
            if (!this.vtLayers) {
              this.vtLayers = new Pf(new Om(this.rawTileData)).layers, this.sourceLayerCoder = new ym(this.vtLayers ? Object.keys(this.vtLayers).sort() : ["_geojsonTileLayer"]), this.vtFeatures = {};
              for (const t2 in this.vtLayers)
                this.vtFeatures[t2] = [];
            }
            return this.vtLayers;
          }
          query(t2, e2, r2, n2) {
            this.loadVTLayers();
            const i2 = t2.params || {}, s2 = dl(i2.filter), a2 = t2.tileResult, o2 = t2.transform, l2 = a2.bufferedTilespaceBounds, u2 = this.grid.query(l2.min.x, l2.min.y, l2.max.x, l2.max.y, (t3, e3, r3, n3) => hh(a2.bufferedTilespaceGeometry, t3, e3, r3, n3));
            u2.sort(Gm);
            let c2 = null;
            o2.elevation && u2.length > 0 && (c2 = ad.create(o2.elevation, this.tileID));
            const h2 = {};
            let p2;
            for (let l3 = 0; l3 < u2.length; l3++) {
              const f2 = u2[l3];
              if (f2 === p2)
                continue;
              p2 = f2;
              const d2 = this.featureIndexArray.get(f2);
              let m2 = null;
              if (this.is3DTile) {
                const t3 = this.bucketLayerIDs[0][0], r3 = e2[t3];
                if ("model" !== r3.type)
                  continue;
                const { queryFeature: n3, intersectionZ: i3 } = r3.queryIntersectsMatchingFeature(a2, d2.featureIndex, s2, o2);
                n3 && this.appendToResult(h2, t3, d2.featureIndex, n3, i3);
              } else
                this.loadMatchingFeature(h2, d2, s2, i2.layers, i2.availableImages, e2, r2, n2, (e3, r3, n3, i3 = 0) => (m2 || (m2 = Kc(e3, this.tileID.canonical, t2.tileTransform)), r3.queryIntersectsFeature(a2, e3, n3, m2, this.z, t2.transform, t2.pixelPosMatrix, c2, i3)));
            }
            return h2;
          }
          loadMatchingFeature(t2, e2, r2, n2, i2, s2, a2, o2, l2) {
            const { featureIndex: u2, bucketIndex: c2, sourceLayerIndex: h2, layoutVertexArrayOffset: p2 } = e2, f2 = this.bucketLayerIDs[c2];
            if (n2 && !function(t3, e3) {
              for (let r3 = 0; r3 < t3.length; r3++)
                if (e3.indexOf(t3[r3]) >= 0)
                  return true;
              return false;
            }(n2, f2))
              return;
            const d2 = this.sourceLayerCoder.decode(h2), m2 = this.vtLayers[d2].feature(u2);
            if (r2.needGeometry) {
              const t3 = Wc(m2, true);
              if (!r2.filter(new Wo(this.tileID.overscaledZ), t3, this.tileID.canonical))
                return;
            } else if (!r2.filter(new Wo(this.tileID.overscaledZ), m2))
              return;
            const y2 = this.getId(m2, d2);
            for (let e3 = 0; e3 < f2.length; e3++) {
              const r3 = f2[e3];
              if (n2 && n2.indexOf(r3) < 0)
                continue;
              const c3 = s2[r3];
              if (!c3)
                continue;
              let h3 = {};
              void 0 !== y2 && o2 && (h3 = o2.getState(c3.sourceLayer || "_geojsonTileLayer", y2));
              const d3 = !l2 || l2(m2, c3, h3, p2);
              if (!d3)
                continue;
              const g2 = new jm(m2, this.z, this.x, this.y, y2), x2 = rr({}, a2[r3]);
              x2.paint = qm(x2.paint, c3.paint, m2, h3, i2), x2.layout = qm(x2.layout, c3.layout, m2, h3, i2), g2.layer = x2, this.appendToResult(t2, r3, u2, g2, d3);
            }
          }
          appendToResult(t2, e2, r2, n2, i2) {
            let s2 = t2[e2];
            void 0 === s2 && (s2 = t2[e2] = []), s2.push({ featureIndex: r2, feature: n2, intersectionZ: i2 });
          }
          lookupSymbolFeatures(t2, e2, r2, n2, i2, s2, a2, o2) {
            const l2 = {};
            this.loadVTLayers();
            const u2 = dl(i2);
            for (const i3 of t2)
              this.loadMatchingFeature(l2, { bucketIndex: r2, sourceLayerIndex: n2, featureIndex: i3, layoutVertexArrayOffset: 0 }, u2, s2, a2, o2, e2);
            return l2;
          }
          loadFeature(t2) {
            const { featureIndex: e2, sourceLayerIndex: r2 } = t2;
            this.loadVTLayers();
            const n2 = this.sourceLayerCoder.decode(r2), i2 = this.vtFeatures[n2];
            if (i2[e2])
              return i2[e2];
            const s2 = this.vtLayers[n2].feature(e2);
            return i2[e2] = s2, s2;
          }
          hasLayer(t2) {
            for (const e2 of this.bucketLayerIDs)
              for (const r2 of e2)
                if (t2 === r2)
                  return true;
            return false;
          }
          getId(t2, e2) {
            let r2 = t2.id;
            if (this.promoteId) {
              const n2 = "string" == typeof this.promoteId ? this.promoteId : this.promoteId[e2];
              null != n2 && (r2 = t2.properties[n2]), "boolean" == typeof r2 && (r2 = Number(r2));
            }
            return r2;
          }
        }
        function qm(t2, e2, r2, n2, i2) {
          return cr(t2, (t3, s2) => {
            const a2 = e2 instanceof sl ? e2.get(s2) : null;
            return a2 && a2.evaluate ? a2.evaluate(r2, n2, i2) : a2;
          });
        }
        function Gm(t2, e2) {
          return e2 - t2;
        }
        So($m, "FeatureIndex", { omit: ["rawTileData", "sourceLayerCoder"] });
        var Xm = 24;
        const Ym = 128;
        function Zm(t2, e2) {
          const { expression: r2 } = e2;
          if ("constant" === r2.kind)
            return { kind: "constant", layoutSize: r2.evaluate(new Wo(t2 + 1)) };
          if ("source" === r2.kind)
            return { kind: "source" };
          {
            const { zoomStops: e3, interpolationType: n2 } = r2;
            let i2 = 0;
            for (; i2 < e3.length && e3[i2] <= t2; )
              i2++;
            i2 = Math.max(0, i2 - 1);
            let s2 = i2;
            for (; s2 < e3.length && e3[s2] < t2 + 1; )
              s2++;
            s2 = Math.min(e3.length - 1, s2);
            const a2 = e3[i2], o2 = e3[s2];
            return "composite" === r2.kind ? { kind: "composite", minZoom: a2, maxZoom: o2, interpolationType: n2 } : { kind: "camera", minZoom: a2, maxZoom: o2, minSize: r2.evaluate(new Wo(a2)), maxSize: r2.evaluate(new Wo(o2)), interpolationType: n2 };
          }
        }
        function Hm(t2, { uSize: e2, uSizeT: r2 }, { lowerSize: n2, upperSize: i2 }) {
          return "source" === t2.kind ? n2 / Ym : "composite" === t2.kind ? Yn(n2 / Ym, i2 / Ym, r2) : e2;
        }
        function Km(t2, e2) {
          let r2 = 0, n2 = 0;
          if ("constant" === t2.kind)
            n2 = t2.layoutSize;
          else if ("source" !== t2.kind) {
            const { interpolationType: i2, minZoom: s2, maxZoom: a2 } = t2, o2 = i2 ? We(wa.interpolationFactor(i2, e2, s2, a2), 0, 1) : 0;
            "camera" === t2.kind ? n2 = Yn(t2.minSize, t2.maxSize, o2) : r2 = o2;
          }
          return { uSizeT: r2, uSize: n2 };
        }
        var Wm = Object.freeze({ __proto__: null, SIZE_PACK_FACTOR: Ym, evaluateSizeForFeature: Hm, evaluateSizeForZoom: Km, getSizeData: Zm });
        function Jm(t2, e2, r2) {
          return t2.sections.forEach((t3) => {
            t3.text = function(t4, e3, r3) {
              const n2 = e3.layout.get("text-transform").evaluate(r3, {});
              return "uppercase" === n2 ? t4 = t4.toLocaleUpperCase() : "lowercase" === n2 && (t4 = t4.toLocaleLowerCase()), Ko.applyArabicShaping && (t4 = Ko.applyArabicShaping(t4)), t4;
            }(t3.text, e2, r2);
          }), t2;
        }
        const Qm = { "!": "\uFE15", "#": "\uFF03", $: "\uFF04", "%": "\uFF05", "&": "\uFF06", "(": "\uFE35", ")": "\uFE36", "*": "\uFF0A", "+": "\uFF0B", ",": "\uFE10", "-": "\uFE32", ".": "\u30FB", "/": "\uFF0F", ":": "\uFE13", ";": "\uFE14", "<": "\uFE3F", "=": "\uFF1D", ">": "\uFE40", "?": "\uFE16", "@": "\uFF20", "[": "\uFE47", "\\": "\uFF3C", "]": "\uFE48", "^": "\uFF3E", _: "\uFE33", "`": "\uFF40", "{": "\uFE37", "|": "\u2015", "}": "\uFE38", "~": "\uFF5E", "\xA2": "\uFFE0", "\xA3": "\uFFE1", "\xA5": "\uFFE5", "\xA6": "\uFFE4", "\xAC": "\uFFE2", "\xAF": "\uFFE3", "\u2013": "\uFE32", "\u2014": "\uFE31", "\u2018": "\uFE43", "\u2019": "\uFE44", "\u201C": "\uFE41", "\u201D": "\uFE42", "\u2026": "\uFE19", "\u2027": "\u30FB", "\u20A9": "\uFFE6", "\u3001": "\uFE11", "\u3002": "\uFE12", "\u3008": "\uFE3F", "\u3009": "\uFE40", "\u300A": "\uFE3D", "\u300B": "\uFE3E", "\u300C": "\uFE41", "\u300D": "\uFE42", "\u300E": "\uFE43", "\u300F": "\uFE44", "\u3010": "\uFE3B", "\u3011": "\uFE3C", "\u3014": "\uFE39", "\u3015": "\uFE3A", "\u3016": "\uFE17", "\u3017": "\uFE18", "\uFF01": "\uFE15", "\uFF08": "\uFE35", "\uFF09": "\uFE36", "\uFF0C": "\uFE10", "\uFF0D": "\uFE32", "\uFF0E": "\u30FB", "\uFF1A": "\uFE13", "\uFF1B": "\uFE14", "\uFF1C": "\uFE3F", "\uFF1E": "\uFE40", "\uFF1F": "\uFE16", "\uFF3B": "\uFE47", "\uFF3D": "\uFE48", "\uFF3F": "\uFE33", "\uFF5B": "\uFE37", "\uFF5C": "\u2015", "\uFF5D": "\uFE38", "\uFF5F": "\uFE35", "\uFF60": "\uFE36", "\uFF61": "\uFE12", "\uFF62": "\uFE41", "\uFF63": "\uFE42", "\u2190": "\u2191", "\u2192": "\u2193" };
        function ty(t2) {
          return "\uFE36" === t2 || "\uFE48" === t2 || "\uFE38" === t2 || "\uFE44" === t2 || "\uFE42" === t2 || "\uFE3E" === t2 || "\uFE3C" === t2 || "\uFE3A" === t2 || "\uFE18" === t2 || "\uFE40" === t2 || "\uFE10" === t2 || "\uFE13" === t2 || "\uFE14" === t2 || "\uFF40" === t2 || "\uFFE3" === t2 || "\uFE11" === t2 || "\uFE12" === t2;
        }
        function ey(t2) {
          return "\uFE35" === t2 || "\uFE47" === t2 || "\uFE37" === t2 || "\uFE43" === t2 || "\uFE41" === t2 || "\uFE3D" === t2 || "\uFE3B" === t2 || "\uFE39" === t2 || "\uFE17" === t2 || "\uFE3F" === t2;
        }
        const ry = 3;
        function ny(t2, e2, r2) {
          e2.glyphs = [], 1 === t2 && r2.readMessage(iy, e2);
        }
        function iy(t2, e2, r2) {
          if (3 === t2) {
            const { id: t3, bitmap: n2, width: i2, height: s2, left: a2, top: o2, advance: l2 } = r2.readMessage(sy, {});
            e2.glyphs.push({ id: t3, bitmap: new yp({ width: i2 + 2 * ry, height: s2 + 2 * ry }, n2), metrics: { width: i2, height: s2, left: a2, top: o2, advance: l2 } });
          } else
            4 === t2 ? e2.ascender = r2.readSVarint() : 5 === t2 && (e2.descender = r2.readSVarint());
        }
        function sy(t2, e2, r2) {
          1 === t2 ? e2.id = r2.readVarint() : 2 === t2 ? e2.bitmap = r2.readBytes() : 3 === t2 ? e2.width = r2.readVarint() : 4 === t2 ? e2.height = r2.readVarint() : 5 === t2 ? e2.left = r2.readSVarint() : 6 === t2 ? e2.top = r2.readSVarint() : 7 === t2 && (e2.advance = r2.readVarint());
        }
        const ay = ry, oy = { horizontal: 1, vertical: 2, horizontalOnly: 3 };
        class ly {
          constructor() {
            this.scale = 1, this.fontStack = "", this.imageName = null;
          }
          static forText(t2, e2) {
            const r2 = new ly();
            return r2.scale = t2 || 1, r2.fontStack = e2, r2;
          }
          static forImage(t2) {
            const e2 = new ly();
            return e2.imageName = t2, e2;
          }
        }
        class uy {
          constructor() {
            this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
          }
          static fromFeature(t2, e2) {
            const r2 = new uy();
            for (let n2 = 0; n2 < t2.sections.length; n2++) {
              const i2 = t2.sections[n2];
              i2.image ? r2.addImageSection(i2) : r2.addTextSection(i2, e2);
            }
            return r2;
          }
          length() {
            return this.text.length;
          }
          getSection(t2) {
            return this.sections[this.sectionIndex[t2]];
          }
          getSections() {
            return this.sections;
          }
          getSectionIndex(t2) {
            return this.sectionIndex[t2];
          }
          getCodePoint(t2) {
            return this.text.codePointAt(t2);
          }
          verticalizePunctuation(t2) {
            this.text = function(t3, e2) {
              let r2 = "";
              for (let n2 = 0; n2 < t3.length; n2++) {
                const i2 = t3.charCodeAt(n2 + 1) || null, s2 = t3.charCodeAt(n2 - 1) || null;
                r2 += !e2 && (i2 && Co(i2) && !Qm[t3[n2 + 1]] || s2 && Co(s2) && !Qm[t3[n2 - 1]]) || !Qm[t3[n2]] ? t3[n2] : Qm[t3[n2]];
              }
              return r2;
            }(this.text, t2);
          }
          trim() {
            let t2 = 0;
            for (let e3 = 0; e3 < this.text.length && hy[this.text.charCodeAt(e3)]; e3++)
              t2++;
            let e2 = this.text.length;
            for (let r2 = this.text.length - 1; r2 >= 0 && r2 >= t2 && hy[this.text.charCodeAt(r2)]; r2--)
              e2--;
            this.text = this.text.substring(t2, e2), this.sectionIndex = this.sectionIndex.slice(t2, e2);
          }
          substring(t2, e2) {
            const r2 = new uy();
            return r2.text = this.text.substring(t2, e2), r2.sectionIndex = this.sectionIndex.slice(t2, e2), r2.sections = this.sections, r2;
          }
          toString() {
            return this.text;
          }
          getMaxScale() {
            return this.sectionIndex.reduce((t2, e2) => Math.max(t2, this.sections[e2].scale), 0);
          }
          addTextSection(t2, e2) {
            this.text += t2.text, this.sections.push(ly.forText(t2.scale, t2.fontStack || e2));
            const r2 = this.sections.length - 1;
            for (let e3 = 0; e3 < t2.text.length; ++e3)
              this.sectionIndex.push(r2);
          }
          addImageSection(t2) {
            const e2 = t2.image ? t2.image.namePrimary : "";
            if (0 === e2.length)
              return void dr("Can't add FormattedSection with an empty image.");
            const r2 = this.getNextImageSectionCharCode();
            r2 ? (this.text += String.fromCodePoint(r2), this.sections.push(ly.forImage(e2)), this.sectionIndex.push(this.sections.length - 1)) : dr("Reached maximum number of images 6401");
          }
          getNextImageSectionCharCode() {
            return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
          }
        }
        function cy(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2) {
          const m2 = uy.fromFeature(t2, i2);
          h2 === oy.vertical && m2.verticalizePunctuation(p2);
          let y2 = [];
          const g2 = function(t3, e3, r3, n3, i3, s3) {
            if (!t3)
              return [];
            const a3 = [], o3 = function(t4, e4, r4, n4, i4, s4) {
              let a4 = 0;
              for (let r5 = 0; r5 < t4.length(); r5++) {
                const o4 = t4.getSection(r5);
                a4 += fy(t4.getCodePoint(r5), o4, n4, i4, e4, s4);
              }
              return a4 / Math.max(1, Math.ceil(a4 / r4));
            }(t3, e3, r3, n3, i3, s3), l3 = t3.text.indexOf("\u200B") >= 0;
            let u3 = 0;
            for (let r4 = 0; r4 < t3.length(); r4++) {
              const h3 = t3.getSection(r4), p3 = t3.getCodePoint(r4);
              if (hy[p3] || (u3 += fy(p3, h3, n3, i3, e3, s3)), r4 < t3.length() - 1) {
                const e4 = !((c3 = p3) < 11904 || !(zo["Bopomofo Extended"](c3) || zo.Bopomofo(c3) || zo["CJK Compatibility Forms"](c3) || zo["CJK Compatibility Ideographs"](c3) || zo["CJK Compatibility"](c3) || zo["CJK Radicals Supplement"](c3) || zo["CJK Strokes"](c3) || zo["CJK Symbols and Punctuation"](c3) || zo["CJK Unified Ideographs Extension A"](c3) || zo["CJK Unified Ideographs"](c3) || zo["Enclosed CJK Letters and Months"](c3) || zo["Halfwidth and Fullwidth Forms"](c3) || zo.Hiragana(c3) || zo["Ideographic Description Characters"](c3) || zo["Kangxi Radicals"](c3) || zo["Katakana Phonetic Extensions"](c3) || zo.Katakana(c3) || zo["Vertical Forms"](c3) || zo["Yi Radicals"](c3) || zo["Yi Syllables"](c3)));
                (py[p3] || e4 || h3.imageName) && a3.push(yy(r4 + 1, u3, o3, a3, my(p3, t3.getCodePoint(r4 + 1), e4 && l3), false));
              }
            }
            var c3;
            return gy(yy(t3.length(), u3, o3, a3, 0, true));
          }(m2, u2, s2, e2, n2, f2), { processBidirectionalText: x2, processStyledBidirectionalText: b2 } = Ko;
          if (x2 && 1 === m2.sections.length) {
            const t3 = x2(m2.toString(), g2);
            for (const e3 of t3) {
              const t4 = new uy();
              t4.text = e3, t4.sections = m2.sections;
              for (let r3 = 0; r3 < e3.length; r3++)
                t4.sectionIndex.push(0);
              y2.push(t4);
            }
          } else if (b2) {
            const t3 = b2(m2.text, m2.sectionIndex, g2);
            for (const e3 of t3) {
              const t4 = new uy();
              t4.text = e3[0], t4.sectionIndex = e3[1], t4.sections = m2.sections, y2.push(t4);
            }
          } else
            y2 = function(t3, e3) {
              const r3 = [], n3 = t3.text;
              let i3 = 0;
              for (const n4 of e3)
                r3.push(t3.substring(i3, n4)), i3 = n4;
              return i3 < n3.length && r3.push(t3.substring(i3, n3.length)), r3;
            }(m2, g2);
          const v2 = [], _2 = { positionedLines: v2, text: m2.toString(), top: c2[1], bottom: c2[1], left: c2[0], right: c2[0], writingMode: h2, iconsInText: false, verticalizable: false, hasBaseline: false };
          return function(t3, e3, r3, n3, i3, s3, a3, o3, l3, u3, c3, h3) {
            let p3 = 0, f3 = 0, d3 = 0;
            const m3 = "right" === o3 ? 1 : "left" === o3 ? 0 : 0.5;
            let y3 = false;
            for (const t4 of i3) {
              const r4 = t4.getSections();
              for (const t5 of r4) {
                if (t5.imageName)
                  continue;
                const r5 = e3[t5.fontStack];
                if (r5 && (y3 = void 0 !== r5.ascender && void 0 !== r5.descender, !y3))
                  break;
              }
              if (!y3)
                break;
            }
            let g3 = 0;
            for (const a4 of i3) {
              a4.trim();
              const i4 = a4.getMaxScale(), o4 = (i4 - 1) * Xm, b4 = { positionedGlyphs: [], lineOffset: 0 };
              t3.positionedLines[g3] = b4;
              const v4 = b4.positionedGlyphs;
              let _4 = 0;
              if (!a4.length()) {
                f3 += s3, ++g3;
                continue;
              }
              let w2 = 0, M2 = 0;
              for (let s4 = 0; s4 < a4.length(); s4++) {
                const o5 = a4.getSection(s4), d4 = a4.getSectionIndex(s4), m4 = a4.getCodePoint(s4);
                let g4 = o5.scale, b5 = null, A3 = null, S2 = null, I2 = Xm, T2 = 0;
                const k2 = !(l3 === oy.horizontal || !c3 && !Ro(m4) || c3 && (hy[m4] || (x3 = m4, zo.Arabic(x3) || zo["Arabic Supplement"](x3) || zo["Arabic Extended-A"](x3) || zo["Arabic Presentation Forms-A"](x3) || zo["Arabic Presentation Forms-B"](x3))));
                if (o5.imageName) {
                  const e4 = n3[o5.imageName];
                  if (!e4)
                    continue;
                  S2 = o5.imageName, t3.iconsInText = t3.iconsInText || true, A3 = e4.paddedRect;
                  const r4 = e4.displaySize;
                  g4 = g4 * Xm / h3, b5 = { width: r4[0], height: r4[1], left: 0, top: -ay, advance: k2 ? r4[1] : r4[0], localGlyph: false }, T2 = y3 ? -b5.height * g4 : i4 * Xm - 17 - r4[1] * g4, I2 = b5.advance;
                  const s5 = (k2 ? r4[0] : r4[1]) * g4 - Xm * i4;
                  s5 > 0 && s5 > _4 && (_4 = s5);
                } else {
                  const t4 = r3[o5.fontStack];
                  if (!t4)
                    continue;
                  t4[m4] && (A3 = t4[m4]);
                  const n4 = e3[o5.fontStack];
                  if (!n4)
                    continue;
                  const s5 = n4.glyphs[m4];
                  if (!s5)
                    continue;
                  if (b5 = s5.metrics, I2 = 8203 !== m4 ? Xm : 0, y3) {
                    const t5 = void 0 !== n4.ascender ? Math.abs(n4.ascender) : 0, e4 = void 0 !== n4.descender ? Math.abs(n4.descender) : 0, r4 = (t5 + e4) * g4;
                    w2 < r4 && (w2 = r4, M2 = (t5 - e4) / 2 * g4), T2 = -t5 * g4;
                  } else
                    T2 = (i4 - g4) * Xm - 17;
                }
                k2 ? (t3.verticalizable = true, v4.push({ glyph: m4, imageName: S2, x: p3, y: f3 + T2, vertical: k2, scale: g4, localGlyph: b5.localGlyph, fontStack: o5.fontStack, sectionIndex: d4, metrics: b5, rect: A3 }), p3 += I2 * g4 + u3) : (v4.push({ glyph: m4, imageName: S2, x: p3, y: f3 + T2, vertical: k2, scale: g4, localGlyph: b5.localGlyph, fontStack: o5.fontStack, sectionIndex: d4, metrics: b5, rect: A3 }), p3 += b5.advance * g4 + u3);
              }
              0 !== v4.length && (d3 = Math.max(p3 - u3, d3), y3 ? by(v4, m3, _4, M2, s3 * i4 / 2) : by(v4, m3, _4, 0, s3 / 2)), p3 = 0;
              const A2 = s3 * i4 + _4;
              b4.lineOffset = Math.max(_4, o4), f3 += A2, ++g3;
            }
            var x3;
            const b3 = f3, { horizontalAlign: v3, verticalAlign: _3 } = xy(a3);
            (function(t4, e4, r4, n4, i4, s4) {
              const a4 = (e4 - r4) * i4, o4 = -s4 * n4;
              for (const e5 of t4)
                for (const t5 of e5.positionedGlyphs)
                  t5.x += a4, t5.y += o4;
            })(t3.positionedLines, m3, v3, _3, d3, b3), t3.top += -_3 * b3, t3.bottom = t3.top + b3, t3.left += -v3 * d3, t3.right = t3.left + d3, t3.hasBaseline = y3;
          }(_2, e2, r2, n2, y2, a2, o2, l2, h2, u2, p2, d2), !function(t3) {
            for (const e3 of t3)
              if (0 !== e3.positionedGlyphs.length)
                return false;
            return true;
          }(v2) && _2;
        }
        const hy = { 9: true, 10: true, 11: true, 12: true, 13: true, 32: true }, py = { 10: true, 32: true, 38: true, 40: true, 41: true, 43: true, 45: true, 47: true, 173: true, 183: true, 8203: true, 8208: true, 8211: true, 8231: true };
        function fy(t2, e2, r2, n2, i2, s2) {
          if (e2.imageName) {
            const t3 = n2[e2.imageName];
            return t3 ? t3.displaySize[0] * e2.scale * Xm / s2 + i2 : 0;
          }
          {
            const n3 = r2[e2.fontStack], s3 = n3 && n3.glyphs[t2];
            return s3 ? s3.metrics.advance * e2.scale + i2 : 0;
          }
        }
        function dy(t2, e2, r2, n2) {
          const i2 = Math.pow(t2 - e2, 2);
          return n2 ? t2 < e2 ? i2 / 2 : 2 * i2 : i2 + Math.abs(r2) * r2;
        }
        function my(t2, e2, r2) {
          let n2 = 0;
          return 10 === t2 && (n2 -= 1e4), r2 && (n2 += 150), 40 !== t2 && 65288 !== t2 || (n2 += 50), 41 !== e2 && 65289 !== e2 || (n2 += 50), n2;
        }
        function yy(t2, e2, r2, n2, i2, s2) {
          let a2 = null, o2 = dy(e2, r2, i2, s2);
          for (const t3 of n2) {
            const n3 = dy(e2 - t3.x, r2, i2, s2) + t3.badness;
            n3 <= o2 && (a2 = t3, o2 = n3);
          }
          return { index: t2, x: e2, priorBreak: a2, badness: o2 };
        }
        function gy(t2) {
          return t2 ? gy(t2.priorBreak).concat(t2.index) : [];
        }
        function xy(t2) {
          let e2 = 0.5, r2 = 0.5;
          switch (t2) {
            case "right":
            case "top-right":
            case "bottom-right":
              e2 = 1;
              break;
            case "left":
            case "top-left":
            case "bottom-left":
              e2 = 0;
          }
          switch (t2) {
            case "bottom":
            case "bottom-right":
            case "bottom-left":
              r2 = 1;
              break;
            case "top":
            case "top-right":
            case "top-left":
              r2 = 0;
          }
          return { horizontalAlign: e2, verticalAlign: r2 };
        }
        function by(t2, e2, r2, n2, i2) {
          if (!(e2 || r2 || n2 || i2))
            return;
          const s2 = t2.length - 1, a2 = t2[s2], o2 = (a2.x + a2.metrics.advance * a2.scale) * e2;
          for (let e3 = 0; e3 <= s2; e3++)
            t2[e3].x -= o2, t2[e3].y += r2 + n2 + i2;
        }
        function vy(t2, e2, r2, n2) {
          const { horizontalAlign: i2, verticalAlign: s2 } = xy(n2), a2 = r2[0] - t2.displaySize[0] * i2, o2 = r2[1] - t2.displaySize[1] * s2;
          return { imagePrimary: t2, imageSecondary: e2, top: o2, bottom: o2 + t2.displaySize[1], left: a2, right: a2 + t2.displaySize[0] };
        }
        function _y(t2, e2, r2, n2, i2, s2) {
          const a2 = t2.imagePrimary;
          let o2;
          if (a2.content) {
            const t3 = a2.content, e3 = a2.pixelRatio || 1;
            o2 = [t3[0] / e3, t3[1] / e3, a2.displaySize[0] - t3[2] / e3, a2.displaySize[1] - t3[3] / e3];
          }
          const l2 = e2.left * s2, u2 = e2.right * s2;
          let c2, h2, p2, f2;
          "width" === r2 || "both" === r2 ? (f2 = i2[0] + l2 - n2[3], h2 = i2[0] + u2 + n2[1]) : (f2 = i2[0] + (l2 + u2 - a2.displaySize[0]) / 2, h2 = f2 + a2.displaySize[0]);
          const d2 = e2.top * s2, m2 = e2.bottom * s2;
          return "height" === r2 || "both" === r2 ? (c2 = i2[1] + d2 - n2[0], p2 = i2[1] + m2 + n2[2]) : (c2 = i2[1] + (d2 + m2 - a2.displaySize[1]) / 2, p2 = c2 + a2.displaySize[1]), { imagePrimary: a2, imageSecondary: void 0, top: c2, right: h2, bottom: p2, left: f2, collisionPadding: o2 };
        }
        class wy extends je {
          constructor(t2, e2, r2, n2, i2) {
            super(t2, e2), this.angle = n2, this.z = r2, void 0 !== i2 && (this.segment = i2);
          }
          clone() {
            return new wy(this.x, this.y, this.z, this.angle, this.segment);
          }
        }
        function My(t2, e2, r2, n2, i2) {
          if (void 0 === e2.segment)
            return true;
          let s2 = e2, a2 = e2.segment + 1, o2 = 0;
          for (; o2 > -r2 / 2; ) {
            if (a2--, a2 < 0)
              return false;
            o2 -= t2[a2].dist(s2), s2 = t2[a2];
          }
          o2 += t2[a2].dist(t2[a2 + 1]), a2++;
          const l2 = [];
          let u2 = 0;
          for (; o2 < r2 / 2; ) {
            const e3 = t2[a2], r3 = t2[a2 + 1];
            if (!r3)
              return false;
            let s3 = t2[a2 - 1].angleTo(e3) - e3.angleTo(r3);
            for (s3 = Math.abs((s3 + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l2.push({ distance: o2, angleDelta: s3 }), u2 += s3; o2 - l2[0].distance > n2; )
              u2 -= l2.shift().angleDelta;
            if (u2 > i2)
              return false;
            a2++, o2 += e3.dist(r3);
          }
          return true;
        }
        function Ay(t2) {
          let e2 = 0;
          for (let r2 = 0; r2 < t2.length - 1; r2++)
            e2 += t2[r2].dist(t2[r2 + 1]);
          return e2;
        }
        function Sy(t2, e2, r2) {
          return t2 ? 0.6 * e2 * r2 : 0;
        }
        function Iy(t2, e2) {
          return Math.max(t2 ? t2.right - t2.left : 0, e2 ? e2.right - e2.left : 0);
        }
        function Ty(t2, e2, r2, n2, i2, s2) {
          const a2 = Sy(r2, i2, s2), o2 = Iy(r2, n2) * s2;
          let l2 = 0;
          const u2 = Ay(t2) / 2;
          for (let r3 = 0; r3 < t2.length - 1; r3++) {
            const n3 = t2[r3], i3 = t2[r3 + 1], s3 = n3.dist(i3);
            if (l2 + s3 > u2) {
              const c2 = (u2 - l2) / s3, h2 = Yn(n3.x, i3.x, c2), p2 = Yn(n3.y, i3.y, c2), f2 = new wy(h2, p2, 0, i3.angleTo(n3), r3);
              return !a2 || My(t2, f2, o2, a2, e2) ? f2 : void 0;
            }
            l2 += s3;
          }
        }
        function ky(t2, e2, r2, n2, i2, s2, a2, o2, l2) {
          const u2 = Sy(n2, s2, a2), c2 = Iy(n2, i2), h2 = c2 * a2, p2 = 0 === t2[0].x || t2[0].x === l2 || 0 === t2[0].y || t2[0].y === l2;
          return e2 - h2 < e2 / 4 && (e2 = h2 + e2 / 4), Py(t2, p2 ? e2 / 2 * o2 % e2 : (c2 / 2 + 2 * s2) * a2 * o2 % e2, e2, u2, r2, h2, p2, false, l2);
        }
        function Py(t2, e2, r2, n2, i2, s2, a2, o2, l2) {
          const u2 = s2 / 2, c2 = Ay(t2);
          let h2 = 0, p2 = e2 - r2, f2 = [];
          for (let e3 = 0; e3 < t2.length - 1; e3++) {
            const a3 = t2[e3], o3 = t2[e3 + 1], d2 = a3.dist(o3), m2 = o3.angleTo(a3);
            for (; p2 + r2 < h2 + d2; ) {
              p2 += r2;
              const y2 = (p2 - h2) / d2, g2 = Yn(a3.x, o3.x, y2), x2 = Yn(a3.y, o3.y, y2);
              if (g2 >= 0 && g2 < l2 && x2 >= 0 && x2 < l2 && p2 - u2 >= 0 && p2 + u2 <= c2) {
                const r3 = new wy(g2, x2, 0, m2, e3);
                n2 && !My(t2, r3, s2, n2, i2) || f2.push(r3);
              }
            }
            h2 += d2;
          }
          return o2 || f2.length || a2 || (f2 = Py(t2, h2 / 2, r2, n2, i2, s2, a2, true, l2)), f2;
        }
        function zy(t2, e2, r2, n2, i2) {
          const s2 = [];
          for (let a2 = 0; a2 < t2.length; a2++) {
            const o2 = t2[a2];
            let l2;
            for (let t3 = 0; t3 < o2.length - 1; t3++) {
              let a3 = o2[t3], u2 = o2[t3 + 1];
              a3.x < e2 && u2.x < e2 || (a3.x < e2 ? a3 = new je(e2, a3.y + (e2 - a3.x) / (u2.x - a3.x) * (u2.y - a3.y))._round() : u2.x < e2 && (u2 = new je(e2, a3.y + (e2 - a3.x) / (u2.x - a3.x) * (u2.y - a3.y))._round()), a3.y < r2 && u2.y < r2 || (a3.y < r2 ? a3 = new je(a3.x + (r2 - a3.y) / (u2.y - a3.y) * (u2.x - a3.x), r2)._round() : u2.y < r2 && (u2 = new je(a3.x + (r2 - a3.y) / (u2.y - a3.y) * (u2.x - a3.x), r2)._round()), a3.x >= n2 && u2.x >= n2 || (a3.x >= n2 ? a3 = new je(n2, a3.y + (n2 - a3.x) / (u2.x - a3.x) * (u2.y - a3.y))._round() : u2.x >= n2 && (u2 = new je(n2, a3.y + (n2 - a3.x) / (u2.x - a3.x) * (u2.y - a3.y))._round()), a3.y >= i2 && u2.y >= i2 || (a3.y >= i2 ? a3 = new je(a3.x + (i2 - a3.y) / (u2.y - a3.y) * (u2.x - a3.x), i2)._round() : u2.y >= i2 && (u2 = new je(a3.x + (i2 - a3.y) / (u2.y - a3.y) * (u2.x - a3.x), i2)._round()), l2 && a3.equals(l2[l2.length - 1]) || (l2 = [a3], s2.push(l2)), l2.push(u2)))));
            }
          }
          return s2;
        }
        function Ey(t2) {
          let e2 = 0, r2 = 0;
          for (const n3 of t2)
            e2 += n3.w * n3.h, r2 = Math.max(r2, n3.w);
          t2.sort((t3, e3) => e3.h - t3.h);
          const n2 = [{ x: 0, y: 0, w: Math.max(Math.ceil(Math.sqrt(e2 / 0.95)), r2), h: 1 / 0 }];
          let i2 = 0, s2 = 0;
          for (const e3 of t2)
            for (let t3 = n2.length - 1; t3 >= 0; t3--) {
              const r3 = n2[t3];
              if (!(e3.w > r3.w || e3.h > r3.h)) {
                if (e3.x = r3.x, e3.y = r3.y, s2 = Math.max(s2, e3.y + e3.h), i2 = Math.max(i2, e3.x + e3.w), e3.w === r3.w && e3.h === r3.h) {
                  const e4 = n2.pop();
                  t3 < n2.length && (n2[t3] = e4);
                } else
                  e3.h === r3.h ? (r3.x += e3.w, r3.w -= e3.w) : e3.w === r3.w ? (r3.y += e3.h, r3.h -= e3.h) : (n2.push({ x: r3.x + e3.w, y: r3.y, w: r3.w - e3.w, h: e3.h }), r3.y += e3.h, r3.h -= e3.h);
                break;
              }
            }
          return { w: i2, h: s2, fill: e2 / (i2 * s2) || 0 };
        }
        So(wy, "Anchor");
        const By = 1;
        class Dy {
          constructor(t2, { pixelRatio: e2, version: r2, stretchX: n2, stretchY: i2, content: s2 }) {
            this.paddedRect = t2, this.pixelRatio = e2, this.stretchX = n2, this.stretchY = i2, this.content = s2, this.version = r2;
          }
          get tl() {
            return [this.paddedRect.x + By, this.paddedRect.y + By];
          }
          get br() {
            return [this.paddedRect.x + this.paddedRect.w - By, this.paddedRect.y + this.paddedRect.h - By];
          }
          get displaySize() {
            return [(this.paddedRect.w - 2 * By) / this.pixelRatio, (this.paddedRect.h - 2 * By) / this.pixelRatio];
          }
        }
        class Ry {
          constructor(t2, e2, r2) {
            const n2 = {}, i2 = {};
            this.haveRenderCallbacks = [];
            const s2 = [];
            this.addImages(t2, n2, s2), this.addImages(e2, i2, s2);
            const { w: a2, h: o2 } = Ey(s2), l2 = new gp({ width: a2 || 1, height: o2 || 1 });
            for (const e3 in t2) {
              const i3 = t2[e3], s3 = n2[e3].paddedRect;
              gp.copy(i3.data, l2, { x: 0, y: 0 }, { x: s3.x + By, y: s3.y + By }, i3.data, r2, i3.sdf);
            }
            for (const t3 in e2) {
              const n3 = e2[t3], s3 = i2[t3].paddedRect, a3 = s3.x + By, o3 = s3.y + By, u2 = n3.data.width, c2 = n3.data.height;
              gp.copy(n3.data, l2, { x: 0, y: 0 }, { x: a3, y: o3 }, n3.data, r2), gp.copy(n3.data, l2, { x: 0, y: c2 - 1 }, { x: a3, y: o3 - 1 }, { width: u2, height: 1 }, r2), gp.copy(n3.data, l2, { x: 0, y: 0 }, { x: a3, y: o3 + c2 }, { width: u2, height: 1 }, r2), gp.copy(n3.data, l2, { x: u2 - 1, y: 0 }, { x: a3 - 1, y: o3 }, { width: 1, height: c2 }, r2), gp.copy(n3.data, l2, { x: 0, y: 0 }, { x: a3 + u2, y: o3 }, { width: 1, height: c2 }, r2);
            }
            this.image = l2, this.iconPositions = n2, this.patternPositions = i2;
          }
          addImages(t2, e2, r2) {
            for (const n2 in t2) {
              const i2 = t2[n2], s2 = { x: 0, y: 0, w: i2.data.width + 2 * By, h: i2.data.height + 2 * By };
              r2.push(s2), e2[n2] = new Dy(s2, i2), i2.hasRenderCallback && this.haveRenderCallbacks.push(n2);
            }
          }
          patchUpdatedImages(t2, e2, r2) {
            this.haveRenderCallbacks = this.haveRenderCallbacks.filter((e3) => t2.hasImage(e3, r2)), t2.dispatchRenderCallbacks(this.haveRenderCallbacks, r2);
            for (const n2 in t2.getUpdatedImages(r2))
              this.patchUpdatedImage(this.iconPositions[n2], t2.getImage(n2, r2), e2), this.patchUpdatedImage(this.patternPositions[n2], t2.getImage(n2, r2), e2);
          }
          patchUpdatedImage(t2, e2, r2) {
            if (!t2 || !e2)
              return;
            if (t2.version === e2.version)
              return;
            t2.version = e2.version;
            const [n2, i2] = t2.tl, s2 = !!Object.keys(this.patternPositions).length;
            r2.update(e2.data, { useMipmap: s2 }, { x: n2, y: i2 });
          }
        }
        So(Dy, "ImagePosition"), So(Ry, "ImageAtlas");
        const Cy = 1e20;
        function Ly(t2, e2, r2, n2, i2, s2, a2, o2, l2) {
          for (let u2 = e2; u2 < e2 + n2; u2++)
            Vy(t2, r2 * s2 + u2, s2, i2, a2, o2, l2);
          for (let u2 = r2; u2 < r2 + i2; u2++)
            Vy(t2, u2 * s2 + e2, 1, n2, a2, o2, l2);
        }
        function Vy(t2, e2, r2, n2, i2, s2, a2) {
          s2[0] = 0, a2[0] = -Cy, a2[1] = Cy, i2[0] = t2[e2];
          for (let o2 = 1, l2 = 0, u2 = 0; o2 < n2; o2++) {
            i2[o2] = t2[e2 + o2 * r2];
            const n3 = o2 * o2;
            do {
              const t3 = s2[l2];
              u2 = (i2[o2] - i2[t3] + n3 - t3 * t3) / (o2 - t3) / 2;
            } while (u2 <= a2[l2] && --l2 > -1);
            l2++, s2[l2] = o2, a2[l2] = u2, a2[l2 + 1] = Cy;
          }
          for (let o2 = 0, l2 = 0; o2 < n2; o2++) {
            for (; a2[l2 + 1] < o2; )
              l2++;
            const n3 = s2[l2], u2 = o2 - n3;
            t2[e2 + o2 * r2] = i2[n3] + u2 * u2;
          }
        }
        const Fy = 2, Oy = { none: 0, ideographs: 1, all: 2 };
        class Uy {
          constructor(t2, e2, r2) {
            this.requestManager = t2, this.localGlyphMode = e2, this.localFontFamily = r2, this.urls = {}, this.entries = {}, this.localGlyphs = { 200: {}, 400: {}, 500: {}, 900: {} };
          }
          setURL(t2, e2) {
            this.urls[e2] = t2;
          }
          getGlyphs(t2, e2, r2) {
            const i2 = [], s2 = this.urls[e2] || n.GLYPHS_URL;
            for (const e3 in t2)
              for (const r3 of t2[e3])
                i2.push({ stack: e3, id: r3 });
            tr(i2, ({ stack: t3, id: e3 }, r3) => {
              let n2 = this.entries[t3];
              n2 || (n2 = this.entries[t3] = { glyphs: {}, requests: {}, ranges: {}, ascender: void 0, descender: void 0 });
              let i3 = n2.glyphs[e3];
              if (void 0 !== i3)
                return void r3(null, { stack: t3, id: e3, glyph: i3 });
              if (i3 = this._tinySDF(n2, t3, e3), i3)
                return n2.glyphs[e3] = i3, void r3(null, { stack: t3, id: e3, glyph: i3 });
              const a2 = Math.floor(e3 / 256);
              if (256 * a2 > 65535)
                return void r3(new Error("glyphs > 65535 not supported"));
              if (n2.ranges[a2])
                return void r3(null, { stack: t3, id: e3, glyph: i3 });
              let o2 = n2.requests[a2];
              o2 || (o2 = n2.requests[a2] = [], Uy.loadGlyphRange(t3, a2, s2, this.requestManager, (t4, e4) => {
                if (e4) {
                  n2.ascender = e4.ascender, n2.descender = e4.descender;
                  for (const t5 in e4.glyphs)
                    this._doesCharSupportLocalGlyph(+t5) || (n2.glyphs[+t5] = e4.glyphs[+t5]);
                  n2.ranges[a2] = true;
                }
                for (const r4 of o2)
                  r4(t4, e4);
                delete n2.requests[a2];
              })), o2.push((n3, i4) => {
                n3 ? r3(n3) : i4 && r3(null, { stack: t3, id: e3, glyph: i4.glyphs[e3] || null });
              });
            }, (t3, e3) => {
              if (t3)
                r2(t3);
              else if (e3) {
                const t4 = {};
                for (const { stack: r3, id: n2, glyph: i3 } of e3)
                  void 0 === t4[r3] && (t4[r3] = {}), void 0 === t4[r3].glyphs && (t4[r3].glyphs = {}), t4[r3].glyphs[n2] = i3 && { id: i3.id, bitmap: i3.bitmap.clone(), metrics: i3.metrics }, t4[r3].ascender = this.entries[r3].ascender, t4[r3].descender = this.entries[r3].descender;
                r2(null, t4);
              }
            });
          }
          _doesCharSupportLocalGlyph(t2) {
            return this.localGlyphMode !== Oy.none && (this.localGlyphMode === Oy.all ? !!this.localFontFamily : !!this.localFontFamily && (zo["CJK Unified Ideographs"](t2) || zo["Hangul Syllables"](t2) || zo.Hiragana(t2) || zo.Katakana(t2) || zo["CJK Symbols and Punctuation"](t2) || zo["CJK Unified Ideographs Extension A"](t2) || zo["CJK Unified Ideographs Extension B"](t2)));
          }
          _tinySDF(t2, e2, r2) {
            const n2 = this.localFontFamily;
            if (!n2 || !this._doesCharSupportLocalGlyph(r2))
              return;
            let i2 = t2.tinySDF;
            if (!i2) {
              let r3 = "400";
              /bold/i.test(e2) ? r3 = "900" : /medium/i.test(e2) ? r3 = "500" : /light/i.test(e2) && (r3 = "200"), i2 = t2.tinySDF = new Uy.TinySDF({ fontFamily: n2, fontWeight: r3, fontSize: 24 * Fy, buffer: 3 * Fy, radius: 8 * Fy }), i2.fontWeight = r3;
            }
            if (this.localGlyphs[i2.fontWeight][r2])
              return this.localGlyphs[i2.fontWeight][r2];
            const s2 = String.fromCodePoint(r2), { data: a2, width: o2, height: l2, glyphWidth: u2, glyphHeight: c2, glyphLeft: h2, glyphTop: p2, glyphAdvance: f2 } = i2.draw(s2);
            return this.localGlyphs[i2.fontWeight][r2] = { id: r2, bitmap: new yp({ width: o2, height: l2 }, a2), metrics: { width: u2 / Fy, height: c2 / Fy, left: h2 / Fy, top: p2 / Fy - 27, advance: f2 / Fy, localGlyph: true } };
          }
        }
        Uy.loadGlyphRange = function(t2, e2, r2, n2, i2) {
          const s2 = 256 * e2, a2 = s2 + 255, o2 = n2.transformRequest(n2.normalizeGlyphsURL(r2).replace("{fontstack}", t2).replace("{range}", `${s2}-${a2}`), Qr.Glyphs);
          nn(o2, (t3, e3) => {
            if (t3)
              i2(t3);
            else if (e3) {
              const t4 = {}, r3 = function(t5) {
                return new Om(t5).readFields(ny, {});
              }(e3);
              for (const e4 of r3.glyphs)
                t4[e4.id] = e4;
              i2(null, { glyphs: t4, ascender: r3.ascender, descender: r3.descender });
            }
          });
        }, Uy.TinySDF = class {
          constructor({ fontSize: t2 = 24, buffer: e2 = 3, radius: r2 = 8, cutoff: n2 = 0.25, fontFamily: i2 = "sans-serif", fontWeight: s2 = "normal", fontStyle: a2 = "normal" } = {}) {
            this.buffer = e2, this.cutoff = n2, this.radius = r2;
            const o2 = this.size = t2 + 4 * e2, l2 = this._createCanvas(o2), u2 = this.ctx = l2.getContext("2d", { willReadFrequently: true });
            u2.font = `${a2} ${s2} ${t2}px ${i2}`, u2.textBaseline = "alphabetic", u2.textAlign = "left", u2.fillStyle = "black", this.gridOuter = new Float64Array(o2 * o2), this.gridInner = new Float64Array(o2 * o2), this.f = new Float64Array(o2), this.z = new Float64Array(o2 + 1), this.v = new Uint16Array(o2);
          }
          _createCanvas(t2) {
            const e2 = document.createElement("canvas");
            return e2.width = e2.height = t2, e2;
          }
          draw(t2) {
            const { width: e2, actualBoundingBoxAscent: r2, actualBoundingBoxDescent: n2, actualBoundingBoxLeft: i2, actualBoundingBoxRight: s2 } = this.ctx.measureText(t2), a2 = Math.ceil(r2), o2 = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(s2 - i2))), l2 = Math.min(this.size - this.buffer, a2 + Math.ceil(n2)), u2 = o2 + 2 * this.buffer, c2 = l2 + 2 * this.buffer, h2 = Math.max(u2 * c2, 0), p2 = new Uint8ClampedArray(h2), f2 = { data: p2, width: u2, height: c2, glyphWidth: o2, glyphHeight: l2, glyphTop: a2, glyphLeft: 0, glyphAdvance: e2 };
            if (0 === o2 || 0 === l2)
              return f2;
            const { ctx: d2, buffer: m2, gridInner: y2, gridOuter: g2 } = this;
            d2.clearRect(m2, m2, o2, l2), d2.fillText(t2, m2, m2 + a2);
            const x2 = d2.getImageData(m2, m2, o2, l2);
            g2.fill(Cy, 0, h2), y2.fill(0, 0, h2);
            for (let t3 = 0; t3 < l2; t3++)
              for (let e3 = 0; e3 < o2; e3++) {
                const r3 = x2.data[4 * (t3 * o2 + e3) + 3] / 255;
                if (0 === r3)
                  continue;
                const n3 = (t3 + m2) * u2 + e3 + m2;
                if (1 === r3)
                  g2[n3] = 0, y2[n3] = Cy;
                else {
                  const t4 = 0.5 - r3;
                  g2[n3] = t4 > 0 ? t4 * t4 : 0, y2[n3] = t4 < 0 ? t4 * t4 : 0;
                }
              }
            Ly(g2, 0, 0, u2, c2, u2, this.f, this.v, this.z), Ly(y2, m2, m2, o2, l2, u2, this.f, this.v, this.z);
            for (let t3 = 0; t3 < h2; t3++) {
              const e3 = Math.sqrt(g2[t3]) - Math.sqrt(y2[t3]);
              p2[t3] = Math.round(255 - 255 * (e3 / this.radius + this.cutoff));
            }
            return f2;
          }
        };
        const jy = By;
        function Ny(t2, e2, r2, n2) {
          const i2 = [], s2 = t2.imagePrimary, a2 = s2.pixelRatio, o2 = s2.paddedRect.w - 2 * jy, l2 = s2.paddedRect.h - 2 * jy, u2 = t2.right - t2.left, c2 = t2.bottom - t2.top, h2 = s2.stretchX || [[0, o2]], p2 = s2.stretchY || [[0, l2]], f2 = (t3, e3) => t3 + e3[1] - e3[0], d2 = h2.reduce(f2, 0), m2 = p2.reduce(f2, 0), y2 = o2 - d2, g2 = l2 - m2;
          let x2 = 0, b2 = d2, v2 = 0, _2 = m2, w2 = 0, M2 = y2, A2 = 0, S2 = g2;
          if (s2.content && n2) {
            const t3 = s2.content;
            x2 = $y(h2, 0, t3[0]), v2 = $y(p2, 0, t3[1]), b2 = $y(h2, t3[0], t3[2]), _2 = $y(p2, t3[1], t3[3]), w2 = t3[0] - x2, A2 = t3[1] - v2, M2 = t3[2] - t3[0] - b2, S2 = t3[3] - t3[1] - _2;
          }
          const I2 = (n3, i3, o3, l3) => {
            const h3 = Gy(n3.stretch - x2, b2, u2, t2.left), p3 = Xy(n3.fixed - w2, M2, n3.stretch, d2), f3 = Gy(i3.stretch - v2, _2, c2, t2.top), y3 = Xy(i3.fixed - A2, S2, i3.stretch, m2), g3 = Gy(o3.stretch - x2, b2, u2, t2.left), I3 = Xy(o3.fixed - w2, M2, o3.stretch, d2), T2 = Gy(l3.stretch - v2, _2, c2, t2.top), k2 = Xy(l3.fixed - A2, S2, l3.stretch, m2), P2 = new je(h3, f3), z2 = new je(g3, f3), E2 = new je(g3, T2), B2 = new je(h3, T2), D2 = new je(p3 / a2, y3 / a2), R2 = new je(I3 / a2, k2 / a2), C2 = e2 * Math.PI / 180;
            if (C2) {
              const t3 = Math.sin(C2), e3 = Math.cos(C2), r3 = [e3, -t3, t3, e3];
              P2._matMult(r3), z2._matMult(r3), B2._matMult(r3), E2._matMult(r3);
            }
            const L2 = n3.stretch + n3.fixed, V2 = o3.stretch + o3.fixed, F2 = i3.stretch + i3.fixed, O2 = l3.stretch + l3.fixed, U2 = t2.imageSecondary;
            return { tl: P2, tr: z2, bl: B2, br: E2, texPrimary: { x: s2.paddedRect.x + jy + L2, y: s2.paddedRect.y + jy + F2, w: V2 - L2, h: O2 - F2 }, texSecondary: U2 ? { x: U2.paddedRect.x + jy + L2, y: U2.paddedRect.y + jy + F2, w: V2 - L2, h: O2 - F2 } : void 0, writingMode: void 0, glyphOffset: [0, 0], sectionIndex: 0, pixelOffsetTL: D2, pixelOffsetBR: R2, minFontScaleX: M2 / a2 / u2, minFontScaleY: S2 / a2 / c2, isSDF: r2 };
          };
          if (n2 && (s2.stretchX || s2.stretchY)) {
            const t3 = qy(h2, y2, d2), e3 = qy(p2, g2, m2);
            for (let r3 = 0; r3 < t3.length - 1; r3++) {
              const n3 = t3[r3], s3 = t3[r3 + 1];
              for (let t4 = 0; t4 < e3.length - 1; t4++)
                i2.push(I2(n3, e3[t4], s3, e3[t4 + 1]));
            }
          } else
            i2.push(I2({ fixed: 0, stretch: -1 }, { fixed: 0, stretch: -1 }, { fixed: 0, stretch: o2 + 1 }, { fixed: 0, stretch: l2 + 1 }));
          return i2;
        }
        function $y(t2, e2, r2) {
          let n2 = 0;
          for (const i2 of t2)
            n2 += Math.max(e2, Math.min(r2, i2[1])) - Math.max(e2, Math.min(r2, i2[0]));
          return n2;
        }
        function qy(t2, e2, r2) {
          const n2 = [{ fixed: -jy, stretch: 0 }];
          for (const [e3, r3] of t2) {
            const t3 = n2[n2.length - 1];
            n2.push({ fixed: e3 - t3.stretch, stretch: t3.stretch }), n2.push({ fixed: e3 - t3.stretch, stretch: t3.stretch + (r3 - e3) });
          }
          return n2.push({ fixed: e2 + jy, stretch: r2 }), n2;
        }
        function Gy(t2, e2, r2, n2) {
          return t2 / e2 * r2 + n2;
        }
        function Xy(t2, e2, r2, n2) {
          return t2 - e2 * r2 / n2;
        }
        function Yy(t2, e2, r2, n2) {
          const i2 = e2 + t2.positionedLines[n2].lineOffset;
          return 0 === n2 ? r2 + i2 / 2 : r2 + (i2 + (e2 + t2.positionedLines[n2 - 1].lineOffset)) / 2;
        }
        function Zy(t2, e2 = 1, r2 = false) {
          let n2 = 1 / 0, i2 = 1 / 0, s2 = -1 / 0, a2 = -1 / 0;
          const o2 = t2[0];
          for (let t3 = 0; t3 < o2.length; t3++) {
            const e3 = o2[t3];
            (!t3 || e3.x < n2) && (n2 = e3.x), (!t3 || e3.y < i2) && (i2 = e3.y), (!t3 || e3.x > s2) && (s2 = e3.x), (!t3 || e3.y > a2) && (a2 = e3.y);
          }
          const l2 = Math.min(s2 - n2, a2 - i2);
          let u2 = l2 / 2;
          const c2 = new fs([], Hy);
          if (0 === l2)
            return new je(n2, i2);
          for (let e3 = n2; e3 < s2; e3 += l2)
            for (let r3 = i2; r3 < a2; r3 += l2)
              c2.push(new Ky(e3 + u2, r3 + u2, u2, t2));
          let h2 = function(t3) {
            let e3 = 0, r3 = 0, n3 = 0;
            const i3 = t3[0];
            for (let t4 = 0, s3 = i3.length, a3 = s3 - 1; t4 < s3; a3 = t4++) {
              const s4 = i3[t4], o3 = i3[a3], l3 = s4.x * o3.y - o3.x * s4.y;
              r3 += (s4.x + o3.x) * l3, n3 += (s4.y + o3.y) * l3, e3 += 3 * l3;
            }
            return new Ky(r3 / e3, n3 / e3, 0, t3);
          }(t2), p2 = c2.length;
          for (; c2.length; ) {
            const n3 = c2.pop();
            (n3.d > h2.d || !h2.d) && (h2 = n3, r2 && console.log("found best %d after %d probes", Math.round(1e4 * n3.d) / 1e4, p2)), n3.max - h2.d <= e2 || (u2 = n3.h / 2, c2.push(new Ky(n3.p.x - u2, n3.p.y - u2, u2, t2)), c2.push(new Ky(n3.p.x + u2, n3.p.y - u2, u2, t2)), c2.push(new Ky(n3.p.x - u2, n3.p.y + u2, u2, t2)), c2.push(new Ky(n3.p.x + u2, n3.p.y + u2, u2, t2)), p2 += 4);
          }
          return r2 && (console.log(`num probes: ${p2}`), console.log(`best distance: ${h2.d}`)), h2.p;
        }
        function Hy(t2, e2) {
          return e2.max - t2.max;
        }
        class Ky {
          constructor(t2, e2, r2, n2) {
            this.p = new je(t2, e2), this.h = r2, this.d = function(t3, e3) {
              let r3 = false, n3 = 1 / 0;
              for (let i2 = 0; i2 < e3.length; i2++) {
                const s2 = e3[i2];
                for (let e4 = 0, i3 = s2.length, a2 = i3 - 1; e4 < i3; a2 = e4++) {
                  const i4 = s2[e4], o2 = s2[a2];
                  i4.y > t3.y != o2.y > t3.y && t3.x < (o2.x - i4.x) * (t3.y - i4.y) / (o2.y - i4.y) + i4.x && (r3 = !r3), n3 = Math.min(n3, lh(t3, i4, o2));
                }
              }
              return (r3 ? 1 : -1) * Math.sqrt(n3);
            }(this.p, n2), this.max = this.d + this.h * Math.SQRT2;
          }
        }
        const Wy = Number.POSITIVE_INFINITY, Jy = Math.sqrt(2);
        function Qy(t2, [e2, r2]) {
          let n2 = 0, i2 = 0;
          if (r2 === Wy) {
            e2 < 0 && (e2 = 0);
            const r3 = e2 / Jy;
            switch (t2) {
              case "top-right":
              case "top-left":
                i2 = r3 - 7;
                break;
              case "bottom-right":
              case "bottom-left":
                i2 = 7 - r3;
                break;
              case "bottom":
                i2 = 7 - e2;
                break;
              case "top":
                i2 = e2 - 7;
            }
            switch (t2) {
              case "top-right":
              case "bottom-right":
                n2 = -r3;
                break;
              case "top-left":
              case "bottom-left":
                n2 = r3;
                break;
              case "left":
                n2 = e2;
                break;
              case "right":
                n2 = -e2;
            }
          } else {
            switch (e2 = Math.abs(e2), r2 = Math.abs(r2), t2) {
              case "top-right":
              case "top-left":
              case "top":
                i2 = r2 - 7;
                break;
              case "bottom-right":
              case "bottom-left":
              case "bottom":
                i2 = 7 - r2;
            }
            switch (t2) {
              case "top-right":
              case "bottom-right":
              case "right":
                n2 = -e2;
                break;
              case "top-left":
              case "bottom-left":
              case "left":
                n2 = e2;
            }
          }
          return [n2, i2];
        }
        function tg(t2) {
          switch (t2) {
            case "right":
            case "top-right":
            case "bottom-right":
              return "right";
            case "left":
            case "top-left":
            case "bottom-left":
              return "left";
          }
          return "center";
        }
        function eg(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2) {
          let m2 = s2.textMaxSize.evaluate(e2, {}, h2);
          void 0 === m2 && (m2 = a2);
          const y2 = t2.layers[0].layout, g2 = y2.get("icon-offset").evaluate(e2, {}, h2), x2 = sg(r2.horizontal) || r2.vertical, b2 = "globe" === p2.name, v2 = Xm, _2 = a2 / v2, w2 = t2.tilePixelRatio * m2 / v2, M2 = (E2 = t2.overscaling, t2.zoom > 18 && E2 > 2 && (E2 >>= 1), Math.max(ds / (512 * E2), 1) * y2.get("symbol-spacing")), A2 = y2.get("text-padding") * t2.tilePixelRatio, S2 = y2.get("icon-padding") * t2.tilePixelRatio, I2 = Ge(y2.get("text-max-angle")), T2 = "map" === y2.get("text-rotation-alignment") && "point" !== y2.get("symbol-placement"), k2 = "map" === y2.get("icon-rotation-alignment") && "point" !== y2.get("symbol-placement"), P2 = y2.get("symbol-placement"), z2 = M2 / 2;
          var E2;
          const B2 = y2.get("icon-text-fit").evaluate(e2, {}, h2), D2 = y2.get("icon-text-fit-padding").evaluate(e2, {}, h2), R2 = "none" !== B2;
          let C2;
          false === t2.hasAnyIconTextFit && R2 && (t2.hasAnyIconTextFit = true), n2 && R2 && (t2.allowVerticalPlacement && r2.vertical && (C2 = _y(n2, r2.vertical, B2, D2, g2, _2)), x2 && (n2 = _y(n2, x2, B2, D2, g2, _2)));
          const L2 = (a3, o3, m3) => {
            if (o3.x < 0 || o3.x >= ds || o3.y < 0 || o3.y >= ds)
              return;
            let y3 = null;
            if (b2) {
              const { x: t3, y: e3, z: r3 } = p2.projectTilePoint(o3.x, o3.y, m3);
              y3 = { anchor: new wy(t3, e3, r3, 0, void 0), up: p2.upVector(m3, o3.x, o3.y) };
            }
            !function(t3, e3, r3, n3, i3, s3, a4, o4, l3, u3, c3, h3, p3, f3, d3, m4, y4, g3, x3, b3, v3, _3, w3, M3, A3, S3, I3) {
              const T3 = t3.addToLineVertexArray(e3, n3);
              let k3, P3, z3, E3, B3, D3, R3, C3 = 0, L3 = 0, V2 = 0, F2 = 0, O2 = -1, U2 = -1;
              const j2 = {};
              let N2 = Rn("");
              const $2 = r3 ? r3.anchor : e3, q2 = "none" !== l3.layout.get("icon-text-fit").evaluate(v3, {}, A3);
              let G2 = 0, X2 = 0;
              if (void 0 === l3._unevaluatedLayout.getValue("text-radial-offset") ? [G2, X2] = l3.layout.get("text-offset").evaluate(v3, {}, A3).map((t4) => t4 * Xm) : (G2 = l3.layout.get("text-radial-offset").evaluate(v3, {}, A3) * Xm, X2 = Wy), t3.allowVerticalPlacement && i3.vertical) {
                const t4 = i3.vertical;
                if (d3)
                  D3 = og(t4), o4 && (R3 = og(o4));
                else {
                  const r4 = l3.layout.get("text-rotate").evaluate(v3, {}, A3) + 90;
                  z3 = ag(u3, $2, e3, c3, h3, p3, t4, f3, r4, m4), o4 && (E3 = ag(u3, $2, e3, c3, h3, p3, o4, g3, r4));
                }
              }
              if (s3) {
                const n4 = l3.layout.get("icon-rotate").evaluate(v3, {}, A3), i4 = Ny(s3, n4, w3, q2), a5 = o4 ? Ny(o4, n4, w3, q2) : void 0;
                P3 = ag(u3, $2, e3, c3, h3, p3, s3, g3, n4), C3 = 4 * i4.length;
                const f4 = t3.iconSizeData;
                let d4 = null;
                "source" === f4.kind ? (d4 = [Ym * l3.layout.get("icon-size").evaluate(v3, {}, A3)], d4[0] > ng && dr(`${t3.layerIds[0]}: Value for "icon-size" is >= ${rg}. Reduce your "icon-size".`)) : "composite" === f4.kind && (d4 = [Ym * _3.compositeIconSizes[0].evaluate(v3, {}, A3), Ym * _3.compositeIconSizes[1].evaluate(v3, {}, A3)], (d4[0] > ng || d4[1] > ng) && dr(`${t3.layerIds[0]}: Value for "icon-size" is >= ${rg}. Reduce your "icon-size".`)), t3.addSymbols(t3.icon, i4, d4, b3, x3, v3, false, r3, e3, T3.lineStartIndex, T3.lineLength, -1, M3, A3, S3, I3), O2 = t3.icon.placedSymbolArray.length - 1, a5 && (L3 = 4 * a5.length, t3.addSymbols(t3.icon, a5, d4, b3, x3, v3, oy.vertical, r3, e3, T3.lineStartIndex, T3.lineLength, -1, M3, A3, S3, I3), U2 = t3.icon.placedSymbolArray.length - 1);
              }
              for (const n4 in i3.horizontal) {
                const s4 = i3.horizontal[n4];
                k3 || (N2 = Rn(s4.text), d3 ? B3 = og(s4) : k3 = ag(u3, $2, e3, c3, h3, p3, s4, f3, l3.layout.get("text-rotate").evaluate(v3, {}, A3), m4));
                const o5 = 1 === s4.positionedLines.length;
                if (V2 += ig(t3, r3, e3, s4, a4, l3, d3, v3, m4, T3, i3.vertical ? oy.horizontal : oy.horizontalOnly, o5 ? Object.keys(i3.horizontal) : [n4], j2, O2, _3, M3, A3, S3), o5)
                  break;
              }
              i3.vertical && (F2 += ig(t3, r3, e3, i3.vertical, a4, l3, d3, v3, m4, T3, oy.vertical, ["vertical"], j2, U2, _3, M3, A3, S3));
              let Y2 = -1;
              const Z2 = (t4, e4) => t4 ? Math.max(t4, e4) : e4;
              Y2 = Z2(B3, Y2), Y2 = Z2(D3, Y2), Y2 = Z2(R3, Y2);
              const H2 = Y2 > -1 ? 1 : 0;
              t3.glyphOffsetArray.length >= 65535 && dr("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== v3.sortKey && t3.addToSortKeyRanges(t3.symbolInstances.length, v3.sortKey), t3.symbolInstances.emplaceBack(e3.x, e3.y, $2.x, $2.y, $2.z, j2.right >= 0 ? j2.right : -1, j2.center >= 0 ? j2.center : -1, j2.left >= 0 ? j2.left : -1, j2.vertical >= 0 ? j2.vertical : -1, O2, U2, N2, void 0 !== k3 ? k3 : t3.collisionBoxArray.length, void 0 !== k3 ? k3 + 1 : t3.collisionBoxArray.length, void 0 !== z3 ? z3 : t3.collisionBoxArray.length, void 0 !== z3 ? z3 + 1 : t3.collisionBoxArray.length, void 0 !== P3 ? P3 : t3.collisionBoxArray.length, void 0 !== P3 ? P3 + 1 : t3.collisionBoxArray.length, E3 || t3.collisionBoxArray.length, E3 ? E3 + 1 : t3.collisionBoxArray.length, c3, V2, F2, C3, L3, H2, 0, G2, X2, Y2, 0, q2 ? 1 : 0);
            }(t2, o3, y3, a3, r2, n2, i2, C2, t2.layers[0], t2.collisionBoxArray, e2.index, e2.sourceLayerIndex, t2.index, A2, T2, l2, 0, S2, k2, g2, e2, s2, u2, c2, h2, f2, d2);
          };
          if ("line" === P2)
            for (const i3 of zy(e2.geometry, 0, 0, ds, ds)) {
              const e3 = ky(i3, M2, I2, r2.vertical || x2, n2, v2, w2, t2.overscaling, ds);
              for (const r3 of e3)
                x2 && lg(t2, x2.text, z2, r3) || L2(i3, r3, h2);
            }
          else if ("line-center" === P2) {
            for (const t3 of e2.geometry)
              if (t3.length > 1) {
                const e3 = Ty(t3, I2, r2.vertical || x2, n2, v2, w2);
                e3 && L2(t3, e3, h2);
              }
          } else if ("Polygon" === e2.type)
            for (const t3 of Wp(e2.geometry, 0)) {
              const e3 = Zy(t3, 16);
              L2(t3[0], new wy(e3.x, e3.y, 0, 0, void 0), h2);
            }
          else if ("LineString" === e2.type)
            for (const t3 of e2.geometry)
              L2(t3, new wy(t3[0].x, t3[0].y, 0, 0, void 0), h2);
          else if ("Point" === e2.type)
            for (const t3 of e2.geometry)
              for (const e3 of t3)
                L2([e3], new wy(e3.x, e3.y, 0, 0, void 0), h2);
        }
        const rg = 255, ng = rg * Ym;
        function ig(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2, y2, g2) {
          const x2 = function(t3, e3, r3, n3, i3, s3, a3, o3) {
            const l3 = [];
            if (0 === e3.positionedLines.length)
              return l3;
            const u3 = n3.layout.get("text-rotate").evaluate(s3, {}) * Math.PI / 180, c3 = function(t4) {
              const e4 = t4[0], r4 = t4[1], n4 = e4 * r4;
              return n4 > 0 ? [e4, -r4] : n4 < 0 ? [-e4, r4] : 0 === e4 ? [r4, e4] : [r4, -e4];
            }(r3);
            let h3 = Math.abs(e3.top - e3.bottom);
            for (const t4 of e3.positionedLines)
              h3 -= t4.lineOffset;
            const p3 = e3.positionedLines.length, f3 = h3 / p3;
            let d3 = e3.top - r3[1];
            for (let t4 = 0; t4 < p3; ++t4) {
              const n4 = e3.positionedLines[t4];
              d3 = Yy(e3, f3, d3, t4);
              for (const t5 of n4.positionedGlyphs) {
                if (!t5.rect)
                  continue;
                const n5 = t5.rect || {};
                let s4 = ay + 1, h4 = true, p4 = 1, f4 = 0;
                if (t5.imageName) {
                  const e4 = a3[t5.imageName];
                  if (!e4)
                    continue;
                  if (e4.sdf) {
                    dr("SDF images are not supported in formatted text and will be ignored.");
                    continue;
                  }
                  h4 = false, p4 = e4.pixelRatio, s4 = By / p4;
                }
                const m3 = (i3 || o3) && t5.vertical, y3 = t5.metrics.advance * t5.scale / 2, g3 = t5.metrics, x3 = t5.rect;
                if (null === x3)
                  continue;
                o3 && e3.verticalizable && (f4 = t5.imageName ? y3 - t5.metrics.width * t5.scale / 2 : 0);
                const b3 = i3 ? [t5.x + y3, t5.y] : [0, 0];
                let v3 = [0, 0], _2 = [0, 0], w2 = false;
                i3 || (m3 ? (_2 = [t5.x + y3 + c3[0], t5.y + c3[1] - f4], w2 = true) : v3 = [t5.x + y3 + r3[0], t5.y + r3[1] - f4]);
                const M2 = x3.w * t5.scale / (p4 * (t5.localGlyph ? Fy : 1)), A2 = x3.h * t5.scale / (p4 * (t5.localGlyph ? Fy : 1));
                let S2, I2, T2, k2;
                if (m3) {
                  const e4 = t5.y - d3, r4 = new je(-y3, y3 - e4), n6 = -Math.PI / 2, i4 = new je(..._2);
                  S2 = new je(-y3 + v3[0], v3[1]), S2._rotateAround(n6, r4)._add(i4), S2.x += -e4 + y3, S2.y -= (g3.left - s4) * t5.scale;
                  const a4 = t5.imageName ? g3.advance * t5.scale : Xm * t5.scale, o4 = String.fromCodePoint(t5.glyph);
                  ty(o4) ? S2.x += (1 - s4) * t5.scale : ey(o4) ? S2.x += a4 - g3.height * t5.scale + (-s4 - 1) * t5.scale : S2.x += t5.imageName || g3.width + 2 * s4 === x3.w && g3.height + 2 * s4 === x3.h ? (a4 - A2) / 2 : (a4 - (g3.height + 2 * s4) * t5.scale) / 2, I2 = new je(S2.x, S2.y - M2), T2 = new je(S2.x + A2, S2.y), k2 = new je(S2.x + A2, S2.y - M2);
                } else {
                  const e4 = (g3.left - s4) * t5.scale - y3 + v3[0], r4 = (-g3.top - s4) * t5.scale + v3[1], n6 = e4 + M2, i4 = r4 + A2;
                  S2 = new je(e4, r4), I2 = new je(n6, r4), T2 = new je(e4, i4), k2 = new je(n6, i4);
                }
                if (u3) {
                  let t6;
                  t6 = i3 ? new je(0, 0) : w2 ? new je(c3[0], c3[1]) : new je(r3[0], r3[1]), S2._rotateAround(u3, t6), I2._rotateAround(u3, t6), T2._rotateAround(u3, t6), k2._rotateAround(u3, t6);
                }
                const P2 = new je(0, 0), z2 = new je(0, 0);
                l3.push({ tl: S2, tr: I2, bl: T2, br: k2, texPrimary: n5, texSecondary: void 0, writingMode: e3.writingMode, glyphOffset: b3, sectionIndex: t5.sectionIndex, isSDF: h4, pixelOffsetTL: P2, pixelOffsetBR: z2, minFontScaleX: 0, minFontScaleY: 0 });
              }
            }
            return l3;
          }(0, n2, l2, s2, a2, o2, i2, t2.allowVerticalPlacement), b2 = t2.textSizeData;
          let v2 = null;
          "source" === b2.kind ? (v2 = [Ym * s2.layout.get("text-size").evaluate(o2, {}, y2)], v2[0] > ng && dr(`${t2.layerIds[0]}: Value for "text-size" is >= ${rg}. Reduce your "text-size".`)) : "composite" === b2.kind && (v2 = [Ym * d2.compositeTextSizes[0].evaluate(o2, {}, y2), Ym * d2.compositeTextSizes[1].evaluate(o2, {}, y2)], (v2[0] > ng || v2[1] > ng) && dr(`${t2.layerIds[0]}: Value for "text-size" is >= ${rg}. Reduce your "text-size".`)), t2.addSymbols(t2.text, x2, v2, l2, a2, o2, c2, e2, r2, u2.lineStartIndex, u2.lineLength, f2, m2, y2, g2, false);
          for (const e3 of h2)
            p2[e3] = t2.text.placedSymbolArray.length - 1;
          return 4 * x2.length;
        }
        function sg(t2) {
          for (const e2 in t2)
            return t2[e2];
          return null;
        }
        function ag(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2) {
          let c2 = a2.top, h2 = a2.bottom, p2 = a2.left, f2 = a2.right;
          const d2 = a2.collisionPadding;
          if (d2 && (p2 -= d2[0], c2 -= d2[1], f2 += d2[2], h2 += d2[3]), l2) {
            const t3 = new je(p2, c2), e3 = new je(f2, c2), r3 = new je(p2, h2), n3 = new je(f2, h2), i3 = Ge(l2);
            let s3 = new je(0, 0);
            u2 && (s3 = new je(u2[0], u2[1])), t3._rotateAround(i3, s3), e3._rotateAround(i3, s3), r3._rotateAround(i3, s3), n3._rotateAround(i3, s3), p2 = Math.min(t3.x, e3.x, r3.x, n3.x), f2 = Math.max(t3.x, e3.x, r3.x, n3.x), c2 = Math.min(t3.y, e3.y, r3.y, n3.y), h2 = Math.max(t3.y, e3.y, r3.y, n3.y);
          }
          return t2.emplaceBack(e2.x, e2.y, e2.z, r2.x, r2.y, p2, c2, f2, h2, o2, n2, i2, s2), t2.length - 1;
        }
        function og(t2) {
          t2.collisionPadding && (t2.top -= t2.collisionPadding[1], t2.bottom += t2.collisionPadding[3]);
          const e2 = t2.bottom - t2.top;
          return e2 > 0 ? Math.max(10, e2) : null;
        }
        function lg(t2, e2, r2, n2) {
          const i2 = t2.compareText;
          if (e2 in i2) {
            const t3 = i2[e2];
            for (let e3 = t3.length - 1; e3 >= 0; e3--)
              if (n2.dist(t3[e3]) < r2)
                return true;
          } else
            i2[e2] = [];
          return i2[e2].push(n2), false;
        }
        function ug(t2, e2) {
          const r2 = t2.fovAboveCenter, n2 = t2.elevation ? t2.elevation.getMinElevationBelowMSL() * e2 : 0, i2 = (t2._camera.position[2] * t2.worldSize - n2) / Math.cos(t2._pitch), s2 = Math.sin(r2) * i2 / Math.sin(Math.max(Math.PI / 2 - t2._pitch - r2, 0.01)), a2 = Math.sin(t2._pitch) * s2 + i2;
          return Math.min(1.01 * a2, i2 * (1 / t2._horizonShift));
        }
        function cg(t2, e2) {
          if (!e2.isReprojectedInTileSpace)
            return { scale: 1 << t2.z, x: t2.x, y: t2.y, x2: t2.x + 1, y2: t2.y + 1, projection: e2 };
          const r2 = Math.pow(2, -t2.z), n2 = t2.x * r2, i2 = (t2.x + 1) * r2, s2 = t2.y * r2, a2 = (t2.y + 1) * r2, o2 = Rc(n2), l2 = Rc(i2), u2 = Cc(s2), c2 = Cc(a2), h2 = e2.project(o2, u2), p2 = e2.project(l2, u2), f2 = e2.project(l2, c2), d2 = e2.project(o2, c2);
          let m2 = Math.min(h2.x, p2.x, f2.x, d2.x), y2 = Math.min(h2.y, p2.y, f2.y, d2.y), g2 = Math.max(h2.x, p2.x, f2.x, d2.x), x2 = Math.max(h2.y, p2.y, f2.y, d2.y);
          const b2 = r2 / 16;
          function v2(t3, r3, n3, i3, s3, a3) {
            const o3 = (n3 + s3) / 2, l3 = (i3 + a3) / 2, u3 = e2.project(Rc(o3), Cc(l3)), c3 = Math.max(0, m2 - u3.x, y2 - u3.y, u3.x - g2, u3.y - x2);
            m2 = Math.min(m2, u3.x), g2 = Math.max(g2, u3.x), y2 = Math.min(y2, u3.y), x2 = Math.max(x2, u3.y), c3 > b2 && (v2(t3, u3, n3, i3, o3, l3), v2(u3, r3, o3, l3, s3, a3));
          }
          v2(h2, p2, n2, s2, i2, s2), v2(p2, f2, i2, s2, i2, a2), v2(f2, d2, i2, a2, n2, a2), v2(d2, h2, n2, a2, n2, s2), m2 -= b2, y2 -= b2, g2 += b2, x2 += b2;
          const _2 = 1 / Math.max(g2 - m2, x2 - y2);
          return { scale: _2, x: m2 * _2, y: y2 * _2, x2: g2 * _2, y2: x2 * _2, projection: e2 };
        }
        function hg(t2, { x: e2, y: r2 }, n2 = 0) {
          return new je(((e2 - n2) * t2.scale - t2.x) * ds, (r2 * t2.scale - t2.y) * ds);
        }
        const pg = t.ae.identity(new Float32Array(16));
        class fg {
          constructor(t2) {
            this.spec = t2, this.name = t2.name, this.wrap = false, this.requiresDraping = false, this.supportsWorldCopies = false, this.supportsTerrain = false, this.supportsFog = false, this.supportsFreeCamera = false, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = true, this.unsupportedLayers = ["custom"], this.center = [0, 0], this.range = [3.5, 7];
          }
          project(t2, e2) {
            return { x: 0, y: 0, z: 0 };
          }
          unproject(t2, e2) {
            return new bc(0, 0);
          }
          projectTilePoint(t2, e2, r2) {
            return { x: t2, y: e2, z: 0 };
          }
          locationPoint(t2, e2, r2 = true) {
            return t2._coordinatePoint(t2.locationCoordinate(e2), r2);
          }
          pixelsPerMeter(t2, e2) {
            return Dc(1, t2) * e2;
          }
          pixelSpaceConversion(t2, e2, r2) {
            return 1;
          }
          farthestPixelDistance(t2) {
            return ug(t2, t2.pixelsPerMeter);
          }
          pointCoordinate(t2, e2, r2, n2) {
            const i2 = t2.horizonLineFromTop(false), s2 = new je(e2, Math.max(i2, r2));
            return t2.rayIntersectionCoordinate(t2.pointRayIntersection(s2, n2));
          }
          pointCoordinate3D(t2, e2, r2) {
            const n2 = new je(e2, r2);
            if (t2.elevation)
              return t2.elevation.pointCoordinate(n2);
            {
              const e3 = this.pointCoordinate(t2, n2.x, n2.y, 0);
              return [e3.x, e3.y, e3.z];
            }
          }
          isPointAboveHorizon(t2, e2) {
            if (t2.elevation && t2.elevation.visibleDemTiles.length)
              return !this.pointCoordinate3D(t2, e2.x, e2.y);
            const r2 = t2.horizonLineFromTop();
            return e2.y < r2;
          }
          createInversionMatrix(t2, e2) {
            return pg;
          }
          createTileMatrix(e2, r2, n2) {
            let i2, s2, a2;
            const o2 = n2.canonical, l2 = t.ae.identity(new Float64Array(16));
            if (this.isReprojectedInTileSpace) {
              const u2 = cg(o2, this);
              i2 = 1, s2 = u2.x + n2.wrap * u2.scale, a2 = u2.y, t.ae.scale(l2, l2, [i2 / u2.scale, i2 / u2.scale, e2.pixelsPerMeter / r2]);
            } else
              i2 = r2 / e2.zoomScale(o2.z), s2 = (o2.x + Math.pow(2, o2.z) * n2.wrap) * i2, a2 = o2.y * i2;
            return t.ae.translate(l2, l2, [s2, a2, 0]), t.ae.scale(l2, l2, [i2 / ds, i2 / ds, 1]), l2;
          }
          upVector(t2, e2, r2) {
            return [0, 0, 1];
          }
          upVectorScale(t2, e2, r2) {
            return { metersToTile: 1 };
          }
        }
        class dg extends fg {
          constructor(t2) {
            super(t2), this.range = [4, 7], this.center = t2.center || [-96, 37.5];
            const [e2, r2] = this.parallels = t2.parallels || [29.5, 45.5], n2 = Math.sin(Ge(e2));
            this.n = (n2 + Math.sin(Ge(r2))) / 2, this.c = 1 + n2 * (2 * this.n - n2), this.r0 = Math.sqrt(this.c) / this.n;
          }
          project(t2, e2) {
            const { n: r2, c: n2, r0: i2 } = this, s2 = Ge(t2 - this.center[0]), a2 = Ge(e2), o2 = Math.sqrt(n2 - 2 * r2 * Math.sin(a2)) / r2;
            return { x: o2 * Math.sin(s2 * r2), y: o2 * Math.cos(s2 * r2) - i2, z: 0 };
          }
          unproject(t2, e2) {
            const { n: r2, c: n2, r0: i2 } = this, s2 = i2 + e2;
            let a2 = Math.atan2(t2, Math.abs(s2)) * Math.sign(s2);
            s2 * r2 < 0 && (a2 -= Math.PI * Math.sign(t2) * Math.sign(s2));
            const o2 = Ge(this.center[0]) * r2;
            a2 = Qe(a2, -Math.PI - o2, Math.PI - o2);
            const l2 = We(Xe(a2 / r2) + this.center[0], -180, 180), u2 = Math.asin(We((n2 - (t2 * t2 + s2 * s2) * r2 * r2) / (2 * r2), -1, 1)), c2 = We(Xe(u2), -Vc, Vc);
            return new bc(l2, c2);
          }
        }
        const mg = 1.340264, yg = -0.081106, gg = 893e-6, xg = 3796e-6, bg = Math.sqrt(3) / 2;
        class vg extends fg {
          project(t2, e2) {
            e2 = e2 / 180 * Math.PI, t2 = t2 / 180 * Math.PI;
            const r2 = Math.asin(bg * Math.sin(e2)), n2 = r2 * r2, i2 = n2 * n2 * n2;
            return { x: 0.5 * (t2 * Math.cos(r2) / (bg * (mg + 3 * yg * n2 + i2 * (7 * gg + 9 * xg * n2))) / Math.PI + 0.5), y: 1 - 0.5 * (r2 * (mg + yg * n2 + i2 * (gg + xg * n2)) / Math.PI + 1), z: 0 };
          }
          unproject(t2, e2) {
            t2 = (2 * t2 - 0.5) * Math.PI;
            let r2 = e2 = (2 * (1 - e2) - 1) * Math.PI, n2 = r2 * r2, i2 = n2 * n2 * n2;
            for (let t3, s3, a3, o3 = 0; o3 < 12 && (s3 = r2 * (mg + yg * n2 + i2 * (gg + xg * n2)) - e2, a3 = mg + 3 * yg * n2 + i2 * (7 * gg + 9 * xg * n2), t3 = s3 / a3, r2 = We(r2 - t3, -Math.PI / 3, Math.PI / 3), n2 = r2 * r2, i2 = n2 * n2 * n2, !(Math.abs(t3) < 1e-12)); ++o3)
              ;
            const s2 = bg * t2 * (mg + 3 * yg * n2 + i2 * (7 * gg + 9 * xg * n2)) / Math.cos(r2), a2 = Math.asin(Math.sin(r2) / bg), o2 = We(180 * s2 / Math.PI, -180, 180), l2 = We(180 * a2 / Math.PI, -Vc, Vc);
            return new bc(o2, l2);
          }
        }
        class _g extends fg {
          constructor(t2) {
            super(t2), this.wrap = true, this.supportsWorldCopies = true;
          }
          project(t2, e2) {
            return { x: 0.5 + t2 / 360, y: 0.5 - e2 / 360, z: 0 };
          }
          unproject(t2, e2) {
            const r2 = 360 * (t2 - 0.5), n2 = We(360 * (0.5 - e2), -Vc, Vc);
            return new bc(r2, n2);
          }
        }
        const wg = Math.PI / 2;
        function Mg(t2) {
          return Math.tan((wg + t2) / 2);
        }
        class Ag extends fg {
          constructor(t2) {
            super(t2), this.center = t2.center || [0, 30];
            const [e2, r2] = this.parallels = t2.parallels || [30, 30];
            let n2 = Ge(e2), i2 = Ge(r2);
            this.southernCenter = n2 + i2 < 0, this.southernCenter && (n2 = -n2, i2 = -i2);
            const s2 = Math.cos(n2), a2 = Mg(n2);
            this.n = n2 === i2 ? Math.sin(n2) : Math.log(s2 / Math.cos(i2)) / Math.log(Mg(i2) / a2), this.f = s2 * Math.pow(Mg(n2), this.n) / this.n;
          }
          project(t2, e2) {
            e2 = Ge(e2), this.southernCenter && (e2 = -e2), t2 = Ge(t2 - this.center[0]);
            const r2 = 1e-6, { n: n2, f: i2 } = this;
            i2 > 0 ? e2 < -wg + r2 && (e2 = -wg + r2) : e2 > wg - r2 && (e2 = wg - r2);
            const s2 = i2 / Math.pow(Mg(e2), n2);
            let a2 = s2 * Math.sin(n2 * t2), o2 = i2 - s2 * Math.cos(n2 * t2);
            return a2 = 0.5 * (a2 / Math.PI + 0.5), o2 = 0.5 * (o2 / Math.PI + 0.5), { x: a2, y: this.southernCenter ? o2 : 1 - o2, z: 0 };
          }
          unproject(t2, e2) {
            t2 = (2 * t2 - 0.5) * Math.PI, this.southernCenter && (e2 = 1 - e2), e2 = (2 * (1 - e2) - 0.5) * Math.PI;
            const { n: r2, f: n2 } = this, i2 = n2 - e2, s2 = Math.sign(i2), a2 = Math.sign(r2) * Math.sqrt(t2 * t2 + i2 * i2);
            let o2 = Math.atan2(t2, Math.abs(i2)) * s2;
            i2 * r2 < 0 && (o2 -= Math.PI * Math.sign(t2) * s2);
            const l2 = We(Xe(o2 / r2) + this.center[0], -180, 180), u2 = We(Xe(2 * Math.atan(Math.pow(n2 / a2, 1 / r2)) - wg), -Vc, Vc);
            return new bc(l2, this.southernCenter ? -u2 : u2);
          }
        }
        class Sg extends fg {
          constructor(t2) {
            super(t2), this.wrap = true, this.supportsWorldCopies = true, this.supportsTerrain = true, this.supportsFog = true, this.supportsFreeCamera = true, this.isReprojectedInTileSpace = false, this.unsupportedLayers = [], this.range = null;
          }
          project(t2, e2) {
            return { x: Ec(t2), y: Bc(e2), z: 0 };
          }
          unproject(t2, e2) {
            const r2 = Rc(t2), n2 = Cc(e2);
            return new bc(r2, n2);
          }
        }
        const Ig = Ge(Vc);
        class Tg extends fg {
          project(t2, e2) {
            const r2 = (e2 = Ge(e2)) * e2, n2 = r2 * r2;
            return { x: 0.5 * ((t2 = Ge(t2)) * (0.8707 - 0.131979 * r2 + n2 * (n2 * (3971e-6 * r2 - 1529e-6 * n2) - 0.013791)) / Math.PI + 0.5), y: 1 - 0.5 * (e2 * (1.007226 + r2 * (0.015085 + n2 * (0.028874 * r2 - 0.044475 - 5916e-6 * n2))) / Math.PI + 1), z: 0 };
          }
          unproject(t2, e2) {
            t2 = (2 * t2 - 0.5) * Math.PI;
            let r2 = e2 = (2 * (1 - e2) - 1) * Math.PI, n2 = 25, i2 = 0, s2 = r2 * r2;
            do {
              s2 = r2 * r2;
              const t3 = s2 * s2;
              i2 = (r2 * (1.007226 + s2 * (0.015085 + t3 * (0.028874 * s2 - 0.044475 - 5916e-6 * t3))) - e2) / (1.007226 + s2 * (0.045255 + t3 * (0.259866 * s2 - 0.311325 - 5916e-6 * 11 * t3))), r2 = We(r2 - i2, -Ig, Ig);
            } while (Math.abs(i2) > 1e-6 && --n2 > 0);
            s2 = r2 * r2;
            const a2 = We(Xe(t2 / (0.8707 + s2 * (s2 * (s2 * s2 * s2 * (3971e-6 - 1529e-6 * s2) - 0.013791) - 0.131979))), -180, 180), o2 = Xe(r2);
            return new bc(a2, o2);
          }
        }
        const kg = Ge(Vc);
        class Pg extends fg {
          project(t2, e2) {
            e2 = Ge(e2), t2 = Ge(t2);
            const r2 = Math.cos(e2), n2 = 2 / Math.PI, i2 = Math.acos(r2 * Math.cos(t2 / 2)), s2 = Math.sin(i2) / i2, a2 = 0.5 * (t2 * n2 + 2 * r2 * Math.sin(t2 / 2) / s2) || 0, o2 = 0.5 * (e2 + Math.sin(e2) / s2) || 0;
            return { x: 0.5 * (a2 / Math.PI + 0.5), y: 1 - 0.5 * (o2 / Math.PI + 1), z: 0 };
          }
          unproject(t2, e2) {
            let r2 = t2 = (2 * t2 - 0.5) * Math.PI, n2 = e2 = (2 * (1 - e2) - 1) * Math.PI, i2 = 25;
            const s2 = 1e-6;
            let a2 = 0, o2 = 0;
            do {
              const i3 = Math.cos(n2), s3 = Math.sin(n2), l2 = 2 * s3 * i3, u2 = s3 * s3, c2 = i3 * i3, h2 = Math.cos(r2 / 2), p2 = Math.sin(r2 / 2), f2 = 2 * h2 * p2, d2 = p2 * p2, m2 = 1 - c2 * h2 * h2, y2 = m2 ? 1 / m2 : 0, g2 = m2 ? Math.acos(i3 * h2) * Math.sqrt(1 / m2) : 0, x2 = 0.5 * (2 * g2 * i3 * p2 + 2 * r2 / Math.PI) - t2, b2 = 0.5 * (g2 * s3 + n2) - e2, v2 = 0.5 * y2 * (c2 * d2 + g2 * i3 * h2 * u2) + 1 / Math.PI, _2 = y2 * (f2 * l2 / 4 - g2 * s3 * p2), w2 = 0.125 * y2 * (l2 * p2 - g2 * s3 * c2 * f2), M2 = 0.5 * y2 * (u2 * h2 + g2 * d2 * i3) + 0.5, A2 = _2 * w2 - M2 * v2;
              a2 = (b2 * _2 - x2 * M2) / A2, o2 = (x2 * w2 - b2 * v2) / A2, r2 = We(r2 - a2, -Math.PI, Math.PI), n2 = We(n2 - o2, -kg, kg);
            } while ((Math.abs(a2) > s2 || Math.abs(o2) > s2) && --i2 > 0);
            return new bc(Xe(r2), Xe(n2));
          }
        }
        class zg extends fg {
          constructor(t2) {
            super(t2), this.center = t2.center || [0, 0], this.parallels = t2.parallels || [0, 0], this.cosPhi = Math.max(0.01, Math.cos(Ge(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = true, this.supportsWorldCopies = true;
          }
          project(t2, e2) {
            const { scale: r2, cosPhi: n2 } = this;
            return { x: Ge(t2) * n2 * r2 + 0.5, y: -Math.sin(Ge(e2)) / n2 * r2 + 0.5, z: 0 };
          }
          unproject(t2, e2) {
            const { scale: r2, cosPhi: n2 } = this, i2 = -(e2 - 0.5) / r2, s2 = We(Xe((t2 - 0.5) / r2) / n2, -180, 180), a2 = Math.asin(We(i2 * n2, -1, 1)), o2 = We(Xe(a2), -Vc, Vc);
            return new bc(s2, o2);
          }
        }
        class Eg extends Sg {
          constructor(t2) {
            super(t2), this.requiresDraping = true, this.supportsWorldCopies = false, this.supportsFog = true, this.zAxisUnit = "pixels", this.unsupportedLayers = ["debug"], this.range = [3, 5];
          }
          projectTilePoint(e2, r2, n2) {
            const i2 = Gh(e2, r2, n2), s2 = Zh(Fh(n2));
            return t.$.transformMat4(i2, i2, s2), { x: i2[0], y: i2[1], z: i2[2] };
          }
          locationPoint(e2, r2) {
            const n2 = yc(r2.lat, r2.lng), i2 = t.$.normalize([], n2), s2 = e2.elevation ? e2.elevation.getAtPointOrZero(e2.locationCoordinate(r2), e2._centerAltitude) : e2._centerAltitude, a2 = Dc(1, 0) * ds * s2;
            t.$.scaleAndAdd(n2, n2, i2, a2);
            const o2 = t.ae.identity(new Float64Array(16));
            return t.ae.multiply(o2, e2.pixelMatrix, e2.globeMatrix), t.$.transformMat4(n2, n2, o2), new je(n2[0], n2[1]);
          }
          pixelsPerMeter(t2, e2) {
            return Dc(1, 0) * e2;
          }
          pixelSpaceConversion(t2, e2, r2) {
            const n2 = Dc(1, t2) * e2, i2 = Yn(Dc(1, 45) * e2, n2, r2);
            return this.pixelsPerMeter(t2, e2) / i2;
          }
          createTileMatrix(e2, r2, n2) {
            const i2 = Hh(Fh(n2.canonical));
            return t.ae.multiply(new Float64Array(16), e2.globeMatrix, i2);
          }
          createInversionMatrix(e2, r2) {
            const { center: n2 } = e2, i2 = Zh(Fh(r2));
            return t.ae.rotateY(i2, i2, Ge(n2.lng)), t.ae.rotateX(i2, i2, Ge(n2.lat)), t.ae.scale(i2, i2, [e2._pixelsPerMercatorPixel, e2._pixelsPerMercatorPixel, 1]), Float32Array.from(i2);
          }
          pointCoordinate(t2, e2, r2, n2) {
            return Ch(t2, e2, r2, true) || new Nc(0, 0);
          }
          pointCoordinate3D(t2, e2, r2) {
            const n2 = this.pointCoordinate(t2, e2, r2, 0);
            return [n2.x, n2.y, n2.z];
          }
          isPointAboveHorizon(t2, e2) {
            return !Ch(t2, e2.x, e2.y, false);
          }
          farthestPixelDistance(e2) {
            const r2 = function(e3, r3) {
              const n3 = e3.cameraToCenterDistance, i2 = e3._centerAltitude * r3, s2 = e3._camera, a2 = e3._camera.forward(), o2 = t.$.add([], t.$.scale([], a2, -n3), [0, 0, i2]), l2 = e3.worldSize / (2 * Math.PI), u2 = [0, 0, -l2], c2 = e3.width / e3.height, h2 = Math.tan(e3.fovAboveCenter), p2 = t.$.scale([], s2.up(), h2), f2 = t.$.scale([], s2.right(), h2 * c2), d2 = t.$.normalize([], t.$.add([], t.$.add([], a2, p2), f2)), m2 = [];
              let y2;
              if (new _h(o2, d2).closestPointOnSphere(u2, l2, m2)) {
                const r4 = t.$.add([], m2, u2), n4 = t.$.sub([], r4, o2);
                y2 = Math.cos(e3.fovAboveCenter) * t.$.length(n4);
              } else {
                const e4 = t.$.sub([], o2, u2), r4 = t.$.sub([], u2, o2);
                t.$.normalize(r4, r4);
                const n4 = t.$.length(e4) - l2;
                y2 = Math.sqrt(n4 * (n4 + 2 * l2));
                const i3 = Math.acos(y2 / (l2 + n4)) - Math.acos(t.$.dot(a2, r4));
                y2 *= Math.cos(i3);
              }
              return 1.01 * y2;
            }(e2, this.pixelsPerMeter(e2.center.lat, e2.worldSize)), n2 = Qh(e2.zoom);
            if (n2 > 0) {
              const t2 = ug(e2, Dc(1, e2.center.lat) * e2.worldSize), i2 = e2.worldSize / (2 * Math.PI), s2 = Math.max(e2.width, e2.height) / e2.worldSize * Math.PI;
              return Yn(r2, t2 + i2 * (1 - Math.cos(s2)), Math.pow(n2, 10));
            }
            return r2;
          }
          upVector(t2, e2, r2) {
            return Gh(e2, r2, t2, 1);
          }
          upVectorScale(t2) {
            return { metersToTile: Dh(Xh(Fh(t2))) };
          }
        }
        function Bg(t2) {
          const e2 = t2.parallels, r2 = !!e2 && Math.abs(e2[0] + e2[1]) < 0.01;
          switch (t2.name) {
            case "mercator":
              return new Sg(t2);
            case "equirectangular":
              return new _g(t2);
            case "naturalEarth":
              return new Tg(t2);
            case "equalEarth":
              return new vg(t2);
            case "winkelTripel":
              return new Pg(t2);
            case "albers":
              return r2 ? new zg(t2) : new dg(t2);
            case "lambertConformalConic":
              return r2 ? new zg(t2) : new Ag(t2);
            case "globe":
              return new Eg(t2);
          }
          throw new Error(`Invalid projection name: ${t2.name}`);
        }
        const Dg = zf.types, Rg = [{ name: "a_fade_opacity", components: 1, type: "Uint8", offset: 0 }];
        function Cg(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2) {
          const f2 = o2 ? Math.min(ng, Math.round(o2[0])) : 0, d2 = o2 ? Math.min(ng, Math.round(o2[1])) : 0;
          t2.emplaceBack(e2, r2, Math.round(32 * n2), Math.round(32 * i2), s2, a2, (f2 << 1) + (l2 ? 1 : 0), d2, 16 * u2, 16 * c2, 256 * h2, 256 * p2);
        }
        function Lg(t2, e2, r2) {
          t2.emplaceBack(e2, r2);
        }
        function Vg(t2, e2, r2, n2, i2, s2, a2) {
          t2.emplaceBack(e2, r2, n2, i2, s2, a2);
        }
        function Fg(t2, e2, r2, n2, i2) {
          t2.emplaceBack(e2, r2, n2, i2), t2.emplaceBack(e2, r2, n2, i2), t2.emplaceBack(e2, r2, n2, i2), t2.emplaceBack(e2, r2, n2, i2);
        }
        function Og(t2) {
          for (const e2 of t2.sections)
            if (Fo(e2.text))
              return true;
          return false;
        }
        class Ug {
          constructor(t2) {
            this.layoutVertexArray = new Xl(), this.indexArray = new tu(), this.programConfigurations = t2, this.segments = new ku(), this.dynamicLayoutVertexArray = new jl(), this.opacityVertexArray = new Zl(), this.placedSymbolArray = new yu(), this.iconTransitioningVertexArray = new Hl(), this.globeExtVertexArray = new Yl(), this.zOffsetVertexArray = new nu();
          }
          isEmpty() {
            return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length && 0 === this.iconTransitioningVertexArray.length;
          }
          upload(t2, e2, r2, n2, i2) {
            this.isEmpty() || (r2 && (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, Zd.members), this.indexBuffer = t2.createIndexBuffer(this.indexArray, e2), this.dynamicLayoutVertexBuffer = t2.createVertexBuffer(this.dynamicLayoutVertexArray, Kd.members, true), this.opacityVertexBuffer = t2.createVertexBuffer(this.opacityVertexArray, Rg, true), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = t2.createVertexBuffer(this.iconTransitioningVertexArray, Jd.members, true)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = t2.createVertexBuffer(this.globeExtVertexArray, Hd.members, true)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || i2) && (this.zOffsetVertexBuffer = t2.createVertexBuffer(this.zOffsetVertexArray, Wd.members, true)), this.opacityVertexBuffer.itemSize = 1), (r2 || n2) && this.programConfigurations.upload(t2));
          }
          destroy() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy());
          }
        }
        So(Ug, "SymbolBuffers");
        class jg {
          constructor(t2, e2, r2) {
            this.layoutVertexArray = new t2(), this.layoutAttributes = e2, this.indexArray = new r2(), this.segments = new ku(), this.collisionVertexArray = new Ql(), this.collisionVertexArrayExt = new jl();
          }
          upload(t2) {
            this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t2.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t2.createVertexBuffer(this.collisionVertexArray, Qd.members, true), this.collisionVertexBufferExt = t2.createVertexBuffer(this.collisionVertexArrayExt, tm.members, true);
          }
          destroy() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
          }
        }
        So(jg, "CollisionBuffers");
        class Ng {
          constructor(e2) {
            this.collisionBoxArray = e2.collisionBoxArray, this.zoom = e2.zoom, this.lut = e2.lut, this.overscaling = e2.overscaling, this.layers = e2.layers, this.layerIds = this.layers.map((t2) => t2.fqid), this.index = e2.index, this.pixelRatio = e2.pixelRatio, this.sourceLayerIndex = e2.sourceLayerIndex, this.hasPattern = false, this.hasRTLText = false, this.fullyClipped = false, this.hasAnyIconTextFit = false, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = t.ae.identity([]), this.placementViewportMatrix = t.ae.identity([]);
            const r2 = this.layers[0]._unevaluatedLayout._values;
            this.textSizeData = Zm(this.zoom, r2["text-size"]), this.iconSizeData = Zm(this.zoom, r2["icon-size"]);
            const n2 = this.layers[0].layout, i2 = n2.get("symbol-sort-key"), s2 = n2.get("symbol-z-order");
            this.canOverlap = n2.get("text-allow-overlap") || n2.get("icon-allow-overlap") || n2.get("text-ignore-placement") || n2.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== s2 && void 0 !== i2.constantOr(1), this.sortFeaturesByY = ("viewport-y" === s2 || "auto" === s2 && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = n2.get("text-writing-mode").map((t2) => oy[t2]), this.stateDependentLayerIds = this.layers.filter((t2) => t2.isStateDependent()).map((t2) => t2.id), this.sourceID = e2.sourceID, this.projection = e2.projection, this.hasAnyZOffset = false, this.zOffsetSortDirty = false, this.zOffsetBuffersNeedUpload = n2.get("symbol-z-elevate"), this.activeReplacements = [], this.replacementUpdateTime = 0;
          }
          createArrays() {
            this.text = new Ug(new ec(this.layers, { zoom: this.zoom, lut: this.lut }, (t2) => /^text/.test(t2))), this.icon = new Ug(new ec(this.layers, { zoom: this.zoom, lut: this.lut }, (t2) => /^icon/.test(t2))), this.glyphOffsetArray = new bu(), this.lineVertexArray = new vu(), this.symbolInstances = new xu();
          }
          calculateGlyphDependencies(t2, e2, r2, n2, i2) {
            for (let r3 = 0; r3 < t2.length; r3++) {
              const s2 = t2.codePointAt(r3);
              if (void 0 === s2)
                break;
              if (e2[s2] = true, n2 && i2 && s2 <= 65535) {
                const n3 = Qm[t2.charAt(r3)];
                n3 && (e2[n3.charCodeAt(0)] = true);
              }
            }
          }
          updateFootprints(t2, e2) {
          }
          updateReplacement(t2, e2) {
            if (e2.updateTime === this.replacementUpdateTime)
              return false;
            this.replacementUpdateTime = e2.updateTime;
            const r2 = e2.getReplacementRegionsForTile(t2.toUnwrapped(), true);
            return !jf(this.activeReplacements, r2) && (this.activeReplacements = r2, true);
          }
          populate(e2, r2, n2, i2) {
            const s2 = this.layers[0], a2 = s2.layout, o2 = "globe" === this.projection.name, l2 = a2.get("text-font"), u2 = a2.get("text-field"), c2 = a2.get("icon-image"), h2 = ("constant" !== u2.value.kind || u2.value.value instanceof gi && !u2.value.value.isEmpty() || u2.value.value.toString().length > 0) && ("constant" !== l2.value.kind || l2.value.value.length > 0), p2 = "constant" !== c2.value.kind || !!c2.value.value || Object.keys(c2.parameters).length > 0, f2 = a2.get("symbol-sort-key");
            if (this.features = [], !h2 && !p2)
              return;
            const d2 = r2.iconDependencies, m2 = r2.glyphDependencies, y2 = r2.availableImages, g2 = new Wo(this.zoom);
            for (const { feature: r3, id: u3, index: c3, sourceLayerIndex: x2 } of e2) {
              const e3 = s2._featureFilter.needGeometry, b2 = Wc(r3, e3);
              if (!s2._featureFilter.filter(g2, b2, n2))
                continue;
              if (e3 || (b2.geometry = Kc(r3, n2, i2)), o2 && 1 !== r3.type && n2.z <= 5) {
                const e4 = b2.geometry, r4 = 0.98078528056, i3 = (e5, i4) => {
                  const s3 = Gh(e5.x, e5.y, n2, 1), a3 = Gh(i4.x, i4.y, n2, 1);
                  return t.$.dot(s3, a3) < r4;
                };
                for (let t2 = 0; t2 < e4.length; t2++)
                  e4[t2] = Xc(e4[t2], i3);
              }
              let v2, _2;
              if (h2) {
                const t2 = s2.getValueAndResolveTokens("text-field", b2, n2, y2), e4 = gi.factory(t2);
                Og(e4) && (this.hasRTLText = true), (!this.hasRTLText || "unavailable" === Zo() || this.hasRTLText && Ko.isParsed()) && (v2 = Jm(e4, s2, b2));
              }
              if (p2) {
                const t2 = s2.getValueAndResolveTokens("icon-image", b2, n2, y2);
                _2 = t2 instanceof xi ? t2 : xi.fromString(t2);
              }
              if (!v2 && !_2)
                continue;
              const w2 = this.sortFeaturesByKey ? f2.evaluate(b2, {}, n2) : void 0;
              if (this.features.push({ id: u3, text: v2, icon: _2, index: c3, sourceLayerIndex: x2, geometry: b2.geometry, properties: r3.properties, type: Dg[r3.type], sortKey: w2 }), _2 && (d2[_2.namePrimary] = true, _2.nameSecondary && (d2[_2.nameSecondary] = true)), v2) {
                const t2 = l2.evaluate(b2, {}, n2).join(","), e4 = "map" === a2.get("text-rotation-alignment") && "point" !== a2.get("symbol-placement");
                this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(oy.vertical) >= 0;
                for (const r4 of v2.sections)
                  if (r4.image)
                    d2[r4.image.namePrimary] = true;
                  else {
                    const n3 = Eo(v2.toString()), i3 = r4.fontStack || t2, s3 = m2[i3] = m2[i3] || {};
                    this.calculateGlyphDependencies(r4.text, s3, e4, this.allowVerticalPlacement, n3);
                  }
              }
            }
            "line" === a2.get("symbol-placement") && (this.features = function(t2) {
              const e3 = {}, r3 = {}, n3 = [];
              let i3 = 0;
              function s3(e4) {
                n3.push(t2[e4]), i3++;
              }
              function a3(t3, e4, i4) {
                const s4 = r3[t3];
                return delete r3[t3], r3[e4] = s4, n3[s4].geometry[0].pop(), n3[s4].geometry[0] = n3[s4].geometry[0].concat(i4[0]), s4;
              }
              function o3(t3, r4, i4) {
                const s4 = e3[r4];
                return delete e3[r4], e3[t3] = s4, n3[s4].geometry[0].shift(), n3[s4].geometry[0] = i4[0].concat(n3[s4].geometry[0]), s4;
              }
              function l3(t3, e4, r4) {
                const n4 = r4 ? e4[0][e4[0].length - 1] : e4[0][0];
                return `${t3}:${n4.x}:${n4.y}`;
              }
              for (let u3 = 0; u3 < t2.length; u3++) {
                const c3 = t2[u3], h3 = c3.geometry, p3 = c3.text ? c3.text.toString() : null;
                if (!p3) {
                  s3(u3);
                  continue;
                }
                const f3 = l3(p3, h3), d3 = l3(p3, h3, true);
                if (f3 in r3 && d3 in e3 && r3[f3] !== e3[d3]) {
                  const t3 = o3(f3, d3, h3), i4 = a3(f3, d3, n3[t3].geometry);
                  delete e3[f3], delete r3[d3], r3[l3(p3, n3[i4].geometry, true)] = i4, n3[t3].geometry = null;
                } else
                  f3 in r3 ? a3(f3, d3, h3) : d3 in e3 ? o3(f3, d3, h3) : (s3(u3), e3[f3] = i3 - 1, r3[d3] = i3 - 1);
              }
              return n3.filter((t3) => t3.geometry);
            }(this.features)), this.sortFeaturesByKey && this.features.sort((t2, e3) => t2.sortKey - e3.sortKey);
          }
          update(t2, e2, r2, n2, i2) {
            const s2 = 0 !== Object.keys(t2).length;
            if (s2 && !this.stateDependentLayers.length)
              return;
            const a2 = s2 ? this.stateDependentLayers : this.layers;
            this.text.programConfigurations.updatePaintArrays(t2, e2, a2, r2, n2, i2), this.icon.programConfigurations.updatePaintArrays(t2, e2, a2, r2, n2, i2);
          }
          updateZOffset() {
            const t2 = (t3, e3, n3) => {
              r2 += e3, r2 > t3.length && t3.resize(r2);
              for (let i2 = -e3; i2 < 0; i2++)
                t3.emplace(i2 + r2, n3);
            }, e2 = (t3, e3, r3) => {
              n2 += e3, n2 > t3.length && t3.resize(n2);
              for (let i2 = -e3; i2 < 0; i2++)
                t3.emplace(i2 + n2, r3);
            };
            if (!this.zOffsetBuffersNeedUpload)
              return;
            this.zOffsetBuffersNeedUpload = false;
            let r2 = 0, n2 = 0;
            for (let r3 = 0; r3 < this.symbolInstances.length; r3++) {
              const n3 = this.symbolInstances.get(r3), { numHorizontalGlyphVertices: i2, numVerticalGlyphVertices: s2, numIconVertices: a2 } = n3, o2 = n3.zOffset, l2 = a2 > 0;
              if ((i2 > 0 || s2 > 0) && (t2(this.text.zOffsetVertexArray, i2, o2), t2(this.text.zOffsetVertexArray, s2, o2)), l2) {
                const { placedIconSymbolIndex: t3, verticalPlacedIconSymbolIndex: r4 } = n3;
                t3 >= 0 && e2(this.icon.zOffsetVertexArray, a2, o2), r4 >= 0 && e2(this.icon.zOffsetVertexArray, n3.numVerticalIconVertices, o2);
              }
            }
            this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(this.text.zOffsetVertexArray), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(this.icon.zOffsetVertexArray);
          }
          isEmpty() {
            return 0 === this.symbolInstances.length && !this.hasRTLText;
          }
          uploadPending() {
            return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
          }
          upload(t2) {
            !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t2), this.iconCollisionBox.upload(t2)), this.text.upload(t2, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.icon.upload(t2, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.uploaded = true;
          }
          destroyDebugData() {
            this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
          }
          getProjection() {
            return this.projectionInstance || (this.projectionInstance = Bg(this.projection)), this.projectionInstance;
          }
          destroy() {
            this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
          }
          addToLineVertexArray(t2, e2) {
            const r2 = this.lineVertexArray.length;
            if (void 0 !== t2.segment)
              for (const { x: t3, y: r3 } of e2)
                this.lineVertexArray.emplaceBack(t3, r3);
            return { lineStartIndex: r2, lineLength: this.lineVertexArray.length - r2 };
          }
          addSymbols(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2, h2, p2, f2, d2, m2) {
            const y2 = t2.indexArray, g2 = t2.layoutVertexArray, x2 = t2.globeExtVertexArray, b2 = t2.segments.prepareSegment(4 * e2.length, g2, y2, this.canOverlap ? s2.sortKey : void 0), v2 = this.glyphOffsetArray.length, _2 = b2.vertexLength, w2 = this.allowVerticalPlacement && a2 === oy.vertical ? Math.PI / 2 : 0, M2 = s2.text && s2.text.sections;
            for (let n3 = 0; n3 < e2.length; n3++) {
              const { tl: i3, tr: a3, bl: u3, br: c3, texPrimary: h3, texSecondary: v3, pixelOffsetTL: _3, pixelOffsetBR: A3, minFontScaleX: S2, minFontScaleY: I2, glyphOffset: T2, isSDF: k2, sectionIndex: P2 } = e2[n3], z2 = b2.vertexLength, E2 = T2[1];
              if (Cg(g2, l2.x, l2.y, i3.x, E2 + i3.y, h3.x, h3.y, r2, k2, _3.x, _3.y, S2, I2), Cg(g2, l2.x, l2.y, a3.x, E2 + a3.y, h3.x + h3.w, h3.y, r2, k2, A3.x, _3.y, S2, I2), Cg(g2, l2.x, l2.y, u3.x, E2 + u3.y, h3.x, h3.y + h3.h, r2, k2, _3.x, A3.y, S2, I2), Cg(g2, l2.x, l2.y, c3.x, E2 + c3.y, h3.x + h3.w, h3.y + h3.h, r2, k2, A3.x, A3.y, S2, I2), o2) {
                const { x: e3, y: r3, z: n4 } = o2.anchor, [i4, s3, a4] = o2.up;
                Vg(x2, e3, r3, n4, i4, s3, a4), Vg(x2, e3, r3, n4, i4, s3, a4), Vg(x2, e3, r3, n4, i4, s3, a4), Vg(x2, e3, r3, n4, i4, s3, a4), Fg(t2.dynamicLayoutVertexArray, e3, r3, n4, w2);
              } else
                Fg(t2.dynamicLayoutVertexArray, l2.x, l2.y, l2.z, w2);
              if (m2) {
                const e3 = v3 || h3;
                Lg(t2.iconTransitioningVertexArray, e3.x, e3.y), Lg(t2.iconTransitioningVertexArray, e3.x + e3.w, e3.y), Lg(t2.iconTransitioningVertexArray, e3.x, e3.y + e3.h), Lg(t2.iconTransitioningVertexArray, e3.x + e3.w, e3.y + e3.h);
              }
              y2.emplaceBack(z2, z2 + 1, z2 + 2), y2.emplaceBack(z2 + 1, z2 + 2, z2 + 3), b2.vertexLength += 4, b2.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(T2[0]), n3 !== e2.length - 1 && P2 === e2[n3 + 1].sectionIndex || t2.programConfigurations.populatePaintArrays(g2.length, s2, s2.index, {}, p2, f2, d2, M2 && M2[P2]);
            }
            const A2 = o2 ? o2.anchor : l2;
            t2.placedSymbolArray.emplaceBack(A2.x, A2.y, A2.z, l2.x, l2.y, v2, this.glyphOffsetArray.length - v2, _2, u2, c2, l2.segment, r2 ? r2[0] : 0, r2 ? r2[1] : 0, n2[0], n2[1], a2, 0, false, 0, h2, 0);
          }
          _commitLayoutVertex(t2, e2, r2, n2, i2, s2, a2) {
            t2.emplaceBack(e2, r2, n2, i2, s2, Math.round(a2.x), Math.round(a2.y));
          }
          _addCollisionDebugVertices(t2, e2, r2, n2, i2, s2, a2) {
            const o2 = r2.segments.prepareSegment(4, r2.layoutVertexArray, r2.indexArray), l2 = o2.vertexLength, u2 = a2.tileAnchorX, c2 = a2.tileAnchorY;
            for (let t3 = 0; t3 < 4; t3++)
              r2.collisionVertexArray.emplaceBack(0, 0, 0, 0);
            this._commitDebugCollisionVertexUpdate(r2.collisionVertexArrayExt, e2, t2.padding, a2.zOffset), this._commitLayoutVertex(r2.layoutVertexArray, n2, i2, s2, u2, c2, new je(t2.x1, t2.y1)), this._commitLayoutVertex(r2.layoutVertexArray, n2, i2, s2, u2, c2, new je(t2.x2, t2.y1)), this._commitLayoutVertex(r2.layoutVertexArray, n2, i2, s2, u2, c2, new je(t2.x2, t2.y2)), this._commitLayoutVertex(r2.layoutVertexArray, n2, i2, s2, u2, c2, new je(t2.x1, t2.y2)), o2.vertexLength += 4;
            const h2 = r2.indexArray;
            h2.emplaceBack(l2, l2 + 1), h2.emplaceBack(l2 + 1, l2 + 2), h2.emplaceBack(l2 + 2, l2 + 3), h2.emplaceBack(l2 + 3, l2), o2.primitiveLength += 4;
          }
          _addTextDebugCollisionBoxes(t2, e2, r2, n2, i2, s2) {
            for (let a2 = n2; a2 < i2; a2++) {
              const n3 = r2.get(a2), i3 = this.getSymbolInstanceTextSize(t2, s2, e2, a2);
              this._addCollisionDebugVertices(n3, i3, this.textCollisionBox, n3.projectedAnchorX, n3.projectedAnchorY, n3.projectedAnchorZ, s2);
            }
          }
          _addIconDebugCollisionBoxes(t2, e2, r2, n2, i2, s2) {
            for (let a2 = n2; a2 < i2; a2++) {
              const n3 = r2.get(a2), i3 = this.getSymbolInstanceIconSize(t2, e2, s2.placedIconSymbolIndex);
              this._addCollisionDebugVertices(n3, i3, this.iconCollisionBox, n3.projectedAnchorX, n3.projectedAnchorY, n3.projectedAnchorZ, s2);
            }
          }
          generateCollisionDebugBuffers(t2, e2) {
            this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new jg(Wl, em.members, Hl), this.iconCollisionBox = new jg(Wl, em.members, Hl);
            const r2 = Km(this.iconSizeData, t2), n2 = Km(this.textSizeData, t2);
            for (let i2 = 0; i2 < this.symbolInstances.length; i2++) {
              const s2 = this.symbolInstances.get(i2);
              this._addTextDebugCollisionBoxes(n2, t2, e2, s2.textBoxStartIndex, s2.textBoxEndIndex, s2), this._addTextDebugCollisionBoxes(n2, t2, e2, s2.verticalTextBoxStartIndex, s2.verticalTextBoxEndIndex, s2), this._addIconDebugCollisionBoxes(r2, t2, e2, s2.iconBoxStartIndex, s2.iconBoxEndIndex, s2), this._addIconDebugCollisionBoxes(r2, t2, e2, s2.verticalIconBoxStartIndex, s2.verticalIconBoxEndIndex, s2);
            }
          }
          getSymbolInstanceTextSize(t2, e2, r2, n2) {
            const i2 = this.text.placedSymbolArray.get(e2.rightJustifiedTextSymbolIndex >= 0 ? e2.rightJustifiedTextSymbolIndex : e2.centerJustifiedTextSymbolIndex >= 0 ? e2.centerJustifiedTextSymbolIndex : e2.leftJustifiedTextSymbolIndex >= 0 ? e2.leftJustifiedTextSymbolIndex : e2.verticalPlacedTextSymbolIndex >= 0 ? e2.verticalPlacedTextSymbolIndex : n2), s2 = Hm(this.textSizeData, t2, i2) / Xm;
            return this.tilePixelRatio * s2;
          }
          getSymbolInstanceIconSize(t2, e2, r2) {
            const n2 = this.icon.placedSymbolArray.get(r2), i2 = Hm(this.iconSizeData, t2, n2);
            return this.tilePixelRatio * i2;
          }
          _commitDebugCollisionVertexUpdate(t2, e2, r2, n2) {
            t2.emplaceBack(e2, -r2, -r2, n2), t2.emplaceBack(e2, r2, -r2, n2), t2.emplaceBack(e2, r2, r2, n2), t2.emplaceBack(e2, -r2, r2, n2);
          }
          _updateTextDebugCollisionBoxes(t2, e2, r2, n2, i2, s2) {
            for (let a2 = n2; a2 < i2; a2++) {
              const n3 = r2.get(a2), i3 = this.getSymbolInstanceTextSize(t2, s2, e2, a2);
              this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, i3, n3.padding, s2.zOffset);
            }
          }
          _updateIconDebugCollisionBoxes(t2, e2, r2, n2, i2, s2) {
            for (let a2 = n2; a2 < i2; a2++) {
              const n3 = r2.get(a2), i3 = this.getSymbolInstanceIconSize(t2, e2, s2.placedIconSymbolIndex);
              this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, i3, n3.padding, s2.zOffset);
            }
          }
          updateCollisionDebugBuffers(t2, e2) {
            if (!this.hasDebugData())
              return;
            this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
            const r2 = Km(this.iconSizeData, t2), n2 = Km(this.textSizeData, t2);
            for (let i2 = 0; i2 < this.symbolInstances.length; i2++) {
              const s2 = this.symbolInstances.get(i2);
              this._updateTextDebugCollisionBoxes(n2, t2, e2, s2.textBoxStartIndex, s2.textBoxEndIndex, s2), this._updateTextDebugCollisionBoxes(n2, t2, e2, s2.verticalTextBoxStartIndex, s2.verticalTextBoxEndIndex, s2), this._updateIconDebugCollisionBoxes(r2, t2, e2, s2.iconBoxStartIndex, s2.iconBoxEndIndex, s2), this._updateIconDebugCollisionBoxes(r2, t2, e2, s2.verticalIconBoxStartIndex, s2.verticalIconBoxEndIndex, s2);
            }
            this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
          }
          _deserializeCollisionBoxesForSymbol(t2, e2, r2, n2, i2, s2, a2, o2, l2) {
            const u2 = {};
            if (e2 < r2) {
              const { x1: r3, y1: n3, x2: i3, y2: s3, padding: a3, projectedAnchorX: o3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h2, tileAnchorY: p2, featureIndex: f2 } = t2.get(e2);
              u2.textBox = { x1: r3, y1: n3, x2: i3, y2: s3, padding: a3, projectedAnchorX: o3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h2, tileAnchorY: p2 }, u2.textFeatureIndex = f2;
            }
            if (n2 < i2) {
              const { x1: e3, y1: r3, x2: i3, y2: s3, padding: a3, projectedAnchorX: o3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h2, tileAnchorY: p2, featureIndex: f2 } = t2.get(n2);
              u2.verticalTextBox = { x1: e3, y1: r3, x2: i3, y2: s3, padding: a3, projectedAnchorX: o3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h2, tileAnchorY: p2 }, u2.verticalTextFeatureIndex = f2;
            }
            if (s2 < a2) {
              const { x1: e3, y1: r3, x2: n3, y2: i3, padding: a3, projectedAnchorX: o3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h2, tileAnchorY: p2, featureIndex: f2 } = t2.get(s2);
              u2.iconBox = { x1: e3, y1: r3, x2: n3, y2: i3, padding: a3, projectedAnchorX: o3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h2, tileAnchorY: p2 }, u2.iconFeatureIndex = f2;
            }
            if (o2 < l2) {
              const { x1: e3, y1: r3, x2: n3, y2: i3, padding: s3, projectedAnchorX: a3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h2, tileAnchorY: p2, featureIndex: f2 } = t2.get(o2);
              u2.verticalIconBox = { x1: e3, y1: r3, x2: n3, y2: i3, padding: s3, projectedAnchorX: a3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h2, tileAnchorY: p2 }, u2.verticalIconFeatureIndex = f2;
            }
            return u2;
          }
          deserializeCollisionBoxes(t2) {
            this.collisionArrays = [];
            for (let e2 = 0; e2 < this.symbolInstances.length; e2++) {
              const r2 = this.symbolInstances.get(e2);
              this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t2, r2.textBoxStartIndex, r2.textBoxEndIndex, r2.verticalTextBoxStartIndex, r2.verticalTextBoxEndIndex, r2.iconBoxStartIndex, r2.iconBoxEndIndex, r2.verticalIconBoxStartIndex, r2.verticalIconBoxEndIndex));
            }
          }
          hasTextData() {
            return this.text.segments.get().length > 0;
          }
          hasIconData() {
            return this.icon.segments.get().length > 0;
          }
          hasDebugData() {
            return this.textCollisionBox && this.iconCollisionBox;
          }
          hasTextCollisionBoxData() {
            return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
          }
          hasIconCollisionBoxData() {
            return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
          }
          hasIconTextFit() {
            return this.hasAnyIconTextFit;
          }
          addIndicesForPlacedSymbol(t2, e2) {
            const r2 = t2.placedSymbolArray.get(e2), n2 = r2.vertexStartIndex + 4 * r2.numGlyphs;
            for (let e3 = r2.vertexStartIndex; e3 < n2; e3 += 4)
              t2.indexArray.emplaceBack(e3, e3 + 1, e3 + 2), t2.indexArray.emplaceBack(e3 + 1, e3 + 2, e3 + 3);
          }
          getSortedSymbolIndexes(t2) {
            if (this.sortedAngle === t2 && void 0 !== this.symbolInstanceIndexes)
              return this.symbolInstanceIndexes;
            const e2 = Math.sin(t2), r2 = Math.cos(t2), n2 = [], i2 = [], s2 = [];
            for (let t3 = 0; t3 < this.symbolInstances.length; ++t3) {
              s2.push(t3);
              const a2 = this.symbolInstances.get(t3);
              n2.push(0 | Math.round(e2 * a2.tileAnchorX + r2 * a2.tileAnchorY)), i2.push(a2.featureIndex);
            }
            return s2.sort((t3, e3) => n2[t3] - n2[e3] || i2[e3] - i2[t3]), s2;
          }
          getSortedIndexesByZOffset() {
            if (!this.zOffsetSortDirty)
              return this.symbolInstanceIndexesSortedZOffset;
            if (!this.symbolInstanceIndexesSortedZOffset) {
              this.symbolInstanceIndexesSortedZOffset = [];
              for (let t2 = 0; t2 < this.symbolInstances.length; ++t2)
                this.symbolInstanceIndexesSortedZOffset.push(t2);
            }
            return this.zOffsetSortDirty = false, this.symbolInstanceIndexesSortedZOffset.sort((t2, e2) => this.symbolInstances.get(e2).zOffset - this.symbolInstances.get(t2).zOffset);
          }
          addToSortKeyRanges(t2, e2) {
            const r2 = this.sortKeyRanges[this.sortKeyRanges.length - 1];
            r2 && r2.sortKey === e2 ? r2.symbolInstanceEnd = t2 + 1 : this.sortKeyRanges.push({ sortKey: e2, symbolInstanceStart: t2, symbolInstanceEnd: t2 + 1 });
          }
          sortFeatures(t2) {
            if (this.sortFeaturesByY && this.sortedAngle !== t2 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
              this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t2), this.sortedAngle = t2, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
              for (const t3 of this.symbolInstanceIndexes) {
                const e2 = this.symbolInstances.get(t3);
                this.featureSortOrder.push(e2.featureIndex);
                const { rightJustifiedTextSymbolIndex: r2, centerJustifiedTextSymbolIndex: n2, leftJustifiedTextSymbolIndex: i2, verticalPlacedTextSymbolIndex: s2, placedIconSymbolIndex: a2, verticalPlacedIconSymbolIndex: o2 } = e2;
                r2 >= 0 && this.addIndicesForPlacedSymbol(this.text, r2), n2 >= 0 && n2 !== r2 && this.addIndicesForPlacedSymbol(this.text, n2), i2 >= 0 && i2 !== n2 && i2 !== r2 && this.addIndicesForPlacedSymbol(this.text, i2), s2 >= 0 && this.addIndicesForPlacedSymbol(this.text, s2), a2 >= 0 && this.addIndicesForPlacedSymbol(this.icon, a2), o2 >= 0 && this.addIndicesForPlacedSymbol(this.icon, o2);
              }
              this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
            }
          }
        }
        So(Ng, "SymbolBucket", { omit: ["layers", "collisionBoxArray", "features", "compareText"] }), Ng.addDynamicAttributes = Fg;
        class $g {
          constructor(t2, e2, r2, n2) {
            this.context = t2, this.format = r2, this.texture = t2.gl.createTexture(), this.update(e2, n2);
          }
          update(t2, e2, r2) {
            const { width: n2, height: i2 } = t2, { context: s2 } = this, { gl: a2 } = s2;
            if (a2.bindTexture(a2.TEXTURE_2D, this.texture), s2.pixelStoreUnpackFlipY.set(false), s2.pixelStoreUnpack.set(1), s2.pixelStoreUnpackPremultiplyAlpha.set(this.format === a2.RGBA && (!e2 || false !== e2.premultiply)), this.useMipmap = Boolean(e2 && e2.useMipmap), r2 || this.size && this.size[0] === n2 && this.size[1] === i2) {
              const { x: e3, y: s3 } = r2 || { x: 0, y: 0 };
              if (t2 instanceof HTMLImageElement || t2 instanceof HTMLCanvasElement || t2 instanceof HTMLVideoElement || t2 instanceof ImageData || ImageBitmap && t2 instanceof ImageBitmap)
                a2.texSubImage2D(a2.TEXTURE_2D, 0, e3, s3, a2.RGBA, a2.UNSIGNED_BYTE, t2);
              else {
                let r3 = this.format, o2 = a2.UNSIGNED_BYTE;
                this.format === a2.R32F && (r3 = a2.RED, o2 = a2.FLOAT), a2.texSubImage2D(a2.TEXTURE_2D, 0, e3, s3, n2, i2, r3, o2, t2.data);
              }
            } else if (this.size = [n2, i2], t2 instanceof HTMLImageElement || t2 instanceof HTMLCanvasElement || t2 instanceof HTMLVideoElement || t2 instanceof ImageData || ImageBitmap && t2 instanceof ImageBitmap) {
              let e3 = this.format;
              this.format === a2.R8 && (e3 = a2.RED), a2.texImage2D(a2.TEXTURE_2D, 0, this.format, e3, a2.UNSIGNED_BYTE, t2);
            } else {
              let e3 = this.format, r3 = this.format, s3 = a2.UNSIGNED_BYTE, o2 = false;
              this.format === a2.DEPTH_COMPONENT && (e3 = a2.DEPTH_COMPONENT16, s3 = a2.UNSIGNED_SHORT), this.format === a2.DEPTH_STENCIL && (e3 = a2.DEPTH24_STENCIL8, s3 = a2.UNSIGNED_INT_24_8, o2 = true), this.format === a2.R8 && (r3 = a2.RED), this.format === a2.R32F && (s3 = a2.FLOAT, r3 = a2.RED), !this.useMipmap && o2 ? a2.texStorage2D(a2.TEXTURE_2D, 1, e3, n2, i2) : a2.texImage2D(a2.TEXTURE_2D, 0, e3, n2, i2, 0, r3, s3, t2.data);
            }
            this.useMipmap && a2.generateMipmap(a2.TEXTURE_2D);
          }
          bind(t2, e2, r2 = false) {
            const { context: n2 } = this, { gl: i2 } = n2;
            i2.bindTexture(i2.TEXTURE_2D, this.texture), t2 !== this.minFilter && (i2.texParameteri(i2.TEXTURE_2D, i2.TEXTURE_MAG_FILTER, t2), i2.texParameteri(i2.TEXTURE_2D, i2.TEXTURE_MIN_FILTER, this.useMipmap && !r2 ? t2 === i2.NEAREST ? i2.NEAREST_MIPMAP_NEAREST : i2.LINEAR_MIPMAP_LINEAR : t2), this.minFilter = t2), e2 !== this.wrapS && (i2.texParameteri(i2.TEXTURE_2D, i2.TEXTURE_WRAP_S, e2), i2.texParameteri(i2.TEXTURE_2D, i2.TEXTURE_WRAP_T, e2), this.wrapS = e2);
          }
          bindExtraParam(t2, e2, r2, n2) {
            const { context: i2 } = this, { gl: s2 } = i2;
            s2.bindTexture(s2.TEXTURE_2D, this.texture), e2 !== this.magFilter && (s2.texParameteri(s2.TEXTURE_2D, s2.TEXTURE_MAG_FILTER, e2), this.magFilter = e2), t2 !== this.minFilter && (s2.texParameteri(s2.TEXTURE_2D, s2.TEXTURE_MIN_FILTER, this.useMipmap ? t2 === s2.NEAREST ? s2.NEAREST_MIPMAP_NEAREST : s2.LINEAR_MIPMAP_LINEAR : t2), this.minFilter = t2), r2 !== this.wrapS && (s2.texParameteri(s2.TEXTURE_2D, s2.TEXTURE_WRAP_S, r2), this.wrapS = r2), n2 !== this.wrapT && (s2.texParameteri(s2.TEXTURE_2D, s2.TEXTURE_WRAP_T, n2), this.wrapT = n2);
          }
          destroy() {
            const { gl: t2 } = this.context;
            t2.deleteTexture(this.texture), this.texture = null;
          }
        }
        class qg {
          constructor(t2, e2) {
            this.context = t2, this.texture = e2;
          }
          bind(t2, e2) {
            const { context: r2 } = this, { gl: n2 } = r2;
            n2.bindTexture(n2.TEXTURE_2D, this.texture), t2 !== this.minFilter && (n2.texParameteri(n2.TEXTURE_2D, n2.TEXTURE_MAG_FILTER, t2), n2.texParameteri(n2.TEXTURE_2D, n2.TEXTURE_MIN_FILTER, t2), this.minFilter = t2), e2 !== this.wrapS && (n2.texParameteri(n2.TEXTURE_2D, n2.TEXTURE_WRAP_S, e2), n2.texParameteri(n2.TEXTURE_2D, n2.TEXTURE_WRAP_T, e2), this.wrapS = e2);
          }
        }
        const Gg = 32, Xg = 33, Yg = new Uint16Array(8184);
        for (let t2 = 0; t2 < 2046; t2++) {
          let e2 = t2 + 2, r2 = 0, n2 = 0, i2 = 0, s2 = 0, a2 = 0, o2 = 0;
          for (1 & e2 ? i2 = s2 = a2 = Gg : r2 = n2 = o2 = Gg; (e2 >>= 1) > 1; ) {
            const t3 = r2 + i2 >> 1, l3 = n2 + s2 >> 1;
            1 & e2 ? (i2 = r2, s2 = n2, r2 = a2, n2 = o2) : (r2 = i2, n2 = s2, i2 = a2, s2 = o2), a2 = t3, o2 = l3;
          }
          const l2 = 4 * t2;
          Yg[l2 + 0] = r2, Yg[l2 + 1] = n2, Yg[l2 + 2] = i2, Yg[l2 + 3] = s2;
        }
        const Zg = new Uint16Array(2178), Hg = new Uint8Array(1089), Kg = new Uint16Array(1089);
        function Wg(t2) {
          return 0 === t2 ? -0.03125 : 32 === t2 ? 0.03125 : 0;
        }
        var Jg = Rl([{ name: "a_pos", type: "Int16", components: 2 }, { name: "a_texture_pos", type: "Int16", components: 2 }]);
        class Qg {
          constructor(t2, e2, r2, n2) {
            this.id = Qg.uniqueIdxCounter, Qg.uniqueIdxCounter++, this.context = t2;
            const i2 = t2.gl;
            this.buffer = i2.createBuffer(), this.dynamicDraw = Boolean(r2), this.context.unbindVAO(), t2.bindElementBuffer.set(this.buffer), i2.bufferData(i2.ELEMENT_ARRAY_BUFFER, e2.arrayBuffer, this.dynamicDraw ? i2.DYNAMIC_DRAW : i2.STATIC_DRAW), this.dynamicDraw || n2 || e2.destroy();
          }
          bind() {
            this.context.bindElementBuffer.set(this.buffer);
          }
          updateData(t2) {
            this.id = Qg.uniqueIdxCounter, Qg.uniqueIdxCounter++;
            const e2 = this.context.gl;
            this.context.unbindVAO(), this.bind(), e2.bufferSubData(e2.ELEMENT_ARRAY_BUFFER, 0, t2.arrayBuffer);
          }
          destroy() {
            this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
          }
        }
        Qg.uniqueIdxCounter = 0;
        class tx {
          constructor(t2, e2, r2) {
            this.func = t2, this.mask = e2, this.range = r2;
          }
        }
        tx.ReadOnly = false, tx.ReadWrite = true, tx.disabled = new tx(519, tx.ReadOnly, [0, 1]);
        const ex = 7680;
        class rx {
          constructor(t2, e2, r2, n2, i2, s2) {
            this.test = t2, this.ref = e2, this.mask = r2, this.fail = n2, this.depthFail = i2, this.pass = s2;
          }
        }
        rx.disabled = new rx({ func: 519, mask: 0 }, 0, 0, ex, ex, ex);
        const nx = 771;
        class ix {
          constructor(t2, e2, r2, n2) {
            this.blendFunction = t2, this.blendColor = e2, this.mask = r2, this.blendEquation = n2;
          }
        }
        ix.Replace = [1, 0, 1, 0], ix.disabled = new ix(ix.Replace, Gn.transparent, [false, false, false, false]), ix.unblended = new ix(ix.Replace, Gn.transparent, [true, true, true, true]), ix.alphaBlended = new ix([1, nx, 1, nx], Gn.transparent, [true, true, true, true]), ix.alphaBlendedNonPremultiplied = new ix([770, nx, 770, nx], Gn.transparent, [true, true, true, true]), ix.multiply = new ix([774, 0, 774, 0], Gn.transparent, [true, true, true, true]);
        const sx = 1029, ax = 2305;
        class ox {
          constructor(t2, e2, r2) {
            this.enable = t2, this.mode = e2, this.frontFace = r2;
          }
        }
        ox.disabled = new ox(false, sx, ax), ox.backCCW = new ox(true, sx, ax), ox.backCW = new ox(true, sx, 2304), ox.frontCW = new ox(true, 1028, 2304), ox.frontCCW = new ox(true, 1028, ax);
        var lx = Rl([{ name: "a_index", type: "Int16", components: 1 }]);
        const ux = (() => ({ type: 2, extent: ds, loadGeometry: () => [[new je(0, 0), new je(ds + 1, 0), new je(ds + 1, ds + 1), new je(0, ds + 1), new je(0, 0)]] }))();
        class cx {
          constructor(t2, e2, r2, n2, i2) {
            this.tileID = t2, this.uid = ir(), this.uses = 0, this.tileSize = e2, this.tileZoom = r2, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = false, this.hasRTLText = false, this.dependencies = {}, this.isRaster = i2, n2 && n2.style && (this._lastUpdatedBrightness = n2.style.getBrightness()), this.expiredRequestCount = 0, this.state = "loading", n2 && n2.transform && (this.projection = n2.transform.projection);
          }
          registerFadeDuration(t2) {
            const e2 = t2 + this.timeAdded;
            e2 < Rr.now() || this.fadeEndTime && e2 < this.fadeEndTime || (this.fadeEndTime = e2);
          }
          wasRequested() {
            return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
          }
          get tileTransform() {
            return this._tileTransform || (this._tileTransform = cg(this.tileID.canonical, this.projection)), this._tileTransform;
          }
          loadVectorData(t2, e2, r2) {
            if (this.unloadVectorData(), this.state = "loaded", t2) {
              t2.featureIndex && (this.latestFeatureIndex = t2.featureIndex, t2.rawTileData ? (this.latestRawTileData = t2.rawTileData, this.latestFeatureIndex.rawTileData = t2.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t2.collisionBoxArray, this.buckets = function(t3, e3) {
                const r3 = {};
                if (!e3)
                  return r3;
                for (const n2 of t3) {
                  const t4 = n2.layerIds.map((t5) => e3.getLayer(t5)).filter(Boolean);
                  if (0 !== t4.length) {
                    n2.layers = t4, n2.stateDependentLayerIds && (n2.stateDependentLayers = n2.stateDependentLayerIds.map((e4) => t4.filter((t5) => t5.id === e4)[0]));
                    for (const e4 of t4)
                      r3[e4.fqid] = n2;
                  }
                }
                return r3;
              }(t2.buckets, e2.style), this.hasSymbolBuckets = false;
              for (const t3 in this.buckets) {
                const e3 = this.buckets[t3];
                if (e3 instanceof Ng) {
                  if (this.hasSymbolBuckets = true, !r2)
                    break;
                  e3.justReloaded = true;
                }
              }
              if (this.hasRTLText = false, this.hasSymbolBuckets)
                for (const t3 in this.buckets) {
                  const e3 = this.buckets[t3];
                  if (e3 instanceof Ng && e3.hasRTLText) {
                    this.hasRTLText = true, Ko.isLoading() || Ko.isLoaded() || "deferred" !== Zo() || Ho();
                    break;
                  }
                }
              this.queryPadding = 0;
              for (const t3 in this.buckets) {
                const r3 = this.buckets[t3], n2 = e2.style.getOwnLayer(t3);
                if (!n2)
                  continue;
                const i2 = n2.queryRadius(r3);
                this.queryPadding = Math.max(this.queryPadding, i2);
              }
              t2.imageAtlas && (this.imageAtlas = t2.imageAtlas), t2.glyphAtlasImage && (this.glyphAtlasImage = t2.glyphAtlasImage), t2.lineAtlas && (this.lineAtlas = t2.lineAtlas), this._lastUpdatedBrightness = t2.brightness;
            } else
              this.collisionBoxArray = new du();
          }
          unloadVectorData() {
            if (this.hasData()) {
              for (const t2 in this.buckets)
                this.buckets[t2].destroy();
              this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
            }
          }
          getBucket(t2) {
            return this.buckets[t2.fqid];
          }
          upload(t2) {
            for (const e3 in this.buckets) {
              const r3 = this.buckets[e3];
              r3.uploadPending() && r3.upload(t2);
            }
            const e2 = t2.gl, r2 = this.imageAtlas;
            if (r2 && !r2.uploaded) {
              const n2 = !!Object.keys(r2.patternPositions).length;
              this.imageAtlasTexture = new $g(t2, r2.image, e2.RGBA, { useMipmap: n2 }), this.imageAtlas.uploaded = true;
            }
            this.glyphAtlasImage && (this.glyphAtlasTexture = new $g(t2, this.glyphAtlasImage, e2.R8), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new $g(t2, this.lineAtlas.image, e2.R8), this.lineAtlas.uploaded = true);
          }
          prepare(t2, e2, r2) {
            if (this.imageAtlas && this.imageAtlasTexture && this.imageAtlas.patchUpdatedImages(t2, this.imageAtlasTexture, r2), !e2 || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData)
              return;
            const n2 = e2.style.getBrightness();
            (this._lastUpdatedBrightness || n2) && (this._lastUpdatedBrightness && n2 && Math.abs(this._lastUpdatedBrightness - n2) < 1e-3 || (this._lastUpdatedBrightness = n2, this.updateBuckets(void 0, e2)));
          }
          queryRenderedFeatures(t2, e2, r2, n2, i2, s2, a2, o2) {
            return this.latestFeatureIndex && (this.latestFeatureIndex.rawTileData || this.latestFeatureIndex.is3DTile) ? this.latestFeatureIndex.query({ tileResult: n2, pixelPosMatrix: a2, transform: s2, params: i2, tileTransform: this.tileTransform }, t2, e2, r2) : {};
          }
          querySourceFeatures(t2, e2) {
            const r2 = this.latestFeatureIndex;
            if (!r2 || !r2.rawTileData)
              return;
            const n2 = r2.loadVTLayers(), i2 = e2 ? e2.sourceLayer : "", s2 = n2._geojsonTileLayer || n2[i2];
            if (!s2)
              return;
            const a2 = dl(e2 && e2.filter), { z: o2, x: l2, y: u2 } = this.tileID.canonical, c2 = { z: o2, x: l2, y: u2 };
            for (let e3 = 0; e3 < s2.length; e3++) {
              const n3 = s2.feature(e3);
              if (a2.needGeometry) {
                const t3 = Wc(n3, true);
                if (!a2.filter(new Wo(this.tileID.overscaledZ), t3, this.tileID.canonical))
                  continue;
              } else if (!a2.filter(new Wo(this.tileID.overscaledZ), n3))
                continue;
              const h2 = r2.getId(n3, i2), p2 = new jm(n3, o2, l2, u2, h2);
              p2.tile = c2, t2.push(p2);
            }
          }
          hasData() {
            return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
          }
          patternsLoaded() {
            return !!this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
          }
          setExpiryData(t2) {
            const e2 = this.expirationTime;
            if (t2.cacheControl) {
              const e3 = br(t2.cacheControl);
              e3["max-age"] && (this.expirationTime = Date.now() + 1e3 * e3["max-age"]);
            } else
              t2.expires && (this.expirationTime = new Date(t2.expires).getTime());
            if (this.expirationTime) {
              const t3 = Date.now();
              let r2 = false;
              if (this.expirationTime > t3)
                r2 = false;
              else if (e2)
                if (this.expirationTime < e2)
                  r2 = true;
                else {
                  const n2 = this.expirationTime - e2;
                  n2 ? this.expirationTime = t3 + Math.max(n2, 3e4) : r2 = true;
                }
              else
                r2 = true;
              r2 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
            }
          }
          getExpiryTimeout() {
            if (this.expirationTime)
              return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (/* @__PURE__ */ new Date()).getTime(), Math.pow(2, 31) - 1);
          }
          setFeatureState(t2, e2) {
            this.latestFeatureIndex && this.latestFeatureIndex.rawTileData && 0 !== Object.keys(t2).length && e2 && this.updateBuckets(t2, e2);
          }
          updateBuckets(t2, e2) {
            if (!this.latestFeatureIndex)
              return;
            const r2 = this.latestFeatureIndex.loadVTLayers(), n2 = e2.style.listImages(), i2 = e2.style.getBrightness();
            for (const s2 in this.buckets) {
              if (!e2.style.hasLayer(s2))
                continue;
              const a2 = this.buckets[s2], o2 = a2.layers[0].sourceLayer || "_geojsonTileLayer", l2 = r2[o2];
              let u2 = {};
              if (t2 && (u2 = t2[o2], !l2 || !u2 || 0 === Object.keys(u2).length))
                continue;
              if (a2.update(u2, l2, n2, this.imageAtlas && this.imageAtlas.patternPositions || {}, i2), a2 instanceof om || a2 instanceof ef) {
                const t3 = e2.style.getOwnSourceCache(a2.layers[0].source);
                e2._terrain && e2._terrain.enabled && t3 && a2.programConfigurations.needsUpload && e2._terrain._clearRenderCacheForTile(t3.id, this.tileID);
              }
              const c2 = e2 && e2.style && e2.style.getOwnLayer(s2);
              c2 && (this.queryPadding = Math.max(this.queryPadding, c2.queryRadius(a2)));
            }
          }
          holdingForFade() {
            return void 0 !== this.symbolFadeHoldUntil;
          }
          symbolFadeFinished() {
            return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < Rr.now();
          }
          clearFadeHold() {
            this.symbolFadeHoldUntil = void 0;
          }
          setHoldDuration(t2) {
            this.symbolFadeHoldUntil = Rr.now() + t2;
          }
          setTexture(t2, e2) {
            const r2 = e2.context, n2 = r2.gl;
            this.texture = this.texture || e2.getTileTexture(t2.width), this.texture && this.texture instanceof $g ? this.texture.update(t2, { useMipmap: true }) : (this.texture = new $g(r2, t2, n2.RGBA, { useMipmap: true }), this.texture.bind(n2.LINEAR, n2.CLAMP_TO_EDGE));
          }
          setDependencies(t2, e2) {
            const r2 = {};
            for (const t3 of e2)
              r2[t3] = true;
            this.dependencies[t2] = r2;
          }
          hasDependency(t2, e2) {
            for (const r2 of t2) {
              const t3 = this.dependencies[r2];
              if (t3) {
                for (const r3 of e2)
                  if (t3[r3])
                    return true;
              }
            }
            return false;
          }
          clearQueryDebugViz() {
          }
          _makeDebugTileBoundsBuffers(t2, e2) {
            if (!e2 || "mercator" === e2.name || this._tileDebugBuffer)
              return;
            const r2 = Kc(ux, this.tileID.canonical, this.tileTransform)[0], n2 = new Ll(), i2 = new ou();
            for (let t3 = 0; t3 < r2.length; t3++) {
              const { x: e3, y: s2 } = r2[t3];
              n2.emplaceBack(e3, s2), i2.emplaceBack(t3);
            }
            i2.emplaceBack(0), this._tileDebugIndexBuffer = t2.createIndexBuffer(i2), this._tileDebugBuffer = t2.createVertexBuffer(n2, Bh.members), this._tileDebugSegments = ku.simpleSegment(0, 0, n2.length, i2.length);
          }
          _makeTileBoundsBuffers(t2, e2) {
            if (this._tileBoundsBuffer || !e2 || "mercator" === e2.name)
              return;
            const r2 = Kc(ux, this.tileID.canonical, this.tileTransform)[0];
            let n2, i2;
            if (this.isRaster) {
              const t3 = function(t4, e3) {
                const r3 = cg(t4, e3), n3 = Math.pow(2, t4.z);
                for (let i4 = 0; i4 < Xg; i4++)
                  for (let s3 = 0; s3 < Xg; s3++) {
                    const a3 = Rc((t4.x + (s3 + Wg(s3)) / Gg) / n3), o3 = Cc((t4.y + (i4 + Wg(i4)) / Gg) / n3), l3 = e3.project(a3, o3), u2 = i4 * Xg + s3;
                    Zg[2 * u2 + 0] = Math.round((l3.x * r3.scale - r3.x) * ds), Zg[2 * u2 + 1] = Math.round((l3.y * r3.scale - r3.y) * ds);
                  }
                Hg.fill(0), Kg.fill(0);
                for (let t5 = 2045; t5 >= 0; t5--) {
                  const e4 = 4 * t5, r4 = Yg[e4 + 0], n4 = Yg[e4 + 1], i4 = Yg[e4 + 2], s3 = Yg[e4 + 3], a3 = r4 + i4 >> 1, o3 = n4 + s3 >> 1, l3 = a3 + o3 - n4, u2 = o3 + r4 - a3, c2 = n4 * Xg + r4, h2 = s3 * Xg + i4, p2 = o3 * Xg + a3, f2 = Math.hypot((Zg[2 * c2 + 0] + Zg[2 * h2 + 0]) / 2 - Zg[2 * p2 + 0], (Zg[2 * c2 + 1] + Zg[2 * h2 + 1]) / 2 - Zg[2 * p2 + 1]) >= 16;
                  Hg[p2] = Hg[p2] || (f2 ? 1 : 0), t5 < 1022 && (Hg[p2] = Hg[p2] || Hg[(n4 + u2 >> 1) * Xg + (r4 + l3 >> 1)] || Hg[(s3 + u2 >> 1) * Xg + (i4 + l3 >> 1)]);
                }
                const i3 = new Fl(), s2 = new tu();
                let a2 = 0;
                function o2(t5, e4) {
                  const r4 = e4 * Xg + t5;
                  return 0 === Kg[r4] && (i3.emplaceBack(Zg[2 * r4 + 0], Zg[2 * r4 + 1], t5 * ds / Gg, e4 * ds / Gg), Kg[r4] = ++a2), Kg[r4] - 1;
                }
                function l2(t5, e4, r4, n4, i4, a3) {
                  const u2 = t5 + r4 >> 1, c2 = e4 + n4 >> 1;
                  if (Math.abs(t5 - i4) + Math.abs(e4 - a3) > 1 && Hg[c2 * Xg + u2])
                    l2(i4, a3, t5, e4, u2, c2), l2(r4, n4, i4, a3, u2, c2);
                  else {
                    const l3 = o2(t5, e4), u3 = o2(r4, n4), c3 = o2(i4, a3);
                    s2.emplaceBack(l3, u3, c3);
                  }
                }
                return l2(0, 0, Gg, Gg, Gg, 0), l2(Gg, Gg, 0, 0, 0, Gg), { vertices: i3, indices: s2 };
              }(this.tileID.canonical, e2);
              n2 = t3.vertices, i2 = t3.indices;
            } else {
              n2 = new Fl(), i2 = new tu();
              for (const { x: t4, y: e3 } of r2)
                n2.emplaceBack(t4, e3, 0, 0);
              const t3 = Ip(n2.int16, void 0, 4);
              for (let e3 = 0; e3 < t3.length; e3 += 3)
                i2.emplaceBack(t3[e3], t3[e3 + 1], t3[e3 + 2]);
            }
            this._tileBoundsBuffer = t2.createVertexBuffer(n2, Jg.members), this._tileBoundsIndexBuffer = t2.createIndexBuffer(i2), this._tileBoundsSegments = ku.simpleSegment(0, 0, n2.length, i2.length);
          }
          _makeGlobeTileDebugBuffers(e2, r2) {
            const n2 = r2.projection;
            if (!n2 || "globe" !== n2.name || r2.freezeTileCoverage)
              return;
            const i2 = this.tileID.canonical, s2 = Zh(Uh(i2, r2)), a2 = Qh(r2.zoom);
            let o2;
            a2 > 0 && (o2 = t.ae.invert(new Float64Array(16), r2.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(e2, i2, r2, s2, o2, a2), this._makeGlobeTileDebugTextBuffer(e2, i2, r2, s2, o2, a2);
          }
          _globePoint(e2, r2, n2, i2, s2, a2, o2) {
            let l2 = Gh(e2, r2, n2);
            if (a2) {
              const s3 = 1 << n2.z, u2 = Ec(i2.center.lng), c2 = Bc(i2.center.lat), h2 = (n2.x + 0.5) / s3 - u2;
              let p2 = 0;
              h2 > 0.5 ? p2 = -1 : h2 < -0.5 && (p2 = 1);
              let f2 = (e2 / ds + n2.x) / s3 + p2, d2 = (r2 / ds + n2.y) / s3;
              f2 = (f2 - u2) * i2._pixelsPerMercatorPixel + u2, d2 = (d2 - c2) * i2._pixelsPerMercatorPixel + c2;
              const m2 = [f2 * i2.worldSize, d2 * i2.worldSize, 0];
              t.$.transformMat4(m2, m2, a2), l2 = Oh(l2, m2, o2);
            }
            return t.$.transformMat4(l2, l2, s2);
          }
          _makeGlobeTileDebugBorderBuffer(t2, e2, r2, n2, i2, s2) {
            const a2 = new Ll(), o2 = new ou(), l2 = new Vl(), u2 = (t3, u3, c3, h2, p2) => {
              const f2 = (c3 - t3) / (p2 - 1), d2 = (h2 - u3) / (p2 - 1), m2 = a2.length;
              for (let c4 = 0; c4 < p2; c4++) {
                const h3 = t3 + c4 * f2, p3 = u3 + c4 * d2;
                a2.emplaceBack(h3, p3);
                const y2 = this._globePoint(h3, p3, e2, r2, n2, i2, s2);
                l2.emplaceBack(y2[0], y2[1], y2[2]), o2.emplaceBack(m2 + c4);
              }
            }, c2 = ds;
            u2(0, 0, c2, 0, 16), u2(c2, 0, c2, c2, 16), u2(c2, c2, 0, c2, 16), u2(0, c2, 0, 0, 16), this._tileDebugIndexBuffer = t2.createIndexBuffer(o2), this._tileDebugBuffer = t2.createVertexBuffer(a2, Bh.members), this._globeTileDebugBorderBuffer = t2.createVertexBuffer(l2, Eh.members), this._tileDebugSegments = ku.simpleSegment(0, 0, a2.length, o2.length);
          }
          _makeGlobeTileDebugTextBuffer(t2, e2, r2, n2, i2, s2) {
            const a2 = ds / 4, o2 = new Ll(), l2 = new tu(), u2 = new Vl(), c2 = 25;
            l2.reserve(32), o2.reserve(c2), u2.reserve(c2);
            const h2 = (t3, e3) => c2 * t3 + e3;
            for (let t3 = 0; t3 < c2; t3++) {
              const l3 = t3 * a2;
              for (let t4 = 0; t4 < c2; t4++) {
                const c3 = t4 * a2;
                o2.emplaceBack(c3, l3);
                const h3 = this._globePoint(c3, l3, e2, r2, n2, i2, s2);
                u2.emplaceBack(h3[0], h3[1], h3[2]);
              }
            }
            for (let t3 = 0; t3 < 4; t3++)
              for (let e3 = 0; e3 < 4; e3++) {
                const r3 = h2(t3, e3), n3 = h2(t3, e3 + 1), i3 = h2(t3 + 1, e3), s3 = h2(t3 + 1, e3 + 1);
                l2.emplaceBack(r3, n3, i3), l2.emplaceBack(i3, n3, s3);
              }
            this._tileDebugTextIndexBuffer = t2.createIndexBuffer(l2), this._tileDebugTextBuffer = t2.createVertexBuffer(o2, Bh.members), this._globeTileDebugTextBuffer = t2.createVertexBuffer(u2, Eh.members), this._tileDebugTextSegments = ku.simpleSegment(0, 0, c2, 32);
          }
          destroy(t2 = false) {
            for (const t3 in this.buckets)
              this.buckets[t3].destroy();
            this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture.destroy(), delete this.imageAtlasTexture), this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), !t2 && this.texture && this.texture instanceof $g && (this.texture.destroy(), delete this.texture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.rasterParticleState && (this.rasterParticleState.destroy(), delete this.rasterParticleState), this.latestFeatureIndex = null, this.state = "unloaded";
          }
        }
        function hx(t2, e2, r2) {
          1 === t2 ? e2.header_length = r2.readFixed32() : 2 === t2 ? e2.x = r2.readVarint() : 3 === t2 ? e2.y = r2.readVarint() : 4 === t2 ? e2.z = r2.readVarint() : 5 === t2 && e2.layers.push(function(t3, e3) {
            return t3.readFields(yx, { version: 0, name: "", units: "", tilesize: 0, buffer: 0, pixel_format: 0, data_index: [] }, e3);
          }(r2, r2.readVarint() + r2.pos));
        }
        function px(t2, e2, r2) {
          1 === t2 ? (e2.delta_filter = function(t3, e3) {
            return t3.readFields(fx, { block_size: 0 }, e3);
          }(r2, r2.readVarint() + r2.pos), e2.filter = "delta_filter") : 2 === t2 ? (r2.readVarint(), e2.filter = "zigzag_filter") : 3 === t2 ? (r2.readVarint(), e2.filter = "bitshuffle_filter") : 4 === t2 && (r2.readVarint(), e2.filter = "byteshuffle_filter");
        }
        function fx(t2, e2, r2) {
          1 === t2 && (e2.block_size = r2.readVarint());
        }
        function dx(t2, e2, r2) {
          1 === t2 ? (r2.readVarint(), e2.codec = "gzip_data") : 2 === t2 ? (r2.readVarint(), e2.codec = "jpeg_image") : 3 === t2 ? (r2.readVarint(), e2.codec = "webp_image") : 4 === t2 && (r2.readVarint(), e2.codec = "png_image");
        }
        function mx(t2, e2, r2) {
          1 === t2 ? e2.first_byte = r2.readFixed64() : 2 === t2 ? e2.last_byte = r2.readFixed64() : 3 === t2 ? e2.filters.push(function(t3, e3) {
            return t3.readFields(px, {}, e3);
          }(r2, r2.readVarint() + r2.pos)) : 4 === t2 ? e2.codec = function(t3, e3) {
            return t3.readFields(dx, {}, e3);
          }(r2, r2.readVarint() + r2.pos) : 5 === t2 ? e2.deprecated_offset = r2.readFloat() : 6 === t2 ? e2.deprecated_scale = r2.readFloat() : 7 === t2 ? e2.bands.push(r2.readString()) : 8 === t2 ? e2.offset = r2.readDouble() : 9 === t2 && (e2.scale = r2.readDouble());
        }
        function yx(t2, e2, r2) {
          1 === t2 ? e2.version = r2.readVarint() : 2 === t2 ? e2.name = r2.readString() : 3 === t2 ? e2.units = r2.readString() : 4 === t2 ? e2.tilesize = r2.readVarint() : 5 === t2 ? e2.buffer = r2.readVarint() : 6 === t2 ? e2.pixel_format = r2.readVarint() : 7 === t2 && e2.data_index.push(function(t3, e3) {
            return t3.readFields(mx, { first_byte: 0, last_byte: 0, filters: [], codec: null, offset: 0, scale: 0, deprecated_offset: 0, deprecated_scale: 0, bands: [] }, e3);
          }(r2, r2.readVarint() + r2.pos));
        }
        function gx(t2, e2, r2) {
          if (2 === t2)
            !function(t3, e3, r3) {
              t3.readFields(xx, r3, e3);
            }(r2, r2.readVarint() + r2.pos, e2);
          else if (3 === t2)
            throw new Error("Not implemented");
        }
        function xx(t2, e2, r2) {
          if (1 === t2) {
            let t3 = 0;
            const n2 = r2.readVarint() + r2.pos;
            for (; r2.pos < n2; )
              e2[t3++] = r2.readVarint();
          }
        }
        class bx {
          constructor(t2) {
            this.capacity = t2, this.cache = /* @__PURE__ */ new Map();
          }
          get(t2) {
            if (!this.cache.has(t2))
              return;
            const e2 = this.cache.get(t2);
            return this.cache.delete(t2), this.cache.set(t2, e2), e2;
          }
          put(t2, e2) {
            this.cache.has(t2) ? this.cache.delete(t2) : this.cache.size === this.capacity && this.cache.delete(this.cache.keys().next().value), this.cache.set(t2, e2);
          }
        }
        function vx(t2, e2) {
          if (4 !== e2.length)
            throw new Error(`Expected data of dimension 4 but got ${e2.length}.`);
          let r2 = e2[3];
          for (let n2 = 2; n2 >= 1; n2--) {
            const i2 = 1 === n2 ? 1 : 0, s2 = 2 === n2 ? 1 : 0;
            for (let n3 = 0; n3 < e2[0]; n3++) {
              const a2 = e2[1] * n3;
              for (let n4 = i2; n4 < e2[1]; n4++) {
                const i3 = e2[2] * (n4 + a2);
                for (let n5 = s2; n5 < e2[2]; n5++) {
                  const s3 = e2[3] * (n5 + i3);
                  for (let n6 = 0; n6 < e2[3]; n6++) {
                    const e3 = s3 + n6;
                    t2[e3] += t2[e3 - r2];
                  }
                }
              }
            }
            r2 *= e2[n2];
          }
          return t2;
        }
        function _x(t2) {
          for (let e2 = 0, r2 = t2.length; e2 < r2; e2++)
            t2[e2] = t2[e2] >>> 1 ^ -(1 & t2[e2]);
          return t2;
        }
        function wx(t2, e2) {
          switch (e2) {
            case "uint32":
              return t2;
            case "uint16":
              for (let e3 = 0; e3 < t2.length; e3 += 2) {
                const r2 = t2[e3], n2 = t2[e3 + 1];
                t2[e3] = (240 & r2) >> 4 | (61440 & r2) >> 8 | (240 & n2) << 4 | 61440 & n2, t2[e3 + 1] = 15 & r2 | (3840 & r2) >> 4 | (15 & n2) << 8 | (3840 & n2) << 4;
              }
              return t2;
            case "uint8":
              for (let e3 = 0; e3 < t2.length; e3 += 4) {
                const r2 = t2[e3], n2 = t2[e3 + 1], i2 = t2[e3 + 2], s2 = t2[e3 + 3];
                t2[e3 + 0] = (192 & r2) >> 6 | (192 & n2) >> 4 | (192 & i2) >> 2 | 192 & s2, t2[e3 + 1] = (48 & r2) >> 4 | (48 & n2) >> 2 | 48 & i2 | (48 & s2) << 2, t2[e3 + 2] = (12 & r2) >> 2 | 12 & n2 | (12 & i2) << 2 | (12 & s2) << 4, t2[e3 + 3] = 3 & r2 | (3 & n2) << 2 | (3 & i2) << 4 | (3 & s2) << 6;
              }
              return t2;
            default:
              throw new Error(`Invalid pixel format, "${e2}"`);
          }
        }
        var Mx = Uint8Array, Ax = Uint16Array, Sx = Int32Array, Ix = new Mx([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), Tx = new Mx([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), kx = new Mx([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), Px = function(t2, e2) {
          for (var r2 = new Ax(31), n2 = 0; n2 < 31; ++n2)
            r2[n2] = e2 += 1 << t2[n2 - 1];
          var i2 = new Sx(r2[30]);
          for (n2 = 1; n2 < 30; ++n2)
            for (var s2 = r2[n2]; s2 < r2[n2 + 1]; ++s2)
              i2[s2] = s2 - r2[n2] << 5 | n2;
          return { b: r2, r: i2 };
        }, zx = Px(Ix, 2), Ex = zx.b, Bx = zx.r;
        Ex[28] = 258, Bx[258] = 28;
        for (var Dx = Px(Tx, 0).b, Rx = new Ax(32768), Cx = 0; Cx < 32768; ++Cx) {
          var Lx = (43690 & Cx) >> 1 | (21845 & Cx) << 1;
          Rx[Cx] = ((65280 & (Lx = (61680 & (Lx = (52428 & Lx) >> 2 | (13107 & Lx) << 2)) >> 4 | (3855 & Lx) << 4)) >> 8 | (255 & Lx) << 8) >> 1;
        }
        var Vx = function(t2, e2, r2) {
          for (var n2 = t2.length, i2 = 0, s2 = new Ax(e2); i2 < n2; ++i2)
            t2[i2] && ++s2[t2[i2] - 1];
          var a2, o2 = new Ax(e2);
          for (i2 = 1; i2 < e2; ++i2)
            o2[i2] = o2[i2 - 1] + s2[i2 - 1] << 1;
          a2 = new Ax(1 << e2);
          var l2 = 15 - e2;
          for (i2 = 0; i2 < n2; ++i2)
            if (t2[i2])
              for (var u2 = i2 << 4 | t2[i2], c2 = e2 - t2[i2], h2 = o2[t2[i2] - 1]++ << c2, p2 = h2 | (1 << c2) - 1; h2 <= p2; ++h2)
                a2[Rx[h2] >> l2] = u2;
          return a2;
        }, Fx = new Mx(288);
        for (Cx = 0; Cx < 144; ++Cx)
          Fx[Cx] = 8;
        for (Cx = 144; Cx < 256; ++Cx)
          Fx[Cx] = 9;
        for (Cx = 256; Cx < 280; ++Cx)
          Fx[Cx] = 7;
        for (Cx = 280; Cx < 288; ++Cx)
          Fx[Cx] = 8;
        var Ox = new Mx(32);
        for (Cx = 0; Cx < 32; ++Cx)
          Ox[Cx] = 5;
        var Ux = Vx(Fx, 9), jx = Vx(Ox, 5), Nx = function(t2) {
          for (var e2 = t2[0], r2 = 1; r2 < t2.length; ++r2)
            t2[r2] > e2 && (e2 = t2[r2]);
          return e2;
        }, $x = function(t2, e2, r2) {
          var n2 = e2 / 8 | 0;
          return (t2[n2] | t2[n2 + 1] << 8) >> (7 & e2) & r2;
        }, qx = function(t2, e2) {
          var r2 = e2 / 8 | 0;
          return (t2[r2] | t2[r2 + 1] << 8 | t2[r2 + 2] << 16) >> (7 & e2);
        }, Gx = ["unexpected EOF", "invalid block type", "invalid length/literal", "invalid distance", "stream finished", "no stream handler", , "no callback", "invalid UTF-8 data", "extra field too long", "date not in range 1980-2099", "filename too long", "stream finishing", "invalid zip data"], Xx = function(t2, e2, r2) {
          var n2 = new Error(e2 || Gx[t2]);
          if (n2.code = t2, Error.captureStackTrace && Error.captureStackTrace(n2, Xx), !r2)
            throw n2;
          return n2;
        }, Yx = new Mx(0), Zx = "undefined" != typeof TextDecoder && new TextDecoder();
        try {
          Zx.decode(Yx, { stream: true });
        } catch (t2) {
        }
        const Hx = { gzip_data: "gzip" };
        class Kx extends Error {
          constructor(t2) {
            super(t2), this.name = "MRTError";
          }
        }
        const Wx = { 0: "uint32", 1: "uint32", 2: "uint16", 3: "uint8" }, Jx = { uint32: 1, uint16: 2, uint8: 4 }, Qx = { uint32: Uint32Array, uint16: Uint16Array, uint8: Uint8Array };
        let tb, eb;
        class rb {
          constructor(t2 = 5) {
            this.x = NaN, this.y = NaN, this.z = NaN, this.layers = {}, this._cacheSize = t2;
          }
          getLayer(t2) {
            const e2 = this.layers[t2];
            if (!e2)
              throw new Kx(`Layer '${t2}' not found`);
            return e2;
          }
          getHeaderLength(t2) {
            const e2 = new Uint8Array(t2), r2 = new DataView(t2);
            if (13 !== e2[0])
              throw new Kx("File is not a valid MRT.");
            return r2.getUint32(1, true);
          }
          parseHeader(t2) {
            const e2 = new Uint8Array(t2), r2 = this.getHeaderLength(t2);
            if (e2.length < r2)
              throw new Kx(`Expected header with length >= ${r2} but got buffer of length ${e2.length}`);
            const n2 = function(t3, e3) {
              return t3.readFields(hx, { header_length: 0, x: 0, y: 0, z: 0, layers: [] }, void 0);
            }(new tb(e2.subarray(0, r2)));
            if (!isNaN(this.x) && (this.x !== n2.x || this.y !== n2.y || this.z !== n2.z))
              throw new Kx(`Invalid attempt to parse header ${n2.z}/${n2.x}/${n2.y} for tile ${this.z}/${this.x}/${this.y}`);
            this.x = n2.x, this.y = n2.y, this.z = n2.z;
            for (const t3 of n2.layers)
              this.layers[t3.name] = new nb(t3, { cacheSize: this._cacheSize });
            return this;
          }
          createDecodingTask(t2) {
            const e2 = [], r2 = this.getLayer(t2.layerName);
            for (let n2 of t2.blockIndices) {
              const i2 = r2.dataIndex[n2], s2 = i2.first_byte - t2.firstByte, a2 = i2.last_byte - t2.firstByte;
              if (r2._blocksInProgress.has(n2))
                continue;
              const o2 = { layerName: r2.name, firstByte: s2, lastByte: a2, pixelFormat: r2.pixelFormat, blockIndex: n2, blockShape: [i2.bands.length].concat(r2.bandShape), buffer: r2.buffer, codec: i2.codec.codec, filters: i2.filters.map((t3) => t3.filter) };
              r2._blocksInProgress.add(n2), e2.push(o2);
            }
            return new ib(e2, () => {
              e2.forEach((t3) => r2._blocksInProgress.delete(t3.blockIndex));
            }, (t3, n2) => {
              if (e2.forEach((t4) => r2._blocksInProgress.delete(t4.blockIndex)), t3)
                throw t3;
              n2.forEach((t4) => {
                this.getLayer(t4.layerName).processDecodedData(t4);
              });
            });
          }
        }
        class nb {
          constructor({ version: t2, name: e2, units: r2, tilesize: n2, pixel_format: i2, buffer: s2, data_index: a2 }, o2) {
            if (this.version = t2, 1 !== this.version)
              throw new Kx(`Cannot parse raster layer encoded with MRT version ${t2}`);
            this.name = e2, this.units = r2, this.tileSize = n2, this.buffer = s2, this.pixelFormat = Wx[i2], this.dataIndex = a2, this.bandShape = [n2 + 2 * s2, n2 + 2 * s2, Jx[this.pixelFormat]], this._decodedBlocks = new bx(o2 ? o2.cacheSize : 5), this._blocksInProgress = /* @__PURE__ */ new Set();
          }
          get dimension() {
            return Jx[this.pixelFormat];
          }
          get cacheSize() {
            return this._decodedBlocks.capacity;
          }
          getBandList() {
            return this.dataIndex.map(({ bands: t2 }) => t2).flat();
          }
          processDecodedData(t2) {
            const e2 = t2.blockIndex.toString();
            this._decodedBlocks.get(e2) || this._decodedBlocks.put(e2, t2.data);
          }
          getBlockForBand(t2) {
            let e2 = 0;
            switch (typeof t2) {
              case "string":
                for (const [r2, n2] of this.dataIndex.entries()) {
                  for (const [i2, s2] of n2.bands.entries())
                    if (s2 === t2)
                      return { bandIndex: e2 + i2, blockIndex: r2, blockBandIndex: i2 };
                  e2 += n2.bands.length;
                }
                break;
              case "number":
                for (const [r2, n2] of this.dataIndex.entries()) {
                  if (t2 >= e2 && t2 < e2 + n2.bands.length)
                    return { bandIndex: t2, blockIndex: r2, blockBandIndex: t2 - e2 };
                  e2 += n2.bands.length;
                }
                break;
              default:
                throw new Kx(`Invalid band \`${JSON.stringify(t2)}\`. Expected string or integer.`);
            }
            throw new Kx(`Band not found: ${JSON.stringify(t2)}`);
          }
          getDataRange(t2) {
            let e2 = 1 / 0, r2 = -1 / 0;
            const n2 = [], i2 = /* @__PURE__ */ new Set();
            for (const s2 of t2) {
              const { blockIndex: t3 } = this.getBlockForBand(s2);
              if (t3 < 0)
                throw new Kx(`Invalid band: ${JSON.stringify(s2)}`);
              const a2 = this.dataIndex[t3];
              n2.includes(t3) || n2.push(t3), i2.add(t3), e2 = Math.min(e2, a2.first_byte), r2 = Math.max(r2, a2.last_byte);
            }
            if (i2.size > this.cacheSize)
              throw new Kx(`Number of blocks to decode (${i2.size}) exceeds cache size (${this.cacheSize}).`);
            return { layerName: this.name, firstByte: e2, lastByte: r2, blockIndices: n2 };
          }
          hasBand(t2) {
            const { blockIndex: e2 } = this.getBlockForBand(t2);
            return e2 >= 0;
          }
          hasDataForBand(t2) {
            const { blockIndex: e2 } = this.getBlockForBand(t2);
            return e2 >= 0 && !!this._decodedBlocks.get(e2.toString());
          }
          getBandView(t2) {
            const { blockIndex: e2, blockBandIndex: r2 } = this.getBlockForBand(t2), n2 = this._decodedBlocks.get(e2.toString());
            if (!n2)
              throw new Kx(`Data for band ${JSON.stringify(t2)} of layer "${this.name}" not decoded.`);
            const i2 = this.dataIndex[e2], s2 = this.bandShape.reduce((t3, e3) => t3 * e3, 1), a2 = r2 * s2, o2 = n2.subarray(a2, a2 + s2);
            return { data: o2, bytes: new Uint8Array(o2.buffer).subarray(o2.byteOffset, o2.byteOffset + o2.byteLength), tileSize: this.tileSize, buffer: this.buffer, pixelFormat: this.pixelFormat, dimension: this.dimension, offset: 0 !== i2.offset ? i2.offset : i2.deprecated_offset, scale: 0 !== i2.scale ? i2.scale : i2.deprecated_scale };
          }
        }
        rb.setPbf = function(t2) {
          tb = t2;
        };
        class ib {
          constructor(t2, e2, r2) {
            this.tasks = t2, this._onCancel = e2, this._onComplete = r2, this._finalized = false;
          }
          cancel() {
            this._finalized || (this._onCancel(), this._finalized = true);
          }
          complete(t2, e2) {
            this._finalized || (this._onComplete(t2, e2), this._finalized = true);
          }
        }
        rb.performDecoding = function(t2, e2) {
          const r2 = new Uint8Array(t2);
          return Promise.all(e2.tasks.map((t3) => {
            const { layerName: e3, firstByte: n2, lastByte: i2, pixelFormat: s2, blockShape: a2, blockIndex: o2, filters: l2, codec: u2 } = t3, c2 = r2.subarray(n2, i2 + 1), h2 = new Uint32Array(a2[0] * a2[1] * a2[2]);
            let p2;
            if ("gzip_data" !== u2)
              throw new Kx(`Unhandled codec: ${u2}`);
            return p2 = function(t4, e4) {
              if (!globalThis.DecompressionStream && "gzip_data" === e4)
                return Promise.resolve(((s3 = function(t5) {
                  31 == t5[0] && 139 == t5[1] && 8 == t5[2] || Xx(6, "invalid gzip data");
                  var e5 = t5[3], r4 = 10;
                  4 & e5 && (r4 += 2 + (t5[10] | t5[11] << 8));
                  for (var n4 = (e5 >> 3 & 1) + (e5 >> 4 & 1); n4 > 0; n4 -= !t5[r4++])
                    ;
                  return r4 + (2 & e5);
                }(i3 = t4)) + 8 > i3.length && Xx(6, "invalid gzip data"), function(t5, e5, r4, n4) {
                  var i4 = t5.length;
                  if (!i4 || e5.f && !e5.l)
                    return r4 || new Mx(0);
                  var s4 = !r4, a4 = s4 || 2 != e5.i, o4 = e5.i;
                  s4 && (r4 = new Mx(3 * i4));
                  var l3, u3, c3 = function(t6) {
                    var e6 = r4.length;
                    if (t6 > e6) {
                      var n5 = new Mx(Math.max(2 * e6, t6));
                      n5.set(r4), r4 = n5;
                    }
                  }, h3 = e5.f || 0, p3 = e5.p || 0, f2 = e5.b || 0, d2 = e5.l, m2 = e5.d, y2 = e5.m, g2 = e5.n, x2 = 8 * i4;
                  do {
                    if (!d2) {
                      h3 = $x(t5, p3, 1);
                      var b2 = $x(t5, p3 + 1, 3);
                      if (p3 += 3, !b2) {
                        var v2 = t5[(E2 = 4 + ((p3 + 7) / 8 | 0)) - 4] | t5[E2 - 3] << 8, _2 = E2 + v2;
                        if (_2 > i4) {
                          o4 && Xx(0);
                          break;
                        }
                        a4 && c3(f2 + v2), r4.set(t5.subarray(E2, _2), f2), e5.b = f2 += v2, e5.p = p3 = 8 * _2, e5.f = h3;
                        continue;
                      }
                      if (1 == b2)
                        d2 = Ux, m2 = jx, y2 = 9, g2 = 5;
                      else if (2 == b2) {
                        var w2 = $x(t5, p3, 31) + 257, M2 = $x(t5, p3 + 10, 15) + 4, A2 = w2 + $x(t5, p3 + 5, 31) + 1;
                        p3 += 14;
                        for (var S2 = new Mx(A2), I2 = new Mx(19), T2 = 0; T2 < M2; ++T2)
                          I2[kx[T2]] = $x(t5, p3 + 3 * T2, 7);
                        p3 += 3 * M2;
                        var k2 = Nx(I2), P2 = (1 << k2) - 1, z2 = Vx(I2, k2);
                        for (T2 = 0; T2 < A2; ) {
                          var E2, B2 = z2[$x(t5, p3, P2)];
                          if (p3 += 15 & B2, (E2 = B2 >> 4) < 16)
                            S2[T2++] = E2;
                          else {
                            var D2 = 0, R2 = 0;
                            for (16 == E2 ? (R2 = 3 + $x(t5, p3, 3), p3 += 2, D2 = S2[T2 - 1]) : 17 == E2 ? (R2 = 3 + $x(t5, p3, 7), p3 += 3) : 18 == E2 && (R2 = 11 + $x(t5, p3, 127), p3 += 7); R2--; )
                              S2[T2++] = D2;
                          }
                        }
                        var C2 = S2.subarray(0, w2), L2 = S2.subarray(w2);
                        y2 = Nx(C2), g2 = Nx(L2), d2 = Vx(C2, y2), m2 = Vx(L2, g2);
                      } else
                        Xx(1);
                      if (p3 > x2) {
                        o4 && Xx(0);
                        break;
                      }
                    }
                    a4 && c3(f2 + 131072);
                    for (var V2 = (1 << y2) - 1, F2 = (1 << g2) - 1, O2 = p3; ; O2 = p3) {
                      var U2 = (D2 = d2[qx(t5, p3) & V2]) >> 4;
                      if ((p3 += 15 & D2) > x2) {
                        o4 && Xx(0);
                        break;
                      }
                      if (D2 || Xx(2), U2 < 256)
                        r4[f2++] = U2;
                      else {
                        if (256 == U2) {
                          O2 = p3, d2 = null;
                          break;
                        }
                        var j2 = U2 - 254;
                        U2 > 264 && (j2 = $x(t5, p3, (1 << (q2 = Ix[T2 = U2 - 257])) - 1) + Ex[T2], p3 += q2);
                        var N2 = m2[qx(t5, p3) & F2], $2 = N2 >> 4;
                        if (N2 || Xx(3), p3 += 15 & N2, L2 = Dx[$2], $2 > 3) {
                          var q2 = Tx[$2];
                          L2 += qx(t5, p3) & (1 << q2) - 1, p3 += q2;
                        }
                        if (p3 > x2) {
                          o4 && Xx(0);
                          break;
                        }
                        a4 && c3(f2 + 131072);
                        var G2 = f2 + j2;
                        if (f2 < L2) {
                          var X2 = 0 - L2, Y2 = Math.min(L2, G2);
                          for (X2 + f2 < 0 && Xx(3); f2 < Y2; ++f2)
                            r4[f2] = (void 0)[X2 + f2];
                        }
                        for (; f2 < G2; ++f2)
                          r4[f2] = r4[f2 - L2];
                      }
                    }
                    e5.l = d2, e5.p = O2, e5.b = f2, e5.f = h3, d2 && (h3 = 1, e5.m = y2, e5.d = m2, e5.n = g2);
                  } while (!h3);
                  return f2 != r4.length && s4 ? (l3 = r4, (null == (u3 = f2) || u3 > l3.length) && (u3 = l3.length), new Mx(l3.subarray(0, u3))) : r4.subarray(0, f2);
                }(i3.subarray(s3, -8), { i: 2 }, new Mx(((r3 = i3)[(n3 = r3.length) - 4] | r3[n3 - 3] << 8 | r3[n3 - 2] << 16 | r3[n3 - 1] << 24) >>> 0))));
              var r3, n3, i3, s3;
              const a3 = Hx[e4];
              if (!a3)
                throw new Error(`Unhandled codec: ${e4}`);
              const o3 = new globalThis.DecompressionStream(a3);
              return new Response(new Blob([t4]).stream().pipeThrough(o3)).arrayBuffer().then((t5) => new Uint8Array(t5));
            }(c2, u2).then((t4) => (function(t5, e4) {
              t5.readFields(gx, e4);
            }(new tb(t4), h2), new (0, Qx[s2])(h2.buffer))), p2.then((t4) => {
              for (let e4 = l2.length - 1; e4 >= 0; e4--)
                switch (l2[e4]) {
                  case "delta_filter":
                    vx(t4, a2);
                    break;
                  case "zigzag_filter":
                    _x(t4);
                    break;
                  case "bitshuffle_filter":
                    wx(t4, s2);
                    break;
                  default:
                    throw new Kx(`Unhandled filter "${l2[e4]}"`);
                }
              return { layerName: e3, blockIndex: o2, data: t4 };
            }).catch((t4) => {
              throw t4;
            });
          }));
        }, rb.setPbf(Om);
        class sb extends cx {
          constructor(t2, e2, r2, n2, i2) {
            super(t2, e2, r2, n2, i2), this._workQueue = [], this._fetchQueue = [], this._isHeaderLoaded = false;
          }
          setTexture(t2, e2) {
            const r2 = e2.context, n2 = r2.gl;
            this.texture = this.texture || e2.getTileTexture(t2.width), this.texture && this.texture instanceof $g ? this.texture.update(t2, { useMipmap: false, premultiply: false }) : this.texture = new $g(r2, t2, n2.RGBA, { useMipmap: false, premultiply: false });
          }
          flushQueues() {
            for (; this._workQueue.length; )
              this._workQueue.pop()();
            for (; this._fetchQueue.length; )
              this._fetchQueue.pop()();
          }
          fetchHeader(t2 = 16384, e2) {
            const r2 = this._mrt = new rb(30), n2 = Object.assign({}, this.requestParams, { headers: { Range: "bytes=0-" + (t2 - 1) } });
            return this.entireBuffer = null, this.request = nn(n2, (n3, i2, s2, a2) => {
              if (n3)
                e2(n3);
              else
                try {
                  const n4 = r2.getHeaderLength(i2);
                  if (n4 > t2)
                    return void (this.request = this.fetchHeader(n4, e2));
                  r2.parseHeader(i2), this._isHeaderLoaded = true;
                  let o2 = 0;
                  for (const t3 of Object.values(r2.layers))
                    o2 = Math.max(o2, t3.dataIndex[t3.dataIndex.length - 1].last_byte);
                  i2.byteLength >= o2 && (this.entireBuffer = i2), e2(null, this.entireBuffer || i2, s2, a2);
                } catch (t3) {
                  e2(t3);
                }
            }), this.request;
          }
          fetchBand(t2, e2, r2) {
            const n2 = this._mrt;
            if (!this._isHeaderLoaded || !n2)
              return void r2(new Error("Tile header is not ready"));
            const i2 = this.actor;
            if (!i2)
              return void r2(new Error("Can't fetch tile band without an actor"));
            let s2;
            const a2 = (n3, i3) => {
              s2.complete(n3, i3), n3 ? r2(n3) : (this.updateTextureDescriptor(t2, e2), r2(null, this.textureDescriptor && this.textureDescriptor.img));
            }, o2 = (t3, e3) => {
              if (t3)
                return r2(t3);
              const n3 = i2.send("decodeRasterArray", { buffer: e3, task: s2 }, a2, void 0, true);
              this._workQueue.push(() => {
                n3 && n3.cancel(), s2.cancel();
              });
            }, l2 = n2.getLayer(t2);
            if (!l2)
              return void r2(new Error(`Unknown sourceLayer "${t2}"`));
            if (l2.hasDataForBand(e2))
              return this.updateTextureDescriptor(t2, e2), void r2(null, this.textureDescriptor ? this.textureDescriptor.img : null);
            const u2 = l2.getDataRange([e2]);
            if (s2 = n2.createDecodingTask(u2), !s2 || s2.tasks.length)
              if (this.flushQueues(), this.entireBuffer)
                o2(null, this.entireBuffer.slice(u2.firstByte, u2.lastByte + 1));
              else {
                const t3 = Object.assign({}, this.requestParams, { headers: { Range: `bytes=${u2.firstByte}-${u2.lastByte}` } }), e3 = nn(t3, o2);
                this._fetchQueue.push(() => {
                  e3.cancel(), s2.cancel();
                });
              }
            else
              r2(null);
          }
          updateNeeded(t2, e2) {
            return (!this.textureDescriptor || this.textureDescriptor.band !== e2 || this.textureDescriptor.layer !== t2) && "errored" !== this.state;
          }
          updateTextureDescriptor(t2, e2) {
            if (!this._mrt)
              return;
            const r2 = this._mrt.getLayer(t2);
            if (!r2 || !r2.hasBand(e2) || !r2.hasDataForBand(e2))
              return;
            const { bytes: n2, tileSize: i2, buffer: s2, offset: a2, scale: o2 } = r2.getBandView(e2), l2 = i2 + 2 * s2, u2 = { data: n2, width: l2, height: l2 }, c2 = this.texture;
            c2 && c2 instanceof $g && c2.update(u2, { useMipmap: false, premultiply: false }), this.textureDescriptor = { layer: t2, band: e2, img: u2, buffer: s2, offset: a2, tileSize: i2, format: r2.pixelFormat, mix: [o2, 256 * o2, 65536 * o2, 16777216 * o2] };
          }
        }
        class ab {
          constructor(t2, e2) {
            this.max = t2, this.onRemove = e2, this.reset();
          }
          reset() {
            for (const t2 in this.data)
              for (const e2 of this.data[t2])
                e2.timeout && clearTimeout(e2.timeout), this.onRemove(e2.value);
            return this.data = {}, this.order = [], this;
          }
          add(t2, e2, r2) {
            const n2 = t2.wrapped().key;
            void 0 === this.data[n2] && (this.data[n2] = []);
            const i2 = { value: e2, timeout: void 0 };
            if (void 0 !== r2 && (i2.timeout = setTimeout(() => {
              this.remove(t2, i2);
            }, r2)), this.data[n2].push(i2), this.order.push(n2), this.order.length > this.max) {
              const t3 = this._getAndRemoveByKey(this.order[0]);
              t3 && this.onRemove(t3);
            }
            return this;
          }
          has(t2) {
            return t2.wrapped().key in this.data;
          }
          getAndRemove(t2) {
            return this.has(t2) ? this._getAndRemoveByKey(t2.wrapped().key) : null;
          }
          _getAndRemoveByKey(t2) {
            const e2 = this.data[t2].shift();
            return e2.timeout && clearTimeout(e2.timeout), 0 === this.data[t2].length && delete this.data[t2], this.order.splice(this.order.indexOf(t2), 1), e2.value;
          }
          getByKey(t2) {
            const e2 = this.data[t2];
            return e2 ? e2[0].value : null;
          }
          get(t2) {
            return this.has(t2) ? this.data[t2.wrapped().key][0].value : null;
          }
          remove(t2, e2) {
            if (!this.has(t2))
              return this;
            const r2 = t2.wrapped().key, n2 = void 0 === e2 ? 0 : this.data[r2].indexOf(e2), i2 = this.data[r2][n2];
            return this.data[r2].splice(n2, 1), i2.timeout && clearTimeout(i2.timeout), 0 === this.data[r2].length && delete this.data[r2], this.onRemove(i2.value), this.order.splice(this.order.indexOf(r2), 1), this;
          }
          setMaxSize(t2) {
            for (this.max = t2; this.order.length > this.max; ) {
              const t3 = this._getAndRemoveByKey(this.order[0]);
              t3 && this.onRemove(t3);
            }
            return this;
          }
          filter(t2) {
            const e2 = [];
            for (const r2 in this.data)
              for (const n2 of this.data[r2])
                t2(n2.value) || e2.push(n2);
            for (const t3 of e2)
              this.remove(t3.value.tileID, t3);
          }
        }
        class ob extends On {
          constructor(t2, e2, r2) {
            super(), this.id = t2, this._onlySymbols = r2, e2.on("data", (t3) => {
              "source" === t3.dataType && "metadata" === t3.sourceDataType && (this._sourceLoaded = true), this._sourceLoaded && !this._paused && "source" === t3.dataType && "content" === t3.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
            }), e2.on("error", () => {
              this._sourceErrored = true;
            }), this._source = e2, this._tiles = {}, this._cache = new ab(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = e2.minTileCacheSize, this._maxTileCacheSize = e2.maxTileCacheSize, this._loadedParentTiles = {}, this.castsShadows = false, this.tileCoverLift = 0, this._coveredTiles = {}, this._shadowCasterTiles = {}, this._state = new Nm(), this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "raster-array" === this._source.type || "custom" === this._source.type && "raster" === this._source._dataType;
          }
          onAdd(t2) {
            this.map = t2, this._minTileCacheSize = void 0 === this._minTileCacheSize && t2 ? t2._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && t2 ? t2._maxTileCacheSize : this._maxTileCacheSize;
          }
          loaded() {
            if (this._sourceErrored)
              return true;
            if (!this._sourceLoaded)
              return false;
            if (!this._source.loaded())
              return false;
            for (const t2 in this._tiles) {
              const e2 = this._tiles[t2];
              if ("loaded" !== e2.state && "errored" !== e2.state)
                return false;
            }
            return true;
          }
          getSource() {
            return this._source;
          }
          pause() {
            this._paused = true;
          }
          resume() {
            if (!this._paused)
              return;
            const t2 = this._shouldReloadOnResume;
            this._paused = false, this._shouldReloadOnResume = false, t2 && this.reload(), this.transform && this.update(this.transform);
          }
          _loadTile(t2, e2) {
            return t2.isSymbolTile = this._onlySymbols, t2.isExtraShadowCaster = this._shadowCasterTiles[t2.tileID.key], this._source.loadTile(t2, e2);
          }
          _unloadTile(t2) {
            if (this._source.unloadTile)
              return this._source.unloadTile(t2);
          }
          _abortTile(t2) {
            if (this._source.abortTile)
              return this._source.abortTile(t2);
          }
          serialize() {
            return this._source.serialize();
          }
          prepare(t2) {
            this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
            for (const e2 in this._tiles) {
              const r2 = this._tiles[e2];
              r2.upload(t2), r2.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
            }
          }
          getIds() {
            return er(this._tiles).map((t2) => t2.tileID).sort(lb).map((t2) => t2.key);
          }
          getRenderableIds(t2, e2) {
            const r2 = [];
            for (const n2 in this._tiles)
              this._isIdRenderable(+n2, t2, e2) && r2.push(this._tiles[n2]);
            return t2 ? r2.sort((t3, e3) => {
              const r3 = t3.tileID, n2 = e3.tileID, i2 = new je(r3.canonical.x, r3.canonical.y)._rotate(this.transform.angle), s2 = new je(n2.canonical.x, n2.canonical.y)._rotate(this.transform.angle);
              return r3.overscaledZ - n2.overscaledZ || s2.y - i2.y || s2.x - i2.x;
            }).map((t3) => t3.tileID.key) : r2.map((t3) => t3.tileID).sort(lb).map((t3) => t3.key);
          }
          hasRenderableParent(t2) {
            const e2 = this.findLoadedParent(t2, 0);
            return !!e2 && this._isIdRenderable(e2.tileID.key);
          }
          _isIdRenderable(t2, e2, r2) {
            return this._tiles[t2] && this._tiles[t2].hasData() && !this._coveredTiles[t2] && (e2 || !this._tiles[t2].holdingForFade()) && (r2 || !this._shadowCasterTiles[t2]);
          }
          reload() {
            if (this._paused)
              this._shouldReloadOnResume = true;
            else {
              this._cache.reset();
              for (const t2 in this._tiles)
                "errored" !== this._tiles[t2].state && this._reloadTile(+t2, "reloading");
            }
          }
          _reloadTile(t2, e2) {
            const r2 = this._tiles[t2];
            r2 && ("loading" !== r2.state && (r2.state = e2), this._loadTile(r2, this._tileLoaded.bind(this, r2, t2, e2)));
          }
          _tileLoaded(t2, e2, r2, n2) {
            if (n2)
              if (t2.state = "errored", 404 !== n2.status)
                this._source.fire(new Ln(n2, { tile: t2 }));
              else {
                if (this._source.fire(new Cn("data", { dataType: "source", sourceDataType: "error", sourceId: this._source.id, tile: t2 })), !(t2.tileID.key in this._loadedParentTiles))
                  return;
                if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                  const t3 = this.map.painter.terrain;
                  this.update(this.transform, t3.getScaledDemTileSize(), true), t3.resetTileLookupCache(this.id);
                } else
                  this.update(this.transform);
              }
            else
              t2.timeAdded = Rr.now(), "expired" === r2 && (t2.refreshedUponExpiration = true), this._setTileReloadTimer(e2, t2), "raster-dem" === this._source.type && t2.dem && this._backfillDEM(t2), this._state.initializeTileState(t2, this.map ? this.map.painter : null), this._source.fire(new Cn("data", { dataType: "source", tile: t2, coord: t2.tileID, sourceCacheId: this.id }));
          }
          _backfillDEM(t2) {
            const e2 = this.getRenderableIds();
            for (let n2 = 0; n2 < e2.length; n2++) {
              const i2 = e2[n2];
              if (t2.neighboringTiles && t2.neighboringTiles[i2]) {
                const e3 = this.getTileByID(i2);
                r2(t2, e3), r2(e3, t2);
              }
            }
            function r2(t3, e3) {
              if (!t3.dem || t3.dem.borderReady)
                return;
              t3.needsHillshadePrepare = true, t3.needsDEMTextureUpload = true;
              let r3 = e3.tileID.canonical.x - t3.tileID.canonical.x;
              const n2 = e3.tileID.canonical.y - t3.tileID.canonical.y, i2 = Math.pow(2, t3.tileID.canonical.z), s2 = e3.tileID.key;
              0 === r3 && 0 === n2 || Math.abs(n2) > 1 || (Math.abs(r3) > 1 && (1 === Math.abs(r3 + i2) ? r3 += i2 : 1 === Math.abs(r3 - i2) && (r3 -= i2)), e3.dem && t3.dem && (t3.dem.backfillBorder(e3.dem, r3, n2), t3.neighboringTiles && t3.neighboringTiles[s2] && (t3.neighboringTiles[s2].backfilled = true)));
            }
          }
          getTile(t2) {
            return this.getTileByID(t2.key);
          }
          getTileByID(t2) {
            return this._tiles[t2];
          }
          _retainLoadedChildren(t2, e2, r2, n2) {
            for (const i2 in this._tiles) {
              let s2 = this._tiles[i2];
              if (n2[i2] || !s2.hasData() || s2.tileID.overscaledZ <= e2 || s2.tileID.overscaledZ > r2)
                continue;
              let a2 = s2.tileID;
              for (; s2 && s2.tileID.overscaledZ > e2 + 1; ) {
                const t3 = s2.tileID.scaledTo(s2.tileID.overscaledZ - 1);
                s2 = this._tiles[t3.key], s2 && s2.hasData() && (a2 = t3);
              }
              let o2 = a2;
              for (; o2.overscaledZ > e2; )
                if (o2 = o2.scaledTo(o2.overscaledZ - 1), t2[o2.key]) {
                  n2[a2.key] = a2;
                  break;
                }
            }
          }
          findLoadedParent(t2, e2) {
            if (t2.key in this._loadedParentTiles) {
              const r2 = this._loadedParentTiles[t2.key];
              return r2 && r2.tileID.overscaledZ >= e2 ? r2 : null;
            }
            for (let r2 = t2.overscaledZ - 1; r2 >= e2; r2--) {
              const e3 = t2.scaledTo(r2), n2 = this._getLoadedTile(e3);
              if (n2)
                return n2;
            }
          }
          _getLoadedTile(t2) {
            const e2 = this._tiles[t2.key];
            return e2 && e2.hasData() ? e2 : this._cache.getByKey(this._source.reparseOverscaled ? t2.wrapped().key : t2.canonical.key);
          }
          updateCacheSize(t2, e2) {
            e2 = e2 || this._source.tileSize;
            const r2 = Math.ceil(t2.width / e2) + 1, n2 = Math.ceil(t2.height / e2) + 1, i2 = Math.floor(r2 * n2 * 5), s2 = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, i2) : i2, a2 = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, s2) : s2;
            this._cache.setMaxSize(a2);
          }
          handleWrapJump(t2) {
            const e2 = Math.round((t2 - (void 0 === this._prevLng ? t2 : this._prevLng)) / 360);
            if (this._prevLng = t2, e2) {
              const t3 = {};
              for (const r2 in this._tiles) {
                const n2 = this._tiles[r2];
                n2.tileID = n2.tileID.unwrapTo(n2.tileID.wrap + e2), t3[n2.tileID.key] = n2;
              }
              this._tiles = t3;
              for (const t4 in this._timers)
                clearTimeout(this._timers[t4]), delete this._timers[t4];
              for (const t4 in this._tiles)
                this._setTileReloadTimer(+t4, this._tiles[t4]);
            }
          }
          update(t2, e2, r2, n2) {
            if (this.transform = t2, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage)
              return;
            if (this.usedForTerrain && !r2)
              return;
            this.updateCacheSize(t2, e2), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = {}, this._coveredTiles = {};
            const i2 = "batched-model" === this._source.type;
            let s2;
            if (this.used || this.usedForTerrain) {
              if (this._source.tileID)
                s2 = t2.getVisibleUnwrappedCoordinates(this._source.tileID).map((t3) => new Sc(t3.canonical.z, t3.wrap, t3.canonical.z, t3.canonical.x, t3.canonical.y));
              else if (0 !== this.tileCoverLift) {
                const n3 = t2.clone();
                n3.tileCoverLift = this.tileCoverLift, s2 = n3.coveringTiles({ tileSize: e2 || this._source.tileSize, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: this._source.roundZoom && !r2, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain, calculateQuadrantVisibility: i2 }), this._source.minzoom <= 1 && "globe" === t2.projection.name && (s2.push(new Sc(1, 0, 1, 0, 0)), s2.push(new Sc(1, 0, 1, 1, 0)), s2.push(new Sc(1, 0, 1, 0, 1)), s2.push(new Sc(1, 0, 1, 1, 1)));
              } else if (s2 = t2.coveringTiles({ tileSize: e2 || this._source.tileSize, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: this._source.roundZoom && !r2, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain, calculateQuadrantVisibility: i2 }), this._source.hasTile) {
                const t3 = this._source.hasTile.bind(this._source);
                s2 = s2.filter((e3) => t3(e3));
              }
            } else
              s2 = [];
            if (s2.length > 0 && this.castsShadows && n2 && "globe" !== this.transform.projection.name && !this.usedForTerrain && !ub(this._source.type)) {
              const a3 = t2.coveringZoomLevel({ tileSize: e2 || this._source.tileSize, roundZoom: this._source.roundZoom && !r2 }), o3 = Math.min(a3, this._source.maxzoom);
              if (i2) {
                const e3 = t2.extendTileCover(s2, o3);
                for (const t3 of e3)
                  s2.push(t3);
              } else {
                const e3 = t2.extendTileCover(s2, o3, n2);
                for (const t3 of e3)
                  this._shadowCasterTiles[t3.key] = true, s2.push(t3);
              }
            }
            const a2 = this._updateRetainedTiles(s2);
            if (ub(this._source.type) && 0 !== s2.length) {
              const t3 = {}, e3 = {}, r3 = Object.keys(a2);
              for (const n4 of r3) {
                const r4 = a2[n4], i3 = this._tiles[n4];
                if (!i3 || i3.fadeEndTime && i3.fadeEndTime <= Rr.now())
                  continue;
                const s3 = this.findLoadedParent(r4, Math.max(r4.overscaledZ - ob.maxOverzooming, this._source.minzoom));
                s3 && (this._addTile(s3.tileID), t3[s3.tileID.key] = s3.tileID), e3[n4] = r4;
              }
              const n3 = s2[s2.length - 1].overscaledZ;
              for (const t4 in this._tiles) {
                const r4 = this._tiles[t4];
                if (a2[t4] || !r4.hasData())
                  continue;
                let i3 = r4.tileID;
                for (; i3.overscaledZ > n3; ) {
                  i3 = i3.scaledTo(i3.overscaledZ - 1);
                  const n4 = this._tiles[i3.key];
                  if (n4 && n4.hasData() && e3[i3.key]) {
                    a2[t4] = r4.tileID;
                    break;
                  }
                }
              }
              for (const e4 in t3)
                a2[e4] || (this._coveredTiles[e4] = true, a2[e4] = t3[e4]);
            }
            for (const t3 in a2)
              this._tiles[t3].clearFadeHold();
            const o2 = function(t3, e3) {
              const r3 = [];
              for (const n3 in t3)
                n3 in e3 || r3.push(n3);
              return r3;
            }(this._tiles, a2);
            for (const t3 of o2) {
              const e3 = this._tiles[t3];
              e3.hasSymbolBuckets && !e3.holdingForFade() ? e3.setHoldDuration(this.map._fadeDuration) : e3.hasSymbolBuckets && !e3.symbolFadeFinished() || this._removeTile(+t3);
            }
            this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
          }
          releaseSymbolFadeTiles() {
            for (const t2 in this._tiles)
              this._tiles[t2].holdingForFade() && this._removeTile(+t2);
          }
          _updateRetainedTiles(t2) {
            const e2 = {};
            if (0 === t2.length)
              return e2;
            const r2 = {}, n2 = t2.reduce((t3, e3) => Math.min(t3, e3.overscaledZ), 1 / 0), i2 = t2[0].overscaledZ, s2 = Math.max(i2 - ob.maxOverzooming, this._source.minzoom), a2 = Math.max(i2 + ob.maxUnderzooming, this._source.minzoom), o2 = {};
            for (const r3 of t2) {
              const t3 = this._addTile(r3);
              e2[r3.key] = r3, t3.hasData() || n2 < this._source.maxzoom && (o2[r3.key] = r3);
            }
            this._retainLoadedChildren(o2, n2, a2, e2);
            for (const n3 of t2) {
              let t3 = this._tiles[n3.key];
              if (t3.hasData())
                continue;
              if (n3.canonical.z >= this._source.maxzoom) {
                const t4 = n3.children(this._source.maxzoom)[0], r3 = this.getTile(t4);
                if (r3 && r3.hasData()) {
                  e2[t4.key] = t4;
                  continue;
                }
              } else {
                const t4 = n3.children(this._source.maxzoom);
                if (e2[t4[0].key] && e2[t4[1].key] && e2[t4[2].key] && e2[t4[3].key])
                  continue;
              }
              let i3 = t3.wasRequested();
              for (let a3 = n3.overscaledZ - 1; a3 >= s2; --a3) {
                const s3 = n3.scaledTo(a3);
                if (r2[s3.key])
                  break;
                if (r2[s3.key] = true, t3 = this.getTile(s3), !t3 && i3 && (t3 = this._addTile(s3)), t3 && (e2[s3.key] = s3, i3 = t3.wasRequested(), t3.hasData()))
                  break;
              }
            }
            return e2;
          }
          _updateLoadedParentTileCache() {
            this._loadedParentTiles = {};
            for (const t2 in this._tiles) {
              const e2 = [];
              let r2, n2 = this._tiles[t2].tileID;
              for (; n2.overscaledZ > 0; ) {
                if (n2.key in this._loadedParentTiles) {
                  r2 = this._loadedParentTiles[n2.key];
                  break;
                }
                e2.push(n2.key);
                const t3 = n2.scaledTo(n2.overscaledZ - 1);
                if (r2 = this._getLoadedTile(t3), r2)
                  break;
                n2 = t3;
              }
              for (const t3 of e2)
                this._loadedParentTiles[t3] = r2;
            }
          }
          _addTile(t2) {
            let e2 = this._tiles[t2.key];
            if (e2)
              return true !== e2.isExtraShadowCaster || !!this._shadowCasterTiles[t2.key] || this._reloadTile(t2.key, "reloading"), e2;
            e2 = this._cache.getAndRemove(t2), e2 && (this._setTileReloadTimer(t2.key, e2), e2.tileID = t2, this._state.initializeTileState(e2, this.map ? this.map.painter : null), this._cacheTimers[t2.key] && (clearTimeout(this._cacheTimers[t2.key]), delete this._cacheTimers[t2.key], this._setTileReloadTimer(t2.key, e2)));
            const r2 = Boolean(e2);
            if (!r2) {
              const r3 = this.map ? this.map.painter : null, n2 = this._source.tileSize * t2.overscaleFactor();
              e2 = "raster-array" === this._source.type ? new sb(t2, n2, this.transform.tileZoom, r3, this._isRaster) : new cx(t2, n2, this.transform.tileZoom, r3, this._isRaster), this._loadTile(e2, this._tileLoaded.bind(this, e2, t2.key, e2.state));
            }
            return e2 ? (e2.uses++, this._tiles[t2.key] = e2, r2 || this._source.fire(new Cn("dataloading", { tile: e2, coord: e2.tileID, dataType: "source" })), e2) : null;
          }
          _setTileReloadTimer(t2, e2) {
            t2 in this._timers && (clearTimeout(this._timers[t2]), delete this._timers[t2]);
            const r2 = e2.getExpiryTimeout();
            r2 && (this._timers[t2] = setTimeout(() => {
              this._reloadTile(t2, "expired"), delete this._timers[t2];
            }, r2));
          }
          _removeTile(t2) {
            const e2 = this._tiles[t2];
            e2 && (e2.uses--, delete this._tiles[t2], this._timers[t2] && (clearTimeout(this._timers[t2]), delete this._timers[t2]), e2.uses > 0 || (e2.hasData() && "reloading" !== e2.state || "empty" === e2.state ? this._cache.add(e2.tileID, e2, e2.getExpiryTimeout()) : (e2.aborted = true, this._abortTile(e2), this._unloadTile(e2))));
          }
          clearTiles() {
            this._shouldReloadOnResume = false, this._paused = false;
            for (const t2 in this._tiles)
              this._removeTile(+t2);
            this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
          }
          tilesIn(t2, e2, r2) {
            const n2 = [], i2 = this.transform;
            if (!i2)
              return n2;
            const s2 = "globe" === i2.projection.name, a2 = Ec(i2.center.lng);
            for (const o2 in this._tiles) {
              const l2 = this._tiles[o2];
              if (r2 && l2.clearQueryDebugViz(), l2.holdingForFade())
                continue;
              let u2;
              if (s2) {
                const t3 = l2.tileID.canonical;
                if (0 === t3.z) {
                  const e3 = [Math.abs(We(a2, ...cb(t3, -1)) - a2), Math.abs(We(a2, ...cb(t3, 1)) - a2)];
                  u2 = [0, 2 * e3.indexOf(Math.min(...e3)) - 1];
                } else {
                  const e3 = [Math.abs(We(a2, ...cb(t3, -1)) - a2), Math.abs(We(a2, ...cb(t3, 0)) - a2), Math.abs(We(a2, ...cb(t3, 1)) - a2)];
                  u2 = [e3.indexOf(Math.min(...e3)) - 1];
                }
              } else
                u2 = [0];
              for (const r3 of u2) {
                const s3 = t2.containsTile(l2, i2, e2, r3);
                s3 && n2.push(s3);
              }
            }
            return n2;
          }
          getShadowCasterCoordinates() {
            return this._getRenderableCoordinates(false, true);
          }
          getVisibleCoordinates(t2) {
            return this._getRenderableCoordinates(t2);
          }
          _getRenderableCoordinates(t2, e2) {
            const r2 = this.getRenderableIds(t2, e2).map((t3) => this._tiles[t3].tileID), n2 = "globe" === this.transform.projection.name;
            for (const t3 of r2)
              t3.projMatrix = this.transform.calculateProjMatrix(t3.toUnwrapped()), t3.expandedProjMatrix = n2 ? this.transform.calculateProjMatrix(t3.toUnwrapped(), false, true) : t3.projMatrix;
            return r2;
          }
          sortCoordinatesByDistance(t2) {
            const e2 = t2.slice(), r2 = this.transform._camera.position, n2 = this.transform._camera.forward(), i2 = {};
            for (const t3 of e2) {
              const e3 = 1 / (1 << t3.canonical.z);
              i2[t3.key] = ((t3.canonical.x + 0.5) * e3 + t3.wrap - r2[0]) * n2[0] + ((t3.canonical.y + 0.5) * e3 - r2[1]) * n2[1] - r2[2] * n2[2];
            }
            return e2.sort((t3, e3) => i2[t3.key] - i2[e3.key]), e2;
          }
          hasTransition() {
            if (this._source.hasTransition())
              return true;
            if (ub(this._source.type))
              for (const t2 in this._tiles) {
                const e2 = this._tiles[t2];
                if (void 0 !== e2.fadeEndTime && e2.fadeEndTime >= Rr.now())
                  return true;
              }
            return false;
          }
          setFeatureState(t2, e2, r2) {
            this._state.updateState(t2 = t2 || "_geojsonTileLayer", e2, r2);
          }
          removeFeatureState(t2, e2, r2) {
            this._state.removeFeatureState(t2 = t2 || "_geojsonTileLayer", e2, r2);
          }
          getFeatureState(t2, e2) {
            return this._state.getState(t2 = t2 || "_geojsonTileLayer", e2);
          }
          setDependencies(t2, e2, r2) {
            const n2 = this._tiles[t2];
            n2 && n2.setDependencies(e2, r2);
          }
          reloadTilesForDependencies(t2, e2) {
            for (const r2 in this._tiles)
              this._tiles[r2].hasDependency(t2, e2) && this._reloadTile(+r2, "reloading");
            this._cache.filter((r2) => !r2.hasDependency(t2, e2));
          }
          _preloadTiles(t2, e2) {
            if (!this._sourceLoaded) {
              const r3 = () => {
                this._sourceLoaded && (this._source.off("data", r3), this._preloadTiles(t2, e2));
              };
              return void this._source.on("data", r3);
            }
            const r2 = /* @__PURE__ */ new Map(), n2 = Array.isArray(t2) ? t2 : [t2], i2 = this.map.painter.terrain, s2 = this.usedForTerrain && i2 ? i2.getScaledDemTileSize() : this._source.tileSize;
            for (const t3 of n2) {
              const e3 = t3.coveringTiles({ tileSize: s2, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: this._source.roundZoom && !this.usedForTerrain, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain });
              for (const t4 of e3)
                r2.set(t4.key, t4);
              this.usedForTerrain && t3.updateElevation(false);
            }
            tr(Array.from(r2.values()), (t3, e3) => {
              const r3 = new cx(t3, this._source.tileSize * t3.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster);
              this._loadTile(r3, (t4) => {
                "raster-dem" === this._source.type && r3.dem && this._backfillDEM(r3), e3(t4, r3);
              });
            }, e2);
          }
        }
        function lb(t2, e2) {
          const r2 = Math.abs(2 * t2.wrap) - +(t2.wrap < 0), n2 = Math.abs(2 * e2.wrap) - +(e2.wrap < 0);
          return t2.overscaledZ - e2.overscaledZ || n2 - r2 || e2.canonical.y - t2.canonical.y || e2.canonical.x - t2.canonical.x;
        }
        function ub(t2) {
          return "raster" === t2 || "image" === t2 || "video" === t2 || "custom" === t2;
        }
        function cb(t2, e2) {
          const r2 = 1 << t2.z;
          return [t2.x / r2 + e2, (t2.x + 1) / r2 + e2];
        }
        ob.maxOverzooming = 10, ob.maxUnderzooming = 3;
        const hb = () => eb || (eb = { layout: um || (um = new ul({ "line-cap": new ol(cl.layout_line["line-cap"]), "line-join": new ol(cl.layout_line["line-join"]), "line-miter-limit": new al(cl.layout_line["line-miter-limit"]), "line-round-limit": new al(cl.layout_line["line-round-limit"]), "line-sort-key": new ol(cl.layout_line["line-sort-key"]), "line-z-offset": new ol(cl.layout_line["line-z-offset"]), visibility: new al(cl.layout_line.visibility) })), paint: cm || (cm = new ul({ "line-opacity": new ol(cl.paint_line["line-opacity"]), "line-color": new ol(cl.paint_line["line-color"]), "line-translate": new al(cl.paint_line["line-translate"]), "line-translate-anchor": new al(cl.paint_line["line-translate-anchor"]), "line-width": new ol(cl.paint_line["line-width"]), "line-gap-width": new ol(cl.paint_line["line-gap-width"]), "line-offset": new ol(cl.paint_line["line-offset"]), "line-blur": new ol(cl.paint_line["line-blur"]), "line-dasharray": new ol(cl.paint_line["line-dasharray"]), "line-pattern": new ol(cl.paint_line["line-pattern"]), "line-gradient": new ll(cl.paint_line["line-gradient"]), "line-trim-offset": new al(cl.paint_line["line-trim-offset"]), "line-trim-fade-range": new al(cl.paint_line["line-trim-fade-range"]), "line-trim-color": new al(cl.paint_line["line-trim-color"]), "line-emissive-strength": new al(cl.paint_line["line-emissive-strength"]), "line-border-width": new ol(cl.paint_line["line-border-width"]), "line-border-color": new ol(cl.paint_line["line-border-color"]), "line-occlusion-opacity": new al(cl.paint_line["line-occlusion-opacity"]) })) }, eb);
        class pb extends ol {
          possiblyEvaluate(t2, e2) {
            return e2 = new Wo(Math.floor(e2.zoom), { now: e2.now, fadeDuration: e2.fadeDuration, transition: e2.transition }), super.possiblyEvaluate(t2, e2);
          }
          evaluate(t2, e2, r2, n2) {
            return e2 = rr({}, e2, { zoom: Math.floor(e2.zoom) }), super.evaluate(t2, e2, r2, n2);
          }
        }
        let fb, db, mb, yb;
        function gb(t2, e2) {
          return e2 > 0 ? e2 + 2 * t2 : t2;
        }
        class xb {
          constructor(t2) {
            this.type = t2.property.overrides ? t2.property.overrides.runtimeType : Qn, this.defaultValue = t2;
          }
          evaluate(t2) {
            if (t2.formattedSection) {
              const e2 = this.defaultValue.property.overrides;
              if (e2 && e2.hasOverride(t2.formattedSection))
                return e2.getOverride(t2.formattedSection);
            }
            return t2.feature && t2.featureState ? this.defaultValue.evaluate(t2.feature, t2.featureState) : this.defaultValue.property.specification.default;
          }
          eachChild(t2) {
            this.defaultValue.isConstant() || t2(this.defaultValue.value._styleExpression.expression);
          }
          outputDefined() {
            return false;
          }
          serialize() {
            return null;
          }
        }
        So(xb, "FormatSectionOverride", { omit: ["defaultValue"] });
        const bb = () => yb || (yb = { layout: db || (db = new ul({ "symbol-placement": new al(cl.layout_symbol["symbol-placement"]), "symbol-spacing": new al(cl.layout_symbol["symbol-spacing"]), "symbol-avoid-edges": new al(cl.layout_symbol["symbol-avoid-edges"]), "symbol-sort-key": new ol(cl.layout_symbol["symbol-sort-key"]), "symbol-z-order": new al(cl.layout_symbol["symbol-z-order"]), "symbol-z-elevate": new al(cl.layout_symbol["symbol-z-elevate"]), "icon-allow-overlap": new al(cl.layout_symbol["icon-allow-overlap"]), "icon-ignore-placement": new al(cl.layout_symbol["icon-ignore-placement"]), "icon-optional": new al(cl.layout_symbol["icon-optional"]), "icon-rotation-alignment": new al(cl.layout_symbol["icon-rotation-alignment"]), "icon-size": new ol(cl.layout_symbol["icon-size"]), "icon-text-fit": new ol(cl.layout_symbol["icon-text-fit"]), "icon-text-fit-padding": new ol(cl.layout_symbol["icon-text-fit-padding"]), "icon-image": new ol(cl.layout_symbol["icon-image"]), "icon-rotate": new ol(cl.layout_symbol["icon-rotate"]), "icon-padding": new al(cl.layout_symbol["icon-padding"]), "icon-keep-upright": new al(cl.layout_symbol["icon-keep-upright"]), "icon-offset": new ol(cl.layout_symbol["icon-offset"]), "icon-anchor": new ol(cl.layout_symbol["icon-anchor"]), "icon-pitch-alignment": new al(cl.layout_symbol["icon-pitch-alignment"]), "text-pitch-alignment": new al(cl.layout_symbol["text-pitch-alignment"]), "text-rotation-alignment": new al(cl.layout_symbol["text-rotation-alignment"]), "text-field": new ol(cl.layout_symbol["text-field"]), "text-font": new ol(cl.layout_symbol["text-font"]), "text-size": new ol(cl.layout_symbol["text-size"]), "text-max-width": new ol(cl.layout_symbol["text-max-width"]), "text-line-height": new ol(cl.layout_symbol["text-line-height"]), "text-letter-spacing": new ol(cl.layout_symbol["text-letter-spacing"]), "text-justify": new ol(cl.layout_symbol["text-justify"]), "text-radial-offset": new ol(cl.layout_symbol["text-radial-offset"]), "text-variable-anchor": new al(cl.layout_symbol["text-variable-anchor"]), "text-anchor": new ol(cl.layout_symbol["text-anchor"]), "text-max-angle": new al(cl.layout_symbol["text-max-angle"]), "text-writing-mode": new al(cl.layout_symbol["text-writing-mode"]), "text-rotate": new ol(cl.layout_symbol["text-rotate"]), "text-padding": new al(cl.layout_symbol["text-padding"]), "text-keep-upright": new al(cl.layout_symbol["text-keep-upright"]), "text-transform": new ol(cl.layout_symbol["text-transform"]), "text-offset": new ol(cl.layout_symbol["text-offset"]), "text-allow-overlap": new al(cl.layout_symbol["text-allow-overlap"]), "text-ignore-placement": new al(cl.layout_symbol["text-ignore-placement"]), "text-optional": new al(cl.layout_symbol["text-optional"]), visibility: new al(cl.layout_symbol.visibility) })), paint: mb || (mb = new ul({ "icon-opacity": new ol(cl.paint_symbol["icon-opacity"]), "icon-occlusion-opacity": new ol(cl.paint_symbol["icon-occlusion-opacity"]), "icon-emissive-strength": new ol(cl.paint_symbol["icon-emissive-strength"]), "text-emissive-strength": new ol(cl.paint_symbol["text-emissive-strength"]), "icon-color": new ol(cl.paint_symbol["icon-color"]), "icon-halo-color": new ol(cl.paint_symbol["icon-halo-color"]), "icon-halo-width": new ol(cl.paint_symbol["icon-halo-width"]), "icon-halo-blur": new ol(cl.paint_symbol["icon-halo-blur"]), "icon-translate": new al(cl.paint_symbol["icon-translate"]), "icon-translate-anchor": new al(cl.paint_symbol["icon-translate-anchor"]), "icon-image-cross-fade": new ol(cl.paint_symbol["icon-image-cross-fade"]), "text-opacity": new ol(cl.paint_symbol["text-opacity"]), "text-occlusion-opacity": new ol(cl.paint_symbol["text-occlusion-opacity"]), "text-color": new ol(cl.paint_symbol["text-color"], { runtimeType: ni, getOverride: (t2) => t2.textColor, hasOverride: (t2) => !!t2.textColor }), "text-halo-color": new ol(cl.paint_symbol["text-halo-color"]), "text-halo-width": new ol(cl.paint_symbol["text-halo-width"]), "text-halo-blur": new ol(cl.paint_symbol["text-halo-blur"]), "text-translate": new al(cl.paint_symbol["text-translate"]), "text-translate-anchor": new al(cl.paint_symbol["text-translate-anchor"]), "icon-color-saturation": new al(cl.paint_symbol["icon-color-saturation"]), "icon-color-contrast": new al(cl.paint_symbol["icon-color-contrast"]), "icon-color-brightness-min": new al(cl.paint_symbol["icon-color-brightness-min"]), "icon-color-brightness-max": new al(cl.paint_symbol["icon-color-brightness-max"]) })) }, yb);
        class vb extends zl {
          constructor(e2, r2, n2, i2) {
            super(e2, bb(), r2, n2, i2), this._colorAdjustmentMatrix = t.ae.identity([]), this.hasInitialOcclusionOpacityProperties = void 0 !== e2.paint && ("icon-occlusion-opacity" in e2.paint || "text-occlusion-opacity" in e2.paint);
          }
          recalculate(t2, e2) {
            super.recalculate(t2, e2), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
            const r2 = this.layout.get("text-writing-mode");
            if (r2) {
              const t3 = [];
              for (const e3 of r2)
                t3.indexOf(e3) < 0 && t3.push(e3);
              this.layout._values["text-writing-mode"] = t3;
            } else
              this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? ["horizontal"] : ["horizontal", "vertical"];
            this._setPaintOverrides();
          }
          getColorAdjustmentMatrix(e2, r2, n2, i2) {
            return this._saturation === e2 && this._contrast === r2 && this._brightnessMin === n2 && this._brightnessMax === i2 || (this._colorAdjustmentMatrix = function(e3, r3, n3, i3) {
              e3 = Br(e3), r3 = Er(r3);
              const s2 = t.ae.create(), a2 = e3 / 3, o2 = 1 - 2 * a2, l2 = [o2, a2, a2, 0, a2, o2, a2, 0, a2, a2, o2, 0, 0, 0, 0, 1], u2 = 0.5 - 0.5 * r3, c2 = i3 - n3;
              return t.ae.multiply(s2, [c2, 0, 0, 0, 0, c2, 0, 0, 0, 0, c2, 0, n3, n3, n3, 1], [r3, 0, 0, 0, 0, r3, 0, 0, 0, 0, r3, 0, u2, u2, u2, 1]), t.ae.multiply(s2, s2, l2), s2;
            }(e2, r2, n2, i2), this._saturation = e2, this._contrast = r2, this._brightnessMin = n2, this._brightnessMax = i2), this._colorAdjustmentMatrix;
          }
          getValueAndResolveTokens(t2, e2, r2, n2) {
            const i2 = this.layout.get(t2).evaluate(e2, {}, r2, n2), s2 = this._unevaluatedLayout._values[t2];
            return s2.isDataDriven() || po(s2.value) || !i2 ? i2 : function(t3, e3) {
              return e3.replace(/{([^{}]+)}/g, (e4, r3) => r3 in t3 ? String(t3[r3]) : "");
            }(e2.properties, i2);
          }
          createBucket(t2) {
            return new Ng(t2);
          }
          queryRadius() {
            return 0;
          }
          queryIntersectsFeature() {
            return false;
          }
          _setPaintOverrides() {
            for (const t2 of bb().paint.overridableProperties) {
              if (!vb.hasPaintOverride(this.layout, t2))
                continue;
              const e2 = this.paint.get(t2), r2 = new xb(e2), n2 = new ho(r2, e2.property.specification, this.scope, this.options);
              let i2 = null;
              i2 = "constant" === e2.value.kind || "source" === e2.value.kind ? new mo("source", n2) : new yo("composite", n2, e2.value.zoomStops, e2.value._interpolationType), this.paint._values[t2] = new il(e2.property, i2, e2.parameters);
            }
          }
          _handleOverridablePaintPropertyUpdate(t2, e2, r2) {
            return !(!this.layout || e2.isDataDriven() || r2.isDataDriven()) && vb.hasPaintOverride(this.layout, t2);
          }
          static hasPaintOverride(t2, e2) {
            const r2 = t2.get("text-field"), n2 = bb().paint.properties[e2];
            let i2 = false;
            const s2 = (t3) => {
              for (const e3 of t3)
                if (n2.overrides && n2.overrides.hasOverride(e3))
                  return void (i2 = true);
            };
            if ("constant" === r2.value.kind && r2.value.value instanceof gi)
              s2(r2.value.value.sections);
            else if ("source" === r2.value.kind) {
              const t3 = (e4) => {
                i2 || (e4 instanceof Mi && _i(e4.value) === oi ? s2(e4.value.sections) : e4 instanceof Ti ? s2(e4.sections) : e4.eachChild(t3));
              }, e3 = r2.value;
              e3._styleExpression && t3(e3._styleExpression.expression);
            }
            return i2;
          }
          getProgramIds() {
            const t2 = 0 !== this.paint.get("icon-opacity").constantOr(1), e2 = 0 !== this.paint.get("text-opacity").constantOr(1), r2 = [];
            return t2 && r2.push("symbolIcon"), e2 && r2.push("symbolSDF"), r2;
          }
          getDefaultProgramParams(t2, e2, r2) {
            return { config: new tc(this, { zoom: e2, lut: r2 }), overrideFog: false };
          }
        }
        let _b, wb, Mb, Ab;
        function Sb(e2, r2, n2, i2, s2, a2, o2, l2) {
          const u2 = [e2, r2, 1, n2, i2, 1, s2, a2, 1], c2 = [o2, l2, 1], h2 = t.bE.adjoint([], u2), [p2, f2, d2] = t.$.transformMat3(c2, c2, h2);
          return t.bE.multiply(u2, u2, [p2, 0, 0, 0, f2, 0, 0, 0, d2]);
        }
        function Ib(e2, r2, n2, i2, s2, a2, o2, l2) {
          const u2 = function(e3, r3, n3, i3, s3, a3, o3, l3) {
            const u3 = Sb(0, 0, 1, 0, 1, 1, 0, 1), c2 = Sb(e3, r3, n3, i3, s3, a3, o3, l3), h2 = t.bE.adjoint([], u3);
            return t.bE.multiply(c2, c2, h2);
          }(e2, r2, n2, i2, s2, a2, o2, l2);
          return [u2[2] / u2[8] / ds, u2[5] / u2[8] / ds];
        }
        function Tb(t2) {
          return [t2[0], Math.min(Math.max(t2[1], -Vc), Vc)];
        }
        class kb extends On {
          constructor(t2, e2, r2, n2) {
            super(), this.id = t2, this.dispatcher = r2, this.coordinates = e2.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = false, this.onNorthPole = false, this.onSouthPole = false, this.setEventedParent(n2), this.options = e2, this._dirty = false;
          }
          load(t2, e2) {
            if (this._loaded = e2 || false, this.fire(new Cn("dataloading", { dataType: "source" })), this.url = this.options.url, !this.url)
              return t2 && (this.coordinates = t2), this._loaded = true, void this._finishLoading();
            this._imageRequest = un(this.map._requestManager.transformRequest(this.url, Qr.Image), (e3, r2) => {
              this._imageRequest = null, this._loaded = true, e3 ? this.fire(new Ln(e3)) : r2 && (this.image = r2 instanceof HTMLImageElement ? Rr.getImageData(r2) : r2, this._dirty = true, this.width = this.image.width, this.height = this.image.height, t2 && (this.coordinates = t2), this._finishLoading());
            });
          }
          loaded() {
            return this._loaded;
          }
          updateImage(t2) {
            return t2.url ? (this._imageRequest && t2.url !== this.options.url && (this._imageRequest.cancel(), this._imageRequest = null), this.options.url = t2.url, this.load(t2.coordinates, this._loaded), this) : this;
          }
          setTexture(t2) {
            if (!(t2.handle instanceof WebGLTexture))
              throw new Error("The provided handle is not a WebGLTexture instance");
            return this.texture = new qg(this.map.painter.context, t2.handle), this.width = t2.dimensions[0], this.height = t2.dimensions[1], this._dirty = false, this._loaded = true, this._finishLoading(), this;
          }
          _finishLoading() {
            this.map && (this.setCoordinates(this.coordinates), this.fire(new Cn("data", { dataType: "source", sourceDataType: "metadata" })));
          }
          onAdd(t2) {
            this.map = t2, this.load();
          }
          onRemove(t2) {
            this._imageRequest && (this._imageRequest.cancel(), this._imageRequest = null), !this.texture || this.texture instanceof qg || this.texture.destroy(), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy());
          }
          setCoordinates(t2) {
            if (this.coordinates = t2, this._boundsArray = void 0, this._unsupportedCoords = false, !t2.length)
              return this;
            this.onNorthPole = false, this.onSouthPole = false;
            let e2 = t2[0][1], r2 = t2[0][1];
            for (const n3 of t2)
              n3[1] > r2 && (r2 = n3[1]), n3[1] < e2 && (e2 = n3[1]);
            const n2 = (r2 + e2) / 2;
            if (n2 > Vc ? this.onNorthPole = true : n2 < -Vc && (this.onSouthPole = true), !this.onNorthPole && !this.onSouthPole) {
              const e3 = t2.map(Nc.fromLngLat);
              this.tileID = function(t3) {
                let e4 = 1 / 0, r3 = 1 / 0, n3 = -1 / 0, i2 = -1 / 0;
                for (const s3 of t3)
                  e4 = Math.min(e4, s3.x), r3 = Math.min(r3, s3.y), n3 = Math.max(n3, s3.x), i2 = Math.max(i2, s3.y);
                const s2 = Math.max(n3 - e4, i2 - r3), a2 = Math.max(0, Math.floor(-Math.log(s2) / Math.LN2)), o2 = Math.pow(2, a2);
                let l2 = Math.floor((e4 + n3) / 2 * o2);
                return l2 > 1 && (l2 -= 1), new Mc(a2, l2, Math.floor((r3 + i2) / 2 * o2));
              }(e3), this.minzoom = this.maxzoom = this.tileID.z;
            }
            return this.fire(new Cn("data", { dataType: "source", sourceDataType: "content" })), this;
          }
          _clear() {
            this._boundsArray = void 0, this._unsupportedCoords = false;
          }
          _prepareData(e2) {
            for (const t2 in this.tiles) {
              const e3 = this.tiles[t2];
              "loaded" !== e3.state && (e3.state = "loaded", e3.texture = this.texture);
            }
            if (this._boundsArray || this.onNorthPole || this.onSouthPole || this._unsupportedCoords)
              return;
            const r2 = cg(new Mc(0, 0, 0), this.map.transform.projection), n2 = [r2.projection.project(this.coordinates[0][0], this.coordinates[0][1]), r2.projection.project(this.coordinates[1][0], this.coordinates[1][1]), r2.projection.project(this.coordinates[2][0], this.coordinates[2][1]), r2.projection.project(this.coordinates[3][0], this.coordinates[3][1])];
            if (!function(t2) {
              const e3 = t2[1].x - t2[0].x, r3 = t2[1].y - t2[0].y, n3 = t2[2].x - t2[1].x, i3 = t2[2].y - t2[1].y, s3 = t2[3].x - t2[2].x, a3 = t2[3].y - t2[2].y, o3 = t2[0].x - t2[3].x, l3 = t2[0].y - t2[3].y, u3 = e3 * i3 - n3 * r3, c3 = n3 * a3 - s3 * i3, h3 = s3 * l3 - o3 * a3, p3 = o3 * r3 - e3 * l3;
              return u3 > 0 && c3 > 0 && h3 > 0 && p3 > 0 || u3 < 0 && c3 < 0 && h3 < 0 && p3 < 0;
            }(n2))
              return console.warn("Image source coordinates are defining non-convex area in the Mercator projection"), void (this._unsupportedCoords = true);
            const i2 = cg(this.tileID, this.map.transform.projection), [s2, a2, o2, l2] = this.coordinates.map((t2) => {
              const e3 = i2.projection.project(t2[0], t2[1]);
              return hg(i2, e3)._round();
            });
            this.perspectiveTransform = Ib(s2.x, s2.y, a2.x, a2.y, o2.x, o2.y, l2.x, l2.y);
            const u2 = this._boundsArray = new Fl();
            u2.emplaceBack(s2.x, s2.y, 0, 0), u2.emplaceBack(a2.x, a2.y, ds, 0), u2.emplaceBack(l2.x, l2.y, 0, ds), u2.emplaceBack(o2.x, o2.y, ds, ds), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy()), this.boundsBuffer = e2.createVertexBuffer(u2, Jg.members), this.boundsSegments = ku.simpleSegment(0, 0, 4, 2);
            const c2 = [], h2 = function(t2) {
              return [Tb(t2[0]), Tb(t2[1]), Tb(t2[2]), Tb(t2[3])];
            }(this.coordinates), [p2, f2, d2, m2] = function(t2) {
              let e3 = t2[0][0], r3 = e3, n3 = t2[0][1], i3 = n3;
              for (let s3 = 1; s3 < t2.length; s3++)
                t2[s3][0] < e3 ? e3 = t2[s3][0] : t2[s3][0] > r3 && (r3 = t2[s3][0]), t2[s3][1] < n3 ? n3 = t2[s3][1] : t2[s3][1] > i3 && (i3 = t2[s3][1]);
              return [e3, n3, r3 - e3, i3 - n3];
            }(h2);
            {
              const i3 = new Fl(), [s3, a3, o3, l3] = function(t2) {
                let e3 = t2[0].x, r3 = e3, n3 = t2[0].y, i4 = n3;
                for (let s4 = 1; s4 < t2.length; s4++)
                  t2[s4].x < e3 ? e3 = t2[s4].x : t2[s4].x > r3 && (r3 = t2[s4].x), t2[s4].y < n3 ? n3 = t2[s4].y : t2[s4].y > i4 && (i4 = t2[s4].y);
                return [e3, n3, r3 - e3, i4 - n3];
              }(n2), u3 = (t2) => [(t2.x - s3) / o3, (t2.y - a3) / l3], [h3, y2, g2, x2] = n2.map(u3), b2 = function(e3, r3, n3, i4, s4, a4, o4, l4) {
                const u4 = Sb(0, 0, 1, 0, 1, 1, 0, 1), c3 = Sb(e3, r3, n3, i4, s4, a4, o4, l4), h4 = t.bE.adjoint([], c3);
                return t.bE.multiply(u4, u4, h4);
              }(h3[0], h3[1], y2[0], y2[1], g2[0], g2[1], x2[0], x2[1]);
              this.elevatedGlobePerspectiveTransform = Ib(h3[0], h3[1], y2[0], y2[1], g2[0], g2[1], x2[0], x2[1]);
              const v2 = (e3, r3) => {
                c2.push(e3.lng);
                const n3 = Math.round((e3.lng - p2) / d2 * ds), s4 = Math.round((e3.lat - f2) / m2 * ds), a4 = u3(r3), o4 = t.$.transformMat3([], [a4[0], a4[1], 1], b2), l4 = Math.round(o4[0] / o4[2] * ds), h4 = Math.round(o4[1] / o4[2] * ds);
                i3.emplaceBack(n3, s4, l4, h4);
              }, _2 = n2[3].x - n2[0].x, w2 = n2[3].y - n2[0].y, M2 = n2[2].x - n2[1].x, A2 = n2[2].y - n2[1].y;
              for (let t2 = 0; t2 < 65; t2++) {
                const e3 = t2 / 64, i4 = [n2[0].x + e3 * _2, n2[0].y + e3 * w2], s4 = [n2[1].x + e3 * M2, n2[1].y + e3 * A2], a4 = s4[0] - i4[0], o4 = s4[1] - i4[1];
                for (let t3 = 0; t3 < 65; t3++) {
                  const e4 = t3 / 64, n3 = { x: i4[0] + a4 * e4, y: i4[1] + o4 * e4, z: 0 };
                  v2(r2.projection.unproject(n3.x, n3.y), n3);
                }
              }
              this.elevatedGlobeVertexBuffer = e2.createVertexBuffer(i3, Jg.members);
            }
            {
              this.maxLongitudeTriangleSize = 0;
              let t2 = [], r3 = new tu();
              const n3 = (e3, n4, i3) => {
                r3.emplaceBack(e3, n4, i3);
                const s3 = c2[e3], a3 = c2[n4], o3 = c2[i3], l3 = Math.min(Math.min(s3, a3), o3), u3 = Math.max(Math.max(s3, a3), o3) - l3;
                u3 > this.maxLongitudeTriangleSize && (this.maxLongitudeTriangleSize = u3), t2.push(l3 + u3 / 2);
              };
              for (let t3 = 0; t3 < 64; t3++)
                for (let e3 = 0; e3 < 64; e3++) {
                  const r4 = 65 * t3 + e3, i3 = r4 + 1, s3 = r4 + 65, a3 = s3 + 1;
                  n3(r4, s3, i3), n3(i3, s3, a3);
                }
              [t2, r3] = function(t3, e3) {
                const r4 = Array.from({ length: t3.length }, (t4, e4) => e4);
                r4.sort((e4, r5) => t3[e4] - t3[r5]);
                const n4 = [], i3 = new tu();
                for (let s3 = 0; s3 < r4.length; s3++) {
                  const a3 = r4[s3];
                  n4.push(t3[a3]);
                  const o3 = 3 * a3, l3 = o3 + 1;
                  i3.emplaceBack(e3.uint16[o3], e3.uint16[l3], e3.uint16[l3 + 1]);
                }
                return [n4, i3];
              }(t2, r3), this.elevatedGlobeTrianglesCenterLongitudes = t2, this.elevatedGlobeIndexBuffer = e2.createIndexBuffer(r3);
            }
            this.elevatedGlobeSegments = ku.simpleSegment(0, 0, 4225, 8192), this.elevatedGlobeGridMatrix = new Float32Array([0, d2 / ds, 0, m2 / ds, 0, 0, f2, p2, 0]);
          }
          prepare() {
            const t2 = 0 !== Object.keys(this.tiles).length;
            if (this.tileID && !t2)
              return;
            const e2 = this.map.painter.context, r2 = e2.gl;
            !this._dirty || this.texture instanceof qg || (this.texture ? this.texture.update(this.image) : (this.texture = new $g(e2, this.image, r2.RGBA), this.texture.bind(r2.LINEAR, r2.CLAMP_TO_EDGE)), this._dirty = false), t2 && this._prepareData(e2);
          }
          loadTile(t2, e2) {
            this.tileID && this.tileID.equals(t2.tileID.canonical) ? (this.tiles[String(t2.tileID.wrap)] = t2, t2.buckets = {}, e2(null)) : (t2.state = "errored", e2(null));
          }
          serialize() {
            return { type: "image", url: this.options.url, coordinates: this.coordinates };
          }
          hasTransition() {
            return false;
          }
          getSegmentsForLongitude(t2) {
            const e2 = this.elevatedGlobeSegments;
            if (!this.elevatedGlobeTrianglesCenterLongitudes || !e2)
              return null;
            const r2 = this.elevatedGlobeTrianglesCenterLongitudes;
            let n2 = (i2 = t2 + 180) + 360 * Math.round((r2[0] - i2) / 360);
            var i2;
            const s2 = new ku(), a2 = (t3, r3) => {
              s2.segments.push({ vertexOffset: 0, primitiveOffset: t3, vertexLength: e2.segments[0].vertexLength, primitiveLength: r3, sortKey: void 0, vaos: {} });
            }, o2 = 0.51 * this.maxLongitudeTriangleSize;
            if (Math.abs(r2[0] - n2) <= o2) {
              const t3 = zr(r2, 0, r2.length, n2 + o2);
              return t3 === r2.length || a2(t3, Pr(r2, t3 + 1, r2.length, n2 + 360 - o2) - t3), s2;
            }
            n2 < r2[0] && (n2 += 360);
            const l2 = Pr(r2, 0, r2.length, n2 - o2);
            if (l2 === r2.length)
              return a2(0, r2.length), s2;
            a2(0, l2 - 0);
            const u2 = zr(r2, l2 + 1, r2.length, n2 + o2);
            return u2 !== r2.length && a2(u2, r2.length - u2), s2;
          }
        }
        const Pb = (Math.pow(256, 2) - 1) / 16907520;
        class zb extends zl {
          constructor(t2, e2, r2, n2) {
            super(t2, { layout: Mb || (Mb = new ul({ visibility: new al(cl.layout_raster.visibility) })), paint: Ab || (Ab = new ul({ "raster-opacity": new al(cl.paint_raster["raster-opacity"]), "raster-color": new ll(cl.paint_raster["raster-color"]), "raster-color-mix": new al(cl.paint_raster["raster-color-mix"]), "raster-color-range": new al(cl.paint_raster["raster-color-range"]), "raster-hue-rotate": new al(cl.paint_raster["raster-hue-rotate"]), "raster-brightness-min": new al(cl.paint_raster["raster-brightness-min"]), "raster-brightness-max": new al(cl.paint_raster["raster-brightness-max"]), "raster-saturation": new al(cl.paint_raster["raster-saturation"]), "raster-contrast": new al(cl.paint_raster["raster-contrast"]), "raster-resampling": new al(cl.paint_raster["raster-resampling"]), "raster-fade-duration": new al(cl.paint_raster["raster-fade-duration"]), "raster-emissive-strength": new al(cl.paint_raster["raster-emissive-strength"]), "raster-array-band": new al(cl.paint_raster["raster-array-band"]), "raster-elevation": new al(cl.paint_raster["raster-elevation"]) })) }, e2, r2, n2), this.updateColorRamp(), this._curRampRange = [NaN, NaN];
          }
          getProgramIds() {
            return ["raster"];
          }
          hasColorMap() {
            return !!this._transitionablePaint._values["raster-color"].value.value;
          }
          tileCoverLift() {
            return this.paint.get("raster-elevation");
          }
          isDraped(t2) {
            return !(t2 && t2._source instanceof kb && (t2._source.onNorthPole || t2._source.onSouthPole)) && 0 === this.paint.get("raster-elevation");
          }
          _handleSpecialPaintPropertyUpdate(t2) {
            "raster-color" !== t2 && "raster-color-range" !== t2 || (this._curRampRange = [NaN, NaN], this.updateColorRamp());
          }
          updateColorRamp(t2) {
            if (!this.hasColorMap())
              return;
            if (!this._curRampRange)
              return;
            const e2 = this._transitionablePaint._values["raster-color"].value.expression, [r2, n2] = t2 || this._transitionablePaint._values["raster-color-range"].value.expression.evaluate({ zoom: 0 }) || [NaN, NaN];
            isNaN(r2) && isNaN(n2) || r2 === this._curRampRange[0] && n2 === this._curRampRange[1] || (this.colorRamp = Mp({ expression: e2, evaluationKey: "rasterValue", image: this.colorRamp, clips: [{ start: r2, end: n2 }], resolution: 256 }), this.colorRampTexture = null, this._curRampRange = [r2, n2]);
          }
        }
        let Eb, Bb, Db, Rb, Cb;
        class Lb extends zl {
          constructor(t2, e2, r2, n2) {
            super(t2, { layout: Eb || (Eb = new ul({ visibility: new al(cl["layout_raster-particle"].visibility) })), paint: Bb || (Bb = new ul({ "raster-particle-array-band": new al(cl["paint_raster-particle"]["raster-particle-array-band"]), "raster-particle-count": new al(cl["paint_raster-particle"]["raster-particle-count"]), "raster-particle-color": new ll(cl["paint_raster-particle"]["raster-particle-color"]), "raster-particle-max-speed": new al(cl["paint_raster-particle"]["raster-particle-max-speed"]), "raster-particle-speed-factor": new al(cl["paint_raster-particle"]["raster-particle-speed-factor"]), "raster-particle-fade-opacity-factor": new al(cl["paint_raster-particle"]["raster-particle-fade-opacity-factor"]), "raster-particle-reset-rate-factor": new al(cl["paint_raster-particle"]["raster-particle-reset-rate-factor"]), "raster-particle-elevation": new al(cl["paint_raster-particle"]["raster-particle-elevation"]) })) }, e2, r2, n2), this._updateColorRamp(), this.lastInvalidatedAt = Rr.now();
          }
          onRemove(t2) {
            this.colorRampTexture && this.colorRampTexture.destroy(), this.tileFramebuffer && this.tileFramebuffer.destroy(), this.particleFramebuffer && this.particleFramebuffer.destroy();
          }
          hasColorMap() {
            return !!this._transitionablePaint._values["raster-particle-color"].value.value;
          }
          getProgramIds() {
            return ["rasterParticle"];
          }
          hasOffscreenPass() {
            return "none" !== this.visibility;
          }
          isDraped(t2) {
            return false;
          }
          _handleSpecialPaintPropertyUpdate(t2) {
            "raster-particle-color" !== t2 && "raster-particle-max-speed" !== t2 || (this._updateColorRamp(), this._invalidateAnimationState()), "raster-particle-count" === t2 && this._invalidateAnimationState();
          }
          _updateColorRamp() {
            if (!this.hasColorMap())
              return;
            const t2 = this._transitionablePaint._values["raster-particle-color"].value.expression, e2 = this._transitionablePaint._values["raster-particle-max-speed"].value.expression.evaluate({ zoom: 0 });
            this.colorRamp = Mp({ expression: t2, evaluationKey: "rasterParticleSpeed", image: this.colorRamp, clips: [{ start: 0, end: e2 }], resolution: 256 }), this.colorRampTexture = null;
          }
          _invalidateAnimationState() {
            this.lastInvalidatedAt = Rr.now();
          }
          tileCoverLift() {
            return this.paint.get("raster-particle-elevation");
          }
        }
        class Vb extends zl {
          constructor(t2, e2) {
            super(t2, {}, e2, null), this.implementation = t2, t2.slot && (this.slot = t2.slot);
          }
          is3D() {
            return "3d" === this.implementation.renderingMode;
          }
          hasOffscreenPass() {
            return void 0 !== this.implementation.prerender;
          }
          isDraped(t2) {
            return void 0 !== this.implementation.renderToTile;
          }
          shouldRedrape() {
            return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
          }
          recalculate() {
          }
          updateTransitions() {
          }
          hasTransition() {
            return false;
          }
          serialize() {
          }
          onAdd(t2) {
            this.implementation.onAdd && this.implementation.onAdd(t2, t2.painter.context.gl);
          }
          onRemove(t2) {
            this.implementation.onRemove && this.implementation.onRemove(t2, t2.painter.context.gl);
          }
        }
        function Fb(e2, r2, n2) {
          const i2 = [0, 0, 1], s2 = t.aw.identity([]);
          return t.aw.rotateY(s2, s2, n2 ? -Ge(e2) + Math.PI : Ge(e2)), t.aw.rotateX(s2, s2, -Ge(r2)), t.$.transformQuat(i2, i2, s2), t.$.normalize(i2, i2);
        }
        function Ob(e2, r2) {
          const n2 = jb(e2.projection, e2.zoom, e2.width, e2.height), i2 = function(e3, r3, n3, i3, s3) {
            const a2 = new bc(n3.lng - 180 * Nb, n3.lat), o2 = new bc(n3.lng + 180 * Nb, n3.lat), l2 = e3.project(a2.lng, a2.lat), u2 = e3.project(o2.lng, o2.lat), c2 = -Math.atan2(u2.y - l2.y, u2.x - l2.x), h2 = Nc.fromLngLat(n3);
            h2.y = We(h2.y, -1 + Nb, 1 - Nb);
            const p2 = h2.toLngLat(), f2 = e3.project(p2.lng, p2.lat), d2 = Nc.fromLngLat(p2);
            d2.x += Nb;
            const m2 = d2.toLngLat(), y2 = e3.project(m2.lng, m2.lat), g2 = qb(y2.x - f2.x, y2.y - f2.y, c2), x2 = Nc.fromLngLat(p2);
            x2.y += Nb;
            const b2 = x2.toLngLat(), v2 = e3.project(b2.lng, b2.lat), _2 = qb(v2.x - f2.x, v2.y - f2.y, c2), w2 = Math.abs(g2.x) / Math.abs(_2.y), M2 = t.ae.identity([]);
            t.ae.rotateZ(M2, M2, -c2 * (1 - (s3 ? 0 : i3)));
            const A2 = t.ae.identity([]);
            return t.ae.scale(A2, A2, [1, 1 - (1 - w2) * i3, 1]), A2[4] = -_2.x / _2.y * i3, t.ae.rotateZ(A2, A2, c2), t.ae.multiply(A2, M2, A2), A2;
          }(e2.projection, 0, e2.center, n2, r2), s2 = Ub(e2);
          return t.ae.scale(i2, i2, [s2, s2, 1]), i2;
        }
        function Ub(t2) {
          const e2 = t2.projection, r2 = jb(t2.projection, t2.zoom, t2.width, t2.height), n2 = $b(e2, t2.center), i2 = $b(e2, bc.convert(e2.center));
          return Math.pow(2, n2 * r2 + (1 - r2) * i2);
        }
        function jb(t2, e2, r2, n2, i2 = 1 / 0) {
          const s2 = t2.range;
          if (!s2)
            return 0;
          const a2 = Math.min(i2, Math.max(r2, n2)), o2 = Math.log(a2 / 1024) / Math.LN2;
          return Je(s2[0] + o2, s2[1] + o2, e2);
        }
        const Nb = 1 / 4e4;
        function $b(t2, e2) {
          const r2 = We(e2.lat, -Vc, Vc), n2 = new bc(e2.lng - 180 * Nb, r2), i2 = new bc(e2.lng + 180 * Nb, r2), s2 = t2.project(n2.lng, r2), a2 = t2.project(i2.lng, r2), o2 = Nc.fromLngLat(n2), l2 = Nc.fromLngLat(i2), u2 = a2.x - s2.x, c2 = a2.y - s2.y, h2 = l2.x - o2.x, p2 = l2.y - o2.y, f2 = Math.sqrt((h2 * h2 + p2 * p2) / (u2 * u2 + c2 * c2));
          return Math.log(f2) / Math.LN2;
        }
        function qb(t2, e2, r2) {
          const n2 = Math.cos(r2), i2 = Math.sin(r2);
          return { x: t2 * n2 - e2 * i2, y: t2 * i2 + e2 * n2 };
        }
        function Gb(e2, r2, n2) {
          t.ae.identity(e2), t.ae.rotateZ(e2, e2, Ge(r2[2])), t.ae.rotateX(e2, e2, Ge(r2[0])), t.ae.rotateY(e2, e2, Ge(r2[1])), t.ae.scale(e2, e2, n2), t.ae.multiply(e2, e2, [1, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
        }
        function Xb(e2, r2, n2, i2, s2, a2, o2, l2) {
          const u2 = [n2[0] - r2[0], n2[1] - r2[1], 0], c2 = [i2[0] - r2[0], i2[1] - r2[1], 0];
          if (t.$.length(u2) < 1e-12 || t.$.length(c2) < 1e-12)
            return t.aw.identity(e2);
          const h2 = t.$.cross([], u2, c2);
          t.$.normalize(h2, h2), t.$.subtract(c2, i2, r2), u2[2] = (a2 - s2) * l2, c2[2] = (o2 - s2) * l2;
          const p2 = u2;
          return t.$.cross(p2, u2, c2), t.$.normalize(p2, p2), t.aw.rotationTo(e2, h2, p2);
        }
        function Yb(e2, r2, n2 = false) {
          const i2 = Qh(r2.zoom), s2 = function(e3, r3, n3) {
            const i3 = r3.worldSize, s3 = [e3[12], e3[13], e3[14]], a2 = Cc(s3[1] / i3), o2 = Rc(s3[0] / i3), l2 = t.ae.identity([]), u2 = Dc(1, a2) * i3, c2 = Dc(1, 0) * i3 * Oc(a2, r3.zoom), h2 = 1 / Kh(i3);
            let p2 = c2 * h2;
            if (n3) {
              const t2 = jb(r3.projection, r3.zoom, r3.width, r3.height, 1024);
              p2 = h2 * r3.projection.pixelSpaceConversion(r3.center.lat, i3, t2);
            }
            const f2 = yc(a2, o2);
            t.$.add(f2, f2, t.$.scale([], t.$.normalize([], f2), u2 * p2 * s3[2]));
            const d2 = function(e4) {
              const r4 = [e4[0], e4[1], e4[2]];
              let n4 = [0, 1, 0];
              const i4 = t.$.cross([], n4, r4);
              return t.$.cross(n4, r4, i4), 0 === t.$.squaredLength(n4) && (n4 = [0, 1, 0], t.$.cross(i4, r4, n4)), t.$.normalize(i4, i4), t.$.normalize(n4, n4), t.$.normalize(r4, r4), [i4[0], i4[1], i4[2], 0, n4[0], n4[1], n4[2], 0, r4[0], r4[1], r4[2], 0, e4[0], e4[1], e4[2], 1];
            }(f2);
            t.ae.scale(l2, l2, [p2, p2, p2 * u2]), t.ae.translate(l2, l2, [-s3[0], -s3[1], -s3[2]]);
            const m2 = t.ae.multiply([], r3.globeMatrix, d2);
            return t.ae.multiply(m2, m2, l2), t.ae.multiply(m2, m2, e3), m2;
          }(e2, r2, n2);
          if (i2 > 0) {
            const n3 = function(e3, r3) {
              const n4 = r3.worldSize, i3 = Dc(1, 0) * n4 * Oc(r3.center.lat, r3.zoom) / Kh(n4), s3 = Dc(1, r3.center.lat) * n4, a2 = t.ae.identity([]);
              return t.ae.rotateY(a2, a2, Ge(r3.center.lng)), t.ae.rotateX(a2, a2, Ge(r3.center.lat)), t.ae.translate(a2, a2, [0, 0, oc]), t.ae.scale(a2, a2, [i3, i3, i3 * s3]), t.ae.translate(a2, a2, [r3.point.x - 0.5 * n4, r3.point.y - 0.5 * n4, 0]), t.ae.multiply(a2, a2, e3), t.ae.multiply(a2, r3.globeMatrix, a2);
            }(e2, r2);
            return function(e3, r3, n4) {
              const i3 = (e4, r4, n5) => {
                const i4 = t.$.length(e4), s4 = t.$.length(r4), a3 = Oh(e4, r4, n5);
                return t.$.scale(a3, a3, 1 / t.$.length(a3) * Yn(i4, s4, n5));
              }, s3 = i3([e3[0], e3[1], e3[2]], [r3[0], r3[1], r3[2]], n4), a2 = i3([e3[4], e3[5], e3[6]], [r3[4], r3[5], r3[6]], n4), o2 = i3([e3[8], e3[9], e3[10]], [r3[8], r3[9], r3[10]], n4), l2 = Oh([e3[12], e3[13], e3[14]], [r3[12], r3[13], r3[14]], n4);
              return [s3[0], s3[1], s3[2], 0, a2[0], a2[1], a2[2], 0, o2[0], o2[1], o2[2], 0, l2[0], l2[1], l2[2], 1];
            }(s2, n3, i2);
          }
          return s2;
        }
        function Zb(t2, e2, r2, n2) {
          const i2 = kh.projectAabbCorners(n2, r2);
          let s2 = Number.MAX_VALUE, a2 = -1;
          for (let t3 = 0; t3 < i2.length; ++t3) {
            const r3 = i2[t3];
            r3[0] = (0.5 * r3[0] + 0.5) * e2.width, r3[1] = (0.5 - 0.5 * r3[1]) * e2.height, r3[2] < s2 && (a2 = t3, s2 = r3[2]);
          }
          const o2 = (t3) => new je(i2[t3][0], i2[t3][1]);
          let l2;
          switch (a2) {
            case 0:
            case 6:
              l2 = [o2(1), o2(5), o2(4), o2(7), o2(3), o2(2), o2(1)];
              break;
            case 1:
            case 7:
              l2 = [o2(0), o2(4), o2(5), o2(6), o2(2), o2(3), o2(0)];
              break;
            case 3:
            case 5:
              l2 = [o2(1), o2(0), o2(4), o2(7), o2(6), o2(2), o2(1)];
              break;
            default:
              l2 = [o2(1), o2(5), o2(6), o2(7), o2(3), o2(0), o2(1)];
          }
          if (eh(t2, l2))
            return s2;
        }
        const Hb = Rl([{ name: "a_pos_3f", components: 3, type: "Float32" }]), Kb = Rl([{ name: "a_color_3f", components: 3, type: "Float32" }]), Wb = Rl([{ name: "a_color_4f", components: 4, type: "Float32" }]), Jb = Rl([{ name: "a_uv_2f", components: 2, type: "Float32" }]), Qb = Rl([{ name: "a_normal_3f", components: 3, type: "Float32" }]), tv = Rl([{ name: "a_normal_matrix0", components: 4, type: "Float32" }, { name: "a_normal_matrix1", components: 4, type: "Float32" }, { name: "a_normal_matrix2", components: 4, type: "Float32" }, { name: "a_normal_matrix3", components: 4, type: "Float32" }]), ev = Rl([{ name: "a_pbr", components: 4, type: "Uint16" }, { name: "a_heightBasedEmissiveStrength", components: 3, type: "Float32" }]);
        class rv {
          constructor(t2, e2, r2, n2) {
            this.message = (t2 ? `${t2}: ` : "") + r2, n2 && (this.identifier = n2), null != e2 && e2.__line__ && (this.line = e2.__line__);
          }
        }
        function nv(t2, e2) {
          const r2 = -1 === t2.indexOf("://");
          try {
            return new URL(t2, r2 && e2 ? "http://example.com" : void 0), true;
          } catch (t3) {
            return false;
          }
        }
        class iv {
          constructor(t2, e2) {
            this.feature = t2, this.instancedDataOffset = e2, this.instancedDataCount = 0, this.rotation = [0, 0, 0], this.scale = [1, 1, 1], this.translation = [0, 0, 0];
          }
        }
        class sv {
          constructor() {
            this.instancedDataArray = new uu(), this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
          }
        }
        class av {
          constructor(t2) {
            this.zoom = t2.zoom, this.canonical = t2.canonical, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.fqid), this.projection = t2.projection, this.index = t2.index, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.hasPattern = false, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = { id: null, timestamp: 0 }, this.modelUris = [], this.modelsRequested = false, this.activeReplacements = [], this.replacementUpdateTime = 0;
          }
          updateFootprints(t2, e2) {
          }
          populate(t2, e2, r2, n2) {
            this.tileToMeter = jc(r2);
            const i2 = this.layers[0]._featureFilter.needGeometry;
            this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
            for (const { feature: s2, id: a2, index: o2, sourceLayerIndex: l2 } of t2) {
              const t3 = null != a2 ? a2 : s2.properties && s2.properties.hasOwnProperty("id") ? s2.properties.id : void 0, u2 = Wc(s2, i2);
              if (!this.layers[0]._featureFilter.filter(new Wo(this.zoom), u2, r2))
                continue;
              const c2 = { id: t3, sourceLayerIndex: l2, index: o2, geometry: i2 ? u2.geometry : Kc(s2, r2, n2), properties: s2.properties, type: s2.type, patterns: {} }, h2 = this.addFeature(c2, c2.geometry, u2);
              h2 && e2.featureIndex.insert(s2, c2.geometry, o2, l2, this.index, this.instancesPerModel[h2].instancedDataArray.length, ds / 32);
            }
            this.lookup = null;
          }
          update(t2, e2, r2, n2) {
            for (const e3 in this.instancesPerModel) {
              const r3 = this.instancesPerModel[e3];
              for (const e4 in t2)
                r3.idToFeaturesIndex.hasOwnProperty(e4) && (this.evaluate(r3.features[r3.idToFeaturesIndex[e4]], t2[e4], r3, true), this.uploaded = false);
            }
            this.maxHeight = 0;
          }
          updateZoomBasedPaintProperties() {
            if (!this.hasZoomDependentProperties)
              return false;
            let e2 = false;
            for (const r2 in this.instancesPerModel) {
              const n2 = this.instancesPerModel[r2];
              for (const r3 of n2.features) {
                const i2 = this.layers[0], s2 = r3.feature, a2 = this.canonical, o2 = i2.paint.get("model-rotation").evaluate(s2, {}, a2), l2 = i2.paint.get("model-scale").evaluate(s2, {}, a2), u2 = i2.paint.get("model-translation").evaluate(s2, {}, a2);
                t.$.exactEquals(r3.rotation, o2) && t.$.exactEquals(r3.scale, l2) && t.$.exactEquals(r3.translation, u2) || (this.evaluate(r3, r3.featureStates, n2, true), e2 = true);
              }
            }
            return e2;
          }
          updateReplacement(t2, e2, r2, n2) {
            if (e2.updateTime === this.replacementUpdateTime)
              return false;
            this.replacementUpdateTime = e2.updateTime;
            const i2 = e2.getReplacementRegionsForTile(t2.toUnwrapped(), true);
            if (jf(this.activeReplacements, i2))
              return false;
            this.activeReplacements = i2;
            let s2 = false;
            for (const e3 in this.instancesPerModel) {
              const i3 = this.instancesPerModel[e3], a2 = i3.instancedDataArray;
              for (const e4 of i3.features) {
                const i4 = e4.instancedDataOffset, o2 = e4.instancedDataCount;
                for (let e5 = 0; e5 < o2; e5++) {
                  const o3 = 16 * (e5 + i4);
                  let l2 = a2.float32[o3 + 0];
                  l2 = l2 > ds ? l2 - ds : l2;
                  const u2 = Math.floor(l2), c2 = a2.float32[o3 + 1];
                  let h2 = false;
                  for (const e6 of this.activeReplacements)
                    if (!Vf(e6, r2, od.Model, n2) && !(e6.min.x > u2 || u2 > e6.max.x || e6.min.y > c2 || c2 > e6.max.y) && (h2 = Yf(Xf(u2, c2, t2.canonical, e6.footprintTileId.canonical), e6), h2))
                      break;
                  a2.float32[o3] = h2 ? l2 + ds : l2, s2 = s2 || h2;
                }
              }
            }
            return s2;
          }
          isEmpty() {
            for (const t2 in this.instancesPerModel)
              if (0 !== this.instancesPerModel[t2].instancedDataArray.length)
                return false;
            return true;
          }
          uploadPending() {
            return !this.uploaded;
          }
          upload(t2) {
            if (!this.uploaded)
              for (const e2 in this.instancesPerModel) {
                const r2 = this.instancesPerModel[e2];
                r2.instancedDataArray.length < 0 || 0 === r2.instancedDataArray.length || (r2.instancedDataBuffer ? r2.instancedDataBuffer.updateData(r2.instancedDataArray) : r2.instancedDataBuffer = t2.createVertexBuffer(r2.instancedDataArray, tv.members, true, void 0, this.instanceCount));
              }
            this.uploaded = true;
          }
          destroy() {
            for (const t3 in this.instancesPerModel) {
              const e2 = this.instancesPerModel[t3];
              0 !== e2.instancedDataArray.length && e2.instancedDataBuffer && e2.instancedDataBuffer.destroy();
            }
            const t2 = this.layers[0].modelManager;
            if (t2 && this.modelUris)
              for (const e2 of this.modelUris)
                t2.removeModel(e2, "");
          }
          addFeature(t2, e2, r2) {
            const n2 = this.layers[0], i2 = n2.layout.get("model-id").evaluate(r2, {}, this.canonical);
            if (!i2)
              return dr(`modelId is not evaluated for layer ${n2.id} and it is not going to get rendered.`), i2;
            nv(i2, false) && (this.modelUris.includes(i2) || this.modelUris.push(i2)), this.instancesPerModel[i2] || (this.instancesPerModel[i2] = new sv());
            const s2 = this.instancesPerModel[i2], a2 = s2.instancedDataArray, o2 = new iv(r2, a2.length);
            for (const t3 of e2)
              for (const e3 of t3) {
                if (e3.x < 0 || e3.x >= ds || e3.y < 0 || e3.y >= ds)
                  continue;
                const t4 = (this.lookupDim - 1) / ds, r3 = this.lookupDim * (e3.y * t4 | 0) + e3.x * t4 | 0;
                if (this.lookup) {
                  if (0 !== this.lookup[r3])
                    continue;
                  this.lookup[r3] = 1;
                }
                this.instanceCount++;
                const n3 = a2.length;
                a2.resize(n3 + 1), s2.instancesEvaluatedElevation.push(0), a2.float32[16 * n3] = e3.x, a2.float32[16 * n3 + 1] = e3.y;
              }
            return o2.instancedDataCount = s2.instancedDataArray.length - o2.instancedDataOffset, o2.instancedDataCount > 0 && (t2.id && (s2.idToFeaturesIndex[t2.id] = s2.features.length), s2.features.push(o2), this.evaluate(o2, {}, s2, false)), i2;
          }
          getModelUris() {
            return this.modelUris;
          }
          evaluate(t2, e2, r2, n2) {
            const i2 = this.layers[0], s2 = t2.feature, a2 = this.canonical, o2 = t2.rotation = i2.paint.get("model-rotation").evaluate(s2, e2, a2), l2 = t2.scale = i2.paint.get("model-scale").evaluate(s2, e2, a2), u2 = t2.translation = i2.paint.get("model-translation").evaluate(s2, e2, a2), c2 = i2.paint.get("model-color").evaluate(s2, e2, a2);
            c2.a = i2.paint.get("model-color-mix-intensity").evaluate(s2, e2, a2);
            const h2 = [];
            this.maxVerticalOffset < u2[2] && (this.maxVerticalOffset = u2[2]), this.maxScale = Math.max(Math.max(this.maxScale, l2[0]), Math.max(l2[1], l2[2])), Gb(h2, o2, l2);
            const p2 = Math.round(100 * c2.a) + c2.b / 1.05;
            for (let e3 = 0; e3 < t2.instancedDataCount; ++e3) {
              const i3 = t2.instancedDataOffset + e3, s3 = 16 * i3, o3 = r2.instancedDataArray.float32;
              let l3 = 0;
              n2 && (l3 = o3[s3 + 6] - r2.instancesEvaluatedElevation[i3]);
              const f2 = 0 | o3[s3 + 1];
              o3[s3] = (0 | o3[s3]) + c2.r / 1.05, o3[s3 + 1] = f2 + c2.g / 1.05, o3[s3 + 2] = p2, o3[s3 + 3] = 1 / (a2.z > 10 ? this.tileToMeter : jc(a2, f2)), o3[s3 + 4] = u2[0], o3[s3 + 5] = u2[1], o3[s3 + 6] = u2[2] + l3, o3[s3 + 7] = h2[0], o3[s3 + 8] = h2[1], o3[s3 + 9] = h2[2], o3[s3 + 10] = h2[4], o3[s3 + 11] = h2[5], o3[s3 + 12] = h2[6], o3[s3 + 13] = h2[8], o3[s3 + 14] = h2[9], o3[s3 + 15] = h2[10], r2.instancesEvaluatedElevation[i3] = u2[2];
            }
          }
        }
        let ov, lv;
        So(av, "ModelBucket", { omit: ["layers"] }), So(sv, "PerModelAttributes"), So(iv, "ModelFeature");
        const uv = 64, cv = { CoordinateSpaceTile: 1, CoordinateSpaceYUp: 2, HasMapboxMeshFeatures: 4, HasMeshoptCompression: 8 };
        function hv(e2, r2, n2, i2, s2, a2, o2, l2, u2, c2 = false) {
          const h2 = n2.zoom, p2 = n2.project(i2), f2 = Oc(i2.lat, h2), d2 = 1 / f2;
          t.ae.identity(e2), t.ae.translate(e2, e2, [p2.x + o2[0] * d2, p2.y + o2[1] * d2, o2[2]]);
          let m2 = 1, y2 = 1;
          const g2 = n2.worldSize;
          if (c2) {
            if ("mercator" === n2.projection.name) {
              let e3 = 0;
              n2.elevation && (e3 = n2.elevation.getAtPointOrZero(new Nc(p2.x / g2, p2.y / g2), 0));
              const r3 = t.aB.transformMat4([], [p2.x, p2.y, e3, 1], n2.projMatrix)[3] / n2.cameraToCenterDistance;
              m2 = r3, y2 = r3 * Oc(n2.center.lat, h2);
            } else if ("globe" === n2.projection.name) {
              const r3 = Yb(e2, n2), s3 = t.ae.multiply([], n2.projMatrix, r3), a3 = [0, 0, 0, 1];
              t.aB.transformMat4(a3, a3, s3);
              const o3 = a3[3] / n2.cameraToCenterDistance, l3 = Qh(h2), u3 = n2.projection.pixelsPerMeter(i2.lat, g2) * Oc(i2.lat, h2), c3 = n2.projection.pixelsPerMeter(n2.center.lat, g2) * Oc(n2.center.lat, h2);
              m2 = o3 / Yn(u3, Fc(n2.center.lat), l3), y2 = o3 * f2 / u3, m2 *= c3, y2 *= c3;
            }
          } else
            m2 = d2;
          t.ae.scale(e2, e2, [m2, m2, y2]);
          const x2 = [...e2], b2 = r2.orientation, v2 = [];
          if (Gb(v2, [b2[0] + s2[0], b2[1] + s2[1], b2[2] + s2[2]], a2), t.ae.multiply(e2, x2, v2), l2 && n2.elevation) {
            let s3 = 0;
            const a3 = [];
            if (u2 && n2.elevation) {
              s3 = function(e3, r3, n3, i3, s4) {
                const a4 = r3.elevation;
                if (!a4)
                  return 0;
                const o4 = kh.projectAabbCorners(n3, i3), l4 = Dc(1, s4.lat) * r3.worldSize, u3 = function(e4, r4) {
                  const n4 = [0, 0, 1], i4 = [{ corners: [0, 1, 3, 2], dotProductWithUp: 0 }, { corners: [1, 5, 2, 6], dotProductWithUp: 0 }, { corners: [0, 4, 1, 5], dotProductWithUp: 0 }, { corners: [2, 6, 3, 7], dotProductWithUp: 0 }, { corners: [4, 7, 5, 6], dotProductWithUp: 0 }, { corners: [0, 3, 4, 7], dotProductWithUp: 0 }];
                  for (const s5 of i4) {
                    const i5 = e4[s5.corners[0]], a5 = e4[s5.corners[1]], o5 = e4[s5.corners[2]], l5 = [a5[0] - i5[0], a5[1] - i5[1], r4 * (a5[2] - i5[2])], u4 = t.$.cross(l5, l5, [o5[0] - i5[0], o5[1] - i5[1], r4 * (o5[2] - i5[2])]);
                    t.$.normalize(u4, u4), s5.dotProductWithUp = t.$.dot(u4, n4);
                  }
                  return i4.sort((t2, e5) => t2.dotProductWithUp - e5.dotProductWithUp), i4[0].corners;
                }(o4, l4), c3 = o4[u3[0]], h3 = o4[u3[1]], p3 = o4[u3[2]], f3 = o4[u3[3]], d3 = a4.getAtPointOrZero(new Nc(c3[0] / r3.worldSize, c3[1] / r3.worldSize), 0), m3 = a4.getAtPointOrZero(new Nc(h3[0] / r3.worldSize, h3[1] / r3.worldSize), 0), y3 = a4.getAtPointOrZero(new Nc(p3[0] / r3.worldSize, p3[1] / r3.worldSize), 0), g3 = a4.getAtPointOrZero(new Nc(f3[0] / r3.worldSize, f3[1] / r3.worldSize), 0), x3 = (d3 + g3) / 2, b3 = (m3 + y3) / 2;
                return x3 > b3 ? m3 < y3 ? Xb(e3, h3, f3, c3, m3, g3, d3, l4) : Xb(e3, p3, c3, f3, y3, d3, g3, l4) : d3 < g3 ? Xb(e3, c3, h3, p3, d3, m3, y3, l4) : Xb(e3, f3, p3, h3, g3, y3, m3, l4), Math.max(x3, b3);
              }(a3, n2, r2.aabb, e2, i2);
              const o3 = t.ae.fromQuat([], a3), l3 = t.ae.multiply([], o3, v2);
              t.ae.multiply(e2, x2, l3);
            } else
              s3 = n2.elevation.getAtPointOrZero(new Nc(p2.x / g2, p2.y / g2), 0);
            0 !== s3 && (e2[14] += s3);
          }
        }
        function pv(t2, e2, r2 = false) {
          t2.uploaded || (t2.gfxTexture = new $g(e2, t2.image, r2 ? e2.gl.R8 : e2.gl.RGBA, { useMipmap: t2.sampler.minFilter >= e2.gl.NEAREST_MIPMAP_NEAREST }), t2.uploaded = true, t2.image = null);
        }
        function fv(t2, e2, r2) {
          t2.indexBuffer = e2.createIndexBuffer(t2.indexArray, false, true), t2.vertexBuffer = e2.createVertexBuffer(t2.vertexArray, Hb.members, false, true), t2.normalArray && (t2.normalBuffer = e2.createVertexBuffer(t2.normalArray, Qb.members, false, true)), t2.texcoordArray && (t2.texcoordBuffer = e2.createVertexBuffer(t2.texcoordArray, Jb.members, false, true)), t2.colorArray && (t2.colorBuffer = e2.createVertexBuffer(t2.colorArray, (12 === t2.colorArray.bytesPerElement ? Kb : Wb).members, false, true)), t2.featureArray && (t2.pbrBuffer = e2.createVertexBuffer(t2.featureArray, ev.members, true)), t2.segments = ku.simpleSegment(0, 0, t2.vertexArray.length, t2.indexArray.length);
          const n2 = t2.material;
          n2.pbrMetallicRoughness.baseColorTexture && pv(n2.pbrMetallicRoughness.baseColorTexture, e2), n2.pbrMetallicRoughness.metallicRoughnessTexture && pv(n2.pbrMetallicRoughness.metallicRoughnessTexture, e2), n2.normalTexture && pv(n2.normalTexture, e2), n2.occlusionTexture && pv(n2.occlusionTexture, e2, r2), n2.emissionTexture && pv(n2.emissionTexture, e2);
        }
        function dv(t2, e2, r2) {
          if (t2.meshes)
            for (const n2 of t2.meshes)
              fv(n2, e2, r2);
          if (t2.children)
            for (const n2 of t2.children)
              dv(n2, e2, r2);
        }
        function mv(t2) {
          if (t2.meshes)
            for (const e2 of t2.meshes)
              e2.indexArray.destroy(), e2.vertexArray.destroy(), e2.colorArray && e2.colorArray.destroy(), e2.normalArray && e2.normalArray.destroy(), e2.texcoordArray && e2.texcoordArray.destroy(), e2.featureArray && e2.featureArray.destroy();
          if (t2.children)
            for (const e2 of t2.children)
              mv(e2);
        }
        function yv(t2) {
          if (t2.meshes)
            for (const r2 of t2.meshes)
              r2.vertexBuffer && (r2.vertexBuffer.destroy(), r2.indexBuffer.destroy(), r2.normalBuffer && r2.normalBuffer.destroy(), r2.texcoordBuffer && r2.texcoordBuffer.destroy(), r2.colorBuffer && r2.colorBuffer.destroy(), r2.pbrBuffer && r2.pbrBuffer.destroy(), r2.segments.destroy(), r2.material && ((e2 = r2.material).pbrMetallicRoughness.baseColorTexture && e2.pbrMetallicRoughness.baseColorTexture.gfxTexture && e2.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), e2.pbrMetallicRoughness.metallicRoughnessTexture && e2.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && e2.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), e2.normalTexture && e2.normalTexture.gfxTexture && e2.normalTexture.gfxTexture.destroy(), e2.emissionTexture && e2.emissionTexture.gfxTexture && e2.emissionTexture.gfxTexture.destroy(), e2.occlusionTexture && e2.occlusionTexture.gfxTexture && e2.occlusionTexture.gfxTexture.destroy()));
          var e2;
          if (t2.children)
            for (const e3 of t2.children)
              yv(e3);
        }
        class gv {
          constructor(t2) {
            this._callback = t2, this._triggered = false, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel(), this._channel.port2.onmessage = () => {
              this._triggered = false, this._callback();
            });
          }
          trigger() {
            this._triggered || (this._triggered = true, this._channel ? this._channel.port1.postMessage(true) : setTimeout(() => {
              this._triggered = false, this._callback();
            }, 0));
          }
          remove() {
            this._channel = void 0, this._callback = () => {
            };
          }
        }
        class xv {
          constructor() {
            this.tasks = {}, this.taskQueue = [], lr(["process"], this), this.invoker = new gv(this.process), this.nextId = 0;
          }
          add(t2, e2) {
            const r2 = this.nextId++, n2 = function({ type: t3, isSymbolTile: e3, zoom: r3 }) {
              return r3 = r3 || 0, "message" === t3 ? 0 : "maybePrepare" !== t3 || e3 ? "parseTile" !== t3 || e3 ? "parseTile" === t3 && e3 ? 300 - r3 : "maybePrepare" === t3 && e3 ? 400 - r3 : 500 : 200 - r3 : 100 - r3;
            }(e2);
            if (0 === n2) {
              try {
                t2();
              } finally {
              }
              return null;
            }
            return this.tasks[r2] = { fn: t2, metadata: e2, priority: n2, id: r2 }, this.taskQueue.push(r2), this.invoker.trigger(), { cancel: () => {
              delete this.tasks[r2];
            } };
          }
          process() {
            try {
              if (this.taskQueue = this.taskQueue.filter((t3) => !!this.tasks[t3]), !this.taskQueue.length)
                return;
              const t2 = this.pick();
              if (null === t2)
                return;
              const e2 = this.tasks[t2];
              if (delete this.tasks[t2], this.taskQueue.length && this.invoker.trigger(), !e2)
                return;
              e2.fn();
            } finally {
            }
          }
          pick() {
            let t2 = null, e2 = 1 / 0;
            for (let r3 = 0; r3 < this.taskQueue.length; r3++) {
              const n2 = this.tasks[this.taskQueue[r3]];
              n2.priority < e2 && (e2 = n2.priority, t2 = r3);
            }
            if (null === t2)
              return null;
            const r2 = this.taskQueue[t2];
            return this.taskQueue.splice(t2, 1), r2;
          }
          remove() {
            this.invoker.remove();
          }
        }
        class bv {
          constructor(t2, e2, r2) {
            this.target = t2, this.parent = e2, this.mapId = r2, this.callbacks = {}, this.cancelCallbacks = {}, lr(["receive"], this), this.target.addEventListener("message", this.receive, false), this.scheduler = new xv();
          }
          send(t2, e2, r2, n2, i2 = false, s2) {
            const a2 = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
            r2 && (r2.metadata = s2, this.callbacks[a2] = r2);
            const o2 = /* @__PURE__ */ new Set();
            return this.target.postMessage({ id: a2, type: t2, hasCallback: !!r2, targetMapId: n2, mustQueue: i2, sourceMapId: this.mapId, data: ko(e2, o2) }, o2), { cancel: () => {
              r2 && delete this.callbacks[a2], this.target.postMessage({ id: a2, type: "<cancel>", targetMapId: n2, sourceMapId: this.mapId });
            } };
          }
          receive(t2) {
            const e2 = t2.data, r2 = e2.id;
            if (r2 && (!e2.targetMapId || this.mapId === e2.targetMapId))
              if ("<cancel>" === e2.type) {
                const t3 = this.cancelCallbacks[r2];
                delete this.cancelCallbacks[r2], t3 && t3.cancel();
              } else if (e2.mustQueue || xr()) {
                const t3 = this.callbacks[r2], n2 = this.scheduler.add(() => this.processTask(r2, e2), t3 && t3.metadata || { type: "message" });
                n2 && (this.cancelCallbacks[r2] = n2);
              } else
                this.processTask(r2, e2);
          }
          processTask(t2, e2) {
            if (delete this.cancelCallbacks[t2], "<response>" === e2.type) {
              const r2 = this.callbacks[t2];
              delete this.callbacks[t2], r2 && (e2.error ? r2(Po(e2.error)) : r2(null, Po(e2.data)));
            } else {
              const r2 = /* @__PURE__ */ new Set(), n2 = e2.hasCallback ? (e3, n3) => {
                this.target.postMessage({ id: t2, type: "<response>", sourceMapId: this.mapId, error: e3 ? ko(e3) : null, data: ko(n3, r2) }, r2);
              } : (t3) => {
              }, i2 = Po(e2.data);
              if (this.parent[e2.type])
                this.parent[e2.type](e2.sourceMapId, i2, n2);
              else if (this.parent.getWorkerSource) {
                const t3 = e2.type.split(".");
                this.parent.getWorkerSource(e2.sourceMapId, t3[0], i2.source, i2.scope)[t3[1]](i2, n2);
              } else
                n2(new Error(`Could not find function ${e2.type}`));
            }
          }
          remove() {
            this.scheduler.remove(), this.target.removeEventListener("message", this.receive, false);
          }
        }
        class vv {
          constructor(t2, e2) {
            this.workerPool = t2, this.actors = [], this.currentActor = 0, this.id = ir();
            const r2 = this.workerPool.acquire(this.id);
            for (let t3 = 0; t3 < r2.length; t3++) {
              const n2 = new vv.Actor(r2[t3], e2, this.id);
              n2.name = `Worker ${t3}`, this.actors.push(n2);
            }
            this.ready = false, this.broadcast("checkIfReady", null, () => {
              this.ready = true;
            });
          }
          broadcast(t2, e2, r2) {
            tr(this.actors, (r3, n2) => {
              r3.send(t2, e2, n2);
            }, r2 = r2 || function() {
            });
          }
          getActor() {
            return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
          }
          remove() {
            this.actors.forEach((t2) => {
              t2.remove();
            }), this.actors = [], this.workerPool.release(this.id);
          }
        }
        vv.Actor = bv;
        var _v = { workerUrl: "", workerClass: null, workerParams: void 0 };
        function wv() {
          return null != _v.workerClass ? new _v.workerClass() : new self.Worker(_v.workerUrl, _v.workerParams);
        }
        const Mv = "mapboxgl_preloaded_worker_pool";
        class Av {
          constructor() {
            this.active = {};
          }
          acquire(t2) {
            if (!this.workers)
              for (this.workers = []; this.workers.length < Av.workerCount; )
                this.workers.push(new wv());
            return this.active[t2] = true, this.workers.slice();
          }
          release(t2) {
            delete this.active[t2], this.workers && 0 === this.numActive() && (this.workers.forEach((t3) => {
              t3.terminate();
            }), this.workers = null);
          }
          isPreloaded() {
            return !!this.active[Mv];
          }
          numActive() {
            return Object.keys(this.active).length;
          }
        }
        let Sv;
        function Iv() {
          return Sv || (Sv = new Av()), Sv;
        }
        Av.workerCount = 2;
        let Tv, kv, Pv, zv, Ev, Bv = null;
        function Dv() {
          return xr() && self.worker && self.worker.dracoUrl ? self.worker.dracoUrl : kv || n.DRACO_URL;
        }
        function Rv() {
          if (xr() && self.worker && self.worker.meshoptUrl)
            return self.worker.meshoptUrl;
          if (zv)
            return zv;
          const t2 = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 3, 2, 0, 0, 5, 3, 1, 0, 1, 12, 1, 0, 10, 22, 2, 12, 0, 65, 0, 65, 0, 65, 0, 252, 10, 0, 0, 11, 7, 0, 65, 0, 253, 15, 26, 11]);
          if ("object" != typeof WebAssembly)
            throw new Error("WebAssembly not supported, cannot instantiate meshoptimizer");
          return zv = WebAssembly.validate(t2) ? n.MESHOPT_SIMD_URL : n.MESHOPT_URL, zv;
        }
        const Cv = { 5120: Int8Array, 5121: Uint8Array, 5122: Int16Array, 5123: Uint16Array, 5125: Uint32Array, 5126: Float32Array }, Lv = { 5120: "DT_INT8", 5121: "DT_UINT8", 5122: "DT_INT16", 5123: "DT_UINT16", 5125: "DT_UINT32", 5126: "DT_FLOAT32" }, Vv = { SCALAR: 1, VEC2: 2, VEC3: 3, VEC4: 4, MAT2: 4, MAT3: 9, MAT4: 16 };
        function Fv(t2, e2, r2) {
          const n2 = r2.json.bufferViews.length, i2 = r2.buffers.length;
          e2.bufferView = n2, r2.json.bufferViews[n2] = { buffer: i2, byteLength: t2.byteLength }, r2.buffers[i2] = t2;
        }
        const Ov = "KHR_draco_mesh_compression";
        function Uv(t2, e2) {
          const r2 = t2.extensions && t2.extensions[Ov];
          if (!r2)
            return;
          const n2 = new Pv.Decoder(), i2 = Yv(e2, r2.bufferView), s2 = new Pv.Mesh();
          if (!n2.DecodeArrayToMesh(i2, i2.byteLength, s2))
            throw new Error("Failed to decode Draco mesh");
          const a2 = e2.json.accessors[t2.indices], o2 = Cv[a2.componentType], l2 = a2.count * o2.BYTES_PER_ELEMENT, u2 = Pv._malloc(l2);
          o2 === Uint16Array ? n2.GetTrianglesUInt16Array(s2, l2, u2) : n2.GetTrianglesUInt32Array(s2, l2, u2), Fv(Pv.memory.buffer.slice(u2, u2 + l2), a2, e2), Pv._free(u2);
          for (const i3 of Object.keys(r2.attributes)) {
            const a3 = n2.GetAttributeByUniqueId(s2, r2.attributes[i3]), o3 = e2.json.accessors[t2.attributes[i3]], l3 = Lv[o3.componentType], u3 = o3.count * Vv[o3.type] * Cv[o3.componentType].BYTES_PER_ELEMENT, c2 = Pv._malloc(u3);
            n2.GetAttributeDataArrayForAllPoints(s2, a3, Pv[l3], u3, c2), Fv(Pv.memory.buffer.slice(c2, c2 + u3), o3, e2), Pv._free(c2);
          }
          n2.destroy(), s2.destroy(), delete t2.extensions[Ov];
        }
        const jv = "EXT_meshopt_compression";
        function Nv(t2, e2) {
          if (!t2.extensions || !t2.extensions[jv])
            return;
          const r2 = t2.extensions[jv], n2 = new Uint8Array(e2.buffers[r2.buffer], r2.byteOffset || 0, r2.byteLength || 0), i2 = new Uint8Array(r2.count * r2.byteStride);
          Ev.decodeGltfBuffer(i2, r2.count, r2.byteStride, n2, r2.mode, r2.filter), t2.buffer = e2.buffers.length, t2.byteOffset = 0, e2.buffers[t2.buffer] = i2.buffer, delete t2.extensions[jv];
        }
        const $v = 1179937895, qv = new TextDecoder("utf8");
        function Gv(t2, e2) {
          return new URL(t2, e2).href;
        }
        function Xv(t2, e2, r2, n2) {
          return fetch(Gv(t2.uri, n2)).then((t3) => t3.arrayBuffer()).then((t3) => {
            e2.buffers[r2] = t3;
          });
        }
        function Yv(t2, e2) {
          const r2 = t2.json.bufferViews[e2];
          return new Uint8Array(t2.buffers[r2.buffer], r2.byteOffset || 0, r2.byteLength);
        }
        function Zv(t2, e2, r2, n2) {
          if (t2.uri) {
            const i2 = Gv(t2.uri, n2);
            return fetch(i2).then((t3) => t3.blob()).then((t3) => createImageBitmap(t3)).then((t3) => {
              e2.images[r2] = t3;
            });
          }
          if (void 0 !== t2.bufferView) {
            const n3 = Yv(e2, t2.bufferView), i2 = new Blob([n3], { type: t2.mimeType });
            return createImageBitmap(i2).then((t3) => {
              e2.images[r2] = t3;
            });
          }
        }
        function Hv(t2, e2 = 0, r2) {
          const n2 = { json: null, images: [], buffers: [] };
          if (new Uint32Array(t2, e2, 1)[0] === $v) {
            const r3 = new Uint32Array(t2, e2);
            let i3 = 2;
            const s3 = (r3[i3++] >> 2) - 3, a3 = r3[i3++] >> 2;
            if (i3++, n2.json = JSON.parse(qv.decode(r3.subarray(i3, i3 + a3))), i3 += a3, i3 < s3) {
              const s4 = r3[i3++];
              i3++;
              const a4 = e2 + (i3 << 2);
              n2.buffers[0] = t2.slice(a4, a4 + s4);
            }
          } else
            n2.json = JSON.parse(qv.decode(new Uint8Array(t2, e2)));
          const { buffers: i2, images: s2, meshes: a2, extensionsUsed: o2, bufferViews: l2 } = n2.json;
          let u2 = Promise.resolve();
          if (i2) {
            const t3 = [];
            for (let e3 = 0; e3 < i2.length; e3++) {
              const s3 = i2[e3];
              s3.uri ? t3.push(Xv(s3, n2, e3, r2)) : n2.buffers[e3] || (n2.buffers[e3] = null);
            }
            u2 = Promise.all(t3);
          }
          return u2.then(() => {
            const t3 = [], e3 = o2 && o2.includes(Ov), i3 = o2 && o2.includes(jv);
            if (e3 && t3.push(function() {
              if (!Pv)
                return Tv || (Tv = function(t4) {
                  let e4, r3 = null;
                  function n3() {
                    e4 = new Uint8Array(r3.buffer);
                  }
                  function i4() {
                    throw new Error("Unexpected Draco error.");
                  }
                  const s3 = { a: { a: i4, d: function(t5, r4, n4) {
                    return e4.copyWithin(t5, r4, r4 + n4);
                  }, c: function(t5) {
                    const i5 = e4.length, s4 = Math.max(t5 >>> 0, Math.ceil(1.2 * i5)), a3 = Math.ceil((s4 - i5) / 65536);
                    try {
                      return r3.grow(a3), n3(), true;
                    } catch (t6) {
                      return false;
                    }
                  }, b: i4 } };
                  return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(t4, s3) : t4.then((t5) => t5.arrayBuffer()).then((t5) => WebAssembly.instantiate(t5, s3))).then((t5) => {
                    const { Rb: i5, Qb: s4, P: a3, T: o3, X: l3, Ja: u3, La: c2, Qa: h2, Va: p2, Wa: f2, eb: d2, jb: m2, f: y2, e: g2, yb: x2, zb: b2, Ab: v2, Bb: _2, Db: w2, Gb: M2 } = t5.instance.exports;
                    r3 = g2;
                    const A2 = (() => {
                      let t6 = 0, r4 = 0, n4 = 0, a4 = 0;
                      return (o4) => {
                        n4 && (i5(a4), i5(t6), r4 += n4, n4 = t6 = 0), t6 || (r4 += 128, t6 = s4(r4));
                        const l4 = o4.length + 7 & -8;
                        let u4 = t6;
                        l4 >= r4 && (n4 = l4, u4 = a4 = s4(l4));
                        for (let t7 = 0; t7 < o4.length; t7++)
                          e4[u4 + t7] = o4[t7];
                        return u4;
                      };
                    })();
                    return n3(), y2(), { memory: g2, _free: i5, _malloc: s4, Mesh: class {
                      constructor() {
                        this.ptr = a3();
                      }
                      destroy() {
                        o3(this.ptr);
                      }
                    }, Decoder: class {
                      constructor() {
                        this.ptr = u3();
                      }
                      destroy() {
                        m2(this.ptr);
                      }
                      DecodeArrayToMesh(t6, e5, r4) {
                        const n4 = A2(t6), i6 = c2(this.ptr, n4, e5, r4.ptr);
                        return !!l3(i6);
                      }
                      GetAttributeByUniqueId(t6, e5) {
                        return { ptr: h2(this.ptr, t6.ptr, e5) };
                      }
                      GetTrianglesUInt16Array(t6, e5, r4) {
                        p2(this.ptr, t6.ptr, e5, r4);
                      }
                      GetTrianglesUInt32Array(t6, e5, r4) {
                        f2(this.ptr, t6.ptr, e5, r4);
                      }
                      GetAttributeDataArrayForAllPoints(t6, e5, r4, n4, i6) {
                        d2(this.ptr, t6.ptr, e5.ptr, r4, n4, i6);
                      }
                    }, DT_INT8: x2(), DT_UINT8: b2(), DT_INT16: v2(), DT_UINT16: _2(), DT_UINT32: w2(), DT_FLOAT32: M2() };
                  });
                }(fetch(Dv())), Tv.then((t4) => {
                  Pv = t4, Tv = void 0;
                }));
            }()), i3 && t3.push(function() {
              if (Ev)
                return;
              const t4 = function(t5) {
                let e4;
                const r3 = WebAssembly.instantiateStreaming(t5, {}).then((t6) => {
                  e4 = t6.instance, e4.exports.__wasm_call_ctors();
                }), n3 = { NONE: "", OCTAHEDRAL: "meshopt_decodeFilterOct", QUATERNION: "meshopt_decodeFilterQuat", EXPONENTIAL: "meshopt_decodeFilterExp" }, i4 = { ATTRIBUTES: "meshopt_decodeVertexBuffer", TRIANGLES: "meshopt_decodeIndexBuffer", INDICES: "meshopt_decodeIndexSequence" };
                return { ready: r3, supported: true, decodeGltfBuffer(t6, r4, s3, a3, o3, l3) {
                  !function(t7, e5, r5, n4, i5, s4, a4) {
                    const o4 = t7.exports.sbrk, l4 = n4 + 3 & -4, u3 = o4(l4 * i5), c2 = o4(s4.length), h2 = new Uint8Array(t7.exports.memory.buffer);
                    h2.set(s4, c2);
                    const p2 = e5(u3, n4, i5, c2, s4.length);
                    if (0 === p2 && a4 && a4(u3, l4, i5), r5.set(h2.subarray(u3, u3 + n4 * i5)), o4(u3 - o4(0)), 0 !== p2)
                      throw new Error(`Malformed buffer data: ${p2}`);
                  }(e4, e4.exports[i4[o3]], t6, r4, s3, a3, e4.exports[n3[l3]]);
                } };
              }(fetch(Rv()));
              return t4.ready.then(() => {
                Ev = t4;
              });
            }()), s2)
              for (let e4 = 0; e4 < s2.length; e4++)
                t3.push(Zv(s2[e4], n2, e4, r2));
            return (t3.length ? Promise.all(t3) : Promise.resolve()).then(() => {
              if (e3 && a2)
                for (const { primitives: t4 } of a2)
                  for (const e4 of t4)
                    Uv(e4, n2);
              if (i3 && a2 && l2)
                for (const t4 of l2)
                  Nv(t4, n2);
              return n2;
            });
          });
        }
        function Kv(t2, e2) {
          const r2 = t2.json.bufferViews[e2.bufferView], n2 = Cv[e2.componentType];
          return new n2(t2.buffers[r2.buffer], (e2.byteOffset || 0) + (r2.byteOffset || 0), e2.count * (r2.byteStride && r2.byteStride !== Vv[e2.type] * n2.BYTES_PER_ELEMENT ? r2.byteStride / n2.BYTES_PER_ELEMENT : Vv[e2.type]));
        }
        function Wv(t2, e2, r2, n2) {
          const i2 = Cv[e2.componentType], s2 = function(t3) {
            switch (t3) {
              case Int8Array:
                return 1 / 127;
              case Uint8Array:
                return 1 / 255;
              case Int16Array:
                return 1 / 32767;
              case Uint16Array:
                return 1 / 65535;
              default:
                return 1;
            }
          }(i2), a2 = t2.json.bufferViews[e2.bufferView], o2 = a2.byteStride ? a2.byteStride / i2.BYTES_PER_ELEMENT : Vv[e2.type], l2 = r2.float32, u2 = l2.length / r2.capacity;
          for (let t3 = 0, r3 = 0; t3 < e2.count * o2; t3 += o2, r3 += u2)
            for (let e3 = 0; e3 < u2; e3++)
              l2[r3 + e3] = n2[t3 + e3] * s2;
          r2._trim();
        }
        function Jv(t2, e2, r2) {
          const n2 = t2.indices, i2 = t2.attributes, s2 = {};
          s2.indexArray = new tu();
          const a2 = e2.json.accessors[n2], o2 = a2.count / 3;
          s2.indexArray.reserve(o2);
          const l2 = Kv(e2, a2);
          for (let t3 = 0; t3 < o2; t3++)
            s2.indexArray.emplaceBack(l2[3 * t3], l2[3 * t3 + 1], l2[3 * t3 + 2]);
          s2.indexArray._trim(), s2.vertexArray = new Nl();
          const u2 = e2.json.accessors[i2.POSITION];
          s2.vertexArray.reserve(u2.count);
          const c2 = Kv(e2, u2);
          for (let t3 = 0; t3 < u2.count; t3++)
            s2.vertexArray.emplaceBack(c2[3 * t3], c2[3 * t3 + 1], c2[3 * t3 + 2]);
          if (s2.vertexArray._trim(), s2.aabb = new kh(u2.min, u2.max), s2.centroid = function(t3, e3) {
            const r3 = [0, 0, 0], n3 = t3.length;
            if (n3 > 0) {
              for (let i3 = 0; i3 < n3; i3++) {
                const n4 = 3 * t3[i3];
                r3[0] += e3[n4], r3[1] += e3[n4 + 1], r3[2] += e3[n4 + 2];
              }
              r3[0] /= n3, r3[1] /= n3, r3[2] /= n3;
            }
            return r3;
          }(l2, c2), void 0 !== i2.COLOR_0) {
            const t3 = e2.json.accessors[i2.COLOR_0], r3 = Vv[t3.type], n3 = Kv(e2, t3);
            s2.colorArray = 3 === r3 ? new Nl() : new jl(), s2.colorArray.resize(t3.count), Wv(e2, t3, s2.colorArray, n3);
          }
          if (void 0 !== i2.NORMAL) {
            s2.normalArray = new Nl();
            const t3 = e2.json.accessors[i2.NORMAL];
            s2.normalArray.resize(t3.count);
            const r3 = Kv(e2, t3);
            Wv(e2, t3, s2.normalArray, r3);
          }
          if (void 0 !== i2.TEXCOORD_0 && r2.length > 0) {
            s2.texcoordArray = new lu();
            const t3 = e2.json.accessors[i2.TEXCOORD_0];
            s2.texcoordArray.resize(t3.count);
            const r3 = Kv(e2, t3);
            Wv(e2, t3, s2.texcoordArray, r3);
          }
          if (void 0 !== i2._FEATURE_ID_RGBA4444) {
            const t3 = e2.json.accessors[i2._FEATURE_ID_RGBA4444];
            e2.json.extensionsUsed && e2.json.extensionsUsed.includes("EXT_meshopt_compression") && (s2.featureData = Kv(e2, t3));
          }
          void 0 !== i2._FEATURE_RGBA4444 && (s2.featureData = new Uint32Array(Kv(e2, e2.json.accessors[i2._FEATURE_RGBA4444]).buffer));
          const h2 = t2.material;
          return s2.material = function(t3, e3) {
            const { emissiveFactor: r3 = [0, 0, 0], alphaMode: n3 = "OPAQUE", alphaCutoff: i3 = 0.5, normalTexture: s3, occlusionTexture: a3, emissiveTexture: o3, doubleSided: l3 } = t3, { baseColorFactor: u3 = [1, 1, 1, 1], metallicFactor: c3 = 1, roughnessFactor: h3 = 1, baseColorTexture: p2, metallicRoughnessTexture: f2 } = t3.pbrMetallicRoughness || {}, d2 = a3 ? e3[a3.index] : void 0;
            if (a3 && a3.extensions && a3.extensions.KHR_texture_transform && d2) {
              const t4 = a3.extensions.KHR_texture_transform;
              d2.offsetScale = [t4.offset[0], t4.offset[1], t4.scale[0], t4.scale[1]];
            }
            return { pbrMetallicRoughness: { baseColorFactor: new Gn(...u3), metallicFactor: c3, roughnessFactor: h3, baseColorTexture: p2 ? e3[p2.index] : void 0, metallicRoughnessTexture: f2 ? e3[f2.index] : void 0 }, doubleSided: l3, emissiveFactor: r3, alphaMode: n3, alphaCutoff: i3, normalTexture: s3 ? e3[s3.index] : void 0, occlusionTexture: d2, emissionTexture: o3 ? e3[o3.index] : void 0, defined: void 0 === t3.defined };
          }(void 0 !== h2 ? e2.json.materials[h2] : { defined: false }, r2), s2;
        }
        function Qv(e2, r2, n2) {
          const { matrix: i2, rotation: s2, translation: a2, scale: o2, mesh: l2, extras: u2, children: c2 } = e2, h2 = {};
          if (h2.matrix = i2 || t.ae.fromRotationTranslationScale([], s2 || [0, 0, 0, 1], a2 || [0, 0, 0], o2 || [1, 1, 1]), void 0 !== l2) {
            h2.meshes = n2[l2];
            const t2 = h2.anchor = [0, 0];
            for (const e3 of h2.meshes) {
              const { min: r3, max: n3 } = e3.aabb;
              t2[0] += r3[0] + n3[0], t2[1] += r3[1] + n3[1];
            }
            t2[0] = Math.floor(t2[0] / h2.meshes.length / 2), t2[1] = Math.floor(t2[1] / h2.meshes.length / 2);
          }
          if (u2 && (u2.id && (h2.id = u2.id), u2.lights && (h2.lights = function(t2) {
            if (!t2.length)
              return [];
            const e3 = function(t3) {
              const e4 = atob(t3), r4 = new Uint8Array(e4.length);
              for (let t4 = 0; t4 < e4.length; t4++)
                r4[t4] = e4.codePointAt(t4);
              return r4;
            }(t2), r3 = [], n3 = e3.length / 24, i3 = new Uint16Array(e3.buffer), s3 = new Float32Array(e3.buffer);
            for (let t3 = 0; t3 < n3; t3++) {
              const e4 = i3[2 * t3 * 6] / 30, n4 = i3[2 * t3 * 6 + 1] / 30, a3 = i3[2 * t3 * 6 + 10] / 100, o3 = s3[6 * t3 + 1], l3 = s3[6 * t3 + 2], u3 = s3[6 * t3 + 3], c3 = s3[6 * t3 + 4], h3 = u3 - o3, p2 = c3 - l3, f2 = Math.hypot(h3, p2);
              r3.push({ pos: [o3 + 0.5 * h3, l3 + 0.5 * p2, n4], normal: [p2 / f2, -h3 / f2, 0], width: f2, height: e4, depth: a3, points: [o3, l3, u3, c3] });
            }
            return r3;
          }(u2.lights))), c2) {
            const t2 = [];
            for (const e3 of c2)
              t2.push(Qv(r2.json.nodes[e3], r2, n2));
            h2.children = t2;
          }
          return h2;
        }
        function t_(t2) {
          if (0 === t2.vertices.length || 0 === t2.indices.length)
            return null;
          const e2 = new of(t2.vertices, t2.indices, 8, 256), [r2, n2] = [e2.min.clone(), e2.max.clone()];
          return { vertices: t2.vertices, indices: t2.indices, grid: e2, min: r2, max: n2 };
        }
        function e_(t2) {
          if (!t2.extras || !t2.extras.ground)
            return null;
          const e2 = t2.extras.ground;
          if (!e2 || !Array.isArray(e2) || 0 === e2.length)
            return null;
          const r2 = e2[0];
          if (!r2 || !Array.isArray(r2) || 0 === r2.length)
            return null;
          const n2 = [];
          for (const t3 of r2) {
            if (!Array.isArray(t3) || 2 !== t3.length)
              continue;
            const e3 = t3[0], r3 = t3[1];
            "number" == typeof e3 && "number" == typeof r3 && n2.push(new je(e3, r3));
          }
          if (n2.length < 3)
            return null;
          n2.length > 1 && n2[n2.length - 1].equals(n2[0]) && n2.pop();
          let i2 = 0;
          for (let t3 = 0; t3 < n2.length; t3++) {
            const e3 = n2[t3], r3 = n2[(t3 + 1) % n2.length], s3 = n2[(t3 + 2) % n2.length];
            i2 += (e3.x - r3.x) * (s3.y - r3.y) - (s3.x - r3.x) * (e3.y - r3.y);
          }
          i2 > 0 && n2.reverse();
          const s2 = Ip(n2.flatMap((t3) => [t3.x, t3.y]), []);
          return 0 === s2.length ? null : { vertices: n2, indices: s2 };
        }
        function r_(e2, r2) {
          const n2 = [], i2 = [];
          let s2 = 0;
          const a2 = [];
          for (const o2 of e2) {
            s2 = n2.length;
            const e3 = o2.vertexArray.float32, l2 = o2.indexArray.uint16;
            for (let i3 = 0; i3 < o2.vertexArray.length; i3++)
              a2[0] = e3[3 * i3 + 0], a2[1] = e3[3 * i3 + 1], a2[2] = e3[3 * i3 + 2], t.$.transformMat4(a2, a2, r2), n2.push(new je(a2[0], a2[1]));
            for (let t2 = 0; t2 < 3 * o2.indexArray.length; t2++)
              i2.push(l2[t2] + s2);
          }
          if (i2.length % 3 != 0)
            return null;
          for (let t2 = 0; t2 < i2.length; t2 += 3) {
            const e3 = n2[i2[t2 + 0]], r3 = n2[i2[t2 + 1]], s3 = n2[i2[t2 + 2]];
            (e3.x - r3.x) * (s3.y - r3.y) - (s3.x - r3.x) * (e3.y - r3.y) > 0 && ([i2[t2 + 1], i2[t2 + 2]] = [i2[t2 + 2], i2[t2 + 1]]);
          }
          return { vertices: n2, indices: i2 };
        }
        function n_(t2) {
          const e2 = function(t3, e3) {
            const r3 = [], n3 = WebGL2RenderingContext;
            if (t3.json.textures)
              for (const i3 of t3.json.textures) {
                const s3 = { magFilter: n3.LINEAR, minFilter: n3.NEAREST, wrapS: n3.REPEAT, wrapT: n3.REPEAT };
                void 0 !== i3.sampler && Object.assign(s3, t3.json.samplers[i3.sampler]), r3.push({ image: e3[i3.source], sampler: s3, uploaded: false });
              }
            return r3;
          }(t2, t2.images), r2 = function(t3, e3) {
            const r3 = [];
            for (const n3 of t3.json.meshes) {
              const i3 = [];
              for (const r4 of n3.primitives)
                i3.push(Jv(r4, t3, e3));
              r3.push(i3);
            }
            return r3;
          }(t2, e2), { scenes: n2, scene: i2, nodes: s2 } = t2.json, a2 = n2 ? n2[i2 || 0].nodes : s2, o2 = [];
          for (const e3 of a2)
            o2.push(Qv(s2[e3], t2, r2));
          return function(t3, e3, r3) {
            const n3 = {}, i3 = /* @__PURE__ */ new Set();
            for (let s3 = 0; s3 < t3.length; s3++) {
              const t4 = r3[e3[s3]];
              if (!t4.extras)
                continue;
              const a3 = t4.extras["mapbox:footprint:version"], o3 = t4.extras["mapbox:footprint:id"];
              (a3 || o3) && i3.add(s3), "1.0.0" === a3 && o3 && (n3[o3] = s3);
            }
            for (let s3 = 0; s3 < t3.length; s3++) {
              if (i3.has(s3))
                continue;
              const a3 = t3[s3], o3 = r3[e3[s3]];
              if (!o3.extras)
                continue;
              let l2 = null;
              a3.id in n3 && (l2 = r_(t3[n3[a3.id]].meshes, a3.matrix)), l2 || (l2 = e_(o3)), l2 && (a3.footprint = t_(l2));
            }
            if (i3.size > 0) {
              const e4 = Array.from(i3.values()).sort((t4, e5) => t4 - e5);
              for (let r4 = e4.length - 1; r4 >= 0; r4--)
                t3.splice(e4[r4], 1);
            }
          }(o2, a2, t2.json.nodes), o2;
        }
        function i_(t2) {
          t2.heightmap = new Float32Array(4096), t2.heightmap.fill(-1);
          const e2 = t2.vertexArray.float32, r2 = t2.aabb.min[0] - 1, n2 = t2.aabb.min[1] - 1, i2 = uv / (t2.aabb.max[0] - r2 + 2), s2 = uv / (t2.aabb.max[1] - n2 + 2);
          for (let a2 = 0; a2 < e2.length; a2 += 3) {
            const o2 = e2[a2 + 2], l2 = (e2[a2 + 0] - r2) * i2 | 0, u2 = (e2[a2 + 1] - n2) * s2 | 0;
            o2 > t2.heightmap[u2 * uv + l2] && (t2.heightmap[u2 * uv + l2] = o2);
          }
        }
        function s_(e2, r2) {
          const n2 = {};
          n2.indexArray = new tu(), n2.indexArray.reserve(4 * e2.length), n2.vertexArray = new Nl(), n2.vertexArray.reserve(10 * e2.length), n2.colorArray = new jl(), n2.vertexArray.reserve(10 * e2.length);
          let i2 = 0;
          for (const s3 of e2) {
            const e3 = Math.min(10, Math.max(4, 1.3 * s3.height)) * r2, a3 = [-s3.normal[1], s3.normal[0], 0], o2 = Math.min(0.29, 0.1 * s3.width / s3.depth), l2 = s3.width - 2 * s3.depth * r2 * (o2 + 0.01), u2 = t.$.scaleAndAdd([], s3.pos, a3, l2 / 2), c2 = t.$.scaleAndAdd([], s3.pos, a3, -l2 / 2), h2 = [u2[0], u2[1], u2[2] + s3.height], p2 = [c2[0], c2[1], c2[2] + s3.height], f2 = t.$.scaleAndAdd([], s3.normal, a3, o2);
            t.$.scale(f2, f2, e3);
            const d2 = t.$.scaleAndAdd([], s3.normal, a3, -o2);
            t.$.scale(d2, d2, e3), t.$.add(f2, u2, f2), t.$.add(d2, c2, d2), u2[2] += 0.1, c2[2] += 0.1, n2.vertexArray.emplaceBack(f2[0], f2[1], f2[2]), n2.vertexArray.emplaceBack(d2[0], d2[1], d2[2]), n2.vertexArray.emplaceBack(u2[0], u2[1], u2[2]), n2.vertexArray.emplaceBack(c2[0], c2[1], c2[2]), n2.vertexArray.emplaceBack(h2[0], h2[1], h2[2]), n2.vertexArray.emplaceBack(p2[0], p2[1], p2[2]), n2.vertexArray.emplaceBack(u2[0], u2[1], u2[2]), n2.vertexArray.emplaceBack(c2[0], c2[1], c2[2]), n2.vertexArray.emplaceBack(f2[0], f2[1], f2[2]), n2.vertexArray.emplaceBack(d2[0], d2[1], d2[2]);
            const m2 = l2 / e3 / 2;
            n2.colorArray.emplaceBack(-m2 - o2, -1, m2, 0.8), n2.colorArray.emplaceBack(m2 + o2, -1, m2, 0.8), n2.colorArray.emplaceBack(-m2, 0, m2, 1.3), n2.colorArray.emplaceBack(m2, 0, m2, 1.3), n2.colorArray.emplaceBack(m2 + o2, -0.8, m2, 0.7), n2.colorArray.emplaceBack(m2 + o2, -0.8, m2, 0.7), n2.colorArray.emplaceBack(0, 0, m2, 1.3), n2.colorArray.emplaceBack(0, 0, m2, 1.3), n2.colorArray.emplaceBack(m2 + o2, -1.2, m2, 0.8), n2.colorArray.emplaceBack(m2 + o2, -1.2, m2, 0.8), n2.indexArray.emplaceBack(6 + i2, 4 + i2, 8 + i2), n2.indexArray.emplaceBack(7 + i2, 9 + i2, 5 + i2), n2.indexArray.emplaceBack(0 + i2, 1 + i2, 2 + i2), n2.indexArray.emplaceBack(1 + i2, 3 + i2, 2 + i2), i2 += 10;
          }
          const s2 = { defined: true, emissiveFactor: [0, 0, 0] }, a2 = {};
          return a2.baseColorFactor = Gn.white, s2.pbrMetallicRoughness = a2, n2.material = s2, n2.aabb = new kh([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), n2;
        }
        const a_ = new Float32Array(262144), o_ = new Uint8Array(262144);
        function l_(t2) {
          let e2 = 0;
          if (t2.meshes)
            for (const r2 of t2.meshes)
              e2 = Math.max(e2, r2.aabb.max[2]);
          if (t2.children)
            for (const r2 of t2.children)
              e2 = Math.max(e2, l_(r2));
          return e2;
        }
        function u_(t2, e2, r2) {
          if (t2.meshes)
            for (const n2 of t2.meshes)
              n2.aabb.min[0] !== 1 / 0 && r2.insert(e2, n2.aabb.min[0], n2.aabb.min[1], n2.aabb.max[0], n2.aabb.max[1]);
          if (t2.children)
            for (const n2 of t2.children)
              u_(n2, e2, r2);
        }
        const c_ = ["", "wall", "door", "roof", "window", "lamp", "logo"];
        class h_ {
          constructor(t2) {
            this.node = t2, this.evaluatedRMEA = [[1, 0, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1], [0.4, 1, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1]], this.hiddenByReplacement = false, this.evaluatedScale = [1, 1, 1], this.evaluatedColor = [], this.emissionHeightBasedParams = [], this.feature = { type: "Point", id: t2.id, geometry: [], properties: { height: l_(t2) } }, this.aabb = this._getLocalBounds();
          }
          _getLocalBounds() {
            if (!this.node.meshes)
              return new kh([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]);
            if (!this.aabb) {
              let t2 = 0;
              const e2 = new kh([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]);
              for (const r2 of this.node.meshes)
                this.node.lightMeshIndex !== t2 && (r2.transformedAabb = kh.applyTransformFast(r2.aabb, this.node.matrix), e2.encapsulate(r2.transformedAabb)), t2++;
              this.aabb = e2;
            }
            return this.aabb;
          }
        }
        class p_ {
          constructor(t2, e2, r2, n2, i2, s2) {
            this.id = e2, this.modelTraits |= cv.CoordinateSpaceTile, this.uploaded = false, this.hasPattern = false, r2 && (this.modelTraits |= cv.HasMapboxMeshFeatures), n2 && (this.modelTraits |= cv.HasMeshoptCompression), this.zoom = -1, this.terrainExaggeration = 1, this.projection = { name: "mercator" }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = i2, this.dirty = true, this.needsUpload = false, this.nodesInfo = [];
            for (const e3 of t2)
              this.nodesInfo.push(new h_(e3)), u_(e3, s2.featureIndexArray.length, s2.grid), s2.featureIndexArray.emplaceBack(this.nodesInfo.length - 1, 0, s2.bucketLayerIDs.length - 1, 0);
          }
          updateFootprints(t2, e2) {
            for (const r2 of this.getNodesInfo()) {
              const n2 = r2.node;
              n2.footprint && e2.push({ footprint: n2.footprint, id: t2 });
            }
          }
          update() {
            console.log("Update 3D model bucket");
          }
          populate() {
            console.log("populate 3D model bucket");
          }
          uploadPending() {
            return !this.uploaded || this.needsUpload;
          }
          upload(t2) {
            if (!this.needsUpload)
              return;
            const e2 = this.getNodesInfo();
            for (const r2 of e2) {
              const e3 = r2.node;
              this.uploaded ? this.updatePbrBuffer(e3) : dv(e3, t2, true);
            }
            for (const t3 of e2)
              mv(t3.node);
            this.uploaded = true, this.needsUpload = false;
          }
          updatePbrBuffer(t2) {
            let e2 = false;
            if (!t2.meshes)
              return e2;
            for (const r2 of t2.meshes)
              r2.pbrBuffer && (r2.pbrBuffer.updateData(r2.featureArray), e2 = true);
            return e2;
          }
          needsReEvaluation(t2, e2, r2) {
            const n2 = t2.transform.projectionOptions, i2 = t2.style.getBrightness(), s2 = this.brightness !== i2;
            return !!(!this.uploaded || this.dirty || n2.name !== this.projection.name || f_(r2.paint.get("model-color").value, s2) || f_(r2.paint.get("model-color-mix-intensity").value, s2) || f_(r2.paint.get("model-roughness").value, s2) || f_(r2.paint.get("model-emissive-strength").value, s2) || f_(r2.paint.get("model-height-based-emissive-strength-multiplier").value, s2)) && (this.projection = n2, this.brightness = i2, true);
          }
          evaluateScale(t2, e2) {
            if (t2.transform.zoom === this.zoom)
              return;
            this.zoom = t2.transform.zoom;
            const r2 = this.getNodesInfo(), n2 = this.id.canonical;
            for (const t3 of r2) {
              const r3 = t3.feature;
              t3.evaluatedScale = e2.paint.get("model-scale").evaluate(r3, {}, n2);
            }
          }
          evaluate(t2) {
            const e2 = this.getNodesInfo();
            for (const r2 of e2) {
              if (!r2.node.meshes)
                continue;
              const e3 = r2.feature, n2 = r2.node.meshes && r2.node.meshes[0].featureData, i2 = r2.evaluatedColor[2], s2 = r2.evaluatedRMEA[2], a2 = this.id.canonical;
              if (r2.hasTranslucentParts = false, n2) {
                for (let n3 = 0; n3 < c_.length; n3++) {
                  const i3 = c_[n3];
                  i3.length && (e3.properties.part = i3);
                  const s3 = t2.paint.get("model-color").evaluate(e3, {}, a2).toRenderColor(null), o2 = t2.paint.get("model-color-mix-intensity").evaluate(e3, {}, a2);
                  r2.evaluatedColor[n3] = [s3.r, s3.g, s3.b, o2], r2.evaluatedRMEA[n3][0] = t2.paint.get("model-roughness").evaluate(e3, {}, a2), r2.evaluatedRMEA[n3][2] = t2.paint.get("model-emissive-strength").evaluate(e3, {}, a2), r2.evaluatedRMEA[n3][3] = s3.a, r2.emissionHeightBasedParams[n3] = t2.paint.get("model-height-based-emissive-strength-multiplier").evaluate(e3, {}, a2), !r2.hasTranslucentParts && s3.a < 1 && (r2.hasTranslucentParts = true);
                }
                delete e3.properties.part, m_(r2, i2 !== r2.evaluatedColor[2] || s2 !== r2.evaluatedRMEA[2], this.modelTraits);
              } else
                r2.evaluatedRMEA[0][2] = t2.paint.get("model-emissive-strength").evaluate(e3, {}, a2);
              r2.evaluatedScale = t2.paint.get("model-scale").evaluate(e3, {}, a2), this.updatePbrBuffer(r2.node) || (this.needsUpload = true);
            }
            this.dirty = false;
          }
          elevationUpdate(t2, e2, r2, n2) {
            const i2 = t2.findDEMTileFor(r2);
            if (i2 && (i2.tileID.canonical !== this.terrainTile || e2 !== this.terrainExaggeration)) {
              if (i2.dem && i2.tileID.overscaledZ !== this.elevationReadFromZ) {
                this.elevationReadFromZ = i2.tileID.overscaledZ;
                const e3 = ad.create(t2, r2, i2);
                if (!e3)
                  return;
                this.modelTraits & cv.HasMapboxMeshFeatures && this.updateDEM(t2, e3, r2, n2);
                for (const t3 of this.getNodesInfo()) {
                  const r3 = t3.node;
                  if (!r3.footprint || !r3.footprint.vertices || !r3.footprint.vertices.length)
                    continue;
                  const n3 = r3.footprint.vertices;
                  let i3 = e3.getElevationAt(n3[0].x, n3[0].y, true, true);
                  for (let t4 = 1; t4 < n3.length; t4++)
                    i3 = Math.min(i3, e3.getElevationAt(n3[t4].x, n3[t4].y, true, true));
                  r3.elevation = i3;
                }
              }
              this.terrainTile = i2.tileID.canonical, this.terrainExaggeration = e2;
            }
          }
          updateDEM(t2, e2, r2, n2) {
            let i2 = e2._dem._modifiedForSources[n2];
            if (void 0 === i2 && (e2._dem._modifiedForSources[n2] = [], i2 = e2._dem._modifiedForSources[n2]), i2.includes(r2.canonical))
              return;
            const s2 = e2._dem.dim;
            i2.push(r2.canonical);
            let a2 = false;
            for (const t3 of this.getNodesInfo()) {
              const r3 = t3.node;
              if (!r3.footprint || !r3.footprint.grid)
                continue;
              const n3 = r3.footprint.grid, i3 = e2.tileCoordToPixel(n3.min.x, n3.min.y), o2 = e2.tileCoordToPixel(n3.max.x, n3.max.y), l2 = Math.min(Math.min(s2 - o2.y, i3.x), Math.min(i3.y, s2 - o2.x));
              if (l2 < 0)
                continue;
              const u2 = We(l2, 2, 5);
              let c2 = Math.max(0, i3.x - u2), h2 = Math.max(0, i3.y - u2), p2 = Math.min(o2.x + u2, s2 - 1), f2 = Math.min(o2.y + u2, s2 - 1);
              for (let t4 = h2; t4 <= f2; ++t4)
                for (let e3 = c2; e3 <= p2; ++e3)
                  o_[t4 * s2 + e3] = 255;
              let d2 = 0, m2 = 0;
              for (let t4 = 0; t4 < n3.cellsY; ++t4)
                for (let r4 = 0; r4 < n3.cellsX; ++r4) {
                  if (!n3.cells[t4 * n3.cellsX + r4])
                    continue;
                  const i4 = e2.tileCoordToPixel(n3.min.x + r4 / n3.xScale, n3.min.y + t4 / n3.yScale), a3 = e2.tileCoordToPixel(n3.min.x + (r4 + 1) / n3.xScale, n3.min.y + (t4 + 1) / n3.yScale);
                  for (let t5 = i4.y; t5 <= Math.min(a3.y + 1, s2 - 1); ++t5)
                    for (let r5 = i4.x; r5 <= Math.min(a3.x + 1, s2 - 1); ++r5)
                      255 === o_[t5 * s2 + r5] && (o_[t5 * s2 + r5] = 0, d2 += e2.getElevationAtPixel(r5, t5), m2++);
                }
              const y2 = d2 / m2;
              c2 = Math.max(1, i3.x - u2), h2 = Math.max(1, i3.y - u2), p2 = Math.min(o2.x + u2, s2 - 2), f2 = Math.min(o2.y + u2, s2 - 2), a2 = true;
              for (let t4 = h2; t4 <= f2; ++t4)
                for (let r4 = c2; r4 <= p2; ++r4)
                  0 === o_[t4 * s2 + r4] && (a_[t4 * s2 + r4] = e2._dem.set(r4, t4, y2));
              for (let t4 = 1; t4 < u2; ++t4) {
                c2 = Math.max(1, i3.x - t4), h2 = Math.max(1, i3.y - t4), p2 = Math.min(o2.x + t4, s2 - 2), f2 = Math.min(o2.y + t4, s2 - 2);
                for (let r4 = h2; r4 <= f2; ++r4)
                  for (let n4 = c2; n4 <= p2; ++n4) {
                    const i4 = r4 * s2 + n4;
                    if (255 === o_[i4]) {
                      let a3 = 0, o3 = 0, l3 = -1, c3 = -1;
                      for (let e3 = -1; e3 <= 1; ++e3)
                        for (let i5 = -1; i5 <= 1; ++i5) {
                          const u3 = (r4 + e3) * s2 + n4 + i5;
                          if (o_[u3] >= t4)
                            continue;
                          const h3 = a_[u3], p3 = Math.abs(h3);
                          p3 > o3 && (a3 = h3, o3 = p3, l3 = i5, c3 = e3);
                        }
                      if (o3 > 0.1) {
                        const s3 = 1 - (t4 + 0.5 * Math.abs(l3 * c3)) / u2;
                        let o4 = e2._dem.get(n4, r4) + a3 * s3;
                        const h3 = e2._dem.get(n4 + l3, r4 + c3), p3 = e2._dem.get(n4 - l3, r4 - c3, true);
                        (o4 - h3) * (o4 - p3) > 0 && (o4 = (h3 + p3) / 2), a_[i4] = e2._dem.set(n4, r4, o4), o_[i4] = t4;
                      }
                    }
                  }
              }
            }
            a2 && (e2._demTile.needsDEMTextureUpload = true, e2._dem._timestamp = Rr.now());
          }
          getNodesInfo() {
            return this.nodesInfo;
          }
          destroy() {
            const t2 = this.getNodesInfo();
            for (const e2 of t2)
              mv(e2.node), yv(e2.node);
          }
          isEmpty() {
            return !this.nodesInfo.length;
          }
          updateReplacement(t2, e2) {
            if (e2.updateTime === this.replacementUpdateTime)
              return;
            this.replacementUpdateTime = e2.updateTime;
            const r2 = e2.getReplacementRegionsForTile(t2.toUnwrapped()), n2 = this.getNodesInfo();
            for (let t3 = 0; t3 < this.nodesInfo.length; t3++) {
              const e3 = n2[t3].node;
              n2[t3].hiddenByReplacement = !!e3.footprint && !r2.find((t4) => t4.footprint === e3.footprint);
            }
          }
          getHeightAtTileCoord(e2, r2) {
            const n2 = this.getNodesInfo(), i2 = [], s2 = [0, 0, 0], a2 = t.ae.identity([]);
            for (let o2 = 0; o2 < this.nodesInfo.length; o2++) {
              const l2 = n2[o2], u2 = l2.node.meshes[0], c2 = u2.transformedAabb;
              if (e2 < c2.min[0] || r2 < c2.min[1] || e2 > c2.max[0] || r2 > c2.max[1])
                continue;
              if (true === l2.node.hidden)
                return { height: 0, maxHeight: l2.feature.properties.height, hidden: false, verticalScale: l2.evaluatedScale[2] };
              t.ae.invert(a2, l2.node.matrix), s2[0] = e2, s2[1] = r2, t.$.transformMat4(s2, s2, a2);
              const h2 = (s2[0] - u2.aabb.min[0]) / (u2.aabb.max[0] - u2.aabb.min[0]) * uv | 0, p2 = Math.min(63, (s2[1] - u2.aabb.min[1]) / (u2.aabb.max[1] - u2.aabb.min[1]) * uv | 0) * uv + Math.min(63, h2), f2 = u2.heightmap[p2];
              if (!(f2 < 0 && l2.node.footprint)) {
                if (l2.hiddenByReplacement)
                  return;
                return { height: f2, maxHeight: l2.feature.properties.height, hidden: false, verticalScale: l2.evaluatedScale[2] };
              }
              if (l2.node.footprint.grid.query(new je(e2, r2), new je(e2, r2), i2), i2.length > 0)
                return { height: void 0, maxHeight: l2.feature.properties.height, hidden: l2.hiddenByReplacement, verticalScale: l2.evaluatedScale[2] };
            }
          }
        }
        function f_(t2, e2) {
          return !t2.isLightConstant && e2;
        }
        function d_(t2, e2, r2, n2, i2, s2, a2, o2) {
          let l2 = (61440 & e2 | (61440 & e2) >> 4) >> 8, u2 = (3840 & e2 | (3840 & e2) >> 4) >> 4, c2 = 240 & e2 | (240 & e2) >> 4;
          r2[3] > 0 && (l2 = Yn(l2, 255 * r2[0], r2[3]), u2 = Yn(u2, 255 * r2[1], r2[3]), c2 = Yn(c2, 255 * r2[2], r2[3]));
          const h2 = l2 << 8 | u2, p2 = c2 << 8 | Math.floor(255 * n2[3]), f2 = function(t3) {
            const e3 = We(t3, 0, 2);
            return Math.min(Math.round(0.5 * e3 * 255), 255);
          }(n2[2]) << 8 | 15 * n2[0] << 4 | 15 * n2[1], d2 = We(i2[0], 0, 1), m2 = We(i2[1], 0, 1), y2 = We(i2[2], 0, 1), g2 = We(i2[3], 0, 1);
          let x2, b2, v2, _2;
          if (d2 !== m2 && a2 !== s2 && m2 !== d2) {
            const t3 = a2 - s2;
            b2 = 1 / (t3 * (m2 - d2)), v2 = -(s2 + t3 * d2) / (t3 * (m2 - d2));
            const e3 = We(i2[4], -1, 1);
            _2 = Math.pow(10, e3), x2 = 255 * y2 << 8 | 255 * g2;
          } else
            x2 = 65535, b2 = 0, v2 = 1, _2 = 1;
          if (t2.emplaceBack(h2, p2, f2, x2, b2, v2, _2), o2) {
            const t3 = o2.length;
            o2.clear();
            for (let e3 = 0; e3 < t3; e3++)
              o2.emplaceBack(h2, p2, f2, x2, b2, v2, _2);
          }
        }
        function m_(t2, e2, r2) {
          const n2 = t2.node;
          let i2 = 0;
          const s2 = r2 & cv.HasMeshoptCompression;
          for (const r3 of n2.meshes) {
            if (n2.lights && n2.lightMeshIndex === i2)
              continue;
            if (!r3.featureData)
              continue;
            r3.featureArray = new cu(), r3.featureArray.reserve(r3.featureData.length);
            let a2 = e2;
            for (const e3 of r3.featureData) {
              const i3 = s2 ? 65535 & e3 : e3 >> 16 & 65535, o2 = s2 ? e3 >> 16 & 65535 : 65535 & e3, l2 = (15 & o2) < 8 ? 15 & o2 : 0, u2 = t2.evaluatedRMEA[l2], c2 = t2.evaluatedColor[l2], h2 = t2.emissionHeightBasedParams[l2];
              let p2;
              if (a2 && 2 === l2 && n2.lights && (p2 = new cu(), p2.resize(10 * n2.lights.length)), d_(r3.featureArray, i3, c2, u2, h2, r3.aabb.min[2], r3.aabb.max[2], p2), p2 && a2) {
                a2 = false;
                const t3 = n2.meshes[n2.lightMeshIndex];
                t3.featureArray = p2, t3.featureArray._trim();
              }
            }
            r3.featureArray._trim(), i2++;
          }
        }
        function y_(t2, e2, r2, n2) {
          const i2 = 1 << t2.z;
          e2.lat = Cc((n2 / ds + t2.y) / i2), e2.lng = Rc((r2 / ds + t2.x) / i2);
        }
        So(p_, "Tiled3dModelBucket", { omit: ["layers"] }), So(h_, "Tiled3dModelFeature");
        const g_ = { circle: class extends zl {
          constructor(t2, e2, r2, n2) {
            super(t2, { layout: bh || (bh = new ul({ "circle-sort-key": new ol(cl.layout_circle["circle-sort-key"]), visibility: new al(cl.layout_circle.visibility) })), paint: vh || (vh = new ul({ "circle-radius": new ol(cl.paint_circle["circle-radius"]), "circle-color": new ol(cl.paint_circle["circle-color"]), "circle-blur": new ol(cl.paint_circle["circle-blur"]), "circle-opacity": new ol(cl.paint_circle["circle-opacity"]), "circle-translate": new al(cl.paint_circle["circle-translate"]), "circle-translate-anchor": new al(cl.paint_circle["circle-translate-anchor"]), "circle-pitch-scale": new al(cl.paint_circle["circle-pitch-scale"]), "circle-pitch-alignment": new al(cl.paint_circle["circle-pitch-alignment"]), "circle-stroke-width": new ol(cl.paint_circle["circle-stroke-width"]), "circle-stroke-color": new ol(cl.paint_circle["circle-stroke-color"]), "circle-stroke-opacity": new ol(cl.paint_circle["circle-stroke-opacity"]), "circle-emissive-strength": new al(cl.paint_circle["circle-emissive-strength"]) })) }, e2, r2, n2);
          }
          createBucket(t2) {
            return new th(t2);
          }
          queryRadius(t2) {
            const e2 = t2;
            return mh("circle-radius", this, e2) + mh("circle-stroke-width", this, e2) + yh(this.paint.get("circle-translate"));
          }
          queryIntersectsFeature(t2, e2, r2, n2, i2, s2, a2, o2) {
            const l2 = xh(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), s2.angle, t2.pixelToTileUnitsFactor), u2 = this.paint.get("circle-radius").evaluate(e2, r2) + this.paint.get("circle-stroke-width").evaluate(e2, r2);
            return op(t2, n2, s2, a2, o2, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l2, u2);
          }
          getProgramIds() {
            return ["circle"];
          }
          getDefaultProgramParams(t2, e2, r2) {
            const n2 = ap(this);
            return { config: new tc(this, { zoom: e2, lut: r2 }), defines: n2, overrideFog: false };
          }
        }, heatmap: class extends zl {
          createBucket(t2) {
            return new pp(t2);
          }
          constructor(t2, e2, r2, n2) {
            super(t2, { layout: bp || (bp = new ul({ visibility: new al(cl.layout_heatmap.visibility) })), paint: vp || (vp = new ul({ "heatmap-radius": new ol(cl.paint_heatmap["heatmap-radius"]), "heatmap-weight": new ol(cl.paint_heatmap["heatmap-weight"]), "heatmap-intensity": new al(cl.paint_heatmap["heatmap-intensity"]), "heatmap-color": new ll(cl.paint_heatmap["heatmap-color"]), "heatmap-opacity": new al(cl.paint_heatmap["heatmap-opacity"]) })) }, e2, r2, n2), this._updateColorRamp();
          }
          _handleSpecialPaintPropertyUpdate(t2) {
            "heatmap-color" === t2 && this._updateColorRamp();
          }
          _updateColorRamp() {
            this.colorRamp = Mp({ expression: this._transitionablePaint._values["heatmap-color"].value.expression, evaluationKey: "heatmapDensity", image: this.colorRamp }), this.colorRampTexture = null;
          }
          resize() {
            this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
          }
          queryRadius(t2) {
            return mh("heatmap-radius", this, t2);
          }
          queryIntersectsFeature(t2, e2, r2, n2, i2, s2, a2, o2) {
            const l2 = this.paint.get("heatmap-radius").evaluate(e2, r2);
            return op(t2, n2, s2, a2, o2, true, true, new je(0, 0), l2);
          }
          hasOffscreenPass() {
            return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
          }
          getProgramIds() {
            return ["heatmap", "heatmapTexture"];
          }
          getDefaultProgramParams(t2, e2, r2) {
            return "heatmap" === t2 ? { config: new tc(this, { zoom: e2, lut: r2 }), overrideFog: false } : {};
          }
        }, hillshade: class extends zl {
          constructor(t2, e2, r2, n2) {
            super(t2, { layout: _p || (_p = new ul({ visibility: new al(cl.layout_hillshade.visibility) })), paint: wp || (wp = new ul({ "hillshade-illumination-direction": new al(cl.paint_hillshade["hillshade-illumination-direction"]), "hillshade-illumination-anchor": new al(cl.paint_hillshade["hillshade-illumination-anchor"]), "hillshade-exaggeration": new al(cl.paint_hillshade["hillshade-exaggeration"]), "hillshade-shadow-color": new al(cl.paint_hillshade["hillshade-shadow-color"]), "hillshade-highlight-color": new al(cl.paint_hillshade["hillshade-highlight-color"]), "hillshade-accent-color": new al(cl.paint_hillshade["hillshade-accent-color"]), "hillshade-emissive-strength": new al(cl.paint_hillshade["hillshade-emissive-strength"]) })) }, e2, r2, n2);
          }
          hasOffscreenPass() {
            return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
          }
          getProgramIds() {
            return ["hillshade", "hillshadePrepare"];
          }
          getDefaultProgramParams(t2, e2, r2) {
            return { overrideFog: false };
          }
        }, fill: class extends zl {
          constructor(t2, e2, r2, n2) {
            super(t2, { layout: rf || (rf = new ul({ "fill-sort-key": new ol(cl.layout_fill["fill-sort-key"]), visibility: new al(cl.layout_fill.visibility) })), paint: nf || (nf = new ul({ "fill-antialias": new al(cl.paint_fill["fill-antialias"]), "fill-opacity": new ol(cl.paint_fill["fill-opacity"]), "fill-color": new ol(cl.paint_fill["fill-color"]), "fill-outline-color": new ol(cl.paint_fill["fill-outline-color"]), "fill-translate": new al(cl.paint_fill["fill-translate"]), "fill-translate-anchor": new al(cl.paint_fill["fill-translate-anchor"]), "fill-pattern": new ol(cl.paint_fill["fill-pattern"]), "fill-emissive-strength": new al(cl.paint_fill["fill-emissive-strength"]) })) }, e2, r2, n2);
          }
          getProgramIds() {
            const t2 = this.paint.get("fill-pattern"), e2 = t2 && t2.constantOr(1), r2 = [e2 ? "fillPattern" : "fill"];
            return this.paint.get("fill-antialias") && r2.push(e2 && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), r2;
          }
          getDefaultProgramParams(t2, e2, r2) {
            return { config: new tc(this, { zoom: e2, lut: r2 }), overrideFog: false };
          }
          recalculate(t2, e2) {
            super.recalculate(t2, e2);
            const r2 = this.paint._values["fill-outline-color"];
            "constant" === r2.value.kind && void 0 === r2.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
          }
          createBucket(t2) {
            return new ef(t2);
          }
          queryRadius() {
            return yh(this.paint.get("fill-translate"));
          }
          queryIntersectsFeature(t2, e2, r2, n2, i2, s2) {
            return !t2.queryGeometry.isAboveHorizon && nh(gh(t2.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), s2.angle, t2.pixelToTileUnitsFactor), n2);
          }
          isTileClipped() {
            return true;
          }
        }, "fill-extrusion": class extends zl {
          constructor(t2, e2, r2, n2) {
            super(t2, { layout: Vd || (Vd = new ul({ visibility: new al(cl["layout_fill-extrusion"].visibility), "fill-extrusion-edge-radius": new al(cl["layout_fill-extrusion"]["fill-extrusion-edge-radius"]) })), paint: Fd || (Fd = new ul({ "fill-extrusion-opacity": new al(cl["paint_fill-extrusion"]["fill-extrusion-opacity"]), "fill-extrusion-color": new ol(cl["paint_fill-extrusion"]["fill-extrusion-color"]), "fill-extrusion-translate": new al(cl["paint_fill-extrusion"]["fill-extrusion-translate"]), "fill-extrusion-translate-anchor": new al(cl["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]), "fill-extrusion-pattern": new ol(cl["paint_fill-extrusion"]["fill-extrusion-pattern"]), "fill-extrusion-height": new ol(cl["paint_fill-extrusion"]["fill-extrusion-height"]), "fill-extrusion-base": new ol(cl["paint_fill-extrusion"]["fill-extrusion-base"]), "fill-extrusion-vertical-gradient": new al(cl["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]), "fill-extrusion-ambient-occlusion-intensity": new al(cl["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]), "fill-extrusion-ambient-occlusion-radius": new al(cl["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]), "fill-extrusion-ambient-occlusion-wall-radius": new al(cl["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]), "fill-extrusion-ambient-occlusion-ground-radius": new al(cl["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]), "fill-extrusion-ambient-occlusion-ground-attenuation": new al(cl["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]), "fill-extrusion-flood-light-color": new al(cl["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]), "fill-extrusion-flood-light-intensity": new al(cl["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]), "fill-extrusion-flood-light-wall-radius": new ol(cl["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]), "fill-extrusion-flood-light-ground-radius": new ol(cl["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]), "fill-extrusion-flood-light-ground-attenuation": new al(cl["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]), "fill-extrusion-vertical-scale": new al(cl["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]), "fill-extrusion-rounded-roof": new al(cl["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]), "fill-extrusion-cutoff-fade-range": new al(cl["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]), "fill-extrusion-emissive-strength": new al(cl["paint_fill-extrusion"]["fill-extrusion-emissive-strength"]), "fill-extrusion-line-width": new ol(cl["paint_fill-extrusion"]["fill-extrusion-line-width"]), "fill-extrusion-line-alignment": new al(cl["paint_fill-extrusion"]["fill-extrusion-line-alignment"]) })) }, e2, r2, n2), this._stats = { numRenderedVerticesInShadowPass: 0, numRenderedVerticesInTransparentPass: 0 };
          }
          createBucket(t2) {
            return new Id(t2);
          }
          queryRadius() {
            return yh(this.paint.get("fill-extrusion-translate"));
          }
          is3D() {
            return true;
          }
          hasShadowPass() {
            return true;
          }
          cutoffRange() {
            return this.paint.get("fill-extrusion-cutoff-fade-range");
          }
          canCastShadows() {
            return true;
          }
          getProgramIds() {
            return [this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"];
          }
          queryIntersectsFeature(e2, r2, n2, i2, s2, a2, o2, l2, u2) {
            const c2 = xh(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), a2.angle, e2.pixelToTileUnitsFactor), h2 = this.paint.get("fill-extrusion-height").evaluate(r2, n2), p2 = this.paint.get("fill-extrusion-base").evaluate(r2, n2), f2 = [0, 0], d2 = l2 && a2.elevation, m2 = a2.elevation ? a2.elevation.exaggeration() : 1, y2 = e2.tile.getBucket(this);
            if (d2 && y2 instanceof Id) {
              const t2 = y2.centroidVertexArray, e3 = u2 + 1;
              e3 < t2.length && (f2[0] = t2.geta_centroid_pos0(e3), f2[1] = t2.geta_centroid_pos1(e3));
            }
            if (0 === f2[0] && 1 === f2[1])
              return false;
            "globe" === a2.projection.name && (i2 = Cd([i2], [new je(0, 0), new je(ds, ds)], e2.tileID.canonical).map((t2) => t2.polygon).flat());
            const g2 = d2 ? l2 : null, [x2, b2] = function(e3, r3, n3, i3, s3, a3, o3, l3, u3, c3, h3) {
              return "globe" === e3.projection.name ? function(e4, r4, n4, i4, s4, a4, o4, l4, u4, c4, h4) {
                const p3 = [], f3 = [], d3 = e4.projection.upVectorScale(h4, e4.center.lat, e4.worldSize).metersToTile, m3 = [0, 0, 0, 1], y3 = [0, 0, 0, 1], g3 = (t2, e5, r5, n5) => {
                  t2[0] = e5, t2[1] = r5, t2[2] = n5, t2[3] = 1;
                }, x3 = Rd();
                n4 > 0 && (n4 += x3), i4 += x3;
                for (const x4 of r4) {
                  const r5 = [], b3 = [];
                  for (const p4 of x4) {
                    const f4 = p4.x + s4.x, x5 = p4.y + s4.y, v3 = e4.projection.projectTilePoint(f4, x5, h4), _2 = e4.projection.upVector(h4, p4.x, p4.y);
                    let w2 = n4, M2 = i4;
                    if (o4) {
                      const t2 = jd(f4, x5, n4, i4, o4, l4, u4, c4);
                      w2 += t2.base, M2 += t2.top;
                    }
                    0 !== n4 ? g3(m3, v3.x + _2[0] * d3 * w2, v3.y + _2[1] * d3 * w2, v3.z + _2[2] * d3 * w2) : g3(m3, v3.x, v3.y, v3.z), g3(y3, v3.x + _2[0] * d3 * M2, v3.y + _2[1] * d3 * M2, v3.z + _2[2] * d3 * M2), t.$.transformMat4(m3, m3, a4), t.$.transformMat4(y3, y3, a4), r5.push(new Ef(m3[0], m3[1], m3[2])), b3.push(new Ef(y3[0], y3[1], y3[2]));
                  }
                  p3.push(r5), f3.push(b3);
                }
                return [p3, f3];
              }(e3, r3, n3, i3, s3, a3, o3, l3, u3, c3, h3) : o3 ? function(e4, r4, n4, i4, s4, a4, o4, l4, u4) {
                const c4 = [], h4 = [], p3 = [0, 0, 0, 1];
                for (const f3 of e4) {
                  const e5 = [], d3 = [];
                  for (const c5 of f3) {
                    const h5 = c5.x + i4.x, f4 = c5.y + i4.y, m3 = jd(h5, f4, r4, n4, a4, o4, l4, u4);
                    p3[0] = h5, p3[1] = f4, p3[2] = m3.base, p3[3] = 1, t.aB.transformMat4(p3, p3, s4), p3[3] = Math.max(p3[3], 1e-5);
                    const y3 = new Ef(p3[0] / p3[3], p3[1] / p3[3], p3[2] / p3[3]);
                    p3[0] = h5, p3[1] = f4, p3[2] = m3.top, p3[3] = 1, t.aB.transformMat4(p3, p3, s4), p3[3] = Math.max(p3[3], 1e-5);
                    const g3 = new Ef(p3[0] / p3[3], p3[1] / p3[3], p3[2] / p3[3]);
                    e5.push(y3), d3.push(g3);
                  }
                  c4.push(e5), h4.push(d3);
                }
                return [c4, h4];
              }(r3, n3, i3, s3, a3, o3, l3, u3, c3) : function(t2, e4, r4, n4, i4) {
                const s4 = [], a4 = [], o4 = i4[8] * e4, l4 = i4[9] * e4, u4 = i4[10] * e4, c4 = i4[11] * e4, h4 = i4[8] * r4, p3 = i4[9] * r4, f3 = i4[10] * r4, d3 = i4[11] * r4;
                for (const e5 of t2) {
                  const t3 = [], r5 = [];
                  for (const s5 of e5) {
                    const e6 = s5.x + n4.x, a5 = s5.y + n4.y, m3 = i4[0] * e6 + i4[4] * a5 + i4[12], y3 = i4[1] * e6 + i4[5] * a5 + i4[13], g3 = i4[2] * e6 + i4[6] * a5 + i4[14], x3 = i4[3] * e6 + i4[7] * a5 + i4[15], b3 = m3 + o4, v3 = y3 + l4, _2 = g3 + u4, w2 = Math.max(x3 + c4, 1e-5), M2 = m3 + h4, A2 = y3 + p3, S2 = g3 + f3, I2 = Math.max(x3 + d3, 1e-5);
                    t3.push(new Ef(b3 / w2, v3 / w2, _2 / w2)), r5.push(new Ef(M2 / I2, A2 / I2, S2 / I2));
                  }
                  s4.push(t3), a4.push(r5);
                }
                return [s4, a4];
              }(r3, n3, i3, s3, a3);
            }(a2, i2, p2, h2, c2, o2, g2, f2, m2, a2.center.lat, e2.tileID.canonical), v2 = e2.queryGeometry;
            return function(t2, e3, r3) {
              let n3 = 1 / 0;
              nh(r3, e3) && (n3 = Ud(r3, e3[0]));
              for (let i3 = 0; i3 < e3.length; i3++) {
                const s3 = e3[i3], a3 = t2[i3];
                for (let t3 = 0; t3 < s3.length - 1; t3++) {
                  const e4 = s3[t3], i4 = [e4, s3[t3 + 1], a3[t3 + 1], a3[t3], e4];
                  eh(r3, i4) && (n3 = Math.min(n3, Ud(r3, i4)));
                }
              }
              return n3 !== 1 / 0 && n3;
            }(x2, b2, v2.isPointQuery() ? v2.screenBounds : v2.screenGeometry);
          }
        }, line: class extends zl {
          constructor(t2, e2, r2, n2) {
            const i2 = hb();
            super(t2, i2, e2, r2, n2), i2.layout && (this.layout = new sl(i2.layout)), this.gradientVersion = 0;
          }
          _handleSpecialPaintPropertyUpdate(t2) {
            if ("line-gradient" === t2) {
              const t3 = this._transitionablePaint._values["line-gradient"].value.expression;
              this.stepInterpolant = t3._styleExpression && t3._styleExpression.expression instanceof na, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
            }
          }
          gradientExpression() {
            return this._transitionablePaint._values["line-gradient"].value.expression;
          }
          widthExpression() {
            return this._transitionablePaint._values["line-width"].value.expression;
          }
          recalculate(t2, e2) {
            super.recalculate(t2, e2), this.paint._values["line-floorwidth"] = (() => {
              if (fb)
                return fb;
              const t3 = hb();
              return fb = new pb(t3.paint.properties["line-width"].specification), fb.useIntegerZoom = true, fb;
            })().possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t2);
          }
          createBucket(t2) {
            return new om(t2);
          }
          getProgramIds() {
            return [this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"];
          }
          getDefaultProgramParams(t2, e2, r2) {
            const n2 = dm(this);
            return { config: new tc(this, { zoom: e2, lut: r2 }), defines: n2, overrideFog: false };
          }
          queryRadius(t2) {
            const e2 = t2, r2 = gb(mh("line-width", this, e2), mh("line-gap-width", this, e2)), n2 = mh("line-offset", this, e2);
            return r2 / 2 + Math.abs(n2) + yh(this.paint.get("line-translate"));
          }
          queryIntersectsFeature(t2, e2, r2, n2, i2, s2) {
            if (t2.queryGeometry.isAboveHorizon)
              return false;
            const a2 = gh(t2.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), s2.angle, t2.pixelToTileUnitsFactor), o2 = t2.pixelToTileUnitsFactor / 2 * gb(this.paint.get("line-width").evaluate(e2, r2), this.paint.get("line-gap-width").evaluate(e2, r2)), l2 = this.paint.get("line-offset").evaluate(e2, r2);
            return l2 && (n2 = function(t3, e3) {
              const r3 = [], n3 = new je(0, 0);
              for (let i3 = 0; i3 < t3.length; i3++) {
                const s3 = t3[i3], a3 = [];
                for (let t4 = 0; t4 < s3.length; t4++) {
                  const r4 = s3[t4], i4 = s3[t4 + 1], o3 = 0 === t4 ? n3 : r4.sub(s3[t4 - 1])._unit()._perp(), l3 = t4 === s3.length - 1 ? n3 : i4.sub(r4)._unit()._perp(), u2 = o3._add(l3)._unit();
                  u2._mult(1 / (u2.x * l3.x + u2.y * l3.y)), a3.push(u2._mult(e3)._add(r4));
                }
                r3.push(a3);
              }
              return r3;
            }(n2, l2 * t2.pixelToTileUnitsFactor)), function(t3, e3, r3) {
              for (let n3 = 0; n3 < e3.length; n3++) {
                const i3 = e3[n3];
                if (t3.length >= 3) {
                  for (let e4 = 0; e4 < i3.length; e4++)
                    if (ch(t3, i3[e4]))
                      return true;
                }
                if (ih(t3, i3, r3))
                  return true;
              }
              return false;
            }(a2, n2, o2);
          }
          isTileClipped() {
            return true;
          }
          isDraped(t2) {
            const e2 = this.layout.get("line-z-offset");
            return e2.isConstant() && !e2.constantOr(0);
          }
        }, symbol: vb, background: class extends zl {
          constructor(t2, e2, r2, n2) {
            super(t2, { layout: _b || (_b = new ul({ visibility: new al(cl.layout_background.visibility) })), paint: wb || (wb = new ul({ "background-color": new al(cl.paint_background["background-color"]), "background-pattern": new al(cl.paint_background["background-pattern"]), "background-opacity": new al(cl.paint_background["background-opacity"]), "background-emissive-strength": new al(cl.paint_background["background-emissive-strength"]) })) }, e2, r2, n2);
          }
          getProgramIds() {
            return [this.paint.get("background-pattern") ? "backgroundPattern" : "background"];
          }
          getDefaultProgramParams(t2, e2, r2) {
            return { overrideFog: false };
          }
        }, raster: zb, "raster-particle": Lb, sky: class extends zl {
          constructor(t2, e2, r2, n2) {
            super(t2, { layout: Db || (Db = new ul({ visibility: new al(cl.layout_sky.visibility) })), paint: Rb || (Rb = new ul({ "sky-type": new al(cl.paint_sky["sky-type"]), "sky-atmosphere-sun": new al(cl.paint_sky["sky-atmosphere-sun"]), "sky-atmosphere-sun-intensity": new al(cl.paint_sky["sky-atmosphere-sun-intensity"]), "sky-gradient-center": new al(cl.paint_sky["sky-gradient-center"]), "sky-gradient-radius": new al(cl.paint_sky["sky-gradient-radius"]), "sky-gradient": new ll(cl.paint_sky["sky-gradient"]), "sky-atmosphere-halo-color": new al(cl.paint_sky["sky-atmosphere-halo-color"]), "sky-atmosphere-color": new al(cl.paint_sky["sky-atmosphere-color"]), "sky-opacity": new al(cl.paint_sky["sky-opacity"]) })) }, e2, r2, n2), this._updateColorRamp();
          }
          _handleSpecialPaintPropertyUpdate(t2) {
            "sky-gradient" === t2 ? this._updateColorRamp() : "sky-atmosphere-sun" !== t2 && "sky-atmosphere-halo-color" !== t2 && "sky-atmosphere-color" !== t2 && "sky-atmosphere-sun-intensity" !== t2 || (this._skyboxInvalidated = true);
          }
          _updateColorRamp() {
            this.colorRamp = Mp({ expression: this._transitionablePaint._values["sky-gradient"].value.expression, evaluationKey: "skyRadialProgress" }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
          }
          needsSkyboxCapture(t2) {
            if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry)
              return true;
            if (!this.paint.get("sky-atmosphere-sun")) {
              const e2 = t2.style.light.properties.get("position");
              return this._lightPosition.azimuthal !== e2.azimuthal || this._lightPosition.polar !== e2.polar;
            }
            return false;
          }
          getCenter(t2, e2) {
            if ("atmosphere" === this.paint.get("sky-type")) {
              const r3 = this.paint.get("sky-atmosphere-sun"), n2 = !r3, i2 = t2.style.light, s2 = i2.properties.get("position");
              return n2 && "viewport" === i2.properties.get("anchor") && dr("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), n2 ? Fb(s2.azimuthal, 90 - s2.polar, e2) : Fb(r3[0], 90 - r3[1], e2);
            }
            const r2 = this.paint.get("sky-gradient-center");
            return Fb(r2[0], 90 - r2[1], e2);
          }
          isSky() {
            return true;
          }
          markSkyboxValid(t2) {
            this._skyboxInvalidated = false, this._lightPosition = t2.style.light.properties.get("position");
          }
          hasOffscreenPass() {
            return true;
          }
          getProgramIds() {
            const t2 = this.paint.get("sky-type");
            return "atmosphere" === t2 ? ["skyboxCapture", "skybox"] : "gradient" === t2 ? ["skyboxGradient"] : null;
          }
        }, slot: class extends zl {
          constructor(t2, e2, r2, n2) {
            super(t2, { paint: Cb || (Cb = new ul({})) }, e2, null);
          }
        }, model: class extends zl {
          constructor(t2, e2, r2, n2) {
            super(t2, { layout: ov || (ov = new ul({ visibility: new al(cl.layout_model.visibility), "model-id": new ol(cl.layout_model["model-id"]) })), paint: lv || (lv = new ul({ "model-opacity": new al(cl.paint_model["model-opacity"]), "model-rotation": new ol(cl.paint_model["model-rotation"]), "model-scale": new ol(cl.paint_model["model-scale"]), "model-translation": new ol(cl.paint_model["model-translation"]), "model-color": new ol(cl.paint_model["model-color"]), "model-color-mix-intensity": new ol(cl.paint_model["model-color-mix-intensity"]), "model-type": new al(cl.paint_model["model-type"]), "model-cast-shadows": new al(cl.paint_model["model-cast-shadows"]), "model-receive-shadows": new al(cl.paint_model["model-receive-shadows"]), "model-ambient-occlusion-intensity": new al(cl.paint_model["model-ambient-occlusion-intensity"]), "model-emissive-strength": new ol(cl.paint_model["model-emissive-strength"]), "model-roughness": new ol(cl.paint_model["model-roughness"]), "model-height-based-emissive-strength-multiplier": new ol(cl.paint_model["model-height-based-emissive-strength-multiplier"]), "model-cutoff-fade-range": new al(cl.paint_model["model-cutoff-fade-range"]), "model-front-cutoff": new al(cl.paint_model["model-front-cutoff"]) })) }, e2, r2, n2), this._stats = { numRenderedVerticesInShadowPass: 0, numRenderedVerticesInTransparentPass: 0 };
          }
          createBucket(t2) {
            return new av(t2);
          }
          getProgramIds() {
            return ["model"];
          }
          is3D() {
            return true;
          }
          hasShadowPass() {
            return true;
          }
          canCastShadows() {
            return true;
          }
          hasLightBeamPass() {
            return true;
          }
          cutoffRange() {
            return this.paint.get("model-cutoff-fade-range");
          }
          queryRadius(t2) {
            return t2 instanceof p_ ? ds - 1 : 0;
          }
          queryIntersectsFeature(e2, r2, n2, i2, s2, a2) {
            if (!this.modelManager)
              return false;
            const o2 = this.modelManager, l2 = e2.tile.getBucket(this);
            if (!(l2 && l2 instanceof av))
              return false;
            const u2 = l2;
            for (const n3 in u2.instancesPerModel) {
              const i3 = u2.instancesPerModel[n3], s3 = void 0 !== r2.id ? r2.id : r2.properties && r2.properties.hasOwnProperty("id") ? r2.properties.id : void 0;
              if (i3.idToFeaturesIndex.hasOwnProperty(s3)) {
                const r3 = i3.features[i3.idToFeaturesIndex[s3]], l3 = o2.getModel(n3, this.scope);
                if (!l3)
                  return false;
                let c2 = t.ae.create();
                const h2 = new bc(0, 0), p2 = u2.canonical;
                let f2 = Number.MAX_VALUE;
                for (let n4 = 0; n4 < r3.instancedDataCount; ++n4) {
                  const s4 = 16 * (r3.instancedDataOffset + n4), o3 = i3.instancedDataArray.float32, u3 = [o3[s4 + 4], o3[s4 + 5], o3[s4 + 6]];
                  y_(p2, h2, o3[s4], 0 | o3[s4 + 1]), hv(c2, l3, a2, h2, r3.rotation, r3.scale, u3, false, false, false), "globe" === a2.projection.name && (c2 = Yb(c2, a2));
                  const d2 = t.ae.multiply([], a2.projMatrix, c2), m2 = e2.queryGeometry, y2 = Zb(m2.isPointQuery() ? m2.screenBounds : m2.screenGeometry, a2, d2, l3.aabb);
                  null != y2 && (f2 = Math.min(y2, f2));
                }
                return f2 !== Number.MAX_VALUE && f2;
              }
            }
            return false;
          }
          _handleOverridablePaintPropertyUpdate(t2, e2, r2) {
            return !(!this.layout || e2.isDataDriven() || r2.isDataDriven() || "model-color" !== t2 && "model-color-mix-intensity" !== t2 && "model-rotation" !== t2 && "model-scale" !== t2 && "model-translation" !== t2 && "model-emissive-strength" !== t2);
          }
          _isPropertyZoomDependent(t2) {
            const e2 = this._transitionablePaint._values[t2];
            return null != e2 && null != e2.value && null != e2.value.expression && e2.value.expression instanceof yo;
          }
          isZoomDependent() {
            return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
          }
          queryIntersectsMatchingFeature(e2, r2, n2, i2) {
            const s2 = e2.tile, a2 = s2.getBucket(this);
            let o2 = null, l2 = Number.MAX_VALUE;
            if (!(a2 && a2 instanceof p_))
              return { queryFeature: o2, intersectionZ: l2 };
            const u2 = a2.getNodesInfo()[r2];
            if (u2.hiddenByReplacement || !u2.node.meshes || !n2.filter(new Wo(s2.tileID.overscaledZ), u2.feature, s2.tileID.canonical))
              return { queryFeature: o2, intersectionZ: l2 };
            const c2 = u2.node, h2 = i2.calculatePosMatrix(s2.tileID.toUnwrapped(), i2.worldSize), p2 = u2.evaluatedScale;
            let f2 = 0;
            i2.elevation && c2.elevation && (f2 = c2.elevation * i2.elevation.exaggeration()), t.ae.translate(h2, h2, [(c2.anchor ? c2.anchor[0] : 0) * (p2[0] - 1), (c2.anchor ? c2.anchor[1] : 0) * (p2[1] - 1), f2]), t.ae.scale(h2, h2, p2), t.ae.multiply(h2, h2, c2.matrix);
            const d2 = e2.queryGeometry, m2 = d2.isPointQuery() ? d2.screenBounds : d2.screenGeometry, y2 = function(e3) {
              const r3 = t.ae.multiply([], h2, e3.matrix), n3 = t.ae.multiply(r3, i2.expandedFarZProjMatrix, r3);
              for (let t2 = 0; t2 < e3.meshes.length; ++t2) {
                const r4 = e3.meshes[t2];
                if (t2 === e3.lightMeshIndex)
                  continue;
                const s3 = Zb(m2, i2, n3, r4.aabb);
                null != s3 && (l2 = Math.min(s3, l2));
              }
              if (e3.children)
                for (const t2 of e3.children)
                  y2(t2);
            };
            if (y2(c2), l2 === Number.MAX_VALUE)
              return { queryFeature: o2, intersectionZ: l2 };
            const g2 = new bc(0, 0);
            return y_(s2.tileID.canonical, g2, u2.node.anchor[0], u2.node.anchor[1]), o2 = { type: "Feature", geometry: { type: "Point", coordinates: [g2.lng, g2.lat] }, properties: u2.feature.properties, id: u2.feature.id, state: {}, layer: this.serialize() }, { queryFeature: o2, intersectionZ: l2 };
          }
        }, clip: class extends zl {
          constructor(t2, e2, r2, n2) {
            super(t2, { layout: sf || (sf = new ul({ "clip-layer-types": new al(cl.layout_clip["clip-layer-types"]), "clip-layer-scope": new al(cl.layout_clip["clip-layer-scope"]) })), paint: af || (af = new ul({})) }, e2, r2, n2);
          }
          recalculate(t2, e2) {
            super.recalculate(t2, e2);
          }
          createBucket(t2) {
            return new uf(t2);
          }
          isTileClipped() {
            return true;
          }
          is3D() {
            return true;
          }
        } };
        So(ib, "MRTDecodingBatch", { omit: ["_onCancel", "_onComplete"] });
        const x_ = [Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
        class b_ {
          static from(t2) {
            if (!(t2 instanceof ArrayBuffer))
              throw new Error("Data must be an instance of ArrayBuffer.");
            const [e2, r2] = new Uint8Array(t2, 0, 2);
            if (219 !== e2)
              throw new Error("Data does not appear to be in a KDBush format.");
            const n2 = r2 >> 4;
            if (1 !== n2)
              throw new Error(`Got v${n2} data when expected v1.`);
            const i2 = x_[15 & r2];
            if (!i2)
              throw new Error("Unrecognized array type.");
            const [s2] = new Uint16Array(t2, 2, 1), [a2] = new Uint32Array(t2, 4, 1);
            return new b_(a2, s2, i2, t2);
          }
          constructor(t2, e2 = 64, r2 = Float64Array, n2) {
            if (isNaN(t2) || t2 < 0)
              throw new Error(`Unpexpected numItems value: ${t2}.`);
            this.numItems = +t2, this.nodeSize = Math.min(Math.max(+e2, 2), 65535), this.ArrayType = r2, this.IndexArrayType = t2 < 65536 ? Uint16Array : Uint32Array;
            const i2 = x_.indexOf(this.ArrayType), s2 = 2 * t2 * this.ArrayType.BYTES_PER_ELEMENT, a2 = t2 * this.IndexArrayType.BYTES_PER_ELEMENT, o2 = (8 - a2 % 8) % 8;
            if (i2 < 0)
              throw new Error(`Unexpected typed array class: ${r2}.`);
            n2 && n2 instanceof ArrayBuffer ? (this.data = n2, this.ids = new this.IndexArrayType(this.data, 8, t2), this.coords = new this.ArrayType(this.data, 8 + a2 + o2, 2 * t2), this._pos = 2 * t2, this._finished = true) : (this.data = new ArrayBuffer(8 + s2 + a2 + o2), this.ids = new this.IndexArrayType(this.data, 8, t2), this.coords = new this.ArrayType(this.data, 8 + a2 + o2, 2 * t2), this._pos = 0, this._finished = false, new Uint8Array(this.data, 0, 2).set([219, 16 + i2]), new Uint16Array(this.data, 2, 1)[0] = e2, new Uint32Array(this.data, 4, 1)[0] = t2);
          }
          add(t2, e2) {
            const r2 = this._pos >> 1;
            return this.ids[r2] = r2, this.coords[this._pos++] = t2, this.coords[this._pos++] = e2, r2;
          }
          finish() {
            const t2 = this._pos >> 1;
            if (t2 !== this.numItems)
              throw new Error(`Added ${t2} items when expected ${this.numItems}.`);
            return v_(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = true, this;
          }
          range(t2, e2, r2, n2) {
            if (!this._finished)
              throw new Error("Data not yet indexed - call index.finish().");
            const { ids: i2, coords: s2, nodeSize: a2 } = this, o2 = [0, i2.length - 1, 0], l2 = [];
            for (; o2.length; ) {
              const u2 = o2.pop() || 0, c2 = o2.pop() || 0, h2 = o2.pop() || 0;
              if (c2 - h2 <= a2) {
                for (let a3 = h2; a3 <= c2; a3++) {
                  const o3 = s2[2 * a3], u3 = s2[2 * a3 + 1];
                  o3 >= t2 && o3 <= r2 && u3 >= e2 && u3 <= n2 && l2.push(i2[a3]);
                }
                continue;
              }
              const p2 = h2 + c2 >> 1, f2 = s2[2 * p2], d2 = s2[2 * p2 + 1];
              f2 >= t2 && f2 <= r2 && d2 >= e2 && d2 <= n2 && l2.push(i2[p2]), (0 === u2 ? t2 <= f2 : e2 <= d2) && (o2.push(h2), o2.push(p2 - 1), o2.push(1 - u2)), (0 === u2 ? r2 >= f2 : n2 >= d2) && (o2.push(p2 + 1), o2.push(c2), o2.push(1 - u2));
            }
            return l2;
          }
          within(t2, e2, r2) {
            if (!this._finished)
              throw new Error("Data not yet indexed - call index.finish().");
            const { ids: n2, coords: i2, nodeSize: s2 } = this, a2 = [0, n2.length - 1, 0], o2 = [], l2 = r2 * r2;
            for (; a2.length; ) {
              const u2 = a2.pop() || 0, c2 = a2.pop() || 0, h2 = a2.pop() || 0;
              if (c2 - h2 <= s2) {
                for (let r3 = h2; r3 <= c2; r3++)
                  A_(i2[2 * r3], i2[2 * r3 + 1], t2, e2) <= l2 && o2.push(n2[r3]);
                continue;
              }
              const p2 = h2 + c2 >> 1, f2 = i2[2 * p2], d2 = i2[2 * p2 + 1];
              A_(f2, d2, t2, e2) <= l2 && o2.push(n2[p2]), (0 === u2 ? t2 - r2 <= f2 : e2 - r2 <= d2) && (a2.push(h2), a2.push(p2 - 1), a2.push(1 - u2)), (0 === u2 ? t2 + r2 >= f2 : e2 + r2 >= d2) && (a2.push(p2 + 1), a2.push(c2), a2.push(1 - u2));
            }
            return o2;
          }
        }
        function v_(t2, e2, r2, n2, i2, s2) {
          if (i2 - n2 <= r2)
            return;
          const a2 = n2 + i2 >> 1;
          __(t2, e2, a2, n2, i2, s2), v_(t2, e2, r2, n2, a2 - 1, 1 - s2), v_(t2, e2, r2, a2 + 1, i2, 1 - s2);
        }
        function __(t2, e2, r2, n2, i2, s2) {
          for (; i2 > n2; ) {
            if (i2 - n2 > 600) {
              const a3 = i2 - n2 + 1, o3 = r2 - n2 + 1, l3 = Math.log(a3), u2 = 0.5 * Math.exp(2 * l3 / 3), c2 = 0.5 * Math.sqrt(l3 * u2 * (a3 - u2) / a3) * (o3 - a3 / 2 < 0 ? -1 : 1);
              __(t2, e2, r2, Math.max(n2, Math.floor(r2 - o3 * u2 / a3 + c2)), Math.min(i2, Math.floor(r2 + (a3 - o3) * u2 / a3 + c2)), s2);
            }
            const a2 = e2[2 * r2 + s2];
            let o2 = n2, l2 = i2;
            for (w_(t2, e2, n2, r2), e2[2 * i2 + s2] > a2 && w_(t2, e2, n2, i2); o2 < l2; ) {
              for (w_(t2, e2, o2, l2), o2++, l2--; e2[2 * o2 + s2] < a2; )
                o2++;
              for (; e2[2 * l2 + s2] > a2; )
                l2--;
            }
            e2[2 * n2 + s2] === a2 ? w_(t2, e2, n2, l2) : (l2++, w_(t2, e2, l2, i2)), l2 <= r2 && (n2 = l2 + 1), r2 <= l2 && (i2 = l2 - 1);
          }
        }
        function w_(t2, e2, r2, n2) {
          M_(t2, r2, n2), M_(e2, 2 * r2, 2 * n2), M_(e2, 2 * r2 + 1, 2 * n2 + 1);
        }
        function M_(t2, e2, r2) {
          const n2 = t2[e2];
          t2[e2] = t2[r2], t2[r2] = n2;
        }
        function A_(t2, e2, r2, n2) {
          const i2 = t2 - r2, s2 = e2 - n2;
          return i2 * i2 + s2 * s2;
        }
        t.A = Hs, t.B = Ws, t.C = Gn, t.D = Zs, t.E = On, t.F = Ri, t.H = fl, t.I = Qg, t.J = no, t.K = to, t.L = function(t2) {
          const e2 = t2.value;
          let r2 = [];
          if (!e2)
            return r2;
          const n2 = Pi(e2);
          return "string" !== n2 ? (r2 = r2.concat([new rv(t2.key, e2, `string expected, "${n2}" found`)]), r2) : (nv(e2, true) || (r2 = r2.concat([new rv(t2.key, e2, `invalid url "${e2}"`)])), r2);
        }, t.M = class {
          constructor(t2, e2, r2, n2) {
            this.id = t2, this.position = null != e2 ? new bc(e2[0], e2[1]) : new bc(0, 0), this.orientation = null != r2 ? r2 : [0, 0, 0], this.nodes = n2, this.uploaded = false, this.aabb = new kh([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), this.matrix = [];
          }
          _applyTransformations(e2, r2) {
            if (t.ae.multiply(e2.matrix, r2, e2.matrix), e2.meshes)
              for (const t2 of e2.meshes) {
                const r3 = kh.applyTransformFast(t2.aabb, e2.matrix);
                this.aabb.encapsulate(r3);
              }
            if (e2.children)
              for (const t2 of e2.children)
                this._applyTransformations(t2, e2.matrix);
          }
          computeBoundsAndApplyParent() {
            const e2 = t.ae.identity([]);
            for (const t2 of this.nodes)
              this._applyTransformations(t2, e2);
          }
          computeModelMatrix(t2, e2, r2, n2, i2, s2, a2 = false) {
            hv(this.matrix, this, t2.transform, this.position, e2, r2, n2, i2, s2, a2);
          }
          upload(t2) {
            if (!this.uploaded) {
              for (const e2 of this.nodes)
                dv(e2, t2);
              for (const t3 of this.nodes)
                mv(t3);
              this.uploaded = true;
            }
          }
          destroy() {
            for (const t2 of this.nodes)
              yv(t2);
          }
        }, t.N = cl, t.O = tl, t.P = je, t.Q = rr, t.R = Qr, t.S = hu, t.T = $g, t.U = ul, t.V = rv, t.W = al, t.X = class {
          constructor(t2) {
            this.specification = t2;
          }
          possiblyEvaluate(t2, e2) {
            return gr(t2.expression.evaluate(e2));
          }
          interpolate(t2, e2, r2) {
            return { x: Yn(t2.x, e2.x, r2), y: Yn(t2.y, e2.y, r2), z: Yn(t2.z, e2.z, r2), azimuthal: Yn(t2.azimuthal, e2.azimuthal, r2), polar: Yn(t2.polar, e2.polar, r2) };
          }
        }, t.Y = Wo, t.Z = yo, t._ = Nc, t.a = ix, t.a$ = wh, t.a0 = Je, t.a1 = sl, t.a2 = Qh, t.a3 = Yn, t.a4 = ds, t.a5 = Zn, t.a6 = class {
          constructor(t2) {
            this.specification = t2;
          }
          possiblyEvaluate(t2, e2) {
            return function([t3, e3]) {
              const r2 = gr([1, t3, e3]);
              return { x: r2.x, y: r2.y, z: r2.z };
            }(t2.expression.evaluate(e2));
          }
          interpolate(t2, e2, r2) {
            return { x: Yn(t2.x, e2.x, r2), y: Yn(t2.y, e2.y, r2), z: Yn(t2.z, e2.z, r2) };
          }
        }, t.a7 = qu, t.a8 = Vu, t.a9 = Ou, t.aA = function(t2, e2, r2) {
          t2[4 * e2 + 0] = r2[0], t2[4 * e2 + 1] = r2[1], t2[4 * e2 + 2] = r2[2], t2[4 * e2 + 3] = r2[3];
        }, t.aC = function(e2, r2) {
          const { x: n2, y: i2 } = e2.point, s2 = Jh(n2, i2, e2.worldSize / e2._pixelsPerMercatorPixel, 0, 0);
          return t.ae.multiply(s2, s2, Hh(Fh(r2)));
        }, t.aE = Km, t.aF = oy, t.aG = Hm, t.aH = function(t2, e2, r2, n2, i2) {
          const s2 = 5 * e2 + 2;
          t2.float32[s2 + 0] = r2, t2.float32[s2 + 1] = n2, t2.float32[s2 + 2] = i2;
        }, t.aI = Fg, t.aJ = bc, t.aK = Bg, t.aL = Ac, t.aM = Th, t.aN = Ub, t.aO = Mc, t.aP = Nh, t.aQ = Sc, t.aR = function(t2, e2, r2, n2, i2, s2, a2, o2, l2) {
          if ("globe" === l2.name)
            return Nh(t2, e2, new Mc(r2, n2, i2), false);
          const u2 = cg({ z: r2, x: n2, y: i2 }, l2);
          return new kh([(s2 + u2.x / u2.scale) * e2, e2 * (u2.y / u2.scale), a2], [(s2 + u2.x2 / u2.scale) * e2, e2 * (u2.y2 / u2.scale), o2]);
        }, t.aS = function(t2, e2, r2) {
          let n2 = 0;
          for (let r3 = 0; r3 < 2; ++r3) {
            const i2 = 0;
            t2[r3] > i2 && (n2 += (t2[r3] - i2) * (t2[r3] - i2)), e2[r3] < i2 && (n2 += (i2 - e2[r3]) * (i2 - e2[r3]));
          }
          return n2;
        }, t.aT = Vc, t.aU = _h, t.aV = uc, t.aW = function(e2) {
          const r2 = t.ae.identity(new Float64Array(16));
          t.ae.multiply(r2, e2.pixelMatrix, e2.globeMatrix);
          const n2 = [0, fc, 0], i2 = [0, dc, 0];
          return t.$.transformMat4(n2, n2, r2), t.$.transformMat4(i2, i2, r2), [n2[0] > 0 && n2[0] <= e2.width && n2[1] > 0 && n2[1] <= e2.height && !ep(e2, new bc(e2.center.lat, 90)), i2[0] > 0 && i2[0] <= e2.width && i2[1] > 0 && i2[1] <= e2.height && !ep(e2, new bc(e2.center.lat, -90))];
        }, t.aX = function(e2, r2) {
          const { scale: n2 } = e2.tileTransform, i2 = n2 * ds / (e2.tileSize * Math.pow(2, r2.zoom - e2.tileID.overscaledZ + e2.tileID.canonical.z));
          return t.aD.scale(new Float32Array(4), r2.inverseAdjustmentMatrix, [i2, i2]);
        }, t.aY = jb, t.aZ = Ob, t.a_ = function(e2) {
          const r2 = Ob(e2, true);
          return t.aD.invert([], [r2[0], r2[1], r2[4], r2[5]]);
        }, t.aa = Nu, t.ab = Fu, t.ac = Ge, t.ad = function(t2, e2, r2) {
          const n2 = Math.sqrt(t2 * t2 + e2 * e2 + r2 * r2), i2 = n2 > 0 ? Math.acos(r2 / n2) * qe : 0;
          let s2 = 0 !== t2 || 0 !== e2 ? Math.atan2(-e2, -t2) * qe + 90 : 0;
          return s2 < 0 && (s2 += 360), [n2, s2, i2];
        }, t.af = tx, t.ag = ox, t.ah = rx, t.ai = function(t2, e2) {
          const r2 = {};
          for (let n2 = 0; n2 < e2.length; n2++) {
            const i2 = e2[n2];
            i2 in t2 && (r2[i2] = t2[i2]);
          }
          return r2;
        }, t.aj = vc, t.ak = Ec, t.al = Bc, t.am = Tl, t.an = function(t2) {
          Gr++, Gr > Or && (t2.getActor().send("enforceCacheSizeLimit", Fr), Gr = 0);
        }, t.ao = bn, t.ap = class {
          constructor(t2) {
            this.entries = {}, this.scheduler = t2;
          }
          request(t2, e2, r2, n2) {
            const i2 = this.entries[t2] = this.entries[t2] || { callbacks: [] };
            if (i2.result) {
              const [t3, r3] = i2.result;
              return this.scheduler ? this.scheduler.add(() => {
                n2(t3, r3);
              }, e2) : n2(t3, r3), () => {
              };
            }
            return i2.callbacks.push(n2), i2.cancel || (i2.cancel = r2((r3, n3) => {
              i2.result = [r3, n3];
              for (const t3 of i2.callbacks)
                this.scheduler ? this.scheduler.add(() => {
                  t3(r3, n3);
                }, e2) : t3(r3, n3);
              setTimeout(() => delete this.entries[t2], 3e3);
            })), () => {
              i2.result || (i2.callbacks = i2.callbacks.filter((t3) => t3 !== n2), i2.callbacks.length || (i2.cancel(), delete this.entries[t2]));
            };
          }
        }, t.aq = function(t2, e2, r2) {
          const n2 = JSON.stringify(t2.request);
          return t2.data && (this.deduped.entries[n2] = { result: [null, t2.data] }), this.deduped.request(n2, { type: "parseTile", isSymbolTile: t2.isSymbolTile, zoom: t2.tileZoom }, (e3) => {
            const n3 = nn(t2.request, (t3, n4, i2, s2) => {
              t3 ? e3(t3) : n4 && e3(null, { vectorTile: r2 ? void 0 : new Pf(new Om(n4)), rawData: n4, cacheControl: i2, expires: s2 });
            });
            return () => {
              n3.cancel(), e3();
            };
          }, e2);
        }, t.ar = Uu, t.as = class extends Lu {
          constructor(t2) {
            super(t2), this.current = Gu;
          }
          set(t2, e2, r2) {
            if (this.fetchUniformLocation(t2, e2)) {
              for (let t3 = 0; t3 < 9; t3++)
                if (r2[t3] !== this.current[t3]) {
                  this.current = r2, this.gl.uniformMatrix3fv(this.location, false, r2);
                  break;
                }
            }
          }
        }, t.at = ju, t.au = We, t.av = Qe, t.ax = kr, t.ay = Dc, t.az = Cc, t.b = ku, t.b$ = Tc, t.b0 = function(t2) {
          const { x: e2, y: r2 } = t2.point, { lng: n2, lat: i2 } = t2._center;
          return Jh(e2, r2, t2.worldSize, n2, i2);
        }, t.b1 = Xe, t.b2 = Ic, t.b3 = lc, t.b4 = function(t2) {
          const e2 = Math.round((t2 + 45 + 360) % 360 / 90) % 4;
          return Ye[e2];
        }, t.b5 = 45, t.b6 = zc, t.b7 = jc, t.b8 = kh, t.b9 = gr, t.bA = cx, t.bB = xp, t.bC = function(t2, e2) {
          return [Math.pow(t2[0], 2.2) * e2, Math.pow(t2[1], 2.2) * e2, Math.pow(t2[2], 2.2) * e2];
        }, t.bD = hm, t.bF = Wh, t.bG = Br, t.bH = Er, t.bI = 256, t.bJ = function(e2, r2) {
          const n2 = [0, 0, 0], i2 = Zh(Fh(r2.canonical));
          return t.$.transformMat4(n2, n2, i2), t.$.transformMat4(n2, n2, e2), n2;
        }, t.bK = (t2) => ({ u_camera_to_center_distance: new Fu(t2), u_extrude_scale: new Yu(t2), u_device_pixel_ratio: new Fu(t2), u_matrix: new qu(t2), u_inv_rot_matrix: new qu(t2), u_merc_center: new Ou(t2), u_tile_id: new Uu(t2), u_zoom_transition: new Fu(t2), u_up_dir: new Uu(t2), u_emissive_strength: new Fu(t2) }), t.bL = (t2) => ({ u_matrix: new qu(t2), u_pixels_to_tile_units: new Yu(t2), u_device_pixel_ratio: new Fu(t2), u_units_to_pixels: new Ou(t2), u_dash_image: new Vu(t2), u_gradient_image: new Vu(t2), u_image_height: new Fu(t2), u_texsize: new Ou(t2), u_tile_units_to_pixels: new Fu(t2), u_alpha_discard_threshold: new Fu(t2), u_trim_offset: new Ou(t2), u_trim_fade_range: new Ou(t2), u_trim_color: new ju(t2), u_emissive_strength: new Fu(t2) }), t.bM = (t2) => ({ u_matrix: new qu(t2), u_texsize: new Ou(t2), u_pixels_to_tile_units: new Yu(t2), u_device_pixel_ratio: new Fu(t2), u_image: new Vu(t2), u_units_to_pixels: new Ou(t2), u_tile_units_to_pixels: new Fu(t2), u_alpha_discard_threshold: new Fu(t2), u_trim_offset: new Ou(t2) }), t.bN = Jl, t.bO = rm, t.bP = Xm, t.bQ = Wm, t.bR = Qy, t.bS = xy, t.bT = ap, t.bU = (t2, e2, r2, n2, i2, s2) => {
          const a2 = t2.transform, o2 = "globe" === a2.projection.name;
          let l2;
          if ("map" === s2.paint.get("circle-pitch-alignment"))
            if (o2) {
              const t3 = Wh(a2.zoom, e2.canonical) * a2._pixelsPerMercatorPixel;
              l2 = Float32Array.from([t3, 0, 0, t3]);
            } else
              l2 = a2.calculatePixelsToTileUnitsMatrix(r2);
          else
            l2 = new Float32Array([a2.pixelsToGLUnits[0], 0, 0, a2.pixelsToGLUnits[1]]);
          const u2 = { u_camera_to_center_distance: t2.transform.getCameraToCenterDistance(a2.projection), u_matrix: t2.translatePosMatrix(e2.projMatrix, r2, s2.paint.get("circle-translate"), s2.paint.get("circle-translate-anchor")), u_device_pixel_ratio: Rr.devicePixelRatio, u_extrude_scale: l2, u_inv_rot_matrix: sp, u_merc_center: [0, 0], u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_up_dir: [0, 0, 0], u_emissive_strength: s2.paint.get("circle-emissive-strength") };
          if (o2) {
            u2.u_inv_rot_matrix = n2, u2.u_merc_center = i2, u2.u_tile_id = [e2.canonical.x, e2.canonical.y, 1 << e2.canonical.z], u2.u_zoom_transition = Qh(a2.zoom);
            const t3 = i2[0] * ds, r3 = i2[1] * ds;
            u2.u_up_dir = a2.projection.upVector(new Mc(0, 0, 0), t3, r3);
          }
          return u2;
        }, t.bV = dm, t.bW = (t2, e2, r2, n2, i2, s2) => {
          const a2 = t2.transform;
          return { u_matrix: fm(t2, e2, r2, n2), u_texsize: e2.imageAtlasTexture ? e2.imageAtlasTexture.size : [0, 0], u_pixels_to_tile_units: a2.calculatePixelsToTileUnitsMatrix(e2), u_device_pixel_ratio: i2, u_image: 0, u_tile_units_to_pixels: pm(e2, a2), u_units_to_pixels: [1 / a2.pixelsToGLUnits[0], 1 / a2.pixelsToGLUnits[1]], u_alpha_discard_threshold: 0, u_trim_offset: s2 };
        }, t.bX = (t2, e2, r2, n2, i2, s2, a2) => {
          const o2 = t2.transform, l2 = o2.calculatePixelsToTileUnitsMatrix(e2);
          return { u_matrix: fm(t2, e2, r2, n2), u_pixels_to_tile_units: l2, u_device_pixel_ratio: s2, u_units_to_pixels: [1 / o2.pixelsToGLUnits[0], 1 / o2.pixelsToGLUnits[1]], u_dash_image: 0, u_gradient_image: 1, u_image_height: i2, u_texsize: mm(r2) && e2.lineAtlasTexture ? e2.lineAtlasTexture.size : [0, 0], u_tile_units_to_pixels: pm(e2, t2.transform), u_alpha_discard_threshold: 0, u_trim_offset: a2, u_trim_fade_range: r2.paint.get("line-trim-fade-range"), u_trim_color: r2.paint.get("line-trim-color").toRenderColor(r2.lut).toArray01(), u_emissive_strength: r2.paint.get("line-emissive-strength") };
        }, t.bY = ar, t.bZ = Mp, t.b_ = Rd, t.ba = function(t2) {
          return [Math.pow(t2[0], 1 / 2.2), Math.pow(t2[1], 1 / 2.2), Math.pow(t2[2], 1 / 2.2)];
        }, t.bb = Ze, t.bc = function(t2, e2, r2) {
          const n2 = Qh(r2.zoom), i2 = t2.style.map._antialias, s2 = e2.options.extStandardDerivativesForceOff || t2.terrain && t2.terrain.exaggeration() > 0;
          return 0 === n2 && !i2 && !s2;
        }, t.bd = function(e2) {
          const r2 = e2.pixelsPerMeter, n2 = r2 / Dc(1, e2.center.lat), i2 = t.ae.identity(new Float64Array(16));
          return t.ae.translate(i2, i2, [e2.point.x, e2.point.y, 0]), t.ae.scale(i2, i2, [n2, n2, r2]), Float32Array.from(i2);
        }, t.be = $h, t.bf = function(t2) {
          const e2 = Vc - 5;
          t2 = We(t2, -e2, e2) / e2 * 90;
          const r2 = Math.pow(Math.abs(Math.sin(Ge(t2))), 3);
          return Math.round(r2 * (pc.length - 1));
        }, t.bg = function(e2, r2, n2, i2) {
          const s2 = r2.getNorth(), a2 = r2.getSouth(), o2 = r2.getWest(), l2 = r2.getEast(), u2 = 1 << e2.z, c2 = l2 - o2, h2 = s2 - a2, p2 = c2 / hc, f2 = -h2 / pc[n2], d2 = [0, p2, 0, f2, 0, 0, s2, o2, 0];
          if (e2.z > 0) {
            const e3 = 180 / i2;
            t.bE.multiply(d2, d2, [e3 / c2 + 1, 0, 0, 0, e3 / h2 + 1, 0, -0.5 * e3 / p2, 0.5 * e3 / f2, 1]);
          }
          return d2[2] = u2, d2[5] = e2.x, d2[8] = e2.y, d2;
        }, t.bh = Zh, t.bi = Fh, t.bj = function(e2, r2, n2) {
          const i2 = t.ae.identity(new Float64Array(16)), s2 = (r2 / (1 << e2) - 0.5) * Math.PI * 2;
          return t.ae.rotateY(i2, n2.globeMatrix, s2), Float32Array.from(i2);
        }, t.bk = Dr, t.bl = function(t2) {
          return t2 <= 1 ? 1 : Math.pow(2, Math.floor(Math.log(t2) / Math.LN2));
        }, t.bm = zb, t.bn = Lb, t.bo = kb, t.bp = function(t2, e2) {
          const r2 = document.createElement("video");
          r2.muted = true, r2.onloadstart = function() {
            e2(null, r2);
          };
          for (let e3 = 0; e3 < t2.length; e3++) {
            const n2 = document.createElement("source");
            sn(t2[e3]) || (r2.crossOrigin = "Anonymous"), n2.src = t2[e3], r2.appendChild(n2);
          }
          return { cancel: () => {
          } };
        }, t.bq = qg, t.br = lr, t.bs = class {
          isDataAvailableAtPoint(t2) {
            const e2 = this._source();
            if (this.isUsingMockSource() || !e2 || t2.y < 0 || t2.y > 1)
              return false;
            const r2 = e2.getSource().maxzoom, n2 = 1 << r2, i2 = Math.floor(t2.x), s2 = Math.floor((t2.x - i2) * n2), a2 = Math.floor(t2.y * n2), o2 = this.findDEMTileFor(new Sc(r2, i2, r2, s2, a2));
            return !(!o2 || !o2.dem);
          }
          getAtPointOrZero(t2, e2 = 0) {
            return this.getAtPoint(t2, e2) || 0;
          }
          getAtPoint(t2, e2, r2 = true) {
            if (this.isUsingMockSource())
              return null;
            null == e2 && (e2 = null);
            const n2 = this._source();
            if (!n2)
              return e2;
            if (t2.y < 0 || t2.y > 1)
              return e2;
            const i2 = n2.getSource().maxzoom, s2 = 1 << i2, a2 = Math.floor(t2.x), o2 = t2.x - a2, l2 = new Sc(i2, a2, i2, Math.floor(o2 * s2), Math.floor(t2.y * s2)), u2 = this.findDEMTileFor(l2);
            if (!u2 || !u2.dem)
              return e2;
            const c2 = u2.dem, h2 = 1 << u2.tileID.canonical.z, p2 = (o2 * h2 - u2.tileID.canonical.x) * c2.dim, f2 = (t2.y * h2 - u2.tileID.canonical.y) * c2.dim, d2 = Math.floor(p2), m2 = Math.floor(f2);
            return (r2 ? this.exaggeration() : 1) * Yn(Yn(c2.get(d2, m2), c2.get(d2, m2 + 1), f2 - m2), Yn(c2.get(d2 + 1, m2), c2.get(d2 + 1, m2 + 1), f2 - m2), p2 - d2);
          }
          getAtTileOffset(t2, e2, r2) {
            const n2 = 1 << t2.canonical.z;
            return this.getAtPointOrZero(new Nc(t2.wrap + (t2.canonical.x + e2 / ds) / n2, (t2.canonical.y + r2 / ds) / n2));
          }
          getAtTileOffsetFunc(e2, r2, n2, i2) {
            return (s2) => {
              const a2 = this.getAtTileOffset(e2, s2.x, s2.y), o2 = i2.upVector(e2.canonical, s2.x, s2.y), l2 = i2.upVectorScale(e2.canonical, r2, n2).metersToTile;
              return t.$.scale(o2, o2, a2 * l2), o2;
            };
          }
          getForTilePoints(t2, e2, r2, n2) {
            if (this.isUsingMockSource())
              return false;
            const i2 = ad.create(this, t2, n2);
            return !!i2 && (e2.forEach((t3) => {
              t3[2] = this.exaggeration() * i2.getElevationAt(t3[0], t3[1], r2);
            }), true);
          }
          getMinMaxForTile(t2) {
            if (this.isUsingMockSource())
              return null;
            const e2 = this.findDEMTileFor(t2);
            if (!e2 || !e2.dem)
              return null;
            const r2 = e2.dem.tree, n2 = e2.tileID, i2 = 1 << t2.canonical.z - n2.canonical.z;
            let s2 = t2.canonical.x / i2 - n2.canonical.x, a2 = t2.canonical.y / i2 - n2.canonical.y, o2 = 0;
            for (let e3 = 0; e3 < t2.canonical.z - n2.canonical.z && !r2.leaves[o2]; e3++) {
              s2 *= 2, a2 *= 2;
              const t3 = 2 * Math.floor(a2) + Math.floor(s2);
              o2 = r2.childOffsets[o2] + t3, s2 %= 1, a2 %= 1;
            }
            return { min: this.exaggeration() * r2.minimums[o2], max: this.exaggeration() * r2.maximums[o2] };
          }
          getMinElevationBelowMSL() {
            throw new Error("Pure virtual method called.");
          }
          raycast(t2, e2, r2) {
            throw new Error("Pure virtual method called.");
          }
          pointCoordinate(t2) {
            throw new Error("Pure virtual method called.");
          }
          _source() {
            throw new Error("Pure virtual method called.");
          }
          isUsingMockSource() {
            throw new Error("Pure virtual method called.");
          }
          exaggeration() {
            throw new Error("Pure virtual method called.");
          }
          findDEMTileFor(t2) {
            throw new Error("Pure virtual method called.");
          }
          get visibleDemTiles() {
            throw new Error("Getter must be implemented in subclass.");
          }
          getMinMaxForVisibleTiles() {
            const t2 = this.visibleDemTiles;
            if (0 === t2.length)
              return null;
            let e2 = false, r2 = Number.MAX_VALUE, n2 = Number.MIN_VALUE;
            for (const i2 of t2) {
              const t3 = this.getMinMaxForTile(i2.tileID);
              t3 && (r2 = Math.min(r2, t3.min), n2 = Math.max(n2, t3.max), e2 = true);
            }
            return e2 ? { min: r2, max: n2 } : null;
          }
        }, t.bt = Bh, t.bu = Dh, t.bv = Ll, t.bw = tu, t.bx = ob, t.by = vv, t.bz = Iv, t.c = n_, t.c$ = function(t2, e2, r2, n2) {
          return "custom" === t2.type ? new Vb(t2, e2) : new g_[t2.type](t2, e2, r2, n2);
        }, t.c0 = Id, t.c1 = dd, t.c2 = 450, t.c3 = 7, t.c4 = Pb, t.c5 = sb, t.c6 = 256, t.c7 = Uh, t.c8 = Hh, t.c9 = Rl, t.cA = hh, t.cB = function(e2, r2, n2 = 0) {
          return t.$.fromValues(((r2.x - n2) * e2.scale - e2.x) * ds, (r2.y * e2.scale - e2.y) * ds, Lc(r2.z, r2.y));
        }, t.cC = function(t2) {
          let e2 = 1 / 0, r2 = 1 / 0, n2 = -1 / 0, i2 = -1 / 0;
          for (const s2 of t2)
            e2 = Math.min(e2, s2.x), r2 = Math.min(r2, s2.y), n2 = Math.max(n2, s2.x), i2 = Math.max(i2, s2.y);
          return { min: new je(e2, r2), max: new je(n2, i2) };
        }, t.cD = ch, t.cE = qc, t.cF = oc, t.cG = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"], t.cH = zy, t.cI = eh, t.cJ = Vf, t.cK = Xf, t.cL = Yf, t.cM = tg, t.cN = b_, t.cO = function(t2) {
          return t2({ pluginStatus: $o, pluginURL: qo }), Yo.on("pluginStateChange", t2), t2;
        }, t.cP = Uy, t.cQ = Oy, t.cR = en, t.cS = Go, t.cT = s, t.cU = Lr, t.cV = Rn, t.cW = pr, t.cX = function(t2) {
          const e2 = t2.indexOf(Il);
          return e2 >= 0 ? t2.slice(0, e2) : t2;
        }, t.cY = function(t2) {
          return t2.indexOf(Il) >= 0;
        }, t.cZ = function(t2) {
          const e2 = t2.indexOf(Il);
          return e2 >= 0 ? t2.slice(e2 + 1) : "";
        }, t.c_ = function(t2) {
          const e2 = [], r2 = t2.id;
          return void 0 === r2 && e2.push({ message: `layers.${r2}: missing required property "id"` }), void 0 === t2.render && e2.push({ message: `layers.${r2}: missing required method "render"` }), t2.renderingMode && "2d" !== t2.renderingMode && "3d" !== t2.renderingMode && e2.push({ message: `layers.${r2}: property "renderingMode" must be either "2d" or "3d"` }), e2;
        }, t.ca = Nl, t.cb = iu, t.cc = 1, t.cd = nx, t.ce = 0, t.cf = su, t.cg = function(t2, e2, r2, n2, i2) {
          return We((t2 - e2) / (r2 - e2) * (i2 - n2) + n2, n2, i2);
        }, t.ch = $a, t.ci = Oc, t.cj = class {
          constructor(t2, e2, r2, n2) {
            this.context = t2, this.format = n2, this.size = r2, this.texture = t2.gl.createTexture();
            const [i2, s2, a2] = this.size, { gl: o2 } = t2;
            o2.bindTexture(o2.TEXTURE_3D, this.texture), t2.pixelStoreUnpackFlipY.set(false), t2.pixelStoreUnpack.set(1), t2.pixelStoreUnpackPremultiplyAlpha.set(false);
            let l2 = this.format, u2 = o2.UNSIGNED_BYTE;
            this.format === o2.DEPTH_COMPONENT && (l2 = o2.DEPTH_COMPONENT16, u2 = o2.UNSIGNED_SHORT), this.format === o2.R8 && (n2 = o2.RED), this.format === o2.R32F && (u2 = o2.FLOAT, n2 = o2.RED), o2.texImage3D(o2.TEXTURE_3D, 0, l2, i2, s2, a2, 0, n2, u2, e2.data);
          }
          bind(t2, e2) {
            const { context: r2 } = this, { gl: n2 } = r2;
            n2.bindTexture(n2.TEXTURE_3D, this.texture), t2 !== this.minFilter && (n2.texParameteri(n2.TEXTURE_3D, n2.TEXTURE_MAG_FILTER, t2), n2.texParameteri(n2.TEXTURE_3D, n2.TEXTURE_MIN_FILTER, t2), this.minFilter = t2), e2 !== this.wrapS && (n2.texParameteri(n2.TEXTURE_3D, n2.TEXTURE_WRAP_S, e2), n2.texParameteri(n2.TEXTURE_3D, n2.TEXTURE_WRAP_T, e2), this.wrapS = e2);
          }
          destroy() {
            const { gl: t2 } = this.context;
            t2.deleteTexture(this.texture), this.texture = null;
          }
        }, t.ck = Yb, t.cl = [1, 1, 1], t.cm = ad, t.cn = cv, t.co = Hl, t.cp = class {
          constructor() {
            this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [], this._globalClipBounds = { min: new je(1 / 0, 1 / 0), max: new je(-1 / 0, -1 / 0) };
          }
          clear() {
            this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
          }
          get updateTime() {
            return this._updateTime;
          }
          getReplacementRegionsForTile(t2, e2 = false) {
            const r2 = Nf(new je(0, 0), new je(ds, ds), t2), n2 = [];
            if (e2 && !Uf(r2, this._globalClipBounds))
              return n2;
            for (const e3 of this._activeRegions) {
              if (e3.hiddenByOverlap)
                continue;
              if (!Uf(r2, e3))
                continue;
              const i2 = $f(e3.min, e3.max, t2);
              n2.push({ min: i2.min, max: i2.max, sourceId: this._sourceIds[e3.priority], footprint: e3.footprint, footprintTileId: e3.tileId, order: e3.order, clipMask: e3.clipMask, clipScope: e3.clipScope });
            }
            return n2;
          }
          setSources(t2) {
            this._setSources(t2.map((t3) => ({ getSourceId: () => t3.cache.id, getFootprints: () => {
              const e2 = [];
              for (const r2 of t3.cache.getVisibleCoordinates()) {
                const n2 = t3.cache.getTile(r2).buckets[t3.layer];
                n2 && n2.updateFootprints(r2.toUnwrapped(), e2);
              }
              return e2;
            }, getOrder: () => t3.order, getClipMask: () => t3.clipMask, getClipScope: () => t3.clipScope })));
          }
          _addSource(t2) {
            const e2 = t2.getFootprints();
            if (0 === e2.length)
              return;
            const r2 = t2.getOrder(), n2 = t2.getClipMask(), i2 = t2.getClipScope();
            for (const t3 of e2) {
              if (!t3.footprint)
                continue;
              const e3 = Nf(t3.footprint.min, t3.footprint.max, t3.id);
              this._activeRegions.push({ min: e3.min, max: e3.max, hiddenByOverlap: false, priority: this._sourceIds.length, tileId: t3.id, footprint: t3.footprint, order: r2, clipMask: n2, clipScope: i2 });
            }
            this._sourceIds.push(t2.getSourceId());
          }
          _computeReplacement() {
            this._activeRegions.sort((t3, e2) => t3.priority - e2.priority || Ff(t3.min, e2.min) || Ff(t3.max, e2.max) || t3.order - e2.order || t3.clipMask - e2.clipMask || function(t4, e3) {
              const r2 = (t5, e4) => t5 + e4;
              return t4.length - e3.length || t4.reduce(r2, "").localeCompare(e3.reduce(r2, ""));
            }(t3.clipScope, e2.clipScope));
            let t2 = this._activeRegions.length !== this._prevRegions.length;
            if (!t2) {
              let e2 = 0;
              for (; !t2 && e2 !== this._activeRegions.length; ) {
                const r2 = this._activeRegions[e2], n2 = this._prevRegions[e2];
                t2 = r2.priority !== n2.priority || !Of(r2, n2) || r2.order !== n2.order || r2.clipMask !== n2.clipMask || !Ne(r2.clipScope, n2.clipScope), ++e2;
              }
            }
            if (t2) {
              ++this._updateTime;
              for (const t4 of this._activeRegions)
                t4.order !== Lf && (this._globalClipBounds.min.x = Math.min(this._globalClipBounds.min.x, t4.min.x), this._globalClipBounds.min.y = Math.min(this._globalClipBounds.min.y, t4.min.y), this._globalClipBounds.max.x = Math.max(this._globalClipBounds.max.x, t4.max.x), this._globalClipBounds.max.y = Math.max(this._globalClipBounds.max.y, t4.max.y));
              const t3 = (t4) => {
                const e2 = this._activeRegions;
                if (t4 >= e2.length)
                  return t4;
                const r2 = e2[t4].priority;
                for (; t4 < e2.length && e2[t4].priority === r2; )
                  ++t4;
                return t4;
              };
              if (this._sourceIds.length > 1) {
                let e2 = 0, r2 = t3(e2);
                for (; e2 !== r2; ) {
                  let n2 = e2;
                  const i2 = e2;
                  for (; n2 !== r2; ) {
                    const t4 = this._activeRegions[n2];
                    t4.hiddenByOverlap = false;
                    for (let e3 = 0; e3 < i2; e3++) {
                      const r3 = this._activeRegions[e3];
                      if (!r3.hiddenByOverlap && t4.order === Lf && Uf(t4, r3) && (t4.hiddenByOverlap = Gf(t4.footprint, t4.tileId, r3.footprint, r3.tileId), t4.hiddenByOverlap))
                        break;
                    }
                    ++n2;
                  }
                  e2 = r2, r2 = t3(e2);
                }
              }
            }
          }
          _setSources(t2) {
            [this._prevRegions, this._activeRegions] = [this._activeRegions, []], this._sourceIds = [];
            for (let e2 = t2.length - 1; e2 >= 0; e2--)
              this._addSource(t2[e2]);
            this._computeReplacement();
          }
        }, t.cq = Fl, t.cr = Jg, t.cs = ou, t.ct = class {
          constructor(t2) {
            this._createGrid(t2), this._createPoles(t2);
          }
          destroy() {
            this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
            for (const t2 of this._poleSegments)
              t2.destroy();
            for (const t2 of this._gridSegments)
              t2.withSkirts.destroy(), t2.withoutSkirts.destroy();
          }
          _fillGridMeshWithLods(t2, e2) {
            const r2 = new Ll(), n2 = new tu(), i2 = [], s2 = t2 + 1 + 2, a2 = e2[0] + 1, o2 = e2[0] + 1 + (1 + e2.length), l2 = (t3, e3, r3) => {
              let n3 = t3 === s2 - 1 ? t3 - 2 : 0 === t3 ? t3 : t3 - 1;
              return n3 += r3 ? 24575 : 0, [n3, e3];
            };
            for (let t3 = 0; t3 < s2; ++t3)
              r2.emplaceBack(...l2(t3, 0, true));
            for (let t3 = 0; t3 < a2; ++t3)
              for (let e3 = 0; e3 < s2; ++e3)
                r2.emplaceBack(...l2(e3, t3, (0 === e3 || e3 === s2 - 1) && true));
            for (let t3 = 0; t3 < e2.length; ++t3) {
              const n3 = e2[t3];
              for (let t4 = 0; t4 < s2; ++t4)
                r2.emplaceBack(...l2(t4, n3, true));
            }
            for (let t3 = 0; t3 < e2.length; ++t3) {
              const a3 = n2.length, l3 = e2[t3] + 1 + 2, u2 = new tu();
              for (let r3 = 0; r3 < l3 - 1; r3++) {
                const i3 = r3 === l3 - 2, a4 = i3 ? s2 * (o2 - e2.length + t3 - r3) : s2;
                for (let t4 = 0; t4 < s2 - 1; t4++) {
                  const e3 = r3 * s2 + t4;
                  0 === r3 || i3 || 0 === t4 || t4 === s2 - 2 ? (u2.emplaceBack(e3 + 1, e3, e3 + a4), u2.emplaceBack(e3 + a4, e3 + a4 + 1, e3 + 1)) : (n2.emplaceBack(e3 + 1, e3, e3 + a4), n2.emplaceBack(e3 + a4, e3 + a4 + 1, e3 + 1));
                }
              }
              const c2 = ku.simpleSegment(0, a3, r2.length, n2.length - a3);
              for (let t4 = 0; t4 < u2.uint16.length; t4 += 3)
                n2.emplaceBack(u2.uint16[t4], u2.uint16[t4 + 1], u2.uint16[t4 + 2]);
              const h2 = ku.simpleSegment(0, a3, r2.length, n2.length - a3);
              i2.push({ withoutSkirts: c2, withSkirts: h2 });
            }
            return { vertices: r2, indices: n2, segments: i2 };
          }
          _createGrid(t2) {
            const e2 = this._fillGridMeshWithLods(hc, pc);
            this._gridSegments = e2.segments, this._gridBuffer = t2.createVertexBuffer(e2.vertices, Bh.members), this._gridIndexBuffer = t2.createIndexBuffer(e2.indices, true);
          }
          _createPoles(t2) {
            const e2 = new tu();
            for (let t3 = 0; t3 <= hc; t3++)
              e2.emplaceBack(0, t3 + 1, t3 + 2);
            this._poleIndexBuffer = t2.createIndexBuffer(e2, true);
            const r2 = new iu(), n2 = new iu(), i2 = new iu(), s2 = new iu();
            this._poleSegments = [];
            for (let t3 = 0, e3 = 0; t3 < lc; t3++) {
              const a2 = 360 / (1 << t3);
              r2.emplaceBack(0, -oc, 0, 0.5, 0), n2.emplaceBack(0, -oc, 0, 0.5, 1), i2.emplaceBack(0, -oc, 0, 0.5, 0.5), s2.emplaceBack(0, -oc, 0, 0.5, 0.5);
              for (let t4 = 0; t4 <= hc; t4++) {
                let e4 = t4 / hc, o2 = 0;
                const l2 = Yn(0, a2, e4), [u2, c2, h2] = mc(np, ip, l2, oc);
                r2.emplaceBack(u2, c2, h2, e4, o2), n2.emplaceBack(u2, c2, h2, e4, 1 - o2);
                const p2 = Ge(l2);
                e4 = 0.5 + 0.5 * Math.sin(p2), o2 = 0.5 + 0.5 * Math.cos(p2), i2.emplaceBack(u2, c2, h2, e4, o2), s2.emplaceBack(u2, c2, h2, e4, 1 - o2);
              }
              this._poleSegments.push(ku.simpleSegment(e3, 0, 66, 64)), e3 += 66;
            }
            this._poleNorthVertexBuffer = t2.createVertexBuffer(r2, zh, false), this._poleSouthVertexBuffer = t2.createVertexBuffer(n2, zh, false), this._texturedPoleNorthVertexBuffer = t2.createVertexBuffer(i2, zh, false), this._texturedPoleSouthVertexBuffer = t2.createVertexBuffer(s2, zh, false);
          }
          getGridBuffers(t2, e2) {
            return [this._gridBuffer, this._gridIndexBuffer, e2 ? this._gridSegments[t2].withSkirts : this._gridSegments[t2].withoutSkirts];
          }
          getPoleBuffers(t2, e2) {
            return [e2 ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer, e2 ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer, this._poleIndexBuffer, this._poleSegments[t2]];
          }
        }, t.cu = function(t2) {
          return kn.has(t2);
        }, t.cv = Lf, t.cw = od, t.cx = function(t2, e2, r2 = 0, n2 = true) {
          const i2 = new je(r2, r2), s2 = t2.sub(i2), a2 = e2.add(i2), o2 = [s2, new je(a2.x, s2.y), a2, new je(s2.x, a2.y)];
          return n2 && o2.push(s2.clone()), o2;
        }, t.cy = function(t2, e2) {
          const r2 = [];
          for (let n2 = 0; n2 < t2.length; n2++) {
            const i2 = Qe(n2 - 1, -1, t2.length - 1), s2 = Qe(n2 + 1, -1, t2.length - 1), a2 = t2[n2], o2 = t2[s2], l2 = t2[i2].sub(a2).unit(), u2 = o2.sub(a2).unit(), c2 = u2.angleWithSep(l2.x, l2.y), h2 = l2.add(u2).unit().mult(-1 * e2 / Math.sin(c2 / 2));
            r2.push(a2.add(h2));
          }
          return r2;
        }, t.cz = hg, t.d = Ne, t.d$ = rb, t.d0 = hr, t.d1 = Yo, t.d2 = rn, t.d3 = He, t.d4 = function() {
          return !!document.fullscreenElement || !!document.webkitFullscreenElement;
        }, t.d5 = Ke, t.d6 = Uc, t.d7 = yc, t.d8 = function([t2, e2, r2]) {
          const n2 = Math.hypot(t2, e2, r2), i2 = Math.atan2(t2, r2), s2 = 0.5 * Math.PI - Math.acos(-e2 / n2);
          return new bc(Xe(i2), Xe(s2));
        }, t.d9 = Rc, t.dA = function() {
          Iv().acquire(Mv);
        }, t.dB = function() {
          const t2 = Sv;
          t2 && (t2.isPreloaded() && 1 === t2.numActive() ? (t2.release(Mv), Sv = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
        }, t.dC = Av, t.dD = function(t2) {
          const e2 = $r();
          if (!e2)
            return;
          const r2 = e2.delete(Vr);
          t2 && r2.catch(t2).then(() => t2());
        }, t.dE = _v, t.dF = Dv, t.dG = function(t2) {
          kv = Rr.resolveURL(t2), Bv || (Bv = new vv(Iv(), new On())), Bv.broadcast("setDracoUrl", kv);
        }, t.dH = Rv, t.dI = function(t2) {
          zv = Rr.resolveURL(t2), Bv || (Bv = new vv(Iv(), new On())), Bv.broadcast("setMeshoptUrl", zv);
        }, t.dJ = er, t.dK = So, t.dL = yp, t.dM = Fy, t.dN = cg, t.dO = du, t.dP = ym, t.dQ = $m, t.dR = nm, t.dS = cr, t.dT = Ry, t.dU = Ng, t.dV = function(t2, e2, r2, n2, i2, s2, a2, o2, l2, u2, c2) {
          t2.createArrays(), t2.tilePixelRatio = ds / (512 * t2.overscaling), t2.compareText = {}, t2.iconsNeedLinear = false;
          const h2 = t2.layers[0].layout, p2 = t2.layers[0]._unevaluatedLayout._values, f2 = {};
          if ("composite" === t2.textSizeData.kind) {
            const { minZoom: e3, maxZoom: r3 } = t2.textSizeData;
            f2.compositeTextSizes = [p2["text-size"].possiblyEvaluate(new Wo(e3), o2), p2["text-size"].possiblyEvaluate(new Wo(r3), o2)];
          }
          if ("composite" === t2.iconSizeData.kind) {
            const { minZoom: e3, maxZoom: r3 } = t2.iconSizeData;
            f2.compositeIconSizes = [p2["icon-size"].possiblyEvaluate(new Wo(e3), o2), p2["icon-size"].possiblyEvaluate(new Wo(r3), o2)];
          }
          f2.layoutTextSize = p2["text-size"].possiblyEvaluate(new Wo(l2 + 1), o2), f2.layoutIconSize = p2["icon-size"].possiblyEvaluate(new Wo(l2 + 1), o2), f2.textMaxSize = p2["text-size"].possiblyEvaluate(new Wo(18), o2);
          const d2 = "map" === h2.get("text-rotation-alignment") && "point" !== h2.get("symbol-placement"), m2 = h2.get("text-size");
          let y2 = false;
          for (const e3 of t2.features)
            if (e3.icon && e3.icon.nameSecondary) {
              y2 = true;
              break;
            }
          for (const s3 of t2.features) {
            const l3 = h2.get("text-font").evaluate(s3, {}, o2).join(","), p3 = m2.evaluate(s3, {}, o2), g2 = f2.layoutTextSize.evaluate(s3, {}, o2), x2 = (f2.layoutIconSize.evaluate(s3, {}, o2), { horizontal: {}, vertical: void 0 }), b2 = s3.text;
            let v2, _2 = [0, 0];
            if (b2) {
              const n3 = b2.toString(), a3 = h2.get("text-letter-spacing").evaluate(s3, {}, o2) * Xm, u3 = h2.get("text-line-height").evaluate(s3, {}, o2) * Xm, c3 = Bo(n3) ? a3 : 0, f3 = h2.get("text-anchor").evaluate(s3, {}, o2), m3 = h2.get("text-variable-anchor");
              if (!m3) {
                const t3 = h2.get("text-radial-offset").evaluate(s3, {}, o2);
                _2 = t3 ? Qy(f3, [t3 * Xm, Wy]) : h2.get("text-offset").evaluate(s3, {}, o2).map((t4) => t4 * Xm);
              }
              let y3 = d2 ? "center" : h2.get("text-justify").evaluate(s3, {}, o2);
              const v3 = "point" === h2.get("symbol-placement"), w3 = v3 ? h2.get("text-max-width").evaluate(s3, {}, o2) * Xm : 1 / 0, M3 = (s4) => {
                t2.allowVerticalPlacement && Eo(n3) && (x2.vertical = cy(b2, e2, r2, i2, l3, w3, u3, f3, s4, c3, _2, oy.vertical, true, g2, p3));
              };
              if (!d2 && m3) {
                const t3 = "auto" === y3 ? m3.map((t4) => tg(t4)) : [y3];
                let n4 = false;
                for (let s4 = 0; s4 < t3.length; s4++) {
                  const a4 = t3[s4];
                  if (!x2.horizontal[a4])
                    if (n4)
                      x2.horizontal[a4] = x2.horizontal[0];
                    else {
                      const t4 = cy(b2, e2, r2, i2, l3, w3, u3, "center", a4, c3, _2, oy.horizontal, false, g2, p3);
                      t4 && (x2.horizontal[a4] = t4, n4 = 1 === t4.positionedLines.length);
                    }
                }
                M3("left");
              } else {
                if ("auto" === y3 && (y3 = tg(f3)), v3 || h2.get("text-writing-mode").indexOf("horizontal") >= 0 || !Eo(n3)) {
                  const t3 = cy(b2, e2, r2, i2, l3, w3, u3, f3, y3, c3, _2, oy.horizontal, false, g2, p3);
                  t3 && (x2.horizontal[y3] = t3);
                }
                M3(v3 ? "left" : y3);
              }
            }
            let w2 = false;
            if (s3.icon && s3.icon.namePrimary) {
              const e3 = n2[s3.icon.namePrimary];
              e3 && (v2 = vy(i2[s3.icon.namePrimary], s3.icon.nameSecondary ? i2[s3.icon.nameSecondary] : void 0, h2.get("icon-offset").evaluate(s3, {}, o2), h2.get("icon-anchor").evaluate(s3, {}, o2)), w2 = e3.sdf, void 0 === t2.sdfIcons ? t2.sdfIcons = e3.sdf : t2.sdfIcons !== e3.sdf && dr("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (e3.pixelRatio !== t2.pixelRatio || 0 !== h2.get("icon-rotate").constantOr(1)) && (t2.iconsNeedLinear = true));
            }
            const M2 = sg(x2.horizontal) || x2.vertical;
            t2.iconsInText || (t2.iconsInText = !!M2 && M2.iconsInText), (M2 || v2) && eg(t2, s3, x2, v2, n2, f2, g2, 0, _2, w2, a2, o2, u2, c2, y2);
          }
          s2 && t2.generateCollisionDebugBuffers(l2, t2.collisionBoxArray);
        }, t.dW = om, t.dX = ef, t.dY = Pf, t.dZ = Om, t.d_ = sd, t.da = gc, t.db = n, t.dc = ep, t.dd = tp, t.de = function(e2) {
          const r2 = [0, 0, 0], n2 = t.ae.identity(new Float64Array(16));
          return t.ae.multiply(n2, e2.pixelMatrix, e2.globeMatrix), t.$.transformMat4(r2, r2, n2), new je(r2[0], r2[1]);
        }, t.df = c, t.dg = u, t.dh = function(t2) {
          const e2 = t2.navigator ? t2.navigator.userAgent : null;
          return !!function(t3) {
            if (null == Ir) {
              const e3 = t3.navigator ? t3.navigator.userAgent : null;
              Ir = !!t3.safari || !(!e3 || !(/\b(iPad|iPhone|iPod)\b/.test(e3) || e3.match("Safari") && !e3.match("Chrome")));
            }
            return Ir;
          }(t2) && e2 && (e2.match("Version/15.4") || e2.match("Version/15.5") || e2.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/));
        }, t.di = ir, t.dj = class {
          constructor(t2, e2, r2) {
            this._transformRequestFn = t2, this._customAccessToken = e2, this._silenceAuthErrors = !!r2, this._createSkuToken();
          }
          _createSkuToken() {
            const t2 = function() {
              let t3 = "";
              for (let e2 = 0; e2 < 10; e2++)
                t3 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
              return { token: ["1", cn, t3].join(""), tokenExpiresAt: Date.now() + 432e5 };
            }();
            this._skuToken = t2.token, this._skuTokenExpiresAt = t2.tokenExpiresAt;
          }
          _isSkuTokenExpired() {
            return Date.now() > this._skuTokenExpiresAt;
          }
          transformRequest(t2, e2) {
            return this._transformRequestFn && this._transformRequestFn(t2, e2) || { url: t2 };
          }
          normalizeStyleURL(t2, r2) {
            if (!s(t2))
              return t2;
            const n2 = fn(t2);
            return n2.params.push(`sdk=js-${e}`), n2.path = `/styles/v1${n2.path}`, this._makeAPIURL(n2, this._customAccessToken || r2);
          }
          normalizeGlyphsURL(t2, e2) {
            if (!s(t2))
              return t2;
            const r2 = fn(t2);
            return r2.path = `/fonts/v1${r2.path}`, this._makeAPIURL(r2, this._customAccessToken || e2);
          }
          normalizeModelURL(t2, e2) {
            if (!s(t2))
              return t2;
            const r2 = fn(t2);
            return r2.path = `/models/v1${r2.path}`, this._makeAPIURL(r2, this._customAccessToken || e2);
          }
          normalizeSourceURL(t2, e2, r2, n2) {
            if (!s(t2))
              return t2;
            const i2 = fn(t2);
            return i2.path = `/v4/${i2.authority}.json`, i2.params.push("secure"), r2 && i2.params.push(`language=${r2}`), n2 && i2.params.push(`worldview=${n2}`), this._makeAPIURL(i2, this._customAccessToken || e2);
          }
          normalizeSpriteURL(t2, e2, r2, n2) {
            const i2 = fn(t2);
            return s(t2) ? (i2.path = `/styles/v1${i2.path}/sprite${e2}${r2}`, this._makeAPIURL(i2, this._customAccessToken || n2)) : (i2.path += `${e2}${r2}`, dn(i2));
          }
          normalizeTileURL(t2, e2, r2) {
            if (this._isSkuTokenExpired() && this._createSkuToken(), t2 && !s(t2))
              return t2;
            const i2 = fn(t2);
            i2.path = i2.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${e2 || r2 && "raster" !== i2.authority && 512 === r2 ? "@2x" : ""}${Xr.supported ? ".webp" : "$1"}`), "raster" === i2.authority ? i2.path = `/${n.RASTER_URL_PREFIX}${i2.path}` : "rasterarrays" === i2.authority ? i2.path = `/${n.RASTERARRAYS_URL_PREFIX}${i2.path}` : "3dtiles" === i2.authority ? i2.path = `/${n.TILES3D_URL_PREFIX}${i2.path}` : (i2.path = i2.path.replace(/^.+\/v4\//, "/"), i2.path = `/${n.TILE_URL_VERSION}${i2.path}`);
            const a2 = this._customAccessToken || function(t3) {
              for (const e3 of t3) {
                const t4 = e3.match(/^access_token=(.*)$/);
                if (t4)
                  return t4[1];
              }
              return null;
            }(i2.params) || n.ACCESS_TOKEN;
            return n.REQUIRE_ACCESS_TOKEN && a2 && this._skuToken && i2.params.push(`sku=${this._skuToken}`), this._makeAPIURL(i2, a2);
          }
          canonicalizeTileURL(t2, e2) {
            const r2 = fn(t2);
            if (!r2.path.match(/^(\/v4\/|\/(raster|rasterarrays)\/v1\/)/) || !r2.path.match(/\.[\w]+$/))
              return t2;
            let i2 = "mapbox://";
            r2.path.match(/^\/raster\/v1\//) ? i2 += `raster/${r2.path.replace(`/${n.RASTER_URL_PREFIX}/`, "")}` : r2.path.match(/^\/rasterarrays\/v1\//) ? i2 += `rasterarrays/${r2.path.replace(`/${n.RASTERARRAYS_URL_PREFIX}/`, "")}` : i2 += `tiles/${r2.path.replace(`/${n.TILE_URL_VERSION}/`, "")}`;
            let s2 = r2.params;
            return e2 && (s2 = s2.filter((t3) => !t3.match(/^access_token=/))), s2.length && (i2 += `?${s2.join("&")}`), i2;
          }
          canonicalizeTileset(t2, e2) {
            const r2 = !!e2 && s(e2), n2 = [];
            for (const e3 of t2.tiles || [])
              i(e3) ? n2.push(this.canonicalizeTileURL(e3, r2)) : n2.push(e3);
            return n2;
          }
          _makeAPIURL(t2, e2) {
            const r2 = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", i2 = fn(n.API_URL);
            if (t2.protocol = i2.protocol, t2.authority = i2.authority, "http" === t2.protocol) {
              const e3 = t2.params.indexOf("secure");
              e3 >= 0 && t2.params.splice(e3, 1);
            }
            if ("/" !== i2.path && (t2.path = `${i2.path}${t2.path}`), !n.REQUIRE_ACCESS_TOKEN)
              return dn(t2);
            if (e2 = e2 || n.ACCESS_TOKEN, !this._silenceAuthErrors) {
              if (!e2)
                throw new Error(`An API access token is required to use Mapbox GL. ${r2}`);
              if ("s" === e2[0])
                throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${r2}`);
            }
            return t2.params = t2.params.filter((t3) => -1 === t3.indexOf("access_token")), t2.params.push(`access_token=${e2 || ""}`), dn(t2);
          }
        }, t.dk = function(t2, e2) {
          e2 ? kn.add(t2) : kn.delete(t2);
        }, t.dl = Xr, t.dm = Sn, t.dn = Tn, t.dp = hn, t.dq = _n, t.dr = Mn, t.ds = function(t2) {
          kn.delete(t2);
        }, t.dt = In, t.du = vn, t.dv = tr, t.dw = e, t.dx = function(t2, e2) {
          Fr = t2, Or = e2;
        }, t.dy = function(t2, e2, r2 = false) {
          if ($o === Oo || $o === Uo || $o === jo)
            throw new Error("setRTLTextPlugin cannot be called multiple times.");
          qo = Rr.resolveURL(t2), $o = Oo, No = e2, Xo(), r2 || Ho();
        }, t.dz = Zo, t.e = Rr, t.e0 = zf, t.e1 = gf, t.e2 = Oe, t.e3 = xm, t.e4 = p, t.e5 = nn, t.e6 = function(t2) {
          let e2 = 0;
          if (new Uint32Array(t2, 0, 1)[0] !== $v) {
            const r2 = new Uint32Array(t2, 0, 7), [, , n2, i2, s2, a2] = r2;
            e2 = r2.byteLength + i2 + s2 + a2 + s2, (n2 !== t2.byteLength || e2 >= t2.byteLength) && dr("Invalid b3dm header information.");
          }
          return Hv(t2, e2);
        }, t.e7 = function(t2, e2) {
          const r2 = n_(t2);
          for (const t3 of r2) {
            for (const e3 of t3.meshes)
              i_(e3);
            t3.lights && (t3.lightMeshIndex = t3.meshes.length, t3.meshes.push(s_(t3.lights, e2)));
          }
          return r2;
        }, t.e8 = p_, t.e9 = bv, t.ea = Ko, t.eb = function(t2) {
          qr(), jr && jr.then((e2) => {
            e2.keys().then((r2) => {
              for (let n2 = 0; n2 < r2.length - t2; n2++)
                e2.delete(r2[n2]);
            });
          });
        }, t.f = Ln, t.g = Cn, t.h = function(t2, e2) {
          return rn(rr(t2, { type: "json" }), e2);
        }, t.i = un, t.j = gp, t.k = Ey, t.l = function(t2) {
          return fetch(t2).then((t3) => t3.arrayBuffer()).then((e2) => Hv(e2, 0, t2));
        }, t.m = Dy, t.n = class extends rv {
        }, t.o = Pi, t.p = lx, t.q = Kn, t.r = Qa, t.s = ro, t.t = eo, t.u = hl, t.v = po, t.w = dr, t.x = pl, t.y = go, t.z = fo;
      });
      define2(["./shared"], function(e) {
        function t(e2) {
          const t2 = e2 ? e2.url.toString() : void 0;
          return t2 ? performance.getEntriesByName(t2) : [];
        }
        function s(e2) {
          if ("number" == typeof e2 || "boolean" == typeof e2 || "string" == typeof e2 || null == e2)
            return JSON.stringify(e2);
          if (Array.isArray(e2)) {
            let t3 = "[";
            for (const o2 of e2)
              t3 += `${s(o2)},`;
            return `${t3}]`;
          }
          let t2 = "{";
          for (const o2 of Object.keys(e2).sort())
            t2 += `${o2}:${s(e2[o2])},`;
          return `${t2}}`;
        }
        function o(t2) {
          let o2 = "";
          for (const i2 of e.cG)
            o2 += `/${s(t2[i2])}`;
          return o2;
        }
        class i {
          constructor(e2) {
            this.keyCache = {}, this._layers = {}, this._layerConfigs = {}, e2 && this.replace(e2);
          }
          replace(e2, t2) {
            this._layerConfigs = {}, this._layers = {}, this.update(e2, [], t2);
          }
          update(t2, s2, i2) {
            this._options = i2;
            for (const s3 of t2)
              this._layerConfigs[s3.id] = s3, (this._layers[s3.id] = e.c$(s3, this.scope, null, this._options)).compileFilter(), this.keyCache[s3.id] && delete this.keyCache[s3.id];
            for (const e2 of s2)
              delete this.keyCache[e2], delete this._layerConfigs[e2], delete this._layers[e2];
            this.familiesBySource = {};
            const n2 = function(e2, t3) {
              const s3 = {};
              for (let i4 = 0; i4 < e2.length; i4++) {
                const n3 = t3 && t3[e2[i4].id] || o(e2[i4]);
                t3 && (t3[e2[i4].id] = n3);
                let r2 = s3[n3];
                r2 || (r2 = s3[n3] = []), r2.push(e2[i4]);
              }
              const i3 = [];
              for (const e3 in s3)
                i3.push(s3[e3]);
              return i3;
            }(e.dJ(this._layerConfigs), this.keyCache);
            for (const e2 of n2) {
              const t3 = e2.map((e3) => this._layers[e3.id]), s3 = t3[0];
              if ("none" === s3.visibility)
                continue;
              const o2 = s3.source || "";
              let i3 = this.familiesBySource[o2];
              i3 || (i3 = this.familiesBySource[o2] = {});
              const n3 = s3.sourceLayer || "_geojsonTileLayer";
              let r2 = i3[n3];
              r2 || (r2 = i3[n3] = []), r2.push(t3);
            }
          }
        }
        const n = 1 * e.dM;
        class r {
          constructor(t2) {
            const s2 = {}, o2 = [];
            for (const e2 in t2) {
              const i3 = t2[e2], r3 = s2[e2] = {};
              for (const e3 in i3.glyphs) {
                const t3 = i3.glyphs[+e3];
                if (!t3 || 0 === t3.bitmap.width || 0 === t3.bitmap.height)
                  continue;
                const s3 = t3.metrics.localGlyph ? n : 1, a3 = { x: 0, y: 0, w: t3.bitmap.width + 2 * s3, h: t3.bitmap.height + 2 * s3 };
                o2.push(a3), r3[e3] = a3;
              }
            }
            const { w: i2, h: r2 } = e.k(o2), a2 = new e.dL({ width: i2 || 1, height: r2 || 1 });
            for (const o3 in t2) {
              const i3 = t2[o3];
              for (const t3 in i3.glyphs) {
                const r3 = i3.glyphs[+t3];
                if (!r3 || 0 === r3.bitmap.width || 0 === r3.bitmap.height)
                  continue;
                const l2 = s2[o3][t3], c2 = r3.metrics.localGlyph ? n : 1;
                e.dL.copy(r3.bitmap, a2, { x: 0, y: 0 }, { x: l2.x + c2, y: l2.y + c2 }, r3.bitmap);
              }
            }
            this.image = a2, this.positions = s2;
          }
        }
        e.dK(r, "GlyphAtlas");
        class a {
          constructor(t2) {
            this.tileID = new e.aQ(t2.tileID.overscaledZ, t2.tileID.wrap, t2.tileID.canonical.z, t2.tileID.canonical.x, t2.tileID.canonical.y), this.tileZoom = t2.tileZoom, this.uid = t2.uid, this.zoom = t2.zoom, this.lut = t2.lut, this.canonical = t2.tileID.canonical, this.pixelRatio = t2.pixelRatio, this.tileSize = t2.tileSize, this.source = t2.source, this.scope = t2.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t2.showCollisionBoxes, this.collectResourceTiming = !!t2.collectResourceTiming, this.promoteId = t2.promoteId, this.isSymbolTile = t2.isSymbolTile, this.tileTransform = e.dN(t2.tileID.canonical, t2.projection), this.projection = t2.projection, this.brightness = t2.brightness, this.extraShadowCaster = !!t2.extraShadowCaster, this.tessellationStep = t2.tessellationStep;
          }
          parse(t2, s2, o2, i2, n2) {
            this.status = "parsing", this.data = t2, this.collisionBoxArray = new e.dO();
            const a2 = new e.dP(Object.keys(t2.layers).sort()), c2 = new e.dQ(this.tileID, this.promoteId);
            c2.bucketLayerIDs = [];
            const h2 = {}, u2 = new e.dR(256, 256), d2 = { featureIndex: c2, iconDependencies: {}, patternDependencies: {}, glyphDependencies: {}, lineAtlas: u2, availableImages: o2, brightness: this.brightness }, f2 = s2.familiesBySource[this.source];
            for (const s3 in f2) {
              const i3 = t2.layers[s3];
              if (!i3)
                continue;
              let n3 = false, r2 = false, u3 = false;
              for (const e2 of f2[s3])
                "symbol" === e2[0].type ? n3 = true : r2 = true, e2[0].is3D() && "model" !== e2[0].type && (u3 = true);
              if (this.extraShadowCaster && !u3)
                continue;
              if (true === this.isSymbolTile && !n3)
                continue;
              if (false === this.isSymbolTile && !r2)
                continue;
              1 === i3.version && e.w(`Vector tile source "${this.source}" layer "${s3}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
              const p3 = a2.encode(s3), g3 = [];
              for (let e2 = 0; e2 < i3.length; e2++) {
                const t3 = i3.feature(e2), o3 = c2.getId(t3, s3);
                g3.push({ feature: t3, id: o3, index: e2, sourceLayerIndex: p3 });
              }
              for (const e2 of f2[s3]) {
                const t3 = e2[0];
                (!this.extraShadowCaster || t3.is3D() && "model" !== t3.type) && (void 0 !== this.isSymbolTile && "symbol" === t3.type !== this.isSymbolTile || t3.minzoom && this.zoom < Math.floor(t3.minzoom) || t3.maxzoom && this.zoom >= t3.maxzoom || "none" !== t3.visibility && (l(e2, this.zoom, d2.brightness, o2), (h2[t3.id] = t3.createBucket({ index: c2.bucketLayerIDs.length, layers: e2, zoom: this.zoom, lut: this.lut, canonical: this.canonical, pixelRatio: this.pixelRatio, overscaling: this.overscaling, collisionBoxArray: this.collisionBoxArray, sourceLayerIndex: p3, sourceID: this.source, projection: this.projection.spec, tessellationStep: this.tessellationStep })).populate(g3, d2, this.tileID.canonical, this.tileTransform), c2.bucketLayerIDs.push(e2.map((e3) => e3.id))));
              }
            }
            let p2, g2, m2, y2;
            u2.trim();
            const x2 = { type: "maybePrepare", isSymbolTile: this.isSymbolTile, zoom: this.zoom }, w2 = () => {
              if (p2)
                return this.status = "done", n2(p2);
              if (this.extraShadowCaster)
                this.status = "done", n2(null, { buckets: e.dJ(h2).filter((e2) => !e2.isEmpty()), featureIndex: c2, collisionBoxArray: null, glyphAtlasImage: null, lineAtlas: null, imageAtlas: null, brightness: d2.brightness, glyphMap: null, iconMap: null, glyphPositions: null });
              else if (g2 && m2 && y2) {
                const t3 = new r(g2), s3 = new e.dT(m2, y2, this.lut);
                for (const i3 in h2) {
                  const n3 = h2[i3];
                  n3 instanceof e.dU ? (l(n3.layers, this.zoom, d2.brightness, o2), e.dV(n3, g2, t3.positions, m2, s3.iconPositions, this.showCollisionBoxes, o2, this.tileID.canonical, this.tileZoom, this.projection, this.brightness)) : n3.hasPattern && (n3 instanceof e.dW || n3 instanceof e.dX || n3 instanceof e.c0) && (l(n3.layers, this.zoom, d2.brightness, o2), n3.addFeatures(d2, this.tileID.canonical, s3.patternPositions, o2, this.tileTransform, this.brightness));
                }
                this.status = "done", n2(null, { buckets: e.dJ(h2).filter((e2) => !e2.isEmpty()), featureIndex: c2, collisionBoxArray: this.collisionBoxArray, glyphAtlasImage: t3.image, lineAtlas: u2, imageAtlas: s3, brightness: d2.brightness });
              }
            };
            if (!this.extraShadowCaster) {
              const t3 = e.dS(d2.glyphDependencies, (e2) => Object.keys(e2).map(Number));
              Object.keys(t3).length ? i2.send("getGlyphs", { uid: this.uid, stacks: t3, scope: this.scope }, (e2, t4) => {
                p2 || (p2 = e2, g2 = t4, w2());
              }, void 0, false, x2) : g2 = {};
              const s3 = Object.keys(d2.iconDependencies);
              s3.length ? i2.send("getImages", { icons: s3, source: this.source, scope: this.scope, tileID: this.tileID, type: "icons" }, (e2, t4) => {
                p2 || (p2 = e2, m2 = t4, w2());
              }, void 0, false, x2) : m2 = {};
              const o3 = Object.keys(d2.patternDependencies);
              o3.length ? i2.send("getImages", { icons: o3, source: this.source, scope: this.scope, tileID: this.tileID, type: "patterns" }, (e2, t4) => {
                p2 || (p2 = e2, y2 = t4, w2());
              }, void 0, false, x2) : y2 = {};
            }
            w2();
          }
        }
        function l(t2, s2, o2, i2) {
          const n2 = new e.Y(s2, { brightness: o2 });
          for (const e2 of t2)
            e2.recalculate(n2, i2);
        }
        class c extends e.E {
          constructor(t2, s2, o2, i2, n2, r2) {
            super(), this.actor = t2, this.layerIndex = s2, this.availableImages = o2, this.loadVectorData = n2 || e.aq, this.loading = {}, this.loaded = {}, this.deduped = new e.ap(t2.scheduler), this.isSpriteLoaded = i2, this.scheduler = t2.scheduler, this.brightness = r2;
          }
          loadTile(s2, o2) {
            const i2 = s2.uid, n2 = s2 && s2.request, r2 = n2 && n2.collectResourceTiming, l2 = this.loading[i2] = new a(s2);
            l2.abort = this.loadVectorData(s2, (a2, c2) => {
              const h2 = !this.loading[i2];
              if (delete this.loading[i2], h2 || a2 || !c2)
                return l2.status = "done", h2 || (this.loaded[i2] = l2), o2(a2);
              const u2 = c2.rawData, d2 = {};
              c2.expires && (d2.expires = c2.expires), c2.cacheControl && (d2.cacheControl = c2.cacheControl), l2.vectorTile = c2.vectorTile || new e.dY(new e.dZ(u2));
              const f2 = () => {
                l2.parse(l2.vectorTile, this.layerIndex, this.availableImages, this.actor, (s3, i3) => {
                  if (s3 || !i3)
                    return o2(s3);
                  const a3 = {};
                  if (r2) {
                    const e2 = t(n2);
                    e2.length > 0 && (a3.resourceTiming = JSON.parse(JSON.stringify(e2)));
                  }
                  o2(null, e.Q({ rawTileData: u2.slice(0) }, i3, d2, a3));
                });
              };
              this.isSpriteLoaded ? f2() : this.once("isSpriteLoaded", () => {
                this.scheduler ? this.scheduler.add(f2, { type: "parseTile", isSymbolTile: s2.isSymbolTile, zoom: s2.tileZoom }) : f2();
              }), this.loaded = this.loaded || {}, this.loaded[i2] = l2;
            });
          }
          reloadTile(t2, s2) {
            const o2 = this.loaded, i2 = t2.uid;
            if (o2 && o2[i2]) {
              const n2 = o2[i2];
              n2.showCollisionBoxes = t2.showCollisionBoxes, n2.projection = t2.projection, n2.brightness = t2.brightness, n2.tileTransform = e.dN(t2.tileID.canonical, t2.projection), n2.extraShadowCaster = t2.extraShadowCaster, n2.lut = t2.lut;
              const r2 = (e2, t3) => {
                const o3 = n2.reloadCallback;
                o3 && (delete n2.reloadCallback, n2.parse(n2.vectorTile, this.layerIndex, this.availableImages, this.actor, o3)), s2(e2, t3);
              };
              "parsing" === n2.status ? n2.reloadCallback = r2 : "done" === n2.status && (n2.vectorTile ? n2.parse(n2.vectorTile, this.layerIndex, this.availableImages, this.actor, r2) : r2());
            } else
              s2(null, void 0);
          }
          abortTile(e2, t2) {
            const s2 = e2.uid, o2 = this.loading[s2];
            o2 && (o2.abort && o2.abort(), delete this.loading[s2]), t2();
          }
          removeTile(e2, t2) {
            const s2 = this.loaded, o2 = e2.uid;
            s2 && s2[o2] && delete s2[o2], t2();
          }
        }
        class h {
          loadTile(t2, s2) {
            const { uid: o2, encoding: i2, rawImageData: n2, padding: r2 } = t2, a2 = ImageBitmap && n2 instanceof ImageBitmap ? this.getImageData(n2, r2) : n2;
            s2(null, new e.d_(o2, a2, i2, r2 < 1));
          }
          getImageData(e2, t2) {
            this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e2.width, e2.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", { willReadFrequently: true })), this.offscreenCanvas.width = e2.width, this.offscreenCanvas.height = e2.height, this.offscreenCanvasContext.drawImage(e2, 0, 0, e2.width, e2.height);
            const s2 = this.offscreenCanvasContext.getImageData(-t2, -t2, e2.width + 2 * t2, e2.height + 2 * t2);
            return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), s2;
          }
        }
        e.d$.setPbf(e.dZ);
        class u {
          decodeRasterArray({ task: t2, buffer: s2 }, o2) {
            e.d$.performDecoding(s2, t2).then((e2) => {
              o2(null, e2);
            }, (e2) => {
              o2(e2);
            });
          }
        }
        const d = e.e0.prototype.toGeoJSON;
        let f = class {
          constructor(t2) {
            this._feature = t2, this.extent = e.a4, this.type = t2.type, this.properties = t2.tags, "id" in t2 && !isNaN(t2.id) && (this.id = parseInt(t2.id, 10));
          }
          loadGeometry() {
            if (1 === this._feature.type) {
              const t2 = [];
              for (const s2 of this._feature.geometry)
                t2.push([new e.P(s2[0], s2[1])]);
              return t2;
            }
            {
              const t2 = [];
              for (const s2 of this._feature.geometry) {
                const o2 = [];
                for (const t3 of s2)
                  o2.push(new e.P(t3[0], t3[1]));
                t2.push(o2);
              }
              return t2;
            }
          }
          toGeoJSON(e2, t2, s2) {
            return d.call(this, e2, t2, s2);
          }
        }, p = class {
          constructor(t2) {
            this.layers = { _geojsonTileLayer: this }, this.name = "_geojsonTileLayer", this.extent = e.a4, this.length = t2.length, this._features = t2;
          }
          feature(e2) {
            return new f(this._features[e2]);
          }
        };
        const g = 64 / 4096, m = 128;
        class y {
          constructor() {
            this.features = /* @__PURE__ */ new Map();
          }
          clear() {
            this.features.clear();
          }
          load(e2 = [], t2) {
            for (const s2 of e2) {
              const e3 = s2.id;
              if (null == e3)
                continue;
              let o2 = this.features.get(e3);
              o2 && this.updateCache(o2, t2), s2.geometry ? (o2 = w(s2), this.updateCache(o2, t2), this.features.set(e3, o2)) : this.features.delete(e3), this.updateCache(o2, t2);
            }
          }
          updateCache(e2, t2) {
            for (const { canonical: s2, uid: o2 } of Object.values(t2)) {
              const { z: i2, x: n2, y: r2 } = s2;
              x(e2, Math.pow(2, i2), n2, r2) && delete t2[o2];
            }
          }
          getTile(e2, t2, s2) {
            const o2 = Math.pow(2, e2), i2 = [];
            for (const e3 of this.features.values())
              x(e3, o2, t2, s2) && i2.push(I(e3, o2, t2, s2));
            return { features: i2 };
          }
          getFeatures() {
            return [...this.features.values()];
          }
        }
        function x({ minX: e2, minY: t2, maxX: s2, maxY: o2 }, i2, n2, r2) {
          return e2 < (n2 + 1 + g) / i2 && t2 < (r2 + 1 + g) / i2 && s2 > (n2 - g) / i2 && o2 > (r2 - g) / i2;
        }
        function w(e2) {
          const { id: t2, geometry: s2, properties: o2 } = e2;
          if (!s2)
            return;
          if ("GeometryCollection" === s2.type)
            throw new Error("GeometryCollection not supported in dynamic mode.");
          const { type: i2, coordinates: n2 } = s2, r2 = { id: t2, type: 1, geometry: [], tags: o2, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 }, a2 = r2.geometry;
          if ("Point" === i2)
            S(n2, a2, r2);
          else if ("MultiPoint" === i2)
            for (const e3 of n2)
              S(e3, a2, r2);
          else if ("LineString" === i2)
            r2.type = 2, b(n2, a2, r2);
          else if ("MultiLineString" === i2)
            r2.type = 2, v(n2, a2, r2);
          else if ("Polygon" === i2)
            r2.type = 3, v(n2, a2, r2, true);
          else {
            if ("MultiPolygon" !== i2)
              throw new Error("Input data is not a valid GeoJSON object.");
            r2.type = 3;
            for (const e3 of n2)
              v(e3, a2, r2, true);
          }
          return r2;
        }
        function S([t2, s2], o2, i2) {
          const n2 = e.ak(t2);
          let r2 = e.al(s2);
          r2 = r2 < 0 ? 0 : r2 > 1 ? 1 : r2, o2.push(n2, r2), i2.minX = Math.min(i2.minX, n2), i2.minY = Math.min(i2.minY, r2), i2.maxX = Math.max(i2.maxX, n2), i2.maxY = Math.max(i2.maxY, r2);
        }
        function b(e2, t2, s2, o2 = false, i2 = false) {
          const n2 = [];
          for (const t3 of e2)
            S(t3, n2, s2);
          t2.push(n2), o2 && function(e3, t3) {
            let s3 = 0;
            for (let t4 = 0, o3 = e3.length, i3 = o3 - 2; t4 < o3; i3 = t4, t4 += 2)
              s3 += (e3[t4] - e3[i3]) * (e3[t4 + 1] + e3[i3 + 1]);
            if (s3 > 0 === t3)
              for (let t4 = 0, s4 = e3.length; t4 < s4 / 2; t4 += 2) {
                const o3 = e3[t4], i3 = e3[t4 + 1];
                e3[t4] = e3[s4 - 2 - t4], e3[t4 + 1] = e3[s4 - 1 - t4], e3[s4 - 2 - t4] = o3, e3[s4 - 1 - t4] = i3;
              }
          }(n2, i2);
        }
        function v(e2, t2, s2, o2 = false) {
          for (let i2 = 0; i2 < e2.length; i2++)
            b(e2[i2], t2, s2, o2, 0 === i2);
        }
        function I(t2, s2, o2, i2) {
          const { id: n2, type: r2, geometry: a2, tags: l2 } = t2, c2 = [];
          if (1 === r2)
            !function(t3, s3, o3, i3, n3) {
              for (let r3 = 0; r3 < t3.length; r3 += 2) {
                const a3 = Math.round(e.a4 * (t3[r3 + 0] * s3 - o3)), l3 = Math.round(e.a4 * (t3[r3 + 1] * s3 - i3));
                n3.push([a3, l3]);
              }
            }(a2, s2, o2, i2, c2);
          else
            for (const e2 of a2)
              M(e2, s2, o2, i2, c2);
          return { id: n2, type: r2, geometry: c2, tags: l2 };
        }
        function M(t2, s2, o2, i2, n2) {
          const r2 = -m, a2 = e.a4 + m;
          let l2;
          for (let c2 = 0; c2 < t2.length - 2; c2 += 2) {
            let h2 = Math.round(e.a4 * (t2[c2 + 0] * s2 - o2)), u2 = Math.round(e.a4 * (t2[c2 + 1] * s2 - i2)), d2 = Math.round(e.a4 * (t2[c2 + 2] * s2 - o2)), f2 = Math.round(e.a4 * (t2[c2 + 3] * s2 - i2));
            const p2 = d2 - h2, g2 = f2 - u2;
            h2 < r2 && d2 < r2 || (h2 < r2 ? (u2 += Math.round(g2 * ((r2 - h2) / p2)), h2 = r2) : d2 < r2 && (f2 = u2 + Math.round(g2 * ((r2 - h2) / p2)), d2 = r2), u2 < r2 && f2 < r2 || (u2 < r2 ? (h2 += Math.round(p2 * ((r2 - u2) / g2)), u2 = r2) : f2 < r2 && (d2 = h2 + Math.round(p2 * ((r2 - u2) / g2)), f2 = r2), h2 >= a2 && d2 >= a2 || (h2 >= a2 ? (u2 += Math.round(g2 * ((a2 - h2) / p2)), h2 = a2) : d2 >= a2 && (f2 = u2 + Math.round(g2 * ((a2 - h2) / p2)), d2 = a2), u2 >= a2 && f2 >= a2 || (u2 >= a2 ? (h2 += Math.round(p2 * ((a2 - u2) / g2)), u2 = a2) : f2 >= a2 && (d2 = h2 + Math.round(p2 * ((a2 - u2) / g2)), f2 = a2), l2 && h2 === l2[l2.length - 1][0] && u2 === l2[l2.length - 1][1] || (l2 = [[h2, u2]], n2.push(l2)), l2.push([d2, f2])))));
          }
        }
        var k = { exports: {} }, T = e.e2, P = e.e1.VectorTileFeature, C = _;
        function _(e2, t2) {
          this.options = t2 || {}, this.features = e2, this.length = e2.length;
        }
        function L(e2, t2) {
          this.id = "number" == typeof e2.id ? e2.id : void 0, this.type = e2.type, this.rawGeometry = 1 === e2.type ? [e2.geometry] : e2.geometry, this.properties = e2.tags, this.extent = t2 || 4096;
        }
        _.prototype.feature = function(e2) {
          return new L(this.features[e2], this.options.extent);
        }, L.prototype.loadGeometry = function() {
          var e2 = this.rawGeometry;
          this.geometry = [];
          for (var t2 = 0; t2 < e2.length; t2++) {
            for (var s2 = e2[t2], o2 = [], i2 = 0; i2 < s2.length; i2++)
              o2.push(new T(s2[i2][0], s2[i2][1]));
            this.geometry.push(o2);
          }
          return this.geometry;
        }, L.prototype.bbox = function() {
          this.geometry || this.loadGeometry();
          for (var e2 = this.geometry, t2 = 1 / 0, s2 = -1 / 0, o2 = 1 / 0, i2 = -1 / 0, n2 = 0; n2 < e2.length; n2++)
            for (var r2 = e2[n2], a2 = 0; a2 < r2.length; a2++) {
              var l2 = r2[a2];
              t2 = Math.min(t2, l2.x), s2 = Math.max(s2, l2.x), o2 = Math.min(o2, l2.y), i2 = Math.max(i2, l2.y);
            }
          return [t2, o2, s2, i2];
        }, L.prototype.toGeoJSON = P.prototype.toGeoJSON;
        var D = e.e3, j = C;
        function O(e2) {
          var t2 = new D();
          return function(e3, t3) {
            for (var s2 in e3.layers)
              t3.writeMessage(3, z, e3.layers[s2]);
          }(e2, t2), t2.finish();
        }
        function z(e2, t2) {
          var s2;
          t2.writeVarintField(15, e2.version || 1), t2.writeStringField(1, e2.name || ""), t2.writeVarintField(5, e2.extent || 4096);
          var o2 = { keys: [], values: [], keycache: {}, valuecache: {} };
          for (s2 = 0; s2 < e2.length; s2++)
            o2.feature = e2.feature(s2), t2.writeMessage(2, Z, o2);
          var i2 = o2.keys;
          for (s2 = 0; s2 < i2.length; s2++)
            t2.writeStringField(3, i2[s2]);
          var n2 = o2.values;
          for (s2 = 0; s2 < n2.length; s2++)
            t2.writeMessage(4, F, n2[s2]);
        }
        function Z(e2, t2) {
          var s2 = e2.feature;
          void 0 !== s2.id && t2.writeVarintField(1, s2.id), t2.writeMessage(2, A, e2), t2.writeVarintField(3, s2.type), t2.writeMessage(4, Y, s2);
        }
        function A(e2, t2) {
          var s2 = e2.feature, o2 = e2.keys, i2 = e2.values, n2 = e2.keycache, r2 = e2.valuecache;
          for (var a2 in s2.properties) {
            var l2 = s2.properties[a2], c2 = n2[a2];
            if (null !== l2) {
              void 0 === c2 && (o2.push(a2), n2[a2] = c2 = o2.length - 1), t2.writeVarint(c2);
              var h2 = typeof l2;
              "string" !== h2 && "boolean" !== h2 && "number" !== h2 && (l2 = JSON.stringify(l2));
              var u2 = h2 + ":" + l2, d2 = r2[u2];
              void 0 === d2 && (i2.push(l2), r2[u2] = d2 = i2.length - 1), t2.writeVarint(d2);
            }
          }
        }
        function E(e2, t2) {
          return (t2 << 3) + (7 & e2);
        }
        function N(e2) {
          return e2 << 1 ^ e2 >> 31;
        }
        function Y(e2, t2) {
          for (var s2 = e2.loadGeometry(), o2 = e2.type, i2 = 0, n2 = 0, r2 = s2.length, a2 = 0; a2 < r2; a2++) {
            var l2 = s2[a2], c2 = 1;
            1 === o2 && (c2 = l2.length), t2.writeVarint(E(1, c2));
            for (var h2 = 3 === o2 ? l2.length - 1 : l2.length, u2 = 0; u2 < h2; u2++) {
              1 === u2 && 1 !== o2 && t2.writeVarint(E(2, h2 - 1));
              var d2 = l2[u2].x - i2, f2 = l2[u2].y - n2;
              t2.writeVarint(N(d2)), t2.writeVarint(N(f2)), i2 += d2, n2 += f2;
            }
            3 === o2 && t2.writeVarint(E(7, 1));
          }
        }
        function F(e2, t2) {
          var s2 = typeof e2;
          "string" === s2 ? t2.writeStringField(1, e2) : "boolean" === s2 ? t2.writeBooleanField(7, e2) : "number" === s2 && (e2 % 1 != 0 ? t2.writeDoubleField(3, e2) : e2 < 0 ? t2.writeSVarintField(6, e2) : t2.writeVarintField(5, e2));
        }
        k.exports = O, k.exports.fromVectorTileJs = O, k.exports.fromGeojsonVt = function(e2, t2) {
          t2 = t2 || {};
          var s2 = {};
          for (var o2 in e2)
            s2[o2] = new j(e2[o2].features, t2), s2[o2].name = o2, s2[o2].version = t2.version, s2[o2].extent = t2.extent;
          return O({ layers: s2 });
        }, k.exports.GeoJSONWrapper = j;
        var X = e.e4(k.exports);
        const J = { minZoom: 0, maxZoom: 16, minPoints: 2, radius: 40, extent: 512, nodeSize: 64, log: false, generateId: false, reduce: null, map: (e2) => e2 }, G = Math.fround || (W = new Float32Array(1), (e2) => (W[0] = +e2, W[0]));
        var W;
        const B = 3, R = 5, V = 6;
        class $ {
          constructor(e2) {
            this.options = Object.assign(Object.create(J), e2), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
          }
          load(e2) {
            const { log: t2, minZoom: s2, maxZoom: o2 } = this.options;
            t2 && console.time("total time");
            const i2 = `prepare ${e2.length} points`;
            t2 && console.time(i2), this.points = e2;
            const n2 = [];
            for (let t3 = 0; t3 < e2.length; t3++) {
              const s3 = e2[t3];
              if (!s3.geometry)
                continue;
              const [o3, i3] = s3.geometry.coordinates, r3 = G(Q(o3)), a2 = G(K(i3));
              n2.push(r3, a2, 1 / 0, t3, -1, 1), this.options.reduce && n2.push(0);
            }
            let r2 = this.trees[o2 + 1] = this._createTree(n2);
            t2 && console.timeEnd(i2);
            for (let e3 = o2; e3 >= s2; e3--) {
              const s3 = +Date.now();
              r2 = this.trees[e3] = this._createTree(this._cluster(r2, e3)), t2 && console.log("z%d: %d clusters in %dms", e3, r2.numItems, +Date.now() - s3);
            }
            return t2 && console.timeEnd("total time"), this;
          }
          getClusters(e2, t2) {
            let s2 = ((e2[0] + 180) % 360 + 360) % 360 - 180;
            const o2 = Math.max(-90, Math.min(90, e2[1]));
            let i2 = 180 === e2[2] ? 180 : ((e2[2] + 180) % 360 + 360) % 360 - 180;
            const n2 = Math.max(-90, Math.min(90, e2[3]));
            if (e2[2] - e2[0] >= 360)
              s2 = -180, i2 = 180;
            else if (s2 > i2) {
              const e3 = this.getClusters([s2, o2, 180, n2], t2), r3 = this.getClusters([-180, o2, i2, n2], t2);
              return e3.concat(r3);
            }
            const r2 = this.trees[this._limitZoom(t2)], a2 = r2.range(Q(s2), K(n2), Q(i2), K(o2)), l2 = r2.data, c2 = [];
            for (const e3 of a2) {
              const t3 = this.stride * e3;
              c2.push(l2[t3 + R] > 1 ? q(l2, t3, this.clusterProps) : this.points[l2[t3 + B]]);
            }
            return c2;
          }
          getChildren(e2) {
            const t2 = this._getOriginId(e2), s2 = this._getOriginZoom(e2), o2 = "No cluster with the specified id.", i2 = this.trees[s2];
            if (!i2)
              throw new Error(o2);
            const n2 = i2.data;
            if (t2 * this.stride >= n2.length)
              throw new Error(o2);
            const r2 = this.options.radius / (this.options.extent * Math.pow(2, s2 - 1)), a2 = i2.within(n2[t2 * this.stride], n2[t2 * this.stride + 1], r2), l2 = [];
            for (const t3 of a2) {
              const s3 = t3 * this.stride;
              n2[s3 + 4] === e2 && l2.push(n2[s3 + R] > 1 ? q(n2, s3, this.clusterProps) : this.points[n2[s3 + B]]);
            }
            if (0 === l2.length)
              throw new Error(o2);
            return l2;
          }
          getLeaves(e2, t2, s2) {
            const o2 = [];
            return this._appendLeaves(o2, e2, t2 = t2 || 10, s2 = s2 || 0, 0), o2;
          }
          getTile(e2, t2, s2) {
            const o2 = this.trees[this._limitZoom(e2)], i2 = Math.pow(2, e2), { extent: n2, radius: r2 } = this.options, a2 = r2 / n2, l2 = (s2 - a2) / i2, c2 = (s2 + 1 + a2) / i2, h2 = { features: [] };
            return this._addTileFeatures(o2.range((t2 - a2) / i2, l2, (t2 + 1 + a2) / i2, c2), o2.data, t2, s2, i2, h2), 0 === t2 && this._addTileFeatures(o2.range(1 - a2 / i2, l2, 1, c2), o2.data, i2, s2, i2, h2), t2 === i2 - 1 && this._addTileFeatures(o2.range(0, l2, a2 / i2, c2), o2.data, -1, s2, i2, h2), h2.features.length ? h2 : null;
          }
          getClusterExpansionZoom(e2) {
            let t2 = this._getOriginZoom(e2) - 1;
            for (; t2 <= this.options.maxZoom; ) {
              const s2 = this.getChildren(e2);
              if (t2++, 1 !== s2.length)
                break;
              e2 = s2[0].properties.cluster_id;
            }
            return t2;
          }
          _appendLeaves(e2, t2, s2, o2, i2) {
            const n2 = this.getChildren(t2);
            for (const t3 of n2) {
              const n3 = t3.properties;
              if (n3 && n3.cluster ? i2 + n3.point_count <= o2 ? i2 += n3.point_count : i2 = this._appendLeaves(e2, n3.cluster_id, s2, o2, i2) : i2 < o2 ? i2++ : e2.push(t3), e2.length === s2)
                break;
            }
            return i2;
          }
          _createTree(t2) {
            const s2 = new e.cN(t2.length / this.stride | 0, this.options.nodeSize, Float32Array);
            for (let e2 = 0; e2 < t2.length; e2 += this.stride)
              s2.add(t2[e2], t2[e2 + 1]);
            return s2.finish(), s2.data = t2, s2;
          }
          _addTileFeatures(e2, t2, s2, o2, i2, n2) {
            for (const r2 of e2) {
              const e3 = r2 * this.stride, a2 = t2[e3 + R] > 1;
              let l2, c2, h2;
              if (a2)
                l2 = U(t2, e3, this.clusterProps), c2 = t2[e3], h2 = t2[e3 + 1];
              else {
                const s3 = this.points[t2[e3 + B]];
                l2 = s3.properties;
                const [o3, i3] = s3.geometry.coordinates;
                c2 = Q(o3), h2 = K(i3);
              }
              const u2 = { type: 1, geometry: [[Math.round(this.options.extent * (c2 * i2 - s2)), Math.round(this.options.extent * (h2 * i2 - o2))]], tags: l2 };
              let d2;
              d2 = a2 || this.options.generateId ? t2[e3 + B] : this.points[t2[e3 + B]].id, void 0 !== d2 && (u2.id = d2), n2.features.push(u2);
            }
          }
          _limitZoom(e2) {
            return Math.max(this.options.minZoom, Math.min(Math.floor(+e2), this.options.maxZoom + 1));
          }
          _cluster(e2, t2) {
            const { radius: s2, extent: o2, reduce: i2, minPoints: n2 } = this.options, r2 = s2 / (o2 * Math.pow(2, t2)), a2 = e2.data, l2 = [], c2 = this.stride;
            for (let s3 = 0; s3 < a2.length; s3 += c2) {
              if (a2[s3 + 2] <= t2)
                continue;
              a2[s3 + 2] = t2;
              const o3 = a2[s3], h2 = a2[s3 + 1], u2 = e2.within(a2[s3], a2[s3 + 1], r2), d2 = a2[s3 + R];
              let f2 = d2;
              for (const e3 of u2) {
                const s4 = e3 * c2;
                a2[s4 + 2] > t2 && (f2 += a2[s4 + R]);
              }
              if (f2 > d2 && f2 >= n2) {
                let e3, n3 = o3 * d2, r3 = h2 * d2, p2 = -1;
                const g2 = (s3 / c2 << 5) + (t2 + 1) + this.points.length;
                for (const o4 of u2) {
                  const l3 = o4 * c2;
                  if (a2[l3 + 2] <= t2)
                    continue;
                  a2[l3 + 2] = t2;
                  const h3 = a2[l3 + R];
                  n3 += a2[l3] * h3, r3 += a2[l3 + 1] * h3, a2[l3 + 4] = g2, i2 && (e3 || (e3 = this._map(a2, s3, true), p2 = this.clusterProps.length, this.clusterProps.push(e3)), i2(e3, this._map(a2, l3)));
                }
                a2[s3 + 4] = g2, l2.push(n3 / f2, r3 / f2, 1 / 0, g2, -1, f2), i2 && l2.push(p2);
              } else {
                for (let e3 = 0; e3 < c2; e3++)
                  l2.push(a2[s3 + e3]);
                if (f2 > 1)
                  for (const e3 of u2) {
                    const s4 = e3 * c2;
                    if (!(a2[s4 + 2] <= t2)) {
                      a2[s4 + 2] = t2;
                      for (let e4 = 0; e4 < c2; e4++)
                        l2.push(a2[s4 + e4]);
                    }
                  }
              }
            }
            return l2;
          }
          _getOriginId(e2) {
            return e2 - this.points.length >> 5;
          }
          _getOriginZoom(e2) {
            return (e2 - this.points.length) % 32;
          }
          _map(e2, t2, s2) {
            if (e2[t2 + R] > 1) {
              const o3 = this.clusterProps[e2[t2 + V]];
              return s2 ? Object.assign({}, o3) : o3;
            }
            const o2 = this.points[e2[t2 + B]].properties, i2 = this.options.map(o2);
            return s2 && i2 === o2 ? Object.assign({}, i2) : i2;
          }
        }
        function q(e2, t2, s2) {
          return { type: "Feature", id: e2[t2 + B], properties: U(e2, t2, s2), geometry: { type: "Point", coordinates: [(o2 = e2[t2], 360 * (o2 - 0.5)), H(e2[t2 + 1])] } };
          var o2;
        }
        function U(e2, t2, s2) {
          const o2 = e2[t2 + R], i2 = o2 >= 1e4 ? `${Math.round(o2 / 1e3)}k` : o2 >= 1e3 ? Math.round(o2 / 100) / 10 + "k" : o2, n2 = e2[t2 + V], r2 = -1 === n2 ? {} : Object.assign({}, s2[n2]);
          return Object.assign(r2, { cluster: true, cluster_id: e2[t2 + B], point_count: o2, point_count_abbreviated: i2 });
        }
        function Q(e2) {
          return e2 / 360 + 0.5;
        }
        function K(e2) {
          const t2 = Math.sin(e2 * Math.PI / 180), s2 = 0.5 - 0.25 * Math.log((1 + t2) / (1 - t2)) / Math.PI;
          return s2 < 0 ? 0 : s2 > 1 ? 1 : s2;
        }
        function H(e2) {
          const t2 = (180 - 360 * e2) * Math.PI / 180;
          return 360 * Math.atan(Math.exp(t2)) / Math.PI - 90;
        }
        function ee(e2, t2, s2, o2) {
          let i2 = o2;
          const n2 = t2 + (s2 - t2 >> 1);
          let r2, a2 = s2 - t2;
          const l2 = e2[t2], c2 = e2[t2 + 1], h2 = e2[s2], u2 = e2[s2 + 1];
          for (let o3 = t2 + 3; o3 < s2; o3 += 3) {
            const t3 = te(e2[o3], e2[o3 + 1], l2, c2, h2, u2);
            if (t3 > i2)
              r2 = o3, i2 = t3;
            else if (t3 === i2) {
              const e3 = Math.abs(o3 - n2);
              e3 < a2 && (r2 = o3, a2 = e3);
            }
          }
          i2 > o2 && (r2 - t2 > 3 && ee(e2, t2, r2, o2), e2[r2 + 2] = i2, s2 - r2 > 3 && ee(e2, r2, s2, o2));
        }
        function te(e2, t2, s2, o2, i2, n2) {
          let r2 = i2 - s2, a2 = n2 - o2;
          if (0 !== r2 || 0 !== a2) {
            const l2 = ((e2 - s2) * r2 + (t2 - o2) * a2) / (r2 * r2 + a2 * a2);
            l2 > 1 ? (s2 = i2, o2 = n2) : l2 > 0 && (s2 += r2 * l2, o2 += a2 * l2);
          }
          return r2 = e2 - s2, a2 = t2 - o2, r2 * r2 + a2 * a2;
        }
        function se(e2, t2, s2, o2) {
          const i2 = { id: e2 != null ? e2 : null, type: t2, geometry: s2, tags: o2, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 };
          if ("Point" === t2 || "MultiPoint" === t2 || "LineString" === t2)
            oe(i2, s2);
          else if ("Polygon" === t2)
            oe(i2, s2[0]);
          else if ("MultiLineString" === t2)
            for (const e3 of s2)
              oe(i2, e3);
          else if ("MultiPolygon" === t2)
            for (const e3 of s2)
              oe(i2, e3[0]);
          return i2;
        }
        function oe(e2, t2) {
          for (let s2 = 0; s2 < t2.length; s2 += 3)
            e2.minX = Math.min(e2.minX, t2[s2]), e2.minY = Math.min(e2.minY, t2[s2 + 1]), e2.maxX = Math.max(e2.maxX, t2[s2]), e2.maxY = Math.max(e2.maxY, t2[s2 + 1]);
        }
        function ie(e2, t2, s2, o2) {
          if (!t2.geometry)
            return;
          const i2 = t2.geometry.coordinates;
          if (i2 && 0 === i2.length)
            return;
          const n2 = t2.geometry.type, r2 = Math.pow(s2.tolerance / ((1 << s2.maxZoom) * s2.extent), 2);
          let a2 = [], l2 = t2.id;
          if (s2.promoteId ? l2 = t2.properties[s2.promoteId] : s2.generateId && (l2 = o2 || 0), "Point" === n2)
            ne(i2, a2);
          else if ("MultiPoint" === n2)
            for (const e3 of i2)
              ne(e3, a2);
          else if ("LineString" === n2)
            re(i2, a2, r2, false);
          else if ("MultiLineString" === n2) {
            if (s2.lineMetrics) {
              for (const s3 of i2)
                a2 = [], re(s3, a2, r2, false), e2.push(se(l2, "LineString", a2, t2.properties));
              return;
            }
            ae(i2, a2, r2, false);
          } else if ("Polygon" === n2)
            ae(i2, a2, r2, true);
          else {
            if ("MultiPolygon" !== n2) {
              if ("GeometryCollection" === n2) {
                for (const i3 of t2.geometry.geometries)
                  ie(e2, { id: l2, geometry: i3, properties: t2.properties }, s2, o2);
                return;
              }
              throw new Error("Input data is not a valid GeoJSON object.");
            }
            for (const e3 of i2) {
              const t3 = [];
              ae(e3, t3, r2, true), a2.push(t3);
            }
          }
          e2.push(se(l2, n2, a2, t2.properties));
        }
        function ne(e2, t2) {
          t2.push(le(e2[0]), ce(e2[1]), 0);
        }
        function re(e2, t2, s2, o2) {
          let i2, n2, r2 = 0;
          for (let s3 = 0; s3 < e2.length; s3++) {
            const a3 = le(e2[s3][0]), l2 = ce(e2[s3][1]);
            t2.push(a3, l2, 0), s3 > 0 && (r2 += o2 ? (i2 * l2 - a3 * n2) / 2 : Math.sqrt(Math.pow(a3 - i2, 2) + Math.pow(l2 - n2, 2))), i2 = a3, n2 = l2;
          }
          const a2 = t2.length - 3;
          t2[2] = 1, ee(t2, 0, a2, s2), t2[a2 + 2] = 1, t2.size = Math.abs(r2), t2.start = 0, t2.end = t2.size;
        }
        function ae(e2, t2, s2, o2) {
          for (let i2 = 0; i2 < e2.length; i2++) {
            const n2 = [];
            re(e2[i2], n2, s2, o2), t2.push(n2);
          }
        }
        function le(e2) {
          return e2 / 360 + 0.5;
        }
        function ce(e2) {
          const t2 = Math.sin(e2 * Math.PI / 180), s2 = 0.5 - 0.25 * Math.log((1 + t2) / (1 - t2)) / Math.PI;
          return s2 < 0 ? 0 : s2 > 1 ? 1 : s2;
        }
        function he(e2, t2, s2, o2, i2, n2, r2, a2) {
          if (o2 /= t2, n2 >= (s2 /= t2) && r2 < o2)
            return e2;
          if (r2 < s2 || n2 >= o2)
            return null;
          const l2 = [];
          for (const t3 of e2) {
            const e3 = t3.geometry;
            let n3 = t3.type;
            const r3 = 0 === i2 ? t3.minX : t3.minY, c2 = 0 === i2 ? t3.maxX : t3.maxY;
            if (r3 >= s2 && c2 < o2) {
              l2.push(t3);
              continue;
            }
            if (c2 < s2 || r3 >= o2)
              continue;
            let h2 = [];
            if ("Point" === n3 || "MultiPoint" === n3)
              ue(e3, h2, s2, o2, i2);
            else if ("LineString" === n3)
              de(e3, h2, s2, o2, i2, false, a2.lineMetrics);
            else if ("MultiLineString" === n3)
              pe(e3, h2, s2, o2, i2, false);
            else if ("Polygon" === n3)
              pe(e3, h2, s2, o2, i2, true);
            else if ("MultiPolygon" === n3)
              for (const t4 of e3) {
                const e4 = [];
                pe(t4, e4, s2, o2, i2, true), e4.length && h2.push(e4);
              }
            if (h2.length) {
              if (a2.lineMetrics && "LineString" === n3) {
                for (const e4 of h2)
                  l2.push(se(t3.id, n3, e4, t3.tags));
                continue;
              }
              "LineString" !== n3 && "MultiLineString" !== n3 || (1 === h2.length ? (n3 = "LineString", h2 = h2[0]) : n3 = "MultiLineString"), "Point" !== n3 && "MultiPoint" !== n3 || (n3 = 3 === h2.length ? "Point" : "MultiPoint"), l2.push(se(t3.id, n3, h2, t3.tags));
            }
          }
          return l2.length ? l2 : null;
        }
        function ue(e2, t2, s2, o2, i2) {
          for (let n2 = 0; n2 < e2.length; n2 += 3) {
            const r2 = e2[n2 + i2];
            r2 >= s2 && r2 <= o2 && ge(t2, e2[n2], e2[n2 + 1], e2[n2 + 2]);
          }
        }
        function de(e2, t2, s2, o2, i2, n2, r2) {
          let a2 = fe(e2);
          const l2 = 0 === i2 ? me : ye;
          let c2, h2, u2 = e2.start;
          for (let d3 = 0; d3 < e2.length - 3; d3 += 3) {
            const f3 = e2[d3], p3 = e2[d3 + 1], g3 = e2[d3 + 2], m2 = e2[d3 + 3], y2 = e2[d3 + 4], x2 = 0 === i2 ? f3 : p3, w2 = 0 === i2 ? m2 : y2;
            let S2 = false;
            r2 && (c2 = Math.sqrt(Math.pow(f3 - m2, 2) + Math.pow(p3 - y2, 2))), x2 < s2 ? w2 > s2 && (h2 = l2(a2, f3, p3, m2, y2, s2), r2 && (a2.start = u2 + c2 * h2)) : x2 > o2 ? w2 < o2 && (h2 = l2(a2, f3, p3, m2, y2, o2), r2 && (a2.start = u2 + c2 * h2)) : ge(a2, f3, p3, g3), w2 < s2 && x2 >= s2 && (h2 = l2(a2, f3, p3, m2, y2, s2), S2 = true), w2 > o2 && x2 <= o2 && (h2 = l2(a2, f3, p3, m2, y2, o2), S2 = true), !n2 && S2 && (r2 && (a2.end = u2 + c2 * h2), t2.push(a2), a2 = fe(e2)), r2 && (u2 += c2);
          }
          let d2 = e2.length - 3;
          const f2 = e2[d2], p2 = e2[d2 + 1], g2 = 0 === i2 ? f2 : p2;
          g2 >= s2 && g2 <= o2 && ge(a2, f2, p2, e2[d2 + 2]), d2 = a2.length - 3, n2 && d2 >= 3 && (a2[d2] !== a2[0] || a2[d2 + 1] !== a2[1]) && ge(a2, a2[0], a2[1], a2[2]), a2.length && t2.push(a2);
        }
        function fe(e2) {
          const t2 = [];
          return t2.size = e2.size, t2.start = e2.start, t2.end = e2.end, t2;
        }
        function pe(e2, t2, s2, o2, i2, n2) {
          for (const r2 of e2)
            de(r2, t2, s2, o2, i2, n2, false);
        }
        function ge(e2, t2, s2, o2) {
          e2.push(t2, s2, o2);
        }
        function me(e2, t2, s2, o2, i2, n2) {
          const r2 = (n2 - t2) / (o2 - t2);
          return ge(e2, n2, s2 + (i2 - s2) * r2, 1), r2;
        }
        function ye(e2, t2, s2, o2, i2, n2) {
          const r2 = (n2 - s2) / (i2 - s2);
          return ge(e2, t2 + (o2 - t2) * r2, n2, 1), r2;
        }
        function xe(e2, t2) {
          const s2 = [];
          for (let o2 = 0; o2 < e2.length; o2++) {
            const i2 = e2[o2], n2 = i2.type;
            let r2;
            if ("Point" === n2 || "MultiPoint" === n2 || "LineString" === n2)
              r2 = we(i2.geometry, t2);
            else if ("MultiLineString" === n2 || "Polygon" === n2) {
              r2 = [];
              for (const e3 of i2.geometry)
                r2.push(we(e3, t2));
            } else if ("MultiPolygon" === n2) {
              r2 = [];
              for (const e3 of i2.geometry) {
                const s3 = [];
                for (const o3 of e3)
                  s3.push(we(o3, t2));
                r2.push(s3);
              }
            }
            s2.push(se(i2.id, n2, r2, i2.tags));
          }
          return s2;
        }
        function we(e2, t2) {
          const s2 = [];
          s2.size = e2.size, void 0 !== e2.start && (s2.start = e2.start, s2.end = e2.end);
          for (let o2 = 0; o2 < e2.length; o2 += 3)
            s2.push(e2[o2] + t2, e2[o2 + 1], e2[o2 + 2]);
          return s2;
        }
        function Se(e2, t2) {
          if (e2.transformed)
            return e2;
          const s2 = 1 << e2.z, o2 = e2.x, i2 = e2.y;
          for (const n2 of e2.features) {
            const e3 = n2.geometry, r2 = n2.type;
            if (n2.geometry = [], 1 === r2)
              for (let r3 = 0; r3 < e3.length; r3 += 2)
                n2.geometry.push(be(e3[r3], e3[r3 + 1], t2, s2, o2, i2));
            else
              for (let r3 = 0; r3 < e3.length; r3++) {
                const a2 = [];
                for (let n3 = 0; n3 < e3[r3].length; n3 += 2)
                  a2.push(be(e3[r3][n3], e3[r3][n3 + 1], t2, s2, o2, i2));
                n2.geometry.push(a2);
              }
          }
          return e2.transformed = true, e2;
        }
        function be(e2, t2, s2, o2, i2, n2) {
          return [Math.round(s2 * (e2 * o2 - i2)), Math.round(s2 * (t2 * o2 - n2))];
        }
        function ve(e2, t2, s2, o2, i2) {
          const n2 = t2 === i2.maxZoom ? 0 : i2.tolerance / ((1 << t2) * i2.extent), r2 = { features: [], numPoints: 0, numSimplified: 0, numFeatures: e2.length, source: null, x: s2, y: o2, z: t2, transformed: false, minX: 2, minY: 1, maxX: -1, maxY: 0 };
          for (const t3 of e2)
            Ie(r2, t3, n2, i2);
          return r2;
        }
        function Ie(e2, t2, s2, o2) {
          const i2 = t2.geometry, n2 = t2.type, r2 = [];
          if (e2.minX = Math.min(e2.minX, t2.minX), e2.minY = Math.min(e2.minY, t2.minY), e2.maxX = Math.max(e2.maxX, t2.maxX), e2.maxY = Math.max(e2.maxY, t2.maxY), "Point" === n2 || "MultiPoint" === n2)
            for (let t3 = 0; t3 < i2.length; t3 += 3)
              r2.push(i2[t3], i2[t3 + 1]), e2.numPoints++, e2.numSimplified++;
          else if ("LineString" === n2)
            Me(r2, i2, e2, s2, false, false);
          else if ("MultiLineString" === n2 || "Polygon" === n2)
            for (let t3 = 0; t3 < i2.length; t3++)
              Me(r2, i2[t3], e2, s2, "Polygon" === n2, 0 === t3);
          else if ("MultiPolygon" === n2)
            for (let t3 = 0; t3 < i2.length; t3++) {
              const o3 = i2[t3];
              for (let t4 = 0; t4 < o3.length; t4++)
                Me(r2, o3[t4], e2, s2, true, 0 === t4);
            }
          if (r2.length) {
            let s3 = t2.tags || null;
            if ("LineString" === n2 && o2.lineMetrics) {
              s3 = {};
              for (const e3 in t2.tags)
                s3[e3] = t2.tags[e3];
              s3.mapbox_clip_start = i2.start / i2.size, s3.mapbox_clip_end = i2.end / i2.size;
            }
            const a2 = { geometry: r2, type: "Polygon" === n2 || "MultiPolygon" === n2 ? 3 : "LineString" === n2 || "MultiLineString" === n2 ? 2 : 1, tags: s3 };
            null !== t2.id && (a2.id = t2.id), e2.features.push(a2);
          }
        }
        function Me(e2, t2, s2, o2, i2, n2) {
          const r2 = o2 * o2;
          if (o2 > 0 && t2.size < (i2 ? r2 : o2))
            return void (s2.numPoints += t2.length / 3);
          const a2 = [];
          for (let e3 = 0; e3 < t2.length; e3 += 3)
            (0 === o2 || t2[e3 + 2] > r2) && (s2.numSimplified++, a2.push(t2[e3], t2[e3 + 1])), s2.numPoints++;
          i2 && function(e3, t3) {
            let s3 = 0;
            for (let t4 = 0, o3 = e3.length, i3 = o3 - 2; t4 < o3; i3 = t4, t4 += 2)
              s3 += (e3[t4] - e3[i3]) * (e3[t4 + 1] + e3[i3 + 1]);
            if (s3 > 0 === t3)
              for (let t4 = 0, s4 = e3.length; t4 < s4 / 2; t4 += 2) {
                const o3 = e3[t4], i3 = e3[t4 + 1];
                e3[t4] = e3[s4 - 2 - t4], e3[t4 + 1] = e3[s4 - 1 - t4], e3[s4 - 2 - t4] = o3, e3[s4 - 1 - t4] = i3;
              }
          }(a2, n2), e2.push(a2);
        }
        const ke = { maxZoom: 14, indexMaxZoom: 5, indexMaxPoints: 1e5, tolerance: 3, extent: 4096, buffer: 64, lineMetrics: false, promoteId: null, generateId: false, debug: 0 };
        class Te {
          constructor(e2, t2) {
            const s2 = (t2 = this.options = function(e3, t3) {
              for (const s3 in t3)
                e3[s3] = t3[s3];
              return e3;
            }(Object.create(ke), t2)).debug;
            if (s2 && console.time("preprocess data"), t2.maxZoom < 0 || t2.maxZoom > 24)
              throw new Error("maxZoom should be in the 0-24 range");
            if (t2.promoteId && t2.generateId)
              throw new Error("promoteId and generateId cannot be used together.");
            let o2 = function(e3, t3) {
              const s3 = [];
              if ("FeatureCollection" === e3.type)
                for (let o3 = 0; o3 < e3.features.length; o3++)
                  ie(s3, e3.features[o3], t3, o3);
              else
                ie(s3, "Feature" === e3.type ? e3 : { geometry: e3 }, t3);
              return s3;
            }(e2, t2);
            this.tiles = {}, this.tileCoords = [], s2 && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t2.indexMaxZoom, t2.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), o2 = function(e3, t3) {
              const s3 = t3.buffer / t3.extent;
              let o3 = e3;
              const i2 = he(e3, 1, -1 - s3, s3, 0, -1, 2, t3), n2 = he(e3, 1, 1 - s3, 2 + s3, 0, -1, 2, t3);
              return (i2 || n2) && (o3 = he(e3, 1, -s3, 1 + s3, 0, -1, 2, t3) || [], i2 && (o3 = xe(i2, 1).concat(o3)), n2 && (o3 = o3.concat(xe(n2, -1)))), o3;
            }(o2, t2), o2.length && this.splitTile(o2, 0, 0, 0), s2 && (o2.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
          }
          splitTile(e2, t2, s2, o2, i2, n2, r2) {
            const a2 = [e2, t2, s2, o2], l2 = this.options, c2 = l2.debug;
            for (; a2.length; ) {
              o2 = a2.pop(), s2 = a2.pop(), t2 = a2.pop(), e2 = a2.pop();
              const h2 = 1 << t2, u2 = Pe(t2, s2, o2);
              let d2 = this.tiles[u2];
              if (!d2 && (c2 > 1 && console.time("creation"), d2 = this.tiles[u2] = ve(e2, t2, s2, o2, l2), this.tileCoords.push({ z: t2, x: s2, y: o2 }), c2)) {
                c2 > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t2, s2, o2, d2.numFeatures, d2.numPoints, d2.numSimplified), console.timeEnd("creation"));
                const e3 = `z${t2}`;
                this.stats[e3] = (this.stats[e3] || 0) + 1, this.total++;
              }
              if (d2.source = e2, null == i2) {
                if (t2 === l2.indexMaxZoom || d2.numPoints <= l2.indexMaxPoints)
                  continue;
              } else {
                if (t2 === l2.maxZoom || t2 === i2)
                  continue;
                if (null != i2) {
                  const e3 = i2 - t2;
                  if (s2 !== n2 >> e3 || o2 !== r2 >> e3)
                    continue;
                }
              }
              if (d2.source = null, 0 === e2.length)
                continue;
              c2 > 1 && console.time("clipping");
              const f2 = 0.5 * l2.buffer / l2.extent, p2 = 0.5 - f2, g2 = 0.5 + f2, m2 = 1 + f2;
              let y2 = null, x2 = null, w2 = null, S2 = null, b2 = he(e2, h2, s2 - f2, s2 + g2, 0, d2.minX, d2.maxX, l2), v2 = he(e2, h2, s2 + p2, s2 + m2, 0, d2.minX, d2.maxX, l2);
              e2 = null, b2 && (y2 = he(b2, h2, o2 - f2, o2 + g2, 1, d2.minY, d2.maxY, l2), x2 = he(b2, h2, o2 + p2, o2 + m2, 1, d2.minY, d2.maxY, l2), b2 = null), v2 && (w2 = he(v2, h2, o2 - f2, o2 + g2, 1, d2.minY, d2.maxY, l2), S2 = he(v2, h2, o2 + p2, o2 + m2, 1, d2.minY, d2.maxY, l2), v2 = null), c2 > 1 && console.timeEnd("clipping"), a2.push(y2 || [], t2 + 1, 2 * s2, 2 * o2), a2.push(x2 || [], t2 + 1, 2 * s2, 2 * o2 + 1), a2.push(w2 || [], t2 + 1, 2 * s2 + 1, 2 * o2), a2.push(S2 || [], t2 + 1, 2 * s2 + 1, 2 * o2 + 1);
            }
          }
          getTile(e2, t2, s2) {
            e2 = +e2, t2 = +t2, s2 = +s2;
            const o2 = this.options, { extent: i2, debug: n2 } = o2;
            if (e2 < 0 || e2 > 24)
              return null;
            const r2 = 1 << e2, a2 = Pe(e2, t2 = t2 + r2 & r2 - 1, s2);
            if (this.tiles[a2])
              return Se(this.tiles[a2], i2);
            n2 > 1 && console.log("drilling down to z%d-%d-%d", e2, t2, s2);
            let l2, c2 = e2, h2 = t2, u2 = s2;
            for (; !l2 && c2 > 0; )
              c2--, h2 >>= 1, u2 >>= 1, l2 = this.tiles[Pe(c2, h2, u2)];
            return l2 && l2.source ? (n2 > 1 && (console.log("found parent tile z%d-%d-%d", c2, h2, u2), console.time("drilling down")), this.splitTile(l2.source, c2, h2, u2, e2, t2, s2), n2 > 1 && console.timeEnd("drilling down"), this.tiles[a2] ? Se(this.tiles[a2], i2) : null) : null;
          }
        }
        function Pe(e2, t2, s2) {
          return 32 * ((1 << e2) * s2 + t2) + e2;
        }
        function Ce(e2, t2) {
          const s2 = e2.tileID.canonical;
          if (!this._geoJSONIndex)
            return t2(null, null);
          const o2 = this._geoJSONIndex.getTile(s2.z, s2.x, s2.y);
          if (!o2)
            return t2(null, null);
          const i2 = new p(o2.features);
          let n2 = X(i2);
          0 === n2.byteOffset && n2.byteLength === n2.buffer.byteLength || (n2 = new Uint8Array(n2)), t2(null, { vectorTile: i2, rawData: n2.buffer });
        }
        class _e extends c {
          constructor(e2, t2, s2, o2, i2, n2) {
            super(e2, t2, s2, o2, Ce, n2), i2 && (this.loadGeoJSON = i2), this._dynamicIndex = new y();
          }
          loadData(s2, o2) {
            const i2 = s2 && s2.request, n2 = i2 && i2.collectResourceTiming;
            this.loadGeoJSON(s2, (r2, a2) => {
              if (r2 || !a2)
                return o2(r2);
              if ("object" != typeof a2)
                return o2(new Error(`Input data given to '${s2.source}' is not a valid GeoJSON object.`));
              {
                try {
                  if (s2.filter) {
                    const t2 = e.z(s2.filter, { type: "boolean", "property-type": "data-driven", overridable: false, transition: false });
                    if ("error" === t2.result)
                      throw new Error(t2.value.map((e2) => `${e2.key}: ${e2.message}`).join(", "));
                    a2.features = a2.features.filter((e2) => t2.value.evaluate({ zoom: 0 }, e2));
                  }
                  s2.dynamic ? ("Feature" === a2.type && (a2 = { type: "FeatureCollection", features: [a2] }), s2.append || (this._dynamicIndex.clear(), this.loaded = {}), this._dynamicIndex.load(a2.features, this.loaded), s2.cluster && (a2.features = this._dynamicIndex.getFeatures())) : this.loaded = {}, this._geoJSONIndex = s2.cluster ? new $(function({ superclusterOptions: t2, clusterProperties: s3 }) {
                    if (!s3 || !t2)
                      return t2;
                    const o3 = {}, i3 = {}, n3 = { accumulated: null, zoom: 0 }, r4 = { properties: null }, a3 = Object.keys(s3);
                    for (const t3 of a3) {
                      const [n4, r5] = s3[t3], a4 = e.z(r5), l2 = e.z("string" == typeof n4 ? [n4, ["accumulated"], ["get", t3]] : n4);
                      o3[t3] = a4.value, i3[t3] = l2.value;
                    }
                    return t2.map = (e2) => {
                      r4.properties = e2;
                      const t3 = {};
                      for (const e3 of a3)
                        t3[e3] = o3[e3].evaluate(n3, r4);
                      return t3;
                    }, t2.reduce = (e2, t3) => {
                      r4.properties = t3;
                      for (const t4 of a3)
                        n3.accumulated = e2[t4], e2[t4] = i3[t4].evaluate(n3, r4);
                    }, t2;
                  }(s2)).load(a2.features) : s2.dynamic ? this._dynamicIndex : function(e2, t2) {
                    return new Te(e2, t2);
                  }(a2, s2.geojsonVtOptions);
                } catch (e2) {
                  return o2(e2);
                }
                const r3 = {};
                if (n2) {
                  const e2 = t(i2);
                  e2 && (r3.resourceTiming = {}, r3.resourceTiming[s2.source] = JSON.parse(JSON.stringify(e2)));
                }
                o2(null, r3);
              }
            });
          }
          reloadTile(e2, t2) {
            const s2 = this.loaded;
            return s2 && s2[e2.uid] ? e2.partial ? t2(null, void 0) : super.reloadTile(e2, t2) : this.loadTile(e2, t2);
          }
          loadGeoJSON(t2, s2) {
            if (t2.request)
              e.h(t2.request, s2);
            else {
              if ("string" != typeof t2.data)
                return s2(new Error(`Input data given to '${t2.source}' is not a valid GeoJSON object.`));
              try {
                return s2(null, JSON.parse(t2.data));
              } catch (e2) {
                return s2(new Error(`Input data given to '${t2.source}' is not a valid GeoJSON object.`));
              }
            }
          }
          getClusterExpansionZoom(e2, t2) {
            try {
              t2(null, this._geoJSONIndex.getClusterExpansionZoom(e2.clusterId));
            } catch (e3) {
              t2(e3);
            }
          }
          getClusterChildren(e2, t2) {
            try {
              t2(null, this._geoJSONIndex.getChildren(e2.clusterId));
            } catch (e3) {
              t2(e3);
            }
          }
          getClusterLeaves(e2, t2) {
            try {
              t2(null, this._geoJSONIndex.getLeaves(e2.clusterId, e2.limit, e2.offset));
            } catch (e3) {
              t2(e3);
            }
          }
        }
        class Le {
          constructor(t2, s2) {
            this.tileID = new e.aQ(t2.tileID.overscaledZ, t2.tileID.wrap, t2.tileID.canonical.z, t2.tileID.canonical.x, t2.tileID.canonical.y), this.tileZoom = t2.tileZoom, this.uid = t2.uid, this.zoom = t2.zoom, this.canonical = t2.tileID.canonical, this.pixelRatio = t2.pixelRatio, this.tileSize = t2.tileSize, this.source = t2.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = t2.projection, this.brightness = s2;
          }
          parse(t2, s2, o2, i2) {
            this.status = "parsing";
            const n2 = new e.aQ(o2.tileID.overscaledZ, o2.tileID.wrap, o2.tileID.canonical.z, o2.tileID.canonical.x, o2.tileID.canonical.y), r2 = {}, a2 = s2.familiesBySource[o2.source], l2 = new e.dQ(n2, o2.promoteId);
            return l2.bucketLayerIDs = [], l2.is3DTile = true, e.e6(t2).then((t3) => {
              if (!t3)
                return i2(new Error("Could not parse tile"));
              const s3 = e.e7(t3, 1 / e.b7(o2.tileID.canonical)), c2 = t3.json.extensionsUsed && t3.json.extensionsUsed.includes("MAPBOX_mesh_features") || t3.json.asset.extras && t3.json.asset.extras.MAPBOX_mesh_features, h2 = t3.json.extensionsUsed && t3.json.extensionsUsed.includes("EXT_meshopt_compression"), u2 = new e.Y(this.zoom, { brightness: this.brightness });
              for (const t4 in a2)
                for (const o3 of a2[t4]) {
                  const t5 = o3[0];
                  l2.bucketLayerIDs.push(o3.map((e2) => e2.id)), t5.recalculate(u2, []);
                  const i3 = new e.e8(s3, n2, c2, h2, this.brightness, l2);
                  c2 || (i3.needsUpload = true), r2[t5.fqid] = i3, i3.evaluate(t5);
                }
              this.status = "done", i2(null, { buckets: r2, featureIndex: l2 });
            }).catch((e2) => i2(new Error(e2.message)));
          }
        }
        class De {
          constructor(e2, t2, s2, o2, i2, n2) {
            this.actor = e2, this.layerIndex = t2, this.brightness = n2, this.loading = {}, this.loaded = {};
          }
          loadTile(t2, s2) {
            const o2 = t2.uid, i2 = this.loading[o2] = new Le(t2, this.brightness);
            e.e5(t2.request, (e2, n2) => {
              const r2 = !this.loading[o2];
              return delete this.loading[o2], r2 || e2 ? (i2.status = "done", r2 || (this.loaded[o2] = i2), s2(e2)) : n2 && 0 !== n2.byteLength ? void i2.parse(n2, this.layerIndex, t2, (e3, t3) => {
                i2.status = "done", this.loaded = this.loaded || {}, this.loaded[o2] = i2, e3 || !t3 ? s2(e3) : s2(null, t3);
              }) : (i2.status = "done", this.loaded[o2] = i2, s2());
            });
          }
          reloadTile(e2, t2) {
            const s2 = this.loaded, o2 = e2.uid;
            if (s2 && s2[o2]) {
              const i2 = s2[o2];
              i2.projection = e2.projection, i2.brightness = e2.brightness;
              const n2 = (s3, o3) => {
                i2.reloadCallback && (delete i2.reloadCallback, this.loadTile(e2, t2)), t2(s3, o3);
              };
              "parsing" === i2.status ? i2.reloadCallback = n2 : "done" === i2.status && this.loadTile(e2, t2);
            }
          }
          abortTile(e2, t2) {
            const s2 = e2.uid;
            this.loading[s2] && delete this.loading[s2], t2();
          }
          removeTile(e2, t2) {
            const s2 = this.loaded, o2 = e2.uid;
            s2 && s2[o2] && delete s2[o2], t2();
          }
        }
        class je {
          constructor(t2) {
            this.self = t2, this.actor = new e.e9(t2, this), this.layerIndexes = {}, this.availableImages = {}, this.isSpriteLoaded = {}, this.projections = {}, this.defaultProjection = e.aK({ name: "mercator" }), this.workerSourceTypes = { vector: c, geojson: _e, "batched-model": De }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (e2, t3) => {
              if (this.workerSourceTypes[e2])
                throw new Error(`Worker source with name "${e2}" already registered.`);
              this.workerSourceTypes[e2] = t3;
            }, this.self.registerRTLTextPlugin = (t3) => {
              if (e.ea.isParsed())
                throw new Error("RTL text plugin already registered.");
              e.ea.applyArabicShaping = t3.applyArabicShaping, e.ea.processBidirectionalText = t3.processBidirectionalText, e.ea.processStyledBidirectionalText = t3.processStyledBidirectionalText;
            };
          }
          clearCaches(e2, t2, s2) {
            delete this.layerIndexes[e2], delete this.availableImages[e2], delete this.workerSources[e2], delete this.demWorkerSources[e2], delete this.rasterArrayWorkerSource, s2();
          }
          checkIfReady(e2, t2, s2) {
            s2();
          }
          setReferrer(e2, t2) {
            this.referrer = t2;
          }
          spriteLoaded(t2, { scope: s2, isLoaded: o2 }) {
            if (this.isSpriteLoaded[t2] || (this.isSpriteLoaded[t2] = {}), this.isSpriteLoaded[t2][s2] = o2, this.workerSources[t2] && this.workerSources[t2][s2])
              for (const i2 in this.workerSources[t2][s2]) {
                const n2 = this.workerSources[t2][s2][i2];
                for (const t3 in n2) {
                  const s3 = n2[t3];
                  s3 instanceof c && (s3.isSpriteLoaded = o2, s3.fire(new e.g("isSpriteLoaded")));
                }
              }
          }
          setImages(e2, { scope: t2, images: s2 }, o2) {
            if (this.availableImages[e2] || (this.availableImages[e2] = {}), this.availableImages[e2][t2] = s2, this.workerSources[e2] && this.workerSources[e2][t2]) {
              for (const o3 in this.workerSources[e2][t2]) {
                const i2 = this.workerSources[e2][t2][o3];
                for (const e3 in i2)
                  i2[e3].availableImages = s2;
              }
              o2();
            } else
              o2();
          }
          setProjection(t2, s2) {
            this.projections[t2] = e.aK(s2);
          }
          setBrightness(e2, t2, s2) {
            this.brightness = t2, s2();
          }
          setLayers(e2, t2, s2) {
            this.getLayerIndex(e2, t2.scope).replace(t2.layers, t2.options), s2();
          }
          updateLayers(e2, t2, s2) {
            this.getLayerIndex(e2, t2.scope).update(t2.layers, t2.removedIds, t2.options), s2();
          }
          loadTile(e2, t2, s2) {
            t2.projection = this.projections[e2] || this.defaultProjection, this.getWorkerSource(e2, t2.type, t2.source, t2.scope).loadTile(t2, s2);
          }
          loadDEMTile(e2, t2, s2) {
            this.getDEMWorkerSource(e2, t2.source, t2.scope).loadTile(t2, s2);
          }
          decodeRasterArray(e2, t2, s2) {
            this.getRasterArrayWorkerSource().decodeRasterArray(t2, s2);
          }
          reloadTile(e2, t2, s2) {
            t2.projection = this.projections[e2] || this.defaultProjection, this.getWorkerSource(e2, t2.type, t2.source, t2.scope).reloadTile(t2, s2);
          }
          abortTile(e2, t2, s2) {
            this.getWorkerSource(e2, t2.type, t2.source, t2.scope).abortTile(t2, s2);
          }
          removeTile(e2, t2, s2) {
            this.getWorkerSource(e2, t2.type, t2.source, t2.scope).removeTile(t2, s2);
          }
          removeSource(e2, t2, s2) {
            if (!(this.workerSources[e2] && this.workerSources[e2][t2.scope] && this.workerSources[e2][t2.scope][t2.type] && this.workerSources[e2][t2.scope][t2.type][t2.source]))
              return;
            const o2 = this.workerSources[e2][t2.scope][t2.type][t2.source];
            delete this.workerSources[e2][t2.scope][t2.type][t2.source], void 0 !== o2.removeSource ? o2.removeSource(t2, s2) : s2();
          }
          loadWorkerSource(e2, t2, s2) {
            try {
              this.self.importScripts(t2.url), s2();
            } catch (e3) {
              s2(e3.toString());
            }
          }
          syncRTLPluginState(t2, s2, o2) {
            try {
              e.ea.setState(s2);
              const t3 = e.ea.getPluginURL();
              if (e.ea.isLoaded() && !e.ea.isParsed() && null != t3) {
                this.self.importScripts(t3);
                const s3 = e.ea.isParsed();
                o2(s3 ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${t3}`), s3);
              }
            } catch (e2) {
              o2(e2.toString());
            }
          }
          setDracoUrl(e2, t2) {
            this.dracoUrl = t2;
          }
          getAvailableImages(e2, t2) {
            this.availableImages[e2] || (this.availableImages[e2] = {});
            let s2 = this.availableImages[e2][t2];
            return s2 || (s2 = []), s2;
          }
          getLayerIndex(e2, t2) {
            this.layerIndexes[e2] || (this.layerIndexes[e2] = {});
            let s2 = this.layerIndexes[e2][t2];
            return s2 || (s2 = this.layerIndexes[e2][t2] = new i(), s2.scope = t2), s2;
          }
          getWorkerSource(e2, t2, s2, o2) {
            return this.workerSources[e2] || (this.workerSources[e2] = {}), this.workerSources[e2][o2] || (this.workerSources[e2][o2] = {}), this.workerSources[e2][o2][t2] || (this.workerSources[e2][o2][t2] = {}), this.isSpriteLoaded[e2] || (this.isSpriteLoaded[e2] = {}), this.workerSources[e2][o2][t2][s2] || (this.workerSources[e2][o2][t2][s2] = new this.workerSourceTypes[t2]({ send: (t3, s3, o3, i2, n2, r2) => {
              this.actor.send(t3, s3, o3, e2, n2, r2);
            }, scheduler: this.actor.scheduler }, this.getLayerIndex(e2, o2), this.getAvailableImages(e2, o2), this.isSpriteLoaded[e2][o2], void 0, this.brightness)), this.workerSources[e2][o2][t2][s2];
          }
          getDEMWorkerSource(e2, t2, s2) {
            return this.demWorkerSources[e2] || (this.demWorkerSources[e2] = {}), this.demWorkerSources[e2][s2] || (this.demWorkerSources[e2][s2] = {}), this.demWorkerSources[e2][s2][t2] || (this.demWorkerSources[e2][s2][t2] = new h()), this.demWorkerSources[e2][s2][t2];
          }
          getRasterArrayWorkerSource() {
            return this.rasterArrayWorkerSource || (this.rasterArrayWorkerSource = new u()), this.rasterArrayWorkerSource;
          }
          enforceCacheSizeLimit(t2, s2) {
            e.eb(s2);
          }
          getWorkerPerformanceMetrics(e2, t2, s2) {
            s2(void 0, void 0);
          }
        }
        return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope && (self.worker = new je(self)), je;
      });
      define2(["./shared"], function(e) {
        var t = i;
        function i(e2) {
          return !function(e3) {
            return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : function() {
              if (!("Worker" in window && "Blob" in window && "URL" in window))
                return false;
              var e4, t3, i2 = new Blob([""], { type: "text/javascript" }), o2 = URL.createObjectURL(i2);
              try {
                t3 = new Worker(o2), e4 = true;
              } catch (t4) {
                e4 = false;
              }
              return t3 && t3.terminate(), URL.revokeObjectURL(o2), e4;
            }() ? function() {
              var e4 = document.createElement("canvas");
              e4.width = e4.height = 1;
              var t3 = e4.getContext("2d");
              if (!t3)
                return false;
              var i2 = t3.getImageData(0, 0, 1, 1);
              return i2 && i2.width === e4.width;
            }() ? (void 0 === o[t2 = e3 && e3.failIfMajorPerformanceCaveat] && (o[t2] = function(e4) {
              var t3, o2 = function(e5) {
                var t4 = document.createElement("canvas"), o3 = Object.create(i.webGLContextAttributes);
                return o3.failIfMajorPerformanceCaveat = e5, t4.getContext("webgl2", o3);
              }(e4);
              if (!o2)
                return false;
              try {
                t3 = o2.createShader(o2.VERTEX_SHADER);
              } catch (e5) {
                return false;
              }
              return !(!t3 || o2.isContextLost()) && (o2.shaderSource(t3, "void main() {}"), o2.compileShader(t3), true === o2.getShaderParameter(t3, o2.COMPILE_STATUS));
            }(t2)), o[t2] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL2 support") : "insufficient Canvas/getImageData support" : "insufficient worker support";
            var t2;
          }(e2);
        }
        var o = {};
        function r(e2, t2, i2) {
          const o2 = document.createElement(e2);
          return null != t2 && (o2.className = t2), i2 && i2.appendChild(o2), o2;
        }
        function a(e2, t2, i2) {
          const o2 = document.createElementNS("http://www.w3.org/2000/svg", e2);
          for (const e3 of Object.keys(t2))
            o2.setAttributeNS(null, e3, String(t2[e3]));
          return i2 && i2.appendChild(o2), o2;
        }
        i.webGLContextAttributes = { antialias: false, alpha: true, stencil: true, depth: true };
        const n = "undefined" != typeof document ? document.documentElement && document.documentElement.style : null, s = n && void 0 !== n.userSelect ? "userSelect" : "WebkitUserSelect";
        let l;
        function c() {
          n && s && (l = n[s], n[s] = "none");
        }
        function h() {
          n && s && (n[s] = l);
        }
        function _(e2) {
          e2.preventDefault(), e2.stopPropagation(), window.removeEventListener("click", _, true);
        }
        function u() {
          window.addEventListener("click", _, true), window.setTimeout(() => {
            window.removeEventListener("click", _, true);
          }, 0);
        }
        function d(e2, t2) {
          const i2 = e2.getBoundingClientRect();
          return m(e2, i2, t2);
        }
        function p(e2, t2) {
          const i2 = e2.getBoundingClientRect(), o2 = [];
          for (let r2 = 0; r2 < t2.length; r2++)
            o2.push(m(e2, i2, t2[r2]));
          return o2;
        }
        function f(e2) {
          return void 0 !== window.InstallTrigger && 2 === e2.button && e2.ctrlKey && window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : e2.button;
        }
        function m(t2, i2, o2) {
          const r2 = t2.offsetWidth === i2.width ? 1 : t2.offsetWidth / i2.width;
          return new e.P((o2.clientX - i2.left) * r2, (o2.clientY - i2.top) * r2);
        }
        class g {
          constructor() {
            this._changed = false, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps = /* @__PURE__ */ new Set(), this._updatedImages = /* @__PURE__ */ new Set();
          }
          isDirty() {
            return this._changed;
          }
          setDirty() {
            this._changed = true;
          }
          getUpdatedSourceCaches() {
            return this._updatedSourceCaches;
          }
          updateSourceCache(e2, t2) {
            this._updatedSourceCaches[e2] = t2, this.setDirty();
          }
          discardSourceCacheUpdate(e2) {
            delete this._updatedSourceCaches[e2];
          }
          updateLayer(e2) {
            const t2 = e2.scope;
            this._updatedLayers[t2] = this._updatedLayers[t2] || /* @__PURE__ */ new Set(), this._updatedLayers[t2].add(e2.id), this.setDirty();
          }
          removeLayer(e2) {
            const t2 = e2.scope;
            this._removedLayers[t2] = this._removedLayers[t2] || {}, this._updatedLayers[t2] = this._updatedLayers[t2] || /* @__PURE__ */ new Set(), this._removedLayers[t2][e2.id] = e2, this._updatedLayers[t2].delete(e2.id), this._updatedPaintProps.delete(e2.fqid), this.setDirty();
          }
          getRemovedLayer(e2) {
            return this._removedLayers[e2.scope] ? this._removedLayers[e2.scope][e2.id] : null;
          }
          discardLayerRemoval(e2) {
            this._removedLayers[e2.scope] && delete this._removedLayers[e2.scope][e2.id];
          }
          getLayerUpdatesByScope() {
            const e2 = {};
            for (const t2 in this._updatedLayers)
              e2[t2] = e2[t2] || {}, e2[t2].updatedIds = Array.from(this._updatedLayers[t2].values());
            for (const t2 in this._removedLayers)
              e2[t2] = e2[t2] || {}, e2[t2].removedIds = Object.keys(this._removedLayers[t2]);
            return e2;
          }
          getUpdatedPaintProperties() {
            return this._updatedPaintProps;
          }
          updatePaintProperties(e2) {
            this._updatedPaintProps.add(e2.fqid), this.setDirty();
          }
          getUpdatedImages() {
            return Array.from(this._updatedImages.values());
          }
          updateImage(e2) {
            this._updatedImages.add(e2), this.setDirty();
          }
          resetUpdatedImages() {
            this._updatedImages.clear();
          }
          reset() {
            this._changed = false, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps.clear(), this._updatedImages.clear();
          }
        }
        const v = { Int8: "BYTE", Uint8: "UNSIGNED_BYTE", Int16: "SHORT", Uint16: "UNSIGNED_SHORT", Int32: "INT", Uint32: "UNSIGNED_INT", Float32: "FLOAT" };
        class x {
          constructor(e2, t2, i2, o2, r2, a2) {
            this.length = t2.length, this.attributes = i2, this.itemSize = t2.bytesPerElement, this.dynamicDraw = o2, this.instanceCount = a2, this.context = e2;
            const n2 = e2.gl;
            this.buffer = n2.createBuffer(), e2.bindVertexBuffer.set(this.buffer), n2.bufferData(n2.ARRAY_BUFFER, t2.arrayBuffer, this.dynamicDraw ? n2.DYNAMIC_DRAW : n2.STATIC_DRAW), this.dynamicDraw || r2 || t2.destroy();
          }
          bind() {
            this.context.bindVertexBuffer.set(this.buffer);
          }
          updateData(e2) {
            const t2 = this.context.gl;
            this.bind(), t2.bufferSubData(t2.ARRAY_BUFFER, 0, e2.arrayBuffer);
          }
          enableAttributes(e2, t2) {
            for (let i2 = 0; i2 < this.attributes.length; i2++) {
              const o2 = t2.attributes[this.attributes[i2].name];
              void 0 !== o2 && e2.enableVertexAttribArray(o2);
            }
          }
          setVertexAttribPointers(e2, t2, i2) {
            for (let o2 = 0; o2 < this.attributes.length; o2++) {
              const r2 = this.attributes[o2], a2 = t2.attributes[r2.name];
              void 0 !== a2 && e2.vertexAttribPointer(a2, r2.components, e2[v[r2.type]], false, this.itemSize, r2.offset + this.itemSize * (i2 || 0));
            }
          }
          setVertexAttribDivisor(e2, t2, i2) {
            for (let o2 = 0; o2 < this.attributes.length; o2++) {
              const r2 = t2.attributes[this.attributes[o2].name];
              void 0 !== r2 && this.instanceCount && this.instanceCount > 0 && e2.vertexAttribDivisor(r2, i2);
            }
          }
          destroy() {
            this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
          }
        }
        class y {
          constructor(e2) {
            this.gl = e2.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = false;
          }
          get() {
            return this.current;
          }
          set(e2) {
          }
          getDefault() {
            return this.default;
          }
          setDefault() {
            this.set(this.default);
          }
        }
        class b extends y {
          getDefault() {
            return e.C.transparent;
          }
          set(e2) {
            const t2 = this.current;
            (e2.r !== t2.r || e2.g !== t2.g || e2.b !== t2.b || e2.a !== t2.a || this.dirty) && (this.gl.clearColor(e2.r, e2.g, e2.b, e2.a), this.current = e2, this.dirty = false);
          }
        }
        class w extends y {
          getDefault() {
            return 1;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.clearDepth(e2), this.current = e2, this.dirty = false);
          }
        }
        class T extends y {
          getDefault() {
            return 0;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.clearStencil(e2), this.current = e2, this.dirty = false);
          }
        }
        class E extends y {
          getDefault() {
            return [true, true, true, true];
          }
          set(e2) {
            const t2 = this.current;
            (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || e2[3] !== t2[3] || this.dirty) && (this.gl.colorMask(e2[0], e2[1], e2[2], e2[3]), this.current = e2, this.dirty = false);
          }
        }
        class C extends y {
          getDefault() {
            return true;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.depthMask(e2), this.current = e2, this.dirty = false);
          }
        }
        class S extends y {
          getDefault() {
            return 255;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.stencilMask(e2), this.current = e2, this.dirty = false);
          }
        }
        class I extends y {
          getDefault() {
            return { func: this.gl.ALWAYS, ref: 0, mask: 255 };
          }
          set(e2) {
            const t2 = this.current;
            (e2.func !== t2.func || e2.ref !== t2.ref || e2.mask !== t2.mask || this.dirty) && (this.gl.stencilFunc(e2.func, e2.ref, e2.mask), this.current = e2, this.dirty = false);
          }
        }
        class L extends y {
          getDefault() {
            const e2 = this.gl;
            return [e2.KEEP, e2.KEEP, e2.KEEP];
          }
          set(e2) {
            const t2 = this.current;
            (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || this.dirty) && (this.gl.stencilOp(e2[0], e2[1], e2[2]), this.current = e2, this.dirty = false);
          }
        }
        class P extends y {
          getDefault() {
            return false;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            const t2 = this.gl;
            e2 ? t2.enable(t2.STENCIL_TEST) : t2.disable(t2.STENCIL_TEST), this.current = e2, this.dirty = false;
          }
        }
        class R extends y {
          getDefault() {
            return [0, 1];
          }
          set(e2) {
            const t2 = this.current;
            (e2[0] !== t2[0] || e2[1] !== t2[1] || this.dirty) && (this.gl.depthRange(e2[0], e2[1]), this.current = e2, this.dirty = false);
          }
        }
        class D extends y {
          getDefault() {
            return false;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            const t2 = this.gl;
            e2 ? t2.enable(t2.DEPTH_TEST) : t2.disable(t2.DEPTH_TEST), this.current = e2, this.dirty = false;
          }
        }
        class A extends y {
          getDefault() {
            return this.gl.LESS;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.depthFunc(e2), this.current = e2, this.dirty = false);
          }
        }
        class M extends y {
          getDefault() {
            return false;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            const t2 = this.gl;
            e2 ? t2.enable(t2.BLEND) : t2.disable(t2.BLEND), this.current = e2, this.dirty = false;
          }
        }
        class z extends y {
          getDefault() {
            const e2 = this.gl;
            return [e2.ONE, e2.ZERO, e2.ONE, e2.ZERO];
          }
          set(e2) {
            const t2 = this.current;
            (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || e2[3] !== t2[3] || this.dirty) && (this.gl.blendFuncSeparate(e2[0], e2[1], e2[2], e2[3]), this.current = e2, this.dirty = false);
          }
        }
        class O extends y {
          getDefault() {
            return e.C.transparent;
          }
          set(e2) {
            const t2 = this.current;
            (e2.r !== t2.r || e2.g !== t2.g || e2.b !== t2.b || e2.a !== t2.a || this.dirty) && (this.gl.blendColor(e2.r, e2.g, e2.b, e2.a), this.current = e2, this.dirty = false);
          }
        }
        class F extends y {
          getDefault() {
            return this.gl.FUNC_ADD;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.blendEquationSeparate(e2, e2), this.current = e2, this.dirty = false);
          }
        }
        class B extends y {
          getDefault() {
            return false;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            const t2 = this.gl;
            e2 ? t2.enable(t2.CULL_FACE) : t2.disable(t2.CULL_FACE), this.current = e2, this.dirty = false;
          }
        }
        class k extends y {
          getDefault() {
            return this.gl.BACK;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.cullFace(e2), this.current = e2, this.dirty = false);
          }
        }
        class N extends y {
          getDefault() {
            return this.gl.CCW;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.frontFace(e2), this.current = e2, this.dirty = false);
          }
        }
        let U = class extends y {
          getDefault() {
            return null;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.useProgram(e2), this.current = e2, this.dirty = false);
          }
        };
        class G extends y {
          getDefault() {
            return this.gl.TEXTURE0;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.activeTexture(e2), this.current = e2, this.dirty = false);
          }
        }
        class j extends y {
          getDefault() {
            const e2 = this.gl;
            return [0, 0, e2.drawingBufferWidth, e2.drawingBufferHeight];
          }
          set(e2) {
            const t2 = this.current;
            (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || e2[3] !== t2[3] || this.dirty) && (this.gl.viewport(e2[0], e2[1], e2[2], e2[3]), this.current = e2, this.dirty = false);
          }
        }
        class V extends y {
          getDefault() {
            return null;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            const t2 = this.gl;
            t2.bindFramebuffer(t2.FRAMEBUFFER, e2), this.current = e2, this.dirty = false;
          }
        }
        class $ extends y {
          getDefault() {
            return null;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            const t2 = this.gl;
            t2.bindRenderbuffer(t2.RENDERBUFFER, e2), this.current = e2, this.dirty = false;
          }
        }
        class Z extends y {
          getDefault() {
            return null;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            const t2 = this.gl;
            t2.bindTexture(t2.TEXTURE_2D, e2), this.current = e2, this.dirty = false;
          }
        }
        class W extends y {
          getDefault() {
            return null;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            const t2 = this.gl;
            t2.bindBuffer(t2.ARRAY_BUFFER, e2), this.current = e2, this.dirty = false;
          }
        }
        class H extends y {
          getDefault() {
            return null;
          }
          set(e2) {
            const t2 = this.gl;
            t2.bindBuffer(t2.ELEMENT_ARRAY_BUFFER, e2), this.current = e2, this.dirty = false;
          }
        }
        class q extends y {
          getDefault() {
            return null;
          }
          set(e2) {
            this.gl && (e2 !== this.current || this.dirty) && (this.gl.bindVertexArray(e2), this.current = e2, this.dirty = false);
          }
        }
        class X extends y {
          getDefault() {
            return 4;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            const t2 = this.gl;
            t2.pixelStorei(t2.UNPACK_ALIGNMENT, e2), this.current = e2, this.dirty = false;
          }
        }
        class Q extends y {
          getDefault() {
            return false;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            const t2 = this.gl;
            t2.pixelStorei(t2.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e2), this.current = e2, this.dirty = false;
          }
        }
        class Y extends y {
          getDefault() {
            return false;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            const t2 = this.gl;
            t2.pixelStorei(t2.UNPACK_FLIP_Y_WEBGL, e2), this.current = e2, this.dirty = false;
          }
        }
        class J extends y {
          constructor(e2, t2) {
            super(e2), this.context = e2, this.parent = t2;
          }
          getDefault() {
            return null;
          }
        }
        class K extends J {
          setDirty() {
            this.dirty = true;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            this.context.bindFramebuffer.set(this.parent);
            const t2 = this.gl;
            t2.framebufferTexture2D(t2.FRAMEBUFFER, t2.COLOR_ATTACHMENT0, t2.TEXTURE_2D, e2, 0), this.current = e2, this.dirty = false;
          }
        }
        class ee extends J {
          attachment() {
            return this.gl.DEPTH_ATTACHMENT;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            this.context.bindFramebuffer.set(this.parent);
            const t2 = this.gl;
            t2.framebufferRenderbuffer(t2.FRAMEBUFFER, this.attachment(), t2.RENDERBUFFER, e2), this.current = e2, this.dirty = false;
          }
        }
        class te extends J {
          attachment() {
            return this.gl.DEPTH_ATTACHMENT;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty)
              return;
            this.context.bindFramebuffer.set(this.parent);
            const t2 = this.gl;
            t2.framebufferTexture2D(t2.FRAMEBUFFER, this.attachment(), t2.TEXTURE_2D, e2, 0), this.current = e2, this.dirty = false;
          }
        }
        class ie extends ee {
          attachment() {
            return this.gl.DEPTH_STENCIL_ATTACHMENT;
          }
        }
        class oe {
          constructor(e2, t2, i2, o2, r2) {
            this.context = e2, this.width = t2, this.height = i2;
            const a2 = this.framebuffer = e2.gl.createFramebuffer();
            o2 && (this.colorAttachment = new K(e2, a2)), r2 && (this.depthAttachmentType = r2, this.depthAttachment = "renderbuffer" === r2 ? new ee(e2, a2) : new te(e2, a2));
          }
          destroy() {
            const e2 = this.context.gl;
            if (this.colorAttachment) {
              const t2 = this.colorAttachment.get();
              t2 && e2.deleteTexture(t2);
            }
            if (this.depthAttachment && this.depthAttachmentType)
              if ("renderbuffer" === this.depthAttachmentType) {
                const t2 = this.depthAttachment.get();
                t2 && e2.deleteRenderbuffer(t2);
              } else {
                const t2 = this.depthAttachment.get();
                t2 && e2.deleteTexture(t2);
              }
            e2.deleteFramebuffer(this.framebuffer);
          }
        }
        class re {
          constructor(e2, t2) {
            this.gl = e2, this.clearColor = new b(this), this.clearDepth = new w(this), this.clearStencil = new T(this), this.colorMask = new E(this), this.depthMask = new C(this), this.stencilMask = new S(this), this.stencilFunc = new I(this), this.stencilOp = new L(this), this.stencilTest = new P(this), this.depthRange = new R(this), this.depthTest = new D(this), this.depthFunc = new A(this), this.blend = new M(this), this.blendFunc = new z(this), this.blendColor = new O(this), this.blendEquation = new F(this), this.cullFace = new B(this), this.cullFaceSide = new k(this), this.frontFace = new N(this), this.program = new U(this), this.activeTexture = new G(this), this.viewport = new j(this), this.bindFramebuffer = new V(this), this.bindRenderbuffer = new $(this), this.bindTexture = new Z(this), this.bindVertexBuffer = new W(this), this.bindElementBuffer = new H(this), this.bindVertexArrayOES = new q(this), this.pixelStoreUnpack = new X(this), this.pixelStoreUnpackPremultiplyAlpha = new Q(this), this.pixelStoreUnpackFlipY = new Y(this), this.options = t2 ? __spreadValues({}, t2) : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = e2.getExtension("EXT_texture_filter_anisotropic") || e2.getExtension("MOZ_EXT_texture_filter_anisotropic") || e2.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e2.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = e2.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e2.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e2.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = e2.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = e2.getExtension("EXT_color_buffer_half_float"), this.extTimerQuery = e2.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = e2.getParameter(e2.MAX_TEXTURE_SIZE), this.maxPointSize = e2.getParameter(e2.ALIASED_POINT_SIZE_RANGE)[1];
          }
          setDefault() {
            this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
          }
          setDirty() {
            this.clearColor.dirty = true, this.clearDepth.dirty = true, this.clearStencil.dirty = true, this.colorMask.dirty = true, this.depthMask.dirty = true, this.stencilMask.dirty = true, this.stencilFunc.dirty = true, this.stencilOp.dirty = true, this.stencilTest.dirty = true, this.depthRange.dirty = true, this.depthTest.dirty = true, this.depthFunc.dirty = true, this.blend.dirty = true, this.blendFunc.dirty = true, this.blendColor.dirty = true, this.blendEquation.dirty = true, this.cullFace.dirty = true, this.cullFaceSide.dirty = true, this.frontFace.dirty = true, this.program.dirty = true, this.activeTexture.dirty = true, this.viewport.dirty = true, this.bindFramebuffer.dirty = true, this.bindRenderbuffer.dirty = true, this.bindTexture.dirty = true, this.bindVertexBuffer.dirty = true, this.bindElementBuffer.dirty = true, this.bindVertexArrayOES.dirty = true, this.pixelStoreUnpack.dirty = true, this.pixelStoreUnpackPremultiplyAlpha.dirty = true, this.pixelStoreUnpackFlipY.dirty = true;
          }
          createIndexBuffer(t2, i2, o2) {
            return new e.I(this, t2, i2, o2);
          }
          createVertexBuffer(e2, t2, i2, o2, r2) {
            return new x(this, e2, t2, i2, o2, r2);
          }
          createRenderbuffer(e2, t2, i2) {
            const o2 = this.gl, r2 = o2.createRenderbuffer();
            return this.bindRenderbuffer.set(r2), o2.renderbufferStorage(o2.RENDERBUFFER, e2, t2, i2), this.bindRenderbuffer.set(null), r2;
          }
          createFramebuffer(e2, t2, i2, o2) {
            return new oe(this, e2, t2, i2, o2);
          }
          clear({ color: e2, depth: t2, stencil: i2, colorMask: o2 }) {
            const r2 = this.gl;
            let a2 = 0;
            e2 && (a2 |= r2.COLOR_BUFFER_BIT, this.clearColor.set(e2), this.colorMask.set(o2 || [true, true, true, true])), void 0 !== t2 && (a2 |= r2.DEPTH_BUFFER_BIT, this.depthRange.set([0, 1]), this.clearDepth.set(t2), this.depthMask.set(true)), void 0 !== i2 && (a2 |= r2.STENCIL_BUFFER_BIT, this.clearStencil.set(i2), this.stencilMask.set(255)), r2.clear(a2);
          }
          setCullFace(e2) {
            false === e2.enable ? this.cullFace.set(false) : (this.cullFace.set(true), this.cullFaceSide.set(e2.mode), this.frontFace.set(e2.frontFace));
          }
          setDepthMode(e2) {
            e2.func !== this.gl.ALWAYS || e2.mask ? (this.depthTest.set(true), this.depthFunc.set(e2.func), this.depthMask.set(e2.mask), this.depthRange.set(e2.range)) : this.depthTest.set(false);
          }
          setStencilMode(e2) {
            e2.test.func !== this.gl.ALWAYS || e2.mask ? (this.stencilTest.set(true), this.stencilMask.set(e2.mask), this.stencilOp.set([e2.fail, e2.depthFail, e2.pass]), this.stencilFunc.set({ func: e2.test.func, ref: e2.ref, mask: e2.test.mask })) : this.stencilTest.set(false);
          }
          setColorMode(t2) {
            e.d(t2.blendFunction, e.a.Replace) ? this.blend.set(false) : (this.blend.set(true), this.blendFunc.set(t2.blendFunction), this.blendColor.set(t2.blendColor), t2.blendEquation ? this.blendEquation.set(t2.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(t2.mask);
          }
          unbindVAO() {
            this.bindVertexArrayOES.set(null);
          }
        }
        class ae {
          constructor(t2, i2, o2, r2) {
            const a2 = { width: o2[0], height: o2[1], data: null }, n2 = t2.gl;
            this.targetColorTexture = new e.T(t2, a2, n2.RGBA, { useMipmap: false }), this.backgroundColorTexture = new e.T(t2, a2, n2.RGBA, { useMipmap: false }), this.context = t2, this.updateParticleTexture(i2, r2), this.lastInvalidatedAt = 0;
          }
          updateParticleTexture(t2, i2) {
            if (this.particleTextureDimension === i2.width)
              return;
            (this.particleTexture0 || this.particleTexture1 || this.particleIndexBuffer || this.particleSegment) && (this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleIndexBuffer.destroy(), this.particleSegment.destroy());
            const o2 = this.context.gl, r2 = i2.width * i2.height;
            this.particleTexture0 = new e.T(this.context, i2, o2.RGBA, { premultiply: false, useMipmap: false }), this.particleTexture1 = new e.T(this.context, i2, o2.RGBA, { premultiply: false, useMipmap: false });
            const a2 = new e.S();
            a2.reserve(r2);
            for (let e2 = 0; e2 < r2; e2++)
              a2.emplaceBack(e2);
            this.particleIndexBuffer = this.context.createVertexBuffer(a2, e.p.members, true), this.particleSegment = e.b.simpleSegment(0, 0, this.particleIndexBuffer.length, 0), this.particleTextureDimension = i2.width;
          }
          update(t2) {
            return !(this.lastInvalidatedAt < t2 && (this.lastInvalidatedAt = e.e.now(), 1));
          }
          destroy() {
            this.targetColorTexture.destroy(), this.backgroundColorTexture.destroy(), this.particleIndexBuffer.destroy(), this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleSegment.destroy();
          }
        }
        class ne extends e.E {
          constructor(e2) {
            super(), this.requestManager = e2, this.models = { "": {} }, this.numModelsLoading = {};
          }
          loadModel(t2, i2) {
            return e.l(this.requestManager.transformRequest(i2, e.R.Model).url).then((i3) => {
              if (!i3)
                return;
              const o2 = e.c(i3), r2 = new e.M(t2, void 0, void 0, o2);
              return r2.computeBoundsAndApplyParent(), r2;
            }).catch((o2) => {
              if (o2 && 404 === o2.status)
                return null;
              this.fire(new e.f(new Error(`Could not load model ${t2} from ${i2}: ${o2.message}`)));
            });
          }
          load(t2, i2) {
            this.models[i2] || (this.models[i2] = {});
            const o2 = Object.keys(t2);
            this.numModelsLoading[i2] = (this.numModelsLoading[i2] || 0) + o2.length;
            const r2 = [];
            for (const e2 of o2)
              r2.push(this.loadModel(e2, t2[e2]));
            Promise.allSettled(r2).then((t3) => {
              for (let e2 = 0; e2 < t3.length; e2++) {
                const { status: r3, value: a2 } = t3[e2];
                "fulfilled" === r3 && a2 && (this.models[i2][o2[e2]] = { model: a2, numReferences: 1 });
              }
              this.numModelsLoading[i2] -= o2.length, this.fire(new e.g("data", { dataType: "style" }));
            }).catch((t3) => {
              this.fire(new e.f(new Error(`Could not load models: ${t3.message}`)));
            });
          }
          isLoaded() {
            for (const e2 in this.numModelsLoading)
              if (this.numModelsLoading[e2] > 0)
                return false;
            return true;
          }
          hasModel(e2, t2) {
            return !!this.getModel(e2, t2);
          }
          getModel(e2, t2) {
            return this.models[t2] || (this.models[t2] = {}), this.models[t2][e2] ? this.models[t2][e2].model : void 0;
          }
          addModel(e2, t2, i2) {
            this.models[i2] || (this.models[i2] = {}), this.hasModel(e2, i2) && this.models[i2][e2].numReferences++, this.load({ [e2]: this.requestManager.normalizeModelURL(t2) }, i2);
          }
          addModels(e2, t2) {
            this.models[t2] || (this.models[t2] = {});
            const i2 = {};
            for (const o2 in e2)
              this.models[t2][o2] = {}, i2[o2] = this.requestManager.normalizeModelURL(e2[o2]);
            this.load(i2, t2);
          }
          addModelsFromBucket(e2, t2) {
            this.models[t2] || (this.models[t2] = {});
            const i2 = {};
            for (const o2 of e2)
              this.hasModel(o2, t2) ? this.models[t2][o2].numReferences++ : i2[o2] = this.requestManager.normalizeModelURL(o2);
            this.load(i2, t2);
          }
          removeModel(e2, t2) {
            if (this.models[t2] && this.models[t2][e2] && (this.models[t2][e2].numReferences--, 0 === this.models[t2][e2].numReferences)) {
              const i2 = this.models[t2][e2].model;
              delete this.models[t2][e2], i2.destroy();
            }
          }
          listModels(e2) {
            return this.models[e2] || (this.models[e2] = {}), Object.keys(this.models[e2]);
          }
          upload(e2, t2) {
            this.models[t2] || (this.models[t2] = {});
            for (const i2 in this.models[t2])
              this.models[t2][i2].model && this.models[t2][i2].model.upload(e2.context);
          }
        }
        function se(e2) {
          const { userImage: t2 } = e2;
          return !!(t2 && t2.render && t2.render()) && (e2.data.replace(new Uint8Array(t2.data.buffer)), true);
        }
        class le extends e.E {
          constructor() {
            super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = {}, this.requestors = [], this.patterns = {}, this.atlasImage = {}, this.atlasTexture = {}, this.dirty = true;
          }
          createScope(t2) {
            this.images[t2] = {}, this.loaded[t2] = false, this.updatedImages[t2] = {}, this.patterns[t2] = {}, this.callbackDispatchedThisFrame[t2] = {}, this.atlasImage[t2] = new e.j({ width: 1, height: 1 });
          }
          isLoaded() {
            for (const e2 in this.loaded)
              if (!this.loaded[e2])
                return false;
            return true;
          }
          setLoaded(e2, t2) {
            if (this.loaded[t2] !== e2 && (this.loaded[t2] = e2, e2)) {
              for (const { ids: e3, callback: i2 } of this.requestors)
                this._notify(e3, t2, i2);
              this.requestors = [];
            }
          }
          hasImage(e2, t2) {
            return !!this.getImage(e2, t2);
          }
          getImage(e2, t2) {
            return this.images[t2][e2];
          }
          addImage(e2, t2, i2) {
            this._validate(e2, i2) && (this.images[t2][e2] = i2);
          }
          _validate(t2, i2) {
            let o2 = true;
            return this._validateStretch(i2.stretchX, i2.data && i2.data.width) || (this.fire(new e.f(new Error(`Image "${t2}" has invalid "stretchX" value`))), o2 = false), this._validateStretch(i2.stretchY, i2.data && i2.data.height) || (this.fire(new e.f(new Error(`Image "${t2}" has invalid "stretchY" value`))), o2 = false), this._validateContent(i2.content, i2) || (this.fire(new e.f(new Error(`Image "${t2}" has invalid "content" value`))), o2 = false), o2;
          }
          _validateStretch(e2, t2) {
            if (!e2)
              return true;
            let i2 = 0;
            for (const o2 of e2) {
              if (o2[0] < i2 || o2[1] < o2[0] || t2 < o2[1])
                return false;
              i2 = o2[1];
            }
            return true;
          }
          _validateContent(e2, t2) {
            return !(e2 && (4 !== e2.length || e2[0] < 0 || t2.data.width < e2[0] || e2[1] < 0 || t2.data.height < e2[1] || e2[2] < 0 || t2.data.width < e2[2] || e2[3] < 0 || t2.data.height < e2[3] || e2[2] < e2[0] || e2[3] < e2[1]));
          }
          updateImage(e2, t2, i2) {
            i2.version = this.images[t2][e2].version + 1, this.images[t2][e2] = i2, this.updatedImages[t2][e2] = true;
          }
          removeImage(e2, t2) {
            const i2 = this.images[t2][e2];
            delete this.images[t2][e2], delete this.patterns[t2][e2], i2.userImage && i2.userImage.onRemove && i2.userImage.onRemove();
          }
          listImages(e2) {
            return Object.keys(this.images[e2]);
          }
          getImages(e2, t2, i2) {
            let o2 = true;
            const r2 = !!this.loaded[t2];
            if (!r2)
              for (const i3 of e2)
                this.images[t2][i3] || (o2 = false);
            r2 || o2 ? this._notify(e2, t2, i2) : this.requestors.push({ ids: e2, scope: t2, callback: i2 });
          }
          getUpdatedImages(e2) {
            return this.updatedImages[e2];
          }
          _notify(t2, i2, o2) {
            const r2 = {};
            for (const o3 of t2) {
              this.images[i2][o3] || this.fire(new e.g("styleimagemissing", { id: o3 }));
              const t3 = this.images[i2][o3];
              t3 ? r2[o3] = { data: t3.data.clone(), pixelRatio: t3.pixelRatio, sdf: t3.sdf, version: t3.version, stretchX: t3.stretchX, stretchY: t3.stretchY, content: t3.content, hasRenderCallback: Boolean(t3.userImage && t3.userImage.render) } : e.w(`Image "${o3}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
            }
            o2(null, r2);
          }
          getPixelSize(e2) {
            const { width: t2, height: i2 } = this.atlasImage[e2];
            return { width: t2, height: i2 };
          }
          getPattern(t2, i2, o2) {
            const r2 = this.patterns[i2][t2], a2 = this.getImage(t2, i2);
            if (!a2)
              return null;
            if (r2 && r2.position.version === a2.version)
              return r2.position;
            if (r2)
              r2.position.version = a2.version;
            else {
              const o3 = { w: a2.data.width + 2, h: a2.data.height + 2, x: 0, y: 0 }, r3 = new e.m(o3, a2);
              this.patterns[i2][t2] = { bin: o3, position: r3 };
            }
            return this._updatePatternAtlas(i2, o2), this.patterns[i2][t2].position;
          }
          bind(t2, i2) {
            const o2 = t2.gl;
            let r2 = this.atlasTexture[i2];
            r2 ? this.dirty && (r2.update(this.atlasImage[i2]), this.dirty = false) : (r2 = new e.T(t2, this.atlasImage[i2], o2.RGBA), this.atlasTexture[i2] = r2), r2.bind(o2.LINEAR, o2.CLAMP_TO_EDGE);
          }
          _updatePatternAtlas(t2, i2) {
            const o2 = [];
            for (const e2 in this.patterns[t2])
              o2.push(this.patterns[t2][e2].bin);
            const { w: r2, h: a2 } = e.k(o2), n2 = this.atlasImage[t2];
            n2.resize({ width: r2 || 1, height: a2 || 1 });
            for (const o3 in this.patterns[t2]) {
              const { bin: r3 } = this.patterns[t2][o3], a3 = r3.x + 1, s2 = r3.y + 1, l2 = this.images[t2][o3].data, c2 = l2.width, h2 = l2.height;
              e.j.copy(l2, n2, { x: 0, y: 0 }, { x: a3, y: s2 }, { width: c2, height: h2 }, i2), e.j.copy(l2, n2, { x: 0, y: h2 - 1 }, { x: a3, y: s2 - 1 }, { width: c2, height: 1 }, i2), e.j.copy(l2, n2, { x: 0, y: 0 }, { x: a3, y: s2 + h2 }, { width: c2, height: 1 }, i2), e.j.copy(l2, n2, { x: c2 - 1, y: 0 }, { x: a3 - 1, y: s2 }, { width: 1, height: h2 }, i2), e.j.copy(l2, n2, { x: 0, y: 0 }, { x: a3 + c2, y: s2 }, { width: 1, height: h2 }, i2);
            }
            this.dirty = true;
          }
          beginFrame() {
            for (const e2 in this.images)
              this.callbackDispatchedThisFrame[e2] = {};
          }
          dispatchRenderCallbacks(e2, t2) {
            for (const i2 of e2) {
              if (this.callbackDispatchedThisFrame[t2][i2])
                continue;
              this.callbackDispatchedThisFrame[t2][i2] = true;
              const e3 = this.images[t2][i2];
              se(e3) && this.updateImage(i2, t2, e3);
            }
          }
        }
        function ce(t2) {
          const i2 = t2.key, o2 = t2.value, r2 = t2.valueSpec || {}, a2 = t2.objectElementValidators || {}, n2 = t2.style, s2 = t2.styleSpec;
          let l2 = [];
          const c2 = e.o(o2);
          if ("object" !== c2)
            return [new e.V(i2, o2, `object expected, ${c2} found`)];
          for (const t3 in o2) {
            const c3 = t3.split(".")[0];
            let h2;
            a2[c3] ? h2 = a2[c3] : r2[c3] ? h2 = De : a2["*"] ? h2 = a2["*"] : r2["*"] && (h2 = De), h2 ? l2 = l2.concat(h2({ key: (i2 ? `${i2}.` : i2) + t3, value: o2[t3], valueSpec: r2[c3] || r2["*"], style: n2, styleSpec: s2, object: o2, objectKey: t3 }, o2)) : l2.push(new e.n(i2, o2[t3], `unknown property "${t3}"`));
          }
          for (const t3 in r2)
            a2[t3] || r2[t3].required && void 0 === r2[t3].default && void 0 === o2[t3] && l2.push(new e.V(i2, o2, `missing required property "${t3}"`));
          return l2;
        }
        function he(t2) {
          const i2 = t2.value, o2 = t2.valueSpec, r2 = t2.style, a2 = t2.styleSpec, n2 = t2.key, s2 = t2.arrayElementValidator || De;
          if ("array" !== e.o(i2))
            return [new e.V(n2, i2, `array expected, ${e.o(i2)} found`)];
          if (o2.length && i2.length !== o2.length)
            return [new e.V(n2, i2, `array length ${o2.length} expected, length ${i2.length} found`)];
          if (o2["min-length"] && i2.length < o2["min-length"])
            return [new e.V(n2, i2, `array length at least ${o2["min-length"]} expected, length ${i2.length} found`)];
          let l2 = { type: o2.value, values: o2.values, minimum: o2.minimum, maximum: o2.maximum, function: void 0 };
          a2.$version < 7 && (l2.function = o2.function), "object" === e.o(o2.value) && (l2 = o2.value);
          let c2 = [];
          for (let e2 = 0; e2 < i2.length; e2++)
            c2 = c2.concat(s2({ array: i2, arrayIndex: e2, value: i2[e2], valueSpec: l2, style: r2, styleSpec: a2, key: `${n2}[${e2}]` }, true));
          return c2;
        }
        function _e(t2) {
          const i2 = t2.key, o2 = t2.value, r2 = t2.valueSpec;
          let a2 = e.o(o2);
          if ("number" === a2 && o2 != o2 && (a2 = "NaN"), "number" !== a2)
            return [new e.V(i2, o2, `number expected, ${a2} found`)];
          if ("minimum" in r2) {
            let a3 = r2.minimum;
            if ("array" === e.o(r2.minimum) && (a3 = r2.minimum[t2.arrayIndex]), o2 < a3)
              return [new e.V(i2, o2, `${o2} is less than the minimum value ${a3}`)];
          }
          if ("maximum" in r2) {
            let a3 = r2.maximum;
            if ("array" === e.o(r2.maximum) && (a3 = r2.maximum[t2.arrayIndex]), o2 > a3)
              return [new e.V(i2, o2, `${o2} is greater than the maximum value ${a3}`)];
          }
          return [];
        }
        function ue(t2) {
          const i2 = t2.valueSpec, o2 = e.u(t2.value.type);
          let r2, a2, n2, s2 = {};
          const l2 = "categorical" !== o2 && void 0 === t2.value.property, c2 = !l2, h2 = "array" === e.o(t2.value.stops) && "array" === e.o(t2.value.stops[0]) && "object" === e.o(t2.value.stops[0][0]), _2 = ce({ key: t2.key, value: t2.value, valueSpec: t2.styleSpec.function, style: t2.style, styleSpec: t2.styleSpec, objectElementValidators: { stops: function(t3) {
            if ("identity" === o2)
              return [new e.V(t3.key, t3.value, 'identity function may not have a "stops" property')];
            let i3 = [];
            const r3 = t3.value;
            return i3 = i3.concat(he({ key: t3.key, value: r3, valueSpec: t3.valueSpec, style: t3.style, styleSpec: t3.styleSpec, arrayElementValidator: u2 })), "array" === e.o(r3) && 0 === r3.length && i3.push(new e.V(t3.key, r3, "array must have at least one stop")), i3;
          }, default: function(e2) {
            return De({ key: e2.key, value: e2.value, valueSpec: i2, style: e2.style, styleSpec: e2.styleSpec });
          } } });
          return "identity" === o2 && l2 && _2.push(new e.V(t2.key, t2.value, 'missing required property "property"')), "identity" === o2 || t2.value.stops || _2.push(new e.V(t2.key, t2.value, 'missing required property "stops"')), "exponential" === o2 && t2.valueSpec.expression && !e.s(t2.valueSpec) && _2.push(new e.V(t2.key, t2.value, "exponential functions not supported")), t2.styleSpec.$version >= 8 && (c2 && !e.r(t2.valueSpec) ? _2.push(new e.V(t2.key, t2.value, "property functions not supported")) : l2 && !e.t(t2.valueSpec) && _2.push(new e.V(t2.key, t2.value, "zoom functions not supported"))), "categorical" !== o2 && !h2 || void 0 !== t2.value.property || _2.push(new e.V(t2.key, t2.value, '"property" property is required')), _2;
          function u2(t3) {
            let o3 = [];
            const r3 = t3.value, l3 = t3.key;
            if ("array" !== e.o(r3))
              return [new e.V(l3, r3, `array expected, ${e.o(r3)} found`)];
            if (2 !== r3.length)
              return [new e.V(l3, r3, `array length 2 expected, length ${r3.length} found`)];
            if (h2) {
              if ("object" !== e.o(r3[0]))
                return [new e.V(l3, r3, `object expected, ${e.o(r3[0])} found`)];
              if (void 0 === r3[0].zoom)
                return [new e.V(l3, r3, "object stop key must have zoom")];
              if (void 0 === r3[0].value)
                return [new e.V(l3, r3, "object stop key must have value")];
              const i3 = e.u(r3[0].zoom);
              if ("number" != typeof i3)
                return [new e.V(l3, r3[0].zoom, "stop zoom values must be numbers")];
              if (n2 && n2 > i3)
                return [new e.V(l3, r3[0].zoom, "stop zoom values must appear in ascending order")];
              i3 !== n2 && (n2 = i3, a2 = void 0, s2 = {}), o3 = o3.concat(ce({ key: `${l3}[0]`, value: r3[0], valueSpec: { zoom: {} }, style: t3.style, styleSpec: t3.styleSpec, objectElementValidators: { zoom: _e, value: d2 } }));
            } else
              o3 = o3.concat(d2({ key: `${l3}[0]`, value: r3[0], valueSpec: {}, style: t3.style, styleSpec: t3.styleSpec }, r3));
            return e.v(e.x(r3[1])) ? o3.concat([new e.V(`${l3}[1]`, r3[1], "expressions are not allowed in function stops.")]) : o3.concat(De({ key: `${l3}[1]`, value: r3[1], valueSpec: i2, style: t3.style, styleSpec: t3.styleSpec }));
          }
          function d2(t3, n3) {
            const l3 = e.o(t3.value), c3 = e.u(t3.value), h3 = null !== t3.value ? t3.value : n3;
            if (r2) {
              if (l3 !== r2)
                return [new e.V(t3.key, h3, `${l3} stop domain type must match previous stop domain type ${r2}`)];
            } else
              r2 = l3;
            if ("number" !== l3 && "string" !== l3 && "boolean" !== l3 && "number" != typeof c3 && "string" != typeof c3 && "boolean" != typeof c3)
              return [new e.V(t3.key, h3, "stop domain value must be a number, string, or boolean")];
            if ("number" !== l3 && "categorical" !== o2) {
              let r3 = `number expected, ${l3} found`;
              return e.r(i2) && void 0 === o2 && (r3 += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [new e.V(t3.key, h3, r3)];
            }
            return "categorical" !== o2 || "number" !== l3 || "number" == typeof c3 && isFinite(c3) && Math.floor(c3) === c3 ? "categorical" !== o2 && "number" === l3 && "number" == typeof c3 && "number" == typeof a2 && void 0 !== a2 && c3 < a2 ? [new e.V(t3.key, h3, "stop domain values must appear in ascending order")] : (a2 = c3, "categorical" === o2 && c3 in s2 ? [new e.V(t3.key, h3, "stop domain values must be unique")] : (s2[c3] = true, [])) : [new e.V(t3.key, h3, `integer expected, found ${String(c3)}`)];
          }
        }
        function de(t2) {
          const i2 = ("property" === t2.expressionContext ? e.y : e.z)(e.x(t2.value), t2.valueSpec);
          if ("error" === i2.result)
            return i2.value.map((i3) => new e.V(`${t2.key}${i3.key}`, t2.value, i3.message));
          const o2 = i2.value.expression || i2.value._styleExpression.expression;
          if ("property" === t2.expressionContext && "text-font" === t2.propertyKey && !o2.outputDefined())
            return [new e.V(t2.key, t2.value, `Invalid data expression for "${t2.propertyKey}". Output values must be contained as literals within the expression.`)];
          if ("property" === t2.expressionContext && "layout" === t2.propertyType && !e.A(o2))
            return [new e.V(t2.key, t2.value, '"feature-state" data expressions are not supported with layout properties.')];
          if ("filter" === t2.expressionContext)
            return pe(o2, t2);
          if (t2.expressionContext && 0 === t2.expressionContext.indexOf("cluster")) {
            if (!e.B(o2, ["zoom", "feature-state"]))
              return [new e.V(t2.key, t2.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')];
            if ("cluster-initial" === t2.expressionContext && !e.D(o2))
              return [new e.V(t2.key, t2.value, "Feature data expressions are not supported with initial expression part of cluster properties.")];
          }
          return [];
        }
        function pe(t2, i2) {
          const o2 = /* @__PURE__ */ new Set(["zoom", "feature-state", "pitch", "distance-from-center"]);
          if (i2.valueSpec && i2.valueSpec.expression)
            for (const e2 of i2.valueSpec.expression.parameters)
              o2.delete(e2);
          if (0 === o2.size)
            return [];
          const r2 = [];
          return t2 instanceof e.F && o2.has(t2.name) ? [new e.V(i2.key, i2.value, `["${t2.name}"] expression is not supported in a filter for a ${i2.object.type} layer with id: ${i2.object.id}`)] : (t2.eachChild((e2) => {
            r2.push(...pe(e2, i2));
          }), r2);
        }
        function fe(t2) {
          const i2 = t2.key, o2 = t2.value, r2 = t2.valueSpec, a2 = [];
          return Array.isArray(r2.values) ? -1 === r2.values.indexOf(e.u(o2)) && a2.push(new e.V(i2, o2, `expected one of [${r2.values.join(", ")}], ${JSON.stringify(o2)} found`)) : -1 === Object.keys(r2.values).indexOf(e.u(o2)) && a2.push(new e.V(i2, o2, `expected one of [${Object.keys(r2.values).join(", ")}], ${JSON.stringify(o2)} found`)), a2;
        }
        function me(t2) {
          return e.H(e.x(t2.value)) ? de(e.q({}, t2, { expressionContext: "filter", valueSpec: t2.styleSpec[`filter_${t2.layerType || "fill"}`] })) : ge(t2);
        }
        function ge(t2) {
          const i2 = t2.value, o2 = t2.key;
          if ("array" !== e.o(i2))
            return [new e.V(o2, i2, `array expected, ${e.o(i2)} found`)];
          const r2 = t2.styleSpec;
          let a2, n2 = [];
          if (i2.length < 1)
            return [new e.V(o2, i2, "filter array must have at least 1 element")];
          switch (n2 = n2.concat(fe({ key: `${o2}[0]`, value: i2[0], valueSpec: r2.filter_operator, style: t2.style, styleSpec: t2.styleSpec })), e.u(i2[0])) {
            case "<":
            case "<=":
            case ">":
            case ">=":
              i2.length >= 2 && "$type" === e.u(i2[1]) && n2.push(new e.V(o2, i2, `"$type" cannot be use with operator "${i2[0]}"`));
            case "==":
            case "!=":
              3 !== i2.length && n2.push(new e.V(o2, i2, `filter array for operator "${i2[0]}" must have 3 elements`));
            case "in":
            case "!in":
              i2.length >= 2 && (a2 = e.o(i2[1]), "string" !== a2 && n2.push(new e.V(`${o2}[1]`, i2[1], `string expected, ${a2} found`)));
              for (let s2 = 2; s2 < i2.length; s2++)
                a2 = e.o(i2[s2]), "$type" === e.u(i2[1]) ? n2 = n2.concat(fe({ key: `${o2}[${s2}]`, value: i2[s2], valueSpec: r2.geometry_type, style: t2.style, styleSpec: t2.styleSpec })) : "string" !== a2 && "number" !== a2 && "boolean" !== a2 && n2.push(new e.V(`${o2}[${s2}]`, i2[s2], `string, number, or boolean expected, ${a2} found`));
              break;
            case "any":
            case "all":
            case "none":
              for (let e2 = 1; e2 < i2.length; e2++)
                n2 = n2.concat(ge({ key: `${o2}[${e2}]`, value: i2[e2], style: t2.style, styleSpec: t2.styleSpec }));
              break;
            case "has":
            case "!has":
              a2 = e.o(i2[1]), 2 !== i2.length ? n2.push(new e.V(o2, i2, `filter array for "${i2[0]}" operator must have 2 elements`)) : "string" !== a2 && n2.push(new e.V(`${o2}[1]`, i2[1], `string expected, ${a2} found`));
          }
          return n2;
        }
        function ve(t2, i2) {
          const o2 = t2.key, r2 = t2.style, a2 = t2.layer, n2 = t2.styleSpec, s2 = t2.value, l2 = t2.objectKey, c2 = n2[`${i2}_${t2.layerType}`];
          if (!c2)
            return [];
          const h2 = l2.match(/^(.*)-transition$/);
          if ("paint" === i2 && h2 && c2[h2[1]] && c2[h2[1]].transition)
            return De({ key: o2, value: s2, valueSpec: n2.transition, style: r2, styleSpec: n2 });
          const _2 = t2.valueSpec || c2[l2];
          if (!_2)
            return [new e.n(o2, s2, `unknown property "${l2}"`)];
          let u2;
          if ("string" === e.o(s2) && e.r(_2) && !_2.tokens && (u2 = /^{([^}]+)}$/.exec(s2))) {
            const t3 = `\`{ "type": "identity", "property": ${u2 ? JSON.stringify(u2[1]) : '"_"'} }\``;
            return [new e.V(o2, s2, `"${l2}" does not support interpolation syntax
Use an identity property function instead: ${t3}.`)];
          }
          const d2 = [];
          if ("symbol" === t2.layerType)
            "text-field" !== l2 || !r2 || r2.glyphs || r2.imports || d2.push(new e.V(o2, s2, 'use of "text-field" requires a style "glyphs" property')), "text-font" === l2 && e.J(e.x(s2)) && "identity" === e.u(s2.type) && d2.push(new e.V(o2, s2, '"text-font" does not support identity functions'));
          else if ("model" === t2.layerType && "paint" === i2 && a2 && a2.layout && a2.layout.hasOwnProperty("model-id") && e.r(_2) && (e.K(_2) || e.t(_2))) {
            const t3 = e.y(e.x(s2), _2), i3 = t3.value.expression || t3.value._styleExpression.expression;
            i3 && !e.B(i3, ["measure-light"]) && ("model-emissive-strength" === l2 && e.D(i3) && e.A(i3) || d2.push(new e.V(o2, s2, `${l2} does not support measure-light expressions when the model layer source is vector tile or GeoJSON.`)));
          }
          return d2.concat(De({ key: t2.key, value: s2, valueSpec: _2, style: r2, styleSpec: n2, expressionContext: "property", propertyType: i2, propertyKey: l2 }));
        }
        function xe(e2) {
          return ve(e2, "paint");
        }
        function ye(e2) {
          return ve(e2, "layout");
        }
        function be(t2) {
          let i2 = [];
          const o2 = t2.value, r2 = t2.key, a2 = t2.style, n2 = t2.styleSpec;
          o2.type || o2.ref || i2.push(new e.V(r2, o2, 'either "type" or "ref" is required'));
          let s2 = e.u(o2.type);
          const l2 = e.u(o2.ref);
          if (o2.id) {
            const n3 = e.u(o2.id);
            for (let s3 = 0; s3 < t2.arrayIndex; s3++) {
              const t3 = a2.layers[s3];
              e.u(t3.id) === n3 && i2.push(new e.V(r2, o2.id, `duplicate layer id "${o2.id}", previously used at line ${t3.id.__line__}`));
            }
          }
          if ("ref" in o2) {
            let t3;
            ["type", "source", "source-layer", "filter", "layout"].forEach((t4) => {
              t4 in o2 && i2.push(new e.V(r2, o2[t4], `"${t4}" is prohibited for ref layers`));
            }), a2.layers.forEach((i3) => {
              e.u(i3.id) === l2 && (t3 = i3);
            }), t3 ? t3.ref ? i2.push(new e.V(r2, o2.ref, "ref cannot reference another ref layer")) : s2 = e.u(t3.type) : "string" == typeof l2 && i2.push(new e.V(r2, o2.ref, `ref layer "${l2}" not found`));
          } else if ("background" !== s2 && "sky" !== s2 && "slot" !== s2)
            if (o2.source) {
              const t3 = a2.sources && a2.sources[o2.source], n3 = t3 && e.u(t3.type);
              t3 ? "vector" === n3 && "raster" === s2 ? i2.push(new e.V(r2, o2.source, `layer "${o2.id}" requires a raster source`)) : "raster" === n3 && "raster" !== s2 ? i2.push(new e.V(r2, o2.source, `layer "${o2.id}" requires a vector source`)) : "vector" !== n3 || o2["source-layer"] ? "raster-dem" === n3 && "hillshade" !== s2 ? i2.push(new e.V(r2, o2.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "raster-array" !== n3 || ["raster", "raster-particle"].includes(s2) ? "line" !== s2 || !o2.paint || !o2.paint["line-gradient"] && !o2.paint["line-trim-offset"] || "geojson" === n3 && t3.lineMetrics ? "raster-particle" === s2 && "raster-array" !== n3 && i2.push(new e.V(r2, o2.source, `layer "${o2.id}" requires a 'raster-array' source.`)) : i2.push(new e.V(r2, o2, `layer "${o2.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : i2.push(new e.V(r2, o2.source, "raster-array source can only be used with layer type 'raster'.")) : i2.push(new e.V(r2, o2, `layer "${o2.id}" must specify a "source-layer"`)) : i2.push(new e.V(r2, o2.source, `source "${o2.source}" not found`));
            } else
              i2.push(new e.V(r2, o2, 'missing required property "source"'));
          return i2 = i2.concat(ce({ key: r2, value: o2, valueSpec: n2.layer, style: t2.style, styleSpec: t2.styleSpec, objectElementValidators: { "*": () => [], type: () => De({ key: `${r2}.type`, value: o2.type, valueSpec: n2.layer.type, style: t2.style, styleSpec: t2.styleSpec, object: o2, objectKey: "type" }), filter: (t3) => me(e.q({ layerType: s2 }, t3)), layout: (t3) => ce({ layer: o2, key: t3.key, value: t3.value, valueSpec: {}, style: t3.style, styleSpec: t3.styleSpec, objectElementValidators: { "*": (t4) => ye(e.q({ layerType: s2 }, t4)) } }), paint: (t3) => ce({ layer: o2, key: t3.key, value: t3.value, valueSpec: {}, style: t3.style, styleSpec: t3.styleSpec, objectElementValidators: { "*": (t4) => xe(e.q({ layerType: s2, layer: o2 }, t4)) } }) } })), i2;
        }
        function we(t2) {
          const i2 = t2.value, o2 = t2.key, r2 = e.o(i2);
          return "string" !== r2 ? [new e.V(o2, i2, `string expected, ${r2} found`)] : [];
        }
        const Te = { promoteId: function({ key: t2, value: i2 }) {
          if ("string" === e.o(i2))
            return we({ key: t2, value: i2 });
          {
            const e2 = [];
            for (const o2 in i2)
              e2.push(...we({ key: `${t2}.${o2}`, value: i2[o2] }));
            return e2;
          }
        } };
        function Ee(t2) {
          const i2 = t2.value, o2 = t2.key, r2 = t2.styleSpec, a2 = t2.style;
          if (!i2.type)
            return [new e.V(o2, i2, '"type" is required')];
          const n2 = e.u(i2.type);
          let s2 = [];
          switch (["vector", "raster", "raster-dem", "raster-array"].includes(n2) && (i2.url || i2.tiles || s2.push(new e.n(o2, i2, 'Either "url" or "tiles" is required.'))), n2) {
            case "vector":
            case "raster":
            case "raster-dem":
            case "raster-array":
              return s2 = s2.concat(ce({ key: o2, value: i2, valueSpec: r2[`source_${n2.replace("-", "_")}`], style: t2.style, styleSpec: r2, objectElementValidators: Te })), s2;
            case "geojson":
              if (s2 = ce({ key: o2, value: i2, valueSpec: r2.source_geojson, style: a2, styleSpec: r2, objectElementValidators: Te }), i2.cluster)
                for (const e2 in i2.clusterProperties) {
                  const [t3, r3] = i2.clusterProperties[e2], a3 = "string" == typeof t3 ? [t3, ["accumulated"], ["get", e2]] : t3;
                  s2.push(...de({ key: `${o2}.${e2}.map`, value: r3, expressionContext: "cluster-map" })), s2.push(...de({ key: `${o2}.${e2}.reduce`, value: a3, expressionContext: "cluster-reduce" }));
                }
              return s2;
            case "video":
              return ce({ key: o2, value: i2, valueSpec: r2.source_video, style: a2, styleSpec: r2 });
            case "image":
              return ce({ key: o2, value: i2, valueSpec: r2.source_image, style: a2, styleSpec: r2 });
            case "canvas":
              return [new e.V(o2, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")];
            default:
              return fe({ key: `${o2}.type`, value: i2.type, valueSpec: { values: Ce(r2) }, style: a2, styleSpec: r2 });
          }
        }
        function Ce(e2) {
          return e2.source.reduce((t2, i2) => {
            const o2 = e2[i2];
            return "enum" === o2.type.type && (t2 = t2.concat(Object.keys(o2.type.values))), t2;
          }, []);
        }
        function Se(t2) {
          const i2 = t2.value, o2 = t2.styleSpec, r2 = o2.light, a2 = t2.style;
          let n2 = [];
          const s2 = e.o(i2);
          if (void 0 === i2)
            return n2;
          if ("object" !== s2)
            return n2 = n2.concat([new e.V("light", i2, `object expected, ${s2} found`)]), n2;
          for (const t3 in i2) {
            const s3 = t3.match(/^(.*)-transition$/);
            n2 = n2.concat(s3 && r2[s3[1]] && r2[s3[1]].transition ? De({ key: t3, value: i2[t3], valueSpec: o2.transition, style: a2, styleSpec: o2 }) : r2[t3] ? De({ key: t3, value: i2[t3], valueSpec: r2[t3], style: a2, styleSpec: o2 }) : [new e.V(t3, i2[t3], `unknown property "${t3}"`)]);
          }
          return n2;
        }
        function Ie(t2) {
          const i2 = t2.value;
          let o2 = [];
          if (!i2)
            return o2;
          const r2 = e.o(i2);
          if ("object" !== r2)
            return o2 = o2.concat([new e.V("light-3d", i2, `object expected, ${r2} found`)]), o2;
          const a2 = t2.styleSpec, n2 = a2["light-3d"], s2 = t2.key, l2 = t2.style, c2 = t2.style.lights;
          for (const t3 of ["type", "id"])
            if (!(t3 in i2))
              return o2 = o2.concat([new e.V("light-3d", i2, `missing property ${t3} on light`)]), o2;
          if (i2.type && c2)
            for (let r3 = 0; r3 < t2.arrayIndex; r3++) {
              const t3 = e.u(i2.type), a3 = c2[r3];
              e.u(a3.type) === t3 && o2.push(new e.V(s2, i2.id, `duplicate light type "${i2.type}", previously defined at line ${a3.id.__line__}`));
            }
          const h2 = `properties_light_${i2.type}`;
          if (!(h2 in a2))
            return o2 = o2.concat([new e.V("light-3d", i2, `Invalid light type ${i2.type}`)]), o2;
          const _2 = a2[h2];
          for (const r3 in i2)
            if ("properties" === r3) {
              const n3 = i2[r3], s3 = e.o(n3);
              if ("object" !== s3)
                return o2 = o2.concat([new e.V("properties", n3, `object expected, ${s3} found`)]), o2;
              for (const i3 in n3)
                o2 = o2.concat(_2[i3] ? De({ key: i3, value: n3[i3], valueSpec: _2[i3], style: l2, styleSpec: a2 }) : [new e.n(t2.key, n3[i3], `unknown property "${i3}"`)]);
            } else {
              const t3 = r3.match(/^(.*)-transition$/);
              o2 = o2.concat(t3 && n2[t3[1]] && n2[t3[1]].transition ? De({ key: r3, value: i2[r3], valueSpec: a2.transition, style: l2, styleSpec: a2 }) : n2[r3] ? De({ key: r3, value: i2[r3], valueSpec: n2[r3], style: l2, styleSpec: a2 }) : [new e.n(r3, i2[r3], `unknown property "${r3}"`)]);
            }
          return o2;
        }
        function Le(t2) {
          const i2 = t2.value, o2 = t2.key, r2 = t2.style, a2 = t2.styleSpec, n2 = a2.terrain;
          let s2 = [];
          const l2 = e.o(i2);
          if (void 0 === i2)
            return s2;
          if ("null" === l2)
            return s2;
          if ("object" !== l2)
            return s2 = s2.concat([new e.V("terrain", i2, `object expected, ${l2} found`)]), s2;
          for (const t3 in i2) {
            const o3 = t3.match(/^(.*)-transition$/);
            s2 = s2.concat(o3 && n2[o3[1]] && n2[o3[1]].transition ? De({ key: t3, value: i2[t3], valueSpec: a2.transition, style: r2, styleSpec: a2 }) : n2[t3] ? De({ key: t3, value: i2[t3], valueSpec: n2[t3], style: r2, styleSpec: a2 }) : [new e.n(t3, i2[t3], `unknown property "${t3}"`)]);
          }
          if (i2.source) {
            const t3 = r2.sources && r2.sources[i2.source], a3 = t3 && e.u(t3.type);
            t3 ? "raster-dem" !== a3 && s2.push(new e.V(o2, i2.source, `terrain cannot be used with a source of type ${String(a3)}, it only be used with a "raster-dem" source type`)) : s2.push(new e.V(o2, i2.source, `source "${i2.source}" not found`));
          } else
            s2.push(new e.V(o2, i2, 'terrain is missing required property "source"'));
          return s2;
        }
        function Pe(t2) {
          const i2 = t2.value, o2 = t2.style, r2 = t2.styleSpec, a2 = r2.fog;
          let n2 = [];
          const s2 = e.o(i2);
          if (void 0 === i2)
            return n2;
          if ("object" !== s2)
            return n2 = n2.concat([new e.V("fog", i2, `object expected, ${s2} found`)]), n2;
          for (const t3 in i2) {
            const s3 = t3.match(/^(.*)-transition$/);
            n2 = n2.concat(s3 && a2[s3[1]] && a2[s3[1]].transition ? De({ key: t3, value: i2[t3], valueSpec: r2.transition, style: o2, styleSpec: r2 }) : a2[t3] ? De({ key: t3, value: i2[t3], valueSpec: a2[t3], style: o2, styleSpec: r2 }) : [new e.n(t3, i2[t3], `unknown property "${t3}"`)]);
          }
          return n2;
        }
        const Re = { "*": () => [], array: he, boolean: function(t2) {
          const i2 = t2.value, o2 = t2.key, r2 = e.o(i2);
          return "boolean" !== r2 ? [new e.V(o2, i2, `boolean expected, ${r2} found`)] : [];
        }, number: _e, color: function(t2) {
          const i2 = t2.key, o2 = t2.value, r2 = e.o(o2);
          return "string" !== r2 ? [new e.V(i2, o2, `color expected, ${r2} found`)] : null === e.G(o2) ? [new e.V(i2, o2, `color expected, "${o2}" found`)] : [];
        }, enum: fe, filter: me, function: ue, layer: be, object: ce, source: Ee, model: e.L, light: Se, "light-3d": Ie, terrain: Le, fog: Pe, string: we, formatted: function(e2) {
          return 0 === we(e2).length ? [] : de(e2);
        }, resolvedImage: function(e2) {
          return 0 === we(e2).length ? [] : de(e2);
        }, projection: function(t2) {
          const i2 = t2.value, o2 = t2.styleSpec, r2 = o2.projection, a2 = t2.style;
          let n2 = [];
          const s2 = e.o(i2);
          if ("object" === s2)
            for (const e2 in i2)
              n2 = n2.concat(De({ key: e2, value: i2[e2], valueSpec: r2[e2], style: a2, styleSpec: o2 }));
          else
            "string" !== s2 && (n2 = n2.concat([new e.V("projection", i2, `object or string expected, ${s2} found`)]));
          return n2;
        }, import: function(t2) {
          const { value: i2, styleSpec: o2 } = t2, _a2 = i2, { data: r2 } = _a2, a2 = __objRest(_a2, ["data"]);
          Object.defineProperty(a2, "__line__", { value: i2.__line__, enumerable: false });
          let n2 = ce(e.q({}, t2, { value: a2, valueSpec: o2.import }));
          return "" === e.u(a2.id) && n2.push(new e.V(`${t2.key}.id`, a2, "import id can't be an empty string")), r2 && (n2 = n2.concat(Me(r2, o2, { key: `${t2.key}.data` }))), n2;
        } };
        function De(t2, i2 = false) {
          const o2 = t2.value, r2 = t2.valueSpec, a2 = t2.styleSpec;
          if (r2.expression && e.J(e.u(o2)))
            return ue(t2);
          if (r2.expression && e.v(e.x(o2)))
            return de(t2);
          if (r2.type && Re[r2.type]) {
            const o3 = Re[r2.type](t2);
            return true === i2 && o3.length > 0 && "array" === e.o(t2.value) ? de(t2) : o3;
          }
          return ce(e.q({}, t2, { valueSpec: r2.type ? a2[r2.type] : r2 }));
        }
        function Ae(t2) {
          const i2 = t2.value, o2 = t2.key, r2 = we(t2);
          return r2.length || (-1 === i2.indexOf("{fontstack}") && r2.push(new e.V(o2, i2, '"glyphs" url must include a "{fontstack}" token')), -1 === i2.indexOf("{range}") && r2.push(new e.V(o2, i2, '"glyphs" url must include a "{range}" token'))), r2;
        }
        function Me(t2, i2 = e.N, o2 = {}) {
          return De({ key: o2.key || "", value: t2, valueSpec: i2.$root, styleSpec: i2, style: t2, objectElementValidators: { glyphs: Ae, "*": () => [] } });
        }
        function ze(t2, i2 = e.N) {
          return Ze(Me(t2, i2));
        }
        const Oe = (e2) => Ze(Ee(e2)), Fe = (e2) => Ze(Se(e2)), Be = (e2) => Ze(Ie(e2)), ke = (e2) => Ze(Le(e2)), Ne = (e2) => Ze(Pe(e2)), Ue = (e2) => Ze(be(e2)), Ge = (e2) => Ze(me(e2)), je = (e2) => Ze(xe(e2)), Ve = (e2) => Ze(ye(e2)), $e = (t2) => Ze(e.L(t2));
        function Ze(e2) {
          return e2.slice().sort((e3, t2) => e3.line && t2.line ? e3.line - t2.line : 0);
        }
        function We(t2, i2) {
          let o2 = false;
          if (i2 && i2.length)
            for (const r2 of i2)
              r2 instanceof e.n ? e.w(r2.message) : (t2.fire(new e.f(new Error(r2.message))), o2 = true);
          return o2;
        }
        let He;
        class qe extends e.E {
          constructor(t2, i2 = "flat") {
            super(), this._transitionable = new e.O(He || (He = new e.U({ anchor: new e.W(e.N.light.anchor), position: new e.X(e.N.light.position), color: new e.W(e.N.light.color), intensity: new e.W(e.N.light.intensity) }))), this.setLight(t2, i2), this._transitioning = this._transitionable.untransitioned();
          }
          getLight() {
            return this._transitionable.serialize();
          }
          setLight(e2, t2, i2 = {}) {
            this._validate(Fe, e2, i2) || (this._transitionable.setTransitionOrValue(e2), this.id = t2);
          }
          updateTransitions(e2) {
            this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
          }
          hasTransition() {
            return this._transitioning.hasTransition();
          }
          recalculate(e2) {
            this.properties = this._transitioning.possiblyEvaluate(e2);
          }
          _validate(t2, i2, o2) {
            return (!o2 || false !== o2.validate) && We(this, t2.call(ze, e.Q({ value: i2, style: { glyphs: true, sprite: true }, styleSpec: e.N })));
          }
        }
        const Xe = new e.U({ source: new e.W(e.N.terrain.source), exaggeration: new e.W(e.N.terrain.exaggeration) });
        let Qe = class extends e.E {
          constructor(t2, i2, o2, r2) {
            super(), this.scope = o2, this._transitionable = new e.O(Xe, o2, r2), this._transitionable.setTransitionOrValue(t2, r2), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = i2;
          }
          get() {
            return this._transitionable.serialize();
          }
          set(e2, t2) {
            this._transitionable.setTransitionOrValue(e2, t2);
          }
          updateTransitions(e2) {
            this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
          }
          hasTransition() {
            return this._transitioning.hasTransition();
          }
          recalculate(e2) {
            this.properties = this._transitioning.possiblyEvaluate(e2);
          }
          getExaggeration(t2) {
            return this._transitioning.possiblyEvaluate(new e.Y(t2)).get("exaggeration");
          }
          isZoomDependent() {
            const t2 = this._transitionable._values.exaggeration;
            return null != t2 && null != t2.value && null != t2.value.expression && t2.value.expression instanceof e.Z;
          }
        };
        const Ye = 45, Je = 65, Ke = 0.05;
        function et(t2, i2, o2, r2) {
          const a2 = e.a0(Ye, Je, o2), [n2, s2] = tt(t2, r2);
          let l2 = 1 - Math.min(1, Math.exp((i2 - n2) / (s2 - n2) * -6));
          return l2 *= l2 * l2, l2 = Math.min(1, 1.00747 * l2), l2 * a2 * t2.alpha;
        }
        function tt(e2, t2) {
          const i2 = 0.5 / Math.tan(0.5 * t2);
          return [e2.range[0] + i2, e2.range[1] + i2];
        }
        function it(t2, i2, o2, r2, a2) {
          const n2 = e.$.transformMat4([], [i2, o2, r2], a2.mercatorFogMatrix);
          return et(t2, e.$.length(n2), a2.pitch, a2._fov);
        }
        function ot(t2, i2, o2, r2, a2, n2, s2) {
          const l2 = [[o2, r2, 0], [a2, r2, 0], [a2, n2, 0], [o2, n2, 0]];
          let c2 = Number.MAX_VALUE, h2 = -Number.MAX_VALUE;
          for (const t3 of l2) {
            const o3 = e.$.transformMat4([], t3, i2), r3 = e.$.length(o3);
            c2 = Math.min(c2, r3), h2 = Math.max(h2, r3);
          }
          return [et(t2, c2, s2.pitch, s2._fov), et(t2, h2, s2.pitch, s2._fov)];
        }
        const rt = new e.U({ range: new e.W(e.N.fog.range), color: new e.W(e.N.fog.color), "high-color": new e.W(e.N.fog["high-color"]), "space-color": new e.W(e.N.fog["space-color"]), "horizon-blend": new e.W(e.N.fog["horizon-blend"]), "star-intensity": new e.W(e.N.fog["star-intensity"]), "vertical-range": new e.W(e.N.fog["vertical-range"]) });
        class at extends e.E {
          constructor(t2, i2, o2, r2) {
            super(), this._transitionable = new e.O(rt, o2, new Map(r2)), this.set(t2, r2), this._transitioning = this._transitionable.untransitioned(), this._transform = i2, this.properties = new e.a1(rt), this.scope = o2;
          }
          get state() {
            const t2 = this._transform, i2 = "globe" === t2.projection.name, o2 = e.a2(t2.zoom), r2 = this.properties.get("range"), a2 = [0.5, 3];
            return { range: i2 ? [e.a3(a2[0], r2[0], o2), e.a3(a2[1], r2[1], o2)] : r2, horizonBlend: this.properties.get("horizon-blend"), alpha: this.properties.get("color").a };
          }
          get() {
            return this._transitionable.serialize();
          }
          set(t2, i2, o2 = {}) {
            if (this._validate(Ne, t2, o2))
              return;
            const r2 = e.Q({}, t2);
            for (const t3 of Object.keys(e.N.fog))
              void 0 === r2[t3] && (r2[t3] = e.N.fog[t3].default);
            this._options = r2, this._transitionable.setTransitionOrValue(this._options, i2);
          }
          getOpacity(t2) {
            if (!this._transform.projection.supportsFog)
              return 0;
            const i2 = this.properties && this.properties.get("color") || 1;
            return ("globe" === this._transform.projection.name ? 1 : e.a0(Ye, Je, t2)) * i2.a;
          }
          getOpacityAtLatLng(t2, i2) {
            return this._transform.projection.supportsFog ? function(t3, i3, o2) {
              const r2 = e._.fromLngLat(i3), a2 = o2.elevation ? o2.elevation.getAtPointOrZero(r2) : 0;
              return it(t3, r2.x, r2.y, a2, o2);
            }(this.state, t2, i2) : 0;
          }
          getOpacityForTile(t2) {
            if (!this._transform.projection.supportsFog)
              return [1, 1];
            const i2 = this._transform.calculateFogTileMatrix(t2.toUnwrapped());
            return ot(this.state, i2, 0, 0, e.a4, e.a4, this._transform);
          }
          getOpacityForBounds(e2, t2, i2, o2, r2) {
            return this._transform.projection.supportsFog ? ot(this.state, e2, t2, i2, o2, r2, this._transform) : [1, 1];
          }
          getFovAdjustedRange(e2) {
            return this._transform.projection.supportsFog ? tt(this.state, e2) : [0, 1];
          }
          isVisibleOnFrustum(t2) {
            if (!this._transform.projection.supportsFog)
              return false;
            const i2 = [4, 5, 6, 7];
            for (const o2 of i2) {
              const i3 = t2.points[o2];
              let r2;
              if (i3[2] >= 0)
                r2 = i3;
              else {
                const a2 = t2.points[o2 - 4];
                r2 = e.a5(a2, i3, a2[2] / (a2[2] - i3[2]));
              }
              if (it(this.state, r2[0], r2[1], 0, this._transform) >= Ke)
                return true;
            }
            return false;
          }
          updateConfig(e2) {
            this._transitionable.setTransitionOrValue(this._options, new Map(e2));
          }
          updateTransitions(e2) {
            this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
          }
          hasTransition() {
            return this._transitioning.hasTransition();
          }
          recalculate(e2) {
            this.properties = this._transitioning.possiblyEvaluate(e2);
          }
          _validate(t2, i2, o2) {
            return (!o2 || false !== o2.validate) && We(this, t2.call(ze, e.Q({ value: i2, style: { glyphs: true, sprite: true }, styleSpec: e.N })));
          }
        }
        class nt extends e.E {
          constructor(t2, i2, o2, r2) {
            super(), this.scope = o2, this._options = t2, this.properties = new e.a1(i2), this._transitionable = new e.O(i2, o2, new Map(r2)), this._transitionable.setTransitionOrValue(t2.properties), this._transitioning = this._transitionable.untransitioned();
          }
          updateConfig(e2) {
            this._transitionable.setTransitionOrValue(this._options.properties, new Map(e2));
          }
          updateTransitions(e2) {
            this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
          }
          hasTransition() {
            return this._transitioning.hasTransition();
          }
          recalculate(e2) {
            this.properties = this._transitioning.possiblyEvaluate(e2);
          }
          get() {
            return this._options.properties = this._transitionable.serialize(), this._options;
          }
          set(e2, t2) {
            this._options = e2, this._transitionable.setTransitionOrValue(e2.properties, t2);
          }
          shadowsEnabled() {
            return !!this.properties && true === this.properties.get("cast-shadows");
          }
        }
        let st, lt;
        var ct = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#ifdef RENDER_CUTOFF\nfloat cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}\n#endif", ht = "\nout vec4 glFragColor;highp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}\n#ifdef INDICATOR_CUTOUT\nuniform vec2 u_indicator_cutout_centers;uniform vec4 u_indicator_cutout_params;\n#endif\nvec4 applyCutout(vec4 color) {\n#ifdef INDICATOR_CUTOUT\nfloat holeMinOpacity=u_indicator_cutout_params.x;float holeRadius=max(u_indicator_cutout_params.y,0.0);float holeAspectRatio=u_indicator_cutout_params.z;float fadeStart=u_indicator_cutout_params.w;float distA=distance(vec2(gl_FragCoord.x,gl_FragCoord.y*holeAspectRatio),vec2(u_indicator_cutout_centers[0],u_indicator_cutout_centers[1]*holeAspectRatio));return color*min(smoothstep(fadeStart,holeRadius,distA)+holeMinOpacity,1.0);\n#else\nreturn color;\n#endif\n}\n#ifdef DEBUG_WIREFRAME\n#define HANDLE_WIREFRAME_DEBUG \\\nglFragColor=vec4(0.7,0.0,0.0,0.7); \\\ngl_FragDepth=gl_FragCoord.z-0.0001;\n#else\n#define HANDLE_WIREFRAME_DEBUG\n#endif\n#ifdef RENDER_CUTOFF\nuniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;\n#endif\nvec4 textureLodCustom(sampler2D image,vec2 pos,vec2 lod_coord) {vec2 size=vec2(textureSize(image,0));vec2 dx=dFdx(lod_coord.xy*size);vec2 dy=dFdy(lod_coord.xy*size);float delta_max_sqr=max(dot(dx,dx),dot(dy,dy));float lod=0.5*log2(delta_max_sqr);return textureLod(image,pos,lod);}vec4 applyLUT(highp sampler3D lut,vec4 col) {vec3 size=vec3(textureSize(lut,0));vec3 uvw=(col.rbg*float(size-1.0)+0.5)/size;return vec4(texture(lut,uvw).rgb,col.a);}vec3 applyLUT(highp sampler3D lut,vec3 col) {return applyLUT(lut,vec4(col,1.0)).rgb;}", _t = "\n#define EXTENT 8192.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}\n#ifdef RENDER_CUTOFF\nuniform vec4 u_cutoff_params;out float v_cutoff_opacity;\n#endif\nconst vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(vec2 posWithComposedSkirt)\n{float skirt=float(posWithComposedSkirt.x >=skirtOffset);vec2 pos=posWithComposedSkirt-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}", ut = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", dt = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nreturn currentElevation(apos);}\n#endif\nvec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }\n#endif\n#ifdef DEPTH_OCCLUSION\nuniform highp sampler2D u_depth;uniform highp vec2 u_depth_size_inv;uniform highp vec2 u_depth_range_unpack;uniform highp float u_occluder_half_size;uniform highp float u_occlusion_depth_offset;\n#ifdef DEPTH_D24\nfloat unpack_depth(float depth) {return depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}vec4 unpack_depth4(vec4 depth) {return depth*u_depth_range_unpack.x+vec4(u_depth_range_unpack.y);}\n#else\nhighp float unpack_depth_rgba(vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;\n#ifdef DEPTH_D24\nfloat depth=unpack_depth(texture(u_depth,(coord.xy+1.0)*0.5).r);\n#else\nfloat depth=unpack_depth_rgba(texture(u_depth,(coord.xy+1.0)*0.5));\n#endif\nreturn coord.z+u_occlusion_depth_offset > depth;}highp vec4 getCornerDepths(vec2 coord) {highp vec3 df=vec3(u_occluder_half_size*u_depth_size_inv,0.0);highp vec2 uv=0.5*coord.xy+0.5;\n#ifdef DEPTH_D24\nhighp vec4 depth=vec4(\ntexture(u_depth,uv-df.xz).r,texture(u_depth,uv+df.xz).r,texture(u_depth,uv-df.zy).r,texture(u_depth,uv+df.zy).r\n);depth=unpack_depth4(depth);\n#else\nhighp vec4 depth=vec4(\nunpack_depth_rgba(texture(u_depth,uv-df.xz)),unpack_depth_rgba(texture(u_depth,uv+df.xz)),unpack_depth_rgba(texture(u_depth,uv-df.zy)),unpack_depth_rgba(texture(u_depth,uv+df.zy))\n);\n#endif\nreturn depth;}highp float occlusionFadeMultiSample(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec2 uv=0.5*coord.xy+0.5;int NX=3;int NY=4;highp vec2 df=u_occluder_half_size*u_depth_size_inv;highp vec2 oneStep=2.0*u_occluder_half_size*u_depth_size_inv/vec2(NX-1,NY-1);highp float res=0.0;for (int y=0; y < NY;++y) {for (int x=0; x < NX;++x) {\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)));\n#endif\nres+=1.0-clamp(300.0*(coord.z+u_occlusion_depth_offset-depth),0.0,1.0);}}res=clamp(2.0*res/float(NX*NY)-0.5,0.0,1.0);return res;}highp float occlusionFade(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec4 depth=getCornerDepths(coord.xy);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z+u_occlusion_depth_offset)-depth),0.0,1.0));}\n#else\nbool isOccluded(vec4 frag) { return false; }highp float occlusionFade(vec4 frag) { return 1.0; }highp float occlusionFadeMultiSample(vec4 frag) { return 1.0; }\n#endif//DEPTH_OCCLUSION", pt = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", ft = "highp vec3 hash(highp vec2 p) {highp vec3 p3=fract(p.xyx*vec3(443.8975,397.2973,491.1871));p3+=dot(p3,p3.yxz+19.19);return fract((p3.xxy+p3.yzz)*p3.zyx);}vec3 dither(vec3 color,highp vec2 seed) {vec3 rnd=hash(seed)+hash(seed+0.59374)-0.5;return color+rnd/255.0;}\n#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {\n#ifdef FOG_DITHERING\nvec2 dither_seed=gl_FragCoord.xy+u_fog_temporal_offset;return dither(color,dither_seed);\n#else\nreturn color;\n#endif\n}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif", mt = "#ifdef RASTER_ARRAY\nuniform sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);ivec4 _raTexLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}vec2 _raTexLinearMix(highp vec2 fxy,highp vec4 colorMix,highp float colorOffset,highp vec4 t00,highp vec4 t10,highp vec4 t01,highp vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image0,c.yz,0),texelFetch(u_image0,c.xz,0),texelFetch(u_image0,c.yw,0),texelFetch(u_image0,c.xw,0)\n);}vec2 raTexture2D_image1_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image1,c.yz,0),texelFetch(u_image1,c.xz,0),texelFetch(u_image1,c.yw,0),texelFetch(u_image1,c.xw,0)\n);}vec2 raTexture2D_image0_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image0,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image1,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}\n#endif", gt = "#ifdef RASTER_ARRAY\nuniform sampler2D u_velocity;uniform mediump vec2 u_velocity_res;uniform mediump float u_max_speed;const vec4 NO_DATA=vec4(1);const vec2 INVALID_VELOCITY=vec2(-1);uniform highp vec2 u_uv_offset;uniform highp float u_data_offset;uniform highp vec2 u_data_scale;ivec4 rasterArrayLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}highp vec2 lookup_velocity(highp vec2 uv) {uv=u_uv_offset.x+u_uv_offset.y*uv;highp vec2 fxy;ivec4 c=rasterArrayLinearCoord(uv,u_velocity_res,fxy);highp vec4 tl=texelFetch(u_velocity,c.yz,0);highp vec4 tr=texelFetch(u_velocity,c.xz,0);highp vec4 bl=texelFetch(u_velocity,c.yw,0);highp vec4 br=texelFetch(u_velocity,c.xw,0);if (tl==NO_DATA) {return INVALID_VELOCITY;}if (tr==NO_DATA) {return INVALID_VELOCITY;}if (bl==NO_DATA) {return INVALID_VELOCITY;}if (br==NO_DATA) {return INVALID_VELOCITY;}highp vec4 t=mix(mix(bl,br,fxy.x),mix(tl,tr,fxy.x),fxy.y);highp vec2 velocity=u_data_offset+vec2(dot(t.rg,u_data_scale),dot(t.ba,u_data_scale));velocity.y=-velocity.y;velocity/=max(u_max_speed,length(velocity));return velocity;}\n#endif\nuniform highp float u_particle_pos_scale;uniform highp vec2 u_particle_pos_offset;highp vec4 pack_pos_to_rgba(highp vec2 p) {highp vec2 v=(p+u_particle_pos_offset)/u_particle_pos_scale;highp vec4 r=vec4(v.x,fract(v.x*255.0),v.y,fract(v.y*255.0));return vec4(r.x-r.y/255.0,r.y,r.z-r.w/255.0,r.w);}highp vec2 unpack_pos_from_rgba(highp vec4 v) {v=floor(v*255.0+0.5)/255.0;highp vec2 p=vec2(v.x+(v.y/255.0),v.z+(v.w/255.0));return u_particle_pos_scale*p-u_particle_pos_offset;}", vt = "#ifdef RENDER_SHADOWS\nuniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {vec3 transformed_normal=vec3(-normal.xy,normal.z);float NDotL=dot(normalize(transformed_normal),u_shadow_direction);float dotScale=min(1.0-NDotL,1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}\n#endif//RENDER_SHADOWS", xt = "#ifdef RENDER_SHADOWS\n#ifdef DEPTH_TEXTURE\nuniform highp sampler2D u_shadowmap_0;uniform highp sampler2D u_shadowmap_1;\n#else\nuniform sampler2D u_shadowmap_0;uniform sampler2D u_shadowmap_1;\n#endif\nuniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;highp float shadow_sample_1(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_1,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_1,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}highp float shadow_sample_0(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_0,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_0,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}float shadow_occlusion_1(highp vec4 pos,highp float bias) {highp vec2 uv=pos.xy;return shadow_sample_1(uv,pos.z-bias);}float shadow_occlusion_0(highp vec4 pos,highp float bias) {highp float compare0=pos.z-bias;\n#ifdef NATIVE\nhighp vec2 uv=pos.xy;highp vec4 samples=textureGather(u_shadowmap_0,uv,0);lowp vec4 stepSamples=step(samples,vec4(compare0));\n#else\nhighp vec2 uv00=pos.xy-vec2(0.5*u_shadow_texel_size);highp vec2 uv10=uv00+vec2(u_shadow_texel_size,0.0);highp vec2 uv01=uv00+vec2(0.0,u_shadow_texel_size);highp vec2 uv11=uv01+vec2(u_shadow_texel_size,0.0);lowp vec4 stepSamples=vec4(\nshadow_sample_0(uv01,compare0),shadow_sample_0(uv11,compare0),shadow_sample_0(uv10,compare0),shadow_sample_0(uv00,compare0)\n);\n#endif\nvec2 f=fract(pos.xy*u_shadow_map_resolution-vec2(0.5));lowp vec2 lerpx=mix(stepSamples.wx,stepSamples.zy,f.xx);return mix(lerpx.x,lerpx.y,f.y);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {\n#ifdef SHADOWS_SINGLE_CASCADE\nlight_view_pos0.xyz=light_view_pos0.xyz/light_view_pos0.w*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);\n#else\nlight_view_pos0.xyz/=light_view_pos0.w;light_view_pos1.xyz/=light_view_pos1.w;vec4 uv=vec4(light_view_pos0.xy,light_view_pos1.xy);vec4 abs_bounds=abs(uv);if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {light_view_pos0.xyz=light_view_pos0.xyz*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}light_view_pos1.xyz=light_view_pos1.xyz*0.5+0.5;float occlusion1=shadow_occlusion_1(light_view_pos1,bias);return mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth));\n#endif\n}highp float calculate_shadow_bias(float NDotL) {\n#ifdef NORMAL_OFFSET\nreturn 0.5*u_shadow_bias.x;\n#else\nreturn 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));\n#endif\n}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_opacity(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,float shadow_opacity) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias)*shadow_opacity;return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}\n#endif";
        const yt = [];
        St(ct, yt), St(_t, yt), St(ht, yt);
        const bt = { "_prelude_fog.vertex.glsl": pt, "_prelude_terrain.vertex.glsl": dt, "_prelude_shadow.vertex.glsl": vt, "_prelude_fog.fragment.glsl": ft, "_prelude_shadow.fragment.glsl": xt, "_prelude_lighting.glsl": "\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}\n#endif//LIGHTING_3D_MODE", "_prelude_raster_array.glsl": mt, "_prelude_raster_particle.glsl": gt }, wt = {};
        It("", dt), It(ft, pt), It(xt, vt), It(mt, ""), It(gt, "");
        const Tt = It(ht, _t), Et = ct;
        var Ct = { background: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec4 u_color;uniform float u_opacity;\n#ifdef LIGHTING_3D_MODE\nin vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_lighting.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec4 u_color;out vec4 v_color;uniform float u_emissive_strength;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), backgroundPattern: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in vec2 v_pos;void main() {vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=textureLodCustom(u_image,pos,v_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), circle: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float blur_positive=blur < 0.0 ? 0.0 : 1.0;lowp float antialiasblur=v_data.z;float extrude_length=length(extrude)+antialiasblur*(1.0-blur_positive);float antialiased_blur=-max(abs(blur),antialiasblur);float opacity_t=smoothstep((1.0-blur_positive)*antialiased_blur,blur_positive*antialiased_blur,extrude_length-1.0)-smoothstep(0.0,antialiasblur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\nglFragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);float height=circle_elevation(circle_center);world_center=vec4(circle_center,height,1);\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}'), clippingMask: It("void main() {glFragColor=vec4(1.0);}", "in vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), heatmap: It('#include "_prelude_fog.fragment.glsl"\nuniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'), heatmapTexture: It("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"), collisionBox: It("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", '#include "_prelude_terrain.vertex.glsl"\nin vec3 a_pos;in vec2 a_anchor_pos;in vec2 a_extrude;in vec2 a_placed;in vec2 a_shift;in float a_size_scale;in vec2 a_padding;in float a_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;out float v_placed;out float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*(a_z_offset+elevation(a_anchor_pos)),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}'), collisionCircle: It("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", "in vec2 a_pos_2f;in float a_radius;in vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"), debug: It("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", '#include "_prelude_terrain.vertex.glsl"\nin vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;\n#endif\nout vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}'), fill: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), fillOutline: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin highp vec2 v_pos;uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;out highp vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), fillOutlinePattern: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_emissive_strength;in highp vec2 v_pos;in highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;out highp vec2 v_pos;out highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);v_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), fillPattern: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;in vec2 v_pos;uniform float u_emissive_strength;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), fillExtrusion: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec4 v_color;in vec4 v_flat;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\nuniform lowp float u_opacity;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec2 v_ao;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nin vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nin highp vec3 v_normal;\n#endif\nuniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nin float v_flood_radius;in float v_has_floodlight;\n#endif\nuniform float u_emissive_strength;in float v_height;void main() {\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nvec3 normal=normalize(v_normal);\n#endif\nfloat z;vec4 color=v_color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);\n#ifdef LIGHTING_3D_MODE\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#else\ncolor=mix(v_color,v_roof_color,z);\n#endif\n#endif\nfloat h=max(0.0,v_height);float ao_shade=1.0;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\ncolor.rgb*=mix(ao_shade,1.0,v_has_floodlight);\n#else\ncolor.rgb*=ao_shade;\n#endif\n#else\ncolor.rgb*=ao_shade;\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nfloat flood_radiance=0.0;\n#ifdef FLOOD_LIGHT\nflood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef FLOOD_LIGHT\nfloat ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);\n#else\nfloat shadowed_lighting_factor;\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\ncolor.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);\n#endif\n#else\ncolor.rgb=apply_lighting(color.rgb,normal);\n#ifdef FLOOD_LIGHT\ncolor.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);\n#endif\n#endif\ncolor.rgb=mix(color.rgb,v_flat.rgb,u_emissive_strength);color*=u_opacity;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));\n#endif\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;uniform float u_alignment;uniform float u_width_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec4 a_join_normal_inside_polygon;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nuniform highp float u_vertical_scale;out vec4 v_color;out vec4 v_flat;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nout vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nout highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec2 v_ao;\n#endif\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nout float v_flood_radius;out float v_has_floodlight;\n#endif\nout float v_height;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define highp float flood_light_wall_radius\n#pragma mapbox: define highp float line_width\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize highp float flood_light_wall_radius\n#pragma mapbox: initialize highp float line_width\nbase*=u_vertical_scale;height*=u_vertical_scale;vec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nv_normal=normal;\n#endif\nbase=max(0.0,base);float attr_height=height;height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;float c_ele=0.0;vec3 pos;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat cutoff=1.0;vec3 scaled_pos=pos;\n#ifdef RENDER_CUTOFF\nvec3 centroid_random=vec3(centroid_pos.xy,centroid_pos.x+centroid_pos.y+1.0);vec3 ground_pos=centroid_pos.x==0.0 ? pos.xyz : (centroid_random/8.0);vec4 ground=u_matrix*vec4(ground_pos.xy,ele,1.0);cutoff=cutoff_opacity(u_cutoff_params,ground.z);if (centroid_pos.y !=0.0 && centroid_pos.x !=0.0) {vec3 g=floor(ground_pos);vec3 mod_=centroid_random-g*8.0;float seed=min(1.0,0.1*(min(3.5,max(mod_.x+mod_.y,0.2*attr_height))*0.35+mod_.z));if (cutoff < 0.8-seed) {cutoff=0.0;}}float cutoff_scale=cutoff;v_cutoff_opacity=cutoff;scaled_pos.z=mix(c_ele,h,cutoff_scale);\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (cutoff==0.0 && centroid_pos.x !=0.0));\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside_polygon.xy/EXTENT);float isPolygon=a_join_normal_inside_polygon.w;float sideAlignment=abs(isPolygon*u_alignment);scaled_pos.xy+=(1.0-a_join_normal_inside_polygon.z)*mix(wall_offset*0.5,wall_offset*mix(1.0,0.0,max(u_alignment,0.0)),sideAlignment);scaled_pos.xy-=a_join_normal_inside_polygon.z*mix(wall_offset*0.5,wall_offset*mix(0.0,1.0,max(u_alignment,0.0)),sideAlignment);\n#endif\ngl_Position=mix(u_matrix*vec4(scaled_pos,1),AWAY,hidden);h=h-ele;v_height=h;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifndef LIGHTING_3D_MODE\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#endif\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\nfloat is_wall=1.0-float(t > 0.0 && top_up_ny.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;\n#endif\nv_color=vec4(color.rgb,1.0);v_flat=vec4(linearProduct(color.rgb,vec3(calculate_NdotL(normal))),1.0);\n#else\nv_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'), fillExtrusionDepth: It("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_alignment;uniform float u_width_scale;uniform float u_vertical_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec4 a_join_normal_inside_polygon;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp float line_width\nout highp float v_depth;void main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp float line_width\nbase*=u_vertical_scale;height*=u_vertical_scale;vec3 pos_nx=floor(a_pos_normal_ed.xyz*0.5);mediump vec3 top_up_ny=a_pos_normal_ed.xyz-2.0*pos_nx;base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nvec3 pos;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;float ele=elevation(pos_nx.xy);float c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;float h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base);pos=vec3(pos_nx.xy,h);\n#else\npos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside_polygon.xy/EXTENT);float isPolygon=a_join_normal_inside_polygon.w;float sideAlignment=abs(isPolygon*u_alignment);pos.xy+=(1.0-a_join_normal_inside_polygon.z)*mix(wall_offset*0.5,wall_offset*mix(1.0,0.0,max(u_alignment,0.0)),sideAlignment);pos.xy-=a_join_normal_inside_polygon.z*mix(wall_offset*0.5,wall_offset*mix(0.0,1.0,max(u_alignment,0.0)),sideAlignment);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);v_depth=gl_Position.z/gl_Position.w;}'), fillExtrusionPattern: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nin vec3 v_normal;\n#endif\nin vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_alignment;uniform float u_width_scale;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec4 a_join_normal_inside_polygon;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nout vec2 v_pos;out vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nout vec3 v_normal;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\n#pragma mapbox: define highp float line_width\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\n#pragma mapbox: initialize highp float line_width\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside_polygon.xy/EXTENT);float isPolygon=a_join_normal_inside_polygon.w;float sideAlignment=abs(isPolygon*u_alignment);p.xy+=(1.0-a_join_normal_inside_polygon.z)*mix(wall_offset*0.5,wall_offset*mix(1.0,0.0,max(u_alignment,0.0)),sideAlignment);p.xy-=a_join_normal_inside_polygon.z*mix(wall_offset*0.5,wall_offset*mix(0.0,1.0,max(u_alignment,0.0)),sideAlignment);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_normal=normal;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif \n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}'), groundShadow: It('#include "_prelude_shadow.fragment.glsl"\nprecision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\nvoid main() {float light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);\n#ifdef RENDER_CUTOFF\nshadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w));\n#endif\n#ifdef FOG\nshadow=mix(shadow,vec3(1.0),v_fog_opacity);\n#endif\n#ifdef INDICATOR_CUTOUT\nshadow=mix(shadow,vec3(1.0),1.0-applyCutout(vec4(1.0)).r);\n#endif\nglFragColor=vec4(shadow,1.0);}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in vec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);v_fog_opacity=fog(v_fog_pos);\n#endif\n}'), fillExtrusionGroundEffect: It("uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;\n#ifdef SDF_SUBPASS\nin highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}\n#ifdef FOG\nin highp float v_fog;\n#endif\n#endif\nvoid main() {\n#ifdef CLEAR_SUBPASS\nvec4 color=vec4(1.0);\n#ifdef CLEAR_FROM_TEXTURE\ncolor=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));\n#endif\nglFragColor=color;\n#else\n#ifdef SDF_SUBPASS\nhighp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;\n#ifdef FOG\nfog=v_fog;\n#endif\n#ifdef RENDER_CUTOFF\nfog*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));\n#else\nvec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);\n#ifdef OVERDRAW_INSPECTOR\ncolor=vec4(1.0);\n#endif\nglFragColor=color;\n#endif\nHANDLE_WIREFRAME_DEBUG;\n#endif\n}", '#include "_prelude_fog.vertex.glsl"\nin highp vec4 a_pos_end;in highp float a_angular_offset_factor;in highp float a_hidden_by_landmark;\n#ifdef SDF_SUBPASS\nout highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;\n#ifdef FOG\nout highp float v_fog;\n#endif\n#endif\nuniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp vec2 u_ao;\n#pragma mapbox: define highp float flood_light_ground_radius\nconst float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {\n#pragma mapbox: initialize highp float flood_light_ground_radius\nvec2 p=a_pos_end.xy;vec2 q=floor(a_pos_end.zw*0.5);vec2 start_bottom=a_pos_end.zw-q*2.0;float fl_ground_radius=flood_light_ground_radius;fl_ground_radius=abs(flood_light_ground_radius);float direction=flood_light_ground_radius < 0.0 ?-1.0 : 1.0;float flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=a_angular_offset_factor/NORM*TANGENT_CUTOFF;float angular_offset=direction*angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(1.0,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=direction*perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;\n#ifdef SDF_SUBPASS\nv_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);\n#ifdef FOG\nv_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);\n#endif\n#endif\nfloat hidden_by_landmark=0.0;\n#ifdef HAS_CENTROID\nhidden_by_landmark=a_hidden_by_landmark;\n#endif\nfloat isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'), hillshadePrepare: It("precision highp float;uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"), hillshade: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\nglFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);\n#endif\n#ifdef FOG\nglFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), line: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform lowp float u_device_pixel_ratio;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;in vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\nfloat luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture(u_dash_image,v_tex).r;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/dash.z;alpha*=linearstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trim_alpha=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);out_color=mix(out_color,u_trim_color,transition_factor);trim_alpha=out_color.a;}\n#endif\nif (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}\n#ifdef RENDER_LINE_BORDER\nfloat edgeBlur=(border_width+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2.t-edgeBlur),v_width2.s-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);if (border_color.a==0.0) {float Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}} else {out_color.rgb=mix(border_color.rgb*border_color.a*trim_alpha,out_color.rgb,smoothAlpha);}}\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(alpha*opacity);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define EXTRUDE_SCALE 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED)\nin float a_z_offset;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nin highp vec4 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nin float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);\n#if defined(ELEVATED)\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 halfCellProgress=normal.yx*32.0;float ele0=elevation(pos);float ele_line=max(ele0,max(elevation(pos+halfCellProgress),elevation(pos-halfCellProgress)));float ele1=elevation(pos+offsetTile);float ele2=elevation(pos-offsetTile);float ele_max=max(ele_line,0.5*(ele1+ele2));float ele=ele_max-ele0+ele1+a_z_offset ;gl_Position=u_matrix*vec4(pos+offsetTile,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*0.1*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);\n#else\ngl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nfloat a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec4(a_uv_x,a_split_index*texel_height-half_texel_height,a_clip_start,a_clip_end);\n#else\nv_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat scale=dash.z==0.0 ? 0.0 : u_tile_units_to_pixels/dash.z;float height=dash.y;v_tex=vec2(a_linesofar*scale/floorwidth,(-normal.y*height+dash.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'), linePattern: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform highp float u_device_pixel_ratio;uniform highp float u_alpha_discard_threshold;uniform highp vec2 u_texsize;uniform highp float u_tile_units_to_pixels;uniform highp vec2 u_trim_offset;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in highp float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec4 v_uv;\n#endif\n#ifdef LINE_JOIN_NONE\nin vec2 v_pattern_data;\n#endif\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;float pattern_size=display_size.x/u_tile_units_to_pixels;float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);highp float pattern_x=v_linesofar/pattern_size*aspect;float x=mod(pattern_x,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));vec2 lod_pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(pattern_x,y));vec4 color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {if (line_progress <=trim_end && line_progress >=trim_start) {color=vec4(0,0,0,0);}}\n#endif\n#ifdef LINE_JOIN_NONE\nfloat pattern_len=pattern_size/aspect;float segment_phase=pattern_len-mod(v_linesofar-v_pattern_data.x+pattern_len,pattern_len);float visible_start=segment_phase-step(pattern_len*0.5,segment_phase)*pattern_len;float visible_end=floor((v_pattern_data.y-segment_phase)/pattern_len)*pattern_len+segment_phase;visible_end+=step(pattern_len*0.5,v_pattern_data.y-visible_end)*pattern_len;if (v_pattern_data.x < visible_start || v_pattern_data.x >=visible_end) {color=vec4(0.0);}\n#endif\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting_ground(color);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=(alpha*opacity);if (u_alpha_discard_threshold !=0.0) {if (color.a < u_alpha_discard_threshold) {discard;}}\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED)\nin float a_z_offset;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec4 a_packed;\n#endif\nin highp float a_linesofar;\n#ifdef LINE_JOIN_NONE\nin highp vec3 a_pattern_data;out vec2 v_pattern_data;\n#endif\nuniform mat4 u_matrix;uniform float u_tile_units_to_pixels;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out highp float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nout highp vec4 v_uv;\n#endif\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define mediump float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float floorwidth\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define mediump float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize mediump float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize mediump float pixel_ratio\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);vec2 dist=outset*a_extrude*scale;float u=0.5*a_direction;float t=1.0-abs(u);vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);\n#if defined(ELEVATED)\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 halfCellProgress=normal.yx*32.0;float ele0=elevation(pos);float ele_line=max(ele0,max(elevation(pos+halfCellProgress),elevation(pos-halfCellProgress)));float ele1=elevation(pos+offsetTile);float ele2=elevation(pos-offsetTile);float ele_max=max(ele_line,0.5*(ele1+ele2));float ele=ele_max-ele0+ele1+a_z_offset ;gl_Position=u_matrix*vec4(pos+offsetTile,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*0.1*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);\n#else\ngl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nfloat a_uv_x=a_packed[0];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];v_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;\n#ifdef LINE_JOIN_NONE\nv_width=floorwidth+ANTIALIASING;mediump float pixels_to_tile_units=1.0/u_tile_units_to_pixels;mediump float pixel_ratio_inverse=1.0/pixel_ratio;mediump float aspect=v_width/((pattern.w-pattern.y)*pixel_ratio_inverse);highp float subt_multiple=(pattern.z-pattern.x)*pixel_ratio_inverse*pixels_to_tile_units*aspect*32.0;highp float subt=floor(a_pattern_data.z/subt_multiple)*subt_multiple;float offset_sign=(fract(a_pattern_data.x)-0.5)*4.0;float line_progress_offset=offset_sign*v_width*0.5*pixels_to_tile_units;v_linesofar=(a_pattern_data.z-subt)+a_linesofar+line_progress_offset;v_pattern_data=vec2(a_pattern_data.x+line_progress_offset,a_pattern_data.y);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'), raster: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_raster_array.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;uniform highp float u_zoom_transition;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nin float v_split_fade;\n#endif\nuniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;\n#ifndef RASTER_ARRAY\nuniform sampler2D u_image0;uniform sampler2D u_image1;\n#endif\n#ifdef RASTER_COLOR\nuniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;\n#endif\nvoid main() {vec4 color0,color1,color;vec2 value;\n#ifdef RASTER_COLOR\n#ifdef RASTER_ARRAY\n#ifdef RASTER_ARRAY_LINEAR\nvalue=mix(\nraTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#else\nvalue=mix(\nraTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#endif\nif (value.y > 0.0) value.x/=value.y;\n#else\ncolor=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);\n#endif\ncolor=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;\n#else\ncolor0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);\n#endif\ncolor.a*=u_opacity;\n#ifdef GLOBE_POLES\ncolor.a*=1.0-smoothstep(0.0,0.05,u_zoom_transition);\n#endif\nvec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef PROJECTION_GLOBE_VIEW\nglFragColor*=mix(1.0,1.0-smoothstep(0.0,0.05,u_zoom_transition),smoothstep(0.8,0.9,v_split_fade));\n#endif\n#ifdef RENDER_CUTOFF\nglFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;in vec2 a_texture_pos;\n#endif\nout vec2 v_pos0;out vec2 v_pos1;out float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nout float v_split_fade;\n#endif\nvoid main() {vec2 uv;\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos   ,1.0);uv=a_uv;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);\n#endif\n#else\nfloat w=1.0+dot(a_texture_pos,u_perspective_transform);uv=a_texture_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);    \nv_split_fade=0.0;if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;float opposite_merc_center=mod(u_merc_center.x+0.5,1.0);float dist_from_poles=(abs(mercatorY-0.5)*2.0);float range=0.1;v_split_fade=abs(opposite_merc_center-mercatorX);v_split_fade=clamp(1.0-v_split_fade,0.0,1.0);v_split_fade=max(smoothstep(1.0-range,1.0,dist_from_poles),max(smoothstep(1.0-range,1.0,v_split_fade),smoothstep(1.0-range,1.0,1.0-v_split_fade)));}float tiles=u_grid_matrix[0][2];if (tiles > 0.0) {float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvY=mercatorY*tiles-idy;float uvX=mercatorX*tiles-idx;uv=vec2(uvX,uvY);}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\ngl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;\n#ifdef RENDER_CUTOFF\nv_depth=gl_Position.z;\n#endif\n}'), rasterParticle: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;uniform sampler2D u_image0;uniform sampler2D u_image1;void main() {vec4 color0,color1,color;color0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 out_color=color.rgb;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),0.0).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\nin vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {float w=1.0;vec2 uv;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);float tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvX=mercatorX*tiles-idx;float uvY=mercatorY*tiles-idy;uv=vec2(uvX,uvY);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nuv=a_texture_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}'), rasterParticleDraw: It("uniform sampler2D u_color_ramp;in float v_particle_speed;void main() {glFragColor=texture(u_color_ramp,vec2(v_particle_speed,0.5));}", '#include "_prelude_raster_particle.glsl"\nin float a_index;uniform sampler2D u_particle_texture;uniform float u_particle_texture_side_len;uniform vec2 u_tile_offset;out float v_particle_speed;void main() {ivec2 pixel_coord=ivec2(\nmod(a_index,u_particle_texture_side_len),a_index/u_particle_texture_side_len);vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);vec2 pos=unpack_pos_from_rgba(pixel)+u_tile_offset;vec2 tex_coord=fract(pos);vec2 velocity=lookup_velocity(tex_coord);if (velocity==INVALID_VELOCITY) {gl_Position=AWAY;v_particle_speed=0.0;} else {gl_Position=vec4(2.0*pos-1.0,0,1);v_particle_speed=length(velocity);}gl_PointSize=1.0;}'), rasterParticleTexture: It("uniform sampler2D u_texture;uniform float u_opacity;in vec2 v_tex_pos;void main() {vec4 color=texture(u_texture,v_tex_pos);glFragColor=vec4(floor(255.0*color*u_opacity)/255.0);}", "in vec2 a_pos;out vec2 v_tex_pos;void main() {vec2 uv=0.5*a_pos+vec2(0.5);v_tex_pos=uv;gl_Position=vec4(a_pos,0.0,1.0);}"), rasterParticleUpdate: It('#include "_prelude_raster_particle.glsl"\nuniform sampler2D u_particle_texture;uniform mediump float u_particle_texture_side_len;uniform mediump float u_speed_factor;uniform highp float u_reset_rate;uniform highp float u_rand_seed;in highp vec2 v_tex_coord;vec2 linearstep(vec2 edge0,vec2 edge1,vec2 x) {return  clamp((x-edge0)/(edge1-edge0),vec2(0),vec2(1));}const highp vec3 rand_constants=vec3(12.9898,78.233,4375.85453);highp float rand(const highp vec2 co) {highp float t=dot(rand_constants.xy,co);return fract(sin(t)*(rand_constants.z+t));}void main() {ivec2 pixel_coord=ivec2(v_tex_coord*u_particle_texture_side_len);highp vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);highp vec2 pos=unpack_pos_from_rgba(pixel);highp vec2 velocity=lookup_velocity(clamp(pos,0.0,1.0));highp vec2 dp=velocity==INVALID_VELOCITY ? vec2(0) : velocity*u_speed_factor;pos=pos+dp;highp vec2 seed=(pos+v_tex_coord)*u_rand_seed;highp vec2 random_pos=vec2(rand(seed+1.3),rand(seed+2.1));highp vec2 persist_rate=pow(\nlinearstep(vec2(-u_particle_pos_offset),vec2(0),pos)*linearstep(vec2(1.0+u_particle_pos_offset),vec2(1),pos),vec2(4)\n);highp vec2 per_frame_persist=pow(persist_rate,abs(dp)/u_particle_pos_offset);highp float drop_rate=1.0-per_frame_persist.x*per_frame_persist.y;drop_rate=any(greaterThanEqual(abs(pos-0.5),vec2(0.5+u_particle_pos_offset))) ? 1.0 : drop_rate;highp float drop=step(1.0-drop_rate-u_reset_rate,rand(seed));highp vec2 next_pos=mix(pos,random_pos,drop);glFragColor=pack_pos_to_rgba(next_pos);}', "in vec2 a_pos;out vec2 v_tex_coord;void main() {v_tex_coord=0.5*(a_pos+vec2(1.0));gl_Position=vec4(a_pos,0.0,1.0);}"), symbolIcon: It('#include "_prelude_lighting.glsl"\nuniform sampler2D u_texture;\n#ifdef ICON_TRANSITION\nuniform float u_icon_transition;\n#endif\nin float v_fade_opacity;in vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nin vec2 v_tex_b;\n#endif\n#ifdef COLOR_ADJUSTMENT\nuniform mat4 u_color_adj_mat;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float emissive_strength\nlowp float alpha=opacity*v_fade_opacity;vec4 out_color;\n#ifdef ICON_TRANSITION\nvec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b);\n#else\nout_color=texture(u_texture,v_tex_a);\n#endif\n#ifdef COLOR_ADJUSTMENT\nout_color=u_color_adj_mat*out_color;\n#endif\nout_color*=alpha;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\n#ifdef Z_OFFSET\nin float a_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef ICON_TRANSITION\nin vec2 a_texb;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform vec3 u_up_vector;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nout vec2 v_tex_b;\n#endif\nout float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float emissive_strength\n#pragma mapbox: define lowp float occlusion_opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float emissive_strength\n#pragma mapbox: initialize lowp float occlusion_opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=a_globe_anchor+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjected_point;vec2 a;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetProjected_point=u_matrix*vec4(a_globe_anchor+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;\n#else\noffsetProjected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;\n#endif\nvec2 b=offsetProjected_point.xy/offsetProjected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=globe_occlusion_fade;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float out_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change))*projection_transition_fade;float alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nv_tex_a=a_tex/u_texsize;\n#ifdef ICON_TRANSITION\nv_tex_b=a_texb/u_texsize;\n#endif\nv_fade_opacity=out_fade_opacity;\n#ifdef DEPTH_OCCLUSION\nfloat depthOcclusion=occlusionFadeMultiSample(projected_point);float depthOcclusionMultplier=mix(occlusion_opacity,1.0,depthOcclusion);v_fade_opacity*=depthOcclusionMultplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);v_fade_opacity*=occludedFadeMultiplier;\n#endif\n}'), symbolSDF: It('#include "_prelude_lighting.glsl"\n#define SDF_PX 8.0\nuniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_halo;in float v_draw_halo;in vec2 v_data0;in vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);vec4 out_color=color*(alpha*opacity*fade_opacity);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout float v_draw_halo;out vec2 v_data0;out vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\n#pragma mapbox: define lowp float occlusion_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\n#pragma mapbox: initialize lowp float occlusion_opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=a_globe_anchor+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;vec2 a;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;\n#endif\nvec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=globe_occlusion_fade;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float out_fade_opacity=interpolated_fade_opacity*projection_transition_fade;\n#ifdef DEPTH_OCCLUSION\nfloat depthOcclusion=occlusionFadeMultiSample(projected_point);float depthOcclusionMultplier=mix(occlusion_opacity,1.0,depthOcclusion);out_fade_opacity*=depthOcclusionMultplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);out_fade_opacity*=occludedFadeMultiplier;\n#endif\nfloat alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nfloat gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,out_fade_opacity);}'), symbolTextAndIcon: It('#include "_prelude_lighting.glsl"\n#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_halo;in float v_draw_halo;in vec4 v_data0;in vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;glFragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);vec4 out_color=color*(alpha*opacity*fade_opacity);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\n#ifdef Z_OFFSET\nin float a_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout float v_draw_halo;out vec4 v_data0;out vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\n#pragma mapbox: define lowp float occlusion_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\n#pragma mapbox: initialize lowp float occlusion_opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offset_projected_point=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projected_point.xy/projected_point.w;vec2 b=offset_projected_point.xy/offset_projected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*font_scale);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=globe_occlusion_fade;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nfloat out_fade_opacity=interpolated_fade_opacity*projection_transition_fade;\n#ifdef DEPTH_OCCLUSION\nfloat depthOcclusion=occlusionFadeMultiSample(projected_point);float depthOcclusionMultplier=mix(occlusion_opacity,1.0,depthOcclusion);out_fade_opacity*=depthOcclusionMultplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);out_fade_opacity*=occludedFadeMultiplier;\n#endif\nfloat alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+ xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nfloat gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,out_fade_opacity,is_sdf);}'), terrainRaster: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;in vec2 v_pos0;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#endif\nuniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;\n#ifdef LIGHTING_3D_MODE\nconst vec3 normal=vec3(0.0,0.0,1.0);\n#ifdef RENDER_SHADOWS\nfloat cutoffOpacity=1.0;\n#ifdef RENDER_CUTOFF\ncutoffOpacity=cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w);\n#endif\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nvec3 unlit_base=image_color.rgb*(1.0-image_color.a);vec3 emissive_base=image_color.rgb*image_color.a;float ndotl=u_shadow_direction.z;float occlusion=ndotl < 0.0 ? 1.0 : shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,0.0);ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;\n#else\nfloat lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));\n#endif\n#else\nfloat lighting_factor=u_lighting_directional_dir.z;color=apply_lighting(image_color,normal,lighting_factor);\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor.rgb=mix(color.rgb,image_color.rgb,image_color.a);color.a=1.0;\n#endif\n#endif\n#else\ncolor=image_color;\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_skirt_height;in vec2 a_pos;out vec2 v_pos0;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth;\n#endif\nvoid main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);\n#endif\n}'), terrainDepth: It("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;out float v_depth;void main() {float elevation=elevation(a_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}'), skybox: It('#include "_prelude_fog.fragment.glsl"\nin lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color.rgb=dither(sky_color.rgb,gl_FragCoord.xy+u_temporal_offset);sky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', ut), skyboxGradient: It('#include "_prelude_fog.fragment.glsl"\nin highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;color.rgb=dither(color.rgb,gl_FragCoord.xy+u_temporal_offset);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', ut), skyboxCapture: It("\nin highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}", "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"), globeRaster: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;uniform float u_far_z_cutoff;in vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nvec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);vec3 dir=normalize(ray_dir);vec3 closest_point=dot(u_globe_pos,dir)*dir;float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nraster=apply_lighting_with_emission_ground(raster,raster.a);color=vec4(raster.rgb*antialias,antialias);\n#else\nraster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor=apply_lighting_with_emission_ground(color,color.a);color.a=1.0;\n#else\ncolor=apply_lighting_ground(color);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=1.0-step(u_far_z_cutoff,1.0/gl_FragCoord.w);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;\n#endif\nout vec2 v_pos0;void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);globe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}'), globeAtmosphere: It('#include "_prelude_fog.fragment.glsl"\nuniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {\n#ifdef ALPHA_PASS\nglFragColor=vec4(0,0,0,0);return;\n#else\n#ifdef NATIVE\nglFragColor=vec4(1,1,1,1);\n#else\nglFragColor=vec4(0,0,0,1);\n#endif\nreturn;\n#endif\n}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;\n#ifdef ALPHA_PASS\nfloat a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);\n#else\nvec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;\n#ifndef NATIVE\nc=dither(c,gl_FragCoord.xy+u_temporal_offset);\n#endif\nglFragColor=vec4(c*t,t);\n#endif\n}', "in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}"), model: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_opacity;uniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;uniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nuniform vec4 u_occlusionTextureTransform;\n#endif\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#ifdef HAS_ATTRIBUTE_a_pbr\nin lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;\n#endif\n#ifdef HAS_TEXTURE_u_baseColorTexture\nuniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;\n#endif\n#ifdef HAS_TEXTURE_u_metallicRoughnessTexture\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\n#ifdef HAS_TEXTURE_u_occlusionTexture\nuniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;\n#endif\n#ifdef HAS_TEXTURE_u_normalTexture\nuniform sampler2D u_normalTexture;\n#endif\n#ifdef HAS_TEXTURE_u_emissionTexture\nuniform sampler2D u_emissionTexture;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nin highp float v_depth;uniform highp sampler2D u_depthTexture;uniform vec2 u_inv_depth_size;uniform vec2 u_depth_range_unpack;\n#ifdef DEPTH_D24\nfloat unpack_depth(float depth) {return  depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}\n#else\nhighp float unpack_depth_rgba(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded() {vec2 coord=gl_FragCoord.xy*u_inv_depth_size;\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depthTexture,coord).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depthTexture,coord));\n#endif\nreturn v_depth > depth+0.0005;}\n#endif\n#define saturate(_x) clamp(_x,0.,1.)\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)\n{\n#ifdef LIGHTING_3D_MODE\nvec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));\n#endif\nreturn apply_lighting(albedo,transformed_normal,lighting_factor);\n#else\nvec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;\n#endif\n}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;\n#ifdef HAS_ATTRIBUTE_a_color_3f\nalbedo*=vec4(color_3f,1.0);\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#else\n#ifdef HAS_ATTRIBUTE_a_color_4f\nalbedo*=color_4f;\n#endif\n#endif\n#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)\nvec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}\n#ifdef UNPREMULT_TEXTURE_IN_SHADER\nif(texColor.w > 0.0) {texColor.rgb/=texColor.w;}texColor.w=1.0;\n#endif\nif(u_baseTextureIsAlpha) {if (texColor.r < 0.5) {discard;}} else {texColor.rgb=sRGBToLinear(texColor.rgb);albedo*=texColor;}\n#endif\nvec4 color=vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\nreturn color;}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {\n#ifdef HAS_TEXTURE_u_normalTexture\nhighp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=dp2perp*duv1.x+dp1perp*duv2.x;highp vec3 B=dp2perp*duv1.y+dp1perp*duv2.y;highp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;\n#else\nreturn mat3(1.0);\n#endif\n}highp vec3 getNormal(){highp vec3 n;\n#ifdef HAS_ATTRIBUTE_a_normal_3f\nn=normalize(normal_3f);\n#else\nhighp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));n=normalize(cross(fdx,fdy))*-1.0;\n#endif\n#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=normalize(-v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);\n#endif\nreturn n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;\n#ifdef HAS_ATTRIBUTE_a_pbr\nmat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;\n#endif\n#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f) \nvec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;\n#endif\nconst float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)\n{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)\n{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)\n{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)\n{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)\n{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)\n{\n#ifdef LIGHTING_3D_MODE\nreturn mat.diffuseColor;\n#else\nreturn mat.diffuseColor/PI;\n#endif\n}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)\n{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)\n{vec3 env_light=vec3(0.65,0.65,0.65);\n#ifdef LIGHTING_3D_MODE\nfloat ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;\n#endif\nvec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)\n{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=NdotL;\n#endif\nvec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;\n#if !defined(LIGHTING_3D_MODE)\nconst vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);\n#endif\ncolor*=intensityFactor;return color;}void main() {\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nif (isOccluded()) {discard;}\n#endif\nvec3 lightDir=u_lightpos;vec3 lightColor=u_lightcolor;\n#ifdef LIGHTING_3D_MODE\nlightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;\n#endif\nvec4 finalColor;\n#ifdef DIFFUSE_SHADED\nvec3 N=getNormal();vec3 baseColor=getBaseColor().rgb;vec3 diffuse=getDiffuseShadedColor(baseColor,N,lightDir,lightColor);\n#ifdef HAS_TEXTURE_u_occlusionTexture\nfloat ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;\n#endif\nfinalColor=vec4(mix(diffuse,baseColor,u_emissive_strength),1.0)*u_opacity;\n#else\nMaterial mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;\n#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nvec2 uv=uv_2f.xy*u_occlusionTextureTransform.zw+u_occlusionTextureTransform.xy;\n#else\nvec2 uv=uv_2f;\n#endif\nao=(texture(u_occlusionTexture,uv).x-1.0)*u_aoIntensity+1.0;color*=ao;\n#endif\nvec4 emissive=u_emissiveFactor;\n#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nemissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nfloat emissiveFactorLength=max(length(u_emissiveFactor.rgb),0.001);emissive.rgb=sRGBToLinear(applyLUT(u_lutTexture,linearTosRGB(emissive.rgb/emissiveFactorLength).rbg))*emissiveFactorLength;\n#endif\ncolor+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;\n#ifdef HAS_ATTRIBUTE_a_pbr\nfloat resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);vec3 color_mix=v_color_mix.rgb;\n#ifdef APPLY_LUT_ON_GPU\ncolor_mix=applyLUT(u_lutTexture,color_mix);\n#endif\ncolor=mix(color,color_mix,min(1.0,resEmission));\n#ifdef HAS_ATTRIBUTE_a_color_4f\nfloat distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);\n#endif\n#endif\nvec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);\n#endif\n#ifdef FOG\nfinalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));\n#endif\n#ifdef RENDER_CUTOFF\nfinalColor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\nfinalColor=applyCutout(finalColor);\n#endif\nglFragColor=finalColor;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute-vertex-shader-only highp vec4 pbr\n#pragma mapbox: define-attribute-vertex-shader-only highp vec3 heightBasedEmissiveStrength\nuniform mat4 u_matrix;uniform mat4 u_node_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_normal_matrix;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nout vec4 v_position_height;out lowp vec4 v_color_mix;\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nout highp float v_depth;\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\nout lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute-custom highp vec4 pbr\n#pragma mapbox: initialize-attribute-custom highp vec3 heightBasedEmissiveStrength\nhighp mat4 normal_matrix;\n#ifdef INSTANCED_ARRAYS\nnormal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\nnormal_matrix=u_normal_matrix;\n#endif\nvec3 local_pos;mat3 rs;\n#ifdef MODEL_POSITION_ON_GPU\nvec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float hidden=float(pos_a.x > EXTENT);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=mix(u_matrix*pos,AWAY,hidden);pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;\n#else\nlocal_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);\n#endif\nv_position_height.w=a_pos_3f.z;\n#ifdef HAS_ATTRIBUTE_a_pbr\nvec4 albedo_c=decode_color(pbr.xy);vec2 e_r_m=unpack_float(pbr.z);vec2 r_m= unpack_float(e_r_m.y*16.0);r_m.r=r_m.r*16.0;v_color_mix=vec4(albedo_c.rgb,1.0);v_roughness_metallic_emissive_alpha=vec4(vec3(r_m,e_r_m.x)/255.0,albedo_c.a);v_roughness_metallic_emissive_alpha.z*=2.0;float heightBasedRelativeIntepolation=a_pos_3f.z*heightBasedEmissiveStrength.x+heightBasedEmissiveStrength.y;v_height_based_emission_params.x=heightBasedRelativeIntepolation;v_height_based_emission_params.y=heightBasedEmissiveStrength.z;vec2 emissionMultiplierValues=unpack_float(pbr.w)/256.0;v_height_based_emission_params.z=emissionMultiplierValues.x;v_height_based_emission_params.w=emissionMultiplierValues.y-emissionMultiplierValues.x;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(local_pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nfloat x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_3f=rs*((u_lighting_matrix*vec4(normal_3f,0.0)).xyz/squared_scale);normal_3f=normalize(normal_3f);\n#else\nnormal_3f=vec3(normal_matrix*vec4(normal_3f,0));\n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#ifdef HAS_ATTRIBUTE_a_color_4f\nv_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shadow_pos=u_node_matrix*vec4(local_pos,1.0);\n#ifdef NORMAL_OFFSET\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nvec3 offset=shadow_normal_offset(vec3(-normal_3f.xy,normal_3f.z));shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#else\nvec3 offset=shadow_normal_offset_model(normal_3f);shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#endif\n#endif\n#endif\nv_pos_light_view_0=u_light_matrix_0*shadow_pos;v_pos_light_view_1=u_light_matrix_1*shadow_pos;v_depth_shadows=gl_Position.w;\n#endif\n}'), modelDepth: It("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", "in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;\n#ifdef MODEL_POSITION_ON_GPU\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_instance;\n#endif\nuniform highp mat4 u_node_matrix;\n#endif\nvoid main() {\n#ifdef MODEL_POSITION_ON_GPU\nhighp mat4 instance;\n#ifdef INSTANCED_ARRAYS\ninstance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\ninstance=u_instance;\n#endif\nvec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float hidden=float(pos_a.x > EXTENT);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=mix(u_matrix*pos,AWAY,hidden);\n#else\ngl_Position=u_matrix*vec4(a_pos_3f,1);\n#endif\nv_depth=gl_Position.z/gl_Position.w;}"), stars: It("in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)\n{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}", "\nin vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_fade_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_fade_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}"), occlusion: It("uniform vec4 u_color;void main() {glFragColor=u_color;}", '#include "_prelude_terrain.vertex.glsl"\nin highp vec2 a_offset_xy;uniform highp vec3 u_anchorPos;uniform mat4 u_matrix;uniform vec2 u_screenSizePx;uniform vec2 u_occluderSizePx;void main() {vec3 world_pos=u_anchorPos;\n#ifdef TERRAIN\nfloat e=elevation(world_pos.xy);world_pos.z+=e;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1.0);projected_point.xy+=projected_point.w*a_offset_xy*0.5*u_occluderSizePx/u_screenSizePx;gl_Position=projected_point;}') };
        function St(e2, t2) {
          const i2 = e2.replace(/\s*\/\/[^\n]*\n/g, "\n").split("\n");
          for (let e3 of i2)
            if (e3 = e3.trim(), "#" === e3[0] && e3.includes("if") && !e3.includes("endif")) {
              e3 = e3.replace("#", "").replace(/ifdef|ifndef|elif|if/g, "").replace(/!|defined|\(|\)|\|\||&&/g, "").replace(/\s+/g, " ").trim();
              const i3 = e3.split(" ");
              for (const e4 of i3)
                t2.includes(e4) || t2.push(e4);
            }
        }
        function It(e2, t2) {
          const i2 = /#include\s+"([^"]+)"/g, o2 = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g;
          let r2 = t2.match(/(attribute(\S*)|(^\s*|;)in) (highp |mediump |lowp )?([\w]+) ([\w]+)/gm);
          r2 && (r2 = r2.map((e3) => {
            const t3 = e3.split(" ");
            return t3[t3.length - 1];
          }), r2 = [...new Set(r2)]);
          const a2 = {}, n2 = [], s2 = [];
          if (e2 = e2.replace(i2, (e3, t3) => (s2.push(t3), "")), (t2 = t2.replace(i2, (e3, t3) => (n2.push(t3), ""))).includes("flat out"))
            return void console.error('The usage of "flat" qualifier is disallowed, see: https://bugs.webkit.org/show_bug.cgi?id=268071');
          let l2 = [...yt];
          St(e2, l2), St(t2, l2);
          for (const e3 of [...n2, ...s2])
            bt[e3] || console.error(`Undefined include: ${e3}`), wt[e3] || (wt[e3] = [], St(bt[e3], wt[e3])), l2 = [...l2, ...wt[e3]];
          return { fragmentSource: e2 = e2.replace(o2, (e3, t3, i3, o3, r3) => (a2[r3] = true, "define" === t3 ? `
#ifndef HAS_UNIFORM_u_${r3}
in ${i3} ${o3} ${r3};
#else
uniform ${i3} ${o3} u_${r3};
#endif
` : "initialize" === t3 ? `
#ifdef HAS_UNIFORM_u_${r3}
    ${i3} ${o3} ${r3} = u_${r3};
#endif
` : "define-attribute" === t3 ? `
#ifdef HAS_ATTRIBUTE_a_${r3}
    in ${i3} ${o3} ${r3};
#endif
` : "initialize-attribute" === t3 ? "" : void 0)), vertexSource: t2 = t2.replace(o2, (e3, t3, i3, o3, r3) => {
            const n3 = "float" === o3 ? "vec2" : o3, s3 = r3.match(/color/) ? "color" : n3;
            return "define-attribute-vertex-shader-only" === t3 ? `
#ifdef HAS_ATTRIBUTE_a_${r3}
in ${i3} ${o3} a_${r3};
#endif
` : a2[r3] ? "define" === t3 ? `
#ifndef HAS_UNIFORM_u_${r3}
uniform lowp float u_${r3}_t;
in ${i3} ${n3} a_${r3};
out ${i3} ${o3} ${r3};
#else
uniform ${i3} ${o3} u_${r3};
#endif
` : "initialize" === t3 ? "vec4" === s3 ? `
#ifndef HAS_UNIFORM_u_${r3}
    ${r3} = a_${r3};
#else
    ${i3} ${o3} ${r3} = u_${r3};
#endif
` : `
#ifndef HAS_UNIFORM_u_${r3}
    ${r3} = unpack_mix_${s3}(a_${r3}, u_${r3}_t);
#else
    ${i3} ${o3} ${r3} = u_${r3};
#endif
` : "define-attribute" === t3 ? `
#ifdef HAS_ATTRIBUTE_a_${r3}
    in ${i3} ${o3} a_${r3};
    out ${i3} ${o3} ${r3};
#endif
` : "initialize-attribute" === t3 ? `
#ifdef HAS_ATTRIBUTE_a_${r3}
    ${r3} = a_${r3};
#endif
` : void 0 : "define" === t3 ? `
#ifndef HAS_UNIFORM_u_${r3}
uniform lowp float u_${r3}_t;
in ${i3} ${n3} a_${r3};
#else
uniform ${i3} ${o3} u_${r3};
#endif
` : "define-instanced" === t3 ? "mat4" === s3 ? `
#ifdef INSTANCED_ARRAYS
in vec4 a_${r3}0;
in vec4 a_${r3}1;
in vec4 a_${r3}2;
in vec4 a_${r3}3;
#else
uniform ${i3} ${o3} u_${r3};
#endif
` : `
#ifdef INSTANCED_ARRAYS
in ${i3} ${n3} a_${r3};
#else
uniform ${i3} ${o3} u_${r3};
#endif
` : "initialize-attribute-custom" === t3 ? `
#ifdef HAS_ATTRIBUTE_a_${r3}
    ${i3} ${o3} ${r3} = a_${r3};
#endif
` : "vec4" === s3 ? `
#ifndef HAS_UNIFORM_u_${r3}
    ${i3} ${o3} ${r3} = a_${r3};
#else
    ${i3} ${o3} ${r3} = u_${r3};
#endif
` : `
#ifndef HAS_UNIFORM_u_${r3}
    ${i3} ${o3} ${r3} = unpack_mix_${s3}(a_${r3}, u_${r3}_t);
#else
    ${i3} ${o3} ${r3} = u_${r3};
#endif
`;
          }), staticAttributes: r2, usedDefines: l2, vertexIncludes: n2, fragmentIncludes: s2 };
        }
        class Lt {
          constructor() {
            this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
          }
          bind(e2, t2, i2, o2, r2, a2, n2, s2) {
            this.context = e2;
            let l2 = this.boundPaintVertexBuffers.length !== o2.length;
            for (let e3 = 0; !l2 && e3 < o2.length; e3++)
              this.boundPaintVertexBuffers[e3] !== o2[e3] && (l2 = true);
            let c2 = this.boundDynamicVertexBuffers.length !== n2.length;
            for (let e3 = 0; !c2 && e3 < n2.length; e3++)
              this.boundDynamicVertexBuffers[e3] !== n2[e3] && (c2 = true);
            if (!this.vao || this.boundProgram !== t2 || this.boundLayoutVertexBuffer !== i2 || l2 || c2 || this.boundIndexBuffer !== r2 || this.boundVertexOffset !== a2)
              this.freshBind(t2, i2, o2, r2, a2, n2, s2);
            else {
              e2.bindVertexArrayOES.set(this.vao);
              for (const i3 of n2)
                i3 && (i3.bind(), s2 && i3.instanceCount && i3.setVertexAttribDivisor(e2.gl, t2, s2));
              r2 && r2.dynamicDraw && r2.bind();
            }
          }
          freshBind(e2, t2, i2, o2, r2, a2, n2) {
            const s2 = e2.numAttributes, l2 = this.context, c2 = l2.gl;
            this.vao && this.destroy(), this.vao = l2.gl.createVertexArray(), l2.bindVertexArrayOES.set(this.vao), this.boundProgram = e2, this.boundLayoutVertexBuffer = t2, this.boundPaintVertexBuffers = i2, this.boundIndexBuffer = o2, this.boundVertexOffset = r2, this.boundDynamicVertexBuffers = a2, t2.enableAttributes(c2, e2), t2.bind(), t2.setVertexAttribPointers(c2, e2, r2);
            for (const t3 of i2)
              t3.enableAttributes(c2, e2), t3.bind(), t3.setVertexAttribPointers(c2, e2, r2);
            for (const t3 of a2)
              t3 && (t3.enableAttributes(c2, e2), t3.bind(), t3.setVertexAttribPointers(c2, e2, r2), n2 && t3.instanceCount && t3.setVertexAttribDivisor(c2, e2, n2));
            o2 && o2.bind(), l2.currentNumAttributes = s2;
          }
          destroy() {
            this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
          }
        }
        function Pt(t2, i2) {
          const o2 = Math.pow(2, i2.canonical.z), r2 = i2.canonical.y;
          return [new e._(0, r2 / o2).toLngLat().lat, new e._(0, (r2 + 1) / o2).toLngLat().lat];
        }
        function Rt(t2, i2, o2, r2, a2, n2, s2) {
          const l2 = t2.context, c2 = l2.gl, h2 = o2.hillshadeFBO;
          if (!h2)
            return;
          t2.prepareDrawTile();
          const _2 = t2.isTileAffectedByFog(i2), u2 = t2.getOrCreateProgram("hillshade", { overrideFog: _2 });
          l2.activeTexture.set(c2.TEXTURE0), c2.bindTexture(c2.TEXTURE_2D, h2.colorAttachment.get());
          const d2 = ((t3, i3, o3, r3) => {
            const a3 = o3.paint.get("hillshade-shadow-color"), n3 = o3.paint.get("hillshade-highlight-color"), s3 = o3.paint.get("hillshade-accent-color"), l3 = o3.paint.get("hillshade-emissive-strength");
            let c3 = e.ac(o3.paint.get("hillshade-illumination-direction"));
            if ("viewport" === o3.paint.get("hillshade-illumination-anchor"))
              c3 -= t3.transform.angle;
            else if (t3.style && t3.style.enable3dLights() && t3.style.directionalLight) {
              const i4 = t3.style.directionalLight.properties.get("direction"), o4 = e.ad(i4.x, i4.y, i4.z);
              c3 = e.ac(o4[1]);
            }
            const h3 = !t3.options.moving;
            return { u_matrix: r3 || t3.transform.calculateProjMatrix(i3.tileID.toUnwrapped(), h3), u_image: 0, u_latrange: Pt(0, i3.tileID), u_light: [o3.paint.get("hillshade-exaggeration"), c3], u_shadow: a3.toRenderColor(o3.lut), u_highlight: n3.toRenderColor(o3.lut), u_emissive_strength: l3, u_accent: s3.toRenderColor(o3.lut) };
          })(t2, o2, r2, t2.terrain ? i2.projMatrix : null);
          t2.uploadCommonUniforms(l2, u2, i2.toUnwrapped());
          const { tileBoundsBuffer: p2, tileBoundsIndexBuffer: f2, tileBoundsSegments: m2 } = t2.getTileBoundsBuffers(o2);
          u2.draw(t2, c2.TRIANGLES, a2, n2, s2, e.ag.disabled, d2, r2.id, p2, f2, m2);
        }
        function Dt(t2, i2, o2) {
          if (!i2.needsDEMTextureUpload)
            return;
          const r2 = t2.context, a2 = r2.gl;
          r2.pixelStoreUnpackPremultiplyAlpha.set(false), i2.demTexture = i2.demTexture || t2.getTileTexture(o2.stride);
          const n2 = o2.getPixels();
          i2.demTexture ? i2.demTexture.update(n2, { premultiply: false }) : i2.demTexture = new e.T(r2, n2, a2.R32F, { premultiply: false }), i2.needsDEMTextureUpload = false;
        }
        function At(t2, i2, o2) {
          const r2 = t2.context, a2 = r2.gl;
          if (!i2.dem)
            return;
          const n2 = i2.dem;
          if (r2.activeTexture.set(a2.TEXTURE1), Dt(t2, i2, n2), !i2.demTexture)
            return;
          i2.demTexture.bind(a2.NEAREST, a2.CLAMP_TO_EDGE);
          const s2 = n2.dim;
          r2.activeTexture.set(a2.TEXTURE0);
          let l2 = i2.hillshadeFBO;
          if (!l2) {
            const t3 = new e.T(r2, { width: s2, height: s2, data: null }, a2.RGBA);
            t3.bind(a2.LINEAR, a2.CLAMP_TO_EDGE), l2 = i2.hillshadeFBO = r2.createFramebuffer(s2, s2, true, "renderbuffer"), l2.colorAttachment.set(t3.texture);
          }
          r2.bindFramebuffer.set(l2.framebuffer), r2.viewport.set([0, 0, s2, s2]);
          const { tileBoundsBuffer: c2, tileBoundsIndexBuffer: h2, tileBoundsSegments: _2 } = t2.getMercatorTileBoundsBuffers(), u2 = [];
          t2.linearFloatFilteringSupported() && u2.push("TERRAIN_DEM_FLOAT_FORMAT"), t2.getOrCreateProgram("hillshadePrepare", { defines: u2 }).draw(t2, a2.TRIANGLES, e.af.disabled, e.ah.disabled, e.a.unblended, e.ag.disabled, ((t3, i3) => {
            const o3 = i3.stride, r3 = e.ae.create();
            return e.ae.ortho(r3, 0, e.a4, -e.a4, 0, 0, 1), e.ae.translate(r3, r3, [0, -e.a4, 0]), { u_matrix: r3, u_image: 1, u_dimension: [o3, o3], u_zoom: t3.overscaledZ };
          })(i2.tileID, n2), o2.id, c2, h2, _2), i2.needsHillshadePrepare = false;
        }
        function Mt(t2, i2, o2, r2, a2) {
          const n2 = function(o3, r3) {
            if (o3)
              return a2(o3);
            if (r3) {
              if (t2.url && r3.tiles && t2.tiles && delete t2.tiles, r3.variants) {
                if (!Array.isArray(r3.variants))
                  return a2(new Error("variants must be an array"));
                for (const t3 of r3.variants) {
                  if (null == t3 || "object" != typeof t3 || t3.constructor !== Object)
                    return a2(new Error("variant must be an object"));
                  if (!Array.isArray(t3.capabilities))
                    return a2(new Error("capabilities must be an array"));
                  if (1 === t3.capabilities.length && "meshopt" === t3.capabilities[0]) {
                    r3 = e.Q(r3, t3);
                    break;
                  }
                }
              }
              const o4 = e.ai(e.Q(r3, t2), ["tilejson", "tiles", "minzoom", "maxzoom", "attribution", "mapbox_logo", "bounds", "scheme", "tileSize", "encoding"]);
              r3.vector_layers && (o4.vectorLayers = r3.vector_layers, o4.vectorLayerIds = o4.vectorLayers.map((e2) => e2.id)), r3.raster_layers && (o4.rasterLayers = r3.raster_layers, o4.rasterLayerIds = o4.rasterLayers.map((e2) => e2.id)), o4.tiles = i2.canonicalizeTileset(o4, t2.url), a2(null, o4);
            }
          }, s2 = function(e2, t3, i3) {
            if (!e2)
              return null;
            if (!t3 && !i3)
              return e2;
            i3 = i3 || e2.worldview_default;
            const o3 = Object.values(e2.language || {});
            if (0 === o3.length)
              return null;
            const r3 = Object.values(e2.worldview || {});
            if (0 === r3.length)
              return null;
            const a3 = o3.every((e3) => e3 === t3), n3 = r3.every((e3) => e3 === i3);
            return a3 && n3 ? e2 : t3 in (e2.language_options || {}) || i3 in (e2.worldview_options || {}) ? null : e2.language_options && e2.worldview_options ? e2 : null;
          }(t2.data, o2, r2);
          return s2 ? e.e.frame(() => n2(null, s2)) : t2.url ? e.h(i2.transformRequest(i2.normalizeSourceURL(t2.url, null, o2, r2), e.R.Source), n2) : e.e.frame(() => {
            const _a2 = t2, { data: e2 } = _a2, i3 = __objRest(_a2, ["data"]);
            n2(null, i3);
          });
        }
        class zt {
          constructor(t2, i2, o2) {
            this.bounds = e.aj.convert(this.validateBounds(t2)), this.minzoom = i2 || 0, this.maxzoom = o2 || 24;
          }
          validateBounds(e2) {
            return Array.isArray(e2) && 4 === e2.length ? [Math.max(-180, e2[0]), Math.max(-90, e2[1]), Math.min(180, e2[2]), Math.min(90, e2[3])] : [-180, -90, 180, 90];
          }
          contains(t2) {
            const i2 = Math.pow(2, t2.z), o2 = Math.floor(e.ak(this.bounds.getWest()) * i2), r2 = Math.floor(e.al(this.bounds.getNorth()) * i2), a2 = Math.ceil(e.ak(this.bounds.getEast()) * i2), n2 = Math.ceil(e.al(this.bounds.getSouth()) * i2);
            return t2.x >= o2 && t2.x < a2 && t2.y >= r2 && t2.y < n2;
          }
        }
        class Ot extends e.E {
          constructor(t2, i2, o2, r2) {
            super(), this.id = t2, this.dispatcher = o2, this.setEventedParent(r2), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = true, this.scheme = "xyz", this.tileSize = 512, this._loaded = false, this._options = e.Q({ type: "raster" }, i2), e.Q(this, e.ai(i2, ["url", "scheme", "tileSize"]));
          }
          load(t2) {
            this._loaded = false, this.fire(new e.g("dataloading", { dataType: "source" })), this._tileJSONRequest = Mt(this._options, this.map._requestManager, null, null, (i2, o2) => {
              this._tileJSONRequest = null, this._loaded = true, i2 ? this.fire(new e.f(i2)) : o2 && (e.Q(this, o2), o2.bounds && (this.tileBounds = new zt(o2.bounds, this.minzoom, this.maxzoom)), e.ao(o2.tiles), this.fire(new e.g("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e.g("data", { dataType: "source", sourceDataType: "content" }))), t2 && t2(i2);
            });
          }
          loaded() {
            return this._loaded;
          }
          onAdd(e2) {
            this.map = e2, this.load();
          }
          reload() {
            this.cancelTileJSONRequest();
            const t2 = e.am(this.id, this.scope);
            this.load(() => this.map.style.clearSource(t2));
          }
          setTiles(e2) {
            return this._options.tiles = e2, this.reload(), this;
          }
          setUrl(e2) {
            return this.url = e2, this._options.url = e2, this.reload(), this;
          }
          onRemove(e2) {
            this.cancelTileJSONRequest();
          }
          serialize() {
            return e.Q({}, this._options);
          }
          hasTile(e2) {
            return !this.tileBounds || this.tileBounds.contains(e2.canonical);
          }
          loadTile(t2, i2) {
            const o2 = e.e.devicePixelRatio >= 2, r2 = this.map._requestManager.normalizeTileURL(t2.tileID.canonical.url(this.tiles, this.scheme), o2, this.tileSize);
            t2.request = e.i(this.map._requestManager.transformRequest(r2, e.R.Tile), (o3, r3, a2, n2) => (delete t2.request, t2.aborted ? (t2.state = "unloaded", i2(null)) : o3 ? (t2.state = "errored", i2(o3)) : r3 ? (this.map._refreshExpiredTiles && t2.setExpiryData({ cacheControl: a2, expires: n2 }), t2.setTexture(r3, this.map.painter), t2.state = "loaded", e.an(this.dispatcher), void i2(null)) : i2(null)));
          }
          abortTile(e2, t2) {
            e2.request && (e2.request.cancel(), delete e2.request), t2 && t2();
          }
          unloadTile(t2, i2) {
            t2.texture && t2.texture instanceof e.T ? (t2.destroy(true), t2.texture && t2.texture instanceof e.T && this.map.painter.saveTileTexture(t2.texture)) : t2.destroy(), i2 && i2();
          }
          hasTransition() {
            return false;
          }
          cancelTileJSONRequest() {
            this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
          }
        }
        class Ft extends e.E {
          constructor(t2, i2, o2, r2) {
            if (super(), this.id = t2, this.dispatcher = o2, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = true, this.isTileClipped = true, this._loaded = false, e.Q(this, e.ai(i2, ["url", "scheme", "tileSize", "promoteId"])), this._options = e.Q({ type: "vector" }, i2), this._collectResourceTiming = !!i2.collectResourceTiming, 512 !== this.tileSize)
              throw new Error("vector tile sources must have a tileSize of 512");
            this.setEventedParent(r2), this._tileWorkers = {}, this._deduped = new e.ap();
          }
          load(t2) {
            this._loaded = false, this.fire(new e.g("dataloading", { dataType: "source" }));
            const i2 = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o2 = this.map._worldview;
            this._tileJSONRequest = Mt(this._options, this.map._requestManager, i2, o2, (r2, a2) => {
              this._tileJSONRequest = null, this._loaded = true, r2 ? (i2 && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i2}`), o2 && 2 !== o2.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o2}`), this.fire(new e.f(r2))) : a2 && (e.Q(this, a2), a2.bounds && (this.tileBounds = new zt(a2.bounds, this.minzoom, this.maxzoom)), e.ao(a2.tiles, this.map._requestManager._customAccessToken), this.fire(new e.g("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e.g("data", { dataType: "source", sourceDataType: "content" }))), t2 && t2(r2);
            });
          }
          loaded() {
            return this._loaded;
          }
          hasTile(e2) {
            return !this.tileBounds || this.tileBounds.contains(e2.canonical);
          }
          onAdd(e2) {
            this.map = e2, this.load();
          }
          reload() {
            this.cancelTileJSONRequest();
            const t2 = e.am(this.id, this.scope);
            this.load(() => this.map.style.clearSource(t2));
          }
          setTiles(e2) {
            return this._options.tiles = e2, this.reload(), this;
          }
          setUrl(e2) {
            return this.url = e2, this._options.url = e2, this.reload(), this;
          }
          onRemove(e2) {
            this.cancelTileJSONRequest();
          }
          serialize() {
            return e.Q({}, this._options);
          }
          loadTile(t2, i2) {
            const o2 = this.map._requestManager.normalizeTileURL(t2.tileID.canonical.url(this.tiles, this.scheme)), r2 = this.map._requestManager.transformRequest(o2, e.R.Tile), a2 = this.map.style ? this.map.style.getLut(this.scope) : null, n2 = { request: r2, data: void 0, uid: t2.uid, tileID: t2.tileID, tileZoom: t2.tileZoom, zoom: t2.tileID.overscaledZ, lut: a2 ? { image: a2.image.clone() } : null, tileSize: this.tileSize * t2.tileID.overscaleFactor(), type: this.type, source: this.id, scope: this.scope, pixelRatio: e.e.devicePixelRatio, showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId, isSymbolTile: t2.isSymbolTile, brightness: this.map.style && this.map.style.getBrightness() || 0, extraShadowCaster: t2.isExtraShadowCaster, tessellationStep: this.map._tessellationStep };
            if (n2.request.collectResourceTiming = this._collectResourceTiming, t2.actor && "expired" !== t2.state)
              "loading" === t2.state ? t2.reloadCallback = i2 : t2.request = t2.actor.send("reloadTile", n2, s2.bind(this));
            else if (t2.actor = this._tileWorkers[o2] = this._tileWorkers[o2] || this.dispatcher.getActor(), this.dispatcher.ready)
              t2.request = t2.actor.send("loadTile", n2, s2.bind(this), void 0, true);
            else {
              const i3 = e.aq.call({ deduped: this._deduped }, n2, (e2, i4) => {
                e2 || !i4 ? s2.call(this, e2) : (n2.data = { cacheControl: i4.cacheControl, expires: i4.expires, rawData: i4.rawData.slice(0) }, t2.actor && t2.actor.send("loadTile", n2, s2.bind(this), void 0, true));
              }, true);
              t2.request = { cancel: i3 };
            }
            function s2(o3, r3) {
              return delete t2.request, t2.aborted ? i2(null) : o3 && 404 !== o3.status ? i2(o3) : (r3 && r3.resourceTiming && (t2.resourceTiming = r3.resourceTiming), this.map._refreshExpiredTiles && r3 && t2.setExpiryData(r3), t2.loadVectorData(r3, this.map.painter), e.an(this.dispatcher), i2(null), void (t2.reloadCallback && (this.loadTile(t2, t2.reloadCallback), t2.reloadCallback = null)));
            }
          }
          abortTile(e2) {
            e2.request && (e2.request.cancel(), delete e2.request), e2.actor && e2.actor.send("abortTile", { uid: e2.uid, type: this.type, source: this.id, scope: this.scope });
          }
          unloadTile(e2, t2) {
            e2.actor && e2.actor.send("removeTile", { uid: e2.uid, type: this.type, source: this.id, scope: this.scope }), e2.destroy();
          }
          hasTransition() {
            return false;
          }
          afterUpdate() {
            this._tileWorkers = {};
          }
          cancelTileJSONRequest() {
            this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
          }
        }
        const Bt = (e2, t2, i2) => ({ u_matrix: e2, u_image0: 0, u_skirt_height: t2, u_ground_shadow_factor: i2 }), kt = (e2, t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2) => ({ u_proj_matrix: Float32Array.from(e2), u_globe_matrix: t2, u_normalize_matrix: Float32Array.from(o2), u_merc_matrix: i2, u_zoom_transition: r2, u_merc_center: a2, u_image0: 0, u_frustum_tl: n2, u_frustum_tr: s2, u_frustum_br: l2, u_frustum_bl: c2, u_globe_pos: h2, u_globe_radius: _2, u_viewport: u2, u_grid_matrix: f2 ? Float32Array.from(f2) : new Float32Array(9), u_skirt_height: d2, u_far_z_cutoff: p2 });
        class Nt {
          constructor(e2 = 0, t2 = 0, i2 = 0, o2 = 0) {
            if (isNaN(e2) || e2 < 0 || isNaN(t2) || t2 < 0 || isNaN(i2) || i2 < 0 || isNaN(o2) || o2 < 0)
              throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
            this.top = e2, this.bottom = t2, this.left = i2, this.right = o2;
          }
          interpolate(t2, i2, o2) {
            return null != i2.top && null != t2.top && (this.top = e.a3(t2.top, i2.top, o2)), null != i2.bottom && null != t2.bottom && (this.bottom = e.a3(t2.bottom, i2.bottom, o2)), null != i2.left && null != t2.left && (this.left = e.a3(t2.left, i2.left, o2)), null != i2.right && null != t2.right && (this.right = e.a3(t2.right, i2.right, o2)), this;
          }
          getCenter(t2, i2) {
            const o2 = e.au((this.left + t2 - this.right) / 2, 0, t2), r2 = e.au((this.top + i2 - this.bottom) / 2, 0, i2);
            return new e.P(o2, r2);
          }
          equals(e2) {
            return this.top === e2.top && this.bottom === e2.bottom && this.left === e2.left && this.right === e2.right;
          }
          clone() {
            return new Nt(this.top, this.bottom, this.left, this.right);
          }
          toJSON() {
            return { top: this.top, bottom: this.bottom, left: this.left, right: this.right };
          }
        }
        function Ut(t2, i2) {
          const o2 = e.ax(t2, 3);
          e.ae.fromQuat(t2, i2), e.aA(t2, 3, o2);
        }
        function Gt(t2, i2) {
          const o2 = e.aw.identity([]);
          return e.aw.rotateZ(o2, o2, -i2), e.aw.rotateX(o2, o2, -t2), o2;
        }
        function jt(t2, i2) {
          const o2 = [t2[0], t2[1], 0], r2 = [i2[0], i2[1], 0];
          if (e.$.length(o2) >= 1e-15) {
            const t3 = e.$.normalize([], o2);
            e.$.scale(r2, t3, e.$.dot(r2, t3)), i2[0] = r2[0], i2[1] = r2[1];
          }
          const a2 = e.$.cross([], i2, t2);
          if (e.$.len(a2) < 1e-15)
            return null;
          const n2 = Math.atan2(-a2[1], a2[0]);
          return Gt(Math.atan2(Math.sqrt(t2[0] * t2[0] + t2[1] * t2[1]), -t2[2]), n2);
        }
        class Vt {
          constructor(e2, t2) {
            this.position = e2, this.orientation = t2;
          }
          get position() {
            return this._position;
          }
          set position(t2) {
            if (t2) {
              const i2 = t2 instanceof e._ ? t2 : new e._(t2[0], t2[1], t2[2]);
              this._renderWorldCopies && (i2.x = e.av(i2.x, 0, 1)), this._position = i2;
            } else
              this._position = null;
          }
          lookAtPoint(t2, i2) {
            if (this.orientation = null, !this.position)
              return;
            const o2 = this.position, r2 = this._elevation ? this._elevation.getAtPointOrZero(e._.fromLngLat(t2)) : 0, a2 = e._.fromLngLat(t2, r2), n2 = [a2.x - o2.x, a2.y - o2.y, a2.z - o2.z];
            i2 || (i2 = [0, 0, 1]), i2[2] = Math.abs(i2[2]), this.orientation = jt(n2, i2);
          }
          setPitchBearing(t2, i2) {
            this.orientation = Gt(e.ac(t2), e.ac(-i2));
          }
        }
        class $t {
          constructor(t2, i2) {
            this._transform = e.ae.identity([]), this.orientation = i2, this.position = t2;
          }
          get mercatorPosition() {
            const t2 = this.position;
            return new e._(t2[0], t2[1], t2[2]);
          }
          get position() {
            const t2 = e.ax(this._transform, 3);
            return [t2[0], t2[1], t2[2]];
          }
          set position(t2) {
            var i2;
            t2 && e.aA(this._transform, 3, [(i2 = t2)[0], i2[1], i2[2], 1]);
          }
          get orientation() {
            return this._orientation;
          }
          set orientation(t2) {
            this._orientation = t2 || e.aw.identity([]), t2 && Ut(this._transform, this._orientation);
          }
          getPitchBearing() {
            const e2 = this.forward(), t2 = this.right();
            return { bearing: Math.atan2(-t2[1], t2[0]), pitch: Math.atan2(Math.sqrt(e2[0] * e2[0] + e2[1] * e2[1]), -e2[2]) };
          }
          setPitchBearing(e2, t2) {
            this._orientation = Gt(e2, t2), Ut(this._transform, this._orientation);
          }
          forward() {
            const t2 = e.ax(this._transform, 2);
            return [-t2[0], -t2[1], -t2[2]];
          }
          up() {
            const t2 = e.ax(this._transform, 1);
            return [-t2[0], -t2[1], -t2[2]];
          }
          right() {
            const t2 = e.ax(this._transform, 0);
            return [t2[0], t2[1], t2[2]];
          }
          getCameraToWorld(t2, i2) {
            const o2 = new Float64Array(16);
            return e.ae.invert(o2, this.getWorldToCamera(t2, i2)), o2;
          }
          getCameraToWorldMercator() {
            return this._transform;
          }
          getWorldToCameraPosition(t2, i2, o2) {
            const r2 = this.position;
            e.$.scale(r2, r2, -t2);
            const a2 = new Float64Array(16);
            return e.ae.fromScaling(a2, [o2, o2, o2]), e.ae.translate(a2, a2, r2), a2[10] *= i2, a2;
          }
          getWorldToCamera(t2, i2) {
            const o2 = new Float64Array(16), r2 = new Float64Array(4), a2 = this.position;
            return e.aw.conjugate(r2, this._orientation), e.$.scale(a2, a2, -t2), e.ae.fromQuat(o2, r2), e.ae.translate(o2, o2, a2), o2[1] *= -1, o2[5] *= -1, o2[9] *= -1, o2[13] *= -1, o2[8] *= i2, o2[9] *= i2, o2[10] *= i2, o2[11] *= i2, o2;
          }
          getCameraToClipPerspective(t2, i2, o2, r2) {
            const a2 = new Float64Array(16);
            return e.ae.perspective(a2, t2, i2, o2, r2), a2;
          }
          getCameraToClipOrthographic(t2, i2, o2, r2, a2, n2) {
            const s2 = new Float64Array(16);
            return e.ae.ortho(s2, t2, i2, o2, r2, a2, n2), s2;
          }
          getDistanceToElevation(t2, i2 = false) {
            const o2 = 0 === t2 ? 0 : e.ay(t2, i2 ? e.az(this.position[1]) : this.position[1]), r2 = this.forward();
            return (o2 - this.position[2]) / r2[2];
          }
          clone() {
            return new $t([...this.position], [...this.orientation]);
          }
        }
        const Zt = { unknown: 0, flipRequired: 1, flipNotRequired: 2 }, Wt = Math.tan(85 * Math.PI / 180);
        function Ht(t2, i2, o2, r2, a2, n2, s2) {
          const l2 = e.ae.create();
          if (o2)
            if ("globe" === n2.name) {
              const t3 = e.aC(a2, i2);
              e.ae.multiply(l2, l2, t3);
            } else {
              const t3 = e.aD.invert([], s2);
              l2[0] = t3[0], l2[1] = t3[1], l2[4] = t3[2], l2[5] = t3[3], r2 || e.ae.rotateZ(l2, l2, a2.angle);
            }
          else
            e.ae.multiply(l2, a2.labelPlaneMatrix, t2);
          return l2;
        }
        function qt(e2, t2, i2, o2, r2, a2, n2) {
          const s2 = Ht(e2, t2, i2, o2, r2, a2, n2);
          return "globe" === a2.name && i2 || (s2[2] = s2[6] = s2[10] = s2[14] = 0), s2;
        }
        function Xt(t2, i2, o2, r2, a2, n2, s2) {
          if (o2) {
            if ("globe" === n2.name) {
              const l2 = Ht(t2, i2, o2, r2, a2, n2, s2);
              return e.ae.invert(l2, l2), e.ae.multiply(l2, t2, l2), l2;
            }
            {
              const i3 = e.ae.clone(t2), o3 = e.ae.identity([]);
              return o3[0] = s2[0], o3[1] = s2[1], o3[4] = s2[2], o3[5] = s2[3], e.ae.multiply(i3, i3, o3), r2 || e.ae.rotateZ(i3, i3, -a2.angle), i3;
            }
          }
          return a2.glCoordMatrix;
        }
        function Qt(t2, i2, o2, r2) {
          const a2 = [t2, i2, o2, 1];
          o2 ? e.aB.transformMat4(a2, a2, r2) : si(a2, a2, r2);
          const n2 = a2[3];
          return a2[0] /= n2, a2[1] /= n2, a2[2] /= n2, a2;
        }
        function Yt(e2, t2) {
          return Math.min(0.5 + e2 / t2 * 0.5, 1.5);
        }
        function Jt(e2, t2) {
          const i2 = e2[0] / e2[3], o2 = e2[1] / e2[3];
          return i2 >= -t2[0] && i2 <= t2[0] && o2 >= -t2[1] && o2 <= t2[1];
        }
        function Kt(t2, i2, o2, r2, a2, n2, s2, l2, c2, h2) {
          const _2 = o2.transform, u2 = r2 ? t2.textSizeData : t2.iconSizeData, d2 = e.aE(u2, o2.transform.zoom), p2 = "globe" === _2.projection.name, f2 = [256 / o2.width * 2 + 1, 256 / o2.height * 2 + 1], m2 = r2 ? t2.text.dynamicLayoutVertexArray : t2.icon.dynamicLayoutVertexArray;
          m2.clear();
          let g2 = null;
          p2 && (g2 = r2 ? t2.text.globeExtVertexArray : t2.icon.globeExtVertexArray);
          const v2 = t2.lineVertexArray, x2 = r2 ? t2.text.placedSymbolArray : t2.icon.placedSymbolArray, y2 = o2.transform.width / o2.transform.height;
          let b2, w2 = false;
          for (let r3 = 0; r3 < x2.length; r3++) {
            const p3 = x2.get(r3), { numGlyphs: T2, writingMode: E2 } = p3;
            if (E2 !== e.aF.vertical || w2 || b2 === e.aF.horizontal || (w2 = true), b2 = E2, (p3.hidden || E2 === e.aF.vertical) && !w2) {
              ni(T2, m2);
              continue;
            }
            w2 = false;
            const C2 = new e.P(p3.tileAnchorX, p3.tileAnchorY);
            let { x: S2, y: I2, z: L2 } = _2.projection.projectTilePoint(C2.x, C2.y, h2.canonical);
            if (c2) {
              const [e2, t3, i3] = c2(C2);
              S2 += e2, I2 += t3, L2 += i3;
            }
            const P2 = [S2, I2, L2, 1];
            if (e.aB.transformMat4(P2, P2, i2), !Jt(P2, f2)) {
              ni(T2, m2);
              continue;
            }
            const R2 = P2[3], D2 = Yt(o2.transform.getCameraToCenterDistance(_2.projection), R2), A2 = e.aG(u2, d2, p3), M2 = s2 ? A2 / D2 : A2 * D2, z2 = Qt(S2, I2, L2, a2);
            if (z2[3] <= 0) {
              ni(T2, m2);
              continue;
            }
            let O2 = {};
            const F2 = s2 ? null : c2, B2 = ii(p3, M2, false, l2, i2, a2, n2, t2.glyphOffsetArray, v2, m2, g2, z2, C2, O2, y2, F2, _2.projection, h2, s2);
            w2 = B2.useVertical, F2 && B2.needsFlipping && (O2 = {}), (B2.notEnoughRoom || w2 || B2.needsFlipping && ii(p3, M2, true, l2, i2, a2, n2, t2.glyphOffsetArray, v2, m2, g2, z2, C2, O2, y2, F2, _2.projection, h2, s2).notEnoughRoom) && ni(T2, m2);
          }
          r2 ? (t2.text.dynamicLayoutVertexBuffer.updateData(m2), g2 && t2.text.globeExtVertexBuffer && t2.text.globeExtVertexBuffer.updateData(g2)) : (t2.icon.dynamicLayoutVertexBuffer.updateData(m2), g2 && t2.icon.globeExtVertexBuffer && t2.icon.globeExtVertexBuffer.updateData(g2));
        }
        function ei(e2, t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2) {
          const { lineStartIndex: m2, glyphStartIndex: g2, segment: v2 } = s2, x2 = g2 + s2.numGlyphs, y2 = m2 + s2.lineLength, b2 = t2.getoffsetX(g2), w2 = t2.getoffsetX(x2 - 1), T2 = ai(e2 * b2, i2, o2, r2, a2, n2, v2, m2, y2, l2, c2, h2, _2, u2, true, d2, p2, f2);
          if (!T2)
            return null;
          const E2 = ai(e2 * w2, i2, o2, r2, a2, n2, v2, m2, y2, l2, c2, h2, _2, u2, true, d2, p2, f2);
          return E2 ? { first: T2, last: E2 } : null;
        }
        function ti(t2, i2, o2, r2) {
          return t2 === e.aF.horizontal && Math.abs(r2) > Math.abs(o2) ? { useVertical: true } : t2 === e.aF.vertical ? r2 > 0 ? { needsFlipping: true } : null : i2 !== Zt.unknown && function(e2, t3) {
            return 0 === e2 || Math.abs(t3 / e2) > Wt;
          }(o2, r2) ? i2 === Zt.flipRequired ? { needsFlipping: true } : null : o2 < 0 ? { needsFlipping: true } : null;
        }
        function ii(t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2, m2, g2, v2, x2) {
          const y2 = i2 / 24, b2 = t2.lineOffsetX * y2, w2 = t2.lineOffsetY * y2, { lineStartIndex: T2, glyphStartIndex: E2, numGlyphs: C2, segment: S2, writingMode: I2, flipState: L2 } = t2, P2 = T2 + t2.lineLength, R2 = (t3) => {
            if (_2) {
              const [i4, o4, r4] = t3.up, a3 = h2.length;
              e.aH(_2, a3 + 0, i4, o4, r4), e.aH(_2, a3 + 1, i4, o4, r4), e.aH(_2, a3 + 2, i4, o4, r4), e.aH(_2, a3 + 3, i4, o4, r4);
            }
            const [i3, o3, r3] = t3.point;
            e.aI(h2, i3, o3, r3, t3.angle);
          };
          if (C2 > 1) {
            const e2 = ei(y2, l2, b2, w2, o2, u2, d2, t2, c2, n2, p2, m2, false, g2, v2, x2);
            if (!e2)
              return { notEnoughRoom: true };
            if (r2 && !o2) {
              let [i3, o3, r3] = e2.first.point, [a3, n3, l3] = e2.last.point;
              [i3, o3] = Qt(i3, o3, r3, s2), [a3, n3] = Qt(a3, n3, l3, s2);
              const c3 = ti(I2, L2, (a3 - i3) * f2, n3 - o3);
              if (t2.flipState = c3 && c3.needsFlipping ? Zt.flipRequired : Zt.flipNotRequired, c3)
                return c3;
            }
            R2(e2.first);
            for (let e3 = E2 + 1; e3 < E2 + C2 - 1; e3++) {
              const t3 = ai(y2 * l2.getoffsetX(e3), b2, w2, o2, u2, d2, S2, T2, P2, c2, n2, p2, m2, false, false, g2, v2, x2);
              if (!t3)
                return h2.length -= 4 * (e3 - E2), { notEnoughRoom: true };
              R2(t3);
            }
            R2(e2.last);
          } else {
            if (r2 && !o2) {
              const i4 = Qt(d2.x, d2.y, 0, a2), o3 = T2 + S2 + 1, r3 = new e.P(c2.getx(o3), c2.gety(o3)), n3 = Qt(r3.x, r3.y, 0, a2), s3 = n3[3] > 0 ? n3 : ri(d2, r3, i4, 1, a2, void 0, g2, v2.canonical), l3 = ti(I2, L2, (s3[0] - i4[0]) * f2, s3[1] - i4[1]);
              if (t2.flipState = l3 && l3.needsFlipping ? Zt.flipRequired : Zt.flipNotRequired, l3)
                return l3;
            }
            const i3 = ai(y2 * l2.getoffsetX(E2), b2, w2, o2, u2, d2, S2, T2, P2, c2, n2, p2, m2, false, false, g2, v2, x2);
            if (!i3)
              return { notEnoughRoom: true };
            R2(i3);
          }
          return {};
        }
        function oi(e2, t2, i2, o2, r2) {
          const { x: a2, y: n2, z: s2 } = o2.projectTilePoint(e2.x, e2.y, t2);
          if (!r2)
            return Qt(a2, n2, s2, i2);
          const [l2, c2, h2] = r2(e2);
          return Qt(a2 + l2, n2 + c2, s2 + h2, i2);
        }
        function ri(t2, i2, o2, r2, a2, n2, s2, l2) {
          const c2 = oi(t2.sub(i2)._unit()._add(t2), l2, a2, s2, n2);
          return e.$.sub(c2, o2, c2), e.$.normalize(c2, c2), e.$.scaleAndAdd(c2, o2, c2, r2);
        }
        function ai(t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2, m2, g2, v2) {
          const x2 = r2 ? t2 - i2 : t2 + i2;
          let y2 = x2 > 0 ? 1 : -1, b2 = 0;
          r2 && (y2 *= -1, b2 = Math.PI), y2 < 0 && (b2 += Math.PI);
          let w2 = l2 + s2 + (y2 > 0 ? 0 : 1) | 0, T2 = a2, E2 = a2, C2 = 0, S2 = 0;
          const I2 = Math.abs(x2), L2 = [], P2 = [];
          let R2 = n2, D2 = R2;
          const A2 = () => ri(D2, R2, E2, I2 - C2 + 1, _2, d2, m2, g2.canonical);
          for (; C2 + S2 <= I2; ) {
            if (w2 += y2, w2 < l2 || w2 >= c2)
              return null;
            if (E2 = T2, D2 = R2, L2.push(E2), p2 && P2.push(D2), R2 = new e.P(h2.getx(w2), h2.gety(w2)), T2 = u2[w2], !T2) {
              const e2 = oi(R2, g2.canonical, _2, m2, d2);
              T2 = e2[3] > 0 ? u2[w2] = e2 : A2();
            }
            C2 += S2, S2 = e.$.distance(E2, T2);
          }
          f2 && d2 && (u2[w2] && (T2 = A2(), S2 = e.$.distance(E2, T2)), u2[w2] = T2);
          const M2 = (I2 - C2) / S2, z2 = R2.sub(D2)._mult(M2)._add(D2), O2 = e.$.sub([], T2, E2), F2 = e.$.scaleAndAdd([], E2, O2, M2);
          let B2 = [0, 0, 1], k2 = O2[0], N2 = O2[1];
          if (v2 && (B2 = m2.upVector(g2.canonical, z2.x, z2.y), 0 !== B2[0] || 0 !== B2[1] || 1 !== B2[2])) {
            const t3 = [B2[2], 0, -B2[0]], i3 = e.$.cross([], B2, t3);
            e.$.normalize(t3, t3), e.$.normalize(i3, i3), k2 = e.$.dot(O2, t3), N2 = e.$.dot(O2, i3);
          }
          if (o2) {
            const t3 = e.$.cross([], B2, O2);
            e.$.normalize(t3, t3), e.$.scaleAndAdd(F2, F2, t3, o2 * y2);
          }
          const U2 = b2 + Math.atan2(N2, k2);
          return L2.push(F2), p2 && P2.push(z2), { point: F2, angle: U2, path: L2, tilePath: P2, up: B2 };
        }
        function ni(e2, t2) {
          const i2 = t2.length, o2 = i2 + 4 * e2;
          t2.resize(o2), t2.float32.fill(-1 / 0, 4 * i2, 4 * o2);
        }
        function si(e2, t2, i2) {
          const o2 = t2[0], r2 = t2[1];
          return e2[0] = i2[0] * o2 + i2[4] * r2 + i2[12], e2[1] = i2[1] * o2 + i2[5] * r2 + i2[13], e2[3] = i2[3] * o2 + i2[7] * r2 + i2[15], e2;
        }
        const li = (e2, t2, i2) => (1 - i2) * e2 + i2 * t2, ci = (e2) => e2 * e2 * e2 * e2 * e2;
        class hi {
          constructor(t2, i2, o2, r2, a2, n2, s2) {
            this.tileSize = 512, this._renderWorldCopies = void 0 === a2 || a2, this._minZoom = t2 || 0, this._maxZoom = i2 || 22, this._minPitch = o2 != null ? o2 : 0, this._maxPitch = r2 != null ? r2 : 60, this.setProjection(n2), this.setMaxBounds(s2), this.width = 0, this.height = 0, this._center = new e.aJ(0, 0), this.zoom = 0, this.angle = 0, this._fov = 0.6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._unmodified = true, this._edgeInsets = new Nt(), this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._expandedProjMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new $t(), this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [0, 0, 0], this._tileCoverLift = 0, this.freezeTileCoverage = false, this._horizonShift = 0.1, this._orthographicProjectionAtLowPitch = false;
          }
          clone() {
            const e2 = new hi(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection());
            return e2._elevation = this._elevation, e2._centerAltitude = this._centerAltitude, e2._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e2.tileSize = this.tileSize, e2.mercatorFromTransition = this.mercatorFromTransition, e2.width = this.width, e2.height = this.height, e2.cameraElevationReference = this.cameraElevationReference, e2._center = this._center, e2._setZoom(this.zoom), e2._seaLevelZoom = this._seaLevelZoom, e2.angle = this.angle, e2._fov = this._fov, e2._pitch = this._pitch, e2._nearZ = this._nearZ, e2._farZ = this._farZ, e2._averageElevation = this._averageElevation, e2._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, e2._unmodified = this._unmodified, e2._edgeInsets = this._edgeInsets.clone(), e2._camera = this._camera.clone(), e2._calcMatrices(), e2.freezeTileCoverage = this.freezeTileCoverage, e2.frustumCorners = this.frustumCorners, e2;
          }
          get isOrthographic() {
            return "globe" !== this.projection.name && this._orthographicProjectionAtLowPitch && this.pitch < 15;
          }
          get elevation() {
            return this._elevation;
          }
          set elevation(e2) {
            this._elevation !== e2 && (this._elevation = e2, this._updateCameraOnTerrain(), this._calcMatrices());
          }
          get depthOcclusionForSymbolsAndCircles() {
            return "globe" !== this.projection.name && !this.isOrthographic;
          }
          updateElevation(e2, t2 = false) {
            const i2 = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
            (null == this._seaLevelZoom || i2) && this._updateCameraOnTerrain(), (e2 || i2) && this._constrainCamera(t2), this._calcMatrices();
          }
          getProjection() {
            return e.ai(this.projection, ["name", "center", "parallels"]);
          }
          setProjection(t2) {
            this.projectionOptions = t2 || { name: "mercator" };
            const i2 = this.projection ? this.getProjection() : void 0;
            this.projection = e.aK(this.projectionOptions);
            const o2 = this.getProjection(), r2 = !e.d(i2, o2);
            return r2 && this._calcMatrices(), this.mercatorFromTransition = false, r2;
          }
          setOrthographicProjectionAtLowPitch(e2) {
            return this._orthographicProjectionAtLowPitch !== e2 && (this._orthographicProjectionAtLowPitch = e2, this._calcMatrices(), true);
          }
          setMercatorFromTransition() {
            const t2 = this.projection.name;
            this.mercatorFromTransition = true, this.projectionOptions = { name: "mercator" }, this.projection = e.aK({ name: "mercator" });
            const i2 = t2 !== this.projection.name;
            return i2 && this._calcMatrices(), i2;
          }
          get minZoom() {
            return this._minZoom;
          }
          set minZoom(e2) {
            this._minZoom !== e2 && (this._minZoom = e2, this.zoom = Math.max(this.zoom, e2));
          }
          get maxZoom() {
            return this._maxZoom;
          }
          set maxZoom(e2) {
            this._maxZoom !== e2 && (this._maxZoom = e2, this.zoom = Math.min(this.zoom, e2));
          }
          get minPitch() {
            return this._minPitch;
          }
          set minPitch(e2) {
            this._minPitch !== e2 && (this._minPitch = e2, this.pitch = Math.max(this.pitch, e2));
          }
          get maxPitch() {
            return this._maxPitch;
          }
          set maxPitch(e2) {
            this._maxPitch !== e2 && (this._maxPitch = e2, this.pitch = Math.min(this.pitch, e2));
          }
          get renderWorldCopies() {
            return this._renderWorldCopies && true === this.projection.supportsWorldCopies;
          }
          set renderWorldCopies(e2) {
            void 0 === e2 ? e2 = true : null === e2 && (e2 = false), this._renderWorldCopies = e2;
          }
          get worldSize() {
            return this.tileSize * this.scale;
          }
          get cameraWorldSizeForFog() {
            const e2 = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
            return this._worldSizeFromZoom(this._zoomFromMercatorZ(e2));
          }
          get cameraWorldSize() {
            const e2 = Math.max(this._camera.getDistanceToElevation(this._averageElevation, true), Number.EPSILON);
            return this._worldSizeFromZoom(this._zoomFromMercatorZ(e2));
          }
          get pixelsPerMeter() {
            return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
          }
          get cameraPixelsPerMeter() {
            return e.ay(1, this.center.lat) * this.cameraWorldSizeForFog;
          }
          get centerOffset() {
            return this.centerPoint._sub(this.size._div(2));
          }
          get size() {
            return new e.P(this.width, this.height);
          }
          get bearing() {
            return e.av(this.rotation, -180, 180);
          }
          set bearing(e2) {
            this.rotation = e2;
          }
          get rotation() {
            return -this.angle / Math.PI * 180;
          }
          set rotation(t2) {
            const i2 = -t2 * Math.PI / 180;
            this.angle !== i2 && (this._unmodified = false, this.angle = i2, this._calcMatrices(), this.rotationMatrix = e.aD.create(), e.aD.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
          }
          get pitch() {
            return this._pitch / Math.PI * 180;
          }
          set pitch(t2) {
            const i2 = e.au(t2, this.minPitch, this.maxPitch) / 180 * Math.PI;
            this._pitch !== i2 && (this._unmodified = false, this._pitch = i2, this._calcMatrices());
          }
          get aspect() {
            return this.width / this.height;
          }
          get fov() {
            return this._fov / Math.PI * 180;
          }
          get fovX() {
            return this._fov;
          }
          get fovY() {
            const e2 = 1 / Math.tan(0.5 * this.fovX);
            return 2 * Math.atan(1 / this.aspect / e2);
          }
          set fov(t2) {
            t2 = Math.max(0.01, Math.min(60, t2)), this._fov !== t2 && (this._unmodified = false, this._fov = e.ac(t2), this._calcMatrices());
          }
          get averageElevation() {
            return this._averageElevation;
          }
          set averageElevation(e2) {
            this._averageElevation = e2, this._calcFogMatrices(), this._distanceTileDataCache = {};
          }
          get zoom() {
            return this._zoom;
          }
          set zoom(e2) {
            const t2 = Math.min(Math.max(e2, this.minZoom), this.maxZoom);
            this._zoom !== t2 && (this._unmodified = false, this._setZoom(t2), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
          }
          _setZoom(e2) {
            this._zoom = e2, this.scale = this.zoomScale(e2), this.tileZoom = Math.floor(e2), this.zoomFraction = e2 - this.tileZoom;
          }
          get tileCoverLift() {
            return this._tileCoverLift;
          }
          set tileCoverLift(e2) {
            this._tileCoverLift !== e2 && (this._tileCoverLift = e2);
          }
          _updateCameraOnTerrain() {
            const e2 = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY, t2 = this.elevation && e2 === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
            if (!this._elevation || e2 === Number.NEGATIVE_INFINITY && (!t2 || !this._centerAltitude))
              return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
            const i2 = this._elevation;
            t2 || this._centerAltitude && this._centerAltitudeValidForExaggeration && i2.exaggeration() && this._centerAltitudeValidForExaggeration !== i2.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * i2.exaggeration(), this._centerAltitudeValidForExaggeration = i2.exaggeration()) : (this._centerAltitude = e2 || 0, this._centerAltitudeValidForExaggeration = i2.exaggeration()), this._updateSeaLevelZoom();
          }
          _updateSeaLevelZoom() {
            void 0 !== this._centerAltitudeValidForExaggeration && (this._seaLevelZoom = this._zoomFromMercatorZ((this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize));
          }
          sampleAverageElevation() {
            if (!this._elevation)
              return 0;
            const t2 = this._elevation, i2 = [[0.5, 0.2], [0.3, 0.5], [0.5, 0.5], [0.7, 0.5], [0.5, 0.8]], o2 = this.horizonLineFromTop();
            let r2 = 0, a2 = 0;
            for (let n2 = 0; n2 < i2.length; n2++) {
              const s2 = new e.P(i2[n2][0] * this.width, o2 + i2[n2][1] * (this.height - o2)), l2 = t2.pointCoordinate(s2);
              if (!l2)
                continue;
              const c2 = 1 / Math.hypot(l2[0] - this._camera.position[0], l2[1] - this._camera.position[1]);
              r2 += l2[3] * c2, a2 += c2;
            }
            return 0 === a2 ? NaN : r2 / a2;
          }
          get center() {
            return this._center;
          }
          set center(e2) {
            e2.lat === this._center.lat && e2.lng === this._center.lng || (this._unmodified = false, this._center = e2, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
          }
          _updateZoomFromElevation() {
            if (null == this._seaLevelZoom || !this._elevation)
              return;
            const e2 = this._seaLevelZoom, t2 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i2 = this.pixelsPerMeter / this.worldSize * t2, o2 = this._mercatorZfromZoom(e2), r2 = this._mercatorZfromZoom(this._maxZoom), a2 = Math.max(o2 - i2, r2);
            this._setZoom(this._zoomFromMercatorZ(a2));
          }
          get padding() {
            return this._edgeInsets.toJSON();
          }
          set padding(e2) {
            this._edgeInsets.equals(e2) || (this._unmodified = false, this._edgeInsets.interpolate(this._edgeInsets, e2, 1), this._calcMatrices());
          }
          computeZoomRelativeTo(t2) {
            const i2 = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, t2.toAltitude()));
            let o2;
            o2 = t2.z < this._camera.position[2] ? [i2.x, i2.y, i2.z] : [t2.x, t2.y, t2.z];
            const r2 = e.$.length(e.$.sub([], this._camera.position, o2));
            return e.au(this._zoomFromMercatorZ(r2), this._minZoom, this._maxZoom);
          }
          setFreeCameraOptions(t2) {
            if (!this.height)
              return;
            if (!t2.position && !t2.orientation)
              return;
            this._updateCameraState();
            let i2 = false;
            if (t2.orientation && !e.aw.exactEquals(t2.orientation, this._camera.orientation) && (i2 = this._setCameraOrientation(t2.orientation)), t2.position) {
              const o2 = [t2.position.x, t2.position.y, t2.position.z];
              e.$.exactEquals(o2, this._camera.position) || (this._setCameraPosition(o2), i2 = true);
            }
            i2 && (this._updateStateFromCamera(), this.recenterOnTerrain());
          }
          getFreeCameraOptions() {
            this._updateCameraState();
            const t2 = this._camera.position, i2 = new Vt();
            return i2.position = new e._(t2[0], t2[1], t2[2]), i2.orientation = this._camera.orientation, i2._elevation = this.elevation, i2._renderWorldCopies = this.renderWorldCopies, i2;
          }
          _setCameraOrientation(t2) {
            if (!e.aw.length(t2))
              return false;
            e.aw.normalize(t2, t2);
            const i2 = e.$.transformQuat([], [0, 0, -1], t2), o2 = e.$.transformQuat([], [0, -1, 0], t2);
            if (o2[2] < 0)
              return false;
            const r2 = jt(i2, o2);
            return !!r2 && (this._camera.orientation = r2, true);
          }
          _setCameraPosition(t2) {
            const i2 = this.zoomScale(this.minZoom) * this.tileSize, o2 = this.zoomScale(this.maxZoom) * this.tileSize, r2 = this.cameraToCenterDistance;
            t2[2] = e.au(t2[2], r2 / o2, r2 / i2), this._camera.position = t2;
          }
          get centerPoint() {
            return this._edgeInsets.getCenter(this.width, this.height);
          }
          get fovAboveCenter() {
            return this._fov * (0.5 + this.centerOffset.y / this.height);
          }
          isPaddingEqual(e2) {
            return this._edgeInsets.equals(e2);
          }
          interpolatePadding(e2, t2, i2) {
            this._unmodified = false, this._edgeInsets.interpolate(e2, t2, i2), this._constrain(), this._calcMatrices();
          }
          coveringZoomLevel(e2) {
            const t2 = (e2.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e2.tileSize));
            return Math.max(0, t2);
          }
          getVisibleUnwrappedCoordinates(t2) {
            const i2 = [new e.aL(0, t2)];
            if (this.renderWorldCopies) {
              const o2 = this.pointCoordinate(new e.P(0, 0)), r2 = this.pointCoordinate(new e.P(this.width, 0)), a2 = this.pointCoordinate(new e.P(this.width, this.height)), n2 = this.pointCoordinate(new e.P(0, this.height)), s2 = Math.floor(Math.min(o2.x, r2.x, a2.x, n2.x)), l2 = Math.floor(Math.max(o2.x, r2.x, a2.x, n2.x)), c2 = 1;
              for (let o3 = s2 - c2; o3 <= l2 + c2; o3++)
                0 !== o3 && i2.push(new e.aL(o3, t2));
            }
            return i2;
          }
          isLODDisabled(e2) {
            return (!e2 || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
          }
          extendTileCover(t2, i2, o2) {
            let r2 = [];
            const a2 = void 0 !== o2, n2 = !a2;
            if (n2 && this.zoom < i2)
              return r2;
            if (a2 && 0 === o2[0] && 0 === o2[1])
              return r2;
            const s2 = /* @__PURE__ */ new Set(), l2 = (t3, i3, o3, a3, n3) => {
              const l3 = e.b2(i3, t3, o3, a3, n3);
              s2.has(l3) || (r2.push(new e.aQ(t3, i3, o3, a3, n3)), s2.add(l3));
            };
            for (let e2 = 0; e2 < t2.length; e2++) {
              const r3 = t2[e2];
              if (n2 && r3.canonical.z !== i2)
                continue;
              const s3 = r3.canonical, c3 = r3.overscaledZ, h2 = r3.wrap, _2 = 1 << s3.z, u2 = s3.x + 1 < _2, d2 = s3.x > 0, p2 = s3.y + 1 < _2, f2 = s3.y > 0, m2 = r3.wrap - (d2 ? 0 : 1), g2 = r3.wrap + (u2 ? 0 : 1), v2 = d2 ? s3.x - 1 : _2 - 1, x2 = u2 ? s3.x + 1 : 0;
              if (a2)
                o2[0] < 0 ? (l2(c3, g2, s3.z, x2, s3.y), o2[1] < 0 && p2 && (l2(c3, h2, s3.z, s3.x, s3.y + 1), l2(c3, g2, s3.z, x2, s3.y + 1)), o2[1] > 0 && f2 && (l2(c3, h2, s3.z, s3.x, s3.y - 1), l2(c3, g2, s3.z, x2, s3.y - 1))) : o2[0] > 0 ? (l2(c3, m2, s3.z, v2, s3.y), o2[1] < 0 && p2 && (l2(c3, h2, s3.z, s3.x, s3.y + 1), l2(c3, m2, s3.z, v2, s3.y + 1)), o2[1] > 0 && f2 && (l2(c3, h2, s3.z, s3.x, s3.y - 1), l2(c3, m2, s3.z, v2, s3.y - 1))) : o2[1] < 0 && p2 ? l2(c3, h2, s3.z, s3.x, s3.y + 1) : f2 && l2(c3, h2, s3.z, s3.x, s3.y - 1);
              else {
                const e3 = r3.visibleQuadrants;
                1 & e3 && (l2(c3, m2, s3.z, v2, s3.y), f2 && (l2(c3, h2, s3.z, s3.x, s3.y - 1), l2(c3, m2, s3.z, v2, s3.y - 1))), 2 & e3 && (l2(c3, g2, s3.z, x2, s3.y), f2 && (l2(c3, h2, s3.z, s3.x, s3.y - 1), l2(c3, g2, s3.z, x2, s3.y - 1))), 4 & e3 && (l2(c3, m2, s3.z, v2, s3.y), p2 && (l2(c3, h2, s3.z, s3.x, s3.y + 1), l2(c3, m2, s3.z, v2, s3.y + 1))), 8 & e3 && (l2(c3, g2, s3.z, x2, s3.y), p2 && (l2(c3, h2, s3.z, s3.x, s3.y + 1), l2(c3, g2, s3.z, x2, s3.y + 1)));
              }
            }
            const c2 = [];
            for (const e2 of r2)
              r2.some((t3) => e2.isChildOf(t3)) || c2.push(e2);
            if (r2 = c2.filter((e2) => !t2.some((t3) => !!(e2.overscaledZ < i2 && t3.isChildOf(e2)) || e2.equals(t3) || e2.isChildOf(t3))), n2) {
              const e2 = 1 << i2, t3 = "globe" === this.projection.name ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), o3 = [e2 * t3.x, e2 * t3.y], a3 = 4, n3 = a3 * a3;
              r2 = r2.filter((e3) => {
                const t4 = e3.canonical.x + 0.5 - o3[0], i3 = e3.canonical.y + 0.5 - o3[1];
                return t4 * t4 + i3 * i3 < n3;
              });
            }
            return r2;
          }
          coveringTiles(t2) {
            let i2 = this.coveringZoomLevel(t2);
            const o2 = i2, r2 = this.elevation && this.elevation.exaggeration(), a2 = r2 && !t2.isTerrainDEM, n2 = "mercator" === this.projection.name;
            if (void 0 !== t2.minzoom && i2 < t2.minzoom)
              return [];
            void 0 !== t2.maxzoom && i2 > t2.maxzoom && (i2 = t2.maxzoom);
            const s2 = this.locationCoordinate(this.center), l2 = this.center.lat, c2 = 1 << i2, h2 = [c2 * s2.x, c2 * s2.y, 0], _2 = "globe" === this.projection.name, u2 = !_2, d2 = e.aM.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i2, u2), p2 = _2 ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), f2 = c2 * e.ay(1, this.center.lat), m2 = this._camera.position[2] / e.ay(1, this.center.lat), g2 = [c2 * p2.x, c2 * p2.y, m2 * (u2 ? 1 : f2)], v2 = _2 || r2, x2 = this.cameraToCenterDistance / t2.tileSize * (t2.roundZoom ? 1 : 0.502), y2 = this.isLODDisabled(true) ? i2 : 0;
            let b2;
            if (this._elevation && t2.isTerrainDEM)
              b2 = 1e4 * this._elevation.exaggeration();
            else if (this._elevation) {
              const e2 = this._elevation.getMinMaxForVisibleTiles();
              b2 = e2 ? e2.max : this._centerAltitude;
            } else
              b2 = this._centerAltitude;
            const w2 = t2.isTerrainDEM ? -b2 : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, T2 = this.projection.isReprojectedInTileSpace ? e.aN(this) : 1, E2 = (t3) => {
              const i3 = 1 / 4e4, o3 = new e._(t3.x + i3, t3.y, t3.z), r3 = new e._(t3.x, t3.y + i3, t3.z), a3 = t3.toLngLat(), n3 = o3.toLngLat(), s3 = r3.toLngLat(), l3 = this.locationCoordinate(a3), c3 = this.locationCoordinate(n3), h3 = this.locationCoordinate(s3), _3 = Math.hypot(c3.x - l3.x, c3.y - l3.y), u3 = Math.hypot(h3.x - l3.x, h3.y - l3.y);
              return Math.sqrt(_3 * u3) * T2 / i3;
            }, C2 = (t3) => {
              const i3 = b2, o3 = w2;
              return { aabb: e.aR(this, c2, 0, 0, 0, t3, o3, i3, this.projection), zoom: 0, x: 0, y: 0, minZ: o3, maxZ: i3, wrap: t3, fullyVisible: false };
            }, S2 = [];
            let I2 = [];
            const L2 = i2, P2 = t2.reparseOverscaled ? o2 : i2, R2 = (m2 - this._centerAltitude) * f2, D2 = (e2) => {
              if (!this._elevation || !e2.tileID || !n2)
                return;
              const t3 = this._elevation.getMinMaxForTile(e2.tileID), i3 = e2.aabb;
              t3 ? (i3.min[2] = t3.min, i3.max[2] = t3.max, i3.center[2] = (i3.min[2] + i3.max[2]) / 2) : (e2.shouldSplit = M2(e2), e2.shouldSplit || (i3.min[2] = i3.max[2] = i3.center[2] = this._centerAltitude));
            }, A2 = (e2, t3) => {
              if (0.707 * t3 < e2)
                return 1;
              const i3 = t3 / e2;
              return i3 / (1.4144271570014144 + (Math.pow(1.1, i3 - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
            }, M2 = (t3) => {
              if (t3.zoom < y2)
                return true;
              if (t3.zoom === L2)
                return false;
              if (null != t3.shouldSplit)
                return t3.shouldSplit;
              const i3 = t3.aabb.distanceX(g2), r3 = t3.aabb.distanceY(g2);
              let s3 = R2, c3 = 1;
              if (_2) {
                s3 = t3.aabb.distanceZ(g2);
                const i4 = Math.pow(2, t3.zoom), o3 = e.az((t3.y + 1) / i4), r4 = e.az(t3.y / i4), a3 = Math.min(Math.max(l2, o3), r4), n3 = e.b6(a3) / e.b6(l2);
                if (c3 = a3 === l2 ? 1 / Math.max(1, this._mercatorScaleRatio - 0.3) : Math.min(1, n3 / this._mercatorScaleRatio), this.zoom <= e.b3 && t3.zoom === L2 - 1 && n3 >= 0.9)
                  return true;
              } else if (a2 && (s3 = t3.aabb.distanceZ(g2) * f2), this.projection.isReprojectedInTileSpace && o2 <= 5) {
                const i4 = Math.pow(2, t3.zoom), o3 = E2(new e._((t3.x + 0.5) / i4, (t3.y + 0.5) / i4));
                c3 = o3 > 0.85 ? 1 : o3;
              }
              if (!n2) {
                const e2 = Math.sqrt(i3 * i3 + r3 * r3 + s3 * s3);
                let o3 = (1 << L2 - t3.zoom) * x2 * c3;
                return o3 *= A2(Math.max(s3, R2), e2), e2 < o3;
              }
              let u3 = Number.MAX_VALUE, d3 = 0;
              const p3 = t3.aabb.getCorners(), m3 = [];
              for (const t4 of p3) {
                e.$.sub(m3, t4, g2), _2 || (a2 ? m3[2] *= f2 : m3[2] = R2);
                const i4 = e.$.dot(m3, this._camera.forward());
                i4 < u3 && (u3 = i4, d3 = Math.abs(m3[2]));
              }
              let v3 = (1 << L2 - t3.zoom) * x2 * c3;
              if (v3 *= A2(Math.max(d3, R2), u3), u3 < v3)
                return true;
              const b3 = t3.aabb.closestPoint(h2);
              return b3[0] === h2[0] && b3[1] === h2[1];
            };
            if (this.renderWorldCopies)
              for (let e2 = 1; e2 <= 3; e2++)
                S2.push(C2(-e2)), S2.push(C2(e2));
            for (S2.push(C2(0)); S2.length > 0; ) {
              const o3 = S2.pop(), r3 = o3.x, s3 = o3.y;
              let l3 = o3.fullyVisible;
              const u3 = () => "globe" === this.projection.name && (0 === o3.y || o3.y === (1 << o3.zoom) - 1);
              if (!l3) {
                let t3 = v2 ? o3.aabb.intersects(d2) : o3.aabb.intersectsFlat(d2);
                if (0 === t3 && u3()) {
                  const i3 = new e.aO(o3.zoom, r3, s3);
                  t3 = e.aP(this, c2, i3, true).intersects(d2);
                }
                if (0 === t3)
                  continue;
                l3 = 2 === t3;
              }
              if (o3.zoom !== L2 && M2(o3))
                for (let t3 = 0; t3 < 4; t3++) {
                  const i3 = (r3 << 1) + t3 % 2, h3 = (s3 << 1) + (t3 >> 1), u4 = { aabb: n2 ? o3.aabb.quadrant(t3) : e.aR(this, c2, o3.zoom + 1, i3, h3, o3.wrap, o3.minZ, o3.maxZ, this.projection), zoom: o3.zoom + 1, x: i3, y: h3, wrap: o3.wrap, fullyVisible: l3, tileID: void 0, shouldSplit: void 0, minZ: o3.minZ, maxZ: o3.maxZ };
                  a2 && !_2 && (u4.tileID = new e.aQ(o3.zoom + 1 === L2 ? P2 : o3.zoom + 1, o3.wrap, o3.zoom + 1, i3, h3), D2(u4)), S2.push(u4);
                }
              else {
                const a3 = o3.zoom === L2 ? P2 : o3.zoom;
                if (t2.minzoom && t2.minzoom > a3)
                  continue;
                let n3 = 0;
                if (!l3) {
                  let i3 = v2 ? o3.aabb.intersectsPrecise(d2) : o3.aabb.intersectsPreciseFlat(d2);
                  if (0 === i3 && u3()) {
                    const t3 = new e.aO(o3.zoom, r3, s3);
                    i3 = e.aP(this, c2, t3, true).intersectsPrecise(d2);
                  }
                  if (0 === i3)
                    continue;
                  if (t2.calculateQuadrantVisibility)
                    if (d2.containsPoint(o3.aabb.center))
                      n3 = 15;
                    else
                      for (let e2 = 0; e2 < 4; e2++)
                        0 !== o3.aabb.quadrant(e2).intersects(d2) && (n3 |= 1 << e2);
                }
                const _3 = h2[0] - (0.5 + r3 + (o3.wrap << o3.zoom)) * (1 << i2 - o3.zoom), p3 = h2[1] - 0.5 - s3, f3 = o3.tileID ? o3.tileID : new e.aQ(a3, o3.wrap, o3.zoom, r3, s3);
                t2.calculateQuadrantVisibility && (f3.visibleQuadrants = n3), I2.push({ tileID: f3, distanceSq: _3 * _3 + p3 * p3 });
              }
            }
            if (this.fogCullDistSq) {
              const i3 = this.fogCullDistSq, o3 = this.horizonLineFromTop();
              I2 = I2.filter((r3) => {
                const a3 = [0, 0, 0, 1], n3 = [e.a4, e.a4, 0, 1], s3 = this.calculateFogTileMatrix(r3.tileID.toUnwrapped());
                e.aB.transformMat4(a3, a3, s3), e.aB.transformMat4(n3, n3, s3);
                const l3 = e.aB.min([], a3, n3), c3 = e.aB.max([], a3, n3), h3 = e.aS(l3, c3);
                if (0 === h3)
                  return true;
                let _3 = false;
                const u3 = this._elevation;
                if (u3 && h3 > i3 && 0 !== o3) {
                  const i4 = this.calculateProjMatrix(r3.tileID.toUnwrapped());
                  let a4;
                  t2.isTerrainDEM || (a4 = u3.getMinMaxForTile(r3.tileID)), a4 || (a4 = { min: w2, max: b2 });
                  const n4 = e.b4(this.rotation), s4 = [n4[0] * e.a4, n4[1] * e.a4, a4.max];
                  e.$.transformMat4(s4, s4, i4), _3 = (1 - s4[1]) * this.height * 0.5 < o3;
                }
                return h3 < i3 || _3;
              });
            }
            return I2.sort((e2, t3) => e2.distanceSq - t3.distanceSq).map((e2) => e2.tileID);
          }
          resize(e2, t2) {
            this.width = e2, this.height = t2, this.pixelsToGLUnits = [2 / e2, -2 / t2], this._constrain(), this._calcMatrices();
          }
          get unmodified() {
            return this._unmodified;
          }
          zoomScale(e2) {
            return Math.pow(2, e2);
          }
          scaleZoom(e2) {
            return Math.log(e2) / Math.LN2;
          }
          project(t2) {
            const i2 = e.au(t2.lat, -e.aT, e.aT), o2 = this.projection.project(t2.lng, i2);
            return new e.P(o2.x * this.worldSize, o2.y * this.worldSize);
          }
          unproject(e2) {
            return this.projection.unproject(e2.x / this.worldSize, e2.y / this.worldSize);
          }
          get point() {
            return this.project(this.center);
          }
          get pointMerc() {
            return this.point._div(this.worldSize);
          }
          get pixelsPerMeterRatio() {
            return this.pixelsPerMeter / e.ay(1, this.center.lat) / this.worldSize;
          }
          setLocationAtPoint(t2, i2) {
            let o2, r2;
            const a2 = this.centerPoint;
            if ("globe" === this.projection.name) {
              const e2 = this.worldSize;
              o2 = (i2.x - a2.x) / e2, r2 = (i2.y - a2.y) / e2;
            } else {
              const e2 = this.pointCoordinate(i2), t3 = this.pointCoordinate(a2);
              o2 = e2.x - t3.x, r2 = e2.y - t3.y;
            }
            const n2 = this.locationCoordinate(t2);
            this.setLocation(new e._(n2.x - o2, n2.y - r2));
          }
          setLocation(e2) {
            this.center = this.coordinateLocation(e2), this.projection.wrap && (this.center = this.center.wrap());
          }
          locationPoint(e2) {
            return this.projection.locationPoint(this, e2);
          }
          locationPoint3D(e2) {
            return this.projection.locationPoint(this, e2, true);
          }
          pointLocation(e2) {
            return this.coordinateLocation(this.pointCoordinate(e2));
          }
          pointLocation3D(e2) {
            return this.coordinateLocation(this.pointCoordinate3D(e2));
          }
          locationCoordinate(t2, i2) {
            const o2 = i2 ? e.ay(i2, t2.lat) : void 0, r2 = this.projection.project(t2.lng, t2.lat);
            return new e._(r2.x, r2.y, o2);
          }
          coordinateLocation(e2) {
            return this.projection.unproject(e2.x, e2.y);
          }
          pointRayIntersection(t2, i2) {
            const o2 = null != i2 ? i2 : this._centerAltitude, r2 = [t2.x, t2.y, 0, 1], a2 = [t2.x, t2.y, 1, 1];
            e.aB.transformMat4(r2, r2, this.pixelMatrixInverse), e.aB.transformMat4(a2, a2, this.pixelMatrixInverse);
            const n2 = a2[3];
            e.aB.scale(r2, r2, 1 / r2[3]), e.aB.scale(a2, a2, 1 / n2);
            const s2 = r2[2], l2 = a2[2];
            return { p0: r2, p1: a2, t: s2 === l2 ? 0 : (o2 - s2) / (l2 - s2) };
          }
          screenPointToMercatorRay(t2) {
            const i2 = [t2.x, t2.y, 0, 1], o2 = [t2.x, t2.y, 1, 1];
            return e.aB.transformMat4(i2, i2, this.pixelMatrixInverse), e.aB.transformMat4(o2, o2, this.pixelMatrixInverse), e.aB.scale(i2, i2, 1 / i2[3]), e.aB.scale(o2, o2, 1 / o2[3]), i2[2] = e.ay(i2[2], this._center.lat) * this.worldSize, o2[2] = e.ay(o2[2], this._center.lat) * this.worldSize, e.aB.scale(i2, i2, 1 / this.worldSize), e.aB.scale(o2, o2, 1 / this.worldSize), new e.aU([i2[0], i2[1], i2[2]], e.$.normalize([], e.$.sub([], o2, i2)));
          }
          rayIntersectionCoordinate(t2) {
            const { p0: i2, p1: o2, t: r2 } = t2, a2 = e.ay(i2[2], this._center.lat), n2 = e.ay(o2[2], this._center.lat);
            return new e._(e.a3(i2[0], o2[0], r2) / this.worldSize, e.a3(i2[1], o2[1], r2) / this.worldSize, e.a3(a2, n2, r2));
          }
          pointCoordinate(e2, t2 = this._centerAltitude) {
            return this.projection.pointCoordinate(this, e2.x, e2.y, t2);
          }
          pointCoordinate3D(t2) {
            if (!this.elevation)
              return this.pointCoordinate(t2);
            let i2 = this.projection.pointCoordinate3D(this, t2.x, t2.y);
            if (i2)
              return new e._(i2[0], i2[1], i2[2]);
            let o2 = 0, r2 = this.horizonLineFromTop();
            if (t2.y > r2)
              return this.pointCoordinate(t2);
            const a2 = 0.02 * r2, n2 = t2.clone();
            for (let t3 = 0; t3 < 10 && r2 - o2 > a2; t3++) {
              n2.y = e.a3(o2, r2, 0.66);
              const t4 = this.projection.pointCoordinate3D(this, n2.x, n2.y);
              t4 ? (r2 = n2.y, i2 = t4) : o2 = n2.y;
            }
            return i2 ? new e._(i2[0], i2[1], i2[2]) : this.pointCoordinate(t2);
          }
          isPointAboveHorizon(e2) {
            return this.projection.isPointAboveHorizon(this, e2);
          }
          isPointOnSurface(t2) {
            if (t2.y < 0 || t2.y > this.height || t2.x < 0 || t2.x > this.width)
              return false;
            if (this.elevation || this.zoom >= e.aV)
              return !this.isPointAboveHorizon(t2);
            const i2 = this.pointCoordinate(t2);
            return i2.y >= 0 && i2.y <= 1;
          }
          _coordinatePoint(t2, i2) {
            const o2 = i2 && this.elevation ? this.elevation.getAtPointOrZero(t2, this._centerAltitude) : this._centerAltitude, r2 = [t2.x * this.worldSize, t2.y * this.worldSize, o2 + t2.toAltitude(), 1];
            return e.aB.transformMat4(r2, r2, this.pixelMatrix), r2[3] > 0 ? new e.P(r2[0] / r2[3], r2[1] / r2[3]) : new e.P(Number.MAX_VALUE, Number.MAX_VALUE);
          }
          _getBoundsNonRectangular() {
            const { top: t2, left: i2 } = this._edgeInsets, o2 = this.height - this._edgeInsets.bottom, r2 = this.width - this._edgeInsets.right, a2 = this.pointLocation3D(new e.P(i2, t2)), n2 = this.pointLocation3D(new e.P(r2, t2)), s2 = this.pointLocation3D(new e.P(r2, o2)), l2 = this.pointLocation3D(new e.P(i2, o2));
            let c2 = Math.min(a2.lng, n2.lng, s2.lng, l2.lng), h2 = Math.max(a2.lng, n2.lng, s2.lng, l2.lng), _2 = Math.min(a2.lat, n2.lat, s2.lat, l2.lat), u2 = Math.max(a2.lat, n2.lat, s2.lat, l2.lat);
            const d2 = Math.pow(2, -this.zoom) / 16 * 270, p2 = "globe" === this.projection.name ? 1 : 4, f2 = (t3, i3, o3, r3, a3) => {
              const n3 = (t3 + o3) / 2, s3 = (i3 + r3) / 2, l3 = new e.P(n3, s3), { lng: m2, lat: g2 } = this.pointLocation3D(l3), v2 = Math.max(0, c2 - m2, _2 - g2, m2 - h2, g2 - u2);
              c2 = Math.min(c2, m2), h2 = Math.max(h2, m2), _2 = Math.min(_2, g2), u2 = Math.max(u2, g2), (a3 < p2 || v2 > d2) && (f2(t3, i3, n3, s3, a3 + 1), f2(n3, s3, o3, r3, a3 + 1));
            };
            if (f2(i2, t2, r2, t2, 1), f2(r2, t2, r2, o2, 1), f2(r2, o2, i2, o2, 1), f2(i2, o2, i2, t2, 1), "globe" === this.projection.name) {
              const [t3, i3] = e.aW(this);
              t3 ? (u2 = 90, h2 = 180, c2 = -180) : i3 && (_2 = -90, h2 = 180, c2 = -180);
            }
            return new e.aj(new e.aJ(c2, _2), new e.aJ(h2, u2));
          }
          _getBoundsRectangular(t2, i2) {
            const { top: o2, left: r2 } = this._edgeInsets, a2 = this.height - this._edgeInsets.bottom, n2 = this.width - this._edgeInsets.right, s2 = new e.P(r2, o2), l2 = new e.P(n2, o2), c2 = new e.P(n2, a2), h2 = new e.P(r2, a2);
            let _2 = this.pointCoordinate(s2, t2), u2 = this.pointCoordinate(l2, t2);
            const d2 = this.pointCoordinate(c2, i2), p2 = this.pointCoordinate(h2, i2), f2 = (e2, t3) => (t3.y - e2.y) / (t3.x - e2.x);
            return _2.y > 1 && u2.y >= 0 ? _2 = new e._((1 - p2.y) / f2(p2, _2) + p2.x, 1) : _2.y < 0 && u2.y <= 1 && (_2 = new e._(-p2.y / f2(p2, _2) + p2.x, 0)), u2.y > 1 && _2.y >= 0 ? u2 = new e._((1 - d2.y) / f2(d2, u2) + d2.x, 1) : u2.y < 0 && _2.y <= 1 && (u2 = new e._(-d2.y / f2(d2, u2) + d2.x, 0)), new e.aj().extend(this.coordinateLocation(_2)).extend(this.coordinateLocation(u2)).extend(this.coordinateLocation(p2)).extend(this.coordinateLocation(d2));
          }
          _getBoundsRectangularTerrain() {
            const e2 = this.elevation;
            if (!e2.visibleDemTiles.length || e2.isUsingMockSource())
              return this._getBoundsRectangular(0, 0);
            const t2 = e2.visibleDemTiles.reduce((e3, t3) => {
              if (t3.dem) {
                const i2 = t3.dem.tree;
                e3.min = Math.min(e3.min, i2.minimums[0]), e3.max = Math.max(e3.max, i2.maximums[0]);
              }
              return e3;
            }, { min: Number.MAX_VALUE, max: 0 });
            return this._getBoundsRectangular(t2.min * e2.exaggeration(), t2.max * e2.exaggeration());
          }
          getBounds() {
            return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
          }
          horizonLineFromTop(e2 = true) {
            const t2 = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, 0.1)) - this.centerOffset.y, i2 = this.height / 2 - t2 * (1 - this._horizonShift);
            return e2 ? Math.max(0, i2) : i2;
          }
          getMaxBounds() {
            return this.maxBounds;
          }
          setMaxBounds(t2) {
            this.maxBounds = t2, this.minLat = -e.aT, this.maxLat = e.aT, this.minLng = -180, this.maxLng = 180, t2 && (this.minLat = t2.getSouth(), this.maxLat = t2.getNorth(), this.minLng = t2.getWest(), this.maxLng = t2.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = e.ak(this.minLng) * this.tileSize, this.worldMaxX = e.ak(this.maxLng) * this.tileSize, this.worldMinY = e.al(this.maxLat) * this.tileSize, this.worldMaxY = e.al(this.minLat) * this.tileSize, this._constrain();
          }
          calculatePosMatrix(e2, t2) {
            return this.projection.createTileMatrix(this, t2, e2);
          }
          calculateDistanceTileData(t2) {
            const i2 = t2.key, o2 = this._distanceTileDataCache;
            if (o2[i2])
              return o2[i2];
            const r2 = t2.canonical, a2 = 1 / this.height, n2 = this.cameraWorldSize, s2 = n2 / this.zoomScale(r2.z), l2 = (r2.x + Math.pow(2, r2.z) * t2.wrap) * s2, c2 = r2.y * s2, h2 = this.point;
            h2.x *= n2 / this.worldSize, h2.y *= n2 / this.worldSize;
            const _2 = this.angle, u2 = Math.sin(-_2), d2 = -Math.cos(-_2);
            return o2[i2] = { bearing: [u2, d2], center: [(h2.x - l2) * a2, (h2.y - c2) * a2], scale: s2 / e.a4 * a2 }, o2[i2];
          }
          calculateFogTileMatrix(t2) {
            const i2 = t2.key, o2 = this._fogTileMatrixCache;
            if (o2[i2])
              return o2[i2];
            const r2 = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, t2);
            return e.ae.multiply(r2, this.worldToFogMatrix, r2), o2[i2] = new Float32Array(r2), o2[i2];
          }
          calculateProjMatrix(t2, i2 = false, o2 = false) {
            const r2 = t2.key;
            let a2;
            if (a2 = o2 ? this._expandedProjMatrixCache : i2 ? this._alignedProjMatrixCache : this._projMatrixCache, a2[r2])
              return a2[r2];
            const n2 = this.calculatePosMatrix(t2, this.worldSize);
            let s2;
            return s2 = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : o2 ? this.expandedFarZProjMatrix : i2 ? this.alignedProjMatrix : this.projMatrix, e.ae.multiply(n2, s2, n2), a2[r2] = new Float32Array(n2), a2[r2];
          }
          calculatePixelsToTileUnitsMatrix(t2) {
            const i2 = t2.tileID.key, o2 = this._pixelsToTileUnitsCache;
            if (o2[i2])
              return o2[i2];
            const r2 = e.aX(t2, this);
            return o2[i2] = r2, o2[i2];
          }
          customLayerMatrix() {
            return this.mercatorMatrix.slice();
          }
          globeToMercatorMatrix() {
            if ("globe" === this.projection.name) {
              const t2 = 1 / this.worldSize, i2 = e.ae.fromScaling([], [t2, t2, t2]);
              return e.ae.multiply(i2, i2, this.globeMatrix), i2;
            }
          }
          recenterOnTerrain() {
            if (!this._elevation || "globe" === this.projection.name)
              return;
            const t2 = this._elevation;
            this._updateCameraState();
            const i2 = e.ay(1, this._center.lat) * this.worldSize, o2 = this._computeCameraPosition(i2), r2 = this._camera.forward(), a2 = e.ay(1, this._center.lat);
            o2[2] /= a2, r2[2] /= a2, e.$.normalize(r2, r2);
            const n2 = t2.raycast(o2, r2, t2.exaggeration());
            if (n2) {
              const t3 = e.$.scaleAndAdd([], o2, r2, n2), i3 = new e._(t3[0], t3[1], e.ay(t3[2], e.az(t3[1]))), s2 = (i3.z + e.$.length([i3.x - o2[0], i3.y - o2[1], i3.z - o2[2] * a2])) * this._pixelsPerMercatorPixel;
              this._seaLevelZoom = this._zoomFromMercatorZ(s2), this._centerAltitude = i3.toAltitude(), this._center = this.coordinateLocation(i3), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
            }
          }
          _constrainCamera(t2 = false) {
            if (!this._elevation)
              return;
            const i2 = this._elevation, o2 = e.ay(1, this._center.lat) * this.worldSize, r2 = this._computeCameraPosition(o2), a2 = i2.getAtPointOrZero(new e._(...r2)), n2 = this.pixelsPerMeter / this.worldSize * a2, s2 = this._minimumHeightOverTerrain(), l2 = r2[2] - n2;
            if (l2 <= s2)
              if (l2 < 0 || t2) {
                const t3 = this.locationCoordinate(this._center, this._centerAltitude), i3 = [r2[0], r2[1], t3.z - r2[2]], o3 = e.$.length(i3);
                i3[2] -= (s2 - l2) / this._pixelsPerMercatorPixel;
                const a3 = e.$.length(i3);
                if (0 === a3)
                  return;
                e.$.scale(i3, i3, o3 / a3 * this._pixelsPerMercatorPixel), this._camera.position = [r2[0], r2[1], t3.z * this._pixelsPerMercatorPixel - i3[2]], this._updateStateFromCamera();
              } else
                this._isCameraConstrained = true;
          }
          _constrain() {
            if (!this.center || !this.width || !this.height || this._constraining)
              return;
            this._constraining = true;
            const t2 = "globe" === this.projection.name || this.mercatorFromTransition;
            if (this.projection.isReprojectedInTileSpace || t2) {
              const i3 = this.center;
              return i3.lat = e.au(i3.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !t2) && (i3.lng = e.au(i3.lng, this.minLng, this.maxLng)), this.center = i3, void (this._constraining = false);
            }
            const i2 = this._unmodified, { x: o2, y: r2 } = this.point;
            let a2 = 0, n2 = o2, s2 = r2;
            const l2 = this.width / 2, c2 = this.height / 2, h2 = this.worldMinY * this.scale, _2 = this.worldMaxY * this.scale;
            if (r2 - c2 < h2 && (s2 = h2 + c2), r2 + c2 > _2 && (s2 = _2 - c2), _2 - h2 < this.height && (a2 = Math.max(a2, this.height / (_2 - h2)), s2 = (_2 + h2) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
              const e2 = this.worldMinX * this.scale, t3 = this.worldMaxX * this.scale, i3 = this.worldSize / 2 - (e2 + t3) / 2;
              n2 = (o2 + i3 + this.worldSize) % this.worldSize - i3, n2 - l2 < e2 && (n2 = e2 + l2), n2 + l2 > t3 && (n2 = t3 - l2), t3 - e2 < this.width && (a2 = Math.max(a2, this.width / (t3 - e2)), n2 = (t3 + e2) / 2);
            }
            n2 === o2 && s2 === r2 || (this.center = this.unproject(new e.P(n2, s2))), a2 && (this.zoom += this.scaleZoom(a2)), this._constrainCamera(), this._unmodified = i2, this._constraining = false;
          }
          _minZoomForBounds() {
            let e2 = Math.max(0, this.scaleZoom(this.height / (this.worldMaxY - this.worldMinY)));
            return this.maxBounds && (e2 = Math.max(e2, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e2;
          }
          _maxCameraBoundsDistance() {
            return this._mercatorZfromZoom(this._minZoomForBounds());
          }
          _calcMatrices() {
            if (!this.height)
              return;
            const t2 = this.centerOffset, i2 = "globe" === this.projection.name, o2 = this.pixelsPerMeter;
            "globe" === this.projection.name && (this._mercatorScaleRatio = e.ay(1, this.center.lat) / e.ay(1, e.b5));
            const r2 = e.aY(this.projection, this.zoom, this.width, this.height, 1024);
            this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, r2), this.cameraToCenterDistance = 0.5 / Math.tan(0.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
            const a2 = "meters" === this.projection.zAxisUnit ? o2 : 1, n2 = this._camera.getWorldToCamera(this.worldSize, a2);
            let s2;
            const l2 = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
            if (l2[8] = 2 * -t2.x / this.width, l2[9] = 2 * t2.y / this.height, this.isOrthographic) {
              let e2 = 0.5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(0.5 * this._fov), i3 = e2 * this.aspect, o3 = -i3, r3 = -e2;
              i3 -= t2.x, o3 -= t2.x, e2 += t2.y, r3 += t2.y, s2 = this._camera.getCameraToClipOrthographic(o3, i3, r3, e2, this._nearZ, this._farZ), ((e3, t3, i4, o4) => {
                for (let r4 = 0; r4 < 16; r4++)
                  e3[r4] = li(t3[r4], i4[r4], o4);
              })(s2, s2, l2, ci(this.pitch >= 15 ? 1 : this.pitch / 15));
            } else
              s2 = l2;
            const c2 = e.ae.mul([], l2, n2);
            let h2 = e.ae.mul([], s2, n2);
            if (this.projection.isReprojectedInTileSpace) {
              const t3 = this.locationCoordinate(this.center), i3 = e.ae.identity([]);
              e.ae.translate(i3, i3, [t3.x * this.worldSize, t3.y * this.worldSize, 0]), e.ae.multiply(i3, i3, e.aZ(this)), e.ae.translate(i3, i3, [-t3.x * this.worldSize, -t3.y * this.worldSize, 0]), e.ae.multiply(h2, h2, i3), e.ae.multiply(c2, c2, i3), this.inverseAdjustmentMatrix = e.a_(this);
            } else
              this.inverseAdjustmentMatrix = [1, 0, 0, 1];
            if (this.mercatorMatrix = e.ae.scale([], h2, [this.worldSize, this.worldSize, this.worldSize / a2, 1]), this.projMatrix = h2, this.invProjMatrix = e.ae.invert(new Float64Array(16), this.projMatrix), i2) {
              const i3 = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
              i3[8] = 2 * -t2.x / this.width, i3[9] = 2 * t2.y / this.height, this.expandedFarZProjMatrix = e.ae.mul([], i3, n2);
            } else
              this.expandedFarZProjMatrix = this.projMatrix;
            const _2 = e.ae.invert([], s2);
            this.frustumCorners = e.a$.fromInvProjectionMatrix(_2, this.horizonLineFromTop(), this.height), this.cameraFrustum = e.aM.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, 0, !i2);
            const u2 = new Float32Array(16);
            e.ae.identity(u2), e.ae.scale(u2, u2, [1, -1, 1]), e.ae.rotateX(u2, u2, this._pitch), e.ae.rotateZ(u2, u2, this.angle);
            const d2 = e.ae.perspective(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ);
            this.starsProjMatrix = e.ae.clone(d2);
            const p2 = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
            d2[8] = 2 * -t2.x / this.width, d2[9] = 2 * (t2.y + p2) / this.height, this.skyboxMatrix = e.ae.multiply(u2, d2, u2);
            const f2 = this.point, m2 = f2.x, g2 = f2.y, v2 = this.width % 2 / 2, x2 = this.height % 2 / 2, y2 = Math.cos(this.angle), b2 = Math.sin(this.angle), w2 = m2 - Math.round(m2) + y2 * v2 + b2 * x2, T2 = g2 - Math.round(g2) + y2 * x2 + b2 * v2, E2 = new Float64Array(h2);
            if (e.ae.translate(E2, E2, [w2 > 0.5 ? w2 - 1 : w2, T2 > 0.5 ? T2 - 1 : T2, 0]), this.alignedProjMatrix = E2, h2 = e.ae.create(), e.ae.scale(h2, h2, [this.width / 2, -this.height / 2, 1]), e.ae.translate(h2, h2, [1, -1, 0]), this.labelPlaneMatrix = h2, h2 = e.ae.create(), e.ae.scale(h2, h2, [1, -1, 1]), e.ae.translate(h2, h2, [-1, -1, 0]), e.ae.scale(h2, h2, [2 / this.width, 2 / this.height, 1]), this.glCoordMatrix = h2, this.pixelMatrix = e.ae.multiply(new Float64Array(16), this.labelPlaneMatrix, c2), this._calcFogMatrices(), this._distanceTileDataCache = {}, h2 = e.ae.invert(new Float64Array(16), this.pixelMatrix), !h2)
              throw new Error("failed to invert matrix");
            if (this.pixelMatrixInverse = h2, "globe" === this.projection.name || this.mercatorFromTransition) {
              this.globeMatrix = e.b0(this);
              const t3 = [this.globeMatrix[12], this.globeMatrix[13], this.globeMatrix[14]];
              this.globeCenterInViewSpace = e.$.transformMat4(t3, t3, n2), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
            } else
              this.globeMatrix = h2;
            this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {}, this._expandedProjMatrixCache = {};
          }
          _calcFogMatrices() {
            this._fogTileMatrixCache = {};
            const t2 = this.cameraWorldSizeForFog, i2 = this.cameraPixelsPerMeter, o2 = this._camera.position, r2 = 1 / this.height / this._pixelsPerMercatorPixel, a2 = [t2, t2, i2];
            e.$.scale(a2, a2, r2), e.$.scale(o2, o2, -1), e.$.multiply(o2, o2, a2);
            const n2 = e.ae.create();
            e.ae.translate(n2, n2, o2), e.ae.scale(n2, n2, a2), this.mercatorFogMatrix = n2, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(t2, i2, r2);
          }
          _computeCameraPosition(e2) {
            const t2 = (e2 = e2 || this.pixelsPerMeter) / this.pixelsPerMeter, i2 = this._camera.forward(), o2 = this.point, r2 = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t2 - e2 / this.worldSize * this._centerAltitude;
            return [o2.x / this.worldSize - i2[0] * r2, o2.y / this.worldSize - i2[1] * r2, e2 / this.worldSize * this._centerAltitude - i2[2] * r2];
          }
          _updateCameraState() {
            this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
          }
          _translateCameraConstrained(t2) {
            const i2 = this._maxCameraBoundsDistance() * Math.cos(this._pitch), o2 = this._camera.position[2], r2 = t2[2];
            let a2 = 1;
            this.projection.wrap && (this.center = this.center.wrap()), r2 > 0 && (a2 = Math.min((i2 - o2) / r2, 1)), this._camera.position = e.$.scaleAndAdd([], this._camera.position, t2, a2), this._updateStateFromCamera();
          }
          _updateStateFromCamera() {
            const t2 = this._camera.position, i2 = this._camera.forward(), { pitch: o2, bearing: r2 } = this._camera.getPitchBearing(), a2 = e.ay(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, n2 = this._mercatorZfromZoom(this._maxZoom) * Math.cos(e.ac(this._maxPitch)), s2 = Math.max((t2[2] - a2) / Math.cos(o2), n2), l2 = this._zoomFromMercatorZ(s2);
            e.$.scaleAndAdd(t2, t2, i2, s2), this._pitch = e.au(o2, e.ac(this.minPitch), e.ac(this.maxPitch)), this.angle = e.av(r2, -Math.PI, Math.PI), this._setZoom(e.au(l2, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new e._(t2[0], t2[1], t2[2])), this._unmodified = false, this._constrain(), this._calcMatrices();
          }
          _worldSizeFromZoom(e2) {
            return Math.pow(2, e2) * this.tileSize;
          }
          _mercatorZfromZoom(e2) {
            return this.cameraToCenterDistance / this._worldSizeFromZoom(e2);
          }
          _minimumHeightOverTerrain() {
            const e2 = Math.min(null != this._seaLevelZoom ? this._seaLevelZoom : this._zoom, this._maxZoom) + 4;
            return this._mercatorZfromZoom(e2);
          }
          _zoomFromMercatorZ(e2) {
            return this.scaleZoom(this.cameraToCenterDistance / (e2 * this.tileSize));
          }
          zoomFromMercatorZAdjusted(t2) {
            let i2 = 0, o2 = e.aV, r2 = 0, a2 = 1 / 0;
            for (; o2 - i2 > 1e-6 && o2 > i2; ) {
              const e2 = i2 + 0.5 * (o2 - i2), n2 = this.tileSize * Math.pow(2, e2), s2 = this.getCameraToCenterDistance(this.projection, e2, n2), l2 = this.scaleZoom(s2 / (t2 * this.tileSize)), c2 = Math.abs(e2 - l2);
              c2 < a2 && (a2 = c2, r2 = e2), e2 < l2 ? i2 = e2 : o2 = e2;
            }
            return r2;
          }
          _terrainEnabled() {
            return !(!this._elevation || !this.projection.supportsTerrain && (e.w("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
          }
          anyCornerOffEdge(t2, i2) {
            const o2 = Math.min(t2.x, i2.x), r2 = Math.max(t2.x, i2.x), a2 = Math.min(t2.y, i2.y), n2 = Math.max(t2.y, i2.y);
            if (a2 < this.horizonLineFromTop(false))
              return true;
            if ("mercator" !== this.projection.name)
              return false;
            const s2 = [new e.P(o2, a2), new e.P(r2, n2), new e.P(o2, n2), new e.P(r2, a2)], l2 = this.renderWorldCopies ? -3 : 0, c2 = this.renderWorldCopies ? 4 : 1;
            for (const e2 of s2) {
              const t3 = this.pointRayIntersection(e2);
              if (t3.t < 0)
                return true;
              const i3 = this.rayIntersectionCoordinate(t3);
              if (i3.x < l2 || i3.y < 0 || i3.x > c2 || i3.y > 1)
                return true;
            }
            return false;
          }
          isHorizonVisible() {
            return this.pitch + e.b1(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new e.P(0, 0), new e.P(this.width, this.height));
          }
          zoomDeltaToMovement(t2, i2) {
            const o2 = e.$.length(e.$.sub([], this._camera.position, t2)), r2 = this._zoomFromMercatorZ(o2) + i2;
            return o2 - this._mercatorZfromZoom(r2);
          }
          getCameraPoint() {
            if ("globe" === this.projection.name) {
              const t2 = function([t3, i2, o2], r2) {
                const a2 = [t3, i2, o2, 1];
                e.aB.transformMat4(a2, a2, r2);
                const n2 = a2[3] = Math.max(a2[3], 1e-6);
                return a2[0] /= n2, a2[1] /= n2, a2[2] /= n2, a2;
              }([this.globeMatrix[12], this.globeMatrix[13], this.globeMatrix[14]], this.pixelMatrix);
              return new e.P(t2[0], t2[1]);
            }
            {
              const t2 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
              return this.centerPoint.add(new e.P(0, t2));
            }
          }
          getCameraToCenterDistance(t2, i2 = this.zoom, o2 = this.worldSize) {
            const r2 = e.aY(t2, i2, this.width, this.height, 1024), a2 = t2.pixelSpaceConversion(this.center.lat, o2, r2);
            let n2 = 0.5 / Math.tan(0.5 * this._fov) * this.height * a2;
            return this.isOrthographic && (n2 = li(1, n2, ci(this.pitch >= 15 ? 1 : this.pitch / 15))), n2;
          }
          getWorldToCameraMatrix() {
            const t2 = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? this.pixelsPerMeter : 1);
            return "globe" === this.projection.name && e.ae.multiply(t2, t2, this.globeMatrix), t2;
          }
          getFrustum(t2) {
            return e.aM.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, t2, "meters" === this.projection.zAxisUnit);
          }
        }
        const _i = { BaseColor: 5, MetallicRoughness: 6, Normal: 7, Occlusion: 8, Emission: 9, LUT: 10, ShadowMap0: 11 }, ui = (t2, i2) => {
          if (i2 > 0 && t2.terrain && e.w("Cutoff is currently disabled on terrain"), i2 <= 0 || t2.terrain)
            return { shouldRenderCutoff: false, uniformValues: { u_cutoff_params: [0, 0, 0, 1] } };
          const o2 = t2.transform, r2 = Math.max(Math.abs(o2._zoom - (t2.minCutoffZoom - 1)), 1), a2 = o2.isLODDisabled(false) ? e.a0(60, 45, o2.pitch) : e.a0(30, 15, o2.pitch), n2 = o2._farZ - o2._nearZ, s2 = i2 * o2.height, l2 = ((1 - (c2 = a2)) * o2.cameraToCenterDistance + c2 * (o2._farZ + s2)) * r2;
          var c2;
          return { shouldRenderCutoff: a2 < 1, uniformValues: { u_cutoff_params: [o2._nearZ, o2._farZ, (l2 - o2._nearZ) / n2, (l2 - s2 - o2._nearZ) / n2] } };
        }, di = { cascadeCount: 2, normalOffset: 3, shadowMapResolution: 2048 };
        class pi {
          constructor(e2, t2) {
            this.aabb = e2, this.lastCascade = t2;
          }
        }
        class fi {
          add(e2, t2) {
            const i2 = this.receivers[e2.key];
            void 0 !== i2 ? (i2.aabb.min[0] = Math.min(i2.aabb.min[0], t2.min[0]), i2.aabb.min[1] = Math.min(i2.aabb.min[1], t2.min[1]), i2.aabb.min[2] = Math.min(i2.aabb.min[2], t2.min[2]), i2.aabb.max[0] = Math.max(i2.aabb.max[0], t2.max[0]), i2.aabb.max[1] = Math.max(i2.aabb.max[1], t2.max[1]), i2.aabb.max[2] = Math.max(i2.aabb.max[2], t2.max[2])) : this.receivers[e2.key] = new pi(t2, null);
          }
          clear() {
            this.receivers = {};
          }
          get(e2) {
            return this.receivers[e2.key];
          }
          computeRequiredCascades(t2, i2, o2) {
            const r2 = e.b8.fromPoints(t2.points);
            let a2 = 0;
            for (const t3 in this.receivers) {
              const n2 = this.receivers[t3];
              if (!n2)
                continue;
              if (!r2.intersectsAabb(n2.aabb))
                continue;
              n2.aabb.min = r2.closestPoint(n2.aabb.min), n2.aabb.max = r2.closestPoint(n2.aabb.max);
              const s2 = n2.aabb.getCorners();
              for (let t4 = 0; t4 < o2.length; t4++) {
                let r3 = true;
                for (const a3 of s2) {
                  const n3 = [a3[0] * i2, a3[1] * i2, a3[2]];
                  if (e.$.transformMat4(n3, n3, o2[t4].matrix), n3[0] < -1 || n3[0] > 1 || n3[1] < -1 || n3[1] > 1) {
                    r3 = false;
                    break;
                  }
                }
                if (n2.lastCascade = t4, a2 = Math.max(a2, t4), r3)
                  break;
              }
            }
            return a2 + 1;
          }
        }
        class mi {
          constructor(t2) {
            this.painter = t2, this._enabled = false, this._shadowLayerCount = 0, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new fi(), this._depthMode = new e.af(t2.context.gl.LEQUAL, e.af.ReadWrite, [0, 1]), this._uniformValues = { u_light_matrix_0: new Float32Array(16), u_light_matrix_1: new Float32Array(16), u_shadow_intensity: 0, u_fade_range: [0, 0], u_shadow_normal_offset: [1, 1, 1], u_shadow_texel_size: 1, u_shadow_map_resolution: 1, u_shadow_direction: [0, 0, 1], u_shadow_bias: [36e-5, 12e-4, 0.012], u_shadowmap_0: 0, u_shadowmap_1: 0 }, this._forceDisable = false, this.useNormalOffset = false, t2.tp.registerParameter(this, ["Shadows"], "_forceDisable", { label: "forceDisable" }, () => {
              this.painter.style.map.triggerRepaint();
            }), t2.tp.registerParameter(di, ["Shadows"], "cascadeCount", { min: 1, max: 2, step: 1 }), t2.tp.registerParameter(di, ["Shadows"], "normalOffset", { min: 0, max: 10, step: 0.05 }), t2.tp.registerParameter(di, ["Shadows"], "shadowMapResolution", { min: 32, max: 2048, step: 32 }), t2.tp.registerBinding(this, ["Shadows"], "_numCascadesToRender", { readonly: true, label: "numCascadesToRender" });
          }
          destroy() {
            for (const e2 of this._cascades)
              e2.texture.destroy(), e2.framebuffer.destroy();
            this._cascades = [];
          }
          updateShadowParameters(t2, i2) {
            const o2 = this.painter;
            if (this._enabled = false, this._shadowLayerCount = 0, this._receivers.clear(), !i2 || !i2.properties)
              return;
            const r2 = i2.properties.get("shadow-intensity");
            if (!i2.shadowsEnabled() || r2 <= 0)
              return;
            if (this._shadowLayerCount = o2.style.order.reduce((e2, i3) => {
              const r3 = o2.style._mergedLayers[i3];
              return e2 + (r3.hasShadowPass() && !r3.isHidden(t2.zoom) ? 1 : 0);
            }, 0), this._enabled = this._shadowLayerCount > 0, !this.enabled)
              return;
            const a2 = o2.context, n2 = di.shadowMapResolution, s2 = di.shadowMapResolution;
            if (0 === this._cascades.length || di.shadowMapResolution !== this._cascades[0].texture.size[0]) {
              this._cascades = [];
              for (let t3 = 0; t3 < di.cascadeCount; ++t3) {
                const t4 = o2._shadowMapDebug, i3 = a2.gl, r3 = a2.createFramebuffer(n2, s2, t4, "texture"), l3 = new e.T(a2, { width: n2, height: s2, data: null }, i3.DEPTH_COMPONENT);
                if (r3.depthAttachment.set(l3.texture), t4) {
                  const t5 = new e.T(a2, { width: n2, height: s2, data: null }, i3.RGBA);
                  r3.colorAttachment.set(t5.texture);
                }
                this._cascades.push({ framebuffer: r3, texture: l3, matrix: [], far: 0, boundingSphereRadius: 0, frustum: new e.aM(), scale: 0 });
              }
            }
            this.shadowDirection = vi(i2);
            let l2 = 0;
            if (t2.elevation) {
              const e2 = t2.elevation, i3 = [1e4, -1e4];
              e2.visibleDemTiles.filter((e3) => e3.dem).forEach((e3) => {
                const t3 = e3.dem.tree;
                i3[0] = Math.min(i3[0], t3.minimums[0]), i3[1] = Math.max(i3[1], t3.maximums[0]);
              }), 1e4 !== i3[0] && (l2 = (i3[1] - i3[0]) * e2.exaggeration());
            }
            const c2 = 1.5 * t2.cameraToCenterDistance, h2 = 3 * c2, _2 = new Float64Array(16);
            for (let i3 = 0; i3 < this._cascades.length; ++i3) {
              const o3 = this._cascades[i3];
              let r3 = t2.height / 50, a3 = 1;
              1 === di.cascadeCount ? a3 = h2 : 0 === i3 ? a3 = c2 : (r3 = c2, a3 = h2);
              const [n3, s3] = yi(t2, this.shadowDirection, r3, a3, di.shadowMapResolution, l2);
              o3.scale = t2.scale, o3.matrix = n3, o3.boundingSphereRadius = s3, e.ae.invert(_2, o3.matrix), o3.frustum = e.aM.fromInvProjectionMatrix(_2, 1, 0, true), o3.far = a3;
            }
            const u2 = this._cascades.length - 1;
            this._uniformValues.u_fade_range = [0.75 * this._cascades[u2].far, this._cascades[u2].far], this._uniformValues.u_shadow_intensity = r2, this._uniformValues.u_shadow_direction = [this.shadowDirection[0], this.shadowDirection[1], this.shadowDirection[2]], this._uniformValues.u_shadow_texel_size = 1 / di.shadowMapResolution, this._uniformValues.u_shadow_map_resolution = di.shadowMapResolution, this._uniformValues.u_shadowmap_0 = _i.ShadowMap0, this._uniformValues.u_shadowmap_1 = _i.ShadowMap0 + 1, this._groundShadowTiles = o2.transform.coveringTiles({ tileSize: 512, renderWorldCopies: true });
            const d2 = o2.transform.elevation;
            for (const e2 of this._groundShadowTiles) {
              let t3 = { min: 0, max: 0 };
              if (d2) {
                const i3 = d2.getMinMaxForTile(e2);
                i3 && (t3 = i3);
              }
              this.addShadowReceiver(e2.toUnwrapped(), t3.min, t3.max);
            }
          }
          get enabled() {
            return this._enabled && !this._forceDisable;
          }
          set enabled(e2) {
            this._enabled = e2;
          }
          drawShadowPass(t2, i2) {
            if (!this.enabled)
              return;
            const o2 = this.painter, r2 = o2.context;
            this._numCascadesToRender = this._receivers.computeRequiredCascades(o2.transform.getFrustum(0), o2.transform.worldSize, this._cascades), r2.viewport.set([0, 0, di.shadowMapResolution, di.shadowMapResolution]);
            for (let a2 = 0; a2 < this._numCascadesToRender; ++a2) {
              o2.currentShadowCascade = a2, r2.bindFramebuffer.set(this._cascades[a2].framebuffer.framebuffer), r2.clear({ color: e.C.white, depth: 1 });
              for (const e2 of t2.order) {
                const r3 = t2._mergedLayers[e2];
                if (!r3.hasShadowPass() || r3.isHidden(o2.transform.zoom))
                  continue;
                const a3 = t2.getLayerSourceCache(r3), n2 = a3 ? i2[a3.id] : void 0;
                ("model" === r3.type || n2 && n2.length) && o2.renderLayer(o2, a3, r3, n2);
              }
            }
            o2.currentShadowCascade = 0;
          }
          drawGroundShadows() {
            if (!this.enabled)
              return;
            const t2 = this.painter, i2 = t2.style, o2 = t2.context, r2 = i2.directionalLight, a2 = i2.ambientLight;
            if (!r2 || !a2)
              return;
            const n2 = [], s2 = ui(t2, t2.longestCutoffRange);
            s2.shouldRenderCutoff && n2.push("RENDER_CUTOFF");
            const l2 = xi(i2, r2, a2), c2 = new e.af(o2.gl.LEQUAL, e.af.ReadOnly, t2.depthRangeFor3D);
            for (const i3 of this._groundShadowTiles) {
              const r3 = i3.toUnwrapped(), a3 = t2.isTileAffectedByFog(i3), h2 = t2.getOrCreateProgram("groundShadow", { defines: n2, overrideFog: a3 });
              this.setupShadows(r3, h2), t2.uploadCommonUniforms(o2, h2, r3, null, s2);
              const _2 = { u_matrix: t2.transform.calculateProjMatrix(r3), u_ground_shadow_factor: l2 };
              h2.draw(t2, o2.gl.TRIANGLES, c2, e.ah.disabled, e.a.multiply, e.ag.disabled, _2, "ground_shadow", t2.tileExtentBuffer, t2.quadTriangleIndexBuffer, t2.tileExtentSegments, {}, t2.transform.zoom, null, null);
            }
          }
          getShadowPassColorMode() {
            return this.painter._shadowMapDebug ? e.a.unblended : e.a.disabled;
          }
          getShadowPassDepthMode() {
            return this._depthMode;
          }
          getShadowCastingLayerCount() {
            return this._shadowLayerCount;
          }
          calculateShadowPassMatrixFromTile(t2) {
            const i2 = this.painter.transform, o2 = i2.calculatePosMatrix(t2, i2.worldSize);
            return e.ae.multiply(o2, this._cascades[this.painter.currentShadowCascade].matrix, o2), Float32Array.from(o2);
          }
          calculateShadowPassMatrixFromMatrix(t2) {
            return e.ae.multiply(t2, this._cascades[this.painter.currentShadowCascade].matrix, t2), Float32Array.from(t2);
          }
          setupShadows(t2, i2, o2, r2 = 0) {
            if (!this.enabled)
              return;
            const a2 = this.painter.transform, n2 = this.painter.context, s2 = n2.gl, l2 = this._uniformValues, c2 = new Float64Array(16), h2 = a2.calculatePosMatrix(t2, a2.worldSize);
            for (let t3 = 0; t3 < this._cascades.length; t3++)
              e.ae.multiply(c2, this._cascades[t3].matrix, h2), l2[0 === t3 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(c2), n2.activeTexture.set(s2.TEXTURE0 + _i.ShadowMap0 + t3), this._cascades[t3].texture.bind(s2.NEAREST, s2.CLAMP_TO_EDGE);
            if (this.useNormalOffset = !!o2, this.useNormalOffset) {
              const i3 = e.b7(t2.canonical), n3 = 2 / a2.tileSize * e.a4 / di.shadowMapResolution, s3 = n3 * this._cascades[0].boundingSphereRadius, c3 = n3 * this._cascades[this._cascades.length - 1].boundingSphereRadius, h3 = ("vector-tile" === o2 ? 1 : 3) / Math.pow(2, r2 - t2.canonical.z - (1 - a2.zoom + Math.floor(a2.zoom)));
              l2.u_shadow_normal_offset = [i3, s3 * h3, c3 * h3], l2.u_shadow_bias = [6e-5, 12e-4, 0.012];
            } else
              l2.u_shadow_bias = [36e-5, 12e-4, 0.012];
            i2.setShadowUniformValues(n2, l2);
          }
          setupShadowsFromMatrix(t2, i2, o2 = false) {
            if (!this.enabled)
              return;
            const r2 = this.painter.context, a2 = r2.gl, n2 = this._uniformValues, s2 = new Float64Array(16);
            for (let i3 = 0; i3 < di.cascadeCount; i3++)
              e.ae.multiply(s2, this._cascades[i3].matrix, t2), n2[0 === i3 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(s2), r2.activeTexture.set(a2.TEXTURE0 + _i.ShadowMap0 + i3), this._cascades[i3].texture.bind(a2.NEAREST, a2.CLAMP_TO_EDGE);
            if (this.useNormalOffset = o2, o2) {
              const e2 = di.normalOffset;
              n2.u_shadow_normal_offset = [1, e2, e2], n2.u_shadow_bias = [6e-5, 12e-4, 0.012];
            } else
              n2.u_shadow_bias = [36e-5, 12e-4, 0.012];
            i2.setShadowUniformValues(r2, n2);
          }
          getShadowUniformValues() {
            return this._uniformValues;
          }
          getCurrentCascadeFrustum() {
            return this._cascades[this.painter.currentShadowCascade].frustum;
          }
          computeSimplifiedTileShadowVolume(t2, i2, o2, r2) {
            if (r2[2] >= 0)
              return {};
            const a2 = function(t3, i3, o3) {
              const r3 = o3 / (1 << t3.canonical.z);
              return new e.b8([t3.canonical.x * r3 + t3.wrap * o3, t3.canonical.y * r3 + t3.wrap * o3, 0], [(t3.canonical.x + 1) * r3 + t3.wrap * o3, (t3.canonical.y + 1) * r3 + t3.wrap * o3, i3]);
            }(t2, i2, o2).getCorners(), n2 = i2 / -r2[2];
            r2[0] < 0 ? (e.$.add(a2[0], a2[0], [r2[0] * n2, 0, 0]), e.$.add(a2[3], a2[3], [r2[0] * n2, 0, 0])) : r2[0] > 0 && (e.$.add(a2[1], a2[1], [r2[0] * n2, 0, 0]), e.$.add(a2[2], a2[2], [r2[0] * n2, 0, 0])), r2[1] < 0 ? (e.$.add(a2[0], a2[0], [0, r2[1] * n2, 0]), e.$.add(a2[1], a2[1], [0, r2[1] * n2, 0])) : r2[1] > 0 && (e.$.add(a2[2], a2[2], [0, r2[1] * n2, 0]), e.$.add(a2[3], a2[3], [0, r2[1] * n2, 0]));
            const s2 = {};
            return s2.vertices = a2, s2.planes = [gi(a2[1], a2[0], a2[4]), gi(a2[2], a2[1], a2[5]), gi(a2[3], a2[2], a2[6]), gi(a2[0], a2[3], a2[7])], s2;
          }
          addShadowReceiver(t2, i2, o2) {
            this._receivers.add(t2, e.b8.fromTileIdAndHeight(t2, i2, o2));
          }
          getMaxCascadeForTile(e2) {
            const t2 = this._receivers.get(e2);
            return t2 && t2.lastCascade ? t2.lastCascade : 0;
          }
        }
        function gi(t2, i2, o2) {
          const r2 = e.$.sub([], o2, i2), a2 = e.$.sub([], t2, i2), n2 = e.$.cross([], r2, a2), s2 = e.$.length(n2);
          return 0 === s2 ? [0, 0, 1, 0] : (e.$.scale(n2, n2, 1 / s2), [n2[0], n2[1], n2[2], -e.$.dot(n2, i2)]);
        }
        function vi(t2) {
          const i2 = t2.properties.get("direction"), o2 = e.ad(i2.x, i2.y, i2.z);
          o2[2] = e.au(o2[2], 0, 75);
          const r2 = e.b9([o2[0], o2[1], o2[2]]);
          return e.$.fromValues(r2.x, r2.y, r2.z);
        }
        function xi(t2, i2, o2) {
          const r2 = i2.properties.get("color"), a2 = i2.properties.get("intensity"), n2 = i2.properties.get("direction"), s2 = [n2.x, n2.y, n2.z], l2 = o2.properties.get("color"), c2 = o2.properties.get("intensity"), h2 = Math.max(e.$.dot([0, 0, 1], s2), 0), _2 = [0, 0, 0];
          e.$.scale(_2, l2.toRenderColor(t2.getLut(i2.scope)).toArray01Linear().slice(0, 3), c2);
          const u2 = [0, 0, 0];
          return e.$.scale(u2, r2.toRenderColor(t2.getLut(o2.scope)).toArray01Linear().slice(0, 3), h2 * a2), e.ba([_2[0] > 0 ? _2[0] / (_2[0] + u2[0]) : 0, _2[1] > 0 ? _2[1] / (_2[1] + u2[1]) : 0, _2[2] > 0 ? _2[2] / (_2[2] + u2[2]) : 0]);
        }
        function yi(t2, i2, o2, r2, a2, n2) {
          const s2 = t2.zoom, l2 = t2.scale, c2 = t2.worldSize, h2 = 1 / c2, _2 = t2.aspect, u2 = Math.sqrt(1 + _2 * _2) * Math.tan(0.5 * t2.fovX), d2 = u2 * u2, p2 = r2 - o2, f2 = r2 + o2;
          let m2, g2;
          d2 > p2 / f2 ? (m2 = r2, g2 = r2 * u2) : (m2 = 0.5 * f2 * (1 + d2), g2 = 0.5 * Math.sqrt(p2 * p2 + 2 * (r2 * r2 + o2 * o2) * d2 + f2 * f2 * d2 * d2));
          const v2 = t2.projection.pixelsPerMeter(t2.center.lat, c2), x2 = t2._camera.getCameraToWorldMercator(), y2 = [0, 0, -m2 * h2];
          e.$.transformMat4(y2, y2, x2);
          let b2 = g2 * h2;
          const w2 = t2._edgeInsets;
          if (!(0 === w2.left && 0 === w2.top && 0 === w2.right && 0 === w2.bottom || w2.left === w2.right && w2.top === w2.bottom)) {
            const i3 = t2._camera.getWorldToCamera(t2.worldSize, "meters" === t2.projection.zAxisUnit ? v2 : 1), a3 = t2._camera.getCameraToClipPerspective(t2._fov, t2.width / t2.height, o2, r2);
            a3[8] = 2 * -t2.centerOffset.x / t2.width, a3[9] = 2 * t2.centerOffset.y / t2.height;
            const n3 = new Float64Array(16);
            e.ae.mul(n3, a3, i3);
            const h3 = new Float64Array(16);
            e.ae.invert(h3, n3);
            const _3 = e.aM.fromInvProjectionMatrix(h3, c2, s2, true);
            for (const i4 of _3.points) {
              const o3 = ((T2 = i4)[0] /= l2, T2[1] /= l2, T2[2] = e.ay(T2[2], t2._center.lat), T2);
              b2 = Math.max(b2, e.$.len(e.$.subtract([], y2, o3)));
            }
          }
          var T2;
          b2 *= a2 / (a2 - 1);
          const E2 = Math.acos(i2[2]), C2 = Math.atan2(-i2[0], -i2[1]), S2 = new $t();
          S2.position = y2, S2.setPitchBearing(E2, C2);
          const I2 = S2.getWorldToCamera(c2, v2), L2 = b2 * c2, P2 = Math.min(t2._mercatorZfromZoom(17) * c2 * -2, -2 * L2), R2 = S2.getCameraToClipOrthographic(-L2, L2, -L2, L2, P2, (L2 + n2 * v2) / i2[2]), D2 = new Float64Array(16);
          e.ae.multiply(D2, R2, I2);
          const A2 = e.$.fromValues(Math.floor(1e6 * y2[0]) / 1e6 * c2, Math.floor(1e6 * y2[1]) / 1e6 * c2, 0), M2 = 0.5 * a2, z2 = [0, 0, 0];
          e.$.transformMat4(z2, A2, D2), e.$.scale(z2, z2, M2);
          const O2 = [Math.floor(z2[0]), Math.floor(z2[1]), Math.floor(z2[2])], F2 = [0, 0, 0];
          e.$.sub(F2, z2, O2), e.$.scale(F2, F2, -1 / M2);
          const B2 = new Float64Array(16);
          return e.ae.identity(B2), e.ae.translate(B2, B2, F2), e.ae.multiply(D2, B2, D2), [D2, L2];
        }
        function bi(e2, t2) {
          return null != e2 && null != t2 && !(!e2.hasData() || !t2.hasData()) && null != e2.demTexture && null != t2.demTexture && e2.tileID.key !== t2.tileID.key;
        }
        const wi = new class {
          constructor() {
            this.operations = {};
          }
          newMorphing(e2, t2, i2, o2, r2) {
            if (e2 in this.operations) {
              const t3 = this.operations[e2];
              t3.to.tileID.key !== i2.tileID.key && (t3.queued = i2);
            } else
              this.operations[e2] = { startTime: o2, phase: 0, duration: r2, from: t2, to: i2, queued: null };
          }
          getMorphValuesForProxy(e2) {
            if (!(e2 in this.operations))
              return null;
            const t2 = this.operations[e2];
            return { from: t2.from, to: t2.to, phase: t2.phase };
          }
          update(e2) {
            for (const t2 in this.operations) {
              const i2 = this.operations[t2];
              for (i2.phase = (e2 - i2.startTime) / i2.duration; i2.phase >= 1 || !this._validOp(i2); )
                if (!this._nextOp(i2, e2)) {
                  delete this.operations[t2];
                  break;
                }
            }
          }
          _nextOp(e2, t2) {
            return !!e2.queued && (e2.from = e2.to, e2.to = e2.queued, e2.queued = null, e2.phase = 0, e2.startTime = t2, true);
          }
          _validOp(e2) {
            return e2.from.hasData() && e2.to.hasData();
          }
        }(), Ti = { 0: null, 1: "TERRAIN_VERTEX_MORPHING" };
        function Ei(e2, t2, i2) {
          if (0 === t2)
            return 0;
          const o2 = t2 < 1 && 514 === i2 ? 0.25 / t2 : 1;
          return 6 * Math.pow(1.5, 22 - e2) * Math.max(t2, 1) * o2;
        }
        function Ci(e2, t2) {
          const i2 = 1 << e2.z;
          return !t2 && (0 === e2.x || e2.x === i2 - 1) || 0 === e2.y || e2.y === i2 - 1;
        }
        const Si = (e2) => ({ u_matrix: e2 });
        function Ii(t2, i2, o2, r2, a2) {
          if (a2 > 0) {
            const n2 = e.e.now(), s2 = (n2 - t2.timeAdded) / a2, l2 = i2 ? (n2 - i2.timeAdded) / a2 : -1, c2 = o2.getSource(), h2 = r2.coveringZoomLevel({ tileSize: c2.tileSize, roundZoom: c2.roundZoom }), _2 = !i2 || Math.abs(i2.tileID.overscaledZ - h2) > Math.abs(t2.tileID.overscaledZ - h2), u2 = _2 && t2.refreshedUponExpiration ? 1 : e.au(_2 ? s2 : 1 - l2, 0, 1);
            return t2.refreshedUponExpiration && s2 >= 1 && (t2.refreshedUponExpiration = false), i2 ? { opacity: 1, mix: 1 - u2 } : { opacity: u2, mix: 0 };
          }
          return { opacity: 1, mix: 0 };
        }
        class Li extends Ot {
          constructor(t2, i2, o2, r2) {
            super(t2, i2, o2, r2), this.type = "raster-array", this.maxzoom = 22, this._options = e.Q({ type: "raster-array" }, i2);
          }
          triggerRepaint(e2) {
            const t2 = this.map.painter._terrain, i2 = this.map.style.getSourceCache(this.id);
            t2 && t2.enabled && i2 && t2._clearRenderCacheForTile(i2.id, e2.tileID), this.map.triggerRepaint();
          }
          loadTile(t2, i2) {
            const o2 = this.map._requestManager.normalizeTileURL(t2.tileID.canonical.url(this.tiles, this.scheme), false, this.tileSize), r2 = this.map._requestManager.transformRequest(o2, e.R.Tile);
            t2.requestParams = r2, t2.actor || (t2.actor = this.dispatcher.getActor()), t2.request = t2.fetchHeader(void 0, (e2, o3, r3, a2) => {
              if (delete t2.request, t2.aborted)
                return t2.state = "unloaded", i2(null);
              if (e2) {
                if (20 === e2.code)
                  return;
                return t2.state = "errored", i2(e2);
              }
              this.map._refreshExpiredTiles && t2.setExpiryData({ cacheControl: r3, expires: a2 }), t2.state = "empty", i2(null);
            });
          }
          unloadTile(t2, i2) {
            const o2 = t2.texture;
            o2 && o2 instanceof e.T ? (t2.destroy(true), this.map.painter.saveTileTexture(o2)) : (t2.destroy(), t2.flushQueues(), t2._isHeaderLoaded = false, delete t2._mrt, delete t2.textureDescriptor), t2.fbo && (t2.fbo.destroy(), delete t2.fbo), delete t2.request, delete t2.requestParams, delete t2.neighboringTiles, t2.state = "unloaded";
          }
          prepareTile(t2, i2, o2) {
            t2._isHeaderLoaded && ("empty" !== t2.state && (t2.state = "reloading"), t2.fetchBand(i2, o2, (i3, o3) => {
              if (i3)
                return t2.state = "errored", this.fire(new e.f(i3)), void this.triggerRepaint(t2);
              o3 && (t2.setTexture(o3, this.map.painter), t2.state = "loaded", this.triggerRepaint(t2));
            }));
          }
          getInitialBand(e2) {
            if (!this.rasterLayers)
              return 0;
            const t2 = this.rasterLayers.find(({ id: t3 }) => t3 === e2), i2 = t2 && t2.fields, o2 = i2 && i2.bands && i2.bands;
            return o2 ? o2[0] : 0;
          }
          getTextureDescriptor(t2, i2, o2) {
            if (!t2)
              return;
            const r2 = i2.sourceLayer || this.rasterLayerIds && this.rasterLayerIds[0];
            if (!r2)
              return;
            let a2 = null;
            i2 instanceof e.bm ? a2 = i2.paint.get("raster-array-band") : i2 instanceof e.bn && (a2 = i2.paint.get("raster-particle-array-band"));
            const n2 = a2 || this.getInitialBand(r2);
            if (null != n2)
              if (t2.textureDescriptor) {
                if (!t2.updateNeeded(r2, n2) || o2)
                  return Object.assign({}, t2.textureDescriptor, { texture: t2.texture });
              } else
                this.prepareTile(t2, r2, n2);
          }
        }
        const Pi = { vector: Ft, raster: Ot, "raster-dem": class extends Ot {
          constructor(t2, i2, o2, r2) {
            super(t2, i2, o2, r2), this.type = "raster-dem", this.maxzoom = 22, this._options = e.Q({ type: "raster-dem" }, i2), this.encoding = i2.encoding || "mapbox";
          }
          loadTile(t2, i2) {
            const o2 = this.map._requestManager.normalizeTileURL(t2.tileID.canonical.url(this.tiles, this.scheme), false, this.tileSize);
            function r2(e2, o3) {
              e2 && (t2.state = "errored", i2(e2)), o3 && (t2.dem = o3, t2.dem.onDeserialize(), t2.needsHillshadePrepare = true, t2.needsDEMTextureUpload = true, t2.state = "loaded", i2(null));
            }
            t2.request = e.i(this.map._requestManager.transformRequest(o2, e.R.Tile), function(o3, a2, n2, s2) {
              if (delete t2.request, t2.aborted)
                t2.state = "unloaded", i2(null);
              else if (o3)
                t2.state = "errored", i2(o3);
              else if (a2) {
                this.map._refreshExpiredTiles && t2.setExpiryData({ cacheControl: n2, expires: s2 });
                const i3 = ImageBitmap && a2 instanceof ImageBitmap && e.bk(), o4 = 1 - (a2.width - e.bl(a2.width)) / 2;
                o4 < 1 || t2.neighboringTiles || (t2.neighboringTiles = this._getNeighboringTiles(t2.tileID));
                const l2 = i3 ? a2 : e.e.getImageData(a2, o4), c2 = { uid: t2.uid, coord: t2.tileID, source: this.id, scope: this.scope, rawImageData: l2, encoding: this.encoding, padding: o4 };
                t2.actor && "expired" !== t2.state || (t2.actor = this.dispatcher.getActor(), t2.actor.send("loadDEMTile", c2, r2.bind(this), void 0, true));
              }
            }.bind(this));
          }
          _getNeighboringTiles(t2) {
            const i2 = t2.canonical, o2 = Math.pow(2, i2.z), r2 = (i2.x - 1 + o2) % o2, a2 = 0 === i2.x ? t2.wrap - 1 : t2.wrap, n2 = (i2.x + 1 + o2) % o2, s2 = i2.x + 1 === o2 ? t2.wrap + 1 : t2.wrap, l2 = {};
            return l2[new e.aQ(t2.overscaledZ, a2, i2.z, r2, i2.y).key] = { backfilled: false }, l2[new e.aQ(t2.overscaledZ, s2, i2.z, n2, i2.y).key] = { backfilled: false }, i2.y > 0 && (l2[new e.aQ(t2.overscaledZ, a2, i2.z, r2, i2.y - 1).key] = { backfilled: false }, l2[new e.aQ(t2.overscaledZ, t2.wrap, i2.z, i2.x, i2.y - 1).key] = { backfilled: false }, l2[new e.aQ(t2.overscaledZ, s2, i2.z, n2, i2.y - 1).key] = { backfilled: false }), i2.y + 1 < o2 && (l2[new e.aQ(t2.overscaledZ, a2, i2.z, r2, i2.y + 1).key] = { backfilled: false }, l2[new e.aQ(t2.overscaledZ, t2.wrap, i2.z, i2.x, i2.y + 1).key] = { backfilled: false }, l2[new e.aQ(t2.overscaledZ, s2, i2.z, n2, i2.y + 1).key] = { backfilled: false }), l2;
          }
        }, "raster-array": Li, geojson: class extends e.E {
          constructor(t2, i2, o2, r2) {
            super(), this.id = t2, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = true, this.reparseOverscaled = true, this._loaded = false, this.actor = o2.getActor(), this.setEventedParent(r2), this._data = i2.data, this._options = e.Q({}, i2), this._collectResourceTiming = i2.collectResourceTiming, void 0 !== i2.maxzoom && (this.maxzoom = i2.maxzoom), void 0 !== i2.minzoom && (this.minzoom = i2.minzoom), i2.type && (this.type = i2.type), i2.attribution && (this.attribution = i2.attribution), this.promoteId = i2.promoteId;
            const a2 = e.a4 / this.tileSize;
            this.workerOptions = e.Q({ source: this.id, scope: this.scope, cluster: i2.cluster || false, geojsonVtOptions: { buffer: (void 0 !== i2.buffer ? i2.buffer : 128) * a2, tolerance: (void 0 !== i2.tolerance ? i2.tolerance : 0.375) * a2, extent: e.a4, maxZoom: this.maxzoom, lineMetrics: i2.lineMetrics || false, generateId: i2.generateId || false }, superclusterOptions: { maxZoom: void 0 !== i2.clusterMaxZoom ? i2.clusterMaxZoom : this.maxzoom - 1, minPoints: Math.max(2, i2.clusterMinPoints || 2), extent: e.a4, radius: (void 0 !== i2.clusterRadius ? i2.clusterRadius : 50) * a2, log: false, generateId: i2.generateId || false }, clusterProperties: i2.clusterProperties, filter: i2.filter, dynamic: i2.dynamic }, i2.workerOptions);
          }
          onAdd(e2) {
            this.map = e2, this.setData(this._data);
          }
          setData(e2) {
            return this._data = e2, this._updateWorkerData(), this;
          }
          updateData(t2) {
            if (!this._options.dynamic)
              return this.fire(new e.f(new Error("Can't call updateData on a GeoJSON source with dynamic set to false.")));
            if ("string" != typeof t2 && ("Feature" === t2.type && (t2 = { type: "FeatureCollection", features: [t2] }), "FeatureCollection" !== t2.type))
              return this.fire(new e.f(new Error("Data to update should be a feature or a feature collection.")));
            if (this._coalesce && "string" != typeof t2 && "string" != typeof this._data && "FeatureCollection" === this._data.type) {
              const e2 = /* @__PURE__ */ new Map();
              for (const t3 of this._data.features)
                e2.set(t3.id, t3);
              for (const i2 of t2.features)
                e2.set(i2.id, i2);
              this._data.features = [...e2.values()];
            } else
              this._data = t2;
            return this._updateWorkerData(true), this;
          }
          getClusterExpansionZoom(e2, t2) {
            return this.actor.send("geojson.getClusterExpansionZoom", { clusterId: e2, source: this.id, scope: this.scope }, t2), this;
          }
          getClusterChildren(e2, t2) {
            return this.actor.send("geojson.getClusterChildren", { clusterId: e2, source: this.id, scope: this.scope }, t2), this;
          }
          getClusterLeaves(e2, t2, i2, o2) {
            return this.actor.send("geojson.getClusterLeaves", { source: this.id, scope: this.scope, clusterId: e2, limit: t2, offset: i2 }, o2), this;
          }
          _updateWorkerData(t2 = false) {
            if (this._pendingLoad)
              return void (this._coalesce = true);
            this.fire(new e.g("dataloading", { dataType: "source" })), this._loaded = false;
            const i2 = e.Q({ append: t2 }, this.workerOptions);
            i2.scope = this.scope;
            const o2 = this._data;
            "string" == typeof o2 ? (i2.request = this.map._requestManager.transformRequest(e.e.resolveURL(o2), e.R.Source), i2.request.collectResourceTiming = this._collectResourceTiming) : i2.data = JSON.stringify(o2), this._pendingLoad = this.actor.send(`${this.type}.loadData`, i2, (i3, o3) => {
              if (this._loaded = true, this._pendingLoad = null, i3)
                this.fire(new e.f(i3));
              else {
                const i4 = { dataType: "source", sourceDataType: this._metadataFired ? "content" : "metadata" };
                this._collectResourceTiming && o3 && o3.resourceTiming && o3.resourceTiming[this.id] && (i4.resourceTiming = o3.resourceTiming[this.id]), t2 && (this._partialReload = true), this.fire(new e.g("data", i4)), this._partialReload = false, this._metadataFired = true;
              }
              this._coalesce && (this._updateWorkerData(t2), this._coalesce = false);
            });
          }
          loaded() {
            return this._loaded;
          }
          loadTile(t2, i2) {
            const o2 = t2.actor ? "reloadTile" : "loadTile";
            t2.actor = this.actor;
            const r2 = this.map.style ? this.map.style.getLut(this.scope) : null, a2 = this._partialReload, n2 = { type: this.type, uid: t2.uid, tileID: t2.tileID, tileZoom: t2.tileZoom, zoom: t2.tileID.overscaledZ, maxZoom: this.maxzoom, tileSize: this.tileSize, source: this.id, lut: r2 ? { image: r2.image.clone() } : null, scope: this.scope, pixelRatio: e.e.devicePixelRatio, showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId, brightness: this.map.style && this.map.style.getBrightness() || 0, partial: a2 };
            t2.request = this.actor.send(o2, n2, (e2, r3) => a2 && !r3 ? (t2.state = "loaded", i2(null)) : (delete t2.request, t2.destroy(), t2.aborted ? i2(null) : e2 ? i2(e2) : (t2.loadVectorData(r3, this.map.painter, "reloadTile" === o2), i2(null))), void 0, "loadTile" === o2);
          }
          abortTile(e2) {
            e2.request && (e2.request.cancel(), delete e2.request), e2.aborted = true;
          }
          unloadTile(e2, t2) {
            this.actor.send("removeTile", { uid: e2.uid, type: this.type, source: this.id, scope: this.scope }), e2.destroy();
          }
          onRemove(e2) {
            this._pendingLoad && this._pendingLoad.cancel();
          }
          serialize() {
            return e.Q({}, this._options, { type: this.type, data: this._data });
          }
          hasTransition() {
            return false;
          }
        }, video: class extends e.bo {
          constructor(e2, t2, i2, o2) {
            super(e2, t2, i2, o2), this.roundZoom = true, this.type = "video", this.options = t2;
          }
          load() {
            this._loaded = false;
            const t2 = this.options;
            this.urls = [];
            for (const i2 of t2.urls)
              this.urls.push(this.map._requestManager.transformRequest(i2, e.R.Source).url);
            e.bp(this.urls, (t3, i2) => {
              this._loaded = true, t3 ? this.fire(new e.f(t3)) : i2 && (this.video = i2, this.video.loop = true, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", () => {
                this.map.triggerRepaint();
              }), this.map && this.video.play(), this._finishLoading());
            });
          }
          pause() {
            this.video && this.video.pause();
          }
          play() {
            this.video && this.video.play();
          }
          seek(t2) {
            if (this.video) {
              const i2 = this.video.seekable;
              t2 < i2.start(0) || t2 > i2.end(0) ? this.fire(new e.f(new e.V(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i2.start(0)} and ${i2.end(0)}-second mark.`))) : this.video.currentTime = t2;
            }
          }
          getVideo() {
            return this.video;
          }
          onAdd(e2) {
            this.map || (this.map = e2, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
          }
          prepare() {
            if (0 === Object.keys(this.tiles).length || this.video.readyState < 2)
              return;
            const t2 = this.map.painter.context, i2 = t2.gl;
            this.texture ? this.video.paused || (this.texture.bind(i2.LINEAR, i2.CLAMP_TO_EDGE), i2.texSubImage2D(i2.TEXTURE_2D, 0, 0, 0, i2.RGBA, i2.UNSIGNED_BYTE, this.video)) : (this.texture = new e.T(t2, this.video, i2.RGBA), this.texture.bind(i2.LINEAR, i2.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(t2);
          }
          serialize() {
            return { type: "video", urls: this.urls, coordinates: this.coordinates };
          }
          hasTransition() {
            return this.video && !this.video.paused;
          }
        }, image: e.bo, model: class extends e.E {
          constructor(e2, t2, i2, o2) {
            super(), this.id = e2, this.type = "model", this.models = [], this._loaded = false, this._options = t2;
          }
          load() {
            const t2 = [];
            for (const i2 in this._options.models) {
              const o2 = this._options.models[i2], r2 = e.l(this.map._requestManager.transformRequest(o2.uri, e.R.Model).url).then((t3) => {
                if (!t3)
                  return;
                const r3 = e.c(t3), a2 = new e.M(i2, o2.position, o2.orientation, r3);
                a2.computeBoundsAndApplyParent(), this.models.push(a2);
              }).catch((t3) => {
                this.fire(new e.f(new Error(`Could not load model ${i2} from ${o2.uri}: ${t3.message}`)));
              });
              t2.push(r2);
            }
            return Promise.allSettled(t2).then(() => {
              this._loaded = true, this.fire(new e.g("data", { dataType: "source", sourceDataType: "metadata" }));
            }).catch((t3) => {
              this.fire(new e.f(new Error(`Could not load models: ${t3.message}`)));
            });
          }
          onAdd(e2) {
            this.map = e2, this.load();
          }
          hasTransition() {
            return false;
          }
          loaded() {
            return this._loaded;
          }
          getModels() {
            return this.models;
          }
          loadTile(e2, t2) {
          }
          serialize() {
            return { type: "model" };
          }
        }, "batched-model": class extends e.E {
          constructor(e2, t2, i2, o2) {
            super(), this.type = "batched-model", this.id = e2, this.tileSize = 512, this._options = t2, this.tiles = this._options.tiles, this.maxzoom = t2.maxzoom || 19, this.minzoom = t2.minzoom || 0, this.roundZoom = true, this.usedInConflation = true, this.dispatcher = i2, this.reparseOverscaled = false, this.scheme = "xyz", this._loaded = false, this.setEventedParent(o2);
          }
          onAdd(e2) {
            this.map = e2, this.load();
          }
          load(t2) {
            this._loaded = false, this.fire(new e.g("dataloading", { dataType: "source" }));
            const i2 = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o2 = this.map._worldview;
            this._tileJSONRequest = Mt(this._options, this.map._requestManager, i2, o2, (r2, a2) => {
              this._tileJSONRequest = null, this._loaded = true, r2 ? (i2 && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i2}`), o2 && 2 !== o2.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o2}`), this.fire(new e.f(r2))) : a2 && (e.Q(this, a2), a2.bounds && (this.tileBounds = new zt(a2.bounds, this.minzoom, this.maxzoom)), e.ao(a2.tiles, this.map._requestManager._customAccessToken), this.fire(new e.g("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e.g("data", { dataType: "source", sourceDataType: "content" }))), t2 && t2(r2);
            });
          }
          hasTransition() {
            return false;
          }
          hasTile(e2) {
            return !this.tileBounds || this.tileBounds.contains(e2.canonical);
          }
          loaded() {
            return this._loaded;
          }
          loadTile(t2, i2) {
            const o2 = this.map._requestManager.normalizeTileURL(t2.tileID.canonical.url(this.tiles, this.scheme)), r2 = { request: this.map._requestManager.transformRequest(o2, e.R.Tile), data: void 0, uid: t2.uid, tileID: t2.tileID, tileZoom: t2.tileZoom, zoom: t2.tileID.overscaledZ, tileSize: this.tileSize * t2.tileID.overscaleFactor(), type: this.type, source: this.id, scope: this.scope, showCollisionBoxes: this.map.showCollisionBoxes, isSymbolTile: t2.isSymbolTile, brightness: this.map.style && this.map.style.getBrightness() || 0 };
            if (t2.actor && "expired" !== t2.state)
              if ("loading" === t2.state)
                t2.reloadCallback = i2;
              else {
                if (t2.buckets) {
                  const e2 = Object.values(t2.buckets);
                  for (const t3 of e2)
                    t3.dirty = true;
                  return void (t2.state = "loaded");
                }
                t2.request = t2.actor.send("reloadTile", r2, a2.bind(this));
              }
            else
              t2.actor = this.dispatcher.getActor(), t2.request = t2.actor.send("loadTile", r2, a2.bind(this), void 0, true);
            function a2(e2, o3) {
              return t2.aborted ? i2(null) : e2 && 404 !== e2.status ? i2(e2) : (o3 && (o3.resourceTiming && (t2.resourceTiming = o3.resourceTiming), this.map._refreshExpiredTiles && t2.setExpiryData(o3), t2.buckets = __spreadValues(__spreadValues({}, t2.buckets), o3.buckets), o3.featureIndex && (t2.latestFeatureIndex = o3.featureIndex)), t2.state = "loaded", void i2(null));
            }
          }
          serialize() {
            return e.Q({}, this._options);
          }
        }, canvas: class extends e.bo {
          constructor(t2, i2, o2, r2) {
            super(t2, i2, o2, r2), i2.coordinates ? Array.isArray(i2.coordinates) && 4 === i2.coordinates.length && !i2.coordinates.some((e2) => !Array.isArray(e2) || 2 !== e2.length || e2.some((e3) => "number" != typeof e3)) || this.fire(new e.f(new e.V(`sources.${t2}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e.f(new e.V(`sources.${t2}`, null, 'missing required property "coordinates"'))), i2.animate && "boolean" != typeof i2.animate && this.fire(new e.f(new e.V(`sources.${t2}`, null, 'optional "animate" property must be a boolean value'))), i2.canvas ? "string" == typeof i2.canvas || i2.canvas instanceof HTMLCanvasElement || this.fire(new e.f(new e.V(`sources.${t2}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e.f(new e.V(`sources.${t2}`, null, 'missing required property "canvas"'))), this.options = i2, this.animate = void 0 === i2.animate || i2.animate;
          }
          load() {
            this._loaded = true, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e.f(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
              this._playing = true, this.map.triggerRepaint();
            }, this.pause = function() {
              this._playing && (this.prepare(), this._playing = false);
            }, this._finishLoading());
          }
          getCanvas() {
            return this.canvas;
          }
          onAdd(e2) {
            this.map = e2, this.load(), this.canvas && this.animate && this.play();
          }
          onRemove(e2) {
            this.pause();
          }
          prepare() {
            let t2 = false;
            if (this.canvas.width !== this.width && (this.width = this.canvas.width, t2 = true), this.canvas.height !== this.height && (this.height = this.canvas.height, t2 = true), this._hasInvalidDimensions())
              return;
            if (0 === Object.keys(this.tiles).length)
              return;
            const i2 = this.map.painter.context;
            this.texture ? !t2 && !this._playing || this.texture instanceof e.bq || this.texture.update(this.canvas, { premultiply: true }) : this.texture = new e.T(i2, this.canvas, i2.gl.RGBA, { premultiply: true }), this._prepareData(i2);
          }
          serialize() {
            return { type: "canvas", coordinates: this.coordinates };
          }
          hasTransition() {
            return this._playing;
          }
          _hasInvalidDimensions() {
            for (const e2 of [this.canvas.width, this.canvas.height])
              if (isNaN(e2) || e2 <= 0)
                return true;
            return false;
          }
        }, custom: class extends e.E {
          constructor(t2, i2, o2, r2) {
            super(), this.id = t2, this.type = "custom", this._dataType = "raster", this._dispatcher = o2, this._implementation = i2, this.setEventedParent(r2), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = false, this.roundZoom = true, this._implementation || this.fire(new e.f(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new e.f(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new zt(this._implementation.bounds, this.minzoom, this.maxzoom)), i2.update = this._update.bind(this), i2.clearTiles = this._clearTiles.bind(this), i2.coveringTiles = this._coveringTiles.bind(this), e.Q(this, e.ai(i2, ["dataType", "scheme", "minzoom", "maxzoom", "tileSize", "attribution", "minTileCacheSize", "maxTileCacheSize"]));
          }
          serialize() {
            return e.ai(this, ["type", "scheme", "minzoom", "maxzoom", "tileSize", "attribution"]);
          }
          load() {
            this._loaded = true, this.fire(new e.g("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e.g("data", { dataType: "source", sourceDataType: "content" }));
          }
          loaded() {
            return this._loaded;
          }
          onAdd(t2) {
            this.map = t2, this._loaded = false, this.fire(new e.g("dataloading", { dataType: "source" })), this._implementation.onAdd && this._implementation.onAdd(t2), this.load();
          }
          onRemove(e2) {
            this._implementation.onRemove && this._implementation.onRemove(e2);
          }
          hasTile(e2) {
            if (this._implementation.hasTile) {
              const { x: t2, y: i2, z: o2 } = e2.canonical;
              return this._implementation.hasTile({ x: t2, y: i2, z: o2 });
            }
            return !this.tileBounds || this.tileBounds.contains(e2.canonical);
          }
          loadTile(e2, t2) {
            const { x: i2, y: o2, z: r2 } = e2.tileID.canonical, a2 = new AbortController();
            e2.request = Promise.resolve(this._implementation.loadTile({ x: i2, y: o2, z: r2 }, { signal: a2.signal })).then(function(i3) {
              return delete e2.request, e2.aborted ? (e2.state = "unloaded", t2(null)) : void 0 === i3 ? (e2.state = "errored", t2(null)) : null === i3 ? (this.loadTileData(e2, { width: this.tileSize, height: this.tileSize, data: null }), e2.state = "loaded", t2(null)) : function(e3) {
                return e3 instanceof ImageData || e3 instanceof HTMLCanvasElement || e3 instanceof ImageBitmap || e3 instanceof HTMLImageElement;
              }(i3) ? (this.loadTileData(e2, i3), e2.state = "loaded", void t2(null)) : (e2.state = "errored", t2(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`)));
            }.bind(this)).catch((i3) => {
              20 !== i3.code && (e2.state = "errored", t2(i3));
            }), e2.request.cancel = () => a2.abort();
          }
          loadTileData(e2, t2) {
            e2.setTexture(t2, this.map.painter);
          }
          unloadTile(t2, i2) {
            if (t2.texture && t2.texture instanceof e.T ? (t2.destroy(true), t2.texture && t2.texture instanceof e.T && this.map.painter.saveTileTexture(t2.texture)) : t2.destroy(), this._implementation.unloadTile) {
              const { x: e2, y: i3, z: o2 } = t2.tileID.canonical;
              this._implementation.unloadTile({ x: e2, y: i3, z: o2 });
            }
            i2 && i2();
          }
          abortTile(e2, t2) {
            e2.request && e2.request.cancel && (e2.request.cancel(), delete e2.request), t2 && t2();
          }
          hasTransition() {
            return false;
          }
          _coveringTiles() {
            return this.map.transform.coveringTiles({ tileSize: this.tileSize, minzoom: this.minzoom, maxzoom: this.maxzoom, roundZoom: this.roundZoom }).map((e2) => ({ x: e2.canonical.x, y: e2.canonical.y, z: e2.canonical.z }));
          }
          _clearTiles() {
            const t2 = e.am(this.id, this.scope);
            this.map.style.clearSource(t2);
          }
          _update() {
            this.fire(new e.g("data", { dataType: "source", sourceDataType: "content" }));
          }
        } }, Ri = function(t2, i2, o2, r2) {
          const a2 = new Pi[i2.type](t2, i2, o2, r2);
          if (a2.id !== t2)
            throw new Error(`Expected Source id to be ${t2} instead of ${a2.id}`);
          return e.br(["load", "abort", "unload", "serialize", "prepare"], a2), a2;
        };
        class Di extends e.bx {
          constructor(t2) {
            const i2 = { type: "raster-dem", maxzoom: t2.transform.maxZoom }, o2 = new e.by(e.bz(), null), r2 = Ri("mock-dem", i2, o2, t2.style);
            super("mock-dem", r2, false), r2.setEventedParent(this), this._sourceLoaded = true;
          }
          _loadTile(e2, t2) {
            e2.state = "loaded", t2(null);
          }
        }
        class Ai extends e.bx {
          constructor(t2) {
            const i2 = Ri("proxy", { type: "geojson", maxzoom: t2.transform.maxZoom }, new e.by(e.bz(), null), t2.style);
            super("proxy", i2, false), i2.setEventedParent(this), this.map = this.getSource().map = t2, this.used = this._sourceLoaded = true, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
          }
          update(t2, i2, o2) {
            if (t2.freezeTileCoverage)
              return;
            this.transform = t2;
            const r2 = t2.coveringTiles({ tileSize: this._source.tileSize, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: this._source.roundZoom, reparseOverscaled: this._source.reparseOverscaled }).reduce((i3, o3) => {
              if (i3[o3.key] = "", !this._tiles[o3.key]) {
                const i4 = new e.bA(o3, this._source.tileSize * o3.overscaleFactor(), t2.tileZoom);
                i4.state = "loaded", this._tiles[o3.key] = i4;
              }
              return i3;
            }, {});
            for (const e2 in this._tiles)
              e2 in r2 || (this.freeFBO(e2), this._tiles[e2].unloadVectorData(), delete this._tiles[e2]);
          }
          freeFBO(e2) {
            const t2 = this.proxyCachedFBO[e2];
            if (void 0 !== t2) {
              const i2 = Object.values(t2);
              this.renderCachePool.push(...i2), delete this.proxyCachedFBO[e2];
            }
          }
          deallocRenderCache() {
            this.renderCache.forEach((e2) => e2.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
          }
        }
        class Mi extends e.aQ {
          constructor(e2, t2, i2) {
            super(e2.overscaledZ, e2.wrap, e2.canonical.z, e2.canonical.x, e2.canonical.y), this.proxyTileKey = t2, this.projMatrix = i2;
          }
        }
        class zi extends e.bs {
          constructor(t2, i2) {
            super(), this._debugParams = { sortTilesHiZFirst: true, disableRenderCache: false }, t2.tp.registerParameter(this._debugParams, ["Terrain"], "sortTilesHiZFirst", {}, () => {
              this._style.map.triggerRepaint();
            }), t2.tp.registerParameter(this._debugParams, ["Terrain"], "disableRenderCache", {}, () => {
              this._style.map.triggerRepaint();
            }), t2.tp.registerButton(["Terrain"], "Invalidate Render Cache", () => {
              this.invalidateRenderCache = true, this._style.map.triggerRepaint();
            }), this.painter = t2, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
            const [o2, r2, a2] = function(t3) {
              const i3 = new e.bv(), o3 = new e.bw(), r3 = 131;
              i3.reserve(17161), o3.reserve(33800);
              const a3 = e.a4 / 128, n3 = e.a4 + a3 / 2, s3 = n3 + a3;
              for (let t4 = -a3; t4 < s3; t4 += a3)
                for (let o4 = -a3; o4 < s3; o4 += a3) {
                  const r4 = o4 < 0 || o4 > n3 || t4 < 0 || t4 > n3 ? 24575 : 0, a4 = e.au(Math.round(o4), 0, e.a4), s4 = e.au(Math.round(t4), 0, e.a4);
                  i3.emplaceBack(a4 + r4, s4);
                }
              const l2 = (e2, t4) => {
                const i4 = t4 * r3 + e2;
                o3.emplaceBack(i4 + 1, i4, i4 + r3), o3.emplaceBack(i4 + r3, i4 + r3 + 1, i4 + 1);
              };
              for (let e2 = 1; e2 < 129; e2++)
                for (let t4 = 1; t4 < 129; t4++)
                  l2(t4, e2);
              return [0, 129].forEach((e2) => {
                for (let t4 = 0; t4 < 130; t4++)
                  l2(t4, e2), l2(e2, t4);
              }), [i3, o3, 32768];
            }(), n2 = t2.context;
            this.gridBuffer = n2.createVertexBuffer(o2, e.bt.members), this.gridIndexBuffer = n2.createIndexBuffer(r2), this.gridSegments = e.b.simpleSegment(0, 0, o2.length, r2.length), this.gridNoSkirtSegments = e.b.simpleSegment(0, 0, o2.length, a2), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new Ai(i2.map), this.orthoMatrix = e.ae.create(), e.ae.ortho(this.orthoMatrix, "globe" === this.painter.transform.projection.name ? 0.015 : 0, e.a4, 0, e.a4, 0, 1);
            const s2 = n2.gl;
            this._overlapStencilMode = new e.ah({ func: s2.GEQUAL, mask: 255 }, 0, 255, s2.KEEP, s2.KEEP, s2.REPLACE), this._previousZoom = t2.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = i2, this._useVertexMorphing = true, this._exaggeration = 1, this._mockSourceCache = new Di(i2.map), this._pendingGroundEffectLayers = [];
          }
          set style(e2) {
            e2.on("data", this._onStyleDataEvent.bind(this)), this._style = e2, this._style.map.on("moveend", () => {
              this._clearLineLayersFromRenderCache();
            });
          }
          update(t2, i2, o2) {
            if (t2 && t2.terrain) {
              this._style !== t2 && (this.style = t2, this._evaluationZoom = void 0);
              const r2 = t2.terrain.properties, a2 = 0 === t2.terrain.drapeRenderMode, n2 = t2.terrain.isZoomDependent();
              this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = e.e.now();
              const s2 = t2.terrain && t2.terrain.scope, l2 = r2.get("source"), c2 = a2 ? this._mockSourceCache : t2.getSourceCache(l2, s2);
              if (!c2)
                return void e.w(`Couldn't find terrain source "${l2}".`);
              if (this.sourceCache = c2, this._exaggeration = n2 ? this.calculateExaggeration(i2) : r2.get("exaggeration"), !i2.projection.requiresDraping && n2 && 0 === this._exaggeration)
                return void this._disable();
              this.enabled = true;
              const h2 = () => {
                this.sourceCache.used && e.w(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.
This leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
                const t3 = this.getScaledDemTileSize();
                this.sourceCache.update(i2, t3, true), this.resetTileLookupCache(this.sourceCache.id);
              };
              this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = true, h2(), this._initializing = true), h2(), i2.updateElevation(true, o2), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i2), this._emptyDEMTextureDirty = true, this._previousZoom = i2.zoom;
            } else
              this._disable();
          }
          calculateExaggeration(t2) {
            const i2 = this._previousCameraAltitude, o2 = t2.getFreeCameraOptions().position.z / t2.pixelsPerMeter * t2.worldSize;
            this._previousCameraAltitude = o2;
            const r2 = null != i2 ? o2 - i2 : Number.MAX_VALUE;
            if (Math.abs(r2) < 2)
              return this._exaggeration;
            const a2 = t2.zoom, n2 = this._style.terrain;
            if (!this._previousUpdateTimestamp)
              return n2.getExaggeration(a2);
            let s2 = a2 - this._previousZoom;
            const l2 = this._previousUpdateTimestamp;
            let c2 = a2;
            null != this._evaluationZoom && (c2 = this._evaluationZoom, Math.abs(a2 - c2) > 0.5 && (s2 = 0.5 * (a2 - c2 + s2)), s2 * r2 < 0 && (c2 += s2)), this._evaluationZoom = c2;
            const h2 = n2.getExaggeration(c2), _2 = h2 === n2.getExaggeration(Math.max(0, c2 - 0.1));
            if (_2 && Math.abs(h2 - this._exaggeration) < 0.01)
              return h2;
            let u2 = Math.min(0.1, 375e-5 * (this._updateTimestamp - l2));
            return (_2 || h2 < 0.1 || Math.abs(s2) < 1e-4) && (u2 = Math.min(0.2, 4 * u2)), e.a3(this._exaggeration, h2, u2);
          }
          resetTileLookupCache(e2) {
            this._findCoveringTileCache[e2] = {};
          }
          getScaledDemTileSize() {
            return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
          }
          _onStyleDataEvent(e2) {
            e2.coord && "source" === e2.dataType ? this._clearRenderCacheForTile(e2.sourceCacheId, e2.coord) : "style" === e2.dataType && (this.invalidateRenderCache = true, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
          }
          _disable() {
            if (this.enabled && (this.enabled = false, this._emptyDEMTextureDirty = true, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style))
              for (const e2 in this._style._mergedSourceCaches)
                this._style._mergedSourceCaches[e2].usedForTerrain = false;
          }
          destroy() {
            this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this.pool.forEach((e2) => e2.fb.destroy()), this.pool = [], this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
          }
          _source() {
            return this.enabled ? this.sourceCache : null;
          }
          isUsingMockSource() {
            return this.sourceCache === this._mockSourceCache;
          }
          exaggeration() {
            return this.enabled ? this._exaggeration : 0;
          }
          get visibleDemTiles() {
            return this._visibleDemTiles;
          }
          get drapeBufferSize() {
            const e2 = 2 * this.proxySourceCache.getSource().tileSize;
            return [e2, e2];
          }
          set useVertexMorphing(e2) {
            this._useVertexMorphing = e2;
          }
          updateTileBinding(t2) {
            if (!this.enabled)
              return;
            this.prevTerrainTileForTile = this.terrainTileForTile;
            const i2 = this.proxySourceCache, o2 = this.painter.transform;
            this._initializing && (this._initializing = 0 === o2._centerAltitude && -1 === this.getAtPointOrZero(e._.fromLngLat(o2.center), -1), this._emptyDEMTextureDirty = !this._initializing);
            const r2 = this.proxyCoords = i2.getIds().map((e2) => {
              const t3 = i2.getTileByID(e2).tileID;
              return t3.projMatrix = o2.calculateProjMatrix(t3.toUnwrapped()), t3;
            });
            !function(t3, i3) {
              const o3 = i3.transform.pointCoordinate(i3.transform.getCameraPoint()), r3 = new e.P(o3.x, o3.y);
              t3.sort((t4, i4) => {
                if (i4.overscaledZ - t4.overscaledZ)
                  return i4.overscaledZ - t4.overscaledZ;
                const o4 = new e.P(t4.canonical.x + (1 << t4.canonical.z) * t4.wrap, t4.canonical.y), a3 = new e.P(i4.canonical.x + (1 << i4.canonical.z) * i4.wrap, i4.canonical.y), n3 = r3.mult(1 << t4.canonical.z);
                return n3.x -= 0.5, n3.y -= 0.5, n3.distSqr(o4) - n3.distSqr(a3);
              });
            }(r2, this.painter);
            const a2 = this.proxyToSource || {};
            this.proxyToSource = {}, r2.forEach((e2) => {
              this.proxyToSource[e2.key] = {};
            }), this.terrainTileForTile = {};
            const n2 = this._style._mergedSourceCaches;
            for (const e2 in n2) {
              const i3 = n2[e2];
              if (!i3.used)
                continue;
              if (i3 !== this.sourceCache && this.resetTileLookupCache(i3.id), this._setupProxiedCoordsForOrtho(i3, t2[e2], a2), i3.usedForTerrain)
                continue;
              const o3 = t2[e2];
              i3.getSource().reparseOverscaled && this._assignTerrainTiles(o3);
            }
            this.proxiedCoords[i2.id] = r2.map((e2) => new Mi(e2, e2.key, this.orthoMatrix)), this._assignTerrainTiles(r2), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(a2), this.renderingToTexture = false;
            const s2 = {};
            this._visibleDemTiles = [];
            for (const e2 of this.proxyCoords) {
              const t3 = this.terrainTileForTile[e2.key];
              if (!t3)
                continue;
              const i3 = t3.tileID.key;
              i3 in s2 || (this._visibleDemTiles.push(t3), s2[i3] = i3);
            }
          }
          _assignTerrainTiles(e2) {
            this._initializing || e2.forEach((e3) => {
              if (this.terrainTileForTile[e3.key])
                return;
              const t2 = this._findTileCoveringTileID(e3, this.sourceCache);
              t2 && (this.terrainTileForTile[e3.key] = t2);
            });
          }
          _prepareDEMTextures() {
            const e2 = this.painter.context, t2 = e2.gl;
            for (const i2 in this.terrainTileForTile) {
              const o2 = this.terrainTileForTile[i2], r2 = o2.dem;
              !r2 || o2.demTexture && !o2.needsDEMTextureUpload || (e2.activeTexture.set(t2.TEXTURE1), Dt(this.painter, o2, r2));
            }
          }
          _prepareDemTileUniforms(e2, t2, i2, o2) {
            if (!t2 || null == t2.demTexture)
              return false;
            const r2 = e2.tileID.canonical, a2 = Math.pow(2, t2.tileID.canonical.z - r2.z), n2 = o2 || "";
            return i2[`u_dem_tl${n2}`] = [r2.x * a2 % 1, r2.y * a2 % 1], i2[`u_dem_scale${n2}`] = a2, true;
          }
          get emptyDEMTexture() {
            return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
          }
          _getLoadedAreaMinimum() {
            if (!this.enabled)
              return 0;
            let e2 = 0;
            const t2 = this._visibleDemTiles.reduce((t3, i2) => {
              if (!i2.dem)
                return t3;
              const o2 = i2.dem.tree.minimums[0];
              return o2 > 0 && e2++, t3 + o2;
            }, 0);
            return e2 ? t2 / e2 : 0;
          }
          _updateEmptyDEMTexture() {
            const t2 = this.painter.context, i2 = t2.gl;
            t2.activeTexture.set(i2.TEXTURE2);
            const o2 = this._getLoadedAreaMinimum(), [r2, a2] = (() => {
              const t3 = new e.bB({ width: 1, height: 1 }, new Float32Array([o2]));
              return [i2.R32F, t3];
            })();
            this._emptyDEMTextureDirty = false;
            let n2 = this._emptyDEMTexture;
            return n2 ? n2.update(a2, { premultiply: false }) : n2 = this._emptyDEMTexture = new e.T(t2, a2, r2, { premultiply: false }), n2;
          }
          setupElevationDraw(t2, i2, o2) {
            const r2 = this.painter.context, a2 = r2.gl, n2 = { u_dem: 2, u_dem_prev: 4, u_dem_tl: [0, 0], u_dem_tl_prev: [0, 0], u_dem_scale: 0, u_dem_scale_prev: 0, u_dem_size: 0, u_dem_lerp: 1, u_depth: 3, u_depth_size_inv: [0, 0], u_depth_range_unpack: [0, 1], u_occluder_half_size: 16, u_occlusion_depth_offset: -1e-4, u_exaggeration: 0 };
            n2.u_exaggeration = this.exaggeration();
            let s2 = null, l2 = null, c2 = 1;
            if (o2 && o2.morphing && this._useVertexMorphing) {
              const e2 = o2.morphing.srcDemTile, i3 = o2.morphing.dstDemTile;
              c2 = o2.morphing.phase, e2 && i3 && (this._prepareDemTileUniforms(t2, e2, n2, "_prev") && (l2 = e2), this._prepareDemTileUniforms(t2, i3, n2) && (s2 = i3));
            }
            const h2 = (e2) => e2 && e2.demTexture && this.painter.linearFloatFilteringSupported() ? a2.LINEAR : a2.NEAREST;
            let _2 = null;
            var u2;
            if (this.enabled ? l2 && s2 ? (_2 = s2.demTexture, r2.activeTexture.set(a2.TEXTURE4), l2.demTexture.bind(h2(l2), a2.CLAMP_TO_EDGE), n2.u_dem_lerp = c2) : (s2 = this.terrainTileForTile[t2.tileID.key], _2 = this._prepareDemTileUniforms(t2, s2, n2) ? s2.demTexture : this.emptyDEMTexture) : _2 = this.emptyDEMTexture, r2.activeTexture.set(a2.TEXTURE2), _2 && (n2.u_dem_size = 1 === (u2 = _2).size[0] ? 1 : u2.size[0] - 2, _2.bind(h2(s2), a2.CLAMP_TO_EDGE)), this.painter.setupDepthForOcclusion(o2 && o2.useDepthForOcclusion, i2, n2), o2 && o2.useMeterToDem && s2) {
              const t3 = (1 << s2.tileID.canonical.z) * e.ay(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
              n2.u_meter_to_dem = t3;
            }
            if (o2 && o2.labelPlaneMatrixInv && (n2.u_label_plane_matrix_inv = o2.labelPlaneMatrixInv), i2.setTerrainUniformValues(r2, n2), "globe" === this.painter.transform.projection.name) {
              const e2 = this.globeUniformValues(this.painter.transform, t2.tileID.canonical, o2 && o2.useDenormalizedUpVectorScale);
              i2.setGlobeUniformValues(r2, e2);
            }
          }
          globeUniformValues(t2, i2, o2) {
            const r2 = t2.projection;
            return { u_tile_tl_up: r2.upVector(i2, 0, 0), u_tile_tr_up: r2.upVector(i2, e.a4, 0), u_tile_br_up: r2.upVector(i2, e.a4, e.a4), u_tile_bl_up: r2.upVector(i2, 0, e.a4), u_tile_up_scale: o2 ? e.bu(1) : r2.upVectorScale(i2, t2.center.lat, t2.worldSize).metersToTile };
          }
          renderToBackBuffer(t2) {
            const i2 = this.painter, o2 = this.painter.context;
            0 !== t2.length && (o2.bindFramebuffer.set(null), o2.viewport.set([0, 0, i2.width, i2.height]), i2.gpuTimingDeferredRenderStart(), this.renderingToTexture = false, function(t3, i3, o3, r2, a2) {
              if ("globe" === t3.transform.projection.name)
                !function(t4, i4, o4, r3, a3) {
                  const n2 = t4.context, s2 = n2.gl;
                  let l2, c2;
                  const h2 = t4.transform, _2 = e.bc(t4, n2, h2), u2 = (e2, i5) => {
                    if (c2 === i5)
                      return;
                    const o5 = [Ti[i5], "PROJECTION_GLOBE_VIEW"];
                    _2 && o5.push("CUSTOM_ANTIALIASING");
                    const r4 = t4.isTileAffectedByFog(e2);
                    l2 = t4.getOrCreateProgram("globeRaster", { defines: o5, overrideFog: r4 }), c2 = i5;
                  }, d2 = t4.colorModeForRenderPass(), p2 = new e.af(s2.LEQUAL, e.af.ReadWrite, t4.depthRangeFor3D);
                  wi.update(a3);
                  const f2 = e.bd(h2), m2 = [e.ak(h2.center.lng), e.al(h2.center.lat)], g2 = t4.globeSharedBuffers, v2 = [h2.width * e.e.devicePixelRatio, h2.height * e.e.devicePixelRatio], x2 = Float32Array.from(h2.globeMatrix), y2 = { useDenormalizedUpVectorScale: true };
                  {
                    const h3 = t4.transform, _3 = Ei(h3.zoom, i4.exaggeration(), i4.sourceCache._source.tileSize);
                    c2 = -1;
                    const b2 = s2.TRIANGLES;
                    for (const c3 of r3) {
                      const r4 = o4.getTile(c3), w2 = e.ah.disabled, T2 = i4.prevTerrainTileForTile[c3.key], E2 = i4.terrainTileForTile[c3.key];
                      bi(T2, E2) && wi.newMorphing(c3.key, T2, E2, a3, 250), n2.activeTexture.set(s2.TEXTURE0), r4.texture && r4.texture.bind(s2.LINEAR, s2.CLAMP_TO_EDGE);
                      const C2 = wi.getMorphValuesForProxy(c3.key), S2 = C2 ? 1 : 0;
                      C2 && e.q(y2, { morphing: { srcDemTile: C2.from, dstDemTile: C2.to, phase: e.bb(C2.phase) } });
                      const I2 = e.be(c3.canonical), L2 = e.bf(I2.getCenter().lat), P2 = e.bg(c3.canonical, I2, L2, h3.worldSize / h3._pixelsPerMercatorPixel), R2 = e.bh(e.bi(c3.canonical)), D2 = kt(h3.expandedFarZProjMatrix, x2, f2, R2, e.a2(h3.zoom), m2, h3.frustumCorners.TL, h3.frustumCorners.TR, h3.frustumCorners.BR, h3.frustumCorners.BL, h3.globeCenterInViewSpace, h3.globeRadius, v2, _3, h3._farZ, P2);
                      if (u2(c3, S2), l2 && (i4.setupElevationDraw(r4, l2, y2), t4.uploadCommonUniforms(n2, l2, c3.toUnwrapped()), g2)) {
                        const [i5, o5, r5] = g2.getGridBuffers(L2, 0 !== _3);
                        l2.draw(t4, b2, p2, w2, d2, e.ag.backCCW, D2, "globe_raster", i5, o5, r5);
                      }
                    }
                  }
                  if (g2 && (t4.renderDefaultNorthPole || t4.renderDefaultSouthPole)) {
                    const a4 = ["GLOBE_POLES", "PROJECTION_GLOBE_VIEW"];
                    _2 && a4.push("CUSTOM_ANTIALIASING"), l2 = t4.getOrCreateProgram("globeRaster", { defines: a4 });
                    for (const a5 of r3) {
                      const { x: r4, y: c3, z: _3 } = a5.canonical, u3 = 0 === c3, f3 = c3 === (1 << _3) - 1, [x3, b2, w2, T2] = g2.getPoleBuffers(_3, false);
                      if (T2 && (u3 || f3)) {
                        const c4 = o4.getTile(a5);
                        n2.activeTexture.set(s2.TEXTURE0), c4.texture && c4.texture.bind(s2.LINEAR, s2.CLAMP_TO_EDGE);
                        let g3 = e.bj(_3, r4, h2);
                        const E2 = e.bh(e.bi(a5.canonical)), C2 = (i5, o5) => i5.draw(t4, s2.TRIANGLES, p2, e.ah.disabled, d2, e.ag.disabled, kt(h2.expandedFarZProjMatrix, g3, g3, E2, 0, m2, h2.frustumCorners.TL, h2.frustumCorners.TR, h2.frustumCorners.BR, h2.frustumCorners.BL, h2.globeCenterInViewSpace, h2.globeRadius, v2, 0, h2._farZ), "globe_pole_raster", o5, w2, T2);
                        i4.setupElevationDraw(c4, l2, y2), t4.uploadCommonUniforms(n2, l2, a5.toUnwrapped()), u3 && t4.renderDefaultNorthPole && C2(l2, x3), f3 && t4.renderDefaultSouthPole && (g3 = e.ae.scale(e.ae.create(), g3, [1, -1, 1]), C2(l2, b2));
                      }
                    }
                  }
                }(t3, i3, o3, r2, a2);
              else {
                const n2 = t3.context, s2 = n2.gl;
                let l2, c2;
                const h2 = t3.shadowRenderer, _2 = ui(t3, t3.longestCutoffRange), u2 = (e2) => {
                  if (c2 === e2)
                    return;
                  const i4 = [];
                  i4.push(Ti[e2]), _2.shouldRenderCutoff && i4.push("RENDER_CUTOFF"), l2 = t3.getOrCreateProgram("terrainRaster", { defines: i4 }), c2 = e2;
                }, d2 = t3.colorModeForRenderPass(), p2 = new e.af(s2.LEQUAL, e.af.ReadWrite, t3.depthRangeFor3D);
                wi.update(a2);
                const f2 = t3.transform, m2 = Ei(f2.zoom, i3.exaggeration(), i3.sourceCache._source.tileSize);
                let g2 = [0, 0, 0];
                if (h2) {
                  const e2 = t3.style.directionalLight, i4 = t3.style.ambientLight;
                  e2 && i4 && (g2 = xi(t3.style, e2, i4));
                }
                {
                  c2 = -1;
                  const v2 = s2.TRIANGLES, [x2, y2] = [i3.gridIndexBuffer, i3.gridSegments];
                  for (const c3 of r2) {
                    const r3 = o3.getTile(c3), b2 = e.ah.disabled, w2 = i3.prevTerrainTileForTile[c3.key], T2 = i3.terrainTileForTile[c3.key];
                    bi(w2, T2) && wi.newMorphing(c3.key, w2, T2, a2, 250), n2.activeTexture.set(s2.TEXTURE0), r3.texture && r3.texture.bind(s2.LINEAR, s2.CLAMP_TO_EDGE);
                    const E2 = wi.getMorphValuesForProxy(c3.key), C2 = E2 ? 1 : 0;
                    let S2;
                    E2 && (S2 = { morphing: { srcDemTile: E2.from, dstDemTile: E2.to, phase: e.bb(E2.phase) } });
                    const I2 = Bt(c3.projMatrix, Ci(c3.canonical, f2.renderWorldCopies) ? m2 / 10 : m2, g2);
                    if (u2(C2), !l2)
                      continue;
                    i3.setupElevationDraw(r3, l2, S2);
                    const L2 = c3.toUnwrapped();
                    h2 && h2.setupShadows(L2, l2), t3.uploadCommonUniforms(n2, l2, L2, null, _2), l2.draw(t3, v2, p2, b2, d2, e.ag.backCCW, I2, "terrain_raster", i3.gridBuffer, x2, y2);
                  }
                }
              }
            }(i2, this, this.proxySourceCache, t2, this._updateTimestamp), this.renderingToTexture = true, i2.gpuTimingDeferredRenderEnd(), t2.splice(0, t2.length));
          }
          renderBatch(t2) {
            if (0 === this._drapedRenderBatches.length)
              return t2 + 1;
            this.renderingToTexture = true;
            const i2 = this.painter, o2 = this.painter.context, r2 = this.proxySourceCache, a2 = this.proxiedCoords[r2.id], n2 = this._drapedRenderBatches.shift(), s2 = i2.style.order, l2 = [];
            let c2 = 0;
            for (const h2 of a2) {
              const a3 = r2.getTileByID(h2.proxyTileKey), _2 = r2.proxyCachedFBO[h2.key] ? r2.proxyCachedFBO[h2.key][t2] : void 0, u2 = void 0 !== _2 ? r2.renderCache[_2] : this.pool[c2++], d2 = void 0 !== _2;
              if (a3.texture = u2.tex, d2 && !u2.dirty) {
                l2.push(a3.tileID);
                continue;
              }
              let p2;
              o2.bindFramebuffer.set(u2.fb.framebuffer), this.renderedToTile = false, u2.dirty && (o2.clear({ color: e.C.transparent, stencil: 0 }), u2.dirty = false);
              for (let e2 = n2.start; e2 <= n2.end; ++e2) {
                const t3 = i2.style._mergedLayers[s2[e2]];
                if (t3.isHidden(i2.transform.zoom))
                  continue;
                const r3 = i2.style.getLayerSourceCache(t3), a4 = r3 ? this.proxyToSource[h2.key][r3.id] : [h2];
                if (!a4)
                  continue;
                const n3 = a4;
                o2.viewport.set([0, 0, u2.fb.width, u2.fb.height]), p2 !== (r3 ? r3.id : null) && (this._setupStencil(u2, a4, t3, r3), p2 = r3 ? r3.id : null), i2.renderLayer(i2, r3, t3, n3);
              }
              if (0 === this._drapedRenderBatches.length)
                for (const e2 of this._pendingGroundEffectLayers) {
                  const t3 = i2.style._mergedLayers[s2[e2]];
                  if (t3.isHidden(i2.transform.zoom))
                    continue;
                  const r3 = i2.style.getLayerSourceCache(t3), a4 = r3 ? this.proxyToSource[h2.key][r3.id] : [h2];
                  if (!a4)
                    continue;
                  const n3 = a4;
                  o2.viewport.set([0, 0, u2.fb.width, u2.fb.height]), p2 !== (r3 ? r3.id : null) && (this._setupStencil(u2, a4, t3, r3), p2 = r3 ? r3.id : null), i2.renderLayer(i2, r3, t3, n3);
                }
              this.renderedToTile ? (u2.dirty = true, l2.push(a3.tileID)) : d2 || --c2, 5 === c2 && (c2 = 0, this.renderToBackBuffer(l2));
            }
            return this.renderToBackBuffer(l2), this.renderingToTexture = false, o2.bindFramebuffer.set(null), o2.viewport.set([0, 0, i2.width, i2.height]), n2.end + 1;
          }
          postRender() {
          }
          isLayerOrderingCorrect(e2) {
            const t2 = e2.order.length;
            let i2 = -1, o2 = t2;
            for (let r2 = 0; r2 < t2; ++r2)
              this._style.isLayerDraped(e2._mergedLayers[e2.order[r2]]) ? i2 = Math.max(i2, r2) : o2 = Math.min(o2, r2);
            return o2 > i2;
          }
          getMinElevationBelowMSL() {
            let e2 = 0;
            return this._visibleDemTiles.filter((e3) => e3.dem).forEach((t2) => {
              e2 = Math.min(e2, t2.dem.tree.minimums[0]);
            }), 0 === e2 ? e2 : (e2 - 30) * this._exaggeration;
          }
          raycast(e2, t2, i2) {
            if (!this._visibleDemTiles)
              return null;
            const o2 = this._visibleDemTiles.filter((e3) => e3.dem).map((o3) => {
              const r2 = o3.tileID, a2 = 1 << r2.overscaledZ, { x: n2, y: s2 } = r2.canonical, l2 = n2 / a2, c2 = (n2 + 1) / a2, h2 = s2 / a2, _2 = (s2 + 1) / a2;
              return { minx: l2, miny: h2, maxx: c2, maxy: _2, t: o3.dem.tree.raycastRoot(l2, h2, c2, _2, e2, t2, i2), tile: o3 };
            });
            o2.sort((e3, t3) => (null !== e3.t ? e3.t : Number.MAX_VALUE) - (null !== t3.t ? t3.t : Number.MAX_VALUE));
            for (const r2 of o2) {
              if (null == r2.t)
                return null;
              const o3 = r2.tile.dem.tree.raycast(r2.minx, r2.miny, r2.maxx, r2.maxy, e2, t2, i2);
              if (null != o3)
                return o3;
            }
            return null;
          }
          _createFBO() {
            const t2 = this.painter.context, i2 = t2.gl, o2 = this.drapeBufferSize;
            t2.activeTexture.set(i2.TEXTURE0);
            const r2 = new e.T(t2, { width: o2[0], height: o2[1], data: null }, i2.RGBA);
            r2.bind(i2.LINEAR, i2.CLAMP_TO_EDGE);
            const a2 = t2.createFramebuffer(o2[0], o2[1], true, null);
            return a2.colorAttachment.set(r2.texture), a2.depthAttachment = new ie(t2, a2.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = t2.createRenderbuffer(t2.gl.DEPTH_STENCIL, o2[0], o2[1]), this._stencilRef = 0, a2.depthAttachment.set(this._sharedDepthStencil), t2.clear({ stencil: 0 })) : a2.depthAttachment.set(this._sharedDepthStencil), t2.extTextureFilterAnisotropic && i2.texParameterf(i2.TEXTURE_2D, t2.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t2.extTextureFilterAnisotropicMax), { fb: a2, tex: r2, dirty: false };
          }
          _initFBOPool() {
            for (; this.pool.length < Math.min(5, this.proxyCoords.length); )
              this.pool.push(this._createFBO());
          }
          _shouldDisableRenderCache() {
            if (this._debugParams.disableRenderCache)
              return true;
            if (this._style.hasLightTransitions())
              return true;
            for (const e2 in this._style._mergedSourceCaches)
              if (this._style._mergedSourceCaches[e2].hasTransition())
                return true;
            return this._style.order.some((e2) => {
              const t2 = this._style._mergedLayers[e2], i2 = t2.isHidden(this.painter.transform.zoom);
              return "custom" === t2.type ? !i2 && t2.shouldRedrape() : !i2 && t2.hasTransition();
            });
          }
          _clearLineLayersFromRenderCache() {
            let t2 = false;
            for (const e2 of this._style.getSources())
              if (e2 instanceof Ft) {
                t2 = true;
                break;
              }
            if (!t2)
              return;
            const i2 = {};
            for (let t3 = 0; t3 < this._style.order.length; ++t3) {
              const o2 = this._style._mergedLayers[this._style.order[t3]], r2 = this._style.getLayerSourceCache(o2);
              if (r2 && !i2[r2.id] && !o2.isHidden(this.painter.transform.zoom) && "line" === o2.type && o2.widthExpression() instanceof e.Z) {
                i2[r2.id] = true;
                for (const e2 of this.proxyCoords) {
                  const t4 = this.proxyToSource[e2.key][r2.id];
                  if (t4)
                    for (const e3 of t4)
                      this._clearRenderCacheForTile(r2.id, e3);
                }
              }
            }
          }
          _clearRasterLayersFromRenderCache() {
            let e2 = false;
            for (const t3 in this._style._mergedSourceCaches)
              if (this._style._mergedSourceCaches[t3]._source instanceof Ot) {
                e2 = true;
                break;
              }
            if (!e2)
              return;
            const t2 = {};
            for (let e3 = 0; e3 < this._style.order.length; ++e3) {
              const i2 = this._style._mergedLayers[this._style.order[e3]], o2 = this._style.getLayerSourceCache(i2);
              if (!o2 || t2[o2.id])
                continue;
              if (i2.isHidden(this.painter.transform.zoom) || "raster" !== i2.type)
                continue;
              const r2 = i2.paint.get("raster-fade-duration");
              for (const e4 of this.proxyCoords) {
                const t3 = this.proxyToSource[e4.key][o2.id];
                if (t3)
                  for (const e5 of t3) {
                    const t4 = Ii(o2.getTile(e5), o2.findLoadedParent(e5, 0), o2, this.painter.transform, r2);
                    (1 !== t4.opacity || 0 !== t4.mix) && this._clearRenderCacheForTile(o2.id, e5);
                  }
              }
            }
          }
          _setupDrapedRenderBatches() {
            const t2 = this._style.order, i2 = t2.length;
            if (0 === i2)
              return;
            const o2 = [];
            this._pendingGroundEffectLayers = [];
            let r2, a2 = 0, n2 = this._style._mergedLayers[t2[a2]];
            for (; !this._style.isLayerDraped(n2) && n2.isHidden(this.painter.transform.zoom) && ++a2 < i2; )
              n2 = this._style._mergedLayers[t2[a2]];
            for (; a2 < i2; ++a2) {
              const e2 = this._style._mergedLayers[t2[a2]];
              e2.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(e2) ? void 0 === r2 && (r2 = a2) : ("fill-extrusion" === e2.type && this._pendingGroundEffectLayers.push(a2), void 0 !== r2 && (o2.push({ start: r2, end: a2 - 1 }), r2 = void 0)));
            }
            if (void 0 !== r2 && o2.push({ start: r2, end: a2 - 1 }), 0 !== o2.length) {
              const t3 = o2[o2.length - 1];
              this._pendingGroundEffectLayers.every((e2) => e2 > t3.end) || e.w("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
            }
            this._drapedRenderBatches = o2;
          }
          _setupRenderCache(e2) {
            const t2 = this.proxySourceCache;
            if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
              if (this.invalidateRenderCache = false, t2.renderCache.length > t2.renderCachePool.length) {
                const e3 = Object.values(t2.proxyCachedFBO);
                t2.proxyCachedFBO = {};
                for (let i3 = 0; i3 < e3.length; ++i3) {
                  const o3 = Object.values(e3[i3]);
                  t2.renderCachePool.push(...o3);
                }
              }
              return;
            }
            this._clearRasterLayersFromRenderCache();
            const i2 = this.proxyCoords, o2 = this._tilesDirty;
            for (let r3 = i2.length - 1; r3 >= 0; r3--) {
              const a2 = i2[r3];
              if (t2.getTileByID(a2.key), void 0 !== t2.proxyCachedFBO[a2.key]) {
                const i3 = e2[a2.key], r4 = this.proxyToSource[a2.key];
                let n2 = 0;
                for (const e3 in r4) {
                  const t3 = r4[e3], a3 = i3[e3];
                  if (!a3 || a3.length !== t3.length || t3.some((t4, i4) => t4 !== a3[i4] || o2[e3] && o2[e3].hasOwnProperty(t4.key))) {
                    n2 = -1;
                    break;
                  }
                  ++n2;
                }
                for (const e3 in t2.proxyCachedFBO[a2.key])
                  t2.renderCache[t2.proxyCachedFBO[a2.key][e3]].dirty = n2 < 0 || n2 !== Object.values(i3).length;
              }
            }
            const r2 = [...this._drapedRenderBatches];
            r2.sort((e3, t3) => t3.end - t3.start - (e3.end - e3.start));
            for (const e3 of r2)
              for (const o3 of i2) {
                if (t2.proxyCachedFBO[o3.key])
                  continue;
                let i3 = t2.renderCachePool.pop();
                void 0 === i3 && t2.renderCache.length < 50 && (i3 = t2.renderCache.length, t2.renderCache.push(this._createFBO())), void 0 !== i3 && (t2.proxyCachedFBO[o3.key] = {}, t2.proxyCachedFBO[o3.key][e3.start] = i3, t2.renderCache[i3].dirty = true);
              }
            this._tilesDirty = {};
          }
          _setupStencil(e2, t2, i2, o2) {
            if (!o2 || !this._sourceTilesOverlap[o2.id])
              return void (this._overlapStencilType && (this._overlapStencilType = false));
            const r2 = this.painter.context, a2 = r2.gl;
            if (t2.length <= 1)
              return void (this._overlapStencilType = false);
            let n2;
            if (i2.isTileClipped())
              n2 = t2.length, this._overlapStencilMode.test = { func: a2.EQUAL, mask: 255 }, this._overlapStencilType = "Clip";
            else {
              if (!(t2[0].overscaledZ > t2[t2.length - 1].overscaledZ))
                return void (this._overlapStencilType = false);
              n2 = 1, this._overlapStencilMode.test = { func: a2.GREATER, mask: 255 }, this._overlapStencilType = "Mask";
            }
            this._stencilRef + n2 > 255 && (r2.clear({ stencil: 0 }), this._stencilRef = 0), this._stencilRef += n2, this._overlapStencilMode.ref = this._stencilRef, i2.isTileClipped() && this._renderTileClippingMasks(t2, this._overlapStencilMode.ref);
          }
          clipOrMaskOverlapStencilType() {
            return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
          }
          stencilModeForRTTOverlap(t2) {
            return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[t2.key]), this._overlapStencilMode) : e.ah.disabled;
          }
          _renderTileClippingMasks(t2, i2) {
            const o2 = this.painter, r2 = this.painter.context, a2 = r2.gl;
            o2._tileClippingMaskIDs = {}, r2.setColorMode(e.a.disabled), r2.setDepthMode(e.af.disabled);
            const n2 = o2.getOrCreateProgram("clippingMask");
            for (const r3 of t2) {
              const t3 = o2._tileClippingMaskIDs[r3.key] = --i2;
              n2.draw(o2, a2.TRIANGLES, e.af.disabled, new e.ah({ func: a2.ALWAYS, mask: 0 }, t3, 255, a2.KEEP, a2.KEEP, a2.REPLACE), e.a.disabled, e.ag.disabled, Si(r3.projMatrix), "$clipping", o2.tileExtentBuffer, o2.quadTriangleIndexBuffer, o2.tileExtentSegments);
            }
          }
          pointCoordinate(t2) {
            const i2 = this.painter.transform;
            if (t2.x < 0 || t2.x > i2.width || t2.y < 0 || t2.y > i2.height)
              return null;
            const o2 = [t2.x, t2.y, 1, 1];
            e.aB.transformMat4(o2, o2, i2.pixelMatrixInverse), e.aB.scale(o2, o2, 1 / o2[3]), o2[0] /= i2.worldSize, o2[1] /= i2.worldSize;
            const r2 = i2._camera.position, a2 = e.ay(1, i2.center.lat), n2 = [r2[0], r2[1], r2[2] / a2, 0], s2 = e.$.subtract([], o2.slice(0, 3), n2);
            e.$.normalize(s2, s2);
            const l2 = this.raycast(n2, s2, this._exaggeration);
            return null !== l2 && l2 ? (e.$.scaleAndAdd(n2, n2, s2, l2), n2[3] = n2[2], n2[2] *= a2, n2) : null;
          }
          _setupProxiedCoordsForOrtho(t2, i2, o2) {
            if (t2.getSource() instanceof e.bo)
              return this._setupProxiedCoordsForImageSource(t2, i2, o2);
            this._findCoveringTileCache[t2.id] = this._findCoveringTileCache[t2.id] || {};
            const r2 = this.proxiedCoords[t2.id] = [], a2 = this.proxyCoords;
            for (let e2 = 0; e2 < a2.length; e2++) {
              const i3 = a2[e2], n3 = this._findTileCoveringTileID(i3, t2);
              if (n3) {
                const e3 = this._createProxiedId(i3, n3, o2[i3.key] && o2[i3.key][t2.id]);
                r2.push(e3), this.proxyToSource[i3.key][t2.id] = [e3];
              }
            }
            let n2 = false;
            const s2 = /* @__PURE__ */ new Set();
            for (let e2 = 0; e2 < i2.length; e2++) {
              const a3 = t2.getTile(i2[e2]);
              if (!a3 || !a3.hasData())
                continue;
              const l2 = this._findTileCoveringTileID(a3.tileID, this.proxySourceCache);
              if (l2 && l2.tileID.canonical.z !== a3.tileID.canonical.z) {
                const e3 = this.proxyToSource[l2.tileID.key][t2.id], i3 = this._createProxiedId(l2.tileID, a3, o2[l2.tileID.key] && o2[l2.tileID.key][t2.id]);
                e3 ? e3.splice(e3.length - 1, 0, i3) : this.proxyToSource[l2.tileID.key][t2.id] = [i3];
                const c2 = this.proxyToSource[l2.tileID.key][t2.id];
                s2.has(c2) || s2.add(c2), r2.push(i3), n2 = true;
              }
            }
            if (this._sourceTilesOverlap[t2.id] = n2, n2 && this._debugParams.sortTilesHiZFirst)
              for (const e2 of s2)
                e2.sort((e3, t3) => t3.overscaledZ - e3.overscaledZ);
          }
          _setupProxiedCoordsForImageSource(t2, i2, o2) {
            if (!t2.getSource().loaded())
              return;
            const r2 = this.proxiedCoords[t2.id] = [], a2 = this.proxyCoords, n2 = t2.getSource(), s2 = n2.tileID;
            if (!s2)
              return;
            const l2 = new e.P(s2.x, s2.y)._div(1 << s2.z), c2 = n2.coordinates.map(e._.fromLngLat).reduce((e2, t3) => (e2.min.x = Math.min(e2.min.x, t3.x - l2.x), e2.min.y = Math.min(e2.min.y, t3.y - l2.y), e2.max.x = Math.max(e2.max.x, t3.x - l2.x), e2.max.y = Math.max(e2.max.y, t3.y - l2.y), e2), { min: new e.P(Number.MAX_VALUE, Number.MAX_VALUE), max: new e.P(-Number.MAX_VALUE, -Number.MAX_VALUE) }), h2 = (t3, i3) => {
              const o3 = t3.wrap + t3.canonical.x / (1 << t3.canonical.z), r3 = t3.canonical.y / (1 << t3.canonical.z), a3 = e.a4 / (1 << t3.canonical.z), n3 = i3.wrap + i3.canonical.x / (1 << i3.canonical.z), s3 = i3.canonical.y / (1 << i3.canonical.z);
              return o3 + a3 < n3 + c2.min.x || o3 > n3 + c2.max.x || r3 + a3 < s3 + c2.min.y || r3 > s3 + c2.max.y;
            };
            for (let e2 = 0; e2 < a2.length; e2++) {
              const n3 = a2[e2];
              for (let e3 = 0; e3 < i2.length; e3++) {
                const a3 = t2.getTile(i2[e3]);
                if (!a3 || !a3.hasData())
                  continue;
                if (h2(n3, a3.tileID))
                  continue;
                const s3 = this._createProxiedId(n3, a3, o2[n3.key] && o2[n3.key][t2.id]), l3 = this.proxyToSource[n3.key][t2.id];
                l3 ? l3.push(s3) : this.proxyToSource[n3.key][t2.id] = [s3], r2.push(s3);
              }
            }
          }
          _createProxiedId(t2, i2, o2) {
            let r2 = this.orthoMatrix;
            if (o2) {
              const e2 = o2.find((e3) => e3.key === i2.tileID.key);
              if (e2)
                return e2;
            }
            if (i2.tileID.key !== t2.key) {
              const o3 = t2.canonical.z - i2.tileID.canonical.z;
              let a2, n2, s2;
              r2 = e.ae.create();
              const l2 = i2.tileID.wrap - t2.wrap << t2.overscaledZ;
              o3 > 0 ? (a2 = e.a4 >> o3, n2 = a2 * ((i2.tileID.canonical.x << o3) - t2.canonical.x + l2), s2 = a2 * ((i2.tileID.canonical.y << o3) - t2.canonical.y)) : (a2 = e.a4 << -o3, n2 = e.a4 * (i2.tileID.canonical.x - (t2.canonical.x + l2 << -o3)), s2 = e.a4 * (i2.tileID.canonical.y - (t2.canonical.y << -o3))), e.ae.ortho(r2, 0, a2, 0, a2, 0, 1), e.ae.translate(r2, r2, [n2, s2, 0]);
            }
            return new Mi(i2.tileID, t2.key, r2);
          }
          _findTileCoveringTileID(t2, i2) {
            let o2 = i2.getTile(t2);
            if (o2 && o2.hasData())
              return o2;
            const r2 = this._findCoveringTileCache[i2.id], a2 = r2[t2.key];
            if (o2 = a2 ? i2.getTileByID(a2) : null, o2 && o2.hasData() || null === a2)
              return o2;
            let n2 = o2 ? o2.tileID : t2, s2 = n2.overscaledZ;
            const l2 = i2.getSource().minzoom, c2 = [];
            if (!a2) {
              const r3 = i2.getSource().maxzoom;
              if (t2.canonical.z >= r3) {
                const o3 = t2.canonical.z - r3;
                i2.getSource().reparseOverscaled ? (s2 = Math.max(t2.canonical.z + 2, i2.transform.tileZoom), n2 = new e.aQ(s2, t2.wrap, r3, t2.canonical.x >> o3, t2.canonical.y >> o3)) : 0 !== o3 && (s2 = r3, n2 = new e.aQ(s2, t2.wrap, r3, t2.canonical.x >> o3, t2.canonical.y >> o3));
              }
              n2.key !== t2.key && (c2.push(n2.key), o2 = i2.getTile(n2));
            }
            const h2 = (e2) => {
              c2.forEach((t3) => {
                r2[t3] = e2;
              }), c2.length = 0;
            };
            for (s2 -= 1; s2 >= l2 && (!o2 || !o2.hasData()); s2--) {
              o2 && h2(o2.tileID.key);
              const e2 = n2.calculateScaledKey(s2);
              if (o2 = i2.getTileByID(e2), o2 && o2.hasData())
                break;
              const t3 = r2[e2];
              if (null === t3)
                break;
              void 0 === t3 ? c2.push(e2) : o2 = i2.getTileByID(t3);
            }
            return h2(o2 ? o2.tileID.key : null), o2 && o2.hasData() ? o2 : null;
          }
          findDEMTileFor(e2) {
            return this.enabled ? this._findTileCoveringTileID(e2, this.sourceCache) : null;
          }
          prepareDrawTile() {
            this.renderedToTile = true;
          }
          _clearRenderCacheForTile(e2, t2) {
            let i2 = this._tilesDirty[e2];
            i2 || (i2 = this._tilesDirty[e2] = {}), i2[t2.key] = true;
          }
        }
        function Oi(t2, i2, o2) {
          const r2 = function(t3, i3, o3) {
            const r3 = e.$.dot(i3, t3), a3 = e.$.dot(o3, [0.2126, 0.7152, 0.0722]), n3 = (e2, t4, i4) => (1 - i4) * e2 + i4 * t4, s3 = n3(1 - 0.3 * Math.min(a3, 1), 1, Math.min(r3 + 1, 1));
            return n3(0.92, 1, Math.asin(e.au(i3[2], -1, 1)) / Math.PI + 0.5) * s3;
          }(t2, [0, 0, 1], i2), a2 = [0, 0, 0];
          e.$.scale(a2, o2.slice(0, 3), r2);
          const n2 = [0, 0, 0];
          e.$.scale(n2, i2.slice(0, 3), t2[2]);
          const s2 = [0, 0, 0];
          return e.$.add(s2, a2, n2), e.ba(s2);
        }
        const Fi = ["fill", "fillOutline", "fillPattern", "line", "linePattern", "background", "backgroundPattern", "hillshade", "raster"], Bi = ["stars", "fillExtrusion", "fillExtrusionGroundEffect", "model", "symbolSDF", "symbolIcon", "symbolTextAndIcon"];
        class ki {
          static cacheKey(e2, t2, i2, o2) {
            let r2 = `${t2}${o2 ? o2.cacheKey : ""}`;
            for (const t3 of i2)
              e2.usedDefines.includes(t3) && (r2 += `/${t3}`);
            return r2;
          }
          constructor(t2, i2, o2, r2, a2, n2) {
            const s2 = t2.gl;
            this.program = s2.createProgram(), this.configuration = r2, this.name = i2, this.fixedDefines = [...n2];
            const l2 = r2 ? r2.getBinderAttributes() : [], c2 = (o2.staticAttributes || []).concat(l2);
            let h2 = r2 ? r2.defines() : [];
            h2 = h2.concat(n2.map((e2) => `#define ${e2}`));
            const _2 = "#version 300 es\n";
            let u2 = _2 + h2.concat("precision mediump float;", Et, Tt.fragmentSource).join("\n");
            for (const e2 of o2.fragmentIncludes)
              u2 += `
${bt[e2]}`;
            u2 += `
${o2.fragmentSource}`;
            let d2 = _2 + h2.concat("precision highp float;", Et, Tt.vertexSource).join("\n");
            for (const e2 of o2.vertexIncludes)
              d2 += `
${bt[e2]}`;
            d2 += `
${o2.vertexSource}`;
            const p2 = s2.createShader(s2.FRAGMENT_SHADER);
            if (s2.isContextLost())
              return void (this.failedToCreate = true);
            s2.shaderSource(p2, u2), s2.compileShader(p2), s2.attachShader(this.program, p2);
            const f2 = s2.createShader(s2.VERTEX_SHADER);
            if (s2.isContextLost())
              this.failedToCreate = true;
            else {
              s2.shaderSource(f2, d2), s2.compileShader(f2), s2.attachShader(this.program, f2), this.attributes = {}, this.numAttributes = c2.length;
              for (let e2 = 0; e2 < this.numAttributes; e2++)
                if (c2[e2]) {
                  const t3 = c2[e2].startsWith("a_") ? c2[e2] : `a_${c2[e2]}`;
                  s2.bindAttribLocation(this.program, e2, t3), this.attributes[t3] = e2;
                }
              s2.linkProgram(this.program), s2.deleteShader(f2), s2.deleteShader(p2), this.fixedUniforms = a2(t2), this.binderUniforms = r2 ? r2.getUniforms(t2) : [], (n2.includes("TERRAIN") || -1 !== i2.indexOf("symbol") || -1 !== i2.indexOf("circle")) && (this.terrainUniforms = ((t3) => ({ u_dem: new e.a8(t3), u_dem_prev: new e.a8(t3), u_dem_tl: new e.a9(t3), u_dem_scale: new e.ab(t3), u_dem_tl_prev: new e.a9(t3), u_dem_scale_prev: new e.ab(t3), u_dem_size: new e.ab(t3), u_dem_lerp: new e.ab(t3), u_exaggeration: new e.ab(t3), u_depth: new e.a8(t3), u_depth_size_inv: new e.a9(t3), u_depth_range_unpack: new e.a9(t3), u_occluder_half_size: new e.ab(t3), u_occlusion_depth_offset: new e.ab(t3), u_meter_to_dem: new e.ab(t3), u_label_plane_matrix_inv: new e.a7(t3) }))(t2)), n2.includes("GLOBE") && (this.globeUniforms = ((t3) => ({ u_tile_tl_up: new e.ar(t3), u_tile_tr_up: new e.ar(t3), u_tile_br_up: new e.ar(t3), u_tile_bl_up: new e.ar(t3), u_tile_up_scale: new e.ab(t3) }))(t2)), n2.includes("FOG") && (this.fogUniforms = ((t3) => ({ u_fog_matrix: new e.a7(t3), u_fog_range: new e.a9(t3), u_fog_color: new e.at(t3), u_fog_horizon_blend: new e.ab(t3), u_fog_vertical_limit: new e.a9(t3), u_fog_temporal_offset: new e.ab(t3), u_frustum_tl: new e.ar(t3), u_frustum_tr: new e.ar(t3), u_frustum_br: new e.ar(t3), u_frustum_bl: new e.ar(t3), u_globe_pos: new e.ar(t3), u_globe_radius: new e.ab(t3), u_globe_transition: new e.ab(t3), u_is_globe: new e.a8(t3), u_viewport: new e.a9(t3) }))(t2)), n2.includes("RENDER_CUTOFF") && (this.cutoffUniforms = ((t3) => ({ u_cutoff_params: new e.at(t3) }))(t2)), n2.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = ((t3) => ({ u_lighting_ambient_color: new e.ar(t3), u_lighting_directional_dir: new e.ar(t3), u_lighting_directional_color: new e.ar(t3), u_ground_radiance: new e.ar(t3) }))(t2)), n2.includes("RENDER_SHADOWS") && (this.shadowUniforms = ((t3) => ({ u_light_matrix_0: new e.a7(t3), u_light_matrix_1: new e.a7(t3), u_fade_range: new e.a9(t3), u_shadow_normal_offset: new e.ar(t3), u_shadow_intensity: new e.ab(t3), u_shadow_texel_size: new e.ab(t3), u_shadow_map_resolution: new e.ab(t3), u_shadow_direction: new e.ar(t3), u_shadow_bias: new e.ar(t3), u_shadowmap_0: new e.a8(t3), u_shadowmap_1: new e.a8(t3) }))(t2));
            }
          }
          setTerrainUniformValues(e2, t2) {
            if (!this.terrainUniforms)
              return;
            const i2 = this.terrainUniforms;
            if (!this.failedToCreate) {
              e2.program.set(this.program);
              for (const e3 in t2)
                i2[e3] && i2[e3].set(this.program, e3, t2[e3]);
            }
          }
          setGlobeUniformValues(e2, t2) {
            if (!this.globeUniforms)
              return;
            const i2 = this.globeUniforms;
            if (!this.failedToCreate) {
              e2.program.set(this.program);
              for (const e3 in t2)
                i2[e3] && i2[e3].set(this.program, e3, t2[e3]);
            }
          }
          setFogUniformValues(e2, t2) {
            if (!this.fogUniforms)
              return;
            const i2 = this.fogUniforms;
            if (!this.failedToCreate) {
              e2.program.set(this.program);
              for (const e3 in t2)
                i2[e3].set(this.program, e3, t2[e3]);
            }
          }
          setCutoffUniformValues(e2, t2) {
            if (!this.cutoffUniforms)
              return;
            const i2 = this.cutoffUniforms;
            if (!this.failedToCreate) {
              e2.program.set(this.program);
              for (const e3 in t2)
                i2[e3].set(this.program, e3, t2[e3]);
            }
          }
          setLightsUniformValues(e2, t2) {
            if (!this.lightsUniforms)
              return;
            const i2 = this.lightsUniforms;
            if (!this.failedToCreate) {
              e2.program.set(this.program);
              for (const e3 in t2)
                i2[e3].set(this.program, e3, t2[e3]);
            }
          }
          setShadowUniformValues(e2, t2) {
            if (this.failedToCreate || !this.shadowUniforms)
              return;
            const i2 = this.shadowUniforms;
            e2.program.set(this.program);
            for (const e3 in t2)
              i2[e3].set(this.program, e3, t2[e3]);
          }
          _drawDebugWireframe(t2, i2, o2, r2, a2, n2, s2, l2, c2, h2) {
            const _2 = t2.options.wireframe;
            if (false === _2.terrain && false === _2.layers2D && false === _2.layers3D)
              return;
            const u2 = t2.context;
            if (!(() => !(!_2.terrain || "terrainRaster" !== this.name && "globeRaster" !== this.name) || !(!_2.layers2D || t2._terrain && t2._terrain.renderingToTexture || !Fi.includes(this.name)) || !(!_2.layers3D || !Bi.includes(this.name)))())
              return;
            const d2 = u2.gl, p2 = t2.wireframeDebugCache.getLinesFromTrianglesBuffer(t2.frameCounter, a2, u2);
            if (!p2)
              return;
            const f2 = [...this.fixedDefines];
            f2.push("DEBUG_WIREFRAME");
            const m2 = t2.getOrCreateProgram(this.name, { config: this.configuration, defines: f2 });
            u2.program.set(m2.program);
            const g2 = (e2, t3, i3) => {
              if (t3[e2] && i3[e2])
                for (const o3 in t3[e2])
                  i3[e2][o3] && i3[e2][o3].set(i3.program, o3, t3[e2][o3].current);
            };
            c2 && c2.setUniforms(m2.program, u2, m2.binderUniforms, s2, { zoom: l2 }), g2("fixedUniforms", this, m2), g2("terrainUniforms", this, m2), g2("globeUniforms", this, m2), g2("fogUniforms", this, m2), g2("lightsUniforms", this, m2), g2("shadowUniforms", this, m2), p2.bind(), u2.setColorMode(new e.a([d2.ONE, d2.ONE_MINUS_SRC_ALPHA, d2.ZERO, d2.ONE], e.C.transparent, [true, true, true, false])), u2.setDepthMode(new e.af(i2.func === d2.LESS ? d2.LEQUAL : i2.func, e.af.ReadOnly, i2.range)), u2.setStencilMode(e.ah.disabled);
            const v2 = 3 * n2.primitiveLength * 2, x2 = 3 * n2.primitiveOffset * 2 * 2;
            h2 && h2 > 1 ? d2.drawElementsInstanced(d2.LINES, v2, d2.UNSIGNED_SHORT, x2, h2) : d2.drawElements(d2.LINES, v2, d2.UNSIGNED_SHORT, x2), a2.bind(), u2.program.set(this.program), u2.setDepthMode(i2), u2.setStencilMode(o2), u2.setColorMode(r2);
          }
          draw(e2, t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2) {
            const m2 = e2.context, g2 = m2.gl;
            if (this.failedToCreate)
              return;
            m2.program.set(this.program), m2.setDepthMode(i2), m2.setStencilMode(o2), m2.setColorMode(r2), m2.setCullFace(a2);
            for (const e3 of Object.keys(this.fixedUniforms))
              this.fixedUniforms[e3].set(this.program, e3, n2[e3]);
            d2 && d2.setUniforms(this.program, m2, this.binderUniforms, _2, { zoom: u2 });
            const v2 = { [g2.POINTS]: 1, [g2.LINES]: 2, [g2.TRIANGLES]: 3, [g2.LINE_STRIP]: 1 }[t2], x2 = f2 && f2 > 0 ? 1 : void 0;
            for (const a3 of h2.get()) {
              const n3 = a3.vaos || (a3.vaos = {});
              (n3[s2] || (n3[s2] = new Lt())).bind(m2, this, l2, d2 ? d2.getPaintVertexBuffers() : [], c2, a3.vertexOffset, p2 || [], x2), f2 && f2 > 1 ? g2.drawElementsInstanced(t2, a3.primitiveLength * v2, g2.UNSIGNED_SHORT, a3.primitiveOffset * v2 * 2, f2) : c2 ? g2.drawElements(t2, a3.primitiveLength * v2, g2.UNSIGNED_SHORT, a3.primitiveOffset * v2 * 2) : g2.drawArrays(t2, a3.vertexOffset, a3.vertexLength), t2 === g2.TRIANGLES && c2 && this._drawDebugWireframe(e2, i2, o2, r2, c2, a3, _2, u2, d2, f2);
            }
          }
        }
        function Ni(t2, i2) {
          const o2 = Math.pow(2, i2.tileID.overscaledZ), r2 = i2.tileSize * Math.pow(2, t2.transform.tileZoom) / o2, a2 = r2 * (i2.tileID.canonical.x + i2.tileID.wrap * o2), n2 = r2 * i2.tileID.canonical.y;
          return { u_image: 0, u_texsize: i2.imageAtlasTexture ? i2.imageAtlasTexture.size : [0, 0], u_tile_units_to_pixels: 1 / e.bD(i2, 1, t2.transform.tileZoom), u_pixel_coord_upper: [a2 >> 16, n2 >> 16], u_pixel_coord_lower: [65535 & a2, 65535 & n2] };
        }
        const Ui = e.ae.create(), Gi = (t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2, m2, g2, v2) => {
          const x2 = i2.style.light, y2 = x2.properties.get("position"), b2 = [y2.x, y2.y, y2.z], w2 = e.bE.create();
          "viewport" === x2.properties.get("anchor") && (e.bE.fromRotation(w2, -i2.transform.angle), e.$.transformMat3(b2, b2, w2));
          const T2 = x2.properties.get("color"), E2 = i2.transform, C2 = { u_matrix: t2, u_lightpos: b2, u_lightintensity: x2.properties.get("intensity"), u_lightcolor: [T2.r, T2.g, T2.b], u_vertical_gradient: +o2, u_opacity: r2, u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_inv_rot_matrix: Ui, u_merc_center: [0, 0], u_up_dir: [0, 0, 0], u_height_lift: 0, u_ao: a2, u_edge_radius: n2, u_alignment: s2, u_width_scale: l2, u_flood_light_color: p2, u_vertical_scale: f2, u_flood_light_intensity: m2, u_ground_shadow_factor: g2, u_emissive_strength: v2 };
          return "globe" === E2.projection.name && (C2.u_tile_id = [c2.canonical.x, c2.canonical.y, 1 << c2.canonical.z], C2.u_zoom_transition = _2, C2.u_inv_rot_matrix = d2, C2.u_merc_center = u2, C2.u_up_dir = E2.projection.upVector(new e.aO(0, 0, 0), u2[0] * e.a4, u2[1] * e.a4), C2.u_height_lift = h2), C2;
        }, ji = (e2, t2, i2, o2, r2) => ({ u_matrix: e2, u_edge_radius: t2, u_alignment: i2, u_width_scale: o2, u_vertical_scale: r2 }), Vi = (t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2, m2) => {
          const g2 = Gi(t2, i2, o2, r2, a2, n2, s2, l2, c2, _2, u2, d2, p2, f2, m2, 1, [0, 0, 0], 0), v2 = { u_height_factor: -Math.pow(2, c2.overscaledZ) / h2.tileSize / 8 };
          return e.Q(g2, Ni(i2, h2), v2);
        }, $i = (e2, t2) => ({ u_matrix: e2, u_emissive_strength: t2 }), Zi = (t2, i2, o2, r2) => e.Q($i(t2, i2), Ni(o2, r2)), Wi = (e2, t2, i2) => ({ u_matrix: e2, u_world: i2, u_emissive_strength: t2 }), Hi = (t2, i2, o2, r2, a2) => e.Q(Zi(t2, i2, o2, r2), { u_world: a2 }), qi = (t2, i2, o2, r2) => {
          const a2 = e.a4 / o2.tileSize;
          return { u_matrix: t2, u_camera_to_center_distance: i2.getCameraToCenterDistance(r2), u_extrude_scale: [i2.pixelsToGLUnits[0] / a2, i2.pixelsToGLUnits[1] / a2] };
        }, Xi = (e2, t2, i2 = 1) => ({ u_matrix: e2, u_color: t2.toRenderColor(null), u_overlay: 0, u_overlay_scale: i2 }), Qi = e.ae.create(), Yi = (t2, i2, o2, r2, a2, n2, s2) => {
          const l2 = t2.transform, c2 = "globe" === l2.projection.name, h2 = c2 ? e.bF(l2.zoom, i2.canonical) * l2._pixelsPerMercatorPixel : e.bD(o2, 1, n2), _2 = { u_matrix: i2.projMatrix, u_extrude_scale: h2, u_intensity: s2, u_inv_rot_matrix: Qi, u_merc_center: [0, 0], u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_up_dir: [0, 0, 0] };
          if (c2) {
            _2.u_inv_rot_matrix = r2, _2.u_merc_center = a2, _2.u_tile_id = [i2.canonical.x, i2.canonical.y, 1 << i2.canonical.z], _2.u_zoom_transition = e.a2(l2.zoom);
            const t3 = a2[0] * e.a4, o3 = a2[1] * e.a4;
            _2.u_up_dir = l2.projection.upVector(new e.aO(0, 0, 0), t3, o3);
          }
          return _2;
        };
        function Ji(e2, [t2, i2, o2, r2], [a2, n2]) {
          if (a2 === n2)
            return [0, 0, 0, 0];
          const s2 = 255 * (e2 - 1) / (e2 * (n2 - a2));
          return [t2 * s2, i2 * s2, o2 * s2, r2 * s2];
        }
        function Ki(e2, t2, [i2, o2]) {
          return i2 === o2 ? 0 : 0.5 / e2 + (t2 - i2) * (e2 - 1) / (e2 * (o2 - i2));
        }
        const eo = (t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2, m2, g2, v2, x2, y2, b2) => ({ u_matrix: t2, u_normalize_matrix: i2, u_globe_matrix: o2, u_merc_matrix: r2, u_grid_matrix: a2, u_tl_parent: n2, u_scale_parent: h2, u_fade_t: _2.mix, u_opacity: _2.opacity * u2.paint.get("raster-opacity"), u_image0: 0, u_image1: 1, u_brightness_low: u2.paint.get("raster-brightness-min"), u_brightness_high: u2.paint.get("raster-brightness-max"), u_saturation_factor: e.bG(u2.paint.get("raster-saturation")), u_contrast_factor: e.bH(u2.paint.get("raster-contrast")), u_spin_weights: to(u2.paint.get("raster-hue-rotate")), u_perspective_transform: d2, u_raster_elevation: p2, u_zoom_transition: s2, u_merc_center: l2, u_cutoff_params: c2, u_colorization_mix: Ji(e.bI, m2, v2), u_colorization_offset: Ki(e.bI, g2, v2), u_color_ramp: f2, u_texture_offset: [y2 / (x2 + 2 * y2), x2 / (x2 + 2 * y2)], u_texture_res: [x2 + 2 * y2, x2 + 2 * y2], u_emissive_strength: b2 });
        function to(e2) {
          e2 *= Math.PI / 180;
          const t2 = Math.sin(e2), i2 = Math.cos(e2);
          return [(2 * i2 + 1) / 3, (-Math.sqrt(3) * t2 - i2 + 1) / 3, (Math.sqrt(3) * t2 - i2 + 1) / 3];
        }
        const io = 0.05, oo = (e2, t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2) => ({ u_matrix: e2, u_normalize_matrix: t2, u_globe_matrix: i2, u_merc_matrix: o2, u_grid_matrix: r2, u_tl_parent: a2, u_scale_parent: c2, u_fade_t: h2.mix, u_opacity: h2.opacity, u_image0: 0, u_image1: 1, u_raster_elevation: _2, u_zoom_transition: n2, u_merc_center: s2, u_cutoff_params: l2 }), ro = (e2, t2, i2, o2, r2, a2, n2, s2, l2, c2) => ({ u_particle_texture: e2, u_particle_texture_side_len: t2, u_tile_offset: i2, u_velocity: o2, u_color_ramp: a2, u_velocity_res: r2, u_max_speed: n2, u_uv_offset: s2, u_data_scale: [255 * l2[0], 255 * l2[1]], u_data_offset: c2, u_particle_pos_scale: 1.1, u_particle_pos_offset: [io, io] }), ao = (e2, t2, i2, o2, r2, a2, n2, s2, l2, c2) => ({ u_particle_texture: e2, u_particle_texture_side_len: t2, u_velocity: i2, u_velocity_res: o2, u_max_speed: r2, u_speed_factor: a2, u_reset_rate: n2, u_rand_seed: Math.random(), u_uv_offset: s2, u_data_scale: [255 * l2[0], 255 * l2[1]], u_data_offset: c2, u_particle_pos_scale: 1.1, u_particle_pos_offset: [io, io] }), no = e.ae.create(), so = (t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2, m2, g2, v2) => {
          const x2 = a2.transform, y2 = { u_is_size_zoom_constant: +("constant" === t2 || "source" === t2), u_is_size_feature_constant: +("constant" === t2 || "camera" === t2), u_size_t: i2 ? i2.uSizeT : 0, u_size: i2 ? i2.uSize : 0, u_camera_to_center_distance: x2.getCameraToCenterDistance(m2), u_rotate_symbol: +o2, u_aspect_ratio: x2.width / x2.height, u_fade_change: a2.options.fadeDuration ? a2.symbolFadeChange : 1, u_matrix: n2, u_label_plane_matrix: s2, u_coord_matrix: l2, u_is_text: +c2, u_pitch_with_map: +r2, u_texsize: h2, u_texture: 0, u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_inv_rot_matrix: no, u_merc_center: [0, 0], u_camera_forward: [0, 0, 0], u_ecef_origin: [0, 0, 0], u_tile_matrix: no, u_up_vector: [0, -1, 0], u_color_adj_mat: g2, u_icon_transition: v2 || 0 };
          return "globe" === m2.name && (y2.u_tile_id = [_2.canonical.x, _2.canonical.y, 1 << _2.canonical.z], y2.u_zoom_transition = u2, y2.u_inv_rot_matrix = p2, y2.u_merc_center = d2, y2.u_camera_forward = x2._camera.forward(), y2.u_ecef_origin = e.bJ(x2.globeMatrix, _2.toUnwrapped()), y2.u_tile_matrix = Float32Array.from(x2.globeMatrix), y2.u_up_vector = f2), y2;
        }, lo = (t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2, m2, g2) => e.Q(so(t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, u2, d2, p2, f2, m2, g2), { u_gamma_scale: r2 ? a2.transform.getCameraToCenterDistance(g2) * Math.cos(a2.terrain ? 0 : a2.transform._pitch) : 1, u_device_pixel_ratio: e.e.devicePixelRatio, u_is_halo: +_2, undefined: void 0 }), co = (t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2, m2) => e.Q(lo(t2, i2, o2, r2, a2, n2, s2, l2, true, c2, true, _2, u2, d2, p2, f2, m2), { u_texsize_icon: h2, u_texture_icon: 1 }), ho = (e2, t2, i2, o2) => ({ u_matrix: e2, u_emissive_strength: t2, u_opacity: i2, u_color: o2 }), _o = (t2, i2, o2, r2, a2, n2, s2, l2) => e.Q(function(t3, i3, o3, r3, a3) {
          const { width: n3, height: s3 } = r3.imageManager.getPixelSize(i3), l3 = Math.pow(2, a3.tileID.overscaledZ), c2 = a3.tileSize * Math.pow(2, r3.transform.tileZoom) / l3, h2 = c2 * (a3.tileID.canonical.x + a3.tileID.wrap * l3), _2 = c2 * a3.tileID.canonical.y;
          return { u_image: 0, u_pattern_tl: o3.tl, u_pattern_br: o3.br, u_texsize: [n3, s3], u_pattern_size: o3.displaySize, u_tile_units_to_pixels: 1 / e.bD(a3, 1, r3.transform.tileZoom), u_pixel_coord_upper: [h2 >> 16, _2 >> 16], u_pixel_coord_lower: [65535 & h2, 65535 & _2] };
        }(0, n2, s2, r2, l2), { u_matrix: t2, u_emissive_strength: i2, u_opacity: o2 }), uo = new Float32Array(e.ae.identity([])), po = (t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2 = [0, 0, 0], f2) => {
          const m2 = a2.style.light, g2 = m2.properties.get("position"), v2 = [-g2.x, -g2.y, g2.z], x2 = e.bE.create();
          "viewport" === m2.properties.get("anchor") && (e.bE.fromRotation(x2, -a2.transform.angle), e.$.transformMat3(v2, v2, x2));
          const y2 = "MASK" === _2.alphaMode, b2 = m2.properties.get("color").toRenderColor(null), w2 = d2.paint.get("model-ambient-occlusion-intensity"), T2 = d2.paint.get("model-color").constantOr(e.C.white).toRenderColor(null), E2 = d2.paint.get("model-color-mix-intensity").constantOr(0);
          return { u_matrix: t2, u_lighting_matrix: i2, u_normal_matrix: o2, u_node_matrix: r2 || uo, u_lightpos: v2, u_lightintensity: m2.properties.get("intensity"), u_lightcolor: [b2.r, b2.g, b2.b], u_camera_pos: p2, u_opacity: n2, u_baseTextureIsAlpha: 0, u_alphaMask: +y2, u_alphaCutoff: _2.alphaCutoff, u_baseColorFactor: [s2.r, s2.g, s2.b, s2.a], u_emissiveFactor: [l2[0], l2[1], l2[2], 1], u_metallicFactor: c2, u_roughnessFactor: h2, u_baseColorTexture: _i.BaseColor, u_metallicRoughnessTexture: _i.MetallicRoughness, u_normalTexture: _i.Normal, u_occlusionTexture: _i.Occlusion, u_emissionTexture: _i.Emission, u_lutTexture: _i.LUT, u_color_mix: [T2.r, T2.g, T2.b, E2], u_aoIntensity: w2, u_emissive_strength: u2, u_occlusionTextureTransform: f2 || [0, 0, 0, 0] };
        }, fo = (e2, t2 = uo, i2 = uo) => ({ u_matrix: e2, u_instance: t2, u_node_matrix: i2 }), mo = { fillExtrusion: (t2) => ({ u_matrix: new e.a7(t2), u_lightpos: new e.ar(t2), u_lightintensity: new e.ab(t2), u_lightcolor: new e.ar(t2), u_vertical_gradient: new e.ab(t2), u_opacity: new e.ab(t2), u_edge_radius: new e.ab(t2), u_alignment: new e.ab(t2), u_width_scale: new e.ab(t2), u_ao: new e.a9(t2), u_tile_id: new e.ar(t2), u_zoom_transition: new e.ab(t2), u_inv_rot_matrix: new e.a7(t2), u_merc_center: new e.a9(t2), u_up_dir: new e.ar(t2), u_height_lift: new e.ab(t2), u_flood_light_color: new e.ar(t2), u_vertical_scale: new e.ab(t2), u_flood_light_intensity: new e.ab(t2), u_ground_shadow_factor: new e.ar(t2), u_emissive_strength: new e.ab(t2) }), fillExtrusionDepth: (t2) => ({ u_matrix: new e.a7(t2), u_edge_radius: new e.ab(t2), u_alignment: new e.ab(t2), u_width_scale: new e.ab(t2), u_vertical_scale: new e.ab(t2) }), fillExtrusionPattern: (t2) => ({ u_matrix: new e.a7(t2), u_lightpos: new e.ar(t2), u_lightintensity: new e.ab(t2), u_lightcolor: new e.ar(t2), u_vertical_gradient: new e.ab(t2), u_height_factor: new e.ab(t2), u_edge_radius: new e.ab(t2), u_alignment: new e.ab(t2), u_width_scale: new e.ab(t2), u_ao: new e.a9(t2), u_tile_id: new e.ar(t2), u_zoom_transition: new e.ab(t2), u_inv_rot_matrix: new e.a7(t2), u_merc_center: new e.a9(t2), u_up_dir: new e.ar(t2), u_height_lift: new e.ab(t2), u_image: new e.a8(t2), u_texsize: new e.a9(t2), u_pixel_coord_upper: new e.a9(t2), u_pixel_coord_lower: new e.a9(t2), u_tile_units_to_pixels: new e.ab(t2), u_opacity: new e.ab(t2) }), fillExtrusionGroundEffect: (t2) => ({ u_matrix: new e.a7(t2), u_opacity: new e.ab(t2), u_ao_pass: new e.ab(t2), u_meter_to_tile: new e.ab(t2), u_ao: new e.a9(t2), u_flood_light_intensity: new e.ab(t2), u_flood_light_color: new e.ar(t2), u_attenuation: new e.ab(t2), u_edge_radius: new e.ab(t2), u_fb: new e.a8(t2), u_fb_size: new e.ab(t2) }), fill: (t2) => ({ u_matrix: new e.a7(t2), u_emissive_strength: new e.ab(t2) }), fillPattern: (t2) => ({ u_matrix: new e.a7(t2), u_emissive_strength: new e.ab(t2), u_image: new e.a8(t2), u_texsize: new e.a9(t2), u_pixel_coord_upper: new e.a9(t2), u_pixel_coord_lower: new e.a9(t2), u_tile_units_to_pixels: new e.ab(t2) }), fillOutline: (t2) => ({ u_matrix: new e.a7(t2), u_emissive_strength: new e.ab(t2), u_world: new e.a9(t2) }), fillOutlinePattern: (t2) => ({ u_matrix: new e.a7(t2), u_emissive_strength: new e.ab(t2), u_world: new e.a9(t2), u_image: new e.a8(t2), u_texsize: new e.a9(t2), u_pixel_coord_upper: new e.a9(t2), u_pixel_coord_lower: new e.a9(t2), u_tile_units_to_pixels: new e.ab(t2) }), circle: e.bK, collisionBox: (t2) => ({ u_matrix: new e.a7(t2), u_camera_to_center_distance: new e.ab(t2), u_extrude_scale: new e.a9(t2) }), collisionCircle: (t2) => ({ u_matrix: new e.a7(t2), u_inv_matrix: new e.a7(t2), u_camera_to_center_distance: new e.ab(t2), u_viewport_size: new e.a9(t2) }), debug: (t2) => ({ u_color: new e.aa(t2), u_matrix: new e.a7(t2), u_overlay: new e.a8(t2), u_overlay_scale: new e.ab(t2) }), clippingMask: (t2) => ({ u_matrix: new e.a7(t2) }), heatmap: (t2) => ({ u_extrude_scale: new e.ab(t2), u_intensity: new e.ab(t2), u_matrix: new e.a7(t2), u_inv_rot_matrix: new e.a7(t2), u_merc_center: new e.a9(t2), u_tile_id: new e.ar(t2), u_zoom_transition: new e.ab(t2), u_up_dir: new e.ar(t2) }), heatmapTexture: (t2) => ({ u_image: new e.a8(t2), u_color_ramp: new e.a8(t2), u_opacity: new e.ab(t2) }), hillshade: (t2) => ({ u_matrix: new e.a7(t2), u_image: new e.a8(t2), u_latrange: new e.a9(t2), u_light: new e.a9(t2), u_shadow: new e.aa(t2), u_highlight: new e.aa(t2), u_emissive_strength: new e.ab(t2), u_accent: new e.aa(t2) }), hillshadePrepare: (t2) => ({ u_matrix: new e.a7(t2), u_image: new e.a8(t2), u_dimension: new e.a9(t2), u_zoom: new e.ab(t2) }), line: e.bL, linePattern: e.bM, raster: (t2) => ({ u_matrix: new e.a7(t2), u_normalize_matrix: new e.a7(t2), u_globe_matrix: new e.a7(t2), u_merc_matrix: new e.a7(t2), u_grid_matrix: new e.as(t2), u_tl_parent: new e.a9(t2), u_scale_parent: new e.ab(t2), u_fade_t: new e.ab(t2), u_opacity: new e.ab(t2), u_image0: new e.a8(t2), u_image1: new e.a8(t2), u_brightness_low: new e.ab(t2), u_brightness_high: new e.ab(t2), u_saturation_factor: new e.ab(t2), u_contrast_factor: new e.ab(t2), u_spin_weights: new e.ar(t2), u_perspective_transform: new e.a9(t2), u_raster_elevation: new e.ab(t2), u_zoom_transition: new e.ab(t2), u_merc_center: new e.a9(t2), u_cutoff_params: new e.at(t2), u_colorization_mix: new e.at(t2), u_colorization_offset: new e.ab(t2), u_color_ramp: new e.a8(t2), u_texture_offset: new e.a9(t2), u_texture_res: new e.a9(t2), u_emissive_strength: new e.ab(t2) }), rasterParticle: (t2) => ({ u_matrix: new e.a7(t2), u_normalize_matrix: new e.a7(t2), u_globe_matrix: new e.a7(t2), u_merc_matrix: new e.a7(t2), u_grid_matrix: new e.as(t2), u_tl_parent: new e.a9(t2), u_scale_parent: new e.ab(t2), u_fade_t: new e.ab(t2), u_opacity: new e.ab(t2), u_image0: new e.a8(t2), u_image1: new e.a8(t2), u_raster_elevation: new e.ab(t2), u_zoom_transition: new e.ab(t2), u_merc_center: new e.a9(t2), u_cutoff_params: new e.at(t2) }), rasterParticleTexture: (t2) => ({ u_texture: new e.a8(t2), u_opacity: new e.ab(t2) }), rasterParticleDraw: (t2) => ({ u_particle_texture: new e.a8(t2), u_particle_texture_side_len: new e.ab(t2), u_tile_offset: new e.a9(t2), u_velocity: new e.a8(t2), u_color_ramp: new e.a8(t2), u_velocity_res: new e.a9(t2), u_max_speed: new e.ab(t2), u_uv_offset: new e.a9(t2), u_data_scale: new e.a9(t2), u_data_offset: new e.ab(t2), u_particle_pos_scale: new e.ab(t2), u_particle_pos_offset: new e.a9(t2) }), rasterParticleUpdate: (t2) => ({ u_particle_texture: new e.a8(t2), u_particle_texture_side_len: new e.ab(t2), u_velocity: new e.a8(t2), u_velocity_res: new e.a9(t2), u_max_speed: new e.ab(t2), u_speed_factor: new e.ab(t2), u_reset_rate: new e.ab(t2), u_rand_seed: new e.ab(t2), u_uv_offset: new e.a9(t2), u_data_scale: new e.a9(t2), u_data_offset: new e.ab(t2), u_particle_pos_scale: new e.ab(t2), u_particle_pos_offset: new e.a9(t2) }), symbolIcon: (t2) => ({ u_is_size_zoom_constant: new e.a8(t2), u_is_size_feature_constant: new e.a8(t2), u_size_t: new e.ab(t2), u_size: new e.ab(t2), u_camera_to_center_distance: new e.ab(t2), u_rotate_symbol: new e.a8(t2), u_aspect_ratio: new e.ab(t2), u_fade_change: new e.ab(t2), u_matrix: new e.a7(t2), u_label_plane_matrix: new e.a7(t2), u_coord_matrix: new e.a7(t2), u_is_text: new e.a8(t2), u_pitch_with_map: new e.a8(t2), u_texsize: new e.a9(t2), u_tile_id: new e.ar(t2), u_zoom_transition: new e.ab(t2), u_inv_rot_matrix: new e.a7(t2), u_merc_center: new e.a9(t2), u_camera_forward: new e.ar(t2), u_tile_matrix: new e.a7(t2), u_up_vector: new e.ar(t2), u_ecef_origin: new e.ar(t2), u_texture: new e.a8(t2), u_icon_transition: new e.ab(t2), u_color_adj_mat: new e.a7(t2) }), symbolSDF: (t2) => ({ u_is_size_zoom_constant: new e.a8(t2), u_is_size_feature_constant: new e.a8(t2), u_size_t: new e.ab(t2), u_size: new e.ab(t2), u_camera_to_center_distance: new e.ab(t2), u_rotate_symbol: new e.a8(t2), u_aspect_ratio: new e.ab(t2), u_fade_change: new e.ab(t2), u_matrix: new e.a7(t2), u_label_plane_matrix: new e.a7(t2), u_coord_matrix: new e.a7(t2), u_is_text: new e.a8(t2), u_pitch_with_map: new e.a8(t2), u_texsize: new e.a9(t2), u_texture: new e.a8(t2), u_gamma_scale: new e.ab(t2), u_device_pixel_ratio: new e.ab(t2), u_tile_id: new e.ar(t2), u_zoom_transition: new e.ab(t2), u_inv_rot_matrix: new e.a7(t2), u_merc_center: new e.a9(t2), u_camera_forward: new e.ar(t2), u_tile_matrix: new e.a7(t2), u_up_vector: new e.ar(t2), u_ecef_origin: new e.ar(t2), u_is_halo: new e.a8(t2) }), symbolTextAndIcon: (t2) => ({ u_is_size_zoom_constant: new e.a8(t2), u_is_size_feature_constant: new e.a8(t2), u_size_t: new e.ab(t2), u_size: new e.ab(t2), u_camera_to_center_distance: new e.ab(t2), u_rotate_symbol: new e.a8(t2), u_aspect_ratio: new e.ab(t2), u_fade_change: new e.ab(t2), u_matrix: new e.a7(t2), u_label_plane_matrix: new e.a7(t2), u_coord_matrix: new e.a7(t2), u_is_text: new e.a8(t2), u_pitch_with_map: new e.a8(t2), u_texsize: new e.a9(t2), u_texsize_icon: new e.a9(t2), u_texture: new e.a8(t2), u_texture_icon: new e.a8(t2), u_gamma_scale: new e.ab(t2), u_device_pixel_ratio: new e.ab(t2), u_is_halo: new e.a8(t2) }), background: (t2) => ({ u_matrix: new e.a7(t2), u_emissive_strength: new e.ab(t2), u_opacity: new e.ab(t2), u_color: new e.aa(t2) }), backgroundPattern: (t2) => ({ u_matrix: new e.a7(t2), u_emissive_strength: new e.ab(t2), u_opacity: new e.ab(t2), u_image: new e.a8(t2), u_pattern_tl: new e.a9(t2), u_pattern_br: new e.a9(t2), u_texsize: new e.a9(t2), u_pattern_size: new e.a9(t2), u_pixel_coord_upper: new e.a9(t2), u_pixel_coord_lower: new e.a9(t2), u_tile_units_to_pixels: new e.ab(t2) }), terrainRaster: (t2) => ({ u_matrix: new e.a7(t2), u_image0: new e.a8(t2), u_skirt_height: new e.ab(t2), u_ground_shadow_factor: new e.ar(t2) }), skybox: (t2) => ({ u_matrix: new e.a7(t2), u_sun_direction: new e.ar(t2), u_cubemap: new e.a8(t2), u_opacity: new e.ab(t2), u_temporal_offset: new e.ab(t2) }), skyboxGradient: (t2) => ({ u_matrix: new e.a7(t2), u_color_ramp: new e.a8(t2), u_center_direction: new e.ar(t2), u_radius: new e.ab(t2), u_opacity: new e.ab(t2), u_temporal_offset: new e.ab(t2) }), skyboxCapture: (t2) => ({ u_matrix_3f: new e.as(t2), u_sun_direction: new e.ar(t2), u_sun_intensity: new e.ab(t2), u_color_tint_r: new e.at(t2), u_color_tint_m: new e.at(t2), u_luminance: new e.ab(t2) }), globeRaster: (t2) => ({ u_proj_matrix: new e.a7(t2), u_globe_matrix: new e.a7(t2), u_normalize_matrix: new e.a7(t2), u_merc_matrix: new e.a7(t2), u_zoom_transition: new e.ab(t2), u_merc_center: new e.a9(t2), u_image0: new e.a8(t2), u_grid_matrix: new e.as(t2), u_skirt_height: new e.ab(t2), u_far_z_cutoff: new e.ab(t2), u_frustum_tl: new e.ar(t2), u_frustum_tr: new e.ar(t2), u_frustum_br: new e.ar(t2), u_frustum_bl: new e.ar(t2), u_globe_pos: new e.ar(t2), u_globe_radius: new e.ab(t2), u_viewport: new e.a9(t2) }), globeAtmosphere: (t2) => ({ u_frustum_tl: new e.ar(t2), u_frustum_tr: new e.ar(t2), u_frustum_br: new e.ar(t2), u_frustum_bl: new e.ar(t2), u_horizon: new e.ab(t2), u_transition: new e.ab(t2), u_fadeout_range: new e.ab(t2), u_color: new e.at(t2), u_high_color: new e.at(t2), u_space_color: new e.at(t2), u_temporal_offset: new e.ab(t2), u_horizon_angle: new e.ab(t2) }), model: (t2) => ({ u_matrix: new e.a7(t2), u_lighting_matrix: new e.a7(t2), u_normal_matrix: new e.a7(t2), u_node_matrix: new e.a7(t2), u_lightpos: new e.ar(t2), u_lightintensity: new e.ab(t2), u_lightcolor: new e.ar(t2), u_camera_pos: new e.ar(t2), u_opacity: new e.ab(t2), u_baseColorFactor: new e.at(t2), u_emissiveFactor: new e.at(t2), u_metallicFactor: new e.ab(t2), u_roughnessFactor: new e.ab(t2), u_baseTextureIsAlpha: new e.a8(t2), u_alphaMask: new e.a8(t2), u_alphaCutoff: new e.ab(t2), u_baseColorTexture: new e.a8(t2), u_metallicRoughnessTexture: new e.a8(t2), u_normalTexture: new e.a8(t2), u_occlusionTexture: new e.a8(t2), u_emissionTexture: new e.a8(t2), u_lutTexture: new e.a8(t2), u_color_mix: new e.at(t2), u_aoIntensity: new e.ab(t2), u_emissive_strength: new e.ab(t2), u_occlusionTextureTransform: new e.at(t2) }), modelDepth: (t2) => ({ u_matrix: new e.a7(t2), u_instance: new e.a7(t2), u_node_matrix: new e.a7(t2) }), groundShadow: (t2) => ({ u_matrix: new e.a7(t2), u_ground_shadow_factor: new e.ar(t2) }), stars: (t2) => ({ u_matrix: new e.a7(t2), u_up: new e.ar(t2), u_right: new e.ar(t2), u_intensity_multiplier: new e.ab(t2) }), occlusion: (t2) => ({ u_matrix: new e.a7(t2), u_anchorPos: new e.ar(t2), u_screenSizePx: new e.a9(t2), u_occluderSizePx: new e.a9(t2), u_color: new e.at(t2) }) };
        function go(t2, i2, o2) {
          const r2 = i2.createTileMatrix(t2, t2.worldSize, o2.toUnwrapped());
          return e.ae.multiply(new Float32Array(16), t2.projMatrix, r2);
        }
        function vo(e2, t2, i2) {
          if (t2.projection.name === i2.projection.name)
            return e2.projMatrix;
          const o2 = i2.clone();
          return o2.setProjection(t2.projection), go(o2, t2.getProjection(), e2);
        }
        function xo(e2, t2, i2) {
          return t2.name === i2.projection.name ? e2.projMatrix : go(i2, t2, e2);
        }
        let yo;
        function bo(t2, i2, o2, r2, a2, n2, s2) {
          const l2 = t2.context, c2 = l2.gl, h2 = t2.transform, _2 = t2.getOrCreateProgram("collisionBox"), u2 = [];
          let d2 = 0, p2 = 0;
          for (let l3 = 0; l3 < r2.length; l3++) {
            const f3 = r2[l3], m3 = i2.getTile(f3), g3 = m3.getBucket(o2);
            if (!g3)
              continue;
            const v3 = vo(f3, g3, h2);
            let x3 = v3;
            0 === a2[0] && 0 === a2[1] || (x3 = t2.translatePosMatrix(v3, m3, a2, n2));
            const y3 = s2 ? g3.textCollisionBox : g3.iconCollisionBox, b2 = g3.collisionCircleArray;
            if (b2.length > 0) {
              const t3 = e.ae.create(), i3 = x3;
              e.ae.mul(t3, g3.placementInvProjMatrix, h2.glCoordMatrix), e.ae.mul(t3, t3, g3.placementViewportMatrix), u2.push({ circleArray: b2, circleOffset: p2, transform: i3, invTransform: t3, projection: g3.getProjection() }), d2 += b2.length / 4, p2 = d2;
            }
            y3 && (t2.terrain && t2.terrain.setupElevationDraw(m3, _2), _2.draw(t2, c2.LINES, e.af.disabled, e.ah.disabled, t2.colorModeForRenderPass(), e.ag.disabled, qi(x3, h2, m3, g3.getProjection()), o2.id, y3.layoutVertexBuffer, y3.indexBuffer, y3.segments, null, h2.zoom, null, [y3.collisionVertexBuffer, y3.collisionVertexBufferExt]));
          }
          if (!s2 || !u2.length)
            return;
          const f2 = t2.getOrCreateProgram("collisionCircle"), m2 = new e.bN();
          m2.resize(4 * d2), m2._trim();
          let g2 = 0;
          for (const e2 of u2)
            for (let t3 = 0; t3 < e2.circleArray.length / 4; t3++) {
              const i3 = 4 * t3, o3 = e2.circleArray[i3 + 0], r3 = e2.circleArray[i3 + 1], a3 = e2.circleArray[i3 + 2], n3 = e2.circleArray[i3 + 3];
              m2.emplace(g2++, o3, r3, a3, n3, 0), m2.emplace(g2++, o3, r3, a3, n3, 1), m2.emplace(g2++, o3, r3, a3, n3, 2), m2.emplace(g2++, o3, r3, a3, n3, 3);
            }
          (!yo || yo.length < 2 * d2) && (yo = function(t3) {
            const i3 = 2 * t3, o3 = new e.bw();
            o3.resize(i3), o3._trim();
            for (let e2 = 0; e2 < i3; e2++) {
              const t4 = 6 * e2;
              o3.uint16[t4 + 0] = 4 * e2 + 0, o3.uint16[t4 + 1] = 4 * e2 + 1, o3.uint16[t4 + 2] = 4 * e2 + 2, o3.uint16[t4 + 3] = 4 * e2 + 2, o3.uint16[t4 + 4] = 4 * e2 + 3, o3.uint16[t4 + 5] = 4 * e2 + 0;
            }
            return o3;
          }(d2));
          const v2 = l2.createIndexBuffer(yo, true), x2 = l2.createVertexBuffer(m2, e.bO.members, true);
          for (const i3 of u2) {
            const r3 = { u_matrix: i3.transform, u_inv_matrix: i3.invTransform, u_camera_to_center_distance: (y2 = h2).getCameraToCenterDistance(i3.projection), u_viewport_size: [y2.width, y2.height] };
            f2.draw(t2, c2.TRIANGLES, e.af.disabled, e.ah.disabled, t2.colorModeForRenderPass(), e.ag.disabled, r3, o2.id, x2, v2, e.b.simpleSegment(0, 2 * i3.circleOffset, i3.circleArray.length, i3.circleArray.length / 2), null, h2.zoom);
          }
          var y2;
          x2.destroy(), v2.destroy();
        }
        const wo = e.ae.create();
        function To(t2) {
          const i2 = t2._camera.getWorldToCamera(t2.worldSize, 1), o2 = e.ae.multiply([], i2, t2.globeMatrix);
          e.ae.invert(o2, o2);
          const r2 = [0, 0, 0], a2 = [0, 1, 0, 0];
          return e.aB.transformMat4(a2, a2, o2), r2[0] = a2[0], r2[1] = a2[1], r2[2] = a2[2], e.$.normalize(r2, r2), r2;
        }
        function Eo({ width: t2, height: i2, anchor: o2, textOffset: r2, textScale: a2 }, n2) {
          const { horizontalAlign: s2, verticalAlign: l2 } = e.bS(o2), c2 = -(s2 - 0.5) * t2, h2 = -(l2 - 0.5) * i2, _2 = e.bR(o2, r2);
          return new e.P((c2 / a2 + _2[0]) * n2, (h2 / a2 + _2[1]) * n2);
        }
        function Co(t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2) {
          const u2 = t2.text.placedSymbolArray, d2 = t2.text.dynamicLayoutVertexArray, p2 = t2.icon.dynamicLayoutVertexArray, f2 = {}, m2 = t2.getProjection(), g2 = xo(l2, m2, n2), v2 = n2.elevation, x2 = m2.upVectorScale(l2.canonical, n2.center.lat, n2.worldSize).metersToTile;
          d2.clear();
          for (let p3 = 0; p3 < u2.length; p3++) {
            const y2 = u2.get(p3), { tileAnchorX: b2, tileAnchorY: w2, numGlyphs: T2 } = y2, E2 = y2.hidden || !y2.crossTileID || t2.allowVerticalPlacement && !y2.placedOrientation ? null : r2[y2.crossTileID];
            if (E2) {
              let r3 = 0, u3 = 0, p4 = 0;
              if (v2) {
                const e2 = v2 ? v2.getAtTileOffset(l2, b2, w2) : 0, [t3, i3, o3] = m2.upVector(l2.canonical, b2, w2);
                r3 = e2 * t3 * x2, u3 = e2 * i3 * x2, p4 = e2 * o3 * x2;
              }
              let [C2, S2, I2, L2] = Qt(y2.projectedAnchorX + r3, y2.projectedAnchorY + u3, y2.projectedAnchorZ + p4, o2 ? g2 : s2);
              const P2 = Yt(n2.getCameraToCenterDistance(m2), L2);
              let R2 = a2.evaluateSizeForFeature(t2.textSizeData, h2, y2) * P2 / e.bP;
              o2 && (R2 *= t2.tilePixelRatio / c2);
              const D2 = Eo(E2, R2);
              o2 ? ({ x: C2, y: S2, z: I2 } = m2.projectTilePoint(b2 + D2.x, w2 + D2.y, l2.canonical), [C2, S2, I2] = Qt(C2 + r3, S2 + u3, I2 + p4, s2)) : (i2 && D2._rotate(-n2.angle), C2 += D2.x, S2 += D2.y, I2 = 0);
              const A2 = t2.allowVerticalPlacement && y2.placedOrientation === e.aF.vertical ? Math.PI / 2 : 0;
              for (let t3 = 0; t3 < T2; t3++)
                e.aI(d2, C2, S2, I2, A2);
              _2 && y2.associatedIconIndex >= 0 && (f2[y2.associatedIconIndex] = { x: C2, y: S2, z: I2, angle: A2 });
            } else
              ni(T2, d2);
          }
          if (_2) {
            p2.clear();
            const i3 = t2.icon.placedSymbolArray;
            for (let t3 = 0; t3 < i3.length; t3++) {
              const o3 = i3.get(t3), { numGlyphs: r3 } = o3, a3 = f2[t3];
              if (o3.hidden || !a3)
                ni(r3, p2);
              else {
                const { x: t4, y: i4, z: o4, angle: n3 } = a3;
                for (let a4 = 0; a4 < r3; a4++)
                  e.aI(p2, t4, i4, o4, n3);
              }
            }
            t2.icon.dynamicLayoutVertexBuffer.updateData(p2);
          }
          t2.text.dynamicLayoutVertexBuffer.updateData(d2);
        }
        function So(t2, i2, o2, r2, a2, n2, s2 = {}) {
          const l2 = o2.paint.get("icon-translate"), c2 = o2.paint.get("text-translate"), h2 = o2.paint.get("icon-translate-anchor"), _2 = o2.paint.get("text-translate-anchor"), u2 = o2.layout.get("icon-rotation-alignment"), d2 = o2.layout.get("text-rotation-alignment"), p2 = o2.layout.get("icon-pitch-alignment"), f2 = o2.layout.get("text-pitch-alignment"), m2 = o2.layout.get("icon-keep-upright"), g2 = o2.layout.get("text-keep-upright"), v2 = o2.paint.get("icon-color-saturation"), x2 = o2.paint.get("icon-color-contrast"), y2 = o2.paint.get("icon-color-brightness-min"), b2 = o2.paint.get("icon-color-brightness-max");
          o2.paint.get("icon-occlusion-opacity").constantOr(0), o2.paint.get("text-occlusion-opacity").constantOr(0);
          const w2 = t2.context, T2 = w2.gl, E2 = t2.transform, C2 = "map" === u2, S2 = "map" === d2, I2 = "map" === p2, L2 = "map" === f2, P2 = void 0 !== o2.layout.get("symbol-sort-key").constantOr(1);
          let R2 = false;
          const D2 = t2.depthModeForSublayer(0, e.af.ReadOnly), A2 = [e.ak(E2.center.lng), e.al(E2.center.lat)], M2 = o2.layout.get("text-variable-anchor"), z2 = "globe" === E2.projection.name, O2 = [], F2 = [0, -1, 0];
          for (const a3 of r2) {
            const r3 = i2.getTile(a3), n3 = r3.getBucket(o2);
            if (!n3)
              continue;
            if ("mercator" === n3.projection.name && z2)
              continue;
            if (n3.fullyClipped)
              continue;
            const u3 = "globe" === n3.projection.name, d3 = u3 ? e.a2(E2.zoom) : 0, p3 = xo(a3, n3.getProjection(), E2), f3 = E2.calculatePixelsToTileUnitsMatrix(r3), w3 = M2 && n3.hasTextData(), D3 = n3.hasIconTextFit() && w3 && n3.hasIconData(), B2 = n3.getProjection().createInversionMatrix(E2, a3.canonical), k2 = (e2) => {
              E2.depthOcclusionForSymbolsAndCircles && (o2.hasInitialOcclusionOpacityProperties || t2.terrain) && (e2.push("DEPTH_D24"), e2.push("DEPTH_OCCLUSION"));
            }, N2 = () => {
              const i3 = C2 && "point" !== o2.layout.get("symbol-placement"), s3 = [];
              k2(s3);
              const c3 = i3 || D3, _3 = o2.paint.get("icon-image-cross-fade").constantOr(0);
              t2.terrainRenderModeElevated() && I2 && s3.push("PITCH_WITH_MAP_TERRAIN"), u3 && (s3.push("PROJECTION_GLOBE_VIEW"), c3 && s3.push("PROJECTED_POS_ON_VIEWPORT")), _3 > 0 && s3.push("ICON_TRANSITION"), n3.icon.zOffsetVertexBuffer && s3.push("Z_OFFSET"), 0 === v2 && 0 === x2 && 0 === y2 && 1 === b2 || s3.push("COLOR_ADJUSTMENT");
              const g3 = n3.icon.programConfigurations.get(o2.id), w4 = t2.getOrCreateProgram(n3.sdfIcons ? "symbolSDF" : "symbolIcon", { config: g3, defines: s3 });
              let S3;
              const L3 = r3.imageAtlasTexture ? r3.imageAtlasTexture.size : [0, 0], P3 = n3.iconSizeData, R3 = e.aE(P3, E2.zoom), M3 = I2 || 0 !== E2.pitch, O3 = Ht(p3, r3.tileID.canonical, I2, C2, E2, n3.getProjection(), f3), N3 = Xt(p3, r3.tileID.canonical, I2, C2, E2, n3.getProjection(), f3), U3 = t2.translatePosMatrix(N3, r3, l2, h2, true), G3 = t2.translatePosMatrix(p3, r3, l2, h2), j3 = c3 ? wo : O3, V3 = C2 && !I2 && !i3;
              let $3 = F2;
              !z2 && !E2.mercatorFromTransition || C2 || ($3 = To(E2));
              const Z3 = u3 ? $3 : F2;
              if (n3.sdfIcons && !n3.iconsInText)
                S3 = lo(P3.kind, R3, V3, I2, t2, G3, j3, U3, false, L3, true, a3, d3, A2, B2, Z3, n3.getProjection());
              else {
                const e2 = o2.getColorAdjustmentMatrix(v2, x2, y2, b2);
                S3 = so(P3.kind, R3, V3, I2, t2, G3, j3, U3, false, L3, a3, d3, A2, B2, Z3, n3.getProjection(), e2, _3);
              }
              const W3 = r3.imageAtlasTexture ? r3.imageAtlasTexture : null, H2 = 1 !== o2.layout.get("icon-size").constantOr(0) || n3.iconsNeedLinear, q2 = n3.sdfIcons || t2.options.rotating || t2.options.zooming || H2 || M3 ? T2.LINEAR : T2.NEAREST, X2 = n3.sdfIcons && 0 !== o2.paint.get("icon-halo-width").constantOr(1), Q2 = t2.terrain && I2 && i3 ? e.ae.invert(e.ae.create(), O3) : wo;
              if (i3 && n3.icon) {
                const e2 = E2.elevation, i4 = e2 ? e2.getAtTileOffsetFunc(a3, E2.center.lat, E2.worldSize, n3.getProjection()) : null, o3 = qt(p3, r3.tileID.canonical, I2, C2, E2, n3.getProjection(), f3);
                Kt(n3, p3, t2, false, o3, N3, I2, m2, i4, a3);
              }
              return { program: w4, buffers: n3.icon, uniformValues: S3, atlasTexture: W3, atlasTextureIcon: null, atlasInterpolation: q2, atlasInterpolationIcon: null, isSDF: n3.sdfIcons, hasHalo: X2, tile: r3, labelPlaneMatrixInv: Q2 };
            }, U2 = () => {
              const i3 = S2 && "point" !== o2.layout.get("symbol-placement"), s3 = [], l3 = i3 || M2 || D3;
              t2.terrainRenderModeElevated() && L2 && s3.push("PITCH_WITH_MAP_TERRAIN"), u3 && (s3.push("PROJECTION_GLOBE_VIEW"), l3 && s3.push("PROJECTED_POS_ON_VIEWPORT")), n3.text.zOffsetVertexBuffer && s3.push("Z_OFFSET"), k2(s3);
              const h3 = n3.text.programConfigurations.get(o2.id), m3 = t2.getOrCreateProgram(n3.iconsInText ? "symbolTextAndIcon" : "symbolSDF", { config: h3, defines: s3 });
              let v3, x3 = [0, 0], y3 = null;
              const b3 = n3.textSizeData;
              n3.iconsInText && (x3 = r3.imageAtlasTexture ? r3.imageAtlasTexture.size : [0, 0], y3 = r3.imageAtlasTexture ? r3.imageAtlasTexture : null, v3 = L2 || 0 !== E2.pitch || t2.options.rotating || t2.options.zooming || "composite" === b3.kind || "camera" === b3.kind ? T2.LINEAR : T2.NEAREST);
              const w4 = r3.glyphAtlasTexture ? r3.glyphAtlasTexture.size : [0, 0], C3 = e.aE(b3, E2.zoom), I3 = Ht(p3, r3.tileID.canonical, L2, S2, E2, n3.getProjection(), f3), P3 = Xt(p3, r3.tileID.canonical, L2, S2, E2, n3.getProjection(), f3), R3 = t2.translatePosMatrix(P3, r3, c2, _2, true), O3 = t2.translatePosMatrix(p3, r3, c2, _2), N3 = l3 ? wo : I3, U3 = S2 && !L2 && !i3;
              let G3 = F2;
              !z2 && !E2.mercatorFromTransition || S2 || (G3 = To(E2));
              const j3 = u3 ? G3 : F2;
              let V3;
              V3 = n3.iconsInText ? co(b3.kind, C3, U3, L2, t2, O3, N3, R3, w4, x3, a3, d3, A2, B2, j3, n3.getProjection()) : lo(b3.kind, C3, U3, L2, t2, O3, N3, R3, true, w4, true, a3, d3, A2, B2, j3, n3.getProjection());
              const $3 = r3.glyphAtlasTexture ? r3.glyphAtlasTexture : null, Z3 = T2.LINEAR, W3 = 0 !== o2.paint.get("text-halo-width").constantOr(1), H2 = t2.terrain && L2 && i3 ? e.ae.invert(e.ae.create(), I3) : wo;
              if (i3 && n3.text) {
                const e2 = E2.elevation, i4 = e2 ? e2.getAtTileOffsetFunc(a3, E2.center.lat, E2.worldSize, n3.getProjection()) : null, o3 = qt(p3, r3.tileID.canonical, L2, S2, E2, n3.getProjection(), f3);
                Kt(n3, p3, t2, true, o3, P3, L2, g2, i4, a3);
              }
              return { program: m3, buffers: n3.text, uniformValues: V3, atlasTexture: $3, atlasTextureIcon: y3, atlasInterpolation: Z3, atlasInterpolationIcon: v3, isSDF: true, hasHalo: W3, tile: r3, labelPlaneMatrixInv: H2 };
            }, G2 = n3.icon.segments.get().length, j2 = n3.text.segments.get().length, V2 = G2 && !s2.onlyText ? N2() : null, $2 = j2 && !s2.onlyIcons ? U2() : null, Z2 = o2.paint.get("icon-opacity").constantOr(1), W2 = o2.paint.get("text-opacity").constantOr(1);
            if (P2 && n3.canOverlap) {
              R2 = true;
              const t3 = Z2 && !s2.onlyText ? n3.icon.segments.get() : [], i3 = W2 && !s2.onlyIcons ? n3.text.segments.get() : [];
              for (const i4 of t3)
                O2.push({ segments: new e.b([i4]), sortKey: i4.sortKey, state: V2 });
              for (const t4 of i3)
                O2.push({ segments: new e.b([t4]), sortKey: t4.sortKey, state: $2 });
            } else
              s2.onlyText || O2.push({ segments: Z2 ? n3.icon.segments : new e.b([]), sortKey: 0, state: V2 }), s2.onlyIcons || O2.push({ segments: W2 ? n3.text.segments : new e.b([]), sortKey: 0, state: $2 });
          }
          R2 && O2.sort((e2, t3) => e2.sortKey - t3.sortKey);
          for (const e2 of O2) {
            const i3 = e2.state;
            if (i3)
              if (t2.terrain ? t2.terrain.setupElevationDraw(i3.tile, i3.program, { useDepthForOcclusion: E2.depthOcclusionForSymbolsAndCircles, labelPlaneMatrixInv: i3.labelPlaneMatrixInv }) : t2.setupDepthForOcclusion(E2.depthOcclusionForSymbolsAndCircles, i3.program), w2.activeTexture.set(T2.TEXTURE0), i3.atlasTexture && i3.atlasTexture.bind(i3.atlasInterpolation, T2.CLAMP_TO_EDGE, true), i3.atlasTextureIcon && (w2.activeTexture.set(T2.TEXTURE1), i3.atlasTextureIcon && i3.atlasTextureIcon.bind(i3.atlasInterpolationIcon, T2.CLAMP_TO_EDGE, true)), t2.uploadCommonLightUniforms(t2.context, i3.program), i3.hasHalo) {
                const r3 = i3.uniformValues;
                r3.u_is_halo = 1, Io(i3.buffers, e2.segments, o2, t2, i3.program, D2, a2, n2, r3, 2), r3.u_is_halo = 0;
              } else {
                if (i3.isSDF) {
                  const r3 = i3.uniformValues;
                  i3.hasHalo && (r3.u_is_halo = 1, Io(i3.buffers, e2.segments, o2, t2, i3.program, D2, a2, n2, r3, 1)), r3.u_is_halo = 0;
                }
                Io(i3.buffers, e2.segments, o2, t2, i3.program, D2, a2, n2, i3.uniformValues, 1);
              }
          }
        }
        function Io(t2, i2, o2, r2, a2, n2, s2, l2, c2, h2) {
          const _2 = [t2.dynamicLayoutVertexBuffer, t2.opacityVertexBuffer, t2.iconTransitioningVertexBuffer, t2.globeExtVertexBuffer, t2.zOffsetVertexBuffer];
          a2.draw(r2, r2.context.gl.TRIANGLES, n2, s2, l2, e.ag.disabled, c2, o2.id, t2.layoutVertexBuffer, t2.indexBuffer, i2, o2.paint, r2.transform.zoom, t2.programConfigurations.get(o2.id), _2, h2);
        }
        function Lo(t2, i2, o2, r2, a2, n2, s2) {
          const l2 = t2.context.gl, c2 = o2.paint.get("fill-pattern"), h2 = c2 && c2.constantOr(1);
          let _2, u2, d2, p2, f2;
          s2 ? (u2 = h2 && !o2.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", _2 = l2.LINES) : (u2 = h2 ? "fillPattern" : "fill", _2 = l2.TRIANGLES);
          for (const m2 of r2) {
            const r3 = i2.getTile(m2);
            if (h2 && !r3.patternsLoaded())
              continue;
            const g2 = r3.getBucket(o2);
            if (!g2)
              continue;
            t2.prepareDrawTile();
            const v2 = g2.programConfigurations.get(o2.id), x2 = t2.isTileAffectedByFog(m2), y2 = t2.getOrCreateProgram(u2, { config: v2, overrideFog: x2 });
            h2 && (t2.context.activeTexture.set(l2.TEXTURE0), r3.imageAtlasTexture && r3.imageAtlasTexture.bind(l2.LINEAR, l2.CLAMP_TO_EDGE), v2.updatePaintBuffers());
            const b2 = c2.constantOr(null);
            if (b2 && r3.imageAtlas) {
              const e2 = r3.imageAtlas.patternPositions[b2.toString()];
              e2 && v2.setConstantPatternPositions(e2);
            }
            const w2 = t2.translatePosMatrix(m2.projMatrix, r3, o2.paint.get("fill-translate"), o2.paint.get("fill-translate-anchor")), T2 = o2.paint.get("fill-emissive-strength");
            if (s2) {
              p2 = g2.indexBuffer2, f2 = g2.segments2;
              const e2 = t2.terrain && t2.terrain.renderingToTexture ? t2.terrain.drapeBufferSize : [l2.drawingBufferWidth, l2.drawingBufferHeight];
              d2 = "fillOutlinePattern" === u2 && h2 ? Hi(w2, T2, t2, r3, e2) : Wi(w2, T2, e2);
            } else
              p2 = g2.indexBuffer, f2 = g2.segments, d2 = h2 ? Zi(w2, T2, t2, r3) : $i(w2, T2);
            t2.uploadCommonUniforms(t2.context, y2, m2.toUnwrapped()), y2.draw(t2, _2, a2, t2.stencilModeForClipping(m2), n2, e.ag.disabled, d2, o2.id, g2.layoutVertexBuffer, p2, f2, o2.paint, t2.transform.zoom, v2, void 0);
          }
        }
        function Po(t2, i2, o2, r2, a2, n2, s2, l2) {
          o2.resetLayerRenderingStats(t2);
          const c2 = t2.context, h2 = c2.gl, _2 = t2.transform, u2 = o2.paint.get("fill-extrusion-pattern"), d2 = u2.constantOr(1), p2 = o2.paint.get("fill-extrusion-opacity"), f2 = t2.style.enable3dLights(), m2 = o2.paint.get(f2 && !d2 ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"), g2 = [o2.paint.get("fill-extrusion-ambient-occlusion-intensity"), m2], v2 = o2.layout.get("fill-extrusion-edge-radius"), x2 = v2 > 0 && !o2.paint.get("fill-extrusion-rounded-roof"), y2 = x2 ? 0 : v2, b2 = "globe" === _2.projection.name ? e.b_() : 0, w2 = "globe" === _2.projection.name, T2 = w2 ? e.a2(_2.zoom) : 0, E2 = [e.ak(_2.center.lng), e.al(_2.center.lat)], C2 = o2.paint.get("fill-extrusion-flood-light-color").toRenderColor(o2.lut).toArray01().slice(0, 3), S2 = o2.paint.get("fill-extrusion-flood-light-intensity"), I2 = o2.paint.get("fill-extrusion-vertical-scale"), L2 = 0 !== o2.paint.get("fill-extrusion-line-width").constantOr(1), P2 = ui(t2, o2.paint.get("fill-extrusion-cutoff-fade-range")), R2 = o2.paint.get("fill-extrusion-emissive-strength"), D2 = [];
          w2 && D2.push("PROJECTION_GLOBE_VIEW"), g2[0] > 0 && D2.push("FAUX_AO"), x2 && D2.push("ZERO_ROOF_RADIUS"), l2 && D2.push("HAS_CENTROID"), S2 > 0 && D2.push("FLOOD_LIGHT"), P2.shouldRenderCutoff && D2.push("RENDER_CUTOFF"), L2 && D2.push("RENDER_WALL_MODE");
          const A2 = (() => {
            const t3 = o2.paint.get("fill-extrusion-line-alignment");
            switch (t3) {
              case "inside":
                return 1;
              case "outside":
                return -1;
              case "center":
                return 0;
              default:
                return e.w(`Unsupported value for fill-extrusion-line-alignment: ${t3}`), 0;
            }
          })();
          let M2;
          const z2 = "shadow" === t2.renderPass, O2 = t2.shadowRenderer, F2 = z2 && !!O2;
          t2.shadowRenderer && (t2.shadowRenderer.useNormalOffset = true);
          let B2 = [0, 0, 0];
          if (O2) {
            const e2 = t2.style.directionalLight, i3 = t2.style.ambientLight;
            e2 && i3 && (B2 = xi(t2.style, e2, i3)), M2 = D2.concat(["SHADOWS_SINGLE_CASCADE"]);
          }
          const k2 = F2 ? "fillExtrusionDepth" : d2 ? "fillExtrusionPattern" : "fillExtrusion", N2 = o2.getLayerRenderingStats();
          for (const f3 of r2) {
            const r3 = i2.getTile(f3), m3 = r3.getBucket(o2);
            if (!m3 || m3.projection.name !== _2.projection.name)
              continue;
            let v3 = false;
            O2 && (v3 = 0 === O2.getMaxCascadeForTile(f3.toUnwrapped()));
            const x3 = t2.isTileAffectedByFog(f3), F3 = m3.programConfigurations.get(o2.id), U2 = t2.getOrCreateProgram(k2, { config: F3, defines: v3 ? M2 : D2, overrideFog: x3 });
            if (t2.terrain && t2.terrain.setupElevationDraw(r3, U2, { useMeterToDem: true }), !m3.centroidVertexBuffer) {
              const e2 = U2.attributes.a_centroid_pos;
              void 0 !== e2 && h2.vertexAttrib2f(e2, 0, 0);
            }
            !z2 && O2 && O2.setupShadows(r3.tileID.toUnwrapped(), U2, "vector-tile", r3.tileID.overscaledZ), d2 && (t2.context.activeTexture.set(h2.TEXTURE0), r3.imageAtlasTexture && r3.imageAtlasTexture.bind(h2.LINEAR, h2.CLAMP_TO_EDGE), F3.updatePaintBuffers());
            const G2 = u2.constantOr(null);
            if (G2 && r3.imageAtlas) {
              const e2 = r3.imageAtlas.patternPositions[G2.toString()];
              e2 && F3.setConstantPatternPositions(e2);
            }
            const j2 = o2.paint.get("fill-extrusion-vertical-gradient"), V2 = 1 / m3.tileToMeter;
            let $2;
            if (z2 && O2) {
              if (Oo(r3.tileID, m3, t2))
                continue;
              const e2 = O2.calculateShadowPassMatrixFromTile(r3.tileID.toUnwrapped());
              $2 = ji(e2, y2, A2, V2, I2);
            } else {
              const e2 = t2.translatePosMatrix(f3.expandedProjMatrix, r3, o2.paint.get("fill-extrusion-translate"), o2.paint.get("fill-extrusion-translate-anchor")), i3 = _2.projection.createInversionMatrix(_2, f3.canonical);
              $2 = d2 ? Vi(e2, t2, j2, p2, g2, y2, A2, V2, f3, r3, b2, T2, E2, i3, C2, I2) : Gi(e2, t2, j2, p2, g2, y2, A2, V2, f3, b2, T2, E2, i3, C2, I2, S2, B2, R2);
            }
            t2.uploadCommonUniforms(c2, U2, f3.toUnwrapped(), null, P2);
            let Z2 = m3.segments;
            if ("mercator" === _2.projection.name && !z2 && (Z2 = m3.getVisibleSegments(r3.tileID, t2.terrain, t2.transform.getFrustum(0)), !Z2.get().length))
              continue;
            if (N2)
              if (z2)
                for (const e2 of Z2.get())
                  N2.numRenderedVerticesInShadowPass += e2.primitiveLength;
              else
                for (const e2 of Z2.get())
                  N2.numRenderedVerticesInTransparentPass += e2.primitiveLength;
            const W2 = [];
            (t2.terrain || l2) && W2.push(m3.centroidVertexBuffer), w2 && W2.push(m3.layoutVertexExtBuffer), L2 && W2.push(m3.wallVertexBuffer), U2.draw(t2, c2.gl.TRIANGLES, a2, n2, s2, e.ag.backCCW, $2, o2.id, m3.layoutVertexBuffer, m3.indexBuffer, Z2, o2.paint, t2.transform.zoom, F3, W2);
          }
          t2.shadowRenderer && (t2.shadowRenderer.useNormalOffset = false);
        }
        function Ro(t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2, m2, g2, v2, x2) {
          const y2 = t2.context, b2 = y2.gl, w2 = t2.transform, T2 = t2.transform.zoom, E2 = [], C2 = ui(t2, o2.paint.get("fill-extrusion-cutoff-fade-range"));
          "clear" === h2 ? (E2.push("CLEAR_SUBPASS"), x2 && (E2.push("CLEAR_FROM_TEXTURE"), y2.activeTexture.set(b2.TEXTURE0), x2.bind(b2.LINEAR, b2.CLAMP_TO_EDGE))) : "sdf" === h2 && E2.push("SDF_SUBPASS"), g2 && E2.push("HAS_CENTROID"), C2.shouldRenderCutoff && E2.push("RENDER_CUTOFF");
          const S2 = o2.layout.get("fill-extrusion-edge-radius"), I2 = (e2, i3, r3, h3, v3) => {
            const b3 = i3.programConfigurations.get(o2.id), w3 = t2.isTileAffectedByFog(e2), I3 = t2.getOrCreateProgram("fillExtrusionGroundEffect", { config: b3, defines: E2, overrideFog: w3 }), L2 = ((e3, t3, i4, o3, r4, a3, n3, s3, l3, c3, h4) => ({ u_matrix: t3, u_opacity: i4, u_ao_pass: o3 ? 1 : 0, u_meter_to_tile: r4, u_ao: a3, u_flood_light_intensity: n3, u_flood_light_color: s3, u_attenuation: l3, u_edge_radius: c3, u_fb: 0, u_fb_size: h4 }))(0, h3, _2, c2, v3, [u2, d2 * v3], p2, f2, m2, T2 >= 17 ? 0 : S2 * v3, x2 ? x2.size[0] : 0), P2 = [];
            g2 && P2.push(i3.hiddenByLandmarkVertexBuffer), t2.uploadCommonUniforms(y2, I3, e2.toUnwrapped(), null, C2), I3.draw(t2, y2.gl.TRIANGLES, a2, n2, s2, l2, L2, o2.id, i3.vertexBuffer, i3.indexBuffer, r3, o2.paint, T2, b3, P2);
          };
          for (const a3 of r2) {
            const r3 = i2.getTile(a3), n3 = r3.getBucket(o2);
            if (!n3 || n3.projection.name !== w2.projection.name || !n3.groundEffect || n3.groundEffect && !n3.groundEffect.hasData())
              continue;
            const s3 = n3.groundEffect, l3 = 1 / n3.tileToMeter;
            {
              const e2 = t2.translatePosMatrix(a3.projMatrix, r3, o2.paint.get("fill-extrusion-translate"), o2.paint.get("fill-extrusion-translate-anchor")), i3 = s3.getDefaultSegment();
              I2(a3, s3, i3, e2, l3);
            }
            if (v2)
              for (let n4 = 0; n4 < 4; n4++) {
                const s4 = e.b$[n4](a3), c3 = i2.getTile(s4);
                if (!c3)
                  continue;
                const h3 = c3.getBucket(o2);
                if (!h3 || h3.projection.name !== w2.projection.name || !h3.groundEffect || h3.groundEffect && !h3.groundEffect.hasData())
                  continue;
                const _3 = h3.groundEffect;
                let u3, d3;
                0 === n4 ? (u3 = [-e.a4, 0, 0], d3 = 1) : 1 === n4 ? (u3 = [e.a4, 0, 0], d3 = 0) : 2 === n4 ? (u3 = [0, -e.a4, 0], d3 = 3) : (u3 = [0, e.a4, 0], d3 = 2);
                const p3 = _3.regionSegments[d3];
                if (!p3)
                  continue;
                const f3 = new Float32Array(16);
                e.ae.translate(f3, a3.projMatrix, u3), I2(a3, _3, p3, t2.translatePosMatrix(f3, r3, o2.paint.get("fill-extrusion-translate"), o2.paint.get("fill-extrusion-translate-anchor")), l3);
              }
          }
        }
        function Do(t2, i2, o2, r2, a2, n2, s2) {
          0 === r2.centroidVertexArray.length && r2.createCentroidsBuffer();
          const l2 = n2 ? n2.findDEMTileFor(o2) : null;
          if (!(l2 && l2.dem || s2))
            return;
          const c2 = (t3) => new e.P(Math.ceil((t3 + e.c2) * e.c3), 0), h2 = (e2) => {
            const t3 = i2.getSource().minzoom, o3 = (e3) => {
              const t4 = i2.getTileByID(e3);
              if (t4 && t4.hasData())
                return t4.getBucket(a2);
            }, r3 = [0, -1, 1];
            for (const i3 of r3) {
              if (e2.overscaledZ + i3 < t3)
                continue;
              const r4 = o3(e2.calculateScaledKey(e2.overscaledZ + i3));
              if (r4)
                return r4;
            }
          }, _2 = [0, 0, 0], u2 = (t3, i3) => (_2[0] = Math.min(t3.min.y, i3.min.y), _2[1] = Math.max(t3.max.y, i3.max.y), _2[2] = e.a4 - i3.min.x > t3.max.x ? i3.min.x - e.a4 : t3.max.x, _2), d2 = (t3, i3) => (_2[0] = Math.min(t3.min.x, i3.min.x), _2[1] = Math.max(t3.max.x, i3.max.x), _2[2] = e.a4 - i3.min.y > t3.max.y ? i3.min.y - e.a4 : t3.max.y, _2), p2 = [(e2, t3) => u2(e2, t3), (e2, t3) => u2(t3, e2), (e2, t3) => d2(e2, t3), (e2, t3) => d2(t3, e2)], f2 = (t3, i3, r3, a3, s3, c3, h3) => {
            if (!n2)
              return 0;
            const _3 = [[c3 ? r3 : t3, c3 ? t3 : r3, 0], [c3 ? r3 : i3, c3 ? i3 : r3, 0]], u3 = h3 < 0 ? e.a4 + h3 : h3, d3 = [c3 ? u3 : (t3 + i3) / 2, c3 ? (t3 + i3) / 2 : u3, 0];
            return 0 === r3 && h3 < 0 || 0 !== r3 && h3 > 0 ? n2.getForTilePoints(s3, [d3], true, a3) : _3.push(d3), n2.getForTilePoints(o2, _3, true, l2), Math.max(_3[0][2], _3[1][2], d3[2]) / n2.exaggeration();
          };
          for (let t3 = 0; t3 < 4; t3++) {
            const i3 = r2.borderFeatureIndices[t3];
            if (0 === i3.length)
              continue;
            const a3 = e.b$[t3](o2), l3 = h2(a3);
            if (!(l3 && l3 instanceof e.c0))
              continue;
            if (r2.borderDoneWithNeighborZ[t3] === l3.canonical.z)
              continue;
            0 === l3.centroidVertexArray.length && l3.createCentroidsBuffer();
            const _3 = n2 ? n2.findDEMTileFor(a3) : null;
            if (!(_3 && _3.dem || s2))
              continue;
            const u3 = (t3 < 2 ? 1 : 5) - t3, d3 = l3.borderDoneWithNeighborZ[u3] !== r2.canonical.z, v2 = l3.borderFeatureIndices[u3];
            let x2 = 0;
            if (r2.canonical.z !== l3.canonical.z) {
              for (const e2 of i3)
                r2.showCentroid(r2.featuresOnBorder[e2]);
              if (d3)
                for (const e2 of v2)
                  l3.showCentroid(l3.featuresOnBorder[e2]);
              r2.borderDoneWithNeighborZ[t3] = l3.canonical.z, l3.borderDoneWithNeighborZ[u3] = r2.canonical.z;
            }
            for (const o3 of i3) {
              const i4 = r2.featuresOnBorder[o3], n3 = r2.centroidData[i4.centroidDataIndex], h3 = i4.borders[t3];
              let d4;
              for (; x2 < v2.length; ) {
                d4 = l3.featuresOnBorder[v2[x2]];
                const e2 = d4.borders[u3];
                if (e2[1] > h3[0] + 3 || e2[0] > h3[0] - 3)
                  break;
                l3.showCentroid(d4), x2++;
              }
              if (d4 && x2 < v2.length) {
                const o4 = x2;
                let y2 = 0;
                for (; !(d4.borders[u3][0] > h3[1] - 3) && (y2++, ++x2 !== v2.length); )
                  d4 = l3.featuresOnBorder[v2[x2]];
                if (d4 = l3.featuresOnBorder[v2[o4]], y2 > 1) {
                  const e2 = d4.borders[u3];
                  Math.abs(h3[0] - e2[0]) < 3 && Math.abs(h3[1] - e2[1]) < 3 && (y2 = 1, x2 = o4 + 1);
                } else if (0 === y2) {
                  r2.showCentroid(i4);
                  continue;
                }
                const b2 = l3.centroidData[d4.centroidDataIndex];
                s2 && 1 === y2 && (((m2 = n3).flags | (g2 = b2).flags) & e.c1 ? (m2.flags |= e.c1, g2.flags |= e.c1) : (m2.flags &= ~e.c1, g2.flags &= ~e.c1));
                const w2 = i4.intersectsCount() > 1 || d4.intersectsCount() > 1;
                if (y2 > 1)
                  x2 = o4, n3.centroidXY = b2.centroidXY = new e.P(0, 0);
                else if (_3 && _3.dem && !w2) {
                  const i5 = p2[t3](n3, b2), o5 = t3 % 2 ? e.a4 - 1 : 0, r3 = f2(i5[0], Math.min(e.a4 - 1, i5[1]), o5, _3, a3, t3 < 2, i5[2]);
                  n3.centroidXY = b2.centroidXY = c2(r3);
                } else
                  w2 ? n3.centroidXY = b2.centroidXY = new e.P(0, 0) : (n3.centroidXY = r2.encodeBorderCentroid(i4), b2.centroidXY = l3.encodeBorderCentroid(d4));
                r2.writeCentroidToBuffer(n3), l3.writeCentroidToBuffer(b2);
              } else
                r2.showCentroid(i4);
            }
            r2.borderDoneWithNeighborZ[t3] = l3.canonical.z, l3.borderDoneWithNeighborZ[u3] = r2.canonical.z;
          }
          var m2, g2;
          (r2.needsCentroidUpdate || !r2.centroidVertexBuffer && 0 !== r2.centroidVertexArray.length) && r2.uploadCentroid(t2);
        }
        const Ao = [1, 0, 0], Mo = [0, 1, 0], zo = [0, 0, 1];
        function Oo(t2, i2, o2) {
          const r2 = o2.transform, a2 = o2.shadowRenderer;
          if (!a2)
            return true;
          const n2 = t2.toUnwrapped(), s2 = r2.tileSize * a2._cascades[o2.currentShadowCascade].scale;
          let l2 = i2.maxHeight;
          if (r2.elevation) {
            const e2 = r2.elevation.getMinMaxForTile(t2);
            e2 && (l2 += e2.max);
          }
          const c2 = [...a2.shadowDirection];
          c2[2] = -c2[2];
          const h2 = a2.computeSimplifiedTileShadowVolume(n2, l2, s2, c2);
          if (!h2)
            return false;
          const _2 = [Ao, Mo, zo, c2, [c2[0], 0, c2[2]], [0, c2[1], c2[2]]], u2 = "globe" === r2.projection.name, d2 = r2.scaleZoom(s2), p2 = e.aM.fromInvProjectionMatrix(r2.invProjMatrix, r2.worldSize, d2, !u2), f2 = a2.getCurrentCascadeFrustum();
          return 0 === p2.intersectsPrecise(h2.vertices, h2.planes, _2) || 0 === f2.intersectsPrecise(h2.vertices, h2.planes, _2);
        }
        function Fo(t2) {
          return [t2[0] * e.c4, t2[1] * e.c4, t2[2] * e.c4, 0];
        }
        function Bo(t2, i2, o2, r2, a2, n2, s2, l2, c2) {
          const h2 = r2.getSource(), _2 = o2.globeSharedBuffers;
          if (!_2)
            return;
          let u2, d2, p2;
          if (i2 && (u2 = r2.getTile(i2)), h2 instanceof e.bo ? (d2 = h2.texture, p2 = e.bj(0, 0, o2.transform)) : u2 && i2 && (d2 = u2.texture, p2 = e.bj(i2.canonical.z, i2.canonical.x, o2.transform)), !d2 || !p2)
            return;
          t2 || (p2 = e.ae.scale(e.ae.create(), p2, [1, -1, 1]));
          const f2 = o2.context, m2 = f2.gl, g2 = "nearest" === a2.paint.get("raster-resampling") ? m2.NEAREST : m2.LINEAR, v2 = o2.colorModeForDrapableLayerRenderPass(n2), x2 = s2.defines;
          x2.push("GLOBE_POLES");
          const y2 = new e.af(m2.LEQUAL, e.af.ReadWrite, o2.depthRangeFor3D), b2 = Float32Array.from(o2.transform.expandedFarZProjMatrix), w2 = Float32Array.from(e.bh(e.bi(new e.aO(0, 0, 0))));
          o2.terrain && o2.terrain.prepareDrawTile(), f2.activeTexture.set(m2.TEXTURE0), d2.bind(g2, m2.CLAMP_TO_EDGE), f2.activeTexture.set(m2.TEXTURE1), d2.bind(g2, m2.CLAMP_TO_EDGE), d2.useMipmap && f2.extTextureFilterAnisotropic && o2.transform.pitch > 20 && m2.texParameterf(m2.TEXTURE_2D, f2.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, f2.extTextureFilterAnisotropicMax);
          const [T2, E2, C2, S2] = i2 ? _2.getPoleBuffers(i2.canonical.z, false) : _2.getPoleBuffers(0, true), I2 = a2.paint.get("raster-elevation");
          let L2;
          t2 ? (L2 = T2, o2.renderDefaultNorthPole = 0 !== I2) : (L2 = E2, o2.renderDefaultSouthPole = 0 !== I2);
          const P2 = Fo(s2.mix), R2 = ((e2, t3, i3, o3, r3, a3, n3, s3, l3, c3, h3, _3, u3) => eo(e2, t3, i3, new Float32Array(16), new Float32Array(9), [0, 0], o3, [0, 0], [0, 0, 0, 0], 1, { opacity: 1, mix: 0 }, a3, [0, 0], s3, 2, c3, h3, _3, 1, 0, u3))(b2, w2, p2, e.a2(o2.transform.zoom), 0, a2, 0, I2, 0, P2, s2.offset, s2.range, n2), D2 = o2.getOrCreateProgram("raster", { defines: x2 });
          o2.uploadCommonUniforms(f2, D2, null), D2.draw(o2, m2.TRIANGLES, y2, c2, v2, l2, R2, a2.id, L2, C2, S2);
        }
        function ko(e2) {
          const t2 = e2._nearZ, i2 = e2.projection.farthestPixelDistance(e2), o2 = i2 - t2, r2 = 0.2 * e2.height, a2 = t2 + r2;
          return [t2, i2, (a2 - r2 - t2) / o2, (a2 - t2) / o2];
        }
        function No(t2, i2, o2, r2) {
          if (t2)
            return i2 instanceof Li && t2 instanceof e.c5 ? i2.getTextureDescriptor(t2, o2, true) : { texture: t2.texture, mix: Fo(r2.mix), offset: r2.offset, buffer: 0, tileSize: 1 };
        }
        function Uo(t2, i2, o2) {
          if (!t2)
            return null;
          const r2 = i2.getTextureDescriptor(t2, o2, true);
          if (!r2)
            return null;
          let { texture: a2, mix: n2, offset: s2, tileSize: l2, buffer: c2, format: h2 } = r2;
          if (!a2 || !h2)
            return null;
          let _2 = false;
          return "uint32" === h2 && (_2 = true, n2[3] = 0, n2 = Ji(e.c6, n2, [0, o2.paint.get("raster-particle-max-speed")]), s2 = Ki(e.c6, s2, [0, o2.paint.get("raster-particle-max-speed")])), { texture: a2, textureOffset: [c2 / (l2 + 2 * c2), l2 / (l2 + 2 * c2)], tileSize: l2, scalarData: _2, scale: n2, offset: s2, defines: ["RASTER_ARRAY", { uint8: "DATA_FORMAT_UINT8", uint16: "DATA_FORMAT_UINT16", uint32: "DATA_FORMAT_UINT32" }[h2]] };
        }
        function Go(e2) {
          const t2 = e2._nearZ, i2 = e2.projection.farthestPixelDistance(e2), o2 = i2 - t2, r2 = 0.2 * e2.height, a2 = t2 + r2;
          return [t2, i2, (a2 - r2 - t2) / o2, (a2 - t2) / o2];
        }
        const jo = new e.C(1, 0, 0, 1), Vo = new e.C(0, 1, 0, 1), $o = new e.C(0, 0, 1, 1), Zo = new e.C(1, 0, 1, 1), Wo = new e.C(0, 1, 1, 1);
        function Ho(t2, i2, o2, r2, a2, n2, s2) {
          const l2 = t2.context, c2 = t2.transform, h2 = l2.gl, _2 = "globe" === c2.projection.name, u2 = _2 ? ["PROJECTION_GLOBE_VIEW"] : [];
          let d2 = e.ae.clone(o2.projMatrix);
          if (_2 && e.a2(c2.zoom) > 0) {
            const t3 = e.c7(o2.canonical, c2), i3 = e.c8(t3);
            d2 = e.ae.multiply(new Float32Array(16), c2.globeMatrix, i3), e.ae.multiply(d2, c2.projMatrix, d2);
          }
          const p2 = e.ae.create();
          p2[12] += 2 * a2 / (e.e.devicePixelRatio * c2.width), p2[13] += 2 * n2 / (e.e.devicePixelRatio * c2.height), e.ae.multiply(d2, p2, d2);
          const f2 = t2.getOrCreateProgram("debug", { defines: u2 }), m2 = i2.getTileByID(o2.key);
          t2.terrain && t2.terrain.setupElevationDraw(m2, f2);
          const g2 = e.af.disabled, v2 = e.ah.disabled, x2 = t2.colorModeForRenderPass(), y2 = "$debug";
          l2.activeTexture.set(h2.TEXTURE0), t2.emptyTexture.bind(h2.LINEAR, h2.CLAMP_TO_EDGE), _2 ? m2._makeGlobeTileDebugBuffers(t2.context, c2) : m2._makeDebugTileBoundsBuffers(t2.context, c2.projection);
          const b2 = m2._tileDebugBuffer || t2.debugBuffer, w2 = m2._tileDebugIndexBuffer || t2.debugIndexBuffer, T2 = m2._tileDebugSegments || t2.debugSegments;
          if (f2.draw(t2, h2.LINE_STRIP, g2, v2, x2, e.ag.disabled, Xi(d2, r2), y2, b2, w2, T2, null, null, null, [m2._globeTileDebugBorderBuffer]), s2) {
            const e2 = m2.latestRawTileData, i3 = Math.floor((e2 && e2.byteLength || 0) / 1024);
            let r3 = o2.canonical.toString();
            o2.overscaledZ !== o2.canonical.z && (r3 += ` => ${o2.overscaledZ}`), r3 += ` ${m2.state}`, r3 += ` ${i3}kb`, function(e3, t3) {
              e3.initDebugOverlayCanvas();
              const i4 = e3.debugOverlayCanvas, o3 = e3.context.gl, r4 = e3.debugOverlayCanvas.getContext("2d");
              r4.clearRect(0, 0, i4.width, i4.height), r4.shadowColor = "white", r4.shadowBlur = 2, r4.lineWidth = 1.5, r4.strokeStyle = "white", r4.textBaseline = "top", r4.font = "bold 36px Open Sans, sans-serif", r4.fillText(t3, 5, 5), r4.strokeText(t3, 5, 5), e3.debugOverlayTexture.update(i4), e3.debugOverlayTexture.bind(o3.LINEAR, o3.CLAMP_TO_EDGE);
            }(t2, r3);
          }
          const E2 = i2.getTile(o2).tileSize, C2 = 512 / Math.min(E2, 512) * (o2.overscaledZ / c2.zoom) * 0.5, S2 = m2._tileDebugTextBuffer || t2.debugBuffer, I2 = m2._tileDebugTextIndexBuffer || t2.quadTriangleIndexBuffer, L2 = m2._tileDebugTextSegments || t2.debugSegments;
          f2.draw(t2, h2.TRIANGLES, g2, v2, e.a.alphaBlended, e.ag.disabled, Xi(d2, e.C.transparent, C2), y2, S2, I2, L2, null, null, null, [m2._globeTileDebugTextBuffer]);
        }
        function qo(e2, t2, i2, o2) {
          Qo(e2, 0, t2 + i2 / 2, e2.transform.width, i2, o2);
        }
        function Xo(e2, t2, i2, o2) {
          Qo(e2, t2 - i2 / 2, 0, i2, e2.transform.height, o2);
        }
        function Qo(t2, i2, o2, r2, a2, n2) {
          const s2 = t2.context, l2 = s2.gl;
          l2.enable(l2.SCISSOR_TEST), l2.scissor(i2 * e.e.devicePixelRatio, o2 * e.e.devicePixelRatio, r2 * e.e.devicePixelRatio, a2 * e.e.devicePixelRatio), s2.clear({ color: n2 }), l2.disable(l2.SCISSOR_TEST);
        }
        const Yo = e.c9([{ name: "a_pos_3f", components: 3, type: "Float32" }]), { members: Jo } = Yo;
        function Ko(e2, t2, i2, o2) {
          e2.emplaceBack(t2, i2, o2);
        }
        class er {
          constructor(t2) {
            this.vertexArray = new e.ca(), this.indices = new e.bw(), Ko(this.vertexArray, -1, -1, 1), Ko(this.vertexArray, 1, -1, 1), Ko(this.vertexArray, -1, 1, 1), Ko(this.vertexArray, 1, 1, 1), Ko(this.vertexArray, -1, -1, -1), Ko(this.vertexArray, 1, -1, -1), Ko(this.vertexArray, -1, 1, -1), Ko(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t2.createVertexBuffer(this.vertexArray, Jo), this.indexBuffer = t2.createIndexBuffer(this.indices), this.segment = e.b.simpleSegment(0, 0, 36, 12);
          }
        }
        function tr(t2, i2, o2, r2, a2, n2) {
          const s2 = t2.context.gl, l2 = i2.paint.get("sky-atmosphere-color"), c2 = i2.paint.get("sky-atmosphere-halo-color"), h2 = i2.paint.get("sky-atmosphere-sun-intensity"), _2 = ((e2, t3, i3, o3, r3) => ({ u_matrix_3f: e2, u_sun_direction: t3, u_sun_intensity: i3, u_color_tint_r: [o3.r, o3.g, o3.b, o3.a], u_color_tint_m: [r3.r, r3.g, r3.b, r3.a], u_luminance: 5e-5 }))(e.bE.fromMat4(e.bE.create(), r2), a2, h2, l2, c2);
          s2.framebufferTexture2D(s2.FRAMEBUFFER, s2.COLOR_ATTACHMENT0, s2.TEXTURE_CUBE_MAP_POSITIVE_X + n2, i2.skyboxTexture, 0), o2.draw(t2, s2.TRIANGLES, e.af.disabled, e.ah.disabled, e.a.unblended, e.ag.frontCW, _2, "skyboxCapture", i2.skyboxGeometry.vertexBuffer, i2.skyboxGeometry.indexBuffer, i2.skyboxGeometry.segment);
        }
        const ir = e.c9([{ type: "Float32", name: "a_pos", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }]);
        class or {
          constructor(t2) {
            const i2 = new e.cb();
            i2.emplaceBack(-1, 1, 1, 0, 0), i2.emplaceBack(1, 1, 1, 1, 0), i2.emplaceBack(1, -1, 1, 1, 1), i2.emplaceBack(-1, -1, 1, 0, 1);
            const o2 = new e.bw();
            o2.emplaceBack(0, 1, 2), o2.emplaceBack(2, 3, 0), this.vertexBuffer = t2.createVertexBuffer(i2, ir.members), this.indexBuffer = t2.createIndexBuffer(o2), this.segments = e.b.simpleSegment(0, 0, 4, 2);
          }
          destroy() {
            this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
          }
        }
        const rr = e.c9([{ type: "Float32", name: "a_pos_3f", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }, { type: "Float32", name: "a_size_scale", components: 1 }, { type: "Float32", name: "a_fade_opacity", components: 1 }]);
        class ar {
          constructor() {
            this.starsCount = 16e3, this.sizeMultiplier = 0.15, this.sizeRange = 100, this.intensityRange = 200;
          }
        }
        class nr {
          constructor(t2) {
            this.colorModeAlphaBlendedWriteRGB = new e.a([e.cc, e.cd, e.cc, e.cd], e.C.transparent, [true, true, true, false]), this.colorModeWriteAlpha = new e.a([e.cc, e.ce, e.cc, e.ce], e.C.transparent, [false, false, false, true]), this.params = new ar(), this.updateNeeded = true, t2.tp.registerParameter(this.params, ["Stars"], "starsCount", { min: 100, max: 16e3, step: 1 }, () => {
              this.updateNeeded = true;
            }), t2.tp.registerParameter(this.params, ["Stars"], "sizeMultiplier", { min: 0.01, max: 2, step: 0.01 }), t2.tp.registerParameter(this.params, ["Stars"], "sizeRange", { min: 0, max: 200, step: 1 }, () => {
              this.updateNeeded = true;
            }), t2.tp.registerParameter(this.params, ["Stars"], "intensityRange", { min: 0, max: 200, step: 1 }, () => {
              this.updateNeeded = true;
            });
          }
          update(t2) {
            const i2 = t2.context;
            if (!this.atmosphereBuffer || this.updateNeeded) {
              this.updateNeeded = false, this.atmosphereBuffer = new or(i2);
              const t3 = this.params.sizeRange, o2 = this.params.intensityRange, r2 = function(t4) {
                const i3 = e.ch(30), o3 = [];
                for (let r3 = 0; r3 < t4; ++r3) {
                  const t5 = 2 * Math.PI * i3(), r4 = Math.acos(1 - 2 * i3()) - 0.5 * Math.PI;
                  o3.push(e.$.fromValues(Math.cos(r4) * Math.cos(t5), Math.cos(r4) * Math.sin(t5), Math.sin(r4)));
                }
                return o3;
              }(this.params.starsCount), a2 = e.ch(300), n2 = new e.cf(), s2 = new e.bw();
              let l2 = 0;
              for (let i3 = 0; i3 < r2.length; ++i3) {
                const c2 = e.$.scale([], r2[i3], 200), h2 = Math.max(0, 1 + 0.01 * t3 * (1 * a2() - 0.5)), _2 = Math.max(0, 1 + 0.01 * o2 * (1 * a2() - 0.5));
                n2.emplaceBack(c2[0], c2[1], c2[2], -1, -1, h2, _2), n2.emplaceBack(c2[0], c2[1], c2[2], 1, -1, h2, _2), n2.emplaceBack(c2[0], c2[1], c2[2], 1, 1, h2, _2), n2.emplaceBack(c2[0], c2[1], c2[2], -1, 1, h2, _2), s2.emplaceBack(l2 + 0, l2 + 1, l2 + 2), s2.emplaceBack(l2 + 0, l2 + 2, l2 + 3), l2 += 4;
              }
              this.starsVx = i2.createVertexBuffer(n2, rr.members), this.starsIdx = i2.createIndexBuffer(s2), this.starsSegments = e.b.simpleSegment(0, 0, n2.length, s2.length);
            }
          }
          destroy() {
            this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy();
          }
          drawAtmosphereGlow(t2, i2) {
            const o2 = t2.context, r2 = o2.gl, a2 = t2.transform, n2 = new e.af(r2.LEQUAL, e.af.ReadOnly, [0, 1]), s2 = e.a2(a2.zoom), l2 = t2.style.getLut(i2.scope), c2 = i2.properties.get("color").toRenderColor(l2).toArray01(), h2 = i2.properties.get("high-color").toRenderColor(l2).toArray01(), _2 = i2.properties.get("space-color").toRenderColor(l2).toArray01PremultipliedAlpha(), u2 = 5e-4, d2 = e.cg(i2.properties.get("horizon-blend"), 0, 1, u2, 0.25), p2 = e.bc(t2, o2, a2) && d2 === u2 ? a2.worldSize / (2 * Math.PI * 1.025) - 1 : a2.globeRadius, f2 = t2.frameCounter / 1e3 % 1, m2 = e.$.length(a2.globeCenterInViewSpace), g2 = Math.sqrt(Math.pow(m2, 2) - Math.pow(p2, 2)), v2 = Math.acos(g2 / m2), x2 = (i3) => {
              const l3 = "globe" === a2.projection.name ? ["PROJECTION_GLOBE_VIEW", "FOG"] : ["FOG"];
              i3 && l3.push("ALPHA_PASS");
              const u3 = t2.getOrCreateProgram("globeAtmosphere", { defines: l3 }), p3 = ((e2, t3, i4, o3, r3, a3, n3, s3, l4, c3, h3, _3) => ({ u_frustum_tl: e2, u_frustum_tr: t3, u_frustum_br: i4, u_frustum_bl: o3, u_horizon: r3, u_transition: a3, u_fadeout_range: n3, u_color: s3, u_high_color: l4, u_space_color: c3, u_temporal_offset: h3, u_horizon_angle: _3 }))(a2.frustumCorners.TL, a2.frustumCorners.TR, a2.frustumCorners.BR, a2.frustumCorners.BL, a2.frustumCorners.horizon, s2, d2, c2, h2, _2, f2, v2);
              t2.uploadCommonUniforms(o2, u3);
              const m3 = this.atmosphereBuffer;
              m3 && u3.draw(t2, r2.TRIANGLES, n2, e.ah.disabled, i3 ? this.colorModeWriteAlpha : this.colorModeAlphaBlendedWriteRGB, e.ag.backCW, p3, i3 ? "atmosphere_glow_alpha" : "atmosphere_glow", m3.vertexBuffer, m3.indexBuffer, m3.segments);
            };
            x2(false), x2(true);
          }
          drawStars(t2, i2) {
            const o2 = e.au(i2.properties.get("star-intensity"), 0, 1);
            if (0 === o2)
              return;
            const r2 = t2.context, a2 = r2.gl, n2 = t2.transform, s2 = t2.getOrCreateProgram("stars"), l2 = e.aw.identity([]);
            e.aw.rotateX(l2, l2, -n2._pitch), e.aw.rotateZ(l2, l2, -n2.angle), e.aw.rotateX(l2, l2, e.ac(n2._center.lat)), e.aw.rotateY(l2, l2, -e.ac(n2._center.lng));
            const c2 = e.ae.fromQuat(new Float32Array(16), l2), h2 = e.ae.multiply([], n2.starsProjMatrix, c2), _2 = e.bE.fromMat4([], c2), u2 = e.bE.invert([], _2), d2 = [0, 1, 0];
            e.$.transformMat3(d2, d2, u2), e.$.scale(d2, d2, this.params.sizeMultiplier);
            const p2 = [1, 0, 0];
            e.$.transformMat3(p2, p2, u2), e.$.scale(p2, p2, this.params.sizeMultiplier);
            const f2 = (m2 = d2, g2 = p2, v2 = o2, { u_matrix: Float32Array.from(h2), u_up: m2, u_right: g2, u_intensity_multiplier: v2 });
            var m2, g2, v2;
            t2.uploadCommonUniforms(r2, s2), this.starsVx && this.starsIdx && s2.draw(t2, a2.TRIANGLES, e.af.disabled, e.ah.disabled, this.colorModeAlphaBlendedWriteRGB, e.ag.disabled, f2, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
          }
        }
        function sr(t2, i2) {
          const o2 = [...t2], r2 = i2.cameraWorldSizeForFog / i2.worldSize, a2 = e.ae.identity([]);
          return e.ae.scale(a2, a2, [r2, r2, 1]), e.ae.multiply(o2, a2, o2), e.ae.multiply(o2, i2.worldToFogMatrix, o2), o2;
        }
        function lr(t2, i2, o2, r2, a2) {
          const n2 = o2.material, s2 = r2.context, { baseColorTexture: l2, metallicRoughnessTexture: c2 } = n2.pbrMetallicRoughness, { normalTexture: h2, occlusionTexture: _2, emissionTexture: u2 } = n2;
          function d2(e2, i3, o3) {
            if (e2 && (t2.push(i3), s2.activeTexture.set(s2.gl.TEXTURE0 + o3), e2.gfxTexture)) {
              const { minFilter: t3, magFilter: i4, wrapS: o4, wrapT: r3 } = e2.sampler;
              e2.gfxTexture.bindExtraParam(t3, i4, o4, r3);
            }
          }
          d2(l2, "HAS_TEXTURE_u_baseColorTexture", _i.BaseColor), d2(c2, "HAS_TEXTURE_u_metallicRoughnessTexture", _i.MetallicRoughness), d2(h2, "HAS_TEXTURE_u_normalTexture", _i.Normal), d2(_2, "HAS_TEXTURE_u_occlusionTexture", _i.Occlusion), d2(u2, "HAS_TEXTURE_u_emissionTexture", _i.Emission), a2 && (a2.texture || (a2.texture = new e.cj(r2.context, a2.image, [a2.image.height, a2.image.height, a2.image.height], s2.gl.RGBA)), s2.activeTexture.set(s2.gl.TEXTURE0 + _i.LUT), a2.texture && a2.texture.bind(s2.gl.LINEAR, s2.gl.CLAMP_TO_EDGE), t2.push("APPLY_LUT_ON_GPU")), o2.texcoordBuffer && (t2.push("HAS_ATTRIBUTE_a_uv_2f"), i2.push(o2.texcoordBuffer)), o2.colorBuffer && (t2.push(12 === o2.colorBuffer.itemSize ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), i2.push(o2.colorBuffer)), o2.normalBuffer && (t2.push("HAS_ATTRIBUTE_a_normal_3f"), i2.push(o2.normalBuffer)), o2.pbrBuffer && (t2.push("HAS_ATTRIBUTE_a_pbr"), t2.push("HAS_ATTRIBUTE_a_heightBasedEmissiveStrength"), i2.push(o2.pbrBuffer)), "OPAQUE" !== n2.alphaMode && "MASK" !== n2.alphaMode || t2.push("UNPREMULT_TEXTURE_IN_SHADER"), n2.defined || t2.push("DIFFUSE_SHADED"), t2.push("USE_STANDARD_DERIVATIVES");
        }
        function cr(t2, i2, o2, r2, a2, n2) {
          const s2 = o2.paint.get("model-opacity"), l2 = i2.context, c2 = new e.af(i2.context.gl.LEQUAL, e.af.ReadWrite, i2.depthRangeFor3D), h2 = i2.transform, _2 = t2.mesh, u2 = _2.material, d2 = u2.pbrMetallicRoughness, p2 = i2.style.fog;
          let f2;
          f2 = "pixels" === i2.transform.projection.zAxisUnit ? [...t2.nodeModelMatrix] : e.ae.multiply([], r2.zScaleMatrix, t2.nodeModelMatrix), e.ae.multiply(f2, r2.negCameraPosMatrix, f2);
          const m2 = e.ae.invert([], f2);
          e.ae.transpose(m2, m2);
          const g2 = o2.paint.get("model-emissive-strength").constantOr(0), v2 = po(new Float32Array(t2.worldViewProjection), new Float32Array(f2), new Float32Array(m2), null, i2, s2, d2.baseColorFactor.toRenderColor(null), u2.emissiveFactor, d2.metallicFactor, d2.roughnessFactor, u2, g2, o2), x2 = { defines: [] }, y2 = [];
          lr(x2.defines, y2, _2, i2, o2.lut);
          const b2 = i2.shadowRenderer;
          b2 && (b2.useNormalOffset = false);
          let w2 = null;
          if (p2) {
            const e2 = sr(t2.nodeModelMatrix, i2.transform);
            if (w2 = new Float32Array(e2), "globe" !== h2.projection.name) {
              const t3 = _2.aabb.min, i3 = _2.aabb.max, [o3, r3] = p2.getOpacityForBounds(e2, t3[0], t3[1], i3[0], i3[1]);
              x2.overrideFog = o3 >= Ke || r3 >= Ke;
            }
          }
          const T2 = ui(i2, o2.paint.get("model-cutoff-fade-range"));
          T2.shouldRenderCutoff && x2.defines.push("RENDER_CUTOFF");
          const E2 = i2.getOrCreateProgram("model", x2);
          i2.uploadCommonUniforms(l2, E2, null, w2, T2), "shadow" !== i2.renderPass && b2 && b2.setupShadowsFromMatrix(t2.nodeModelMatrix, E2), E2.draw(i2, l2.gl.TRIANGLES, c2, a2, n2, _2.material.doubleSided ? e.ag.disabled : e.ag.backCCW, v2, o2.id, _2.vertexBuffer, _2.indexBuffer, _2.segments, o2.paint, i2.transform.zoom, void 0, y2);
        }
        function hr(t2, i2, o2, r2, a2, n2, s2) {
          let l2;
          l2 = "globe" === t2.projection.name ? e.ck(o2, t2) : [...o2], e.ae.multiply(l2, l2, i2.matrix);
          const c2 = e.ae.multiply([], r2, l2);
          if (i2.meshes)
            for (const t3 of i2.meshes) {
              if ("BLEND" !== t3.material.alphaMode) {
                s2.push({ mesh: t3, depth: 0, modelIndex: a2, worldViewProjection: c2, nodeModelMatrix: l2 });
                continue;
              }
              const i3 = e.$.transformMat4([], t3.centroid, c2);
              i3[2] > 0 && n2.push({ mesh: t3, depth: i3[2], modelIndex: a2, worldViewProjection: c2, nodeModelMatrix: l2 });
            }
          if (i2.children)
            for (const e2 of i2.children)
              hr(t2, e2, o2, r2, a2, n2, s2);
        }
        function _r(t2, i2, o2, r2) {
          const a2 = o2.shadowRenderer;
          if (!a2)
            return;
          const n2 = a2.getShadowPassDepthMode(), s2 = a2.getShadowPassColorMode(), l2 = a2.calculateShadowPassMatrixFromMatrix(i2), c2 = fo(l2);
          o2.getOrCreateProgram("modelDepth", { defines: o2._shadowMapDebug ? [] : ["DEPTH_TEXTURE"] }).draw(o2, o2.context.gl.TRIANGLES, n2, e.ah.disabled, s2, e.ag.backCCW, c2, r2.id, t2.vertexBuffer, t2.indexBuffer, t2.segments, r2.paint, o2.transform.zoom, void 0, void 0);
        }
        function ur(t2, i2, o2) {
          const r2 = i2.updateZoomBasedPaintProperties(), a2 = function(t3, i3, o3) {
            let r3, a3, n2, s2 = t3.terrain ? t3.terrain.exaggeration() : 0;
            if (t3.terrain && s2 > 0) {
              const i4 = t3.terrain, a4 = i4.findDEMTileFor(o3);
              a4 && a4.dem ? r3 = e.cm.create(i4, o3, a4) : s2 = 0;
            }
            if (0 === s2 && (i3.terrainElevationMin = 0, i3.terrainElevationMax = 0), s2 === i3.validForExaggeration && (0 === s2 || r3 && r3._demTile && r3._demTile.tileID === i3.validForDEMTile.id && r3._dem._timestamp === i3.validForDEMTile.timestamp))
              return false;
            for (const e2 in i3.instancesPerModel) {
              const t4 = i3.instancesPerModel[e2];
              for (let e3 = 0; e3 < t4.instancedDataArray.length; ++e3) {
                const o4 = (r3 ? s2 * r3.getElevationAt(0 | t4.instancedDataArray.float32[16 * e3], 0 | t4.instancedDataArray.float32[16 * e3 + 1], true, true) : 0) + t4.instancesEvaluatedElevation[e3];
                t4.instancedDataArray.float32[16 * e3 + 6] = o4, a3 = a3 ? Math.min(i3.terrainElevationMin, o4) : o4, n2 = n2 ? Math.max(i3.terrainElevationMax, o4) : o4;
              }
            }
            return i3.terrainElevationMin = a3 || 0, i3.terrainElevationMax = n2 || 0, i3.validForExaggeration = s2, i3.validForDEMTile = r3 && r3._demTile ? { id: r3._demTile.tileID, timestamp: r3._dem._timestamp } : { id: void 0, timestamp: 0 }, true;
          }(t2, i2, o2);
          (r2 || a2) && (i2.uploaded = false, i2.upload(t2.context));
        }
        const dr = { shadowUniformsInitialized: false, useSingleShadowCascade: false, tileMatrix: new Float64Array(16), shadowTileMatrix: new Float32Array(16), aabb: new e.b8([0, 0, 0], [e.a4, e.a4, 0]) };
        function pr(t2, i2) {
          const o2 = 1 << t2.canonical.z, r2 = i2.getFreeCameraOptions().position, a2 = i2.elevation, n2 = t2.canonical.x / o2, s2 = (t2.canonical.x + 1) / o2, l2 = t2.canonical.y / o2, c2 = (t2.canonical.y + 1) / o2;
          let h2 = i2._centerAltitude;
          if (a2) {
            const e2 = a2.getMinMaxForTile(t2);
            e2 && e2.max > h2 && (h2 = e2.max);
          }
          const _2 = e.au(r2.x, n2, s2) - r2.x, u2 = e.au(r2.y, l2, c2) - r2.y, d2 = e.ay(h2, i2.center.lat) - r2.z;
          return i2._zoomFromMercatorZ(Math.sqrt(_2 * _2 + u2 * u2 + d2 * d2));
        }
        function fr(t2, i2, o2, r2, a2, n2, s2) {
          const l2 = t2.context, c2 = "shadow" === t2.renderPass, h2 = t2.shadowRenderer, _2 = c2 && h2 ? h2.getShadowPassDepthMode() : new e.af(l2.gl.LEQUAL, e.af.ReadWrite, t2.depthRangeFor3D), u2 = t2.isTileAffectedByFog(n2);
          if (o2.meshes)
            for (const d2 of o2.meshes) {
              const p2 = ["MODEL_POSITION_ON_GPU"], f2 = [];
              let m2, g2, v2;
              r2.instancedDataArray.length > 20 && p2.push("INSTANCED_ARRAYS");
              const x2 = ui(t2, i2.paint.get("model-cutoff-fade-range"));
              if (x2.shouldRenderCutoff && p2.push("RENDER_CUTOFF"), c2 && h2)
                m2 = t2.getOrCreateProgram("modelDepth", { defines: p2 }), g2 = fo(s2.shadowTileMatrix, s2.shadowTileMatrix, Float32Array.from(o2.matrix)), v2 = h2.getShadowPassColorMode();
              else {
                lr(p2, f2, d2, t2, i2.lut), m2 = t2.getOrCreateProgram("model", { defines: p2, overrideFog: u2 });
                const r3 = d2.material, c3 = r3.pbrMetallicRoughness, _3 = i2.paint.get("model-opacity"), y3 = i2.paint.get("model-emissive-strength").constantOr(0);
                g2 = po(n2.expandedProjMatrix, Float32Array.from(o2.matrix), new Float32Array(16), null, t2, _3, c3.baseColorFactor.toRenderColor(null), r3.emissiveFactor, c3.metallicFactor, c3.roughnessFactor, r3, y3, i2, a2), h2 && (s2.shadowUniformsInitialized ? m2.setShadowUniformValues(l2, h2.getShadowUniformValues()) : (h2.setupShadows(n2.toUnwrapped(), m2, "model-tile", n2.overscaledZ), s2.shadowUniformsInitialized = true)), v2 = x2.shouldRenderCutoff || _3 < 1 || "OPAQUE" !== r3.alphaMode ? e.a.alphaBlended : e.a.unblended;
              }
              t2.uploadCommonUniforms(l2, m2, n2.toUnwrapped(), null, x2);
              const y2 = d2.material.doubleSided ? e.ag.disabled : e.ag.backCCW;
              if (r2.instancedDataArray.length > 20)
                f2.push(r2.instancedDataBuffer), m2.draw(t2, l2.gl.TRIANGLES, _2, e.ah.disabled, v2, y2, g2, i2.id, d2.vertexBuffer, d2.indexBuffer, d2.segments, i2.paint, t2.transform.zoom, void 0, f2, r2.instancedDataArray.length);
              else {
                const o3 = c2 ? "u_instance" : "u_normal_matrix";
                for (let a3 = 0; a3 < r2.instancedDataArray.length; ++a3)
                  g2[o3] = new Float32Array(r2.instancedDataArray.arrayBuffer, 64 * a3, 16), m2.draw(t2, l2.gl.TRIANGLES, _2, e.ah.disabled, v2, y2, g2, i2.id, d2.vertexBuffer, d2.indexBuffer, d2.segments, i2.paint, t2.transform.zoom, void 0, f2);
              }
            }
          if (o2.children)
            for (const e2 of o2.children)
              fr(t2, i2, e2, r2, a2, n2, s2);
        }
        const mr = [1, -1, 1];
        function gr(t2, i2, o2, r2) {
          if (!o2.modelManager)
            return true;
          const a2 = o2.modelManager;
          if (!o2.shadowRenderer)
            return true;
          const n2 = o2.shadowRenderer, s2 = i2.aabb;
          let l2 = true, c2 = t2.maxHeight;
          if (0 === c2) {
            let e2 = 0;
            for (const i3 in t2.instancesPerModel) {
              const t3 = a2.getModel(i3, r2);
              t3 ? e2 = Math.max(e2, Math.max(Math.max(t3.aabb.max[0], t3.aabb.max[1]), t3.aabb.max[2])) : l2 = false;
            }
            c2 = t2.maxScale * e2 * 1.41 + t2.maxVerticalOffset, l2 && (t2.maxHeight = c2);
          }
          s2.max[2] = c2, s2.min[2] += t2.terrainElevationMin, s2.max[2] += t2.terrainElevationMax, e.$.transformMat4(s2.min, s2.min, i2.tileMatrix), e.$.transformMat4(s2.max, s2.max, i2.tileMatrix);
          const h2 = s2.intersects(n2.getCurrentCascadeFrustum());
          return 0 === o2.currentShadowCascade && (t2.isInsideFirstShadowMapFrustum = 2 === h2), 0 === h2;
        }
        function vr(t2, i2) {
          const o2 = t2.uniformValues.u_cutoff_params[0], r2 = t2.uniformValues.u_cutoff_params[1], a2 = t2.uniformValues.u_cutoff_params[2], n2 = t2.uniformValues.u_cutoff_params[3];
          return r2 === o2 || n2 === a2 ? 1 : e.au(((i2 - o2) / (r2 - o2) - a2) / (n2 - a2), 0, 1);
        }
        function xr(t2, i2, o2, r2) {
          if (i2.pitch < 20)
            return 1;
          const a2 = i2.getWorldToCameraMatrix(), n2 = e.ae.multiply([], a2, t2), s2 = [...o2.min, 1];
          let l2 = e.aB.transformMat4([], s2, n2), c2 = l2, h2 = l2;
          s2[1] = o2.max[1], l2 = e.aB.transformMat4([], s2, n2), c2 = l2[1] < c2[1] ? l2 : c2, h2 = l2[1] > h2[1] ? l2 : h2, s2[0] = o2.max[0], l2 = e.aB.transformMat4([], s2, n2), c2 = l2[1] < c2[1] ? l2 : c2, h2 = l2[1] > h2[1] ? l2 : h2, s2[1] = o2.min[1], l2 = e.aB.transformMat4([], s2, n2), c2 = l2[1] < c2[1] ? l2 : c2, h2 = l2[1] > h2[1] ? l2 : h2;
          const _2 = e.au(r2[0], 0, 1), u2 = 100 * i2.pixelsPerMeter * e.au(r2[1], 0, 1), d2 = e.au(r2[2], 0, 1), p2 = e.$.lerp([], c2, h2, _2), f2 = Math.tan(0.5 * i2.fovX), m2 = -p2[2] * f2;
          if (0 === u2)
            return p2[1] < -Math.abs(m2) ? d2 : 1;
          const g2 = (-Math.abs(m2) - p2[1]) / u2, v2 = (e2, t3, i3) => (1 - i3) * e2 + i3 * t3, x2 = e.au(v2(1, d2, g2), d2, 1);
          return v2(1, x2, e.au((i2.pitch - 20) / 20, 0, 1));
        }
        class yr {
        }
        class br {
          constructor() {
            this._storage = /* @__PURE__ */ new Map();
          }
          getLinesFromTrianglesBuffer(t2, i2, o2) {
            {
              const e2 = this._storage.get(i2.id);
              if (e2)
                return e2.lastUsedFrameIdx = t2, e2.buf;
            }
            const r2 = o2.gl, a2 = r2.getBufferParameter(r2.ELEMENT_ARRAY_BUFFER, r2.BUFFER_SIZE), n2 = new ArrayBuffer(a2), s2 = new Int16Array(n2);
            r2.getBufferSubData(r2.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(n2));
            const l2 = new e.co();
            for (let e2 = 0; e2 < a2 / 2; e2 += 3) {
              const t3 = s2[e2], i3 = s2[e2 + 1], o3 = s2[e2 + 2];
              l2.emplaceBack(t3, i3), l2.emplaceBack(i3, o3), l2.emplaceBack(o3, t3);
            }
            const c2 = o2.bindVertexArrayOES.current, h2 = new yr();
            return h2.buf = new e.I(o2, l2), h2.lastUsedFrameIdx = t2, this._storage.set(i2.id, h2), o2.bindVertexArrayOES.set(c2), h2.buf;
          }
          update(e2) {
            for (const [t2, i2] of this._storage)
              e2 - i2.lastUsedFrameIdx > 30 && (i2.buf.destroy(), this._storage.delete(t2));
          }
          destroy() {
            for (const [e2, t2] of this._storage)
              t2.buf.destroy(), this._storage.delete(e2);
          }
        }
        class wr {
          constructor(e2) {
            this.occluderSize = 30, this.depthOffset = -1e-4, e2.registerParameter(this, ["Occlusion"], "occluderSize", { min: 1, max: 100, step: 1 }), e2.registerParameter(this, ["Occlusion"], "depthOffset", { min: -0.05, max: 0, step: 1e-5 });
          }
        }
        const Tr = { symbol: function(t2, i2, o2, r2, a2) {
          if ("translucent" !== t2.renderPass)
            return;
          const n2 = e.ah.disabled, s2 = t2.colorModeForRenderPass();
          o2.layout.get("text-variable-anchor") && function(t3, i3, o3, r3, a3, n3, s3) {
            const l3 = i3.transform, c3 = "map" === a3, h2 = "map" === n3;
            for (const i4 of t3) {
              const t4 = r3.getTile(i4), a4 = t4.getBucket(o3);
              if (!a4 || !a4.text || !a4.text.segments.get().length)
                continue;
              const n4 = e.aE(a4.textSizeData, l3.zoom), _2 = xo(i4, a4.getProjection(), l3), u2 = l3.calculatePixelsToTileUnitsMatrix(t4), d2 = Ht(_2, t4.tileID.canonical, h2, c3, l3, a4.getProjection(), u2), p2 = a4.hasIconTextFit() && a4.hasIconData();
              if (n4) {
                const o4 = Math.pow(2, l3.zoom - t4.tileID.overscaledZ);
                Co(a4, c3, h2, s3, e.bQ, l3, d2, i4, o4, n4, p2);
              }
            }
          }(r2, t2, o2, i2, o2.layout.get("text-rotation-alignment"), o2.layout.get("text-pitch-alignment"), a2);
          const l2 = 0 !== o2.paint.get("icon-opacity").constantOr(1), c2 = 0 !== o2.paint.get("text-opacity").constantOr(1);
          void 0 !== o2.layout.get("symbol-sort-key").constantOr(1) && (l2 || c2) ? So(t2, i2, o2, r2, n2, s2) : (l2 && So(t2, i2, o2, r2, n2, s2, { onlyIcons: true }), c2 && So(t2, i2, o2, r2, n2, s2, { onlyText: true })), i2.map.showCollisionBoxes && (bo(t2, i2, o2, r2, o2.paint.get("text-translate"), o2.paint.get("text-translate-anchor"), true), bo(t2, i2, o2, r2, o2.paint.get("icon-translate"), o2.paint.get("icon-translate-anchor"), false));
        }, circle: function(t2, i2, o2, r2) {
          if ("translucent" !== t2.renderPass)
            return;
          const a2 = o2.paint.get("circle-opacity"), n2 = o2.paint.get("circle-stroke-width"), s2 = o2.paint.get("circle-stroke-opacity"), l2 = void 0 !== o2.layout.get("circle-sort-key").constantOr(1), c2 = o2.paint.get("circle-emissive-strength");
          if (0 === a2.constantOr(1) && (0 === n2.constantOr(1) || 0 === s2.constantOr(1)))
            return;
          const h2 = t2.context, _2 = h2.gl, u2 = t2.transform, d2 = t2.depthModeForSublayer(0, e.af.ReadOnly), p2 = e.ah.disabled, f2 = t2.colorModeForDrapableLayerRenderPass(c2), m2 = "globe" === u2.projection.name, g2 = [e.ak(u2.center.lng), e.al(u2.center.lat)], v2 = [];
          for (let a3 = 0; a3 < r2.length; a3++) {
            const n3 = r2[a3], s3 = i2.getTile(n3), c3 = s3.getBucket(o2);
            if (!c3 || c3.projection.name !== u2.projection.name)
              continue;
            const h3 = c3.programConfigurations.get(o2.id), _3 = e.bT(o2), d3 = t2.isTileAffectedByFog(n3);
            m2 && _3.push("PROJECTION_GLOBE_VIEW"), _3.push("DEPTH_D24"), t2.terrain && u2.depthOcclusionForSymbolsAndCircles && _3.push("DEPTH_OCCLUSION");
            const p3 = t2.getOrCreateProgram("circle", { config: h3, defines: _3, overrideFog: d3 }), f3 = c3.layoutVertexBuffer, x3 = c3.globeExtVertexBuffer, y2 = c3.indexBuffer, b2 = u2.projection.createInversionMatrix(u2, n3.canonical), w2 = { programConfiguration: h3, program: p3, layoutVertexBuffer: f3, globeExtVertexBuffer: x3, indexBuffer: y2, uniformValues: e.bU(t2, n3, s3, b2, g2, o2), tile: s3 };
            if (l2) {
              const t3 = c3.segments.get();
              for (const i3 of t3)
                v2.push({ segments: new e.b([i3]), sortKey: i3.sortKey, state: w2 });
            } else
              v2.push({ segments: c3.segments, sortKey: 0, state: w2 });
          }
          l2 && v2.sort((e2, t3) => e2.sortKey - t3.sortKey);
          const x2 = { useDepthForOcclusion: u2.depthOcclusionForSymbolsAndCircles };
          for (const i3 of v2) {
            const { programConfiguration: r3, program: a3, layoutVertexBuffer: n3, globeExtVertexBuffer: s3, indexBuffer: l3, uniformValues: c3, tile: m3 } = i3.state, g3 = i3.segments;
            t2.terrain && t2.terrain.setupElevationDraw(m3, a3, x2), t2.uploadCommonUniforms(h2, a3, m3.tileID.toUnwrapped()), a3.draw(t2, _2.TRIANGLES, d2, p2, f2, e.ag.disabled, c3, o2.id, n3, l3, g3, o2.paint, u2.zoom, r3, [s3]);
          }
        }, heatmap: function(t2, i2, o2, r2) {
          if (0 !== o2.paint.get("heatmap-opacity"))
            if ("offscreen" === t2.renderPass) {
              const a2 = t2.context, n2 = a2.gl, s2 = e.ah.disabled, l2 = new e.a([n2.ONE, n2.ONE, n2.ONE, n2.ONE], e.C.transparent, [true, true, true, true]);
              !function(e2, t3, i3, o3) {
                const r3 = e2.gl, a3 = t3.width * o3, n3 = t3.height * o3;
                e2.activeTexture.set(r3.TEXTURE1), e2.viewport.set([0, 0, a3, n3]);
                let s3 = i3.heatmapFbo;
                if (!s3 || s3 && (s3.width !== a3 || s3.height !== n3)) {
                  s3 && s3.destroy();
                  const t4 = r3.createTexture();
                  r3.bindTexture(r3.TEXTURE_2D, t4), r3.texParameteri(r3.TEXTURE_2D, r3.TEXTURE_WRAP_S, r3.CLAMP_TO_EDGE), r3.texParameteri(r3.TEXTURE_2D, r3.TEXTURE_WRAP_T, r3.CLAMP_TO_EDGE), r3.texParameteri(r3.TEXTURE_2D, r3.TEXTURE_MIN_FILTER, r3.LINEAR), r3.texParameteri(r3.TEXTURE_2D, r3.TEXTURE_MAG_FILTER, r3.LINEAR), s3 = i3.heatmapFbo = e2.createFramebuffer(a3, n3, true, null), function(e3, t5, i4, o4, r4, a4) {
                    const n4 = e3.gl;
                    n4.texImage2D(n4.TEXTURE_2D, 0, e3.extRenderToTextureHalfFloat ? n4.RGBA16F : n4.RGBA, r4, a4, 0, n4.RGBA, e3.extRenderToTextureHalfFloat ? n4.HALF_FLOAT : n4.UNSIGNED_BYTE, null), o4.colorAttachment.set(i4);
                  }(e2, 0, t4, s3, a3, n3);
                } else
                  r3.bindTexture(r3.TEXTURE_2D, s3.colorAttachment.get()), e2.bindFramebuffer.set(s3.framebuffer);
              }(a2, t2, o2, "globe" === t2.transform.projection.name ? 0.5 : 0.25), a2.clear({ color: e.C.transparent });
              const c2 = t2.transform, h2 = "globe" === c2.projection.name, _2 = h2 ? ["PROJECTION_GLOBE_VIEW"] : [], u2 = h2 ? e.ag.frontCCW : e.ag.disabled, d2 = [e.ak(c2.center.lng), e.al(c2.center.lat)];
              for (let p2 = 0; p2 < r2.length; p2++) {
                const f2 = r2[p2];
                if (i2.hasRenderableParent(f2))
                  continue;
                const m2 = i2.getTile(f2), g2 = m2.getBucket(o2);
                if (!g2 || g2.projection.name !== c2.projection.name)
                  continue;
                const v2 = t2.isTileAffectedByFog(f2), x2 = g2.programConfigurations.get(o2.id), y2 = t2.getOrCreateProgram("heatmap", { config: x2, defines: _2, overrideFog: v2 }), { zoom: b2 } = t2.transform;
                t2.terrain && t2.terrain.setupElevationDraw(m2, y2), t2.uploadCommonUniforms(a2, y2, f2.toUnwrapped());
                const w2 = c2.projection.createInversionMatrix(c2, f2.canonical);
                y2.draw(t2, n2.TRIANGLES, e.af.disabled, s2, l2, u2, Yi(t2, f2, m2, w2, d2, b2, o2.paint.get("heatmap-intensity")), o2.id, g2.layoutVertexBuffer, g2.indexBuffer, g2.segments, o2.paint, t2.transform.zoom, x2, h2 ? [g2.globeExtVertexBuffer] : null);
              }
              a2.viewport.set([0, 0, t2.width, t2.height]);
            } else
              "translucent" === t2.renderPass && (t2.context.setColorMode(t2.colorModeForRenderPass()), function(t3, i3) {
                const o3 = t3.context, r3 = o3.gl, a2 = i3.heatmapFbo;
                if (!a2)
                  return;
                o3.activeTexture.set(r3.TEXTURE0), r3.bindTexture(r3.TEXTURE_2D, a2.colorAttachment.get()), o3.activeTexture.set(r3.TEXTURE1);
                let n2 = i3.colorRampTexture;
                n2 || (n2 = i3.colorRampTexture = new e.T(o3, i3.colorRamp, r3.RGBA)), n2.bind(r3.LINEAR, r3.CLAMP_TO_EDGE), t3.getOrCreateProgram("heatmapTexture").draw(t3, r3.TRIANGLES, e.af.disabled, e.ah.disabled, t3.colorModeForRenderPass(), e.ag.disabled, ((e2, t4, i4, o4) => ({ u_image: 0, u_color_ramp: 1, u_opacity: t4.paint.get("heatmap-opacity") }))(0, i3), i3.id, t3.viewportBuffer, t3.quadTriangleIndexBuffer, t3.viewportSegments, i3.paint, t3.transform.zoom);
              }(t2, o2));
        }, line: function(t2, i2, o2, r2) {
          if ("translucent" !== t2.renderPass)
            return;
          const a2 = o2.paint.get("line-opacity"), n2 = o2.paint.get("line-width");
          if (0 === a2.constantOr(1) || 0 === n2.constantOr(1))
            return;
          const s2 = o2.paint.get("line-emissive-strength"), l2 = o2.paint.get("line-occlusion-opacity"), c2 = t2.context, h2 = c2.gl, _2 = o2.layout.get("line-z-offset"), u2 = !_2.isConstant() || !!_2.constantOr(0), d2 = u2 ? new e.af(t2.depthOcclusion ? h2.GREATER : h2.LEQUAL, e.af.ReadOnly, t2.depthRangeFor3D) : t2.depthModeForSublayer(0, e.af.ReadOnly), p2 = t2.colorModeForDrapableLayerRenderPass(s2), f2 = t2.terrain && t2.terrain.renderingToTexture, m2 = f2 ? 1 : e.e.devicePixelRatio, g2 = o2.paint.get("line-dasharray"), v2 = g2.constantOr(1), x2 = o2.layout.get("line-cap"), y2 = g2.constantOr(null), b2 = x2.constantOr(null), w2 = o2.paint.get("line-pattern"), T2 = w2.constantOr(1), E2 = w2.constantOr(null), C2 = o2.paint.get("line-opacity").constantOr(1);
          let S2 = !T2 && 1 !== C2 || t2.depthOcclusion && l2 > 0 && l2 < 1;
          const I2 = o2.paint.get("line-gradient"), L2 = T2 ? "linePattern" : "line", P2 = e.bV(o2);
          let R2;
          if (f2 && t2.terrain && t2.terrain.clipOrMaskOverlapStencilType() && (S2 = false), 0 !== l2 && t2.depthOcclusion) {
            const t3 = o2.paint._values["line-opacity"];
            t3 && t3.value && "constant" === t3.value.kind ? R2 = t3.value : e.w(`Occlusion opacity for layer ${o2.id} is supported only when line-opacity isn't data-driven.`);
          }
          if (u2 && (t2.forceTerrainMode = true), !u2 && 0 !== l2 && t2.terrain && !f2)
            return void e.w(`Occlusion opacity for layer ${o2.id} is supported on terrain only if the layer has non-zero line-z-offset.`);
          const D2 = S2 && u2 ? t2.stencilModeFor3D() : e.ah.disabled;
          for (const a3 of r2) {
            const r3 = i2.getTile(a3);
            if (T2 && !r3.patternsLoaded())
              continue;
            const n3 = r3.getBucket(o2);
            if (!n3)
              continue;
            t2.prepareDrawTile();
            const s3 = n3.programConfigurations.get(o2.id), _3 = t2.isTileAffectedByFog(a3), g3 = t2.getOrCreateProgram(L2, { config: s3, defines: u2 ? [...P2, "ELEVATED"] : P2, overrideFog: _3 });
            if (E2 && r3.imageAtlas) {
              const e2 = r3.imageAtlas.patternPositions[E2.toString()];
              e2 && s3.setConstantPatternPositions(e2);
            }
            if (!T2 && y2 && b2 && r3.lineAtlas) {
              const e2 = r3.lineAtlas.getDash(y2, b2);
              e2 && s3.setConstantPatternPositions(e2);
            }
            let [x3, w3] = o2.paint.get("line-trim-offset");
            if ("round" === b2 || "square" === b2) {
              const e2 = 1;
              x3 !== w3 && (0 === x3 && (x3 -= e2), 1 === w3 && (w3 += e2));
            }
            const A2 = f2 ? a3.projMatrix : null, M2 = T2 ? e.bW(t2, r3, o2, A2, m2, [x3, w3]) : e.bX(t2, r3, o2, A2, n3.lineClipsArray.length, m2, [x3, w3]);
            if (I2) {
              const r4 = n3.gradients[o2.id];
              let s4 = r4.texture;
              if (o2.gradientVersion !== r4.version) {
                let l3 = 256;
                if (o2.stepInterpolant) {
                  const o3 = i2.getSource().maxzoom, r5 = a3.canonical.z === o3 ? Math.ceil(1 << t2.transform.maxZoom - a3.canonical.z) : 1;
                  l3 = e.au(e.bY(n3.maxLineLength / e.a4 * 1024 * r5), 256, c2.maxTextureSize);
                }
                r4.gradient = e.bZ({ expression: o2.gradientExpression(), evaluationKey: "lineProgress", resolution: l3, image: r4.gradient || void 0, clips: n3.lineClipsArray }), r4.texture ? r4.texture.update(r4.gradient) : r4.texture = new e.T(c2, r4.gradient, h2.RGBA), r4.version = o2.gradientVersion, s4 = r4.texture;
              }
              c2.activeTexture.set(h2.TEXTURE1), s4.bind(o2.stepInterpolant ? h2.NEAREST : h2.LINEAR, h2.CLAMP_TO_EDGE);
            }
            v2 && (c2.activeTexture.set(h2.TEXTURE0), r3.lineAtlasTexture && r3.lineAtlasTexture.bind(h2.LINEAR, h2.REPEAT), s3.updatePaintBuffers()), T2 && (c2.activeTexture.set(h2.TEXTURE0), r3.imageAtlasTexture && r3.imageAtlasTexture.bind(h2.LINEAR, h2.CLAMP_TO_EDGE), s3.updatePaintBuffers()), u2 && t2.terrain.setupElevationDraw(r3, g3), t2.uploadCommonUniforms(c2, g3, a3.toUnwrapped());
            const z2 = (i3) => {
              null != R2 && (R2.value = C2 * l2), g3.draw(t2, h2.TRIANGLES, d2, i3, p2, e.ag.disabled, M2, o2.id, n3.layoutVertexBuffer, n3.indexBuffer, n3.segments, o2.paint, t2.transform.zoom, s3, [n3.layoutVertexBuffer2, n3.patternVertexBuffer, n3.zOffsetVertexBuffer]), null != R2 && (R2.value = C2);
            };
            if (S2 && !u2) {
              const i3 = t2.stencilModeForClipping(a3).ref;
              0 === i3 && f2 && c2.clear({ stencil: 0 });
              const o3 = { func: h2.EQUAL, mask: 255 };
              M2.u_alpha_discard_threshold = 0.8, z2(new e.ah(o3, i3, 255, h2.KEEP, h2.KEEP, h2.INVERT)), M2.u_alpha_discard_threshold = 0, z2(new e.ah(o3, i3, 255, h2.KEEP, h2.KEEP, h2.KEEP));
            } else
              S2 && u2 && (M2.u_alpha_discard_threshold = 1e-3), z2(u2 ? D2 : t2.stencilModeForClipping(a3));
          }
          S2 && (t2.resetStencilClippingMasks(), f2 && c2.clear({ stencil: 0 })), 0 === l2 || t2.depthOcclusion || f2 || t2.layersWithOcclusionOpacity.push(t2.currentLayer), u2 && (t2.forceTerrainMode = false);
        }, fill: function(t2, i2, o2, r2) {
          const a2 = o2.paint.get("fill-color"), n2 = o2.paint.get("fill-opacity");
          if (0 === n2.constantOr(1))
            return;
          const s2 = o2.paint.get("fill-emissive-strength"), l2 = t2.colorModeForDrapableLayerRenderPass(s2), c2 = o2.paint.get("fill-pattern"), h2 = t2.opaquePassEnabledForLayer() && !c2.constantOr(1) && 1 === a2.constantOr(e.C.transparent).a && 1 === n2.constantOr(0) ? "opaque" : "translucent";
          if (t2.renderPass === h2) {
            const a3 = t2.depthModeForSublayer(1, "opaque" === t2.renderPass ? e.af.ReadWrite : e.af.ReadOnly);
            Lo(t2, i2, o2, r2, a3, l2, false);
          }
          if ("translucent" === t2.renderPass && o2.paint.get("fill-antialias")) {
            const a3 = t2.depthModeForSublayer(o2.getPaintProperty("fill-outline-color") ? 2 : 0, e.af.ReadOnly);
            Lo(t2, i2, o2, r2, a3, l2, true);
          }
        }, "fill-extrusion": function(t2, i2, o2, r2) {
          const a2 = o2.paint.get("fill-extrusion-opacity"), n2 = t2.context, s2 = n2.gl, l2 = t2.terrain, c2 = l2 && l2.renderingToTexture;
          if (0 === a2)
            return;
          const h2 = t2.conflationActive && t2.style.isLayerClipped(o2, i2.getSource()), _2 = t2.style.order.indexOf(o2.fqid);
          if (h2 && function(e2, t3, i3, o3, r3) {
            for (const a3 of o3) {
              const o4 = t3.getTile(a3).getBucket(i3);
              o4 && (o4.updateReplacement(a3, e2.replacementSource, r3), o4.uploadCentroid(e2.context));
            }
          }(t2, i2, o2, r2, _2), l2 || h2)
            for (const e2 of r2) {
              const r3 = i2.getTile(e2).getBucket(o2);
              r3 && Do(t2.context, i2, e2, r3, o2, l2, h2);
            }
          if ("shadow" === t2.renderPass && t2.shadowRenderer) {
            const n3 = t2.shadowRenderer;
            if (l2 && a2 < 0.65 && o2._transitionablePaint._values["fill-extrusion-opacity"].value.expression instanceof e.Z)
              return;
            const s3 = n3.getShadowPassDepthMode(), c3 = n3.getShadowPassColorMode();
            Po(t2, i2, o2, r2, s3, e.ah.disabled, c3, h2);
          } else if ("translucent" === t2.renderPass) {
            const _3 = !o2.paint.get("fill-extrusion-pattern").constantOr(1), u2 = o2.paint.get("fill-extrusion-color").constantOr(e.C.white);
            if (!c2 && 0 !== u2.a) {
              const n3 = new e.af(t2.context.gl.LEQUAL, e.af.ReadWrite, t2.depthRangeFor3D);
              1 === a2 && _3 ? Po(t2, i2, o2, r2, n3, e.ah.disabled, e.a.unblended, h2) : (Po(t2, i2, o2, r2, n3, e.ah.disabled, e.a.disabled, h2), Po(t2, i2, o2, r2, n3, t2.stencilModeFor3D(), t2.colorModeForRenderPass(), h2), t2.resetStencilClippingMasks());
            }
            if (t2.style.enable3dLights() && _3 && (!l2 && "globe" !== t2.transform.projection.name || c2)) {
              const a3 = o2.paint.get("fill-extrusion-opacity"), _4 = o2.paint.get("fill-extrusion-ambient-occlusion-intensity"), u3 = o2.paint.get("fill-extrusion-ambient-occlusion-ground-radius"), d2 = o2.paint.get("fill-extrusion-flood-light-intensity"), p2 = o2.paint.get("fill-extrusion-flood-light-color").toRenderColor(o2.lut).toArray01().slice(0, 3), f2 = _4 > 0 && u3 > 0, m2 = d2 > 0, g2 = (e2, t3, i3) => (1 - i3) * e2 + i3 * t3, v2 = (n3) => {
                const l3 = t2.depthModeForSublayer(1, e.af.ReadOnly, s2.LEQUAL, true), c3 = o2.paint.get(n3 ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), f3 = g2(0.1, 3, c3), m3 = t2._showOverdrawInspector;
                if (!m3) {
                  const c4 = new e.ah({ func: s2.ALWAYS, mask: 255 }, 255, 255, s2.KEEP, s2.KEEP, s2.REPLACE), m4 = new e.a([s2.ONE, s2.ONE, s2.ONE, s2.ONE], e.C.transparent, [false, false, false, true], s2.MIN);
                  Ro(t2, i2, o2, r2, l3, c4, m4, e.ag.disabled, n3, "sdf", a3, _4, u3, d2, p2, f3, h2, false);
                }
                {
                  const c4 = m3 ? e.ah.disabled : new e.ah({ func: s2.EQUAL, mask: 255 }, 255, 255, s2.KEEP, s2.DECR, s2.DECR), g3 = m3 ? t2.colorModeForRenderPass() : new e.a([s2.ONE_MINUS_DST_ALPHA, s2.DST_ALPHA, s2.ONE, s2.ONE], e.C.transparent, [true, true, true, true]);
                  Ro(t2, i2, o2, r2, l3, c4, g3, e.ag.disabled, n3, "color", a3, _4, u3, d2, p2, f3, h2, false);
                }
              };
              if (c2) {
                const c3 = (n3, l3, c4) => {
                  const f3 = t2.depthModeForSublayer(1, e.af.ReadOnly, s2.LEQUAL, false), m3 = o2.paint.get(n3 ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), v3 = g2(0.1, 3, m3);
                  {
                    const c5 = new e.a([s2.ONE, s2.ONE, s2.ONE, s2.ONE], e.C.transparent, [false, false, false, true]);
                    Ro(t2, i2, o2, r2, f3, e.ah.disabled, c5, e.ag.disabled, n3, "clear", a3, _4, u3, d2, p2, v3, h2, l3);
                  }
                  {
                    const c5 = new e.ah({ func: s2.ALWAYS, mask: 255 }, 255, 255, s2.KEEP, s2.KEEP, s2.REPLACE), m4 = new e.a([s2.ONE, s2.ONE, s2.ONE, s2.ONE], e.C.transparent, [false, false, false, true], s2.MIN);
                    Ro(t2, i2, o2, r2, f3, c5, m4, e.ag.disabled, n3, "sdf", a3, _4, u3, d2, p2, v3, h2, l3);
                  }
                  {
                    const c5 = n3 ? s2.ZERO : s2.ONE_MINUS_DST_ALPHA, m4 = new e.ah({ func: s2.EQUAL, mask: 255 }, 255, 255, s2.KEEP, s2.DECR, s2.DECR), g3 = new e.a([c5, s2.DST_ALPHA, s2.ONE_MINUS_DST_ALPHA, s2.ZERO], e.C.transparent, [true, true, true, true]);
                    Ro(t2, i2, o2, r2, f3, m4, g3, e.ag.disabled, n3, "color", a3, _4, u3, d2, p2, v3, h2, l3);
                  }
                  {
                    const m4 = new e.a([s2.ONE, s2.ONE, s2.ONE, n3 ? s2.ZERO : s2.ONE], e.C.transparent, [false, false, false, true], n3 ? s2.FUNC_ADD : s2.MAX);
                    Ro(t2, i2, o2, r2, f3, e.ah.disabled, m4, e.ag.disabled, n3, "clear", a3, _4, u3, d2, p2, v3, h2, l3, c4);
                  }
                };
                if (f2 || m2) {
                  let i3;
                  if (t2.prepareDrawTile(), l2) {
                    const t3 = l2.drapeBufferSize[0], o3 = l2.drapeBufferSize[1];
                    i3 = l2.framebufferCopyTexture, i3 && (!i3 || i3.size[0] === t3 && i3.size[1] === o3) || (i3 && i3.destroy(), i3 = l2.framebufferCopyTexture = new e.T(n2, new e.j({ width: t3, height: o3 }), s2.RGBA)), i3.bind(s2.LINEAR, s2.CLAMP_TO_EDGE), s2.copyTexImage2D(s2.TEXTURE_2D, 0, s2.RGBA, 0, 0, t3, o3, 0);
                  }
                  f2 && c3(true, false, i3), m2 && c3(false, true, i3);
                }
              } else
                f2 && v2(true), m2 && v2(false), (f2 || m2) && t2.resetStencilClippingMasks();
            }
          }
        }, hillshade: function(t2, i2, o2, r2) {
          if ("offscreen" !== t2.renderPass && "translucent" !== t2.renderPass)
            return;
          if (t2.style.disableElevatedTerrain)
            return;
          const a2 = t2.context, n2 = t2.terrain && t2.terrain.renderingToTexture, [s2, l2] = "translucent" !== t2.renderPass || n2 ? [{}, r2] : t2.stencilConfigForOverlap(r2);
          for (const r3 of l2) {
            const a3 = i2.getTile(r3);
            if (a3.needsHillshadePrepare && "offscreen" === t2.renderPass)
              At(t2, a3, o2);
            else if ("translucent" === t2.renderPass) {
              const i3 = t2.depthModeForSublayer(0, e.af.ReadOnly), l3 = o2.paint.get("hillshade-emissive-strength"), c2 = t2.colorModeForDrapableLayerRenderPass(l3), h2 = n2 && t2.terrain ? t2.terrain.stencilModeForRTTOverlap(r3) : s2[r3.overscaledZ];
              Rt(t2, r3, a3, o2, i3, h2, c2);
            }
          }
          a2.viewport.set([0, 0, t2.width, t2.height]), t2.resetStencilClippingMasks();
        }, raster: function(t2, i2, o2, r2, a2, n2) {
          if ("translucent" !== t2.renderPass)
            return;
          if (0 === o2.paint.get("raster-opacity"))
            return;
          const s2 = "globe" === t2.transform.projection.name, l2 = 0 !== o2.paint.get("raster-elevation"), c2 = l2 && s2;
          if (t2.renderElevatedRasterBackface && !c2)
            return;
          const h2 = t2.context, _2 = h2.gl, u2 = i2.getSource(), d2 = function(t3, i3, o3, r3) {
            const a3 = i3.paint.get("raster-color"), n3 = "raster-array" === t3.type, s3 = [], l3 = i3.paint.get("raster-resampling"), c3 = i3.paint.get("raster-color-mix");
            let h3 = i3.paint.get("raster-color-range");
            const _3 = [c3[0], c3[1], c3[2], 0], u3 = c3[3];
            let d3 = "nearest" === l3 ? r3.NEAREST : r3.LINEAR;
            if (n3 && (s3.push("RASTER_ARRAY"), a3 || s3.push("RASTER_COLOR"), "linear" === l3 && s3.push("RASTER_ARRAY_LINEAR"), d3 = r3.NEAREST, !h3 && t3.rasterLayers)) {
              const e2 = t3.rasterLayers.find(({ id: e3 }) => e3 === i3.sourceLayer);
              e2 && e2.fields && e2.fields.range && (h3 = e2.fields.range);
            }
            if (h3 = h3 || [0, 1], a3) {
              s3.push("RASTER_COLOR"), o3.activeTexture.set(r3.TEXTURE2), i3.updateColorRamp(h3);
              let t4 = i3.colorRampTexture;
              t4 || (t4 = i3.colorRampTexture = new e.T(o3, i3.colorRamp, r3.RGBA)), t4.bind(r3.LINEAR, r3.CLAMP_TO_EDGE);
            }
            return { mix: _3, range: h3, offset: u3, defines: s3, resampling: d3 };
          }(u2, o2, h2, _2);
          if (u2 instanceof e.bo && !r2.length && !s2)
            return;
          const p2 = o2.paint.get("raster-emissive-strength"), f2 = t2.colorModeForDrapableLayerRenderPass(p2), m2 = t2.terrain && t2.terrain.renderingToTexture, g2 = !t2.options.moving, v2 = "nearest" === o2.paint.get("raster-resampling") ? _2.NEAREST : _2.LINEAR;
          if (u2 instanceof e.bo && !r2.length && (u2.onNorthPole || u2.onSouthPole)) {
            const r3 = l2 ? t2.stencilModeFor3D() : e.ah.disabled;
            return void Bo(!!u2.onNorthPole, null, t2, i2, o2, p2, d2, e.ag.disabled, r3);
          }
          if (!r2.length)
            return;
          const [x2, y2] = u2 instanceof e.bo || m2 ? [{}, r2] : t2.stencilConfigForOverlap(r2), b2 = y2[y2.length - 1].overscaledZ;
          c2 && d2.defines.push("PROJECTION_GLOBE_VIEW"), l2 && d2.defines.push("RENDER_CUTOFF");
          const w2 = (r3, a3, y3) => {
            for (const w3 of r3) {
              const r4 = w3.toUnwrapped(), T2 = i2.getTile(w3);
              if (m2 && (!T2 || !T2.hasData()))
                continue;
              h2.activeTexture.set(_2.TEXTURE0);
              const E2 = No(T2, u2, o2, d2);
              if (!E2 || !E2.texture)
                continue;
              const { texture: C2, mix: S2, offset: I2, tileSize: L2, buffer: P2 } = E2;
              let R2, D2;
              m2 ? (R2 = e.af.disabled, D2 = w3.projMatrix) : l2 ? (R2 = new e.af(_2.LEQUAL, e.af.ReadWrite, t2.depthRangeFor3D), D2 = s2 ? Float32Array.from(t2.transform.expandedFarZProjMatrix) : t2.transform.calculateProjMatrix(r4, g2)) : (R2 = t2.depthModeForSublayer(w3.overscaledZ - b2, 1 === o2.paint.get("raster-opacity") ? e.af.ReadWrite : e.af.ReadOnly, _2.LESS), D2 = t2.transform.calculateProjMatrix(r4, g2));
              const A2 = t2.terrain && m2 ? t2.terrain.stencilModeForRTTOverlap(w3) : x2[w3.overscaledZ], M2 = n2 ? 0 : o2.paint.get("raster-fade-duration");
              T2.registerFadeDuration(M2);
              const z2 = i2.findLoadedParent(w3, 0), O2 = Ii(T2, z2, i2, t2.transform, M2);
              let F2, B2;
              t2.terrain && t2.terrain.prepareDrawTile(), h2.activeTexture.set(_2.TEXTURE0), C2.bind(v2, _2.CLAMP_TO_EDGE), h2.activeTexture.set(_2.TEXTURE1), z2 ? (z2.texture && z2.texture.bind(v2, _2.CLAMP_TO_EDGE), F2 = Math.pow(2, z2.tileID.overscaledZ - T2.tileID.overscaledZ), B2 = [T2.tileID.canonical.x * F2 % 1, T2.tileID.canonical.y * F2 % 1]) : C2.bind(v2, _2.CLAMP_TO_EDGE), C2.useMipmap && h2.extTextureFilterAnisotropic && t2.transform.pitch > 20 && _2.texParameterf(_2.TEXTURE_2D, h2.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, h2.extTextureFilterAnisotropicMax);
              const k2 = t2.transform;
              let N2;
              const U2 = l2 ? ko(k2) : [0, 0, 0, 0];
              let G2, j2, V2, $2, Z2, W2 = 0;
              if (c2 && u2 instanceof e.bo && u2.coordinates.length > 3)
                G2 = Float32Array.from(e.bh(e.bi(new e.aO(0, 0, 0)))), j2 = Float32Array.from(k2.globeMatrix), V2 = Float32Array.from(e.bd(k2)), $2 = [e.ak(k2.center.lng), e.al(k2.center.lat)], N2 = u2.elevatedGlobePerspectiveTransform, Z2 = u2.elevatedGlobeGridMatrix || new Float32Array(9);
              else if (c2) {
                const t3 = e.be(w3.canonical);
                W2 = e.bf(t3.getCenter().lat), G2 = Float32Array.from(e.bh(e.bi(w3.canonical))), j2 = Float32Array.from(k2.globeMatrix), V2 = Float32Array.from(e.bd(k2)), $2 = [e.ak(k2.center.lng), e.al(k2.center.lat)], N2 = [0, 0], Z2 = Float32Array.from(e.bg(w3.canonical, t3, W2, k2.worldSize / k2._pixelsPerMercatorPixel));
              } else
                N2 = u2 instanceof e.bo ? u2.perspectiveTransform : [0, 0], G2 = new Float32Array(16), j2 = new Float32Array(9), V2 = new Float32Array(16), $2 = [0, 0], Z2 = new Float32Array(9);
              const H2 = eo(D2, G2, j2, V2, Z2, B2 || [0, 0], e.a2(t2.transform.zoom), $2, U2, F2 || 1, O2, o2, N2, l2 ? o2.paint.get("raster-elevation") : 0, 2, S2, I2, d2.range, L2, P2, p2), q2 = t2.isTileAffectedByFog(w3), X2 = t2.getOrCreateProgram("raster", { defines: d2.defines, overrideFog: q2 });
              if (t2.uploadCommonUniforms(h2, X2, r4), u2 instanceof e.bo) {
                const i3 = u2.elevatedGlobeVertexBuffer, r5 = u2.elevatedGlobeIndexBuffer;
                if (m2 || !s2)
                  u2.boundsBuffer && u2.boundsSegments && X2.draw(t2, _2.TRIANGLES, R2, e.ah.disabled, f2, e.ag.disabled, H2, o2.id, u2.boundsBuffer, t2.quadTriangleIndexBuffer, u2.boundsSegments);
                else if (i3 && r5) {
                  const n3 = k2.zoom <= e.b3 ? u2.elevatedGlobeSegments : u2.getSegmentsForLongitude(k2.center.lng);
                  n3 && X2.draw(t2, _2.TRIANGLES, R2, e.ah.disabled, f2, a3, H2, o2.id, i3, r5, n3);
                }
              } else if (c2) {
                R2 = new e.af(_2.LEQUAL, e.af.ReadOnly, t2.depthRangeFor3D);
                const i3 = t2.globeSharedBuffers;
                if (i3) {
                  const [e2, r5, n3] = i3.getGridBuffers(W2, false);
                  X2.draw(t2, _2.TRIANGLES, R2, y3 || A2, t2.colorModeForRenderPass(), a3, H2, o2.id, e2, r5, n3);
                }
              } else {
                const { tileBoundsBuffer: i3, tileBoundsIndexBuffer: r5, tileBoundsSegments: a4 } = t2.getTileBoundsBuffers(T2);
                X2.draw(t2, _2.TRIANGLES, R2, A2, f2, e.ag.disabled, H2, o2.id, i3, r5, a4);
              }
            }
            if (!(u2 instanceof e.bo) && c2)
              for (const n3 of r3) {
                const r4 = n3.canonical.y === (1 << n3.canonical.z) - 1;
                0 === n3.canonical.y && Bo(true, n3, t2, i2, o2, p2, d2, a3, y3 || e.ah.disabled), r4 && Bo(false, n3, t2, i2, o2, p2, d2, a3 === e.ag.frontCW ? e.ag.backCW : e.ag.frontCW, y3 || e.ah.disabled);
              }
          };
          c2 ? w2(y2, t2.renderElevatedRasterBackface ? e.ag.backCW : e.ag.frontCW, t2.stencilModeFor3D()) : w2(y2, e.ag.disabled, void 0), t2.resetStencilClippingMasks();
        }, "raster-particle": function(t2, i2, o2, r2, a2, n2) {
          "offscreen" === t2.renderPass && function(t3, i3, o3, r3) {
            if (!r3.length)
              return;
            const a3 = t3.context, n3 = a3.gl, s2 = i3.getSource();
            if (!(s2 instanceof Li))
              return;
            const l2 = Math.ceil(Math.sqrt(o3.paint.get("raster-particle-count")));
            let c2 = o3.particlePositionRGBAImage;
            if (!c2 || c2.width !== l2) {
              const t4 = function(e2) {
                const t5 = e2 * e2, i4 = new Uint8Array(4 * t5), o4 = function(e3) {
                  return e3 |= 0, e3 = Math.imul(2747636419 ^ e3, 2654435769), e3 = Math.imul(e3 ^ e3 >>> 16, 2654435769), ((e3 = Math.imul(e3 ^ e3 >>> 16, 2654435769)) >>> 0) / 4294967296;
                }, r4 = 1 / 1.1;
                for (let e3 = 0; e3 < t5; e3++) {
                  const t6 = r4 * (o4(2 * e3 + 0) + io), a4 = r4 * (o4(2 * e3 + 1) + io), n4 = 255 * t6 % 1, s3 = 255 * a4 % 1, l3 = n4, c3 = a4 - s3 / 255, h3 = s3;
                  i4[4 * e3 + 0] = 255 * (t6 - n4 / 255), i4[4 * e3 + 1] = 255 * l3, i4[4 * e3 + 2] = 255 * c3, i4[4 * e3 + 3] = 255 * h3;
                }
                return i4;
              }(l2);
              c2 = o3.particlePositionRGBAImage = new e.j({ width: l2, height: l2 }, t4);
            }
            let h2 = o3.particleFramebuffer;
            h2 ? h2.width !== l2 && (h2.destroy(), h2 = o3.particleFramebuffer = a3.createFramebuffer(l2, l2, true, null)) : h2 = o3.particleFramebuffer = a3.createFramebuffer(l2, l2, true, null);
            const _2 = [];
            for (const t4 of r3) {
              const r4 = i3.getTile(t4);
              if (!(r4 instanceof e.c5))
                continue;
              const n4 = Uo(r4, s2, o3);
              if (!n4)
                continue;
              const h3 = [r4.tileSize, r4.tileSize];
              let u3 = o3.tileFramebuffer;
              u3 || (u3 = o3.tileFramebuffer = a3.createFramebuffer(h3[0], h3[1], true, null));
              let d3 = r4.rasterParticleState;
              d3 || (d3 = r4.rasterParticleState = new ae(a3, t4, h3, c2));
              const p2 = d3.update(o3.lastInvalidatedAt);
              d3.particleTextureDimension !== l2 && d3.updateParticleTexture(t4, c2);
              const f2 = d3.targetColorTexture;
              d3.targetColorTexture = d3.backgroundColorTexture, d3.backgroundColorTexture = f2;
              const m2 = d3.particleTexture0;
              d3.particleTexture0 = d3.particleTexture1, d3.particleTexture1 = m2, _2.push([t4, n4, d3, p2]);
            }
            if (0 === _2.length)
              return;
            const u2 = e.e.now(), d2 = o3.previousDrawTimestamp ? 1e-3 * (u2 - o3.previousDrawTimestamp) : 0.0167;
            if (o3.previousDrawTimestamp = u2, o3.hasColorMap()) {
              a3.activeTexture.set(n3.TEXTURE0 + 2);
              let t4 = o3.colorRampTexture;
              t4 || (t4 = o3.colorRampTexture = new e.T(a3, o3.colorRamp, n3.RGBA)), t4.bind(n3.LINEAR, n3.CLAMP_TO_EDGE);
            }
            a3.bindFramebuffer.set(o3.tileFramebuffer.framebuffer), function(t4, i4, o4) {
              const r4 = t4.context, a4 = r4.gl, n4 = i4.tileFramebuffer;
              r4.activeTexture.set(a4.TEXTURE0);
              const s3 = { u_texture: 0, u_opacity: 1.05 * (c3 = i4.paint.get("raster-particle-fade-opacity-factor")) / (c3 + 0.05) }, l3 = t4.getOrCreateProgram("rasterParticleTexture", { defines: [], overrideFog: false });
              var c3;
              for (const c4 of o4) {
                const [, , o5, h3] = c4;
                n4.colorAttachment.set(o5.targetColorTexture.texture), r4.viewport.set([0, 0, n4.width, n4.height]), r4.clear({ color: e.C.transparent }), h3 && (o5.backgroundColorTexture.bind(a4.NEAREST, a4.CLAMP_TO_EDGE), l3.draw(t4, a4.TRIANGLES, e.af.disabled, e.ah.disabled, e.a.alphaBlended, e.ag.disabled, s3, i4.id, t4.viewportBuffer, t4.quadTriangleIndexBuffer, t4.viewportSegments));
              }
            }(t3, o3, _2), function(t4, i4, o4, r4) {
              const a4 = t4.context, n4 = a4.gl, s3 = o4.tileFramebuffer, l3 = "globe" === t4.transform.projection.name, c3 = o4.paint.get("raster-particle-max-speed");
              for (const h3 of r4) {
                const [r5, _3, u3] = h3;
                a4.activeTexture.set(n4.TEXTURE0 + 0), _3.texture.bind(n4.LINEAR, n4.CLAMP_TO_EDGE), s3.colorAttachment.set(u3.targetColorTexture.texture);
                const d3 = t4.getOrCreateProgram("rasterParticleDraw", { defines: _3.defines, overrideFog: false });
                a4.activeTexture.set(n4.TEXTURE0 + 1);
                const p2 = _3.scalarData ? [] : [0, 1, 2, 3].map((t5) => e.b$[t5](r5));
                p2.push(r5);
                const f2 = r5.canonical.x, m2 = r5.canonical.y;
                for (const a5 of p2) {
                  const s4 = i4.getTile(l3 ? a5.wrapped() : a5);
                  if (!s4)
                    continue;
                  const h4 = s4.rasterParticleState;
                  if (!h4)
                    continue;
                  const u4 = a5.canonical.x + (1 << a5.canonical.z) * (a5.wrap - r5.wrap), p3 = a5.canonical.y;
                  h4.particleTexture0.bind(n4.NEAREST, n4.CLAMP_TO_EDGE);
                  const g2 = ro(1, h4.particleTexture0.size[0], [u4 - f2, p3 - m2], 0, _3.texture.size, 2, c3, _3.textureOffset, _3.scale, _3.offset);
                  d3.draw(t4, n4.POINTS, e.af.disabled, e.ah.disabled, e.a.alphaBlended, e.ag.disabled, g2, o4.id, h4.particleIndexBuffer, void 0, h4.particleSegment);
                }
              }
            }(t3, i3, o3, _2), a3.bindFramebuffer.set(o3.particleFramebuffer.framebuffer), function(t4, i4, o4, r4) {
              const a4 = t4.context, n4 = a4.gl, s3 = i4.paint.get("raster-particle-max-speed"), l3 = r4 * i4.paint.get("raster-particle-speed-factor") * 0.15, c3 = function(e2) {
                return Math.pow(e2, 6);
              }(0.01 + 1 * i4.paint.get("raster-particle-reset-rate-factor")), h3 = i4.particleFramebuffer;
              a4.viewport.set([0, 0, h3.width, h3.height]);
              for (const r5 of o4) {
                const [, o5, _3] = r5;
                a4.activeTexture.set(n4.TEXTURE0 + 0), o5.texture.bind(n4.LINEAR, n4.CLAMP_TO_EDGE), a4.activeTexture.set(n4.TEXTURE0 + 1);
                const u3 = _3.particleTexture0;
                u3.bind(n4.NEAREST, n4.CLAMP_TO_EDGE);
                const d3 = ao(1, u3.size[0], 0, o5.texture.size, s3, l3, c3, o5.textureOffset, o5.scale, o5.offset);
                h3.colorAttachment.set(_3.particleTexture1.texture), a4.clear({ color: e.C.transparent }), t4.getOrCreateProgram("rasterParticleUpdate", { defines: o5.defines }).draw(t4, n4.TRIANGLES, e.af.disabled, e.ah.disabled, e.a.unblended, e.ag.disabled, d3, i4.id, t4.viewportBuffer, t4.quadTriangleIndexBuffer, t4.viewportSegments);
              }
            }(t3, o3, _2, d2);
          }(t2, i2, o2, r2), "translucent" === t2.renderPass && (function(t3, i3, o3, r3, a3) {
            const n3 = t3.context, s2 = n3.gl, l2 = i3.getSource().tileSize, c2 = 5 * (1 - e.a0(e.aV, e.aV + 1, t3.transform.zoom)) * l2 + o3.paint.get("raster-particle-elevation"), h2 = !t3.options.moving, _2 = "globe" === t3.transform.projection.name;
            if (!r3.length)
              return;
            const [u2, d2] = t3.stencilConfigForOverlap(r3), p2 = [];
            _2 && p2.push("PROJECTION_GLOBE_VIEW");
            const f2 = t3.stencilModeFor3D();
            for (const r4 of d2) {
              const a4 = r4.toUnwrapped(), l3 = i3.getTile(r4);
              if (!l3.rasterParticleState)
                continue;
              const d3 = l3.rasterParticleState, m2 = 100;
              l3.registerFadeDuration(m2);
              const g2 = i3.findLoadedParent(r4, 0), v2 = Ii(l3, g2, i3, t3.transform, m2);
              let x2, y2;
              t3.terrain && t3.terrain.prepareDrawTile(), n3.activeTexture.set(s2.TEXTURE0), d3.targetColorTexture.bind(s2.LINEAR, s2.CLAMP_TO_EDGE), n3.activeTexture.set(s2.TEXTURE1), g2 && g2.rasterParticleState ? (g2.rasterParticleState.targetColorTexture.bind(s2.LINEAR, s2.CLAMP_TO_EDGE), x2 = Math.pow(2, g2.tileID.overscaledZ - l3.tileID.overscaledZ), y2 = [l3.tileID.canonical.x * x2 % 1, l3.tileID.canonical.y * x2 % 1]) : d3.targetColorTexture.bind(s2.LINEAR, s2.CLAMP_TO_EDGE);
              const b2 = _2 ? Float32Array.from(t3.transform.expandedFarZProjMatrix) : t3.transform.calculateProjMatrix(a4, h2), w2 = t3.transform, T2 = Go(w2), E2 = e.be(r4.canonical), C2 = e.bf(E2.getCenter().lat);
              let S2, I2, L2, P2, R2;
              _2 ? (S2 = Float32Array.from(e.bh(e.bi(r4.canonical))), I2 = Float32Array.from(w2.globeMatrix), L2 = Float32Array.from(e.bd(w2)), P2 = [e.ak(w2.center.lng), e.al(w2.center.lat)], R2 = Float32Array.from(e.bg(r4.canonical, E2, C2, w2.worldSize / w2._pixelsPerMercatorPixel))) : (S2 = new Float32Array(16), I2 = new Float32Array(9), L2 = new Float32Array(16), P2 = [0, 0], R2 = new Float32Array(9));
              const D2 = oo(b2, S2, I2, L2, R2, y2 || [0, 0], e.a2(t3.transform.zoom), P2, T2, x2 || 1, v2, c2), A2 = t3.isTileAffectedByFog(r4), M2 = t3.getOrCreateProgram("rasterParticle", { defines: p2, overrideFog: A2 });
              if (t3.uploadCommonUniforms(n3, M2, a4), _2) {
                const i4 = new e.af(s2.LEQUAL, e.af.ReadOnly, t3.depthRangeFor3D), r5 = 0, a5 = t3.globeSharedBuffers;
                if (a5) {
                  const [n4, l4, c3] = a5.getGridBuffers(C2, 0 !== r5);
                  M2.draw(t3, s2.TRIANGLES, i4, f2, e.a.alphaBlended, t3.renderElevatedRasterBackface ? e.ag.frontCCW : e.ag.backCCW, D2, o3.id, n4, l4, c3);
                }
              } else {
                const i4 = t3.depthModeForSublayer(0, e.af.ReadOnly), a5 = u2[r4.overscaledZ], { tileBoundsBuffer: n4, tileBoundsIndexBuffer: c3, tileBoundsSegments: h3 } = t3.getTileBoundsBuffers(l3);
                M2.draw(t3, s2.TRIANGLES, i4, a5, e.a.alphaBlended, e.ag.disabled, D2, o3.id, n4, c3, h3);
              }
            }
            t3.resetStencilClippingMasks();
          }(t2, i2, o2, r2), t2.style.map.triggerRepaint());
        }, background: function(t2, i2, o2, r2) {
          const a2 = o2.paint.get("background-color"), n2 = o2.paint.get("background-opacity"), s2 = o2.paint.get("background-emissive-strength");
          if (0 === n2)
            return;
          const l2 = t2.context, c2 = l2.gl, h2 = t2.transform, _2 = h2.tileSize, u2 = o2.paint.get("background-pattern");
          let d2;
          if (void 0 !== u2) {
            if (null === u2)
              return;
            if (d2 = t2.imageManager.getPattern(u2.toString(), o2.scope, t2.style.getLut(o2.scope)), !d2)
              return;
          }
          const p2 = !u2 && 1 === a2.a && 1 === n2 && t2.opaquePassEnabledForLayer() ? "opaque" : "translucent";
          if (t2.renderPass !== p2)
            return;
          const f2 = e.ah.disabled, m2 = t2.depthModeForSublayer(0, "opaque" === p2 ? e.af.ReadWrite : e.af.ReadOnly), g2 = t2.colorModeForDrapableLayerRenderPass(s2), v2 = u2 ? "backgroundPattern" : "background";
          let x2, y2 = r2;
          y2 || (x2 = t2.getBackgroundTiles(), y2 = Object.values(x2).map((e2) => e2.tileID)), u2 && (l2.activeTexture.set(c2.TEXTURE0), t2.imageManager.bind(t2.context, o2.scope));
          for (const p3 of y2) {
            const y3 = t2.isTileAffectedByFog(p3), b2 = t2.getOrCreateProgram(v2, { overrideFog: y3 }), w2 = p3.toUnwrapped(), T2 = r2 ? p3.projMatrix : t2.transform.calculateProjMatrix(w2);
            t2.prepareDrawTile();
            const E2 = i2 ? i2.getTile(p3) : x2 ? x2[p3.key] : new e.bA(p3, _2, h2.zoom, t2), C2 = u2 ? _o(T2, s2, n2, t2, 0, o2.scope, d2, { tileID: p3, tileSize: _2 }) : ho(T2, s2, n2, a2.toRenderColor(o2.lut));
            t2.uploadCommonUniforms(l2, b2, w2);
            const { tileBoundsBuffer: S2, tileBoundsIndexBuffer: I2, tileBoundsSegments: L2 } = t2.getTileBoundsBuffers(E2);
            b2.draw(t2, c2.TRIANGLES, m2, f2, g2, e.ag.disabled, C2, o2.id, S2, I2, L2);
          }
        }, sky: function(t2, i2, o2) {
          const r2 = t2._atmosphere ? e.a2(t2.transform.zoom) : 1, a2 = o2.paint.get("sky-opacity") * r2;
          if (0 === a2)
            return;
          const n2 = t2.context, s2 = o2.paint.get("sky-type"), l2 = new e.af(n2.gl.LEQUAL, e.af.ReadOnly, [0, 1]), c2 = t2.frameCounter / 1e3 % 1;
          "atmosphere" === s2 ? "offscreen" === t2.renderPass ? o2.needsSkyboxCapture(t2) && (function(t3, i3, o3, r3) {
            const a3 = t3.context, n3 = a3.gl;
            let s3 = i3.skyboxFbo;
            if (!s3) {
              s3 = i3.skyboxFbo = a3.createFramebuffer(32, 32, true, null), i3.skyboxGeometry = new er(a3), i3.skyboxTexture = a3.gl.createTexture(), n3.bindTexture(n3.TEXTURE_CUBE_MAP, i3.skyboxTexture), n3.texParameteri(n3.TEXTURE_CUBE_MAP, n3.TEXTURE_WRAP_S, n3.CLAMP_TO_EDGE), n3.texParameteri(n3.TEXTURE_CUBE_MAP, n3.TEXTURE_WRAP_T, n3.CLAMP_TO_EDGE), n3.texParameteri(n3.TEXTURE_CUBE_MAP, n3.TEXTURE_MIN_FILTER, n3.LINEAR), n3.texParameteri(n3.TEXTURE_CUBE_MAP, n3.TEXTURE_MAG_FILTER, n3.LINEAR);
              for (let e2 = 0; e2 < 6; ++e2)
                n3.texImage2D(n3.TEXTURE_CUBE_MAP_POSITIVE_X + e2, 0, n3.RGBA, 32, 32, 0, n3.RGBA, n3.UNSIGNED_BYTE, null);
            }
            a3.bindFramebuffer.set(s3.framebuffer), a3.viewport.set([0, 0, 32, 32]);
            const l3 = i3.getCenter(t3, true), c3 = t3.getOrCreateProgram("skyboxCapture"), h2 = new Float64Array(16);
            e.ae.identity(h2), e.ae.rotateY(h2, h2, 0.5 * -Math.PI), tr(t3, i3, c3, h2, l3, 0), e.ae.identity(h2), e.ae.rotateY(h2, h2, 0.5 * Math.PI), tr(t3, i3, c3, h2, l3, 1), e.ae.identity(h2), e.ae.rotateX(h2, h2, 0.5 * -Math.PI), tr(t3, i3, c3, h2, l3, 2), e.ae.identity(h2), e.ae.rotateX(h2, h2, 0.5 * Math.PI), tr(t3, i3, c3, h2, l3, 3), e.ae.identity(h2), tr(t3, i3, c3, h2, l3, 4), e.ae.identity(h2), e.ae.rotateY(h2, h2, Math.PI), tr(t3, i3, c3, h2, l3, 5), a3.viewport.set([0, 0, t3.width, t3.height]);
          }(t2, o2), o2.markSkyboxValid(t2)) : "sky" === t2.renderPass && function(t3, i3, o3, r3, a3) {
            const n3 = t3.context, s3 = n3.gl, l3 = t3.transform, c3 = t3.getOrCreateProgram("skybox");
            n3.activeTexture.set(s3.TEXTURE0), s3.bindTexture(s3.TEXTURE_CUBE_MAP, i3.skyboxTexture);
            const h2 = ((e2, t4, i4, o4, r4) => ({ u_matrix: e2, u_sun_direction: t4, u_cubemap: 0, u_opacity: o4, u_temporal_offset: r4 }))(l3.skyboxMatrix, i3.getCenter(t3, false), 0, r3, a3);
            t3.uploadCommonUniforms(n3, c3), c3.draw(t3, s3.TRIANGLES, o3, e.ah.disabled, t3.colorModeForRenderPass(), e.ag.backCW, h2, "skybox", i3.skyboxGeometry.vertexBuffer, i3.skyboxGeometry.indexBuffer, i3.skyboxGeometry.segment);
          }(t2, o2, l2, a2, c2) : "gradient" === s2 && "sky" === t2.renderPass && function(t3, i3, o3, r3, a3) {
            const n3 = t3.context, s3 = n3.gl, l3 = t3.transform, c3 = t3.getOrCreateProgram("skyboxGradient");
            i3.skyboxGeometry || (i3.skyboxGeometry = new er(n3)), n3.activeTexture.set(s3.TEXTURE0);
            let h2 = i3.colorRampTexture;
            h2 || (h2 = i3.colorRampTexture = new e.T(n3, i3.colorRamp, s3.RGBA)), h2.bind(s3.LINEAR, s3.CLAMP_TO_EDGE);
            const _2 = ((t4, i4, o4, r4, a4) => ({ u_matrix: t4, u_color_ramp: 0, u_center_direction: i4, u_radius: e.ac(o4), u_opacity: r4, u_temporal_offset: a4 }))(l3.skyboxMatrix, i3.getCenter(t3, false), i3.paint.get("sky-gradient-radius"), r3, a3);
            t3.uploadCommonUniforms(n3, c3), c3.draw(t3, s3.TRIANGLES, o3, e.ah.disabled, t3.colorModeForRenderPass(), e.ag.backCW, _2, "skyboxGradient", i3.skyboxGeometry.vertexBuffer, i3.skyboxGeometry.indexBuffer, i3.skyboxGeometry.segment);
          }(t2, o2, l2, a2, c2);
        }, debug: function(t2, i2, o2, r2, a2, n2) {
          for (let s2 = 0; s2 < o2.length; s2++)
            if (a2) {
              const a3 = 1, l2 = 0.8, c2 = new e.C(r2.r * l2, r2.g * l2, r2.b * l2, 1);
              Ho(t2, i2, o2[s2], r2, -a3, -a3, n2), Ho(t2, i2, o2[s2], r2, -a3, a3, n2), Ho(t2, i2, o2[s2], r2, a3, a3, n2), Ho(t2, i2, o2[s2], r2, a3, -a3, n2), Ho(t2, i2, o2[s2], c2, 0, 0, n2);
            } else
              Ho(t2, i2, o2[s2], r2, 0, 0, n2);
        }, custom: function(t2, i2, o2, r2) {
          const a2 = t2.context, n2 = o2.implementation;
          if (!t2.transform.projection.unsupportedLayers || !t2.transform.projection.unsupportedLayers.includes("custom") || t2.terrain && (t2.terrain.renderingToTexture || "offscreen" === t2.renderPass) && o2.isDraped(i2)) {
            if ("offscreen" === t2.renderPass) {
              const i3 = n2.prerender;
              if (i3) {
                if (t2.setCustomLayerDefaults(), a2.setColorMode(t2.colorModeForRenderPass()), "globe" === t2.transform.projection.name) {
                  const o3 = t2.transform.pointMerc;
                  i3.call(n2, a2.gl, t2.transform.customLayerMatrix(), t2.transform.getProjection(), t2.transform.globeToMercatorMatrix(), e.a2(t2.transform.zoom), [o3.x, o3.y], t2.transform.pixelsPerMeterRatio);
                } else
                  i3.call(n2, a2.gl, t2.transform.customLayerMatrix());
                a2.setDirty(), t2.setBaseState();
              }
            } else if ("translucent" === t2.renderPass) {
              if (t2.terrain && t2.terrain.renderingToTexture) {
                const i4 = n2.renderToTile;
                if (i4) {
                  const o3 = r2[0].canonical, s2 = new e._(o3.x + r2[0].wrap * (1 << o3.z), o3.y, o3.z);
                  a2.setDepthMode(e.af.disabled), a2.setStencilMode(e.ah.disabled), a2.setColorMode(t2.colorModeForRenderPass()), t2.setCustomLayerDefaults(), i4.call(n2, a2.gl, s2), a2.setDirty(), t2.setBaseState();
                }
                return;
              }
              t2.setCustomLayerDefaults(), a2.setColorMode(t2.colorModeForRenderPass()), a2.setStencilMode(e.ah.disabled);
              const i3 = "3d" === n2.renderingMode ? new e.af(t2.context.gl.LEQUAL, e.af.ReadWrite, t2.depthRangeFor3D) : t2.depthModeForSublayer(0, e.af.ReadOnly);
              if (a2.setDepthMode(i3), "globe" === t2.transform.projection.name) {
                const i4 = t2.transform.pointMerc;
                n2.render(a2.gl, t2.transform.customLayerMatrix(), t2.transform.getProjection(), t2.transform.globeToMercatorMatrix(), e.a2(t2.transform.zoom), [i4.x, i4.y], t2.transform.pixelsPerMeterRatio);
              } else
                n2.render(a2.gl, t2.transform.customLayerMatrix());
              a2.setDirty(), t2.setBaseState(), a2.bindFramebuffer.set(null);
            }
          } else
            e.w("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
        }, model: function(t2, i2, o2, r2) {
          if ("opaque" === t2.renderPass)
            return;
          const a2 = o2.paint.get("model-opacity");
          if (0 === a2)
            return;
          const n2 = o2.paint.get("model-cast-shadows");
          if ("shadow" === t2.renderPass) {
            if (!n2)
              return;
            if (t2.terrain && a2 < 0.65 && o2._transitionablePaint._values["model-opacity"].value.expression instanceof e.Z)
              return;
          }
          const s2 = t2.shadowRenderer, l2 = o2.paint.get("model-receive-shadows");
          s2 && (s2.useNormalOffset = true, l2 || (s2.enabled = false));
          const c2 = () => {
            s2 && (s2.useNormalOffset = true, l2 || (s2.enabled = true));
          }, h2 = i2.getSource();
          if ("light-beam" === t2.renderPass && "batched-model" !== h2.type)
            return;
          if ("vector" === h2.type || "geojson" === h2.type)
            return function(t3, i3, o3, r3, a3) {
              const n3 = t3.transform;
              if ("mercator" !== n3.projection.name)
                return void e.w(`Drawing 3D models for ${n3.projection.name} projection is not yet implemented`);
              const s3 = n3.getFreeCameraOptions().position;
              if (!t3.modelManager)
                return;
              const l3 = t3.modelManager;
              o3.modelManager = l3;
              const c3 = t3.shadowRenderer;
              if (!o3._unevaluatedLayout._values.hasOwnProperty("model-id"))
                return;
              const h3 = o3._unevaluatedLayout._values["model-id"], _3 = __spreadValues({}, o3.layout.get("model-id").parameters), u3 = t3.style.order.indexOf(o3.fqid);
              for (const d3 of r3) {
                const r4 = i3.getTile(d3).getBucket(o3);
                if (!r4 || r4.projection.name !== n3.projection.name)
                  continue;
                const p3 = r4.getModelUris();
                p3 && !r4.modelsRequested && (l3.addModelsFromBucket(p3, a3), r4.modelsRequested = true);
                const f3 = pr(d3, n3);
                _3.zoom = f3;
                const m3 = h3.possiblyEvaluate(_3);
                if (ur(t3, r4, d3), dr.shadowUniformsInitialized = false, dr.useSingleShadowCascade = !!c3 && 0 === c3.getMaxCascadeForTile(d3.toUnwrapped()), "shadow" === t3.renderPass && c3) {
                  if (1 === t3.currentShadowCascade && r4.isInsideFirstShadowMapFrustum)
                    continue;
                  const i4 = n3.calculatePosMatrix(d3.toUnwrapped(), n3.worldSize);
                  if (dr.tileMatrix.set(i4), dr.shadowTileMatrix = Float32Array.from(c3.calculateShadowPassMatrixFromMatrix(i4)), dr.aabb.min.fill(0), dr.aabb.max[0] = dr.aabb.max[1] = e.a4, dr.aabb.max[2] = 0, gr(r4, dr, t3, o3.scope))
                    continue;
                }
                const g3 = 1 << d3.canonical.z, v2 = [((s3.x - d3.wrap) * g3 - d3.canonical.x) * e.a4, (s3.y * g3 - d3.canonical.y) * e.a4, s3.z * g3 * e.a4];
                t3.conflationActive && Object.keys(r4.instancesPerModel).length > 0 && t3.style.isLayerClipped(o3, i3.getSource()) && r4.updateReplacement(d3, t3.replacementSource, u3, a3) && (r4.uploaded = false, r4.upload(t3.context));
                for (let e2 in r4.instancesPerModel) {
                  const i4 = r4.instancesPerModel[e2];
                  i4.features.length > 0 && (e2 = m3.evaluate(i4.features[0].feature, {}));
                  const n4 = l3.getModel(e2, a3);
                  if (n4 && n4.uploaded)
                    for (const e3 of n4.nodes)
                      fr(t3, o3, e3, i4, v2, d3, dr);
                }
              }
            }(t2, i2, o2, r2, "vector" === h2.type ? o2.scope : ""), void c2();
          if (!h2.loaded())
            return;
          if ("batched-model" === h2.type)
            return function(t3, i3, o3, r3) {
              o3.resetLayerRenderingStats(t3);
              const a3 = t3.context, n3 = t3.transform, s3 = t3.style.fog, l3 = t3.shadowRenderer;
              if ("mercator" !== n3.projection.name)
                return void e.w(`Drawing 3D landmark models for ${n3.projection.name} projection is not yet implemented`);
              const c3 = t3.transform.getFreeCameraOptions().position, h3 = e.$.scale([], [c3.x, c3.y, c3.z], t3.transform.worldSize);
              e.$.negate(h3, h3);
              const _3 = e.ae.identity([]), u3 = e.ci(n3.center.lat, n3.zoom), d3 = e.ae.fromScaling([], [1, 1, 1 / u3]);
              e.ae.translate(_3, _3, h3);
              const p3 = o3.paint.get("model-opacity"), f3 = new e.af(a3.gl.LEQUAL, e.af.ReadWrite, t3.depthRangeFor3D), m3 = new e.af(a3.gl.LEQUAL, e.af.ReadOnly, t3.depthRangeFor3D), g3 = new e.b8([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), v2 = "shadow" === t3.renderPass, x2 = v2 && l3 ? l3.getCurrentCascadeFrustum() : n3.getFrustum(n3.scaleZoom(n3.worldSize)), y2 = o3.paint.get("model-front-cutoff"), b2 = y2[2] < 1, w2 = ui(t3, o3.paint.get("model-cutoff-fade-range")), T2 = o3.getLayerRenderingStats();
              (function(e2, t4, i4, o4) {
                const r4 = e2.terrain ? e2.terrain.exaggeration() : 0, a4 = e2.transform.zoom;
                for (const n4 of o4) {
                  const o5 = t4.getTile(n4).getBucket(i4);
                  o5 && (e2.conflationActive && o5.updateReplacement(n4, e2.replacementSource), o5.evaluateScale(e2, i4), e2.terrain && r4 > 0 && o5.elevationUpdate(e2.terrain, r4, n4, i4.source), o5.needsReEvaluation(e2, a4, i4) && o5.evaluate(i4));
                }
              })(t3, i3, o3, r3), function() {
                let c4, h4, u4;
                b2 ? (c4 = r3.length - 1, h4 = -1, u4 = -1) : (c4 = 0, h4 = r3.length, u4 = 1);
                for (let E2 = c4; E2 !== h4; E2 += u4) {
                  const c5 = r3[E2], h5 = i3.getTile(c5).getBucket(o3);
                  if (!h5 || !h5.uploaded)
                    continue;
                  let u5 = false;
                  l3 && (u5 = 0 === l3.getMaxCascadeForTile(c5.toUnwrapped()));
                  const C2 = n3.calculatePosMatrix(c5.toUnwrapped(), n3.worldSize), S2 = h5.modelTraits, I2 = [];
                  for (const i4 of h5.getNodesInfo()) {
                    if (i4.hiddenByReplacement)
                      continue;
                    if (!i4.node.meshes)
                      continue;
                    const o4 = i4.node;
                    let r4 = 0;
                    t3.terrain && o4.elevation && (r4 = o4.elevation * t3.terrain.exaggeration());
                    const a4 = i4.evaluatedScale;
                    if (a4[0] <= 1 && a4[1] <= 1 && a4[2] <= 1 && 0 === (() => {
                      const t4 = i4.aabb;
                      return g3.min = [...t4.min], g3.max = [...t4.max], g3.min[2] += r4, g3.max[2] += r4, e.$.transformMat4(g3.min, g3.min, C2), e.$.transformMat4(g3.max, g3.max, C2), g3;
                    })().intersects(x2))
                      continue;
                    const s4 = [...C2], l4 = o4.anchor ? o4.anchor[0] : 0, c6 = o4.anchor ? o4.anchor[1] : 0;
                    e.ae.translate(s4, s4, [l4 * (a4[0] - 1), c6 * (a4[1] - 1), r4]), e.$.exactEquals(a4, e.cl) || e.ae.scale(s4, s4, a4);
                    const h6 = e.ae.multiply([], s4, o4.matrix), _4 = e.ae.multiply([], n3.expandedFarZProjMatrix, h6), u6 = e.ae.multiply([], n3.expandedFarZProjMatrix, s4), d4 = e.aB.transformMat4([], [l4, c6, r4, 1], _4)[2];
                    o4.hidden = false;
                    let f4 = p3;
                    v2 || (b2 && (f4 *= xr(s4, n3, i4.aabb, y2)), f4 *= vr(w2, d4)), 0 !== f4 ? I2.push({ nodeInfo: i4, depth: d4, opacity: f4, wvpForNode: _4, wvpForTile: u6, nodeModelMatrix: h6, tileModelMatrix: s4 }) : o4.hidden = true;
                  }
                  v2 || I2.sort((e2, t4) => !b2 || 1 === e2.opacity && 1 === t4.opacity ? e2.depth < t4.depth ? -1 : 1 : 1 === e2.opacity ? -1 : 1 === t4.opacity ? 1 : e2.depth > t4.depth ? -1 : 1);
                  for (const i4 of I2) {
                    const r4 = i4.nodeInfo, c6 = r4.node;
                    let h6 = e.ae.multiply([], d3, i4.tileModelMatrix);
                    e.ae.multiply(h6, _3, h6);
                    const p4 = e.ae.invert([], h6);
                    e.ae.transpose(p4, p4), e.ae.scale(p4, p4, mr), h6 = e.ae.multiply(h6, h6, c6.matrix);
                    const g4 = "light-beam" === t3.renderPass, x3 = S2 & e.cn.HasMapboxMeshFeatures, y3 = x3 ? 0 : r4.evaluatedRMEA[0][2];
                    for (let _4 = 0; _4 < c6.meshes.length; ++_4) {
                      const d4 = c6.meshes[_4], b3 = _4 === c6.lightMeshIndex;
                      let w3 = i4.wvpForNode;
                      if (b3) {
                        if (!g4 && !t3.terrain && t3.shadowRenderer) {
                          t3.currentLayer < t3.firstLightBeamLayer && (t3.firstLightBeamLayer = t3.currentLayer);
                          continue;
                        }
                        w3 = i4.wvpForTile;
                      } else if (g4)
                        continue;
                      const E3 = { defines: [] }, C3 = [];
                      if (lr(E3.defines, C3, d4, t3, o3.lut), x3 || E3.defines.push("DIFFUSE_SHADED"), u5 && E3.defines.push("SHADOWS_SINGLE_CASCADE"), T2 && (v2 ? T2.numRenderedVerticesInShadowPass += d4.vertexArray.length : T2.numRenderedVerticesInTransparentPass += d4.vertexArray.length), v2) {
                        _r(d4, i4.nodeModelMatrix, t3, o3);
                        continue;
                      }
                      let S3 = null;
                      if (s3) {
                        const e2 = sr(i4.nodeModelMatrix, t3.transform);
                        if (S3 = new Float32Array(e2), "globe" !== n3.projection.name) {
                          const t4 = d4.aabb.min, i5 = d4.aabb.max, [o4, r5] = s3.getOpacityForBounds(e2, t4[0], t4[1], i5[0], i5[1]);
                          E3.overrideFog = o4 >= Ke || r5 >= Ke;
                        }
                      }
                      const I3 = d4.material;
                      let L2;
                      I3.occlusionTexture && I3.occlusionTexture.offsetScale && (L2 = I3.occlusionTexture.offsetScale, E3.defines.push("OCCLUSION_TEXTURE_TRANSFORM")), !v2 && l3 && (l3.useNormalOffset = !!d4.normalBuffer);
                      const P2 = t3.getOrCreateProgram("model", E3);
                      !v2 && l3 && l3.setupShadowsFromMatrix(i4.tileModelMatrix, P2, l3.useNormalOffset), t3.uploadCommonUniforms(a3, P2, null, S3);
                      const R2 = I3.pbrMetallicRoughness;
                      R2.metallicFactor = 0.9, R2.roughnessFactor = 0.5;
                      const D2 = po(new Float32Array(w3), new Float32Array(h6), new Float32Array(p4), new Float32Array(c6.matrix), t3, i4.opacity, R2.baseColorFactor.toRenderColor(null), I3.emissiveFactor, R2.metallicFactor, R2.roughnessFactor, I3, y3, o3, [0, 0, 0], L2);
                      !b3 && (r4.hasTranslucentParts || i4.opacity < 1) && P2.draw(t3, a3.gl.TRIANGLES, f3, e.ah.disabled, e.a.disabled, e.ag.backCCW, D2, o3.id, d4.vertexBuffer, d4.indexBuffer, d4.segments, o3.paint, t3.transform.zoom, void 0, C3), P2.draw(t3, a3.gl.TRIANGLES, b3 ? m3 : f3, e.ah.disabled, b3 || i4.opacity < 1 || r4.hasTranslucentParts ? e.a.alphaBlended : e.a.unblended, e.ag.backCCW, D2, o3.id, d4.vertexBuffer, d4.indexBuffer, d4.segments, o3.paint, t3.transform.zoom, void 0, C3);
                    }
                  }
                }
              }();
            }(t2, i2, o2, r2), void c2();
          if ("model" !== h2.type)
            return;
          const _2 = h2.getModels(), u2 = [], d2 = t2.transform.getFreeCameraOptions().position, p2 = e.$.scale([], [d2.x, d2.y, d2.z], t2.transform.worldSize);
          e.$.negate(p2, p2);
          const f2 = [], m2 = [];
          let g2 = 0;
          for (const i3 of _2) {
            const r3 = o2.paint.get("model-rotation").constantOr(null), a3 = o2.paint.get("model-scale").constantOr(null), n3 = o2.paint.get("model-translation").constantOr(null);
            i3.computeModelMatrix(t2, r3, a3, n3, true, true, false);
            const s3 = e.ae.identity([]), l3 = e.ci(i3.position.lat, t2.transform.zoom), c3 = e.ae.fromScaling([], [1, 1, 1 / l3]);
            e.ae.translate(s3, s3, p2), u2.push({ zScaleMatrix: c3, negCameraPosMatrix: s3 });
            for (const e2 of i3.nodes)
              hr(t2.transform, e2, i3.matrix, t2.transform.expandedFarZProjMatrix, g2, f2, m2);
            g2++;
          }
          if (f2.sort((e2, t3) => t3.depth - e2.depth), "shadow" !== t2.renderPass) {
            if (1 === a2)
              for (const i3 of m2)
                cr(i3, t2, o2, u2[i3.modelIndex], e.ah.disabled, t2.colorModeForRenderPass());
            else {
              for (const i3 of m2)
                cr(i3, t2, o2, u2[i3.modelIndex], e.ah.disabled, e.a.disabled);
              for (const e2 of m2)
                cr(e2, t2, o2, u2[e2.modelIndex], t2.stencilModeFor3D(), t2.colorModeForRenderPass());
              t2.resetStencilClippingMasks();
            }
            for (const i3 of f2)
              cr(i3, t2, o2, u2[i3.modelIndex], e.ah.disabled, t2.colorModeForRenderPass());
            c2();
          } else {
            for (const e2 of m2)
              _r(e2.mesh, e2.nodeModelMatrix, t2, o2);
            for (const e2 of f2)
              _r(e2.mesh, e2.nodeModelMatrix, t2, o2);
            c2();
          }
        } }, Er = { model: function(e2, t2, i2) {
          const o2 = t2.getSource();
          if (!o2.loaded())
            return;
          if ("vector" === o2.type || "geojson" === o2.type)
            return void (i2.modelManager && i2.modelManager.upload(i2, "vector" === o2.type ? e2.scope : ""));
          if ("batched-model" === o2.type)
            return;
          if ("model" !== o2.type)
            return;
          const r2 = o2.getModels();
          for (const e3 of r2)
            e3.upload(i2.context);
        }, raster: function(e2, t2, i2) {
          const o2 = t2.getSource();
          if (!(o2 instanceof Li && o2.loaded()))
            return;
          const r2 = e2.sourceLayer || o2.rasterLayerIds && o2.rasterLayerIds[0];
          if (!r2)
            return;
          const a2 = e2.paint.get("raster-array-band") || o2.getInitialBand(r2);
          if (null == a2)
            return;
          const n2 = t2.getIds().map((e3) => t2.getTileByID(e3));
          for (const e3 of n2)
            e3.updateNeeded(r2, a2) && o2.prepareTile(e3, r2, a2);
        }, "raster-particle": function(e2, t2, i2) {
          const o2 = t2.getSource();
          if (!(o2 instanceof Li && o2.loaded()))
            return;
          const r2 = e2.sourceLayer || o2.rasterLayerIds && o2.rasterLayerIds[0];
          if (!r2)
            return;
          const a2 = e2.paint.get("raster-particle-array-band") || o2.getInitialBand(r2);
          if (null == a2)
            return;
          const n2 = t2.getIds().map((e3) => t2.getTileByID(e3));
          for (const e3 of n2)
            e3.updateNeeded(r2, a2) && o2.prepareTile(e3, r2, a2);
        } };
        class Cr {
          constructor(t2, i2, o2, r2) {
            this.context = new re(t2, i2), this.transform = o2, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.tp = r2, this._timeStamp = e.e.now(), this._averageFPS = 0, this._fpsHistory = [], this._dt = 0, this._debugParams = { showTerrainProxyTiles: false, fpsWindow: 30, continousRedraw: false, enabledLayers: {} };
            const a2 = ["fill", "line", "symbol", "circle", "heatmap", "fill-extrusion", "raster", "raster-particle", "hillshade", "model", "background", "sky"];
            for (const e2 of a2)
              this._debugParams.enabledLayers[e2] = true;
            r2.registerParameter(this._debugParams, ["Terrain"], "showTerrainProxyTiles", {}, () => {
              this.style.map.triggerRepaint();
            }), r2.registerParameter(this._debugParams, ["FPS"], "fpsWindow", { min: 1, max: 100, step: 1 }), r2.registerBinding(this._debugParams, ["FPS"], "continousRedraw", { readonly: true, label: "continuous redraw" }), r2.registerBinding(this, ["FPS"], "_averageFPS", { readonly: true, label: "value" }), r2.registerBinding(this, ["FPS"], "_averageFPS", { readonly: true, label: "graph", view: "graph", min: 0, max: 200 });
            for (const e2 of a2)
              r2.registerParameter(this._debugParams.enabledLayers, ["Debug", "Layers"], e2);
            this.occlusionParams = new wr(r2), this.setup(), this.numSublayers = e.bx.maxUnderzooming + e.bx.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {}, this.conflationActive = false, this.replacementSource = new e.cp(), this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = false, this._cachedTileFogOpacities = {}, this._shadowRenderer = new mi(this), this._wireframeDebugCache = new br(), this.renderDefaultNorthPole = true, this.renderDefaultSouthPole = true, this.layersWithOcclusionOpacity = [];
            const n2 = new e.j({ width: 1, height: 1 }, Uint8Array.of(0, 0, 0, 0));
            this.emptyDepthTexture = new e.T(this.context, n2, t2.RGBA);
          }
          updateTerrain(e2, t2) {
            const i2 = !!e2 && !!e2.terrain && this.transform.projection.supportsTerrain;
            if (!(i2 || this._terrain && this._terrain.enabled))
              return;
            this._terrain || (this._terrain = new zi(this, e2));
            const o2 = this._terrain;
            this.transform.elevation = i2 ? o2 : null, o2.update(e2, this.transform, t2), this.transform.elevation && !o2.enabled && (this.transform.elevation = null);
          }
          _updateFog(e2) {
            const t2 = e2.fog;
            if (!t2 || "globe" === this.transform.projection.name || t2.getOpacity(this.transform.pitch) < 1 || t2.properties.get("horizon-blend") < 0.03)
              return void (this.transform.fogCullDistSq = null);
            const [i2, o2] = t2.getFovAdjustedRange(this.transform._fov);
            if (i2 > o2)
              return void (this.transform.fogCullDistSq = null);
            const r2 = i2 + 0.78 * (o2 - i2);
            this.transform.fogCullDistSq = r2 * r2;
          }
          get terrain() {
            return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled || this._forceTerrainMode ? this._terrain : null;
          }
          get forceTerrainMode() {
            return this._forceTerrainMode;
          }
          set forceTerrainMode(e2) {
            e2 && !this._terrain && (this._terrain = new zi(this, this.style)), this._forceTerrainMode = e2;
          }
          get shadowRenderer() {
            return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
          }
          get wireframeDebugCache() {
            return this._wireframeDebugCache;
          }
          resize(t2, i2) {
            if (this.width = t2 * e.e.devicePixelRatio, this.height = i2 * e.e.devicePixelRatio, this.context.viewport.set([0, 0, this.width, this.height]), this.style)
              for (const e2 of this.style.order)
                this.style._mergedLayers[e2].resize();
          }
          setup() {
            const t2 = this.context, i2 = new e.bv();
            i2.emplaceBack(0, 0), i2.emplaceBack(e.a4, 0), i2.emplaceBack(0, e.a4), i2.emplaceBack(e.a4, e.a4), this.tileExtentBuffer = t2.createVertexBuffer(i2, e.bt.members), this.tileExtentSegments = e.b.simpleSegment(0, 0, 4, 2);
            const o2 = new e.bv();
            o2.emplaceBack(0, 0), o2.emplaceBack(e.a4, 0), o2.emplaceBack(0, e.a4), o2.emplaceBack(e.a4, e.a4), this.debugBuffer = t2.createVertexBuffer(o2, e.bt.members), this.debugSegments = e.b.simpleSegment(0, 0, 4, 5);
            const r2 = new e.bv();
            r2.emplaceBack(-1, -1), r2.emplaceBack(1, -1), r2.emplaceBack(-1, 1), r2.emplaceBack(1, 1), this.viewportBuffer = t2.createVertexBuffer(r2, e.bt.members), this.viewportSegments = e.b.simpleSegment(0, 0, 4, 2);
            const a2 = new e.cq();
            a2.emplaceBack(0, 0, 0, 0), a2.emplaceBack(e.a4, 0, e.a4, 0), a2.emplaceBack(0, e.a4, 0, e.a4), a2.emplaceBack(e.a4, e.a4, e.a4, e.a4), this.mercatorBoundsBuffer = t2.createVertexBuffer(a2, e.cr.members), this.mercatorBoundsSegments = e.b.simpleSegment(0, 0, 4, 2);
            const n2 = new e.bw();
            n2.emplaceBack(0, 1, 2), n2.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t2.createIndexBuffer(n2);
            const s2 = new e.cs();
            for (const e2 of [0, 1, 3, 2, 0])
              s2.emplaceBack(e2);
            this.debugIndexBuffer = t2.createIndexBuffer(s2), this.emptyTexture = new e.T(t2, new e.j({ width: 1, height: 1 }, Uint8Array.of(0, 0, 0, 0)), t2.gl.RGBA), this.identityMat = e.ae.create();
            const l2 = this.context.gl;
            this.stencilClearMode = new e.ah({ func: l2.ALWAYS, mask: 0 }, 0, 255, l2.ZERO, l2.ZERO, l2.ZERO), this.loadTimeStamps.push(performance.now());
          }
          getMercatorTileBoundsBuffers() {
            return { tileBoundsBuffer: this.mercatorBoundsBuffer, tileBoundsIndexBuffer: this.quadTriangleIndexBuffer, tileBoundsSegments: this.mercatorBoundsSegments };
          }
          getTileBoundsBuffers(e2) {
            return e2._makeTileBoundsBuffers(this.context, this.transform.projection), e2._tileBoundsBuffer ? { tileBoundsBuffer: e2._tileBoundsBuffer, tileBoundsIndexBuffer: e2._tileBoundsIndexBuffer, tileBoundsSegments: e2._tileBoundsSegments } : this.getMercatorTileBoundsBuffers();
          }
          clearStencil() {
            const t2 = this.context.gl;
            this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.getOrCreateProgram("clippingMask").draw(this, t2.TRIANGLES, e.af.disabled, this.stencilClearMode, e.a.disabled, e.ag.disabled, Si(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
          }
          resetStencilClippingMasks() {
            this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
          }
          _renderTileClippingMasks(t2, i2, o2) {
            if (!i2 || this.currentStencilSource === i2.id || !t2.isTileClipped() || !o2 || 0 === o2.length)
              return;
            if (this._tileClippingMaskIDs && !this.terrain) {
              let e2 = false;
              for (const t3 of o2)
                if (void 0 === this._tileClippingMaskIDs[t3.key]) {
                  e2 = true;
                  break;
                }
              if (!e2)
                return;
            }
            this.currentStencilSource = i2.id;
            const r2 = this.context, a2 = r2.gl;
            this.nextStencilID + o2.length > 256 && this.clearStencil(), r2.setColorMode(e.a.disabled), r2.setDepthMode(e.af.disabled);
            const n2 = this.getOrCreateProgram("clippingMask");
            this._tileClippingMaskIDs = {};
            for (const t3 of o2) {
              const o3 = i2.getTile(t3), r3 = this._tileClippingMaskIDs[t3.key] = this.nextStencilID++, { tileBoundsBuffer: s2, tileBoundsIndexBuffer: l2, tileBoundsSegments: c2 } = this.getTileBoundsBuffers(o3);
              n2.draw(this, a2.TRIANGLES, e.af.disabled, new e.ah({ func: a2.ALWAYS, mask: 0 }, r3, 255, a2.KEEP, a2.KEEP, a2.REPLACE), e.a.disabled, e.ag.disabled, Si(t3.projMatrix), "$clipping", s2, l2, c2);
            }
          }
          stencilModeFor3D() {
            this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
            const t2 = this.nextStencilID++, i2 = this.context.gl;
            return new e.ah({ func: i2.NOTEQUAL, mask: 255 }, t2, 255, i2.KEEP, i2.KEEP, i2.REPLACE);
          }
          stencilModeForClipping(t2) {
            if (this.terrain)
              return this.terrain.stencilModeForRTTOverlap(t2);
            const i2 = this.context.gl;
            return new e.ah({ func: i2.EQUAL, mask: 255 }, this._tileClippingMaskIDs[t2.key], 0, i2.KEEP, i2.KEEP, i2.REPLACE);
          }
          stencilConfigForOverlap(t2) {
            const i2 = this.context.gl, o2 = t2.sort((e2, t3) => t3.overscaledZ - e2.overscaledZ), r2 = o2[o2.length - 1].overscaledZ, a2 = o2[0].overscaledZ - r2 + 1;
            if (a2 > 1) {
              this.currentStencilSource = void 0, this.nextStencilID + a2 > 256 && this.clearStencil();
              const t3 = {};
              for (let o3 = 0; o3 < a2; o3++)
                t3[o3 + r2] = new e.ah({ func: i2.GEQUAL, mask: 255 }, o3 + this.nextStencilID, 255, i2.KEEP, i2.KEEP, i2.REPLACE);
              return this.nextStencilID += a2, [t3, o2];
            }
            return [{ [r2]: e.ah.disabled }, o2];
          }
          colorModeForRenderPass() {
            const t2 = this.context.gl;
            if (this._showOverdrawInspector) {
              const i2 = 1 / 8;
              return new e.a([t2.CONSTANT_COLOR, t2.ONE, t2.CONSTANT_COLOR, t2.ONE], new e.C(i2, i2, i2, 0), [true, true, true, true]);
            }
            return "opaque" === this.renderPass ? e.a.unblended : e.a.alphaBlended;
          }
          colorModeForDrapableLayerRenderPass(t2) {
            const i2 = this.context.gl;
            return (() => this.style && this.style.enable3dLights() && this.terrain && this.terrain.renderingToTexture)() && "translucent" === this.renderPass ? new e.a([i2.ONE, i2.ONE_MINUS_SRC_ALPHA, i2.CONSTANT_ALPHA, i2.ONE_MINUS_SRC_ALPHA], new e.C(0, 0, 0, void 0 === t2 ? 0 : t2), [true, true, true, true]) : this.colorModeForRenderPass();
          }
          depthModeForSublayer(t2, i2, o2, r2 = false) {
            if (this.depthOcclusion)
              return new e.af(this.context.gl.GREATER, e.af.ReadOnly, this.depthRangeFor3D);
            if (!this.opaquePassEnabledForLayer() && !r2)
              return e.af.disabled;
            const a2 = 1 - ((1 + this.currentLayer) * this.numSublayers + t2) * this.depthEpsilon;
            return new e.af(o2 || this.context.gl.LEQUAL, i2, [a2, a2]);
          }
          opaquePassEnabledForLayer() {
            return this.currentLayer < this.opaquePassCutoff;
          }
          blitDepth() {
            const t2 = this.context.gl, i2 = Math.ceil(this.width), o2 = Math.ceil(this.height), r2 = this.context.bindFramebuffer.get(), a2 = t2.getParameter(t2.TEXTURE_BINDING_2D);
            this.depthFBO && this.depthFBO.width === i2 && this.depthFBO.height === o2 || (this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), 0 !== i2 && 0 !== o2 && (this.depthFBO = new oe(this.context, i2, o2, false, "texture"), this.depthTexture = new e.T(this.context, { width: i2, height: o2, data: null }, t2.DEPTH_STENCIL), this.depthFBO.depthAttachment.set(this.depthTexture.texture))), this.context.bindFramebuffer.set(r2), t2.bindTexture(t2.TEXTURE_2D, a2), this.depthFBO && (t2.bindFramebuffer(t2.READ_FRAMEBUFFER, null), t2.bindFramebuffer(t2.DRAW_FRAMEBUFFER, this.depthFBO.framebuffer), t2.blitFramebuffer(0, 0, i2, o2, 0, 0, i2, o2, t2.DEPTH_BUFFER_BIT, t2.NEAREST), t2.bindFramebuffer(t2.FRAMEBUFFER, this.context.bindFramebuffer.current));
          }
          updateAverageFPS() {
            this._fpsHistory.push(0 === this._dt ? 0 : 1e3 / this._dt), this._fpsHistory.length > this._debugParams.fpsWindow && this._fpsHistory.splice(0, this._fpsHistory.length - this._debugParams.fpsWindow), this._averageFPS = Math.round(this._fpsHistory.reduce((e2, t2) => e2 + t2 / this._fpsHistory.length, 0));
          }
          render(t2, i2) {
            const o2 = e.e.now();
            this._dt = o2 - this._timeStamp, this._timeStamp = o2, this._wireframeDebugCache.update(this.frameCounter), this._debugParams.continousRedraw = t2.map.repaint, this.style = t2, this.options = i2;
            const r2 = this.style._mergedLayers, a2 = this.style.order.filter((e2) => {
              const t3 = r2[e2];
              return !(t3.type in this._debugParams.enabledLayers) || this._debugParams.enabledLayers[t3.type];
            });
            let n2 = false, s2 = false;
            for (const e2 of a2) {
              const t3 = r2[e2];
              "circle" === t3.type && (n2 = true), "symbol" === t3.type && (t3.hasInitialOcclusionOpacityProperties ? s2 = true : n2 = true);
            }
            const l2 = a2.map((e2) => r2[e2]), c2 = this.style._mergedSourceCaches;
            this.imageManager = t2.imageManager, this.modelManager = t2.modelManager, this.symbolFadeChange = t2.placement.symbolFadeChange(e.e.now()), this.imageManager.beginFrame();
            let h2 = 0, _2 = false;
            for (const e2 in c2) {
              const t3 = c2[e2];
              t3.used && (t3.prepare(this.context), t3.getSource().usedInConflation && ++h2);
            }
            let u2 = false;
            for (const e2 of l2)
              e2.isHidden(this.transform.zoom) || ("clip" === e2.type && (u2 = true), this.prepareLayer(e2));
            const d2 = {}, p2 = {}, f2 = {}, m2 = {}, g2 = {};
            for (const e2 in c2) {
              const t3 = c2[e2];
              d2[e2] = t3.getVisibleCoordinates(), p2[e2] = d2[e2].slice().reverse(), f2[e2] = t3.getVisibleCoordinates(true).reverse(), m2[e2] = t3.getShadowCasterCoordinates(), g2[e2] = t3.sortCoordinatesByDistance(d2[e2]);
            }
            const v2 = (e2) => {
              const t3 = this.style.getLayerSourceCache(e2);
              return t3 && t3.used ? t3.getSource() : null;
            };
            if (h2 || u2) {
              const t3 = [], i3 = [];
              let o3 = 0;
              for (const e2 of l2)
                this.isSourceForClippingOrConflation(e2, v2(e2)) && (t3.push(e2), i3.push(o3)), o3++;
              if (t3 && (u2 || t3.length > 1)) {
                const o4 = [];
                for (let r3 = 0; r3 < t3.length; r3++) {
                  const a3 = t3[r3], n3 = i3[r3], s3 = this.style.getLayerSourceCache(a3);
                  if (!s3 || !s3.used || !s3.getSource().usedInConflation && "clip" !== a3.type)
                    continue;
                  let l3 = e.cv, c3 = e.cw.None;
                  const h3 = [];
                  if ("clip" === a3.type) {
                    l3 = n3;
                    for (const t4 of a3.layout.get("clip-layer-types"))
                      c3 |= "model" === t4 ? e.cw.Model : "symbol" === t4 ? e.cw.Symbol : e.cw.FillExtrusion;
                    for (const e2 of a3.layout.get("clip-layer-scope"))
                      h3.push(e2);
                  }
                  o4.push({ layer: a3.fqid, cache: s3, order: l3, clipMask: c3, clipScope: h3 });
                }
                this.replacementSource.setSources(o4), _2 = true;
              }
            }
            _2 || this.replacementSource.clear(), this.conflationActive = _2, this.minCutoffZoom = 0, this.longestCutoffRange = 0, this.opaquePassCutoff = 1 / 0, this._lastOcclusionLayer = -1, this.layersWithOcclusionOpacity = [];
            for (let e2 = 0; e2 < l2.length; e2++) {
              const t3 = l2[e2], i3 = t3.cutoffRange();
              if (this.longestCutoffRange = Math.max(i3, this.longestCutoffRange), i3 > 0) {
                const e3 = v2(t3);
                e3 && (this.minCutoffZoom = Math.max(e3.minzoom, this.minCutoffZoom)), t3.minzoom && (this.minCutoffZoom = Math.max(t3.minzoom, this.minCutoffZoom));
              }
              t3.is3D() && (this.opaquePassCutoff === 1 / 0 && (this.opaquePassCutoff = e2), this._lastOcclusionLayer = e2);
            }
            const x2 = this.style && this.style.fog;
            x2 ? (this._fogVisible = 0 !== x2.getOpacity(this.transform.pitch), this._fogVisible && "globe" !== this.transform.projection.name && (this._fogVisible = x2.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = false, this._cachedTileFogOpacities = {}, this.terrain && (this.terrain.updateTileBinding(f2), this.opaquePassCutoff = 0);
            const y2 = this._shadowRenderer;
            if (y2) {
              y2.updateShadowParameters(this.transform, this.style.directionalLight);
              for (const e2 in c2)
                for (const t3 of d2[e2]) {
                  let e3 = { min: 0, max: 0 };
                  this.terrain && (e3 = this.terrain.getMinMaxForTile(t3) || e3), y2.addShadowReceiver(t3.toUnwrapped(), e3.min, e3.max);
                }
            }
            if ("globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new e.ct(this.context)), this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new nr(this)), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), !e.cu(this.context.gl))
              return;
            this.renderPass = "offscreen";
            for (const e2 of l2) {
              const i3 = t2.getLayerSourceCache(e2);
              if (!e2.hasOffscreenPass() || e2.isHidden(this.transform.zoom))
                continue;
              const o3 = i3 ? p2[i3.id] : void 0;
              ("custom" === e2.type || "raster" === e2.type || "raster-particle" === e2.type || e2.isSky() || o3 && o3.length) && this.renderLayer(this, i3, e2, o3);
            }
            this.depthRangeFor3D = [0, 1 - (l2.length + 2) * this.numSublayers * this.depthEpsilon], this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, m2)), this.context.bindFramebuffer.set(null), this.context.viewport.set([0, 0, this.width, this.height]);
            const b2 = "globe" === this.transform.projection.name || this.transform.isHorizonVisible(), w2 = (() => {
              if (i2.showOverdrawInspector)
                return e.C.black;
              const t3 = this.style.fog;
              if (t3 && this.transform.projection.supportsFog) {
                const i3 = this.style.getLut(t3.scope);
                if (!b2) {
                  const o3 = t3.properties.get("color").toRenderColor(i3).toArray01();
                  return new e.C(...o3);
                }
                if (b2) {
                  const o3 = t3.properties.get("space-color").toRenderColor(i3).toArray01();
                  return new e.C(...o3);
                }
              }
              return e.C.transparent;
            })();
            if (this.context.clear({ color: w2, depth: 1 }), this.clearStencil(), this._showOverdrawInspector = i2.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && b2 && this._atmosphere.drawStars(this, this.style.fog), !this.terrain)
              for (this.currentLayer = a2.length - 1; this.currentLayer >= 0; this.currentLayer--) {
                const e2 = l2[this.currentLayer], i3 = t2.getLayerSourceCache(e2);
                if (e2.isSky())
                  continue;
                const o3 = i3 ? (e2.is3D() ? g2 : p2)[i3.id] : void 0;
                this._renderTileClippingMasks(e2, i3, o3), this.renderLayer(this, i3, e2, o3);
              }
            if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && b2 && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || e.a2(this.transform.zoom) > 0) && ("globe" === this.transform.projection.name || this.transform.isHorizonVisible()))
              for (this.currentLayer = 0; this.currentLayer < a2.length; this.currentLayer++) {
                const e2 = l2[this.currentLayer], i3 = t2.getLayerSourceCache(e2);
                e2.isSky() && this.renderLayer(this, i3, e2, i3 ? p2[i3.id] : void 0);
              }
            function T2(e2, t3) {
              let i3;
              return t3 && (i3 = ("symbol" === e2.type ? f2 : e2.is3D() ? g2 : p2)[t3.id]), i3;
            }
            if (this.renderPass = "translucent", "globe" === this.transform.projection.name) {
              for (this.renderElevatedRasterBackface = true, this.currentLayer = 0; this.currentLayer < a2.length; ) {
                const e2 = l2[this.currentLayer];
                if ("raster" === e2.type || "raster-particle" === e2.type) {
                  const i3 = t2.getLayerSourceCache(e2);
                  this.renderLayer(this, i3, e2, T2(e2, i3));
                }
                ++this.currentLayer;
              }
              this.renderElevatedRasterBackface = false;
            }
            this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER;
            let E2 = 0;
            y2 && (E2 = y2.getShadowCastingLayerCount());
            let C2 = false, S2 = -1;
            for (let e2 = 0; e2 < a2.length; ++e2) {
              const t3 = l2[e2];
              t3.isHidden(this.transform.zoom) || t3.is3D() && (S2 = e2);
            }
            for (s2 && -1 === S2 && (n2 = true); this.currentLayer < a2.length; ) {
              const e2 = l2[this.currentLayer], i3 = t2.getLayerSourceCache(e2);
              if (e2.isSky())
                ++this.currentLayer;
              else if (this.terrain && this.style.isLayerDraped(e2)) {
                if (e2.isHidden(this.transform.zoom)) {
                  ++this.currentLayer;
                  continue;
                }
                this.currentLayer = this.terrain.renderBatch(this.currentLayer), this._lastOcclusionLayer = Math.max(this.currentLayer, this._lastOcclusionLayer);
              } else {
                if (n2 && !C2 && this.terrain && !this.transform.isOrthographic && (C2 = true, this.blitDepth()), s2 && -1 !== S2 && this.currentLayer === S2 + 1 && !this.transform.isOrthographic && this.blitDepth(), e2.is3D() || this.terrain || this._renderTileClippingMasks(e2, i3, i3 ? d2[i3.id] : void 0), this.renderLayer(this, i3, e2, T2(e2, i3)), !this.terrain && y2 && E2 > 0 && e2.hasShadowPass() && 0 == --E2 && (y2.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer)) {
                  const e3 = this.currentLayer;
                  for (this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= e3; this.currentLayer++) {
                    const e4 = l2[this.currentLayer];
                    if (!e4.hasLightBeamPass())
                      continue;
                    const i4 = t2.getLayerSourceCache(e4);
                    this.renderLayer(this, i4, e4, i4 ? p2[i4.id] : void 0);
                  }
                  this.currentLayer = e3, this.renderPass = "translucent";
                }
                if (this.currentLayer >= this._lastOcclusionLayer && this.layersWithOcclusionOpacity.length > 0) {
                  const e3 = this.currentLayer;
                  this.depthOcclusion = true;
                  for (const e4 of this.layersWithOcclusionOpacity) {
                    this.currentLayer = e4;
                    const i4 = l2[this.currentLayer], o3 = t2.getLayerSourceCache(i4), r3 = o3 ? p2[o3.id] : void 0;
                    i4.is3D() || this.terrain || this._renderTileClippingMasks(i4, o3, o3 ? d2[o3.id] : void 0), this.renderLayer(this, o3, i4, r3);
                  }
                  this.depthOcclusion = false, this.currentLayer = e3, this.renderPass = "translucent", this.layersWithOcclusionOpacity = [];
                }
                ++this.currentLayer;
              }
            }
            if (this.terrain && this.terrain.postRender(), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
              let i3 = null;
              l2.forEach((e2) => {
                const o3 = t2.getLayerSourceCache(e2);
                o3 && !e2.isHidden(this.transform.zoom) && o3.getVisibleCoordinates().length && (!i3 || i3.getSource().maxzoom < o3.getSource().maxzoom) && (i3 = o3);
              }), i3 && this.options.showTileBoundaries && Tr.debug(this, i3, i3.getVisibleCoordinates(), e.C.red, false, this.options.showParseStatus);
            }
            this.terrain && this._debugParams.showTerrainProxyTiles && Tr.debug(this, this.terrain.proxySourceCache, this.terrain.proxyCoords, new e.C(1, 0.8, 0.1, 1), true, this.options.showParseStatus), this.options.showPadding && function(e2) {
              const t3 = e2.transform.padding;
              qo(e2, e2.transform.height - (t3.top || 0), 3, jo), qo(e2, t3.bottom || 0, 3, Vo), Xo(e2, t3.left || 0, 3, $o), Xo(e2, e2.transform.width - (t3.right || 0), 3, Zo);
              const i3 = e2.transform.centerPoint;
              !function(e3, t4, i4, o3) {
                Qo(e3, t4 - 1, i4 - 10, 2, 20, o3), Qo(e3, t4 - 10, i4 - 1, 20, 2, o3);
              }(e2, i3.x, e2.transform.height - i3.y, Wo);
            }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(performance.now()), this.saveCanvasCopy()), _2 || (this.conflationActive = false);
          }
          prepareLayer(e2) {
            this.gpuTimingStart(e2);
            const { unsupportedLayers: t2 } = this.transform.projection, i2 = !t2 || !t2.includes(e2.type);
            if (Er[e2.type] && (i2 || this.terrain && "custom" === e2.type)) {
              const t3 = this.style.getLayerSourceCache(e2);
              Er[e2.type](e2, t3, this);
            }
            this.gpuTimingEnd();
          }
          renderLayer(e2, t2, i2, o2) {
            i2.isHidden(this.transform.zoom) || ("background" === i2.type || "sky" === i2.type || "custom" === i2.type || "model" === i2.type || "raster" === i2.type || "raster-particle" === i2.type || o2 && o2.length) && (this.id = i2.id, this.gpuTimingStart(i2), e2.transform.projection.unsupportedLayers && e2.transform.projection.unsupportedLayers.includes(i2.type) && (!e2.terrain || "custom" !== i2.type) || "clip" === i2.type || Tr[i2.type](e2, t2, i2, o2, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
          }
          gpuTimingStart(e2) {
            if (!this.options.gpuTiming)
              return;
            const t2 = this.context.extTimerQuery, i2 = this.context.gl;
            let o2 = this.gpuTimers[e2.id];
            o2 || (o2 = this.gpuTimers[e2.id] = { calls: 0, cpuTime: 0, query: i2.createQuery() }), o2.calls++, i2.beginQuery(t2.TIME_ELAPSED_EXT, o2.query);
          }
          gpuTimingDeferredRenderStart() {
            if (this.options.gpuTimingDeferredRender) {
              const e2 = this.context.extTimerQuery, t2 = this.context.gl, i2 = t2.createQuery();
              this.deferredRenderGpuTimeQueries.push(i2), t2.beginQuery(e2.TIME_ELAPSED_EXT, i2);
            }
          }
          gpuTimingDeferredRenderEnd() {
            this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
          }
          gpuTimingEnd() {
            this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
          }
          collectGpuTimers() {
            const e2 = this.gpuTimers;
            return this.gpuTimers = {}, e2;
          }
          collectDeferredRenderGpuQueries() {
            const e2 = this.deferredRenderGpuTimeQueries;
            return this.deferredRenderGpuTimeQueries = [], e2;
          }
          queryGpuTimers(e2) {
            const t2 = {};
            for (const i2 in e2) {
              const o2 = e2[i2], r2 = this.context.extTimerQuery, a2 = r2.getQueryParameter(o2.query, this.context.gl.QUERY_RESULT) / 1e6;
              r2.deleteQueryEXT(o2.query), t2[i2] = a2;
            }
            return t2;
          }
          queryGpuTimeDeferredRender(e2) {
            if (!this.options.gpuTimingDeferredRender)
              return 0;
            const t2 = this.context.extTimerQuery, i2 = this.context.gl;
            let o2 = 0;
            for (const r2 of e2)
              o2 += t2.getQueryParameter(r2, i2.QUERY_RESULT) / 1e6, t2.deleteQueryEXT(r2);
            return o2;
          }
          translatePosMatrix(t2, i2, o2, r2, a2) {
            if (!o2[0] && !o2[1])
              return t2;
            const n2 = a2 ? "map" === r2 ? this.transform.angle : 0 : "viewport" === r2 ? -this.transform.angle : 0;
            if (n2) {
              const e2 = Math.sin(n2), t3 = Math.cos(n2);
              o2 = [o2[0] * t3 - o2[1] * e2, o2[0] * e2 + o2[1] * t3];
            }
            const s2 = [a2 ? o2[0] : e.bD(i2, o2[0], this.transform.zoom), a2 ? o2[1] : e.bD(i2, o2[1], this.transform.zoom), 0], l2 = new Float32Array(16);
            return e.ae.translate(l2, t2, s2), l2;
          }
          saveTileTexture(e2) {
            const t2 = e2.size[0], i2 = this._tileTextures[t2];
            i2 ? i2.push(e2) : this._tileTextures[t2] = [e2];
          }
          getTileTexture(e2) {
            const t2 = this._tileTextures[e2];
            return t2 && t2.length > 0 ? t2.pop() : null;
          }
          terrainRenderModeElevated() {
            return this.style && !!this.style.getTerrain() && !!this.terrain && !this.terrain.renderingToTexture || this.forceTerrainMode;
          }
          linearFloatFilteringSupported() {
            return null != this.context.extTextureFloatLinear;
          }
          currentGlobalDefines(e2, t2, i2) {
            const o2 = void 0 === i2 ? this.terrain && this.terrain.renderingToTexture : i2, r2 = [];
            return this.style && this.style.enable3dLights() && ("globeRaster" === e2 || "terrainRaster" === e2 ? (r2.push("LIGHTING_3D_MODE"), r2.push("LIGHTING_3D_ALPHA_EMISSIVENESS")) : o2 || r2.push("LIGHTING_3D_MODE")), "shadow" === this.renderPass ? this._shadowMapDebug || r2.push("DEPTH_TEXTURE") : this.shadowRenderer && (this.shadowRenderer.useNormalOffset ? r2.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET") : r2.push("RENDER_SHADOWS", "DEPTH_TEXTURE")), this.terrainRenderModeElevated() && (r2.push("TERRAIN"), this.linearFloatFilteringSupported() && r2.push("TERRAIN_DEM_FLOAT_FORMAT")), "globe" === this.transform.projection.name && r2.push("GLOBE"), !this._fogVisible || o2 || void 0 !== t2 && !t2 || r2.push("FOG", "FOG_DITHERING"), o2 && r2.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && r2.push("OVERDRAW_INSPECTOR"), r2;
          }
          getOrCreateProgram(e2, t2) {
            this.cache = this.cache || {};
            const i2 = t2 && t2.defines || [], o2 = t2 && t2.config, r2 = this.currentGlobalDefines(e2, t2 && t2.overrideFog, t2 && t2.overrideRtt).concat(i2), a2 = ki.cacheKey(Ct[e2], e2, r2, o2);
            return this.cache[a2] || (this.cache[a2] = new ki(this.context, e2, Ct[e2], o2, mo[e2], r2)), this.cache[a2];
          }
          setCustomLayerDefaults() {
            this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
          }
          setBaseState() {
            const e2 = this.context.gl;
            this.context.cullFace.set(false), this.context.viewport.set([0, 0, this.width, this.height]), this.context.blendEquation.set(e2.FUNC_ADD);
          }
          initDebugOverlayCanvas() {
            null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
          }
          destroy() {
            this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy(), this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), this.emptyDepthTexture && this.emptyDepthTexture.destroy();
          }
          prepareDrawTile() {
            this.terrain && this.terrain.prepareDrawTile();
          }
          uploadCommonLightUniforms(t2, i2) {
            if (this.style.enable3dLights()) {
              const o2 = this.style.directionalLight, r2 = this.style.ambientLight;
              if (o2 && r2) {
                const a2 = ((t3, i3, o3) => {
                  const r3 = t3.properties.get("direction"), a3 = t3.properties.get("color").toRenderColor(o3.getLut(t3.scope)).toArray01(), n2 = t3.properties.get("intensity"), s2 = i3.properties.get("color").toRenderColor(o3.getLut(i3.scope)).toArray01(), l2 = i3.properties.get("intensity"), c2 = [r3.x, r3.y, r3.z], h2 = e.bC(s2, l2), _2 = e.bC(a3, n2);
                  return { u_lighting_ambient_color: h2, u_lighting_directional_dir: c2, u_lighting_directional_color: _2, u_ground_radiance: Oi(c2, _2, h2) };
                })(o2, r2, this.style);
                i2.setLightsUniformValues(t2, a2);
              }
            }
          }
          uploadCommonUniforms(t2, i2, o2, r2, a2) {
            if (this.uploadCommonLightUniforms(t2, i2), this.terrain && this.terrain.renderingToTexture)
              return;
            const n2 = this.style.fog;
            if (n2) {
              const a3 = n2.getOpacity(this.transform.pitch), s2 = ((t3, i3, o3, r3, a4, n3, s3, l2, c2, h2, _2, u2) => {
                const d2 = t3.transform, p2 = i3.properties.get("color").toRenderColor(t3.style.getLut(i3.scope)).toArray01();
                p2[3] = r3;
                const f2 = t3.frameCounter / 1e3 % 1, [m2, g2] = i3.properties.get("vertical-range");
                return { u_fog_matrix: o3 ? d2.calculateFogTileMatrix(o3) : u2 || t3.identityMat, u_fog_range: i3.getFovAdjustedRange(d2._fov), u_fog_color: p2, u_fog_horizon_blend: i3.properties.get("horizon-blend"), u_fog_vertical_limit: [Math.min(m2, g2), g2], u_fog_temporal_offset: f2, u_frustum_tl: a4, u_frustum_tr: n3, u_frustum_br: s3, u_frustum_bl: l2, u_globe_pos: c2, u_globe_radius: h2, u_viewport: _2, u_globe_transition: e.a2(d2.zoom), u_is_globe: +("globe" === d2.projection.name) };
              })(this, n2, o2, a3, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [this.transform.width * e.e.devicePixelRatio, this.transform.height * e.e.devicePixelRatio], r2);
              i2.setFogUniformValues(t2, s2);
            }
            a2 && i2.setCutoffUniformValues(t2, a2.uniformValues);
          }
          setTileLoadedFlag(e2) {
            this.tileLoaded = e2;
          }
          saveCanvasCopy() {
            const e2 = this.canvasCopy();
            e2 && (this.frameCopies.push(e2), this.tileLoaded = false);
          }
          canvasCopy() {
            const e2 = this.context.gl, t2 = e2.createTexture();
            return e2.bindTexture(e2.TEXTURE_2D, t2), e2.copyTexImage2D(e2.TEXTURE_2D, 0, e2.RGBA, 0, 0, e2.drawingBufferWidth, e2.drawingBufferHeight, 0), t2;
          }
          getCanvasCopiesAndTimestamps() {
            return { canvasCopies: this.frameCopies, timeStamps: this.loadTimeStamps };
          }
          averageElevationNeedsEasing() {
            if (!this.transform._elevation)
              return false;
            const e2 = this.style && this.style.fog;
            return !!e2 && 0 !== e2.getOpacity(this.transform.pitch);
          }
          getBackgroundTiles() {
            const t2 = this._backgroundTiles, i2 = this._backgroundTiles = {}, o2 = this.transform.coveringTiles({ tileSize: 512 });
            for (const r2 of o2)
              i2[r2.key] = t2[r2.key] || new e.bA(r2, 512, this.transform.tileZoom, this);
            return i2;
          }
          clearBackgroundTiles() {
            this._backgroundTiles = {};
          }
          isSourceForClippingOrConflation(e2, t2) {
            return !(!e2.is3D() || e2.minzoom && e2.minzoom > this.transform.zoom || (this.style._clipLayerIndices.length || "building" !== e2.sourceLayer) && "clip" !== e2.type && (!t2 || "batched-model" !== t2.type));
          }
          isTileAffectedByFog(e2) {
            if (!this.style || !this.style.fog)
              return false;
            if ("globe" === this.transform.projection.name)
              return true;
            let t2 = this._cachedTileFogOpacities[e2.key];
            return t2 || (this._cachedTileFogOpacities[e2.key] = t2 = this.style.fog.getOpacityForTile(e2)), t2[0] >= Ke || t2[1] >= Ke;
          }
          setupDepthForOcclusion(e2, t2, i2) {
            const o2 = this.context, r2 = o2.gl, a2 = !!i2;
            var n2;
            i2 || (i2 = { u_dem: 2, u_dem_prev: 4, u_dem_tl: [0, 0], u_dem_tl_prev: [0, 0], u_dem_scale: 0, u_dem_scale_prev: 0, u_dem_size: 0, u_dem_lerp: 1, u_depth: 3, u_depth_size_inv: [0, 0], u_depth_range_unpack: [0, 1], u_occluder_half_size: 16, u_occlusion_depth_offset: -1e-4, u_exaggeration: 0 }), o2.activeTexture.set(r2.TEXTURE3), e2 && this.depthFBO && this.depthTexture ? (this.depthTexture.bind(r2.NEAREST, r2.CLAMP_TO_EDGE), i2.u_depth_size_inv = [1 / this.depthFBO.width, 1 / this.depthFBO.height], i2.u_depth_range_unpack = [2 / ((n2 = this.depthRangeFor3D)[1] - n2[0]), -1 - 2 * n2[0] / (n2[1] - n2[0])], i2.u_occluder_half_size = 0.5 * this.occlusionParams.occluderSize, i2.u_occlusion_depth_offset = this.occlusionParams.depthOffset) : this.emptyDepthTexture.bind(r2.NEAREST, r2.CLAMP_TO_EDGE), o2.activeTexture.set(r2.TEXTURE0), a2 || t2.setTerrainUniformValues(o2, i2);
          }
        }
        class Sr {
          constructor(e2, t2, i2, o2) {
            this.screenBounds = e2, this.cameraPoint = t2, this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = i2, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, o2);
          }
          static createFromScreenPoints(t2, i2) {
            let o2, r2;
            if (t2 instanceof e.P || "number" == typeof t2[0]) {
              const a2 = e.P.convert(t2);
              o2 = [a2], r2 = i2.isPointAboveHorizon(a2);
            } else {
              const a2 = e.P.convert(t2[0]), n2 = e.P.convert(t2[1]);
              o2 = [a2, n2], r2 = e.cx(a2, n2).every((e2) => i2.isPointAboveHorizon(e2));
            }
            return new Sr(o2, i2.getCameraPoint(), r2, i2);
          }
          isPointQuery() {
            return 1 === this.screenBounds.length;
          }
          bufferedScreenGeometry(t2) {
            return e.cx(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], t2);
          }
          bufferedCameraGeometry(t2) {
            const i2 = this.screenBounds[0], o2 = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1], r2 = e.cx(i2, o2, 0, false);
            return this.cameraPoint.y > o2.y && (this.cameraPoint.x > i2.x && this.cameraPoint.x < o2.x ? r2.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= o2.x ? r2[2] = this.cameraPoint : this.cameraPoint.x <= i2.x && (r2[3] = this.cameraPoint)), e.cy(r2, t2);
          }
          bufferedCameraGeometryGlobe(t2) {
            const i2 = this.screenBounds[0], o2 = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1], r2 = e.cx(i2, o2, t2), a2 = this.cameraPoint.clone();
            switch (3 * ((a2.y > i2.y) + (a2.y > o2.y)) + ((a2.x > i2.x) + (a2.x > o2.x))) {
              case 0:
                r2[0] = a2, r2[4] = a2.clone();
                break;
              case 1:
                r2.splice(1, 0, a2);
                break;
              case 2:
                r2[1] = a2;
                break;
              case 3:
                r2.splice(4, 0, a2);
                break;
              case 5:
                r2.splice(2, 0, a2);
                break;
              case 6:
                r2[3] = a2;
                break;
              case 7:
                r2.splice(3, 0, a2);
                break;
              case 8:
                r2[2] = a2;
            }
            return r2;
          }
          containsTile(t2, i2, o2, r2 = 0) {
            const a2 = t2.queryPadding / i2._pixelsPerMercatorPixel + 1, n2 = o2 ? this._bufferedCameraMercator(a2, i2) : this._bufferedScreenMercator(a2, i2);
            let s2 = t2.tileID.wrap + (n2.unwrapped ? r2 : 0);
            const l2 = n2.polygon.map((i3) => e.cz(t2.tileTransform, i3, s2));
            if (!e.cA(l2, 0, 0, e.a4, e.a4))
              return;
            s2 = t2.tileID.wrap + (this.screenGeometryMercator.unwrapped ? r2 : 0);
            const c2 = this.screenGeometryMercator.polygon.map((i3) => e.cB(t2.tileTransform, i3, s2)), h2 = c2.map((t3) => new e.P(t3[0], t3[1])), _2 = i2.getFreeCameraOptions().position || new e._(0, 0, 0), u2 = e.cB(t2.tileTransform, _2, s2), d2 = c2.map((t3) => {
              const i3 = e.$.sub(t3, t3, u2);
              return e.$.normalize(i3, i3), new e.aU(u2, i3);
            }), p2 = e.bD(t2, 1, i2.zoom) * i2._pixelsPerMercatorPixel;
            return { queryGeometry: this, tilespaceGeometry: h2, tilespaceRays: d2, bufferedTilespaceGeometry: l2, bufferedTilespaceBounds: (f2 = e.cC(l2), f2.min.x = e.au(f2.min.x, 0, e.a4), f2.min.y = e.au(f2.min.y, 0, e.a4), f2.max.x = e.au(f2.max.x, 0, e.a4), f2.max.y = e.au(f2.max.y, 0, e.a4), f2), tile: t2, tileID: t2.tileID, pixelToTileUnitsFactor: p2 };
            var f2;
          }
          _bufferedScreenMercator(e2, t2) {
            const i2 = Pr(e2);
            if (this._screenRaycastCache[i2])
              return this._screenRaycastCache[i2];
            {
              let o2;
              return o2 = "globe" === t2.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e2), t2) : { polygon: this.bufferedScreenGeometry(e2).map((e3) => t2.pointCoordinate3D(e3)), unwrapped: true }, this._screenRaycastCache[i2] = o2, o2;
            }
          }
          _bufferedCameraMercator(e2, t2) {
            const i2 = Pr(e2);
            if (this._cameraRaycastCache[i2])
              return this._cameraRaycastCache[i2];
            {
              let o2;
              return o2 = "globe" === t2.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e2), t2) : { polygon: this.bufferedCameraGeometry(e2).map((e3) => t2.pointCoordinate3D(e3)), unwrapped: true }, this._cameraRaycastCache[i2] = o2, o2;
            }
          }
          _projectAndResample(t2, i2) {
            const o2 = function(t3, i3) {
              const o3 = e.ae.multiply([], i3.pixelMatrix, i3.globeMatrix), r3 = [0, -e.cF, 0, 1], a2 = [0, e.cF, 0, 1], n2 = [0, 0, 0, 1];
              e.aB.transformMat4(r3, r3, o3), e.aB.transformMat4(a2, a2, o3), e.aB.transformMat4(n2, n2, o3);
              const s2 = new e.P(r3[0] / r3[3], r3[1] / r3[3]), l2 = new e.P(a2[0] / a2[3], a2[1] / a2[3]), c2 = e.cD(t3, s2) && r3[3] < n2[3], h2 = e.cD(t3, l2) && a2[3] < n2[3];
              if (!c2 && !h2)
                return null;
              const _2 = function(e2, t4, i4) {
                for (let o4 = 1; o4 < e2.length; o4++) {
                  const r4 = Lr(t4.pointCoordinate3D(e2[o4 - 1]).x), a3 = Lr(t4.pointCoordinate3D(e2[o4]).x);
                  if (i4 < 0) {
                    if (r4 < a3)
                      return { idx: o4, t: -r4 / (a3 - 1 - r4) };
                  } else if (a3 < r4)
                    return { idx: o4, t: (1 - r4) / (a3 + 1 - r4) };
                }
                return null;
              }(t3, i3, c2 ? -1 : 1);
              if (!_2)
                return null;
              const { idx: u2, t: d2 } = _2;
              let p2 = u2 > 1 ? Ir(t3.slice(0, u2), i3) : [], f2 = u2 < t3.length ? Ir(t3.slice(u2), i3) : [];
              p2 = p2.map((t4) => new e.P(Lr(t4.x), t4.y)), f2 = f2.map((t4) => new e.P(Lr(t4.x), t4.y));
              const m2 = [...p2];
              0 === m2.length && m2.push(f2[f2.length - 1]);
              const g2 = e.a3(m2[m2.length - 1].y, (0 === f2.length ? p2[0] : f2[0]).y, d2);
              let v2;
              return v2 = c2 ? [new e.P(0, g2), new e.P(0, 0), new e.P(1, 0), new e.P(1, g2)] : [new e.P(1, g2), new e.P(1, 1), new e.P(0, 1), new e.P(0, g2)], m2.push(...v2), 0 === f2.length ? m2.push(p2[0]) : m2.push(...f2), { polygon: m2.map((t4) => new e._(t4.x, t4.y)), unwrapped: false };
            }(t2, i2);
            if (o2)
              return o2;
            const r2 = function(t3, i3) {
              let o3 = false, r3 = -1 / 0, a2 = 0;
              for (let e2 = 0; e2 < t3.length - 1; e2++)
                t3[e2].x > r3 && (r3 = t3[e2].x, a2 = e2);
              for (let e2 = 0; e2 < t3.length - 1; e2++) {
                const i4 = (a2 + e2) % (t3.length - 1), r4 = t3[i4], n3 = t3[i4 + 1];
                Math.abs(r4.x - n3.x) > 0.5 && (r4.x < n3.x ? (r4.x += 1, 0 === i4 && (t3[t3.length - 1].x += 1)) : (n3.x += 1, i4 + 1 === t3.length - 1 && (t3[0].x += 1)), o3 = true);
              }
              const n2 = e.ak(i3.center.lng);
              return o3 && n2 < Math.abs(n2 - 1) && t3.forEach((e2) => {
                e2.x -= 1;
              }), { polygon: t3, unwrapped: o3 };
            }(Ir(t2, i2).map((t3) => new e.P(Lr(t3.x), t3.y)), i2);
            return { polygon: r2.polygon.map((t3) => new e._(t3.x, t3.y)), unwrapped: r2.unwrapped };
          }
        }
        function Ir(t2, i2) {
          return e.cE(t2, (e2) => {
            const t3 = i2.pointCoordinate3D(e2);
            e2.x = t3.x, e2.y = t3.y;
          }, 1 / 256);
        }
        function Lr(e2) {
          return e2 < 0 ? 1 + e2 % 1 : e2 % 1;
        }
        function Pr(e2) {
          return 100 * e2 | 0;
        }
        function Rr(t2, i2) {
          const o2 = e.ae.identity([]);
          return e.ae.scale(o2, o2, [0.5 * t2.width, 0.5 * -t2.height, 1]), e.ae.translate(o2, o2, [1, -1, 0]), e.ae.multiply(o2, o2, t2.calculateProjMatrix(i2.toUnwrapped())), Float32Array.from(o2);
        }
        function Dr(e2, t2, i2, o2, r2, a2, n2, s2 = false) {
          const l2 = e2.tilesIn(o2, n2, s2);
          l2.sort(Mr);
          const c2 = [];
          for (const o3 of l2)
            c2.push({ wrappedTileID: o3.tile.tileID.wrapped().key, queryResults: o3.tile.queryRenderedFeatures(t2, i2, e2._state, o3, r2, a2, Rr(e2.transform, o3.tile.tileID), s2) });
          const h2 = function(e3) {
            const t3 = {}, i3 = {};
            for (const o3 of e3) {
              const e4 = o3.queryResults, r3 = o3.wrappedTileID, a3 = i3[r3] = i3[r3] || {};
              for (const i4 in e4) {
                const o4 = e4[i4], r4 = a3[i4] = a3[i4] || {}, n3 = t3[i4] = t3[i4] || [];
                for (const e5 of o4)
                  r4[e5.featureIndex] || (r4[e5.featureIndex] = true, n3.push(e5));
              }
            }
            return t3;
          }(c2);
          for (const t3 in h2)
            h2[t3].forEach((t4) => {
              const i3 = t4.feature, o3 = i3.layer;
              o3 && "background" !== o3.type && "sky" !== o3.type && "slot" !== o3.type && (i3.source = o3.source, o3["source-layer"] && (i3.sourceLayer = o3["source-layer"]), i3.state = void 0 !== i3.id ? e2.getFeatureState(o3["source-layer"], i3.id) : {});
            });
          return h2;
        }
        function Ar(e2, t2) {
          const i2 = e2.getRenderableIds().map((t3) => e2.getTileByID(t3)), o2 = [], r2 = {};
          for (let e3 = 0; e3 < i2.length; e3++) {
            const a2 = i2[e3], n2 = a2.tileID.canonical.key;
            r2[n2] || (r2[n2] = true, a2.querySourceFeatures(o2, t2));
          }
          return o2;
        }
        function Mr(e2, t2) {
          const i2 = e2.tileID, o2 = t2.tileID;
          return i2.overscaledZ - o2.overscaledZ || i2.canonical.y - o2.canonical.y || i2.wrap - o2.wrap || i2.canonical.x - o2.canonical.x;
        }
        class zr {
          constructor(e2) {
            this.style = e2, this.layersGotHidden = false, this.layers = [];
          }
          processLayersChanged() {
            this.layers = [];
            const e2 = false, t2 = false;
            for (const i2 in this.style._mergedLayers) {
              const o2 = this.style._mergedLayers[i2];
              if ("fill-extrusion" === o2.type)
                this.layers.push({ layer: o2, visible: e2, visibilityChanged: t2 });
              else if ("model" === o2.type) {
                const i3 = this.style.getLayerSource(o2);
                i3 && "batched-model" === i3.type && this.layers.push({ layer: o2, visible: e2, visibilityChanged: t2 });
              }
            }
          }
          onNewFrame(e2) {
            this.layersGotHidden = false;
            for (const t2 of this.layers) {
              const i2 = t2.layer;
              let o2 = false;
              "fill-extrusion" === i2.type ? o2 = !i2.isHidden(e2) && i2.paint.get("fill-extrusion-opacity") > 0 : "model" === i2.type && (o2 = !i2.isHidden(e2) && i2.paint.get("model-opacity") > 0), this.layersGotHidden = this.layersGotHidden || !o2 && t2.visible, t2.visible = o2;
            }
          }
          updateZOffset(e2, t2) {
            this.currentBuildingBuckets = [];
            for (const e3 of this.layers) {
              const i3 = e3.layer, o2 = this.style.getLayerSourceCache(i3);
              let r2 = 1;
              "fill-extrusion" === i3.type && (r2 = e3.visible ? i3.paint.get("fill-extrusion-vertical-scale") : 0);
              let a2 = o2 ? o2.getTile(t2) : null;
              if (!a2 && o2 && t2.canonical.z > o2.getSource().minzoom) {
                let e4 = t2.scaledTo(Math.min(o2.getSource().maxzoom, t2.overscaledZ - 1));
                for (; e4.overscaledZ >= o2.getSource().minzoom && (a2 = o2.getTile(e4), !a2 && 0 !== e4.overscaledZ); )
                  e4 = e4.scaledTo(e4.overscaledZ - 1);
              }
              this.currentBuildingBuckets.push({ bucket: a2 ? a2.getBucket(i3) : null, tileID: a2 ? a2.tileID : t2, verticalScale: r2 });
            }
            e2.hasAnyZOffset = false;
            let i2 = false;
            for (let o2 = 0; o2 < e2.symbolInstances.length; o2++) {
              const r2 = e2.symbolInstances.get(o2), a2 = r2.zOffset, n2 = this._getHeightAtTileOffset(t2, r2.tileAnchorX, r2.tileAnchorY);
              r2.zOffset = n2 !== Number.NEGATIVE_INFINITY ? n2 : a2, i2 || a2 === r2.zOffset || (i2 = true), e2.hasAnyZOffset || 0 === r2.zOffset || (e2.hasAnyZOffset = true);
            }
            i2 && (e2.zOffsetBuffersNeedUpload = true, e2.zOffsetSortDirty = true);
          }
          _mapCoordToOverlappingTile(t2, i2, o2, r2) {
            let a2 = i2, n2 = o2;
            if (t2.canonical.z !== r2.canonical.z) {
              const s2 = r2.canonical, l2 = 1 / (1 << t2.canonical.z - s2.z);
              a2 = (i2 + t2.canonical.x * e.a4) * l2 - s2.x * e.a4 | 0, n2 = (o2 + t2.canonical.y * e.a4) * l2 - s2.y * e.a4 | 0;
            }
            return { tileX: a2, tileY: n2 };
          }
          _getHeightAtTileOffset(e2, t2, i2) {
            let o2, r2;
            for (let a2 = 0; a2 < this.layers.length; ++a2) {
              if ("fill-extrusion" !== this.layers[a2].layer.type)
                continue;
              const { bucket: n2, tileID: s2, verticalScale: l2 } = this.currentBuildingBuckets[a2];
              if (!n2)
                continue;
              const { tileX: c2, tileY: h2 } = this._mapCoordToOverlappingTile(e2, t2, i2, s2), _2 = n2.getHeightAtTileCoord(c2, h2);
              _2 && void 0 !== _2.height && (_2.hidden ? o2 = _2.height : r2 = Math.max(_2.height * l2, r2 || 0));
            }
            if (void 0 !== r2)
              return r2;
            for (let r3 = 0; r3 < this.layers.length; ++r3) {
              const a2 = this.layers[r3];
              if ("model" !== a2.layer.type || !a2.visible)
                continue;
              const { bucket: n2, tileID: s2 } = this.currentBuildingBuckets[r3];
              if (!n2)
                continue;
              const { tileX: l2, tileY: c2 } = this._mapCoordToOverlappingTile(e2, t2, i2, s2), h2 = n2.getHeightAtTileCoord(l2, c2);
              if (h2 && !h2.hidden)
                return void 0 === h2.height && void 0 !== o2 ? Math.min(h2.maxHeight, o2) * h2.verticalScale : h2.height ? h2.height * h2.verticalScale : Number.NEGATIVE_INFINITY;
            }
            return this.layersGotHidden ? 0 : Number.NEGATIVE_INFINITY;
          }
        }
        function Or(t2, i2) {
          const o2 = {};
          for (const e2 in t2)
            "ref" !== e2 && (o2[e2] = t2[e2]);
          return e.cG.forEach((e2) => {
            e2 in i2 && (o2[e2] = i2[e2]);
          }), o2;
        }
        function Fr(e2) {
          e2 = e2.slice();
          const t2 = /* @__PURE__ */ Object.create(null);
          for (let i2 = 0; i2 < e2.length; i2++)
            t2[e2[i2].id] = e2[i2];
          for (let i2 = 0; i2 < e2.length; i2++)
            "ref" in e2[i2] && (e2[i2] = Or(e2[i2], t2[e2[i2].ref]));
          return e2;
        }
        const Br = { setStyle: "setStyle", addLayer: "addLayer", removeLayer: "removeLayer", setPaintProperty: "setPaintProperty", setLayoutProperty: "setLayoutProperty", setSlot: "setSlot", setFilter: "setFilter", addSource: "addSource", removeSource: "removeSource", setGeoJSONSourceData: "setGeoJSONSourceData", setLayerZoomRange: "setLayerZoomRange", setLayerProperty: "setLayerProperty", setCenter: "setCenter", setZoom: "setZoom", setBearing: "setBearing", setPitch: "setPitch", setSprite: "setSprite", setGlyphs: "setGlyphs", setTransition: "setTransition", setLight: "setLight", setTerrain: "setTerrain", setFog: "setFog", setCamera: "setCamera", setLights: "setLights", setProjection: "setProjection", addImport: "addImport", removeImport: "removeImport", updateImport: "updateImport" };
        function kr(e2, t2, i2) {
          i2.push({ command: Br.addSource, args: [e2, t2[e2]] });
        }
        function Nr(e2, t2, i2) {
          t2.push({ command: Br.removeSource, args: [e2] }), i2[e2] = true;
        }
        function Ur(e2, t2, i2, o2) {
          Nr(e2, i2, o2), kr(e2, t2, i2);
        }
        function Gr(t2, i2, o2) {
          let r2;
          for (r2 in t2[o2])
            if (t2[o2].hasOwnProperty(r2) && "data" !== r2 && !e.d(t2[o2][r2], i2[o2][r2]))
              return false;
          for (r2 in i2[o2])
            if (i2[o2].hasOwnProperty(r2) && "data" !== r2 && !e.d(t2[o2][r2], i2[o2][r2]))
              return false;
          return true;
        }
        function jr(t2, i2, o2, r2, a2, n2) {
          let s2;
          for (s2 in i2 = i2 || {}, t2 = t2 || {})
            t2.hasOwnProperty(s2) && (e.d(t2[s2], i2[s2]) || o2.push({ command: n2, args: [r2, s2, i2[s2], a2] }));
          for (s2 in i2)
            i2.hasOwnProperty(s2) && !t2.hasOwnProperty(s2) && (e.d(t2[s2], i2[s2]) || o2.push({ command: n2, args: [r2, s2, i2[s2], a2] }));
        }
        function Vr(e2) {
          return e2.id;
        }
        function $r(e2, t2) {
          return e2[t2.id] = t2, e2;
        }
        class Zr {
          constructor(e2, t2) {
            this.reset(e2, t2);
          }
          reset(e2, t2) {
            this.points = e2 || [], this._distances = [0];
            for (let e3 = 1; e3 < this.points.length; e3++)
              this._distances[e3] = this._distances[e3 - 1] + this.points[e3].dist(this.points[e3 - 1]);
            this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t2 || 0, 0.5 * this.length), this.paddedLength = this.length - 2 * this.padding;
          }
          lerp(t2) {
            if (1 === this.points.length)
              return this.points[0];
            t2 = e.au(t2, 0, 1);
            let i2 = 1, o2 = this._distances[i2];
            const r2 = t2 * this.paddedLength + this.padding;
            for (; o2 < r2 && i2 < this._distances.length; )
              o2 = this._distances[++i2];
            const a2 = i2 - 1, n2 = this._distances[a2], s2 = o2 - n2, l2 = s2 > 0 ? (r2 - n2) / s2 : 0;
            return this.points[a2].mult(1 - l2).add(this.points[i2].mult(l2));
          }
        }
        class Wr {
          constructor(e2, t2, i2) {
            const o2 = this.boxCells = [], r2 = this.circleCells = [];
            this.xCellCount = Math.ceil(e2 / i2), this.yCellCount = Math.ceil(t2 / i2);
            for (let e3 = 0; e3 < this.xCellCount * this.yCellCount; e3++)
              o2.push([]), r2.push([]);
            this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e2, this.height = t2, this.xScale = this.xCellCount / e2, this.yScale = this.yCellCount / t2, this.boxUid = 0, this.circleUid = 0;
          }
          keysLength() {
            return this.boxKeys.length + this.circleKeys.length;
          }
          insert(e2, t2, i2, o2, r2) {
            this._forEachCell(t2, i2, o2, r2, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e2), this.bboxes.push(t2), this.bboxes.push(i2), this.bboxes.push(o2), this.bboxes.push(r2);
          }
          insertCircle(e2, t2, i2, o2) {
            this._forEachCell(t2 - o2, i2 - o2, t2 + o2, i2 + o2, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e2), this.circles.push(t2), this.circles.push(i2), this.circles.push(o2);
          }
          _insertBoxCell(e2, t2, i2, o2, r2, a2) {
            this.boxCells[r2].push(a2);
          }
          _insertCircleCell(e2, t2, i2, o2, r2, a2) {
            this.circleCells[r2].push(a2);
          }
          _query(e2, t2, i2, o2, r2, a2) {
            if (i2 < 0 || e2 > this.width || o2 < 0 || t2 > this.height)
              return !r2 && [];
            const n2 = [];
            if (e2 <= 0 && t2 <= 0 && this.width <= i2 && this.height <= o2) {
              if (r2)
                return true;
              for (let e3 = 0; e3 < this.boxKeys.length; e3++)
                n2.push({ key: this.boxKeys[e3], x1: this.bboxes[4 * e3], y1: this.bboxes[4 * e3 + 1], x2: this.bboxes[4 * e3 + 2], y2: this.bboxes[4 * e3 + 3] });
              for (let e3 = 0; e3 < this.circleKeys.length; e3++) {
                const t3 = this.circles[3 * e3], i3 = this.circles[3 * e3 + 1], o3 = this.circles[3 * e3 + 2];
                n2.push({ key: this.circleKeys[e3], x1: t3 - o3, y1: i3 - o3, x2: t3 + o3, y2: i3 + o3 });
              }
              return a2 ? n2.filter(a2) : n2;
            }
            return this._forEachCell(e2, t2, i2, o2, this._queryCell, n2, { hitTest: r2, seenUids: { box: {}, circle: {} } }, a2), r2 ? n2.length > 0 : n2;
          }
          _queryCircle(e2, t2, i2, o2, r2) {
            const a2 = e2 - i2, n2 = e2 + i2, s2 = t2 - i2, l2 = t2 + i2;
            if (n2 < 0 || a2 > this.width || l2 < 0 || s2 > this.height)
              return !o2 && [];
            const c2 = [];
            return this._forEachCell(a2, s2, n2, l2, this._queryCellCircle, c2, { hitTest: o2, circle: { x: e2, y: t2, radius: i2 }, seenUids: { box: {}, circle: {} } }, r2), o2 ? c2.length > 0 : c2;
          }
          query(e2, t2, i2, o2, r2) {
            return this._query(e2, t2, i2, o2, false, r2);
          }
          hitTest(e2, t2, i2, o2, r2) {
            return this._query(e2, t2, i2, o2, true, r2);
          }
          hitTestCircle(e2, t2, i2, o2) {
            return this._queryCircle(e2, t2, i2, true, o2);
          }
          _queryCell(e2, t2, i2, o2, r2, a2, n2, s2) {
            const l2 = n2.seenUids, c2 = this.boxCells[r2];
            if (null !== c2) {
              const r3 = this.bboxes;
              for (const h3 of c2)
                if (!l2.box[h3]) {
                  l2.box[h3] = true;
                  const c3 = 4 * h3;
                  if (e2 <= r3[c3 + 2] && t2 <= r3[c3 + 3] && i2 >= r3[c3 + 0] && o2 >= r3[c3 + 1] && (!s2 || s2(this.boxKeys[h3]))) {
                    if (n2.hitTest)
                      return a2.push(true), true;
                    a2.push({ key: this.boxKeys[h3], x1: r3[c3], y1: r3[c3 + 1], x2: r3[c3 + 2], y2: r3[c3 + 3] });
                  }
                }
            }
            const h2 = this.circleCells[r2];
            if (null !== h2) {
              const r3 = this.circles;
              for (const c3 of h2)
                if (!l2.circle[c3]) {
                  l2.circle[c3] = true;
                  const h3 = 3 * c3;
                  if (this._circleAndRectCollide(r3[h3], r3[h3 + 1], r3[h3 + 2], e2, t2, i2, o2) && (!s2 || s2(this.circleKeys[c3]))) {
                    if (n2.hitTest)
                      return a2.push(true), true;
                    {
                      const e3 = r3[h3], t3 = r3[h3 + 1], i3 = r3[h3 + 2];
                      a2.push({ key: this.circleKeys[c3], x1: e3 - i3, y1: t3 - i3, x2: e3 + i3, y2: t3 + i3 });
                    }
                  }
                }
            }
          }
          _queryCellCircle(e2, t2, i2, o2, r2, a2, n2, s2) {
            const l2 = n2.circle, c2 = n2.seenUids, h2 = this.boxCells[r2];
            if (null !== h2) {
              const e3 = this.bboxes;
              for (const t3 of h2)
                if (!c2.box[t3]) {
                  c2.box[t3] = true;
                  const i3 = 4 * t3;
                  if (this._circleAndRectCollide(l2.x, l2.y, l2.radius, e3[i3 + 0], e3[i3 + 1], e3[i3 + 2], e3[i3 + 3]) && (!s2 || s2(this.boxKeys[t3])))
                    return a2.push(true), true;
                }
            }
            const _2 = this.circleCells[r2];
            if (null !== _2) {
              const e3 = this.circles;
              for (const t3 of _2)
                if (!c2.circle[t3]) {
                  c2.circle[t3] = true;
                  const i3 = 3 * t3;
                  if (this._circlesCollide(e3[i3], e3[i3 + 1], e3[i3 + 2], l2.x, l2.y, l2.radius) && (!s2 || s2(this.circleKeys[t3])))
                    return a2.push(true), true;
                }
            }
          }
          _forEachCell(e2, t2, i2, o2, r2, a2, n2, s2) {
            const l2 = this._convertToXCellCoord(e2), c2 = this._convertToYCellCoord(t2), h2 = this._convertToXCellCoord(i2), _2 = this._convertToYCellCoord(o2);
            for (let u2 = l2; u2 <= h2; u2++)
              for (let l3 = c2; l3 <= _2; l3++)
                if (r2.call(this, e2, t2, i2, o2, this.xCellCount * l3 + u2, a2, n2, s2))
                  return;
          }
          _convertToXCellCoord(e2) {
            return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e2 * this.xScale)));
          }
          _convertToYCellCoord(e2) {
            return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e2 * this.yScale)));
          }
          _circlesCollide(e2, t2, i2, o2, r2, a2) {
            const n2 = o2 - e2, s2 = r2 - t2, l2 = i2 + a2;
            return l2 * l2 > n2 * n2 + s2 * s2;
          }
          _circleAndRectCollide(e2, t2, i2, o2, r2, a2, n2) {
            const s2 = (a2 - o2) / 2, l2 = Math.abs(e2 - (o2 + s2));
            if (l2 > s2 + i2)
              return false;
            const c2 = (n2 - r2) / 2, h2 = Math.abs(t2 - (r2 + c2));
            if (h2 > c2 + i2)
              return false;
            if (l2 <= s2 || h2 <= c2)
              return true;
            const _2 = l2 - s2, u2 = h2 - c2;
            return _2 * _2 + u2 * u2 <= i2 * i2;
          }
        }
        const Hr = 100;
        class qr {
          constructor(e2, t2, i2 = new Wr(e2.width + 200, e2.height + 200, 25), o2 = new Wr(e2.width + 200, e2.height + 200, 25)) {
            this.transform = e2, this.grid = i2, this.ignoredGrid = o2, this.pitchfactor = Math.cos(e2._pitch) * e2.cameraToCenterDistance, this.screenRightBoundary = e2.width + Hr, this.screenBottomBoundary = e2.height + Hr, this.gridRightBoundary = e2.width + 200, this.gridBottomBoundary = e2.height + 200, this.fogState = t2;
          }
          placeCollisionBox(e2, t2, i2, o2, r2, a2, n2, s2) {
            let l2 = i2.projectedAnchorX, c2 = i2.projectedAnchorY, h2 = i2.projectedAnchorZ;
            const _2 = i2.elevation, u2 = i2.tileID, d2 = e2.getProjection();
            if (_2 && u2) {
              const [e3, t3, o3] = d2.upVector(u2.canonical, i2.tileAnchorX, i2.tileAnchorY), r3 = d2.upVectorScale(u2.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
              l2 += e3 * _2 * r3, c2 += t3 * _2 * r3, h2 += o3 * _2 * r3;
            }
            const p2 = this.projectAndGetPerspectiveRatio(n2, l2, c2, h2, i2.tileID, "globe" === d2.name || !!_2 || this.transform.pitch > 0, d2), f2 = a2 * p2.perspectiveRatio, m2 = (i2.x1 * t2 + o2.x - i2.padding) * f2 + p2.point.x, g2 = (i2.y1 * t2 + o2.y - i2.padding) * f2 + p2.point.y, v2 = (i2.x2 * t2 + o2.x + i2.padding) * f2 + p2.point.x, x2 = (i2.y2 * t2 + o2.y + i2.padding) * f2 + p2.point.y, y2 = p2.perspectiveRatio <= 0.55 || p2.occluded;
            return !this.isInsideGrid(m2, g2, v2, x2) || !r2 && this.grid.hitTest(m2, g2, v2, x2, s2) || y2 ? { box: [], offscreen: false, occluded: p2.occluded } : { box: [m2, g2, v2, x2], offscreen: this.isOffscreen(m2, g2, v2, x2), occluded: false };
          }
          placeCollisionCircles(t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2) {
            const m2 = [], g2 = this.transform.elevation, v2 = t2.getProjection(), x2 = g2 ? g2.getAtTileOffsetFunc(f2, this.transform.center.lat, this.transform.worldSize, v2) : null, y2 = new e.P(o2.tileAnchorX, o2.tileAnchorY);
            let { x: b2, y: w2, z: T2 } = v2.projectTilePoint(y2.x, y2.y, f2.canonical);
            if (x2) {
              const [e2, t3, i3] = x2(y2);
              b2 += e2, w2 += t3, T2 += i3;
            }
            const E2 = "globe" === v2.name, C2 = this.projectAndGetPerspectiveRatio(s2, b2, w2, T2, f2, E2 || !!g2 || this.transform.pitch > 0, v2), { perspectiveRatio: S2 } = C2, I2 = (_2 ? n2 / S2 : n2 * S2) / e.bP, L2 = Qt(b2, w2, T2, l2), P2 = C2.signedDistanceFromCamera > 0 ? ei(I2, a2, o2.lineOffsetX * I2, o2.lineOffsetY * I2, false, L2, y2, o2, r2, l2, {}, g2 && !_2 ? x2 : null, _2 && !!g2, v2, f2, _2) : null;
            let R2 = false, D2 = false, A2 = true;
            if (P2 && !C2.occluded) {
              const t3 = 0.5 * d2 * S2 + p2, o3 = new e.P(-100, -100), r3 = new e.P(this.screenRightBoundary, this.screenBottomBoundary), a3 = new Zr(), { first: n3, last: s3 } = P2, l3 = n3.path.length;
              let _3 = [];
              for (let e2 = l3 - 1; e2 >= 1; e2--)
                _3.push(n3.path[e2]);
              for (let e2 = 1; e2 < s3.path.length; e2++)
                _3.push(s3.path[e2]);
              const f3 = 2.5 * t3;
              c2 && (_3 = _3.map(([e2, t4, i3], o4) => (x2 && !E2 && (i3 = x2(o4 < l3 - 1 ? n3.tilePath[l3 - 1 - o4] : s3.tilePath[o4 - l3 + 2])[2]), Qt(e2, t4, i3, c2))), _3.some((e2) => e2[3] <= 0) && (_3 = []));
              let g3 = [];
              if (_3.length > 0) {
                let t4 = 1 / 0, i3 = -1 / 0, a4 = 1 / 0, n4 = -1 / 0;
                for (const e2 of _3)
                  t4 = Math.min(t4, e2[0]), a4 = Math.min(a4, e2[1]), i3 = Math.max(i3, e2[0]), n4 = Math.max(n4, e2[1]);
                i3 >= o3.x && t4 <= r3.x && n4 >= o3.y && a4 <= r3.y && (g3 = [_3.map((t5) => new e.P(t5[0], t5[1]))], (t4 < o3.x || i3 > r3.x || a4 < o3.y || n4 > r3.y) && (g3 = e.cH(g3, o3.x, o3.y, r3.x, r3.y)));
              }
              for (const e2 of g3) {
                a3.reset(e2, 0.25 * t3);
                let o4 = 0;
                o4 = a3.length <= 0.5 * t3 ? 1 : Math.ceil(a3.paddedLength / f3) + 1;
                for (let e3 = 0; e3 < o4; e3++) {
                  const r4 = e3 / Math.max(o4 - 1, 1), n4 = a3.lerp(r4), s4 = n4.x + Hr, l4 = n4.y + Hr;
                  m2.push(s4, l4, t3, 0);
                  const c3 = s4 - t3, _4 = l4 - t3, d3 = s4 + t3, p3 = l4 + t3;
                  if (A2 = A2 && this.isOffscreen(c3, _4, d3, p3), D2 = D2 || this.isInsideGrid(c3, _4, d3, p3), !i2 && this.grid.hitTestCircle(s4, l4, t3, u2) && (R2 = true, !h2))
                    return { circles: [], offscreen: false, collisionDetected: R2, occluded: false };
                }
              }
            }
            return { circles: !h2 && R2 || !D2 ? [] : m2, offscreen: A2, collisionDetected: R2, occluded: C2.occluded };
          }
          queryRenderedSymbols(t2) {
            if (0 === t2.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength())
              return {};
            const i2 = [];
            let o2 = 1 / 0, r2 = 1 / 0, a2 = -1 / 0, n2 = -1 / 0;
            for (const s3 of t2) {
              const t3 = new e.P(s3.x + Hr, s3.y + Hr);
              o2 = Math.min(o2, t3.x), r2 = Math.min(r2, t3.y), a2 = Math.max(a2, t3.x), n2 = Math.max(n2, t3.y), i2.push(t3);
            }
            const s2 = this.grid.query(o2, r2, a2, n2).concat(this.ignoredGrid.query(o2, r2, a2, n2)), l2 = {}, c2 = {};
            for (const t3 of s2) {
              const o3 = t3.key;
              if (void 0 === l2[o3.bucketInstanceId] && (l2[o3.bucketInstanceId] = {}), l2[o3.bucketInstanceId][o3.featureIndex])
                continue;
              const r3 = [new e.P(t3.x1, t3.y1), new e.P(t3.x2, t3.y1), new e.P(t3.x2, t3.y2), new e.P(t3.x1, t3.y2)];
              e.cI(i2, r3) && (l2[o3.bucketInstanceId][o3.featureIndex] = true, void 0 === c2[o3.bucketInstanceId] && (c2[o3.bucketInstanceId] = []), c2[o3.bucketInstanceId].push(o3.featureIndex));
            }
            return c2;
          }
          insertCollisionBox(e2, t2, i2, o2, r2) {
            (t2 ? this.ignoredGrid : this.grid).insert({ bucketInstanceId: i2, featureIndex: o2, collisionGroupID: r2 }, e2[0], e2[1], e2[2], e2[3]);
          }
          insertCollisionCircles(e2, t2, i2, o2, r2) {
            const a2 = t2 ? this.ignoredGrid : this.grid, n2 = { bucketInstanceId: i2, featureIndex: o2, collisionGroupID: r2 };
            for (let t3 = 0; t3 < e2.length; t3 += 4)
              a2.insertCircle(n2, e2[t3], e2[t3 + 1], e2[t3 + 2]);
          }
          projectAndGetPerspectiveRatio(t2, i2, o2, r2, a2, n2, s2) {
            const l2 = [i2, o2, r2, 1];
            let c2 = false;
            if (r2 || this.transform.pitch > 0) {
              if (e.aB.transformMat4(l2, l2, t2), this.fogState && a2 && "globe" !== s2.name) {
                const t3 = function(t4, i3, o3, r3, a3, n3) {
                  const s3 = n3.calculateFogTileMatrix(a3), l3 = [i3, o3, r3];
                  return e.$.transformMat4(l3, l3, s3), et(t4, e.$.length(l3), n3.pitch, n3._fov);
                }(this.fogState, i2, o2, r2, a2.toUnwrapped(), this.transform);
                c2 = t3 > 0.9;
              }
            } else
              si(l2, l2, t2);
            const h2 = l2[3];
            return { point: new e.P((l2[0] / h2 + 1) / 2 * this.transform.width + Hr, (-l2[1] / h2 + 1) / 2 * this.transform.height + Hr), perspectiveRatio: Math.min(0.5 + this.transform.getCameraToCenterDistance(s2) / h2 * 0.5, 1.5), signedDistanceFromCamera: h2, occluded: n2 && l2[2] > h2 || c2 };
          }
          isOffscreen(e2, t2, i2, o2) {
            return i2 < Hr || e2 >= this.screenRightBoundary || o2 < Hr || t2 > this.screenBottomBoundary;
          }
          isInsideGrid(e2, t2, i2, o2) {
            return i2 >= 0 && e2 < this.gridRightBoundary && o2 >= 0 && t2 < this.gridBottomBoundary;
          }
          getViewportMatrix() {
            const t2 = e.ae.identity([]);
            return e.ae.translate(t2, t2, [-100, -100, 0]), t2;
          }
        }
        class Xr {
          constructor(e2, t2, i2, o2) {
            this.opacity = e2 ? Math.max(0, Math.min(1, e2.opacity + (e2.placed ? t2 : -t2))) : o2 && i2 ? 1 : 0, this.placed = i2;
          }
          isHidden() {
            return 0 === this.opacity && !this.placed;
          }
        }
        class Qr {
          constructor(e2, t2, i2, o2, r2, a2 = false) {
            this.text = new Xr(e2 ? e2.text : null, t2, i2, r2), this.icon = new Xr(e2 ? e2.icon : null, t2, o2, r2), this.clipped = a2;
          }
          isHidden() {
            return this.text.isHidden() && this.icon.isHidden();
          }
        }
        class Yr {
          constructor(e2, t2, i2, o2 = false) {
            this.text = e2, this.icon = t2, this.skipFade = i2, this.clipped = o2;
          }
        }
        class Jr {
          constructor() {
            this.invProjMatrix = e.ae.create(), this.viewportMatrix = e.ae.create(), this.circles = [];
          }
        }
        class Kr {
          constructor(e2, t2, i2, o2, r2) {
            this.bucketInstanceId = e2, this.featureIndex = t2, this.sourceLayerIndex = i2, this.bucketIndex = o2, this.tileID = r2;
          }
        }
        class ea {
          constructor(e2) {
            this.crossSourceCollisions = e2, this.maxGroupID = 0, this.collisionGroups = {};
          }
          get(e2) {
            if (this.crossSourceCollisions)
              return { ID: 0, predicate: null };
            if (!this.collisionGroups[e2]) {
              const t2 = ++this.maxGroupID;
              this.collisionGroups[e2] = { ID: t2, predicate: (e3) => e3.collisionGroupID === t2 };
            }
            return this.collisionGroups[e2];
          }
        }
        function ta(t2, i2, o2, r2, a2) {
          const { horizontalAlign: n2, verticalAlign: s2 } = e.bS(t2), l2 = -(n2 - 0.5) * i2, c2 = -(s2 - 0.5) * o2, h2 = e.bR(t2, r2);
          return new e.P(l2 + h2[0] * a2, c2 + h2[1] * a2);
        }
        function ia(t2, i2, o2, r2, a2) {
          const n2 = new e.P(t2, i2);
          return o2 && n2._rotate(r2 ? a2 : -a2), n2;
        }
        class oa {
          constructor(e2, t2, i2, o2, r2, a2) {
            this.transform = e2.clone(), this.projection = e2.projection.name, this.collisionIndex = new qr(this.transform, r2), this.buildingIndex = a2, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = false, this.commitTime = 0, this.fadeDuration = t2, this.retainedQueryData = {}, this.collisionGroups = new ea(i2), this.collisionCircleArrays = {}, this.prevPlacement = o2, o2 && (o2.prevPlacement = void 0), this.placedOrientations = {};
          }
          getBucketParts(t2, i2, o2, r2) {
            const a2 = o2.getBucket(i2), n2 = o2.latestFeatureIndex;
            if (!a2 || !n2 || i2.fqid !== a2.layerIds[0])
              return;
            const s2 = a2.layers[0].layout, l2 = o2.collisionBoxArray, c2 = Math.pow(2, this.transform.zoom - o2.tileID.overscaledZ), h2 = o2.tileSize / e.a4, _2 = o2.tileID.toUnwrapped();
            this.transform.setProjection(a2.projection);
            const u2 = (d2 = o2.tileID, p2 = a2.getProjection(), f2 = this.transform, p2.name === this.projection ? f2.calculateProjMatrix(d2.toUnwrapped()) : go(f2, p2, d2));
            var d2, p2, f2;
            const m2 = "map" === s2.get("text-pitch-alignment"), g2 = "map" === s2.get("text-rotation-alignment");
            i2.compileFilter();
            const v2 = i2.dynamicFilter(), x2 = i2.dynamicFilterNeedsFeature(), y2 = this.transform.calculatePixelsToTileUnitsMatrix(o2), b2 = qt(u2, o2.tileID.canonical, m2, g2, this.transform, a2.getProjection(), y2);
            let w2 = null;
            if (m2) {
              const t3 = Xt(u2, o2.tileID.canonical, m2, g2, this.transform, a2.getProjection(), y2);
              w2 = e.ae.multiply([], this.transform.labelPlaneMatrix, t3);
            }
            let T2 = null;
            v2 && o2.latestFeatureIndex && (T2 = { unwrappedTileID: _2, dynamicFilter: v2, dynamicFilterNeedsFeature: x2, featureIndex: o2.latestFeatureIndex }), this.retainedQueryData[a2.bucketInstanceId] = new Kr(a2.bucketInstanceId, n2, a2.sourceLayerIndex, a2.index, o2.tileID);
            const E2 = { bucket: a2, layout: s2, posMatrix: u2, textLabelPlaneMatrix: b2, labelToScreenMatrix: w2, clippingData: T2, scale: c2, textPixelRatio: h2, holdingForFade: o2.holdingForFade(), collisionBoxArray: l2, partiallyEvaluatedTextSize: e.aE(a2.textSizeData, this.transform.zoom), partiallyEvaluatedIconSize: e.aE(a2.iconSizeData, this.transform.zoom), collisionGroup: this.collisionGroups.get(a2.sourceID) };
            if (r2)
              for (const e2 of a2.sortKeyRanges) {
                const { sortKey: i3, symbolInstanceStart: o3, symbolInstanceEnd: r3 } = e2;
                t2.push({ sortKey: i3, symbolInstanceStart: o3, symbolInstanceEnd: r3, parameters: E2 });
              }
            else
              t2.push({ symbolInstanceStart: 0, symbolInstanceEnd: a2.symbolInstances.length, parameters: E2 });
          }
          attemptAnchorPlacement(e2, t2, i2, o2, r2, a2, n2, s2, l2, c2, h2, _2, u2, d2, p2, f2, m2, g2) {
            const { textOffset0: v2, textOffset1: x2, crossTileID: y2 } = _2, b2 = [v2, x2], w2 = ta(e2, i2, o2, b2, r2), T2 = this.collisionIndex.placeCollisionBox(d2, r2, t2, ia(w2.x, w2.y, a2, n2, this.transform.angle), h2, s2, l2, c2.predicate);
            if (f2) {
              const e3 = d2.getSymbolInstanceIconSize(g2, this.transform.zoom, _2.placedIconSymbolIndex);
              if (0 === this.collisionIndex.placeCollisionBox(d2, e3, f2, ia(w2.x, w2.y, a2, n2, this.transform.angle), h2, s2, l2, c2.predicate).box.length)
                return;
            }
            if (T2.box.length > 0) {
              let t3;
              return this.prevPlacement && this.prevPlacement.variableOffsets[y2] && this.prevPlacement.placements[y2] && this.prevPlacement.placements[y2].text && (t3 = this.prevPlacement.variableOffsets[y2].anchor), this.variableOffsets[y2] = { textOffset: b2, width: i2, height: o2, anchor: e2, textScale: r2, prevAnchor: t3 }, this.markUsedJustification(d2, e2, _2, p2), d2.allowVerticalPlacement && (this.markUsedOrientation(d2, p2, _2), this.placedOrientations[y2] = p2), { shift: w2, placedGlyphBoxes: T2 };
            }
          }
          placeLayerBucketPart(t2, i2, o2, r2) {
            const { bucket: a2, layout: n2, posMatrix: s2, textLabelPlaneMatrix: l2, labelToScreenMatrix: c2, clippingData: h2, textPixelRatio: _2, holdingForFade: u2, collisionBoxArray: d2, partiallyEvaluatedTextSize: p2, partiallyEvaluatedIconSize: f2, collisionGroup: m2 } = t2.parameters, g2 = n2.get("text-optional"), v2 = n2.get("icon-optional"), x2 = n2.get("text-allow-overlap"), y2 = n2.get("icon-allow-overlap"), b2 = "map" === n2.get("text-rotation-alignment"), w2 = "map" === n2.get("text-pitch-alignment"), T2 = "viewport-y" === n2.get("symbol-z-order"), E2 = n2.get("symbol-z-elevate");
            this.transform.setProjection(a2.projection);
            let C2 = x2 && (y2 || !a2.hasIconData() || v2), S2 = y2 && (x2 || !a2.hasTextData() || g2);
            !a2.collisionArrays && d2 && a2.deserializeCollisionBoxes(d2), o2 && r2 && a2.updateCollisionDebugBuffers(this.transform.zoom, d2);
            const I2 = (t3, r3, d3) => {
              const { crossTileID: T3, numVerticalGlyphVertices: E3 } = t3;
              if (h2) {
                const o3 = { zoom: this.transform.zoom, pitch: this.transform.pitch };
                let r4 = null;
                if (h2.dynamicFilterNeedsFeature) {
                  const e2 = this.retainedQueryData[a2.bucketInstanceId];
                  r4 = h2.featureIndex.loadFeature({ featureIndex: t3.featureIndex, bucketIndex: e2.bucketIndex, sourceLayerIndex: e2.sourceLayerIndex, layoutVertexArrayOffset: 0 });
                }
                if (!(0, h2.dynamicFilter)(o3, r4, this.retainedQueryData[a2.bucketInstanceId].tileID.canonical, new e.P(t3.tileAnchorX, t3.tileAnchorY), this.transform.calculateDistanceTileData(h2.unwrappedTileID)))
                  return this.placements[T3] = new Yr(false, false, false, true), void i2.add(T3);
              }
              if (i2.has(T3))
                return;
              if (u2)
                return void (this.placements[T3] = new Yr(false, false, false));
              let I3 = false, L2 = false, P2 = true, R2 = false, D2 = false, A2 = null, M2 = { box: null, offscreen: null, occluded: null }, z2 = { box: null, offscreen: null, occluded: null }, O2 = null, F2 = null, B2 = null, k2 = 0, N2 = 0, U2 = 0;
              d3.textFeatureIndex ? k2 = d3.textFeatureIndex : t3.useRuntimeCollisionCircles && (k2 = t3.featureIndex), d3.verticalTextFeatureIndex && (N2 = d3.verticalTextFeatureIndex);
              const G2 = (e2) => {
                e2.tileID = this.retainedQueryData[a2.bucketInstanceId].tileID;
                const i3 = this.transform.elevation;
                e2.elevation = t3.zOffset + (i3 ? i3.getAtTileOffset(e2.tileID, e2.tileAnchorX, e2.tileAnchorY) : 0);
              }, j2 = d3.textBox;
              if (j2) {
                G2(j2);
                const i3 = (i4) => {
                  let o4 = e.aF.horizontal;
                  if (a2.allowVerticalPlacement && !i4 && this.prevPlacement) {
                    const e2 = this.prevPlacement.placedOrientations[T3];
                    e2 && (this.placedOrientations[T3] = e2, o4 = e2, this.markUsedOrientation(a2, o4, t3));
                  }
                  return o4;
                }, o3 = (t4, i4) => {
                  if (a2.allowVerticalPlacement && E3 > 0 && d3.verticalTextBox) {
                    for (const o4 of a2.writingModes)
                      if (o4 === e.aF.vertical ? (M2 = i4(), z2 = M2) : M2 = t4(), M2 && M2.box && M2.box.length)
                        break;
                  } else
                    M2 = t4();
                };
                if (n2.get("text-variable-anchor")) {
                  let l3 = n2.get("text-variable-anchor");
                  if (this.prevPlacement && this.prevPlacement.variableOffsets[T3]) {
                    const e2 = this.prevPlacement.variableOffsets[T3];
                    l3.indexOf(e2.anchor) > 0 && (l3 = l3.filter((t4) => t4 !== e2.anchor), l3.unshift(e2.anchor));
                  }
                  const c3 = (e2, i4, o4) => {
                    const n3 = a2.getSymbolInstanceTextSize(p2, t3, this.transform.zoom, r3), c4 = (e2.x2 - e2.x1) * n3 + 2 * e2.padding, h4 = (e2.y2 - e2.y1) * n3 + 2 * e2.padding, u3 = t3.hasIconTextFit && !y2 ? i4 : null;
                    u3 && G2(u3);
                    let d4 = { box: [], offscreen: false, occluded: false };
                    const g3 = x2 ? 2 * l3.length : l3.length;
                    for (let i5 = 0; i5 < g3; ++i5) {
                      const g4 = this.attemptAnchorPlacement(l3[i5 % l3.length], e2, c4, h4, n3, b2, w2, _2, s2, m2, i5 >= l3.length, t3, r3, a2, o4, u3, p2, f2);
                      if (g4 && (d4 = g4.placedGlyphBoxes, d4 && d4.box && d4.box.length)) {
                        I3 = true, A2 = g4.shift;
                        break;
                      }
                    }
                    return d4;
                  };
                  o3(() => c3(j2, d3.iconBox, e.aF.horizontal), () => {
                    const t4 = d3.verticalTextBox;
                    return t4 && G2(t4), a2.allowVerticalPlacement && !(M2 && M2.box && M2.box.length) && E3 > 0 && t4 ? c3(t4, d3.verticalIconBox, e.aF.vertical) : { box: null, offscreen: null, occluded: null };
                  }), M2 && (I3 = M2.box, P2 = M2.offscreen, R2 = M2.occluded);
                  const h3 = i3(!(!M2 || !M2.box));
                  if (!I3 && this.prevPlacement) {
                    const e2 = this.prevPlacement.variableOffsets[T3];
                    e2 && (this.variableOffsets[T3] = e2, this.markUsedJustification(a2, e2.anchor, t3, h3));
                  }
                } else {
                  const n3 = (i4, o4) => {
                    const n4 = a2.getSymbolInstanceTextSize(p2, t3, this.transform.zoom, r3), l3 = this.collisionIndex.placeCollisionBox(a2, n4, i4, new e.P(0, 0), x2, _2, s2, m2.predicate);
                    return l3 && l3.box && l3.box.length && (this.markUsedOrientation(a2, o4, t3), this.placedOrientations[T3] = o4), l3;
                  };
                  o3(() => n3(j2, e.aF.horizontal), () => {
                    const t4 = d3.verticalTextBox;
                    return a2.allowVerticalPlacement && E3 > 0 && t4 ? (G2(t4), n3(t4, e.aF.vertical)) : { box: null, offscreen: null, occluded: null };
                  }), i3(!!(M2 && M2.box && M2.box.length));
                }
              }
              if (O2 = M2, I3 = O2 && O2.box && O2.box.length > 0, P2 = O2 && O2.offscreen, R2 = O2 && O2.occluded, t3.useRuntimeCollisionCircles) {
                const i3 = a2.text.placedSymbolArray.get(t3.centerJustifiedTextSymbolIndex >= 0 ? t3.centerJustifiedTextSymbolIndex : t3.verticalPlacedTextSymbolIndex), r4 = e.aG(a2.textSizeData, p2, i3), h3 = n2.get("text-padding");
                F2 = this.collisionIndex.placeCollisionCircles(a2, x2, i3, a2.lineVertexArray, a2.glyphOffsetArray, r4, s2, l2, c2, o2, w2, m2.predicate, t3.collisionCircleDiameter * r4 / e.bP, h3, this.retainedQueryData[a2.bucketInstanceId].tileID), I3 = x2 || F2.circles.length > 0 && !F2.collisionDetected, P2 = P2 && F2.offscreen, R2 = F2.occluded;
              }
              if (d3.iconFeatureIndex && (U2 = d3.iconFeatureIndex), d3.iconBox) {
                const i3 = (i4) => {
                  G2(i4);
                  const o3 = t3.hasIconTextFit && A2 ? ia(A2.x, A2.y, b2, w2, this.transform.angle) : new e.P(0, 0), r4 = a2.getSymbolInstanceIconSize(f2, this.transform.zoom, t3.placedIconSymbolIndex);
                  return this.collisionIndex.placeCollisionBox(a2, r4, i4, o3, y2, _2, s2, m2.predicate);
                };
                z2 && z2.box && z2.box.length && d3.verticalIconBox ? (B2 = i3(d3.verticalIconBox), L2 = B2.box.length > 0) : (B2 = i3(d3.iconBox), L2 = B2.box.length > 0), P2 = P2 && B2.offscreen, D2 = B2.occluded;
              }
              const V2 = g2 || 0 === t3.numHorizontalGlyphVertices && 0 === E3, $2 = v2 || 0 === t3.numIconVertices;
              if (V2 || $2 ? $2 ? V2 || (L2 = L2 && I3) : I3 = L2 && I3 : L2 = I3 = L2 && I3, I3 && O2 && O2.box && this.collisionIndex.insertCollisionBox(O2.box, n2.get("text-ignore-placement"), a2.bucketInstanceId, z2 && z2.box && N2 ? N2 : k2, m2.ID), L2 && B2 && this.collisionIndex.insertCollisionBox(B2.box, n2.get("icon-ignore-placement"), a2.bucketInstanceId, U2, m2.ID), F2 && (I3 && this.collisionIndex.insertCollisionCircles(F2.circles, n2.get("text-ignore-placement"), a2.bucketInstanceId, k2, m2.ID), o2)) {
                const e2 = a2.bucketInstanceId;
                let t4 = this.collisionCircleArrays[e2];
                void 0 === t4 && (t4 = this.collisionCircleArrays[e2] = new Jr());
                for (let e3 = 0; e3 < F2.circles.length; e3 += 4)
                  t4.circles.push(F2.circles[e3 + 0]), t4.circles.push(F2.circles[e3 + 1]), t4.circles.push(F2.circles[e3 + 2]), t4.circles.push(F2.collisionDetected ? 1 : 0);
              }
              const Z2 = "globe" !== a2.projection.name;
              C2 = C2 && (Z2 || !R2), S2 = S2 && (Z2 || !D2), this.placements[T3] = new Yr(I3 || C2, L2 || S2, P2 || a2.justReloaded), i2.add(T3);
            };
            if (E2 && this.buildingIndex && (this.buildingIndex.updateZOffset(a2, this.retainedQueryData[a2.bucketInstanceId].tileID), a2.updateZOffset()), T2) {
              const t3 = a2.getSortedSymbolIndexes(this.transform.angle);
              for (let e2 = t3.length - 1; e2 >= 0; --e2) {
                const i3 = t3[e2];
                I2(a2.symbolInstances.get(i3), i3, a2.collisionArrays[i3]);
              }
              a2.hasAnyZOffset && e.w(`${a2.layerIds[0]} layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y`);
            } else if (a2.hasAnyZOffset) {
              const e2 = a2.getSortedIndexesByZOffset();
              for (let t3 = 0; t3 < e2.length; ++t3) {
                const i3 = e2[t3];
                I2(a2.symbolInstances.get(i3), i3, a2.collisionArrays[i3]);
              }
            } else
              for (let e2 = t2.symbolInstanceStart; e2 < t2.symbolInstanceEnd; e2++)
                I2(a2.symbolInstances.get(e2), e2, a2.collisionArrays[e2]);
            if (o2 && a2.bucketInstanceId in this.collisionCircleArrays) {
              const t3 = this.collisionCircleArrays[a2.bucketInstanceId];
              e.ae.invert(t3.invProjMatrix, s2), t3.viewportMatrix = this.collisionIndex.getViewportMatrix();
            }
            a2.justReloaded = false;
          }
          markUsedJustification(t2, i2, o2, r2) {
            const { leftJustifiedTextSymbolIndex: a2, centerJustifiedTextSymbolIndex: n2, rightJustifiedTextSymbolIndex: s2, verticalPlacedTextSymbolIndex: l2, crossTileID: c2 } = o2, h2 = e.cM(i2), _2 = r2 === e.aF.vertical ? l2 : "left" === h2 ? a2 : "center" === h2 ? n2 : "right" === h2 ? s2 : -1;
            a2 >= 0 && (t2.text.placedSymbolArray.get(a2).crossTileID = _2 >= 0 && a2 !== _2 ? 0 : c2), n2 >= 0 && (t2.text.placedSymbolArray.get(n2).crossTileID = _2 >= 0 && n2 !== _2 ? 0 : c2), s2 >= 0 && (t2.text.placedSymbolArray.get(s2).crossTileID = _2 >= 0 && s2 !== _2 ? 0 : c2), l2 >= 0 && (t2.text.placedSymbolArray.get(l2).crossTileID = _2 >= 0 && l2 !== _2 ? 0 : c2);
          }
          markUsedOrientation(t2, i2, o2) {
            const r2 = i2 === e.aF.horizontal || i2 === e.aF.horizontalOnly ? i2 : 0, a2 = i2 === e.aF.vertical ? i2 : 0, { leftJustifiedTextSymbolIndex: n2, centerJustifiedTextSymbolIndex: s2, rightJustifiedTextSymbolIndex: l2, verticalPlacedTextSymbolIndex: c2 } = o2, h2 = t2.text.placedSymbolArray;
            n2 >= 0 && (h2.get(n2).placedOrientation = r2), s2 >= 0 && (h2.get(s2).placedOrientation = r2), l2 >= 0 && (h2.get(l2).placedOrientation = r2), c2 >= 0 && (h2.get(c2).placedOrientation = a2);
          }
          commit(e2) {
            this.commitTime = e2, this.zoomAtLastRecencyCheck = this.transform.zoom;
            const t2 = this.prevPlacement;
            let i2 = false;
            this.prevZoomAdjustment = t2 ? t2.zoomAdjustment(this.transform.zoom) : 0;
            const o2 = t2 ? t2.symbolFadeChange(e2) : 1, r2 = t2 ? t2.opacities : {}, a2 = t2 ? t2.variableOffsets : {}, n2 = t2 ? t2.placedOrientations : {};
            for (const e3 in this.placements) {
              const t3 = this.placements[e3], a3 = r2[e3];
              a3 ? (this.opacities[e3] = new Qr(a3, o2, t3.text, t3.icon, null, t3.clipped), i2 = i2 || t3.text !== a3.text.placed || t3.icon !== a3.icon.placed) : (this.opacities[e3] = new Qr(null, o2, t3.text, t3.icon, t3.skipFade, t3.clipped), i2 = i2 || t3.text || t3.icon);
            }
            for (const e3 in r2) {
              const t3 = r2[e3];
              if (!this.opacities[e3]) {
                const r3 = new Qr(t3, o2, false, false);
                r3.isHidden() || (this.opacities[e3] = r3, i2 = i2 || t3.text.placed || t3.icon.placed);
              }
            }
            for (const e3 in a2)
              this.variableOffsets[e3] || !this.opacities[e3] || this.opacities[e3].isHidden() || (this.variableOffsets[e3] = a2[e3]);
            for (const e3 in n2)
              this.placedOrientations[e3] || !this.opacities[e3] || this.opacities[e3].isHidden() || (this.placedOrientations[e3] = n2[e3]);
            i2 ? this.lastPlacementChangeTime = e2 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t2 ? t2.lastPlacementChangeTime : e2);
          }
          updateLayerOpacities(e2, t2, i2, o2) {
            const r2 = /* @__PURE__ */ new Set();
            for (const a2 of t2) {
              const t3 = a2.getBucket(e2);
              t3 && a2.latestFeatureIndex && e2.fqid === t3.layerIds[0] && (this.updateBucketOpacities(t3, r2, a2.collisionBoxArray, i2, o2, a2.tileID, e2.scope), t3.layers[0].layout.get("symbol-z-elevate") && this.buildingIndex && (this.buildingIndex.updateZOffset(t3, a2.tileID), t3.updateZOffset()));
            }
          }
          updateBucketOpacities(t2, i2, o2, r2, a2, n2, s2) {
            t2.hasTextData() && t2.text.opacityVertexArray.clear(), t2.hasIconData() && t2.icon.opacityVertexArray.clear(), t2.hasIconCollisionBoxData() && t2.iconCollisionBox.collisionVertexArray.clear(), t2.hasTextCollisionBoxData() && t2.textCollisionBox.collisionVertexArray.clear();
            const l2 = t2.layers[0].layout, c2 = !!t2.layers[0].dynamicFilter(), h2 = new Qr(null, 0, false, false, true), _2 = l2.get("text-allow-overlap"), u2 = l2.get("icon-allow-overlap"), d2 = l2.get("text-variable-anchor"), p2 = "map" === l2.get("text-rotation-alignment"), f2 = "map" === l2.get("text-pitch-alignment"), m2 = new Qr(null, 0, _2 && (u2 || !t2.hasIconData() || l2.get("icon-optional")), u2 && (_2 || !t2.hasTextData() || l2.get("text-optional")), true);
            !t2.collisionArrays && o2 && (t2.hasIconCollisionBoxData() || t2.hasTextCollisionBoxData()) && t2.deserializeCollisionBoxes(o2);
            const g2 = (e2, t3, i3) => {
              for (let o3 = 0; o3 < t3 / 4; o3++)
                e2.opacityVertexArray.emplaceBack(i3);
            };
            let v2 = 0;
            a2 && t2.updateReplacement(n2, a2);
            for (let o3 = 0; o3 < t2.symbolInstances.length; o3++) {
              const l3 = t2.symbolInstances.get(o3), { numHorizontalGlyphVertices: _3, numVerticalGlyphVertices: u3, crossTileID: x2, numIconVertices: y2, tileAnchorX: b2, tileAnchorY: w2 } = l3, T2 = i2.has(x2);
              let E2 = this.opacities[x2];
              T2 ? E2 = h2 : E2 || (E2 = m2, this.opacities[x2] = E2), i2.add(x2);
              const C2 = _3 > 0 || u3 > 0, S2 = y2 > 0, I2 = this.placedOrientations[x2], L2 = I2 === e.aF.vertical, P2 = I2 === e.aF.horizontal || I2 === e.aF.horizontalOnly;
              !C2 && !S2 || E2.isHidden() || v2++;
              let R2 = false;
              if ((C2 || S2) && a2)
                for (const i3 of t2.activeReplacements) {
                  if (e.cJ(i3, r2, e.cw.Symbol, s2))
                    continue;
                  if (i3.min.x > b2 || b2 > i3.max.x || i3.min.y > w2 || w2 > i3.max.y)
                    continue;
                  const t3 = e.cK(b2, w2, n2.canonical, i3.footprintTileId.canonical);
                  if (R2 = e.cL(t3, i3), R2)
                    break;
                }
              if (C2) {
                const e2 = R2 ? da : ua(E2.text);
                g2(t2.text, _3, L2 ? da : e2), g2(t2.text, u3, P2 ? da : e2);
                const i3 = E2.text.isHidden(), { leftJustifiedTextSymbolIndex: o4, centerJustifiedTextSymbolIndex: r3, rightJustifiedTextSymbolIndex: a3, verticalPlacedTextSymbolIndex: n3 } = l3, s3 = t2.text.placedSymbolArray, c3 = i3 || L2 ? 1 : 0;
                o4 >= 0 && (s3.get(o4).hidden = c3), r3 >= 0 && (s3.get(r3).hidden = c3), a3 >= 0 && (s3.get(a3).hidden = c3), n3 >= 0 && (s3.get(n3).hidden = i3 || P2 ? 1 : 0);
                const h3 = this.variableOffsets[x2];
                h3 && this.markUsedJustification(t2, h3.anchor, l3, I2);
                const d3 = this.placedOrientations[x2];
                d3 && (this.markUsedJustification(t2, "left", l3, d3), this.markUsedOrientation(t2, d3, l3));
              }
              if (S2) {
                const e2 = R2 ? da : ua(E2.icon), { placedIconSymbolIndex: i3, verticalPlacedIconSymbolIndex: o4 } = l3, r3 = t2.icon.placedSymbolArray, a3 = E2.icon.isHidden() ? 1 : 0;
                i3 >= 0 && (g2(t2.icon, y2, L2 ? da : e2), r3.get(i3).hidden = a3), o4 >= 0 && (g2(t2.icon, l3.numVerticalIconVertices, P2 ? da : e2), r3.get(o4).hidden = a3);
              }
              if (t2.hasIconCollisionBoxData() || t2.hasTextCollisionBoxData()) {
                const i3 = t2.collisionArrays[o3];
                if (i3) {
                  let o4 = new e.P(0, 0), r3 = true;
                  if (i3.textBox || i3.verticalTextBox) {
                    if (d2) {
                      const e2 = this.variableOffsets[x2];
                      e2 ? (o4 = ta(e2.anchor, e2.width, e2.height, e2.textOffset, e2.textScale), p2 && o4._rotate(f2 ? this.transform.angle : -this.transform.angle)) : r3 = false;
                    }
                    c2 && (r3 = !E2.clipped), i3.textBox && ra(t2.textCollisionBox.collisionVertexArray, E2.text.placed, !r3 || L2, o4.x, o4.y), i3.verticalTextBox && ra(t2.textCollisionBox.collisionVertexArray, E2.text.placed, !r3 || P2, o4.x, o4.y);
                  }
                  const a3 = r3 && Boolean(!P2 && i3.verticalIconBox);
                  i3.iconBox && ra(t2.iconCollisionBox.collisionVertexArray, E2.icon.placed, a3, l3.hasIconTextFit ? o4.x : 0, l3.hasIconTextFit ? o4.y : 0), i3.verticalIconBox && ra(t2.iconCollisionBox.collisionVertexArray, E2.icon.placed, !a3, l3.hasIconTextFit ? o4.x : 0, l3.hasIconTextFit ? o4.y : 0);
                }
              }
            }
            if (t2.fullyClipped = 0 === v2, t2.sortFeatures(this.transform.angle), this.retainedQueryData[t2.bucketInstanceId] && (this.retainedQueryData[t2.bucketInstanceId].featureSortOrder = t2.featureSortOrder), t2.hasTextData() && t2.text.opacityVertexBuffer && t2.text.opacityVertexBuffer.updateData(t2.text.opacityVertexArray), t2.hasIconData() && t2.icon.opacityVertexBuffer && t2.icon.opacityVertexBuffer.updateData(t2.icon.opacityVertexArray), t2.hasIconCollisionBoxData() && t2.iconCollisionBox.collisionVertexBuffer && t2.iconCollisionBox.collisionVertexBuffer.updateData(t2.iconCollisionBox.collisionVertexArray), t2.hasTextCollisionBoxData() && t2.textCollisionBox.collisionVertexBuffer && t2.textCollisionBox.collisionVertexBuffer.updateData(t2.textCollisionBox.collisionVertexArray), t2.bucketInstanceId in this.collisionCircleArrays) {
              const e2 = this.collisionCircleArrays[t2.bucketInstanceId];
              t2.placementInvProjMatrix = e2.invProjMatrix, t2.placementViewportMatrix = e2.viewportMatrix, t2.collisionCircleArray = e2.circles, delete this.collisionCircleArrays[t2.bucketInstanceId];
            }
          }
          symbolFadeChange(e2) {
            return 0 === this.fadeDuration ? 1 : (e2 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
          }
          zoomAdjustment(e2) {
            return Math.max(0, (this.transform.zoom - e2) / 1.5);
          }
          hasTransitions(e2) {
            return this.stale || e2 - this.lastPlacementChangeTime < this.fadeDuration;
          }
          stillRecent(e2, t2) {
            const i2 = this.zoomAtLastRecencyCheck === t2 ? 1 - this.zoomAdjustment(t2) : 1;
            return this.zoomAtLastRecencyCheck = t2, this.commitTime + this.fadeDuration * i2 > e2;
          }
          setStale() {
            this.stale = true;
          }
        }
        function ra(e2, t2, i2, o2, r2) {
          e2.emplaceBack(t2 ? 1 : 0, i2 ? 1 : 0, o2 || 0, r2 || 0), e2.emplaceBack(t2 ? 1 : 0, i2 ? 1 : 0, o2 || 0, r2 || 0), e2.emplaceBack(t2 ? 1 : 0, i2 ? 1 : 0, o2 || 0, r2 || 0), e2.emplaceBack(t2 ? 1 : 0, i2 ? 1 : 0, o2 || 0, r2 || 0);
        }
        const aa = Math.pow(2, 25), na = Math.pow(2, 24), sa = Math.pow(2, 17), la = Math.pow(2, 16), ca = Math.pow(2, 9), ha = Math.pow(2, 8), _a = Math.pow(2, 1);
        function ua(e2) {
          if (0 === e2.opacity && !e2.placed)
            return 0;
          if (1 === e2.opacity && e2.placed)
            return 4294967295;
          const t2 = e2.placed ? 1 : 0, i2 = Math.floor(127 * e2.opacity);
          return i2 * aa + t2 * na + i2 * sa + t2 * la + i2 * ca + t2 * ha + i2 * _a + t2;
        }
        const da = 0;
        class pa {
          constructor(e2) {
            this._sortAcrossTiles = "viewport-y" !== e2.layout.get("symbol-z-order") && void 0 !== e2.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = /* @__PURE__ */ new Set(), this._bucketParts = [];
          }
          continuePlacement(e2, t2, i2, o2, r2) {
            const a2 = this._bucketParts;
            for (; this._currentTileIndex < e2.length; )
              if (t2.getBucketParts(a2, o2, e2[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, r2())
                return true;
            for (this._sortAcrossTiles && (this._sortAcrossTiles = false, a2.sort((e3, t3) => e3.sortKey - t3.sortKey)); this._currentPartIndex < a2.length; ) {
              const e3 = a2[this._currentPartIndex];
              if (t2.placeLayerBucketPart(e3, this._seenCrossTileIDs, i2, 0 === e3.symbolInstanceStart), this._currentPartIndex++, r2())
                return true;
            }
            return false;
          }
        }
        class fa {
          constructor(e2, t2, i2, o2, r2, a2, n2, s2, l2) {
            this.placement = new oa(e2, r2, a2, n2, s2, l2), this._currentPlacementIndex = t2.length - 1, this._forceFullPlacement = i2, this._showCollisionBoxes = o2, this._done = false;
          }
          isDone() {
            return this._done;
          }
          continuePlacement(t2, i2, o2, r2) {
            const a2 = e.e.now(), n2 = () => {
              const t3 = e.e.now() - a2;
              return !this._forceFullPlacement && t3 > 2;
            };
            for (; this._currentPlacementIndex >= 0; ) {
              const a3 = i2[t2[this._currentPlacementIndex]], s2 = this.placement.collisionIndex.transform.zoom;
              if ("symbol" === a3.type && (!a3.minzoom || a3.minzoom <= s2) && (!a3.maxzoom || a3.maxzoom > s2)) {
                const t3 = a3, i3 = t3.layout.get("symbol-z-elevate"), s3 = this._inProgressLayer = this._inProgressLayer || new pa(t3), l2 = e.am(a3.source, a3.scope);
                if (s3.continuePlacement(i3 ? r2[l2] : o2[l2], this.placement, this._showCollisionBoxes, a3, n2))
                  return;
                delete this._inProgressLayer;
              }
              this._currentPlacementIndex--;
            }
            this._done = true;
          }
          commit(e2) {
            return this.placement.commit(e2), this.placement;
          }
        }
        const ma = 512 / e.a4 / 2;
        class ga {
          constructor(t2, i2, o2) {
            this.tileID = t2, this.bucketInstanceId = o2, this.index = new e.cN(i2.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
            const r2 = t2.canonical.x * e.a4, a2 = t2.canonical.y * e.a4;
            for (let e2 = 0; e2 < i2.length; e2++) {
              const { key: t3, crossTileID: o3, tileAnchorX: n2, tileAnchorY: s2 } = i2.get(e2), l2 = Math.floor((r2 + n2) * ma), c2 = Math.floor((a2 + s2) * ma);
              this.index.add(l2, c2), this.keys.push(t3), this.crossTileIDs.push(o3);
            }
            this.index.finish();
          }
          findMatches(t2, i2, o2) {
            const r2 = this.tileID.canonical.z < i2.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - i2.canonical.z), a2 = ma / Math.pow(2, i2.canonical.z - this.tileID.canonical.z), n2 = i2.canonical.x * e.a4, s2 = i2.canonical.y * e.a4;
            for (let e2 = 0; e2 < t2.length; e2++) {
              const i3 = t2.get(e2);
              if (i3.crossTileID)
                continue;
              const { key: l2, tileAnchorX: c2, tileAnchorY: h2 } = i3, _2 = Math.floor((n2 + c2) * a2), u2 = Math.floor((s2 + h2) * a2), d2 = this.index.range(_2 - r2, u2 - r2, _2 + r2, u2 + r2);
              for (const e3 of d2) {
                const t3 = this.crossTileIDs[e3];
                if (this.keys[e3] === l2 && !o2.has(t3)) {
                  o2.add(t3), i3.crossTileID = t3;
                  break;
                }
              }
            }
          }
        }
        class va {
          constructor() {
            this.maxCrossTileID = 0;
          }
          generate() {
            return ++this.maxCrossTileID;
          }
        }
        class xa {
          constructor() {
            this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
          }
          handleWrapJump(e2) {
            const t2 = Math.round((e2 - this.lng) / 360);
            if (0 !== t2)
              for (const e3 in this.indexes) {
                const i2 = this.indexes[e3], o2 = {};
                for (const e4 in i2) {
                  const r2 = i2[e4];
                  r2.tileID = r2.tileID.unwrapTo(r2.tileID.wrap + t2), o2[r2.tileID.key] = r2;
                }
                this.indexes[e3] = o2;
              }
            this.lng = e2;
          }
          addBucket(e2, t2, i2) {
            if (this.indexes[e2.overscaledZ] && this.indexes[e2.overscaledZ][e2.key]) {
              if (this.indexes[e2.overscaledZ][e2.key].bucketInstanceId === t2.bucketInstanceId)
                return false;
              this.removeBucketCrossTileIDs(e2.overscaledZ, this.indexes[e2.overscaledZ][e2.key]);
            }
            for (let e3 = 0; e3 < t2.symbolInstances.length; e3++)
              t2.symbolInstances.get(e3).crossTileID = 0;
            this.usedCrossTileIDs[e2.overscaledZ] || (this.usedCrossTileIDs[e2.overscaledZ] = /* @__PURE__ */ new Set());
            const o2 = this.usedCrossTileIDs[e2.overscaledZ];
            for (const i3 in this.indexes) {
              const r2 = this.indexes[i3];
              if (Number(i3) > e2.overscaledZ)
                for (const i4 in r2) {
                  const a2 = r2[i4];
                  a2.tileID.isChildOf(e2) && a2.findMatches(t2.symbolInstances, e2, o2);
                }
              else {
                const a2 = r2[e2.scaledTo(Number(i3)).key];
                a2 && a2.findMatches(t2.symbolInstances, e2, o2);
              }
            }
            for (let e3 = 0; e3 < t2.symbolInstances.length; e3++) {
              const r2 = t2.symbolInstances.get(e3);
              r2.crossTileID || (r2.crossTileID = i2.generate(), o2.add(r2.crossTileID));
            }
            return void 0 === this.indexes[e2.overscaledZ] && (this.indexes[e2.overscaledZ] = {}), this.indexes[e2.overscaledZ][e2.key] = new ga(e2, t2.symbolInstances, t2.bucketInstanceId), true;
          }
          removeBucketCrossTileIDs(e2, t2) {
            for (const i2 of t2.crossTileIDs)
              this.usedCrossTileIDs[e2].delete(i2);
          }
          removeStaleBuckets(e2) {
            let t2 = false;
            for (const i2 in this.indexes) {
              const o2 = this.indexes[i2];
              for (const r2 in o2)
                e2[o2[r2].bucketInstanceId] || (this.removeBucketCrossTileIDs(i2, o2[r2]), delete o2[r2], t2 = true);
            }
            return t2;
          }
        }
        class ya {
          constructor() {
            this.layerIndexes = {}, this.crossTileIDs = new va(), this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
          }
          addLayer(e2, t2, i2, o2) {
            let r2 = this.layerIndexes[e2.fqid];
            void 0 === r2 && (r2 = this.layerIndexes[e2.fqid] = new xa());
            let a2 = false;
            const n2 = {};
            "globe" !== o2.name && r2.handleWrapJump(i2);
            for (const i3 of t2) {
              const t3 = i3.getBucket(e2);
              t3 && e2.fqid === t3.layerIds[0] && (t3.bucketInstanceId || (t3.bucketInstanceId = ++this.maxBucketInstanceId), r2.addBucket(i3.tileID, t3, this.crossTileIDs) && (a2 = true), n2[t3.bucketInstanceId] = true);
            }
            return r2.removeStaleBuckets(n2) && (a2 = true), a2;
          }
          pruneUnusedLayers(e2) {
            const t2 = {};
            e2.forEach((e3) => {
              t2[e3] = true;
            });
            for (const e3 in this.layerIndexes)
              t2[e3] || delete this.layerIndexes[e3];
          }
        }
        const ba = new e.U({ data: new e.W(e.N.colorTheme.data) }), wa = (e2, t2) => We(e2, t2 && t2.filter((e3) => "source.canvas" !== e3.identifier)), Ta = e.ai(Br, ["addLayer", "removeLayer", "setLights", "setPaintProperty", "setLayoutProperty", "setSlot", "setFilter", "addSource", "removeSource", "setLayerZoomRange", "setLight", "setTransition", "setGeoJSONSourceData", "setTerrain", "setFog", "setProjection", "setCamera", "addImport", "removeImport", "updateImport"]), Ea = e.ai(Br, ["setCenter", "setZoom", "setBearing", "setPitch"]), Ca = { version: 8, layers: [], sources: {} }, Sa = { duration: 300, delay: 0 };
        class Ia extends e.E {
          constructor(t2, i2 = {}) {
            super(), this.map = t2, this.scope = i2.scope || "", this.globalId = null, this.fragments = [], this.importDepth = i2.importDepth || 0, this.importsCache = i2.importsCache || /* @__PURE__ */ new Map(), this.resolvedImports = i2.resolvedImports || /* @__PURE__ */ new Set(), this.transition = e.Q({}, Sa), this._buildingIndex = new zr(this), this.crossTileSymbolIndex = new ya(), this._mergedOrder = [], this._drapedFirstOrder = [], this._mergedLayers = {}, this._mergedSourceCaches = {}, this._mergedOtherSourceCaches = {}, this._mergedSymbolSourceCaches = {}, this._clipLayerIndices = [], this._has3DLayers = false, this._hasCircleLayers = false, this._hasSymbolLayers = false, this._changes = i2.styleChanges || new g(), this.dispatcher = i2.dispatcher ? i2.dispatcher : new e.by(e.bz(), this), i2.imageManager ? this.imageManager = i2.imageManager : (this.imageManager = new le(), this.imageManager.setEventedParent(this)), this.imageManager.createScope(this.scope), this.glyphManager = i2.glyphManager ? i2.glyphManager : new e.cP(t2._requestManager, i2.localFontFamily ? e.cQ.all : i2.localIdeographFontFamily ? e.cQ.ideographs : e.cQ.none, i2.localFontFamily || i2.localIdeographFontFamily), i2.modelManager ? this.modelManager = i2.modelManager : (this.modelManager = new ne(t2._requestManager), this.modelManager.setEventedParent(this)), this._layers = {}, this._serializedLayers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this._loaded = false, this._precompileDone = false, this._shouldPrecompile = false, this._availableImages = [], this._order = [], this._markersNeedUpdate = false, this._styleColorTheme = { lut: null, lutLoading: false, lutLoadingCorrelationID: 0, colorTheme: null }, this._styleColorThemeForScope = {}, this.options = i2.configOptions ? i2.configOptions : /* @__PURE__ */ new Map(), this._configDependentLayers = i2.configDependentLayers ? i2.configDependentLayers : /* @__PURE__ */ new Set(), this._config = i2.config, this._initialConfig = i2.initialConfig, this.dispatcher.broadcast("setReferrer", e.cR());
            const o2 = this;
            this._rtlTextPluginCallback = Ia.registerForPluginStateChange((t3) => {
              o2.dispatcher.broadcast("syncRTLPluginState", { pluginStatus: t3.pluginStatus, pluginURL: t3.pluginURL }, (t4, i3) => {
                if (e.cS(t4), i3 && i3.every((e2) => e2))
                  for (const e2 in o2._sourceCaches) {
                    const t5 = o2._sourceCaches[e2], i4 = t5.getSource().type;
                    "vector" !== i4 && "geojson" !== i4 || t5.reload();
                  }
              });
            }), this.on("data", (e2) => {
              if ("source" !== e2.dataType || "metadata" !== e2.sourceDataType)
                return;
              const t3 = this.getOwnSource(e2.sourceId);
              if (t3 && t3.vectorLayerIds)
                for (const e3 in this._layers) {
                  const i3 = this._layers[e3];
                  i3.source === t3.id && this._validateLayer(i3);
                }
            });
          }
          load(e2) {
            return e2 ? ("string" == typeof e2 ? this.loadURL(e2) : this.loadJSON(e2), this) : this;
          }
          _getGlobalId(t2) {
            if (!t2)
              return null;
            if ("string" == typeof t2) {
              if (e.cT(t2))
                return t2;
              const i2 = e.cU(t2);
              if (!i2.startsWith("http"))
                try {
                  return new URL(i2, location.href).toString();
                } catch (e2) {
                  return i2;
                }
              return i2;
            }
            return `json://${e.cV(JSON.stringify(t2))}`;
          }
          _diffStyle(t2, i2, o2) {
            this.globalId = this._getGlobalId(t2);
            const r2 = (e2, t3) => {
              try {
                t3(null, this.setState(e2, o2));
              } catch (e3) {
                t3(e3, false);
              }
            };
            if ("string" == typeof t2) {
              const o3 = this.map._requestManager.normalizeStyleURL(t2), a2 = this.map._requestManager.transformRequest(o3, e.R.Style);
              e.h(a2, (t3, o4) => {
                t3 ? this.fire(new e.f(t3)) : o4 && r2(o4, i2);
              });
            } else
              "object" == typeof t2 && r2(t2, i2);
          }
          loadURL(t2, i2 = {}) {
            this.fire(new e.g("dataloading", { dataType: "style" }));
            const o2 = "boolean" == typeof i2.validate ? i2.validate : !e.cT(t2);
            this.globalId = this._getGlobalId(t2), t2 = this.map._requestManager.normalizeStyleURL(t2, i2.accessToken), this.resolvedImports.add(t2);
            const r2 = this.importsCache.get(t2);
            if (r2)
              return this._load(r2, o2);
            const a2 = this.map._requestManager.transformRequest(t2, e.R.Style);
            this._request = e.h(a2, (i3, r3) => {
              if (this._request = null, i3)
                this.fire(new e.f(i3));
              else if (r3)
                return this.importsCache.set(t2, r3), this._load(r3, o2);
            });
          }
          loadJSON(t2, i2 = {}) {
            this.fire(new e.g("dataloading", { dataType: "style" })), this.globalId = this._getGlobalId(t2), this._request = e.e.frame(() => {
              this._request = null, this._load(t2, false !== i2.validate);
            });
          }
          loadEmpty() {
            this.fire(new e.g("dataloading", { dataType: "style" })), this._load(Ca, false);
          }
          _loadImports(t2, i2, o2) {
            if (this.importDepth >= 4)
              return e.w("Style doesn't support nesting deeper than 5"), Promise.resolve();
            const r2 = [];
            for (const e2 of t2) {
              const t3 = this._createFragmentStyle(e2), a2 = new Promise((e3) => {
                t3.once("style.import.load", e3), t3.once("error", e3);
              }).then(() => this.mergeAll());
              if (r2.push(a2), this.resolvedImports.has(e2.url)) {
                t3.loadEmpty();
                continue;
              }
              const n2 = e2.data || this.importsCache.get(e2.url);
              n2 ? (t3.loadJSON(n2, { validate: i2 }), this._isInternalStyle(n2) && (t3.globalId = null)) : e2.url ? t3.loadURL(e2.url, { validate: i2 }) : t3.loadEmpty();
              const s2 = { style: t3, id: e2.id, config: e2.config };
              if (o2) {
                const e3 = this.fragments.findIndex(({ id: e4 }) => e4 === o2);
                this.fragments = this.fragments.slice(0, e3).concat(s2).concat(this.fragments.slice(e3));
              } else
                this.fragments.push(s2);
            }
            return Promise.allSettled(r2);
          }
          getImportGlobalIds(e2 = this, t2 = /* @__PURE__ */ new Set()) {
            for (const i2 of e2.fragments)
              i2.style.globalId && t2.add(i2.style.globalId), this.getImportGlobalIds(i2.style, t2);
            return [...t2.values()];
          }
          _createFragmentStyle(t2) {
            const i2 = this.scope ? e.am(t2.id, this.scope) : t2.id;
            let o2;
            const r2 = this._initialConfig && this._initialConfig[i2];
            (t2.config || r2) && (o2 = e.Q({}, t2.config, r2));
            const a2 = new Ia(this.map, { scope: i2, styleChanges: this._changes, importDepth: this.importDepth + 1, importsCache: this.importsCache, resolvedImports: new Set(this.resolvedImports), dispatcher: this.dispatcher, imageManager: this.imageManager, glyphManager: this.glyphManager, modelManager: this.modelManager, config: o2, configOptions: this.options, configDependentLayers: this._configDependentLayers });
            return a2.setEventedParent(this.map, { style: a2 }), a2;
          }
          _reloadImports() {
            this.mergeAll(), this._updateMapProjection(), this.updateConfigDependencies(), this.map._triggerCameraUpdate(this.camera), this.dispatcher.broadcast("setLayers", { layers: this._serializeLayers(this._order), scope: this.scope, options: this.options }), this._shouldPrecompile = this.map._precompilePrograms && this.isRootStyle();
          }
          _isInternalStyle(e2) {
            return this.isRootStyle() && (e2.fragment || !!e2.schema && false !== e2.fragment);
          }
          _load(t2, i2) {
            const o2 = t2.schema;
            if (this._isInternalStyle(t2)) {
              const o3 = e.Q({}, Ca, { imports: [{ id: "basemap", data: t2, url: "" }] });
              return void this._load(o3, i2);
            }
            if (this.updateConfig(this._config, o2), i2 && wa(this, ze(t2)))
              return;
            this._loaded = true, this.stylesheet = e.cW(t2);
            const r2 = () => {
              for (const e2 in t2.sources)
                this.addSource(e2, t2.sources[e2], { validate: false, isInitialLoad: true });
              t2.sprite ? this._loadSprite(t2.sprite) : (this.imageManager.setLoaded(true, this.scope), this.dispatcher.broadcast("spriteLoaded", { scope: this.scope, isLoaded: true })), this.glyphManager.setURL(t2.glyphs, this.scope);
              const o3 = Fr(this.stylesheet.layers);
              if (this._order = o3.map((e2) => e2.id), this.stylesheet.light && e.w("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), this.stylesheet.lights)
                if (1 === this.stylesheet.lights.length && "flat" === this.stylesheet.lights[0].type) {
                  const e2 = this.stylesheet.lights[0];
                  this.light = new qe(e2.properties, e2.id);
                } else
                  this.setLights(this.stylesheet.lights);
              this.light || (this.light = new qe(this.stylesheet.light)), this._layers = {}, this._serializedLayers = {};
              for (const t3 of o3) {
                const i3 = e.c$(t3, this.scope, this._styleColorTheme.lut, this.options);
                0 !== i3.configDependencies.size && this._configDependentLayers.add(i3.fqid), i3.setEventedParent(this, { layer: { id: i3.id } }), this._layers[i3.id] = i3, this._serializedLayers[i3.id] = i3.serialize();
                const o4 = this.getOwnLayerSourceCache(i3), r4 = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                o4 && i3.canCastShadows() && r4 && (o4.castsShadows = true);
              }
              this.stylesheet.models && this.modelManager.addModels(this.stylesheet.models, this.scope);
              const r3 = this.stylesheet.terrain;
              r3 && (this.checkCanvasFingerprintNoise(), this.disableElevatedTerrain || this.terrainSetForDrapingOnly() || this._createTerrain(r3, 1)), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this.stylesheet.transition && this.setTransition(this.stylesheet.transition), this.fire(new e.g("data", { dataType: "style" }));
              const a3 = this.isRootStyle();
              t2.imports ? this._loadImports(t2.imports, i2).then(() => {
                this._reloadImports(), this.fire(new e.g(a3 ? "style.load" : "style.import.load"));
              }) : (this._reloadImports(), this.fire(new e.g(a3 ? "style.load" : "style.import.load")));
            }, a2 = this.stylesheet["color-theme"];
            if (this._styleColorTheme.colorTheme = a2, a2) {
              const t3 = this._evaluateColorThemeData(a2);
              this._loadColorTheme(t3).then(() => {
                r2();
              }).catch((t4) => {
                e.w(`Couldn't load color theme from the stylesheet: ${t4}`), r2();
              });
            } else
              this._styleColorTheme.lut = null, r2();
          }
          isRootStyle() {
            return 0 === this.importDepth;
          }
          mergeAll() {
            let t2, i2, o2, r2, a2, n2, s2, l2;
            const c2 = {};
            this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((e2) => {
              if (e2.stylesheet) {
                if (null != e2.light && (t2 = e2.light), e2.stylesheet.lights)
                  for (const t3 of e2.stylesheet.lights)
                    "ambient" === t3.type && null != e2.ambientLight && (i2 = e2.ambientLight), "directional" === t3.type && null != e2.directionalLight && (o2 = e2.directionalLight);
                r2 = this._prioritizeTerrain(r2, e2.terrain, e2.stylesheet.terrain), e2.stylesheet.fog && null != e2.fog && (a2 = e2.fog), null != e2.stylesheet.camera && (l2 = e2.stylesheet.camera), null != e2.stylesheet.projection && (n2 = e2.stylesheet.projection), null != e2.stylesheet.transition && (s2 = e2.stylesheet.transition), c2[e2.scope] = e2._styleColorTheme;
              }
            }), this.light = t2, this.ambientLight = i2, this.directionalLight = o2, this.fog = a2, this._styleColorThemeForScope = c2, null === r2 ? delete this.terrain : this.terrain = r2, this.camera = l2 || { "camera-projection": "perspective" }, this.projection = n2 || { name: "mercator" }, this.transition = e.Q({}, Sa, s2), this.mergeSources(), this.mergeLayers();
          }
          forEachFragmentStyle(e2) {
            const t2 = (i2) => {
              for (const e3 of i2.fragments)
                t2(e3.style);
              e2(i2);
            };
            t2(this);
          }
          _prioritizeTerrain(e2, t2, i2) {
            const o2 = e2 && 0 === e2.drapeRenderMode;
            return null === i2 ? t2 && 0 === t2.drapeRenderMode ? t2 : o2 ? e2 : null : null != t2 && (!e2 || o2 || t2 && 1 === t2.drapeRenderMode) ? t2 : e2;
          }
          mergeTerrain() {
            let e2;
            this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((t2) => {
              e2 = this._prioritizeTerrain(e2, t2.terrain, t2.stylesheet.terrain);
            }), null === e2 ? delete this.terrain : this.terrain = e2;
          }
          mergeProjection() {
            let e2;
            this.forEachFragmentStyle((t2) => {
              null != t2.stylesheet.projection && (e2 = t2.stylesheet.projection);
            }), this.projection = e2 || { name: "mercator" };
          }
          mergeSources() {
            const t2 = {}, i2 = {}, o2 = {};
            this.forEachFragmentStyle((r2) => {
              for (const i3 in r2._sourceCaches) {
                const o3 = e.am(i3, r2.scope);
                t2[o3] = r2._sourceCaches[i3];
              }
              for (const t3 in r2._otherSourceCaches) {
                const o3 = e.am(t3, r2.scope);
                i2[o3] = r2._otherSourceCaches[t3];
              }
              for (const t3 in r2._symbolSourceCaches) {
                const i3 = e.am(t3, r2.scope);
                o2[i3] = r2._symbolSourceCaches[t3];
              }
            }), this._mergedSourceCaches = t2, this._mergedOtherSourceCaches = i2, this._mergedSymbolSourceCaches = o2;
          }
          mergeLayers() {
            const t2 = {}, i2 = [], o2 = {};
            this._mergedSlots = [], this._has3DLayers = false, this._hasCircleLayers = false, this._hasSymbolLayers = false, this.forEachFragmentStyle((o3) => {
              for (const r3 of o3._order) {
                const a3 = o3._layers[r3];
                if ("slot" === a3.type) {
                  const i3 = e.cX(r3);
                  if (t2[i3])
                    continue;
                  t2[i3] = [];
                }
                a3.slot && t2[a3.slot] ? t2[a3.slot].push(a3) : i2.push(a3);
              }
            }), this._mergedOrder = [], this._clipLayerIndices = [];
            let r2 = 0;
            const a2 = (i3 = []) => {
              for (const n2 of i3)
                if ("slot" === n2.type) {
                  const i4 = e.cX(n2.id);
                  t2[i4] && a2(t2[i4]), this._mergedSlots.push(i4);
                } else {
                  const t3 = e.am(n2.id, n2.scope);
                  this._mergedOrder.push(t3), o2[t3] = n2, n2.is3D() && (this._has3DLayers = true), "circle" === n2.type && (this._hasCircleLayers = true), "symbol" === n2.type && (this._hasSymbolLayers = true), "clip" === n2.type && this._clipLayerIndices.push(r2), r2++;
                }
            };
            a2(i2), this._mergedOrder.sort((e2, t3) => {
              const i3 = o2[e2], r3 = o2[t3];
              return i3.hasInitialOcclusionOpacityProperties ? r3.is3D() ? 1 : 0 : i3.is3D() && r3.hasInitialOcclusionOpacityProperties ? -1 : 0;
            }), this._mergedLayers = o2, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged();
          }
          terrainSetForDrapingOnly() {
            return !!this.terrain && 0 === this.terrain.drapeRenderMode;
          }
          getCamera() {
            return this.stylesheet.camera;
          }
          setCamera(t2) {
            return this.stylesheet.camera = e.Q({}, this.stylesheet.camera, t2), this.camera = this.stylesheet.camera, this;
          }
          _evaluateColorThemeData(t2) {
            return t2.data ? function(t3, i2, o2) {
              const r2 = e.Q({}, i2);
              for (const t4 of Object.keys(e.N.colorTheme))
                void 0 === r2[t4] && (r2[t4] = e.N.colorTheme[t4].default);
              const a2 = new e.O(ba, t3, new Map(o2));
              return a2.setTransitionOrValue(r2, o2), a2.untransitioned().possiblyEvaluate(new e.Y(0));
            }(this.scope, t2, this.options).get("data") : null;
          }
          _loadColorTheme(t2) {
            this._styleColorTheme.lutLoading = true, this._styleColorTheme.lutLoadingCorrelationID += 1;
            const i2 = this._styleColorTheme.lutLoadingCorrelationID;
            return new Promise((o2, r2) => {
              const a2 = "data:image/png;base64,";
              if (!t2 || 0 === t2.length)
                return this._styleColorTheme.lut = null, this._styleColorTheme.lutLoading = false, void o2();
              let n2 = t2;
              n2.startsWith(a2) || (n2 = a2 + n2);
              const s2 = "mapbox-reserved-lut", l2 = new Image();
              l2.src = n2, l2.onerror = () => {
                this._styleColorTheme.lutLoading = false, r2(new Error("Failed to load image data"));
              }, l2.onload = () => {
                if (this._styleColorTheme.lutLoadingCorrelationID !== i2)
                  return void o2();
                this._styleColorTheme.lutLoading = false;
                const { width: a3, height: n3, data: c2 } = e.e.getImageData(l2);
                if (n3 > 32)
                  return void r2(new Error("The height of the image must be less than or equal to 32 pixels."));
                if (a3 !== n3 * n3)
                  return void r2(new Error("The width of the image must be equal to the height squared."));
                this.getImage(s2) && this.removeImage(s2), this.addImage(s2, { data: new e.j({ width: a3, height: n3 }, c2), pixelRatio: 1, sdf: false, version: 0 });
                const h2 = this.imageManager.getImage(s2, this.scope);
                h2 ? (this._styleColorTheme.lut = { image: h2.data, data: t2 }, o2()) : r2(new Error("Missing LUT image."));
              };
            });
          }
          getLut(e2) {
            const t2 = this._styleColorThemeForScope[e2];
            return t2 ? t2.lut : null;
          }
          setProjection(e2) {
            e2 ? this.stylesheet.projection = e2 : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
          }
          applyProjectionUpdate() {
            this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? (this.getTerrain() || this.stylesheet.terrain) && !this.disableElevatedTerrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null, 0));
          }
          _updateMapProjection() {
            this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
          }
          _loadSprite(t2) {
            this._spriteRequest = function(t3, i2, o2) {
              let r2, a2, n2;
              const s2 = e.e.devicePixelRatio > 1 ? "@2x" : "";
              let l2 = e.h(i2.transformRequest(i2.normalizeSpriteURL(t3, s2, ".json"), e.R.SpriteJSON), (e2, t4) => {
                l2 = null, n2 || (n2 = e2, r2 = t4, h2());
              }), c2 = e.i(i2.transformRequest(i2.normalizeSpriteURL(t3, s2, ".png"), e.R.SpriteImage), (e2, t4) => {
                c2 = null, n2 || (n2 = e2, a2 = t4, h2());
              });
              function h2() {
                if (n2)
                  o2(n2);
                else if (r2 && a2) {
                  const t4 = e.e.getImageData(a2), i3 = {};
                  for (const o3 in r2) {
                    const { width: a3, height: n3, x: s3, y: l3, sdf: c3, pixelRatio: h3, stretchX: _2, stretchY: u2, content: d2 } = r2[o3], p2 = new e.j({ width: a3, height: n3 });
                    e.j.copy(t4, p2, { x: s3, y: l3 }, { x: 0, y: 0 }, { width: a3, height: n3 }, null), i3[o3] = { data: p2, pixelRatio: h3, sdf: c3, stretchX: _2, stretchY: u2, content: d2 };
                  }
                  o2(null, i3);
                }
              }
              return { cancel() {
                l2 && (l2.cancel(), l2 = null), c2 && (c2.cancel(), c2 = null);
              } };
            }(t2, this.map._requestManager, (t3, i2) => {
              if (this._spriteRequest = null, t3)
                this.fire(new e.f(t3));
              else if (i2)
                for (const e2 in i2)
                  this.imageManager.addImage(e2, this.scope, i2[e2]);
              this.imageManager.setLoaded(true, this.scope), this._availableImages = this.imageManager.listImages(this.scope), this.dispatcher.broadcast("setImages", { scope: this.scope, images: this._availableImages }), this.dispatcher.broadcast("spriteLoaded", { scope: this.scope, isLoaded: true }), this.fire(new e.g("data", { dataType: "style" }));
            });
          }
          _validateLayer(t2) {
            const i2 = this.getOwnSource(t2.source);
            if (!i2)
              return;
            const o2 = t2.sourceLayer;
            o2 && ("geojson" === i2.type || i2.vectorLayerIds && -1 === i2.vectorLayerIds.indexOf(o2)) && this.fire(new e.f(new Error(`Source layer "${o2}" does not exist on source "${i2.id}" as specified by style layer "${t2.id}"`)));
          }
          loaded() {
            if (!this._loaded)
              return false;
            if (Object.keys(this._changes.getUpdatedSourceCaches()).length)
              return false;
            for (const e2 in this._sourceCaches)
              if (!this._sourceCaches[e2].loaded())
                return false;
            if (!this.imageManager.isLoaded())
              return false;
            if (!this.modelManager.isLoaded())
              return false;
            if (this._styleColorTheme.lutLoading)
              return false;
            for (const { style: e2 } of this.fragments)
              if (!e2.loaded())
                return false;
            return true;
          }
          _serializeImports() {
            if (this.stylesheet.imports)
              return this.stylesheet.imports.map((e2, t2) => {
                const i2 = this.fragments[t2];
                return i2 && i2.style && (e2.data = i2.style.serialize()), e2;
              });
          }
          _serializeSources() {
            const e2 = {};
            for (const t2 in this._sourceCaches) {
              const i2 = this._sourceCaches[t2].getSource();
              e2[i2.id] || (e2[i2.id] = i2.serialize());
            }
            return e2;
          }
          _serializeLayers(e2) {
            const t2 = [];
            for (const i2 of e2) {
              const e3 = this._layers[i2];
              e3 && "custom" !== e3.type && t2.push(e3.serialize());
            }
            return t2;
          }
          hasLightTransitions() {
            return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
          }
          hasFogTransition() {
            return !!this.fog && this.fog.hasTransition();
          }
          hasTransitions() {
            if (this.hasLightTransitions())
              return true;
            if (this.hasFogTransition())
              return true;
            for (const e2 in this._sourceCaches)
              if (this._sourceCaches[e2].hasTransition())
                return true;
            for (const e2 in this._layers)
              if (this._layers[e2].hasTransition())
                return true;
            return false;
          }
          get order() {
            return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
          }
          isLayerDraped(e2) {
            return !!this.terrain && e2.isDraped(this.getLayerSourceCache(e2));
          }
          _checkLoaded() {
            if (!this._loaded)
              throw new Error("Style is not done loading");
          }
          _checkLayer(t2) {
            const i2 = this.getOwnLayer(t2);
            if (i2)
              return i2;
            this.fire(new e.f(new Error(`The layer '${t2}' does not exist in the map's style.`)));
          }
          _checkSource(t2) {
            const i2 = this.getOwnSource(t2);
            if (i2)
              return i2;
            this.fire(new e.f(new Error(`The source '${t2}' does not exist in the map's style.`)));
          }
          precompilePrograms(e2, t2) {
            const i2 = this.map.painter;
            if (i2)
              for (let o2 = e2.minzoom || 0; o2 < (e2.maxzoom || 25.5); o2++) {
                const o3 = e2.getProgramIds();
                if (o3)
                  for (const r2 of o3) {
                    const o4 = e2.getDefaultProgramParams(r2, t2.zoom, this._styleColorTheme.lut);
                    o4 && (i2.style = this, this.fog && (i2._fogVisible = true, o4.overrideFog = true, i2.getOrCreateProgram(r2, o4)), i2._fogVisible = false, o4.overrideFog = false, i2.getOrCreateProgram(r2, o4), (this.stylesheet.terrain || this.stylesheet.projection && "globe" === this.stylesheet.projection.name) && (o4.overrideRtt = true, i2.getOrCreateProgram(r2, o4)));
                  }
              }
          }
          update(t2) {
            if (!this._loaded)
              return;
            this.ambientLight && this.ambientLight.recalculate(t2), this.directionalLight && this.directionalLight.recalculate(t2);
            const i2 = this.calculateLightsBrightness();
            t2.brightness = i2 || 0, i2 !== this._brightness && (this._brightness = i2, this.dispatcher.broadcast("setBrightness", i2));
            const o2 = this._changes.isDirty();
            let r2 = false;
            if (this._changes.isDirty()) {
              const e2 = this._changes.getLayerUpdatesByScope();
              for (const t3 in e2) {
                const { updatedIds: i3, removedIds: o3 } = e2[t3];
                (i3 || o3) && (this._updateWorkerLayers(t3, i3, o3), r2 = true);
              }
              this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(t2), this.light && this.light.updateTransitions(t2), this.ambientLight && this.ambientLight.updateTransitions(t2), this.directionalLight && this.directionalLight.updateTransitions(t2), this.fog && this.fog.updateTransitions(t2), this._changes.reset();
            }
            const a2 = {};
            for (const e2 in this._mergedSourceCaches) {
              const t3 = this._mergedSourceCaches[e2];
              a2[e2] = t3.used, t3.used = false, t3.tileCoverLift = 0;
            }
            for (const e2 of this._mergedOrder) {
              const i3 = this._mergedLayers[e2];
              if (i3.recalculate(t2, this._availableImages), !i3.isHidden(t2.zoom)) {
                const e3 = this.getLayerSourceCache(i3);
                e3 && (e3.used = true, e3.tileCoverLift = Math.max(e3.tileCoverLift, i3.tileCoverLift()));
              }
              !this._precompileDone && this._shouldPrecompile && ("requestIdleCallback" in window ? requestIdleCallback(() => {
                this.precompilePrograms(i3, t2);
              }) : this.precompilePrograms(i3, t2));
            }
            this._shouldPrecompile && (this._precompileDone = true), this.terrain && r2 && this.mergeLayers();
            for (const t3 in a2) {
              const i3 = this._mergedSourceCaches[t3];
              a2[t3] !== i3.used && i3.getSource().fire(new e.g("data", { sourceDataType: "visibility", dataType: "source", sourceId: i3.getSource().id }));
            }
            this.light && this.light.recalculate(t2), this.terrain && this.terrain.recalculate(t2), this.fog && this.fog.recalculate(t2), this.z = t2.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = false), o2 && this.fire(new e.g("data", { dataType: "style" }));
          }
          _updateTilesForChangedImages() {
            const e2 = this._changes.getUpdatedImages();
            if (e2.length) {
              for (const t2 in this._sourceCaches)
                this._sourceCaches[t2].reloadTilesForDependencies(["icons", "patterns"], e2);
              this._changes.resetUpdatedImages();
            }
          }
          _updateWorkerLayers(e2, t2, i2) {
            const o2 = this.getFragmentStyle(e2);
            o2 && this.dispatcher.broadcast("updateLayers", { layers: t2 ? o2._serializeLayers(t2) : [], scope: e2, removedIds: i2 || [], options: o2.options });
          }
          setState(t2, i2) {
            if (this._checkLoaded(), wa(this, ze(t2)))
              return false;
            (t2 = e.cW(t2)).layers = Fr(t2.layers);
            const o2 = function(t3, i3) {
              if (!t3)
                return [{ command: Br.setStyle, args: [i3] }];
              let o3 = [];
              try {
                if (!e.d(t3.version, i3.version))
                  return [{ command: Br.setStyle, args: [i3] }];
                if (e.d(t3.center, i3.center) || o3.push({ command: Br.setCenter, args: [i3.center] }), e.d(t3.zoom, i3.zoom) || o3.push({ command: Br.setZoom, args: [i3.zoom] }), e.d(t3.bearing, i3.bearing) || o3.push({ command: Br.setBearing, args: [i3.bearing] }), e.d(t3.pitch, i3.pitch) || o3.push({ command: Br.setPitch, args: [i3.pitch] }), e.d(t3.sprite, i3.sprite) || o3.push({ command: Br.setSprite, args: [i3.sprite] }), e.d(t3.glyphs, i3.glyphs) || o3.push({ command: Br.setGlyphs, args: [i3.glyphs] }), e.d(t3.imports, i3.imports) || function(t4 = [], i4 = [], o4) {
                  i4 = i4 || [];
                  const r4 = (t4 = t4 || []).map(Vr), a4 = i4.map(Vr), n3 = t4.reduce($r, {}), s3 = i4.reduce($r, {}), l2 = r4.slice();
                  let c2, h2, _2, u2;
                  for (c2 = 0, h2 = 0; c2 < r4.length; c2++)
                    _2 = r4[c2], s3.hasOwnProperty(_2) ? h2++ : (o4.push({ command: Br.removeImport, args: [_2] }), l2.splice(l2.indexOf(_2, h2), 1));
                  for (c2 = 0, h2 = 0; c2 < a4.length; c2++)
                    _2 = a4[a4.length - 1 - c2], l2[l2.length - 1 - c2] !== _2 && (n3.hasOwnProperty(_2) ? (o4.push({ command: Br.removeImport, args: [_2] }), l2.splice(l2.lastIndexOf(_2, l2.length - h2), 1)) : h2++, u2 = l2[l2.length - c2], o4.push({ command: Br.addImport, args: [s3[_2], u2] }), l2.splice(l2.length - c2, 0, _2));
                  for (const t5 of i4) {
                    const i5 = n3[t5.id];
                    i5 && !e.d(i5, t5) && o4.push({ command: Br.updateImport, args: [t5.id, t5] });
                  }
                }(t3.imports, i3.imports, o3), e.d(t3.transition, i3.transition) || o3.push({ command: Br.setTransition, args: [i3.transition] }), e.d(t3.light, i3.light) || o3.push({ command: Br.setLight, args: [i3.light] }), e.d(t3.fog, i3.fog) || o3.push({ command: Br.setFog, args: [i3.fog] }), e.d(t3.projection, i3.projection) || o3.push({ command: Br.setProjection, args: [i3.projection] }), e.d(t3.lights, i3.lights) || o3.push({ command: Br.setLights, args: [i3.lights] }), e.d(t3.camera, i3.camera) || o3.push({ command: Br.setCamera, args: [i3.camera] }), !e.d(t3["color-theme"], i3["color-theme"]))
                  return [{ command: Br.setStyle, args: [i3] }];
                const r3 = {}, a3 = [];
                !function(t4, i4, o4, r4) {
                  let a4;
                  for (a4 in i4 = i4 || {}, t4 = t4 || {})
                    t4.hasOwnProperty(a4) && (i4.hasOwnProperty(a4) || Nr(a4, o4, r4));
                  for (a4 in i4) {
                    if (!i4.hasOwnProperty(a4))
                      continue;
                    const n3 = i4[a4];
                    t4.hasOwnProperty(a4) ? e.d(t4[a4], n3) || ("geojson" === t4[a4].type && "geojson" === n3.type && Gr(t4, i4, a4) ? o4.push({ command: Br.setGeoJSONSourceData, args: [a4, n3.data] }) : Ur(a4, i4, o4, r4)) : kr(a4, i4, o4);
                  }
                }(t3.sources, i3.sources, a3, r3);
                const n2 = [];
                t3.layers && t3.layers.forEach((e2) => {
                  e2.source && r3[e2.source] ? o3.push({ command: Br.removeLayer, args: [e2.id] }) : n2.push(e2);
                });
                let s2 = t3.terrain;
                s2 && r3[s2.source] && (o3.push({ command: Br.setTerrain, args: [void 0] }), s2 = void 0), o3 = o3.concat(a3), e.d(s2, i3.terrain) || o3.push({ command: Br.setTerrain, args: [i3.terrain] }), function(t4, i4, o4) {
                  i4 = i4 || [];
                  const r4 = (t4 = t4 || []).map(Vr), a4 = i4.map(Vr), n3 = t4.reduce($r, {}), s3 = i4.reduce($r, {}), l2 = r4.slice(), c2 = /* @__PURE__ */ Object.create(null);
                  let h2, _2, u2, d2, p2, f2, m2;
                  for (h2 = 0, _2 = 0; h2 < r4.length; h2++)
                    u2 = r4[h2], s3.hasOwnProperty(u2) ? _2++ : (o4.push({ command: Br.removeLayer, args: [u2] }), l2.splice(l2.indexOf(u2, _2), 1));
                  for (h2 = 0, _2 = 0; h2 < a4.length; h2++)
                    u2 = a4[a4.length - 1 - h2], l2[l2.length - 1 - h2] !== u2 && (n3.hasOwnProperty(u2) ? (o4.push({ command: Br.removeLayer, args: [u2] }), l2.splice(l2.lastIndexOf(u2, l2.length - _2), 1)) : _2++, f2 = l2[l2.length - h2], o4.push({ command: Br.addLayer, args: [s3[u2], f2] }), l2.splice(l2.length - h2, 0, u2), c2[u2] = true);
                  for (h2 = 0; h2 < a4.length; h2++)
                    if (u2 = a4[h2], d2 = n3[u2], p2 = s3[u2], !c2[u2] && !e.d(d2, p2))
                      if (e.d(d2.source, p2.source) && e.d(d2["source-layer"], p2["source-layer"]) && e.d(d2.type, p2.type)) {
                        for (m2 in jr(d2.layout, p2.layout, o4, u2, null, Br.setLayoutProperty), jr(d2.paint, p2.paint, o4, u2, null, Br.setPaintProperty), e.d(d2.slot, p2.slot) || o4.push({ command: Br.setSlot, args: [u2, p2.slot] }), e.d(d2.filter, p2.filter) || o4.push({ command: Br.setFilter, args: [u2, p2.filter] }), e.d(d2.minzoom, p2.minzoom) && e.d(d2.maxzoom, p2.maxzoom) || o4.push({ command: Br.setLayerZoomRange, args: [u2, p2.minzoom, p2.maxzoom] }), d2)
                          d2.hasOwnProperty(m2) && "layout" !== m2 && "paint" !== m2 && "filter" !== m2 && "metadata" !== m2 && "minzoom" !== m2 && "maxzoom" !== m2 && "slot" !== m2 && (0 === m2.indexOf("paint.") ? jr(d2[m2], p2[m2], o4, u2, m2.slice(6), Br.setPaintProperty) : e.d(d2[m2], p2[m2]) || o4.push({ command: Br.setLayerProperty, args: [u2, m2, p2[m2]] }));
                        for (m2 in p2)
                          p2.hasOwnProperty(m2) && !d2.hasOwnProperty(m2) && "layout" !== m2 && "paint" !== m2 && "filter" !== m2 && "metadata" !== m2 && "minzoom" !== m2 && "maxzoom" !== m2 && "slot" !== m2 && (0 === m2.indexOf("paint.") ? jr(d2[m2], p2[m2], o4, u2, m2.slice(6), Br.setPaintProperty) : e.d(d2[m2], p2[m2]) || o4.push({ command: Br.setLayerProperty, args: [u2, m2, p2[m2]] }));
                      } else
                        o4.push({ command: Br.removeLayer, args: [u2] }), f2 = l2[l2.lastIndexOf(u2) + 1], o4.push({ command: Br.addLayer, args: [p2, f2] });
                }(n2, i3.layers, o3);
              } catch (e2) {
                console.warn("Unable to compute style diff:", e2), o3 = [{ command: Br.setStyle, args: [i3] }];
              }
              return o3;
            }(this.serialize(), t2).filter((e2) => !(e2.command in Ea));
            if (0 === o2.length)
              return false;
            const r2 = o2.filter((e2) => !(e2.command in Ta));
            if (r2.length > 0)
              throw new Error(`Unimplemented: ${r2.map((e2) => e2.command).join(", ")}.`);
            const a2 = [];
            return o2.forEach((e2) => {
              a2.push(this[e2.command].apply(this, e2.args));
            }), i2 && Promise.all(a2).then(i2), this.stylesheet = t2, this.mergeAll(), this.dispatcher.broadcast("setLayers", { layers: this._serializeLayers(this._order), scope: this.scope, options: this.options }), true;
          }
          addImage(t2, i2) {
            return this.getImage(t2) ? this.fire(new e.f(new Error("An image with this name already exists."))) : (this.imageManager.addImage(t2, this.scope, i2), this._afterImageUpdated(t2), this);
          }
          updateImage(e2, t2) {
            this.imageManager.updateImage(e2, this.scope, t2);
          }
          getImage(e2) {
            return this.imageManager.getImage(e2, this.scope);
          }
          removeImage(t2) {
            return this.getImage(t2) ? (this.imageManager.removeImage(t2, this.scope), this._afterImageUpdated(t2), this) : this.fire(new e.f(new Error("No image with this name exists.")));
          }
          _afterImageUpdated(t2) {
            this._availableImages = this.imageManager.listImages(this.scope), this._changes.updateImage(t2), this.dispatcher.broadcast("setImages", { scope: this.scope, images: this._availableImages }), this.fire(new e.g("data", { dataType: "style" }));
          }
          listImages() {
            return this._checkLoaded(), this._availableImages.slice();
          }
          addModel(e2, t2, i2 = {}) {
            return this._checkLoaded(), this._validate($e, `models.${e2}`, t2, null, i2) || (this.modelManager.addModel(e2, t2, this.scope), this._changes.setDirty()), this;
          }
          hasModel(e2) {
            return this.modelManager.hasModel(e2, this.scope);
          }
          removeModel(t2) {
            return this.hasModel(t2) ? (this.modelManager.removeModel(t2, this.scope), this) : this.fire(new e.f(new Error("No model with this ID exists.")));
          }
          listModels() {
            return this._checkLoaded(), this.modelManager.listModels(this.scope);
          }
          addSource(t2, i2, o2 = {}) {
            if (this._checkLoaded(), void 0 !== this.getOwnSource(t2))
              throw new Error(`There is already a source with ID "${t2}".`);
            if (!i2.type)
              throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i2).join(", ")}.`);
            if (["vector", "raster", "geojson", "video", "image"].indexOf(i2.type) >= 0 && this._validate(Oe, `sources.${t2}`, i2, null, o2))
              return;
            this.map && this.map._collectResourceTiming && (i2.collectResourceTiming = true);
            const r2 = Ri(t2, i2, this.dispatcher, this);
            r2.scope = this.scope, r2.setEventedParent(this, () => ({ isSourceLoaded: this._isSourceCacheLoaded(r2.id), source: r2.serialize(), sourceId: r2.id }));
            const a2 = (t3) => {
              const i3 = (t3 ? "symbol:" : "other:") + r2.id, o3 = e.am(i3, this.scope), a3 = this._sourceCaches[i3] = new e.bx(o3, r2, t3);
              (t3 ? this._symbolSourceCaches : this._otherSourceCaches)[r2.id] = a3, a3.onAdd(this.map);
            };
            a2(false), "vector" !== i2.type && "geojson" !== i2.type || a2(true), r2.onAdd && r2.onAdd(this.map), o2.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
          }
          removeSource(t2) {
            this._checkLoaded();
            const i2 = this.getOwnSource(t2);
            if (!i2)
              throw new Error("There is no source with this ID");
            for (const i3 in this._layers)
              if (this._layers[i3].source === t2)
                return this.fire(new e.f(new Error(`Source "${t2}" cannot be removed while layer "${i3}" is using it.`)));
            if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === t2)
              return this.fire(new e.f(new Error(`Source "${t2}" cannot be removed while terrain is using it.`)));
            const o2 = this.getOwnSourceCaches(t2);
            for (const t3 of o2) {
              const i3 = e.cX(t3.id);
              delete this._sourceCaches[i3], this._changes.discardSourceCacheUpdate(t3.id), t3.fire(new e.g("data", { sourceDataType: "metadata", dataType: "source", sourceId: t3.getSource().id })), t3.setEventedParent(null), t3.clearTiles();
            }
            return delete this._otherSourceCaches[t2], delete this._symbolSourceCaches[t2], this.mergeSources(), i2.setEventedParent(null), i2.onRemove && i2.onRemove(this.map), this._changes.setDirty(), this;
          }
          setGeoJSONSourceData(e2, t2) {
            this._checkLoaded(), this.getOwnSource(e2).setData(t2), this._changes.setDirty();
          }
          getOwnSource(e2) {
            const t2 = this.getOwnSourceCache(e2);
            return t2 && t2.getSource();
          }
          getOwnSources() {
            const e2 = [];
            for (const t2 in this._otherSourceCaches) {
              const i2 = this.getOwnSourceCache(t2);
              i2 && e2.push(i2.getSource());
            }
            return e2;
          }
          areTilesLoaded() {
            const e2 = this._mergedSourceCaches;
            for (const t2 in e2) {
              const i2 = e2[t2]._tiles;
              for (const e3 in i2) {
                const t3 = i2[e3];
                if ("loaded" !== t3.state && "errored" !== t3.state)
                  return false;
              }
            }
            return true;
          }
          setLights(t2) {
            if (this._checkLoaded(), !t2)
              return delete this.ambientLight, void delete this.directionalLight;
            const i2 = this._getTransitionParameters();
            for (const o3 of t2) {
              if (this._validate(Be, "lights", o3))
                return;
              switch (o3.type) {
                case "ambient":
                  if (this.ambientLight) {
                    const e2 = this.ambientLight;
                    e2.set(o3), e2.updateTransitions(i2);
                  } else
                    this.ambientLight = new nt(o3, st || (st = new e.U({ color: new e.W(e.N.properties_light_ambient.color), intensity: new e.W(e.N.properties_light_ambient.intensity) })), this.scope, this.options);
                  break;
                case "directional":
                  if (this.directionalLight) {
                    const e2 = this.directionalLight;
                    e2.set(o3), e2.updateTransitions(i2);
                  } else
                    this.directionalLight = new nt(o3, lt || (lt = new e.U({ direction: new e.a6(e.N.properties_light_directional.direction), color: new e.W(e.N.properties_light_directional.color), intensity: new e.W(e.N.properties_light_directional.intensity), "cast-shadows": new e.W(e.N.properties_light_directional["cast-shadows"]), "shadow-intensity": new e.W(e.N.properties_light_directional["shadow-intensity"]) })), this.scope, this.options);
              }
            }
            const o2 = new e.Y(this.z || 0, i2);
            this.ambientLight && this.ambientLight.recalculate(o2), this.directionalLight && this.directionalLight.recalculate(o2), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("setBrightness", this._brightness);
          }
          calculateLightsBrightness() {
            const t2 = this.directionalLight, i2 = this.ambientLight;
            if (!t2 || !i2)
              return;
            const o2 = (e2) => 0.2126 * (e2[0] <= 0.03928 ? e2[0] / 12.92 : Math.pow((e2[0] + 0.055) / 1.055, 2.4)) + 0.7152 * (e2[1] <= 0.03928 ? e2[1] / 12.92 : Math.pow((e2[1] + 0.055) / 1.055, 2.4)) + 0.0722 * (e2[2] <= 0.03928 ? e2[2] / 12.92 : Math.pow((e2[2] + 0.055) / 1.055, 2.4)), r2 = t2.properties.get("color").toRenderColor(null).toArray01(), a2 = t2.properties.get("intensity"), n2 = t2.properties.get("direction"), s2 = 1 - e.ad(n2.x, n2.y, n2.z)[2] / 90, l2 = o2(r2) * a2 * s2, c2 = i2.properties.get("color").toRenderColor(null).toArray01(), h2 = i2.properties.get("intensity");
            return (l2 + o2(c2) * h2) / 2;
          }
          getBrightness() {
            return this._brightness;
          }
          getLights() {
            if (!this.enable3dLights())
              return null;
            const e2 = [];
            return this.directionalLight && e2.push(this.directionalLight.get()), this.ambientLight && e2.push(this.ambientLight.get()), e2;
          }
          enable3dLights() {
            return !!this.ambientLight && !!this.directionalLight;
          }
          getFragmentStyle(t2) {
            if (!t2)
              return this;
            if (e.cY(t2)) {
              const i2 = e.cZ(t2), o2 = this.fragments.find(({ id: e2 }) => e2 === i2);
              if (!o2)
                throw new Error(`Style import not found: ${t2}`);
              const r2 = e.cX(t2);
              return o2.style.getFragmentStyle(r2);
            }
            {
              const e2 = this.fragments.find(({ id: e3 }) => e3 === t2);
              if (!e2)
                throw new Error(`Style import not found: ${t2}`);
              return e2.style;
            }
          }
          getConfigProperty(t2, i2) {
            const o2 = this.getFragmentStyle(t2);
            if (!o2)
              return null;
            const r2 = e.am(i2, o2.scope), a2 = o2.options.get(r2), n2 = a2 ? a2.value || a2.default : null;
            return n2 ? n2.serialize() : null;
          }
          setConfigProperty(t2, i2, o2) {
            const r2 = this.getFragmentStyle(t2);
            if (!r2)
              return;
            const a2 = r2.stylesheet.schema;
            if (!a2 || !a2[i2])
              return;
            const n2 = e.z(o2);
            if ("success" !== n2.result)
              return void wa(this, n2.value);
            const s2 = n2.value.expression, l2 = e.am(i2, r2.scope), c2 = r2.options.get(l2);
            if (!c2)
              return;
            let h2;
            const { minValue: _2, maxValue: u2, stepValue: d2, type: p2, values: f2 } = a2[i2], m2 = e.z(a2[i2].default);
            "success" === m2.result && (h2 = m2.value.expression), h2 ? (this.options.set(l2, __spreadProps(__spreadValues({}, c2), { value: s2, default: h2, minValue: _2, maxValue: u2, stepValue: d2, type: p2, values: f2 })), this.updateConfigDependencies(i2)) : this.fire(new e.f(new Error(`No schema defined for the config option "${i2}" in the "${t2}" fragment.`)));
          }
          getConfig(t2) {
            const i2 = this.getFragmentStyle(t2);
            if (!i2)
              return null;
            const o2 = i2.stylesheet.schema;
            if (!o2)
              return null;
            const r2 = {};
            for (const t3 in o2) {
              const o3 = e.am(t3, i2.scope), a2 = i2.options.get(o3), n2 = a2 ? a2.value || a2.default : null;
              r2[t3] = n2 ? n2.serialize() : null;
            }
            return r2;
          }
          setConfig(e2, t2) {
            const i2 = this.getFragmentStyle(e2);
            i2 && (i2.updateConfig(t2, i2.stylesheet.schema), this.updateConfigDependencies());
          }
          getSchema(e2) {
            const t2 = this.getFragmentStyle(e2);
            return t2 ? t2.stylesheet.schema : null;
          }
          setSchema(e2, t2) {
            const i2 = this.getFragmentStyle(e2);
            i2 && (i2.stylesheet.schema = t2, i2.updateConfig(i2._config, t2), this.updateConfigDependencies());
          }
          updateConfig(t2, i2) {
            if (this._config = t2, t2 || i2)
              if (i2)
                for (const o2 in i2) {
                  let r2, a2;
                  const n2 = e.z(i2[o2].default);
                  if ("success" === n2.result && (r2 = n2.value.expression), t2 && void 0 !== t2[o2]) {
                    const i3 = e.z(t2[o2]);
                    "success" === i3.result && (a2 = i3.value.expression);
                  }
                  const { minValue: s2, maxValue: l2, stepValue: c2, type: h2, values: _2 } = i2[o2];
                  if (r2) {
                    const t3 = e.am(o2, this.scope);
                    this.options.set(t3, { default: r2, value: a2, minValue: s2, maxValue: l2, stepValue: c2, type: h2, values: _2 });
                  } else
                    this.fire(new e.f(new Error(`No schema defined for config option "${o2}".`)));
                }
              else
                this.fire(new e.f(new Error("Attempting to set config for a style without schema.")));
          }
          updateConfigDependencies(e2) {
            for (const t2 of this._configDependentLayers) {
              const i2 = this.getLayer(t2);
              if (i2) {
                if (e2 && !i2.configDependencies.has(e2))
                  continue;
                i2.possiblyEvaluateVisibility(), this._updateLayer(i2);
              }
            }
            this.ambientLight && this.ambientLight.updateConfig(this.options), this.directionalLight && this.directionalLight.updateConfig(this.options), this.fog && this.fog.updateConfig(this.options), this.forEachFragmentStyle((e3) => {
              if (e3._styleColorTheme.colorTheme) {
                const t2 = e3._evaluateColorThemeData(e3._styleColorTheme.colorTheme);
                (!e3._styleColorTheme.lut && "" !== t2 || e3._styleColorTheme.lut && t2 !== e3._styleColorTheme.lut.data) && e3.setColorTheme(e3._styleColorTheme.colorTheme);
              }
            }), this._changes.setDirty();
          }
          addLayer(t2, i2, o2 = {}) {
            this._checkLoaded();
            const r2 = t2.id;
            if (this._layers[r2])
              return void this.fire(new e.f(new Error(`Layer with id "${r2}" already exists on this map`)));
            let a2;
            if ("custom" === t2.type) {
              if (wa(this, e.c_(t2)))
                return;
              a2 = e.c$(t2, this.scope, this._styleColorTheme.lut, this.options);
            } else {
              if ("object" == typeof t2.source && (this.addSource(r2, t2.source), t2 = e.cW(t2), t2 = e.Q(t2, { source: r2 })), this._validate(Ue, `layers.${r2}`, t2, { arrayIndex: -1 }, o2))
                return;
              a2 = e.c$(t2, this.scope, this._styleColorTheme.lut, this.options), this._validateLayer(a2), a2.setEventedParent(this, { layer: { id: r2 } }), this._serializedLayers[a2.id] = a2.serialize();
            }
            0 !== a2.configDependencies.size && this._configDependentLayers.add(a2.fqid);
            let n2 = this._order.length;
            if (i2) {
              const t3 = this._order.indexOf(i2);
              if (-1 === t3)
                return void this.fire(new e.f(new Error(`Layer with id "${i2}" does not exist on this map.`)));
              a2.slot === this._layers[i2].slot ? n2 = t3 : e.w(`Layer with id "${i2}" has a different slot. Layers can only be rearranged within the same slot.`);
            }
            this._order.splice(n2, 0, r2), this._layerOrderChanged = true, this._layers[r2] = a2;
            const s2 = this.getOwnLayerSourceCache(a2), l2 = !!this.directionalLight && this.directionalLight.shadowsEnabled();
            s2 && a2.canCastShadows() && l2 && (s2.castsShadows = true);
            const c2 = this._changes.getRemovedLayer(a2);
            if (c2 && a2.source && s2 && "custom" !== a2.type) {
              this._changes.discardLayerRemoval(a2);
              const t3 = e.am(a2.source, a2.scope);
              c2.type !== a2.type ? this._changes.updateSourceCache(t3, "clear") : (this._changes.updateSourceCache(t3, "reload"), s2.pause());
            }
            this._updateLayer(a2), a2.onAdd && a2.onAdd(this.map), a2.scope = this.scope, this.mergeLayers();
          }
          moveLayer(t2, i2) {
            this._checkLoaded();
            const o2 = this._checkLayer(t2);
            if (!o2)
              return;
            if (t2 === i2)
              return;
            const r2 = this._order.indexOf(t2);
            this._order.splice(r2, 1);
            let a2 = this._order.length;
            if (i2) {
              const t3 = this._order.indexOf(i2);
              if (-1 === t3)
                return void this.fire(new e.f(new Error(`Layer with id "${i2}" does not exist on this map.`)));
              o2.slot === this._layers[i2].slot ? a2 = t3 : e.w(`Layer with id "${i2}" has a different slot. Layers can only be rearranged within the same slot.`);
            }
            this._order.splice(a2, 0, t2), this._changes.setDirty(), this._layerOrderChanged = true, this.mergeLayers();
          }
          removeLayer(e2) {
            this._checkLoaded();
            const t2 = this._checkLayer(e2);
            if (!t2)
              return;
            t2.setEventedParent(null);
            const i2 = this._order.indexOf(e2);
            this._order.splice(i2, 1), delete this._layers[e2], delete this._serializedLayers[e2], this._changes.setDirty(), this._layerOrderChanged = true, this._configDependentLayers.delete(t2.fqid), this._changes.removeLayer(t2);
            const o2 = this.getOwnLayerSourceCache(t2);
            if (o2 && o2.castsShadows) {
              let e3 = false;
              for (const i3 in this._layers)
                if (this._layers[i3].source === t2.source && this._layers[i3].canCastShadows()) {
                  e3 = true;
                  break;
                }
              o2.castsShadows = e3;
            }
            t2.onRemove && t2.onRemove(this.map), this.mergeLayers();
          }
          getOwnLayer(e2) {
            return this._layers[e2];
          }
          hasLayer(e2) {
            return e2 in this._mergedLayers;
          }
          hasLayerType(e2) {
            for (const t2 in this._layers)
              if (this._layers[t2].type === e2)
                return true;
            return false;
          }
          setLayerZoomRange(e2, t2, i2) {
            this._checkLoaded();
            const o2 = this._checkLayer(e2);
            o2 && (o2.minzoom === t2 && o2.maxzoom === i2 || (null != t2 && (o2.minzoom = t2), null != i2 && (o2.maxzoom = i2), this._updateLayer(o2)));
          }
          getSlots() {
            return this._checkLoaded(), this._mergedSlots;
          }
          setSlot(e2, t2) {
            this._checkLoaded();
            const i2 = this._checkLayer(e2);
            i2 && i2.slot !== t2 && (i2.slot = t2, this._updateLayer(i2));
          }
          setFilter(t2, i2, o2 = {}) {
            this._checkLoaded();
            const r2 = this._checkLayer(t2);
            if (r2 && !e.d(r2.filter, i2))
              return null == i2 ? (r2.filter = void 0, void this._updateLayer(r2)) : void (this._validate(Ge, `layers.${r2.id}.filter`, i2, { layerType: r2.type }, o2) || (r2.filter = e.cW(i2), this._updateLayer(r2)));
          }
          getFilter(t2) {
            const i2 = this._checkLayer(t2);
            if (i2)
              return e.cW(i2.filter);
          }
          setLayoutProperty(t2, i2, o2, r2 = {}) {
            this._checkLoaded();
            const a2 = this._checkLayer(t2);
            if (a2 && !e.d(a2.getLayoutProperty(i2), o2)) {
              if (null != o2 && (!r2 || false !== r2.validate) && wa(a2, Ve.call(ze, { key: `layers.${t2}.layout.${i2}`, layerType: a2.type, objectKey: i2, value: o2, styleSpec: e.N, style: { glyphs: true, sprite: true } })))
                return;
              a2.setLayoutProperty(i2, o2), 0 !== a2.configDependencies.size && this._configDependentLayers.add(a2.fqid), this._updateLayer(a2);
            }
          }
          getLayoutProperty(e2, t2) {
            const i2 = this._checkLayer(e2);
            if (i2)
              return i2.getLayoutProperty(t2);
          }
          setPaintProperty(t2, i2, o2, r2 = {}) {
            this._checkLoaded();
            const a2 = this._checkLayer(t2);
            if (!a2)
              return;
            if (e.d(a2.getPaintProperty(i2), o2))
              return;
            if (null != o2 && (!r2 || false !== r2.validate) && wa(a2, je.call(ze, { key: `layers.${t2}.paint.${i2}`, layerType: a2.type, objectKey: i2, value: o2, styleSpec: e.N })))
              return;
            const n2 = a2.setPaintProperty(i2, o2);
            0 !== a2.configDependencies.size && this._configDependentLayers.add(a2.fqid), n2 && this._updateLayer(a2), this._changes.updatePaintProperties(a2);
          }
          getPaintProperty(e2, t2) {
            const i2 = this._checkLayer(e2);
            if (i2)
              return i2.getPaintProperty(t2);
          }
          setFeatureState(t2, i2) {
            this._checkLoaded();
            const o2 = t2.source, r2 = t2.sourceLayer, a2 = this._checkSource(o2);
            if (!a2)
              return;
            const n2 = a2.type;
            if ("geojson" === n2 && r2)
              return void this.fire(new e.f(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
            if ("vector" === n2 && !r2)
              return void this.fire(new e.f(new Error("The sourceLayer parameter must be provided for vector source types.")));
            void 0 === t2.id && this.fire(new e.f(new Error("The feature id parameter must be provided.")));
            const s2 = this.getOwnSourceCaches(o2);
            for (const e2 of s2)
              e2.setFeatureState(r2, t2.id, i2);
          }
          removeFeatureState(t2, i2) {
            this._checkLoaded();
            const o2 = t2.source, r2 = this._checkSource(o2);
            if (!r2)
              return;
            const a2 = r2.type, n2 = "vector" === a2 ? t2.sourceLayer : void 0;
            if ("vector" === a2 && !n2)
              return void this.fire(new e.f(new Error("The sourceLayer parameter must be provided for vector source types.")));
            if (i2 && "string" != typeof t2.id && "number" != typeof t2.id)
              return void this.fire(new e.f(new Error("A feature id is required to remove its specific state property.")));
            const s2 = this.getOwnSourceCaches(o2);
            for (const e2 of s2)
              e2.removeFeatureState(n2, t2.id, i2);
          }
          getFeatureState(t2) {
            this._checkLoaded();
            const i2 = t2.source, o2 = t2.sourceLayer, r2 = this._checkSource(i2);
            if (r2) {
              if ("vector" !== r2.type || o2)
                return void 0 === t2.id && this.fire(new e.f(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(i2)[0].getFeatureState(o2, t2.id);
              this.fire(new e.f(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
          }
          setTransition(t2) {
            return this.stylesheet.transition = e.Q({}, this.stylesheet.transition, t2), this.transition = this.stylesheet.transition, this;
          }
          getTransition() {
            return e.Q({}, this.stylesheet.transition);
          }
          serialize() {
            this._checkLoaded();
            const t2 = this.getTerrain(), i2 = t2 && this.terrain && this.terrain.scope === this.scope ? t2 : this.stylesheet.terrain;
            return e.d0({ version: this.stylesheet.version, name: this.stylesheet.name, metadata: this.stylesheet.metadata, fragment: this.stylesheet.fragment, imports: this._serializeImports(), schema: this.stylesheet.schema, camera: this.stylesheet.camera, light: this.stylesheet.light, lights: this.stylesheet.lights, terrain: i2, fog: this.stylesheet.fog, center: this.stylesheet.center, "color-theme": this.stylesheet["color-theme"], zoom: this.stylesheet.zoom, bearing: this.stylesheet.bearing, pitch: this.stylesheet.pitch, sprite: this.stylesheet.sprite, glyphs: this.stylesheet.glyphs, transition: this.stylesheet.transition, projection: this.stylesheet.projection, sources: this._serializeSources(), layers: this._serializeLayers(this._order) }, (e2) => void 0 !== e2);
          }
          _updateLayer(t2) {
            this._changes.updateLayer(t2);
            const i2 = this.getLayerSourceCache(t2), o2 = e.am(t2.source, t2.scope), r2 = this._changes.getUpdatedSourceCaches();
            t2.source && !r2[o2] && i2 && "raster" !== i2.getSource().type && (this._changes.updateSourceCache(o2, "reload"), i2.pause()), t2.invalidateCompiledFilter();
          }
          _flattenAndSortRenderedFeatures(e2) {
            const t2 = (e3) => "fill-extrusion" === this._mergedLayers[e3].type || "model" === this._mergedLayers[e3].type, i2 = this.order, o2 = {}, r2 = [];
            for (let a3 = i2.length - 1; a3 >= 0; a3--) {
              const n2 = i2[a3];
              if (t2(n2)) {
                o2[n2] = a3;
                for (const t3 of e2) {
                  const e3 = t3[n2];
                  if (e3)
                    for (const t4 of e3)
                      r2.push(t4);
                }
              }
            }
            r2.sort((e3, t3) => t3.intersectionZ - e3.intersectionZ);
            const a2 = [];
            for (let n2 = i2.length - 1; n2 >= 0; n2--) {
              const s2 = i2[n2];
              if (t2(s2))
                for (let e3 = r2.length - 1; e3 >= 0; e3--) {
                  const t3 = r2[e3].feature;
                  if (t3.layer && o2[t3.layer.id] < n2)
                    break;
                  a2.push(t3), r2.pop();
                }
              else
                for (const t3 of e2) {
                  const e3 = t3[s2];
                  if (e3)
                    for (const t4 of e3)
                      a2.push(t4.feature);
                }
            }
            return a2;
          }
          queryRenderedFeatures(t2, i2, o2) {
            i2 && i2.filter && this._validate(Ge, "queryRenderedFeatures.filter", i2.filter, null, i2), i2.scope = this.scope, i2.availableImages = this._availableImages, i2.serializedLayers = this._serializedLayers;
            const r2 = {};
            if (i2 && i2.layers) {
              if (!Array.isArray(i2.layers))
                return this.fire(new e.f(new Error("parameters.layers must be an Array."))), [];
              for (const t3 of i2.layers) {
                const i3 = this._mergedLayers[t3];
                if (!i3)
                  return this.fire(new e.f(new Error(`The layer '${t3}' does not exist in the map's style and cannot be queried for features.`))), [];
                r2[i3.source] = true;
              }
            }
            const a2 = [], n2 = i2.serializedLayers || {}, s2 = i2 && i2.layers ? i2.layers.some((e2) => {
              const t3 = this.getLayer(e2);
              return t3 && t3.is3D();
            }) : this.has3DLayers(), l2 = Sr.createFromScreenPoints(t2, o2);
            for (const e2 in this._mergedSourceCaches) {
              const t3 = this._mergedSourceCaches[e2].getSource();
              if (!t3 || t3.scope !== i2.scope)
                continue;
              const c2 = this._mergedSourceCaches[e2].getSource().id;
              i2.layers && !r2[c2] || a2.push(Dr(this._mergedSourceCaches[e2], this._mergedLayers, n2, l2, i2, o2, s2, !!this.map._showQueryGeometry));
            }
            return this.placement && a2.push(function(e2, t3, i3, o3, r3, a3, n3) {
              const s3 = {}, l3 = a3.queryRenderedSymbols(o3), c2 = [];
              for (const e3 of Object.keys(l3).map(Number))
                c2.push(n3[e3]);
              c2.sort(Mr);
              for (const i4 of c2) {
                const o4 = i4.featureIndex.lookupSymbolFeatures(l3[i4.bucketInstanceId], t3, i4.bucketIndex, i4.sourceLayerIndex, r3.filter, r3.layers, r3.availableImages, e2);
                for (const e3 in o4) {
                  const t4 = s3[e3] = s3[e3] || [], r4 = o4[e3];
                  r4.sort((e4, t5) => {
                    const o5 = i4.featureSortOrder;
                    if (o5) {
                      const i5 = o5.indexOf(e4.featureIndex);
                      return o5.indexOf(t5.featureIndex) - i5;
                    }
                    return t5.featureIndex - e4.featureIndex;
                  });
                  for (const e4 of r4)
                    t4.push(e4);
                }
              }
              for (const t4 in s3)
                s3[t4].forEach((o4) => {
                  const r4 = o4.feature, a4 = i3(e2[t4]);
                  if (!a4)
                    return;
                  const n4 = a4.getFeatureState(r4.layer["source-layer"], r4.id);
                  r4.source = r4.layer.source, r4.layer["source-layer"] && (r4.sourceLayer = r4.layer["source-layer"]), r4.state = n4;
                });
              return s3;
            }(this._mergedLayers, n2, this.getLayerSourceCache.bind(this), l2.screenGeometry, i2, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(a2);
          }
          querySourceFeatures(e2, t2) {
            t2 && t2.filter && this._validate(Ge, "querySourceFeatures.filter", t2.filter, null, t2);
            const i2 = this.getOwnSourceCaches(e2);
            let o2 = [];
            for (const e3 of i2)
              o2 = o2.concat(Ar(e3, t2));
            return o2;
          }
          addSourceType(e2, t2, i2) {
            return Ia.getSourceType(e2) ? i2(new Error(`A source type called "${e2}" already exists.`)) : (Ia.setSourceType(e2, t2), t2.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", { name: e2, url: t2.workerSourceURL }, i2) : i2(null, null));
          }
          getFlatLight() {
            return this.light.getLight();
          }
          setFlatLight(t2, i2, o2 = {}) {
            this._checkLoaded();
            const r2 = this.light.getLight();
            let a2 = false;
            for (const i3 in t2)
              if (!e.d(t2[i3], r2[i3])) {
                a2 = true;
                break;
              }
            if (!a2)
              return;
            const n2 = this._getTransitionParameters();
            this.light.setLight(t2, i2, o2), this.light.updateTransitions(n2);
          }
          getTerrain() {
            return this.terrain && 1 === this.terrain.drapeRenderMode ? this.terrain.get() : null;
          }
          setTerrainForDraping() {
            this.setTerrain({ source: "", exaggeration: 0 }, 0);
          }
          checkCanvasFingerprintNoise() {
            void 0 === this.disableElevatedTerrain && (this.disableElevatedTerrain = e.e.hasCanvasFingerprintNoise(), this.disableElevatedTerrain && e.w("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode)."));
          }
          setTerrain(t2, i2 = 1) {
            if (this._checkLoaded(), !t2)
              return this.terrainSetForDrapingOnly() || (delete this.terrain, this.map.transform.projection.requiresDraping && this.setTerrainForDraping()), 0 === i2 && delete this.terrain, null === t2 ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = true);
            this.checkCanvasFingerprintNoise();
            let o2 = t2;
            const r2 = null == t2.source;
            if (1 === i2) {
              if (this.disableElevatedTerrain)
                return;
              if ("object" == typeof o2.source) {
                const t4 = "terrain-dem-src";
                this.addSource(t4, o2.source), o2 = e.cW(o2), o2 = e.Q(o2, { source: t4 });
              }
              const t3 = e.Q({}, o2), i3 = {};
              if (this.terrain && r2) {
                t3.source = this.terrain.get().source;
                const e2 = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
                e2 && (i3.style = e2.serialize());
              }
              if (this._validate(ke, "terrain", t3, i3))
                return;
            }
            if (!this.terrain || this.terrain.scope !== this.scope && !r2 || this.terrain && i2 !== this.terrain.drapeRenderMode) {
              if (!o2)
                return;
              this._createTerrain(o2, i2), this.fire(new e.g("data", { dataType: "style" }));
            } else {
              const i3 = this.terrain, r3 = i3.get();
              for (const t3 of Object.keys(e.N.terrain))
                !o2.hasOwnProperty(t3) && e.N.terrain[t3].default && (o2[t3] = e.N.terrain[t3].default);
              for (const o3 in t2)
                if (!e.d(t2[o3], r3[o3])) {
                  i3.set(t2, this.options), this.stylesheet.terrain = t2;
                  const o4 = this._getTransitionParameters({ duration: 0 });
                  i3.updateTransitions(o4), this.fire(new e.g("data", { dataType: "style" }));
                  break;
                }
            }
            this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = true;
          }
          _createFog(e2) {
            const t2 = this.fog = new at(e2, this.map.transform, this.scope, this.options);
            this.stylesheet.fog = t2.get();
            const i2 = this._getTransitionParameters({ duration: 0 });
            t2.updateTransitions(i2);
          }
          _updateMarkersOpacity() {
            0 !== this.map._markers.length && this.map._requestDomTask(() => {
              for (const e2 of this.map._markers)
                e2._evaluateOpacity();
            });
          }
          getFog() {
            return this.fog ? this.fog.get() : null;
          }
          setFog(t2) {
            if (this._checkLoaded(), !t2)
              return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = true);
            if (this.fog) {
              const i2 = this.fog;
              if (!e.d(i2.get(), t2)) {
                i2.set(t2, this.options), this.stylesheet.fog = i2.get();
                const e2 = this._getTransitionParameters({ duration: 0 });
                i2.updateTransitions(e2);
              }
            } else
              this._createFog(t2);
            this._markersNeedUpdate = true;
          }
          setColorTheme(t2) {
            this._checkLoaded();
            const i2 = () => {
              for (const e2 in this._layers)
                this._layers[e2].lut = this._styleColorTheme.lut;
              for (const e2 in this._sourceCaches)
                this._sourceCaches[e2].clearTiles();
            };
            if (this._styleColorTheme.colorTheme = t2, !t2)
              return this._styleColorTheme.lut = null, void i2();
            const o2 = this._evaluateColorThemeData(t2);
            this._loadColorTheme(o2).then(() => {
              this.fire(new e.g("colorthemeset")), i2();
            }).catch((t3) => {
              e.w(`Couldn't set color theme: ${t3}`);
            });
          }
          _getTransitionParameters(t2) {
            return { now: e.e.now(), transition: e.Q(this.transition, t2) };
          }
          updateDrapeFirstLayers() {
            if (!this.terrain)
              return;
            const e2 = [], t2 = [];
            for (const i2 of this._mergedOrder)
              this.isLayerDraped(this._mergedLayers[i2]) ? e2.push(i2) : t2.push(i2);
            this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e2), this._drapedFirstOrder.push(...t2);
          }
          _createTerrain(e2, t2) {
            const i2 = this.terrain = new Qe(e2, t2, this.scope, this.options);
            1 === t2 && (this.stylesheet.terrain = e2), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
            const o2 = this._getTransitionParameters({ duration: 0 });
            i2.updateTransitions(o2);
          }
          _force3DLayerUpdate() {
            for (const e2 in this._layers) {
              const t2 = this._layers[e2];
              "fill-extrusion" === t2.type && this._updateLayer(t2);
            }
          }
          _forceSymbolLayerUpdate() {
            for (const e2 in this._layers) {
              const t2 = this._layers[e2];
              "symbol" === t2.type && this._updateLayer(t2);
            }
          }
          _validate(t2, i2, o2, r2, a2 = {}) {
            if (a2 && false === a2.validate)
              return false;
            const n2 = e.Q({}, this.serialize());
            return wa(this, t2.call(ze, e.Q({ key: i2, style: n2, value: o2, styleSpec: e.N }, r2)));
          }
          _remove() {
            this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), e.d1.off("pluginStateChange", this._rtlTextPluginCallback);
            for (const e2 in this._mergedLayers)
              this._mergedLayers[e2].setEventedParent(null);
            for (const e2 in this._mergedSourceCaches)
              this._mergedSourceCaches[e2].clearTiles(), this._mergedSourceCaches[e2].setEventedParent(null);
            this.setEventedParent(null), delete this.fog, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.isRootStyle() && (this.imageManager.setEventedParent(null), this.modelManager.setEventedParent(null), this.dispatcher.remove());
          }
          clearSource(e2) {
            const t2 = this.getSourceCaches(e2);
            for (const e3 of t2)
              e3.clearTiles();
          }
          clearSources() {
            for (const e2 in this._mergedSourceCaches)
              this._mergedSourceCaches[e2].clearTiles();
          }
          reloadSource(e2) {
            const t2 = this.getSourceCaches(e2);
            for (const e3 of t2)
              e3.resume(), e3.reload();
          }
          reloadSources() {
            for (const e2 of this.getSources())
              e2.reload && e2.reload();
          }
          updateSources(e2) {
            let t2;
            this.directionalLight && (t2 = vi(this.directionalLight));
            for (const i2 in this._mergedSourceCaches)
              this._mergedSourceCaches[i2].update(e2, void 0, void 0, t2);
          }
          _generateCollisionBoxes() {
            for (const e2 in this._sourceCaches) {
              const t2 = this._sourceCaches[e2];
              t2.resume(), t2.reload();
            }
          }
          _updatePlacement(t2, i2, o2, r2, a2, n2, s2 = false) {
            let l2 = false, c2 = false;
            const h2 = {}, _2 = {};
            for (const t3 of this._mergedOrder) {
              const o3 = this._mergedLayers[t3];
              if ("symbol" !== o3.type)
                continue;
              const r3 = e.am(o3.source, o3.scope);
              let a3 = h2[r3];
              if (!a3) {
                const e2 = this.getLayerSourceCache(o3);
                if (!e2)
                  continue;
                const t4 = e2.getRenderableIds(true).map((t5) => e2.getTileByID(t5));
                _2[r3] = t4.slice(), a3 = h2[r3] = t4.sort((e3, t5) => t5.tileID.overscaledZ - e3.tileID.overscaledZ || (e3.tileID.isLessThan(t5.tileID) ? -1 : 1));
              }
              const n3 = this.crossTileSymbolIndex.addLayer(o3, a3, i2.center.lng, i2.projection);
              l2 = l2 || n3;
            }
            if (this.crossTileSymbolIndex.pruneUnusedLayers(this._mergedOrder), s2 = s2 || this._layerOrderChanged || 0 === r2, this._layerOrderChanged && this.fire(new e.g("neworder")), (s2 || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(e.e.now(), i2.zoom)) && (this.pauseablePlacement = new fa(i2, this._mergedOrder, s2, o2, r2, a2, this.placement, this.fog && i2.projection.supportsFog ? this.fog.state : null, this._buildingIndex), this._layerOrderChanged = false), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._mergedOrder, this._mergedLayers, h2, _2), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e.e.now()), c2 = true), l2 && this.pauseablePlacement.placement.setStale()), c2 || l2) {
              this._buildingIndex.onNewFrame(i2.zoom);
              for (let t3 = 0; t3 < this._mergedOrder.length; t3++) {
                const i3 = this._mergedLayers[this._mergedOrder[t3]];
                if ("symbol" !== i3.type)
                  continue;
                const o3 = this.isLayerClipped(i3) && this._clipLayerIndices.some((e2) => t3 < e2);
                this.placement.updateLayerOpacities(i3, h2[e.am(i3.source, i3.scope)], t3, o3 ? n2 : null);
              }
            }
            return { needsRerender: !this.pauseablePlacement.isDone() || this.placement.hasTransitions(e.e.now()) };
          }
          _releaseSymbolFadeTiles() {
            for (const e2 in this._sourceCaches)
              this._sourceCaches[e2].releaseSymbolFadeTiles();
          }
          addImport(t2, i2) {
            this._checkLoaded();
            const o2 = this.stylesheet.imports = this.stylesheet.imports || [];
            if (-1 !== o2.findIndex(({ id: e2 }) => e2 === t2.id))
              return void this.fire(new e.f(new Error(`Import with id '${t2.id}' already exists in the map's style.`)));
            if (!i2)
              return o2.push(t2), this._loadImports([t2], true);
            const r2 = o2.findIndex(({ id: e2 }) => e2 === i2);
            return -1 === r2 && this.fire(new e.f(new Error(`Import with id "${i2}" does not exist on this map.`))), this.stylesheet.imports = o2.slice(0, r2).concat(t2).concat(o2.slice(r2)), this._loadImports([t2], true, i2);
          }
          updateImport(t2, i2) {
            this._checkLoaded();
            const o2 = this.stylesheet.imports || [], r2 = this.getImportIndex(t2);
            return -1 === r2 ? this : "string" == typeof i2 ? (this.setImportUrl(t2, i2), this) : (i2.url && i2.url !== o2[r2].url && this.setImportUrl(t2, i2.url), e.d(i2.config, o2[r2].config) || this.setImportConfig(t2, i2.config), e.d(i2.data, o2[r2].data) || this.setImportData(t2, i2.data), this);
          }
          moveImport(e2, t2) {
            this._checkLoaded();
            let i2 = this.stylesheet.imports || [];
            const o2 = this.getImportIndex(e2);
            if (-1 === o2)
              return this;
            const r2 = this.getImportIndex(t2);
            if (-1 === r2)
              return this;
            const a2 = i2[o2], n2 = this.fragments[o2];
            return i2 = i2.filter(({ id: t3 }) => t3 !== e2), this.fragments = this.fragments.filter(({ id: t3 }) => t3 !== e2), this.stylesheet.imports = i2.slice(0, r2).concat(a2).concat(i2.slice(r2)), this.fragments = this.fragments.slice(0, r2).concat(n2).concat(this.fragments.slice(r2)), this.mergeLayers(), this;
          }
          setImportUrl(e2, t2) {
            this._checkLoaded();
            const i2 = this.stylesheet.imports || [], o2 = this.getImportIndex(e2);
            if (-1 === o2)
              return this;
            i2[o2].url = t2;
            const r2 = this.fragments[o2];
            return r2.style = this._createFragmentStyle(i2[o2]), r2.style.on("style.import.load", () => this.mergeAll()), r2.style.loadURL(t2), this;
          }
          setImportData(e2, t2) {
            this._checkLoaded();
            const i2 = this.getImportIndex(e2), o2 = this.stylesheet.imports || [];
            return -1 === i2 ? this : t2 ? (this.fragments[i2].style.setState(t2), this._reloadImports(), this) : (delete o2[i2].data, this.setImportUrl(e2, o2[i2].url));
          }
          setImportConfig(e2, t2) {
            this._checkLoaded();
            const i2 = this.getImportIndex(e2), o2 = this.stylesheet.imports || [];
            if (-1 === i2)
              return this;
            t2 ? o2[i2].config = t2 : delete o2[i2].config;
            const r2 = this.fragments[i2], a2 = r2.style.stylesheet && r2.style.stylesheet.schema;
            return r2.config = t2, r2.style.updateConfig(t2, a2), this.updateConfigDependencies(), this;
          }
          removeImport(e2) {
            this._checkLoaded();
            const t2 = this.stylesheet.imports || [], i2 = this.getImportIndex(e2);
            -1 !== i2 && (t2.splice(i2, 1), this.fragments[i2].style._remove(), this.fragments.splice(i2, 1), this._reloadImports());
          }
          getImportIndex(t2) {
            const i2 = (this.stylesheet.imports || []).findIndex((e2) => e2.id === t2);
            return -1 === i2 && this.fire(new e.f(new Error(`Import '${t2}' does not exist in the map's style and cannot be updated.`))), i2;
          }
          getLayer(e2) {
            return this._mergedLayers[e2];
          }
          getSources() {
            const e2 = [];
            for (const t2 in this._mergedOtherSourceCaches) {
              const i2 = this._mergedOtherSourceCaches[t2];
              i2 && e2.push(i2.getSource());
            }
            return e2;
          }
          getSource(e2, t2) {
            const i2 = this.getSourceCache(e2, t2);
            return i2 && i2.getSource();
          }
          getLayerSource(e2) {
            const t2 = this.getLayerSourceCache(e2);
            return t2 && t2.getSource();
          }
          getSourceCache(t2, i2) {
            const o2 = e.am(t2, i2);
            return this._mergedOtherSourceCaches[o2];
          }
          getLayerSourceCache(t2) {
            const i2 = e.am(t2.source, t2.scope);
            return "symbol" === t2.type ? this._mergedSymbolSourceCaches[i2] : this._mergedOtherSourceCaches[i2];
          }
          getSourceCaches(e2) {
            if (null == e2)
              return Object.values(this._mergedSourceCaches);
            const t2 = [];
            return this._mergedOtherSourceCaches[e2] && t2.push(this._mergedOtherSourceCaches[e2]), this._mergedSymbolSourceCaches[e2] && t2.push(this._mergedSymbolSourceCaches[e2]), t2;
          }
          updateSourceCaches() {
            const e2 = this._changes.getUpdatedSourceCaches();
            for (const t2 in e2) {
              const i2 = e2[t2];
              "reload" === i2 ? this.reloadSource(t2) : "clear" === i2 && this.clearSource(t2);
            }
          }
          updateLayers(e2) {
            const t2 = this._changes.getUpdatedPaintProperties();
            for (const i2 of t2) {
              const t3 = this.getLayer(i2);
              t3 && t3.updateTransitions(e2);
            }
          }
          getImages(e2, t2, i2) {
            this.imageManager.getImages(t2.icons, t2.scope, i2), this._updateTilesForChangedImages();
            const o2 = (e3) => {
              e3 && e3.setDependencies(t2.tileID.key, t2.type, t2.icons);
            };
            o2(this._otherSourceCaches[t2.source]), o2(this._symbolSourceCaches[t2.source]);
          }
          getGlyphs(e2, t2, i2) {
            this.glyphManager.getGlyphs(t2.stacks, t2.scope, i2);
          }
          getResource(t2, i2, o2) {
            return e.d2(i2, o2);
          }
          getOwnSourceCache(e2) {
            return this._otherSourceCaches[e2];
          }
          getOwnLayerSourceCache(e2) {
            return "symbol" === e2.type ? this._symbolSourceCaches[e2.source] : this._otherSourceCaches[e2.source];
          }
          getOwnSourceCaches(e2) {
            const t2 = [];
            return this._otherSourceCaches[e2] && t2.push(this._otherSourceCaches[e2]), this._symbolSourceCaches[e2] && t2.push(this._symbolSourceCaches[e2]), t2;
          }
          _isSourceCacheLoaded(t2) {
            const i2 = this.getOwnSourceCaches(t2);
            return 0 === i2.length ? (this.fire(new e.f(new Error(`There is no source with ID '${t2}'`))), false) : i2.every((e2) => e2.loaded());
          }
          has3DLayers() {
            return this._has3DLayers;
          }
          hasSymbolLayers() {
            return this._hasSymbolLayers;
          }
          hasCircleLayers() {
            return this._hasCircleLayers;
          }
          isLayerClipped(t2, i2) {
            if (0 === this._clipLayerIndices.length && "fill-extrusion" !== t2.type)
              return false;
            const o2 = "fill-extrusion" === t2.type && "building" === t2.sourceLayer;
            let r2 = 0;
            if (t2.is3D()) {
              if (o2 || i2 && "batched-model" === i2.type)
                return true;
              "model" === t2.type && (r2 = e.cw.Model);
            } else
              "symbol" === t2.type && (r2 = e.cw.Symbol);
            for (const t3 of this._clipLayerIndices) {
              const i3 = this._mergedLayers[this._mergedOrder[t3]];
              if (!i3)
                continue;
              const o3 = [];
              for (const t4 of i3.layout.get("clip-layer-types"))
                o3.push("model" === t4 ? e.cw.Model : "symbol" === t4 ? e.cw.Symbol : e.cw.FillExtrusion);
              for (const e2 of o3)
                if (r2 & e2)
                  return true;
            }
            return false;
          }
          _clearWorkerCaches() {
            this.dispatcher.broadcast("clearCaches");
          }
          destroy() {
            this._clearWorkerCaches(), this.fragments.forEach((e2) => {
              e2.style._remove();
            }), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
          }
        }
        function La(e2, t2) {
          let i2 = false, o2 = null;
          const r2 = () => {
            o2 = null, i2 && (e2(), o2 = setTimeout(r2, t2), i2 = false);
          };
          return () => (i2 = true, o2 || r2(), o2);
        }
        Ia.getSourceType = function(e2) {
          return Pi[e2];
        }, Ia.setSourceType = function(e2, t2) {
          Pi[e2] = t2;
        }, Ia.registerForPluginStateChange = e.cO;
        class Pa {
          constructor(t2) {
            this._hashName = t2 && encodeURIComponent(t2), e.br(["_getCurrentHash", "_onHashChange", "_updateHash"], this), this._updateHash = La(this._updateHashUnthrottled.bind(this), 300);
          }
          addTo(e2) {
            return this._map = e2, window.addEventListener("hashchange", this._onHashChange, false), e2.on("moveend", this._updateHash), this;
          }
          remove() {
            return this._map ? (this._map.off("moveend", this._updateHash), window.removeEventListener("hashchange", this._onHashChange, false), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
          }
          getHashString() {
            const e2 = this._map;
            if (!e2)
              return "";
            const t2 = Ra(e2);
            if (this._hashName) {
              const e3 = this._hashName;
              let i2 = false;
              const o2 = location.hash.slice(1).split("&").map((o3) => {
                const r2 = o3.split("=")[0];
                return r2 === e3 ? (i2 = true, `${r2}=${t2}`) : o3;
              }).filter((e4) => e4);
              return i2 || o2.push(`${e3}=${t2}`), `#${o2.join("&")}`;
            }
            return `#${t2}`;
          }
          _getCurrentHash() {
            const e2 = location.hash.replace("#", "");
            if (this._hashName) {
              let t2;
              return e2.split("&").map((e3) => e3.split("=")).forEach((e3) => {
                e3[0] === this._hashName && (t2 = e3);
              }), (t2 && t2[1] || "").split("/");
            }
            return e2.split("/");
          }
          _onHashChange() {
            const e2 = this._map;
            if (!e2)
              return false;
            const t2 = this._getCurrentHash();
            if (t2.length >= 3 && !t2.some((e3) => isNaN(e3))) {
              const i2 = e2.dragRotate.isEnabled() && e2.touchZoomRotate.isEnabled() ? +(t2[3] || 0) : e2.getBearing();
              return e2.jumpTo({ center: [+t2[2], +t2[1]], zoom: +t2[0], bearing: i2, pitch: +(t2[4] || 0) }), true;
            }
            return false;
          }
          _updateHashUnthrottled() {
            history.replaceState(history.state, "", location.href.replace(/(#.+)?$/, this.getHashString()));
          }
        }
        function Ra(e2, t2) {
          const i2 = e2.getCenter(), o2 = Math.round(100 * e2.getZoom()) / 100, r2 = Math.ceil((o2 * Math.LN2 + Math.log(512 / 360 / 0.5)) / Math.LN10), a2 = Math.pow(10, r2), n2 = Math.round(i2.lng * a2) / a2, s2 = Math.round(i2.lat * a2) / a2, l2 = e2.getBearing(), c2 = e2.getPitch();
          let h2 = t2 ? `/${n2}/${s2}/${o2}` : `${o2}/${s2}/${n2}`;
          return (l2 || c2) && (h2 += "/" + Math.round(10 * l2) / 10), c2 && (h2 += `/${Math.round(c2)}`), h2;
        }
        const Da = { linearity: 0.3, easing: e.d3(0, 0, 0.3, 1) }, Aa = e.Q({ deceleration: 2500, maxSpeed: 1400 }, Da), Ma = e.Q({ deceleration: 20, maxSpeed: 1400 }, Da), za = e.Q({ deceleration: 1e3, maxSpeed: 360 }, Da), Oa = e.Q({ deceleration: 1e3, maxSpeed: 90 }, Da);
        class Fa {
          constructor(e2) {
            this._map = e2, this.clear();
          }
          clear() {
            this._inertiaBuffer = [];
          }
          record(t2) {
            this._drainInertiaBuffer(), this._inertiaBuffer.push({ time: e.e.now(), settings: t2 });
          }
          _drainInertiaBuffer() {
            const t2 = this._inertiaBuffer, i2 = e.e.now();
            for (; t2.length > 0 && i2 - t2[0].time > 160; )
              t2.shift();
          }
          _onMoveEnd(t2) {
            if (this._map._prefersReducedMotion())
              return;
            if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2)
              return;
            const i2 = { zoom: 0, bearing: 0, pitch: 0, pan: new e.P(0, 0), pinchAround: void 0, around: void 0 };
            for (const { settings: e2 } of this._inertiaBuffer)
              i2.zoom += e2.zoomDelta || 0, i2.bearing += e2.bearingDelta || 0, i2.pitch += e2.pitchDelta || 0, e2.panDelta && i2.pan._add(e2.panDelta), e2.around && (i2.around = e2.around), e2.pinchAround && (i2.pinchAround = e2.pinchAround);
            const o2 = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, r2 = {};
            if (i2.pan.mag()) {
              const a2 = ka(i2.pan.mag(), o2, e.Q({}, Aa, t2 || {}));
              r2.offset = i2.pan.mult(a2.amount / i2.pan.mag()), r2.center = this._map.transform.center, Ba(r2, a2);
            }
            if (i2.zoom) {
              const e2 = ka(i2.zoom, o2, Ma);
              r2.zoom = this._map.transform.zoom + e2.amount, Ba(r2, e2);
            }
            if (i2.bearing) {
              const t3 = ka(i2.bearing, o2, za);
              r2.bearing = this._map.transform.bearing + e.au(t3.amount, -179, 179), Ba(r2, t3);
            }
            if (i2.pitch) {
              const e2 = ka(i2.pitch, o2, Oa);
              r2.pitch = this._map.transform.pitch + e2.amount, Ba(r2, e2);
            }
            if (r2.zoom || r2.bearing) {
              const e2 = void 0 === i2.pinchAround ? i2.around : i2.pinchAround;
              r2.around = e2 ? this._map.unproject(e2) : this._map.getCenter();
            }
            return this.clear(), r2.noMoveStart = true, r2;
          }
        }
        function Ba(e2, t2) {
          (!e2.duration || e2.duration < t2.duration) && (e2.duration = t2.duration, e2.easing = t2.easing);
        }
        function ka(t2, i2, o2) {
          const { maxSpeed: r2, linearity: a2, deceleration: n2 } = o2, s2 = e.au(t2 * a2 / (i2 / 1e3), -r2, r2), l2 = Math.abs(s2) / (n2 * a2);
          return { easing: o2.easing, duration: 1e3 * l2, amount: s2 * (l2 / 2) };
        }
        class Na extends e.g {
          preventDefault() {
            this._defaultPrevented = true;
          }
          get defaultPrevented() {
            return this._defaultPrevented;
          }
          constructor(t2, i2, o2, r2 = {}) {
            const a2 = d(i2.getCanvasContainer(), o2), n2 = i2.unproject(a2);
            super(t2, e.Q({ point: a2, lngLat: n2, originalEvent: o2 }, r2)), this._defaultPrevented = false, this.target = i2;
          }
        }
        class Ua extends e.g {
          preventDefault() {
            this._defaultPrevented = true;
          }
          get defaultPrevented() {
            return this._defaultPrevented;
          }
          constructor(t2, i2, o2) {
            const r2 = "touchend" === t2 ? o2.changedTouches : o2.touches, a2 = p(i2.getCanvasContainer(), r2), n2 = a2.map((e2) => i2.unproject(e2)), s2 = a2.reduce((e2, t3, i3, o3) => e2.add(t3.div(o3.length)), new e.P(0, 0));
            super(t2, { points: a2, point: s2, lngLats: n2, lngLat: i2.unproject(s2), originalEvent: o2 }), this._defaultPrevented = false;
          }
        }
        class Ga extends e.g {
          preventDefault() {
            this._defaultPrevented = true;
          }
          get defaultPrevented() {
            return this._defaultPrevented;
          }
          constructor(e2, t2) {
            super("wheel", { originalEvent: t2 }), this._defaultPrevented = false;
          }
        }
        class ja {
          constructor(e2, t2) {
            this._map = e2, this._clickTolerance = t2.clickTolerance;
          }
          reset() {
            this._mousedownPos = void 0;
          }
          wheel(e2) {
            return this._firePreventable(new Ga(this._map, e2));
          }
          mousedown(e2, t2) {
            return this._mousedownPos = t2, this._firePreventable(new Na(e2.type, this._map, e2));
          }
          mouseup(e2) {
            this._map.fire(new Na(e2.type, this._map, e2));
          }
          preclick(t2) {
            const i2 = e.Q({}, t2);
            i2.type = "preclick", this._map.fire(new Na(i2.type, this._map, i2));
          }
          click(e2, t2) {
            this._mousedownPos && this._mousedownPos.dist(t2) >= this._clickTolerance || (this.preclick(e2), this._map.fire(new Na(e2.type, this._map, e2)));
          }
          dblclick(e2) {
            return this._firePreventable(new Na(e2.type, this._map, e2));
          }
          mouseover(e2) {
            this._map.fire(new Na(e2.type, this._map, e2));
          }
          mouseout(e2) {
            this._map.fire(new Na(e2.type, this._map, e2));
          }
          touchstart(e2) {
            return this._firePreventable(new Ua(e2.type, this._map, e2));
          }
          touchmove(e2) {
            this._map.fire(new Ua(e2.type, this._map, e2));
          }
          touchend(e2) {
            this._map.fire(new Ua(e2.type, this._map, e2));
          }
          touchcancel(e2) {
            this._map.fire(new Ua(e2.type, this._map, e2));
          }
          _firePreventable(e2) {
            if (this._map.fire(e2), e2.defaultPrevented)
              return {};
          }
          isEnabled() {
            return true;
          }
          isActive() {
            return false;
          }
          enable() {
          }
          disable() {
          }
        }
        class Va {
          constructor(e2) {
            this._map = e2;
          }
          reset() {
            this._delayContextMenu = false, this._contextMenuEvent = void 0;
          }
          mousemove(e2) {
            this._map.fire(new Na(e2.type, this._map, e2));
          }
          mousedown() {
            this._delayContextMenu = true;
          }
          mouseup() {
            this._delayContextMenu = false, this._contextMenuEvent && (this._map.fire(new Na("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
          }
          contextmenu(e2) {
            this._delayContextMenu ? this._contextMenuEvent = e2 : this._map.fire(new Na(e2.type, this._map, e2)), this._map.listens("contextmenu") && e2.preventDefault();
          }
          isEnabled() {
            return true;
          }
          isActive() {
            return false;
          }
          enable() {
          }
          disable() {
          }
        }
        class $a {
          constructor(e2, t2) {
            this._map = e2, this._el = e2.getCanvasContainer(), this._container = e2.getContainer(), this._clickTolerance = t2.clickTolerance || 1;
          }
          isEnabled() {
            return !!this._enabled;
          }
          isActive() {
            return !!this._active;
          }
          enable() {
            this.isEnabled() || (this._enabled = true);
          }
          disable() {
            this.isEnabled() && (this._enabled = false);
          }
          mousedown(e2, t2) {
            this.isEnabled() && e2.shiftKey && 0 === e2.button && (c(), this._startPos = this._lastPos = t2, this._active = true);
          }
          mousemoveWindow(e2, t2) {
            if (!this._active)
              return;
            const i2 = t2, o2 = this._startPos, a2 = this._lastPos;
            if (!o2 || !a2 || a2.equals(i2) || !this._box && i2.dist(o2) < this._clickTolerance)
              return;
            this._lastPos = i2, this._box || (this._box = r("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e2));
            const n2 = Math.min(o2.x, i2.x), s2 = Math.max(o2.x, i2.x), l2 = Math.min(o2.y, i2.y), c2 = Math.max(o2.y, i2.y);
            this._map._requestDomTask(() => {
              this._box && (this._box.style.transform = `translate(${n2}px,${l2}px)`, this._box.style.width = s2 - n2 + "px", this._box.style.height = c2 - l2 + "px");
            });
          }
          mouseupWindow(t2, i2) {
            if (!this._active)
              return;
            const o2 = this._startPos, r2 = i2;
            if (o2 && 0 === t2.button) {
              if (this.reset(), u(), o2.x !== r2.x || o2.y !== r2.y)
                return this._map.fire(new e.g("boxzoomend", { originalEvent: t2 })), { cameraAnimation: (e2) => e2.fitScreenCoordinates(o2, r2, this._map.getBearing(), { linear: false }) };
              this._fireEvent("boxzoomcancel", t2);
            }
          }
          keydown(e2) {
            this._active && 27 === e2.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e2));
          }
          blur() {
            this.reset();
          }
          reset() {
            this._active = false, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), h(), delete this._startPos, delete this._lastPos;
          }
          _fireEvent(t2, i2) {
            return this._map.fire(new e.g(t2, { originalEvent: i2 }));
          }
        }
        function Za(e2, t2) {
          const i2 = {};
          for (let o2 = 0; o2 < e2.length; o2++)
            i2[e2[o2].identifier] = t2[o2];
          return i2;
        }
        class Wa {
          constructor(e2) {
            this.reset(), this.numTouches = e2.numTouches;
          }
          reset() {
            this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = false;
          }
          touchstart(t2, i2, o2) {
            (this.centroid || o2.length > this.numTouches) && (this.aborted = true), this.aborted || (0 === this.startTime && (this.startTime = t2.timeStamp), o2.length === this.numTouches && (this.centroid = function(t3) {
              const i3 = new e.P(0, 0);
              for (const e2 of t3)
                i3._add(e2);
              return i3.div(t3.length);
            }(i2), this.touches = Za(o2, i2)));
          }
          touchmove(e2, t2, i2) {
            if (this.aborted || !this.centroid)
              return;
            const o2 = Za(i2, t2);
            for (const e3 in this.touches) {
              const t3 = o2[e3];
              (!t3 || t3.dist(this.touches[e3]) > 30) && (this.aborted = true);
            }
          }
          touchend(e2, t2, i2) {
            if ((!this.centroid || e2.timeStamp - this.startTime > 500) && (this.aborted = true), 0 === i2.length) {
              const e3 = !this.aborted && this.centroid;
              if (this.reset(), e3)
                return e3;
            }
          }
        }
        class Ha {
          constructor(e2) {
            this.singleTap = new Wa(e2), this.numTaps = e2.numTaps, this.reset();
          }
          reset() {
            this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
          }
          touchstart(e2, t2, i2) {
            this.singleTap.touchstart(e2, t2, i2);
          }
          touchmove(e2, t2, i2) {
            this.singleTap.touchmove(e2, t2, i2);
          }
          touchend(e2, t2, i2) {
            const o2 = this.singleTap.touchend(e2, t2, i2);
            if (o2) {
              const t3 = e2.timeStamp - this.lastTime < 500, i3 = !this.lastTap || this.lastTap.dist(o2) < 30;
              if (t3 && i3 || this.reset(), this.count++, this.lastTime = e2.timeStamp, this.lastTap = o2, this.count === this.numTaps)
                return this.reset(), o2;
            }
          }
        }
        class qa {
          constructor() {
            this._zoomIn = new Ha({ numTouches: 1, numTaps: 2 }), this._zoomOut = new Ha({ numTouches: 2, numTaps: 1 }), this.reset();
          }
          reset() {
            this._active = false, this._zoomIn.reset(), this._zoomOut.reset();
          }
          touchstart(e2, t2, i2) {
            this._zoomIn.touchstart(e2, t2, i2), this._zoomOut.touchstart(e2, t2, i2);
          }
          touchmove(e2, t2, i2) {
            this._zoomIn.touchmove(e2, t2, i2), this._zoomOut.touchmove(e2, t2, i2);
          }
          touchend(e2, t2, i2) {
            const o2 = this._zoomIn.touchend(e2, t2, i2), r2 = this._zoomOut.touchend(e2, t2, i2);
            return o2 ? (this._active = true, e2.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (t3) => t3.easeTo({ duration: 300, zoom: t3.getZoom() + 1, around: t3.unproject(o2) }, { originalEvent: e2 }) }) : r2 ? (this._active = true, e2.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (t3) => t3.easeTo({ duration: 300, zoom: t3.getZoom() - 1, around: t3.unproject(r2) }, { originalEvent: e2 }) }) : void 0;
          }
          touchcancel() {
            this.reset();
          }
          enable() {
            this._enabled = true;
          }
          disable() {
            this._enabled = false, this.reset();
          }
          isEnabled() {
            return this._enabled;
          }
          isActive() {
            return this._active;
          }
        }
        const Xa = { 0: 1, 2: 2 };
        class Qa {
          constructor(e2) {
            this.reset(), this._clickTolerance = e2.clickTolerance || 1;
          }
          blur() {
            this.reset();
          }
          reset() {
            this._active = false, this._moved = false, this._lastPoint = void 0, this._eventButton = void 0;
          }
          _correctButton(e2, t2) {
            return false;
          }
          _move(e2, t2) {
            return {};
          }
          mousedown(e2, t2) {
            if (this._lastPoint)
              return;
            const i2 = f(e2);
            this._correctButton(e2, i2) && (this._lastPoint = t2, this._eventButton = i2);
          }
          mousemoveWindow(e2, t2) {
            const i2 = this._lastPoint;
            if (i2) {
              if (e2.preventDefault(), null != this._eventButton && function(e3, t3) {
                const i3 = Xa[t3];
                return void 0 === e3.buttons || (e3.buttons & i3) !== i3;
              }(e2, this._eventButton))
                this.reset();
              else if (this._moved || !(t2.dist(i2) < this._clickTolerance))
                return this._moved = true, this._lastPoint = t2, this._move(i2, t2);
            }
          }
          mouseupWindow(e2) {
            this._lastPoint && f(e2) === this._eventButton && (this._moved && u(), this.reset());
          }
          enable() {
            this._enabled = true;
          }
          disable() {
            this._enabled = false, this.reset();
          }
          isEnabled() {
            return this._enabled;
          }
          isActive() {
            return this._active;
          }
        }
        class Ya extends Qa {
          mousedown(e2, t2) {
            super.mousedown(e2, t2), this._lastPoint && (this._active = true);
          }
          _correctButton(e2, t2) {
            return 0 === t2 && !e2.ctrlKey;
          }
          _move(e2, t2) {
            return { around: t2, panDelta: t2.sub(e2) };
          }
        }
        class Ja extends Qa {
          _correctButton(e2, t2) {
            return 0 === t2 && e2.ctrlKey || 2 === t2;
          }
          _move(e2, t2) {
            const i2 = 0.8 * (t2.x - e2.x);
            if (i2)
              return this._active = true, { bearingDelta: i2 };
          }
          contextmenu(e2) {
            e2.preventDefault();
          }
        }
        class Ka extends Qa {
          _correctButton(e2, t2) {
            return 0 === t2 && e2.ctrlKey || 2 === t2;
          }
          _move(e2, t2) {
            const i2 = -0.5 * (t2.y - e2.y);
            if (i2)
              return this._active = true, { pitchDelta: i2 };
          }
          contextmenu(e2) {
            e2.preventDefault();
          }
        }
        class en {
          constructor(t2, i2) {
            this._map = t2, this._el = t2.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i2.clickTolerance || 1, this.reset(), e.br(["_addTouchPanBlocker", "_showTouchPanBlockerAlert"], this);
          }
          reset() {
            this._active = false, this._touches = {}, this._sum = new e.P(0, 0);
          }
          touchstart(e2, t2, i2) {
            return this._calculateTransform(e2, t2, i2);
          }
          touchmove(t2, i2, o2) {
            if (this._active && !(o2.length < this._minTouches)) {
              if (this._map._cooperativeGestures && !this._map.isMoving()) {
                if (1 === o2.length && !e.d4())
                  return void this._showTouchPanBlockerAlert();
                "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
              }
              return t2.cancelable && t2.preventDefault(), this._calculateTransform(t2, i2, o2);
            }
          }
          touchend(e2, t2, i2) {
            this._calculateTransform(e2, t2, i2), this._active && i2.length < this._minTouches && this.reset();
          }
          touchcancel() {
            this.reset();
          }
          _calculateTransform(t2, i2, o2) {
            o2.length > 0 && (this._active = true);
            const r2 = Za(o2, i2), a2 = new e.P(0, 0), n2 = new e.P(0, 0);
            let s2 = 0;
            for (const e2 in r2) {
              const t3 = r2[e2], i3 = this._touches[e2];
              i3 && (a2._add(t3), n2._add(t3.sub(i3)), s2++, r2[e2] = t3);
            }
            if (this._touches = r2, s2 < this._minTouches || !n2.mag())
              return;
            const l2 = n2.div(s2);
            return this._sum._add(l2), this._sum.mag() < this._clickTolerance ? void 0 : { around: a2.div(s2), panDelta: l2 };
          }
          enable() {
            this._enabled = true, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
          }
          disable() {
            this._enabled = false, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
          }
          isEnabled() {
            return !!this._enabled;
          }
          isActive() {
            return !!this._active;
          }
          _addTouchPanBlocker() {
            this._map && !this._alertContainer && (this._alertContainer = r("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(0.05 * this._el.clientWidth)))}px`);
          }
          _showTouchPanBlockerAlert() {
            this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(() => {
              this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.removeAttribute("role");
            }, 500);
          }
        }
        class tn {
          constructor() {
            this.reset();
          }
          reset() {
            this._active = false, this._firstTwoTouches = void 0;
          }
          _start(e2) {
          }
          _move(e2, t2, i2) {
            return {};
          }
          touchstart(e2, t2, i2) {
            this._firstTwoTouches || i2.length < 2 || (this._firstTwoTouches = [i2[0].identifier, i2[1].identifier], this._start([t2[0], t2[1]]));
          }
          touchmove(e2, t2, i2) {
            const o2 = this._firstTwoTouches;
            if (!o2)
              return;
            e2.preventDefault();
            const [r2, a2] = o2, n2 = on(i2, t2, r2), s2 = on(i2, t2, a2);
            if (!n2 || !s2)
              return;
            const l2 = this._aroundCenter ? null : n2.add(s2).div(2);
            return this._move([n2, s2], l2, e2);
          }
          touchend(e2, t2, i2) {
            if (!this._firstTwoTouches)
              return;
            const [o2, r2] = this._firstTwoTouches, a2 = on(i2, t2, o2), n2 = on(i2, t2, r2);
            a2 && n2 || (this._active && u(), this.reset());
          }
          touchcancel() {
            this.reset();
          }
          enable(e2) {
            this._enabled = true, this._aroundCenter = !!e2 && "center" === e2.around;
          }
          disable() {
            this._enabled = false, this.reset();
          }
          isEnabled() {
            return this._enabled;
          }
          isActive() {
            return this._active;
          }
        }
        function on(e2, t2, i2) {
          for (let o2 = 0; o2 < e2.length; o2++)
            if (e2[o2].identifier === i2)
              return t2[o2];
        }
        function rn(e2, t2) {
          return Math.log(e2 / t2) / Math.LN2;
        }
        class an extends tn {
          reset() {
            super.reset(), this._distance = 0, this._startDistance = 0;
          }
          _start(e2) {
            this._startDistance = this._distance = e2[0].dist(e2[1]);
          }
          _move(e2, t2) {
            const i2 = this._distance;
            if (this._distance = e2[0].dist(e2[1]), this._active || !(Math.abs(rn(this._distance, this._startDistance)) < 0.1))
              return this._active = true, { zoomDelta: rn(this._distance, i2), pinchAround: t2 };
          }
        }
        function nn(e2, t2) {
          return 180 * e2.angleWith(t2) / Math.PI;
        }
        class sn extends tn {
          reset() {
            super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
          }
          _start(e2) {
            this._startVector = this._vector = e2[0].sub(e2[1]), this._minDiameter = e2[0].dist(e2[1]);
          }
          _move(e2, t2) {
            const i2 = this._vector;
            if (this._vector = e2[0].sub(e2[1]), i2 && (this._active || !this._isBelowThreshold(this._vector)))
              return this._active = true, { bearingDelta: nn(this._vector, i2), pinchAround: t2 };
          }
          _isBelowThreshold(e2) {
            this._minDiameter = Math.min(this._minDiameter, e2.mag());
            const t2 = 25 / (Math.PI * this._minDiameter) * 360, i2 = this._startVector;
            if (!i2)
              return false;
            const o2 = nn(e2, i2);
            return Math.abs(o2) < t2;
          }
        }
        function ln(e2) {
          return Math.abs(e2.y) > Math.abs(e2.x);
        }
        class cn extends tn {
          constructor(e2) {
            super(), this._map = e2;
          }
          reset() {
            super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
          }
          _start(e2) {
            this._lastPoints = e2, ln(e2[0].sub(e2[1])) && (this._valid = false);
          }
          _move(t2, i2, o2) {
            const r2 = this._lastPoints;
            if (!r2)
              return;
            const a2 = t2[0].sub(r2[0]), n2 = t2[1].sub(r2[1]);
            return this._map._cooperativeGestures && !e.d4() && o2.touches.length < 3 || (this._valid = this.gestureBeginsVertically(a2, n2, o2.timeStamp), !this._valid) ? void 0 : (this._lastPoints = t2, this._active = true, { pitchDelta: (a2.y + n2.y) / 2 * -0.5 });
          }
          gestureBeginsVertically(e2, t2, i2) {
            if (void 0 !== this._valid)
              return this._valid;
            const o2 = e2.mag() >= 2, r2 = t2.mag() >= 2;
            if (!o2 && !r2)
              return;
            if (!o2 || !r2)
              return null == this._firstMove && (this._firstMove = i2), i2 - this._firstMove < 100 && void 0;
            const a2 = e2.y > 0 == t2.y > 0;
            return ln(e2) && ln(t2) && a2;
          }
        }
        const hn = { panStep: 100, bearingStep: 15, pitchStep: 10 };
        class _n {
          constructor() {
            const e2 = hn;
            this._panStep = e2.panStep, this._bearingStep = e2.bearingStep, this._pitchStep = e2.pitchStep, this._rotationDisabled = false;
          }
          blur() {
            this.reset();
          }
          reset() {
            this._active = false;
          }
          keydown(e2) {
            if (e2.altKey || e2.ctrlKey || e2.metaKey)
              return;
            let t2 = 0, i2 = 0, o2 = 0, r2 = 0, a2 = 0;
            switch (e2.keyCode) {
              case 61:
              case 107:
              case 171:
              case 187:
                t2 = 1;
                break;
              case 189:
              case 109:
              case 173:
                t2 = -1;
                break;
              case 37:
                e2.shiftKey ? i2 = -1 : (e2.preventDefault(), r2 = -1);
                break;
              case 39:
                e2.shiftKey ? i2 = 1 : (e2.preventDefault(), r2 = 1);
                break;
              case 38:
                e2.shiftKey ? o2 = 1 : (e2.preventDefault(), a2 = -1);
                break;
              case 40:
                e2.shiftKey ? o2 = -1 : (e2.preventDefault(), a2 = 1);
                break;
              default:
                return;
            }
            return this._rotationDisabled && (i2 = 0, o2 = 0), { cameraAnimation: (n2) => {
              const s2 = n2.getZoom();
              n2.easeTo({ duration: 300, easeId: "keyboardHandler", easing: un, zoom: t2 ? Math.round(s2) + t2 * (e2.shiftKey ? 2 : 1) : s2, bearing: n2.getBearing() + i2 * this._bearingStep, pitch: n2.getPitch() + o2 * this._pitchStep, offset: [-r2 * this._panStep, -a2 * this._panStep], center: n2.getCenter() }, { originalEvent: e2 });
            } };
          }
          enable() {
            this._enabled = true;
          }
          disable() {
            this._enabled = false, this.reset();
          }
          isEnabled() {
            return this._enabled;
          }
          isActive() {
            return this._active;
          }
          disableRotation() {
            this._rotationDisabled = true;
          }
          enableRotation() {
            this._rotationDisabled = false;
          }
        }
        function un(e2) {
          return e2 * (2 - e2);
        }
        const dn = 4.000244140625, pn = 1 / 450;
        class fn {
          constructor(t2, i2) {
            this._map = t2, this._el = t2.getCanvasContainer(), this._handler = i2, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = 0.01, this._wheelZoomRate = pn, e.br(["_onTimeout", "_addScrollZoomBlocker", "_showBlockerAlert"], this);
          }
          setZoomRate(e2) {
            this._defaultZoomRate = e2;
          }
          setWheelZoomRate(e2) {
            this._wheelZoomRate = e2;
          }
          isEnabled() {
            return !!this._enabled;
          }
          isActive() {
            return this._active || void 0 !== this._finishTimeout;
          }
          isZooming() {
            return !!this._zooming;
          }
          enable(e2) {
            this.isEnabled() || (this._enabled = true, this._aroundCenter = !!e2 && "center" === e2.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
          }
          disable() {
            this.isEnabled() && (this._enabled = false, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
          }
          wheel(t2) {
            if (!this.isEnabled())
              return;
            if (this._map._cooperativeGestures) {
              if (!(t2.ctrlKey || t2.metaKey || this.isZooming() || e.d4()))
                return void this._showBlockerAlert();
              "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
            }
            let i2 = t2.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * t2.deltaY : t2.deltaY;
            const o2 = e.e.now(), r2 = o2 - (this._lastWheelEventTime || 0);
            this._lastWheelEventTime = o2, 0 !== i2 && i2 % dn == 0 ? this._type = "wheel" : 0 !== i2 && Math.abs(i2) < 4 ? this._type = "trackpad" : r2 > 400 ? (this._type = null, this._lastValue = i2, this._timeout = window.setTimeout(this._onTimeout, 40, t2)) : this._type || (this._type = Math.abs(r2 * i2) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i2 += this._lastValue)), t2.shiftKey && i2 && (i2 /= 4), this._type && (this._lastWheelEvent = t2, this._delta -= i2, this._active || this._start(t2)), t2.preventDefault();
          }
          _onTimeout(e2) {
            this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e2);
          }
          _start(e2) {
            if (!this._delta)
              return;
            this._frameId && (this._frameId = null), this._active = true, this.isZooming() || (this._zooming = true), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
            const t2 = d(this._el, e2);
            this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t2, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = true, this._handler._triggerRenderFrame());
          }
          renderFrame() {
            if (!this._frameId)
              return;
            if (this._frameId = null, !this.isActive())
              return;
            const t2 = this._map.transform;
            "wheel" === this._type && t2.projection.wrap && (t2._center.lng >= 180 || t2._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
            const i2 = () => t2._terrainEnabled() && this._aroundCoord ? t2.computeZoomRelativeTo(this._aroundCoord) : t2.zoom;
            if (0 !== this._delta) {
              const e2 = "wheel" === this._type && Math.abs(this._delta) > dn ? this._wheelZoomRate : this._defaultZoomRate;
              let o3 = 2 / (1 + Math.exp(-Math.abs(this._delta * e2)));
              this._delta < 0 && 0 !== o3 && (o3 = 1 / o3);
              const r3 = i2(), a3 = Math.pow(2, r3), n3 = "number" == typeof this._targetZoom ? t2.zoomScale(this._targetZoom) : a3;
              this._targetZoom = Math.min(t2.maxZoom, Math.max(t2.minZoom, t2.scaleZoom(n3 * o3))), "wheel" === this._type && (this._startZoom = r3, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
            }
            const o2 = "number" == typeof this._targetZoom ? this._targetZoom : i2(), r2 = this._startZoom, a2 = this._easing;
            let n2, s2 = false;
            if ("wheel" === this._type && r2 && a2) {
              const t3 = Math.min((e.e.now() - this._lastWheelEventTime) / 200, 1), i3 = a2(t3);
              n2 = e.a3(r2, o2, i3), t3 < 1 ? this._frameId || (this._frameId = true) : s2 = true;
            } else
              n2 = o2, s2 = true;
            this._active = true, s2 && (this._active = false, this._finishTimeout = window.setTimeout(() => {
              this._zooming = false, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
            }, 200));
            let l2 = n2 - i2();
            return l2 * this._lastDelta < 0 && (l2 = 0), { noInertia: true, needsRenderFrame: !s2, zoomDelta: l2, around: this._aroundPoint, aroundCoord: this._aroundCoord, originalEvent: this._lastWheelEvent };
          }
          _smoothOutEasing(t2) {
            let i2 = e.d5;
            if (this._prevEase) {
              const t3 = this._prevEase, o2 = (e.e.now() - t3.start) / t3.duration, r2 = t3.easing(o2 + 0.01) - t3.easing(o2), a2 = 0.27 / Math.sqrt(r2 * r2 + 1e-4) * 0.01, n2 = Math.sqrt(0.0729 - a2 * a2);
              i2 = e.d3(a2, n2, 0.25, 1);
            }
            return this._prevEase = { start: e.e.now(), duration: t2, easing: i2 }, i2;
          }
          blur() {
            this.reset();
          }
          reset() {
            this._active = false;
          }
          _addScrollZoomBlocker() {
            this._map && !this._alertContainer && (this._alertContainer = r("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(0.05 * this._el.clientWidth)))}px`);
          }
          _showBlockerAlert() {
            this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(() => {
              this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.removeAttribute("role");
            }, 200);
          }
        }
        class mn {
          constructor(e2, t2) {
            this._clickZoom = e2, this._tapZoom = t2;
          }
          enable() {
            this._clickZoom.enable(), this._tapZoom.enable();
          }
          disable() {
            this._clickZoom.disable(), this._tapZoom.disable();
          }
          isEnabled() {
            return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
          }
          isActive() {
            return this._clickZoom.isActive() || this._tapZoom.isActive();
          }
        }
        class gn {
          constructor() {
            this.reset();
          }
          reset() {
            this._active = false;
          }
          blur() {
            this.reset();
          }
          dblclick(e2, t2) {
            return e2.preventDefault(), { cameraAnimation: (i2) => {
              i2.easeTo({ duration: 300, zoom: i2.getZoom() + (e2.shiftKey ? -1 : 1), around: i2.unproject(t2) }, { originalEvent: e2 });
            } };
          }
          enable() {
            this._enabled = true;
          }
          disable() {
            this._enabled = false, this.reset();
          }
          isEnabled() {
            return this._enabled;
          }
          isActive() {
            return this._active;
          }
        }
        class vn {
          constructor() {
            this._tap = new Ha({ numTouches: 1, numTaps: 1 }), this.reset();
          }
          reset() {
            this._active = false, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
          }
          touchstart(e2, t2, i2) {
            this._swipePoint || (this._tapTime && e2.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i2.length > 0 && (this._swipePoint = t2[0], this._swipeTouch = i2[0].identifier) : this._tap.touchstart(e2, t2, i2));
          }
          touchmove(e2, t2, i2) {
            if (this._tapTime) {
              if (this._swipePoint) {
                if (i2[0].identifier !== this._swipeTouch)
                  return;
                const o2 = t2[0], r2 = o2.y - this._swipePoint.y;
                return this._swipePoint = o2, e2.preventDefault(), this._active = true, { zoomDelta: r2 / 128 };
              }
            } else
              this._tap.touchmove(e2, t2, i2);
          }
          touchend(e2, t2, i2) {
            this._tapTime ? this._swipePoint && 0 === i2.length && this.reset() : this._tap.touchend(e2, t2, i2) && (this._tapTime = e2.timeStamp);
          }
          touchcancel() {
            this.reset();
          }
          enable() {
            this._enabled = true;
          }
          disable() {
            this._enabled = false, this.reset();
          }
          isEnabled() {
            return this._enabled;
          }
          isActive() {
            return this._active;
          }
        }
        class xn {
          constructor(e2, t2, i2) {
            this._el = e2, this._mousePan = t2, this._touchPan = i2;
          }
          enable(e2) {
            this._inertiaOptions = e2 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
          }
          disable() {
            this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
          }
          isEnabled() {
            return this._mousePan.isEnabled() && this._touchPan.isEnabled();
          }
          isActive() {
            return this._mousePan.isActive() || this._touchPan.isActive();
          }
        }
        class yn {
          constructor(e2, t2, i2) {
            this._pitchWithRotate = e2.pitchWithRotate, this._mouseRotate = t2, this._mousePitch = i2;
          }
          enable() {
            this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
          }
          disable() {
            this._mouseRotate.disable(), this._mousePitch.disable();
          }
          isEnabled() {
            return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
          }
          isActive() {
            return this._mouseRotate.isActive() || this._mousePitch.isActive();
          }
        }
        class bn {
          constructor(e2, t2, i2, o2) {
            this._el = e2, this._touchZoom = t2, this._touchRotate = i2, this._tapDragZoom = o2, this._rotationDisabled = false, this._enabled = true;
          }
          enable(e2) {
            this._touchZoom.enable(e2), this._rotationDisabled || this._touchRotate.enable(e2), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
          }
          disable() {
            this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
          }
          isEnabled() {
            return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
          }
          isActive() {
            return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
          }
          disableRotation() {
            this._rotationDisabled = true, this._touchRotate.disable();
          }
          enableRotation() {
            this._rotationDisabled = false, this._touchZoom.isEnabled() && this._touchRotate.enable();
          }
        }
        const wn = (e2) => e2.zoom || e2.drag || e2.pitch || e2.rotate;
        class Tn extends e.g {
        }
        class En {
          constructor() {
            this.constants = [1, 1, 0.01], this.radius = 0;
          }
          setup(t2, i2) {
            const o2 = e.$.sub([], i2, t2);
            this.radius = e.$.length(o2[2] < 0 ? e.$.div([], o2, this.constants) : [o2[0], o2[1], 0]);
          }
          projectRay(t2) {
            e.$.div(t2, t2, this.constants), e.$.normalize(t2, t2), e.$.mul(t2, t2, this.constants);
            const i2 = e.$.scale([], t2, this.radius);
            if (i2[2] > 0) {
              const t3 = e.$.scale([], [0, 0, 1], e.$.dot(i2, [0, 0, 1])), o2 = e.$.scale([], e.$.normalize([], [i2[0], i2[1], 0]), this.radius), r2 = e.$.add([], i2, e.$.scale([], e.$.sub([], e.$.add([], o2, t3), i2), 2));
              i2[0] = r2[0], i2[1] = r2[1];
            }
            return i2;
          }
        }
        function Cn(e2) {
          return e2.panDelta && e2.panDelta.mag() || e2.zoomDelta || e2.bearingDelta || e2.pitchDelta;
        }
        class Sn {
          constructor(t2, i2) {
            this._map = t2, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Fa(t2), this._bearingSnap = i2.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new En(), this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i2), e.br(["handleEvent", "handleWindowEvent"], this);
            const o2 = this._el;
            this._listeners = [[o2, "touchstart", { passive: true }], [o2, "touchmove", { passive: false }], [o2, "touchend", void 0], [o2, "touchcancel", void 0], [o2, "mousedown", void 0], [o2, "mousemove", void 0], [o2, "mouseup", void 0], [document, "mousemove", { capture: true }], [document, "mouseup", void 0], [o2, "mouseover", void 0], [o2, "mouseout", void 0], [o2, "dblclick", void 0], [o2, "click", void 0], [o2, "keydown", { capture: false }], [o2, "keyup", void 0], [o2, "wheel", { passive: false }], [o2, "contextmenu", void 0], [window, "blur", void 0]];
            for (const [e2, t3, i3] of this._listeners) {
              const o3 = e2 === document ? this.handleWindowEvent : this.handleEvent;
              e2.addEventListener(t3, o3, i3);
            }
          }
          destroy() {
            for (const [e2, t2, i2] of this._listeners) {
              const o2 = e2 === document ? this.handleWindowEvent : this.handleEvent;
              e2.removeEventListener(t2, o2, i2);
            }
          }
          _addDefaultHandlers(e2) {
            const t2 = this._map, i2 = t2.getCanvasContainer();
            this._add("mapEvent", new ja(t2, e2));
            const o2 = t2.boxZoom = new $a(t2, e2);
            this._add("boxZoom", o2);
            const r2 = new qa(), a2 = new gn();
            t2.doubleClickZoom = new mn(a2, r2), this._add("tapZoom", r2), this._add("clickZoom", a2);
            const n2 = new vn();
            this._add("tapDragZoom", n2);
            const s2 = t2.touchPitch = new cn(t2);
            this._add("touchPitch", s2);
            const l2 = new Ja(e2), c2 = new Ka(e2);
            t2.dragRotate = new yn(e2, l2, c2), this._add("mouseRotate", l2, ["mousePitch"]), this._add("mousePitch", c2, ["mouseRotate"]);
            const h2 = new Ya(e2), _2 = new en(t2, e2);
            t2.dragPan = new xn(i2, h2, _2), this._add("mousePan", h2), this._add("touchPan", _2, ["touchZoom", "touchRotate"]);
            const u2 = new sn(), d2 = new an();
            t2.touchZoomRotate = new bn(i2, d2, u2, n2), this._add("touchRotate", u2, ["touchPan", "touchZoom"]), this._add("touchZoom", d2, ["touchPan", "touchRotate"]), this._add("blockableMapEvent", new Va(t2));
            const p2 = t2.scrollZoom = new fn(t2, this);
            this._add("scrollZoom", p2, ["mousePan"]);
            const f2 = t2.keyboard = new _n();
            this._add("keyboard", f2);
            for (const i3 of ["boxZoom", "doubleClickZoom", "tapDragZoom", "touchPitch", "dragRotate", "dragPan", "touchZoomRotate", "scrollZoom", "keyboard"])
              e2.interactive && e2[i3] && t2[i3].enable(e2[i3]);
          }
          _add(e2, t2, i2) {
            this._handlers.push({ handlerName: e2, handler: t2, allowed: i2 }), this._handlersById[e2] = t2;
          }
          stop(e2) {
            if (!this._updatingCamera) {
              for (const { handler: e3 } of this._handlers)
                e3.reset();
              this._inertia.clear(), this._fireEvents({}, {}, e2), this._changes = [], this._originalZoom = void 0;
            }
          }
          isActive() {
            for (const { handler: e2 } of this._handlers)
              if (e2.isActive())
                return true;
            return false;
          }
          isZooming() {
            return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
          }
          isRotating() {
            return !!this._eventsInProgress.rotate;
          }
          isMoving() {
            return !!wn(this._eventsInProgress) || this.isZooming();
          }
          _isDragging() {
            return !!this._eventsInProgress.drag;
          }
          _blockedByActive(e2, t2, i2) {
            for (const o2 in e2)
              if (o2 !== i2 && (!t2 || t2.indexOf(o2) < 0))
                return true;
            return false;
          }
          handleWindowEvent(e2) {
            this.handleEvent(e2, `${e2.type}Window`);
          }
          _getMapTouches(e2) {
            const t2 = [];
            for (const i2 of e2)
              this._el.contains(i2.target) && t2.push(i2);
            return t2;
          }
          handleEvent(e2, t2) {
            this._updatingCamera = true;
            const i2 = "renderFrame" === e2.type, o2 = i2 ? void 0 : e2, r2 = { needsRenderFrame: false }, a2 = {}, n2 = {}, s2 = e2.touches ? this._getMapTouches(e2.touches) : void 0, l2 = s2 ? p(this._el, s2) : i2 ? void 0 : d(this._el, e2);
            for (const { handlerName: i3, handler: c3, allowed: h3 } of this._handlers) {
              if (!c3.isEnabled())
                continue;
              let _2;
              this._blockedByActive(n2, h3, i3) ? c3.reset() : c3[t2 || e2.type] && (_2 = c3[t2 || e2.type](e2, l2, s2), this.mergeHandlerResult(r2, a2, _2, i3, o2), _2 && _2.needsRenderFrame && this._triggerRenderFrame()), (_2 || c3.isActive()) && (n2[i3] = c3);
            }
            const c2 = {};
            for (const e3 in this._previousActiveHandlers)
              n2[e3] || (c2[e3] = o2);
            this._previousActiveHandlers = n2, (Object.keys(c2).length || Cn(r2)) && (this._changes.push([r2, a2, c2]), this._triggerRenderFrame()), (Object.keys(n2).length || Cn(r2)) && this._map._stop(true), this._updatingCamera = false;
            const { cameraAnimation: h2 } = r2;
            h2 && (this._inertia.clear(), this._fireEvents({}, {}, true), this._changes = [], h2(this._map));
          }
          mergeHandlerResult(t2, i2, o2, r2, a2) {
            if (!o2)
              return;
            e.Q(t2, o2);
            const n2 = { handlerName: r2, originalEvent: o2.originalEvent || a2 };
            void 0 !== o2.zoomDelta && (i2.zoom = n2), void 0 !== o2.panDelta && (i2.drag = n2), void 0 !== o2.pitchDelta && (i2.pitch = n2), void 0 !== o2.bearingDelta && (i2.rotate = n2);
          }
          _applyChanges() {
            const t2 = {}, i2 = {}, o2 = {};
            for (const [r2, a2, n2] of this._changes)
              r2.panDelta && (t2.panDelta = (t2.panDelta || new e.P(0, 0))._add(r2.panDelta)), r2.zoomDelta && (t2.zoomDelta = (t2.zoomDelta || 0) + r2.zoomDelta), r2.bearingDelta && (t2.bearingDelta = (t2.bearingDelta || 0) + r2.bearingDelta), r2.pitchDelta && (t2.pitchDelta = (t2.pitchDelta || 0) + r2.pitchDelta), void 0 !== r2.around && (t2.around = r2.around), void 0 !== r2.aroundCoord && (t2.aroundCoord = r2.aroundCoord), void 0 !== r2.pinchAround && (t2.pinchAround = r2.pinchAround), r2.noInertia && (t2.noInertia = r2.noInertia), e.Q(i2, a2), e.Q(o2, n2);
            this._updateMapTransform(t2, i2, o2), this._changes = [];
          }
          _updateMapTransform(t2, i2, o2) {
            const r2 = this._map, a2 = r2.transform, n2 = (e2) => [e2.x, e2.y, e2.z];
            if (((e2) => {
              const t3 = this._eventsInProgress.drag;
              return t3 && !this._handlersById[t3.handlerName].isActive();
            })() && !Cn(t2)) {
              const e2 = a2.zoom;
              a2.cameraElevationReference = "sea", null != this._originalZoom && a2._orthographicProjectionAtLowPitch && "globe" !== a2.projection.name && 0 === a2.pitch ? (a2.cameraElevationReference = "ground", a2.zoom = this._originalZoom) : (a2.recenterOnTerrain(), a2.cameraElevationReference = "ground"), e2 !== a2.zoom && this._map._update(true);
            }
            if (a2._isCameraConstrained && r2._stop(true), !Cn(t2))
              return void this._fireEvents(i2, o2, true);
            let { panDelta: s2, zoomDelta: l2, bearingDelta: c2, pitchDelta: h2, around: _2, aroundCoord: u2, pinchAround: d2 } = t2;
            a2._isCameraConstrained && (l2 > 0 && (l2 = 0), a2._isCameraConstrained = false), void 0 !== d2 && (_2 = d2), (l2 || ((e2) => i2[e2] && !this._eventsInProgress[e2])("drag")) && _2 && (this._dragOrigin = n2(a2.pointCoordinate3D(_2)), this._originalZoom = a2.zoom, this._trackingEllipsoid.setup(a2._camera.position, this._dragOrigin)), a2.cameraElevationReference = "sea", r2._stop(true), _2 = _2 || r2.transform.centerPoint, c2 && (a2.bearing += c2), h2 && (a2.pitch += h2), a2._updateCameraState();
            const p2 = [0, 0, 0];
            if (s2)
              if ("mercator" === a2.projection.name) {
                const e2 = this._trackingEllipsoid.projectRay(a2.screenPointToMercatorRay(_2).dir), t3 = this._trackingEllipsoid.projectRay(a2.screenPointToMercatorRay(_2.sub(s2)).dir);
                p2[0] = t3[0] - e2[0], p2[1] = t3[1] - e2[1];
              } else {
                const t3 = a2.pointCoordinate(_2);
                if ("globe" === a2.projection.name) {
                  s2 = s2.rotate(-a2.angle);
                  const i3 = a2._pixelsPerMercatorPixel / a2.worldSize;
                  p2[0] = -s2.x * e.d6(e.az(t3.y)) * i3, p2[1] = -s2.y * e.d6(a2.center.lat) * i3;
                } else {
                  const e2 = a2.pointCoordinate(_2.sub(s2));
                  t3 && e2 && (p2[0] = e2.x - t3.x, p2[1] = e2.y - t3.y);
                }
              }
            const f2 = a2.zoom, m2 = [0, 0, 0];
            if (l2) {
              const t3 = n2(u2 || a2.pointCoordinate3D(_2)), i3 = { dir: e.$.normalize([], e.$.sub([], t3, a2._camera.position)) };
              if (i3.dir[2] < 0) {
                const o3 = a2.zoomDeltaToMovement(t3, l2);
                e.$.scale(m2, i3.dir, o3);
              }
            }
            const g2 = e.$.add(p2, p2, m2);
            a2._translateCameraConstrained(g2), l2 && Math.abs(a2.zoom - f2) > 1e-4 && a2.recenterOnTerrain(), a2.cameraElevationReference = "ground", this._map._update(), t2.noInertia || this._inertia.record(t2), this._fireEvents(i2, o2, true);
          }
          _fireEvents(t2, i2, o2) {
            const r2 = wn(this._eventsInProgress), a2 = wn(t2), n2 = {};
            for (const e2 in t2) {
              const { originalEvent: i3 } = t2[e2];
              this._eventsInProgress[e2] || (n2[`${e2}start`] = i3), this._eventsInProgress[e2] = t2[e2];
            }
            !r2 && a2 && this._fireEvent("movestart", a2.originalEvent);
            for (const e2 in n2)
              this._fireEvent(e2, n2[e2]);
            a2 && this._fireEvent("move", a2.originalEvent);
            for (const e2 in t2) {
              const { originalEvent: i3 } = t2[e2];
              this._fireEvent(e2, i3);
            }
            const s2 = {};
            let l2;
            for (const e2 in this._eventsInProgress) {
              const { handlerName: t3, originalEvent: o3 } = this._eventsInProgress[e2];
              this._handlersById[t3].isActive() || (delete this._eventsInProgress[e2], l2 = i2[t3] || o3, s2[`${e2}end`] = l2);
            }
            for (const e2 in s2)
              this._fireEvent(e2, s2[e2]);
            const c2 = wn(this._eventsInProgress);
            if (o2 && (r2 || a2) && !c2) {
              this._updatingCamera = true;
              const t3 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i3 = (e2) => 0 !== e2 && -this._bearingSnap < e2 && e2 < this._bearingSnap;
              t3 ? (i3(t3.bearing || this._map.getBearing()) && (t3.bearing = 0), this._map.easeTo(t3, { originalEvent: l2 })) : (this._map.fire(new e.g("moveend", { originalEvent: l2 })), i3(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = false;
            }
          }
          _fireEvent(t2, i2) {
            this._map.fire(new e.g(t2, i2 ? { originalEvent: i2 } : {}));
          }
          _requestFrame() {
            return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e2) => {
              this._frameId = void 0, this.handleEvent(new Tn("renderFrame", { timeStamp: e2 })), this._applyChanges();
            });
          }
          _triggerRenderFrame() {
            void 0 === this._frameId && (this._frameId = this._requestFrame());
          }
        }
        const In = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
        class Ln extends e.E {
          constructor(t2, i2) {
            super(), this._moving = false, this._zooming = false, this.transform = t2, this._bearingSnap = i2.bearingSnap, this._respectPrefersReducedMotion = false !== i2.respectPrefersReducedMotion, e.br(["_renderFrameCallback"], this);
          }
          getCenter() {
            return new e.aJ(this.transform.center.lng, this.transform.center.lat);
          }
          setCenter(e2, t2) {
            return this.jumpTo({ center: e2 }, t2);
          }
          panBy(t2, i2, o2) {
            return t2 = e.P.convert(t2).mult(-1), this.panTo(this.transform.center, e.Q({ offset: t2 }, i2), o2);
          }
          panTo(t2, i2, o2) {
            return this.easeTo(e.Q({ center: t2 }, i2), o2);
          }
          getZoom() {
            return this.transform.zoom;
          }
          setZoom(e2, t2) {
            return this.jumpTo({ zoom: e2 }, t2), this;
          }
          zoomTo(t2, i2, o2) {
            return this.easeTo(e.Q({ zoom: t2 }, i2), o2);
          }
          zoomIn(e2, t2) {
            return this.zoomTo(this.getZoom() + 1, e2, t2), this;
          }
          zoomOut(e2, t2) {
            return this.zoomTo(this.getZoom() - 1, e2, t2), this;
          }
          getBearing() {
            return this.transform.bearing;
          }
          setBearing(e2, t2) {
            return this.jumpTo({ bearing: e2 }, t2), this;
          }
          getPadding() {
            return this.transform.padding;
          }
          setPadding(e2, t2) {
            return this.jumpTo({ padding: e2 }, t2), this;
          }
          rotateTo(t2, i2, o2) {
            return this.easeTo(e.Q({ bearing: t2 }, i2), o2);
          }
          resetNorth(t2, i2) {
            return this.rotateTo(0, e.Q({ duration: 1e3 }, t2), i2), this;
          }
          resetNorthPitch(t2, i2) {
            return this.easeTo(e.Q({ bearing: 0, pitch: 0, duration: 1e3 }, t2), i2), this;
          }
          snapToNorth(e2, t2) {
            return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e2, t2) : this;
          }
          getPitch() {
            return this.transform.pitch;
          }
          setPitch(e2, t2) {
            return this.jumpTo({ pitch: e2 }, t2), this;
          }
          cameraForBounds(t2, i2) {
            t2 = e.aj.convert(t2);
            const o2 = i2 && i2.bearing || 0, r2 = i2 && i2.pitch || 0, a2 = t2.getNorthWest(), n2 = t2.getSouthEast();
            return this._cameraForBounds(this.transform, a2, n2, o2, r2, i2);
          }
          _extendPadding(t2) {
            const i2 = { top: 0, right: 0, bottom: 0, left: 0 };
            return null == t2 ? e.Q({}, i2, this.transform.padding) : "number" == typeof t2 ? { top: t2, bottom: t2, right: t2, left: t2 } : e.Q({}, i2, t2);
          }
          _extendCameraOptions(t2) {
            return (t2 = e.Q({ offset: [0, 0], maxZoom: this.transform.maxZoom }, t2)).padding = this._extendPadding(t2.padding), t2;
          }
          _minimumAABBFrustumDistance(e2, t2) {
            const i2 = t2.max[0] - t2.min[0], o2 = t2.max[1] - t2.min[1];
            return i2 / o2 > e2.aspect ? i2 / (2 * Math.tan(0.5 * e2.fovX) * e2.aspect) : o2 / (2 * Math.tan(0.5 * e2.fovY) * e2.aspect);
          }
          _cameraForBoundsOnGlobe(t2, i2, o2, r2, a2, n2) {
            const s2 = t2.clone(), l2 = this._extendCameraOptions(n2);
            s2.bearing = r2, s2.pitch = a2;
            const c2 = e.aJ.convert(i2), h2 = e.aJ.convert(o2), _2 = 0.5 * (c2.lat + h2.lat), u2 = 0.5 * (c2.lng + h2.lng), d2 = e.d7(_2, u2), p2 = e.$.normalize([], d2), f2 = e.$.normalize([], e.$.cross([], p2, [0, 1, 0])), m2 = e.$.cross([], f2, p2), g2 = [f2[0], f2[1], f2[2], 0, m2[0], m2[1], m2[2], 0, p2[0], p2[1], p2[2], 0, 0, 0, 0, 1], v2 = [d2, e.d7(c2.lat, c2.lng), e.d7(h2.lat, c2.lng), e.d7(h2.lat, h2.lng), e.d7(c2.lat, h2.lng), e.d7(_2, c2.lng), e.d7(_2, h2.lng), e.d7(c2.lat, u2), e.d7(h2.lat, u2)];
            let x2 = e.b8.fromPoints(v2.map((t3) => [e.$.dot(f2, t3), e.$.dot(m2, t3), e.$.dot(p2, t3)]));
            const y2 = e.$.transformMat4([], x2.center, g2);
            0 === e.$.squaredLength(y2) && e.$.set(y2, 0, 0, 1), e.$.normalize(y2, y2), e.$.scale(y2, y2, e.cF), s2.center = e.d8(y2);
            const b2 = s2.getWorldToCameraMatrix(), w2 = e.ae.invert(new Float64Array(16), b2);
            x2 = e.b8.applyTransform(x2, e.ae.multiply([], b2, g2));
            const T2 = this._extendAABB(x2, s2, l2, r2);
            if (!T2)
              return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
            x2 = T2, e.$.transformMat4(y2, y2, b2);
            const E2 = 0.5 * (x2.max[2] - x2.min[2]), C2 = this._minimumAABBFrustumDistance(s2, x2), S2 = e.$.scale([], [0, 0, 1], E2), I2 = e.$.add(S2, y2, S2), L2 = C2 + (0 === s2.pitch ? 0 : e.$.distance(y2, I2)), P2 = s2.globeCenterInViewSpace, R2 = e.$.sub([], y2, [P2[0], P2[1], P2[2]]);
            e.$.normalize(R2, R2), e.$.scale(R2, R2, L2);
            const D2 = e.$.add([], y2, R2);
            e.$.transformMat4(D2, D2, w2);
            const A2 = e.da / e.cF, M2 = e.$.length(D2), z2 = e.ay(Math.max(M2 * A2 - e.da, Number.EPSILON), 0), O2 = Math.min(s2.zoomFromMercatorZAdjusted(z2), l2.maxZoom);
            return O2 > 0.5 * (e.b3 + e.aV) ? (s2.setProjection({ name: "mercator" }), s2.zoom = O2, this._cameraForBounds(s2, i2, o2, r2, a2, n2)) : { center: s2.center, zoom: O2, bearing: r2, pitch: a2 };
          }
          _extendAABB(t2, i2, o2, r2) {
            const a2 = 0.5 * ((o2.padding.left || 0) + (o2.padding.right || 0)), n2 = 0.5 * ((o2.padding.top || 0) + (o2.padding.bottom || 0)), s2 = n2, l2 = a2, c2 = a2, h2 = n2, _2 = i2.width - (l2 + c2), u2 = i2.height - (s2 + h2), d2 = e.$.sub([], t2.max, t2.min), p2 = Math.min(_2 / d2[0], u2 / d2[1]), f2 = Math.min(i2.scaleZoom(i2.scale * p2), o2.maxZoom);
            if (isNaN(f2))
              return null;
            const m2 = i2.scale / i2.zoomScale(f2), g2 = new e.b8([t2.min[0] - l2 * m2, t2.min[1] - h2 * m2, t2.min[2]], [t2.max[0] + c2 * m2, t2.max[1] + s2 * m2, t2.max[2]]), v2 = ("number" == typeof o2.offset.x && "number" == typeof o2.offset.y ? new e.P(o2.offset.x, o2.offset.y) : e.P.convert(o2.offset)).rotate(-e.ac(r2));
            return g2.center[0] -= v2.x * m2, g2.center[1] += v2.y * m2, g2;
          }
          queryTerrainElevation(t2, i2) {
            const o2 = this.transform.elevation;
            return o2 ? (i2 = e.Q({}, { exaggerated: true }, i2), o2.getAtPoint(e._.fromLngLat(t2), null, i2.exaggerated)) : null;
          }
          _cameraForBounds(t2, i2, o2, r2, a2, n2) {
            if ("globe" === t2.projection.name)
              return this._cameraForBoundsOnGlobe(t2, i2, o2, r2, a2, n2);
            const s2 = t2.clone(), l2 = this._extendCameraOptions(n2);
            s2.bearing = r2, s2.pitch = a2;
            const c2 = e.aJ.convert(i2), h2 = e.aJ.convert(o2), _2 = new e.aJ(c2.lng, h2.lat), u2 = new e.aJ(h2.lng, c2.lat), d2 = s2.project(c2), p2 = s2.project(h2), f2 = this.queryTerrainElevation(c2), m2 = this.queryTerrainElevation(h2), g2 = this.queryTerrainElevation(_2), v2 = this.queryTerrainElevation(u2), x2 = [[d2.x, d2.y, Math.min(f2 || 0, m2 || 0, g2 || 0, v2 || 0)], [p2.x, p2.y, Math.max(f2 || 0, m2 || 0, g2 || 0, v2 || 0)]];
            let y2 = e.b8.fromPoints(x2);
            const b2 = s2.getWorldToCameraMatrix(), w2 = e.ae.invert(new Float64Array(16), b2);
            y2 = e.b8.applyTransform(y2, b2);
            const T2 = this._extendAABB(y2, s2, l2, r2);
            if (!T2)
              return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
            y2 = T2;
            const E2 = 0.5 * e.$.sub([], y2.max, y2.min)[2], C2 = this._minimumAABBFrustumDistance(s2, y2), S2 = [0, 0, 1, 0];
            e.aB.transformMat4(S2, S2, b2), e.aB.normalize(S2, S2);
            const I2 = e.$.scale([], S2, C2 + E2), L2 = e.$.add([], y2.center, I2);
            e.$.transformMat4(y2.center, y2.center, w2), e.$.transformMat4(L2, L2, w2);
            const P2 = [y2.center[0], y2.center[1], L2[2] * s2.pixelsPerMeter];
            e.$.scale(P2, P2, 1 / s2.worldSize);
            const R2 = e.d9(P2[0]), D2 = e.az(P2[1]), A2 = Math.min(s2._zoomFromMercatorZ(P2[2]), l2.maxZoom), M2 = new e.aJ(R2, D2);
            return s2.mercatorFromTransition && A2 < 0.5 * (e.b3 + e.aV) ? (s2.setProjection({ name: "globe" }), s2.zoom = A2, this._cameraForBounds(s2, i2, o2, r2, a2, n2)) : { center: M2, zoom: A2, bearing: r2, pitch: a2 };
          }
          fitBounds(e2, t2, i2) {
            const o2 = this.cameraForBounds(e2, t2);
            return this._fitInternal(o2, t2, i2);
          }
          fitScreenCoordinates(t2, i2, o2, r2, a2) {
            const n2 = e.P.convert(t2), s2 = e.P.convert(i2), l2 = new e.P(Math.min(n2.x, s2.x), Math.min(n2.y, s2.y)), c2 = new e.P(Math.max(n2.x, s2.x), Math.max(n2.y, s2.y));
            if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(n2, s2))
              return this;
            const h2 = this.transform.pointLocation3D(l2), _2 = this.transform.pointLocation3D(c2), u2 = this.transform.pointLocation3D(new e.P(l2.x, c2.y)), d2 = this.transform.pointLocation3D(new e.P(c2.x, l2.y)), p2 = [Math.min(h2.lng, _2.lng, u2.lng, d2.lng), Math.min(h2.lat, _2.lat, u2.lat, d2.lat)], f2 = [Math.max(h2.lng, _2.lng, u2.lng, d2.lng), Math.max(h2.lat, _2.lat, u2.lat, d2.lat)], m2 = r2 && r2.pitch ? r2.pitch : this.getPitch(), g2 = this._cameraForBounds(this.transform, p2, f2, o2, m2, r2);
            return this._fitInternal(g2, r2, a2);
          }
          _fitInternal(t2, i2, o2) {
            return t2 ? (i2 = e.Q(t2, i2)).linear ? this.easeTo(i2, o2) : this.flyTo(i2, o2) : this;
          }
          jumpTo(t2, i2) {
            this.stop();
            const o2 = t2.preloadOnly ? this.transform.clone() : this.transform;
            let r2 = false, a2 = false, n2 = false;
            if ("zoom" in t2 && o2.zoom !== +t2.zoom && (r2 = true, o2.zoom = +t2.zoom), void 0 !== t2.center && (o2.center = e.aJ.convert(t2.center)), "bearing" in t2 && o2.bearing !== +t2.bearing && (a2 = true, o2.bearing = +t2.bearing), "pitch" in t2 && o2.pitch !== +t2.pitch && (n2 = true, o2.pitch = +t2.pitch), null != t2.padding) {
              const e2 = "number" == typeof t2.padding ? this._extendPadding(t2.padding) : t2.padding;
              o2.isPaddingEqual(e2) || (o2.padding = e2);
            }
            return t2.preloadOnly ? (this._preloadTiles(o2), this) : (this.fire(new e.g("movestart", i2)).fire(new e.g("move", i2)), r2 && this.fire(new e.g("zoomstart", i2)).fire(new e.g("zoom", i2)).fire(new e.g("zoomend", i2)), a2 && this.fire(new e.g("rotatestart", i2)).fire(new e.g("rotate", i2)).fire(new e.g("rotateend", i2)), n2 && this.fire(new e.g("pitchstart", i2)).fire(new e.g("pitch", i2)).fire(new e.g("pitchend", i2)), this.fire(new e.g("moveend", i2)));
          }
          getFreeCameraOptions() {
            return this.transform.projection.supportsFreeCamera || e.w(In), this.transform.getFreeCameraOptions();
          }
          setFreeCameraOptions(t2, i2) {
            const o2 = this.transform;
            if (!o2.projection.supportsFreeCamera)
              return e.w(In), this;
            this.stop();
            const r2 = o2.zoom, a2 = o2.pitch, n2 = o2.bearing;
            o2.setFreeCameraOptions(t2);
            const s2 = r2 !== o2.zoom, l2 = a2 !== o2.pitch, c2 = n2 !== o2.bearing;
            return this.fire(new e.g("movestart", i2)).fire(new e.g("move", i2)), s2 && this.fire(new e.g("zoomstart", i2)).fire(new e.g("zoom", i2)).fire(new e.g("zoomend", i2)), c2 && this.fire(new e.g("rotatestart", i2)).fire(new e.g("rotate", i2)).fire(new e.g("rotateend", i2)), l2 && this.fire(new e.g("pitchstart", i2)).fire(new e.g("pitch", i2)).fire(new e.g("pitchend", i2)), this.fire(new e.g("moveend", i2)), this;
          }
          easeTo(t2, i2) {
            this._stop(false, t2.easeId), (false === (t2 = e.Q({ offset: [0, 0], duration: 500, easing: e.d5 }, t2)).animate || this._prefersReducedMotion(t2)) && (t2.duration = 0);
            const o2 = this.transform, r2 = this.getZoom(), a2 = this.getBearing(), n2 = this.getPitch(), s2 = this.getPadding(), l2 = "zoom" in t2 ? +t2.zoom : r2, c2 = "bearing" in t2 ? this._normalizeBearing(t2.bearing, a2) : a2, h2 = "pitch" in t2 ? +t2.pitch : n2, _2 = this._extendPadding(t2.padding), u2 = e.P.convert(t2.offset);
            let d2, p2, f2;
            if ("globe" === o2.projection.name) {
              const i3 = e._.fromLngLat(o2.center), r3 = u2.rotate(-o2.angle);
              i3.x += r3.x / o2.worldSize, i3.y += r3.y / o2.worldSize;
              const a3 = i3.toLngLat(), n3 = e.aJ.convert(t2.center || a3);
              this._normalizeCenter(n3), d2 = o2.centerPoint.add(r3), p2 = new e.P(i3.x, i3.y).mult(o2.worldSize), f2 = new e.P(e.ak(n3.lng), e.al(n3.lat)).mult(o2.worldSize).sub(p2);
            } else {
              d2 = o2.centerPoint.add(u2);
              const i3 = o2.pointLocation(d2), r3 = e.aJ.convert(t2.center || i3);
              this._normalizeCenter(r3), p2 = o2.project(i3), f2 = o2.project(r3).sub(p2);
            }
            const m2 = o2.zoomScale(l2 - r2);
            let g2, v2;
            t2.around && (g2 = e.aJ.convert(t2.around), v2 = o2.locationPoint(g2));
            const x2 = this._zooming || l2 !== r2, y2 = this._rotating || a2 !== c2, b2 = this._pitching || h2 !== n2, w2 = !o2.isPaddingEqual(_2), T2 = (o3) => (T3) => {
              if (x2 && (o3.zoom = e.a3(r2, l2, T3)), y2 && (o3.bearing = e.a3(a2, c2, T3)), b2 && (o3.pitch = e.a3(n2, h2, T3)), w2 && (o3.interpolatePadding(s2, _2, T3), d2 = o3.centerPoint.add(u2)), g2)
                o3.setLocationAtPoint(g2, v2);
              else {
                const e2 = o3.zoomScale(o3.zoom - r2), t3 = l2 > r2 ? Math.min(2, m2) : Math.max(0.5, m2), i3 = Math.pow(t3, 1 - T3), a3 = o3.unproject(p2.add(f2.mult(T3 * i3)).mult(e2));
                o3.setLocationAtPoint(o3.renderWorldCopies ? a3.wrap() : a3, d2);
              }
              return t2.preloadOnly || this._fireMoveEvents(i2), o3;
            };
            if (t2.preloadOnly) {
              const e2 = this._emulate(T2, t2.duration, o2);
              return this._preloadTiles(e2), this;
            }
            const E2 = { moving: this._moving, zooming: this._zooming, rotating: this._rotating, pitching: this._pitching };
            return this._zooming = x2, this._rotating = y2, this._pitching = b2, this._padding = w2, this._easeId = t2.easeId, this._prepareEase(i2, t2.noMoveStart, E2), this._ease(T2(o2), (e2) => {
              "sea" === o2.cameraElevationReference && o2.recenterOnTerrain(), this._afterEase(i2, e2);
            }, t2), this;
          }
          _prepareEase(t2, i2, o2 = {}) {
            this._moving = true, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && 0 === this.transform.pitch && "globe" !== this.transform.projection.name && (this.transform.cameraElevationReference = "ground"), i2 || o2.moving || this.fire(new e.g("movestart", t2)), this._zooming && !o2.zooming && this.fire(new e.g("zoomstart", t2)), this._rotating && !o2.rotating && this.fire(new e.g("rotatestart", t2)), this._pitching && !o2.pitching && this.fire(new e.g("pitchstart", t2));
          }
          _fireMoveEvents(t2) {
            this.fire(new e.g("move", t2)), this._zooming && this.fire(new e.g("zoom", t2)), this._rotating && this.fire(new e.g("rotate", t2)), this._pitching && this.fire(new e.g("pitch", t2));
          }
          _afterEase(t2, i2) {
            if (this._easeId && i2 && this._easeId === i2)
              return;
            this._easeId = void 0, this.transform.cameraElevationReference = "ground";
            const o2 = this._zooming, r2 = this._rotating, a2 = this._pitching;
            this._moving = false, this._zooming = false, this._rotating = false, this._pitching = false, this._padding = false, o2 && this.fire(new e.g("zoomend", t2)), r2 && this.fire(new e.g("rotateend", t2)), a2 && this.fire(new e.g("pitchend", t2)), this.fire(new e.g("moveend", t2));
          }
          flyTo(t2, i2) {
            if (this._prefersReducedMotion(t2)) {
              const o3 = e.ai(t2, ["center", "zoom", "bearing", "pitch", "around", "padding"]);
              return this.jumpTo(o3, i2);
            }
            this.stop(), t2 = e.Q({ offset: [0, 0], speed: 1.2, curve: 1.42, easing: e.d5 }, t2);
            const o2 = this.transform, r2 = this.getZoom(), a2 = this.getBearing(), n2 = this.getPitch(), s2 = this.getPadding(), l2 = "zoom" in t2 ? e.au(+t2.zoom, o2.minZoom, o2.maxZoom) : r2, c2 = "bearing" in t2 ? this._normalizeBearing(t2.bearing, a2) : a2, h2 = "pitch" in t2 ? +t2.pitch : n2, _2 = this._extendPadding(t2.padding), u2 = o2.zoomScale(l2 - r2), d2 = e.P.convert(t2.offset);
            let p2 = o2.centerPoint.add(d2);
            const f2 = o2.pointLocation(p2), m2 = e.aJ.convert(t2.center || f2);
            this._normalizeCenter(m2);
            const g2 = o2.project(f2), v2 = o2.project(m2).sub(g2);
            let x2 = t2.curve;
            const y2 = Math.max(o2.width, o2.height), b2 = y2 / u2, w2 = v2.mag();
            if ("minZoom" in t2) {
              const i3 = e.au(Math.min(t2.minZoom, r2, l2), o2.minZoom, o2.maxZoom), a3 = y2 / o2.zoomScale(i3 - r2);
              x2 = Math.sqrt(a3 / w2 * 2);
            }
            const T2 = x2 * x2;
            function E2(e2) {
              const t3 = (b2 * b2 - y2 * y2 + (e2 ? -1 : 1) * T2 * T2 * w2 * w2) / (2 * (e2 ? b2 : y2) * T2 * w2);
              return Math.log(Math.sqrt(t3 * t3 + 1) - t3);
            }
            function C2(e2) {
              return (Math.exp(e2) - Math.exp(-e2)) / 2;
            }
            function S2(e2) {
              return (Math.exp(e2) + Math.exp(-e2)) / 2;
            }
            const I2 = E2(0);
            let L2 = function(e2) {
              return S2(I2) / S2(I2 + x2 * e2);
            }, P2 = function(e2) {
              return y2 * ((S2(I2) * (C2(t3 = I2 + x2 * e2) / S2(t3)) - C2(I2)) / T2) / w2;
              var t3;
            }, R2 = (E2(1) - I2) / x2;
            if (Math.abs(w2) < 1e-6 || !isFinite(R2)) {
              if (Math.abs(y2 - b2) < 1e-6)
                return this.easeTo(t2, i2);
              const e2 = b2 < y2 ? -1 : 1;
              R2 = Math.abs(Math.log(b2 / y2)) / x2, P2 = function() {
                return 0;
              }, L2 = function(t3) {
                return Math.exp(e2 * x2 * t3);
              };
            }
            t2.duration = "duration" in t2 ? +t2.duration : 1e3 * R2 / ("screenSpeed" in t2 ? +t2.screenSpeed / x2 : +t2.speed), t2.maxDuration && t2.duration > t2.maxDuration && (t2.duration = 0);
            const D2 = a2 !== c2, A2 = h2 !== n2, M2 = !o2.isPaddingEqual(_2), z2 = (o3) => (u3) => {
              const f3 = u3 * R2, x3 = 1 / L2(f3);
              o3.zoom = 1 === u3 ? l2 : r2 + o3.scaleZoom(x3), D2 && (o3.bearing = e.a3(a2, c2, u3)), A2 && (o3.pitch = e.a3(n2, h2, u3)), M2 && (o3.interpolatePadding(s2, _2, u3), p2 = o3.centerPoint.add(d2));
              const y3 = 1 === u3 ? m2 : o3.unproject(g2.add(v2.mult(P2(f3))).mult(x3));
              return o3.setLocationAtPoint(o3.renderWorldCopies ? y3.wrap() : y3, p2), o3._updateCameraOnTerrain(), t2.preloadOnly || this._fireMoveEvents(i2), o3;
            };
            if (t2.preloadOnly) {
              const e2 = this._emulate(z2, t2.duration, o2);
              return this._preloadTiles(e2), this;
            }
            return this._zooming = true, this._rotating = D2, this._pitching = A2, this._padding = M2, this._prepareEase(i2, false), this._ease(z2(o2), () => this._afterEase(i2), t2), this;
          }
          isEasing() {
            return !!this._easeFrameId;
          }
          stop() {
            return this._stop();
          }
          _requestRenderFrame(e2) {
          }
          _cancelRenderFrame(e2) {
          }
          _stop(e2, t2) {
            if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
              const e3 = this._onEaseEnd;
              this._onEaseEnd = void 0, e3.call(this, t2);
            }
            if (!e2) {
              const e3 = this.handlers;
              e3 && e3.stop(false);
            }
            return this;
          }
          _ease(t2, i2, o2) {
            false === o2.animate || 0 === o2.duration ? (t2(1), i2()) : (this._easeStart = e.e.now(), this._easeOptions = o2, this._onEaseFrame = t2, this._onEaseEnd = i2, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
          }
          _renderFrameCallback() {
            const t2 = Math.min((e.e.now() - this._easeStart) / this._easeOptions.duration, 1), i2 = this._onEaseFrame;
            i2 && i2(this._easeOptions.easing(t2)), t2 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
          }
          _normalizeBearing(t2, i2) {
            t2 = e.av(t2, -180, 180);
            const o2 = Math.abs(t2 - i2);
            return Math.abs(t2 - 360 - i2) < o2 && (t2 -= 360), Math.abs(t2 + 360 - i2) < o2 && (t2 += 360), t2;
          }
          _normalizeCenter(e2) {
            const t2 = this.transform;
            if (t2.maxBounds)
              return;
            if ("globe" !== t2.projection.name && !t2.renderWorldCopies)
              return;
            const i2 = e2.lng - t2.center.lng;
            e2.lng += i2 > 180 ? -360 : i2 < -180 ? 360 : 0;
          }
          _prefersReducedMotion(t2) {
            return this._respectPrefersReducedMotion && e.e.prefersReducedMotion && !(t2 && t2.essential);
          }
          _emulate(e2, t2, i2) {
            const o2 = Math.ceil(15 * t2 / 1e3), r2 = [], a2 = e2(i2.clone());
            for (let e3 = 0; e3 <= o2; e3++) {
              const t3 = a2(e3 / o2);
              r2.push(t3.clone());
            }
            return r2;
          }
          _preloadTiles(e2, t2) {
          }
        }
        class Pn {
          constructor(t2 = {}) {
            this.options = t2, e.br(["_toggleAttribution", "_updateEditLink", "_updateData", "_updateCompact"], this);
          }
          getDefaultPosition() {
            return "bottom-right";
          }
          onAdd(e2) {
            const t2 = this.options && this.options.compact, i2 = e2._getUIString("AttributionControl.ToggleAttribution");
            this._map = e2, this._container = r("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = r("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._compactButton.setAttribute("aria-label", i2);
            const o2 = r("span", "mapboxgl-ctrl-icon", this._compactButton);
            return o2.setAttribute("aria-hidden", "true"), o2.setAttribute("title", i2), this._innerContainer = r("div", "mapboxgl-ctrl-attrib-inner", this._container), t2 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t2 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
          }
          onRemove() {
            this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
          }
          _toggleAttribution() {
            this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
          }
          _updateEditLink() {
            let t2 = this._editLink;
            t2 || (t2 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
            const i2 = [{ key: "owner", value: this.styleOwner }, { key: "id", value: this.styleId }, { key: "access_token", value: this._map._requestManager._customAccessToken || e.db.ACCESS_TOKEN }];
            if (t2) {
              const o2 = i2.reduce((e2, t3, o3) => (t3.value && (e2 += `${t3.key}=${t3.value}${o3 < i2.length - 1 ? "&" : ""}`), e2), "?");
              t2.href = `${e.db.FEEDBACK_URL}/${o2}#${Ra(this._map, true)}`, t2.rel = "noopener nofollow";
            }
          }
          _updateData(e2) {
            !e2 || "metadata" !== e2.sourceDataType && "visibility" !== e2.sourceDataType && "style" !== e2.dataType || (this._updateAttributions(), this._updateEditLink());
          }
          _updateAttributions() {
            if (!this._map.style)
              return;
            let e2 = [];
            if (this._map.style.stylesheet) {
              const e3 = this._map.style.stylesheet;
              this.styleOwner = e3.owner, this.styleId = e3.id;
            }
            const t2 = this._map.style._mergedSourceCaches;
            for (const i3 in t2) {
              const o2 = t2[i3];
              if (o2.used) {
                const t3 = o2.getSource();
                t3.attribution && e2.indexOf(t3.attribution) < 0 && e2.push(t3.attribution);
              }
            }
            e2.sort((e3, t3) => e3.length - t3.length), e2 = e2.filter((t3, i3) => {
              for (let o2 = i3 + 1; o2 < e2.length; o2++)
                if (e2[o2].indexOf(t3) >= 0)
                  return false;
              return true;
            }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e2 = [...this.options.customAttribution, ...e2] : e2.unshift(this.options.customAttribution));
            const i2 = e2.join(" | ");
            i2 !== this._attribHTML && (this._attribHTML = i2, e2.length ? (this._innerContainer.innerHTML = i2, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
          }
          _updateCompact() {
            this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
          }
        }
        class Rn {
          constructor() {
            e.br(["_updateLogo", "_updateCompact"], this);
          }
          onAdd(e2) {
            this._map = e2, this._container = r("div", "mapboxgl-ctrl");
            const t2 = r("a", "mapboxgl-ctrl-logo");
            return t2.target = "_blank", t2.rel = "noopener nofollow", t2.href = "https://www.mapbox.com/", t2.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t2.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t2), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
          }
          onRemove() {
            this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
          }
          getDefaultPosition() {
            return "bottom-left";
          }
          _updateLogo(e2) {
            e2 && "metadata" !== e2.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
          }
          _logoRequired() {
            if (!this._map.style)
              return true;
            const e2 = this._map.style._sourceCaches;
            if (0 === Object.entries(e2).length)
              return true;
            for (const t2 in e2) {
              const i2 = e2[t2].getSource();
              if (i2.hasOwnProperty("mapbox_logo") && !i2.mapbox_logo)
                return false;
            }
            return true;
          }
          _updateCompact() {
            const e2 = this._container.children;
            if (e2.length) {
              const t2 = e2[0];
              this._map.getCanvasContainer().offsetWidth < 250 ? t2.classList.add("mapboxgl-compact") : t2.classList.remove("mapboxgl-compact");
            }
          }
        }
        class Dn {
          constructor() {
            this._queue = [], this._id = 0, this._cleared = false, this._currentlyRunning = false;
          }
          add(e2) {
            const t2 = ++this._id;
            return this._queue.push({ callback: e2, id: t2, cancelled: false }), t2;
          }
          remove(e2) {
            const t2 = this._currentlyRunning, i2 = t2 ? this._queue.concat(t2) : this._queue;
            for (const t3 of i2)
              if (t3.id === e2)
                return void (t3.cancelled = true);
          }
          run(e2 = 0) {
            const t2 = this._currentlyRunning = this._queue;
            this._queue = [];
            for (const i2 of t2)
              if (!i2.cancelled && (i2.callback(e2), this._cleared))
                break;
            this._cleared = false, this._currentlyRunning = false;
          }
          clear() {
            this._currentlyRunning && (this._cleared = true), this._queue = [];
          }
        }
        function An(t2, i2, o2) {
          if (t2 = new e.aJ(t2.lng, t2.lat), i2) {
            const r2 = new e.aJ(t2.lng - 360, t2.lat), a2 = new e.aJ(t2.lng + 360, t2.lat), n2 = 360 * Math.ceil(Math.abs(t2.lng - o2.center.lng) / 360), s2 = o2.locationPoint(t2).distSqr(i2), l2 = i2.x < 0 || i2.y < 0 || i2.x > o2.width || i2.y > o2.height;
            o2.locationPoint(r2).distSqr(i2) < s2 && (l2 || Math.abs(r2.lng - o2.center.lng) < n2) ? t2 = r2 : o2.locationPoint(a2).distSqr(i2) < s2 && (l2 || Math.abs(a2.lng - o2.center.lng) < n2) && (t2 = a2);
          }
          for (; Math.abs(t2.lng - o2.center.lng) > 180; ) {
            const e2 = o2.locationPoint(t2);
            if (e2.x >= 0 && e2.y >= 0 && e2.x <= o2.width && e2.y <= o2.height)
              break;
            t2.lng > o2.center.lng ? t2.lng -= 360 : t2.lng += 360;
          }
          return t2;
        }
        const Mn = { center: "translate(-50%,-50%)", top: "translate(-50%,0)", "top-left": "translate(0,0)", "top-right": "translate(-100%,0)", bottom: "translate(-50%,-100%)", "bottom-left": "translate(0,-100%)", "bottom-right": "translate(-100%,-100%)", left: "translate(0,-50%)", right: "translate(-100%,-50%)" };
        class zn extends e.E {
          constructor(t2, i2) {
            if (super(), (t2 instanceof HTMLElement || i2) && (t2 = e.Q({ element: t2 }, i2)), e.br(["_update", "_onMove", "_onUp", "_addDragHandler", "_onMapClick", "_onKeyPress", "_clearFadeTimer"], this), this._anchor = t2 && t2.anchor || "center", this._color = t2 && t2.color || "#3FB1CE", this._scale = t2 && t2.scale || 1, this._draggable = t2 && t2.draggable || false, this._clickTolerance = t2 && t2.clickTolerance || 0, this._isDragging = false, this._state = "inactive", this._rotation = t2 && t2.rotation || 0, this._rotationAlignment = t2 && t2.rotationAlignment || "auto", this._pitchAlignment = t2 && t2.pitchAlignment && t2.pitchAlignment || "auto", this._updateMoving = () => this._update(true), this._occludedOpacity = t2 && t2.occludedOpacity || 0.2, t2 && t2.element)
              this._element = t2.element, this._offset = e.P.convert(t2 && t2.offset || [0, 0]);
            else {
              this._defaultMarker = true, this._element = r("div");
              const i3 = 41, o3 = 27, n3 = a("svg", { display: "block", height: i3 * this._scale + "px", width: o3 * this._scale + "px", viewBox: `0 0 ${o3} ${i3}` }, this._element), s2 = a("radialGradient", { id: "shadowGradient" }, a("defs", {}, n3));
              a("stop", { offset: "10%", "stop-opacity": 0.4 }, s2), a("stop", { offset: "100%", "stop-opacity": 0.05 }, s2), a("ellipse", { cx: 13.5, cy: 34.8, rx: 10.5, ry: 5.25, fill: "url(#shadowGradient)" }, n3), a("path", { fill: this._color, d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z" }, n3), a("path", { opacity: 0.25, d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z" }, n3), a("circle", { fill: "white", cx: 13.5, cy: 13.5, r: 5.5 }, n3), this._offset = e.P.convert(t2 && t2.offset || [0, -14]);
            }
            this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.hasAttribute("role") || this._element.setAttribute("role", "img"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e2) => {
              e2.preventDefault();
            }), this._element.addEventListener("mousedown", (e2) => {
              e2.preventDefault();
            });
            const o2 = this._element.classList;
            for (const e2 in Mn)
              o2.remove(`mapboxgl-marker-anchor-${e2}`);
            o2.add(`mapboxgl-marker-anchor-${this._anchor}`);
            const n2 = t2 && t2.className ? t2.className.trim().split(/\s+/) : [];
            o2.add(...n2), this._popup = null;
          }
          addTo(e2) {
            return e2 === this._map || (this.remove(), this._map = e2, e2.getCanvasContainer().appendChild(this._element), e2.on("move", this._updateMoving), e2.on("moveend", this._update), e2.on("remove", this._clearFadeTimer), e2._addMarker(this), this.setDraggable(this._draggable), this._update(), e2.on("click", this._onMapClick)), this;
          }
          remove() {
            const e2 = this._map;
            return e2 && (e2.off("click", this._onMapClick), e2.off("move", this._updateMoving), e2.off("moveend", this._update), e2.off("mousedown", this._addDragHandler), e2.off("touchstart", this._addDragHandler), e2.off("mouseup", this._onUp), e2.off("touchend", this._onUp), e2.off("mousemove", this._onMove), e2.off("touchmove", this._onMove), e2.off("remove", this._clearFadeTimer), e2._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
          }
          getLngLat() {
            return this._lngLat;
          }
          setLngLat(t2) {
            return this._lngLat = e.aJ.convert(t2), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(true), this;
          }
          getElement() {
            return this._element;
          }
          setPopup(e2) {
            if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e2) {
              if (!("offset" in e2.options)) {
                const t2 = 38.1, i2 = 13.5, o2 = Math.sqrt(Math.pow(i2, 2) / 2);
                e2.options.offset = this._defaultMarker ? { top: [0, 0], "top-left": [0, 0], "top-right": [0, 0], bottom: [0, -t2], "bottom-left": [o2, -1 * (t2 - i2 + o2)], "bottom-right": [-o2, -1 * (t2 - i2 + o2)], left: [i2, -1 * (t2 - i2)], right: [-i2, -1 * (t2 - i2)] } : this._offset;
              }
              this._popup = e2, e2._marker = this, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
            }
            return this;
          }
          _onKeyPress(e2) {
            const t2 = e2.code, i2 = e2.charCode || e2.keyCode;
            "Space" !== t2 && "Enter" !== t2 && 32 !== i2 && 13 !== i2 || this.togglePopup();
          }
          _onMapClick(e2) {
            const t2 = e2.originalEvent.target, i2 = this._element;
            this._popup && (t2 === i2 || i2.contains(t2)) && this.togglePopup();
          }
          getPopup() {
            return this._popup;
          }
          togglePopup() {
            const e2 = this._popup;
            return e2 ? (e2.isOpen() ? (e2.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e2.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
          }
          _behindTerrain() {
            const e2 = this._map, t2 = this._pos;
            if (!e2 || !t2)
              return false;
            const i2 = e2.unproject(t2), o2 = e2.getFreeCameraOptions();
            if (!o2.position)
              return false;
            const r2 = o2.position.toLngLat();
            return r2.distanceTo(i2) < 0.9 * r2.distanceTo(this._lngLat);
          }
          _evaluateOpacity() {
            const t2 = this._map;
            if (!t2)
              return;
            const i2 = this._pos;
            if (!i2 || i2.x < 0 || i2.x > t2.transform.width || i2.y < 0 || i2.y > t2.transform.height)
              return void this._clearFadeTimer();
            const o2 = t2.unproject(i2);
            let r2;
            t2._showingGlobe() && e.dc(t2.transform, this._lngLat) ? r2 = 0 : (r2 = 1 - t2._queryFogOpacity(o2), t2.transform._terrainEnabled() && t2.getTerrain() && this._behindTerrain() && (r2 *= this._occludedOpacity)), this._element.style.opacity = `${r2}`, this._element.style.pointerEvents = r2 > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(r2), this._fadeTimer = null;
          }
          _clearFadeTimer() {
            this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
          }
          _updateDOM() {
            const e2 = this._pos;
            if (!e2 || !this._map)
              return;
            const t2 = this._offset.mult(this._scale);
            this._element.style.transform = `
            translate(${e2.x}px,${e2.y}px)
            ${Mn[this._anchor]}
            ${this._calculateXYTransform()} ${this._calculateZTransform()}
            translate(${t2.x}px,${t2.y}px)
        `;
          }
          _calculateXYTransform() {
            const t2 = this._pos, i2 = this._map, o2 = this.getPitchAlignment();
            if (!i2 || !t2 || "map" !== o2)
              return "";
            if (!i2._showingGlobe()) {
              const e2 = i2.getPitch();
              return e2 ? `rotateX(${e2}deg)` : "";
            }
            const r2 = e.b1(e.dd(i2.transform, this._lngLat)), a2 = t2.sub(e.de(i2.transform)), n2 = Math.abs(a2.x) + Math.abs(a2.y);
            if (0 === n2)
              return "";
            const s2 = r2 / n2;
            return `rotateX(${-a2.y * s2}deg) rotateY(${a2.x * s2}deg)`;
          }
          _calculateZTransform() {
            const t2 = this._pos, i2 = this._map;
            if (!i2 || !t2)
              return "";
            let o2 = 0;
            const r2 = this.getRotationAlignment();
            if ("map" === r2)
              if (i2._showingGlobe()) {
                const t3 = i2.project(new e.aJ(this._lngLat.lng, this._lngLat.lat + 1e-3)), r3 = i2.project(new e.aJ(this._lngLat.lng, this._lngLat.lat - 1e-3)).sub(t3);
                o2 = e.b1(Math.atan2(r3.y, r3.x)) - 90;
              } else
                o2 = -i2.getBearing();
            else if ("horizon" === r2) {
              const r3 = e.a0(4, 6, i2.getZoom()), a2 = e.de(i2.transform);
              a2.y += r3 * i2.transform.height;
              const n2 = t2.sub(a2), s2 = e.b1(Math.atan2(n2.y, n2.x));
              o2 = (s2 > 90 ? s2 - 270 : s2 + 90) * (1 - r3);
            }
            return o2 += this._rotation, o2 ? `rotateZ(${o2}deg)` : "";
          }
          _update(e2) {
            cancelAnimationFrame(this._updateFrameId);
            const t2 = this._map;
            t2 && (t2.transform.renderWorldCopies && (this._lngLat = An(this._lngLat, this._pos, t2.transform)), this._pos = t2.project(this._lngLat), true === e2 ? this._updateFrameId = requestAnimationFrame(() => {
              this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
            }) : this._pos = this._pos.round(), t2._requestDomTask(() => {
              this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (t2._showingGlobe() || t2.getTerrain() || t2.getFog()) && !this._fadeTimer && (this._fadeTimer = window.setTimeout(this._evaluateOpacity.bind(this), 60)));
            }));
          }
          getOffset() {
            return this._offset;
          }
          setOffset(t2) {
            return this._offset = e.P.convert(t2), this._update(), this;
          }
          addClassName(e2) {
            return this._element.classList.add(e2), this;
          }
          removeClassName(e2) {
            return this._element.classList.remove(e2), this;
          }
          toggleClassName(e2) {
            return this._element.classList.toggle(e2);
          }
          _onMove(t2) {
            const i2 = this._map;
            if (!i2)
              return;
            const o2 = this._pointerdownPos, r2 = this._positionDelta;
            if (o2 && r2) {
              if (!this._isDragging) {
                const e2 = this._clickTolerance || i2._clickTolerance;
                if (t2.point.dist(o2) < e2)
                  return;
                this._isDragging = true;
              }
              this._pos = t2.point.sub(r2), this._lngLat = i2.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e.g("dragstart"))), this.fire(new e.g("drag"));
            }
          }
          _onUp() {
            this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = false;
            const t2 = this._map;
            t2 && (t2.off("mousemove", this._onMove), t2.off("touchmove", this._onMove)), "active" === this._state && this.fire(new e.g("dragend")), this._state = "inactive";
          }
          _addDragHandler(e2) {
            const t2 = this._map, i2 = this._pos;
            t2 && i2 && this._element.contains(e2.originalEvent.target) && (e2.preventDefault(), this._positionDelta = e2.point.sub(i2), this._pointerdownPos = e2.point, this._state = "pending", t2.on("mousemove", this._onMove), t2.on("touchmove", this._onMove), t2.once("mouseup", this._onUp), t2.once("touchend", this._onUp));
          }
          setDraggable(e2) {
            this._draggable = !!e2;
            const t2 = this._map;
            return t2 && (e2 ? (t2.on("mousedown", this._addDragHandler), t2.on("touchstart", this._addDragHandler)) : (t2.off("mousedown", this._addDragHandler), t2.off("touchstart", this._addDragHandler))), this;
          }
          isDraggable() {
            return this._draggable;
          }
          setRotation(e2) {
            return this._rotation = e2 || 0, this._update(), this;
          }
          getRotation() {
            return this._rotation;
          }
          setRotationAlignment(e2) {
            return this._rotationAlignment = e2 || "auto", this._update(), this;
          }
          getRotationAlignment() {
            return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
          }
          setPitchAlignment(e2) {
            return this._pitchAlignment = e2 || "auto", this._update(), this;
          }
          getPitchAlignment() {
            return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
          }
          setOccludedOpacity(e2) {
            return this._occludedOpacity = e2 || 0.2, this._update(), this;
          }
          getOccludedOpacity() {
            return this._occludedOpacity;
          }
        }
        const On = { closeButton: true, closeOnClick: true, focusAfterOpen: true, className: "", maxWidth: "240px" }, Fn = ["a[href]", "[tabindex]:not([tabindex='-1'])", "[contenteditable]:not([contenteditable='false'])", "button:not([disabled])", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].join(", ");
        function Bn(t2 = new e.P(0, 0), i2 = "bottom") {
          if ("number" == typeof t2) {
            const o2 = Math.round(Math.sqrt(0.5 * Math.pow(t2, 2)));
            switch (i2) {
              case "top":
                return new e.P(0, t2);
              case "top-left":
                return new e.P(o2, o2);
              case "top-right":
                return new e.P(-o2, o2);
              case "bottom":
                return new e.P(0, -t2);
              case "bottom-left":
                return new e.P(o2, -o2);
              case "bottom-right":
                return new e.P(-o2, -o2);
              case "left":
                return new e.P(t2, 0);
              case "right":
                return new e.P(-t2, 0);
            }
            return new e.P(0, 0);
          }
          return t2 instanceof e.P || Array.isArray(t2) ? e.P.convert(t2) : e.P.convert(t2[i2] || [0, 0]);
        }
        class kn {
          constructor(e2) {
            this.jumpTo(e2);
          }
          getValue(t2) {
            if (t2 <= this._startTime)
              return this._start;
            if (t2 >= this._endTime)
              return this._end;
            const i2 = e.bb((t2 - this._startTime) / (this._endTime - this._startTime));
            return this._start * (1 - i2) + this._end * i2;
          }
          isEasing(e2) {
            return e2 >= this._startTime && e2 <= this._endTime;
          }
          jumpTo(e2) {
            this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e2, this._end = e2;
          }
          easeTo(e2, t2, i2) {
            this._start = this.getValue(t2), this._end = e2, this._startTime = t2, this._endTime = t2 + i2;
          }
        }
        const Nn = { "AttributionControl.ToggleAttribution": "Toggle attribution", "FullscreenControl.Enter": "Enter fullscreen", "FullscreenControl.Exit": "Exit fullscreen", "GeolocateControl.FindMyLocation": "Find my location", "GeolocateControl.LocationNotAvailable": "Location not available", "LogoControl.Title": "Mapbox homepage", "Map.Title": "Map", "NavigationControl.ResetBearing": "Reset bearing to north", "NavigationControl.ZoomIn": "Zoom in", "NavigationControl.ZoomOut": "Zoom out", "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map", "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map", "TouchPanBlocker.Message": "Use two fingers to move the map" };
        class Un {
          registerParameter() {
          }
          registerButton() {
          }
          registerBinding() {
          }
          refreshUI() {
          }
        }
        const Gn = { center: [0, 0], zoom: 0, bearing: 0, pitch: 0, minZoom: -2, maxZoom: 22, minPitch: 0, maxPitch: 85, interactive: true, scrollZoom: true, boxZoom: true, dragRotate: true, dragPan: true, keyboard: true, doubleClickZoom: true, touchZoomRotate: true, touchPitch: true, cooperativeGestures: false, performanceMetricsCollection: true, bearingSnap: 7, clickTolerance: 3, pitchWithRotate: true, hash: false, attributionControl: true, antialias: false, failIfMajorPerformanceCaveat: false, preserveDrawingBuffer: false, trackResize: true, renderWorldCopies: true, refreshExpiredTiles: true, minTileCacheSize: null, maxTileCacheSize: null, localIdeographFontFamily: "sans-serif", localFontFamily: null, transformRequest: null, accessToken: null, fadeDuration: 300, respectPrefersReducedMotion: true, crossSourceCollisions: true, collectResourceTiming: false, testMode: false, precompilePrograms: true }, jn = { showCompass: true, showZoom: true, visualizePitch: false };
        class Vn {
          constructor(t2, i2, o2 = false) {
            this._clickTolerance = 10, this.element = i2, this.mouseRotate = new Ja({ clickTolerance: t2.dragRotate._mouseRotate._clickTolerance }), this.map = t2, o2 && (this.mousePitch = new Ka({ clickTolerance: t2.dragRotate._mousePitch._clickTolerance })), e.br(["mousedown", "mousemove", "mouseup", "touchstart", "touchmove", "touchend", "reset"], this), i2.addEventListener("mousedown", this.mousedown), i2.addEventListener("touchstart", this.touchstart, { passive: false }), i2.addEventListener("touchmove", this.touchmove), i2.addEventListener("touchend", this.touchend), i2.addEventListener("touchcancel", this.reset);
          }
          down(e2, t2) {
            this.mouseRotate.mousedown(e2, t2), this.mousePitch && this.mousePitch.mousedown(e2, t2), c();
          }
          move(e2, t2) {
            const i2 = this.map, o2 = this.mouseRotate.mousemoveWindow(e2, t2), r2 = o2 && o2.bearingDelta;
            if (r2 && i2.setBearing(i2.getBearing() + r2), this.mousePitch) {
              const o3 = this.mousePitch.mousemoveWindow(e2, t2), r3 = o3 && o3.pitchDelta;
              r3 && i2.setPitch(i2.getPitch() + r3);
            }
          }
          off() {
            const e2 = this.element;
            e2.removeEventListener("mousedown", this.mousedown), e2.removeEventListener("touchstart", this.touchstart, { passive: false }), e2.removeEventListener("touchmove", this.touchmove), e2.removeEventListener("touchend", this.touchend), e2.removeEventListener("touchcancel", this.reset), this.offTemp();
          }
          offTemp() {
            h(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup);
          }
          mousedown(t2) {
            this.down(e.Q({}, t2, { ctrlKey: true, preventDefault: () => t2.preventDefault() }), d(this.element, t2)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
          }
          mousemove(e2) {
            this.move(e2, d(this.element, e2));
          }
          mouseup(e2) {
            this.mouseRotate.mouseupWindow(e2), this.mousePitch && this.mousePitch.mouseupWindow(e2), this.offTemp();
          }
          touchstart(e2) {
            1 !== e2.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = p(this.element, e2.targetTouches)[0], this.down({ type: "mousedown", button: 0, ctrlKey: true, preventDefault: () => e2.preventDefault() }, this._startPos));
          }
          touchmove(e2) {
            1 !== e2.targetTouches.length ? this.reset() : (this._lastPos = p(this.element, e2.targetTouches)[0], this.move({ preventDefault: () => e2.preventDefault() }, this._lastPos));
          }
          touchend(e2) {
            0 === e2.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
          }
          reset() {
            this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
          }
        }
        const $n = { positionOptions: { enableHighAccuracy: false, maximumAge: 0, timeout: 6e3 }, fitBoundsOptions: { maxZoom: 15 }, trackUserLocation: false, showAccuracyCircle: true, showUserLocation: true, showUserHeading: false }, Zn = { maxWidth: 100, unit: "metric" }, Wn = { kilometer: "km", meter: "m", mile: "mi", foot: "ft", "nautical-mile": "nm" }, Hn = { version: e.dw, supported: t, setRTLTextPlugin: e.dy, getRTLTextPluginStatus: e.dz, Map: class extends Ln {
          constructor(t2) {
            e.df.mark(e.dg.create);
            const i2 = t2;
            if (null != (t2 = e.Q({}, Gn, t2)).minZoom && null != t2.maxZoom && t2.minZoom > t2.maxZoom)
              throw new Error("maxZoom must be greater than or equal to minZoom");
            if (null != t2.minPitch && null != t2.maxPitch && t2.minPitch > t2.maxPitch)
              throw new Error("maxPitch must be greater than or equal to minPitch");
            if (null != t2.minPitch && t2.minPitch < 0)
              throw new Error("minPitch must be greater than or equal to 0");
            if (null != t2.maxPitch && t2.maxPitch > 85)
              throw new Error("maxPitch must be less than or equal to 85");
            if (t2.antialias && e.dh(window) && (t2.antialias = false, e.w("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), super(new hi(t2.minZoom, t2.maxZoom, t2.minPitch, t2.maxPitch, t2.renderWorldCopies), t2), this._repaint = !!t2.repaint, this._interactive = t2.interactive, this._minTileCacheSize = t2.minTileCacheSize, this._maxTileCacheSize = t2.maxTileCacheSize, this._failIfMajorPerformanceCaveat = t2.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = t2.preserveDrawingBuffer, this._antialias = t2.antialias, this._trackResize = t2.trackResize, this._bearingSnap = t2.bearingSnap, this._refreshExpiredTiles = t2.refreshExpiredTiles, this._fadeDuration = t2.fadeDuration, this._isInitialLoad = true, this._crossSourceCollisions = t2.crossSourceCollisions, this._collectResourceTiming = t2.collectResourceTiming, this._language = this._parseLanguage(t2.language), this._worldview = t2.worldview, this._renderTaskQueue = new Dn(), this._domRenderTaskQueue = new Dn(), this._controls = [], this._markers = [], this._popups = [], this._mapId = e.di(), this._locale = e.Q({}, Nn, t2.locale), this._clickTolerance = t2.clickTolerance, this._cooperativeGestures = t2.cooperativeGestures, this._performanceMetricsCollection = t2.performanceMetricsCollection, this._tessellationStep = t2.tessellationStep, this._containerWidth = 0, this._containerHeight = 0, this._showParseStatus = true, this._precompilePrograms = t2.precompilePrograms, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new kn(0), this._interactionRange = [1 / 0, -1 / 0], this._visibilityHidden = 0, this._useExplicitProjection = false, this._frameId = 0, this._requestManager = new e.dj(t2.transformRequest, t2.accessToken, t2.testMode), this._silenceAuthErrors = !!t2.testMode, this._contextCreateOptions = t2.contextCreateOptions ? __spreadValues({}, t2.contextCreateOptions) : {}, "string" == typeof t2.container) {
              const e2 = document.getElementById(t2.container);
              if (!e2)
                throw new Error(`Container '${t2.container.toString()}' not found.`);
              this._container = e2;
            } else {
              if (!(t2.container instanceof HTMLElement))
                throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
              this._container = t2.container;
            }
            if (this._container.childNodes.length > 0 && e.w("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t2.maxBounds && this.setMaxBounds(t2.maxBounds), e.br(["_onWindowOnline", "_onWindowResize", "_onVisibilityChange", "_onMapScroll", "_contextLost", "_contextRestored"], this), this._setupContainer(), this._tp || (this._tp = new Un()), this._tp.registerParameter(this, ["Debug"], "showOverdrawInspector"), this._tp.registerParameter(this, ["Debug"], "showTileBoundaries"), this._tp.registerParameter(this, ["Debug"], "showParseStatus"), this._tp.registerParameter(this, ["Debug"], "repaint"), this._tp.registerParameter(this, ["Debug"], "showTileAABBs"), this._tp.registerParameter(this, ["Debug"], "showPadding"), this._tp.registerParameter(this, ["Debug"], "showCollisionBoxes", { noSave: true }), this._tp.registerParameter(this.transform, ["Debug"], "freezeTileCoverage", { noSave: true }, () => {
              this._update();
            }), this._tp.registerParameter(this, ["Debug", "Wireframe"], "showTerrainWireframe"), this._tp.registerParameter(this, ["Debug", "Wireframe"], "showLayers2DWireframe"), this._tp.registerParameter(this, ["Debug", "Wireframe"], "showLayers3DWireframe"), this._setupPainter(), void 0 === this.painter)
              throw new Error("Failed to initialize WebGL.");
            if (this.on("move", () => this._update(false)), this.on("moveend", () => this._update(false)), this.on("zoom", () => this._update(true)), this._fullscreenchangeEvent = "onfullscreenchange" in document ? "fullscreenchange" : "webkitfullscreenchange", window.addEventListener("online", this._onWindowOnline, false), window.addEventListener("resize", this._onWindowResize, false), window.addEventListener("orientationchange", this._onWindowResize, false), window.addEventListener(this._fullscreenchangeEvent, this._onWindowResize, false), window.addEventListener("visibilitychange", this._onVisibilityChange, false), this.handlers = new Sn(this, t2), this._localFontFamily = t2.localFontFamily, this._localIdeographFontFamily = t2.localIdeographFontFamily, (t2.style || !t2.testMode) && this.setStyle(t2.style || e.db.DEFAULT_STYLE, { config: t2.config, localFontFamily: this._localFontFamily, localIdeographFontFamily: this._localIdeographFontFamily }), t2.projection && this.setProjection(t2.projection), t2.hash && (this._hash = new Pa("string" == typeof t2.hash && t2.hash || void 0).addTo(this)), !this._hash || !this._hash._onHashChange()) {
              null == i2.center && null == i2.zoom || (this.transform._unmodified = false), this.jumpTo({ center: t2.center, zoom: t2.zoom, bearing: t2.bearing, pitch: t2.pitch });
              const o2 = t2.bounds;
              o2 && (this.resize(), this.fitBounds(o2, e.Q({}, t2.fitBoundsOptions, { duration: 0 })));
            }
            this.resize(), t2.attributionControl && this.addControl(new Pn({ customAttribution: t2.customAttribution })), this._logoControl = new Rn(), this.addControl(this._logoControl, t2.logoPosition), this.on("style.load", () => {
              this.transform.unmodified && this.jumpTo(this.style.stylesheet), this._postStyleLoadEvent();
            }), this.on("data", (t3) => {
              this._update("style" === t3.dataType), this.fire(new e.g(`${t3.dataType}data`, t3));
            }), this.on("dataloading", (t3) => {
              this.fire(new e.g(`${t3.dataType}dataloading`, t3));
            });
          }
          _getMapId() {
            return this._mapId;
          }
          addControl(t2, i2) {
            if (void 0 === i2 && (i2 = t2.getDefaultPosition ? t2.getDefaultPosition() : "top-right"), !t2 || !t2.onAdd)
              return this.fire(new e.f(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
            const o2 = t2.onAdd(this);
            this._controls.push(t2);
            const r2 = this._controlPositions[i2];
            return -1 !== i2.indexOf("bottom") ? r2.insertBefore(o2, r2.firstChild) : r2.appendChild(o2), this;
          }
          removeControl(t2) {
            if (!t2 || !t2.onRemove)
              return this.fire(new e.f(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
            const i2 = this._controls.indexOf(t2);
            return i2 > -1 && this._controls.splice(i2, 1), t2.onRemove(this), this;
          }
          hasControl(e2) {
            return this._controls.indexOf(e2) > -1;
          }
          getContainer() {
            return this._container;
          }
          getCanvasContainer() {
            return this._canvasContainer;
          }
          getCanvas() {
            return this._canvas;
          }
          resize(t2) {
            if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height)
              return this;
            this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
            const i2 = !this._moving;
            return i2 && this.fire(new e.g("movestart", t2)).fire(new e.g("move", t2)), this.fire(new e.g("resize", t2)), i2 && this.fire(new e.g("moveend", t2)), this;
          }
          getBounds() {
            return this.transform.getBounds();
          }
          getMaxBounds() {
            return this.transform.getMaxBounds() || null;
          }
          setMaxBounds(t2) {
            return this.transform.setMaxBounds(e.aj.convert(t2)), this._update();
          }
          setMinZoom(t2) {
            if ((t2 = t2 != null ? t2 : -2) >= -2 && t2 <= this.transform.maxZoom)
              return this.transform.minZoom = t2, this._update(), this.getZoom() < t2 ? this.setZoom(t2) : this.fire(new e.g("zoomstart")).fire(new e.g("zoom")).fire(new e.g("zoomend")), this;
            throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
          }
          getMinZoom() {
            return this.transform.minZoom;
          }
          setMaxZoom(t2) {
            if ((t2 = t2 != null ? t2 : 22) >= this.transform.minZoom)
              return this.transform.maxZoom = t2, this._update(), this.getZoom() > t2 ? this.setZoom(t2) : this.fire(new e.g("zoomstart")).fire(new e.g("zoom")).fire(new e.g("zoomend")), this;
            throw new Error("maxZoom must be greater than the current minZoom");
          }
          getMaxZoom() {
            return this.transform.maxZoom;
          }
          setMinPitch(t2) {
            if ((t2 = t2 != null ? t2 : 0) < 0)
              throw new Error("minPitch must be greater than or equal to 0");
            if (t2 >= 0 && t2 <= this.transform.maxPitch)
              return this.transform.minPitch = t2, this._update(), this.getPitch() < t2 ? this.setPitch(t2) : this.fire(new e.g("pitchstart")).fire(new e.g("pitch")).fire(new e.g("pitchend")), this;
            throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
          }
          getMinPitch() {
            return this.transform.minPitch;
          }
          setMaxPitch(t2) {
            if ((t2 = t2 != null ? t2 : 85) > 85)
              throw new Error("maxPitch must be less than or equal to 85");
            if (t2 >= this.transform.minPitch)
              return this.transform.maxPitch = t2, this._update(), this.getPitch() > t2 ? this.setPitch(t2) : this.fire(new e.g("pitchstart")).fire(new e.g("pitch")).fire(new e.g("pitchend")), this;
            throw new Error("maxPitch must be greater than or equal to minPitch");
          }
          getMaxPitch() {
            return this.transform.maxPitch;
          }
          getRenderWorldCopies() {
            return this.transform.renderWorldCopies;
          }
          setRenderWorldCopies(e2) {
            return this.transform.renderWorldCopies = e2, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(true), this._update();
          }
          getLanguage() {
            return this._language;
          }
          _parseLanguage(e2) {
            return "auto" === e2 ? navigator.language : Array.isArray(e2) ? 0 === e2.length ? void 0 : e2.map((e3) => "auto" === e3 ? navigator.language : e3) : e2;
          }
          setLanguage(e2) {
            const t2 = this._parseLanguage(e2);
            if (!this.style || t2 === this._language)
              return this;
            this._language = t2, this.style.reloadSources();
            for (const e3 of this._controls)
              e3._setLanguage && e3._setLanguage(this._language);
            return this;
          }
          getWorldview() {
            return this._worldview;
          }
          setWorldview(e2) {
            return this.style && e2 !== this._worldview ? (this._worldview = e2, this.style.reloadSources(), this) : this;
          }
          getProjection() {
            return this.transform.mercatorFromTransition ? { name: "globe", center: [0, 0] } : this.transform.getProjection();
          }
          _showingGlobe() {
            return "globe" === this.transform.projection.name;
          }
          setProjection(e2) {
            return this._lazyInitEmptyStyle(), e2 ? "string" == typeof e2 && (e2 = { name: e2 }) : e2 = null, this._useExplicitProjection = !!e2, this._prioritizeAndUpdateProjection(e2, this.style.projection);
          }
          _updateProjectionTransition() {
            if ("globe" !== this.getProjection().name)
              return;
            const t2 = this.transform, i2 = t2.projection.name;
            let o2;
            "globe" === i2 && t2.zoom >= e.aV ? (t2.setMercatorFromTransition(), o2 = true) : "mercator" === i2 && t2.zoom < e.aV && (t2.setProjection({ name: "globe" }), o2 = true), o2 && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate());
          }
          _prioritizeAndUpdateProjection(e2, t2) {
            return this._updateProjection(e2 || t2 || { name: "mercator" });
          }
          _updateProjection(t2) {
            let i2;
            return i2 = "globe" === t2.name && this.transform.zoom >= e.aV ? this.transform.setMercatorFromTransition() : this.transform.setProjection(t2), this.style.applyProjectionUpdate(), i2 && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(true), this._forceMarkerAndPopupUpdate(true)), this;
          }
          project(t2) {
            return this.transform.locationPoint3D(e.aJ.convert(t2));
          }
          unproject(t2) {
            return this.transform.pointLocation3D(e.P.convert(t2));
          }
          isMoving() {
            return this._moving || this.handlers && this.handlers.isMoving() || false;
          }
          isZooming() {
            return this._zooming || this.handlers && this.handlers.isZooming() || false;
          }
          isRotating() {
            return this._rotating || this.handlers && this.handlers.isRotating() || false;
          }
          _isDragging() {
            return this.handlers && this.handlers._isDragging() || false;
          }
          _createDelegatedListener(e2, t2, i2) {
            if ("mouseenter" === e2 || "mouseover" === e2) {
              let o2 = false;
              const r2 = (r3) => {
                const a3 = t2.filter((e3) => this.getLayer(e3)), n2 = a3.length ? this.queryRenderedFeatures(r3.point, { layers: a3 }) : [];
                n2.length ? o2 || (o2 = true, i2.call(this, new Na(e2, this, r3.originalEvent, { features: n2 }))) : o2 = false;
              }, a2 = () => {
                o2 = false;
              };
              return { layers: new Set(t2), listener: i2, delegates: { mousemove: r2, mouseout: a2 } };
            }
            if ("mouseleave" === e2 || "mouseout" === e2) {
              let o2 = false;
              const r2 = (r3) => {
                const a3 = t2.filter((e3) => this.getLayer(e3));
                (a3.length ? this.queryRenderedFeatures(r3.point, { layers: a3 }) : []).length ? o2 = true : o2 && (o2 = false, i2.call(this, new Na(e2, this, r3.originalEvent)));
              }, a2 = (t3) => {
                o2 && (o2 = false, i2.call(this, new Na(e2, this, t3.originalEvent)));
              };
              return { layers: new Set(t2), listener: i2, delegates: { mousemove: r2, mouseout: a2 } };
            }
            {
              const o2 = (e3) => {
                const o3 = t2.filter((e4) => this.getLayer(e4)), r2 = o3.length ? this.queryRenderedFeatures(e3.point, { layers: o3 }) : [];
                r2.length && (e3.features = r2, i2.call(this, e3), delete e3.features);
              };
              return { layers: new Set(t2), listener: i2, delegates: { [e2]: o2 } };
            }
          }
          on(e2, t2, i2) {
            if ("function" == typeof t2 || void 0 === i2)
              return super.on(e2, t2);
            if (Array.isArray(t2) || (t2 = [t2]), t2) {
              for (const e3 of t2)
                if (!this._isValidId(e3))
                  return this;
            }
            const o2 = this._createDelegatedListener(e2, t2, i2);
            this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e2] = this._delegatedListeners[e2] || [], this._delegatedListeners[e2].push(o2);
            for (const e3 in o2.delegates)
              this.on(e3, o2.delegates[e3]);
            return this;
          }
          once(e2, t2, i2) {
            if ("function" == typeof t2 || void 0 === i2)
              return super.once(e2, t2);
            if (Array.isArray(t2) || (t2 = [t2]), t2) {
              for (const e3 of t2)
                if (!this._isValidId(e3))
                  return this;
            }
            const o2 = this._createDelegatedListener(e2, t2, i2);
            for (const e3 in o2.delegates)
              this.once(e3, o2.delegates[e3]);
            return this;
          }
          off(e2, t2, i2) {
            if ("function" == typeof t2 || void 0 === i2)
              return super.off(e2, t2);
            const o2 = new Set(Array.isArray(t2) ? t2 : [t2]);
            for (const e3 of o2)
              if (!this._isValidId(e3))
                return this;
            const r2 = (e3, t3) => {
              if (e3.size !== t3.size)
                return false;
              for (const i3 of e3)
                if (!t3.has(i3))
                  return false;
              return true;
            }, a2 = this._delegatedListeners ? this._delegatedListeners[e2] : void 0;
            return a2 && ((e3) => {
              for (let t3 = 0; t3 < e3.length; t3++) {
                const a3 = e3[t3];
                if (a3.listener === i2 && r2(a3.layers, o2)) {
                  for (const e4 in a3.delegates)
                    this.off(e4, a3.delegates[e4]);
                  return e3.splice(t3, 1), this;
                }
              }
            })(a2), this;
          }
          queryRenderedFeatures(t2, i2) {
            if (!this.style)
              return [];
            if (void 0 !== i2 || void 0 === t2 || t2 instanceof e.P || Array.isArray(t2) || (i2 = t2, t2 = void 0), t2 = t2 || [[0, 0], [this.transform.width, this.transform.height]], (i2 = i2 || {}).layers && Array.isArray(i2.layers)) {
              for (const e2 of i2.layers)
                if (!this._isValidId(e2))
                  return [];
            }
            return this.style.queryRenderedFeatures(t2, i2, this.transform);
          }
          querySourceFeatures(e2, t2) {
            return this._isValidId(e2) ? this.style.querySourceFeatures(e2, t2) : [];
          }
          isPointOnSurface(t2) {
            const { name: i2 } = this.transform.projection;
            return "globe" !== i2 && "mercator" !== i2 && e.w(`${i2} projection does not support isPointOnSurface, this API may behave unexpectedly.`), this.transform.isPointOnSurface(e.P.convert(t2));
          }
          setStyle(t2, i2) {
            return i2 = e.Q({}, { localIdeographFontFamily: this._localIdeographFontFamily, localFontFamily: this._localFontFamily }, i2), this.style && t2 && false !== i2.diff && i2.localFontFamily === this._localFontFamily && i2.localIdeographFontFamily === this._localIdeographFontFamily && !i2.config ? (this.style._diffStyle(t2, (o2, r2) => {
              o2 ? (e.w(`Unable to perform style diff: ${String(o2.message || o2.error || o2)}. Rebuilding the style from scratch.`), this._updateStyle(t2, i2)) : r2 && this._update(true);
            }, () => {
              this._postStyleLoadEvent();
            }), this) : (this._localIdeographFontFamily = i2.localIdeographFontFamily, this._localFontFamily = i2.localFontFamily, this._updateStyle(t2, i2));
          }
          _getUIString(e2) {
            const t2 = this._locale[e2];
            if (null == t2)
              throw new Error(`Missing UI string '${e2}'`);
            return t2;
          }
          _updateStyle(t2, i2) {
            if (this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), t2) {
              const o2 = e.Q({}, i2);
              i2 && i2.config && (o2.initialConfig = i2.config, delete o2.config), this.style = new Ia(this, o2).load(t2), this.style.setEventedParent(this, { style: this.style });
            }
            return this._updateTerrain(), this;
          }
          _lazyInitEmptyStyle() {
            this.style || (this.style = new Ia(this, {}), this.style.setEventedParent(this, { style: this.style }), this.style.loadEmpty());
          }
          getStyle() {
            if (this.style)
              return this.style.serialize();
          }
          isStyleLoaded() {
            return this.style ? this.style.loaded() : (e.w("There is no style added to the map."), false);
          }
          _isValidId(t2) {
            return null == t2 ? (this.fire(new e.f(new Error("IDs can't be empty."))), false) : !e.cY(t2) || (this.fire(new e.f(new Error(`IDs can't contain special symbols: "${t2}".`))), false);
          }
          addSource(e2, t2) {
            return this._isValidId(e2) ? (this._lazyInitEmptyStyle(), this.style.addSource(e2, t2), this._update(true)) : this;
          }
          isSourceLoaded(e2) {
            return !!this._isValidId(e2) && !!this.style && this.style._isSourceCacheLoaded(e2);
          }
          areTilesLoaded() {
            return this.style.areTilesLoaded();
          }
          addSourceType(e2, t2, i2) {
            this._lazyInitEmptyStyle(), this.style.addSourceType(e2, t2, i2);
          }
          removeSource(e2) {
            return this._isValidId(e2) ? (this.style.removeSource(e2), this._updateTerrain(), this._update(true)) : this;
          }
          getSource(e2) {
            return this._isValidId(e2) ? this.style.getOwnSource(e2) : null;
          }
          addImage(t2, i2, { pixelRatio: o2 = 1, sdf: r2 = false, stretchX: a2, stretchY: n2, content: s2 } = {}) {
            if (this._lazyInitEmptyStyle(), i2 instanceof HTMLImageElement || ImageBitmap && i2 instanceof ImageBitmap) {
              const { width: l2, height: c2, data: h2 } = e.e.getImageData(i2);
              this.style.addImage(t2, { data: new e.j({ width: l2, height: c2 }, h2), pixelRatio: o2, stretchX: a2, stretchY: n2, content: s2, sdf: r2, version: 0 });
            } else if (void 0 === i2.width || void 0 === i2.height)
              this.fire(new e.f(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
            else {
              const { width: l2, height: c2 } = i2, h2 = i2;
              this.style.addImage(t2, { data: new e.j({ width: l2, height: c2 }, new Uint8Array(h2.data)), pixelRatio: o2, stretchX: a2, stretchY: n2, content: s2, sdf: r2, version: 0, userImage: h2 }), h2.onAdd && h2.onAdd(this, t2);
            }
          }
          updateImage(t2, i2) {
            this._lazyInitEmptyStyle();
            const o2 = this.style.getImage(t2);
            if (!o2)
              return void this.fire(new e.f(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
            const r2 = i2 instanceof HTMLImageElement || ImageBitmap && i2 instanceof ImageBitmap ? e.e.getImageData(i2) : i2, { width: a2, height: n2, data: s2 } = r2;
            if (void 0 === a2 || void 0 === n2)
              return void this.fire(new e.f(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
            if (a2 !== o2.data.width || n2 !== o2.data.height)
              return void this.fire(new e.f(new Error(`The width and height of the updated image (${a2}, ${n2})
                must be that same as the previous version of the image
                (${o2.data.width}, ${o2.data.height})`)));
            const l2 = !(i2 instanceof HTMLImageElement || ImageBitmap && i2 instanceof ImageBitmap);
            o2.data.replace(s2, l2), this.style.updateImage(t2, o2);
          }
          hasImage(t2) {
            return t2 ? !!this.style && !!this.style.getImage(t2) : (this.fire(new e.f(new Error("Missing required image id"))), false);
          }
          removeImage(e2) {
            this.style.removeImage(e2);
          }
          loadImage(t2, i2) {
            e.i(this._requestManager.transformRequest(t2, e.R.Image), (t3, o2) => {
              i2(t3, o2 instanceof HTMLImageElement ? e.e.getImageData(o2) : o2);
            });
          }
          listImages() {
            return this.style.listImages();
          }
          addModel(e2, t2) {
            this._lazyInitEmptyStyle(), this.style.addModel(e2, t2);
          }
          hasModel(t2) {
            return t2 ? this.style.hasModel(t2) : (this.fire(new e.f(new Error("Missing required model id"))), false);
          }
          removeModel(e2) {
            this.style.removeModel(e2);
          }
          listModels() {
            return this.style.listModels();
          }
          addLayer(e2, t2) {
            return this._isValidId(e2.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(e2, t2), this._update(true)) : this;
          }
          getSlot(e2) {
            const t2 = this.getLayer(e2);
            return t2 && t2.slot || null;
          }
          setSlot(e2, t2) {
            return this.style.setSlot(e2, t2), this.style.mergeLayers(), this._update(true);
          }
          addImport(e2, t2) {
            return this.style.addImport(e2, t2), this;
          }
          updateImport(e2, t2) {
            return "string" != typeof t2 && t2.id !== e2 ? (this.removeImport(e2), this.addImport(t2)) : (this.style.updateImport(e2, t2), this._update(true));
          }
          removeImport(e2) {
            return this.style.removeImport(e2), this;
          }
          moveImport(e2, t2) {
            return this.style.moveImport(e2, t2), this._update(true);
          }
          moveLayer(e2, t2) {
            return this._isValidId(e2) ? (this.style.moveLayer(e2, t2), this._update(true)) : this;
          }
          removeLayer(e2) {
            return this._isValidId(e2) ? (this.style.removeLayer(e2), this._update(true)) : this;
          }
          getLayer(e2) {
            if (!this._isValidId(e2))
              return null;
            const t2 = this.style.getOwnLayer(e2);
            return t2 ? "custom" === t2.type ? t2.implementation : t2.serialize() : void 0;
          }
          getSlots() {
            return this.style.getSlots();
          }
          setLayerZoomRange(e2, t2, i2) {
            return this._isValidId(e2) ? (this.style.setLayerZoomRange(e2, t2, i2), this._update(true)) : this;
          }
          setFilter(e2, t2, i2 = {}) {
            return this._isValidId(e2) ? (this.style.setFilter(e2, t2, i2), this._update(true)) : this;
          }
          getFilter(e2) {
            return this._isValidId(e2) ? this.style.getFilter(e2) : null;
          }
          setPaintProperty(e2, t2, i2, o2 = {}) {
            return this._isValidId(e2) ? (this.style.setPaintProperty(e2, t2, i2, o2), this._update(true)) : this;
          }
          getPaintProperty(e2, t2) {
            return this._isValidId(e2) ? this.style.getPaintProperty(e2, t2) : null;
          }
          setLayoutProperty(e2, t2, i2, o2 = {}) {
            return this._isValidId(e2) ? (this.style.setLayoutProperty(e2, t2, i2, o2), this._update(true)) : this;
          }
          getLayoutProperty(e2, t2) {
            return this._isValidId(e2) ? this.style.getLayoutProperty(e2, t2) : null;
          }
          getSchema(e2) {
            return this.style.getSchema(e2);
          }
          setSchema(e2, t2) {
            return this.style.setSchema(e2, t2), this._update(true);
          }
          getConfig(e2) {
            return this.style.getConfig(e2);
          }
          setConfig(e2, t2) {
            return this.style.setConfig(e2, t2), this._update(true);
          }
          getConfigProperty(e2, t2) {
            return this.style.getConfigProperty(e2, t2);
          }
          setConfigProperty(e2, t2, i2) {
            return this.style.setConfigProperty(e2, t2, i2), this._update(true);
          }
          setLights(e2) {
            if (this._lazyInitEmptyStyle(), e2 && 1 === e2.length && "flat" === e2[0].type) {
              const t2 = e2[0];
              t2.properties ? this.style.setFlatLight(t2.properties, t2.id, {}) : this.style.setFlatLight({}, "flat");
            } else
              this.style.setLights(e2), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = true);
            return this._update(true);
          }
          getLights() {
            const e2 = this.style.getLights() || [];
            return 0 === e2.length && e2.push({ id: this.style.light.id, type: "flat", properties: this.style.getFlatLight() }), e2;
          }
          setLight(e2, t2 = {}) {
            return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([{ id: "flat", type: "flat", properties: e2 }]);
          }
          getLight() {
            return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
          }
          setTerrain(e2) {
            return this._lazyInitEmptyStyle(), !e2 && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e2), this._averageElevationLastSampledAt = -1 / 0, this._update(true);
          }
          getTerrain() {
            return this.style ? this.style.getTerrain() : null;
          }
          setFog(e2) {
            return this._lazyInitEmptyStyle(), this.style.setFog(e2), this._update(true);
          }
          getFog() {
            return this.style ? this.style.getFog() : null;
          }
          setColorTheme(e2) {
            return this._lazyInitEmptyStyle(), this.style.setColorTheme(e2), this._update(true);
          }
          setCamera(e2) {
            return this.style.setCamera(e2), this._triggerCameraUpdate(e2);
          }
          _triggerCameraUpdate(e2) {
            return this._update(this.transform.setOrthographicProjectionAtLowPitch("orthographic" === e2["camera-projection"]));
          }
          getCamera() {
            return this.style.camera;
          }
          _queryFogOpacity(t2) {
            return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e.aJ.convert(t2), this.transform) : 0;
          }
          setFeatureState(e2, t2) {
            return this._isValidId(e2.source) ? (this.style.setFeatureState(e2, t2), this._update()) : this;
          }
          removeFeatureState(e2, t2) {
            return this._isValidId(e2.source) ? (this.style.removeFeatureState(e2, t2), this._update()) : this;
          }
          getFeatureState(e2) {
            return this._isValidId(e2.source) ? this.style.getFeatureState(e2) : null;
          }
          _updateContainerDimensions() {
            if (!this._container)
              return;
            const e2 = this._container.getBoundingClientRect().width || 400, t2 = this._container.getBoundingClientRect().height || 300;
            let i2, o2, r2, a2 = this._container;
            for (; a2 && (!o2 || !r2); ) {
              const e3 = window.getComputedStyle(a2).transform;
              e3 && "none" !== e3 && (i2 = e3.match(/matrix.*\((.+)\)/)[1].split(", "), i2[0] && "0" !== i2[0] && "1" !== i2[0] && (o2 = i2[0]), i2[3] && "0" !== i2[3] && "1" !== i2[3] && (r2 = i2[3])), a2 = a2.parentElement;
            }
            this._containerWidth = o2 ? Math.abs(e2 / o2) : e2, this._containerHeight = r2 ? Math.abs(t2 / r2) : t2;
          }
          _detectMissingCSS() {
            "rgb(250, 128, 114)" !== window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e.w("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
          }
          _setupContainer() {
            const e2 = this._container;
            e2.classList.add("mapboxgl-map"), (this._missingCSSCanary = r("div", "mapboxgl-canary", e2)).style.visibility = "hidden", this._detectMissingCSS();
            const t2 = this._canvasContainer = r("div", "mapboxgl-canvas-container", e2);
            this._canvas = r("canvas", "mapboxgl-canvas", t2), this._interactive && (t2.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, false), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, false), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
            const i2 = this._controlContainer = r("div", "mapboxgl-control-container", e2), o2 = this._controlPositions = {};
            ["top-left", "top-right", "bottom-left", "bottom-right"].forEach((e3) => {
              o2[e3] = r("div", `mapboxgl-ctrl-${e3}`, i2);
            }), this._container.addEventListener("scroll", this._onMapScroll, false);
          }
          _resizeCanvas(t2, i2) {
            const o2 = e.e.devicePixelRatio || 1;
            this._canvas.width = o2 * Math.ceil(t2), this._canvas.height = o2 * Math.ceil(i2), this._canvas.style.width = `${t2}px`, this._canvas.style.height = `${i2}px`;
          }
          _addMarker(e2) {
            this._markers.push(e2);
          }
          _removeMarker(e2) {
            const t2 = this._markers.indexOf(e2);
            -1 !== t2 && this._markers.splice(t2, 1);
          }
          _addPopup(e2) {
            this._popups.push(e2);
          }
          _removePopup(e2) {
            const t2 = this._popups.indexOf(e2);
            -1 !== t2 && this._popups.splice(t2, 1);
          }
          _setupPainter() {
            const i2 = e.Q({}, t.webGLContextAttributes, { failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat, preserveDrawingBuffer: this._preserveDrawingBuffer, antialias: this._antialias || false }), o2 = this._canvas.getContext("webgl2", i2);
            o2 ? (e.dk(o2, true), this.painter = new Cr(o2, this._contextCreateOptions, this.transform, this._tp), this.on("data", (e2) => {
              "source" === e2.dataType && this.painter.setTileLoadedFlag(true);
            }), e.dl.testSupport(o2)) : this.fire(new e.f(new Error("Failed to initialize WebGL")));
          }
          _contextLost(t2) {
            t2.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new e.g("webglcontextlost", { originalEvent: t2 }));
          }
          _contextRestored(t2) {
            this._setupPainter(), this.resize(), this._update(), this.fire(new e.g("webglcontextrestored", { originalEvent: t2 }));
          }
          _onMapScroll(e2) {
            if (e2.target === this._container)
              return this._container.scrollTop = 0, this._container.scrollLeft = 0, false;
          }
          idle() {
            return !this.isMoving() && this.loaded();
          }
          loaded() {
            return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
          }
          frameReady() {
            return this.loaded() && !this._placementDirty;
          }
          _update(e2) {
            return this.style ? (this._styleDirty = this._styleDirty || e2, this._sourcesDirty = true, this.triggerRepaint(), this) : this;
          }
          _requestRenderFrame(e2) {
            return this._update(), this._renderTaskQueue.add(e2);
          }
          _cancelRenderFrame(e2) {
            this._renderTaskQueue.remove(e2);
          }
          _requestDomTask(e2) {
            !this.loaded() || this.loaded() && !this.isMoving() ? e2() : this._domRenderTaskQueue.add(e2);
          }
          _render(t2) {
            let i2;
            this.fire(new e.g("renderstart")), ++this._frameId;
            const o2 = this.painter.context.extTimerQuery, r2 = e.e.now(), a2 = this.painter.context.gl;
            if (this.listens("gpu-timing-frame") && (i2 = a2.createQuery(), a2.beginQuery(o2.TIME_ELAPSED_EXT, i2)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], performance.now())), this._renderTaskQueue.run(t2), this._domRenderTaskQueue.run(t2), this._removed)
              return;
            this._updateProjectionTransition();
            const n2 = this._isInitialLoad ? 0 : this._fadeDuration;
            if (this.style && this._styleDirty) {
              this._styleDirty = false;
              const t3 = this.transform.zoom, i3 = this.transform.pitch, o3 = e.e.now(), r3 = new e.Y(t3, { now: o3, fadeDuration: n2, pitch: i3, transition: this.style.transition });
              this.style.update(r3);
            }
            this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = true, this._sourcesDirty = true);
            let s2 = false;
            this.style && this._sourcesDirty ? (this._sourcesDirty = false, this.painter._updateFog(this.style), this._updateTerrain(), s2 = this._updateAverageElevation(r2), this.style.updateSources(this.transform), this._forceMarkerAndPopupUpdate()) : s2 = this._updateAverageElevation(r2);
            const l2 = this.style && this.style._updatePlacement(this.painter, this.painter.transform, this.showCollisionBoxes, n2, this._crossSourceCollisions, this.painter.replacementSource);
            if (l2 && (this._placementDirty = l2.needsRerender), this.style && this.painter.render(this.style, { showTileBoundaries: this.showTileBoundaries, showParseStatus: this.showParseStatus, wireframe: { terrain: this.showTerrainWireframe, layers2D: this.showLayers2DWireframe, layers3D: this.showLayers3DWireframe }, showOverdrawInspector: this._showOverdrawInspector, showQueryGeometry: !!this._showQueryGeometry, showTileAABBs: this.showTileAABBs, rotating: this.isRotating(), zooming: this.isZooming(), moving: this.isMoving(), fadeDuration: n2, isInitialLoad: this._isInitialLoad, showPadding: this.showPadding, gpuTiming: !!this.listens("gpu-timing-layer"), gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"), speedIndexTiming: this.speedIndexTiming }), this.fire(new e.g("render")), this.loaded() && !this._loaded && (this._loaded = true, e.df.mark(e.dg.load), this.fire(new e.g("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = true), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), i2) {
              const t3 = e.e.now() - r2;
              a2.endQuery(o2.TIME_ELAPSED_EXT), setTimeout(() => {
                const o3 = a2.getQueryParameter(i2, a2.QUERY_RESULT) / 1e6;
                a2.deleteQuery(i2), this.fire(new e.g("gpu-timing-frame", { cpuTime: t3, gpuTime: o3 }));
              }, 50);
            }
            if (this.listens("gpu-timing-layer")) {
              const t3 = this.painter.collectGpuTimers();
              setTimeout(() => {
                const i3 = this.painter.queryGpuTimers(t3);
                this.fire(new e.g("gpu-timing-layer", { layerTimes: i3 }));
              }, 50);
            }
            if (this.listens("gpu-timing-deferred-render")) {
              const t3 = this.painter.collectDeferredRenderGpuQueries();
              setTimeout(() => {
                const i3 = this.painter.queryGpuTimeDeferredRender(t3);
                this.fire(new e.g("gpu-timing-deferred-render", { gpuTime: i3 }));
              }, 50);
            }
            const c2 = this._sourcesDirty || this._styleDirty || this._placementDirty || s2;
            if (c2 || this._repaint)
              this.triggerRepaint();
            else {
              const t3 = this.idle();
              if (t3 && (s2 = this._updateAverageElevation(r2, true)), s2)
                this.triggerRepaint();
              else if (this._triggerFrame(false), t3 && (this.fire(new e.g("idle")), this._isInitialLoad = false, this.speedIndexTiming)) {
                const t4 = this._calculateSpeedIndex();
                this.fire(new e.g("speedindexcompleted", { speedIndex: t4 })), this.speedIndexTiming = false;
              }
            }
            !this._loaded || this._fullyLoaded || c2 || (this._fullyLoaded = true, e.df.mark(e.dg.fullLoad), this._performanceMetricsCollection && e.dm(this._requestManager._customAccessToken, { width: this.painter.width, height: this.painter.height, interactionRange: this._interactionRange, visibilityHidden: this._visibilityHidden, terrainEnabled: !!this.painter.style.getTerrain(), fogEnabled: !!this.painter.style.getFog(), projection: this.getProjection().name, zoom: this.transform.zoom, renderer: this.painter.context.renderer, vendor: this.painter.context.vendor }), this._authenticate());
          }
          _forceMarkerAndPopupUpdate(e2) {
            for (const t2 of this._markers)
              e2 && !this.getRenderWorldCopies() && (t2._lngLat = t2._lngLat.wrap()), t2._update();
            for (const t2 of this._popups)
              !e2 || this.getRenderWorldCopies() || t2._trackPointer || (t2._lngLat = t2._lngLat.wrap()), t2._update();
          }
          _updateAverageElevation(e2, t2 = false) {
            const i2 = (e3) => (this.transform.averageElevation = e3, this._update(false), true);
            if (!this.painter.averageElevationNeedsEasing())
              return 0 !== this.transform.averageElevation && i2(0);
            const o2 = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
            if (o2 || (t2 || e2 - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e2)) {
              const t3 = this.transform.averageElevation;
              let r2 = this.transform.sampleAverageElevation();
              null != this.transform.elevation && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(r2) ? r2 = 0 : this._averageElevationLastSampledAt = e2;
              const a2 = Math.abs(t3 - r2);
              if (a2 > 1) {
                if (this._isInitialLoad || o2)
                  return this._averageElevation.jumpTo(r2), i2(r2);
                this._averageElevation.easeTo(r2, e2, 300);
              } else if (a2 > 1e-4)
                return this._averageElevation.jumpTo(r2), i2(r2);
            }
            return !!this._averageElevation.isEasing(e2) && i2(this._averageElevation.getValue(e2));
          }
          _authenticate() {
            e.dn(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (t2) => {
              if (t2 && (t2.message === e.dp || 401 === t2.status)) {
                const t3 = this.painter.context.gl;
                e.dk(t3, false), this._logoControl instanceof Rn && this._logoControl._updateLogo(), t3 && t3.clear(t3.DEPTH_BUFFER_BIT | t3.COLOR_BUFFER_BIT | t3.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new e.f(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
              }
            }), e.dq(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, () => {
            });
          }
          _postStyleLoadEvent() {
            this.style.globalId && e.dr(this._requestManager._customAccessToken, { map: this, skuToken: this._requestManager._skuToken, style: this.style.globalId, importedStyles: this.style.getImportGlobalIds() });
          }
          _updateTerrain() {
            const e2 = this._isDragging();
            this.painter.updateTerrain(this.style, e2);
          }
          _calculateSpeedIndex() {
            const e2 = this.painter.canvasCopy(), t2 = this.painter.getCanvasCopiesAndTimestamps();
            t2.timeStamps.push(performance.now());
            const i2 = this.painter.context.gl, o2 = i2.createFramebuffer();
            function r2(e3) {
              i2.framebufferTexture2D(i2.FRAMEBUFFER, i2.COLOR_ATTACHMENT0, i2.TEXTURE_2D, e3, 0);
              const t3 = new Uint8Array(i2.drawingBufferWidth * i2.drawingBufferHeight * 4);
              return i2.readPixels(0, 0, i2.drawingBufferWidth, i2.drawingBufferHeight, i2.RGBA, i2.UNSIGNED_BYTE, t3), t3;
            }
            return i2.bindFramebuffer(i2.FRAMEBUFFER, o2), this._canvasPixelComparison(r2(e2), t2.canvasCopies.map(r2), t2.timeStamps);
          }
          _canvasPixelComparison(e2, t2, i2) {
            let o2 = i2[1] - i2[0];
            const r2 = e2.length / 4;
            for (let a2 = 0; a2 < t2.length; a2++) {
              const n2 = t2[a2];
              let s2 = 0;
              for (let t3 = 0; t3 < n2.length; t3 += 4)
                n2[t3] === e2[t3] && n2[t3 + 1] === e2[t3 + 1] && n2[t3 + 2] === e2[t3 + 2] && n2[t3 + 3] === e2[t3 + 3] && (s2 += 1);
              o2 += (i2[a2 + 2] - i2[a2 + 1]) * (1 - s2 / r2);
            }
            return o2;
          }
          remove() {
            this._hash && this._hash.remove();
            for (const e2 of this._controls)
              e2.onRemove(this);
            this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), window.removeEventListener("resize", this._onWindowResize, false), window.removeEventListener("orientationchange", this._onWindowResize, false), window.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, false), window.removeEventListener("online", this._onWindowOnline, false), window.removeEventListener("visibilitychange", this._onVisibilityChange, false);
            const t2 = this.painter.context.gl.getExtension("WEBGL_lose_context");
            t2 && t2.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, false), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, false), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, false), e.ds(this.painter.context.gl), e.dt.remove(), e.du.remove(), this._removed = true, this.fire(new e.g("remove"));
          }
          triggerRepaint() {
            this._triggerFrame(true);
          }
          _triggerFrame(t2) {
            this._renderNextFrame = this._renderNextFrame || t2, this.style && !this._frame && (this._frame = e.e.frame((e2) => {
              const t3 = !!this._renderNextFrame;
              this._frame = null, this._renderNextFrame = null, t3 && this._render(e2);
            }));
          }
          _preloadTiles(t2) {
            const i2 = this.style ? this.style.getSourceCaches() : [];
            return e.dv(i2, (e2, i3) => e2._preloadTiles(t2, i3), () => {
              this.triggerRepaint();
            }), this;
          }
          _onWindowOnline() {
            this._update();
          }
          _onWindowResize(e2) {
            this._trackResize && this.resize({ originalEvent: e2 })._update();
          }
          _onVisibilityChange() {
            "hidden" === document.visibilityState && this._visibilityHidden++;
          }
          get showTileBoundaries() {
            return !!this._showTileBoundaries;
          }
          set showTileBoundaries(e2) {
            this._showTileBoundaries !== e2 && (this._showTileBoundaries = e2, this._tp.refreshUI(), this._update());
          }
          get showParseStatus() {
            return !!this._showParseStatus;
          }
          set showParseStatus(e2) {
            this._showParseStatus !== e2 && (this._showParseStatus = e2, this._tp.refreshUI(), this._update());
          }
          get showTerrainWireframe() {
            return !!this._showTerrainWireframe;
          }
          set showTerrainWireframe(e2) {
            this._showTerrainWireframe !== e2 && (this._showTerrainWireframe = e2, this._tp.refreshUI(), this._update());
          }
          get showLayers2DWireframe() {
            return !!this._showLayers2DWireframe;
          }
          set showLayers2DWireframe(e2) {
            this._showLayers2DWireframe !== e2 && (this._showLayers2DWireframe = e2, this._tp.refreshUI(), this._update());
          }
          get showLayers3DWireframe() {
            return !!this._showLayers3DWireframe;
          }
          set showLayers3DWireframe(e2) {
            this._showLayers3DWireframe !== e2 && (this._showLayers3DWireframe = e2, this._tp.refreshUI(), this._update());
          }
          get speedIndexTiming() {
            return !!this._speedIndexTiming;
          }
          set speedIndexTiming(e2) {
            this._speedIndexTiming !== e2 && (this._speedIndexTiming = e2, this._update());
          }
          get showPadding() {
            return !!this._showPadding;
          }
          set showPadding(e2) {
            this._showPadding !== e2 && (this._showPadding = e2, this._tp.refreshUI(), this._update());
          }
          get showCollisionBoxes() {
            return !!this._showCollisionBoxes;
          }
          set showCollisionBoxes(e2) {
            this._showCollisionBoxes !== e2 && (this._showCollisionBoxes = e2, this._tp.refreshUI(), e2 ? this.style._generateCollisionBoxes() : this._update());
          }
          get showOverdrawInspector() {
            return !!this._showOverdrawInspector;
          }
          set showOverdrawInspector(e2) {
            this._showOverdrawInspector !== e2 && (this._showOverdrawInspector = e2, this._tp.refreshUI(), this._update());
          }
          get repaint() {
            return !!this._repaint;
          }
          set repaint(e2) {
            this._repaint !== e2 && (this._repaint = e2, this._tp.refreshUI(), this.triggerRepaint());
          }
          get vertices() {
            return !!this._vertices;
          }
          set vertices(e2) {
            this._vertices = e2, this._update();
          }
          get showTileAABBs() {
            return !!this._showTileAABBs;
          }
          set showTileAABBs(e2) {
            this._showTileAABBs !== e2 && (this._showTileAABBs = e2, this._tp.refreshUI(), e2 && this._update());
          }
          _setCacheLimits(t2, i2) {
            e.dx(t2, i2);
          }
          get version() {
            return e.dw;
          }
        }, NavigationControl: class {
          constructor(t2 = {}) {
            this.options = e.Q({}, jn, t2), this._container = r("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e2) => e2.preventDefault()), this.options.showZoom && (e.br(["_setButtonTitle", "_updateZoomButtons"], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e2) => {
              this._map && this._map.zoomIn({}, { originalEvent: e2 });
            }), r("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e2) => {
              this._map && this._map.zoomOut({}, { originalEvent: e2 });
            }), r("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (e.br(["_rotateCompassArrow"], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e2) => {
              const t3 = this._map;
              t3 && (this.options.visualizePitch ? t3.resetNorthPitch({}, { originalEvent: e2 }) : t3.resetNorth({}, { originalEvent: e2 }));
            }), this._compassIcon = r("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
          }
          _updateZoomButtons() {
            const e2 = this._map;
            if (!e2)
              return;
            const t2 = e2.getZoom(), i2 = t2 === e2.getMaxZoom(), o2 = t2 === e2.getMinZoom();
            this._zoomInButton.disabled = i2, this._zoomOutButton.disabled = o2, this._zoomInButton.setAttribute("aria-disabled", i2.toString()), this._zoomOutButton.setAttribute("aria-disabled", o2.toString());
          }
          _rotateCompassArrow() {
            const e2 = this._map;
            if (!e2)
              return;
            const t2 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e2.transform.pitch * (Math.PI / 180)), 0.5)}) rotateX(${e2.transform.pitch}deg) rotateZ(${e2.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e2.transform.angle * (180 / Math.PI)}deg)`;
            e2._requestDomTask(() => {
              this._compassIcon && (this._compassIcon.style.transform = t2);
            });
          }
          onAdd(e2) {
            return this._map = e2, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e2.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e2.on("pitch", this._rotateCompassArrow), e2.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Vn(e2, this._compass, this.options.visualizePitch)), this._container;
          }
          onRemove() {
            const e2 = this._map;
            e2 && (this._container.remove(), this.options.showZoom && e2.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e2.off("pitch", this._rotateCompassArrow), e2.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
          }
          _createButton(e2, t2) {
            const i2 = r("button", e2, this._container);
            return i2.type = "button", i2.addEventListener("click", t2), i2;
          }
          _setButtonTitle(e2, t2) {
            if (!this._map)
              return;
            const i2 = this._map._getUIString(`NavigationControl.${t2}`);
            e2.setAttribute("aria-label", i2), e2.firstElementChild && e2.firstElementChild.setAttribute("title", i2);
          }
        }, GeolocateControl: class extends e.E {
          constructor(t2 = {}) {
            super();
            const i2 = navigator.geolocation;
            this.options = e.Q({ geolocation: i2 }, $n, t2), e.br(["_onSuccess", "_onError", "_onZoom", "_finish", "_setupUI", "_updateCamera", "_updateMarker", "_updateMarkerRotation", "_onDeviceOrientation"], this), this._updateMarkerRotationThrottled = La(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
          }
          onAdd(e2) {
            return this._map = e2, this._container = r("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
          }
          onRemove() {
            void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = false;
          }
          _checkGeolocationSupport(e2) {
            const t2 = (t3 = !!this.options.geolocation) => {
              this._supportsGeolocation = t3, e2(t3);
            };
            void 0 !== this._supportsGeolocation ? e2(this._supportsGeolocation) : void 0 !== navigator.permissions ? navigator.permissions.query({ name: "geolocation" }).then((e3) => t2("denied" !== e3.state)).catch(() => t2()) : t2();
          }
          _isOutOfMapMaxBounds(e2) {
            const t2 = this._map.getMaxBounds(), i2 = e2.coords;
            return !!t2 && (i2.longitude < t2.getWest() || i2.longitude > t2.getEast() || i2.latitude < t2.getSouth() || i2.latitude > t2.getNorth());
          }
          _setErrorState() {
            switch (this._watchState) {
              case "WAITING_ACTIVE":
                this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                break;
              case "ACTIVE_LOCK":
                this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                break;
              case "BACKGROUND":
                this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
            }
          }
          _onSuccess(t2) {
            if (this._map) {
              if (this._isOutOfMapMaxBounds(t2))
                return this._setErrorState(), this.fire(new e.g("outofmaxbounds", t2)), this._updateMarker(), void this._finish();
              if (this.options.trackUserLocation)
                switch (this._lastKnownPosition = t2, this._watchState) {
                  case "WAITING_ACTIVE":
                  case "ACTIVE_LOCK":
                  case "ACTIVE_ERROR":
                    this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                    break;
                  case "BACKGROUND":
                  case "BACKGROUND_ERROR":
                    this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                }
              this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t2), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(t2), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.g("geolocate", t2)), this._finish();
            }
          }
          _updateCamera(t2) {
            const i2 = new e.aJ(t2.coords.longitude, t2.coords.latitude), o2 = t2.coords.accuracy, r2 = this._map.getBearing(), a2 = e.Q({ bearing: r2 }, this.options.fitBoundsOptions);
            this._map.fitBounds(i2.toBounds(o2), a2, { geolocateSource: true });
          }
          _updateMarker(t2) {
            if (t2) {
              const i2 = new e.aJ(t2.coords.longitude, t2.coords.latitude);
              this._accuracyCircleMarker.setLngLat(i2).addTo(this._map), this._userLocationDotMarker.setLngLat(i2).addTo(this._map), this._accuracy = t2.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
            } else
              this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
          }
          _updateCircleRadius() {
            const t2 = this._map.transform, i2 = e.ay(1, t2._center.lat) * t2.worldSize, o2 = Math.ceil(2 * this._accuracy * i2);
            this._circleElement.style.width = `${o2}px`, this._circleElement.style.height = `${o2}px`;
          }
          _onZoom() {
            this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
          }
          _updateMarkerRotation() {
            this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
          }
          _onError(t2) {
            if (this._map) {
              if (this.options.trackUserLocation)
                if (1 === t2.code) {
                  this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = true;
                  const e2 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                  this._geolocateButton.setAttribute("aria-label", e2), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e2), void 0 !== this._geolocationWatchID && this._clearWatch();
                } else {
                  if (3 === t2.code && this._noTimeout)
                    return;
                  this._setErrorState();
                }
              "OFF" !== this._watchState && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.g("error", t2)), this._finish();
            }
          }
          _finish() {
            this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
          }
          _setupUI(t2) {
            if (void 0 !== this._map) {
              if (this._container.addEventListener("contextmenu", (e2) => e2.preventDefault()), this._geolocateButton = r("button", "mapboxgl-ctrl-geolocate", this._container), r("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", false === t2) {
                e.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                const t3 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                this._geolocateButton.disabled = true, this._geolocateButton.setAttribute("aria-label", t3), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", t3);
              } else {
                const e2 = this._map._getUIString("GeolocateControl.FindMyLocation");
                this._geolocateButton.setAttribute("aria-label", e2), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e2);
              }
              this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = r("div", "mapboxgl-user-location"), this._dotElement.appendChild(r("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(r("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new zn({ element: this._dotElement, rotationAlignment: "map", pitchAlignment: "map" }), this._circleElement = r("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new zn({ element: this._circleElement, pitchAlignment: "map" }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = true, this.options.trackUserLocation && this._map.on("movestart", (t3) => {
                t3.geolocateSource || "ACTIVE_LOCK" !== this._watchState || t3.originalEvent && "resize" === t3.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new e.g("trackuserlocationend")));
              });
            }
          }
          _onDeviceOrientation(e2) {
            this._userLocationDotMarker && (e2.webkitCompassHeading ? this._heading = e2.webkitCompassHeading : true === e2.absolute && (this._heading = -1 * e2.alpha), this._updateMarkerRotationThrottled());
          }
          trigger() {
            if (!this._setup)
              return e.w("Geolocate control triggered before added to a map"), false;
            if (this.options.trackUserLocation) {
              switch (this._watchState) {
                case "OFF":
                  this._watchState = "WAITING_ACTIVE", this.fire(new e.g("trackuserlocationstart"));
                  break;
                case "WAITING_ACTIVE":
                case "ACTIVE_LOCK":
                case "ACTIVE_ERROR":
                case "BACKGROUND_ERROR":
                  this._numberOfWatches--, this._noTimeout = false, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new e.g("trackuserlocationend"));
                  break;
                case "BACKGROUND":
                  this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e.g("trackuserlocationstart"));
              }
              switch (this._watchState) {
                case "WAITING_ACTIVE":
                  this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                  break;
                case "ACTIVE_LOCK":
                  this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                  break;
                case "ACTIVE_ERROR":
                  this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                  break;
                case "BACKGROUND":
                  this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                  break;
                case "BACKGROUND_ERROR":
                  this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
              }
              if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID)
                this._clearWatch();
              else if (void 0 === this._geolocationWatchID) {
                let e2;
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e2 = { maximumAge: 6e5, timeout: 0 }, this._noTimeout = true) : (e2 = this.options.positionOptions, this._noTimeout = false), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e2), this.options.showUserHeading && this._addDeviceOrientationListener();
              }
            } else
              this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = window.setTimeout(this._finish, 1e4);
            return true;
          }
          _addDeviceOrientationListener() {
            const e2 = () => {
              "ondeviceorientationabsolute" in window ? window.addEventListener("deviceorientationabsolute", this._onDeviceOrientation) : window.addEventListener("deviceorientation", this._onDeviceOrientation);
            };
            "undefined" != typeof DeviceMotionEvent && "function" == typeof DeviceMotionEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then((t2) => {
              "granted" === t2 && e2();
            }).catch(console.error) : e2();
          }
          _clearWatch() {
            this.options.geolocation.clearWatch(this._geolocationWatchID), window.removeEventListener("deviceorientation", this._onDeviceOrientation), window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
          }
        }, AttributionControl: Pn, ScaleControl: class {
          constructor(t2 = {}) {
            this.options = e.Q({}, Zn, t2), this._isNumberFormatSupported = function() {
              try {
                return new Intl.NumberFormat("en", { style: "unit", unitDisplay: "short", unit: "meter" }), true;
              } catch (e2) {
                return false;
              }
            }(), e.br(["_update", "_setScale", "setUnit"], this);
          }
          getDefaultPosition() {
            return "bottom-left";
          }
          _update() {
            const e2 = this.options.maxWidth || 100, t2 = this._map, i2 = t2._containerHeight / 2, o2 = t2._containerWidth / 2 - e2 / 2, r2 = t2.unproject([o2, i2]), a2 = t2.unproject([o2 + e2, i2]), n2 = r2.distanceTo(a2);
            if ("imperial" === this.options.unit) {
              const t3 = 3.2808 * n2;
              t3 > 5280 ? this._setScale(e2, t3 / 5280, "mile") : this._setScale(e2, t3, "foot");
            } else
              "nautical" === this.options.unit ? this._setScale(e2, n2 / 1852, "nautical-mile") : n2 >= 1e3 ? this._setScale(e2, n2 / 1e3, "kilometer") : this._setScale(e2, n2, "meter");
          }
          _setScale(e2, t2, i2) {
            this._map._requestDomTask(() => {
              const o2 = function(e3) {
                const t3 = Math.pow(10, `${Math.floor(e3)}`.length - 1);
                let i3 = e3 / t3;
                return i3 = i3 >= 10 ? 10 : i3 >= 5 ? 5 : i3 >= 3 ? 3 : i3 >= 2 ? 2 : i3 >= 1 ? 1 : function(e4) {
                  const t4 = Math.pow(10, Math.ceil(-Math.log(e4) / Math.LN10));
                  return Math.round(e4 * t4) / t4;
                }(i3), t3 * i3;
              }(t2), r2 = o2 / t2;
              this._container.innerHTML = this._isNumberFormatSupported && "nautical-mile" !== i2 ? new Intl.NumberFormat(this._language, { style: "unit", unitDisplay: "short", unit: i2 }).format(o2) : `${o2}&nbsp;${Wn[i2]}`, this._container.style.width = e2 * r2 + "px";
            });
          }
          onAdd(e2) {
            return this._map = e2, this._language = e2.getLanguage(), this._container = r("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e2.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
          }
          onRemove() {
            this._container.remove(), this._map.off("move", this._update), this._map = void 0;
          }
          _setLanguage(e2) {
            this._language = e2, this._update();
          }
          setUnit(e2) {
            this.options.unit = e2, this._update();
          }
        }, FullscreenControl: class {
          constructor(t2 = {}) {
            this._fullscreen = false, t2 && t2.container && (t2.container instanceof HTMLElement ? this._container = t2.container : e.w("Full screen control 'container' must be a DOM element.")), e.br(["_onClickFullscreen", "_changeIcon"], this), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in document && (this._fullscreenchange = "webkitfullscreenchange");
          }
          onAdd(t2) {
            return this._map = t2, this._container || (this._container = this._map.getContainer()), this._controlContainer = r("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e.w("This device does not support fullscreen mode.")), this._controlContainer;
          }
          onRemove() {
            this._controlContainer.remove(), this._map = null, document.removeEventListener(this._fullscreenchange, this._changeIcon);
          }
          _checkFullscreenSupport() {
            return !(!document.fullscreenEnabled && !document.webkitFullscreenEnabled);
          }
          _setupUI() {
            const e2 = this._fullscreenButton = r("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
            r("span", "mapboxgl-ctrl-icon", e2).setAttribute("aria-hidden", "true"), e2.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), document.addEventListener(this._fullscreenchange, this._changeIcon);
          }
          _updateTitle() {
            const e2 = this._getTitle();
            this._fullscreenButton.setAttribute("aria-label", e2), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e2);
          }
          _getTitle() {
            return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
          }
          _isFullscreen() {
            return this._fullscreen;
          }
          _changeIcon() {
            (document.fullscreenElement || document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
          }
          _onClickFullscreen() {
            this._isFullscreen() ? document.exitFullscreen ? document.exitFullscreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
          }
        }, Popup: class extends e.E {
          constructor(t2) {
            super(), this.options = e.Q(Object.create(On), t2), e.br(["_update", "_onClose", "remove", "_onMouseEvent"], this), this._classList = new Set(t2 && t2.className ? t2.className.trim().split(/\s+/) : []);
          }
          addTo(t2) {
            return this._map && this.remove(), this._map = t2, this.options.closeOnClick && t2.on("preclick", this._onClose), this.options.closeOnMove && t2.on("move", this._onClose), t2.on("remove", this.remove), this._update(), t2._addPopup(this), this._focusFirstElement(), this._trackPointer ? (t2.on("mousemove", this._onMouseEvent), t2.on("mouseup", this._onMouseEvent), t2._canvasContainer.classList.add("mapboxgl-track-pointer")) : t2.on("move", this._update), this.fire(new e.g("open")), this;
          }
          isOpen() {
            return !!this._map;
          }
          remove() {
            this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
            const t2 = this._map;
            return t2 && (t2.off("move", this._update), t2.off("move", this._onClose), t2.off("preclick", this._onClose), t2.off("click", this._onClose), t2.off("remove", this.remove), t2.off("mousemove", this._onMouseEvent), t2.off("mouseup", this._onMouseEvent), t2.off("drag", this._onMouseEvent), t2._canvasContainer && t2._canvasContainer.classList.remove("mapboxgl-track-pointer"), t2._removePopup(this), this._map = void 0), this.fire(new e.g("close")), this;
          }
          getLngLat() {
            return this._lngLat;
          }
          setLngLat(t2) {
            this._lngLat = e.aJ.convert(t2), this._pos = null, this._trackPointer = false, this._update();
            const i2 = this._map;
            return i2 && (i2.on("move", this._update), i2.off("mousemove", this._onMouseEvent), i2._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
          }
          trackPointer() {
            this._trackPointer = true, this._pos = null, this._update();
            const e2 = this._map;
            return e2 && (e2.off("move", this._update), e2.on("mousemove", this._onMouseEvent), e2.on("drag", this._onMouseEvent), e2._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
          }
          getElement() {
            return this._container;
          }
          setText(e2) {
            return this.setDOMContent(document.createTextNode(e2));
          }
          setHTML(e2) {
            const t2 = document.createDocumentFragment(), i2 = document.createElement("body");
            let o2;
            for (i2.innerHTML = e2; o2 = i2.firstChild, o2; )
              t2.appendChild(o2);
            return this.setDOMContent(t2);
          }
          getMaxWidth() {
            return this._container && this._container.style.maxWidth;
          }
          setMaxWidth(e2) {
            return this.options.maxWidth = e2, this._update(), this;
          }
          setDOMContent(e2) {
            let t2 = this._content;
            if (t2)
              for (; t2.hasChildNodes(); )
                t2.firstChild && t2.removeChild(t2.firstChild);
            else
              t2 = this._content = r("div", "mapboxgl-popup-content", this._container || void 0);
            if (t2.appendChild(e2), this.options.closeButton) {
              const e3 = this._closeButton = r("button", "mapboxgl-popup-close-button", t2);
              e3.type = "button", e3.setAttribute("aria-label", "Close popup"), e3.setAttribute("aria-hidden", "true"), e3.innerHTML = "&#215;", e3.addEventListener("click", this._onClose);
            }
            return this._update(), this._focusFirstElement(), this;
          }
          addClassName(e2) {
            return this._classList.add(e2), this._updateClassList(), this;
          }
          removeClassName(e2) {
            return this._classList.delete(e2), this._updateClassList(), this;
          }
          setOffset(e2) {
            return this.options.offset = e2, this._update(), this;
          }
          toggleClassName(e2) {
            let t2;
            return this._classList.delete(e2) ? t2 = false : (this._classList.add(e2), t2 = true), this._updateClassList(), t2;
          }
          _onMouseEvent(e2) {
            this._update(e2.point);
          }
          _getAnchor(e2) {
            if (this.options.anchor)
              return this.options.anchor;
            const t2 = this._map, i2 = this._container, o2 = this._pos;
            if (!t2 || !i2 || !o2)
              return "bottom";
            const r2 = i2.offsetWidth, a2 = i2.offsetHeight, n2 = o2.x < r2 / 2, s2 = o2.x > t2.transform.width - r2 / 2;
            if (o2.y + e2 < a2)
              return n2 ? "top-left" : s2 ? "top-right" : "top";
            if (o2.y > t2.transform.height - a2) {
              if (n2)
                return "bottom-left";
              if (s2)
                return "bottom-right";
            }
            return n2 ? "left" : s2 ? "right" : "bottom";
          }
          _updateClassList() {
            const e2 = this._container;
            if (!e2)
              return;
            const t2 = [...this._classList];
            t2.push("mapboxgl-popup"), this._anchor && t2.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t2.push("mapboxgl-popup-track-pointer"), e2.className = t2.join(" ");
          }
          _update(t2) {
            const i2 = this._map, o2 = this._content;
            if (!i2 || !this._lngLat && !this._trackPointer || !o2)
              return;
            let a2 = this._container;
            if (a2 || (a2 = this._container = r("div", "mapboxgl-popup", i2.getContainer()), this._tip = r("div", "mapboxgl-popup-tip", a2), a2.appendChild(o2)), this.options.maxWidth && a2.style.maxWidth !== this.options.maxWidth && (a2.style.maxWidth = this.options.maxWidth), i2.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = An(this._lngLat, this._pos, i2.transform)), !this._trackPointer || t2) {
              const o3 = this._pos = this._trackPointer && t2 instanceof e.P ? t2 : i2.project(this._lngLat), r2 = Bn(this.options.offset), a3 = this._anchor = this._getAnchor(r2.y), n2 = Bn(this.options.offset, a3), s2 = o3.add(n2).round();
              i2._requestDomTask(() => {
                this._container && a3 && (this._container.style.transform = `${Mn[a3]} translate(${s2.x}px,${s2.y}px)`);
              });
            }
            if (!this._marker && i2._showingGlobe()) {
              const t3 = e.dc(i2.transform, this._lngLat) ? 0 : 1;
              this._setOpacity(t3);
            }
            this._updateClassList();
          }
          _focusFirstElement() {
            if (!this.options.focusAfterOpen || !this._container)
              return;
            const e2 = this._container.querySelector(Fn);
            e2 && e2.focus();
          }
          _onClose() {
            this.remove();
          }
          _setOpacity(e2) {
            this._container && (this._container.style.opacity = `${e2}`), this._content && (this._content.style.pointerEvents = e2 ? "auto" : "none");
          }
        }, Marker: zn, Style: Ia, LngLat: e.aJ, LngLatBounds: e.aj, Point: e.P, MercatorCoordinate: e._, FreeCameraOptions: Vt, Evented: e.E, config: e.db, prewarm: e.dA, clearPrewarmedResources: e.dB, get accessToken() {
          return e.db.ACCESS_TOKEN;
        }, set accessToken(t2) {
          e.db.ACCESS_TOKEN = t2;
        }, get baseApiUrl() {
          return e.db.API_URL;
        }, set baseApiUrl(t2) {
          e.db.API_URL = t2;
        }, get workerCount() {
          return e.dC.workerCount;
        }, set workerCount(t2) {
          e.dC.workerCount = t2;
        }, get maxParallelImageRequests() {
          return e.db.MAX_PARALLEL_IMAGE_REQUESTS;
        }, set maxParallelImageRequests(t2) {
          e.db.MAX_PARALLEL_IMAGE_REQUESTS = t2;
        }, clearStorage(t2) {
          e.dD(t2);
        }, get workerUrl() {
          return e.dE.workerUrl;
        }, set workerUrl(t2) {
          e.dE.workerUrl = t2;
        }, get workerClass() {
          return e.dE.workerClass;
        }, set workerClass(t2) {
          e.dE.workerClass = t2;
        }, get workerParams() {
          return e.dE.workerParams;
        }, set workerParams(t2) {
          e.dE.workerParams = t2;
        }, get dracoUrl() {
          return e.dF();
        }, set dracoUrl(t2) {
          e.dG(t2);
        }, get meshoptUrl() {
          return e.dH();
        }, set meshoptUrl(t2) {
          e.dI(t2);
        }, setNow: e.e.setNow, restoreNow: e.e.restoreNow };
        return Hn;
      });
      var mapboxgl$1 = mapboxgl2;
      return mapboxgl$1;
    });
  }
});

// ../../node_modules/axios/lib/helpers/bind.js
var require_bind = __commonJS({
  "../../node_modules/axios/lib/helpers/bind.js"(exports, module2) {
    "use strict";
    module2.exports = function bind(fn, thisArg) {
      return function wrap() {
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }
        return fn.apply(thisArg, args);
      };
    };
  }
});

// ../../node_modules/axios/lib/utils.js
var require_utils = __commonJS({
  "../../node_modules/axios/lib/utils.js"(exports, module2) {
    "use strict";
    var bind = require_bind();
    var toString = Object.prototype.toString;
    function isArray(val) {
      return toString.call(val) === "[object Array]";
    }
    function isUndefined(val) {
      return typeof val === "undefined";
    }
    function isBuffer(val) {
      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
    }
    function isArrayBuffer(val) {
      return toString.call(val) === "[object ArrayBuffer]";
    }
    function isFormData(val) {
      return typeof FormData !== "undefined" && val instanceof FormData;
    }
    function isArrayBufferView(val) {
      var result;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
      } else {
        result = val && val.buffer && val.buffer instanceof ArrayBuffer;
      }
      return result;
    }
    function isString(val) {
      return typeof val === "string";
    }
    function isNumber(val) {
      return typeof val === "number";
    }
    function isObject(val) {
      return val !== null && typeof val === "object";
    }
    function isPlainObject(val) {
      if (toString.call(val) !== "[object Object]") {
        return false;
      }
      var prototype = Object.getPrototypeOf(val);
      return prototype === null || prototype === Object.prototype;
    }
    function isDate(val) {
      return toString.call(val) === "[object Date]";
    }
    function isFile(val) {
      return toString.call(val) === "[object File]";
    }
    function isBlob(val) {
      return toString.call(val) === "[object Blob]";
    }
    function isFunction(val) {
      return toString.call(val) === "[object Function]";
    }
    function isStream(val) {
      return isObject(val) && isFunction(val.pipe);
    }
    function isURLSearchParams(val) {
      return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
    }
    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function isStandardBrowserEnv() {
      if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
        return false;
      }
      return typeof window !== "undefined" && typeof document !== "undefined";
    }
    function forEach(obj, fn) {
      if (obj === null || typeof obj === "undefined") {
        return;
      }
      if (typeof obj !== "object") {
        obj = [obj];
      }
      if (isArray(obj)) {
        for (var i = 0, l = obj.length; i < l; i++) {
          fn.call(null, obj[i], i, obj);
        }
      } else {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn.call(null, obj[key], key, obj);
          }
        }
      }
    }
    function merge() {
      var result = {};
      function assignValue(val, key) {
        if (isPlainObject(result[key]) && isPlainObject(val)) {
          result[key] = merge(result[key], val);
        } else if (isPlainObject(val)) {
          result[key] = merge({}, val);
        } else if (isArray(val)) {
          result[key] = val.slice();
        } else {
          result[key] = val;
        }
      }
      for (var i = 0, l = arguments.length; i < l; i++) {
        forEach(arguments[i], assignValue);
      }
      return result;
    }
    function extend(a, b, thisArg) {
      forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") {
          a[key] = bind(val, thisArg);
        } else {
          a[key] = val;
        }
      });
      return a;
    }
    function stripBOM(content) {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    }
    module2.exports = {
      isArray,
      isArrayBuffer,
      isBuffer,
      isFormData,
      isArrayBufferView,
      isString,
      isNumber,
      isObject,
      isPlainObject,
      isUndefined,
      isDate,
      isFile,
      isBlob,
      isFunction,
      isStream,
      isURLSearchParams,
      isStandardBrowserEnv,
      forEach,
      merge,
      extend,
      trim,
      stripBOM
    };
  }
});

// ../../node_modules/axios/lib/helpers/buildURL.js
var require_buildURL = __commonJS({
  "../../node_modules/axios/lib/helpers/buildURL.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    function encode(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    module2.exports = function buildURL(url, params, paramsSerializer) {
      if (!params) {
        return url;
      }
      var serializedParams;
      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
          if (val === null || typeof val === "undefined") {
            return;
          }
          if (utils.isArray(val)) {
            key = key + "[]";
          } else {
            val = [val];
          }
          utils.forEach(val, function parseValue(v) {
            if (utils.isDate(v)) {
              v = v.toISOString();
            } else if (utils.isObject(v)) {
              v = JSON.stringify(v);
            }
            parts.push(encode(key) + "=" + encode(v));
          });
        });
        serializedParams = parts.join("&");
      }
      if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) {
          url = url.slice(0, hashmarkIndex);
        }
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url;
    };
  }
});

// ../../node_modules/axios/lib/core/InterceptorManager.js
var require_InterceptorManager = __commonJS({
  "../../node_modules/axios/lib/core/InterceptorManager.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    function InterceptorManager() {
      this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    InterceptorManager.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    InterceptorManager.prototype.forEach = function forEach(fn) {
      utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    };
    module2.exports = InterceptorManager;
  }
});

// ../../node_modules/axios/lib/helpers/normalizeHeaderName.js
var require_normalizeHeaderName = __commonJS({
  "../../node_modules/axios/lib/helpers/normalizeHeaderName.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = function normalizeHeaderName(headers, normalizedName) {
      utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };
  }
});

// ../../node_modules/axios/lib/core/enhanceError.js
var require_enhanceError = __commonJS({
  "../../node_modules/axios/lib/core/enhanceError.js"(exports, module2) {
    "use strict";
    module2.exports = function enhanceError(error, config, code, request, response) {
      error.config = config;
      if (code) {
        error.code = code;
      }
      error.request = request;
      error.response = response;
      error.isAxiosError = true;
      error.toJSON = function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      };
      return error;
    };
  }
});

// ../../node_modules/axios/lib/core/createError.js
var require_createError = __commonJS({
  "../../node_modules/axios/lib/core/createError.js"(exports, module2) {
    "use strict";
    var enhanceError = require_enhanceError();
    module2.exports = function createError(message, config, code, request, response) {
      var error = new Error(message);
      return enhanceError(error, config, code, request, response);
    };
  }
});

// ../../node_modules/axios/lib/core/settle.js
var require_settle = __commonJS({
  "../../node_modules/axios/lib/core/settle.js"(exports, module2) {
    "use strict";
    var createError = require_createError();
    module2.exports = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;
      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(createError(
          "Request failed with status code " + response.status,
          response.config,
          null,
          response.request,
          response
        ));
      }
    };
  }
});

// ../../node_modules/axios/lib/helpers/cookies.js
var require_cookies = __commonJS({
  "../../node_modules/axios/lib/helpers/cookies.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs support document.cookie
      function standardBrowserEnv() {
        return {
          write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if (utils.isNumber(expires)) {
              cookie.push("expires=" + new Date(expires).toGMTString());
            }
            if (utils.isString(path)) {
              cookie.push("path=" + path);
            }
            if (utils.isString(domain)) {
              cookie.push("domain=" + domain);
            }
            if (secure === true) {
              cookie.push("secure");
            }
            document.cookie = cookie.join("; ");
          },
          read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
          },
          remove: function remove(name) {
            this.write(name, "", Date.now() - 864e5);
          }
        };
      }()
    ) : (
      // Non standard browser env (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return {
          write: function write() {
          },
          read: function read() {
            return null;
          },
          remove: function remove() {
          }
        };
      }()
    );
  }
});

// ../../node_modules/axios/lib/helpers/isAbsoluteURL.js
var require_isAbsoluteURL = __commonJS({
  "../../node_modules/axios/lib/helpers/isAbsoluteURL.js"(exports, module2) {
    "use strict";
    module2.exports = function isAbsoluteURL(url) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
    };
  }
});

// ../../node_modules/axios/lib/helpers/combineURLs.js
var require_combineURLs = __commonJS({
  "../../node_modules/axios/lib/helpers/combineURLs.js"(exports, module2) {
    "use strict";
    module2.exports = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
  }
});

// ../../node_modules/axios/lib/core/buildFullPath.js
var require_buildFullPath = __commonJS({
  "../../node_modules/axios/lib/core/buildFullPath.js"(exports, module2) {
    "use strict";
    var isAbsoluteURL = require_isAbsoluteURL();
    var combineURLs = require_combineURLs();
    module2.exports = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }
      return requestedURL;
    };
  }
});

// ../../node_modules/axios/lib/helpers/parseHeaders.js
var require_parseHeaders = __commonJS({
  "../../node_modules/axios/lib/helpers/parseHeaders.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var ignoreDuplicateOf = [
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent"
    ];
    module2.exports = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val;
      var i;
      if (!headers) {
        return parsed;
      }
      utils.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = utils.trim(line.substr(0, i)).toLowerCase();
        val = utils.trim(line.substr(i + 1));
        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }
          if (key === "set-cookie") {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
          }
        }
      });
      return parsed;
    };
  }
});

// ../../node_modules/axios/lib/helpers/isURLSameOrigin.js
var require_isURLSameOrigin = __commonJS({
  "../../node_modules/axios/lib/helpers/isURLSameOrigin.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs have full support of the APIs needed to test
      // whether the request URL is of the same origin as current location.
      function standardBrowserEnv() {
        var msie = /(msie|trident)/i.test(navigator.userAgent);
        var urlParsingNode = document.createElement("a");
        var originURL;
        function resolveURL(url) {
          var href = url;
          if (msie) {
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
          }
          urlParsingNode.setAttribute("href", href);
          return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
          };
        }
        originURL = resolveURL(window.location.href);
        return function isURLSameOrigin(requestURL) {
          var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
          return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
        };
      }()
    ) : (
      // Non standard browser envs (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return function isURLSameOrigin() {
          return true;
        };
      }()
    );
  }
});

// ../../node_modules/axios/lib/cancel/Cancel.js
var require_Cancel = __commonJS({
  "../../node_modules/axios/lib/cancel/Cancel.js"(exports, module2) {
    "use strict";
    function Cancel(message) {
      this.message = message;
    }
    Cancel.prototype.toString = function toString() {
      return "Cancel" + (this.message ? ": " + this.message : "");
    };
    Cancel.prototype.__CANCEL__ = true;
    module2.exports = Cancel;
  }
});

// ../../node_modules/axios/lib/adapters/xhr.js
var require_xhr = __commonJS({
  "../../node_modules/axios/lib/adapters/xhr.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var settle = require_settle();
    var cookies = require_cookies();
    var buildURL = require_buildURL();
    var buildFullPath = require_buildFullPath();
    var parseHeaders = require_parseHeaders();
    var isURLSameOrigin = require_isURLSameOrigin();
    var createError = require_createError();
    var defaults = require_defaults();
    var Cancel = require_Cancel();
    module2.exports = function xhrAdapter(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
          if (config.cancelToken) {
            config.cancelToken.unsubscribe(onCanceled);
          }
          if (config.signal) {
            config.signal.removeEventListener("abort", onCanceled);
          }
        }
        if (utils.isFormData(requestData)) {
          delete requestHeaders["Content-Type"];
        }
        var request = new XMLHttpRequest();
        if (config.auth) {
          var username = config.auth.username || "";
          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
          requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        request.timeout = config.timeout;
        function onloadend() {
          if (!request) {
            return;
          }
          var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config,
            request
          };
          settle(function _resolve(value) {
            resolve(value);
            done();
          }, function _reject(err) {
            reject(err);
            done();
          }, response);
          request = null;
        }
        if ("onloadend" in request) {
          request.onloadend = onloadend;
        } else {
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            }
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }
          reject(createError("Request aborted", config, "ECONNABORTED", request));
          request = null;
        };
        request.onerror = function handleError() {
          reject(createError("Network Error", config, null, request));
          request = null;
        };
        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
          var transitional = config.transitional || defaults.transitional;
          if (config.timeoutErrorMessage) {
            timeoutErrorMessage = config.timeoutErrorMessage;
          }
          reject(createError(
            timeoutErrorMessage,
            config,
            transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
            request
          ));
          request = null;
        };
        if (utils.isStandardBrowserEnv()) {
          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        }
        if ("setRequestHeader" in request) {
          utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
              delete requestHeaders[key];
            } else {
              request.setRequestHeader(key, val);
            }
          });
        }
        if (!utils.isUndefined(config.withCredentials)) {
          request.withCredentials = !!config.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request.responseType = config.responseType;
        }
        if (typeof config.onDownloadProgress === "function") {
          request.addEventListener("progress", config.onDownloadProgress);
        }
        if (typeof config.onUploadProgress === "function" && request.upload) {
          request.upload.addEventListener("progress", config.onUploadProgress);
        }
        if (config.cancelToken || config.signal) {
          onCanceled = function(cancel) {
            if (!request) {
              return;
            }
            reject(!cancel || cancel && cancel.type ? new Cancel("canceled") : cancel);
            request.abort();
            request = null;
          };
          config.cancelToken && config.cancelToken.subscribe(onCanceled);
          if (config.signal) {
            config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
          }
        }
        if (!requestData) {
          requestData = null;
        }
        request.send(requestData);
      });
    };
  }
});

// ../../node_modules/ms/index.js
var require_ms = __commonJS({
  "../../node_modules/ms/index.js"(exports, module2) {
    "use strict";
    var s = 1e3;
    var m = s * 60;
    var h = m * 60;
    var d = h * 24;
    var w = d * 7;
    var y = d * 365.25;
    module2.exports = function(val, options) {
      options = options || {};
      var type = typeof val;
      if (type === "string" && val.length > 0) {
        return parse(val);
      } else if (type === "number" && isFinite(val)) {
        return options.long ? fmtLong(val) : fmtShort(val);
      }
      throw new Error(
        "val is not a non-empty string or a valid number. val=" + JSON.stringify(val)
      );
    };
    function parse(str) {
      str = String(str);
      if (str.length > 100) {
        return;
      }
      var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        str
      );
      if (!match) {
        return;
      }
      var n = parseFloat(match[1]);
      var type = (match[2] || "ms").toLowerCase();
      switch (type) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return n * y;
        case "weeks":
        case "week":
        case "w":
          return n * w;
        case "days":
        case "day":
        case "d":
          return n * d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return n * h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return n * m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return n * s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return n;
        default:
          return void 0;
      }
    }
    function fmtShort(ms) {
      var msAbs = Math.abs(ms);
      if (msAbs >= d) {
        return Math.round(ms / d) + "d";
      }
      if (msAbs >= h) {
        return Math.round(ms / h) + "h";
      }
      if (msAbs >= m) {
        return Math.round(ms / m) + "m";
      }
      if (msAbs >= s) {
        return Math.round(ms / s) + "s";
      }
      return ms + "ms";
    }
    function fmtLong(ms) {
      var msAbs = Math.abs(ms);
      if (msAbs >= d) {
        return plural(ms, msAbs, d, "day");
      }
      if (msAbs >= h) {
        return plural(ms, msAbs, h, "hour");
      }
      if (msAbs >= m) {
        return plural(ms, msAbs, m, "minute");
      }
      if (msAbs >= s) {
        return plural(ms, msAbs, s, "second");
      }
      return ms + " ms";
    }
    function plural(ms, msAbs, n, name) {
      var isPlural = msAbs >= n * 1.5;
      return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
    }
  }
});

// ../../node_modules/debug/src/common.js
var require_common = __commonJS({
  "../../node_modules/debug/src/common.js"(exports, module2) {
    "use strict";
    function setup(env) {
      createDebug.debug = createDebug;
      createDebug.default = createDebug;
      createDebug.coerce = coerce;
      createDebug.disable = disable;
      createDebug.enable = enable;
      createDebug.enabled = enabled;
      createDebug.humanize = require_ms();
      createDebug.destroy = destroy;
      Object.keys(env).forEach((key) => {
        createDebug[key] = env[key];
      });
      createDebug.names = [];
      createDebug.skips = [];
      createDebug.formatters = {};
      function selectColor(namespace) {
        let hash = 0;
        for (let i = 0; i < namespace.length; i++) {
          hash = (hash << 5) - hash + namespace.charCodeAt(i);
          hash |= 0;
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
      }
      createDebug.selectColor = selectColor;
      function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
          if (!debug.enabled) {
            return;
          }
          const self2 = debug;
          const curr = Number(/* @__PURE__ */ new Date());
          const ms = curr - (prevTime || curr);
          self2.diff = ms;
          self2.prev = prevTime;
          self2.curr = curr;
          prevTime = curr;
          args[0] = createDebug.coerce(args[0]);
          if (typeof args[0] !== "string") {
            args.unshift("%O");
          }
          let index = 0;
          args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
            if (match === "%%") {
              return "%";
            }
            index++;
            const formatter = createDebug.formatters[format];
            if (typeof formatter === "function") {
              const val = args[index];
              match = formatter.call(self2, val);
              args.splice(index, 1);
              index--;
            }
            return match;
          });
          createDebug.formatArgs.call(self2, args);
          const logFn = self2.log || createDebug.log;
          logFn.apply(self2, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy;
        Object.defineProperty(debug, "enabled", {
          enumerable: true,
          configurable: false,
          get: () => {
            if (enableOverride !== null) {
              return enableOverride;
            }
            if (namespacesCache !== createDebug.namespaces) {
              namespacesCache = createDebug.namespaces;
              enabledCache = createDebug.enabled(namespace);
            }
            return enabledCache;
          },
          set: (v) => {
            enableOverride = v;
          }
        });
        if (typeof createDebug.init === "function") {
          createDebug.init(debug);
        }
        return debug;
      }
      function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
      }
      function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        const split = (typeof namespaces === "string" ? namespaces : "").trim().replace(" ", ",").split(",").filter(Boolean);
        for (const ns of split) {
          if (ns[0] === "-") {
            createDebug.skips.push(ns.slice(1));
          } else {
            createDebug.names.push(ns);
          }
        }
      }
      function matchesTemplate(search, template) {
        let searchIndex = 0;
        let templateIndex = 0;
        let starIndex = -1;
        let matchIndex = 0;
        while (searchIndex < search.length) {
          if (templateIndex < template.length && (template[templateIndex] === search[searchIndex] || template[templateIndex] === "*")) {
            if (template[templateIndex] === "*") {
              starIndex = templateIndex;
              matchIndex = searchIndex;
              templateIndex++;
            } else {
              searchIndex++;
              templateIndex++;
            }
          } else if (starIndex !== -1) {
            templateIndex = starIndex + 1;
            matchIndex++;
            searchIndex = matchIndex;
          } else {
            return false;
          }
        }
        while (templateIndex < template.length && template[templateIndex] === "*") {
          templateIndex++;
        }
        return templateIndex === template.length;
      }
      function disable() {
        const namespaces = [
          ...createDebug.names,
          ...createDebug.skips.map((namespace) => "-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
      }
      function enabled(name) {
        for (const skip of createDebug.skips) {
          if (matchesTemplate(name, skip)) {
            return false;
          }
        }
        for (const ns of createDebug.names) {
          if (matchesTemplate(name, ns)) {
            return true;
          }
        }
        return false;
      }
      function coerce(val) {
        if (val instanceof Error) {
          return val.stack || val.message;
        }
        return val;
      }
      function destroy() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
      }
      createDebug.enable(createDebug.load());
      return createDebug;
    }
    module2.exports = setup;
  }
});

// ../../node_modules/debug/src/browser.js
var require_browser = __commonJS({
  "../../node_modules/debug/src/browser.js"(exports, module2) {
    "use strict";
    exports.formatArgs = formatArgs;
    exports.save = save;
    exports.load = load;
    exports.useColors = useColors;
    exports.storage = localstorage();
    exports.destroy = (() => {
      let warned = false;
      return () => {
        if (!warned) {
          warned = true;
          console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
      };
    })();
    exports.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function useColors() {
      if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) {
        return true;
      }
      if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
        return false;
      }
      let m;
      return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
      typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator !== "undefined" && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
      typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    function formatArgs(args) {
      args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module2.exports.humanize(this.diff);
      if (!this.useColors) {
        return;
      }
      const c = "color: " + this.color;
      args.splice(1, 0, c, "color: inherit");
      let index = 0;
      let lastC = 0;
      args[0].replace(/%[a-zA-Z%]/g, (match) => {
        if (match === "%%") {
          return;
        }
        index++;
        if (match === "%c") {
          lastC = index;
        }
      });
      args.splice(lastC, 0, c);
    }
    exports.log = console.debug || console.log || (() => {
    });
    function save(namespaces) {
      try {
        if (namespaces) {
          exports.storage.setItem("debug", namespaces);
        } else {
          exports.storage.removeItem("debug");
        }
      } catch (error) {
      }
    }
    function load() {
      let r;
      try {
        r = exports.storage.getItem("debug");
      } catch (error) {
      }
      if (!r && typeof process !== "undefined" && "env" in process) {
        r = process.env.DEBUG;
      }
      return r;
    }
    function localstorage() {
      try {
        return localStorage;
      } catch (error) {
      }
    }
    module2.exports = require_common()(exports);
    var { formatters } = module2.exports;
    formatters.j = function(v) {
      try {
        return JSON.stringify(v);
      } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
      }
    };
  }
});

// ../../node_modules/has-flag/index.js
var require_has_flag = __commonJS({
  "../../node_modules/has-flag/index.js"(exports, module2) {
    "use strict";
    module2.exports = (flag, argv = process.argv) => {
      const prefix = flag.startsWith("-") ? "" : flag.length === 1 ? "-" : "--";
      const position = argv.indexOf(prefix + flag);
      const terminatorPosition = argv.indexOf("--");
      return position !== -1 && (terminatorPosition === -1 || position < terminatorPosition);
    };
  }
});

// ../../node_modules/supports-color/index.js
var require_supports_color = __commonJS({
  "../../node_modules/supports-color/index.js"(exports, module2) {
    "use strict";
    var os = require("os");
    var tty = require("tty");
    var hasFlag = require_has_flag();
    var { env } = process;
    var forceColor;
    if (hasFlag("no-color") || hasFlag("no-colors") || hasFlag("color=false") || hasFlag("color=never")) {
      forceColor = 0;
    } else if (hasFlag("color") || hasFlag("colors") || hasFlag("color=true") || hasFlag("color=always")) {
      forceColor = 1;
    }
    if ("FORCE_COLOR" in env) {
      if (env.FORCE_COLOR === "true") {
        forceColor = 1;
      } else if (env.FORCE_COLOR === "false") {
        forceColor = 0;
      } else {
        forceColor = env.FORCE_COLOR.length === 0 ? 1 : Math.min(parseInt(env.FORCE_COLOR, 10), 3);
      }
    }
    function translateLevel(level) {
      if (level === 0) {
        return false;
      }
      return {
        level,
        hasBasic: true,
        has256: level >= 2,
        has16m: level >= 3
      };
    }
    function supportsColor(haveStream, streamIsTTY) {
      if (forceColor === 0) {
        return 0;
      }
      if (hasFlag("color=16m") || hasFlag("color=full") || hasFlag("color=truecolor")) {
        return 3;
      }
      if (hasFlag("color=256")) {
        return 2;
      }
      if (haveStream && !streamIsTTY && forceColor === void 0) {
        return 0;
      }
      const min = forceColor || 0;
      if (env.TERM === "dumb") {
        return min;
      }
      if (process.platform === "win32") {
        const osRelease = os.release().split(".");
        if (Number(osRelease[0]) >= 10 && Number(osRelease[2]) >= 10586) {
          return Number(osRelease[2]) >= 14931 ? 3 : 2;
        }
        return 1;
      }
      if ("CI" in env) {
        if (["TRAVIS", "CIRCLECI", "APPVEYOR", "GITLAB_CI", "GITHUB_ACTIONS", "BUILDKITE"].some((sign) => sign in env) || env.CI_NAME === "codeship") {
          return 1;
        }
        return min;
      }
      if ("TEAMCITY_VERSION" in env) {
        return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0;
      }
      if (env.COLORTERM === "truecolor") {
        return 3;
      }
      if ("TERM_PROGRAM" in env) {
        const version = parseInt((env.TERM_PROGRAM_VERSION || "").split(".")[0], 10);
        switch (env.TERM_PROGRAM) {
          case "iTerm.app":
            return version >= 3 ? 3 : 2;
          case "Apple_Terminal":
            return 2;
        }
      }
      if (/-256(color)?$/i.test(env.TERM)) {
        return 2;
      }
      if (/^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
        return 1;
      }
      if ("COLORTERM" in env) {
        return 1;
      }
      return min;
    }
    function getSupportLevel(stream) {
      const level = supportsColor(stream, stream && stream.isTTY);
      return translateLevel(level);
    }
    module2.exports = {
      supportsColor: getSupportLevel,
      stdout: translateLevel(supportsColor(true, tty.isatty(1))),
      stderr: translateLevel(supportsColor(true, tty.isatty(2)))
    };
  }
});

// ../../node_modules/debug/src/node.js
var require_node = __commonJS({
  "../../node_modules/debug/src/node.js"(exports, module2) {
    "use strict";
    var tty = require("tty");
    var util = require("util");
    exports.init = init;
    exports.log = log;
    exports.formatArgs = formatArgs;
    exports.save = save;
    exports.load = load;
    exports.useColors = useColors;
    exports.destroy = util.deprecate(
      () => {
      },
      "Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."
    );
    exports.colors = [6, 2, 3, 4, 5, 1];
    try {
      const supportsColor = require_supports_color();
      if (supportsColor && (supportsColor.stderr || supportsColor).level >= 2) {
        exports.colors = [
          20,
          21,
          26,
          27,
          32,
          33,
          38,
          39,
          40,
          41,
          42,
          43,
          44,
          45,
          56,
          57,
          62,
          63,
          68,
          69,
          74,
          75,
          76,
          77,
          78,
          79,
          80,
          81,
          92,
          93,
          98,
          99,
          112,
          113,
          128,
          129,
          134,
          135,
          148,
          149,
          160,
          161,
          162,
          163,
          164,
          165,
          166,
          167,
          168,
          169,
          170,
          171,
          172,
          173,
          178,
          179,
          184,
          185,
          196,
          197,
          198,
          199,
          200,
          201,
          202,
          203,
          204,
          205,
          206,
          207,
          208,
          209,
          214,
          215,
          220,
          221
        ];
      }
    } catch (error) {
    }
    exports.inspectOpts = Object.keys(process.env).filter((key) => {
      return /^debug_/i.test(key);
    }).reduce((obj, key) => {
      const prop = key.substring(6).toLowerCase().replace(/_([a-z])/g, (_, k) => {
        return k.toUpperCase();
      });
      let val = process.env[key];
      if (/^(yes|on|true|enabled)$/i.test(val)) {
        val = true;
      } else if (/^(no|off|false|disabled)$/i.test(val)) {
        val = false;
      } else if (val === "null") {
        val = null;
      } else {
        val = Number(val);
      }
      obj[prop] = val;
      return obj;
    }, {});
    function useColors() {
      return "colors" in exports.inspectOpts ? Boolean(exports.inspectOpts.colors) : tty.isatty(process.stderr.fd);
    }
    function formatArgs(args) {
      const { namespace: name, useColors: useColors2 } = this;
      if (useColors2) {
        const c = this.color;
        const colorCode = "\x1B[3" + (c < 8 ? c : "8;5;" + c);
        const prefix = `  ${colorCode};1m${name} \x1B[0m`;
        args[0] = prefix + args[0].split("\n").join("\n" + prefix);
        args.push(colorCode + "m+" + module2.exports.humanize(this.diff) + "\x1B[0m");
      } else {
        args[0] = getDate() + name + " " + args[0];
      }
    }
    function getDate() {
      if (exports.inspectOpts.hideDate) {
        return "";
      }
      return (/* @__PURE__ */ new Date()).toISOString() + " ";
    }
    function log(...args) {
      return process.stderr.write(util.formatWithOptions(exports.inspectOpts, ...args) + "\n");
    }
    function save(namespaces) {
      if (namespaces) {
        process.env.DEBUG = namespaces;
      } else {
        delete process.env.DEBUG;
      }
    }
    function load() {
      return process.env.DEBUG;
    }
    function init(debug) {
      debug.inspectOpts = {};
      const keys = Object.keys(exports.inspectOpts);
      for (let i = 0; i < keys.length; i++) {
        debug.inspectOpts[keys[i]] = exports.inspectOpts[keys[i]];
      }
    }
    module2.exports = require_common()(exports);
    var { formatters } = module2.exports;
    formatters.o = function(v) {
      this.inspectOpts.colors = this.useColors;
      return util.inspect(v, this.inspectOpts).split("\n").map((str) => str.trim()).join(" ");
    };
    formatters.O = function(v) {
      this.inspectOpts.colors = this.useColors;
      return util.inspect(v, this.inspectOpts);
    };
  }
});

// ../../node_modules/debug/src/index.js
var require_src = __commonJS({
  "../../node_modules/debug/src/index.js"(exports, module2) {
    "use strict";
    if (typeof process === "undefined" || process.type === "renderer" || process.browser === true || process.__nwjs) {
      module2.exports = require_browser();
    } else {
      module2.exports = require_node();
    }
  }
});

// ../../node_modules/follow-redirects/debug.js
var require_debug = __commonJS({
  "../../node_modules/follow-redirects/debug.js"(exports, module2) {
    "use strict";
    var debug;
    module2.exports = function() {
      if (!debug) {
        try {
          debug = require_src()("follow-redirects");
        } catch (error) {
        }
        if (typeof debug !== "function") {
          debug = function() {
          };
        }
      }
      debug.apply(null, arguments);
    };
  }
});

// ../../node_modules/follow-redirects/index.js
var require_follow_redirects = __commonJS({
  "../../node_modules/follow-redirects/index.js"(exports, module2) {
    "use strict";
    var url = require("url");
    var URL2 = url.URL;
    var http = require("http");
    var https = require("https");
    var Writable = require("stream").Writable;
    var assert = require("assert");
    var debug = require_debug();
    (function detectUnsupportedEnvironment() {
      var looksLikeNode = typeof process !== "undefined";
      var looksLikeBrowser = typeof window !== "undefined" && typeof document !== "undefined";
      var looksLikeV8 = isFunction(Error.captureStackTrace);
      if (!looksLikeNode && (looksLikeBrowser || !looksLikeV8)) {
        console.warn("The follow-redirects package should be excluded from browser builds.");
      }
    })();
    var useNativeURL = false;
    try {
      assert(new URL2(""));
    } catch (error) {
      useNativeURL = error.code === "ERR_INVALID_URL";
    }
    var preservedUrlFields = [
      "auth",
      "host",
      "hostname",
      "href",
      "path",
      "pathname",
      "port",
      "protocol",
      "query",
      "search",
      "hash"
    ];
    var events = ["abort", "aborted", "connect", "error", "socket", "timeout"];
    var eventHandlers = /* @__PURE__ */ Object.create(null);
    events.forEach(function(event) {
      eventHandlers[event] = function(arg1, arg2, arg3) {
        this._redirectable.emit(event, arg1, arg2, arg3);
      };
    });
    var InvalidUrlError = createErrorType(
      "ERR_INVALID_URL",
      "Invalid URL",
      TypeError
    );
    var RedirectionError = createErrorType(
      "ERR_FR_REDIRECTION_FAILURE",
      "Redirected request failed"
    );
    var TooManyRedirectsError = createErrorType(
      "ERR_FR_TOO_MANY_REDIRECTS",
      "Maximum number of redirects exceeded",
      RedirectionError
    );
    var MaxBodyLengthExceededError = createErrorType(
      "ERR_FR_MAX_BODY_LENGTH_EXCEEDED",
      "Request body larger than maxBodyLength limit"
    );
    var WriteAfterEndError = createErrorType(
      "ERR_STREAM_WRITE_AFTER_END",
      "write after end"
    );
    var destroy = Writable.prototype.destroy || noop;
    function RedirectableRequest(options, responseCallback) {
      Writable.call(this);
      this._sanitizeOptions(options);
      this._options = options;
      this._ended = false;
      this._ending = false;
      this._redirectCount = 0;
      this._redirects = [];
      this._requestBodyLength = 0;
      this._requestBodyBuffers = [];
      if (responseCallback) {
        this.on("response", responseCallback);
      }
      var self2 = this;
      this._onNativeResponse = function(response) {
        try {
          self2._processResponse(response);
        } catch (cause) {
          self2.emit("error", cause instanceof RedirectionError ? cause : new RedirectionError({ cause }));
        }
      };
      this._performRequest();
    }
    RedirectableRequest.prototype = Object.create(Writable.prototype);
    RedirectableRequest.prototype.abort = function() {
      destroyRequest(this._currentRequest);
      this._currentRequest.abort();
      this.emit("abort");
    };
    RedirectableRequest.prototype.destroy = function(error) {
      destroyRequest(this._currentRequest, error);
      destroy.call(this, error);
      return this;
    };
    RedirectableRequest.prototype.write = function(data, encoding, callback) {
      if (this._ending) {
        throw new WriteAfterEndError();
      }
      if (!isString(data) && !isBuffer(data)) {
        throw new TypeError("data should be a string, Buffer or Uint8Array");
      }
      if (isFunction(encoding)) {
        callback = encoding;
        encoding = null;
      }
      if (data.length === 0) {
        if (callback) {
          callback();
        }
        return;
      }
      if (this._requestBodyLength + data.length <= this._options.maxBodyLength) {
        this._requestBodyLength += data.length;
        this._requestBodyBuffers.push({ data, encoding });
        this._currentRequest.write(data, encoding, callback);
      } else {
        this.emit("error", new MaxBodyLengthExceededError());
        this.abort();
      }
    };
    RedirectableRequest.prototype.end = function(data, encoding, callback) {
      if (isFunction(data)) {
        callback = data;
        data = encoding = null;
      } else if (isFunction(encoding)) {
        callback = encoding;
        encoding = null;
      }
      if (!data) {
        this._ended = this._ending = true;
        this._currentRequest.end(null, null, callback);
      } else {
        var self2 = this;
        var currentRequest = this._currentRequest;
        this.write(data, encoding, function() {
          self2._ended = true;
          currentRequest.end(null, null, callback);
        });
        this._ending = true;
      }
    };
    RedirectableRequest.prototype.setHeader = function(name, value) {
      this._options.headers[name] = value;
      this._currentRequest.setHeader(name, value);
    };
    RedirectableRequest.prototype.removeHeader = function(name) {
      delete this._options.headers[name];
      this._currentRequest.removeHeader(name);
    };
    RedirectableRequest.prototype.setTimeout = function(msecs, callback) {
      var self2 = this;
      function destroyOnTimeout(socket) {
        socket.setTimeout(msecs);
        socket.removeListener("timeout", socket.destroy);
        socket.addListener("timeout", socket.destroy);
      }
      function startTimer(socket) {
        if (self2._timeout) {
          clearTimeout(self2._timeout);
        }
        self2._timeout = setTimeout(function() {
          self2.emit("timeout");
          clearTimer();
        }, msecs);
        destroyOnTimeout(socket);
      }
      function clearTimer() {
        if (self2._timeout) {
          clearTimeout(self2._timeout);
          self2._timeout = null;
        }
        self2.removeListener("abort", clearTimer);
        self2.removeListener("error", clearTimer);
        self2.removeListener("response", clearTimer);
        self2.removeListener("close", clearTimer);
        if (callback) {
          self2.removeListener("timeout", callback);
        }
        if (!self2.socket) {
          self2._currentRequest.removeListener("socket", startTimer);
        }
      }
      if (callback) {
        this.on("timeout", callback);
      }
      if (this.socket) {
        startTimer(this.socket);
      } else {
        this._currentRequest.once("socket", startTimer);
      }
      this.on("socket", destroyOnTimeout);
      this.on("abort", clearTimer);
      this.on("error", clearTimer);
      this.on("response", clearTimer);
      this.on("close", clearTimer);
      return this;
    };
    [
      "flushHeaders",
      "getHeader",
      "setNoDelay",
      "setSocketKeepAlive"
    ].forEach(function(method) {
      RedirectableRequest.prototype[method] = function(a, b) {
        return this._currentRequest[method](a, b);
      };
    });
    ["aborted", "connection", "socket"].forEach(function(property) {
      Object.defineProperty(RedirectableRequest.prototype, property, {
        get: function() {
          return this._currentRequest[property];
        }
      });
    });
    RedirectableRequest.prototype._sanitizeOptions = function(options) {
      if (!options.headers) {
        options.headers = {};
      }
      if (options.host) {
        if (!options.hostname) {
          options.hostname = options.host;
        }
        delete options.host;
      }
      if (!options.pathname && options.path) {
        var searchPos = options.path.indexOf("?");
        if (searchPos < 0) {
          options.pathname = options.path;
        } else {
          options.pathname = options.path.substring(0, searchPos);
          options.search = options.path.substring(searchPos);
        }
      }
    };
    RedirectableRequest.prototype._performRequest = function() {
      var protocol = this._options.protocol;
      var nativeProtocol = this._options.nativeProtocols[protocol];
      if (!nativeProtocol) {
        throw new TypeError("Unsupported protocol " + protocol);
      }
      if (this._options.agents) {
        var scheme = protocol.slice(0, -1);
        this._options.agent = this._options.agents[scheme];
      }
      var request = this._currentRequest = nativeProtocol.request(this._options, this._onNativeResponse);
      request._redirectable = this;
      for (var event of events) {
        request.on(event, eventHandlers[event]);
      }
      this._currentUrl = /^\//.test(this._options.path) ? url.format(this._options) : (
        // When making a request to a proxy, […]
        // a client MUST send the target URI in absolute-form […].
        this._options.path
      );
      if (this._isRedirect) {
        var i = 0;
        var self2 = this;
        var buffers = this._requestBodyBuffers;
        (function writeNext(error) {
          if (request === self2._currentRequest) {
            if (error) {
              self2.emit("error", error);
            } else if (i < buffers.length) {
              var buffer = buffers[i++];
              if (!request.finished) {
                request.write(buffer.data, buffer.encoding, writeNext);
              }
            } else if (self2._ended) {
              request.end();
            }
          }
        })();
      }
    };
    RedirectableRequest.prototype._processResponse = function(response) {
      var statusCode = response.statusCode;
      if (this._options.trackRedirects) {
        this._redirects.push({
          url: this._currentUrl,
          headers: response.headers,
          statusCode
        });
      }
      var location2 = response.headers.location;
      if (!location2 || this._options.followRedirects === false || statusCode < 300 || statusCode >= 400) {
        response.responseUrl = this._currentUrl;
        response.redirects = this._redirects;
        this.emit("response", response);
        this._requestBodyBuffers = [];
        return;
      }
      destroyRequest(this._currentRequest);
      response.destroy();
      if (++this._redirectCount > this._options.maxRedirects) {
        throw new TooManyRedirectsError();
      }
      var requestHeaders;
      var beforeRedirect = this._options.beforeRedirect;
      if (beforeRedirect) {
        requestHeaders = Object.assign({
          // The Host header was set by nativeProtocol.request
          Host: response.req.getHeader("host")
        }, this._options.headers);
      }
      var method = this._options.method;
      if ((statusCode === 301 || statusCode === 302) && this._options.method === "POST" || // RFC7231§6.4.4: The 303 (See Other) status code indicates that
      // the server is redirecting the user agent to a different resource […]
      // A user agent can perform a retrieval request targeting that URI
      // (a GET or HEAD request if using HTTP) […]
      statusCode === 303 && !/^(?:GET|HEAD)$/.test(this._options.method)) {
        this._options.method = "GET";
        this._requestBodyBuffers = [];
        removeMatchingHeaders(/^content-/i, this._options.headers);
      }
      var currentHostHeader = removeMatchingHeaders(/^host$/i, this._options.headers);
      var currentUrlParts = parseUrl(this._currentUrl);
      var currentHost = currentHostHeader || currentUrlParts.host;
      var currentUrl = /^\w+:/.test(location2) ? this._currentUrl : url.format(Object.assign(currentUrlParts, { host: currentHost }));
      var redirectUrl = resolveUrl(location2, currentUrl);
      debug("redirecting to", redirectUrl.href);
      this._isRedirect = true;
      spreadUrlObject(redirectUrl, this._options);
      if (redirectUrl.protocol !== currentUrlParts.protocol && redirectUrl.protocol !== "https:" || redirectUrl.host !== currentHost && !isSubdomain(redirectUrl.host, currentHost)) {
        removeMatchingHeaders(/^(?:(?:proxy-)?authorization|cookie)$/i, this._options.headers);
      }
      if (isFunction(beforeRedirect)) {
        var responseDetails = {
          headers: response.headers,
          statusCode
        };
        var requestDetails = {
          url: currentUrl,
          method,
          headers: requestHeaders
        };
        beforeRedirect(this._options, responseDetails, requestDetails);
        this._sanitizeOptions(this._options);
      }
      this._performRequest();
    };
    function wrap(protocols) {
      var exports2 = {
        maxRedirects: 21,
        maxBodyLength: 10 * 1024 * 1024
      };
      var nativeProtocols = {};
      Object.keys(protocols).forEach(function(scheme) {
        var protocol = scheme + ":";
        var nativeProtocol = nativeProtocols[protocol] = protocols[scheme];
        var wrappedProtocol = exports2[scheme] = Object.create(nativeProtocol);
        function request(input, options, callback) {
          if (isURL(input)) {
            input = spreadUrlObject(input);
          } else if (isString(input)) {
            input = spreadUrlObject(parseUrl(input));
          } else {
            callback = options;
            options = validateUrl(input);
            input = { protocol };
          }
          if (isFunction(options)) {
            callback = options;
            options = null;
          }
          options = Object.assign({
            maxRedirects: exports2.maxRedirects,
            maxBodyLength: exports2.maxBodyLength
          }, input, options);
          options.nativeProtocols = nativeProtocols;
          if (!isString(options.host) && !isString(options.hostname)) {
            options.hostname = "::1";
          }
          assert.equal(options.protocol, protocol, "protocol mismatch");
          debug("options", options);
          return new RedirectableRequest(options, callback);
        }
        function get(input, options, callback) {
          var wrappedRequest = wrappedProtocol.request(input, options, callback);
          wrappedRequest.end();
          return wrappedRequest;
        }
        Object.defineProperties(wrappedProtocol, {
          request: { value: request, configurable: true, enumerable: true, writable: true },
          get: { value: get, configurable: true, enumerable: true, writable: true }
        });
      });
      return exports2;
    }
    function noop() {
    }
    function parseUrl(input) {
      var parsed;
      if (useNativeURL) {
        parsed = new URL2(input);
      } else {
        parsed = validateUrl(url.parse(input));
        if (!isString(parsed.protocol)) {
          throw new InvalidUrlError({ input });
        }
      }
      return parsed;
    }
    function resolveUrl(relative, base) {
      return useNativeURL ? new URL2(relative, base) : parseUrl(url.resolve(base, relative));
    }
    function validateUrl(input) {
      if (/^\[/.test(input.hostname) && !/^\[[:0-9a-f]+\]$/i.test(input.hostname)) {
        throw new InvalidUrlError({ input: input.href || input });
      }
      if (/^\[/.test(input.host) && !/^\[[:0-9a-f]+\](:\d+)?$/i.test(input.host)) {
        throw new InvalidUrlError({ input: input.href || input });
      }
      return input;
    }
    function spreadUrlObject(urlObject, target) {
      var spread = target || {};
      for (var key of preservedUrlFields) {
        spread[key] = urlObject[key];
      }
      if (spread.hostname.startsWith("[")) {
        spread.hostname = spread.hostname.slice(1, -1);
      }
      if (spread.port !== "") {
        spread.port = Number(spread.port);
      }
      spread.path = spread.search ? spread.pathname + spread.search : spread.pathname;
      return spread;
    }
    function removeMatchingHeaders(regex, headers) {
      var lastValue;
      for (var header in headers) {
        if (regex.test(header)) {
          lastValue = headers[header];
          delete headers[header];
        }
      }
      return lastValue === null || typeof lastValue === "undefined" ? void 0 : String(lastValue).trim();
    }
    function createErrorType(code, message, baseClass) {
      function CustomError(properties) {
        if (isFunction(Error.captureStackTrace)) {
          Error.captureStackTrace(this, this.constructor);
        }
        Object.assign(this, properties || {});
        this.code = code;
        this.message = this.cause ? message + ": " + this.cause.message : message;
      }
      CustomError.prototype = new (baseClass || Error)();
      Object.defineProperties(CustomError.prototype, {
        constructor: {
          value: CustomError,
          enumerable: false
        },
        name: {
          value: "Error [" + code + "]",
          enumerable: false
        }
      });
      return CustomError;
    }
    function destroyRequest(request, error) {
      for (var event of events) {
        request.removeListener(event, eventHandlers[event]);
      }
      request.on("error", noop);
      request.destroy(error);
    }
    function isSubdomain(subdomain, domain) {
      assert(isString(subdomain) && isString(domain));
      var dot = subdomain.length - domain.length - 1;
      return dot > 0 && subdomain[dot] === "." && subdomain.endsWith(domain);
    }
    function isString(value) {
      return typeof value === "string" || value instanceof String;
    }
    function isFunction(value) {
      return typeof value === "function";
    }
    function isBuffer(value) {
      return typeof value === "object" && "length" in value;
    }
    function isURL(value) {
      return URL2 && value instanceof URL2;
    }
    module2.exports = wrap({ http, https });
    module2.exports.wrap = wrap;
  }
});

// ../../node_modules/axios/lib/env/data.js
var require_data = __commonJS({
  "../../node_modules/axios/lib/env/data.js"(exports, module2) {
    "use strict";
    module2.exports = {
      "version": "0.24.0"
    };
  }
});

// ../../node_modules/axios/lib/adapters/http.js
var require_http = __commonJS({
  "../../node_modules/axios/lib/adapters/http.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var settle = require_settle();
    var buildFullPath = require_buildFullPath();
    var buildURL = require_buildURL();
    var http = require("http");
    var https = require("https");
    var httpFollow = require_follow_redirects().http;
    var httpsFollow = require_follow_redirects().https;
    var url = require("url");
    var zlib = require("zlib");
    var VERSION = require_data().version;
    var createError = require_createError();
    var enhanceError = require_enhanceError();
    var defaults = require_defaults();
    var Cancel = require_Cancel();
    var isHttps = /https:?/;
    function setProxy(options, proxy, location2) {
      options.hostname = proxy.host;
      options.host = proxy.host;
      options.port = proxy.port;
      options.path = location2;
      if (proxy.auth) {
        var base64 = Buffer.from(proxy.auth.username + ":" + proxy.auth.password, "utf8").toString("base64");
        options.headers["Proxy-Authorization"] = "Basic " + base64;
      }
      options.beforeRedirect = function beforeRedirect(redirection) {
        redirection.headers.host = redirection.host;
        setProxy(redirection, proxy, redirection.href);
      };
    }
    module2.exports = function httpAdapter(config) {
      return new Promise(function dispatchHttpRequest(resolvePromise, rejectPromise) {
        var onCanceled;
        function done() {
          if (config.cancelToken) {
            config.cancelToken.unsubscribe(onCanceled);
          }
          if (config.signal) {
            config.signal.removeEventListener("abort", onCanceled);
          }
        }
        var resolve = function resolve2(value) {
          done();
          resolvePromise(value);
        };
        var reject = function reject2(value) {
          done();
          rejectPromise(value);
        };
        var data = config.data;
        var headers = config.headers;
        var headerNames = {};
        Object.keys(headers).forEach(function storeLowerName(name) {
          headerNames[name.toLowerCase()] = name;
        });
        if ("user-agent" in headerNames) {
          if (!headers[headerNames["user-agent"]]) {
            delete headers[headerNames["user-agent"]];
          }
        } else {
          headers["User-Agent"] = "axios/" + VERSION;
        }
        if (data && !utils.isStream(data)) {
          if (Buffer.isBuffer(data)) {
          } else if (utils.isArrayBuffer(data)) {
            data = Buffer.from(new Uint8Array(data));
          } else if (utils.isString(data)) {
            data = Buffer.from(data, "utf-8");
          } else {
            return reject(createError(
              "Data after transformation must be a string, an ArrayBuffer, a Buffer, or a Stream",
              config
            ));
          }
          if (!headerNames["content-length"]) {
            headers["Content-Length"] = data.length;
          }
        }
        var auth = void 0;
        if (config.auth) {
          var username = config.auth.username || "";
          var password = config.auth.password || "";
          auth = username + ":" + password;
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        var parsed = url.parse(fullPath);
        var protocol = parsed.protocol || "http:";
        if (!auth && parsed.auth) {
          var urlAuth = parsed.auth.split(":");
          var urlUsername = urlAuth[0] || "";
          var urlPassword = urlAuth[1] || "";
          auth = urlUsername + ":" + urlPassword;
        }
        if (auth && headerNames.authorization) {
          delete headers[headerNames.authorization];
        }
        var isHttpsRequest = isHttps.test(protocol);
        var agent = isHttpsRequest ? config.httpsAgent : config.httpAgent;
        var options = {
          path: buildURL(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, ""),
          method: config.method.toUpperCase(),
          headers,
          agent,
          agents: { http: config.httpAgent, https: config.httpsAgent },
          auth
        };
        if (config.socketPath) {
          options.socketPath = config.socketPath;
        } else {
          options.hostname = parsed.hostname;
          options.port = parsed.port;
        }
        var proxy = config.proxy;
        if (!proxy && proxy !== false) {
          var proxyEnv = protocol.slice(0, -1) + "_proxy";
          var proxyUrl = process.env[proxyEnv] || process.env[proxyEnv.toUpperCase()];
          if (proxyUrl) {
            var parsedProxyUrl = url.parse(proxyUrl);
            var noProxyEnv = process.env.no_proxy || process.env.NO_PROXY;
            var shouldProxy = true;
            if (noProxyEnv) {
              var noProxy = noProxyEnv.split(",").map(function trim(s) {
                return s.trim();
              });
              shouldProxy = !noProxy.some(function proxyMatch(proxyElement) {
                if (!proxyElement) {
                  return false;
                }
                if (proxyElement === "*") {
                  return true;
                }
                if (proxyElement[0] === "." && parsed.hostname.substr(parsed.hostname.length - proxyElement.length) === proxyElement) {
                  return true;
                }
                return parsed.hostname === proxyElement;
              });
            }
            if (shouldProxy) {
              proxy = {
                host: parsedProxyUrl.hostname,
                port: parsedProxyUrl.port,
                protocol: parsedProxyUrl.protocol
              };
              if (parsedProxyUrl.auth) {
                var proxyUrlAuth = parsedProxyUrl.auth.split(":");
                proxy.auth = {
                  username: proxyUrlAuth[0],
                  password: proxyUrlAuth[1]
                };
              }
            }
          }
        }
        if (proxy) {
          options.headers.host = parsed.hostname + (parsed.port ? ":" + parsed.port : "");
          setProxy(options, proxy, protocol + "//" + parsed.hostname + (parsed.port ? ":" + parsed.port : "") + options.path);
        }
        var transport;
        var isHttpsProxy = isHttpsRequest && (proxy ? isHttps.test(proxy.protocol) : true);
        if (config.transport) {
          transport = config.transport;
        } else if (config.maxRedirects === 0) {
          transport = isHttpsProxy ? https : http;
        } else {
          if (config.maxRedirects) {
            options.maxRedirects = config.maxRedirects;
          }
          transport = isHttpsProxy ? httpsFollow : httpFollow;
        }
        if (config.maxBodyLength > -1) {
          options.maxBodyLength = config.maxBodyLength;
        }
        if (config.insecureHTTPParser) {
          options.insecureHTTPParser = config.insecureHTTPParser;
        }
        var req = transport.request(options, function handleResponse(res) {
          if (req.aborted)
            return;
          var stream = res;
          var lastRequest = res.req || req;
          if (res.statusCode !== 204 && lastRequest.method !== "HEAD" && config.decompress !== false) {
            switch (res.headers["content-encoding"]) {
              case "gzip":
              case "compress":
              case "deflate":
                stream = stream.pipe(zlib.createUnzip());
                delete res.headers["content-encoding"];
                break;
            }
          }
          var response = {
            status: res.statusCode,
            statusText: res.statusMessage,
            headers: res.headers,
            config,
            request: lastRequest
          };
          if (config.responseType === "stream") {
            response.data = stream;
            settle(resolve, reject, response);
          } else {
            var responseBuffer = [];
            var totalResponseBytes = 0;
            stream.on("data", function handleStreamData(chunk) {
              responseBuffer.push(chunk);
              totalResponseBytes += chunk.length;
              if (config.maxContentLength > -1 && totalResponseBytes > config.maxContentLength) {
                stream.destroy();
                reject(createError(
                  "maxContentLength size of " + config.maxContentLength + " exceeded",
                  config,
                  null,
                  lastRequest
                ));
              }
            });
            stream.on("error", function handleStreamError(err) {
              if (req.aborted)
                return;
              reject(enhanceError(err, config, null, lastRequest));
            });
            stream.on("end", function handleStreamEnd() {
              var responseData = Buffer.concat(responseBuffer);
              if (config.responseType !== "arraybuffer") {
                responseData = responseData.toString(config.responseEncoding);
                if (!config.responseEncoding || config.responseEncoding === "utf8") {
                  responseData = utils.stripBOM(responseData);
                }
              }
              response.data = responseData;
              settle(resolve, reject, response);
            });
          }
        });
        req.on("error", function handleRequestError(err) {
          if (req.aborted && err.code !== "ERR_FR_TOO_MANY_REDIRECTS")
            return;
          reject(enhanceError(err, config, null, req));
        });
        if (config.timeout) {
          var timeout = parseInt(config.timeout, 10);
          if (isNaN(timeout)) {
            reject(createError(
              "error trying to parse `config.timeout` to int",
              config,
              "ERR_PARSE_TIMEOUT",
              req
            ));
            return;
          }
          req.setTimeout(timeout, function handleRequestTimeout() {
            req.abort();
            var transitional = config.transitional || defaults.transitional;
            reject(createError(
              "timeout of " + timeout + "ms exceeded",
              config,
              transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
              req
            ));
          });
        }
        if (config.cancelToken || config.signal) {
          onCanceled = function(cancel) {
            if (req.aborted)
              return;
            req.abort();
            reject(!cancel || cancel && cancel.type ? new Cancel("canceled") : cancel);
          };
          config.cancelToken && config.cancelToken.subscribe(onCanceled);
          if (config.signal) {
            config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
          }
        }
        if (utils.isStream(data)) {
          data.on("error", function handleStreamError(err) {
            reject(enhanceError(err, config, null, req));
          }).pipe(req);
        } else {
          req.end(data);
        }
      });
    };
  }
});

// ../../node_modules/axios/lib/defaults.js
var require_defaults = __commonJS({
  "../../node_modules/axios/lib/defaults.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var normalizeHeaderName = require_normalizeHeaderName();
    var enhanceError = require_enhanceError();
    var DEFAULT_CONTENT_TYPE = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) {
        headers["Content-Type"] = value;
      }
    }
    function getDefaultAdapter() {
      var adapter;
      if (typeof XMLHttpRequest !== "undefined") {
        adapter = require_xhr();
      } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
        adapter = require_http();
      }
      return adapter;
    }
    function stringifySafely(rawValue, parser, encoder) {
      if (utils.isString(rawValue)) {
        try {
          (parser || JSON.parse)(rawValue);
          return utils.trim(rawValue);
        } catch (e) {
          if (e.name !== "SyntaxError") {
            throw e;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults = {
      transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
      },
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, "Accept");
        normalizeHeaderName(headers, "Content-Type");
        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }
        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }
        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
          return data.toString();
        }
        if (utils.isObject(data) || headers && headers["Content-Type"] === "application/json") {
          setContentTypeIfUnset(headers, "application/json");
          return stringifySafely(data);
        }
        return data;
      }],
      transformResponse: [function transformResponse(data) {
        var transitional = this.transitional || defaults.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
        if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
          try {
            return JSON.parse(data);
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === "SyntaxError") {
                throw enhanceError(e, this, "E_JSON_PARSE");
              }
              throw e;
            }
          }
        }
        return data;
      }],
      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      },
      headers: {
        common: {
          "Accept": "application/json, text/plain, */*"
        }
      }
    };
    utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
      defaults.headers[method] = {};
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    module2.exports = defaults;
  }
});

// ../../node_modules/axios/lib/core/transformData.js
var require_transformData = __commonJS({
  "../../node_modules/axios/lib/core/transformData.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var defaults = require_defaults();
    module2.exports = function transformData(data, headers, fns) {
      var context = this || defaults;
      utils.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
      });
      return data;
    };
  }
});

// ../../node_modules/axios/lib/cancel/isCancel.js
var require_isCancel = __commonJS({
  "../../node_modules/axios/lib/cancel/isCancel.js"(exports, module2) {
    "use strict";
    module2.exports = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };
  }
});

// ../../node_modules/axios/lib/core/dispatchRequest.js
var require_dispatchRequest = __commonJS({
  "../../node_modules/axios/lib/core/dispatchRequest.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var transformData = require_transformData();
    var isCancel = require_isCancel();
    var defaults = require_defaults();
    var Cancel = require_Cancel();
    function throwIfCancellationRequested(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }
      if (config.signal && config.signal.aborted) {
        throw new Cancel("canceled");
      }
    }
    module2.exports = function dispatchRequest(config) {
      throwIfCancellationRequested(config);
      config.headers = config.headers || {};
      config.data = transformData.call(
        config,
        config.data,
        config.headers,
        config.transformRequest
      );
      config.headers = utils.merge(
        config.headers.common || {},
        config.headers[config.method] || {},
        config.headers
      );
      utils.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        function cleanHeaderConfig(method) {
          delete config.headers[method];
        }
      );
      var adapter = config.adapter || defaults.adapter;
      return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        response.data = transformData.call(
          config,
          response.data,
          response.headers,
          config.transformResponse
        );
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config);
          if (reason && reason.response) {
            reason.response.data = transformData.call(
              config,
              reason.response.data,
              reason.response.headers,
              config.transformResponse
            );
          }
        }
        return Promise.reject(reason);
      });
    };
  }
});

// ../../node_modules/axios/lib/core/mergeConfig.js
var require_mergeConfig = __commonJS({
  "../../node_modules/axios/lib/core/mergeConfig.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = function mergeConfig(config1, config2) {
      config2 = config2 || {};
      var config = {};
      function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
          return utils.merge(target, source);
        } else if (utils.isPlainObject(source)) {
          return utils.merge({}, source);
        } else if (utils.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        }
      }
      function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function mergeDirectKeys(prop) {
        if (prop in config2) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
      };
      utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
      });
      return config;
    };
  }
});

// ../../node_modules/axios/lib/helpers/validator.js
var require_validator = __commonJS({
  "../../node_modules/axios/lib/helpers/validator.js"(exports, module2) {
    "use strict";
    var VERSION = require_data().version;
    var validators = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
      validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
      };
    });
    var deprecatedWarnings = {};
    validators.transitional = function transitional(validator, version, message) {
      function formatMessage(opt, desc) {
        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
      }
      return function(value, opt, opts) {
        if (validator === false) {
          throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        }
        if (version && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true;
          console.warn(
            formatMessage(
              opt,
              " has been deprecated since v" + version + " and will be removed in the near future"
            )
          );
        }
        return validator ? validator(value, opt, opts) : true;
      };
    };
    function assertOptions(options, schema, allowUnknown) {
      if (typeof options !== "object") {
        throw new TypeError("options must be an object");
      }
      var keys = Object.keys(options);
      var i = keys.length;
      while (i-- > 0) {
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
          var value = options[opt];
          var result = value === void 0 || validator(value, opt, options);
          if (result !== true) {
            throw new TypeError("option " + opt + " must be " + result);
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw Error("Unknown option " + opt);
        }
      }
    }
    module2.exports = {
      assertOptions,
      validators
    };
  }
});

// ../../node_modules/axios/lib/core/Axios.js
var require_Axios = __commonJS({
  "../../node_modules/axios/lib/core/Axios.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var buildURL = require_buildURL();
    var InterceptorManager = require_InterceptorManager();
    var dispatchRequest = require_dispatchRequest();
    var mergeConfig = require_mergeConfig();
    var validator = require_validator();
    var validators = validator.validators;
    function Axios(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    Axios.prototype.request = function request(config) {
      if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
      } else {
        config = config || {};
      }
      config = mergeConfig(this.defaults, config);
      if (config.method) {
        config.method = config.method.toLowerCase();
      } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
      } else {
        config.method = "get";
      }
      var transitional = config.transitional;
      if (transitional !== void 0) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators.transitional(validators.boolean),
          forcedJSONParsing: validators.transitional(validators.boolean),
          clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
      }
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;
      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, void 0];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
      }
      var newConfig = config;
      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }
      try {
        promise = dispatchRequest(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }
      return promise;
    };
    Axios.prototype.getUri = function getUri(config) {
      config = mergeConfig(this.defaults, config);
      return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
    };
    utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
      Axios.prototype[method] = function(url, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url,
          data: (config || {}).data
        }));
      };
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      Axios.prototype[method] = function(url, data, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url,
          data
        }));
      };
    });
    module2.exports = Axios;
  }
});

// ../../node_modules/axios/lib/cancel/CancelToken.js
var require_CancelToken = __commonJS({
  "../../node_modules/axios/lib/cancel/CancelToken.js"(exports, module2) {
    "use strict";
    var Cancel = require_Cancel();
    function CancelToken(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;
      this.promise.then(function(cancel) {
        if (!token._listeners)
          return;
        var i;
        var l = token._listeners.length;
        for (i = 0; i < l; i++) {
          token._listeners[i](cancel);
        }
        token._listeners = null;
      });
      this.promise.then = function(onfulfilled) {
        var _resolve;
        var promise = new Promise(function(resolve) {
          token.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message) {
        if (token.reason) {
          return;
        }
        token.reason = new Cancel(message);
        resolvePromise(token.reason);
      });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    CancelToken.prototype.subscribe = function subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    };
    CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }
      var index = this._listeners.indexOf(listener);
      if (index !== -1) {
        this._listeners.splice(index, 1);
      }
    };
    CancelToken.source = function source() {
      var cancel;
      var token = new CancelToken(function executor(c) {
        cancel = c;
      });
      return {
        token,
        cancel
      };
    };
    module2.exports = CancelToken;
  }
});

// ../../node_modules/axios/lib/helpers/spread.js
var require_spread = __commonJS({
  "../../node_modules/axios/lib/helpers/spread.js"(exports, module2) {
    "use strict";
    module2.exports = function spread(callback) {
      return function wrap(arr) {
        return callback.apply(null, arr);
      };
    };
  }
});

// ../../node_modules/axios/lib/helpers/isAxiosError.js
var require_isAxiosError = __commonJS({
  "../../node_modules/axios/lib/helpers/isAxiosError.js"(exports, module2) {
    "use strict";
    module2.exports = function isAxiosError(payload) {
      return typeof payload === "object" && payload.isAxiosError === true;
    };
  }
});

// ../../node_modules/axios/lib/axios.js
var require_axios = __commonJS({
  "../../node_modules/axios/lib/axios.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var bind = require_bind();
    var Axios = require_Axios();
    var mergeConfig = require_mergeConfig();
    var defaults = require_defaults();
    function createInstance(defaultConfig) {
      var context = new Axios(defaultConfig);
      var instance = bind(Axios.prototype.request, context);
      utils.extend(instance, Axios.prototype, context);
      utils.extend(instance, context);
      instance.create = function create(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig, instanceConfig));
      };
      return instance;
    }
    var axios2 = createInstance(defaults);
    axios2.Axios = Axios;
    axios2.Cancel = require_Cancel();
    axios2.CancelToken = require_CancelToken();
    axios2.isCancel = require_isCancel();
    axios2.VERSION = require_data().version;
    axios2.all = function all(promises) {
      return Promise.all(promises);
    };
    axios2.spread = require_spread();
    axios2.isAxiosError = require_isAxiosError();
    module2.exports = axios2;
    module2.exports.default = axios2;
  }
});

// ../../node_modules/axios/index.js
var require_axios2 = __commonJS({
  "../../node_modules/axios/index.js"(exports, module2) {
    "use strict";
    module2.exports = require_axios();
  }
});

// ../../node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "../../node_modules/lodash/isObject.js"(exports, module2) {
    "use strict";
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module2.exports = isObject;
  }
});

// ../../node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "../../node_modules/lodash/_freeGlobal.js"(exports, module2) {
    "use strict";
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module2.exports = freeGlobal;
  }
});

// ../../node_modules/lodash/_root.js
var require_root = __commonJS({
  "../../node_modules/lodash/_root.js"(exports, module2) {
    "use strict";
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module2.exports = root;
  }
});

// ../../node_modules/lodash/now.js
var require_now = __commonJS({
  "../../node_modules/lodash/now.js"(exports, module2) {
    "use strict";
    var root = require_root();
    var now = function() {
      return root.Date.now();
    };
    module2.exports = now;
  }
});

// ../../node_modules/lodash/_trimmedEndIndex.js
var require_trimmedEndIndex = __commonJS({
  "../../node_modules/lodash/_trimmedEndIndex.js"(exports, module2) {
    "use strict";
    var reWhitespace = /\s/;
    function trimmedEndIndex(string) {
      var index = string.length;
      while (index-- && reWhitespace.test(string.charAt(index))) {
      }
      return index;
    }
    module2.exports = trimmedEndIndex;
  }
});

// ../../node_modules/lodash/_baseTrim.js
var require_baseTrim = __commonJS({
  "../../node_modules/lodash/_baseTrim.js"(exports, module2) {
    "use strict";
    var trimmedEndIndex = require_trimmedEndIndex();
    var reTrimStart = /^\s+/;
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    module2.exports = baseTrim;
  }
});

// ../../node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "../../node_modules/lodash/_Symbol.js"(exports, module2) {
    "use strict";
    var root = require_root();
    var Symbol2 = root.Symbol;
    module2.exports = Symbol2;
  }
});

// ../../node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "../../node_modules/lodash/_getRawTag.js"(exports, module2) {
    "use strict";
    var Symbol2 = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module2.exports = getRawTag;
  }
});

// ../../node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "../../node_modules/lodash/_objectToString.js"(exports, module2) {
    "use strict";
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module2.exports = objectToString;
  }
});

// ../../node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "../../node_modules/lodash/_baseGetTag.js"(exports, module2) {
    "use strict";
    var Symbol2 = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module2.exports = baseGetTag;
  }
});

// ../../node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "../../node_modules/lodash/isObjectLike.js"(exports, module2) {
    "use strict";
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module2.exports = isObjectLike;
  }
});

// ../../node_modules/lodash/isSymbol.js
var require_isSymbol = __commonJS({
  "../../node_modules/lodash/isSymbol.js"(exports, module2) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var symbolTag = "[object Symbol]";
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module2.exports = isSymbol;
  }
});

// ../../node_modules/lodash/toNumber.js
var require_toNumber = __commonJS({
  "../../node_modules/lodash/toNumber.js"(exports, module2) {
    "use strict";
    var baseTrim = require_baseTrim();
    var isObject = require_isObject();
    var isSymbol = require_isSymbol();
    var NAN = 0 / 0;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module2.exports = toNumber;
  }
});

// ../../node_modules/lodash/debounce.js
var require_debounce = __commonJS({
  "../../node_modules/lodash/debounce.js"(exports, module2) {
    "use strict";
    var isObject = require_isObject();
    var now = require_now();
    var toNumber = require_toNumber();
    var FUNC_ERROR_TEXT = "Expected a function";
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    function debounce2(func, wait, options) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    module2.exports = debounce2;
  }
});

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  AppInfo: () => AppInfo,
  DashApp: () => DashApp,
  LogoImage: () => LogoImage,
  MapboxMap: () => MapboxMap,
  fetchCity: () => fetchCity,
  fetchLngLat: () => fetchLngLat
});
module.exports = __toCommonJS(src_exports);

// src/LogoImage/index.tsx
var import_jsx_runtime = require("react/jsx-runtime");
function LogoImage() {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "bg-white bg-opacity-5 rounded-full flex-shrink-0 object-cover p-10", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("img", { src: "logo.png", className: "w-36 h-36", alt: "logo" }) });
}

// src/AppInfo/index.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
function AppInfo({ info }) {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("h1", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { className: "text-2xl opacity-20", children: info }),
    /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { className: "Turbo", children: "TURBO" }),
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { className: "CoolStack", children: "CoolStack" })
    ] })
  ] });
}

// src/GeoAppUI/Map/components/mapbox-map.tsx
var React = __toESM(require("react"));
var import_mapbox_gl = __toESM(require_mapbox_gl());
var import_axios = __toESM(require_axios2());
var import_debounce = __toESM(require_debounce());
var import_jsx_runtime3 = require("react/jsx-runtime");
var desiredSize = 45;
var parseData = (data) => {
  try {
    if (typeof data === "string") {
      return JSON.parse(data);
    }
    return data;
  } catch (error) {
    console.error("Failed to parse data:", error);
    return data;
  }
};
var fetchCity = (lng, lat) => __async(void 0, null, function* () {
  try {
    const response = yield import_axios.default.get(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json`,
      {
        params: {
          access_token: process.env.NEXT_PUBLIC_MAPBOX_TOKEN
        }
      }
    );
    const cityResult = response.data.features.find(
      (feature) => feature.place_type.includes("place")
    );
    return cityResult;
  } catch (error) {
    console.error("Error fetching city:", error);
  }
});
var fetchLngLat = (query) => __async(void 0, null, function* () {
  try {
    const response = yield import_axios.default.get(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json`,
      {
        params: {
          access_token: process.env.NEXT_PUBLIC_MAPBOX_TOKEN
        }
      }
    );
    if (response.data.features.length > 0) {
      const firstResult = response.data.features[0];
      const lngLat = [firstResult.center[0], firstResult.center[1]];
      return lngLat;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching lat/lng:", error);
    return null;
  }
});
var MapboxMap = React.forwardRef((props, ref) => {
  const {
    children,
    location: location2,
    setLocation,
    displayedResults,
    displayedResultsFilter,
    initCenter,
    addCenterOffset,
    focus,
    setActivity,
    setActivityId,
    isMobile,
    setPlace,
    setPlaceId,
    refreshData
  } = props;
  const addCenterOffsetRef = React.useRef(addCenterOffset);
  const mapRef = React.useRef(null);
  const mapManagerRef = React.useRef(null);
  const mapContainerRef = React.useRef(null);
  const mapFocusRef = React.useRef(null);
  const overlayRef = React.useRef(null);
  const [lastMarkersRef, setLastMarkersRef] = React.useState(null);
  const [city, setCity] = React.useState(null);
  const [mapHeight, setMapHeight] = React.useState("100vh");
  const [mapLoaded, setMapLoaded] = React.useState(false);
  const markerIconUrlToScaleFactorRef = React.useRef({});
  const [addCenterOffsetRefValue, setAddCenterOffsetRefValue] = React.useState();
  class MapManager {
    // In-memory cache for SVGs
    constructor(map) {
      this.markers = [];
      // Array to keep track of markers
      this.cachedSVGs = {};
      this.map = map;
    }
  }
  const handleMapCenter = () => {
    var _a;
    if (mapRef.current) {
      refreshData && refreshData();
      const newCenter = (_a = mapRef.current) == null ? void 0 : _a.getCenter();
      localStorage.setItem("center", JSON.stringify(newCenter));
      fetchCity(newCenter.lng, newCenter.lat).then((cityResult) => {
        if (cityResult) {
          setCity(cityResult.place_name);
        } else {
          setCity(null);
        }
      });
    }
  };
  const debouncedHandleMapCenter = React.useRef((0, import_debounce.default)(handleMapCenter, 1e3)).current;
  React.useEffect(() => {
    return () => {
      debouncedHandleMapCenter.cancel();
    };
  }, [debouncedHandleMapCenter]);
  const resizeMap = () => {
    if (mapRef.current) {
      const topLeftPixel = { x: 0, y: 0 };
      const topLeftCoord = mapRef.current.unproject(topLeftPixel);
      mapRef.current.resize();
      const newTopLeftPixel = mapRef.current.project(topLeftCoord);
      const dx = newTopLeftPixel.x - topLeftPixel.x;
      const dy = newTopLeftPixel.y - topLeftPixel.y;
      mapRef.current.panBy([dx, dy], { animate: false });
      mapRef.current.resize();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
        // Optional: 'auto' for instant scroll, 'smooth' for smooth scrolling
      });
    }
  };
  React.useEffect(() => {
    resizeMap();
  }, [mapHeight]);
  const ensureMarkersSource = () => {
    if (mapRef.current && mapRef.current.isStyleLoaded() && !mapRef.current.getSource("markers-source")) {
      mapRef.current.addSource("markers-source", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
          // Initialize with empty data
        },
        cluster: false,
        clusterRadius: 2,
        clusterMaxZoom: 22,
        generateId: true
        // optional: adds a feature id
      });
      mapRef.current.addLayer({
        id: "markers-layer",
        type: "symbol",
        source: "markers-source",
        minzoom: 0,
        // Ensures markers are visible at all zoom levels
        maxzoom: 24,
        paint: {
          "circle-radius": 6,
          "circle-color": "#007cbf"
        },
        layout: {
          "symbol-sort-key": 1,
          "icon-image": ["get", "iconImage"],
          "icon-size": ["get", "iconSize"],
          "icon-allow-overlap": true,
          // Ensures markers are always visible
          "icon-ignore-placement": true,
          // Ensures markers are always visible
          "text-field": ["concat", ["get", "title"], "\n", ["get", "date"]],
          // Combine title and date with a newline character
          "text-allow-overlap": false,
          // Ensures labels don't hide either
          "text-ignore-placement": false,
          "text-size": 13,
          "text-offset": [0, 1.5],
          "text-anchor": "top",
          "visibility": "visible"
        }
      });
    }
  };
  const handleResize = () => {
    var _a;
    const overlayHeight = ((_a = overlayRef.current) == null ? void 0 : _a.offsetHeight) || 0;
    const windowHeight = window.innerHeight;
    const newHeight = Math.max(overlayHeight, windowHeight);
    if (newHeight !== parseFloat(mapHeight)) {
      setMapHeight(`${newHeight}px`);
    }
  };
  const setCustomMarkersToMapGeoJSON = (allMarkers) => __async(void 0, null, function* () {
    var _a, _b;
    if (mapManagerRef.current) {
      if (mapRef.current) {
        const map = mapRef.current;
        ensureMarkersSource();
        if (map.getSource("markers-source")) {
          const geojsonSource = map.getSource("markers-source");
          geojsonSource.setData(allMarkers);
          if ((_a = focus == null ? void 0 : focus.content) == null ? void 0 : _a.id) {
            openPopupById((_b = focus == null ? void 0 : focus.content) == null ? void 0 : _b.id);
          }
        }
      }
    }
  });
  React.useEffect(() => {
    addCenterOffsetRef.current = addCenterOffset;
    setAddCenterOffsetRefValue(addCenterOffset);
  }, [addCenterOffset]);
  React.useEffect(() => {
    setLocation && setLocation({ location: city });
  }, [city]);
  React.useEffect(() => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!mapRef.current || !mapRef.current.isStyleLoaded())
      return;
    if (mapRef.current && mapRef.current.isStyleLoaded()) {
      const layerExists = mapRef.current.getLayer("markers-layer");
      if (layerExists) {
        if (((_a = focus == null ? void 0 : focus.content) == null ? void 0 : _a.id) && ((_b = focus == null ? void 0 : focus.content) == null ? void 0 : _b.lat) && ((_c = focus == null ? void 0 : focus.content) == null ? void 0 : _c.lng)) {
          mapRef.current.setFilter("markers-layer", [
            "==",
            ["get", "id"],
            (_d = focus == null ? void 0 : focus.content) == null ? void 0 : _d.id
          ]);
        } else {
          mapRef.current.setFilter("markers-layer", null);
        }
      } else {
        console.log('Layer "markers-layer" does not exist.');
      }
    } else {
      console.error("Map is not initialized or style is not loaded yet.");
    }
    if ((focus == null ? void 0 : focus.content) && mapRef.current && mapFocusRef.current !== (focus == null ? void 0 : focus.content)) {
      mapFocusRef.current = focus == null ? void 0 : focus.content;
      const { lat, lng } = focus == null ? void 0 : focus.content;
      if (lat && lng) {
        const point = mapRef.current.project([lng, lat]);
        const offsetPoint = {
          x: point.x + (((_e = addCenterOffsetRef == null ? void 0 : addCenterOffsetRef.current) == null ? void 0 : _e.offsetX) || 0),
          y: point.y + (((_f = addCenterOffsetRef == null ? void 0 : addCenterOffsetRef.current) == null ? void 0 : _f.offsetY) || 0)
        };
        const newLngLat = mapRef.current.unproject([offsetPoint.x, offsetPoint.y]);
        mapRef.current.panTo(newLngLat);
      }
      openPopupById((_g = focus == null ? void 0 : focus.content) == null ? void 0 : _g.id);
    } else if (!(focus == null ? void 0 : focus.content)) {
      mapFocusRef.current = null;
      closePopups();
    }
  }, [focus, mapRef, mapLoaded, addCenterOffsetRefValue, lastMarkersRef]);
  const removeDuplicates = (items) => {
    const uniqueUrls = /* @__PURE__ */ new Set();
    return items.filter((item) => {
      if (!uniqueUrls.has(item.url)) {
        uniqueUrls.add(item.url);
        return true;
      }
      return false;
    });
  };
  const registerIcons = (map, icons) => __async(void 0, null, function* () {
    if (!icons)
      return;
    yield Promise.all(
      icons.map((icon) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = icon.url;
          img.onload = () => {
            const originalWidth = img.width;
            const originalHeight = img.height;
            const scaleFactor = desiredSize / Math.max(originalWidth, originalHeight);
            const markerIconUrlToScaleFactor = markerIconUrlToScaleFactorRef.current;
            markerIconUrlToScaleFactor[icon.name] = scaleFactor;
            if (!map.hasImage(icon.name)) {
              map.addImage(icon.name, img);
            }
            resolve();
          };
          img.onerror = reject;
        });
      })
    );
  });
  const updateMarkerIcons = (markerIconList) => __async(void 0, null, function* () {
    if (mapRef.current) {
      yield registerIcons(mapRef.current, markerIconList);
    }
  });
  React.useEffect(() => {
    const handleAllMarkers = (allMarkers2) => __async(void 0, null, function* () {
      yield updateMarkerIcons(removeDuplicates(allMarkers2.map((x) => {
        return x == null ? void 0 : x.icon;
      })));
      const markerIconUrlToScaleFactor = markerIconUrlToScaleFactorRef.current;
      const allMarkersGeoJson = {
        type: "FeatureCollection",
        features: allMarkers2.filter((marker) => {
          var _a;
          if (!focus && displayedResultsFilter && (marker == null ? void 0 : marker.searchable)) {
            return (_a = marker == null ? void 0 : marker.searchable) == null ? void 0 : _a.includes(displayedResultsFilter);
          }
          return true;
        }).map((result) => {
          var _a, _b;
          return {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [result.lng, result.lat]
              // Ensure it's in [lng, lat]
            },
            properties: {
              id: result.id,
              title: result.title,
              description: result.description,
              date: result.eventDate,
              iconImage: (_a = result.icon) == null ? void 0 : _a.name,
              iconSize: markerIconUrlToScaleFactor[(_b = result.icon) == null ? void 0 : _b.name] || ((markerIconUrlToScaleFactor == null ? void 0 : markerIconUrlToScaleFactor.length) > 0 ? Object.values(markerIconUrlToScaleFactor)[0] : null) || 0.4,
              _content: result
            }
          };
        }).filter((x) => {
          var _a;
          return !!((_a = x == null ? void 0 : x.properties) == null ? void 0 : _a.id);
        })
      };
      setLastMarkersRef(allMarkersGeoJson);
      setCustomMarkersToMapGeoJSON(allMarkersGeoJson);
      window.scrollTo({
        top: 0,
        behavior: "smooth"
        // 'auto' for instant scroll, 'smooth' for smooth scrolling
      });
    });
    const allMarkers = [
      focus == null ? void 0 : focus.content,
      ...displayedResults || []
    ].filter((x) => !!(x == null ? void 0 : x.id));
    handleAllMarkers(allMarkers);
  }, [displayedResults, displayedResultsFilter, focus]);
  React.useEffect(() => {
    if ((location2 == null ? void 0 : location2.location) && (location2 == null ? void 0 : location2.updateMap) === true) {
      fetchLngLat(location2 == null ? void 0 : location2.location).then((lngLatResult) => {
        var _a, _b, _c;
        if (mapRef.current && Array.isArray(lngLatResult) && lngLatResult.length === 2) {
          const lngLat = new import_mapbox_gl.default.LngLat(lngLatResult[0], lngLatResult[1]);
          if ((_a = addCenterOffsetRef.current) == null ? void 0 : _a.offsetX) {
            mapRef.current.setCenter(lngLat);
            mapRef.current.panBy([(_b = addCenterOffsetRef.current) == null ? void 0 : _b.offsetX, (_c = addCenterOffsetRef.current) == null ? void 0 : _c.offsetY]);
          } else {
            mapRef.current.setCenter(lngLat);
          }
        }
      });
    }
  }, [location2]);
  const closePopups = () => {
    return openPopupById();
  };
  const openPopupById = (markerId) => {
    var _a, _b;
    const map = mapRef.current;
    if (map) {
      const features = map.querySourceFeatures("markers-source", {
        sourceLayer: "markers-layer"
        // Optional, depending on your setup
      });
      const targetFeature = features.find((feature) => {
        var _a2;
        return ((_a2 = feature.properties) == null ? void 0 : _a2.id) === markerId;
      });
      if (targetFeature) {
        if (targetFeature.geometry && targetFeature.geometry.type === "Point") {
          const coordinates = targetFeature.geometry.coordinates;
          const coordinatesLngLat = coordinates;
          if (mapRef.current) {
            const title = ((_a = targetFeature.properties) == null ? void 0 : _a.title) || "";
            const description = ((_b = targetFeature.properties) == null ? void 0 : _b.description) || "";
            const coordinatesLngLatText = `${coordinatesLngLat[0]}, ${coordinatesLngLat[1]}`;
            let popupContent = "";
            if (title && description) {
              popupContent = `<h3><b>${title}</b></h3><p>${description}</p>`;
            } else if (title) {
              popupContent = `<h3><b>${title}</b></h3>`;
            } else if (description) {
              popupContent = `<p>${description}</p>`;
            } else {
              popupContent = `<h3><b>${coordinatesLngLatText}</b></h3>`;
            }
            const markerPopup = new import_mapbox_gl.default.Popup({
              offset: [0, -15]
              // Adjusts the popup 10px upwards
            }).setLngLat(coordinatesLngLat).setHTML(`<div id="popup-${markerId}">${popupContent}</div>`).addTo(mapRef.current);
            const markerPopupElement = markerPopup.getElement();
            if (markerPopupElement) {
              const closeButton = markerPopupElement.querySelector(".mapboxgl-popup-close-button");
              if (closeButton) {
                closeButton.addEventListener("click", (e) => {
                  e.stopPropagation();
                  closePopups();
                });
              }
              markerPopupElement.addEventListener("click", (e) => {
                var _a2;
                if (e.target === closeButton) {
                  return;
                }
                const parsedData = parseData((_a2 = targetFeature.properties) == null ? void 0 : _a2._content);
                if (parsedData == null ? void 0 : parsedData.id) {
                  if ((parsedData == null ? void 0 : parsedData.type) === "drop") {
                    setActivity && setActivity(parsedData);
                    setActivityId && setActivityId(parsedData == null ? void 0 : parsedData.id);
                  } else if ((parsedData == null ? void 0 : parsedData.type) === "place") {
                    setPlace && setPlace(parsedData);
                    setPlaceId && setPlaceId(parsedData == null ? void 0 : parsedData.id);
                  }
                }
              });
            }
          }
        }
      } else if (markerId) {
        console.log(`Marker with id ${markerId} not found`);
      }
      const prefix = "popup-";
      const popups = document.getElementsByClassName("mapboxgl-popup");
      Array.from(popups).forEach((popup) => {
        const popupElements = popup.querySelectorAll(`div[id^="${prefix}"]`);
        popupElements.forEach((popupElement) => {
          const popupId = popupElement.getAttribute("id");
          if (popupElement && (popupElement.id !== `popup-${markerId}` || !markerId)) {
            popup.remove();
          }
        });
      });
    }
  };
  React.useEffect(() => {
    if (mapContainerRef.current) {
      mapRef.current = new import_mapbox_gl.default.Map({
        container: mapContainerRef.current,
        accessToken: process.env.NEXT_PUBLIC_MAPBOX_TOKEN,
        style: "mapbox://styles/mapbox/streets-v11",
        center: JSON.parse(localStorage.getItem("center")) || initCenter || [-73.935242, 40.73061],
        zoom: 13
      });
      if (!mapRef.current)
        return;
      const navControl = new import_mapbox_gl.default.NavigationControl();
      mapRef.current.addControl(navControl, "top-right");
      const geolocateControl = new import_mapbox_gl.default.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true
        },
        trackUserLocation: true,
        // Track user's location on map
        showUserHeading: true
        // Show direction of user's heading
      });
      mapRef.current.addControl(geolocateControl, "top-right");
      mapRef.current.on("zoom", () => {
        if (mapRef.current) {
        }
      });
      mapRef.current.on("moveend", debouncedHandleMapCenter);
      mapRef.current.on("load", () => __async(void 0, null, function* () {
        if (mapRef.current) {
          ensureMarkersSource();
          mapRef.current.on("click", "markers-layer", (e) => {
            var _a, _b;
            const features = e.features;
            if (features && features.length > 0) {
              const feature = features[0];
              const markerId = (_a = feature.properties) == null ? void 0 : _a.id;
              openPopupById(markerId);
              if (feature.geometry && feature.geometry.type === "Point") {
                const coordinates = feature.geometry.coordinates;
                const coordinatesLngLat = coordinates;
                if (mapRef.current) {
                  const lngLatObj = new import_mapbox_gl.default.LngLat(coordinatesLngLat[0], coordinatesLngLat[1]);
                  if (addCenterOffsetRef == null ? void 0 : addCenterOffsetRef.current) {
                    const point = mapRef.current.project(lngLatObj);
                    const offsetPoint = {
                      x: point.x + (addCenterOffsetRef == null ? void 0 : addCenterOffsetRef.current.offsetX),
                      y: point.y + (addCenterOffsetRef == null ? void 0 : addCenterOffsetRef.current.offsetY)
                    };
                    const newLngLat = mapRef.current.unproject([offsetPoint.x, offsetPoint.y]);
                    mapRef.current.panTo(newLngLat);
                  } else {
                    mapRef.current.panTo(lngLatObj);
                  }
                  const parsedData = parseData((_b = feature.properties) == null ? void 0 : _b._content);
                  if (parsedData == null ? void 0 : parsedData.id) {
                    if ((parsedData == null ? void 0 : parsedData.type) === "drop") {
                      setActivity && setActivity(parsedData);
                      setActivityId && setActivityId(parsedData == null ? void 0 : parsedData.id);
                    } else if ((parsedData == null ? void 0 : parsedData.type) === "place") {
                      setPlace && setPlace(parsedData);
                      setPlaceId && setPlaceId(parsedData == null ? void 0 : parsedData.id);
                    }
                  }
                }
              }
            }
            setMapLoaded(true);
          });
          mapRef.current.on("mouseenter", "markers-layer", () => {
            if (mapRef.current) {
              mapRef.current.getCanvas().style.cursor = "pointer";
            }
          });
          mapRef.current.on("mouseleave", "markers-layer", () => {
            if (mapRef.current) {
              mapRef.current.getCanvas().style.cursor = "";
            }
          });
        }
        debouncedHandleMapCenter();
        handleResize();
      }));
      mapManagerRef.current = new MapManager(mapRef.current);
    }
    const observer = new MutationObserver(() => {
      setTimeout(handleResize, 1e3);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
      // attributes: true,
    });
    window.addEventListener("resize", handleResize);
    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        window.removeEventListener("resize", handleResize);
      }
      observer.disconnect();
    };
  }, []);
  React.useImperativeHandle(ref, () => mapRef.current);
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { className: "relative h-screen", children: [
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      "div",
      {
        ref: mapContainerRef,
        className: "absolute inset-0 w-full",
        style: { position: "absolute", height: mapHeight }
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      "div",
      {
        ref: overlayRef,
        className: "overlayRef absolute top-10 left-10 bg-white p-4 rounded-lg shadow-lg z-20 max-w-lg",
        style: {
          maxWidth: isMobile ? "88%" : void 0,
          maxHeight: "90vh",
          // Limit height
          overflowY: "auto"
          // Enable vertical scrolling
        },
        children
      }
    )
  ] });
});

// src/GeoAppUI/index.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var DashApp = () => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("p", { children: "Hi World!" });
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AppInfo,
  DashApp,
  LogoImage,
  MapboxMap,
  fetchCity,
  fetchLngLat
});
